(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.h2.e9 === region.hb.e9)
	{
		return 'on line ' + region.h2.e9;
	}
	return 'on lines ' + region.h2.e9 + ' through ' + region.hb.e9;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.jb,
		impl.ks,
		impl.nY,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		cz: func(record.cz),
		gD: record.gD,
		gp: record.gp
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.cz;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.gD;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.gp) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.jb,
		impl.ks,
		impl.nY,
		function(sendToApp, initialModel) {
			var view = impl.og;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.jb,
		impl.ks,
		impl.nY,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.hX && impl.hX(sendToApp)
			var view = impl.og;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.T);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.kj) && (_VirtualDom_doc.title = title = doc.kj);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.mW;
	var onUrlRequest = impl.mX;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		hX: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.jS === next.jS
							&& curr.hm === next.hm
							&& curr.jM.a === next.jM.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		jb: function(flags)
		{
			return A3(impl.jb, flags, _Browser_getUrl(), key);
		},
		og: impl.og,
		ks: impl.ks,
		nY: impl.nY
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { lS: 'hidden', k7: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { lS: 'mozHidden', k7: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { lS: 'msHidden', k7: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { lS: 'webkitHidden', k7: 'webkitvisibilitychange' }
		: { lS: 'hidden', k7: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		j1: _Browser_getScene(),
		ky: {
			on: _Browser_window.pageXOffset,
			oq: _Browser_window.pageYOffset,
			kB: _Browser_doc.documentElement.clientWidth,
			i5: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		kB: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		i5: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			j1: {
				kB: node.scrollWidth,
				i5: node.scrollHeight
			},
			ky: {
				on: node.scrollLeft,
				oq: node.scrollTop,
				kB: node.clientWidth,
				i5: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			j1: _Browser_getScene(),
			ky: {
				on: x,
				oq: y,
				kB: _Browser_doc.documentElement.clientWidth,
				i5: _Browser_doc.documentElement.clientHeight
			},
			ha: {
				on: x + rect.left,
				oq: y + rect.top,
				kB: rect.width,
				i5: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.bd.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.bd.b, xhr)); });
		$elm$core$Maybe$isJust(request.bq) && _Http_track(router, xhr, request.bq.a);

		try {
			xhr.open(request.bj, request.K, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.K));
		}

		_Http_configureRequest(xhr, request);

		request.T.a && xhr.setRequestHeader('Content-Type', request.T.a);
		xhr.send(request.T.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.ar; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.bp.a || 0;
	xhr.responseType = request.bd.d;
	xhr.withCredentials = request.kQ;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		K: xhr.responseURL,
		ft: xhr.status,
		h3: xhr.statusText,
		ar: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			nB: event.loaded,
			ce: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			nd: event.loaded,
			ce: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.mJ) { flags += 'm'; }
	if (options.k6) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}




// VIRTUAL-DOM WIDGETS


var _Markdown_toHtml = F3(function(options, factList, rawMarkdown)
{
	return _VirtualDom_custom(
		factList,
		{
			a: options,
			b: rawMarkdown
		},
		_Markdown_render,
		_Markdown_diff
	);
});



// WIDGET IMPLEMENTATION


function _Markdown_render(model)
{
	return A2(_Markdown_replace, model, _VirtualDom_doc.createElement('div'));
}


function _Markdown_diff(x, y)
{
	return x.b === y.b && x.a === y.a
		? false
		: _Markdown_replace(y);
}


var _Markdown_replace = F2(function(model, div)
{
	div.innerHTML = _Markdown_marked(model.b, _Markdown_formatOptions(model.a));
	return div;
});



// ACTUAL MARKDOWN PARSER


var _Markdown_marked = function() {
	// catch the `marked` object regardless of the outer environment.
	// (ex. a CommonJS module compatible environment.)
	// note that this depends on marked's implementation of environment detection.
	var module = {};
	var exports = module.exports = {};

	/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/chjj/marked
	 * commit cd2f6f5b7091154c5526e79b5f3bfb4d15995a51
	 */
	(function(){var block={newline:/^\n+/,code:/^( {4}[^\n]+\n*)+/,fences:noop,hr:/^( *[-*_]){3,} *(?:\n+|$)/,heading:/^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,nptable:noop,lheading:/^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,blockquote:/^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,list:/^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,html:/^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,def:/^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,table:noop,paragraph:/^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,text:/^[^\n]+/};block.bullet=/(?:[*+-]|\d+\.)/;block.item=/^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;block.item=replace(block.item,"gm")(/bull/g,block.bullet)();block.list=replace(block.list)(/bull/g,block.bullet)("hr","\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def","\\n+(?="+block.def.source+")")();block.blockquote=replace(block.blockquote)("def",block.def)();block._tag="(?!(?:"+"a|em|strong|small|s|cite|q|dfn|abbr|data|time|code"+"|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo"+"|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b";block.html=replace(block.html)("comment",/<!--[\s\S]*?-->/)("closed",/<(tag)[\s\S]+?<\/\1>/)("closing",/<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g,block._tag)();block.paragraph=replace(block.paragraph)("hr",block.hr)("heading",block.heading)("lheading",block.lheading)("blockquote",block.blockquote)("tag","<"+block._tag)("def",block.def)();block.normal=merge({},block);block.gfm=merge({},block.normal,{fences:/^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,paragraph:/^/,heading:/^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/});block.gfm.paragraph=replace(block.paragraph)("(?!","(?!"+block.gfm.fences.source.replace("\\1","\\2")+"|"+block.list.source.replace("\\1","\\3")+"|")();block.tables=merge({},block.gfm,{nptable:/^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,table:/^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/});function Lexer(options){this.tokens=[];this.tokens.links={};this.options=options||marked.defaults;this.rules=block.normal;if(this.options.gfm){if(this.options.tables){this.rules=block.tables}else{this.rules=block.gfm}}}Lexer.rules=block;Lexer.lex=function(src,options){var lexer=new Lexer(options);return lexer.lex(src)};Lexer.prototype.lex=function(src){src=src.replace(/\r\n|\r/g,"\n").replace(/\t/g,"    ").replace(/\u00a0/g," ").replace(/\u2424/g,"\n");return this.token(src,true)};Lexer.prototype.token=function(src,top,bq){var src=src.replace(/^ +$/gm,""),next,loose,cap,bull,b,item,space,i,l;while(src){if(cap=this.rules.newline.exec(src)){src=src.substring(cap[0].length);if(cap[0].length>1){this.tokens.push({type:"space"})}}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);cap=cap[0].replace(/^ {4}/gm,"");this.tokens.push({type:"code",text:!this.options.pedantic?cap.replace(/\n+$/,""):cap});continue}if(cap=this.rules.fences.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"code",lang:cap[2],text:cap[3]||""});continue}if(cap=this.rules.heading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[1].length,text:cap[2]});continue}if(top&&(cap=this.rules.nptable.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].split(/ *\| */)}this.tokens.push(item);continue}if(cap=this.rules.lheading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[2]==="="?1:2,text:cap[1]});continue}if(cap=this.rules.hr.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"hr"});continue}if(cap=this.rules.blockquote.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"blockquote_start"});cap=cap[0].replace(/^ *> ?/gm,"");this.token(cap,top,true);this.tokens.push({type:"blockquote_end"});continue}if(cap=this.rules.list.exec(src)){src=src.substring(cap[0].length);bull=cap[2];this.tokens.push({type:"list_start",ordered:bull.length>1});cap=cap[0].match(this.rules.item);next=false;l=cap.length;i=0;for(;i<l;i++){item=cap[i];space=item.length;item=item.replace(/^ *([*+-]|\d+\.) +/,"");if(~item.indexOf("\n ")){space-=item.length;item=!this.options.pedantic?item.replace(new RegExp("^ {1,"+space+"}","gm"),""):item.replace(/^ {1,4}/gm,"")}if(this.options.smartLists&&i!==l-1){b=block.bullet.exec(cap[i+1])[0];if(bull!==b&&!(bull.length>1&&b.length>1)){src=cap.slice(i+1).join("\n")+src;i=l-1}}loose=next||/\n\n(?!\s*$)/.test(item);if(i!==l-1){next=item.charAt(item.length-1)==="\n";if(!loose)loose=next}this.tokens.push({type:loose?"loose_item_start":"list_item_start"});this.token(item,false,bq);this.tokens.push({type:"list_item_end"})}this.tokens.push({type:"list_end"});continue}if(cap=this.rules.html.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:this.options.sanitize?"paragraph":"html",pre:!this.options.sanitizer&&(cap[1]==="pre"||cap[1]==="script"||cap[1]==="style"),text:cap[0]});continue}if(!bq&&top&&(cap=this.rules.def.exec(src))){src=src.substring(cap[0].length);this.tokens.links[cap[1].toLowerCase()]={href:cap[2],title:cap[3]};continue}if(top&&(cap=this.rules.table.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/(?: *\| *)?\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].replace(/^ *\| *| *\| *$/g,"").split(/ *\| */)}this.tokens.push(item);continue}if(top&&(cap=this.rules.paragraph.exec(src))){src=src.substring(cap[0].length);this.tokens.push({type:"paragraph",text:cap[1].charAt(cap[1].length-1)==="\n"?cap[1].slice(0,-1):cap[1]});continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"text",text:cap[0]});continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return this.tokens};var inline={escape:/^\\([\\`*{}\[\]()#+\-.!_>])/,autolink:/^<([^ >]+(@|:\/)[^ >]+)>/,url:noop,tag:/^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,link:/^!?\[(inside)\]\(href\)/,reflink:/^!?\[(inside)\]\s*\[([^\]]*)\]/,nolink:/^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,strong:/^_\_([\s\S]+?)_\_(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,em:/^\b_((?:[^_]|_\_)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,code:/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,br:/^ {2,}\n(?!\s*$)/,del:noop,text:/^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/};inline._inside=/(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;inline._href=/\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;inline.link=replace(inline.link)("inside",inline._inside)("href",inline._href)();inline.reflink=replace(inline.reflink)("inside",inline._inside)();inline.normal=merge({},inline);inline.pedantic=merge({},inline.normal,{strong:/^_\_(?=\S)([\s\S]*?\S)_\_(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,em:/^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/});inline.gfm=merge({},inline.normal,{escape:replace(inline.escape)("])","~|])")(),url:/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,del:/^~~(?=\S)([\s\S]*?\S)~~/,text:replace(inline.text)("]|","~]|")("|","|https?://|")()});inline.breaks=merge({},inline.gfm,{br:replace(inline.br)("{2,}","*")(),text:replace(inline.gfm.text)("{2,}","*")()});function InlineLexer(links,options){this.options=options||marked.defaults;this.links=links;this.rules=inline.normal;this.renderer=this.options.renderer||new Renderer;this.renderer.options=this.options;if(!this.links){throw new Error("Tokens array requires a `links` property.")}if(this.options.gfm){if(this.options.breaks){this.rules=inline.breaks}else{this.rules=inline.gfm}}else if(this.options.pedantic){this.rules=inline.pedantic}}InlineLexer.rules=inline;InlineLexer.output=function(src,links,options){var inline=new InlineLexer(links,options);return inline.output(src)};InlineLexer.prototype.output=function(src){var out="",link,text,href,cap;while(src){if(cap=this.rules.escape.exec(src)){src=src.substring(cap[0].length);out+=cap[1];continue}if(cap=this.rules.autolink.exec(src)){src=src.substring(cap[0].length);if(cap[2]==="@"){text=cap[1].charAt(6)===":"?this.mangle(cap[1].substring(7)):this.mangle(cap[1]);href=this.mangle("mailto:")+text}else{text=escape(cap[1]);href=text}out+=this.renderer.link(href,null,text);continue}if(!this.inLink&&(cap=this.rules.url.exec(src))){src=src.substring(cap[0].length);text=escape(cap[1]);href=text;out+=this.renderer.link(href,null,text);continue}if(cap=this.rules.tag.exec(src)){if(!this.inLink&&/^<a /i.test(cap[0])){this.inLink=true}else if(this.inLink&&/^<\/a>/i.test(cap[0])){this.inLink=false}src=src.substring(cap[0].length);out+=this.options.sanitize?this.options.sanitizer?this.options.sanitizer(cap[0]):escape(cap[0]):cap[0];continue}if(cap=this.rules.link.exec(src)){src=src.substring(cap[0].length);this.inLink=true;out+=this.outputLink(cap,{href:cap[2],title:cap[3]});this.inLink=false;continue}if((cap=this.rules.reflink.exec(src))||(cap=this.rules.nolink.exec(src))){src=src.substring(cap[0].length);link=(cap[2]||cap[1]).replace(/\s+/g," ");link=this.links[link.toLowerCase()];if(!link||!link.href){out+=cap[0].charAt(0);src=cap[0].substring(1)+src;continue}this.inLink=true;out+=this.outputLink(cap,link);this.inLink=false;continue}if(cap=this.rules.strong.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.strong(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.em.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.em(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.codespan(escape(cap[2],true));continue}if(cap=this.rules.br.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.br();continue}if(cap=this.rules.del.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.del(this.output(cap[1]));continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.text(escape(this.smartypants(cap[0])));continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return out};InlineLexer.prototype.outputLink=function(cap,link){var href=escape(link.href),title=link.title?escape(link.title):null;return cap[0].charAt(0)!=="!"?this.renderer.link(href,title,this.output(cap[1])):this.renderer.image(href,title,escape(cap[1]))};InlineLexer.prototype.smartypants=function(text){if(!this.options.smartypants)return text;return text.replace(/---/g,"—").replace(/--/g,"–").replace(/(^|[-\u2014\/(\[{"\s])'/g,"$1‘").replace(/'/g,"’").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g,"$1“").replace(/"/g,"”").replace(/\.{3}/g,"…")};InlineLexer.prototype.mangle=function(text){if(!this.options.mangle)return text;var out="",l=text.length,i=0,ch;for(;i<l;i++){ch=text.charCodeAt(i);if(Math.random()>.5){ch="x"+ch.toString(16)}out+="&#"+ch+";"}return out};function Renderer(options){this.options=options||{}}Renderer.prototype.code=function(code,lang,escaped){if(this.options.highlight){var out=this.options.highlight(code,lang);if(out!=null&&out!==code){escaped=true;code=out}}if(!lang){return"<pre><code>"+(escaped?code:escape(code,true))+"\n</code></pre>"}return'<pre><code class="'+this.options.langPrefix+escape(lang,true)+'">'+(escaped?code:escape(code,true))+"\n</code></pre>\n"};Renderer.prototype.blockquote=function(quote){return"<blockquote>\n"+quote+"</blockquote>\n"};Renderer.prototype.html=function(html){return html};Renderer.prototype.heading=function(text,level,raw){return"<h"+level+' id="'+this.options.headerPrefix+raw.toLowerCase().replace(/[^\w]+/g,"-")+'">'+text+"</h"+level+">\n"};Renderer.prototype.hr=function(){return this.options.xhtml?"<hr/>\n":"<hr>\n"};Renderer.prototype.list=function(body,ordered){var type=ordered?"ol":"ul";return"<"+type+">\n"+body+"</"+type+">\n"};Renderer.prototype.listitem=function(text){return"<li>"+text+"</li>\n"};Renderer.prototype.paragraph=function(text){return"<p>"+text+"</p>\n"};Renderer.prototype.table=function(header,body){return"<table>\n"+"<thead>\n"+header+"</thead>\n"+"<tbody>\n"+body+"</tbody>\n"+"</table>\n"};Renderer.prototype.tablerow=function(content){return"<tr>\n"+content+"</tr>\n"};Renderer.prototype.tablecell=function(content,flags){var type=flags.header?"th":"td";var tag=flags.align?"<"+type+' style="text-align:'+flags.align+'">':"<"+type+">";return tag+content+"</"+type+">\n"};Renderer.prototype.strong=function(text){return"<strong>"+text+"</strong>"};Renderer.prototype.em=function(text){return"<em>"+text+"</em>"};Renderer.prototype.codespan=function(text){return"<code>"+text+"</code>"};Renderer.prototype.br=function(){return this.options.xhtml?"<br/>":"<br>"};Renderer.prototype.del=function(text){return"<del>"+text+"</del>"};Renderer.prototype.link=function(href,title,text){if(this.options.sanitize){try{var prot=decodeURIComponent(unescape(href)).replace(/[^\w:]/g,"").toLowerCase()}catch(e){return""}if(prot.indexOf("javascript:")===0||prot.indexOf("vbscript:")===0||prot.indexOf("data:")===0){return""}}var out='<a href="'+href+'"';if(title){out+=' title="'+title+'"'}out+=">"+text+"</a>";return out};Renderer.prototype.image=function(href,title,text){var out='<img src="'+href+'" alt="'+text+'"';if(title){out+=' title="'+title+'"'}out+=this.options.xhtml?"/>":">";return out};Renderer.prototype.text=function(text){return text};function Parser(options){this.tokens=[];this.token=null;this.options=options||marked.defaults;this.options.renderer=this.options.renderer||new Renderer;this.renderer=this.options.renderer;this.renderer.options=this.options}Parser.parse=function(src,options,renderer){var parser=new Parser(options,renderer);return parser.parse(src)};Parser.prototype.parse=function(src){this.inline=new InlineLexer(src.links,this.options,this.renderer);this.tokens=src.reverse();var out="";while(this.next()){out+=this.tok()}return out};Parser.prototype.next=function(){return this.token=this.tokens.pop()};Parser.prototype.peek=function(){return this.tokens[this.tokens.length-1]||0};Parser.prototype.parseText=function(){var body=this.token.text;while(this.peek().type==="text"){body+="\n"+this.next().text}return this.inline.output(body)};Parser.prototype.tok=function(){switch(this.token.type){case"space":{return""}case"hr":{return this.renderer.hr()}case"heading":{return this.renderer.heading(this.inline.output(this.token.text),this.token.depth,this.token.text)}case"code":{return this.renderer.code(this.token.text,this.token.lang,this.token.escaped)}case"table":{var header="",body="",i,row,cell,flags,j;cell="";for(i=0;i<this.token.header.length;i++){flags={header:true,align:this.token.align[i]};cell+=this.renderer.tablecell(this.inline.output(this.token.header[i]),{header:true,align:this.token.align[i]})}header+=this.renderer.tablerow(cell);for(i=0;i<this.token.cells.length;i++){row=this.token.cells[i];cell="";for(j=0;j<row.length;j++){cell+=this.renderer.tablecell(this.inline.output(row[j]),{header:false,align:this.token.align[j]})}body+=this.renderer.tablerow(cell)}return this.renderer.table(header,body)}case"blockquote_start":{var body="";while(this.next().type!=="blockquote_end"){body+=this.tok()}return this.renderer.blockquote(body)}case"list_start":{var body="",ordered=this.token.ordered;while(this.next().type!=="list_end"){body+=this.tok()}return this.renderer.list(body,ordered)}case"list_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.token.type==="text"?this.parseText():this.tok()}return this.renderer.listitem(body)}case"loose_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.tok()}return this.renderer.listitem(body)}case"html":{var html=!this.token.pre&&!this.options.pedantic?this.inline.output(this.token.text):this.token.text;return this.renderer.html(html)}case"paragraph":{return this.renderer.paragraph(this.inline.output(this.token.text))}case"text":{return this.renderer.paragraph(this.parseText())}}};function escape(html,encode){return html.replace(!encode?/&(?!#?\w+;)/g:/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function unescape(html){return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g,function(_,n){n=n.toLowerCase();if(n==="colon")return":";if(n.charAt(0)==="#"){return n.charAt(1)==="x"?String.fromCharCode(parseInt(n.substring(2),16)):String.fromCharCode(+n.substring(1))}return""})}function replace(regex,opt){regex=regex.source;opt=opt||"";return function self(name,val){if(!name)return new RegExp(regex,opt);val=val.source||val;val=val.replace(/(^|[^\[])\^/g,"$1");regex=regex.replace(name,val);return self}}function noop(){}noop.exec=noop;function merge(obj){var i=1,target,key;for(;i<arguments.length;i++){target=arguments[i];for(key in target){if(Object.prototype.hasOwnProperty.call(target,key)){obj[key]=target[key]}}}return obj}function marked(src,opt,callback){if(callback||typeof opt==="function"){if(!callback){callback=opt;opt=null}opt=merge({},marked.defaults,opt||{});var highlight=opt.highlight,tokens,pending,i=0;try{tokens=Lexer.lex(src,opt)}catch(e){return callback(e)}pending=tokens.length;var done=function(err){if(err){opt.highlight=highlight;return callback(err)}var out;try{out=Parser.parse(tokens,opt)}catch(e){err=e}opt.highlight=highlight;return err?callback(err):callback(null,out)};if(!highlight||highlight.length<3){return done()}delete opt.highlight;if(!pending)return done();for(;i<tokens.length;i++){(function(token){if(token.type!=="code"){return--pending||done()}return highlight(token.text,token.lang,function(err,code){if(err)return done(err);if(code==null||code===token.text){return--pending||done()}token.text=code;token.escaped=true;--pending||done()})})(tokens[i])}return}try{if(opt)opt=merge({},marked.defaults,opt);return Parser.parse(Lexer.lex(src,opt),opt)}catch(e){e.message+="\nPlease report this to https://github.com/chjj/marked.";if((opt||marked.defaults).silent){return"<p>An error occured:</p><pre>"+escape(e.message+"",true)+"</pre>"}throw e}}marked.options=marked.setOptions=function(opt){merge(marked.defaults,opt);return marked};marked.defaults={gfm:true,tables:true,breaks:false,pedantic:false,sanitize:false,sanitizer:null,mangle:true,smartLists:false,silent:false,highlight:null,langPrefix:"lang-",smartypants:false,headerPrefix:"",renderer:new Renderer,xhtml:false};marked.Parser=Parser;marked.parser=Parser.parse;marked.Renderer=Renderer;marked.Lexer=Lexer;marked.lexer=Lexer.lex;marked.InlineLexer=InlineLexer;marked.inlineLexer=InlineLexer.output;marked.parse=marked;if(typeof module!=="undefined"&&typeof exports==="object"){module.exports=marked}else if(typeof define==="function"&&define.amd){define(function(){return marked})}else{this.marked=marked}}).call(function(){return this||(typeof window!=="undefined"?window:global)}());

	return module.exports;
}();


// FORMAT OPTIONS FOR MARKED IMPLEMENTATION

function _Markdown_formatOptions(options)
{
	function toHighlight(code, lang)
	{
		if (!lang && $elm$core$Maybe$isJust(options.ln))
		{
			lang = options.ln.a;
		}

		if (typeof hljs !== 'undefined' && lang && hljs.listLanguages().indexOf(lang) >= 0)
		{
			return hljs.highlight(lang, code, true).value;
		}

		return code;
	}

	var gfm = options.lN.a;

	return {
		highlight: toHighlight,
		gfm: gfm,
		tables: gfm && gfm.n$,
		breaks: gfm && gfm.k4,
		sanitize: options.nv,
		smartypants: options.nI
	};
}



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}

var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$LinkClicked = function (a) {
	return {$: 8, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $author$project$Main$UrlChange = function (a) {
	return {$: 5, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.X) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.ac),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.ac);
		} else {
			var treeLen = builder.X * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.ae) : builder.ae;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.X);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.ac) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.ac);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{ae: nodeList, X: (len / $elm$core$Array$branchFactor) | 0, ac: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {i1: fragment, hm: host, m5: path, jM: port_, jS: protocol, bF: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Auth0$Auth0Config = F3(
	function (domain, clientId, redirectURL) {
		return {iJ: clientId, iU: domain, jV: redirectURL};
	});
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Ports$fetchCsrfToken = _Platform_outgoingPort(
	'fetchCsrfToken',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Main$authenticateStep1 = $author$project$Ports$fetchCsrfToken(0);
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Ports$consoleInfo = _Platform_outgoingPort('consoleInfo', $elm$json$Json$Encode$string);
var $author$project$Api$Endpoint$create = function (flags) {
	return {fK: flags.fK, k3: $elm$core$Maybe$Nothing, lg: $elm$core$Maybe$Nothing, hD: flags.hD, hE: flags.hE};
};
var $author$project$SharedConfig$create = F2(
	function (flags, key) {
		return {
			gX: $author$project$Api$Endpoint$create(flags),
			g0: flags.g0,
			jk: key
		};
	});
var $author$project$Locale$Hungarian$isFirstNameFirst = false;
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $ryan_haskell$date_format$DateFormat$DayOfMonthSuffix = {$: 6};
var $ryan_haskell$date_format$DateFormat$dayOfMonthSuffix = $ryan_haskell$date_format$DateFormat$DayOfMonthSuffix;
var $ryan_haskell$date_format$DateFormat$DayOfWeekNameFull = {$: 14};
var $ryan_haskell$date_format$DateFormat$dayOfWeekNameFull = $ryan_haskell$date_format$DateFormat$DayOfWeekNameFull;
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.h2, posixMinutes) < 0) {
					return posixMinutes + era.d;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $ryan_haskell$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.n5(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		fY: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		jt: month,
		kF: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).fY;
	});
var $ryan_haskell$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $ryan_haskell$date_format$DateFormat$days = _List_fromArray(
	[6, 0, 1, 2, 3, 4, 5]);
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $ryan_haskell$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 6),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryan_haskell$date_format$DateFormat$days)))));
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $ryan_haskell$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryan_haskell$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $ryan_haskell$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $ryan_haskell$date_format$DateFormat$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).jt;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $ryan_haskell$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryan_haskell$date_format$DateFormat$months))));
	});
var $ryan_haskell$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryan_haskell$date_format$DateFormat$monthPair, zone, posix));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).kF;
	});
var $ryan_haskell$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryan_haskell$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryan_haskell$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryan_haskell$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $ryan_haskell$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $elm$core$String$toLower = _String_toLower;
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$core$String$toUpper = _String_toUpper;
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$core$Basics$round = _Basics_round;
var $ryan_haskell$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryan_haskell$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryan_haskell$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryan_haskell$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryan_haskell$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 0:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 1:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.eF(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 2:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 3:
				return language.n7(
					A2($elm$time$Time$toMonth, zone, posix));
			case 4:
				return language.n8(
					A2($elm$time$Time$toMonth, zone, posix));
			case 17:
				return $elm$core$String$fromInt(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 18:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.eF(num));
				}(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 5:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 6:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.eF(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 7:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 8:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 9:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.eF(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 10:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 11:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 12:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.eF(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 13:
				return language.n9(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 14:
				return language.oa(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 19:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 20:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.eF(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 21:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 15:
				return A2(
					$elm$core$String$right,
					2,
					A2($ryan_haskell$date_format$DateFormat$year, zone, posix));
			case 16:
				return A2($ryan_haskell$date_format$DateFormat$year, zone, posix);
			case 22:
				return $elm$core$String$toUpper(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 23:
				return $elm$core$String$toLower(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 24:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 25:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 26:
				return $elm$core$String$fromInt(
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 27:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 28:
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 29:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 30:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 31:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 32:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 33:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 34:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 35:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryan_haskell$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryan_haskell$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryan_haskell$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {n5: toAmPm, n7: toMonthAbbreviation, n8: toMonthName, eF: toOrdinalSuffix, n9: toWeekdayAbbreviation, oa: toWeekdayName};
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $author$project$Locale$Hungarian$toHungarianAmPm = function (hour) {
	return (hour > 11) ? 'du.' : 'de.';
};
var $author$project$Locale$Hungarian$toHungarianMonthAbbreviaton = function (month) {
	switch (month) {
		case 0:
			return 'jan.';
		case 1:
			return 'febr.';
		case 2:
			return 'márc.';
		case 3:
			return 'ápr.';
		case 4:
			return 'máj.';
		case 5:
			return 'jún.';
		case 6:
			return 'júl.';
		case 7:
			return 'aug.';
		case 8:
			return 'szept.';
		case 9:
			return 'okt.';
		case 10:
			return 'nov.';
		default:
			return 'dec.';
	}
};
var $author$project$Locale$Hungarian$toHungarianMonthName = function (month) {
	switch (month) {
		case 0:
			return 'január';
		case 1:
			return 'február';
		case 2:
			return 'március';
		case 3:
			return 'április';
		case 4:
			return 'május';
		case 5:
			return 'június';
		case 6:
			return 'július';
		case 7:
			return 'augusztus';
		case 8:
			return 'szeptember';
		case 9:
			return 'október';
		case 10:
			return 'november';
		default:
			return 'decemeber';
	}
};
var $author$project$Locale$Hungarian$toHungarianWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'hétfő';
		case 1:
			return 'kedd';
		case 2:
			return 'szerda';
		case 3:
			return 'csütörtök';
		case 4:
			return 'péntek';
		case 5:
			return 'szombat';
		default:
			return 'vasárnap';
	}
};
var $author$project$Locale$Hungarian$hungarian = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	$author$project$Locale$Hungarian$toHungarianMonthName,
	$author$project$Locale$Hungarian$toHungarianMonthAbbreviaton,
	$author$project$Locale$Hungarian$toHungarianWeekdayName,
	$author$project$Locale$Hungarian$toHungarianWeekdayName,
	$author$project$Locale$Hungarian$toHungarianAmPm,
	$elm$core$Basics$always('.'));
var $ryan_haskell$date_format$DateFormat$MonthNameFull = {$: 4};
var $ryan_haskell$date_format$DateFormat$monthNameFull = $ryan_haskell$date_format$DateFormat$MonthNameFull;
var $ryan_haskell$date_format$DateFormat$Text = function (a) {
	return {$: 36, a: a};
};
var $ryan_haskell$date_format$DateFormat$text = $ryan_haskell$date_format$DateFormat$Text;
var $ryan_haskell$date_format$DateFormat$YearNumber = {$: 16};
var $ryan_haskell$date_format$DateFormat$yearNumber = $ryan_haskell$date_format$DateFormat$YearNumber;
var $author$project$Locale$Hungarian$dateFormatter = A2(
	$ryan_haskell$date_format$DateFormat$formatWithLanguage,
	$author$project$Locale$Hungarian$hungarian,
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$yearNumber,
			$ryan_haskell$date_format$DateFormat$text('. '),
			$ryan_haskell$date_format$DateFormat$monthNameFull,
			$ryan_haskell$date_format$DateFormat$text(' '),
			$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix,
			$ryan_haskell$date_format$DateFormat$text(' ('),
			$ryan_haskell$date_format$DateFormat$dayOfWeekNameFull,
			$ryan_haskell$date_format$DateFormat$text(')')
		]));
var $ryan_haskell$date_format$DateFormat$HourMilitaryNumber = {$: 24};
var $ryan_haskell$date_format$DateFormat$hourMilitaryNumber = $ryan_haskell$date_format$DateFormat$HourMilitaryNumber;
var $ryan_haskell$date_format$DateFormat$MinuteFixed = {$: 31};
var $ryan_haskell$date_format$DateFormat$minuteFixed = $ryan_haskell$date_format$DateFormat$MinuteFixed;
var $author$project$Locale$Hungarian$dateTimeFormatter = A2(
	$ryan_haskell$date_format$DateFormat$formatWithLanguage,
	$author$project$Locale$Hungarian$hungarian,
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$yearNumber,
			$ryan_haskell$date_format$DateFormat$text('. '),
			$ryan_haskell$date_format$DateFormat$monthNameFull,
			$ryan_haskell$date_format$DateFormat$text(' '),
			$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix,
			$ryan_haskell$date_format$DateFormat$text(' ('),
			$ryan_haskell$date_format$DateFormat$dayOfWeekNameFull,
			$ryan_haskell$date_format$DateFormat$text(')'),
			$ryan_haskell$date_format$DateFormat$text(' '),
			$ryan_haskell$date_format$DateFormat$hourMilitaryNumber,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed
		]));
var $author$project$Locale$Hungarian$formatDays = function (weekdays) {
	var weekdayToText = function (weekday) {
		switch (weekday) {
			case 'MO':
				return 'hétfőn';
			case 'TU':
				return 'kedden';
			case 'WE':
				return 'szerdán';
			case 'TH':
				return 'csütörtökön';
			case 'FR':
				return 'pénteken';
			default:
				return '';
		}
	};
	if (!weekdays.$) {
		var weekdays_ = weekdays.a;
		return A2(
			$elm$core$String$join,
			', ',
			A2($elm$core$List$map, weekdayToText, weekdays_));
	} else {
		return '';
	}
};
var $author$project$Locale$Hungarian$formatRecurring = F2(
	function (frequency, interval) {
		var _v0 = _Utils_Tuple2(frequency, interval);
		if (((_v0.a === 'Weekly') && (!_v0.b.$)) && (_v0.b.a === 2)) {
			return 'kéthetente ';
		} else {
			return 'minden héten ';
		}
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Locale$Hungarian$nameList = function (names) {
	var _v0 = $elm$core$List$reverse(names);
	if (!_v0.b) {
		return '';
	} else {
		if (!_v0.b.b) {
			var x = _v0.a;
			return x;
		} else {
			var x = _v0.a;
			var xs = _v0.b;
			return A2(
				$elm$core$String$join,
				', ',
				$elm$core$List$reverse(xs)) + (' és ' + x);
		}
	}
};
var $ryan_haskell$date_format$DateFormat$DayOfMonthNumber = {$: 5};
var $ryan_haskell$date_format$DateFormat$dayOfMonthNumber = $ryan_haskell$date_format$DateFormat$DayOfMonthNumber;
var $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated = {$: 3};
var $ryan_haskell$date_format$DateFormat$monthNameAbbreviated = $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated;
var $author$project$Locale$Hungarian$termFormatter = F3(
	function (zone, start, end) {
		var sameYear = _Utils_eq(
			A2($elm$time$Time$toYear, zone, start),
			A2($elm$time$Time$toYear, zone, end));
		var sameMonth = _Utils_eq(
			A2($elm$time$Time$toMonth, zone, start),
			A2($elm$time$Time$toMonth, zone, end));
		var sameDay = _Utils_eq(
			A2($elm$time$Time$toDay, zone, start),
			A2($elm$time$Time$toDay, zone, end));
		var _v0 = _Utils_Tuple3(sameYear, sameMonth, sameDay);
		if (_v0.a) {
			if (_v0.b) {
				if (_v0.c) {
					var startDate = A4(
						$ryan_haskell$date_format$DateFormat$formatWithLanguage,
						$author$project$Locale$Hungarian$hungarian,
						_List_fromArray(
							[
								$ryan_haskell$date_format$DateFormat$yearNumber,
								$ryan_haskell$date_format$DateFormat$text('. '),
								$ryan_haskell$date_format$DateFormat$monthNameFull,
								$ryan_haskell$date_format$DateFormat$text(' '),
								$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
								$ryan_haskell$date_format$DateFormat$text('.'),
								$ryan_haskell$date_format$DateFormat$text(' ('),
								$ryan_haskell$date_format$DateFormat$dayOfWeekNameFull,
								$ryan_haskell$date_format$DateFormat$text(')')
							]),
						zone,
						start);
					return startDate;
				} else {
					var startDate = A4(
						$ryan_haskell$date_format$DateFormat$formatWithLanguage,
						$author$project$Locale$Hungarian$hungarian,
						_List_fromArray(
							[
								$ryan_haskell$date_format$DateFormat$yearNumber,
								$ryan_haskell$date_format$DateFormat$text('. '),
								$ryan_haskell$date_format$DateFormat$monthNameFull,
								$ryan_haskell$date_format$DateFormat$text(' '),
								$ryan_haskell$date_format$DateFormat$dayOfMonthNumber
							]),
						zone,
						start);
					var endDate = A4(
						$ryan_haskell$date_format$DateFormat$formatWithLanguage,
						$author$project$Locale$Hungarian$hungarian,
						_List_fromArray(
							[$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix]),
						zone,
						end);
					return startDate + (' – ' + endDate);
				}
			} else {
				var startDate = A4(
					$ryan_haskell$date_format$DateFormat$formatWithLanguage,
					$author$project$Locale$Hungarian$hungarian,
					_List_fromArray(
						[
							$ryan_haskell$date_format$DateFormat$yearNumber,
							$ryan_haskell$date_format$DateFormat$text('. '),
							$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
							$ryan_haskell$date_format$DateFormat$text(' '),
							$ryan_haskell$date_format$DateFormat$dayOfMonthNumber
						]),
					zone,
					start);
				var endDate = A4(
					$ryan_haskell$date_format$DateFormat$formatWithLanguage,
					$author$project$Locale$Hungarian$hungarian,
					_List_fromArray(
						[
							$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
							$ryan_haskell$date_format$DateFormat$text(' '),
							$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix
						]),
					zone,
					end);
				return startDate + (' – ' + endDate);
			}
		} else {
			var startDate = A4(
				$ryan_haskell$date_format$DateFormat$formatWithLanguage,
				$author$project$Locale$Hungarian$hungarian,
				_List_fromArray(
					[
						$ryan_haskell$date_format$DateFormat$yearNumber,
						$ryan_haskell$date_format$DateFormat$text('. '),
						$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
						$ryan_haskell$date_format$DateFormat$text(' '),
						$ryan_haskell$date_format$DateFormat$dayOfMonthNumber
					]),
				zone,
				start);
			var endDate = A4(
				$ryan_haskell$date_format$DateFormat$formatWithLanguage,
				$author$project$Locale$Hungarian$hungarian,
				_List_fromArray(
					[
						$ryan_haskell$date_format$DateFormat$yearNumber,
						$ryan_haskell$date_format$DateFormat$text('. '),
						$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
						$ryan_haskell$date_format$DateFormat$text(' '),
						$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix
					]),
				zone,
				end);
			return startDate + (' – ' + endDate);
		}
	});
var $author$project$Locale$Hungarian$timeFormatter = A2(
	$ryan_haskell$date_format$DateFormat$formatWithLanguage,
	$author$project$Locale$Hungarian$hungarian,
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$hourMilitaryNumber,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed
		]));
var $rl_king$elm_iso3166_country_codes$Iso3166$Hungarian$toName = function (c) {
	switch (c) {
		case 0:
			return 'Andorra';
		case 1:
			return 'Egyesült Arab Emírségek';
		case 2:
			return 'Afganisztán';
		case 3:
			return 'Antigua és Barbuda';
		case 4:
			return 'Anguilla';
		case 5:
			return 'Albánia';
		case 6:
			return 'Örményország';
		case 7:
			return 'Angola';
		case 8:
			return 'Antarktisz';
		case 9:
			return 'Argentína';
		case 10:
			return 'Amerikai Szamoa';
		case 11:
			return 'Ausztria';
		case 12:
			return 'Ausztrália';
		case 13:
			return 'Aruba';
		case 14:
			return 'Åland';
		case 15:
			return 'Azerbajdzsán';
		case 16:
			return 'Bosznia-Hercegovina';
		case 17:
			return 'Barbados';
		case 18:
			return 'Banglades';
		case 19:
			return 'Belgium';
		case 20:
			return 'Burkina Faso';
		case 21:
			return 'Bulgária';
		case 22:
			return 'Bahrein';
		case 23:
			return 'Burundi';
		case 24:
			return 'Benin';
		case 25:
			return 'Saint-Barthélemy';
		case 26:
			return 'Bermuda';
		case 27:
			return 'Brunei';
		case 28:
			return 'Bolívia';
		case 29:
			return 'Karibi Hollandia (Bonaire, Saba, Sint Eustatius)';
		case 30:
			return 'Brazília';
		case 31:
			return 'Bahama-szigetek';
		case 32:
			return 'Bhután';
		case 33:
			return 'Bouvet-sziget';
		case 34:
			return 'Botswana';
		case 35:
			return 'Fehéroroszország';
		case 36:
			return 'Belize';
		case 37:
			return 'Kanada';
		case 38:
			return 'Kókusz (Keeling)-szigetek';
		case 39:
			return 'Kongói Demokratikus Köztársaság (Zaire)';
		case 40:
			return 'Közép-Afrika';
		case 41:
			return 'Kongói Köztársaság (Kongó)';
		case 42:
			return 'Svájc';
		case 43:
			return 'Elefántcsontpart';
		case 44:
			return 'Cook-szigetek';
		case 45:
			return 'Chile';
		case 46:
			return 'Kamerun';
		case 47:
			return 'Kína';
		case 48:
			return 'Kolumbia';
		case 49:
			return 'Costa Rica';
		case 50:
			return 'Kuba';
		case 51:
			return 'Zöld-foki Köztársaság';
		case 52:
			return 'Curaçao';
		case 53:
			return 'Karácsony-sziget';
		case 54:
			return 'Ciprus';
		case 55:
			return 'Csehország';
		case 56:
			return 'Németország';
		case 57:
			return 'Dzsibuti';
		case 58:
			return 'Dánia';
		case 59:
			return 'Dominikai Közösség';
		case 60:
			return 'Dominikai Köztársaság';
		case 61:
			return 'Algéria';
		case 62:
			return 'Ecuador';
		case 63:
			return 'Észtország';
		case 64:
			return 'Egyiptom';
		case 65:
			return 'Nyugat-Szahara';
		case 66:
			return 'Eritrea';
		case 67:
			return 'Spanyolország';
		case 68:
			return 'Etiópia';
		case 69:
			return 'Finnország';
		case 70:
			return 'Fidzsi';
		case 71:
			return 'Falkland-szigetek';
		case 72:
			return 'Mikronézia';
		case 73:
			return 'Feröer';
		case 74:
			return 'Franciaország';
		case 75:
			return 'Gabon';
		case 76:
			return 'Egyesült Királyság';
		case 77:
			return 'Grenada';
		case 78:
			return 'Grúzia';
		case 79:
			return 'Francia Guyana Francia Guyana';
		case 80:
			return 'Guernsey Bailiffség';
		case 81:
			return 'Ghána';
		case 82:
			return 'Gibraltár';
		case 83:
			return 'Grönland';
		case 84:
			return 'Gambia';
		case 85:
			return 'Guinea';
		case 86:
			return 'Guadeloupe';
		case 87:
			return 'Egyenlítői-Guinea';
		case 88:
			return 'Görögország';
		case 89:
			return 'Déli-Georgia és Déli-Sandwich-szigetek';
		case 90:
			return 'Guatemala';
		case 91:
			return 'Guam';
		case 92:
			return 'Bissau-Guinea';
		case 93:
			return 'Guyana';
		case 94:
			return 'Hongkong';
		case 95:
			return 'Heard-sziget és McDonald-szigetek';
		case 96:
			return 'Honduras';
		case 97:
			return 'Horvátország';
		case 98:
			return 'Haiti';
		case 99:
			return 'Magyarország';
		case 100:
			return 'Indonézia';
		case 101:
			return 'Írország';
		case 102:
			return 'Izrael';
		case 103:
			return 'Man-sziget';
		case 104:
			return 'India';
		case 105:
			return 'Brit Indiai-óceáni Terület';
		case 106:
			return 'Irak';
		case 107:
			return 'Irán';
		case 108:
			return 'Izland';
		case 109:
			return 'Olaszország';
		case 110:
			return 'Jersey Bailiffség';
		case 111:
			return 'Jamaica';
		case 112:
			return 'Jordánia';
		case 113:
			return 'Japán';
		case 114:
			return 'Kenya';
		case 115:
			return 'Kirgizisztán';
		case 116:
			return 'Kambodzsa';
		case 117:
			return 'Kiribati';
		case 118:
			return 'Comore-szigetek';
		case 119:
			return 'Saint Kitts és Nevis';
		case 120:
			return 'Észak-Korea (Koreai NDK)';
		case 121:
			return 'Dél-Korea (Koreai Köztársaság)';
		case 122:
			return 'Kuvait';
		case 123:
			return 'Kajmán-szigetek';
		case 124:
			return 'Kazahsztán';
		case 125:
			return 'Laosz';
		case 126:
			return 'Libanon';
		case 127:
			return 'Saint Lucia';
		case 128:
			return 'Liechtenstein';
		case 129:
			return 'Srí Lanka';
		case 130:
			return 'Libéria';
		case 131:
			return 'Lesotho';
		case 132:
			return 'Litvánia';
		case 133:
			return 'Luxemburg';
		case 134:
			return 'Lettország';
		case 135:
			return 'Líbia';
		case 136:
			return 'Marokkó';
		case 137:
			return 'Monaco';
		case 138:
			return 'Moldova';
		case 139:
			return 'Montenegró';
		case 140:
			return 'Saint-Martin';
		case 141:
			return 'Madagaszkár';
		case 142:
			return 'Marshall-szigetek';
		case 143:
			return 'Észak-Macedónia';
		case 144:
			return 'Mali';
		case 145:
			return 'Mianmar';
		case 146:
			return 'Mongólia';
		case 147:
			return 'Makaó';
		case 148:
			return 'Északi-Mariana-szigetek';
		case 149:
			return 'Martinique';
		case 150:
			return 'Mauritánia';
		case 151:
			return 'Montserrat';
		case 152:
			return 'Málta';
		case 153:
			return 'Mauritius';
		case 154:
			return 'Maldív-szigetek';
		case 155:
			return 'Malawi';
		case 156:
			return 'Mexikó';
		case 157:
			return 'Malajzia';
		case 158:
			return 'Mozambik';
		case 159:
			return 'Namíbia';
		case 160:
			return 'Új-Kaledónia';
		case 161:
			return 'Niger';
		case 162:
			return 'Norfolk-sziget';
		case 163:
			return 'Nigéria';
		case 164:
			return 'Nicaragua';
		case 165:
			return 'Hollandia';
		case 166:
			return 'Norvégia';
		case 167:
			return 'Nepál';
		case 168:
			return 'Nauru';
		case 169:
			return 'Niue';
		case 170:
			return 'Új-Zéland';
		case 171:
			return 'Omán';
		case 172:
			return 'Panama';
		case 173:
			return 'Peru';
		case 174:
			return 'Francia Polinézia';
		case 175:
			return 'Pápua Új-Guinea';
		case 176:
			return 'Fülöp-szigetek';
		case 177:
			return 'Pakisztán';
		case 178:
			return 'Lengyelország';
		case 179:
			return 'Saint-Pierre és Miquelon';
		case 180:
			return 'Pitcairn-szigetek';
		case 181:
			return 'Puerto Rico';
		case 182:
			return 'Palesztina';
		case 183:
			return 'Portugália';
		case 184:
			return 'Palau';
		case 185:
			return 'Paraguay';
		case 186:
			return 'Katar';
		case 187:
			return 'Réunion';
		case 188:
			return 'Románia';
		case 189:
			return 'Szerbia';
		case 190:
			return 'Oroszország';
		case 191:
			return 'Ruanda';
		case 192:
			return 'Szaúd-Arábia';
		case 193:
			return 'Salamon-szigetek';
		case 194:
			return 'Seychelle-szigetek';
		case 195:
			return 'Szudán';
		case 196:
			return 'Svédország';
		case 197:
			return 'Szingapúr';
		case 198:
			return 'Szent Ilona';
		case 199:
			return 'Szlovénia';
		case 200:
			return 'Spitzbergák és Jan Mayen-sziget';
		case 201:
			return 'Szlovákia';
		case 202:
			return 'Sierra Leone';
		case 203:
			return 'San Marino';
		case 204:
			return 'Szenegál';
		case 205:
			return 'Szomália';
		case 206:
			return 'Suriname';
		case 207:
			return 'Dél-Szudán';
		case 208:
			return 'São Tomé és Príncipe';
		case 209:
			return 'Salvador';
		case 210:
			return 'Sint Maarten';
		case 211:
			return 'Szíria';
		case 212:
			return 'Szváziföld';
		case 213:
			return 'Turks- és Caicos-szigetek';
		case 214:
			return 'Csád';
		case 215:
			return 'Francia déli és antarktiszi területek';
		case 216:
			return 'Togo';
		case 217:
			return 'Thaiföld';
		case 218:
			return 'Tádzsikisztán';
		case 219:
			return 'Tokelau-szigetek';
		case 220:
			return 'Kelet-Timor';
		case 221:
			return 'Türkmenisztán';
		case 222:
			return 'Tunézia';
		case 223:
			return 'Tonga';
		case 224:
			return 'Törökország';
		case 225:
			return 'Trinidad és Tobago';
		case 226:
			return 'Tuvalu';
		case 227:
			return 'Tajvan';
		case 228:
			return 'Tanzánia';
		case 229:
			return 'Ukrajna';
		case 230:
			return 'Uganda';
		case 231:
			return 'Amerikai Csendes-óceáni szigetek';
		case 232:
			return 'Amerikai Egyesült Államok';
		case 233:
			return 'Uruguay';
		case 234:
			return 'Üzbegisztán';
		case 235:
			return 'Vatikán';
		case 236:
			return 'Saint Vincent és a Grenadine-szigetek';
		case 237:
			return 'Venezuela';
		case 238:
			return 'Brit Virgin-szigetek';
		case 239:
			return 'Amerikai Virgin-szigetek';
		case 240:
			return 'Vietnám';
		case 241:
			return 'Vanuatu';
		case 242:
			return 'Wallis és Futuna';
		case 243:
			return 'Szamoa';
		case 244:
			return 'Jemen';
		case 245:
			return 'Mayotte';
		case 246:
			return 'Dél-afrikai Köztársaság';
		case 247:
			return 'Zambia';
		default:
			return 'Zimbabwe';
	}
};
var $author$project$Locale$Hungarian$translator = function (str) {
	switch (str.$) {
		case 0:
			var s = str.a;
			return s;
		case 1:
			return 'Változott: ';
		case 2:
			var caption = str.a;
			return caption;
		case 3:
			var caption = str.a;
			var from = str.b;
			var to = str.c;
			var visualizeEmpty = function (s) {
				return $elm$core$String$isEmpty(s) ? '∅' : s;
			};
			return caption + (' (' + (visualizeEmpty(from) + (' → ' + (visualizeEmpty(to) + ')'))));
		case 4:
			return 'Az értesítések betöltése sikertelen';
		case 5:
			var teacher = str.a;
			var student = str.b;
			return '<i>' + (teacher + ('</i> feltöltött egy új tanulási szerződést <i>' + (student + '</i> gyerekhez.')));
		case 6:
			var teacher = str.a;
			var student = str.b;
			return '<i>' + (teacher + ('</i> frissítette <i>' + (student + '</i> tanulási szerződését.')));
		case 8:
			return 'Jelenleg nincsenek értesítések.';
		case 7:
			return 'Értesítések betöltése...';
		case 9:
			var person = str.a;
			return '<i>' + (person + '</i> mentornaplója frissült.');
		case 10:
			var teacher = str.a;
			return '<i>' + (teacher + '</i> frissítette a tanáradatait.');
		case 11:
			var student = str.a;
			return '<i>' + (student + '</i> részt vett egy foglalkozáson.');
		case 12:
			var person = str.a;
			return '<i>' + (person + '</i> frissítette az elérhetőségeit.');
		case 13:
			var approvedBy = str.a;
			var student = str.b;
			return '<i>' + (approvedBy + ('</i> frissítette <i>' + (student + '</i> gyerekadatait.')));
		case 14:
			var teacher = str.a;
			return '<i>' + (teacher + '</i> frissítette a tanáradatait.');
		case 15:
			return 'Legutóbbi értesítések';
		case 16:
			return 'Megnézem';
		case 17:
			return 'Tanulási szerződés';
		case 18:
			return 'Méltatás';
		case 19:
			return 'Tanulási eredmény visszavonása';
		case 20:
			return 'Ha töröljük a tanulási eredményt, akkor azt nem számítjuk be többé az eredményszámításba. Biztos ezt szeretnéd?';
		case 21:
			return 'Hiba történt a tanulási eredmény visszavonása közben';
		case 22:
			return 'Sikeresen töröltem a tanulási eredményt.';
		case 23:
			var names = str.a;
			return $elm$core$String$concat(
				_List_fromArray(
					[
						'Kedves ',
						$author$project$Locale$Hungarian$nameList(names),
						'! Még ezt szeretném mondani a fenti visszajelzéssel kapcsolatban:'
					]));
		case 24:
			var names = str.a;
			return $author$project$Locale$Hungarian$nameList(names) + ' tanulási eredményeit elismerted.';
		case 25:
			return 'Műveletek';
		case 27:
			return '+';
		case 26:
			return '-';
		case 28:
			return 'Létrehozás';
		case 29:
			return 'Törlés';
		case 30:
			return 'Szerkesztés';
		case 31:
			return 'Belépés';
		case 32:
			return 'Visszaállítás';
		case 33:
			return 'Mentés';
		case 34:
			return 'OK';
		case 35:
			return 'Megnézem';
		case 36:
			return 'Mégse';
		case 37:
			return 'Kiválasztás';
		case 38:
			return 'Kiválasztás törlése';
		case 39:
			return 'Szűrők';
		case 40:
			return 'A Google Tantermek kurzus lista betöltése sikertelen';
		case 41:
			var animal = str.a;
			var count = str.b;
			return $elm$core$String$fromInt(count) + (' ' + animal);
		case 42:
			return 'Counter';
		case 43:
			var code = str.a;
			return $rl_king$elm_iso3166_country_codes$Iso3166$Hungarian$toName(code);
		case 44:
			return 'BPS Curriculum';
		case 45:
			return 'BPS Curriculum';
		case 46:
			return 'Alsós magyar';
		case 47:
			return 'Érzelmi nevelés';
		case 48:
			return 'Growth mindset';
		case 49:
			return 'Mozgás';
		case 50:
			return 'Természettudomány';
		case 51:
			return 'Egész napos hiányzások';
		case 52:
			return 'A hiányzási adatok betöltése sikertelen';
		case 53:
			return 'Egész napos jelenlét';
		case 54:
			return 'Vedd ki a pipát azoknak a neve elől, akik egész nap hiányoztak. Ha valakinek a neve előtt pipát látsz, az nem jelenti azt, hogy ő egész nap jelen volt, csak annyit, hogy nem hiányzott minden óráról.';
		case 56:
			return 'ÉÉÉÉ-HH-NN';
		case 55:
			return 'A visszajelzés adatok betöltése sikertelen';
		case 57:
			return 'A dátum várt formátuma: ÉÉÉÉ-HH-NN';
		case 58:
			return 'A telefonszám várt formátuma: +36301234567';
		case 59:
			return 'Helytelen webcím';
		case 60:
			var mime = str.a;
			return 'Nem támogatott fájlformátum: ' + mime;
		case 62:
			var size = str.a;
			return 'A fájl túl nagy (' + ($elm$core$String$fromInt((((size / 1024) | 0) / 1024) | 0) + 'MB)');
		case 61:
			return 'Az idő várt 24-órás formátuma: ÓÓ:PP';
		case 63:
			return 'A vége dátum nem lehet hamarabb, mint a kezdő dátum!';
		case 64:
			return 'Nincs kiválasztható opció';
		case 65:
			return 'Hiba történt a dokumentum feltöltése közben';
		case 66:
			return 'Nincs kiválasztva';
		case 67:
			return ' – nem kötelező';
		case 68:
			return 'Több elem kiválasztásához tartsd nyomva a <kbd>Ctrl</kbd> (Windows/Linux) vagy <kbd>Cmd</kbd> (Mac) billentyűt, miközben egérrel kattintva kijelölöd őket.';
		case 69:
			return 'Nem töltöttél fel dokumentumot!';
		case 70:
			return 'Nem lehet üres!';
		case 71:
			return 'Kérlek, adj meg egy érvényes email címet!';
		case 72:
			return 'Kérlek, írj kicsit hosszabban!';
		case 73:
			return 'Kérlek, válassz egy lehetőséget!';
		case 74:
			return 'Hiba történt az adatok mentése közben';
		case 75:
			return 'Összes kijelölése';
		case 76:
			return 'Egyik sem';
		case 77:
			return 'ÓÓ:PP';
		case 78:
			return 'My BPS';
		case 79:
			return 'Lezárt modulok';
		case 80:
			return 'Az értesítők betöltése sikertelen';
		case 81:
			return 'Osztályzatok PDF-ben';
		case 82:
			return 'Visszajelzések PDF-ben';
		case 83:
			return 'felmentve';
		case 84:
			return 'Betöltöm az értesítőket, kérlek, várj...';
		case 85:
			return 'Nincsen elérhető értesítő a gyerek számára';
		case 86:
			return 'Tantárgy';
		case 87:
			return 'Szöveges értékelés';
		case 88:
			return 'Azt szeretnénk, hogy a jegyek az iskolai mindennapokban minél inkább háttérbe szoruljanak, ezért az osztályzatokat tartalmazó év végi értesítőt a 21/22-es tanévtől nem küldjük ki. Szülőként ezt a dokumentumot külön igényelned kell. Az <a href=\"https://forms.gle/JSnaSzAmgNRttLNw7\" target=\"_blank\">igényléshez ezt az űrlapot</a> szükséges kitöltened.';
		case 89:
			return 'Értesítők';
		case 90:
			return 'Kattints ide, ha szeretnéd tantárgyankénti bontásban böngészni a visszajelzéseket.';
		case 91:
			var startYear = str.a;
			var endYear = str.b;
			return $elm$core$String$fromInt(startYear) + ('/' + ($elm$core$String$fromInt(endYear) + ' félév'));
		case 92:
			var startYear = str.a;
			var endYear = str.b;
			return $elm$core$String$fromInt(startYear) + ('/' + ($elm$core$String$fromInt(endYear) + ' évvége'));
		case 93:
			var startYear = str.a;
			var endYear = str.b;
			return $elm$core$String$fromInt(startYear) + ('/' + ($elm$core$String$fromInt(endYear) + ' osztályozó vizsga'));
		case 94:
			return 'Félévi értesítő';
		case 95:
			return 'Évvégi értesítő';
		case 96:
			return 'Osztályozó vizsga értesítő';
		case 113:
			return 'Iskola';
		case 97:
			return 'Ebből a félévből még nem tudsz osztályzatot igényelni.';
		case 98:
			return 'Tantárgyi osztályzatok';
		case 99:
			return 'Ha a gyerekednek szüksége van arra, hogy a tanárai a szöveges értékeléseit osztályzatokra váltsák át, akkor jelöld ki a tantárgy melletti check-boxot és kattints az Osztályzatokat igénylek gombra. Kérjük, csak azokból a tárgyakból igényelj osztályzatot, amelyekre a gyerekednek valami miatt aktuálisan szüksége van.';
		case 100:
			return 'Osztályzatokat igénylek';
		case 101:
			return 'Osztályzatok igénylése';
		case 102:
			return 'Osztályzat státusza';
		case 103:
			return 'Nincsen elérhető értesítő ami alapján osztályzatot igényelhetsz.';
		case 104:
			return 'Nincsenek tantárgyak, amelyekból osztályzatot igényelhetsz.';
		case 105:
			return 'Nem igényelt';
		case 106:
			return 'Hiba történt az osztályzatigénylés közben.';
		case 107:
			return 'Osztályzatigénylés sikeres.';
		case 108:
			return 'Tantárgy';
		case 109:
			return 'Osztályzás folyamatban';
		case 110:
			return 'Indoklás';
		case 111:
			return 'Indokold miért akarsz osztályzatot igényelni';
		case 112:
			return 'Osztályozás alól felmentve';
		case 114:
			return 'Szülők:';
		case 115:
			return 'A tanárok és szülők elérhetőségeit a telefonkönyvben találod.';
		case 116:
			return 'Telefonkönyv';
		case 117:
			return 'Itt egy helyen eléred a mikroiskola gyerekeit és a legfontosabb dokumentumaikat.';
		case 118:
			return 'Gyerekek';
		case 119:
			return 'Adatlap';
		case 120:
			return 'Aktív';
		case 121:
			return 'Inaktív';
		case 122:
			return 'Nem töltöttél fel igazoló dokumentumot!';
		case 123:
			return 'Az igazoló dokumentumot az szmsz-ben meghatározott módon tároljuk.';
		case 124:
			return 'A tanulási értékelések betöltése sikertelen';
		case 125:
			return 'Vége dátum';
		case 126:
			return 'Kezdő dátum';
		case 127:
			return 'Gyerek';
		case 128:
			return 'Dokumentum link';
		case 129:
			return 'A tanulási szerződések betöltése sikertelen';
		case 130:
			var zone = str.a;
			var start = str.b;
			var end = str.c;
			return A3($author$project$Locale$Hungarian$termFormatter, zone, start, end);
		case 131:
			var name = str.a;
			return name + ' tanulási szerződése';
		case 133:
			return 'Jelenleg nincs feltöltve tanulási szerződés. Ha szerinted hiányzik valami, kérlek, lépj kapcsolatba a gyereked mentorával.';
		case 134:
			return 'Még nem töltöttél fel tanulási szerződéseket. Vigyél fel egy újat!';
		case 135:
			return 'A keresett tanulási szerződés nem található. Talán törölték, nincs hozzá jogosultságod, vagy csak egyszerűen nincs ilyen.';
		case 132:
			return 'Betöltöm a tanulási szerződéseket, kérlek, várj...';
		case 136:
			return 'Sikeresen elmentettem a tanulási szerződést.';
		case 137:
			return 'Tanulási szerződés szerkesztése';
		case 138:
			return 'Új tanulási szerződés feltöltése';
		case 139:
			return 'Tanulási szerződések';
		case 140:
			return 'Tanulási szerződés keresése...';
		case 141:
			return 'Nem találtam egy tanulási szerződést sem';
		case 142:
			return 'Saját csoport';
		case 143:
			return 'Mikroiskola csoport';
		case 144:
			return 'Hiba történt a csoport törlése közben.';
		case 145:
			return 'Sikeresen töröltem a csoportot.';
		case 146:
			return 'A csoportok betöltése sikertelen';
		case 147:
			return 'Nincsenek gyerekek a csoportban.';
		case 148:
			return 'Megosztás';
		case 149:
			return 'Csoport neve';
		case 150:
			return 'Iskola kiválasztása';
		case 151:
			return 'Gyerekek kiválasztása';
		case 152:
			return 'Csoport szerkesztése';
		case 153:
			return 'Új csoport létrehozása';
		case 154:
			return 'Csoportok listája';
		case 155:
			return 'Minden csoport';
		case 156:
			return 'Nem találhatók csoportok';
		case 157:
			return 'Betöltöm a csoportokat, kérlek, várj...';
		case 158:
			return 'Saját csoportok';
		case 159:
			return 'Mikroiskola csoportok';
		case 160:
			return 'Keresés a csoport címében és a tagok között';
		case 161:
			return 'Csoportok';
		case 162:
			return 'Hiba történt a csoport mentése közben.';
		case 163:
			return 'Sikeresen elmentettem a csoportot.';
		case 164:
			return 'Csoportok';
		case 165:
			return 'Válaszd ki a csoportot a legördülő listából, hogy a tagjait hozzá add a modulod résztvevőihez.';
		case 166:
			return 'Adj csoportokat a modulodhoz';
		case 167:
			return 'Csoportok';
		case 168:
			return 'Indul a My BPS, egy pillanat az egész...';
		case 169:
			return 'Belépés a My BPS-be';
		case 170:
			return 'A MyBPS csak a BPS-es gyerekek, szülők és tanárok számára elérhető.';
		case 171:
			return 'Kijelentkezés...';
		case 172:
			var name = str.a;
			var grade = str.b;
			return name + (' (' + (grade + '. évf.)'));
		case 173:
			return 'Tantárgy';
		case 174:
			return 'Sajnálom, ez nem sikerült';
		case 175:
			return 'Belépés sikertelen:';
		case 176:
			return 'Kijelentkezés sikertelen:';
		case 177:
			var url = str.a;
			return 'Nem található weboldal a ' + (url + ' címen.');
		case 178:
			return '404-es hiba';
		case 179:
			return 'Az adatlapod letöltése sikertelen:';
		case 180:
			return 'Próbáld újra, amit legutoljára csináltál. Gyakran ez csak egy átmeneti hiba. A hibáról automatikusan értesültünk. Ha a probléma tartósan fent áll, kérlek, írj nekünk a <a href=\"mailto:tech@budapestschool.org\">tech@budapestschool.org</a> címen, és utána járunk a hibának.';
		case 181:
			return 'Jó hír, hogy egy újabb verziója elérhető az alkalmazásnak.';
		case 183:
			return 'Töltsd újra az appot, hogy használhasd!';
		case 184:
			return 'Modulzáró visszajelzés';
		case 185:
			return 'Minden modul elvégzése után a modul céljai, témája, fókusza alapján a gyerekek visszajelzést kapnak a tanulásukról, alkotásaikról, eredményeikről, fejlődésükről és viselkedésükről.';
		case 186:
			return 'Ehhez a modulhoz nem tartoznak még értékelőtáblázatok.';
		case 187:
			return 'Kinek adsz most visszajelzést?';
		case 188:
			return 'Hiba történt a visszajelzés mentése közben';
		case 189:
			return 'Sikeresen elmentettem a visszajelzést.';
		case 190:
			return 'Túl sok a diák a modulzáró visszajelzésben.';
		case 191:
			return 'Modulzárás áttekintő (1. trimeszter)';
		case 192:
			return 'Betöltöm a modulzárás adatokat, kérlek, várj...';
		case 193:
			return 'Modulzárás áttekintő';
		case 194:
			return 'Gyerek';
		case 195:
			return 'Modul';
		case 196:
			return 'Modul lezárva?';
		case 197:
			return 'Iskola';
		case 198:
			return 'Csak mentoráltak';
		case 199:
			return 'Típus';
		case 200:
			return 'Modul';
		case 201:
			return 'Cím';
		case 202:
			return 'Leírás';
		case 203:
			return 'Gyakoriság';
		case 204:
			return 'A megadott napokon';
		case 205:
			return 'Kezdődik';
		case 206:
			return 'Befejeződik';
		case 207:
			return 'Ezen a napon';
		case 208:
			return 'Első alkalom';
		case 209:
			return 'Utolsó alkalom';
		case 210:
			return 'A modulórák betöltése sikertelen';
		case 211:
			var title = str.a.kj;
			var frequency = str.a.V;
			var interval = str.a.jg;
			var weekdays = str.a.N;
			var isRecurring = str.a.md;
			var startTime = str.a.R;
			var endTime = str.a.G;
			var startDate = str.a.nN;
			var endDate = str.a.ly;
			return isRecurring ? (title + (': ' + ((startDate + (' és ' + (endDate + ' között '))) + (A2($author$project$Locale$Hungarian$formatRecurring, frequency, interval) + ($author$project$Locale$Hungarian$formatDays(weekdays) + (' ' + (startTime + (' - ' + endTime)))))))) : (title + (': ' + (startDate + (', ' + (startTime + (' - ' + (endTime + ' között')))))));
		case 212:
			return 'Nem magyar állampolgár esetén a Magyarország területén való tartózkodás jogcíme és a tartózkodásra jogosító okirat megnevezése, száma';
		case 213:
			return 'Tartózkodási hely';
		case 214:
			return 'Végzettségével, szakképzettségével kapcsolatos adatok';
		case 215:
			return 'Az óraadó tanár adatok betöltése sikertelen';
		case 216:
			return 'Sikeresen elmentettem az óraadó tanár adatokat.';
		case 217:
			return 'Óraadó tanár adatok';
		case 218:
			return 'Betöltöm az óraadó tanár adatokat, kérlek, várj...';
		case 219:
			return 'A keresett óraadó tanár adatlap nem található. Talán törölték, nincs hozzá jogosultságod, vagy csak egyszerűen nincs ilyen.';
		case 220:
			var name = str.a;
			return 'Modulvezető: ' + name;
		case 234:
			return 'A modulok betöltése sikertelen';
		case 221:
			return 'Modul törlése';
		case 222:
			return 'Modulzáró visszajelzés';
		case 223:
			return 'Másolat létrehozása';
		case 224:
			return 'Létrehozás és modulóra hozzáadása';
		case 225:
			return 'Új modul létrehozása ebből';
		case 226:
			return 'Mentés sablonként';
		case 227:
			return 'Új modulóra';
		case 228:
			return 'Új portfolió történet';
		case 229:
			var title = str.a;
			return 'Másolat: ' + title;
		case 230:
			return 'A modul egy lezárt időszakhoz tartozik.';
		case 231:
			return 'A modul egy lezárt időszakhoz tartozik. Szerkesztése nem lehetséges.';
		case 232:
			return 'Modulzáró visszajelzés';
		case 233:
			var title = str.a;
			return 'Ha kitörlöd a(z) <b> ' + (title + '</b> modult, az összes kapcsolódó modulóra is törlése kerül. Mehet?');
		case 235:
			return 'Modulvezető';
		case 236:
			return 'Google Tanterem kurzus';
		case 237:
			return 'A modul lényege néhány mondatban';
		case 238:
			return 'Ebben a modulban arról fogunk tanulni, hogy…\nA fontosabb tevékenységek, amikre számíthatsz…\nA megszerzett tudással…\n';
		case 240:
			return 'Migrálható az e-Krétába?';
		case 241:
			return 'Nem';
		case 242:
			return 'Igen';
		case 239:
			return 'Modul kapcsolódó anyagai (URL)';
		case 243:
			return 'Értékelés';
		case 244:
			return 'Célok, amelyeket a gyerekek elérnek a modul végére';
		case 245:
			return 'Mit fognak tudni?';
		case 246:
			return 'A modul végére megismered/megérted/felfedezed/tudni fogod, hogy…';
		case 247:
			return 'Mire lesznek képesek?';
		case 248:
			return 'A modul végére képes leszel/fejlődsz abban, hogy/elsajátítod…/használni tudod…';
		case 249:
			return 'Mit fognak létrehozni?';
		case 250:
			return 'A modul végére létrehozod/megalkotod/kitalálod/elkészíted/megtervezed…';
		case 251:
			return 'Gyerekek';
		case 252:
			return 'Tanárok';
		case 253:
			return 'Iskola';
		case 254:
			return 'Cím';
		case 256:
			return 'Vége dátum';
		case 255:
			return 'Kezdő dátum';
		case 257:
			return 'Évfolyamok';
		case 258:
			return 'Tanárok';
		case 259:
			return 'Iskolák';
		case 260:
			return 'Tantárgyak';
		case 261:
			return 'Szűrők bekapcsolva:';
		case 262:
			return 'Összes iskola';
		case 263:
			return 'Iskola';
		case 264:
			return 'Saját modulok';
		case 265:
			return 'Sablonok';
		case 266:
			return 'Segítség modul létrehozáshoz';
		case 270:
			return 'A keresett modul nem található. Talán törölték, nincs hozzá jogosultságod, vagy csak egyszerűen nincs ilyen.';
		case 267:
			return 'Betöltöm a modulokat, kérlek, várj...';
		case 268:
			return 'További modulok betöltése';
		case 269:
			return 'Nem találhatók modulok.';
		case 271:
			return 'Hiba történt a modul törlése közben';
		case 272:
			return 'Sikeresen töröltem a modult.';
		case 273:
			return 'Migrációra kész';
		case 274:
			return 'Nincsen értékelőtáblázat megadva';
		case 275:
			return 'Nincsenek megadva gyerekek még';
		case 276:
			return 'Modulórák';
		case 277:
			return 'Sikeresen elmentettem a modult.';
		case 278:
			return 'Keresés a modul címekben és leírásokban';
		case 279:
			return 'Csoportos kiválasztás';
		case 280:
			var zone = str.a;
			var start = str.b;
			var end = str.c;
			return A3($author$project$Locale$Hungarian$termFormatter, zone, start, end);
		case 281:
			return 'Modul szerkesztése';
		case 282:
			return 'Új modul létrehozása';
		case 283:
			return 'Új modul sablonból';
		case 284:
			return 'Modulok';
		case 285:
			return 'Értékelőtáblázatok';
		case 286:
			return 'Új értékelőtáblázat hozzáadása';
		case 287:
			return 'Értékelőtáblázatok kiválasztása';
		case 288:
			return 'Hozzájárulások módosítása';
		case 289:
			return 'Hiányzások igazolása';
		case 290:
			return 'A hiányzások igazolását továbbfejlesztettük, most már a my.BPS-ben, a gyereked mellett kis helikopter ikonnal tudod megnézni és igazolni ezeket.';
		case 291:
			return 'Tanulási szerződések';
		case 292:
			return 'Switch to English';
		case 293:
			return 'Átváltás magyarra';
		case 294:
			return 'Bántottak? Segítünk!';
		case 295:
			return 'Kijelentkezés';
		case 296:
			return 'Modulzárás áttekintő';
		case 297:
			return 'Modulok';
		case 298:
			return 'Modulok listája';
		case 299:
			return 'Új modul hozzáadása';
		case 300:
			return 'Értesítések';
		case 301:
			return 'Telefonkönyv';
		case 302:
			return 'Portfolió';
		case 303:
			return 'Történetek listája';
		case 304:
			return 'Új történet hozzáadása';
		case 305:
			return 'Adatlap';
		case 306:
			return 'Visszajelzés összesítő';
		case 307:
			return 'Gyerekek';
		case 308:
			return 'Gyerekek listája';
		case 309:
			return 'Órarend';
		case 310:
			return 'Értesítések';
		case 311:
			return 'Email cím';
		case 312:
			return 'Név előtag';
		case 313:
			return 'Keresztnév';
		case 314:
			var first = str.a;
			var last = str.b;
			return last + (' ' + first);
		case 316:
			return 'Vezetéknév';
		case 315:
			return 'A név vezetéknév–keresztnév formátumú';
		case 317:
			return 'Mentor';
		case 318:
			return 'Telefonszám';
		case 334:
			return 'Telephely';
		case 319:
			return 'Iskola';
		case 320:
			return 'Állandó lakcím';
		case 321:
			return 'Ország';
		case 322:
			return 'Irányítószám';
		case 323:
			return 'Város';
		case 324:
			return 'Közterület neve';
		case 325:
			return 'Közterület jellege';
		case 326:
			return 'Házszám';
		case 327:
			return 'Emelet, ajtó';
		case 328:
			return 'Születési hely';
		case 329:
			return 'Születési ország';
		case 330:
			return 'Születési dátum';
		case 331:
			return 'Állampolgárság';
		case 332:
			return 'TAJ szám';
		case 333:
			return 'Oktatási azonosító';
		case 335:
			return 'Az OM szám 11 számjegyből áll';
		case 336:
			return 'A TAJ szám 9 számjegyből áll';
		case 337:
			return 'A telefonkönyv betöltése sikertelen';
		case 338:
			return 'Mindenki';
		case 339:
			return 'Szülők';
		case 340:
			return 'Tanárok';
		case 341:
			return 'Letöltöm a telefonkönyv adatokat, kérlek, várj...';
		case 342:
			return 'Keresés';
		case 343:
			return 'Telefonkönyv';
		case 344:
			return 'Visszajelzés';
		case 345:
			return 'Google Tanterem';
		case 346:
			return 'Modulzáróként jelölöm';
		case 347:
			return 'A portfolió történet egy lezárt időszakhoz tartozik.';
		case 348:
			return 'A portfolió történet egy lezárt időszakhoz tartozik. Szerkesztése nem lehetséges.';
		case 349:
			return 'Segítség portfolió történet létrehozásahoz';
		case 350:
			return 'Mi történt?';
		case 351:
			return 'Kép/videó';
		case 352:
			return 'Kapcsolódó modul';
		case 353:
			return 'Feltöltötte';
		case 354:
			return 'Ideje';
		case 355:
			return 'Iskola';
		case 356:
			return 'Résztvevő gyerekek';
		case 357:
			return 'A portfoliók betöltése sikertelen';
		case 358:
			return 'A portfoliókhoz tartozó tanárok és gyerekek betöltése sikertelen';
		case 359:
			return 'Szűrők bekapcsolva:';
		case 360:
			return 'Összes';
		case 361:
			return 'Gyerekem';
		case 362:
			return 'Saját iskola';
		case 363:
			return 'Saját történetek';
		case 364:
			return 'Google Tanterem';
		case 365:
			return 'Modulok';
		case 366:
			return 'Saját modulok';
		case 367:
			return 'Egyik sem';
		case 368:
			return 'Gyerekek';
		case 369:
			return 'Tanárok';
		case 370:
			return 'Típus';
		case 371:
			return 'Összes';
		case 372:
			return 'Csak visszajelzéssel';
		case 373:
			return 'Csak modulzárók';
		case 374:
			return 'További portfolió történetek betöltése';
		case 375:
			var size = str.a;
			return 'Maximális fájl méret ' + ($elm$core$String$fromInt(size) + ' MB. Támogatott fájl formátumok: JPEG, MP4, PDF, PNG, Quicktime');
		case 378:
			return 'Portfolió sztori törlése';
		case 376:
			return 'Portfolió sztori szerkesztése';
		case 377:
			return 'Új portfolió sztori létrehozása';
		case 379:
			return 'Betöltöm a portfolió sztorikat, kérlek, várj...';
		case 380:
			return 'Ha törlöd a portfolió sztorit, annak tartalma és csatolmányai nem lesznek többet elérhetők. Biztos ezt szeretnéd?';
		case 381:
			return 'Hiba történt a portfolió sztori törlése közben';
		case 382:
			return 'Sikeresen töröltem a portfolió sztorit.';
		case 383:
			return 'Nem találhatók portfolió történetek.';
		case 384:
			return 'Sikeresen elmentettem a portfolió sztorit.';
		case 385:
			return 'Hiba történt a portfólió sztori mentése közben.';
		case 386:
			return 'Keresés a történetleírások és gyerekek között';
		case 387:
			var creator = str.a;
			return creator + ' megosztott egy történetet.';
		case 388:
			var creator = str.a;
			var students = str.b;
			var module_ = str.c;
			return creator + (' modulzáró visszajelzést adott ' + ($author$project$Locale$Hungarian$nameList(students) + (' részére a(z) ' + (module_ + ' c. modulról.'))));
		case 389:
			var names = str.a;
			return 'Résztvevő gyerekek: ' + $author$project$Locale$Hungarian$nameList(names);
		case 390:
			return 'Portfolió történetek';
		case 391:
			var email = str.a;
			return 'Ez a kép jelenik meg a telefonkönyvben. Szeretnéd megváltoztatni? Menj el a <a href=\"https://gravatar.com/\">gravatar.com</a> oldalra, és tölts fel egy képet, ami a megadott email címhez (<b>' + (email + '</b>) kapcsolódik.');
		case 392:
			var name = str.a;
			return name + ' elérhetőségeinek szerkesztése';
		case 393:
			return 'Betöltöm az adatlapokat, kérlek, várj...';
		case 394:
			return 'A keresett adatlap nem található. Talán törölték, nincs hozzá jogosultságod, vagy csak egyszerűen nincs ilyen.';
		case 395:
			return 'Az adatlap betöltése sikertelen';
		case 396:
			return 'Sikeresen elmentettem az adatlapot.';
		case 397:
			return 'Alapadatok';
		case 398:
			return 'Válassz ki egy értékelőtáblázatot';
		case 399:
			var title = str.a;
			return 'Kiválasztott értékelőtáblázat: ' + title;
		case 400:
			return 'Adj visszajelzést';
		case 401:
			return 'Szempont';
		case 402:
			return 'Tantárgy';
		case 403:
			return 'Nem tudtam létrehozni az értékelőtáblázatot.';
		case 405:
			return 'Hiba történt az értékelőtáblázat törlése közben';
		case 404:
			return 'Sikeresen töröltem az értékelőtáblázatot.';
		case 407:
			return 'Hiba történt az értékelőtáblázat mentése közben';
		case 406:
			return 'Sikeresen elmentettem az értékelőtáblázatot.';
		case 413:
			return 'Nem találhatók értékelőtáblázatok';
		case 414:
			return 'Saját értékelőtáblázatok';
		case 415:
			return 'Összes megosztott';
		case 416:
			return 'Kiválasztva';
		case 417:
			return 'Értékelőtáblázat szerkesztése';
		case 408:
			return 'Privát';
		case 409:
			return 'Másolatot készítek';
		case 410:
			return 'Iskolákkal megosztott';
		case 411:
			return 'Az értékelőtáblázatok betöltése sikertelen.';
		case 412:
			return 'Korcsoportváltó gyerek esetén nem tudsz értékelőtáblázatot választani.';
		case 420:
			return 'Betöltöm az értékelőtáblázatokat, kérlek, várj...';
		case 418:
			return 'Segítség értékelőtáblázat létrehozáshoz';
		case 419:
			return 'Kérlek, vedd figyelembe, hogy az értékelőtáblázat szerkesztése nincs hatással a korábban már megadott visszajelzésekre - azokban az értékelőtáblázatnak a korábbi állapota marad meg. Természetesen a szerkesztés után adott visszajelzésekben már az értékelőtáblázat új tartalma fog megjelenni.';
		case 421:
			return 'Keresés az értékelőtáblázat szerzőkben, címekben és leírásokban';
		case 422:
			return 'Értékelőtáblázatok';
		case 423:
			return 'Értékelőtáblázat választása';
		case 424:
			return 'Nincsenek a szűrőfeltételeknek megfelelő visszajelzések.';
		case 425:
			return 'Nincsenek gyerekek az iskoládban. Ha ez szerinted téves, szólj nekünk.';
		case 426:
			return 'Betöltöm a rubric visszajelzéseket, kérlek, várj...';
		case 427:
			return 'Visszajelzés összesítő';
		case 428:
			return 'Ezen az oldalon megtudhatod, hogy a gyerekek a különböző tantárgyakból mennyi visszajelzést kaptak. Kérlek, vedd figyelembe, hogy az oldal mögötti adatok csak pár percenként frissülnek. Ezért kérünk, ne építs arra, hogy egy visszajelzés megadásának hatására itt azonnal ugranak majd a számok, erre egy keveset várni kell. Köszönjük a megértésedet!';
		case 429:
			return 'Iskola';
		case 430:
			return 'Név';
		case 431:
			return 'Évfolyam';
		case 432:
			return 'Tantárgy';
		case 433:
			return 'Visszajelzések a modulokban';
		case 434:
			return 'Kapott visszajelzések az első félévben';
		case 435:
			return 'Kapott visszajelzések a tanévben';
		case 448:
			var zone = str.a;
			var startDate = str.b;
			var endDate = str.c;
			return A3($author$project$Locale$Hungarian$termFormatter, zone, startDate, endDate);
		case 449:
			return 'A hiányzások betöltése sikertelen';
		case 450:
			return 'Betöltöm a hiányzásokat, kérlek, várj...';
		case 451:
			return 'Nincsenek hiányzások rögzítve. Ha ez szerinted téves, szólj nekünk.';
		case 452:
			var name = str.a;
			return 'Itt látod ' + (name + ' hiányzásait ebben a tanévben');
		case 453:
			return 'igazolatlan';
		case 454:
			return 'orvos által igazolt';
		case 455:
			return 'szülő által igazolt';
		case 456:
			return 'mentortanár által igazolt';
		case 457:
			return 'hibajelzés beküldve';
		case 436:
			return 'Orvosi igazolás';
		case 437:
			return 'Szülői igazolás';
		case 438:
			return 'Mentortanári igazolás';
		case 439:
			var name = str.a;
			var zone = str.b;
			var start = str.c;
			var end = str.d;
			return 'Ha igazolni szeretnéd <b>' + (name + ('</b> számára a <b>' + (A3($author$project$Locale$Hungarian$termFormatter, zone, start, end) + '</b> napi hiányzást, kérlek, adj meg indoklást és szükség esetén csatold az igazoló dokumentumot!')));
		case 440:
			var name = str.a;
			var zone = str.b;
			var start = str.c;
			var end = str.d;
			return 'Ha igazolni szeretnéd <b>' + (name + ('</b> számára a <b>' + (A3($author$project$Locale$Hungarian$termFormatter, zone, start, end) + '</b> napi hiányzást, kérlek, adj meg indoklást és csatold az igazoló dokumentumot!')));
		case 441:
			return 'Hibát jelzek!';
		case 442:
			var zone = str.a;
			var start = str.b;
			var end = str.c;
			return 'Tévesen rögzítették a tanárok a gyereked hiányzását a ' + (A3($author$project$Locale$Hungarian$termFormatter, zone, start, end) + ' napon? Kérjük, az Ok gomb megnyomásával jelezd a hibát! Erről a mentortanár és a tanügyi csapatunk emailben értesül, és fel fogják venni veled a kapcsolatot a helyzet tisztázása érdekében.');
		case 443:
			return 'Mi történt?';
		case 444:
			return 'Igazoló dokumentum';
		case 445:
			var size = str.a;
			return 'Maximális fájl méret ' + ($elm$core$String$fromInt(size) + ' MB. Támogatott fájl formátumok: PDF, JPEG, PNG');
		case 447:
			return 'Nem sikerült elmenteni az igazolást :(';
		case 446:
			return 'Sikeresen elmentettem az igazolást :)';
		case 458:
			var name = str.a;
			return 'Mentor: ' + name;
		case 459:
			return 'Hiányzó mentor!';
		case 460:
			return 'Nem találhatók gyerekek.';
		case 461:
			return 'A keresett gyerek nem található. Talán törölték, nincs hozzá jogosultságod, vagy csak egyszerűen nem létezik.';
		case 462:
			var names = str.a;
			return 'Szülők: ' + $author$project$Locale$Hungarian$nameList(names);
		case 463:
			return 'További gyerekek betöltése';
		case 464:
			return 'általános iskolai nevelés-oktatás';
		case 465:
			return 'gimnáziumi nevelés-oktatás';
		case 466:
			return 'szakiskolai nevelés-oktatás';
		case 471:
			return 'angol';
		case 472:
			return 'német';
		case 473:
			return 'francia';
		case 474:
			return 'spanyol';
		case 475:
			return 'olasz';
		case 467:
			return 'BTMN';
		case 468:
			return 'SNI1';
		case 469:
			return 'SNI2';
		case 470:
			return 'nincs';
		case 476:
			return 'A NEK azonosító 16 karakter hosszú';
		case 477:
			return 'ovi 1. évfolyam';
		case 478:
			return 'ovi 2. évfolyam';
		case 479:
			return 'ovi 3. évfolyam';
		case 480:
			return '1. évfolyam';
		case 481:
			return '2. évfolyam';
		case 482:
			return '3. évfolyam';
		case 483:
			return '4. évfolyam';
		case 484:
			return '5. évfolyam';
		case 485:
			return '6. évfolyam';
		case 486:
			return '7. évfolyam';
		case 487:
			return '8. évfolyam';
		case 488:
			return '9. évfolyam';
		case 489:
			return '10. évfolyam';
		case 490:
			return '11. évfolyam';
		case 491:
			return '12. évfolyam';
		case 492:
			return 'állapot';
		case 493:
			return 'Lakcímkártya; nem magyar állampolgár esetén tartózkodás engedély (dokumentum)';
		case 494:
			return 'Felvételi mikor volt, milyen eredménnyel';
		case 495:
			return 'Anya születési neve';
		case 496:
			return 'Köznevelési alapfeladat, amelyre a jogviszony irányul';
		case 497:
			return 'Jogviszony szünetelésének dátuma, oka';
		case 498:
			return 'Igazolt/igazolatlan órák száma';
		case 499:
			return 'Iskolai gyerekbaleset dátuma, leírása';
		case 500:
			return 'Kompetenciatesztek eredményei, mérési azonosító';
		case 501:
			return 'Utolsó lezárt tanév bizonyítványa (dokumentum)';
		case 502:
			return 'Szorgalom, magatartás, tudás minősítés (dokumentum)';
		case 503:
			return 'Vizsgaadatok (dátum, eredmény, vizsgáztató tanár)';
		case 504:
			return 'Fegyelmi és kártérítési ügyekkel kapcsolatos adatok: ügy száma, rövid leírása (indulásának oka, megoldásának, befejezésének formája, tartalma)';
		case 505:
			return 'Diákigazolvány sorszáma';
		case 506:
			return 'Tankönyvellátás';
		case 507:
			return 'Évfolyamismétlés';
		case 508:
			return 'Határon túli kirándulás';
		case 509:
			return 'Speciális státusz';
		case 510:
			return '<b>SNI1:</b> Enyhe értelmi fogyatékos, beszédfogyatékos vagy pszichés fejlődési zavarral küzdő sajátos nevelési igényű gyermek.<br/><b>SNI2:</b> Mozgásszervi, érzékszervi, középsúlyos értelmi fogyatékos, autizmus spektrum zavarral küzdő vagy halmozottan fogyatékos gyermek.<br/><b>BTMN:</b> Szakértői vélemény alapján beilleszkedési, tanulási, és magatartási nehézséggel küzdő gyerek.';
		case 511:
			return 'Szakvélemény (dokumentum)';
		case 512:
			return 'Egyéni munkarend';
		case 513:
			return 'Egyéni munkarendre vonatkozó adatok (dokumentum)';
		case 514:
			return 'Hányadik osztályba kerül';
		case 515:
			return 'Első idegen nyelv';
		case 516:
			return 'Második idegen nyelv';
		case 517:
			return 'Diákigazolvány (dokumentum)';
		case 518:
			return 'Születési anyakönyvi kivonat (dokumentum)';
		case 519:
			return 'Személyi igazolvány vagy útlevél (dokumentum)';
		case 520:
			return ' - kötelező, ha a gyerek már iskolába jár';
		case 521:
			return 'Adóazonosító (dokumentum)';
		case 522:
			return 'TAJ kártya (dokumentum)';
		case 523:
			return 'NEK azonosító';
		case 524:
			return 'NEK adatlap (dokumentum)';
		case 525:
			var count = str.a;
			return (count === 1) ? 'Törvényes képviselő' : 'Törvényes képviselők';
		case 526:
			return 'Új fájl…';
		case 527:
			return 'Megtekintés';
		case 528:
			return 'Fájl feltöltve — ';
		case 529:
			return 'Maximális fájl méret 10MB. Támogatott fájl formátumok: PDF, JPG, PNG';
		case 531:
			return 'A gyerekadatok betöltése sikertelen';
		case 532:
			return 'Hiba történt a dokumentum letöltése közben';
		case 530:
			return 'A diákigazolvány sorszáma 10 számjegyből áll';
		case 533:
			return 'Sikeresen elmentettem a gyerekadatokat.';
		case 534:
			return 'Gyerekadatok';
		case 535:
			var name = str.a;
			return name + ' gyerekadatok';
		case 536:
			return 'Szülő tölti ki';
		case 537:
			return 'Iskola tölti ki';
		case 538:
			return 'Betöltöm a gyerekadatokat, kérlek, várj...';
		case 539:
			return 'A keresett adatlap nem található. Talán törölték, nincs hozzá jogosultságod, vagy csak egyszerűen nincs ilyen.';
		case 540:
			return 'A gyerek lista betöltése sikertelen';
		case 541:
			return 'Mindenki';
		case 542:
			return 'Mentoráltjaim';
		case 543:
			return 'Betöltöm a gyerek listát, kérlek, várj...';
		case 544:
			return 'Gyerekek';
		case 545:
			return 'Új tanulási szerződés...';
		case 546:
			return 'Tanulási szerződés';
		case 548:
			return 'Cégen keresztül fizetek';
		case 547:
			return 'Támogatási szerződés kötése';
		case 549:
			return 'Adatlap';
		case 550:
			return 'Értesítők';
		case 551:
			return 'Hiányzások';
		case 552:
			return 'Órarend';
		case 553:
			return 'Trimeszter visszajelzések';
		case 554:
			return 'Tantárgyi visszajelzések';
		case 555:
			return 'Keresés a gyerekek nevében';
		case 565:
			return 'Betöltöm a tantárgyi visszajelzéseket, kérlek, várj...';
		case 564:
			return 'A tantárgyi visszajelzések betöltése sikertelen';
		case 556:
			return 'Minden tantárgy';
		case 557:
			var studentName = str.a;
			var studentGrade = str.b;
			var subjectName = str.c;
			return 'Visszajelzések ' + (studentName + (' (' + (studentGrade + (') számára ' + A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (s) {
						return s + ' tantárgyból';
					},
					subjectName))))));
		case 559:
			return 'Tantárgyi visszajelzések';
		case 560:
			return 'Tantárgy';
		case 561:
			return 'Típus';
		case 563:
			return 'Csak féléves';
		case 562:
			return 'Minden';
		case 558:
			return 'Ezen az oldalon látod a kiválasztott gyerek kiválasztott tantárgyból kapott értékelőtáblázat-sorait időrendben. ' + 'Az egyes visszajelzéseket az időpontokra kattintva tudod részletesebben is megnézni.';
		case 566:
			var startYear = str.a;
			var endYear = str.b;
			return $elm$core$String$fromInt(startYear) + ('/' + ($elm$core$String$fromInt(endYear) + ' tanév'));
		case 567:
			return 'Nincsen elérhető értesítő ami alapján osztályzatot igényelhetsz.';
		case 569:
			return 'A tantárgy lista betöltése sikertelen';
		case 568:
			return 'Letöltöm a tantárgyak listáját, kérlek, várj...';
		case 570:
			return 'Felhasználóváltás';
		case 571:
			return 'Miért van szükséged felhasználót váltani? Ezt az üzenetet naplózzuk.';
		case 572:
			var name = str.a;
			return 'Felhasználóváltás sikeres. Üdv ' + (name + '!');
		case 573:
			return 'Felhasználóváltás';
		case 574:
			return 'State';
		case 575:
			return 'Tanár';
		case 576:
			return 'Születési keresztnév';
		case 577:
			return 'Születési vezetéknév';
		case 578:
			return 'A születési név vezetéknév–keresztnév formátumú';
		case 579:
			return 'Anyja neve, előtag';
		case 580:
			return 'Anyja keresztneve';
		case 581:
			return 'Anyja vezetéknéve';
		case 582:
			return 'Az anyja neve vezetéknév–keresztnév formátumú';
		case 583:
			return 'Legmagasabb iskolai végzettség';
		case 584:
			return 'Szakmai gyakorlat éveinek száma';
		case 585:
			return 'Akadémiai tag?';
		case 586:
			return 'Diploma (dokumentum)';
		case 587:
			return 'Egyetem';
		case 588:
			return 'Főiskola';
		case 589:
			return 'Középiskola';
		case 590:
			return 'Születési adatok';
		case 591:
			return 'Elérhetőségek';
		case 592:
			return 'Szakmai adatok';
		case 593:
			return 'A tanáradatok betöltése sikertelen';
		case 594:
			return 'Maximális fájl méret 10MB. Támogatott fájlformátumok: PDF, JPG, PNG';
		case 595:
			return 'Sikeresen elmentettem a tanáradatokat.';
		case 596:
			return 'Tanáradatok';
		case 597:
			var name = str.a;
			return name + ' tanáradatok';
		case 598:
			return 'Betöltöm a tanáradatokat, kérlek, várj...';
		case 599:
			return 'A keresett adatlap nem található. Talán törölték, nincs hozzá jogosultságod, vagy csak egyszerűen nincs ilyen.';
		case 600:
			return 'Az iskola lista betöltése sikertelen';
		case 601:
			var zone = str.a;
			var time = str.b;
			return A2($author$project$Locale$Hungarian$dateFormatter, zone, time);
		case 602:
			var zone = str.a;
			var time = str.b;
			return A2($author$project$Locale$Hungarian$dateTimeFormatter, zone, time);
		case 604:
			var zone = str.a;
			var time1 = str.b;
			var time2 = str.c;
			return A2($author$project$Locale$Hungarian$dateFormatter, zone, time1) + (', ' + (A2($author$project$Locale$Hungarian$timeFormatter, zone, time1) + ('-' + A2($author$project$Locale$Hungarian$timeFormatter, zone, time2))));
		case 603:
			var zone = str.a;
			var time = str.b;
			return A2($author$project$Locale$Hungarian$timeFormatter, zone, time);
		case 605:
			return 'Hetente';
		case 606:
			return 'Kéthetente';
		case 607:
			return 'Egyszeri alkalom';
		case 608:
			var day = str.a;
			return $author$project$Locale$Hungarian$hungarian.oa(day);
		case 609:
			return 'Az órarend betöltése sikertelen';
		case 610:
			return 'Új modulóra létrehozása';
		case 611:
			return 'Modulóra szerkesztése';
		case 612:
			return 'Google Meet';
		case 613:
			return 'Jelenléti ív';
		case 614:
			return 'Modulóra szerkesztése';
		case 615:
			return 'Modulóra törlése';
		case 616:
			return 'Összes alkalom törlése';
		case 618:
			return 'Ez és ezt követő alkalmak törlése';
		case 617:
			return 'Ezen alkalom törlése';
		case 619:
			return 'Ezt és ezt követő alkalmakat';
		case 620:
			return 'Minden alkalmat';
		case 621:
			return 'Tanárok órarendjei';
		case 622:
			return 'Gyerekek órarendjei';
		case 623:
			return 'Órarend betöltése...';
		case 624:
			return 'Órarend';
		case 626:
			return 'Hiba történt a modulóra mentése közben';
		case 625:
			return 'Sikeresen elmentettem a modulóra változásokat.';
		case 627:
			return 'Résztvevők';
		case 628:
			return 'Hiányzók';
		case 629:
			return 'Mely modulóra alkalmakat szeretnéd megváltoztatni?';
		case 630:
			return '<ul>' + ('<li><mark>A modulórákhoz jelenléti ívek tartoznak.</mark> Ha visszamenőlegesen újraütemezel órát, azzal a kitöltött jelenléti ívek elvesznek.</li>' + ('<li>A Google Naptárba csak a jövőbeli változásokat szinkronizáljuk.</li>' + '</ul>'));
		case 631:
			return '<p><mark>A modulórákhoz jelenléti ívek tartoznak.</mark> ' + ('Ha már egy elkezdett modul óráit szünteted meg, a kitöltött jelenléti ívek elvesznek.</p>' + '<p>Ha be szeretnél fejezni hamarabb egy modult, csak ezt és az ezt követő alkalmakat töröld.</p>');
		case 632:
			return '<p><mark>A modulórákhoz jelenléti ívek tartoznak.</mark> ' + 'Ha már egy elkezdett modul óráit szünteted meg, a kitöltött jelenléti ívek elvesznek.</p>';
		case 633:
			return 'Sikeresen töröltem a modulórát.';
		case 634:
			return 'Hiba történt a modulóra törlése közben';
		case 635:
			return 'Sikeresen elmentettem az órarend változásokat.';
		case 636:
			return 'Sikeresen lemondtam a választott modulóra alkalmat.';
		case 637:
			var title = str.a;
			var zone = str.b;
			var start = str.c;
			var end = str.d;
			return title + (' (' + (A3($author$project$Locale$Hungarian$termFormatter, zone, start, end) + ')'));
		case 638:
			var name = str.a;
			return 'Modul: ' + name;
		case 639:
			var creator = str.a;
			var student = str.b;
			return creator + (' trimeszterzáró visszajelzést adott ' + (student + ' részére'));
		case 640:
			return 'A trimeszter betöltése sikertelen';
		case 641:
			var name = str.a;
			return 'Kedves ' + (name + '! Az elmúlt trimeszterrel kapcsolatban azt szeretném neked elmondani, hogy…');
		case 642:
			return 'Trimeszterzáró visszajelzés';
		case 643:
			var name = str.a.fb;
			var startYear = str.a.eB;
			var endYear = str.a.d3;
			var trimester = str.a.kp;
			return $elm$core$String$concat(
				_List_fromArray(
					[
						name,
						' részére, ',
						$elm$core$String$fromInt(startYear),
						'/',
						$elm$core$String$fromInt(endYear),
						'. tanév ',
						$elm$core$String$fromInt(trimester),
						'. trimeszter'
					]));
		case 644:
			return 'Értékelőtáblázat kiválasztása…';
		case 645:
			return 'Sikeresen elmentettem a trimeszterzáró visszajelzést.';
		case 646:
			return 'Hiba történt a trimeszterzáró visszajelzés mentése közben';
		case 647:
			return 'Kérlek, értékeld a szempontokat!';
		case 648:
			return 'Trimeszterzáró visszajelzés hozzáadása';
		case 649:
			return 'Trimeszter visszajelzések';
		case 650:
			return 'Trimeszter visszajelzések';
		case 651:
			return 'Trimeszter visszajelzések betöltése...';
		case 652:
			return 'Nem találhatók trimeszter visszajelzések. Talán törölték, nincs hozzá jogosultságod, vagy csak egyszerűen nincs ilyen.';
		case 653:
			return 'A trimeszter visszajelzések betöltése sikertelen';
		case 654:
			var studentName = str.a;
			return studentName + ' még nem kapott trimeszterzáró visszajelzést. ';
		case 655:
			var studentName = str.a;
			return studentName + ' még nem kapott modulzáró visszajelzést.';
		case 656:
			return 'Készíts visszajelzést számára arról, hogy sikerült a trimeszter!';
		case 657:
			return 'Korábbi évek';
		case 658:
			return '1. trimeszter';
		case 659:
			return '2. trimeszter';
		case 660:
			return '3. trimeszter';
		case 661:
			return 'Sikeresen töröltem a visszajelzést.';
		case 662:
			var schoolYear = str.a;
			var trimester = str.b;
			return $elm$core$String$fromInt(schoolYear) + ('. tanév ' + ($elm$core$String$fromInt(trimester) + '. trimeszter visszajelzések letöltése'));
		case 663:
			return 'Hiba történt a trimeszter visszajelzés törlése közben';
		case 664:
			return 'Elmentettem a beállításokat.';
		case 665:
			return 'Hiba történt a beállítások mentése közben';
		case 666:
			return 'Csinálom a szerődés tervezetét, kérlek, várj...';
		case 667:
			return 'Értékelés';
		case 668:
			var teamName = str.a;
			return teamName;
		case 669:
			return 'Aktuális időszak';
		case 699:
			return 'csak a hiányos értékelések';
		case 670:
			return 'Utólagos';
		case 671:
			return 'Érettségizők';
		case 672:
			var dueDate = str.a;
			return 'Határidő: ' + dueDate;
		case 673:
			return 'Értékelés';
		case 182:
			return 'Betöltés';
		case 679:
			return 'Nincsenek utólagos osztályzat igénylések.';
		case 678:
			return 'utólagos';
		case 674:
			return 'félévi';
		case 675:
			return 'év végi';
		case 676:
			return 'megajánlás';
		case 677:
			return 'véglegesítés';
		case 680:
			return 'Értékelendő';
		case 681:
			return 'Összes';
		case 682:
			return 'Betöltöm az értékelési adatokat, kérlek, várj...';
		case 683:
			return 'Az értékelés betöltése sikertelen';
		case 684:
			return 'Szöveges értékelés';
		case 685:
			return 'Osztályzat';
		case 686:
			return 'Gyerek neve';
		case 687:
			return 'Évfolyam';
		case 694:
			return 'Időszak';
		case 688:
			return 'Tantárgy';
		case 689:
			return 'Tantárgyfelelős';
		case 690:
			return 'Haladsz';
		case 691:
			return 'Még nem';
		case 692:
			return 'Megalajánlott';
		case 693:
			return 'Végleges';
		case 695:
			return 'felmentése van';
		case 696:
			return 'nem igényelt';
		case 712:
			return 'utólag igényelt';
		case 697:
			return 'Változások mentése';
		case 698:
			return 'Hozzájárulások';
		case 700:
			var grade = str.a;
			return grade + '. évfolyam';
		case 701:
			return 'Ezt az értékelést most nem tudod szerkeszteni.';
		case 702:
			return 'Betöltöm a hozzájárulásokat, kérlek, várj...';
		case 703:
			return 'Átnéztem a gyerekek végleges értékeléseit, és a tantárgyfelelős tanárok döntéseihez';
		case 704:
			return 'Hozzájárulok';
		case 705:
			return 'Nem járulok hozzá';
		case 706:
			return 'Tanár neve';
		case 707:
			return 'Hozzájárult';
		case 708:
			return 'A hozzájárulások betöltése sikertelen';
		case 709:
			return 'Hozzájárulások';
		case 710:
			return 'Sikeresen frissítetted a hozzájárulásodat.';
		case 711:
			return 'A hozzájárulás adása előtt minden hiányos értékelést ki kell tölteni';
		case 713:
			return 'Sikeresen elmentettem az értékeléseket.';
		case 714:
			return 'Hiba történt az értékelések mentése közben.';
		case 715:
			return 'Határidő';
		case 717:
			var endDate = str.a;
			return 'A tábla most zárolva van. Gyere vissza leghamarabb ekkor: ' + (endDate + '.');
		case 718:
			return 'zárolva';
		case 719:
			return 'Rekonsziliáció';
		default:
			return 'Nincs jogosultságod megtekinteni ezt az oldalt.';
	}
};
var $author$project$Locale$hungarian = {k8: 'hu', l4: $author$project$Locale$Hungarian$isFirstNameFirst, h6: $author$project$Locale$Hungarian$translator};
var $author$project$Locale$defaultLanguage = $author$project$Locale$hungarian;
var $author$project$Route$PageNotFound = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$auth0Url = 'auth0';
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {c7: frag, hO: params, cY: unvisited, fC: value, dO: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.cY;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.fC);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.fC);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.m5),
					$elm$url$Url$Parser$prepareQuery(url.bF),
					url.i1,
					$elm$core$Basics$identity)));
	});
var $author$project$Route$Auth0Callback = function (a) {
	return {$: 0, a: a};
};
var $author$project$Route$CompanyContractCreate = function (a) {
	return {$: 14, a: a};
};
var $author$project$Route$Counter = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$CurriculumBrowser = {$: 49};
var $author$project$Route$GenericProfileUpdate = function (a) {
	return {$: 32, a: a};
};
var $author$project$Route$GradeRequestList = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Route$GradingPage = F3(
	function (a, b, c) {
		return {$: 47, a: a, b: b, c: c};
	});
var $author$project$Route$Home = {$: 8};
var $author$project$Route$LearningAssessmentCard = function (a) {
	return {$: 6, a: a};
};
var $author$project$Route$LearningContractsCreate = {$: 9};
var $author$project$Route$LearningContractsList = {$: 10};
var $author$project$Route$LearningContractsUpdate = function (a) {
	return {$: 11, a: a};
};
var $author$project$Route$LearningGroupCreate = {$: 12};
var $author$project$Route$LearningGroupList = {$: 13};
var $author$project$Route$LearningGroupUpdate = function (a) {
	return {$: 15, a: a};
};
var $author$project$Route$Login = {$: 1};
var $author$project$Route$Logout = {$: 2};
var $author$project$Route$ModuleClosureOverview = function (a) {
	return {$: 16, a: a};
};
var $author$project$Route$ModuleTeacherProfileUpdate = function (a) {
	return {$: 18, a: a};
};
var $author$project$Route$ModulesClosure = function (a) {
	return {$: 17, a: a};
};
var $author$project$Route$ModulesCreate = {$: 19};
var $author$project$Route$ModulesCreateFromTemplate = function (a) {
	return {$: 20, a: a};
};
var $author$project$Route$ModulesDetail = function (a) {
	return {$: 21, a: a};
};
var $author$project$Route$ModulesDuplicate = function (a) {
	return {$: 22, a: a};
};
var $author$project$Route$ModulesList = {$: 23};
var $author$project$Route$ModulesUpdate = function (a) {
	return {$: 24, a: a};
};
var $author$project$Route$NotificationList = {$: 25};
var $author$project$Route$PhoneBook = {$: 26};
var $author$project$Route$PortfoliosCreate = function (a) {
	return {$: 27, a: a};
};
var $author$project$Route$PortfoliosDetail = function (a) {
	return {$: 28, a: a};
};
var $author$project$Route$PortfoliosList = function (a) {
	return {$: 29, a: a};
};
var $author$project$Route$PortfoliosListMyChildren = {$: 30};
var $author$project$Route$PortfoliosUpdate = function (a) {
	return {$: 31, a: a};
};
var $author$project$Route$ReconciliationPage = {$: 50};
var $author$project$Route$RubricSubjectOverview = function (a) {
	return {$: 37, a: a};
};
var $author$project$Route$RubricsCreate = {$: 33};
var $author$project$Route$RubricsList = {$: 34};
var $author$project$Route$RubricsUpdate = function (a) {
	return {$: 35, a: a};
};
var $author$project$Route$RubricsView = function (a) {
	return {$: 36, a: a};
};
var $author$project$Route$StudentAbsenceList = function (a) {
	return {$: 5, a: a};
};
var $author$project$Route$StudentList = {$: 40};
var $author$project$Route$StudentProfileNekUpdate = function (a) {
	return {$: 38, a: a};
};
var $author$project$Route$StudentProfileUpdate = function (a) {
	return {$: 39, a: a};
};
var $author$project$Route$SubjectFeedbackList = F2(
	function (a, b) {
		return {$: 41, a: a, b: b};
	});
var $author$project$Route$TeacherProfilesUpdate = function (a) {
	return {$: 42, a: a};
};
var $author$project$Route$TimetableCalendar = function (a) {
	return {$: 43, a: a};
};
var $author$project$Route$TimetableCreateEvent = function (a) {
	return {$: 44, a: a};
};
var $author$project$Route$TimetableUpdateEvent = function (a) {
	return {$: 45, a: a};
};
var $author$project$Route$TrimesterFeedbackReport = function (a) {
	return {$: 46, a: a};
};
var $author$project$Route$companyContractUrlPart = 'company-contract';
var $author$project$Route$counterUrl = 'counter';
var $author$project$Route$createUrlSuffix = 'new';
var $author$project$Route$curriculumBrowserUrl = 'curriculum';
var $author$project$Route$duplicateUrlSuffix = 'duplicate';
var $author$project$Route$editUrlSuffix = 'edit';
var $author$project$Route$financialsUrl = 'financials';
var $author$project$Route$gradeRequestUrl = 'grade-requests';
var $author$project$Route$homeUrl = 'home';
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.dO;
			var unvisited = _v0.cY;
			var params = _v0.hO;
			var frag = _v0.c7;
			var value = _v0.fC;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$int = A2($elm$url$Url$Parser$custom, 'NUMBER', $elm$core$String$toInt);
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$int = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$String$toInt(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$Route$learningAssessmentUrlPart = 'learning-assessment';
var $author$project$Route$learningContractsUrl = 'learningcontracts';
var $author$project$Route$learningGroupsUrl = 'learning-groups';
var $author$project$Route$logoutUrl = 'logout';
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.dO;
		var unvisited = _v0.cY;
		var params = _v0.hO;
		var frag = _v0.c7;
		var value = _v0.fC;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.dO;
			var unvisited = _v1.cY;
			var params = _v1.hO;
			var frag = _v1.c7;
			var value = _v1.fC;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$url$Url$Parser$Query$map = F2(
	function (func, _v0) {
		var a = _v0;
		return function (dict) {
			return func(
				a(dict));
		};
	});
var $elm$url$Url$Parser$Query$map2 = F3(
	function (func, _v0, _v1) {
		var a = _v0;
		var b = _v1;
		return function (dict) {
			return A2(
				func,
				a(dict),
				b(dict));
		};
	});
var $author$project$Route$moduleClosureOverviewUrl = 'module-closures';
var $author$project$Route$moduleClosureUrlPart = 'closing-feedback';
var $author$project$Route$moduleParam = 'm';
var $author$project$Route$moduleTeacherProfilesUrlSuffix = 'module-teacher';
var $author$project$Route$modulesUrl = 'modules';
var $author$project$Route$notificationsUrl = 'notifications';
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$url$Url$Parser$Query$enum = F2(
	function (key, dict) {
		return A2(
			$elm$url$Url$Parser$Query$custom,
			key,
			function (stringList) {
				if (stringList.b && (!stringList.b.b)) {
					var str = stringList.a;
					return A2($elm$core$Dict$get, str, dict);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			});
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $author$project$Route$parseBool = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$enum,
		key,
		$elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2('true', true),
					_Utils_Tuple2('false', false)
				])));
};
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $author$project$Route$parseIntList = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		$elm$core$List$filterMap($elm$core$String$toInt));
};
var $author$project$Route$LoStudentOverviewListQuery = F4(
	function (students, subjects, school, module_) {
		return {hG: module_, Q: school, fv: students, kb: subjects};
	});
var $elm$url$Url$Parser$Query$map4 = F5(
	function (func, _v0, _v1, _v2, _v3) {
		var a = _v0;
		var b = _v1;
		var c = _v2;
		var d = _v3;
		return function (dict) {
			return A4(
				func,
				a(dict),
				b(dict),
				c(dict),
				d(dict));
		};
	});
var $author$project$Route$schoolParam = 'school';
var $author$project$Route$studentParam = 's';
var $author$project$Route$subjectParam = 'subject';
var $author$project$Route$parseLoStudentOverviewListQuery = A5(
	$elm$url$Url$Parser$Query$map4,
	$author$project$Route$LoStudentOverviewListQuery,
	$author$project$Route$parseIntList($author$project$Route$studentParam),
	$author$project$Route$parseIntList($author$project$Route$subjectParam),
	$elm$url$Url$Parser$Query$int($author$project$Route$schoolParam),
	$elm$url$Url$Parser$Query$int($author$project$Route$moduleParam));
var $author$project$Route$ModuleClosureOverviewListQuery = F2(
	function (school, onlyMentees) {
		return {cH: onlyMentees, Q: school};
	});
var $author$project$Route$menteesParam = 'mentees';
var $author$project$Route$parseModuleClosureOverviewListQuery = A3(
	$elm$url$Url$Parser$Query$map2,
	$author$project$Route$ModuleClosureOverviewListQuery,
	$elm$url$Url$Parser$Query$int($author$project$Route$schoolParam),
	$author$project$Route$parseBool($author$project$Route$menteesParam));
var $author$project$Route$PortfoliosListQuery = F4(
	function (students, startDate, endDate, withFeedback) {
		return {ly: endDate, nN: startDate, fv: students, ol: withFeedback};
	});
var $author$project$Route$endDateParam = 'end_date';
var $author$project$Route$startDateParam = 'start_date';
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$Route$withFeedbackParam = 'with_feedback';
var $author$project$Route$parsePortfoliosListQuery = A5(
	$elm$url$Url$Parser$Query$map4,
	$author$project$Route$PortfoliosListQuery,
	$author$project$Route$parseIntList($author$project$Route$studentParam),
	$elm$url$Url$Parser$Query$string($author$project$Route$startDateParam),
	$elm$url$Url$Parser$Query$string($author$project$Route$endDateParam),
	$author$project$Route$parseBool($author$project$Route$withFeedbackParam));
var $author$project$Route$SubjectFeedbackListQuery = F3(
	function (subject, grade, midYear) {
		return {W: grade, mB: midYear, gE: subject};
	});
var $author$project$Route$gradeParam = 'grade';
var $elm$url$Url$Parser$Query$map3 = F4(
	function (func, _v0, _v1, _v2) {
		var a = _v0;
		var b = _v1;
		var c = _v2;
		return function (dict) {
			return A3(
				func,
				a(dict),
				b(dict),
				c(dict));
		};
	});
var $author$project$Route$midYearParam = 'mid_year';
var $author$project$Route$parseSubjectFeedbackListQuery = A4(
	$elm$url$Url$Parser$Query$map3,
	$author$project$Route$SubjectFeedbackListQuery,
	$elm$url$Url$Parser$Query$int($author$project$Route$subjectParam),
	$elm$url$Url$Parser$Query$string($author$project$Route$gradeParam),
	$author$project$Route$parseBool($author$project$Route$midYearParam));
var $author$project$Route$TimetableCreateQuery = F3(
	function (moduleId, start, end) {
		return {hb: end, js: moduleId, h2: start};
	});
var $author$project$Route$endParam = 'end';
var $author$project$Route$startParam = 'start';
var $author$project$Route$parseTimetableCreateQuery = A4(
	$elm$url$Url$Parser$Query$map3,
	$author$project$Route$TimetableCreateQuery,
	$elm$url$Url$Parser$Query$int($author$project$Route$moduleParam),
	$elm$url$Url$Parser$Query$int($author$project$Route$startParam),
	$elm$url$Url$Parser$Query$int($author$project$Route$endParam));
var $author$project$Route$TimetableUpdateQuery = F2(
	function (eventId, occId) {
		return {iX: eventId, hL: occId};
	});
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $author$project$Route$parseTimetableUpdateQuery = A2(
	$elm$url$Url$Parser$map,
	$author$project$Route$TimetableUpdateQuery,
	A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$int, $elm$url$Url$Parser$int));
var $author$project$Route$personParam = 'p';
var $author$project$Route$phoneBookUrl = 'contacts';
var $author$project$Route$portfoliosMyChildrenSuffix = 'my-family';
var $author$project$Route$portfoliosUrl = 'portfolios';
var $author$project$Route$profilesUrl = 'profile';
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.dO;
		var unvisited = _v1.cY;
		var params = _v1.hO;
		var frag = _v1.c7;
		var value = _v1.fC;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $author$project$Route$reconciliationUrl = 'reconciliation';
var $author$project$Route$rubricSubjectOverviewUrl = 'rubrics-subjects';
var $author$project$Route$rubricsUrl = 'rubrics';
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.dO;
		var unvisited = _v0.cY;
		var params = _v0.hO;
		var frag = _v0.c7;
		var value = _v0.fC;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $author$project$Route$scheduleUrlSuffix = 'schedule';
var $author$project$Route$studentAbsenceListUrl = 'student-absence';
var $author$project$Route$studentProfilesNekUrlSuffix = 'nek';
var $author$project$Route$studentProfilesUrlSuffix = 'student';
var $author$project$Route$studentsUrl = 'students';
var $author$project$Route$subjectFeedbackUrlPart = 'subject-feedback';
var $author$project$Route$teacherProfilesUrlSuffix = 'teacher';
var $author$project$Route$timetableEventsUrlPart = 'events';
var $author$project$Route$timetableUrl = 'timetable';
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Route$trimesterFeedbackReportUrl = 'trimester-feedback-report';
var $author$project$Route$parser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Route$Login, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Logout,
			$elm$url$Url$Parser$s($author$project$Route$logoutUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Auth0Callback,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$auth0Url),
				$elm$url$Url$Parser$Query$string('id_token'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Counter,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$counterUrl),
				$elm$url$Url$Parser$Query$int('count'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$StudentAbsenceList,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$studentAbsenceListUrl),
				$elm$url$Url$Parser$int)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$LearningAssessmentCard,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$learningAssessmentUrlPart)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$GradeRequestList,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s($author$project$Route$gradeRequestUrl),
						$elm$url$Url$Parser$Query$int('learning_assessment_id'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Home,
			$elm$url$Url$Parser$s($author$project$Route$homeUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$LearningContractsCreate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$learningContractsUrl),
				$elm$url$Url$Parser$s($author$project$Route$createUrlSuffix))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$LearningContractsList,
			$elm$url$Url$Parser$s($author$project$Route$learningContractsUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$CompanyContractCreate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$financialsUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Route$companyContractUrlPart),
						$elm$url$Url$Parser$s($author$project$Route$createUrlSuffix))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$LearningContractsUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$learningContractsUrl),
				$elm$url$Url$Parser$int)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$LearningGroupCreate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$learningGroupsUrl),
				$elm$url$Url$Parser$s($author$project$Route$createUrlSuffix))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$LearningGroupList,
			$elm$url$Url$Parser$s($author$project$Route$learningGroupsUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$LearningGroupUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$learningGroupsUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$editUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModuleClosureOverview,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$moduleClosureOverviewUrl),
				$author$project$Route$parseModuleClosureOverviewListQuery)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModuleTeacherProfileUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$moduleTeacherProfilesUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModulesCreate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$modulesUrl),
				$elm$url$Url$Parser$s($author$project$Route$createUrlSuffix))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModulesList,
			$elm$url$Url$Parser$s($author$project$Route$modulesUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModulesDetail,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$modulesUrl),
				$elm$url$Url$Parser$int)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModulesCreateFromTemplate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$modulesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$createUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModulesDuplicate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$modulesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$duplicateUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModulesUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$modulesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$editUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModulesClosure,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$modulesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$moduleClosureUrlPart)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$NotificationList,
			$elm$url$Url$Parser$s($author$project$Route$notificationsUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$PhoneBook,
			$elm$url$Url$Parser$s($author$project$Route$phoneBookUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$PortfoliosCreate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$portfoliosUrl),
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s($author$project$Route$createUrlSuffix),
					$elm$url$Url$Parser$Query$int($author$project$Route$moduleParam)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$PortfoliosDetail,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$portfoliosUrl),
				$elm$url$Url$Parser$int)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$PortfoliosList,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$portfoliosUrl),
				$author$project$Route$parsePortfoliosListQuery)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$PortfoliosListMyChildren,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$portfoliosUrl),
				$elm$url$Url$Parser$s($author$project$Route$portfoliosMyChildrenSuffix))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$PortfoliosUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$portfoliosUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$editUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$GenericProfileUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				$elm$url$Url$Parser$int)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$RubricsCreate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$rubricsUrl),
				$elm$url$Url$Parser$s($author$project$Route$createUrlSuffix))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$RubricsList,
			$elm$url$Url$Parser$s($author$project$Route$rubricsUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$RubricSubjectOverview,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$rubricSubjectOverviewUrl),
				$author$project$Route$parseLoStudentOverviewListQuery)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$RubricsUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$rubricsUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$editUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$RubricsView,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$rubricsUrl),
				$elm$url$Url$Parser$int)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$StudentProfileUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$studentProfilesUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$StudentProfileNekUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$studentProfilesNekUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$StudentList,
			$elm$url$Url$Parser$s($author$project$Route$studentsUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$SubjectFeedbackList,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s($author$project$Route$subjectFeedbackUrlPart),
						$author$project$Route$parseSubjectFeedbackListQuery)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$TeacherProfilesUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$teacherProfilesUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$TimetableUpdateEvent,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$timetableUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Route$timetableEventsUrlPart),
					$author$project$Route$parseTimetableUpdateQuery))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$TimetableCreateEvent,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$timetableUrl),
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s($author$project$Route$scheduleUrlSuffix),
					$author$project$Route$parseTimetableCreateQuery))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$TimetableCalendar,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$timetableUrl),
				$author$project$Route$parseIntList($author$project$Route$personParam))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$TrimesterFeedbackReport,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$trimesterFeedbackReportUrl)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$CurriculumBrowser,
			$elm$url$Url$Parser$s($author$project$Route$curriculumBrowserUrl)),
			A2(
			$elm$url$Url$Parser$map,
			F2(
				function (schoolId, _v0) {
					var trimesterId = _v0.a;
					var realtime = _v0.b;
					return A3($author$project$Route$GradingPage, schoolId, trimesterId, realtime);
				}),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('grading'),
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$int,
					A3(
						$elm$url$Url$Parser$Query$map2,
						$elm$core$Tuple$pair,
						$elm$url$Url$Parser$Query$int('grade'),
						A2(
							$elm$url$Url$Parser$Query$map,
							$elm$core$Maybe$withDefault(false),
							$author$project$Route$parseBool('realtime')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ReconciliationPage,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$financialsUrl),
				$elm$url$Url$Parser$s($author$project$Route$reconciliationUrl)))
		]));
var $author$project$Route$fromUrl = function (url) {
	var route = A2($elm$core$String$startsWith, '/' + $author$project$Route$auth0Url, url.m5) ? A2(
		$elm$url$Url$Parser$parse,
		$author$project$Route$parser,
		_Utils_update(
			url,
			{i1: $elm$core$Maybe$Nothing, bF: url.i1})) : A2($elm$url$Url$Parser$parse, $author$project$Route$parser, url);
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Route$PageNotFound(url),
		route);
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Route$fromString = function (path) {
	var url = $elm$url$Url$fromString('http://foobar.hu' + path);
	return A2($elm$core$Maybe$map, $author$project$Route$fromUrl, url);
};
var $author$project$Main$getInitialRoute = F2(
	function (storedUrl, route) {
		if (!route.$) {
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Route$Home,
				A2($elm$core$Maybe$andThen, $author$project$Route$fromString, storedUrl));
		} else {
			return route;
		}
	});
var $author$project$Main$Auth0CallbackCalled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$Authenticated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$AutoLogin = {$: 1};
var $author$project$Main$LoggedOut = {$: 0};
var $author$project$Main$initAuthState = function (route) {
	_v0$2:
	while (true) {
		switch (route.$) {
			case 2:
				return $author$project$Main$LoggedOut;
			case 0:
				if (!route.a.$) {
					var token = route.a.a;
					return $author$project$Main$Authenticated(
						$author$project$Main$Auth0CallbackCalled(token));
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return $author$project$Main$AutoLogin;
};
var $author$project$Pages$NotLoaded = {$: 0};
var $author$project$Pages$notLoaded = $author$project$Pages$NotLoaded;
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$Route$analyticsLearningContractUrl = 'learningcontract';
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Route$buildBool = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$string,
			key,
			value ? 'true' : 'false');
	});
var $elm$url$Url$Builder$int = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $author$project$Route$loStudentOverviewListQueryAsParam = function (query) {
	return $elm$url$Url$Builder$toQuery(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_Utils_ap(
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$url$Url$Builder$int($author$project$Route$studentParam),
						$elm$core$Maybe$Just),
					query.fv),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$url$Url$Builder$int($author$project$Route$subjectParam),
							$elm$core$Maybe$Just),
						query.kb),
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Maybe$Nothing,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$url$Url$Builder$int($author$project$Route$schoolParam),
									$elm$core$Maybe$Just),
								query.Q)),
							A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Maybe$Nothing,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$url$Url$Builder$int($author$project$Route$moduleParam),
									$elm$core$Maybe$Just),
								query.hG))
						])))));
};
var $author$project$Route$maybeIntParam = F2(
	function (key, maybeInt) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_int) {
					return $elm$url$Url$Builder$toQuery(
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$int, key, _int)
							]));
				},
				maybeInt));
	});
var $author$project$Route$moduleClosureOverviewListQueryAsParam = function (query) {
	return $elm$url$Url$Builder$toQuery(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$url$Url$Builder$int($author$project$Route$schoolParam),
							$elm$core$Maybe$Just),
						query.Q)),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Route$buildBool($author$project$Route$menteesParam),
							$elm$core$Maybe$Just),
						query.cH))
				])));
};
var $author$project$Route$portfoliosListQueryAsParam = function (query) {
	return $elm$url$Url$Builder$toQuery(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_Utils_ap(
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$url$Url$Builder$int($author$project$Route$studentParam),
						$elm$core$Maybe$Just),
					query.fv),
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$url$Url$Builder$string($author$project$Route$startDateParam),
								$elm$core$Maybe$Just),
							query.nN)),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$url$Url$Builder$string($author$project$Route$endDateParam),
								$elm$core$Maybe$Just),
							query.ly)),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Route$buildBool($author$project$Route$withFeedbackParam),
								$elm$core$Maybe$Just),
							query.ol))
					]))));
};
var $author$project$Route$subjectFeedbackListQueryAsParam = function (query) {
	return $elm$url$Url$Builder$toQuery(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$url$Url$Builder$int($author$project$Route$subjectParam),
							$elm$core$Maybe$Just),
						query.gE)),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$url$Url$Builder$string($author$project$Route$gradeParam),
							$elm$core$Maybe$Just),
						query.W)),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Route$buildBool($author$project$Route$midYearParam),
							$elm$core$Maybe$Just),
						query.mB))
				])));
};
var $author$project$Route$timetableCreateQueryAsParam = function (query) {
	return $elm$url$Url$Builder$toQuery(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$url$Url$Builder$int($author$project$Route$moduleParam),
							$elm$core$Maybe$Just),
						query.js)),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$url$Url$Builder$int($author$project$Route$startParam),
							$elm$core$Maybe$Just),
						query.h2)),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$url$Url$Builder$int($author$project$Route$endParam),
							$elm$core$Maybe$Just),
						query.hb))
				])));
};
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.jS;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.i1,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.bF,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.jM,
					_Utils_ap(http, url.hm)),
				url.m5)));
};
var $author$project$Route$toString = function (page) {
	var join = function (pieces) {
		return '/' + A2($elm$core$String$join, '/', pieces);
	};
	switch (page.$) {
		case 48:
			return join(
				_List_fromArray(
					[$author$project$Route$analyticsLearningContractUrl]));
		case 0:
			return join(
				_List_fromArray(
					[$author$project$Route$auth0Url]));
		case 1:
			return join(_List_Nil);
		case 2:
			return join(
				_List_fromArray(
					[$author$project$Route$logoutUrl]));
		case 3:
			var url = page.a;
			return $elm$url$Url$toString(url);
		case 4:
			var count = page.a;
			if (!count.$) {
				var count_ = count.a;
				return join(
					_List_fromArray(
						[
							$author$project$Route$counterUrl + ('?count=' + $elm$core$String$fromInt(count_))
						]));
			} else {
				return join(
					_List_fromArray(
						[$author$project$Route$counterUrl]));
			}
		case 49:
			return join(
				_List_fromArray(
					[$author$project$Route$curriculumBrowserUrl]));
		case 5:
			var studentId = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$studentAbsenceListUrl,
						$elm$core$String$fromInt(studentId)
					]));
		case 8:
			return join(
				_List_fromArray(
					[$author$project$Route$homeUrl]));
		case 6:
			var personId = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(personId),
						$author$project$Route$learningAssessmentUrlPart
					]));
		case 7:
			var personId = page.a;
			var maybeLearningAssessmentId = page.b;
			var basePath = join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(personId),
						$author$project$Route$gradeRequestUrl
					]));
			if (!maybeLearningAssessmentId.$) {
				var laId = maybeLearningAssessmentId.a;
				return basePath + ('?learning_assessment_id=' + $elm$core$String$fromInt(laId));
			} else {
				return basePath;
			}
		case 9:
			return join(
				_List_fromArray(
					[$author$project$Route$learningContractsUrl, $author$project$Route$createUrlSuffix]));
		case 10:
			return join(
				_List_fromArray(
					[$author$project$Route$learningContractsUrl]));
		case 11:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$learningContractsUrl,
						$elm$core$String$fromInt(id)
					]));
		case 12:
			return join(
				_List_fromArray(
					[$author$project$Route$learningGroupsUrl, $author$project$Route$createUrlSuffix]));
		case 13:
			return join(
				_List_fromArray(
					[$author$project$Route$learningGroupsUrl]));
		case 15:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$learningGroupsUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$editUrlSuffix
					]));
		case 16:
			var query = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$moduleClosureOverviewUrl,
						$author$project$Route$moduleClosureOverviewListQueryAsParam(query)
					]));
		case 18:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$moduleTeacherProfilesUrlSuffix
					]));
		case 19:
			return join(
				_List_fromArray(
					[$author$project$Route$modulesUrl, $author$project$Route$createUrlSuffix]));
		case 23:
			return join(
				_List_fromArray(
					[$author$project$Route$modulesUrl]));
		case 21:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$modulesUrl,
						$elm$core$String$fromInt(id)
					]));
		case 20:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$modulesUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$createUrlSuffix
					]));
		case 22:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$modulesUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$duplicateUrlSuffix
					]));
		case 24:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$modulesUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$editUrlSuffix
					]));
		case 17:
			var moduleId = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$modulesUrl,
						$elm$core$String$fromInt(moduleId),
						$author$project$Route$moduleClosureUrlPart
					]));
		case 25:
			return join(
				_List_fromArray(
					[$author$project$Route$notificationsUrl]));
		case 26:
			return join(
				_List_fromArray(
					[$author$project$Route$phoneBookUrl]));
		case 28:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$portfoliosUrl,
						$elm$core$String$fromInt(id)
					]));
		case 31:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$portfoliosUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$editUrlSuffix
					]));
		case 27:
			var maybeModuleId = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$portfoliosUrl,
						$author$project$Route$createUrlSuffix,
						A2($author$project$Route$maybeIntParam, $author$project$Route$moduleParam, maybeModuleId)
					]));
		case 29:
			var query = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$portfoliosUrl,
						$author$project$Route$portfoliosListQueryAsParam(query)
					]));
		case 30:
			return join(
				_List_fromArray(
					[$author$project$Route$portfoliosUrl, $author$project$Route$portfoliosMyChildrenSuffix]));
		case 32:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(id)
					]));
		case 33:
			return join(
				_List_fromArray(
					[$author$project$Route$rubricsUrl, $author$project$Route$createUrlSuffix]));
		case 34:
			return join(
				_List_fromArray(
					[$author$project$Route$rubricsUrl]));
		case 37:
			var query = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$rubricSubjectOverviewUrl,
						$author$project$Route$loStudentOverviewListQueryAsParam(query)
					]));
		case 35:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$rubricsUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$editUrlSuffix
					]));
		case 36:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$rubricsUrl,
						$elm$core$String$fromInt(id)
					]));
		case 39:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$studentProfilesUrlSuffix
					]));
		case 38:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$studentProfilesNekUrlSuffix
					]));
		case 40:
			return join(
				_List_fromArray(
					[$author$project$Route$studentsUrl]));
		case 41:
			var studentId = page.a;
			var query = page.b;
			return join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(studentId),
						$author$project$Route$subjectFeedbackUrlPart,
						$author$project$Route$subjectFeedbackListQueryAsParam(query)
					]));
		case 42:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$teacherProfilesUrlSuffix
					]));
		case 45:
			var eventId = page.a.iX;
			var occId = page.a.hL;
			return join(
				_List_fromArray(
					[
						$author$project$Route$timetableUrl,
						$author$project$Route$timetableEventsUrlPart,
						$elm$core$String$fromInt(eventId),
						$elm$core$String$fromInt(occId)
					]));
		case 44:
			var query = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$timetableUrl,
						$author$project$Route$scheduleUrlSuffix,
						$author$project$Route$timetableCreateQueryAsParam(query)
					]));
		case 43:
			var people = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$timetableUrl,
						$elm$url$Url$Builder$toQuery(
						A2(
							$elm$core$List$map,
							$elm$url$Url$Builder$int($author$project$Route$personParam),
							people))
					]));
		case 46:
			var personId = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(personId),
						$author$project$Route$trimesterFeedbackReportUrl
					]));
		case 14:
			var studentId = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$financialsUrl,
						$elm$core$String$fromInt(studentId),
						$author$project$Route$companyContractUrlPart,
						$author$project$Route$createUrlSuffix
					]));
		case 47:
			var schoolId = page.a;
			var maybeGrade = page.b;
			var realtime = page.c;
			var queryParams = $elm$url$Url$Builder$toQuery(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$int('grade'),
							maybeGrade),
							$elm$core$Maybe$Just(
							A2($author$project$Route$buildBool, 'realtime', realtime))
						])));
			return join(
				_List_fromArray(
					[
						'grading',
						_Utils_ap(
						$elm$core$String$fromInt(schoolId),
						queryParams)
					]));
		default:
			return join(
				_List_fromArray(
					[$author$project$Route$financialsUrl, $author$project$Route$reconciliationUrl]));
	}
};
var $author$project$Route$replaceUrl = F2(
	function (key, route) {
		return A2(
			$elm$browser$Browser$Navigation$replaceUrl,
			key,
			$author$project$Route$toString(route));
	});
var $author$project$Main$init = F3(
	function (flags, url, key) {
		var route = $author$project$Route$fromUrl(url);
		var initialRoute = A2($author$project$Main$getInitialRoute, flags.mo, route);
		var model = {
			kY: A3($author$project$Auth0$Auth0Config, flags.kZ, flags.kX, flags.kW),
			a0: $author$project$Main$initAuthState(route),
			bK: _List_Nil,
			f7: false,
			jk: key,
			mn: $author$project$Locale$defaultLanguage,
			ef: flags.ef,
			el: $elm$core$Maybe$Nothing,
			bx: $author$project$Pages$notLoaded,
			cM: initialRoute,
			bG: A2($author$project$SharedConfig$create, flags, key)
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Route$replaceUrl, model.bG.jk, model.cM),
						$author$project$Ports$consoleInfo('Build revision: ' + flags.g0),
						$author$project$Main$authenticateStep1
					])));
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Main$GotCsrfToken = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$NewAppVersionIsAvailable = {$: 9};
var $author$project$Main$PageMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Ports$appUpdateReciever = _Platform_incomingPort(
	'appUpdateReciever',
	$elm$json$Json$Decode$null(0));
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Ports$csrfTokenReciever = _Platform_incomingPort('csrfTokenReciever', $elm$json$Json$Decode$string);
var $elm$core$Platform$Sub$map = _Platform_map;
var $author$project$Pages$CounterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$LearningGroupFormMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$LearningGroupSelectorMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$ModulesMainMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$PhoneBookMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$PortfolioFormMsg = function (a) {
	return {$: 17, a: a};
};
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Element$Counter$AnimalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Multiselect$Click = {$: 1};
var $author$project$Multiselect$Opened = 2;
var $author$project$Multiselect$isOpened = function (_v0) {
	var model = _v0;
	return model.S === 2;
};
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {jJ: pids, kc: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {iW: event, jk: key};
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.jJ,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.jk;
		var event = _v0.iW;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.kc);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onClick = A2($elm$browser$Browser$Events$on, 0, 'click');
var $author$project$Multiselect$subscriptions = function (model) {
	return $author$project$Multiselect$isOpened(model) ? $elm$browser$Browser$Events$onClick(
		$elm$json$Json$Decode$succeed($author$project$Multiselect$Click)) : $elm$core$Platform$Sub$none;
};
var $author$project$Element$Counter$subscriptions = function (_v0) {
	var animalSelectorModel = _v0.bC;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Element$Counter$AnimalMsg,
		$author$project$Multiselect$subscriptions(animalSelectorModel.bE.aN.og.fs));
};
var $author$project$Element$LearningGroupForm$StudentsFieldMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$LearningGroupForm$subscriptions = function (_v0) {
	var page = _v0.bk;
	if (page.$ === 1) {
		var form = page.a.bE;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Element$LearningGroupForm$StudentsFieldMsg,
			$author$project$Multiselect$subscriptions(form.fv.og.fs));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Element$LearningGroupSelector$LearningGroupsFieldMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$LearningGroupSelector$subscriptions = function (model) {
	var _v0 = model.bk;
	if (_v0.$ === 1) {
		var form = _v0.a.bE;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Element$LearningGroupSelector$LearningGroupsFieldMsg,
			$author$project$Multiselect$subscriptions(form.cv.og.fs));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Element$ModulesMain$FormMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Element$ModulesMain$LearningGroupSelectorMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModulesMain$PopupMsg = function (a) {
	return {$: 30, a: a};
};
var $author$project$Element$ModulesMain$Students = function (a) {
	return {$: 12, a: a};
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $author$project$Element$ModulesMain$subscriptions = function (_v0) {
	var page = _v0.bk;
	var popupModel = _v0.eq;
	if (page.$ === 3) {
		var formPageModel = page.a;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$Students),
					$author$project$Multiselect$subscriptions(formPageModel.bE.fv.og.fs)),
					function () {
					if ((!popupModel.$) && (popupModel.a.$ === 2)) {
						var learningGroupSelectorModel = popupModel.a.a;
						return A2(
							$elm$core$Platform$Sub$map,
							A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$PopupMsg, $author$project$Element$ModulesMain$LearningGroupSelectorMsg),
							$author$project$Element$LearningGroupSelector$subscriptions(learningGroupSelectorModel));
					} else {
						return $elm$core$Platform$Sub$none;
					}
				}()
				]));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Element$SwitchUserForm$GotSwitchUserAttempt = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$PhoneBook$SwitchUserFormMsg = function (a) {
	return {$: 5, a: a};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Ports$switchUserResponse = _Platform_incomingPort(
	'switchUserResponse',
	A2(
		$elm$json$Json$Decode$andThen,
		function (success) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (statusCode) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (error) {
							return $elm$json$Json$Decode$succeed(
								{lz: error, ft: statusCode, nZ: success});
						},
						A2(
							$elm$json$Json$Decode$field,
							'error',
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
									]))));
				},
				A2(
					$elm$json$Json$Decode$field,
					'statusCode',
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int)
							]))));
		},
		A2($elm$json$Json$Decode$field, 'success', $elm$json$Json$Decode$bool)));
var $author$project$Element$PhoneBook$subscriptions = function (model) {
	var _v0 = model.dH;
	if (!_v0.$) {
		return $author$project$Ports$switchUserResponse(
			A2($elm$core$Basics$composeL, $author$project$Element$PhoneBook$SwitchUserFormMsg, $author$project$Element$SwitchUserForm$GotSwitchUserAttempt));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Element$PortfolioForm$ModuleFieldMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$PortfolioForm$StudentsFieldMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$PortfolioForm$subscriptions = function (_v0) {
	var page = _v0.bk;
	if (page.$ === 1) {
		var form = page.a.bE;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Element$PortfolioForm$ModuleFieldMsg,
					$author$project$Multiselect$subscriptions(form.hG.og.fs)),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Element$PortfolioForm$StudentsFieldMsg,
					$author$project$Multiselect$subscriptions(form.fv.og.fs))
				]));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$subscriptions = function (model) {
	switch (model.$) {
		case 18:
			var portfolioFormModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$PortfolioFormMsg,
				$author$project$Element$PortfolioForm$subscriptions(portfolioFormModel));
		case 2:
			var counterModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$CounterMsg,
				$author$project$Element$Counter$subscriptions(counterModel));
		case 12:
			var modulesMainModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$ModulesMainMsg,
				$author$project$Element$ModulesMain$subscriptions(modulesMainModel));
		case 10:
			var learningGroupFormModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$LearningGroupFormMsg,
				$author$project$Element$LearningGroupForm$subscriptions(learningGroupFormModel));
		case 11:
			var learningGroupSelectorModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$LearningGroupSelectorMsg,
				$author$project$Element$LearningGroupSelector$subscriptions(learningGroupSelectorModel));
		case 16:
			var phoneBookModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$PhoneBookMsg,
				$author$project$Element$PhoneBook$subscriptions(phoneBookModel));
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Main$subscriptions = function (_v0) {
	var pageModel = _v0.bx;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$appUpdateReciever(
				$elm$core$Basics$always($author$project$Main$NewAppVersionIsAvailable)),
				$author$project$Ports$csrfTokenReciever($author$project$Main$GotCsrfToken),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$PageMsg,
				$author$project$Pages$subscriptions(pageModel))
			]));
};
var $author$project$Pages$HomePageMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$HomePage$ListElementMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$ModulesMain$LoadMoreModules = {$: 16};
var $author$project$Element$PortfolioList$LoadMoreStories = {$: 9};
var $author$project$Element$StudentList$LoadMoreStudents = {$: 6};
var $author$project$Main$LogOutRequest = {$: 4};
var $author$project$Main$LogResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$LogoutResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$MainErrorLogin = {$: 175};
var $author$project$Locale$Messages$MainErrorLogout = {$: 176};
var $author$project$Locale$Messages$MainErrorProfileDownload = {$: 179};
var $author$project$Pages$ModuleSingleMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Main$NoOp = {$: 13};
var $author$project$Element$ModuleSingle$PortfolioListMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$Navbar$RouteChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StudentListMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Main$Viewer = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$dictToString = function (d) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			function (_v0) {
				var k = _v0.a;
				var v = _v0.b;
				return k + (': ' + v);
			},
			$elm$core$Dict$toList(d)));
};
var $author$project$Api$httpErrorToHumans = function (error) {
	switch (error.$) {
		case 0:
			var str = error.a;
			return 'bad URL; ' + str;
		case 3:
			var metadata = error.b;
			return $elm$core$String$fromInt(metadata.ft) + (' ' + metadata.h3);
		case 4:
			var body = error.a;
			return 'bad body; ' + body;
		case 5:
			var metadata = error.a;
			return 'bad header; ' + $author$project$Api$dictToString(metadata.ar);
		case 2:
			return 'network error';
		case 1:
			return 'response timeout';
		default:
			return '';
	}
};
var $author$project$Main$addError = F3(
	function (model, message, error) {
		return _Utils_update(
			model,
			{
				bK: A2(
					$elm$core$List$cons,
					message + (' ' + $author$project$Api$httpErrorToHumans(error)),
					model.bK)
			});
	});
var $author$project$Auth0$auth0AuthorizeURL = F2(
	function (auth0Config, silent) {
		var scopes = _List_fromArray(
			['openid', 'name', 'email']);
		var scopeParam = $elm$url$Url$percentEncode(
			A2($elm$core$String$join, ' ', scopes));
		var responseType = 'id_token';
		var maybeConn = $elm$core$Maybe$Nothing;
		var connectionParam = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (c) {
					return '&connection=' + c;
				},
				maybeConn));
		return 'https://' + (auth0Config.iU + ('/authorize' + (('?response_type=' + responseType) + ('&nonce=foobar' + (('&client_id=' + auth0Config.iJ) + (connectionParam + (('&redirect_uri=' + auth0Config.jV) + (('&scope=' + scopeParam) + (silent ? '&prompt=none' : '')))))))));
	});
var $author$project$Main$LoginResponse = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $author$project$Api$Endpoint$Endpoint = $elm$core$Basics$identity;
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $author$project$Api$Endpoint$toQueryParameters = function (params) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var name = _v0.a;
			var value = _v0.b;
			return A2($elm$url$Url$Builder$string, name, value);
		},
		params);
};
var $author$project$Api$Endpoint$url = F3(
	function (protoAndHost, paths, params) {
		var queryParams = $author$project$Api$Endpoint$toQueryParameters(params);
		return A3($elm$url$Url$Builder$crossOrigin, protoAndHost, paths, queryParams);
	});
var $author$project$Api$Endpoint$endpoint = F3(
	function (config, paths, params) {
		var pathsWithTrailingSlash = _Utils_ap(
			paths,
			_List_fromArray(
				['']));
		return A3($author$project$Api$Endpoint$url, config.fK, pathsWithTrailingSlash, params);
	});
var $author$project$Api$Endpoint$login = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'login']),
		_List_Nil);
};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $author$project$Api$BadBody = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$BadStatus = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Api$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$NetworkError = {$: 2};
var $author$project$Api$Timeout = {$: 1};
var $author$project$Api$resolveWithErrorDetailed = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$author$project$Api$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($author$project$Api$Timeout);
			case 2:
				return $elm$core$Result$Err($author$project$Api$NetworkError);
			case 3:
				var metadata = response.a;
				var body = response.b;
				return $elm$core$Result$Err(
					A3($author$project$Api$BadStatus, metadata.ft, metadata, body));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$author$project$Api$BadBody,
					toResult(body));
		}
	});
var $author$project$Api$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$author$project$Api$resolveWithErrorDetailed(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {jZ: reqs, kc: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.bq;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.jZ));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.kc)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					kQ: r.kQ,
					T: r.T,
					bd: A2(_Http_mapExpect, func, r.bd),
					ar: r.ar,
					bj: r.bj,
					bp: r.bp,
					bq: r.bq,
					K: r.K
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{kQ: true, T: r.T, bd: r.bd, ar: r.ar, bj: r.bj, bp: r.bp, bq: r.bq, K: r.K}));
};
var $author$project$Api$Endpoint$toString = function (_v0) {
	var str = _v0;
	return str;
};
var $author$project$Api$Endpoint$request = function (config) {
	return $elm$http$Http$riskyRequest(
		{
			T: config.T,
			bd: config.bd,
			ar: config.ar,
			bj: config.bj,
			bp: config.bp,
			bq: config.bq,
			K: $author$project$Api$Endpoint$toString(config.K)
		});
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Api$toHeaders = function (config) {
	return _Utils_ap(
		function () {
			var _v0 = config.lg;
			if (!_v0.$) {
				var token = _v0.a;
				return _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CsrfToken', token)
					]);
			} else {
				return _List_Nil;
			}
		}(),
		function () {
			var _v1 = config.k3;
			if (!_v1.$) {
				var bearer = _v1.a;
				return _List_fromArray(
					[
						A2($elm$http$Http$header, 'Authorization', 'Bearer ' + bearer)
					]);
			} else {
				return _List_Nil;
			}
		}());
};
var $author$project$Api$post = F5(
	function (url, config, body, toMsg, decoder) {
		return $author$project$Api$Endpoint$request(
			{
				T: body,
				bd: A2($author$project$Api$expectJson, toMsg, decoder),
				ar: $author$project$Api$toHeaders(config),
				bj: 'POST',
				bp: $elm$core$Maybe$Nothing,
				bq: $elm$core$Maybe$Nothing,
				K: url
			});
	});
var $author$project$Api$login = F2(
	function (config, callback) {
		return A5(
			$author$project$Api$post,
			$author$project$Api$Endpoint$login(config),
			config,
			$elm$http$Http$emptyBody,
			callback,
			$elm$json$Json$Decode$succeed(0));
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Api$Endpoint$verifyToken = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['api-token-verify']),
		_List_Nil);
};
var $author$project$Auth0$verifyToken = F3(
	function (config, token, callback) {
		return A5(
			$author$project$Api$post,
			$author$project$Api$Endpoint$verifyToken(config),
			config,
			$elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'token',
							$elm$json$Json$Encode$string(token))
						]))),
			callback,
			$elm$json$Json$Decode$succeed(0));
	});
var $author$project$Main$authenticateStep2 = F2(
	function (authState, backend) {
		switch (authState.$) {
			case 2:
				switch (authState.a.$) {
					case 0:
						var token = authState.a.a;
						return A3($author$project$Auth0$verifyToken, backend, token, $author$project$Main$LoginResponse);
					case 1:
						var _v1 = authState.a;
						return $elm$core$Platform$Cmd$none;
					default:
						return $elm$core$Platform$Cmd$none;
				}
			case 1:
				return A2($author$project$Api$login, backend, $author$project$Main$LoginResponse);
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Notification$remove = F2(
	function (id, notifications) {
		return A2($elm$core$Dict$remove, id, notifications);
	});
var $author$project$Session$clearNotification = F2(
	function (id, session) {
		return _Utils_update(
			session,
			{
				em: A2($author$project$Notification$remove, id, session.em)
			});
	});
var $author$project$Ports$consoleError = _Platform_outgoingPort('consoleError', $elm$json$Json$Encode$string);
var $author$project$Notification$empty = $elm$core$Dict$empty;
var $author$project$Session$create = function (viewer) {
	return {mn: viewer.nD.mn, em: $author$project$Notification$empty, h6: viewer.nD.mn.h6, ok: viewer};
};
var $author$project$Log$ErrorLevel = 0;
var $author$project$Api$Endpoint$log = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'log']),
		_List_Nil);
};
var $author$project$Log$logEventNameToString = function (_v0) {
	var eventNameStr = _v0;
	return eventNameStr;
};
var $author$project$Log$logLevelToString = function (level) {
	if (level === 1) {
		return 'info';
	} else {
		return 'error';
	}
};
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {lZ: index, mu: match, mS: number, nX: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{k6: false, mJ: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $author$project$Log$removeWhitespaces = function (str) {
	var pattern = '\n|\t|[ ]{2,}';
	var maybeRegex = $elm$regex$Regex$fromString(pattern);
	var regex = A2($elm$core$Maybe$withDefault, $elm$regex$Regex$never, maybeRegex);
	var normalize = A2(
		$elm$regex$Regex$replace,
		regex,
		function (_v0) {
			return '';
		});
	return normalize(str);
};
var $elm$http$Http$stringPart = _Http_pair;
var $author$project$Log$makeFormData = F2(
	function (maxLength, event) {
		var normalizedMessage = A3(
			$elm$core$String$slice,
			0,
			maxLength,
			$author$project$Log$removeWhitespaces(event.cz));
		return $elm$http$Http$multipartBody(
			_List_fromArray(
				[
					A2($elm$http$Http$stringPart, 'client_id', event.iJ),
					A2($elm$http$Http$stringPart, 'client_version', event.c$),
					A2(
					$elm$http$Http$stringPart,
					'level',
					$author$project$Log$logLevelToString(event.di)),
					A2(
					$elm$http$Http$stringPart,
					'event_name',
					$author$project$Log$logEventNameToString(event.cn)),
					A2($elm$http$Http$stringPart, 'message', normalizedMessage)
				]));
	});
var $author$project$Log$log = F3(
	function (config, event, callback) {
		return A5(
			$author$project$Api$post,
			$author$project$Api$Endpoint$log(config.gX),
			config.gX,
			A2($author$project$Log$makeFormData, config.gX.hE, event),
			callback,
			$elm$json$Json$Decode$succeed(0));
	});
var $author$project$Log$err = F3(
	function (config, _v0, toMsg) {
		var eventName = _v0.a;
		var message = _v0.b;
		var event = {iJ: config.gX.hD, c$: config.g0, cn: eventName, di: 0, cz: message};
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$Log$log, config, event, toMsg),
					$author$project$Ports$consoleError(
					$author$project$Log$logEventNameToString(event.cn) + (' ' + event.cz))
				]));
	});
var $author$project$Api$httpErrorToRobots = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return 'bad url|' + url;
		case 3:
			var metadata = error.b;
			var body = error.c;
			return $elm$core$String$fromInt(metadata.ft) + (' ' + (metadata.h3 + ('|' + body)));
		case 4:
			var body = error.a;
			return 'bad body|' + body;
		case 5:
			var metadata = error.a;
			return 'bad header|' + $author$project$Api$dictToString(metadata.ar);
		case 2:
			return 'network error';
		case 1:
			return 'response timeout';
		default:
			var msg = error.a;
			return 'error|' + msg;
	}
};
var $author$project$Log$msgSeperator = ';';
var $author$project$Log$error = F3(
	function (config, _v0, toMsg) {
		var eventName = _v0.a;
		var message = _v0.b;
		var error_ = _v0.c;
		if (!message.$) {
			var message_ = message.a;
			return A3(
				$author$project$Log$err,
				config,
				_Utils_Tuple2(
					eventName,
					_Utils_ap(
						message_,
						_Utils_ap(
							$author$project$Log$msgSeperator,
							$author$project$Api$httpErrorToRobots(error_)))),
				toMsg);
		} else {
			return A3(
				$author$project$Log$err,
				config,
				_Utils_Tuple2(
					eventName,
					$author$project$Api$httpErrorToRobots(error_)),
				toMsg);
		}
	});
var $author$project$Main$BackendLoggedIn = {$: 1};
var $author$project$Main$ViewerDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$get = F3(
	function (url, config, expect) {
		return $author$project$Api$Endpoint$request(
			{
				T: $elm$http$Http$emptyBody,
				bd: expect,
				ar: $author$project$Api$toHeaders(config),
				bj: 'GET',
				bp: $elm$core$Maybe$Nothing,
				bq: $elm$core$Maybe$Nothing,
				K: url
			});
	});
var $author$project$Api$Endpoint$me = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'people', 'me']),
		_List_Nil);
};
var $author$project$Person$Active = 1;
var $author$project$Person$Person = function (id) {
	return function (firstName) {
		return function (lastName) {
			return function (phoneNumber) {
				return function (email) {
					return function (permanentAddress) {
						return function (temporaryAddress) {
							return function (birthDate) {
								return function (birthPlaceCountry) {
									return function (birthPlaceTown) {
										return function (roles) {
											return function (mentees) {
												return function (sponsorOf) {
													return function (relatedPeople) {
														return function (settings) {
															return function (state) {
																return function (accessRoles) {
																	return {io: accessRoles, aP: birthDate, aR: birthPlaceCountry, aS: birthPlaceTown, O: email, lI: firstName, i8: id, av: lastName, mx: mentees, dp: permanentAddress, a$: phoneNumber, nh: relatedPeople, nr: roles, nD: settings, nL: sponsorOf, fs: state, n3: temporaryAddress};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Person$Auditor = 1;
var $author$project$Person$BpsStaff = 0;
var $author$project$Person$EduAffairs = 4;
var $author$project$Person$EndOfTrimesterCoordinator = 8;
var $author$project$Person$EnrollmentCoordinator = 7;
var $author$project$Person$FinanceStaff = 6;
var $author$project$Person$Impersonator = 2;
var $author$project$Person$KretaAdmin = 3;
var $author$project$Person$MarketingStaff = 9;
var $author$project$Person$TechStaff = 5;
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Person$accessRoleDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (role) {
		switch (role) {
			case 'bps_staff':
				return $elm$json$Json$Decode$succeed(0);
			case 'auditor':
				return $elm$json$Json$Decode$succeed(1);
			case 'impersonator':
				return $elm$json$Json$Decode$succeed(2);
			case 'kreta_admin':
				return $elm$json$Json$Decode$succeed(3);
			case 'edu_affairs':
				return $elm$json$Json$Decode$succeed(4);
			case 'tech_staff':
				return $elm$json$Json$Decode$succeed(5);
			case 'finance_staff':
				return $elm$json$Json$Decode$succeed(6);
			case 'enrollment_coordinator':
				return $elm$json$Json$Decode$succeed(7);
			case 'end_of_trimester_coordinator':
				return $elm$json$Json$Decode$succeed(8);
			case 'marketing_staff':
				return $elm$json$Json$Decode$succeed(9);
			default:
				return $elm$json$Json$Decode$fail('Unknown access role: ' + role);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Person$accessRolesDecoder = $elm$json$Json$Decode$list($author$project$Person$accessRoleDecoder);
var $author$project$Person$Address = F9(
	function (isPermanent, country, town, postcode, pob, streetName, streetType, streetNumber, streetDoor) {
		return {le: country, ji: isPermanent, jK: pob, nb: postcode, nP: streetDoor, nQ: streetName, nR: streetNumber, nS: streetType, ob: town};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Person$addressDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'street_door',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'street_number',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'street_type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'street_name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'pob',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'postcode',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'town',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'country',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'is_permanent',
									$elm$json$Json$Decode$bool,
									$elm$json$Json$Decode$succeed($author$project$Person$Address))))))))));
var $author$project$UserSettings$default = {i8: -1, mn: $author$project$Locale$defaultLanguage};
var $author$project$Person$Roles = $elm$core$Basics$identity;
var $author$project$Person$emptyRoles = _List_Nil;
var $author$project$Person$Future = 2;
var $author$project$Person$Left = 0;
var $author$project$Person$membershipStateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (state) {
		switch (state) {
			case 'left':
				return $elm$json$Json$Decode$succeed(0);
			case 'active':
				return $elm$json$Json$Decode$succeed(1);
			case 'future':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unknown membership state: ' + state);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Person$NestedPerson = F4(
	function (id, firstName, lastName, email) {
		return {O: email, lI: firstName, i8: id, av: lastName};
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Person$nestedPersonDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'email',
	$elm$json$Json$Decode$string,
	'',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'last_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'first_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Person$NestedPerson)))));
var $author$project$Person$nestedPeopleDecoder = $elm$json$Json$Decode$list($author$project$Person$nestedPersonDecoder);
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $author$project$Team$TeamId = $elm$core$Basics$identity;
var $author$project$Team$teamIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$Person$rolesDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$index, 1, $author$project$Team$teamIdDecoder))));
var $author$project$UserSettings$UserSettings = F2(
	function (id, language) {
		return {i8: id, mn: language};
	});
var $author$project$Locale$English$isFirstNameFirst = true;
var $ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$english = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix);
var $author$project$Locale$English$dateFormatter = A2(
	$ryan_haskell$date_format$DateFormat$formatWithLanguage,
	$ryan_haskell$date_format$DateFormat$Language$english,
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$monthNameFull,
			$ryan_haskell$date_format$DateFormat$text(' '),
			$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix,
			$ryan_haskell$date_format$DateFormat$text(', '),
			$ryan_haskell$date_format$DateFormat$yearNumber,
			$ryan_haskell$date_format$DateFormat$text(' ('),
			$ryan_haskell$date_format$DateFormat$dayOfWeekNameFull,
			$ryan_haskell$date_format$DateFormat$text(')')
		]));
var $author$project$Locale$English$dateTimeFormatter = A2(
	$ryan_haskell$date_format$DateFormat$formatWithLanguage,
	$ryan_haskell$date_format$DateFormat$Language$english,
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$monthNameFull,
			$ryan_haskell$date_format$DateFormat$text(' '),
			$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix,
			$ryan_haskell$date_format$DateFormat$text(', '),
			$ryan_haskell$date_format$DateFormat$yearNumber,
			$ryan_haskell$date_format$DateFormat$text(' ('),
			$ryan_haskell$date_format$DateFormat$dayOfWeekNameFull,
			$ryan_haskell$date_format$DateFormat$text(')'),
			$ryan_haskell$date_format$DateFormat$text(' '),
			$ryan_haskell$date_format$DateFormat$hourMilitaryNumber,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed
		]));
var $author$project$Locale$English$formatDays = function (weekdays) {
	var weekdayToText = function (weekday) {
		switch (weekday) {
			case 'MO':
				return 'Monday';
			case 'TU':
				return 'Tuesday';
			case 'WE':
				return 'Wednesday';
			case 'TH':
				return 'Thursday';
			case 'FR':
				return 'Friday';
			default:
				return '';
		}
	};
	if (!weekdays.$) {
		var weekdays_ = weekdays.a;
		return A2(
			$elm$core$String$join,
			', ',
			A2($elm$core$List$map, weekdayToText, weekdays_));
	} else {
		return '';
	}
};
var $author$project$Locale$English$formatRecurring = F2(
	function (frequency, interval) {
		var _v0 = _Utils_Tuple2(frequency, interval);
		if (((_v0.a === 'Weekly') && (!_v0.b.$)) && (_v0.b.a === 2)) {
			return 'every other week ';
		} else {
			return 'every week ';
		}
	});
var $author$project$Locale$English$nameList = function (names) {
	var _v0 = $elm$core$List$reverse(names);
	if (!_v0.b) {
		return '';
	} else {
		if (!_v0.b.b) {
			var x = _v0.a;
			return x;
		} else {
			var x = _v0.a;
			var xs = _v0.b;
			return A2(
				$elm$core$String$join,
				', ',
				$elm$core$List$reverse(xs)) + (' and ' + x);
		}
	}
};
var $author$project$Locale$English$termFormatter = F3(
	function (zone, start, end) {
		var sameYear = _Utils_eq(
			A2($elm$time$Time$toYear, zone, start),
			A2($elm$time$Time$toYear, zone, end));
		var sameMonth = _Utils_eq(
			A2($elm$time$Time$toMonth, zone, start),
			A2($elm$time$Time$toMonth, zone, end));
		var sameDay = _Utils_eq(
			A2($elm$time$Time$toDay, zone, start),
			A2($elm$time$Time$toDay, zone, end));
		var _v0 = _Utils_Tuple3(sameYear, sameMonth, sameDay);
		if (_v0.a) {
			if (_v0.b) {
				if (_v0.c) {
					var startDate = A4(
						$ryan_haskell$date_format$DateFormat$formatWithLanguage,
						$ryan_haskell$date_format$DateFormat$Language$english,
						_List_fromArray(
							[
								$ryan_haskell$date_format$DateFormat$monthNameFull,
								$ryan_haskell$date_format$DateFormat$text(' '),
								$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
								$ryan_haskell$date_format$DateFormat$text(', '),
								$ryan_haskell$date_format$DateFormat$yearNumber,
								$ryan_haskell$date_format$DateFormat$text(' ('),
								$ryan_haskell$date_format$DateFormat$dayOfWeekNameFull,
								$ryan_haskell$date_format$DateFormat$text(')')
							]),
						zone,
						start);
					return startDate;
				} else {
					var startDate = A4(
						$ryan_haskell$date_format$DateFormat$formatWithLanguage,
						$ryan_haskell$date_format$DateFormat$Language$english,
						_List_fromArray(
							[
								$ryan_haskell$date_format$DateFormat$monthNameFull,
								$ryan_haskell$date_format$DateFormat$text(' '),
								$ryan_haskell$date_format$DateFormat$dayOfMonthNumber
							]),
						zone,
						start);
					var endDate = A4(
						$ryan_haskell$date_format$DateFormat$formatWithLanguage,
						$ryan_haskell$date_format$DateFormat$Language$english,
						_List_fromArray(
							[
								$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
								$ryan_haskell$date_format$DateFormat$text(', '),
								$ryan_haskell$date_format$DateFormat$yearNumber
							]),
						zone,
						end);
					return startDate + ('—' + endDate);
				}
			} else {
				var startDate = A4(
					$ryan_haskell$date_format$DateFormat$formatWithLanguage,
					$ryan_haskell$date_format$DateFormat$Language$english,
					_List_fromArray(
						[
							$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
							$ryan_haskell$date_format$DateFormat$text(' '),
							$ryan_haskell$date_format$DateFormat$dayOfMonthNumber
						]),
					zone,
					start);
				var endDate = A4(
					$ryan_haskell$date_format$DateFormat$formatWithLanguage,
					$ryan_haskell$date_format$DateFormat$Language$english,
					_List_fromArray(
						[
							$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
							$ryan_haskell$date_format$DateFormat$text(' '),
							$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
							$ryan_haskell$date_format$DateFormat$text(', '),
							$ryan_haskell$date_format$DateFormat$yearNumber
						]),
					zone,
					end);
				return startDate + ('—' + endDate);
			}
		} else {
			var startDate = A4(
				$ryan_haskell$date_format$DateFormat$formatWithLanguage,
				$ryan_haskell$date_format$DateFormat$Language$english,
				_List_fromArray(
					[
						$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
						$ryan_haskell$date_format$DateFormat$text(' '),
						$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
						$ryan_haskell$date_format$DateFormat$text(', '),
						$ryan_haskell$date_format$DateFormat$yearNumber
					]),
				zone,
				start);
			var endDate = A4(
				$ryan_haskell$date_format$DateFormat$formatWithLanguage,
				$ryan_haskell$date_format$DateFormat$Language$english,
				_List_fromArray(
					[
						$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
						$ryan_haskell$date_format$DateFormat$text(' '),
						$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
						$ryan_haskell$date_format$DateFormat$text(', '),
						$ryan_haskell$date_format$DateFormat$yearNumber
					]),
				zone,
				end);
			return startDate + ('—' + endDate);
		}
	});
var $author$project$Locale$English$timeFormatter = A2(
	$ryan_haskell$date_format$DateFormat$formatWithLanguage,
	$ryan_haskell$date_format$DateFormat$Language$english,
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$hourMilitaryNumber,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed
		]));
var $rl_king$elm_iso3166_country_codes$Iso3166$English$toName = function (c) {
	switch (c) {
		case 0:
			return 'Andorra';
		case 1:
			return 'United Arab Emirates';
		case 2:
			return 'Afghanistan';
		case 3:
			return 'Antigua and Barbuda';
		case 4:
			return 'Anguilla';
		case 5:
			return 'Albania';
		case 6:
			return 'Armenia';
		case 7:
			return 'Angola';
		case 8:
			return 'Antarctica';
		case 9:
			return 'Argentina';
		case 10:
			return 'American Samoa';
		case 11:
			return 'Austria';
		case 12:
			return 'Australia';
		case 13:
			return 'Aruba';
		case 14:
			return 'Åland Islands';
		case 15:
			return 'Azerbaijan';
		case 16:
			return 'Bosnia and Herzegovina';
		case 17:
			return 'Barbados';
		case 18:
			return 'Bangladesh';
		case 19:
			return 'Belgium';
		case 20:
			return 'Burkina Faso';
		case 21:
			return 'Bulgaria';
		case 22:
			return 'Bahrain';
		case 23:
			return 'Burundi';
		case 24:
			return 'Benin';
		case 25:
			return 'Saint Barthélemy';
		case 26:
			return 'Bermuda';
		case 27:
			return 'Brunei Darussalam';
		case 28:
			return 'Bolivia (Plurinational State of)';
		case 29:
			return 'Bonaire, Sint Eustatius and Saba';
		case 30:
			return 'Brazil';
		case 31:
			return 'Bahamas';
		case 32:
			return 'Bhutan';
		case 33:
			return 'Bouvet Island';
		case 34:
			return 'Botswana';
		case 35:
			return 'Belarus';
		case 36:
			return 'Belize';
		case 37:
			return 'Canada';
		case 38:
			return 'Cocos (Keeling) Islands';
		case 39:
			return 'Congo, Democratic Republic of the';
		case 40:
			return 'Central African Republic';
		case 41:
			return 'Congo';
		case 42:
			return 'Switzerland';
		case 43:
			return 'Côte d\'Ivoire';
		case 44:
			return 'Cook Islands';
		case 45:
			return 'Chile';
		case 46:
			return 'Cameroon';
		case 47:
			return 'China';
		case 48:
			return 'Colombia';
		case 49:
			return 'Costa Rica';
		case 50:
			return 'Cuba';
		case 51:
			return 'Cabo Verde';
		case 52:
			return 'Curaçao';
		case 53:
			return 'Christmas Island';
		case 54:
			return 'Cyprus';
		case 55:
			return 'Czechia';
		case 56:
			return 'Germany';
		case 57:
			return 'Djibouti';
		case 58:
			return 'Denmark';
		case 59:
			return 'Dominica';
		case 60:
			return 'Dominican Republic';
		case 61:
			return 'Algeria';
		case 62:
			return 'Ecuador';
		case 63:
			return 'Estonia';
		case 64:
			return 'Egypt';
		case 65:
			return 'Western Sahara';
		case 66:
			return 'Eritrea';
		case 67:
			return 'Spain';
		case 68:
			return 'Ethiopia';
		case 69:
			return 'Finland';
		case 70:
			return 'Fiji';
		case 71:
			return 'Falkland Islands (Malvinas)';
		case 72:
			return 'Micronesia (Federated States of)';
		case 73:
			return 'Faroe Islands';
		case 74:
			return 'France';
		case 75:
			return 'Gabon';
		case 76:
			return 'United Kingdom of Great Britain and Northern Ireland';
		case 77:
			return 'Grenada';
		case 78:
			return 'Georgia';
		case 79:
			return 'French Guiana';
		case 80:
			return 'Guernsey';
		case 81:
			return 'Ghana';
		case 82:
			return 'Gibraltar';
		case 83:
			return 'Greenland';
		case 84:
			return 'Gambia';
		case 85:
			return 'Guinea';
		case 86:
			return 'Guadeloupe';
		case 87:
			return 'Equatorial Guinea';
		case 88:
			return 'Greece';
		case 89:
			return 'South Georgia and the South Sandwich Islands';
		case 90:
			return 'Guatemala';
		case 91:
			return 'Guam';
		case 92:
			return 'Guinea-Bissau';
		case 93:
			return 'Guyana';
		case 94:
			return 'Hong Kong';
		case 95:
			return 'Heard Island and McDonald Islands';
		case 96:
			return 'Honduras';
		case 97:
			return 'Croatia';
		case 98:
			return 'Haiti';
		case 99:
			return 'Hungary';
		case 100:
			return 'Indonesia';
		case 101:
			return 'Ireland';
		case 102:
			return 'Israel';
		case 103:
			return 'Isle of Man';
		case 104:
			return 'India';
		case 105:
			return 'British Indian Ocean Territory';
		case 106:
			return 'Iraq';
		case 107:
			return 'Iran (Islamic Republic of)';
		case 108:
			return 'Iceland';
		case 109:
			return 'Italy';
		case 110:
			return 'Jersey';
		case 111:
			return 'Jamaica';
		case 112:
			return 'Jordan';
		case 113:
			return 'Japan';
		case 114:
			return 'Kenya';
		case 115:
			return 'Kyrgyzstan';
		case 116:
			return 'Cambodia';
		case 117:
			return 'Kiribati';
		case 118:
			return 'Comoros';
		case 119:
			return 'Saint Kitts and Nevis';
		case 120:
			return 'Korea (Democratic People\'s Republic of)';
		case 121:
			return 'Korea, Republic of';
		case 122:
			return 'Kuwait';
		case 123:
			return 'Cayman Islands';
		case 124:
			return 'Kazakhstan';
		case 125:
			return 'Lao People\'s Democratic Republic';
		case 126:
			return 'Lebanon';
		case 127:
			return 'Saint Lucia';
		case 128:
			return 'Liechtenstein';
		case 129:
			return 'Sri Lanka';
		case 130:
			return 'Liberia';
		case 131:
			return 'Lesotho';
		case 132:
			return 'Lithuania';
		case 133:
			return 'Luxembourg';
		case 134:
			return 'Latvia';
		case 135:
			return 'Libya';
		case 136:
			return 'Morocco';
		case 137:
			return 'Monaco';
		case 138:
			return 'Moldova, Republic of';
		case 139:
			return 'Montenegro';
		case 140:
			return 'Saint Martin (French part)';
		case 141:
			return 'Madagascar';
		case 142:
			return 'Marshall Islands';
		case 143:
			return 'North Macedonia';
		case 144:
			return 'Mali';
		case 145:
			return 'Myanmar';
		case 146:
			return 'Mongolia';
		case 147:
			return 'Macao';
		case 148:
			return 'Northern Mariana Islands';
		case 149:
			return 'Martinique';
		case 150:
			return 'Mauritania';
		case 151:
			return 'Montserrat';
		case 152:
			return 'Malta';
		case 153:
			return 'Mauritius';
		case 154:
			return 'Maldives';
		case 155:
			return 'Malawi';
		case 156:
			return 'Mexico';
		case 157:
			return 'Malaysia';
		case 158:
			return 'Mozambique';
		case 159:
			return 'Namibia';
		case 160:
			return 'New Caledonia';
		case 161:
			return 'Niger';
		case 162:
			return 'Norfolk Island';
		case 163:
			return 'Nigeria';
		case 164:
			return 'Nicaragua';
		case 165:
			return 'Netherlands';
		case 166:
			return 'Norway';
		case 167:
			return 'Nepal';
		case 168:
			return 'Nauru';
		case 169:
			return 'Niue';
		case 170:
			return 'New Zealand';
		case 171:
			return 'Oman';
		case 172:
			return 'Panama';
		case 173:
			return 'Peru';
		case 174:
			return 'French Polynesia';
		case 175:
			return 'Papua New Guinea';
		case 176:
			return 'Philippines';
		case 177:
			return 'Pakistan';
		case 178:
			return 'Poland';
		case 179:
			return 'Saint Pierre and Miquelon';
		case 180:
			return 'Pitcairn';
		case 181:
			return 'Puerto Rico';
		case 182:
			return 'Palestine, State of';
		case 183:
			return 'Portugal';
		case 184:
			return 'Palau';
		case 185:
			return 'Paraguay';
		case 186:
			return 'Qatar';
		case 187:
			return 'Réunion';
		case 188:
			return 'Romania';
		case 189:
			return 'Serbia';
		case 190:
			return 'Russian Federation';
		case 191:
			return 'Rwanda';
		case 192:
			return 'Saudi Arabia';
		case 193:
			return 'Solomon Islands';
		case 194:
			return 'Seychelles';
		case 195:
			return 'Sudan';
		case 196:
			return 'Sweden';
		case 197:
			return 'Singapore';
		case 198:
			return 'Saint Helena, Ascension and Tristan da Cunha';
		case 199:
			return 'Slovenia';
		case 200:
			return 'Svalbard and Jan Mayen';
		case 201:
			return 'Slovakia';
		case 202:
			return 'Sierra Leone';
		case 203:
			return 'San Marino';
		case 204:
			return 'Senegal';
		case 205:
			return 'Somalia';
		case 206:
			return 'Suriname';
		case 207:
			return 'South Sudan';
		case 208:
			return 'Sao Tome and Principe';
		case 209:
			return 'El Salvador';
		case 210:
			return 'Sint Maarten (Dutch part)';
		case 211:
			return 'Syrian Arab Republic';
		case 212:
			return 'Eswatini';
		case 213:
			return 'Turks and Caicos Islands';
		case 214:
			return 'Chad';
		case 215:
			return 'French Southern Territories';
		case 216:
			return 'Togo';
		case 217:
			return 'Thailand';
		case 218:
			return 'Tajikistan';
		case 219:
			return 'Tokelau';
		case 220:
			return 'Timor-Leste';
		case 221:
			return 'Turkmenistan';
		case 222:
			return 'Tunisia';
		case 223:
			return 'Tonga';
		case 224:
			return 'Türkiye';
		case 225:
			return 'Trinidad and Tobago';
		case 226:
			return 'Tuvalu';
		case 227:
			return 'Taiwan, Province of China';
		case 228:
			return 'Tanzania, United Republic of';
		case 229:
			return 'Ukraine';
		case 230:
			return 'Uganda';
		case 231:
			return 'United States Minor Outlying Islands';
		case 232:
			return 'United States of America';
		case 233:
			return 'Uruguay';
		case 234:
			return 'Uzbekistan';
		case 235:
			return 'Holy See';
		case 236:
			return 'Saint Vincent and the Grenadines';
		case 237:
			return 'Venezuela (Bolivarian Republic of)';
		case 238:
			return 'Virgin Islands (British)';
		case 239:
			return 'Virgin Islands (U.S.)';
		case 240:
			return 'Viet Nam';
		case 241:
			return 'Vanuatu';
		case 242:
			return 'Wallis and Futuna';
		case 243:
			return 'Samoa';
		case 244:
			return 'Yemen';
		case 245:
			return 'Mayotte';
		case 246:
			return 'South Africa';
		case 247:
			return 'Zambia';
		default:
			return 'Zimbabwe';
	}
};
var $author$project$Locale$English$translator = function (str) {
	switch (str.$) {
		case 0:
			var s = str.a;
			return s;
		case 1:
			return 'Changed: ';
		case 2:
			var caption = str.a;
			return caption;
		case 3:
			var caption = str.a;
			var from = str.b;
			var to = str.c;
			var visualizeEmpty = function (s) {
				return $elm$core$String$isEmpty(s) ? '∅' : s;
			};
			return caption + (' (' + (visualizeEmpty(from) + (' → ' + (visualizeEmpty(to) + ')'))));
		case 4:
			return 'Downloading recent notifications failed';
		case 5:
			var teacher = str.a;
			var student = str.b;
			return '<i>' + (teacher + ('</i> uploaded a new learning contract for <i>' + (student + '</i>.')));
		case 6:
			var teacher = str.a;
			var student = str.b;
			return '<i>' + (teacher + ('</i> updated the learning contract of <i>' + (student + '</i>.')));
		case 8:
			return 'There are currently no notifications.';
		case 7:
			return 'Loading notifications...';
		case 9:
			var person = str.a;
			return '<i>' + (person + '</i>\'s mentor memo was updated.');
		case 10:
			var teacher = str.a;
			return '<i>' + (teacher + '</i> updated their teacher data.');
		case 11:
			var student = str.a;
			return '<i>' + (student + '</i> participated in an activity.');
		case 12:
			var person = str.a;
			return '<i>' + (person + '</i> updated their contact data.');
		case 13:
			var approvedBy = str.a;
			var student = str.b;
			return '<i>' + (approvedBy + ('</i> updated the child data of <i>' + (student + '</i>.')));
		case 14:
			var teacher = str.a;
			return '<i>' + (teacher + '</i> updated their teacher data.');
		case 15:
			return 'Most recent notifications';
		case 16:
			return 'View';
		case 17:
			return 'Learning contract';
		case 18:
			return 'Appreciation';
		case 19:
			return 'Revoke badge';
		case 20:
			return 'If you revoke the badge, it won\'t be calculated in the progress report any more. Are you sure you want to revoke it?';
		case 21:
			return 'An error occured while revoking the badge';
		case 22:
			return 'Badge was successfully revoked.';
		case 23:
			var names = str.a;
			return $elm$core$String$concat(
				_List_fromArray(
					[
						'Dear ',
						$author$project$Locale$English$nameList(names),
						'! I would like to add the following to your feedback:'
					]));
		case 24:
			var name = str.a;
			return 'You have granted badge to ' + ($author$project$Locale$English$nameList(name) + '.');
		case 25:
			return 'Actions';
		case 27:
			return '+';
		case 26:
			return '-';
		case 28:
			return 'Create';
		case 29:
			return 'Delete';
		case 30:
			return 'Edit';
		case 31:
			return 'Login';
		case 32:
			return 'Reset';
		case 33:
			return 'Save';
		case 34:
			return 'OK';
		case 36:
			return 'Cancel';
		case 35:
			return 'Details';
		case 37:
			return 'Select';
		case 38:
			return 'Deselect';
		case 39:
			return 'Filters';
		case 40:
			return 'Downloading Google Classroom course list failed';
		case 41:
			var animal = str.a;
			var count = str.b;
			return $elm$core$String$fromInt(count) + (' ' + animal);
		case 43:
			var code = str.a;
			return $rl_king$elm_iso3166_country_codes$Iso3166$English$toName(code);
		case 42:
			return 'Counter';
		case 44:
			return 'BPS Curriculum';
		case 45:
			return 'BPS Curriculum';
		case 46:
			return 'Lower grade hungarian';
		case 47:
			return 'Emotional education';
		case 48:
			return 'Growth mindset';
		case 49:
			return 'Movement';
		case 50:
			return 'Natural sciences';
		case 51:
			return 'Full day absences';
		case 52:
			return 'Downloading attendance data failed';
		case 53:
			return 'Full day attendance';
		case 54:
			return 'Remove the checkmark from the students who were absent all day. If you see a checkmark next to a students name it means that they are marked present at some (not necessairly all) classes of the day.';
		case 55:
			return 'Downloading feedback data failed';
		case 56:
			return 'YYYY-MM-DD';
		case 57:
			return 'Date expected in format: YYYY-MM-DD';
		case 58:
			return 'Phone number expected in format: +36301234567';
		case 59:
			return 'Invalid URL address';
		case 60:
			var mime = str.a;
			return 'Not supported file format: ' + mime;
		case 61:
			return 'Time expected in 24-hour format: HH:MM';
		case 62:
			var size = str.a;
			return 'The file is too big (' + ($elm$core$String$fromInt((((size / 1024) | 0) / 1024) | 0) + 'MB)');
		case 63:
			return 'The end date can not be earlier than the start date!';
		case 64:
			return 'No options found';
		case 65:
			return 'An error occured while uploading the document';
		case 66:
			return 'Not selected';
		case 67:
			return ' – optional';
		case 68:
			return 'For choosing multiple items, press and hold down the <kbd>Ctrl</kbd> (Windows/Linux) or <kbd>Cmd</kbd> (Mac) key while you\'re selecting them with a mouse click.';
		case 69:
			return 'You did not upload document!';
		case 70:
			return 'Cannot be blank!';
		case 71:
			return 'Please enter a valid email address!';
		case 72:
			return 'Please, write a bit more!';
		case 73:
			return 'Please select an option!';
		case 74:
			return 'An error occured while saving data';
		case 75:
			return 'Select all';
		case 76:
			return 'Select none';
		case 77:
			return 'HH:MM';
		case 78:
			return 'My BPS';
		case 79:
			return 'Closed modules';
		case 80:
			return 'Downloading grade reports failed';
		case 84:
			return 'Downloading the grade reports, please wait...';
		case 85:
			return 'There are no available grade reports for the child';
		case 81:
			return 'Grade report as PDF';
		case 82:
			return 'Feedback report as PDF';
		case 83:
			return 'excempted';
		case 86:
			return 'Subject';
		case 87:
			return 'Text Appraisal';
		case 88:
			return 'We would like to reduce the significance of the grades in the everyday school life. Therefore the end of year grade reports aren\'t automatically sent out as from the school year 21/22. As a parent, if you want to access it, you need to request this document by <a href=\"https://forms.gle/JSnaSzAmgNRttLNw7\" target=\"_blank\">filling out this form</a>.';
		case 89:
			return 'Grade reports';
		case 90:
			return 'Click here if you want to browse feedbacks by subjects.';
		case 91:
			var startYear = str.a;
			var endYear = str.b;
			return $elm$core$String$fromInt(startYear) + ('/' + ($elm$core$String$fromInt(endYear) + ' mid year'));
		case 92:
			var startYear = str.a;
			var endYear = str.b;
			return $elm$core$String$fromInt(startYear) + ('/' + ($elm$core$String$fromInt(endYear) + ' end of year'));
		case 93:
			var startYear = str.a;
			var endYear = str.b;
			return $elm$core$String$fromInt(startYear) + ('/' + ($elm$core$String$fromInt(endYear) + ' grading exam'));
		case 94:
			return 'Mid year report';
		case 95:
			return 'End of year report';
		case 96:
			return 'Grading exam report';
		case 113:
			return 'School';
		case 100:
			return 'Request grades';
		case 101:
			return 'Grade request form';
		case 97:
			return 'You can only request grades during the grading period.';
		case 98:
			return 'Subject grades';
		case 114:
			return 'Parents:';
		case 115:
			return 'You can find the contacts of the teachers and parents in the phonebook.';
		case 116:
			return 'Phonebook';
		case 117:
			return 'Here you find your children and their most important documents in one place.';
		case 118:
			return 'Children';
		case 119:
			return 'Profile';
		case 120:
			return 'Active';
		case 121:
			return 'Inactive';
		case 122:
			return 'You did not upload justifying document!';
		case 123:
			return 'We store the justifying document in accordance with by-law.';
		case 124:
			return 'Downloading learning assessments failed';
		case 125:
			return 'End date';
		case 126:
			return 'Start date';
		case 128:
			return 'Document link';
		case 127:
			return 'Child';
		case 129:
			return 'Downloading learning contracts failed';
		case 130:
			var zone = str.a;
			var start = str.b;
			var end = str.c;
			return A3($author$project$Locale$English$termFormatter, zone, start, end);
		case 131:
			var name = str.a;
			return name + '\'s learning contract';
		case 133:
			return 'There are no learning contracts uploaded. If you think something is missing, please contact the mentor of your child.';
		case 134:
			return 'You haven\'t uploaded learning contracts yet. Go ahead, and add one.';
		case 135:
			return 'The learning contract you were looking for is not found. Maybe it was deleted, you don\'t have permission to it or it never existed.';
		case 132:
			return 'Downloading learning contacts, please wait...';
		case 136:
			return 'Learning contract was successfully saved.';
		case 137:
			return 'Edit learning contract';
		case 138:
			return 'Add new learning contract';
		case 139:
			return 'Learning contracts';
		case 140:
			return 'Search learning contracts...';
		case 141:
			return 'No learning contracts found.';
		case 142:
			return 'Own group';
		case 143:
			return 'School group';
		case 144:
			return 'An error occured while deleting the learning group';
		case 145:
			return 'Learning group was successfully deleted.';
		case 146:
			return 'Loading groups failed';
		case 147:
			return 'There are no students in this group.';
		case 148:
			return 'Share';
		case 149:
			return 'Group name';
		case 150:
			return 'School selection';
		case 151:
			return 'Children selection';
		case 152:
			return 'Edit learning group';
		case 153:
			return 'Add new learning group';
		case 154:
			return 'List groups';
		case 155:
			return 'All groups';
		case 156:
			return 'No groups found.';
		case 157:
			return 'Downloading groups, please wait...';
		case 158:
			return 'Own groups';
		case 159:
			return 'School groups';
		case 160:
			return 'Search by group name and among members';
		case 161:
			return 'Groups';
		case 162:
			return 'An error occured while saving the learning group';
		case 163:
			return 'Learning group was successfully saved.';
		case 164:
			return 'Groups';
		case 165:
			return 'Select the group from the dropdown list to add its members to the participants of your module.';
		case 166:
			return 'Add groups to module';
		case 167:
			return 'Groups';
		case 168:
			return 'Loading My BPS, hold on...';
		case 169:
			return 'Login to My BPS';
		case 170:
			return 'MyBPS is only available to BPS children, parents and teachers.';
		case 171:
			return 'Logging out...';
		case 172:
			var name = str.a;
			var grade = str.b;
			return name + (' (' + (grade + ' grader)'));
		case 173:
			return 'Subject';
		case 174:
			return 'Sorry, something went wrong';
		case 175:
			return 'Login failed:';
		case 176:
			return 'Logout failed:';
		case 177:
			var url = str.a;
			return 'The page you requested at ' + (url + ' was not found.');
		case 178:
			return 'Error 404';
		case 179:
			return 'Dowloading your profile failed:';
		case 180:
			return 'Try again the last action you performed, often it\'s a temporary issue. We automatically got notified of the issue. If the problem persists, please contact us at <a href=\"mailto:tech@budapestschool.org\">tech@budapestschool.org</a> and we\'ll look into the issue.';
		case 181:
			return 'Good news, a more recent version of the app is available.';
		case 183:
			return 'Reload the app for the updates.';
		case 184:
			return 'Module closing feedback';
		case 185:
			return 'Upon completing each module, based on the goals, topic, focus of the module, the children recieve feedback about their learning process, products, results, development and behaviours.';
		case 186:
			return 'This module doesn\'t have rubrics yet.';
		case 187:
			return 'Whom will you give feedback to?';
		case 188:
			return 'An error occured while saving the feedback';
		case 189:
			return 'Feedback was successfully saved.';
		case 190:
			return 'Too many students in module closure feedback.';
		case 191:
			return 'Module closure overview (3rd trimester)';
		case 192:
			return 'Loading module closures, please wait...';
		case 193:
			return 'Module closure overview';
		case 194:
			return 'Student';
		case 195:
			return 'Module';
		case 196:
			return 'Module closed?';
		case 197:
			return 'School';
		case 198:
			return 'Only mentees';
		case 199:
			return 'Type';
		case 200:
			return 'Module';
		case 201:
			return 'Title';
		case 202:
			return 'Notes';
		case 203:
			return 'Frequency';
		case 204:
			return 'On specific days';
		case 205:
			return 'Starts at';
		case 206:
			return 'Finishes at';
		case 207:
			return 'On this day';
		case 208:
			return 'Last occasion';
		case 209:
			return 'Last occasion';
		case 210:
			return 'Downloading module events failed';
		case 211:
			var title = str.a.kj;
			var frequency = str.a.V;
			var interval = str.a.jg;
			var weekdays = str.a.N;
			var isRecurring = str.a.md;
			var startTime = str.a.R;
			var endTime = str.a.G;
			var startDate = str.a.nN;
			var endDate = str.a.ly;
			return isRecurring ? (title + (': ' + (('between ' + (startDate + (' and ' + (endDate + ' ')))) + (A2($author$project$Locale$English$formatRecurring, frequency, interval) + ($author$project$Locale$English$formatDays(weekdays) + (' ' + (startTime + (' - ' + endTime)))))))) : (title + (': ' + (startDate + (', ' + ('between ' + (startTime + (' - ' + endTime)))))));
		case 212:
			return 'Nem magyar állampolgár esetén a Magyarország területén való tartózkodás jogcíme és a tartózkodásra jogosító okirat megnevezése, száma';
		case 213:
			return 'Tartózkodási hely';
		case 214:
			return 'Végzettségével, szakképzettségével kapcsolatos adatok';
		case 215:
			return 'Downloading module teacher profile failed';
		case 216:
			return 'Module teacher profile data was successfully saved.';
		case 217:
			return 'Module teacher profile';
		case 218:
			return 'Loading module teacher profile, please wait...';
		case 219:
			return 'The module teacher profile you were looking for is not found. Maybe it was deleted, you don\'t have permission to it or it never existed.';
		case 220:
			var name = str.a;
			return 'Module leader: ' + name;
		case 221:
			return 'Delete module';
		case 222:
			return 'Module final assessment';
		case 223:
			return 'Create copy';
		case 224:
			return 'Create and add module event';
		case 225:
			return 'Create new module from this';
		case 226:
			return 'Save as template';
		case 227:
			return 'New module event';
		case 228:
			return 'New portfolio story';
		case 229:
			var title = str.a;
			return 'Copy of ' + title;
		case 230:
			return 'The module belongs to a closed term.';
		case 231:
			return 'The module belongs to a closed term and cannot be edited any more.';
		case 232:
			return 'Module closing feedback';
		case 233:
			var title = str.a;
			return 'If you delete the module <b> ' + (title + '</b>, all related module events will be removed too. OK?');
		case 234:
			return 'Downloading modules failed';
		case 235:
			return 'Module leader';
		case 236:
			return 'Google Classroom course';
		case 237:
			return 'Objective of the module';
		case 238:
			return 'In this module, we will learn about…\nKey activities you can expect are…\nWith the knowledge gained…\n';
		case 239:
			return 'Related module materials (URL)';
		case 240:
			return 'Is module migratable to e-Kreta?';
		case 241:
			return 'No';
		case 242:
			return 'Yes';
		case 243:
			return 'Evaluation';
		case 244:
			return 'Goals the children will reach by the end of the module';
		case 245:
			return 'What are they gonna learn?';
		case 246:
			return 'By the end of the module, you will learn/understand/explore…';
		case 247:
			return 'What skills are they gonna develop?';
		case 248:
			return 'By the end of the module, you can/will develop…';
		case 249:
			return 'What are they gonna achieve?';
		case 250:
			return 'By the end of the module, you will create/make/figure out/plan out…';
		case 251:
			return 'Children';
		case 252:
			return 'Teachers';
		case 253:
			return 'School';
		case 254:
			return 'Title';
		case 256:
			return 'End date';
		case 255:
			return 'Start date';
		case 257:
			return 'Grades';
		case 258:
			return 'Teachers';
		case 259:
			return 'Schools';
		case 260:
			return 'Subjects';
		case 261:
			return 'Enabled filters:';
		case 262:
			return 'All schools';
		case 263:
			return 'Own school';
		case 264:
			return 'Own modules';
		case 265:
			return 'Templates';
		case 266:
			return 'Help on module creation';
		case 270:
			return 'The module you were looking for is not found. Maybe it was deleted, you don\'t have permission to it or it never existed.';
		case 267:
			return 'Downloading modules, please wait...';
		case 268:
			return 'Load more modules';
		case 269:
			return 'No modules found.';
		case 271:
			return 'An error occured while deleting the module';
		case 272:
			return 'Module was successfully deleted.';
		case 273:
			return 'Ready for migration';
		case 274:
			return 'No rubrics assigned yet';
		case 275:
			return 'No children assigned yet';
		case 276:
			return 'Module events';
		case 277:
			return 'Module was successfully saved.';
		case 278:
			return 'Search in module titles and descriptions';
		case 279:
			return 'Group selection';
		case 280:
			var zone = str.a;
			var start = str.b;
			var end = str.c;
			return A3($author$project$Locale$English$termFormatter, zone, start, end);
		case 281:
			return 'Edit module';
		case 282:
			return 'Create new module';
		case 283:
			return 'Create module from template';
		case 284:
			return 'Modules';
		case 285:
			return 'Rubrics';
		case 286:
			return 'Add new rubric';
		case 287:
			return 'Change the set of rubrics';
		case 288:
			return 'Change amounts';
		case 99:
			return 'If your child needs their teachers to convert their text appraisala into grades, please check the box next to the subject and click the \'Request grades\' button. Please request grades only for the subjects your child currently needs for any specific reason.';
		case 102:
			return 'Grade status';
		case 103:
			return 'There are no available grade reports based on which you can request a grade.';
		case 104:
			return 'There are no subjects available for requesting grades from.';
		case 105:
			return 'Not requested';
		case 106:
			return 'An error occured while requesting grades.';
		case 107:
			return 'Grades were requested successfully.';
		case 108:
			return 'Subject';
		case 109:
			return 'Grading in progress';
		case 110:
			return 'Justification';
		case 111:
			return 'Explain why you want to request a grade';
		case 112:
			return 'Waived';
		case 289:
			return 'Justify absences';
		case 290:
			return 'Justification of absences has been improved and moved to my.BPS. Look for the helicopter icon to browse and justify your child\'s absences.';
		case 291:
			return 'Learning contracts';
		case 292:
			return 'Switch to English';
		case 293:
			return 'Átváltás magyarra';
		case 294:
			return 'Report harassment';
		case 295:
			return 'Log out';
		case 296:
			return 'Module closure overview';
		case 297:
			return 'Modules';
		case 298:
			return 'List modules';
		case 299:
			return 'Add new module';
		case 300:
			return 'Notifications';
		case 301:
			return 'Phonebook';
		case 302:
			return 'Portolios';
		case 303:
			return 'List stories';
		case 304:
			return 'Add new story';
		case 305:
			return 'Profile';
		case 306:
			return 'Rubric feedbacks overview';
		case 307:
			return 'Children';
		case 308:
			return 'List children';
		case 309:
			return 'Timetable';
		case 310:
			return 'Notifications';
		case 311:
			return 'Email';
		case 312:
			return 'Name prefix';
		case 313:
			return 'First Name';
		case 314:
			var first = str.a;
			var last = str.b;
			return first + (' ' + last);
		case 316:
			return 'Last Name';
		case 315:
			return 'Name has family name first';
		case 317:
			return 'Mentor';
		case 318:
			return 'Phone Number';
		case 334:
			return 'Site';
		case 319:
			return 'School';
		case 320:
			return 'Permanent address';
		case 321:
			return 'Country';
		case 322:
			return 'Postcode';
		case 323:
			return 'City/Town';
		case 324:
			return 'Street name';
		case 325:
			return 'Street type';
		case 326:
			return 'Street number';
		case 327:
			return 'Floor, door';
		case 328:
			return 'Birthplace, town';
		case 329:
			return 'Birthplace, country';
		case 330:
			return 'Birthdate';
		case 331:
			return 'Nationality';
		case 332:
			return 'SSN';
		case 333:
			return 'Education ID';
		case 335:
			return 'Educational ID has to be 11 digits';
		case 336:
			return 'Social security number has to be 9 digits';
		case 337:
			return 'Loading the phonebook failed';
		case 338:
			return 'Everyone';
		case 339:
			return 'Parents';
		case 340:
			return 'Teachers';
		case 341:
			return 'Downloading your contacts, please wait...';
		case 342:
			return 'Search';
		case 343:
			return 'Phonebook';
		case 344:
			return 'Give feedback';
		case 345:
			return 'Google Classroom';
		case 346:
			return 'Mark as module closing';
		case 347:
			return 'The portfolio story belongs to a closed term.';
		case 348:
			return 'The portfolio story belongs to a closed term and cannot be edited any more.';
		case 349:
			return 'Help on portfolio story creation';
		case 350:
			return 'What happened?';
		case 351:
			return 'Photo/Video';
		case 352:
			return 'Related module';
		case 353:
			return 'Uploaded by';
		case 354:
			return 'Happened at';
		case 355:
			return 'School';
		case 356:
			return 'Participating children';
		case 357:
			return 'Loading portfolios failed';
		case 358:
			return 'Loading teachers and children for portfolios failed';
		case 359:
			return 'Enabled filters:';
		case 360:
			return 'All';
		case 361:
			return 'My children';
		case 362:
			return 'School';
		case 363:
			return 'Own stories';
		case 364:
			return 'Google Classroom';
		case 365:
			return 'Modules';
		case 366:
			return 'Own modules';
		case 367:
			return 'None';
		case 368:
			return 'Children';
		case 369:
			return 'Teachers';
		case 370:
			return 'Type';
		case 371:
			return 'All';
		case 372:
			return 'Only with feedback';
		case 373:
			return 'Only module closures';
		case 374:
			return 'Load more portfolio stories';
		case 375:
			var size = str.a;
			return 'Maximum file size is ' + ($elm$core$String$fromInt(size) + 'MB. Supported file formats are: JPEG, MP4, PDF, PNG, Quicktime');
		case 378:
			return 'Delete portfolio story';
		case 376:
			return 'Edit portfolio story';
		case 377:
			return 'Add new portfolio story';
		case 379:
			return 'Loading portfolio stories, please wait...';
		case 380:
			return 'If you remove the portfolio story, its content and attachments will no longer be available. Are you sure you want to remove it?';
		case 381:
			return 'An error occured while deleting the portfolio story.';
		case 382:
			return 'Portfolio story was successfuly deleted.';
		case 383:
			return 'No portfolio stories found.';
		case 384:
			return 'Portfolio story was successfully saved.';
		case 385:
			return 'An error occured while saving the portfolio story.';
		case 386:
			return 'Search in story descriptions and children';
		case 387:
			var creator = str.a;
			return creator + ' shared a story.';
		case 388:
			var creator = str.a;
			var students = str.b;
			var module_ = str.c;
			return creator + (' gave module closing feedback to ' + ($author$project$Locale$English$nameList(students) + (' of module ' + (module_ + '.'))));
		case 389:
			var names = str.a;
			return 'Participating children: ' + $author$project$Locale$English$nameList(names);
		case 390:
			return 'Portfolio stories';
		case 391:
			var email = str.a;
			return 'This is the picture that appears in the phonebook. Would you like to change it? Go to <a href=\"https://gravatar.com/\">gravatar.com</a> and upload a picture associated with the given email address(<b>' + (email + '</b>).');
		case 392:
			var name = str.a;
			return 'Edit contact data of ' + name;
		case 393:
			return 'Loading your profile, please wait...';
		case 394:
			return 'The profile you were looking for is not found. Maybe it was deleted, you don\'t have permission to it or it never existed.';
		case 395:
			return 'Loading profile data failed';
		case 396:
			return 'Profile data was successfully saved.';
		case 397:
			return 'Basic profile';
		case 398:
			return 'Select a rubric';
		case 399:
			var title = str.a;
			return 'Selected rubric: ' + title;
		case 400:
			return 'Give feedback';
		case 401:
			return 'Aspect';
		case 402:
			return 'Subject';
		case 403:
			return 'New rubric can not be created';
		case 404:
			return 'Rubric was successfully deleted.';
		case 405:
			return 'An error occured while deleting the rubric';
		case 406:
			return 'Rubric was successfully saved.';
		case 407:
			return 'An error occured while saving the rubric';
		case 408:
			return 'Private';
		case 409:
			return 'Create a new like this';
		case 410:
			return 'Shared with schools';
		case 411:
			return 'Loading the rubrics failed';
		case 412:
			return 'Rubric selection is not available for students changing age groups.';
		case 413:
			return 'No rubrics found.';
		case 414:
			return 'Own rubrics';
		case 415:
			return 'All shared';
		case 416:
			return 'Selected';
		case 420:
			return 'Loading rubrics, please wait...';
		case 417:
			return 'Edit rubric';
		case 418:
			return 'Help on rubric creation';
		case 419:
			return 'Please keep in mind that editing a rubric will not affect feedbacks given before the change - those will still contain the previous content of the rubric. Obviously if you give a feedback after the edit, that will contain the changes you have made.';
		case 421:
			return 'Search in the author, title and content of rubrics';
		case 422:
			return 'Rubrics';
		case 423:
			return 'Selecting a rubric';
		case 424:
			return 'There are no rubric feedbacks matching the filter criteria.';
		case 425:
			return 'There are no children in your school. If you believe this is a mistake, please contact us.';
		case 426:
			return 'Loading rubric feedbacks, please wait...';
		case 427:
			return 'Rubric feedbacks summary';
		case 428:
			return 'On this page you can see which student got how many rubric feedbacks from each subject. Please note that the data behind this page refreshes with a few minutes delay. Hence we ask you to not expect the numbers below to change instantly after you gave a feedback, but be patient. Thanks for your understanding.';
		case 429:
			return 'School';
		case 430:
			return 'Name';
		case 431:
			return 'Grade';
		case 432:
			return 'Subject';
		case 433:
			return 'Feedbacks in modules';
		case 434:
			return 'Feedbacks given in the first semester';
		case 435:
			return 'Feedbacks given in the school year';
		case 448:
			var zone = str.a;
			var startDate = str.b;
			var endDate = str.c;
			return A3($author$project$Locale$English$termFormatter, zone, startDate, endDate);
		case 449:
			return 'Downloading absence data failed';
		case 450:
			return 'Loading absence data, please wait...';
		case 451:
			return 'There are no absences registered. If you believe this is a mistake, please contact us.';
		case 452:
			var name = str.a;
			return 'Absences of ' + (name + ' in this school year');
		case 453:
			return 'unjustified';
		case 454:
			return 'justified by doctor';
		case 455:
			return 'justified by parent';
		case 456:
			return 'justified by mentor';
		case 457:
			return 'questioned';
		case 436:
			return 'Justify as doctor';
		case 437:
			return 'Justify as parent';
		case 438:
			return 'Justify as mentor';
		case 439:
			var name = str.a;
			var zone = str.b;
			var start = str.c;
			var end = str.d;
			return 'If you want to justify the absence on <b>' + (A3($author$project$Locale$English$termFormatter, zone, start, end) + ('</b> for <b>' + (name + '</b>, please provide a reason and upload the justifying document if needed.')));
		case 440:
			var name = str.a;
			var zone = str.b;
			var start = str.c;
			var end = str.d;
			return 'If you want to justify the absence on <b>' + (A3($author$project$Locale$English$termFormatter, zone, start, end) + ('</b> for <b>' + (name + '</b>, please provide a reason and upload the justifying document.')));
		case 441:
			return 'I think there\'s a mistake!';
		case 442:
			var zone = str.a;
			var start = str.b;
			var end = str.c;
			return 'If you think the teachers registered the absence at ' + (A3($author$project$Locale$English$termFormatter, zone, start, end) + ' erroneously, please tell us by clicking Ok. We will send an email to the mentor teacher and our tanügy team. They will contact you to resolve the issue.');
		case 443:
			return 'What happened?';
		case 444:
			return 'Justifying document';
		case 445:
			var size = str.a;
			return 'Maximum file size is ' + ($elm$core$String$fromInt(size) + 'MB. Supported file formats are: PDF, JPEG, PNG');
		case 447:
			return 'Failed to save justification :(';
		case 446:
			return 'Student absence justification was successfully saved :)';
		case 458:
			var name = str.a;
			return 'Mentor: ' + name;
		case 459:
			return 'Missing mentor!';
		case 463:
			return 'Load more children';
		case 460:
			return 'No students found.';
		case 461:
			return 'The student you were looking for is not found. Maybe they were deleted, you don\'t have permission to view them or they never existed.';
		case 462:
			var names = str.a;
			return 'Parents: ' + $author$project$Locale$English$nameList(names);
		case 464:
			return 'általános iskolai nevelés-oktatás';
		case 465:
			return 'gimnáziumi nevelés-oktatás';
		case 466:
			return 'szakiskolai nevelés-oktatás';
		case 471:
			return 'English';
		case 472:
			return 'German';
		case 473:
			return 'French';
		case 474:
			return 'Spanish';
		case 475:
			return 'Italian';
		case 467:
			return 'BTMN';
		case 468:
			return 'SNI1';
		case 469:
			return 'SNI2';
		case 470:
			return 'none';
		case 476:
			return 'NEK ID is 16-character long';
		case 477:
			return 'kindergarten 1st grade';
		case 478:
			return 'kindergarten 2nd grade';
		case 479:
			return 'kindergarten 3rd grade';
		case 480:
			return '1st grade';
		case 481:
			return '2nd grade';
		case 482:
			return '3rd grade';
		case 483:
			return '4th grade';
		case 484:
			return '5th grade';
		case 485:
			return '6th grade';
		case 486:
			return '7th grade';
		case 487:
			return '8th grade';
		case 488:
			return '9th grade';
		case 489:
			return '10th grade';
		case 490:
			return '11th grade';
		case 491:
			return '12th grade';
		case 492:
			return 'status';
		case 493:
			return 'Address card; in case of foreigners, residence permit (document)';
		case 494:
			return 'Felvételi mikor volt, milyen eredménnyel';
		case 495:
			return 'Mother\'s maiden name';
		case 496:
			return 'Köznevelési alapfeladat, amelyre a jogviszony irányul';
		case 497:
			return 'Jogviszony szünetelésének dátuma, oka';
		case 498:
			return 'Igazolt/igazolatlan órák száma';
		case 499:
			return 'Iskolai gyerekbaleset dátuma, leírása';
		case 500:
			return 'Kompetenciatesztek eredményei, mérési azonosító';
		case 501:
			return 'Report card from last finished school year (document)';
		case 502:
			return 'Szorgalom, magatartás, tudás minősítés (dokumentum)';
		case 503:
			return 'Vizsgaadatok (dátum, eredmény, vizsgáztató tanár)';
		case 504:
			return 'Fegyelmi és kártérítési ügyekkel kapcsolatos adatok: ügy száma, rövid leírása (indulásának oka, megoldásának, befejezésének formája, tartalma)';
		case 505:
			return 'Diákigazolvány sorszáma';
		case 506:
			return 'Tankönyvellátás';
		case 507:
			return 'Évfolyamismétlés';
		case 508:
			return 'Határon túli kirándulás';
		case 509:
			return 'Special status';
		case 510:
			return '<b>SNI1:</b> Enyhe értelmi fogyatékos, beszédfogyatékos vagy pszichés fejlődési zavarral küzdő sajátos nevelési igényű gyermek.<br/><b>SNI2:</b> Mozgásszervi, érzékszervi, középsúlyos értelmi fogyatékos, autizmus spektrum zavarral küzdő vagy halmozottan fogyatékos gyermek.<br/><b>BTMN:</b> Szakértői vélemény alapján beilleszkedési, tanulási, és magatartási nehézséggel küzdő gyerek.';
		case 511:
			return 'Expert report (document)';
		case 512:
			return 'Egyéni munkarend';
		case 513:
			return 'Egyéni munkarendre vonatkozó adatok (dokumentum)';
		case 514:
			return 'Hányadik osztályba kerül';
		case 515:
			return 'First foreign language';
		case 516:
			return 'Second foreign language';
		case 517:
			return 'Student card (document)';
		case 518:
			return 'Birth certificate (document)';
		case 519:
			return 'ID card or passport (document)';
		case 520:
			return ' - required if the child goes to school';
		case 521:
			return 'Tax ID (document)';
		case 522:
			return 'Social security ID (document)';
		case 523:
			return 'NEK id';
		case 524:
			return 'NEK id (document)';
		case 525:
			var count = str.a;
			return (count === 1) ? 'Legal representative' : 'Legal representatives';
		case 526:
			return 'New file…';
		case 527:
			return 'View';
		case 528:
			return 'File uploaded — ';
		case 529:
			return 'Maximum file size is 10MB. Supported file formats are: PDF, JPG, PNG';
		case 530:
			return 'Student card ID has to be 10 digits';
		case 531:
			return 'Downloading child profile failed';
		case 532:
			return 'An error occured while downloading the document';
		case 533:
			return 'Student profile data was successfully saved.';
		case 534:
			return 'Student profile';
		case 535:
			var name = str.a;
			return 'Student profile of ' + name;
		case 536:
			return 'Parents need to fill it out';
		case 537:
			return 'School needs to fill it out';
		case 538:
			return 'Loading child profile, please wait...';
		case 539:
			return 'The profile you were looking for is not found. Maybe it was deleted, you don\'t have permission to it or it never existed.';
		case 540:
			return 'Downloading the child list failed';
		case 541:
			return 'Everyone';
		case 542:
			return 'My mentees';
		case 543:
			return 'Downloading the child list, please wait...';
		case 544:
			return 'Children';
		case 545:
			return 'Add learning contract...';
		case 546:
			return 'Learning contract';
		case 548:
			return 'Pay by company';
		case 547:
			return 'Company contract';
		case 549:
			return 'Profile';
		case 550:
			return 'Grade reports';
		case 551:
			return 'Absences';
		case 552:
			return 'Timetable';
		case 553:
			return 'Trimester feedbacks';
		case 554:
			return 'Subject feedbacks';
		case 555:
			return 'Search in student names';
		case 565:
			return 'Loading subject feedbacks, please wait...';
		case 564:
			return 'Downloading subject feedbacks failed';
		case 556:
			return 'All subjects';
		case 557:
			var studentName = str.a;
			var studentGrade = str.b;
			var subjectName = str.c;
			return 'Feedbacks for ' + (studentName + (' (' + (studentGrade + (') on ' + A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (s) {
						return 'subject ' + s;
					},
					subjectName))))));
		case 558:
			return 'On this page you see the rubric lines given for the selected student on the selected subject, ordered by creation time. ' + 'You can navigate to the original feedbacks by clicking on the timestamps.';
		case 559:
			return 'Subject feedbacks';
		case 560:
			return 'Subject';
		case 561:
			return 'Kind';
		case 563:
			return 'Mid year only';
		case 562:
			return 'Everything';
		case 569:
			return 'Downloading subjects failed';
		case 568:
			return 'Downloading subjects';
		case 566:
			var startYear = str.a;
			var endYear = str.b;
			return $elm$core$String$fromInt(startYear) + ('/' + ($elm$core$String$fromInt(endYear) + ' school year'));
		case 567:
			return 'There are no available grade reports based on which you can request a grade.';
		case 570:
			return 'Switch user';
		case 571:
			return 'Why do you need to switch user? This message will be recorded.';
		case 572:
			var name = str.a;
			return 'Switch user attempt was successful. Welcome, ' + (name + '!');
		case 573:
			return 'Switch user';
		case 574:
			return 'State';
		case 575:
			return 'Teacher';
		case 576:
			return 'Birth first name';
		case 577:
			return 'Birth last name';
		case 578:
			return 'Birth name has family name first';
		case 579:
			return 'Mother\'s name prefix';
		case 580:
			return 'Mother\'s first name';
		case 581:
			return 'Mother\'s last name';
		case 582:
			return 'Mother\'s name has family name first';
		case 583:
			return 'Highest level of education';
		case 584:
			return 'Number of years in apprenticeship';
		case 585:
			return 'Is member of academy?';
		case 586:
			return 'Diploma (document)';
		case 587:
			return 'University';
		case 588:
			return 'College';
		case 589:
			return 'Secondary school';
		case 590:
			return 'Birth data';
		case 591:
			return 'Contact details';
		case 592:
			return 'Professional details';
		case 593:
			return 'Downloading teacher profile failed';
		case 594:
			return 'Maximum file size is 10MB. Supported file formats are: PDF, JPG, PNG';
		case 595:
			return 'Teacher profile data was successfully saved.';
		case 596:
			return 'Teacher profile';
		case 597:
			var name = str.a;
			return 'Teacher profile of ' + name;
		case 598:
			return 'Loading teacher profile, please wait...';
		case 599:
			return 'The profile you were looking for is not found. Maybe it was deleted, you don\'t have permission to it or it never existed.';
		case 600:
			return 'Downloading schools failed';
		case 601:
			var zone = str.a;
			var time = str.b;
			return A2($author$project$Locale$English$dateFormatter, zone, time);
		case 602:
			var zone = str.a;
			var time = str.b;
			return A2($author$project$Locale$English$dateTimeFormatter, zone, time);
		case 603:
			var zone = str.a;
			var time = str.b;
			return A2($author$project$Locale$English$timeFormatter, zone, time);
		case 604:
			var zone = str.a;
			var time1 = str.b;
			var time2 = str.c;
			return A2($author$project$Locale$English$dateFormatter, zone, time1) + (', ' + (A2($author$project$Locale$English$timeFormatter, zone, time1) + ('-' + A2($author$project$Locale$English$timeFormatter, zone, time2))));
		case 605:
			return 'Weekly';
		case 606:
			return 'Biweekly';
		case 607:
			return 'Happens once';
		case 608:
			var day = str.a;
			return $ryan_haskell$date_format$DateFormat$Language$english.oa(day);
		case 609:
			return 'Downloading the timetable failed';
		case 610:
			return 'Add new module event';
		case 611:
			return 'Edit module event';
		case 612:
			return 'Google Meet';
		case 613:
			return 'Attendance sheet';
		case 614:
			return 'Edit module event';
		case 615:
			return 'Delete module event';
		case 616:
			return 'Delete all occasions';
		case 617:
			return 'Delete this occasion';
		case 618:
			return 'Delete this and following occasions';
		case 619:
			return 'This and following occasions';
		case 620:
			return 'All occasions';
		case 621:
			return 'Timetables of teachers';
		case 622:
			return 'Timetables of children';
		case 623:
			return 'Loading timetable...';
		case 624:
			return 'Timetable';
		case 626:
			return 'An error occured while saving the module event';
		case 625:
			return 'Module event changes were successfully saved.';
		case 627:
			return 'Participants';
		case 628:
			return 'Absents';
		case 629:
			return 'Which occasions would you like to change?';
		case 630:
			return '<ul>' + ('<li><mark>Attendance information is tracked for each module events.</mark> If you reschedule past occasions, their attendance sheets will be lost.</li>' + ('<li>We only synchronize future occasions to Google Calendar.</li>' + '</ul>'));
		case 631:
			return '<p><mark>Attendance information is tracked for each module events.</mark>' + ('If you delete events of a module that was already started, the attendance sheets will be lost too.</p>' + '<p>If you want to finish a module sooner, only remove the future occasions.</p>');
		case 632:
			return '<p><mark>Attendance information is tracked for each module events.</mark>' + 'If you delete events of a module that was already started, the attendance sheets will be lost too.</p>';
		case 633:
			return 'Module event was successfuly deleted.';
		case 634:
			return 'An error occured while deleting the module event';
		case 635:
			return 'Timetable changes were successfully saved.';
		case 636:
			return 'The selected module event occasion was successfully canceled.';
		case 637:
			var title = str.a;
			var zone = str.b;
			var start = str.c;
			var end = str.d;
			return title + (' (' + (A3($author$project$Locale$English$termFormatter, zone, start, end) + ')'));
		case 638:
			var name = str.a;
			return 'Module: ' + name;
		case 639:
			var creator = str.a;
			var student = str.b;
			return creator + (' gave trimester closure feedback to ' + student);
		case 640:
			return 'Downloading the trimester failed';
		case 641:
			var name = str.a;
			return 'Dear ' + (name + '! About the past, trimester I would like to tell you that…');
		case 642:
			return 'Trimester closing feedback';
		case 643:
			var name = str.a.fb;
			var startYear = str.a.eB;
			var endYear = str.a.d3;
			var trimester = str.a.kp;
			return $elm$core$String$concat(
				_List_fromArray(
					[
						'To ',
						name,
						', ',
						$elm$core$String$fromInt(startYear),
						'/',
						$elm$core$String$fromInt(endYear),
						'. school year ',
						$elm$core$String$fromInt(trimester),
						'. trimester'
					]));
		case 644:
			return 'Select a rubric…';
		case 645:
			return 'Trimester closing feedback was succesfully saved.';
		case 646:
			return 'An error occured while saving the trimester closing feedback';
		case 647:
			return 'Please evaluate the aspects!';
		case 648:
			return 'Add trimester closing feedback';
		case 649:
			return 'Trimester feedback';
		case 650:
			return 'Trimester feedback';
		case 651:
			return 'Loading trimester feedback...';
		case 652:
			return 'The trimester feedback you were looking for is not found. Maybe it was deleted, you don\'t have permission to it or it never existed.';
		case 653:
			return 'Downloading the trimester feedback failed';
		case 654:
			var studentName = str.a;
			return studentName + ' hasn\'t recieved trimester closing feedback, yet. ';
		case 655:
			var studentName = str.a;
			return studentName + ' hasn\'t recieved any module closing feedback, yet.';
		case 656:
			return 'Give them feedback about their progress in the trimester!';
		case 657:
			return 'Past years';
		case 658:
			return '1st trimester';
		case 659:
			return '2nd trimester';
		case 660:
			return '3rd trimester';
		case 661:
			return 'Trimester feedback was successfuly deleted.';
		case 662:
			var schoolYear = str.a;
			var trimester = str.b;
			return 'Download feedback for ' + ($elm$core$String$fromInt(trimester) + (' trimester of school year ' + $elm$core$String$fromInt(schoolYear)));
		case 663:
			return 'An error occured while deleting the trimester feedback';
		case 664:
			return 'Settings saved.';
		case 665:
			return 'An error occured while saving the settings';
		case 666:
			return 'Crunching the contract template, please wait...';
		case 667:
			return 'Grading';
		case 668:
			var teamName = str.a;
			return teamName;
		case 669:
			return 'Current period';
		case 670:
			return 'Late requests';
		case 671:
			return 'Graduates';
		case 672:
			var dueDate = str.a;
			return 'Due date: ' + dueDate;
		case 694:
			return 'Assessment type';
		case 699:
			return 'only incomplete rows';
		case 673:
			return 'Grading';
		case 674:
			return 'mid-year';
		case 675:
			return 'end-of-year';
		case 676:
			return 'offering';
		case 677:
			return 'finalization';
		case 678:
			return 'late';
		case 679:
			return 'There are no late mark requests.';
		case 680:
			return 'Needs grading';
		case 681:
			return 'Everything';
		case 682:
			return 'Loading grading data, please wait...';
		case 683:
			return 'Loading grading data failed';
		case 684:
			return 'Text appraisal';
		case 685:
			return 'Mark';
		case 686:
			return 'Student\'s name';
		case 687:
			return 'Grade';
		case 688:
			return 'Subject';
		case 689:
			return 'Responsible teacher';
		case 690:
			return 'Progressing';
		case 691:
			return 'Not yet';
		case 692:
			return 'Offered';
		case 693:
			return 'Final';
		case 695:
			return 'waived';
		case 696:
			return 'not requested';
		case 697:
			return 'Save changes';
		case 698:
			return 'Consents';
		case 700:
			var grade = str.a;
			return grade + '. grade';
		case 701:
			return 'You can\'t edit this mark right now.';
		case 702:
			return 'Loading consents, please wait...';
		case 703:
			return 'I have checked the grades and I give consent';
		case 704:
			return 'I give consent';
		case 705:
			return 'I refuse';
		case 706:
			return 'Teacher';
		case 707:
			return 'Consent given';
		case 708:
			return 'Failed to load consents';
		case 709:
			return 'Consents';
		case 710:
			return 'You successfully updated your consent.';
		case 711:
			return 'All incomplete assessments must be filled out before giving consent';
		case 712:
			return 'requested late';
		case 713:
			return 'Grades were successfully saved.';
		case 714:
			return 'An error occured while saving the grades.';
		case 715:
			return 'Due date';
		case 717:
			var endDate = str.a;
			return 'The table is locked right now. Come back at ' + (endDate + '.');
		case 182:
			return 'Loading';
		case 718:
			return 'locked';
		case 719:
			return 'Reconciliation';
		default:
			return 'You don\'t have access to this page.';
	}
};
var $author$project$Locale$english = {k8: 'en', l4: $author$project$Locale$English$isFirstNameFirst, h6: $author$project$Locale$English$translator};
var $author$project$Locale$fromCode = function (langCode) {
	switch (langCode) {
		case 'hu':
			return $elm$core$Maybe$Just($author$project$Locale$hungarian);
		case 'en':
			return $elm$core$Maybe$Just($author$project$Locale$english);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Locale$languageDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Unknown language code: ' + s),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$Locale$fromCode(s)));
	},
	$elm$json$Json$Decode$string);
var $author$project$UserSettings$userSettingsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'language',
	$author$project$Locale$languageDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$UserSettings$UserSettings)));
var $author$project$Person$personDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'access_roles',
	$author$project$Person$accessRolesDecoder,
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'state',
		$author$project$Person$membershipStateDecoder,
		1,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'settings',
			$author$project$UserSettings$userSettingsDecoder,
			$author$project$UserSettings$default,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'related_people',
				$author$project$Person$nestedPeopleDecoder,
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'sponsor_of',
					$author$project$Person$nestedPeopleDecoder,
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'mentees',
						$author$project$Person$nestedPeopleDecoder,
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'roles',
							$author$project$Person$rolesDecoder,
							$author$project$Person$emptyRoles,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'birthplace',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'birthplace_country',
									$elm$json$Json$Decode$string,
									'',
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'birthdate',
										$elm$json$Json$Decode$string,
										'',
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'temporary_address',
											$elm$json$Json$Decode$nullable($author$project$Person$addressDecoder),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'permanent_address',
												$elm$json$Json$Decode$nullable($author$project$Person$addressDecoder),
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'email',
													$elm$json$Json$Decode$string,
													'',
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'phone_number',
														$elm$json$Json$Decode$string,
														'',
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'last_name',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'first_name',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'id',
																	$elm$json$Json$Decode$int,
																	$elm$json$Json$Decode$succeed($author$project$Person$Person))))))))))))))))));
var $author$project$Person$fetchViewer = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$me(config),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$Person$personDecoder));
	});
var $author$project$Log$LogEventName = $elm$core$Basics$identity;
var $author$project$Log$msgLogin = 'login';
var $author$project$Log$InfoLevel = 1;
var $author$project$Log$ok = F3(
	function (config, _v0, toMsg) {
		var eventName = _v0.a;
		var messages = _v0.b;
		var event = {
			iJ: config.gX.hD,
			c$: config.g0,
			cn: eventName,
			di: 1,
			cz: A2($elm$core$String$join, $author$project$Log$msgSeperator, messages)
		};
		return A3($author$project$Log$log, config, event, toMsg);
	});
var $author$project$Log$paramOk = 'ok';
var $author$project$Main$fetchViewer = function (model) {
	var sharedConfig = model.bG;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				a0: $author$project$Main$Authenticated($author$project$Main$BackendLoggedIn)
			}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3(
					$author$project$Log$ok,
					sharedConfig,
					_Utils_Tuple2(
						$author$project$Log$msgLogin,
						_List_fromArray(
							[$author$project$Log$paramOk])),
					$elm$core$Basics$always($author$project$Main$NoOp)),
					A2($author$project$Person$fetchViewer, sharedConfig.gX, $author$project$Main$ViewerDownloaded)
				])));
};
var $author$project$Pages$isPageLoaded = function (model) {
	return !_Utils_eq(model, $author$project$Pages$notLoaded);
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$Api$Endpoint$logout = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'logout']),
		_List_Nil);
};
var $author$project$Api$logout = F2(
	function (config, callback) {
		return A5(
			$author$project$Api$post,
			$author$project$Api$Endpoint$logout(config),
			config,
			$elm$http$Http$emptyBody,
			callback,
			$elm$json$Json$Decode$succeed(0));
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Main$mapPagesToProgram = F2(
	function (model, _v0) {
		var pageModel = _v0.a;
		var pageCmd = _v0.b;
		var session_ = _v0.c;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					a0: $author$project$Main$Authenticated(
						$author$project$Main$Viewer(session_)),
					bx: pageModel
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Main$PageMsg, pageCmd));
	});
var $author$project$Main$mapProgram = F3(
	function (model, element, _return) {
		var modelWithSession = _Utils_update(
			model,
			{
				a0: $author$project$Main$Authenticated(
					$author$project$Main$Viewer(_return.gB))
			});
		return _Utils_Tuple2(
			A2(element.iz, modelWithSession, _return.eh),
			A2($elm$core$Platform$Cmd$map, element.jv, _return.dX));
	});
var $author$project$Log$msgAppUpdateRequest = 'scope_update_request';
var $author$project$Log$msgAutoLogin = 'auto_login';
var $author$project$Log$msgLogout = 'logout';
var $author$project$Log$msgOpenStartPage = 'open_start_page';
var $author$project$Log$msgPageNotFound = 'page_not_found';
var $author$project$Log$msgProfileDownload = 'profile_download';
var $author$project$Main$NavbarMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$RemoteData$Loading = {$: 1};
var $author$project$Element$Navbar$TeamsDownloaded = function (a) {
	return {$: 6, a: a};
};
var $author$project$Application$Boundaries$andThenCmd = F2(
	function (cmd_, _return) {
		return _Utils_update(
			_return,
			{
				dX: $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[_return.dX, cmd_]))
			});
	});
var $author$project$Locale$Messages$GradingGraduatesNavItem = {$: 671};
var $author$project$Locale$Messages$GradingLateNavItem = {$: 670};
var $author$project$Locale$Messages$GradingNavItem = {$: 667};
var $author$project$Locale$Messages$GradingNavItemWithTeamName = function (a) {
	return {$: 668, a: a};
};
var $author$project$Locale$Messages$GradingRealtimeNavItem = {$: 669};
var $author$project$Team$HighSchool = 4;
var $author$project$Element$Navbar$NavDropdown = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Element$Navbar$NestedDropdownItem = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Element$Navbar$RouteItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Team$isSameTeam = F2(
	function (teamId, team) {
		return _Utils_eq(teamId, team.i8);
	});
var $author$project$Team$findTeam = F2(
	function (teamId, teams) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				$author$project$Team$isSameTeam(teamId),
				teams));
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Team$teamIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Element$Navbar$buildGradingNavItemWithTeams = F3(
	function (teacherTeamIds, demoTeamIds, teams) {
		if (!teacherTeamIds.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!teacherTeamIds.b.b) {
				var teamId = teacherTeamIds.a;
				return A2(
					$elm$core$Maybe$map,
					function (team) {
						var baseItems = _List_fromArray(
							[
								A2(
								$author$project$Element$Navbar$RouteItem,
								A3(
									$author$project$Route$GradingPage,
									$author$project$Team$teamIdToInt(teamId),
									$elm$core$Maybe$Nothing,
									true),
								{
									cm: 'nav-grading-realtime',
									hw: A2($elm$core$List$member, teamId, demoTeamIds),
									ea: $author$project$Locale$Messages$GradingRealtimeNavItem,
									mw: $elm$core$Maybe$Nothing
								}),
								A2(
								$author$project$Element$Navbar$RouteItem,
								A3(
									$author$project$Route$GradingPage,
									$author$project$Team$teamIdToInt(teamId),
									$elm$core$Maybe$Nothing,
									false),
								{cm: 'nav-grading-late', hw: true, ea: $author$project$Locale$Messages$GradingLateNavItem, mw: $elm$core$Maybe$Nothing})
							]);
						var itemsWithGraduates = (team.kg === 4) ? _Utils_ap(
							baseItems,
							_List_fromArray(
								[
									A2(
									$author$project$Element$Navbar$RouteItem,
									A3(
										$author$project$Route$GradingPage,
										$author$project$Team$teamIdToInt(teamId),
										$elm$core$Maybe$Just(12),
										true),
									{cm: 'nav-grading-graduates', hw: true, ea: $author$project$Locale$Messages$GradingGraduatesNavItem, mw: $elm$core$Maybe$Nothing})
								])) : baseItems;
						return A2(
							$author$project$Element$Navbar$NavDropdown,
							A2(
								$author$project$Element$Navbar$RouteItem,
								$author$project$Route$Home,
								{cm: 'nav-grading', hw: true, ea: $author$project$Locale$Messages$GradingNavItem, mw: $elm$core$Maybe$Nothing}),
							itemsWithGraduates);
					},
					A2($author$project$Team$findTeam, teamId, teams));
			} else {
				var teamIds = teacherTeamIds;
				return $elm$core$Maybe$Just(
					A2(
						$author$project$Element$Navbar$NavDropdown,
						A2(
							$author$project$Element$Navbar$RouteItem,
							$author$project$Route$Home,
							{cm: 'nav-grading', hw: true, ea: $author$project$Locale$Messages$GradingNavItem, mw: $elm$core$Maybe$Nothing}),
						A2(
							$elm$core$List$filterMap,
							function (teamId) {
								return A2(
									$elm$core$Maybe$map,
									function (team) {
										var baseItems = _List_fromArray(
											[
												A2(
												$author$project$Element$Navbar$RouteItem,
												A3(
													$author$project$Route$GradingPage,
													$author$project$Team$teamIdToInt(teamId),
													$elm$core$Maybe$Nothing,
													true),
												{
													cm: 'nav-grading-team-' + ($elm$core$String$fromInt(
														$author$project$Team$teamIdToInt(teamId)) + '-realtime'),
													hw: A2($elm$core$List$member, teamId, demoTeamIds),
													ea: $author$project$Locale$Messages$GradingRealtimeNavItem,
													mw: $elm$core$Maybe$Nothing
												}),
												A2(
												$author$project$Element$Navbar$RouteItem,
												A3(
													$author$project$Route$GradingPage,
													$author$project$Team$teamIdToInt(teamId),
													$elm$core$Maybe$Nothing,
													false),
												{
													cm: 'nav-grading-team-' + ($elm$core$String$fromInt(
														$author$project$Team$teamIdToInt(teamId)) + '-late'),
													hw: true,
													ea: $author$project$Locale$Messages$GradingLateNavItem,
													mw: $elm$core$Maybe$Nothing
												})
											]);
										var itemsWithGraduates = (team.kg === 4) ? _Utils_ap(
											baseItems,
											_List_fromArray(
												[
													A2(
													$author$project$Element$Navbar$RouteItem,
													A3(
														$author$project$Route$GradingPage,
														$author$project$Team$teamIdToInt(teamId),
														$elm$core$Maybe$Just(12),
														true),
													{
														cm: 'nav-grading-team-' + ($elm$core$String$fromInt(
															$author$project$Team$teamIdToInt(teamId)) + '-graduates'),
														hw: true,
														ea: $author$project$Locale$Messages$GradingGraduatesNavItem,
														mw: $elm$core$Maybe$Nothing
													})
												])) : baseItems;
										return A2(
											$author$project$Element$Navbar$NestedDropdownItem,
											{
												cm: 'nav-grading-team-' + $elm$core$String$fromInt(
													$author$project$Team$teamIdToInt(teamId)),
												hw: true,
												ea: $author$project$Locale$Messages$GradingNavItemWithTeamName(team.lp),
												mw: $elm$core$Maybe$Nothing
											},
											itemsWithGraduates);
									},
									A2($author$project$Team$findTeam, teamId, teams));
							},
							teamIds)));
			}
		}
	});
var $author$project$Element$Navbar$AbsenceJustificationClicked = {$: 4};
var $author$project$Element$Navbar$ActionItem = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Element$Navbar$LanguageChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Locale$Messages$NavAdminTeamMembership = {$: 288};
var $author$project$Element$Navbar$NavDropdownRight = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Locale$Messages$NavJustifyAbsences = {$: 289};
var $author$project$Locale$Messages$NavLanguageEnglish = {$: 292};
var $author$project$Locale$Messages$NavLanguageHungarian = {$: 293};
var $author$project$Locale$Messages$NavLogout = {$: 295};
var $author$project$Locale$Messages$NavNotifications = {$: 300};
var $author$project$Locale$Messages$NavProfile = {$: 305};
var $author$project$Locale$Messages$NavSafeguard = {$: 294};
var $author$project$Locale$Messages$PersonFullName = F2(
	function (a, b) {
		return {$: 314, a: a, b: b};
	});
var $author$project$Element$Navbar$UrlItem = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$ACL$everyone = true;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $truqu$elm_md5$MD5$emptyWords = A2($elm$core$Array$repeat, 16, 0);
var $truqu$elm_md5$MD5$addUnsigned = F2(
	function (x, y) {
		return 4294967295 & (x + y);
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $truqu$elm_md5$MD5$rotateLeft = F2(
	function (bits, input) {
		return (input << bits) | (input >>> (32 - bits));
	});
var $truqu$elm_md5$MD5$cmn = F8(
	function (fun, a, b, c, d, x, s, ac) {
		return A2(
			$truqu$elm_md5$MD5$addUnsigned,
			b,
			A2(
				$truqu$elm_md5$MD5$rotateLeft,
				s,
				A2(
					$truqu$elm_md5$MD5$addUnsigned,
					a,
					A2(
						$truqu$elm_md5$MD5$addUnsigned,
						ac,
						A2(
							$truqu$elm_md5$MD5$addUnsigned,
							A3(fun, b, c, d),
							x)))));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $truqu$elm_md5$MD5$f = F3(
	function (x, y, z) {
		return z ^ (x & (y ^ z));
	});
var $truqu$elm_md5$MD5$ff = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$f, a, b, c, d, x, s, ac);
	});
var $truqu$elm_md5$MD5$g = F3(
	function (x, y, z) {
		return y ^ (z & (x ^ y));
	});
var $truqu$elm_md5$MD5$gg = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$g, a, b, c, d, x, s, ac);
	});
var $truqu$elm_md5$MD5$h = F3(
	function (x, y, z) {
		return z ^ (x ^ y);
	});
var $truqu$elm_md5$MD5$hh = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$h, a, b, c, d, x, s, ac);
	});
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $truqu$elm_md5$MD5$i = F3(
	function (x, y, z) {
		return y ^ (x | (~z));
	});
var $truqu$elm_md5$MD5$ii = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$i, a, b, c, d, x, s, ac);
	});
var $truqu$elm_md5$MD5$hex_ = F2(
	function (xs, acc) {
		var a = acc.fE;
		var b = acc.fL;
		var c = acc.fQ;
		var d = acc.fW;
		if ((((((((((((((((xs.b && xs.b.b) && xs.b.b.b) && xs.b.b.b.b) && xs.b.b.b.b.b) && xs.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b) && (!xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b)) {
			var x0 = xs.a;
			var _v1 = xs.b;
			var x1 = _v1.a;
			var _v2 = _v1.b;
			var x2 = _v2.a;
			var _v3 = _v2.b;
			var x3 = _v3.a;
			var _v4 = _v3.b;
			var x4 = _v4.a;
			var _v5 = _v4.b;
			var x5 = _v5.a;
			var _v6 = _v5.b;
			var x6 = _v6.a;
			var _v7 = _v6.b;
			var x7 = _v7.a;
			var _v8 = _v7.b;
			var x8 = _v8.a;
			var _v9 = _v8.b;
			var x9 = _v9.a;
			var _v10 = _v9.b;
			var x10 = _v10.a;
			var _v11 = _v10.b;
			var x11 = _v11.a;
			var _v12 = _v11.b;
			var x12 = _v12.a;
			var _v13 = _v12.b;
			var x13 = _v13.a;
			var _v14 = _v13.b;
			var x14 = _v14.a;
			var _v15 = _v14.b;
			var x15 = _v15.a;
			var s44 = 21;
			var s43 = 15;
			var s42 = 10;
			var s41 = 6;
			var s34 = 23;
			var s33 = 16;
			var s32 = 11;
			var s31 = 4;
			var s24 = 20;
			var s23 = 14;
			var s22 = 9;
			var s21 = 5;
			var s14 = 22;
			var s13 = 17;
			var s12 = 12;
			var s11 = 7;
			var d00 = d;
			var c00 = c;
			var b00 = b;
			var a00 = a;
			var a01 = A7($truqu$elm_md5$MD5$ff, a00, b00, c00, d00, x0, s11, 3614090360);
			var d01 = A7($truqu$elm_md5$MD5$ff, d00, a01, b00, c00, x1, s12, 3905402710);
			var c01 = A7($truqu$elm_md5$MD5$ff, c00, d01, a01, b00, x2, s13, 606105819);
			var b01 = A7($truqu$elm_md5$MD5$ff, b00, c01, d01, a01, x3, s14, 3250441966);
			var a02 = A7($truqu$elm_md5$MD5$ff, a01, b01, c01, d01, x4, s11, 4118548399);
			var d02 = A7($truqu$elm_md5$MD5$ff, d01, a02, b01, c01, x5, s12, 1200080426);
			var c02 = A7($truqu$elm_md5$MD5$ff, c01, d02, a02, b01, x6, s13, 2821735955);
			var b02 = A7($truqu$elm_md5$MD5$ff, b01, c02, d02, a02, x7, s14, 4249261313);
			var a03 = A7($truqu$elm_md5$MD5$ff, a02, b02, c02, d02, x8, s11, 1770035416);
			var d03 = A7($truqu$elm_md5$MD5$ff, d02, a03, b02, c02, x9, s12, 2336552879);
			var c03 = A7($truqu$elm_md5$MD5$ff, c02, d03, a03, b02, x10, s13, 4294925233);
			var b03 = A7($truqu$elm_md5$MD5$ff, b02, c03, d03, a03, x11, s14, 2304563134);
			var a04 = A7($truqu$elm_md5$MD5$ff, a03, b03, c03, d03, x12, s11, 1804603682);
			var d04 = A7($truqu$elm_md5$MD5$ff, d03, a04, b03, c03, x13, s12, 4254626195);
			var c04 = A7($truqu$elm_md5$MD5$ff, c03, d04, a04, b03, x14, s13, 2792965006);
			var b04 = A7($truqu$elm_md5$MD5$ff, b03, c04, d04, a04, x15, s14, 1236535329);
			var a05 = A7($truqu$elm_md5$MD5$gg, a04, b04, c04, d04, x1, s21, 4129170786);
			var d05 = A7($truqu$elm_md5$MD5$gg, d04, a05, b04, c04, x6, s22, 3225465664);
			var c05 = A7($truqu$elm_md5$MD5$gg, c04, d05, a05, b04, x11, s23, 643717713);
			var b05 = A7($truqu$elm_md5$MD5$gg, b04, c05, d05, a05, x0, s24, 3921069994);
			var a06 = A7($truqu$elm_md5$MD5$gg, a05, b05, c05, d05, x5, s21, 3593408605);
			var d06 = A7($truqu$elm_md5$MD5$gg, d05, a06, b05, c05, x10, s22, 38016083);
			var c06 = A7($truqu$elm_md5$MD5$gg, c05, d06, a06, b05, x15, s23, 3634488961);
			var b06 = A7($truqu$elm_md5$MD5$gg, b05, c06, d06, a06, x4, s24, 3889429448);
			var a07 = A7($truqu$elm_md5$MD5$gg, a06, b06, c06, d06, x9, s21, 568446438);
			var d07 = A7($truqu$elm_md5$MD5$gg, d06, a07, b06, c06, x14, s22, 3275163606);
			var c07 = A7($truqu$elm_md5$MD5$gg, c06, d07, a07, b06, x3, s23, 4107603335);
			var b07 = A7($truqu$elm_md5$MD5$gg, b06, c07, d07, a07, x8, s24, 1163531501);
			var a08 = A7($truqu$elm_md5$MD5$gg, a07, b07, c07, d07, x13, s21, 2850285829);
			var d08 = A7($truqu$elm_md5$MD5$gg, d07, a08, b07, c07, x2, s22, 4243563512);
			var c08 = A7($truqu$elm_md5$MD5$gg, c07, d08, a08, b07, x7, s23, 1735328473);
			var b08 = A7($truqu$elm_md5$MD5$gg, b07, c08, d08, a08, x12, s24, 2368359562);
			var a09 = A7($truqu$elm_md5$MD5$hh, a08, b08, c08, d08, x5, s31, 4294588738);
			var d09 = A7($truqu$elm_md5$MD5$hh, d08, a09, b08, c08, x8, s32, 2272392833);
			var c09 = A7($truqu$elm_md5$MD5$hh, c08, d09, a09, b08, x11, s33, 1839030562);
			var b09 = A7($truqu$elm_md5$MD5$hh, b08, c09, d09, a09, x14, s34, 4259657740);
			var a10 = A7($truqu$elm_md5$MD5$hh, a09, b09, c09, d09, x1, s31, 2763975236);
			var d10 = A7($truqu$elm_md5$MD5$hh, d09, a10, b09, c09, x4, s32, 1272893353);
			var c10 = A7($truqu$elm_md5$MD5$hh, c09, d10, a10, b09, x7, s33, 4139469664);
			var b10 = A7($truqu$elm_md5$MD5$hh, b09, c10, d10, a10, x10, s34, 3200236656);
			var a11 = A7($truqu$elm_md5$MD5$hh, a10, b10, c10, d10, x13, s31, 681279174);
			var d11 = A7($truqu$elm_md5$MD5$hh, d10, a11, b10, c10, x0, s32, 3936430074);
			var c11 = A7($truqu$elm_md5$MD5$hh, c10, d11, a11, b10, x3, s33, 3572445317);
			var b11 = A7($truqu$elm_md5$MD5$hh, b10, c11, d11, a11, x6, s34, 76029189);
			var a12 = A7($truqu$elm_md5$MD5$hh, a11, b11, c11, d11, x9, s31, 3654602809);
			var d12 = A7($truqu$elm_md5$MD5$hh, d11, a12, b11, c11, x12, s32, 3873151461);
			var c12 = A7($truqu$elm_md5$MD5$hh, c11, d12, a12, b11, x15, s33, 530742520);
			var b12 = A7($truqu$elm_md5$MD5$hh, b11, c12, d12, a12, x2, s34, 3299628645);
			var a13 = A7($truqu$elm_md5$MD5$ii, a12, b12, c12, d12, x0, s41, 4096336452);
			var d13 = A7($truqu$elm_md5$MD5$ii, d12, a13, b12, c12, x7, s42, 1126891415);
			var c13 = A7($truqu$elm_md5$MD5$ii, c12, d13, a13, b12, x14, s43, 2878612391);
			var b13 = A7($truqu$elm_md5$MD5$ii, b12, c13, d13, a13, x5, s44, 4237533241);
			var a14 = A7($truqu$elm_md5$MD5$ii, a13, b13, c13, d13, x12, s41, 1700485571);
			var d14 = A7($truqu$elm_md5$MD5$ii, d13, a14, b13, c13, x3, s42, 2399980690);
			var c14 = A7($truqu$elm_md5$MD5$ii, c13, d14, a14, b13, x10, s43, 4293915773);
			var b14 = A7($truqu$elm_md5$MD5$ii, b13, c14, d14, a14, x1, s44, 2240044497);
			var a15 = A7($truqu$elm_md5$MD5$ii, a14, b14, c14, d14, x8, s41, 1873313359);
			var d15 = A7($truqu$elm_md5$MD5$ii, d14, a15, b14, c14, x15, s42, 4264355552);
			var c15 = A7($truqu$elm_md5$MD5$ii, c14, d15, a15, b14, x6, s43, 2734768916);
			var b15 = A7($truqu$elm_md5$MD5$ii, b14, c15, d15, a15, x13, s44, 1309151649);
			var a16 = A7($truqu$elm_md5$MD5$ii, a15, b15, c15, d15, x4, s41, 4149444226);
			var d16 = A7($truqu$elm_md5$MD5$ii, d15, a16, b15, c15, x11, s42, 3174756917);
			var c16 = A7($truqu$elm_md5$MD5$ii, c15, d16, a16, b15, x2, s43, 718787259);
			var b16 = A7($truqu$elm_md5$MD5$ii, b15, c16, d16, a16, x9, s44, 3951481745);
			var b17 = A2($truqu$elm_md5$MD5$addUnsigned, b00, b16);
			var c17 = A2($truqu$elm_md5$MD5$addUnsigned, c00, c16);
			var d17 = A2($truqu$elm_md5$MD5$addUnsigned, d00, d16);
			var a17 = A2($truqu$elm_md5$MD5$addUnsigned, a00, a16);
			return {fE: a17, fL: b17, fQ: c17, fW: d17};
		} else {
			return acc;
		}
	});
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $truqu$elm_md5$MD5$iget = F2(
	function (index, array) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Array$get, index, array));
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $truqu$elm_md5$MD5$consume = F2(
	function (_char, _v0) {
		var hashState = _v0.a;
		var _v1 = _v0.b;
		var byteCount = _v1.a;
		var words = _v1.b;
		var totalByteCount = _v0.c;
		var wordCount = (byteCount / 4) | 0;
		var oldWord = A2($truqu$elm_md5$MD5$iget, wordCount, words);
		var bytePosition = 8 * (byteCount % 4);
		var code = _char << bytePosition;
		var newWord = oldWord | code;
		var newWords = A3($elm$core$Array$set, wordCount, newWord, words);
		return (byteCount === 63) ? _Utils_Tuple3(
			A2(
				$truqu$elm_md5$MD5$hex_,
				$elm$core$Array$toList(newWords),
				hashState),
			_Utils_Tuple2(0, $truqu$elm_md5$MD5$emptyWords),
			totalByteCount + 1) : _Utils_Tuple3(
			hashState,
			_Utils_Tuple2(byteCount + 1, newWords),
			totalByteCount + 1);
	});
var $truqu$elm_md5$MD5$finishUp = function (_v0) {
	var hashState = _v0.a;
	var _v1 = _v0.b;
	var byteCount = _v1.a;
	var words = _v1.b;
	var totalByteCount = _v0.c;
	var wordCount = (byteCount / 4) | 0;
	var oldWord = A2($truqu$elm_md5$MD5$iget, wordCount, words);
	var bytePosition = 8 * (byteCount % 4);
	var code = 128 << bytePosition;
	var newWord = oldWord | code;
	var newWords = A3($elm$core$Array$set, wordCount, newWord, words);
	return (wordCount < 14) ? function (x) {
		return A2($truqu$elm_md5$MD5$hex_, x, hashState);
	}(
		$elm$core$Array$toList(
			A3(
				$elm$core$Array$set,
				15,
				totalByteCount >>> 29,
				A3($elm$core$Array$set, 14, totalByteCount << 3, newWords)))) : function (x) {
		return A2(
			$truqu$elm_md5$MD5$hex_,
			x,
			A2(
				$truqu$elm_md5$MD5$hex_,
				$elm$core$Array$toList(newWords),
				hashState));
	}(
		$elm$core$Array$toList(
			A3(
				$elm$core$Array$set,
				15,
				totalByteCount >>> 29,
				A3($elm$core$Array$set, 14, totalByteCount << 3, $truqu$elm_md5$MD5$emptyWords))));
};
var $elm$core$String$foldl = _String_foldl;
var $zwilias$elm_utf_tools$String$UTF8$utf32ToUtf8 = F3(
	function (add, _char, acc) {
		return (_char < 128) ? A2(add, _char, acc) : ((_char < 2048) ? A2(
			add,
			128 | (63 & _char),
			A2(add, 192 | (_char >>> 6), acc)) : ((_char < 65536) ? A2(
			add,
			128 | (63 & _char),
			A2(
				add,
				128 | (63 & (_char >>> 6)),
				A2(add, 224 | (_char >>> 12), acc))) : A2(
			add,
			128 | (63 & _char),
			A2(
				add,
				128 | (63 & (_char >>> 6)),
				A2(
					add,
					128 | (63 & (_char >>> 12)),
					A2(add, 240 | (_char >>> 18), acc))))));
	});
var $zwilias$elm_utf_tools$String$UTF8$foldl = F3(
	function (op, initialAcc, input) {
		return A3(
			$elm$core$String$foldl,
			F2(
				function (_char, acc) {
					return A3(
						$zwilias$elm_utf_tools$String$UTF8$utf32ToUtf8,
						op,
						$elm$core$Char$toCode(_char),
						acc);
				}),
			initialAcc,
			input);
	});
var $truqu$elm_md5$MD5$State = F4(
	function (a, b, c, d) {
		return {fE: a, fL: b, fQ: c, fW: d};
	});
var $truqu$elm_md5$MD5$initialHashState = A4($truqu$elm_md5$MD5$State, 1732584193, 4023233417, 2562383102, 271733878);
var $truqu$elm_md5$MD5$hash = function (input) {
	return $truqu$elm_md5$MD5$finishUp(
		A3(
			$zwilias$elm_utf_tools$String$UTF8$foldl,
			$truqu$elm_md5$MD5$consume,
			_Utils_Tuple3(
				$truqu$elm_md5$MD5$initialHashState,
				_Utils_Tuple2(0, $truqu$elm_md5$MD5$emptyWords),
				0),
			input));
};
var $truqu$elm_md5$MD5$bytes = function (string) {
	var _v0 = $truqu$elm_md5$MD5$hash(string);
	var a = _v0.fE;
	var b = _v0.fL;
	var c = _v0.fQ;
	var d = _v0.fW;
	return _List_fromArray(
		[a & 255, (a >>> 8) & 255, (a >>> 16) & 255, (a >>> 24) & 255, b & 255, (b >>> 8) & 255, (b >>> 16) & 255, (b >>> 24) & 255, c & 255, (c >>> 8) & 255, (c >>> 16) & 255, (c >>> 24) & 255, d & 255, (d >>> 8) & 255, (d >>> 16) & 255, (d >>> 24) & 255]);
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $truqu$elm_md5$MD5$toHex = function (_byte) {
	switch (_byte) {
		case 0:
			return '0';
		case 1:
			return '1';
		case 2:
			return '2';
		case 3:
			return '3';
		case 4:
			return '4';
		case 5:
			return '5';
		case 6:
			return '6';
		case 7:
			return '7';
		case 8:
			return '8';
		case 9:
			return '9';
		case 10:
			return 'a';
		case 11:
			return 'b';
		case 12:
			return 'c';
		case 13:
			return 'd';
		case 14:
			return 'e';
		case 15:
			return 'f';
		default:
			return _Utils_ap(
				$truqu$elm_md5$MD5$toHex((_byte / 16) | 0),
				$truqu$elm_md5$MD5$toHex(_byte % 16));
	}
};
var $truqu$elm_md5$MD5$hex = function (s) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (b, acc) {
				return _Utils_ap(
					acc,
					A3(
						$elm$core$String$padLeft,
						2,
						'0',
						$truqu$elm_md5$MD5$toHex(b)));
			}),
		'',
		$truqu$elm_md5$MD5$bytes(s));
};
var $author$project$Util$Media$gravatar = F2(
	function (size, email) {
		return 'https://gravatar.com/avatar/' + ($truqu$elm_md5$MD5$hex(email) + ('?s=' + ($elm$core$String$fromInt(size) + '&d=retro')));
	});
var $author$project$Person$hasRole = F2(
	function (role, person) {
		var _v0 = person.nr;
		var roles = _v0;
		return A2(
			$elm$core$List$any,
			function (r) {
				return _Utils_eq(r.a, role);
			},
			roles);
	});
var $author$project$Person$roleOperator = 'operator';
var $author$project$Person$isOperator = function (person) {
	return A2($author$project$Person$hasRole, $author$project$Person$roleOperator, person);
};
var $author$project$ACL$isOperator = $author$project$Person$isOperator;
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Basics$not = _Basics_not;
var $author$project$Person$isSponsor = function (person) {
	return !$elm$core$List$isEmpty(person.nL);
};
var $author$project$ACL$isSponsor = $author$project$Person$isSponsor;
var $author$project$Element$Navbar$buildProfileMenu = F2(
	function (viewer, language) {
		return A2(
			$author$project$Element$Navbar$NavDropdownRight,
			A2(
				$author$project$Element$Navbar$RouteItem,
				$author$project$Route$GenericProfileUpdate(viewer.i8),
				{
					cm: 'nav-profile',
					hw: $author$project$ACL$everyone,
					ea: A2($author$project$Locale$Messages$PersonFullName, viewer.lI, viewer.av),
					mw: $elm$core$Maybe$Just(
						A2($author$project$Util$Media$gravatar, 48, viewer.O))
				}),
			_List_fromArray(
				[
					A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$GenericProfileUpdate(viewer.i8),
					{cm: 'nav-profile-edit', hw: $author$project$ACL$everyone, ea: $author$project$Locale$Messages$NavProfile, mw: $elm$core$Maybe$Nothing}),
					_Utils_eq(language, $author$project$Locale$hungarian) ? A2(
					$author$project$Element$Navbar$ActionItem,
					$author$project$Element$Navbar$LanguageChanged($author$project$Locale$english),
					{cm: 'nav-lang-en', hw: $author$project$ACL$everyone, ea: $author$project$Locale$Messages$NavLanguageEnglish, mw: $elm$core$Maybe$Nothing}) : A2(
					$author$project$Element$Navbar$ActionItem,
					$author$project$Element$Navbar$LanguageChanged($author$project$Locale$hungarian),
					{cm: 'nav-lang-hu', hw: $author$project$ACL$everyone, ea: $author$project$Locale$Messages$NavLanguageHungarian, mw: $elm$core$Maybe$Nothing}),
					A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$NotificationList,
					{cm: 'nav-notifications', hw: $author$project$ACL$everyone, ea: $author$project$Locale$Messages$NavNotifications, mw: $elm$core$Maybe$Nothing}),
					A2(
					$author$project$Element$Navbar$ActionItem,
					$author$project$Element$Navbar$AbsenceJustificationClicked,
					{
						cm: 'nav-justify-absences',
						hw: $author$project$ACL$isSponsor(viewer),
						ea: $author$project$Locale$Messages$NavJustifyAbsences,
						mw: $elm$core$Maybe$Nothing
					}),
					A2(
					$author$project$Element$Navbar$UrlItem,
					'https://admin.budapestschool.org/admin/people/teammembership/',
					{
						cm: 'nav-admin-team-membership',
						hw: $author$project$ACL$isOperator(viewer),
						ea: $author$project$Locale$Messages$NavAdminTeamMembership,
						mw: $elm$core$Maybe$Nothing
					}),
					A2(
					$author$project$Element$Navbar$UrlItem,
					'https://docs.google.com/forms/d/e/1FAIpQLSfXG2AmSdjbS2n69Fw_8jc2toU4pZO9vYJ017dvgdgeAdD7SA/viewform',
					{cm: 'safeguarding', hw: $author$project$ACL$everyone, ea: $author$project$Locale$Messages$NavSafeguard, mw: $elm$core$Maybe$Nothing}),
					A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$Logout,
					{cm: 'logout', hw: $author$project$ACL$everyone, ea: $author$project$Locale$Messages$NavLogout, mw: $elm$core$Maybe$Nothing})
				]));
	});
var $author$project$Locale$Messages$CurriculumBrowserTitle = {$: 44};
var $author$project$Locale$Messages$LearningGroupList = {$: 154};
var $author$project$Locale$Messages$NavLearningContracts = {$: 291};
var $author$project$Locale$Messages$NavModuleClosureOverview = {$: 296};
var $author$project$Locale$Messages$NavModules = {$: 297};
var $author$project$Locale$Messages$NavModulesList = {$: 298};
var $author$project$Locale$Messages$NavModulesNew = {$: 299};
var $author$project$Locale$Messages$NavPhoneBook = {$: 301};
var $author$project$Locale$Messages$NavPortfolios = {$: 302};
var $author$project$Locale$Messages$NavPortfoliosList = {$: 303};
var $author$project$Locale$Messages$NavPortfoliosNew = {$: 304};
var $author$project$Locale$Messages$NavRubricSubjectOverview = {$: 306};
var $author$project$Element$Navbar$NavSingle = function (a) {
	return {$: 0, a: a};
};
var $author$project$Locale$Messages$NavStudents = {$: 307};
var $author$project$Locale$Messages$NavStudentsList = {$: 308};
var $author$project$Locale$Messages$NavTimetable = {$: 309};
var $author$project$Locale$Messages$RubricsTitle = {$: 422};
var $author$project$Route$blankLoStudentOverviewListQuery = {hG: $elm$core$Maybe$Nothing, Q: $elm$core$Maybe$Nothing, fv: _List_Nil, kb: _List_Nil};
var $author$project$Route$blankModuleClosureOverviewListQuery = {cH: $elm$core$Maybe$Nothing, Q: $elm$core$Maybe$Nothing};
var $author$project$Route$blankPortfoliosListQuery = {ly: $elm$core$Maybe$Nothing, nN: $elm$core$Maybe$Nothing, fv: _List_Nil, ol: $elm$core$Maybe$Nothing};
var $author$project$Person$isActiveMember = function (person) {
	return person.fs === 1;
};
var $author$project$Person$roleModuleTeacher = 'module_teacher';
var $author$project$Person$isModuleTeacher = function (person) {
	return A2($author$project$Person$hasRole, $author$project$Person$roleModuleTeacher, person);
};
var $author$project$Person$hasAccessRole = F2(
	function (person, role) {
		return A2($elm$core$List$member, role, person.io);
	});
var $author$project$ACL$isStaff = function (person) {
	return A2($author$project$Person$hasAccessRole, person, 0);
};
var $author$project$Person$roleStudent = 'student';
var $author$project$Person$isStudent = function (person) {
	return A2($author$project$Person$hasRole, $author$project$Person$roleStudent, person);
};
var $author$project$ACL$isSchoolMember = function (person) {
	return $author$project$ACL$isStaff(person) || ($author$project$Person$isModuleTeacher(person) || ($author$project$Person$isSponsor(person) || $author$project$Person$isStudent(person)));
};
var $author$project$ACL$canCreatePortfolios = function (person) {
	return $author$project$Person$isActiveMember(person) && $author$project$ACL$isSchoolMember(person);
};
var $author$project$ACL$canManageModules = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$Person$roleTeacher = 'teacher';
var $author$project$Person$isTeacher = function (person) {
	return A2($author$project$Person$hasRole, $author$project$Person$roleTeacher, person);
};
var $author$project$ACL$canViewCurriculum = function (viewer) {
	return $author$project$Person$isTeacher(viewer) || ($author$project$Person$isModuleTeacher(viewer) || $author$project$ACL$isStaff(viewer));
};
var $author$project$ACL$canViewLearningContracts = function (person) {
	return $author$project$Person$isActiveMember(person) && $author$project$ACL$isSchoolMember(person);
};
var $author$project$ACL$canViewLearningGroup = function (person) {
	return $author$project$ACL$isStaff(person) || ($author$project$Person$isTeacher(person) || $author$project$Person$isModuleTeacher(person));
};
var $author$project$ACL$isAuditor = function (person) {
	return A2($author$project$Person$hasAccessRole, person, 1);
};
var $author$project$ACL$canViewModules = function (person) {
	return $author$project$Person$isActiveMember(person) && ($author$project$ACL$isSchoolMember(person) || $author$project$ACL$isAuditor(person));
};
var $author$project$ACL$canViewPhonebook = function (person) {
	return $author$project$Person$isActiveMember(person) && $author$project$ACL$isSchoolMember(person);
};
var $author$project$ACL$canViewPortfolios = function (person) {
	return $author$project$Person$isActiveMember(person) && ($author$project$ACL$isSchoolMember(person) || $author$project$ACL$isAuditor(person));
};
var $author$project$ACL$canViewPortfoliosSchool = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$ACL$canViewRubricSubjectOverview = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$ACL$canViewRubrics = function (person) {
	return $author$project$ACL$isStaff(person) || ($author$project$Person$isModuleTeacher(person) || $author$project$ACL$isAuditor(person));
};
var $author$project$ACL$canViewStudents = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$Element$Navbar$buildStandardMenuItems = function (viewer) {
	return _List_fromArray(
		[
			$author$project$Element$Navbar$NavSingle(
			A2(
				$author$project$Element$Navbar$RouteItem,
				$author$project$Route$PhoneBook,
				{
					cm: 'nav-phonebook',
					hw: $author$project$ACL$canViewPhonebook(viewer),
					ea: $author$project$Locale$Messages$NavPhoneBook,
					mw: $elm$core$Maybe$Nothing
				})),
			A2(
			$author$project$Element$Navbar$NavDropdown,
			A2(
				$author$project$Element$Navbar$RouteItem,
				$author$project$Route$StudentList,
				{
					cm: 'nav-students',
					hw: $author$project$ACL$canViewStudents(viewer),
					ea: $author$project$Locale$Messages$NavStudents,
					mw: $elm$core$Maybe$Nothing
				}),
			_List_fromArray(
				[
					A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$StudentList,
					{
						cm: 'nav-students-list',
						hw: $author$project$ACL$canViewStudents(viewer),
						ea: $author$project$Locale$Messages$NavStudentsList,
						mw: $elm$core$Maybe$Nothing
					}),
					A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$LearningGroupList,
					{
						cm: 'nav-learninggroup-list',
						hw: $author$project$ACL$canViewLearningGroup(viewer),
						ea: $author$project$Locale$Messages$LearningGroupList,
						mw: $elm$core$Maybe$Nothing
					}),
					A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$LearningContractsList,
					{
						cm: 'nav-learningcontracts',
						hw: $author$project$ACL$canViewLearningContracts(viewer),
						ea: $author$project$Locale$Messages$NavLearningContracts,
						mw: $elm$core$Maybe$Nothing
					})
				])),
			A2(
			$author$project$Element$Navbar$NavDropdown,
			A2(
				$author$project$Element$Navbar$RouteItem,
				$author$project$Route$ModulesList,
				{
					cm: 'nav-modules',
					hw: $author$project$ACL$canViewModules(viewer),
					ea: $author$project$Locale$Messages$NavModules,
					mw: $elm$core$Maybe$Nothing
				}),
			_List_fromArray(
				[
					A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$ModulesList,
					{
						cm: 'nav-modules-list',
						hw: $author$project$ACL$canViewModules(viewer),
						ea: $author$project$Locale$Messages$NavModulesList,
						mw: $elm$core$Maybe$Nothing
					}),
					A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$ModulesCreate,
					{
						cm: 'nav-modules-new',
						hw: $author$project$ACL$canManageModules(viewer),
						ea: $author$project$Locale$Messages$NavModulesNew,
						mw: $elm$core$Maybe$Nothing
					}),
					A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$TimetableCalendar(_List_Nil),
					{
						cm: 'nav-timetable',
						hw: $author$project$ACL$isStaff(viewer) || ($author$project$Person$isModuleTeacher(viewer) || $author$project$Person$isStudent(viewer)),
						ea: $author$project$Locale$Messages$NavTimetable,
						mw: $elm$core$Maybe$Nothing
					}),
					A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$RubricsList,
					{
						cm: 'nav-rubrics',
						hw: $author$project$ACL$canViewRubrics(viewer),
						ea: $author$project$Locale$Messages$RubricsTitle,
						mw: $elm$core$Maybe$Nothing
					}),
					A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$CurriculumBrowser,
					{
						cm: 'nav-curriculum',
						hw: $author$project$ACL$canViewCurriculum(viewer),
						ea: $author$project$Locale$Messages$CurriculumBrowserTitle,
						mw: $elm$core$Maybe$Nothing
					})
				])),
			A2(
			$author$project$Element$Navbar$NavDropdown,
			A2(
				$author$project$Element$Navbar$RouteItem,
				$author$project$Route$PortfoliosList($author$project$Route$blankPortfoliosListQuery),
				{
					cm: 'nav-portfolios',
					hw: $author$project$ACL$canViewPortfolios(viewer),
					ea: $author$project$Locale$Messages$NavPortfolios,
					mw: $elm$core$Maybe$Nothing
				}),
			_List_fromArray(
				[
					A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$PortfoliosList($author$project$Route$blankPortfoliosListQuery),
					{
						cm: 'nav-portfolios-list',
						hw: $author$project$ACL$canViewPortfolios(viewer),
						ea: $author$project$Locale$Messages$NavPortfoliosList,
						mw: $elm$core$Maybe$Nothing
					}),
					A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$PortfoliosCreate($elm$core$Maybe$Nothing),
					{
						cm: 'nav-portfolios-new',
						hw: $author$project$ACL$canCreatePortfolios(viewer),
						ea: $author$project$Locale$Messages$NavPortfoliosNew,
						mw: $elm$core$Maybe$Nothing
					})
				])),
			A2(
			$author$project$Element$Navbar$NavDropdown,
			A2(
				$author$project$Element$Navbar$RouteItem,
				$author$project$Route$RubricSubjectOverview($author$project$Route$blankLoStudentOverviewListQuery),
				{
					cm: 'nav-rubric-subject-overview',
					hw: $author$project$ACL$canViewRubricSubjectOverview(viewer),
					ea: $author$project$Locale$Messages$NavRubricSubjectOverview,
					mw: $elm$core$Maybe$Nothing
				}),
			_List_fromArray(
				[
					A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$RubricSubjectOverview($author$project$Route$blankLoStudentOverviewListQuery),
					{
						cm: 'nav-rubric-subject-overview',
						hw: $author$project$ACL$canViewRubricSubjectOverview(viewer),
						ea: $author$project$Locale$Messages$NavRubricSubjectOverview,
						mw: $elm$core$Maybe$Nothing
					}),
					A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$ModuleClosureOverview($author$project$Route$blankModuleClosureOverviewListQuery),
					{
						cm: 'nav-mclosure-overview',
						hw: $author$project$ACL$canViewStudents(viewer) && $author$project$ACL$canViewPortfoliosSchool(viewer),
						ea: $author$project$Locale$Messages$NavModuleClosureOverview,
						mw: $elm$core$Maybe$Nothing
					})
				]))
		]);
};
var $author$project$Element$Navbar$endOfTrimesterCoordinatorTeamIds = _List_fromArray(
	[7, 14, 40, 612, 613, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1035, 1037, 1038, 1039, 1040, 1892, 1893, 1908, 2287, 2288, 2295, 2638, 2643, 2981, 3422, 3423]);
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Element$Navbar$getGradingTeamIds = function (viewer) {
	if (A2($author$project$Person$hasAccessRole, viewer, 8) || A2($author$project$Person$hasAccessRole, viewer, 5)) {
		return $author$project$Element$Navbar$endOfTrimesterCoordinatorTeamIds;
	} else {
		var _v0 = viewer.nr;
		var internals = _v0;
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filter,
				function (_v1) {
					var role = _v1.a;
					return (role === 'teacher') || (role === 'module_teacher');
				},
				internals));
	}
};
var $author$project$Element$Navbar$gradingDemoTeamIds = _List_fromArray(
	[1, 2295, 612, 613, 1039, 1040]);
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Element$Navbar$buildMenu = F3(
	function (viewer, language, teams) {
		var teacherTeamIds = $author$project$Element$Navbar$getGradingTeamIds(viewer);
		var menuItems = _Utils_ap(
			$author$project$Element$Navbar$buildStandardMenuItems(viewer),
			_List_fromArray(
				[
					A2($author$project$Element$Navbar$buildProfileMenu, viewer, language)
				]));
		var demoTeamIds = A2(
			$elm$core$List$filter,
			function (teamId) {
				return A2($elm$core$List$member, teamId, $author$project$Element$Navbar$gradingDemoTeamIds);
			},
			teacherTeamIds);
		var maybeGradingItem = A3($author$project$Element$Navbar$buildGradingNavItemWithTeams, teacherTeamIds, demoTeamIds, teams);
		return _Utils_ap(
			menuItems,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $elm$core$List$singleton, maybeGradingItem)));
	});
var $author$project$RemoteData$Failure = function (a) {
	return {$: 3, a: a};
};
var $author$project$RemoteData$Success = function (a) {
	return {$: 2, a: a};
};
var $author$project$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $author$project$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $author$project$RemoteData$Success(x);
	}
};
var $author$project$Api$Endpoint$schools = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'schools']),
		_List_Nil);
};
var $author$project$Team$Team = F4(
	function (id, name, displayName, teamType) {
		return {lp: displayName, i8: id, fb: name, kg: teamType};
	});
var $author$project$Team$Kindergarten = 1;
var $author$project$Team$LowerElementary = 2;
var $author$project$Team$Other = 5;
var $author$project$Team$School = 0;
var $author$project$Team$UpperElementary = 3;
var $author$project$Team$teamTypeDecoder = A2(
	$elm$json$Json$Decode$map,
	function (typeStr) {
		switch (typeStr) {
			case 'school':
				return 0;
			case 'kindergarten':
				return 1;
			case 'lower_elementary':
				return 2;
			case 'upper_elementary':
				return 3;
			case 'high_school':
				return 4;
			default:
				return 5;
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Team$teamDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'team_type',
	$author$project$Team$teamTypeDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'display_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$author$project$Team$teamIdDecoder,
				$elm$json$Json$Decode$succeed($author$project$Team$Team)))));
var $author$project$Team$teamsDecoder = $elm$json$Json$Decode$list($author$project$Team$teamDecoder);
var $author$project$Team$fetchSchools = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$schools(config),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$Team$teamsDecoder));
	});
var $author$project$Application$Boundaries$save = F2(
	function (model, session) {
		return {dX: $elm$core$Platform$Cmd$none, eh: model, gs: $elm$core$Maybe$Nothing, gB: session};
	});
var $author$project$Element$Navbar$init = F3(
	function (config, session, params) {
		var model = {
			b_: config,
			d9: false,
			ef: params.ef,
			eg: A3($author$project$Element$Navbar$buildMenu, session.ok, session.mn, _List_Nil),
			cM: params.cM,
			h9: $author$project$RemoteData$Loading
		};
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A2($author$project$Team$fetchSchools, config.gX, $author$project$Element$Navbar$TeamsDownloaded),
			A2($author$project$Application$Boundaries$save, model, session));
	});
var $author$project$Element$Navbar$LanguageSet = $elm$core$Basics$identity;
var $author$project$Locale$Messages$NavJustifyAbsencesMovedNotification = {$: 290};
var $author$project$Element$Navbar$NoOp = {$: 7};
var $author$project$Locale$Messages$UserSettingsSaveError = {$: 665};
var $author$project$Locale$Messages$UserSettingsSaveSuccess = {$: 664};
var $author$project$Element$Navbar$UserSettingsSaved = function (a) {
	return {$: 5, a: a};
};
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $author$project$Notification$add = F2(
	function (notification, notifications) {
		var nextId = $elm$core$Dict$size(notifications) + 1;
		return A3($elm$core$Dict$insert, nextId, notification, notifications);
	});
var $author$project$Notification$ErrorNotice = 0;
var $author$project$Notification$error = function (message) {
	return {di: 0, cz: message};
};
var $author$project$Session$error = F3(
	function (session, _v0, message) {
		var notification = $author$project$Notification$error(message);
		return _Utils_update(
			session,
			{
				em: A2($author$project$Notification$add, notification, session.em)
			});
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$browser$Browser$Dom$blur = _Browser_call('blur');
var $author$project$Element$Navbar$hideNavItem = function (itemId) {
	return A2(
		$elm$core$Task$attempt,
		$elm$core$Basics$always($author$project$Element$Navbar$NoOp),
		$elm$browser$Browser$Dom$blur(itemId));
};
var $author$project$Log$msgUserSettings = 'user_settings';
var $author$project$Notification$SuccessNotice = 1;
var $author$project$Notification$ok = function (message) {
	return {di: 1, cz: message};
};
var $author$project$Session$ok = F2(
	function (session, message) {
		var notification = $author$project$Notification$ok(message);
		return _Utils_update(
			session,
			{
				em: A2($author$project$Notification$add, notification, session.em)
			});
	});
var $author$project$Application$Boundaries$reply = F2(
	function (cmd, prev) {
		return _Utils_update(
			prev,
			{
				gs: $elm$core$Maybe$Just(cmd)
			});
	});
var $author$project$Api$put = F5(
	function (url, config, body, toMsg, decoder) {
		return $author$project$Api$Endpoint$request(
			{
				T: body,
				bd: A2($author$project$Api$expectJson, toMsg, decoder),
				ar: $author$project$Api$toHeaders(config),
				bj: 'PUT',
				bp: $elm$core$Maybe$Nothing,
				bq: $elm$core$Maybe$Nothing,
				K: url
			});
	});
var $author$project$Api$Endpoint$userSettings = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'user-settings',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$UserSettings$userSettingsEncoder = function (settings) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(settings.i8)),
				_Utils_Tuple2(
				'language',
				$elm$json$Json$Encode$string(settings.mn.k8))
			]));
};
var $author$project$UserSettings$saveSettings = F3(
	function (config, settings, callback) {
		return A5(
			$author$project$Api$put,
			A2($author$project$Api$Endpoint$userSettings, config, settings.i8),
			config,
			$elm$http$Http$jsonBody(
				$author$project$UserSettings$userSettingsEncoder(settings)),
			callback,
			$author$project$UserSettings$userSettingsDecoder);
	});
var $author$project$Ports$setPageLanguage = _Platform_outgoingPort('setPageLanguage', $elm$json$Json$Encode$string);
var $author$project$Session$updateLanguage = F2(
	function (lang, session) {
		var viewer = session.ok;
		var settings = viewer.nD;
		return _Utils_update(
			session,
			{
				mn: lang,
				h6: lang.h6,
				ok: _Utils_update(
					viewer,
					{
						nD: _Utils_update(
							settings,
							{mn: lang})
					})
			});
	});
var $author$project$Element$Navbar$update = F3(
	function (session, msg, model) {
		var t_ = session.h6;
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{d9: !model.d9}),
					session);
			case 2:
				var itemId = msg.a;
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					$author$project$Element$Navbar$hideNavItem(itemId),
					A2($author$project$Application$Boundaries$save, model, session));
			case 1:
				var route = msg.a;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{d9: false, cM: route}),
					session);
			case 4:
				var session2 = A2(
					$author$project$Session$ok,
					session,
					t_($author$project$Locale$Messages$NavJustifyAbsencesMovedNotification));
				return A2($author$project$Application$Boundaries$save, model, session2);
			case 3:
				var lang = msg.a;
				var session2 = A2($author$project$Session$updateLanguage, lang, session);
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					$author$project$Ports$setPageLanguage(lang.k8),
					A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3($author$project$UserSettings$saveSettings, model.b_.gX, session2.ok.nD, $author$project$Element$Navbar$UserSettingsSaved),
						A2($author$project$Application$Boundaries$save, model, session2)));
			case 5:
				if (!msg.a.$) {
					var settings = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$reply,
						settings.mn,
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A2(
								$author$project$Session$ok,
								session,
								t_($author$project$Locale$Messages$UserSettingsSaveSuccess))));
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							model.b_,
							_Utils_Tuple3($author$project$Log$msgUserSettings, $elm$core$Maybe$Nothing, error),
							$elm$core$Basics$always($author$project$Element$Navbar$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$UserSettingsSaveError))));
				}
			case 6:
				var teamsData = msg.a;
				var teams = function () {
					if (teamsData.$ === 2) {
						var t = teamsData.a;
						return t;
					} else {
						return _List_Nil;
					}
				}();
				var updatedMenu = A3($author$project$Element$Navbar$buildMenu, session.ok, session.mn, teams);
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{eg: updatedMenu, h9: teamsData}),
					session);
			default:
				return A2($author$project$Application$Boundaries$save, model, session);
		}
	});
var $author$project$Element$Navbar$BurgerToggled = {$: 0};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$UI$attrCyData = $elm$html$Html$Attributes$attribute('data-cy');
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Route$href = function (targetRoute) {
	return $elm$html$Html$Attributes$href(
		$author$project$Route$toString(targetRoute));
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Element$Navbar$navBurger = F2(
	function (target, toMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'aria-expanded', 'false'),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', 'menu'),
					$elm$html$Html$Attributes$class('navbar-burger burger'),
					A2($elm$html$Html$Attributes$attribute, 'data-target', target),
					A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
					$author$project$UI$attrCyData('burger'),
					$elm$html$Html$Events$onClick(toMsg)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_Nil)
				]));
	});
var $author$project$Element$Navbar$isParent = F3(
	function (menu, child, parent) {
		var isChild = function (navItem) {
			switch (navItem.$) {
				case 0:
					var route = navItem.a;
					return _Utils_eq(route, child);
				case 1:
					return false;
				case 2:
					return false;
				default:
					return false;
			}
		};
		var anyIsChild = function (children) {
			return A2($elm$core$List$any, isChild, children);
		};
		var routeIsParentAndChildIsAmongChildren = F2(
			function (route, children) {
				return _Utils_eq(route, parent) && anyIsChild(children);
			});
		return A2(
			$elm$core$List$any,
			function (navItem) {
				switch (navItem.$) {
					case 0:
						return false;
					case 1:
						var navGenericItem = navItem.a;
						var children = navItem.b;
						switch (navGenericItem.$) {
							case 0:
								var route = navGenericItem.a;
								return A2(routeIsParentAndChildIsAmongChildren, route, children);
							case 1:
								return false;
							case 2:
								return false;
							default:
								return false;
						}
					default:
						var navGenericItem = navItem.a;
						var children = navItem.b;
						switch (navGenericItem.$) {
							case 0:
								var route = navGenericItem.a;
								return A2(routeIsParentAndChildIsAmongChildren, route, children);
							case 1:
								return false;
							case 2:
								return false;
							default:
								return false;
						}
				}
			},
			menu);
	});
var $author$project$Element$Navbar$NavItemClicked = function (a) {
	return {$: 2, a: a};
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $author$project$UI$onClickPreventDefault = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'click',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$UI$actionLink = F3(
	function (msg, attrs, content) {
		return A2(
			$elm$html$Html$a,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$target('_self'),
						$author$project$UI$onClickPreventDefault(msg)
					]),
				attrs),
			content);
	});
var $author$project$Route$isActivePage = F2(
	function (current, target) {
		return _Utils_eq(current, target);
	});
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {k9: col, ld: contextStack, nc: problem, ns: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.ns, s.k9, x, s.l));
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.d, s.c);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{k9: 1, l: s.l, r: s.r, d: s.d + 1, ns: s.ns + 1, c: s.c}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{k9: s.k9 + 1, l: s.l, r: s.r, d: newOffset, ns: s.ns, c: s.c}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.c);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.d, offset) < 0,
					0,
					{k9: col, l: s0.l, r: s0.r, d: offset, ns: row, c: s0.c});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.d, s.ns, s.k9, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$chompIf(fn),
		$elm$parser$Parser$chompWhile(fn));
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.d, s1.d, s0.c),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000D') || ((c === '\u000C') || (c === '\u00A0')))));
};
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		$elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				$elm$core$String$toLower(closingName),
				name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		$elm$parser$Parser$getChompedString(
			$hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<')),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('/'))),
				chompName),
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('>')));
};
var $hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.d, s.ns, s.k9, s.c);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.l)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.d, newOffset) < 0,
			0,
			{k9: newCol, l: s.l, r: s.r, d: newOffset, ns: newRow, c: s.c});
	};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.d, s.ns, s.k9, s.c);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{k9: newCol, l: s.l, r: s.r, d: newOffset, ns: newRow, c: s.c});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $hecrj$html_parser$Html$Parser$commentString = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$token('<!')),
		$elm$parser$Parser$token('--')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompUntil('-->')),
		$elm$parser$Parser$token('-->')));
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $hecrj$html_parser$Html$Parser$comment = A2($elm$parser$Parser$map, $hecrj$html_parser$Html$Parser$Comment, $hecrj$html_parser$Html$Parser$commentString);
var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2($elm$core$List$member, name, $hecrj$html_parser$Html$Parser$voidElements);
};
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		$elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$map,
						function (_new) {
							return $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, _new, list));
						},
						parser_),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(
							$elm$core$List$reverse(list)))
					]));
		});
};
var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var $hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf(
	$elm$core$Basics$eq(';'));
var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\uD835\uDD04'),
			_Utils_Tuple2('afr', '\uD835\uDD1E'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\uD835\uDD38'),
			_Utils_Tuple2('aopf', '\uD835\uDD52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\uD835\uDC9C'),
			_Utils_Tuple2('ascr', '\uD835\uDCB6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\uD835\uDD05'),
			_Utils_Tuple2('bfr', '\uD835\uDD1F'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\uD835\uDD39'),
			_Utils_Tuple2('bopf', '\uD835\uDD53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\uD835\uDCB7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\uD835\uDD20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\uD835\uDD54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\uD835\uDC9E'),
			_Utils_Tuple2('cscr', '\uD835\uDCB8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\uD835\uDD07'),
			_Utils_Tuple2('dfr', '\uD835\uDD21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\uD835\uDD3B'),
			_Utils_Tuple2('dopf', '\uD835\uDD55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\uD835\uDC9F'),
			_Utils_Tuple2('dscr', '\uD835\uDCB9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\uD835\uDD08'),
			_Utils_Tuple2('efr', '\uD835\uDD22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\uD835\uDD3C'),
			_Utils_Tuple2('eopf', '\uD835\uDD56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\uD835\uDD09'),
			_Utils_Tuple2('ffr', '\uD835\uDD23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\uD835\uDD3D'),
			_Utils_Tuple2('fopf', '\uD835\uDD57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\uD835\uDCBB'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\uD835\uDD0A'),
			_Utils_Tuple2('gfr', '\uD835\uDD24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\uD835\uDD3E'),
			_Utils_Tuple2('gopf', '\uD835\uDD58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\uD835\uDCA2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200A'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\uD835\uDD25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\uD835\uDD59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\uD835\uDCBD'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\uD835\uDD26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\uD835\uDD40'),
			_Utils_Tuple2('iopf', '\uD835\uDD5A'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\uD835\uDCBE'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\uD835\uDD0D'),
			_Utils_Tuple2('jfr', '\uD835\uDD27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\uD835\uDD41'),
			_Utils_Tuple2('jopf', '\uD835\uDD5B'),
			_Utils_Tuple2('Jscr', '\uD835\uDCA5'),
			_Utils_Tuple2('jscr', '\uD835\uDCBF'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\uD835\uDD0E'),
			_Utils_Tuple2('kfr', '\uD835\uDD28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\uD835\uDD42'),
			_Utils_Tuple2('kopf', '\uD835\uDD5C'),
			_Utils_Tuple2('Kscr', '\uD835\uDCA6'),
			_Utils_Tuple2('kscr', '\uD835\uDCC0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\uD835\uDD0F'),
			_Utils_Tuple2('lfr', '\uD835\uDD29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\uD835\uDD43'),
			_Utils_Tuple2('lopf', '\uD835\uDD5D'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200E'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\uD835\uDCC1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205F'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\uD835\uDD10'),
			_Utils_Tuple2('mfr', '\uD835\uDD2A'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\uD835\uDD44'),
			_Utils_Tuple2('mopf', '\uD835\uDD5E'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\uD835\uDCC2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00A0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200B'),
			_Utils_Tuple2('NegativeThickSpace', '\u200B'),
			_Utils_Tuple2('NegativeThinSpace', '\u200B'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200B'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\uD835\uDD11'),
			_Utils_Tuple2('nfr', '\uD835\uDD2B'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00A0'),
			_Utils_Tuple2('nopf', '\uD835\uDD5F'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\uD835\uDCA9'),
			_Utils_Tuple2('nscr', '\uD835\uDCC3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\uD835\uDD12'),
			_Utils_Tuple2('ofr', '\uD835\uDD2C'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\uD835\uDD46'),
			_Utils_Tuple2('oopf', '\uD835\uDD60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\uD835\uDCAA'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\uD835\uDD13'),
			_Utils_Tuple2('pfr', '\uD835\uDD2D'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\uD835\uDD61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\uD835\uDCAB'),
			_Utils_Tuple2('pscr', '\uD835\uDCC5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\uD835\uDD14'),
			_Utils_Tuple2('qfr', '\uD835\uDD2E'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\uD835\uDD62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\uD835\uDCAC'),
			_Utils_Tuple2('qscr', '\uD835\uDCC6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\uD835\uDD2F'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200F'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\uD835\uDD63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\uD835\uDCC7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\uD835\uDD16'),
			_Utils_Tuple2('sfr', '\uD835\uDD30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00AD'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\uD835\uDD4A'),
			_Utils_Tuple2('sopf', '\uD835\uDD64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\uD835\uDCAE'),
			_Utils_Tuple2('sscr', '\uD835\uDCC8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\uD835\uDD17'),
			_Utils_Tuple2('tfr', '\uD835\uDD31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205F\u200A'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\uD835\uDD4B'),
			_Utils_Tuple2('topf', '\uD835\uDD65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\uD835\uDCAF'),
			_Utils_Tuple2('tscr', '\uD835\uDCC9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\uD835\uDD18'),
			_Utils_Tuple2('ufr', '\uD835\uDD32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\uD835\uDD4C'),
			_Utils_Tuple2('uopf', '\uD835\uDD66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\uD835\uDCB0'),
			_Utils_Tuple2('uscr', '\uD835\uDCCA'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200A'),
			_Utils_Tuple2('Vfr', '\uD835\uDD19'),
			_Utils_Tuple2('vfr', '\uD835\uDD33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\uD835\uDD4D'),
			_Utils_Tuple2('vopf', '\uD835\uDD67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\uD835\uDCB1'),
			_Utils_Tuple2('vscr', '\uD835\uDCCB'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\uD835\uDD1A'),
			_Utils_Tuple2('wfr', '\uD835\uDD34'),
			_Utils_Tuple2('Wopf', '\uD835\uDD4E'),
			_Utils_Tuple2('wopf', '\uD835\uDD68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\uD835\uDCB2'),
			_Utils_Tuple2('wscr', '\uD835\uDCCC'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\uD835\uDD1B'),
			_Utils_Tuple2('xfr', '\uD835\uDD35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\uD835\uDD4F'),
			_Utils_Tuple2('xopf', '\uD835\uDD69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\uD835\uDCB3'),
			_Utils_Tuple2('xscr', '\uD835\uDCCD'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\uD835\uDD1C'),
			_Utils_Tuple2('yfr', '\uD835\uDD36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\uD835\uDD50'),
			_Utils_Tuple2('yopf', '\uD835\uDD6A'),
			_Utils_Tuple2('Yscr', '\uD835\uDCB4'),
			_Utils_Tuple2('yscr', '\uD835\uDCCE'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200B'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\uD835\uDD37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\uD835\uDD6B'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\uD835\uDCB5'),
			_Utils_Tuple2('zscr', '\uD835\uDCCF'),
			_Utils_Tuple2('zwj', '\u200D'),
			_Utils_Tuple2('zwnj', '\u200C')
		]));
var $hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	$elm$parser$Parser$map,
	function (reference) {
		return A2(
			$elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2($elm$core$Dict$get, reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $hecrj$html_parser$Html$Parser$hexadecimal = A2(
	$elm$parser$Parser$andThen,
	function (hex) {
		var _v0 = $rtfeldman$elm_hex$Hex$fromString(
			$elm$core$String$toLower(hex));
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$parser$Parser$succeed(value);
		} else {
			var error = _v0.a;
			return $elm$parser$Parser$problem(error);
		}
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {k9: s.k9 + (newOffset - s.d), l: s.l, r: s.r, d: newOffset, ns: s.ns, c: s.c};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.d, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$core$String$toFloat = _String_toFloat;
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.c);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.ns, s.k9 - (floatOffset + s.d), invalid, s.l));
		} else {
			if (_Utils_eq(s.d, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.d, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.d, floatOffset, s.c));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.d, s.c)) {
			var zeroOffset = s.d + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.c) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.l$,
				c.i6,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.c),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.c) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.l$,
				c.jC,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.c),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.c) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.l$,
				c.iA,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.c),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.l$,
				c.iY,
				c.jf,
				c.i0,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.l$,
				c.iY,
				c.jf,
				c.i0,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.d, s.c),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				iA: $elm$core$Result$Err(invalid),
				iY: expecting,
				i0: $elm$core$Result$Err(invalid),
				i6: $elm$core$Result$Err(invalid),
				jf: $elm$core$Result$Ok($elm$core$Basics$identity),
				l$: invalid,
				jC: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				$hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq('0'))),
				$elm$parser$Parser$int)
			]));
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq('#'))),
		A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			codepoint));
}();
var $hecrj$html_parser$Html$Parser$characterReference = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('&'))),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				$elm$parser$Parser$succeed('&')
			])));
var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$map,
				$elm$core$String$join(''),
				$hecrj$html_parser$Html$Parser$many(
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$getChompedString(
								$hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								$hecrj$html_parser$Html$Parser$characterReference
							])))),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))));
};
var $hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return $elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (_new) {
								return $elm$parser$Parser$Loop(
									A2($elm$core$List$cons, _new, list));
							},
							parser_),
							$elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem('expecting at least one ' + type_) : $elm$parser$Parser$succeed(
							$elm$parser$Parser$Done(
								$elm$core$List$reverse(list)))
						]));
			});
	});
var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		$elm$parser$Parser$map,
		$elm$core$String$join(''),
		A2(
			$hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$getChompedString(
						$hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						$hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('='))),
				$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			$elm$parser$Parser$succeed('')
		]));
var $hecrj$html_parser$Html$Parser$tagAttribute = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$ignorer,
			$hecrj$html_parser$Html$Parser$tagAttributeName,
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		$elm$parser$Parser$ignorer,
		$hecrj$html_parser$Html$Parser$tagAttributeValue,
		$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
var $hecrj$html_parser$Html$Parser$tagName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum),
			$elm$parser$Parser$chompWhile(
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var $hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var $hecrj$html_parser$Html$Parser$text = A2(
	$elm$parser$Parser$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$join(''),
		$hecrj$html_parser$Html$Parser$Text),
	A2(
		$hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$getChompedString(
					$hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					$hecrj$html_parser$Html$Parser$characterReference
				]))));
function $hecrj$html_parser$Html$Parser$cyclic$node() {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$hecrj$html_parser$Html$Parser$text,
				$hecrj$html_parser$Html$Parser$comment,
				$hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function $hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v0) {
			var name = _v0.a;
			var attributes = _v0.b;
			return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A3($hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$chompIf(
								$elm$core$Basics$eq('/')),
								$elm$parser$Parser$succeed(0)
							]))),
				$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('>'))) : A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A2($hecrj$html_parser$Html$Parser$Element, name, attributes)),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('>'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$many(
						$elm$parser$Parser$backtrackable(
							$hecrj$html_parser$Html$Parser$cyclic$node())),
					$hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Tuple$pair),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$tagName,
					$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			$hecrj$html_parser$Html$Parser$tagAttributes));
}
var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
$hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return $hecrj$html_parser$Html$Parser$node;
};
var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
$hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return $hecrj$html_parser$Html$Parser$element;
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {k9: col, nc: problem, ns: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.ns, p.k9, p.nc);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{k9: 1, l: _List_Nil, r: 1, d: 0, ns: 1, c: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $hecrj$html_parser$Html$Parser$run = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : A2(
		$elm$parser$Parser$run,
		A2($hecrj$html_parser$Html$Parser$oneOrMore, 'node', $hecrj$html_parser$Html$Parser$node),
		str);
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $hecrj$html_parser$Html$Parser$Util$toAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return A2($elm$html$Html$Attributes$attribute, name, value);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDom = function (nodes) {
	return A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach, nodes);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach = function (node) {
	switch (node.$) {
		case 1:
			var name = node.a;
			var attrs = node.b;
			var children = node.c;
			return A3(
				$elm$html$Html$node,
				name,
				A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toAttribute, attrs),
				$hecrj$html_parser$Html$Parser$Util$toVirtualDom(children));
		case 0:
			var s = node.a;
			return $elm$html$Html$text(s);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$UI$textToHtml = function (t) {
	var _v0 = $hecrj$html_parser$Html$Parser$run(t);
	if (!_v0.$) {
		var nodes = _v0.a;
		return $hecrj$html_parser$Html$Parser$Util$toVirtualDom(nodes);
	} else {
		return _List_Nil;
	}
};
var $author$project$UI$caption = F2(
	function (t_, message) {
		var txt = t_(message);
		return A2($elm$core$String$contains, '</', txt) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			$author$project$UI$textToHtml(txt)) : $elm$html$Html$text(txt);
	});
var $elm$html$Html$figure = _VirtualDom_node('figure');
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $author$project$Element$Navbar$navbarMedia = F2(
	function (t_, viewConfig) {
		var _v0 = viewConfig.mw;
		if (!_v0.$) {
			var media = _v0.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$figure,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('image is-48x48 is-hidden-touch is-spaced')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-rounded'),
									$elm$html$Html$Attributes$src(media),
									$elm$html$Html$Attributes$alt(
									t_(viewConfig.ea)),
									$elm$html$Html$Attributes$width(48),
									$elm$html$Html$Attributes$height(48)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-hidden-desktop')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, viewConfig.ea)
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A2($author$project$UI$caption, t_, viewConfig.ea)
				]);
		}
	});
var $author$project$UI$none = $elm$html$Html$text('');
var $author$project$UI$when = F2(
	function (cond, view) {
		return cond ? view : $author$project$UI$none;
	});
var $author$project$Element$Navbar$navbarItem = F3(
	function (t_, currentRoute, item) {
		switch (item.$) {
			case 0:
				var route = item.a;
				var viewConfig = item.b;
				var dataTag = viewConfig.cm;
				var isVisible = viewConfig.hw;
				return A2(
					$author$project$UI$when,
					isVisible,
					A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$UI$attrCyData(dataTag),
								$elm$html$Html$Attributes$id(dataTag),
								$elm$html$Html$Attributes$class('navbar-item'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'is-active',
										A2($author$project$Route$isActivePage, currentRoute, route))
									])),
								$elm$html$Html$Events$onClick(
								$author$project$Element$Navbar$NavItemClicked(dataTag)),
								$author$project$Route$href(route)
							]),
						A2($author$project$Element$Navbar$navbarMedia, t_, viewConfig)));
			case 1:
				var action = item.a;
				var viewConfig = item.b;
				var dataTag = viewConfig.cm;
				var isVisible = viewConfig.hw;
				return A2(
					$author$project$UI$when,
					isVisible,
					A3(
						$author$project$UI$actionLink,
						action,
						_List_fromArray(
							[
								$author$project$UI$attrCyData(dataTag),
								$elm$html$Html$Attributes$class('navbar-item')
							]),
						A2($author$project$Element$Navbar$navbarMedia, t_, viewConfig)));
			case 2:
				var url = item.a;
				var viewConfig = item.b;
				var dataTag = viewConfig.cm;
				var isVisible = viewConfig.hw;
				return A2(
					$author$project$UI$when,
					isVisible,
					A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$UI$attrCyData(dataTag),
								$elm$html$Html$Attributes$class('navbar-item'),
								$elm$html$Html$Attributes$href(url),
								$elm$html$Html$Attributes$target('_blank')
							]),
						A2($author$project$Element$Navbar$navbarMedia, t_, viewConfig)));
			default:
				var viewConfig = item.a;
				var dataTag = viewConfig.cm;
				var isVisible = viewConfig.hw;
				var subItems = item.b;
				return A2(
					$author$project$UI$when,
					isVisible,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$UI$attrCyData(dataTag),
								$elm$html$Html$Attributes$class('navbar-item has-dropdown-nested')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('navbar-link-nested')
									]),
								_Utils_ap(
									A2($author$project$Element$Navbar$navbarMedia, t_, viewConfig),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('nested-arrow')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(' ▸')
												]))
										]))),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('navbar-dropdown-nested')
									]),
								A2(
									$elm$core$List$map,
									A2($author$project$Element$Navbar$navbarItem, t_, currentRoute),
									subItems))
							])));
		}
	});
var $author$project$Element$Navbar$navbarDropDown = F5(
	function (t_, model, isRight, item, navItems) {
		switch (item.$) {
			case 0:
				var route = item.a;
				var viewConfig = item.b;
				return A2(
					$author$project$UI$when,
					viewConfig.hw,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-item has-dropdown is-hoverable')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$author$project$UI$attrCyData(viewConfig.cm),
										$elm$html$Html$Attributes$class('navbar-link'),
										$author$project$Route$href(route),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'is-active',
												A3($author$project$Element$Navbar$isParent, model.eg, model.cM, route))
											]))
									]),
								A2($author$project$Element$Navbar$navbarMedia, t_, viewConfig)),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('navbar-dropdown is-boxed'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('is-right', isRight)
											]))
									]),
								A2(
									$elm$core$List$map,
									A2($author$project$Element$Navbar$navbarItem, t_, model.cM),
									navItems))
							])));
			case 1:
				return $author$project$UI$none;
			case 2:
				return $author$project$UI$none;
			default:
				return $author$project$UI$none;
		}
	});
var $author$project$Element$Navbar$view = F2(
	function (_v0, model) {
		var t_ = _v0.h6;
		var viewRightMenu = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('navbar-end')
				]),
			A2(
				$elm$core$List$map,
				function (item) {
					switch (item.$) {
						case 0:
							return $author$project$UI$none;
						case 1:
							return $author$project$UI$none;
						default:
							var parent = item.a;
							var children = item.b;
							return A5($author$project$Element$Navbar$navbarDropDown, t_, model, true, parent, children);
					}
				},
				model.eg));
		var viewLeftMenu = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('navbar-start')
				]),
			A2(
				$elm$core$List$map,
				function (item) {
					switch (item.$) {
						case 0:
							var single = item.a;
							return A3($author$project$Element$Navbar$navbarItem, t_, model.cM, single);
						case 1:
							var parent = item.a;
							var children = item.b;
							return A5($author$project$Element$Navbar$navbarDropDown, t_, model, false, parent, children);
						default:
							return $author$project$UI$none;
					}
				},
				model.eg));
		var viewBrand = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('navbar-brand')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('navbar-item'),
							$author$project$Route$href($author$project$Route$Home),
							$author$project$UI$attrCyData('nav-home')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(model.ef)
								]),
							_List_Nil)
						])),
					A2($author$project$Element$Navbar$navBurger, 'mainNav', $author$project$Element$Navbar$BurgerToggled)
				]));
		var inlineStyles = A3(
			$elm$html$Html$node,
			'style',
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('\n                    .navbar-link:not(.is-arrowless).is-active::after {\n                        border-color: #485fc7;\n                    }\n\n                    .navbar-dropdown .navbar-item.has-dropdown-nested {\n                        position: relative !important;\n                        display: block !important;\n                        padding: 0 !important;\n                        white-space: nowrap;\n                        overflow: visible;\n                    }\n\n                    .navbar-dropdown .navbar-item.has-dropdown-nested .navbar-link-nested {\n                        padding: 0.375rem 1rem;\n                        cursor: pointer;\n                        display: flex;\n                        align-items: center;\n                        justify-content: space-between;\n                        color: #4a4a4a;\n                        transition: background-color 0.2s ease, color 0.2s ease;\n                        white-space: nowrap;\n                        width: 100%;\n                    }\n\n                    .navbar-dropdown .navbar-item.has-dropdown-nested .navbar-link-nested:hover {\n                        background-color: whitesmoke;\n                        color: #0a0a0a;\n                    }\n\n                    .navbar-dropdown .navbar-item.has-dropdown-nested .navbar-link-nested .nested-arrow {\n                        margin-left: 0.75em;\n                        padding-left: 0.5em;\n                        opacity: 0.8;\n                        font-size: 0.8em;\n                    }\n\n                    .navbar-dropdown .navbar-item.has-dropdown-nested .navbar-dropdown-nested {\n                        visibility: hidden;\n                        opacity: 0;\n                        display: block;\n                        position: absolute;\n                        left: 100%;\n                        top: 0;\n                        min-width: 14rem;\n                        background-color: white;\n                        border: 1px solid #dbdbdb;\n                        border-radius: 6px;\n                        box-shadow: 0 8px 8px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);\n                        z-index: 30;\n                        padding-top: 0.5rem;\n                        padding-bottom: 0.5rem;\n                        transition: opacity 0.15s ease, visibility 0.15s ease;\n                        pointer-events: none;\n                    }\n\n                    .navbar-dropdown .navbar-item.has-dropdown-nested .navbar-dropdown-nested .navbar-item {\n                        padding: 0.375rem 1rem;\n                        white-space: nowrap;\n                        color: #4a4a4a;\n                        display: block;\n                    }\n\n                    .navbar-dropdown .navbar-item.has-dropdown-nested .navbar-dropdown-nested .navbar-item:hover {\n                        background-color: whitesmoke;\n                        color: #0a0a0a;\n                    }\n\n                    .navbar-dropdown .navbar-item.has-dropdown-nested:hover > .navbar-dropdown-nested {\n                        visibility: visible;\n                        opacity: 1;\n                        pointer-events: auto;\n                    }\n                ')
				]));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					inlineStyles,
					A2(
					$elm$html$Html$nav,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'aria-label', 'main navigation'),
							$elm$html$Html$Attributes$class('navbar'),
							A2($elm$html$Html$Attributes$attribute, 'role', 'navigation')
						]),
					_List_fromArray(
						[
							viewBrand,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('navbar-menu'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('is-active', model.d9)
										])),
									$elm$html$Html$Attributes$id('mainNav')
								]),
							_List_fromArray(
								[viewLeftMenu, viewRightMenu]))
						]))
				]));
	});
var $author$project$Element$Navbar$element = {jb: $author$project$Element$Navbar$init, ks: $author$project$Element$Navbar$update, og: $author$project$Element$Navbar$view};
var $author$project$Main$navbar = {
	iz: F2(
		function (model, x) {
			return _Utils_update(
				model,
				{
					el: $elm$core$Maybe$Just(x)
				});
		}),
	ha: $author$project$Element$Navbar$element,
	jv: $author$project$Main$NavbarMsg
};
var $author$project$Application$Boundaries$initElement = F4(
	function (config, session, element, params) {
		return A3(element.ha.jb, config, session, params);
	});
var $author$project$Main$openNavbar = F2(
	function (session_, model) {
		var params = {ef: model.ef, cM: model.cM};
		return A3(
			$author$project$Main$mapProgram,
			model,
			$author$project$Main$navbar,
			A4($author$project$Application$Boundaries$initElement, model.bG, session_, $author$project$Main$navbar, params));
	});
var $author$project$Ports$loadManifest = _Platform_outgoingPort('loadManifest', $elm$json$Json$Encode$string);
var $author$project$Ports$resetManifest = _Platform_outgoingPort(
	'resetManifest',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Pages$toManifestUrl = function (model) {
	switch (model.$) {
		case 18:
			return $elm$core$Maybe$Just('/portfolios.webmanifest');
		case 16:
			return $elm$core$Maybe$Just('/phonebook.webmanifest');
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$andThenLoadManifest = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var manifestCmd = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Ports$resetManifest(0),
		A2(
			$elm$core$Maybe$map,
			$author$project$Ports$loadManifest,
			$author$project$Pages$toManifestUrl(model.bx)));
	return _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					cmd,
					A2($elm$core$Platform$Cmd$map, $author$project$Main$PageMsg, manifestCmd)
				])));
};
var $author$project$Element$Timetable$Calendar = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleSingle$CloseModule = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningContracts$Create = {$: 0};
var $author$project$Element$LearningGroupForm$Create = {$: 0};
var $author$project$Element$PortfolioForm$Create = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$Timetable$CreateEvent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$Timetable$CreateEventSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModulesMain$CreateModule = {$: 0};
var $author$project$Element$ModulesMain$CreateModuleFromTemplate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModulesMain$DuplicateModule = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$StudentProfileForm$FullProfile = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$LearningContracts$List = {$: 1};
var $author$project$Element$ModulesMain$ListModules = {$: 2};
var $author$project$Module$ModuleId = $elm$core$Basics$identity;
var $author$project$Element$PortfolioList$MyChildren = {$: 0};
var $author$project$Element$StudentProfileForm$NekProfile = function (a) {
	return {$: 1, a: a};
};
var $author$project$RemoteData$NotAsked = {$: 0};
var $author$project$Element$PortfolioSingle$Page = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricSubjectOverview$Page = $elm$core$Basics$identity;
var $author$project$Element$RubricsList$Page = {$: 0};
var $author$project$Element$RubricsSingle$Page = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$PortfolioList$SpecificStudents = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningContracts$Update = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioForm$Update = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$Timetable$UpdateEvent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$Timetable$UpdateEventSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LearningGroupForm$UpdateGroup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModulesMain$UpdateModule = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$ModuleSingle$ViewModule = function (a) {
	return {$: 0, a: a};
};
var $author$project$ACL$canOpenStudentAbsences = function (person) {
	return !$author$project$ACL$isSponsor(person);
};
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.c),
			s.d) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$core$String$append = _String_append;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Form$dateToMillis = function (value) {
	return $elm$time$Time$posixToMillis(
		A2(
			$elm$core$Result$withDefault,
			$elm$time$Time$millisToPosix(0),
			$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(value)));
};
var $author$project$Element$PortfolioList$AnyBody = {$: 2};
var $author$project$Element$PortfolioList$defaultParams = {hb: $elm$core$Maybe$Nothing, hH: _List_Nil, mY: false, h2: $elm$core$Maybe$Nothing, fv: $author$project$Element$PortfolioList$AnyBody};
var $author$project$Application$V2$SharedConfig$fromV1 = function (config) {
	return {gX: config.gX, g0: config.g0};
};
var $author$project$Application$V2$Boundaries$addReply = F2(
	function (reply, _return) {
		return _Utils_update(
			_return,
			{gs: reply});
	});
var $author$project$Application$V2$Boundaries$andThenCmd = F2(
	function (cmd_, _return) {
		return _Utils_update(
			_return,
			{
				dX: $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[_return.dX, cmd_]))
			});
	});
var $author$project$Application$V2$Boundaries$save = F2(
	function (model, session) {
		return {dX: $elm$core$Platform$Cmd$none, eh: model, gs: $elm$core$Maybe$Nothing, gB: session};
	});
var $author$project$Application$V2$Boundaries$initElement = F5(
	function (key, config, session, element, params) {
		var _v0 = A3(element.ha.jb, config, session, params);
		var model = _v0.a;
		var effect = _v0.b;
		var reply = _v0.c;
		var cmd = A2(element.ha.hP, key, effect);
		return A2(
			$author$project$Application$V2$Boundaries$andThenCmd,
			cmd,
			A2(
				$author$project$Application$V2$Boundaries$addReply,
				reply,
				A2($author$project$Application$V2$Boundaries$save, model, session)));
	});
var $author$project$Pages$mapProgram = F3(
	function (model, element, _return) {
		return _Utils_Tuple3(
			A2(element.iz, model, _return.eh),
			A2($elm$core$Platform$Cmd$map, element.jv, _return.dX),
			_return.gB);
	});
var $author$project$Pages$mapProgramV2 = F3(
	function (model, element, _return) {
		return _Utils_Tuple3(
			A2(element.kt, model, _return.eh),
			A2($elm$core$Platform$Cmd$map, element.cf, _return.dX),
			_return.gB);
	});
var $author$project$Pages$CompanyContractFormModel = function (a) {
	return {$: 31, a: a};
};
var $author$project$Pages$CompanyContractFormMsg = function (a) {
	return {$: 30, a: a};
};
var $author$project$Pages$CounterModel = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$CurriculumBrowserModel = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$CurriculumBrowserMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$GenericProfileFormModel = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$GenericProfileFormMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$GradeRequestListModel = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$GradeRequestListMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$GradingPageModel = function (a) {
	return {$: 32, a: a};
};
var $author$project$Pages$GradingPageMsg = function (a) {
	return {$: 31, a: a};
};
var $author$project$Pages$HomePageModel = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$LearningAssessmentCardModel = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$LearningAssessmentCardMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$LearningContractsModel = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$LearningContractsMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$LearningGroupFormModel = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$LearningGroupListModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$LearningGroupListMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$LearningGroupSelectorModel = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$ModuleClosureOverviewModel = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$ModuleClosureOverviewMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$ModuleSingleModel = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$ModuleTeacherProfilesModel = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$ModuleTeacherProfilesMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$ModulesMainModel = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$NotificationListModel = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$NotificationListMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$PhoneBookModel = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$PortfolioFormModel = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$PortfolioListModel = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$PortfolioListMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$PortfolioSingleModel = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$PortfolioSingleMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$ReconciliationPageModel = function (a) {
	return {$: 33, a: a};
};
var $author$project$Pages$ReconciliationPageMsg = function (a) {
	return {$: 32, a: a};
};
var $author$project$Pages$RubricSubjectOverviewModel = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$RubricSubjectOverviewMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$RubricsFormModel = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$RubricsFormMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$RubricsListModel = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$RubricsListMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$RubricsSingleModel = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$RubricsSingleMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$StudentAbsenceListModel = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$StudentAbsenceListMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StudentListModel = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$StudentProfileFormModel = function (a) {
	return {$: 25, a: a};
};
var $author$project$Pages$StudentProfileFormMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$SubjectFeedbackListModel = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$SubjectFeedbackListMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$TeacherProfileFormModel = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$TeacherProfileFormMsg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$TimetableModel = function (a) {
	return {$: 29, a: a};
};
var $author$project$Pages$TimetableMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$TrimesterFeedbackReportModel = function (a) {
	return {$: 30, a: a};
};
var $author$project$Pages$TrimesterFeedbackReportMsg = function (a) {
	return {$: 29, a: a};
};
var $author$project$Element$CompanyContractForm$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$CompanyContractForm$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$CompanyContractForm$ConsentPage = {$: 2};
var $author$project$Element$CompanyContractForm$SetPageToHungarian = {$: 2};
var $author$project$Element$CompanyContractForm$UpdateLinkPlaceholderIdk = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$CompanyContractForm$init = F3(
	function (config, session, studentId) {
		var model = {
			ch: false,
			b_: config,
			fV: $elm$core$Maybe$Nothing,
			f4: false,
			ja: false,
			bk: $author$project$Element$CompanyContractForm$ConsentPage,
			b5: false,
			dm: false,
			gB: A2($author$project$Session$updateLanguage, $author$project$Locale$hungarian, session),
			dC: false,
			cQ: false,
			cS: false,
			dE: studentId
		};
		return _Utils_Tuple3(
			model,
			$author$project$Element$CompanyContractForm$BatchEffect(
				_List_fromArray(
					[
						$author$project$Element$CompanyContractForm$Cmd(
						$author$project$Element$CompanyContractForm$UpdateLinkPlaceholderIdk(studentId)),
						$author$project$Element$CompanyContractForm$Cmd($author$project$Element$CompanyContractForm$SetPageToHungarian)
					])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Api$getV2 = function (_v0) {
	var config = _v0.b_;
	var url = _v0.K;
	var decoder = _v0.d_;
	var toMsg = _v0.cf;
	return $author$project$Api$Endpoint$request(
		{
			T: $elm$http$Http$emptyBody,
			bd: A2($author$project$Api$expectJson, toMsg, decoder),
			ar: $author$project$Api$toHeaders(config),
			bj: 'GET',
			bp: $elm$core$Maybe$Nothing,
			bq: $elm$core$Maybe$Nothing,
			K: url
		});
};
var $author$project$Api$postV2 = function (_v0) {
	var config = _v0.b_;
	var url = _v0.K;
	var decoder = _v0.d_;
	var toMsg = _v0.cf;
	var body = _v0.T;
	return $author$project$Api$Endpoint$request(
		{
			T: $elm$http$Http$jsonBody(body),
			bd: A2($author$project$Api$expectJson, toMsg, decoder),
			ar: $author$project$Api$toHeaders(config.gX),
			bj: 'POST',
			bp: $elm$core$Maybe$Nothing,
			bq: $elm$core$Maybe$Nothing,
			K: url
		});
};
var $author$project$Ports$scrollToElement = _Platform_outgoingPort('scrollToElement', $elm$json$Json$Encode$string);
var $author$project$Element$CompanyContractForm$updateFilterUrl = F2(
	function (key, studentId) {
		return A2(
			$author$project$Route$replaceUrl,
			key,
			$author$project$Route$CompanyContractCreate(studentId));
	});
var $author$project$Element$CompanyContractForm$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$CompanyContractForm$perform(key),
						effects));
			case 2:
				var cmd = effect.a;
				switch (cmd.$) {
					case 0:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 1:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					case 3:
						var elem = cmd.a;
						return $author$project$Ports$scrollToElement(elem);
					case 2:
						return $author$project$Ports$setPageLanguage('HU');
					default:
						var studentId = cmd.a;
						return A2($author$project$Element$CompanyContractForm$updateFilterUrl, key, studentId);
				}
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Element$CompanyContractForm$CompanyContractCreated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$CompanyContractForm$CompanyContractTemplateDownloaded = function (a) {
	return {$: 11, a: a};
};
var $author$project$Element$CompanyContractForm$CreateCompanyContract = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$EditedButNotSaved = 1;
var $author$project$Element$CompanyContractForm$ErrorPage = {$: 0};
var $author$project$Element$CompanyContractForm$FetchNewCompanyContractTemplate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$CompanyContractForm$FormPage = F4(
	function (a, b, c, d) {
		return {$: 4, a: a, b: b, c: c, d: d};
	});
var $author$project$Element$CompanyContractForm$LoadingPage = {$: 1};
var $author$project$Element$CompanyContractForm$NoEffect = {$: 0};
var $author$project$Form$NotTouched = 0;
var $author$project$Form$Processing = 2;
var $author$project$Element$CompanyContractForm$ScrollTo = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$CompanyContractForm$SuccessPage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$CompanyContractForm$CompanyAddress = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$CompanyContractForm$CompanyName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$CompanyContractForm$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$CompanyContractForm$RepresentativeEmail = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$CompanyContractForm$RepresentativeName = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$CompanyContractForm$VatNumber = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$FormRequiredEmail = {$: 71};
var $author$project$Locale$Messages$FormRequiredValue = {$: 70};
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$core$String$trim = _String_trim;
var $author$project$Form$requiredEmail = F2(
	function (t_, value) {
		return ($elm$core$String$trim(value) === '') ? $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormRequiredValue)) : (A2(
			$elm$regex$Regex$contains,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')),
			value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormRequiredEmail)));
	});
var $author$project$Form$requiredText = F2(
	function (t_, value) {
		return ($elm$core$String$trim(value) !== '') ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormRequiredValue));
	});
var $author$project$Element$CompanyContractForm$buildForm = function (t_) {
	return {
		iK: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{iK: value});
				}),
			fC: function ($) {
				return $.iK;
			},
			og: {
				cm: 'companyaddress',
				e6: 'fa-map-marker-alt',
				ea: 'Székhely',
				fe: A2($elm$core$Basics$composeL, $author$project$Element$CompanyContractForm$FormMsg, $author$project$Element$CompanyContractForm$CompanyAddress),
				fj: 'Székhely',
				ii: 'text'
			}
		},
		iL: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{iL: value});
				}),
			fC: function ($) {
				return $.iL;
			},
			og: {
				cm: 'companyname',
				e6: 'fa-user',
				ea: 'Cégnév',
				fe: A2($elm$core$Basics$composeL, $author$project$Element$CompanyContractForm$FormMsg, $author$project$Element$CompanyContractForm$CompanyName),
				fj: 'Cégnév',
				ii: 'text'
			}
		},
		jX: {
			e0: false,
			fi: $author$project$Form$requiredEmail(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{jX: value});
				}),
			fC: function ($) {
				return $.jX;
			},
			og: {
				cm: 'representativeemail',
				e6: 'fa-envelope',
				ea: 'A cég törvényes képviselőjének email címe',
				fe: A2($elm$core$Basics$composeL, $author$project$Element$CompanyContractForm$FormMsg, $author$project$Element$CompanyContractForm$RepresentativeEmail),
				fj: 'email cím',
				ii: 'email'
			}
		},
		jY: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{jY: value});
				}),
			fC: function ($) {
				return $.jY;
			},
			og: {
				cm: 'representativename',
				e6: 'fa-user-tie',
				ea: 'A cég törvényes képviselőjének neve',
				fe: A2($elm$core$Basics$composeL, $author$project$Element$CompanyContractForm$FormMsg, $author$project$Element$CompanyContractForm$RepresentativeName),
				fj: 'A cég törvényes képviselőjének neve',
				ii: 'text'
			}
		},
		ku: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ku: value});
				}),
			fC: function ($) {
				return $.ku;
			},
			og: {
				cm: 'vatnumber',
				e6: 'fa-id-card',
				ea: 'Adószám',
				fe: A2($elm$core$Basics$composeL, $author$project$Element$CompanyContractForm$FormMsg, $author$project$Element$CompanyContractForm$VatNumber),
				fj: 'Adószám',
				ii: 'text'
			}
		}
	};
};
var $author$project$Api$Endpoint$companyContractCreate = F2(
	function (config, studentId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'people',
					$elm$core$String$fromInt(studentId),
					'company_contracts'
				]),
			_List_Nil);
	});
var $author$project$CompanyContract$CompanyContract = function (companyName) {
	return function (companyAddress) {
		return function (vatNumber) {
			return function (representativeName) {
				return function (representativeEmail) {
					return function (startDate) {
						return function (endDate) {
							return function (firstInstallmentAmount) {
								return function (firstInstallmentDueDate) {
									return function (secondInstallmentAmount) {
										return function (secondInstallmentDueDate) {
											return function (includeStartupFee) {
												return {iK: companyAddress, iL: companyName, ly: endDate, he: firstInstallmentAmount, hf: firstInstallmentDueDate, ja: includeStartupFee, jX: representativeEmail, jY: representativeName, hV: secondInstallmentAmount, hW: secondInstallmentDueDate, nN: startDate, ku: vatNumber};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$CompanyContract$companyContractDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'include_startup_fee',
	$elm$json$Json$Decode$bool,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'second_installment_due_date',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'second_installment_amount',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'first_installment_due_date',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'first_installment_amount',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'end_date',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'start_date',
							$elm$json$Json$Decode$string,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'representative_email',
								$elm$json$Json$Decode$string,
								'<REDACTED>',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'representative_name',
									$elm$json$Json$Decode$string,
									'<REDACTED>',
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'vat_number',
										$elm$json$Json$Decode$string,
										'<REDACTED>',
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'company_address',
											$elm$json$Json$Decode$string,
											'<REDACTED>',
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'company_name',
												$elm$json$Json$Decode$string,
												'<REDACTED>',
												$elm$json$Json$Decode$succeed($author$project$CompanyContract$CompanyContract)))))))))))));
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Util$Json$encodeMaybe = F2(
	function (encoder, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return encoder(value);
		} else {
			return $elm$json$Json$Encode$null;
		}
	});
var $author$project$CompanyContract$companyContractEncoder = function (contract) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'company_name',
				$elm$json$Json$Encode$string(contract.iL)),
				_Utils_Tuple2(
				'company_address',
				$elm$json$Json$Encode$string(contract.iK)),
				_Utils_Tuple2(
				'vat_number',
				$elm$json$Json$Encode$string(contract.ku)),
				_Utils_Tuple2(
				'representative_name',
				$elm$json$Json$Encode$string(contract.jY)),
				_Utils_Tuple2(
				'representative_email',
				$elm$json$Json$Encode$string(contract.jX)),
				_Utils_Tuple2(
				'start_date',
				$elm$json$Json$Encode$string(contract.nN)),
				_Utils_Tuple2(
				'end_date',
				$elm$json$Json$Encode$string(contract.ly)),
				_Utils_Tuple2(
				'first_installment_amount',
				$elm$json$Json$Encode$int(contract.he)),
				_Utils_Tuple2(
				'first_installment_due_date',
				$elm$json$Json$Encode$string(contract.hf)),
				_Utils_Tuple2(
				'second_installment_amount',
				A2($author$project$Util$Json$encodeMaybe, $elm$json$Json$Encode$int, contract.hV)),
				_Utils_Tuple2(
				'second_installment_due_date',
				A2($author$project$Util$Json$encodeMaybe, $elm$json$Json$Encode$string, contract.hW)),
				_Utils_Tuple2(
				'include_startup_fee',
				$elm$json$Json$Encode$bool(contract.ja))
			]));
};
var $author$project$CompanyContract$createNewCompanyContract2 = F4(
	function (config, studentId, contract, callback) {
		return {
			T: $author$project$CompanyContract$companyContractEncoder(contract),
			b_: config,
			d_: $author$project$CompanyContract$companyContractDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2($author$project$Api$Endpoint$companyContractCreate, config.gX, studentId)
		};
	});
var $author$project$Api$Endpoint$optional = F3(
	function (encoder, _v0, params) {
		var name = _v0.a;
		var value = _v0.b;
		return _Utils_ap(
			params,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (value_) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								name,
								encoder(value_))
							]);
					},
					value)));
	});
var $author$project$Api$Endpoint$stringFromBool = function (x) {
	return x ? 'true' : 'false';
};
var $author$project$Api$Endpoint$companyContractNew = F4(
	function (config, studentId, includeStartupFee, customStartDate) {
		var queryParams = A3(
			$author$project$Api$Endpoint$optional,
			$elm$core$Basics$identity,
			_Utils_Tuple2('custom_start_date', customStartDate),
			A3(
				$author$project$Api$Endpoint$optional,
				$author$project$Api$Endpoint$stringFromBool,
				_Utils_Tuple2(
					'include_startup_fee',
					$elm$core$Maybe$Just(includeStartupFee)),
				_List_Nil));
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'people',
					$elm$core$String$fromInt(studentId),
					'company_contracts',
					'new_contract'
				]),
			queryParams);
	});
var $author$project$CompanyContract$CreateCompanyContractTemplate = F8(
	function (studentName, currentMonthlyAmount, startDate, endDate, startDateOptions, fullAmount, dueDate, installments) {
		return {lh: currentMonthlyAmount, lv: dueDate, ly: endDate, lM: fullAmount, l_: installments, nN: startDate, nO: startDateOptions, nU: studentName};
	});
var $author$project$CompanyContract$Installments = F4(
	function (firstInstallmentAmount, firstInstallmentDueDate, secondInstallmentAmount, secondInstallmentDueDate) {
		return {he: firstInstallmentAmount, hf: firstInstallmentDueDate, hV: secondInstallmentAmount, hW: secondInstallmentDueDate};
	});
var $author$project$CompanyContract$installmentsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'second_installment_due_date',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'second_installment_amount',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'first_installment_due_date',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'first_installment_amount',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$CompanyContract$Installments)))));
var $author$project$CompanyContract$companyContractTemplateDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'installments',
	$elm$json$Json$Decode$maybe($author$project$CompanyContract$installmentsDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'due_date',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'full_amount',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'start_date_options',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'end_date',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'start_date',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'current_monthly_amount',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'student_name',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$CompanyContract$CreateCompanyContractTemplate)))))))));
var $author$project$CompanyContract$fetchNewCompanyContractTemplate2 = F5(
	function (config, studentId, includeStartupFee, customStartDate, callback) {
		return {
			b_: config,
			d_: $author$project$CompanyContract$companyContractTemplateDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A4($author$project$Api$Endpoint$companyContractNew, config, studentId, includeStartupFee, customStartDate)
		};
	});
var $author$project$Element$CompanyContractForm$fillForm = {iK: '', iL: '', jX: '', jY: '', ku: ''};
var $author$project$Form$isFieldValid = F2(
	function (field, values) {
		var _v0 = field.fi(
			field.fC(values));
		if (_v0.$ === 1) {
			return false;
		} else {
			return true;
		}
	});
var $author$project$Element$CompanyContractForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.iL, values) && (A2($author$project$Form$isFieldValid, form.iK, values) && (A2($author$project$Form$isFieldValid, form.ku, values) && (A2($author$project$Form$isFieldValid, form.jY, values) && A2($author$project$Form$isFieldValid, form.jX, values))));
	});
var $author$project$Form$markEdited = function (field) {
	return _Utils_update(
		field,
		{e0: true});
};
var $author$project$Element$CompanyContractForm$updateForm = F3(
	function (msg, form, formValues) {
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							iL: $author$project$Form$markEdited(form.iL)
						}),
					A2(form.iL.ks, value, formValues));
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							iK: $author$project$Form$markEdited(form.iK)
						}),
					A2(form.iK.ks, value, formValues));
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ku: $author$project$Form$markEdited(form.ku)
						}),
					A2(form.ku.ks, value, formValues));
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							jY: $author$project$Form$markEdited(form.jY)
						}),
					A2(form.jY.ks, value, formValues));
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							jX: $author$project$Form$markEdited(form.jX)
						}),
					A2(form.jX.ks, value, formValues));
		}
	});
var $author$project$Element$CompanyContractForm$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			iK: $author$project$Form$markEdited(form.iK),
			iL: $author$project$Form$markEdited(form.iL),
			jX: $author$project$Form$markEdited(form.jX),
			jY: $author$project$Form$markEdited(form.jY),
			ku: $author$project$Form$markEdited(form.ku)
		});
};
var $author$project$Element$CompanyContractForm$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.bk);
		_v0$17:
		while (true) {
			switch (_v0.a.$) {
				case 2:
					if (_v0.b.$ === 2) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bk: $author$project$Element$CompanyContractForm$LoadingPage}),
							$author$project$Element$CompanyContractForm$BatchEffect(
								_List_fromArray(
									[
										$author$project$Element$CompanyContractForm$Cmd(
										$author$project$Element$CompanyContractForm$FetchNewCompanyContractTemplate(
											A5($author$project$CompanyContract$fetchNewCompanyContractTemplate2, model.b_.gX, model.dE, false, $elm$core$Maybe$Nothing, $author$project$Element$CompanyContractForm$CompanyContractTemplateDownloaded))),
										$author$project$Element$CompanyContractForm$Cmd(
										$author$project$Element$CompanyContractForm$UpdateLinkPlaceholderIdk(model.dE))
									])),
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$17;
					}
				case 11:
					switch (_v0.a.a.$) {
						case 2:
							switch (_v0.b.$) {
								case 1:
									var newContract = _v0.a.a.a;
									var _v3 = _v0.b;
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{
												bk: A4(
													$author$project$Element$CompanyContractForm$FormPage,
													0,
													$author$project$Element$CompanyContractForm$buildForm(model.gB.h6),
													$author$project$Element$CompanyContractForm$fillForm,
													newContract)
											}),
										$author$project$Element$CompanyContractForm$NoEffect,
										$elm$core$Maybe$Nothing);
								case 4:
									var newContractTemplate = _v0.a.a.a;
									var _v4 = _v0.b;
									var state = _v4.a;
									var form = _v4.b;
									var values = _v4.c;
									var payInInstallments = _Utils_eq(newContractTemplate.l_, $elm$core$Maybe$Nothing) ? false : model.b5;
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{
												bk: A4($author$project$Element$CompanyContractForm$FormPage, state, form, values, newContractTemplate),
												b5: payInInstallments
											}),
										$author$project$Element$CompanyContractForm$NoEffect,
										$elm$core$Maybe$Nothing);
								default:
									break _v0$17;
							}
						case 3:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{bk: $author$project$Element$CompanyContractForm$ErrorPage}),
								$author$project$Element$CompanyContractForm$NoEffect,
								$elm$core$Maybe$Nothing);
						default:
							break _v0$17;
					}
				case 0:
					if (_v0.b.$ === 4) {
						var fieldMsg = _v0.a.a;
						var _v5 = _v0.b;
						var form = _v5.b;
						var values = _v5.c;
						var template = _v5.d;
						var _v6 = A3($author$project$Element$CompanyContractForm$updateForm, fieldMsg, form, values);
						var form2 = _v6.a;
						var values2 = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bk: A4($author$project$Element$CompanyContractForm$FormPage, 1, form2, values2, template)
								}),
							$author$project$Element$CompanyContractForm$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$17;
					}
				case 1:
					if (_v0.b.$ === 4) {
						var _v7 = _v0.a;
						var _v8 = _v0.b;
						var form = _v8.b;
						var values = _v8.c;
						var template = _v8.d;
						var session1 = model.gB;
						if (!model.dC) {
							var session2 = _Utils_update(
								session1,
								{
									em: A2(
										$author$project$Notification$add,
										$author$project$Notification$error('Kérlek válassz időtartamot'),
										model.gB.em)
								});
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{gB: session2}),
								$author$project$Element$CompanyContractForm$Cmd(
									$author$project$Element$CompanyContractForm$ScrollTo('#payment')),
								$elm$core$Maybe$Nothing);
						} else {
							if (!model.dm) {
								var session2 = _Utils_update(
									session1,
									{
										em: A2(
											$author$project$Notification$add,
											$author$project$Notification$error('Kérlek válassz utalási módot'),
											model.gB.em)
									});
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{gB: session2}),
									$author$project$Element$CompanyContractForm$Cmd(
										$author$project$Element$CompanyContractForm$ScrollTo('#payment')),
									$elm$core$Maybe$Nothing);
							} else {
								if (A2($author$project$Element$CompanyContractForm$isFormValid, form, values)) {
									var installments = function () {
										if (model.b5) {
											var _v9 = template.l_;
											if (!_v9.$) {
												var i = _v9.a;
												return {
													he: i.he,
													hf: i.hf,
													hV: $elm$core$Maybe$Just(i.hV),
													hW: $elm$core$Maybe$Just(i.hW)
												};
											} else {
												return {he: template.lM, hf: template.lv, hV: $elm$core$Maybe$Nothing, hW: $elm$core$Maybe$Nothing};
											}
										} else {
											return {he: template.lM, hf: template.lv, hV: $elm$core$Maybe$Nothing, hW: $elm$core$Maybe$Nothing};
										}
									}();
									var data = {iK: values.iK, iL: values.iL, ly: template.ly, he: installments.he, hf: installments.hf, ja: model.ja, jX: values.jX, jY: values.jY, hV: installments.hV, hW: installments.hW, nN: template.nN, ku: values.ku};
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{
												bk: A4($author$project$Element$CompanyContractForm$FormPage, 2, form, values, template)
											}),
										$author$project$Element$CompanyContractForm$Cmd(
											$author$project$Element$CompanyContractForm$CreateCompanyContract(
												A4($author$project$CompanyContract$createNewCompanyContract2, model.b_, model.dE, data, $author$project$Element$CompanyContractForm$CompanyContractCreated))),
										$elm$core$Maybe$Nothing);
								} else {
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{
												bk: A4(
													$author$project$Element$CompanyContractForm$FormPage,
													1,
													$author$project$Element$CompanyContractForm$validateForm(form),
													values,
													template)
											}),
										$author$project$Element$CompanyContractForm$Cmd(
											$author$project$Element$CompanyContractForm$ScrollTo('div[class~=has-errors]')),
										$elm$core$Maybe$Nothing);
								}
							}
						}
					} else {
						break _v0$17;
					}
				case 3:
					var includeStartupFee = _v0.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ja: !includeStartupFee}),
						$author$project$Element$CompanyContractForm$Cmd(
							$author$project$Element$CompanyContractForm$FetchNewCompanyContractTemplate(
								A5($author$project$CompanyContract$fetchNewCompanyContractTemplate2, model.b_.gX, model.dE, !includeStartupFee, model.fV, $author$project$Element$CompanyContractForm$CompanyContractTemplateDownloaded))),
						$elm$core$Maybe$Nothing);
				case 4:
					if (_v0.b.$ === 4) {
						var payInInstallments = _v0.a.a;
						var _v10 = _v0.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b5: payInInstallments}),
							$author$project$Element$CompanyContractForm$Cmd(
								$author$project$Element$CompanyContractForm$ScrollTo('#payment')),
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$17;
					}
				case 8:
					if (_v0.b.$ === 4) {
						var paymentApproved = _v0.a.a;
						var _v11 = _v0.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{dm: paymentApproved}),
							$author$project$Element$CompanyContractForm$Cmd(
								$author$project$Element$CompanyContractForm$ScrollTo('#finish-buttons')),
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$17;
					}
				case 9:
					if (_v0.b.$ === 4) {
						var startDateApproved = _v0.a.a;
						var _v12 = _v0.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{dC: startDateApproved}),
							$author$project$Element$CompanyContractForm$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$17;
					}
				case 6:
					var studentApproved = _v0.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cS: studentApproved}),
						$author$project$Element$CompanyContractForm$Cmd(
							$author$project$Element$CompanyContractForm$ScrollTo('#finish-buttons')),
						$elm$core$Maybe$Nothing);
				case 7:
					var amountApproved = _v0.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ch: amountApproved}),
						$author$project$Element$CompanyContractForm$Cmd(
							$author$project$Element$CompanyContractForm$ScrollTo('#finish-buttons')),
						$elm$core$Maybe$Nothing);
				case 5:
					var customStartDate = _v0.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fV: $elm$core$Maybe$Just(customStartDate),
								dC: false,
								cQ: false
							}),
						$author$project$Element$CompanyContractForm$Cmd(
							$author$project$Element$CompanyContractForm$FetchNewCompanyContractTemplate(
								A5(
									$author$project$CompanyContract$fetchNewCompanyContractTemplate2,
									model.b_.gX,
									model.dE,
									model.ja,
									$elm$core$Maybe$Just(customStartDate),
									$author$project$Element$CompanyContractForm$CompanyContractTemplateDownloaded))),
						$elm$core$Maybe$Nothing);
				case 12:
					var _v13 = _v0.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cQ: !model.cQ}),
						$author$project$Element$CompanyContractForm$Cmd(
							$author$project$Element$CompanyContractForm$ScrollTo('.dropdown')),
						$elm$core$Maybe$Nothing);
				case 13:
					var helpOpen = _v0.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{f4: helpOpen}),
						$author$project$Element$CompanyContractForm$NoEffect,
						$elm$core$Maybe$Nothing);
				case 10:
					switch (_v0.a.a.$) {
						case 2:
							var contract = _v0.a.a.a;
							var session1 = model.gB;
							var session2 = _Utils_update(
								session1,
								{
									em: A2(
										$author$project$Notification$add,
										$author$project$Notification$ok('A támogatási szerződés sikeresen létrejött'),
										model.gB.em)
								});
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bk: $author$project$Element$CompanyContractForm$SuccessPage(contract),
										gB: session2
									}),
								$author$project$Element$CompanyContractForm$NoEffect,
								$elm$core$Maybe$Nothing);
						case 3:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{bk: $author$project$Element$CompanyContractForm$ErrorPage}),
								$author$project$Element$CompanyContractForm$NoEffect,
								$elm$core$Maybe$Nothing);
						default:
							break _v0$17;
					}
				default:
					break _v0$17;
			}
		}
		return _Utils_Tuple3(model, $author$project$Element$CompanyContractForm$NoEffect, $elm$core$Maybe$Nothing);
	});
var $author$project$Locale$Messages$CompanyContractTemplateCrunching = {$: 666};
var $author$project$Locale$Messages$MainErrorGeneral = {$: 174};
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$UI$notification = function (children) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('notification is-link is-light')
			]),
		children);
};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$progress = _VirtualDom_node('progress');
var $author$project$UI$progressBar = F2(
	function (style, message) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hero')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hero-body')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('content')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('title is-5 is-spaced'),
													$elm$html$Html$Attributes$for('progressbar')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(message)
												]))
										])),
									A2(
									$elm$html$Html$progress,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('progressbar'),
											$elm$html$Html$Attributes$class('progress is-medium'),
											$elm$html$Html$Attributes$class(style)
										]),
									_List_fromArray(
										[$author$project$UI$none]))
								]))
						]))
				]));
	});
var $author$project$Element$CompanyContractForm$ConsentAccepted = {$: 2};
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$UI$panelBlock = function (block) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panel-block')
			]),
		_List_fromArray(
			[block]));
};
var $author$project$UI$panel = function (_v0) {
	var theme = _v0.ie;
	var dataTag = _v0.cm;
	var heading = _v0.hl;
	var tabs = _v0.h7;
	var blocks = _v0.g$;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panel'),
				$elm$html$Html$Attributes$class(theme),
				$author$project$UI$attrCyData(dataTag)
			]),
		A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel-heading')
					]),
				heading),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$nav,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel-tabs')
						]),
					tabs),
				A2($elm$core$List$map, $author$project$UI$panelBlock, blocks))));
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$UI$submitButton = F4(
	function (label, disabled_, loading, toMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('control')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-link'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('is-loading', loading)
								])),
							$elm$html$Html$Attributes$disabled(disabled_),
							$author$project$UI$attrCyData('save'),
							$elm$html$Html$Events$onClick(toMsg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				]));
	});
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Element$CompanyContractForm$viewContractPreviewPanel = function (maybeContract) {
	var noValue = -999;
	var contractSection = F2(
		function (title, paragraphs) {
			return A2(
				$elm$html$Html$p,
				_List_Nil,
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2($elm$html$Html$br, _List_Nil, _List_Nil)
						]),
					A2(
						$elm$core$List$intersperse,
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						paragraphs)));
		});
	var contract = function () {
		if (!maybeContract.$) {
			var c = maybeContract.a;
			return c;
		} else {
			return {iK: '_______________', iL: '_______________', ly: '_______________', he: noValue, hf: '_______________', ja: false, jX: '_______________', jY: '_______________', hV: $elm$core$Maybe$Nothing, hW: $elm$core$Maybe$Nothing, nN: '_______________', ku: '_______________'};
		}
	}();
	var fullAmount = _Utils_eq(contract.hV, $elm$core$Maybe$Nothing) ? contract.he : (contract.he + A2($elm$core$Maybe$withDefault, 0, contract.hV));
	return $author$project$UI$panel(
		{
			g$: _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content mx-6 my-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-text-centered')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('TÁMOGATÁSI SZERZŐDÉS')
								])),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('amely létrejött egyrészről:'),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ml-6')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('cégnév: ' + contract.iL),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$elm$html$Html$text('székhely: ' + contract.iK),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$elm$html$Html$text('adószám: ' + contract.ku),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$elm$html$Html$text('a cég törvényes képviselőjének neve (aki a jelen szerződést megköti a cég nevében): ' + contract.jY),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$elm$html$Html$text('a cég törvényes képviselőjének email címe: ' + contract.jX)
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('- a továbbiakban: Támogató -')
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('másrészről a BPS Tanulók Egyesülete'),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ml-6')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Székhely: 8172 Balatonakarattya, Radnóti Miklós utca 11.'),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$elm$html$Html$text('Nyilvántartási szám: 19-02-0003686'),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$elm$html$Html$text('Adószám: 18846429-1-19'),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$elm$html$Html$text('Képviselő: Halácsy Péter'),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$elm$html$Html$text('Bankszámla szám: 16200151-18534056'),
											A2($elm$html$Html$br, _List_Nil, _List_Nil)
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('- a továbbiakban: Támogatott, együtt Felek -')
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('között a mai napon, az alábbi feltételekkel:')
								])),
							A2(
							contractSection,
							'1. Az Egyesület célja',
							_List_fromArray(
								[
									$elm$html$Html$text('Az Egyesület alapvető célja az óvodás- és iskoláskorú gyermekek oktatásának, nevelésének segítése, az oktatás-nevelés színvonalának elősegítése, ehhez szükséges feltételek, megfelelő környezet megteremtése, biztosítása, támogatása, a kapcsolódó tudományos kutatásokban való aktív részvétel.'),
									$elm$html$Html$text('Az Egyesület célul tűzi ki a kapcsolattartást, koordinációt iskolákkal, oktatási-nevelési intézményekkel, szakmai szervezetekkel, tudásközpontokkal és kutatókkal.'),
									$elm$html$Html$text('Az Egyesület a fentiek hatékony megvalósítása érdekében célul tűzi ki továbbá a szükséges tárgyi-technikai feltételek biztosítását, pénz- és egyéb javak gyűjtését, gyakorlati tudás és kutatási eredmények szakmai célú terjesztését.')
								])),
							A2(
							contractSection,
							'2. A Szerződés tárgya',
							_List_fromArray(
								[
									$elm$html$Html$text('A szerződés tárgya vissza nem térítendő támogatás biztosítása a Támogatott részére oktatási programjának végrehajtása érdekében.')
								])),
							A2(
							contractSection,
							'3. A támogatás',
							_List_fromArray(
								[
									$elm$html$Html$text(
									'A Támogató összesen ' + ((_Utils_eq(fullAmount, noValue) ? '_______________' : $elm$core$String$fromInt(fullAmount)) + ' forint vissza nem térítendő támogatást nyújt.')),
									$elm$html$Html$text('A támogatási időszak kezdete: ' + (contract.nN + (', vége: ' + (contract.ly + '.'))))
								])),
							A2(
							contractSection,
							'3.1. A támogatás folyósítása',
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('3.1.1. A támogatás folyósításának első (egyösszegű fizetés esetén egyetlen) részletének')
										])),
									$elm$html$Html$text(
									' - összege: ' + (_Utils_eq(contract.he, noValue) ? '_______________ forint' : ($elm$core$String$fromInt(contract.he) + ' forint'))),
									$elm$html$Html$text(' - határideje: ' + contract.hf)
								])),
							A2(
							contractSection,
							'3.1.2. A támogatás folyósításának második részletének',
							_List_fromArray(
								[
									$elm$html$Html$text(
									' - összege: ' + function () {
										var _v0 = contract.hV;
										if (!_v0.$) {
											var amount = _v0.a;
											return $elm$core$String$fromInt(amount) + ' Ft';
										} else {
											return '_______________';
										}
									}()),
									$elm$html$Html$text(
									' - határideje: ' + A2($elm$core$Maybe$withDefault, '_______________', contract.hW)),
									$elm$html$Html$text('(A jelen, 3.1.2. pont az egyösszegű támogatások esetén kitöltetlenül hagyandó.)')
								])),
							A2(
							contractSection,
							'3.1.3.',
							_List_fromArray(
								[
									$elm$html$Html$text('Amennyiben nem érkezik be a teljes támogatási összeg-részlet a fenti fizetési határidőt követő legkésőbb 30 napon belül, a szerződés automatikusan, visszamenőlegesen felbontásra kerül.')
								])),
							A2(
							contractSection,
							'4. A támogatással kapcsolatos egyéb rendelkezések.',
							_List_fromArray(
								[
									$elm$html$Html$text('Támogatott a támogatást köszönettel elfogadja. Kijelenti, hogy arról és annak felhasználásáról nyilvántartást vezet. A Támogatott a kapott támogatást az Egyesület céljai elérése érdekében használja fel. Támogatott a támogatásért nem köteles Támogató részére szolgáltatás vagy kedvezmény nyújtására. A Támogatott kijelenti, hogy vállalkozási tevékenységet nem végez. A Támogatott nem közhasznú szervezet, így a támogatás társasági adókedvezményre nem jogosít.'),
									$elm$html$Html$text('A Támogató saját hatáskörében és a saját kockázatára végzi a támogatás könyvelését.')
								])),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-text-centered')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('[dátum és aláírások a digitális felület szerint]')
								]))
						]))
				]),
			cm: 'profile-contract',
			hl: _List_fromArray(
				[
					$elm$html$Html$text('Támogatási szerződés tartalma')
				]),
			h7: _List_Nil,
			ie: 'is-light'
		});
};
var $author$project$Element$CompanyContractForm$viewConsentPage = function () {
	var contractRulesPanel = $author$project$UI$panel(
		{
			g$: _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content mx-6 my-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-text-centered')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Rendszeres, éves támogatási szerződés megkötésének szabályai')
								])),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('A családok, és hozzájuk kapcsolódó cégek jelentős mértékben nyújtanak támogatást a BPS részére. Eljutottunk oda, hogy a rendszeres, éves támogatásokhoz kapcsolódó támogatási szerződéseket automatikusan, egy egyszerű form kitöltésével tudják megkötni azok a szülők, akiknek gyerekük a BPS-be jár. Ezzel egy kiszámíthatóbb, gyorsabb rendszert építünk, amely rendszer meghatározott mechanizmusok alapján működik. Ezért szükség van néhány szabályra a szülőkhöz kapcsolódó cégek által kötött rendszeres, éves támogatási szerződések megkötésére:')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('1. Minden rendszeres, éves támogatási szerződés (\"támogatási szerződés\") kapcsán a támogatási időszak a megkötést követő hónap 1. napjával kezdődik, és a tanév utolsó napjáig tart. Az adott tanévre támogatási szerződést január 20. napjáig köthető.'),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text('- Ez különösen azt is jelenti, hogy nem kötünk visszamenőleges hatállyal támogatási szerződést.')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('2. Támogatási szerződés megkötésének feltétele, hogy az azt kötő szülő gyereke tekintetében ne legyen fennálló tartozás a BPS felé.'),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text('- A tartozás rendezését követően 1 hét átfutási idővel kell számolni, utána köthető támogatási szerződés.')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('3. Egész éves vagy féléves részletfizetés lehetséges.'),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text('- Azaz ritkább részletfizetés nem.'),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text('- A második részlet mindig a márciustól augusztusig tartó második félévre vonatkozik, az első pedig a szerződés megkötésétől február végéig.')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('4. A támogatási összeget előre kell megfizetni.'),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text('- A fizetési határidő a támogatási időszak kezdetét megelőző nap.'),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text('- Két részlet esetén a második részlet fizetési határideje február 28.')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('5. Amennyiben nem érkezik be a teljes támogatási összeg-részlet határidőben, a szerződés automatikusan, visszamenőleges felbontásra kerül.')
								]))
						]))
				]),
			cm: 'profile-contract-rules',
			hl: _List_fromArray(
				[
					$elm$html$Html$text('Támogatási szerződés megkötésének szabályai')
				]),
			h7: _List_Nil,
			ie: 'is-light'
		});
	var consentButton = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('has-text-centered'),
				$author$project$UI$attrCyData('companycontract-consent')
			]),
		_List_fromArray(
			[
				A4($author$project$UI$submitButton, 'Tovább a szerződéskötéshez', false, false, $author$project$Element$CompanyContractForm$ConsentAccepted)
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('is-fullwidth')
			]),
		_List_fromArray(
			[
				$author$project$UI$notification(
				_List_fromArray(
					[
						$elm$html$Html$text('Kérlek, olvasd el figyelmesen a szerződés tartalmát és a szerződéskötés szabályait, majd kattints a „Tovább a szerződéskötéshez” gombra a folytatáshoz.')
					])),
				$author$project$Element$CompanyContractForm$viewContractPreviewPanel($elm$core$Maybe$Nothing),
				contractRulesPanel,
				consentButton
			]));
}();
var $author$project$Element$CompanyContractForm$AmountApproved = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$CompanyContractForm$FormSubmitted = {$: 1};
var $author$project$Element$CompanyContractForm$NoOp = {$: 14};
var $author$project$Element$CompanyContractForm$PaymentApproved = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$CompanyContractForm$SetCustomStartDate = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$CompanyContractForm$SetHelpOpen = function (a) {
	return {$: 13, a: a};
};
var $author$project$Element$CompanyContractForm$SetIncludeStartupFee = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$CompanyContractForm$SetPayInInstallments = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$CompanyContractForm$StartDateApproved = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$CompanyContractForm$StudentApproved = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$CompanyContractForm$ToggleStartDateDropdown = {$: 12};
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$core$String$fromList = _String_fromList;
var $author$project$Locale$Hungarian$displayHungaryMoney = function (amount) {
	var digits = $elm$core$List$reverse(
		$elm$core$String$toList(
			$elm$core$String$fromInt(amount)));
	var grouped = $elm$core$List$reverse(
		$elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, _char) {
						return ((!(!i)) && (!A2($elm$core$Basics$modBy, 3, i))) ? _List_fromArray(
							[' ', _char]) : _List_fromArray(
							[_char]);
					}),
				digits)));
	return $elm$core$String$fromList(grouped) + ' Ft';
};
var $author$project$UI$Icon$IconFaClass = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$Icon$face = function (class_) {
	return $author$project$UI$Icon$IconFaClass(class_);
};
var $author$project$UI$Icon$altText = function (attr) {
	if (attr.$ === 3) {
		var text_ = attr.a;
		return $elm$core$Maybe$Just(text_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$UI$Icon$bulmaClass = function (attr) {
	if (!attr.$) {
		var class_ = attr.a;
		return $elm$core$Maybe$Just(class_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$UI$Icon$faCategory = function (attr) {
	if (attr.$ === 1) {
		var category_ = attr.a;
		return $elm$core$Maybe$Just(category_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$UI$Icon$faClass = function (attr) {
	if (attr.$ === 2) {
		var class_ = attr.a;
		return $elm$core$Maybe$Just(class_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$UI$Icon$filterAttr = F2(
	function (getAttrValue, attributes) {
		return A2($elm$core$List$filterMap, getAttrValue, attributes);
	});
var $elm$html$Html$i = _VirtualDom_node('i');
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$UI$Icon$toClassList = function (classes) {
	return A2(
		$elm$core$List$map,
		function (class_) {
			return _Utils_Tuple2(class_, true);
		},
		classes);
};
var $author$project$UI$Icon$icon = function (attributes) {
	var categoryClass = A2(
		$elm$core$Maybe$withDefault,
		'fas',
		$elm$core$List$head(
			$elm$core$List$reverse(
				A2($author$project$UI$Icon$filterAttr, $author$project$UI$Icon$faCategory, attributes))));
	var altText_ = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			$elm$core$List$reverse(
				A2($author$project$UI$Icon$filterAttr, $author$project$UI$Icon$altText, attributes))));
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('icon'),
				$elm$html$Html$Attributes$classList(
				$author$project$UI$Icon$toClassList(
					A2($author$project$UI$Icon$filterAttr, $author$project$UI$Icon$bulmaClass, attributes)))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
						$elm$html$Html$Attributes$class(categoryClass),
						$elm$html$Html$Attributes$classList(
						$author$project$UI$Icon$toClassList(
							A2($author$project$UI$Icon$filterAttr, $author$project$UI$Icon$faClass, attributes))),
						$elm$html$Html$Attributes$title(altText_)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('is-sr-only')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(altText_)
							]))
					]))
			]));
};
var $author$project$UI$Icon$IconBulmaClass = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Icon$style = function (class_) {
	return $author$project$UI$Icon$IconBulmaClass(class_);
};
var $author$project$UI$dropDownSelect = function (config) {
	var items = config.mk;
	var selectedItem = config.nA;
	var showEmptyItem = config.nF;
	var emptyItemLabel = config.lw;
	var emptyItemSelectedMsg = config.lx;
	var itemLabel = config.mh;
	var isOpen = config.mb;
	var itemSelectedMsg = config.mi;
	var isItemActive = config.l7;
	var itemToggledMsg = config.mj;
	var emptyItem = A3(
		$author$project$UI$actionLink,
		emptyItemSelectedMsg,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dropdown-item')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(emptyItemLabel)
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('field')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(config.ea)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('control is-expanded')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dropdown '),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('is-active', isOpen)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown-trigger'),
										$elm$html$Html$Events$onClick(itemToggledMsg)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'aria-controls', 'dropdown-menu2'),
												A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true'),
												$elm$html$Html$Attributes$class('button')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															emptyItemLabel,
															A2($elm$core$Maybe$map, itemLabel, selectedItem)))
													])),
												$author$project$UI$Icon$icon(
												_List_fromArray(
													[
														$author$project$UI$Icon$face('fa-angle-down'),
														$author$project$UI$Icon$style('is-small')
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown-menu'),
										$elm$html$Html$Attributes$id('dropdown-menu2'),
										A2($elm$html$Html$Attributes$attribute, 'role', 'menu')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dropdown-content')
											]),
										_Utils_ap(
											showEmptyItem ? _List_fromArray(
												[emptyItem]) : _List_Nil,
											A2(
												$elm$core$List$map,
												function (item) {
													return A3(
														$author$project$UI$actionLink,
														itemSelectedMsg(item),
														_List_fromArray(
															[
																$elm$html$Html$Attributes$classList(
																_List_fromArray(
																	[
																		_Utils_Tuple2('dropdown-item', true),
																		_Utils_Tuple2(
																		'is-active',
																		isItemActive(item))
																	]))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																itemLabel(item))
															]));
												},
												items)))
									]))
							]))
					]))
			]));
};
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $elm$html$Html$input = _VirtualDom_node('input');
var $author$project$Form$isProcessing = function (formState) {
	return formState === 2;
};
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$Locale$Messages$FormOptional = {$: 67};
var $author$project$UI$maybe = F2(
	function (data, viewData) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$UI$none,
			A2($elm$core$Maybe$map, viewData, data));
	});
var $author$project$UI$label_ = F4(
	function (htmlTag, t_, message, field) {
		var message_ = function () {
			if (!message.$) {
				var m = message.a;
				return $elm$core$Maybe$Just(
					t_(m));
			} else {
				return field.fp ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$FormOptional));
			}
		}();
		var messageToHtml = function (m) {
			return A2(
				$author$project$UI$maybe,
				m,
				function (m_) {
					return A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('is-italic has-text-weight-light')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(m_)
							]));
				});
		};
		return A2(
			htmlTag,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('label'),
					$elm$html$Html$Attributes$for(field.og.cm)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(field.og.ea),
					messageToHtml(message_)
				]));
	});
var $author$project$UI$fieldLabel = F2(
	function (t_, field) {
		return A4($author$project$UI$label_, $elm$html$Html$label, t_, $elm$core$Maybe$Nothing, field);
	});
var $author$project$UI$Icon$check = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-check'),
			attributes));
};
var $author$project$UI$fieldValidationStatus = F2(
	function (edited, valid) {
		var _v0 = _Utils_Tuple2(edited, valid);
		if (_v0.a) {
			if (_v0.b) {
				return $author$project$UI$Icon$check(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('is-right has-text-success')
						]));
			} else {
				return $author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-exclamation-triangle'),
							$author$project$UI$Icon$style('is-right has-text-danger')
						]));
			}
		} else {
			return $author$project$UI$none;
		}
	});
var $elm$html$Html$Attributes$maxlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'maxlength',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$Attributes$readonly = $elm$html$Html$Attributes$boolProperty('readOnly');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$UI$validationClassList = F2(
	function (field, values) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		return _List_fromArray(
			[
				_Utils_Tuple2('is-danger', field.e0 && (!valid)),
				_Utils_Tuple2('is-success', field.e0 && valid)
			]);
	});
var $author$project$Form$fieldError = F2(
	function (field, values) {
		var _v0 = field.fi(
			field.fC(values));
		if (_v0.$ === 1) {
			var error = _v0.a;
			return $elm$core$Maybe$Just(error);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$UI$validationError = F2(
	function (field, values) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Form$fieldError, field, values),
			field.e0);
		if ((!_v0.a.$) && _v0.b) {
			var error = _v0.a.a;
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('help is-danger'),
						$author$project$UI$attrCyData(field.og.cm + '-error')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(error)
					]));
		} else {
			return $author$project$UI$none;
		}
	});
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$UI$editableTextField = F5(
	function (editable, maxLength, t_, field, values) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		var maxLengthAttribute = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (ml) {
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$maxlength(ml)
						]);
				},
				maxLength));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('has-errors', !valid)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$UI$fieldLabel, t_, field),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('control has-icons-left has-icons-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id(field.og.cm),
										$elm$html$Html$Attributes$class('input'),
										$elm$html$Html$Attributes$classList(
										A2($author$project$UI$validationClassList, field, values)),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('is-static', !editable)
											])),
										$elm$html$Html$Attributes$placeholder(field.og.fj),
										$elm$html$Html$Attributes$type_(field.og.ii),
										$elm$html$Html$Attributes$value(
										field.fC(values)),
										$elm$html$Html$Events$onInput(field.og.fe),
										$author$project$UI$attrCyData(field.og.cm),
										$elm$html$Html$Attributes$readonly(!editable)
									]),
								maxLengthAttribute),
							_List_Nil),
							$author$project$UI$Icon$icon(
							_List_fromArray(
								[
									$author$project$UI$Icon$face(field.og.e6),
									$author$project$UI$Icon$style('is-left')
								])),
							A2($author$project$UI$fieldValidationStatus, field.e0, valid),
							A2($author$project$UI$validationError, field, values)
						]))
				]));
	});
var $author$project$UI$textField = A2($author$project$UI$editableTextField, true, $elm$core$Maybe$Nothing);
var $author$project$UI$warning = function (children) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('notification is-warning')
			]),
		children);
};
var $author$project$Element$CompanyContractForm$viewFormPage = F6(
	function (t_, formState, form, formValues, template, model) {
		var titleWithTick = F2(
			function (titleText, showTick) {
				return A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title is-5 is-flex is-align-items-center')
						]),
					_Utils_ap(
						showTick ? _List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('icon has-text-success mr-2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$i,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fas fa-check-circle')
											]),
										_List_Nil)
									]))
							]) : _List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(titleText)
							])));
			});
		var sponsorDetails = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(titleWithTick, 'Vállalni tervezett támogatás', model.cS && model.ch),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('field ml-1')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('checkbox'),
									$author$project$UI$attrCyData('companycontract-studentapproved')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('checkbox'),
											$elm$html$Html$Attributes$checked(model.cS),
											$elm$html$Html$Events$onCheck($author$project$Element$CompanyContractForm$StudentApproved)
										]),
									_List_Nil),
									$elm$html$Html$text(' Gyerek neve: ' + (template.nU + ' — pipálj, ha helyes'))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('field ml-1')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('checkbox'),
									$author$project$UI$attrCyData('companycontract-amountapproved')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('checkbox'),
											$elm$html$Html$Attributes$checked(model.ch),
											$elm$html$Html$Events$onCheck($author$project$Element$CompanyContractForm$AmountApproved)
										]),
									_List_Nil),
									$elm$html$Html$text(
									' Havi szülői hozzájárulás: ' + ($author$project$Locale$Hungarian$displayHungaryMoney(template.lh) + ' — pipálj, ha helyes'))
								]))
						]))
				]));
		var paymentDetails = function () {
			var tabs = function () {
				var isAvailable = function () {
					var _v1 = template.l_;
					if (!_v1.$) {
						return true;
					} else {
						return false;
					}
				}();
				var disabledAttr = isAvailable ? _List_Nil : _List_fromArray(
					[
						$elm$html$Html$Attributes$disabled(true),
						$elm$html$Html$Attributes$title('A részletfizetés nem elérhető a választott időtartamhoz')
					]);
				var buttonClass = function (isSelected) {
					return $elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('button', true),
								_Utils_Tuple2('is-primary', isSelected && isAvailable),
								_Utils_Tuple2('is-selected', isSelected && isAvailable),
								_Utils_Tuple2('is-light', !isAvailable)
							]));
				};
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('buttons has-addons is-centered'),
							$elm$html$Html$Attributes$id('payment')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							A2(
								$elm$core$List$cons,
								buttonClass(!model.b5),
								_Utils_ap(
									disabledAttr,
									isAvailable ? _List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$Element$CompanyContractForm$SetPayInInstallments(false))
										]) : _List_Nil)),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('icon is-small')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fas fa-calendar-day')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('egy összegben fizetek')
										]))
								])),
							A2(
							$elm$html$Html$button,
							A2(
								$elm$core$List$cons,
								buttonClass(model.b5),
								_Utils_ap(
									disabledAttr,
									isAvailable ? _List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$Element$CompanyContractForm$SetPayInInstallments(true))
										]) : _List_Nil)),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('icon is-small')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fas fa-calendar-week')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('két részletben fizetek')
										]))
								]))
						]));
			}();
			var paymentInfoBubble = F3(
				function (title, dueDate, amount) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('notification is-light mt-4'),
								A2($elm$html$Html$Attributes$style, 'border-radius', '1rem')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('is-flex is-align-items-center mb-3')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('is-size-5')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(title)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('is-flex is-justify-content-space-between mb-1')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('has-text-grey')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Határidő:')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('has-text-weight-bold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(dueDate)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('is-flex is-justify-content-space-between')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('has-text-grey')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Fizetendő összeg:')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('has-text-weight-bold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Locale$Hungarian$displayHungaryMoney(amount))
											]))
									]))
							]));
				});
			var payUpWarning = $author$project$UI$warning(
				_List_fromArray(
					[
						$elm$html$Html$text('Amennyiben '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(template.lv)
							])),
						$elm$html$Html$text('-ig a vállalt összeg nem kerül megfizetésre, a szerződés automatikusan megszűnik - ügyelj ezért kérlek a pontos fizetésre!')
					]));
			var includeStartupFeeSwitch = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('field is-flex')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('switch is-rounded is-success')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(model.ja),
										$elm$html$Html$Events$onCheck(
										A2($elm$core$Basics$composeL, $author$project$Element$CompanyContractForm$SetIncludeStartupFee, $elm$core$Basics$not))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('check')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Az iskolaalapítási támogatás összegével emelt támogatást fizetek - pipálj, ha ezt választod')
							]))
					]));
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				function () {
					var paymentBubbles = function () {
						if (model.b5) {
							var _v0 = template.l_;
							if (!_v0.$) {
								var installments = _v0.a;
								return _List_fromArray(
									[
										A3(paymentInfoBubble, 'Első részlet', installments.hf, installments.he),
										A3(paymentInfoBubble, 'Második részlet', installments.hW, installments.hV)
									]);
							} else {
								return _List_Nil;
							}
						} else {
							return _List_fromArray(
								[
									A3(paymentInfoBubble, 'Fizetendő összeg', template.lv, template.lM)
								]);
						}
					}();
					var paymentAdjustmentControls = (!model.dm) ? _List_fromArray(
						[
							tabs,
							includeStartupFeeSwitch,
							A2($elm$html$Html$hr, _List_Nil, _List_Nil)
						]) : _List_Nil;
					var approvalButton = (!model.dm) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('has-text-centered'),
								$author$project$UI$attrCyData('companycontract-paymentapproved')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										$author$project$Element$CompanyContractForm$PaymentApproved(true)),
										$elm$html$Html$Attributes$class('button is-primary is-fullwidth')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Ezt választom')
									]))
							])) : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('has-text-centered')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										$author$project$Element$CompanyContractForm$PaymentApproved(false)),
										$elm$html$Html$Attributes$class('button is-secondary is-fullwidth')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Másik utalási módot választok')
									]))
							]));
					return A2(
						$elm$core$List$cons,
						A2(titleWithTick, 'Az utalás részletei', model.dm),
						_Utils_ap(
							paymentAdjustmentControls,
							_Utils_ap(
								paymentBubbles,
								_List_fromArray(
									[payUpWarning, approvalButton]))));
				}());
		}();
		var noSaveWarning = $author$project$UI$warning(
			_List_fromArray(
				[
					$elm$html$Html$text('A form adatait nem mentjük, amennyiben a SUBMIT nélkül kilépsz a felületről, újra kell kezdened az adatok megadását.')
				]));
		var formButtons = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('buttons is-centered'),
					$elm$html$Html$Attributes$id('finish-buttons')
				]),
			_List_fromArray(
				[
					(model.cS && model.ch) ? A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-4 mt-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('A szerződés ezen adatokkal érvényes létrejön, ha a formot a mai napon SUBMIT-eled. A formban lévő időpont adatok minden nappal változhatnak, tehát elképzelhető, hogy a holnapi napon már mások lesznek.')
						])) : $elm$html$Html$text(''),
					(model.cS && model.ch) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$UI$attrCyData('companycontract-submit')
						]),
					_List_fromArray(
						[
							A4(
							$author$project$UI$submitButton,
							'Szerződés létrehozása',
							formState !== 1,
							$author$project$Form$isProcessing(formState),
							$author$project$Element$CompanyContractForm$FormSubmitted)
						])) : $elm$html$Html$text(''),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-info'),
							$elm$html$Html$Events$onClick(
							$author$project$Element$CompanyContractForm$SetHelpOpen(true))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Kérdésem van')
						]))
				]));
		var correctDataWarning = $author$project$UI$warning(
			_List_fromArray(
				[
					$elm$html$Html$text('Kérünk ügyelj a cégadatok pontos megadására, különösen arra, hogy a cégjegyzékben bejegyzett törvényes képviselő neve szerepeljen a cég képviselőként - a form alapján létrejövő szerződést az ő emailcímére küldjük ki aláírásra.')
				]));
		var contractDetails = function () {
			var viewStartDateSelector = F3(
				function (isOpen, startDateOptions, selectedStartDate) {
					var label = $elm$core$Basics$identity;
					return $author$project$UI$dropDownSelect(
						{
							lw: '',
							lx: $author$project$Element$CompanyContractForm$NoOp,
							l7: $elm$core$Basics$eq(selectedStartDate),
							mb: isOpen,
							mh: label,
							mi: $author$project$Element$CompanyContractForm$SetCustomStartDate,
							mj: $author$project$Element$CompanyContractForm$ToggleStartDateDropdown,
							mk: startDateOptions,
							ea: '',
							nA: $elm$core$Maybe$Just(selectedStartDate),
							nF: false
						});
				});
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('is-flex is-flex-direction-column'),
						A2($elm$html$Html$Attributes$style, 'height', '100%')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('is-flex-grow-1')
							]),
						_List_fromArray(
							[
								A2(titleWithTick, 'A szerződés időtartama', model.dC),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('contract-period notification is-light is-flex is-align-items-center'),
										A2($elm$html$Html$Attributes$style, 'gap', '1rem')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												model.cQ ? A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('animate-hush-hush')
													]),
												_List_fromArray(
													[
														A3(viewStartDateSelector, model.cQ, template.nO, template.nN)
													])) : A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('is-flex is-flex-direction-column is-align-items-center is-justify-content-center m-0')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Kezdete')
															])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('m-0')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(template.nN)
															]))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'position', 'relative'),
												$elm$html$Html$Attributes$class('is-flex-grow-1'),
												A2($elm$html$Html$Attributes$style, 'height', '2px'),
												A2($elm$html$Html$Attributes$style, 'background-color', '#aaa')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
														A2($elm$html$Html$Attributes$style, 'top', '-5px'),
														A2($elm$html$Html$Attributes$style, 'left', '0'),
														A2($elm$html$Html$Attributes$style, 'width', '10px'),
														A2($elm$html$Html$Attributes$style, 'height', '10px'),
														A2($elm$html$Html$Attributes$style, 'background-color', '#555'),
														A2($elm$html$Html$Attributes$style, 'border-radius', '50%')
													]),
												_List_Nil),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
														A2($elm$html$Html$Attributes$style, 'top', '-5px'),
														A2($elm$html$Html$Attributes$style, 'right', '0'),
														A2($elm$html$Html$Attributes$style, 'width', '10px'),
														A2($elm$html$Html$Attributes$style, 'height', '10px'),
														A2($elm$html$Html$Attributes$style, 'background-color', '#555'),
														A2($elm$html$Html$Attributes$style, 'border-radius', '50%')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('is-flex is-flex-direction-column is-align-items-center is-justify-content-center m-0')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Vége')
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('m-0')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(template.ly)
													]))
											]))
									])),
								(!model.dC) ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('has-text-centered mt-2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Events$onClick(
												$author$project$Element$CompanyContractForm$StartDateApproved(true)),
												$elm$html$Html$Attributes$class('button is-primary is-fullwidth'),
												$author$project$UI$attrCyData('companycontract-startdateapproved')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Ezt választom')
											]))
									])) : $elm$html$Html$text('')
							])),
						(!model.cQ) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('control')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Element$CompanyContractForm$ToggleStartDateDropdown),
										$elm$html$Html$Attributes$class('button is-secondary is-fullwidth mt-4')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Másik kezdési időpontot választok')
									]))
							])) : $elm$html$Html$text('')
					]));
		}();
		var companyDetails = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('columns is-multiline')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column is-12')
						]),
					_List_fromArray(
						[
							A2(
							titleWithTick,
							'Cégadatok',
							A2($author$project$Element$CompanyContractForm$isFormValid, form, formValues))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column is-12'),
							$author$project$UI$attrCyData('companycontract-companyname')
						]),
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.iL, formValues)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column is-6'),
							$author$project$UI$attrCyData('companycontract-companyaddress')
						]),
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.iK, formValues)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column is-6'),
							$author$project$UI$attrCyData('companycontract-vatnumber')
						]),
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.ku, formValues)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column is-6'),
							$author$project$UI$attrCyData('companycontract-representativename')
						]),
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.jY, formValues)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column is-6'),
							$author$project$UI$attrCyData('companycontract-representativeemail')
						]),
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.jX, formValues)
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth')
				]),
			_List_fromArray(
				[
					noSaveWarning,
					correctDataWarning,
					$author$project$UI$panel(
					{
						g$: _List_fromArray(
							[
								companyDetails,
								sponsorDetails,
								(model.cS && model.ch) ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('columns is-fullwidth mt-1 mb-1')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('column is-hidden-touch'),
												A2($elm$html$Html$Attributes$style, 'border-right', '1px solid #ddd'),
												A2($elm$html$Html$Attributes$style, 'padding-right', '1.5rem')
											]),
										_List_fromArray(
											[contractDetails])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('column is-hidden-desktop')
											]),
										_List_fromArray(
											[contractDetails])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('column'),
												A2($elm$html$Html$Attributes$style, 'padding-left', '1.5rem')
											]),
										_List_fromArray(
											[paymentDetails]))
									])) : $author$project$UI$notification(
								_List_fromArray(
									[
										$elm$html$Html$text('Kérlek erősítsd meg hogy helyes a gyerek neve és a havi szülői hozzájárulás összege!')
									])),
								formButtons
							]),
						cm: 'companycontract-form',
						hl: _List_fromArray(
							[
								$elm$html$Html$text('Támogatási szerződés')
							]),
						h7: _List_Nil,
						ie: 'is-light'
					})
				]));
	});
var $author$project$Locale$Messages$BtnOk = {$: 34};
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $elm$html$Html$header = _VirtualDom_node('header');
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$UI$modalPanel = F4(
	function (title_, closeButton_, body, foot) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal is-active')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-background')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-card')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$header,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal-card-head')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('modal-card-title')
										]),
									title_),
								closeButton_)),
							A2(
							$elm$html$Html$section,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal-card-body')
								]),
							body),
							A2(
							$elm$html$Html$footer,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal-card-foot buttons')
								]),
							foot)
						]))
				]));
	});
var $author$project$UI$confirmDialogWithoutDecline_ = F5(
	function (isBtnOkEnabled, t_, config, title_, content) {
		return A4(
			$author$project$UI$modalPanel,
			title_,
			_List_Nil,
			content,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-primary'),
							$elm$html$Html$Events$onClick(config.lc),
							$elm$html$Html$Attributes$disabled(!isBtnOkEnabled),
							$author$project$UI$attrCyData('confirm')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnOk)
						]))
				]));
	});
var $author$project$UI$confirmDialogWithoutDecline = $author$project$UI$confirmDialogWithoutDecline_(true);
var $author$project$Element$CompanyContractForm$viewHelpDialog = function (t_) {
	return A4(
		$author$project$UI$confirmDialogWithoutDecline,
		t_,
		{
			lc: $author$project$Element$CompanyContractForm$SetHelpOpen(false)
		},
		_List_fromArray(
			[
				$elm$html$Html$text('Kérdésem van')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Írj emailt az '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('mailto:tamogatasi@budapestschool.org')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('tamogatasi@budapestschool.org')
							])),
						$elm$html$Html$text('-ra.')
					]))
			]));
};
var $author$project$Element$CompanyContractForm$view = function (model) {
	var session = model.gB;
	var page = model.bk;
	switch (page.$) {
		case 4:
			var formState = page.a;
			var form = page.b;
			var values = page.c;
			var template = page.d;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A6($author$project$Element$CompanyContractForm$viewFormPage, session.h6, formState, form, values, template, model),
						A2(
						$author$project$UI$when,
						model.f4,
						$author$project$Element$CompanyContractForm$viewHelpDialog(session.h6))
					]));
		case 2:
			return $author$project$Element$CompanyContractForm$viewConsentPage;
		case 1:
			return A2(
				$author$project$UI$progressBar,
				'is-primary',
				session.h6($author$project$Locale$Messages$CompanyContractTemplateCrunching));
		case 0:
			return $author$project$UI$notification(
				_List_fromArray(
					[
						A2($author$project$UI$caption, session.h6, $author$project$Locale$Messages$MainErrorGeneral)
					]));
		default:
			var contract = page.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$UI$notification(
						_List_fromArray(
							[
								$elm$html$Html$text('A támogatási szerződés sikeresen létrejött.'),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text('Kérlek, ellenőrizd az e-mailjeidet, és írd alá a szerződést az eszerzodes.hu felületén!')
							])),
						$author$project$Element$CompanyContractForm$viewContractPreviewPanel(
						$elm$core$Maybe$Just(contract))
					]));
	}
};
var $author$project$Element$CompanyContractForm$element = {jb: $author$project$Element$CompanyContractForm$init, hP: $author$project$Element$CompanyContractForm$perform, ks: $author$project$Element$CompanyContractForm$update, og: $author$project$Element$CompanyContractForm$view};
var $author$project$Form$Create = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$Counter$NoEffect = {$: 0};
var $author$project$Element$Counter$animalOptions = _List_fromArray(
	[
		_Utils_Tuple2('bárány', 'bárány'),
		_Utils_Tuple2('kecske', 'kecske'),
		_Utils_Tuple2('ökör', 'ökör'),
		_Utils_Tuple2('galamb', 'galamb'),
		_Utils_Tuple2('nyúl', 'nyúl')
	]);
var $author$project$Locale$Messages$NOTRANS = function (a) {
	return {$: 0, a: a};
};
var $author$project$Multiselect$Hide = 1;
var $author$project$Multiselect$defaultConfig = {dc: 1, ma: true, n0: 'id_multiselect', eI: _List_Nil};
var $author$project$Multiselect$Closed = 0;
var $author$project$Multiselect$Model = $elm$core$Basics$identity;
var $author$project$Multiselect$initModel = function (config) {
	var values = config.eI;
	var inputInMenu = config.dc;
	return {
		lz: $elm$core$Maybe$Nothing,
		M: values,
		P: $elm$core$List$head(values),
		_: $elm$core$Maybe$Just(''),
		dc: inputInMenu,
		f5: 23.0,
		ma: config.ma,
		bT: false,
		D: _List_Nil,
		S: 0,
		n0: config.n0,
		eI: values
	};
};
var $author$project$Form$toMultiselectValues = function (options) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$elm$core$List$map(
				function (option) {
					return _Utils_Tuple2(option.fC, option.ea);
				}),
			options));
};
var $author$project$Element$Counter$initAnimalField = function (options) {
	var defaultConfig = $author$project$Multiselect$defaultConfig;
	return $author$project$Multiselect$initModel(
		_Utils_update(
			defaultConfig,
			{
				ma: false,
				n0: 'Animal',
				eI: $author$project$Form$toMultiselectValues(options)
			}));
};
var $author$project$Locale$Messages$FormRequiredSelection = {$: 73};
var $author$project$Form$requiredChoice = F3(
	function (t_, blankValue, value) {
		return _Utils_eq(blankValue, value) ? $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormRequiredSelection)) : $elm$core$Result$Ok(value);
	});
var $author$project$Form$mapMultiselect = F2(
	function (updateState, field) {
		var view = field.og;
		return _Utils_update(
			field,
			{
				og: _Utils_update(
					view,
					{
						fs: updateState(view.fs)
					})
			});
	});
var $author$project$Multiselect$getValues = function (_v0) {
	var model = _v0;
	return model.eI;
};
var $author$project$Multiselect$valuesWithoutSelected = function (_v0) {
	var selected = _v0.D;
	var values = _v0.eI;
	return A2(
		$elm$core$List$filter,
		function (value) {
			return !A2($elm$core$List$member, value, selected);
		},
		values);
};
var $author$project$Multiselect$populateValues = F3(
	function (_v0, values, selected) {
		var model = _v0;
		var filtered = $elm$core$List$isEmpty(selected) ? values : $author$project$Multiselect$valuesWithoutSelected(
			{D: selected, eI: values});
		return _Utils_update(
			model,
			{M: filtered, D: selected, eI: values});
	});
var $author$project$Form$setMultiselectSelection_ = F2(
	function (selected, state) {
		return A3(
			$author$project$Multiselect$populateValues,
			state,
			$author$project$Multiselect$getValues(state),
			selected);
	});
var $author$project$Form$setMultiselectSelection = F2(
	function (options, field) {
		var selected = $author$project$Form$toMultiselectValues(
			$elm$core$Maybe$Just(options));
		return A2(
			$author$project$Form$mapMultiselect,
			$author$project$Form$setMultiselectSelection_(selected),
			field);
	});
var $author$project$Element$Counter$buildForm = F2(
	function (t_, animalSelectOptions) {
		var selectedFirstOption = $elm$core$List$head(animalSelectOptions);
		var animalField = {
			e0: false,
			fi: A2($author$project$Form$requiredChoice, t_, '!!!'),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aN: value});
				}),
			fC: function ($) {
				return $.aN;
			},
			og: {
				cm: 'animal',
				e6: 'fa-cube',
				ea: t_(
					$author$project$Locale$Messages$NOTRANS('Milyen állatot szeretnél számolni?')),
				m_: $elm$core$Maybe$Just(animalSelectOptions),
				fs: $author$project$Element$Counter$initAnimalField(
					$elm$core$Maybe$Just(animalSelectOptions)),
				cf: $author$project$Element$Counter$AnimalMsg
			}
		};
		return {
			aN: A2(
				$author$project$Form$setMultiselectSelection,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (o) {
							return _List_fromArray(
								[o]);
						},
						selectedFirstOption)),
				animalField)
		};
	});
var $author$project$Element$Counter$emptyForm = {aN: 'bárány'};
var $author$project$Form$toSelectOption = function (_v0) {
	var value = _v0.a;
	var label = _v0.b;
	return {ea: label, fC: value};
};
var $author$project$Form$toSelectOptions = function (choices) {
	return A2($elm$core$List$map, $author$project$Form$toSelectOption, choices);
};
var $author$project$Element$Counter$init = F3(
	function (config, session, count) {
		return _Utils_Tuple3(
			{
				bC: {
					iq: $author$project$Form$Create(0),
					bE: A2(
						$author$project$Element$Counter$buildForm,
						session.h6,
						$author$project$Form$toSelectOptions($author$project$Element$Counter$animalOptions)),
					fs: 0,
					eI: $author$project$Element$Counter$emptyForm
				},
				b_: config,
				dZ: A2(
					$elm$core$Maybe$withDefault,
					$elm$core$String$length(session.ok.lI),
					count),
				gB: session
			},
			$author$project$Element$Counter$NoEffect,
			$elm$core$Maybe$Nothing);
	});
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $author$project$Multiselect$domScrollToY = F2(
	function (id, y) {
		return A2(
			$elm$core$Task$andThen,
			function (vp) {
				return A3($elm$browser$Browser$Dom$setViewportOf, id, vp.ky.on, y);
			},
			$elm$browser$Browser$Dom$getViewportOf(id));
	});
var $author$project$Multiselect$domScrollY = function (id) {
	return A2(
		$elm$core$Task$map,
		function (vp) {
			return vp.ky.oq;
		},
		$elm$browser$Browser$Dom$getViewportOf(id));
};
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Multiselect$perform = function (effect) {
	switch (effect.$) {
		case 0:
			return $elm$core$Platform$Cmd$none;
		case 1:
			var effects = effect.a;
			return $elm$core$Platform$Cmd$batch(
				A2($elm$core$List$map, $author$project$Multiselect$perform, effects));
		case 2:
			var elementName = effect.a;
			var toMsg = effect.b;
			return A2(
				$elm$core$Task$attempt,
				toMsg,
				$elm$browser$Browser$Dom$focus(elementName));
		case 3:
			var elementName = effect.a;
			var toMsg = effect.b;
			return A2(
				$elm$core$Task$attempt,
				toMsg,
				$author$project$Multiselect$domScrollY(elementName));
		case 4:
			var elementName = effect.a;
			var y = effect.b;
			var toMsg = effect.c;
			return A2(
				$elm$core$Task$attempt,
				toMsg,
				A2($author$project$Multiselect$domScrollToY, elementName, y));
		default:
			var ms = effect.a;
			var toMsg = effect.b;
			return A2(
				$elm$core$Task$perform,
				$elm$core$Basics$always(toMsg),
				$elm$core$Process$sleep(ms));
	}
};
var $author$project$Element$Counter$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var toMsg = effect.a;
				var effect_ = effect.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					toMsg,
					$author$project$Multiselect$perform(effect_));
			case 2:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$Counter$perform(key),
						effects));
			default:
				var cmd = effect.a;
				if (!cmd.$) {
					var request = cmd.a;
					return $author$project$Api$postV2(request);
				} else {
					var route = cmd.a;
					return A2($author$project$Route$replaceUrl, key, route);
				}
		}
	});
var $author$project$Element$Counter$Animal = $elm$core$Basics$identity;
var $author$project$Element$Counter$MultiselectEffect = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Multiselect$getSelectedValues = function (_v0) {
	var model = _v0;
	return model.D;
};
var $author$project$Form$getMultiselectFieldSelectedValue = function (field) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			$elm$core$List$head(
				$author$project$Multiselect$getSelectedValues(field.og.fs))));
};
var $author$project$Element$Counter$Balance = $elm$core$Basics$identity;
var $author$project$Element$Counter$BatchEffect = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$Counter$Cmd = function (a) {
	return {$: 3, a: a};
};
var $author$project$Locale$Messages$CounterClickCount = F2(
	function (a, b) {
		return {$: 41, a: a, b: b};
	});
var $author$project$Element$Counter$LogOk = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$Counter$NoOp = {$: 0};
var $author$project$Element$Counter$UpdateUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Log$msgClick = 'click';
var $author$project$Log$encodeLogEvent = F2(
	function (maxLength, event) {
		var normalizedMessage = A3(
			$elm$core$String$slice,
			0,
			maxLength,
			$author$project$Log$removeWhitespaces(event.cz));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'client_id',
					$elm$json$Json$Encode$string(event.iJ)),
					_Utils_Tuple2(
					'client_version',
					$elm$json$Json$Encode$string(event.c$)),
					_Utils_Tuple2(
					'level',
					$elm$json$Json$Encode$string(
						$author$project$Log$logLevelToString(event.di))),
					_Utils_Tuple2(
					'event_name',
					$elm$json$Json$Encode$string(
						$author$project$Log$logEventNameToString(event.cn))),
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string(normalizedMessage))
				]));
	});
var $author$project$Log$okV2 = F3(
	function (config, _v0, toMsg) {
		var eventName = _v0.a;
		var messages = _v0.b;
		var event = {
			iJ: config.gX.hD,
			c$: config.g0,
			cn: eventName,
			di: 1,
			cz: A2($elm$core$String$join, $author$project$Log$msgSeperator, messages)
		};
		return {
			T: A2($author$project$Log$encodeLogEvent, config.gX.hE, event),
			b_: config,
			d_: $elm$json$Json$Decode$succeed(0),
			cf: toMsg,
			K: $author$project$Api$Endpoint$log(config.gX)
		};
	});
var $author$project$Element$Counter$updateCounter = F2(
	function (counter, model) {
		var session = model.gB;
		var updateUrlCmd = $author$project$Element$Counter$Cmd(
			$author$project$Element$Counter$UpdateUrl(
				$author$project$Route$Counter(
					$elm$core$Maybe$Just(counter))));
		var reply = counter;
		var logCmd = $author$project$Element$Counter$Cmd(
			$author$project$Element$Counter$LogOk(
				A3(
					$author$project$Log$okV2,
					model.b_,
					_Utils_Tuple2(
						$author$project$Log$msgClick,
						_List_fromArray(
							[
								$elm$core$String$fromInt(counter)
							])),
					$elm$core$Basics$always($author$project$Element$Counter$NoOp))));
		var animal = $author$project$Form$getMultiselectFieldSelectedValue(model.bC.bE.aN);
		var model2 = _Utils_update(
			model,
			{
				dZ: counter,
				gB: A2(
					$author$project$Session$ok,
					model.gB,
					session.h6(
						A2($author$project$Locale$Messages$CounterClickCount, animal, counter)))
			});
		return _Utils_Tuple3(
			model2,
			$author$project$Element$Counter$BatchEffect(
				_List_fromArray(
					[logCmd, updateUrlCmd])),
			$elm$core$Maybe$Just(reply));
	});
var $author$project$Element$Counter$updateForm = F2(
	function (msg, formPage) {
		var form = formPage.bE;
		var values = formPage.eI;
		var editedFormPage = _Utils_update(
			formPage,
			{fs: 1});
		var value = msg;
		return _Utils_update(
			editedFormPage,
			{
				bE: _Utils_update(
					form,
					{
						aN: $author$project$Form$markEdited(form.aN)
					}),
				eI: A2(
					form.aN.ks,
					A2($elm$core$Maybe$withDefault, '???', value),
					values)
			});
	});
var $author$project$Multiselect$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Multiselect$Cleared = {$: 2};
var $author$project$Multiselect$DisableProtection = {$: 3};
var $author$project$Multiselect$DomScrollToY = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Multiselect$DomScrollY = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Multiselect$NoEffect = {$: 0};
var $author$project$Multiselect$NotFound = function (a) {
	return {$: 3, a: a};
};
var $author$project$Multiselect$ScrollResult = function (a) {
	return {$: 9, a: a};
};
var $author$project$Multiselect$ScrollY = function (a) {
	return {$: 14, a: a};
};
var $author$project$Multiselect$Selected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Multiselect$Show = 0;
var $author$project$Multiselect$Unselected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Multiselect$addSelected = F2(
	function (item, model) {
		return model.ma ? _Utils_ap(
			model.D,
			_List_fromArray(
				[item])) : _List_fromArray(
			[item]);
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Multiselect$Keycodes$backspace = 8;
var $author$project$Multiselect$Sleep = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Multiselect$delayInMs = F2(
	function (ms, msg) {
		return A2($author$project$Multiselect$Sleep, ms, msg);
	});
var $author$project$Multiselect$Keycodes$downArrow = 40;
var $author$project$Multiselect$Keycodes$end = 35;
var $author$project$Multiselect$Keycodes$escape = 27;
var $author$project$Multiselect$fitViewPort = F2(
	function (_v0, _v1) {
		var top = _v0.a;
		var bottom = _v0.b;
		var vpTop = _v1.a;
		var vpBottom = _v1.b;
		return (_Utils_cmp(top, vpTop) < 0) ? top : ((_Utils_cmp(bottom, vpBottom) > 0) ? (vpTop + (bottom - vpBottom)) : vpTop);
	});
var $author$project$Multiselect$FocusInput = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Multiselect$FocusResult = function (a) {
	return {$: 8, a: a};
};
var $author$project$Multiselect$focusInput = function (model) {
	return A2($author$project$Multiselect$FocusInput, 'multiselectInput' + model.n0, $author$project$Multiselect$FocusResult);
};
var $author$project$Multiselect$SelectCss$itemHeight = 32;
var $author$project$Multiselect$getBoundaries = function (i) {
	return _Utils_Tuple2(i * $author$project$Multiselect$SelectCss$itemHeight, (i * $author$project$Multiselect$SelectCss$itemHeight) + $author$project$Multiselect$SelectCss$itemHeight);
};
var $author$project$Multiselect$SelectCss$menuHeight = 150;
var $author$project$Multiselect$getViewPortBoundaries = function (i) {
	return _Utils_Tuple2(i, i + $author$project$Multiselect$SelectCss$menuHeight);
};
var $author$project$Multiselect$Keycodes$home = 36;
var $author$project$Multiselect$indexOf = F2(
	function (el, list) {
		var helper = F2(
			function (l, index) {
				helper:
				while (true) {
					if (!l.b) {
						return $elm$core$Maybe$Nothing;
					} else {
						var x = l.a;
						var xs = l.b;
						if (_Utils_eq(x, el)) {
							return $elm$core$Maybe$Just(index);
						} else {
							var $temp$l = xs,
								$temp$index = index + 1;
							l = $temp$l;
							index = $temp$index;
							continue helper;
						}
					}
				}
			});
		return A2(helper, list, 0);
	});
var $author$project$Multiselect$lastElem = A2(
	$elm$core$List$foldl,
	A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$always),
	$elm$core$Maybe$Nothing);
var $author$project$Multiselect$nextItem = F2(
	function (list, item) {
		var findNextInList = function (l) {
			findNextInList:
			while (true) {
				if (!l.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					if (!l.b.b) {
						var x = l.a;
						return _Utils_eq(x, item) ? $elm$core$List$head(list) : $elm$core$Maybe$Nothing;
					} else {
						var x = l.a;
						var _v1 = l.b;
						var y = _v1.a;
						var rest = _v1.b;
						if (_Utils_eq(x, item)) {
							return $elm$core$Maybe$Just(y);
						} else {
							var $temp$l = A2($elm$core$List$cons, y, rest);
							l = $temp$l;
							continue findNextInList;
						}
					}
				}
			}
		};
		return findNextInList(list);
	});
var $author$project$Multiselect$nextSelectedItem = F2(
	function (list, item) {
		var takeLast = function (l) {
			if (!l.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				if (!l.b.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var _v3 = l.b;
					var y = _v3.a;
					return $elm$core$Maybe$Just(y);
				}
			}
		};
		var findNextInList = function (l) {
			findNextInList:
			while (true) {
				if (!l.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					if (!l.b.b) {
						var x = l.a;
						return _Utils_eq(x, item) ? takeLast(
							$elm$core$List$reverse(list)) : $elm$core$Maybe$Nothing;
					} else {
						var x = l.a;
						var _v1 = l.b;
						var y = _v1.a;
						var rest = _v1.b;
						if (_Utils_eq(x, item)) {
							return $elm$core$Maybe$Just(y);
						} else {
							var $temp$l = A2($elm$core$List$cons, y, rest);
							l = $temp$l;
							continue findNextInList;
						}
					}
				}
			}
		};
		return findNextInList(list);
	});
var $author$project$Multiselect$Keycodes$pageDown = 34;
var $author$project$Multiselect$Keycodes$pageUp = 33;
var $author$project$Multiselect$prevItem = F2(
	function (list, item) {
		return A2(
			$author$project$Multiselect$nextItem,
			$elm$core$List$reverse(list),
			item);
	});
var $author$project$Multiselect$Keycodes$return = 13;
var $author$project$Multiselect$Keycodes$tab = 9;
var $author$project$Multiselect$Keycodes$upArrow = 38;
var $author$project$Multiselect$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing);
			case 4:
				return (model.S === 2) ? _Utils_Tuple3(
					_Utils_update(
						model,
						{S: 0}),
					$author$project$Multiselect$focusInput(model),
					$elm$core$Maybe$Nothing) : _Utils_Tuple3(
					_Utils_update(
						model,
						{S: 2}),
					$author$project$Multiselect$focusInput(model),
					$elm$core$Maybe$Nothing);
			case 1:
				return model.bT ? _Utils_Tuple3(
					_Utils_update(
						model,
						{bT: false}),
					$author$project$Multiselect$NoEffect,
					$elm$core$Maybe$Nothing) : _Utils_Tuple3(
					_Utils_update(
						model,
						{S: 0}),
					$author$project$Multiselect$NoEffect,
					$elm$core$Maybe$Nothing);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bT: false}),
					$author$project$Multiselect$NoEffect,
					$elm$core$Maybe$Nothing);
			case 2:
				return model.bT ? _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing) : _Utils_Tuple3(
					_Utils_update(
						model,
						{bT: true, S: 2}),
					$author$project$Multiselect$BatchEffect(
						_List_fromArray(
							[
								$author$project$Multiselect$focusInput(model),
								A2($author$project$Multiselect$delayInMs, 100, $author$project$Multiselect$DisableProtection)
							])),
					$elm$core$Maybe$Nothing);
			case 9:
				var result = msg.a;
				if (result.$ === 1) {
					var id = result.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								lz: $elm$core$Maybe$Just('Could not find dom id: ' + id)
							}),
						$author$project$Multiselect$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var _v3 = model._;
					if (_v3.$ === 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									_: $elm$core$Maybe$Just('')
								}),
							$author$project$Multiselect$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lz: $elm$core$Maybe$Nothing}),
							$author$project$Multiselect$NoEffect,
							$elm$core$Maybe$Nothing);
					}
				}
			case 8:
				var result = msg.a;
				if (result.$ === 1) {
					var id = result.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								lz: $elm$core$Maybe$Just('Could not find dom id: ' + id)
							}),
						$author$project$Multiselect$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var _v5 = model._;
					if (_v5.$ === 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									_: $elm$core$Maybe$Just('')
								}),
							$author$project$Multiselect$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lz: $elm$core$Maybe$Nothing}),
							$author$project$Multiselect$NoEffect,
							$elm$core$Maybe$Nothing);
					}
				}
			case 11:
				var value = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{f5: value}),
					$author$project$Multiselect$NoEffect,
					$elm$core$Maybe$Nothing);
			case 10:
				var value = msg.a;
				if (model.bT) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bT: false}),
						$author$project$Multiselect$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var lowerValue = $elm$core$String$toLower(value);
					var valuesMatchingSearch = A2(
						$elm$core$List$filter,
						function (_v8) {
							var val = _v8.b;
							return A2(
								$elm$core$String$contains,
								lowerValue,
								$elm$core$String$toLower(val));
						},
						model.eI);
					var maybePrefixedWithValue = ((model.dc === 1) || ((value === '') || A2(
						$elm$core$List$any,
						function (_v7) {
							var val = _v7.b;
							return _Utils_eq(
								$elm$core$String$toLower(val),
								value);
						},
						valuesMatchingSearch))) ? valuesMatchingSearch : A2(
						$elm$core$List$cons,
						_Utils_Tuple2(value, value),
						valuesMatchingSearch);
					var filtered = $author$project$Multiselect$valuesWithoutSelected(
						{D: model.D, eI: maybePrefixedWithValue});
					var _v6 = model.P;
					if (_v6.$ === 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									M: filtered,
									P: $elm$core$List$head(filtered),
									_: $elm$core$Maybe$Just(value),
									S: $elm$core$List$isEmpty(filtered) ? 0 : 2
								}),
							$author$project$Multiselect$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						var item = _v6.a;
						return (!$elm$core$List$length(
							A2(
								$elm$core$List$filter,
								function (i) {
									return _Utils_eq(i, item);
								},
								filtered))) ? _Utils_Tuple3(
							_Utils_update(
								model,
								{
									M: filtered,
									P: $elm$core$List$head(filtered),
									_: $elm$core$Maybe$Just(value),
									S: $elm$core$List$isEmpty(filtered) ? 0 : 2
								}),
							$author$project$Multiselect$NoEffect,
							$elm$core$Maybe$Nothing) : _Utils_Tuple3(
							_Utils_update(
								model,
								{
									M: filtered,
									_: $elm$core$Maybe$Just(value),
									S: $elm$core$List$isEmpty(filtered) ? 0 : 2
								}),
							$author$project$Multiselect$NoEffect,
							$elm$core$Maybe$Nothing);
					}
				}
			case 5:
				var item = msg.a;
				var selected = A2($author$project$Multiselect$addSelected, item, model);
				var filtered = $author$project$Multiselect$valuesWithoutSelected(
					{D: selected, eI: model.eI});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							M: filtered,
							P: A2($author$project$Multiselect$nextSelectedItem, model.M, item),
							_: $elm$core$Maybe$Nothing,
							D: selected,
							S: ($elm$core$List$isEmpty(filtered) || (!model.ma)) ? 0 : 2
						}),
					$author$project$Multiselect$focusInput(model),
					$elm$core$Maybe$Just(
						$author$project$Multiselect$Selected(item)));
			case 6:
				var item = msg.a;
				var selected = A2(
					$elm$core$List$filter,
					function (value) {
						return !_Utils_eq(value, item);
					},
					model.D);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							M: $author$project$Multiselect$valuesWithoutSelected(
								{D: selected, eI: model.eI}),
							P: $elm$core$Maybe$Just(item),
							D: selected
						}),
					A2($author$project$Multiselect$DomScrollY, 'multiselectMenu' + model.n0, $author$project$Multiselect$ScrollY),
					$elm$core$Maybe$Just(
						$author$project$Multiselect$Unselected(item)));
			case 7:
				var selected = _List_Nil;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							M: $author$project$Multiselect$valuesWithoutSelected(
								{D: selected, eI: model.eI}),
							_: $elm$core$Maybe$Nothing,
							D: selected,
							S: 0
						}),
					$author$project$Multiselect$focusInput(model),
					$elm$core$Maybe$Just($author$project$Multiselect$Cleared));
			case 12:
				var item = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							P: $elm$core$Maybe$Just(item)
						}),
					$author$project$Multiselect$NoEffect,
					$elm$core$Maybe$Nothing);
			case 14:
				var result = msg.a;
				if (result.$ === 1) {
					var id = result.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								lz: $elm$core$Maybe$Just('Could not find dom id: ' + id)
							}),
						$author$project$Multiselect$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var y = result.a;
					var _v10 = model.P;
					if (_v10.$ === 1) {
						return _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing);
					} else {
						var item = _v10.a;
						var _v11 = A2($author$project$Multiselect$indexOf, item, model.M);
						if (_v11.$ === 1) {
							return _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing);
						} else {
							var idx = _v11.a;
							var vpBoundaries = $author$project$Multiselect$getViewPortBoundaries(y);
							var boundaries = $author$project$Multiselect$getBoundaries(idx);
							var scroll = A2($author$project$Multiselect$fitViewPort, boundaries, vpBoundaries);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{lz: $elm$core$Maybe$Nothing}),
								A3($author$project$Multiselect$DomScrollToY, 'multiselectMenu' + model.n0, scroll, $author$project$Multiselect$ScrollResult),
								$elm$core$Maybe$Nothing);
						}
					}
				}
			default:
				var key = msg.a;
				if (_Utils_eq(key, $author$project$Multiselect$Keycodes$upArrow)) {
					var _v12 = model.P;
					if (_v12.$ === 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									P: $elm$core$List$head(model.M)
								}),
							$author$project$Multiselect$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						var item = _v12.a;
						var prev = A2($author$project$Multiselect$prevItem, model.M, item);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{P: prev}),
							A2($author$project$Multiselect$DomScrollY, 'multiselectMenu' + model.n0, $author$project$Multiselect$ScrollY),
							$elm$core$Maybe$Nothing);
					}
				} else {
					if (_Utils_eq(key, $author$project$Multiselect$Keycodes$downArrow)) {
						var _v13 = model.P;
						if (_v13.$ === 1) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										P: $elm$core$List$head(model.M)
									}),
								$author$project$Multiselect$NoEffect,
								$elm$core$Maybe$Nothing);
						} else {
							var item = _v13.a;
							var next = A2($author$project$Multiselect$nextItem, model.M, item);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{P: next}),
								A2($author$project$Multiselect$DomScrollY, 'multiselectMenu' + model.n0, $author$project$Multiselect$ScrollY),
								$elm$core$Maybe$Nothing);
						}
					} else {
						if (_Utils_eq(key, $author$project$Multiselect$Keycodes$pageUp) || _Utils_eq(key, $author$project$Multiselect$Keycodes$home)) {
							var first = $elm$core$List$head(model.M);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{P: first}),
								A2($author$project$Multiselect$DomScrollY, 'multiselectMenu' + model.n0, $author$project$Multiselect$ScrollY),
								$elm$core$Maybe$Nothing);
						} else {
							if (_Utils_eq(key, $author$project$Multiselect$Keycodes$pageDown) || _Utils_eq(key, $author$project$Multiselect$Keycodes$end)) {
								var last = $author$project$Multiselect$lastElem(model.M);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{P: last}),
									A2($author$project$Multiselect$DomScrollY, 'multiselectMenu' + model.n0, $author$project$Multiselect$ScrollY),
									$elm$core$Maybe$Nothing);
							} else {
								if (_Utils_eq(key, $author$project$Multiselect$Keycodes$return) && ((model.S === 2) || $elm$core$List$isEmpty(model.M))) {
									var _v14 = model.P;
									if (_v14.$ === 1) {
										var _v15 = model._;
										if (_v15.$ === 1) {
											return _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing);
										} else {
											if (_v15.a === '') {
												return _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing);
											} else {
												var input_ = _v15.a;
												return _Utils_Tuple3(
													model,
													$author$project$Multiselect$NoEffect,
													$elm$core$Maybe$Just(
														$author$project$Multiselect$NotFound(input_)));
											}
										}
									} else {
										var _v16 = _v14.a;
										var id = _v16.a;
										var val = _v16.b;
										var lowerVal = $elm$core$String$toLower(val);
										if ((!model.dc) && (_Utils_eq(
											$elm$core$Maybe$Just(val),
											model._) && A2(
											$elm$core$List$all,
											function (_v17) {
												var value = _v17.b;
												return !_Utils_eq(
													$elm$core$String$toLower(value),
													lowerVal);
											},
											model.eI))) {
											return _Utils_Tuple3(
												model,
												$author$project$Multiselect$NoEffect,
												$elm$core$Maybe$Just(
													$author$project$Multiselect$NotFound(val)));
										} else {
											var item = _Utils_Tuple2(id, val);
											var selected = A2($author$project$Multiselect$addSelected, item, model);
											var filtered = $author$project$Multiselect$valuesWithoutSelected(
												{D: selected, eI: model.eI});
											return _Utils_Tuple3(
												_Utils_update(
													model,
													{
														M: filtered,
														P: A2($author$project$Multiselect$nextSelectedItem, model.M, item),
														_: $elm$core$Maybe$Nothing,
														D: selected,
														S: $elm$core$List$isEmpty(filtered) ? 0 : 2
													}),
												$author$project$Multiselect$focusInput(model),
												$elm$core$Maybe$Just(
													$author$project$Multiselect$Selected(item)));
										}
									}
								} else {
									if (_Utils_eq(key, $author$project$Multiselect$Keycodes$escape)) {
										return _Utils_Tuple3(
											_Utils_update(
												model,
												{bT: true, S: 0}),
											$author$project$Multiselect$NoEffect,
											$elm$core$Maybe$Nothing);
									} else {
										if (_Utils_eq(key, $author$project$Multiselect$Keycodes$tab)) {
											return _Utils_Tuple3(
												_Utils_update(
													model,
													{S: 0}),
												$author$project$Multiselect$NoEffect,
												$elm$core$Maybe$Nothing);
										} else {
											if (_Utils_eq(key, $author$project$Multiselect$Keycodes$backspace)) {
												var _v18 = model._;
												if ((!_v18.$) && (_v18.a === '')) {
													var _v19 = $author$project$Multiselect$lastElem(model.D);
													if (_v19.$ === 1) {
														return _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing);
													} else {
														var item = _v19.a;
														var selected = A2(
															$elm$core$List$filter,
															function (value) {
																return !_Utils_eq(value, item);
															},
															model.D);
														return _Utils_Tuple3(
															_Utils_update(
																model,
																{
																	M: $author$project$Multiselect$valuesWithoutSelected(
																		{D: selected, eI: model.eI}),
																	P: $elm$core$Maybe$Just(item),
																	D: selected
																}),
															$author$project$Multiselect$BatchEffect(
																_List_fromArray(
																	[
																		A2($author$project$Multiselect$DomScrollY, 'multiselectMenu' + model.n0, $author$project$Multiselect$ScrollY),
																		$author$project$Multiselect$focusInput(model)
																	])),
															$elm$core$Maybe$Just(
																$author$project$Multiselect$Unselected(item)));
													}
												} else {
													return _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing);
												}
											} else {
												return _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing);
											}
										}
									}
								}
							}
						}
					}
				}
		}
	});
var $author$project$Form$updateMultiselectField = F2(
	function (fieldMsg, field) {
		var fieldView = field.og;
		var _v0 = A2($author$project$Multiselect$update, fieldMsg, fieldView.fs);
		var updatedState = _v0.a;
		var effect = _v0.b;
		var outMsg = _v0.c;
		return _Utils_Tuple3(
			_Utils_update(
				field,
				{
					og: _Utils_update(
						fieldView,
						{fs: updatedState})
				}),
			effect,
			outMsg);
	});
var $author$project$Element$Counter$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				return A2($author$project$Element$Counter$updateCounter, model.dZ + 1, model);
			case 2:
				return A2($author$project$Element$Counter$updateCounter, model.dZ - 1, model);
			case 3:
				var fieldMsg = msg.a;
				var selector = model.bC;
				var form = model.bC.bE;
				var field = model.bC.bE.aN;
				var _v1 = A2($author$project$Form$updateMultiselectField, fieldMsg, field);
				var updatedField = _v1.a;
				var effect = _v1.b;
				var outMsg = _v1.c;
				var formMsg = $elm$core$Maybe$Just(
					$author$project$Form$getMultiselectFieldSelectedValue(updatedField));
				var model2 = _Utils_update(
					model,
					{
						bC: _Utils_update(
							selector,
							{
								bE: _Utils_update(
									form,
									{aN: updatedField})
							})
					});
				var model3 = function () {
					if (!outMsg.$) {
						return _Utils_update(
							model2,
							{
								bC: A2($author$project$Element$Counter$updateForm, formMsg, model2.bC)
							});
					} else {
						return model2;
					}
				}();
				return _Utils_Tuple3(
					model3,
					A2($author$project$Element$Counter$MultiselectEffect, $author$project$Element$Counter$AnimalMsg, effect),
					$elm$core$Maybe$Nothing);
			default:
				return _Utils_Tuple3(model, $author$project$Element$Counter$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Locale$Messages$BtnCounterDecrement = {$: 26};
var $author$project$Locale$Messages$BtnCounterIncrement = {$: 27};
var $author$project$Element$Counter$Decrement = {$: 2};
var $author$project$Element$Counter$Increment = {$: 1};
var $author$project$UI$level_ = F3(
	function (isAlwaysHorizontal, left, right) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('level'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('is-mobile', isAlwaysHorizontal)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('level-left')
						]),
					A2(
						$elm$core$List$map,
						function (item) {
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('level-item')
									]),
								_List_fromArray(
									[item]));
						},
						left)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('level-right')
						]),
					A2(
						$elm$core$List$map,
						function (item) {
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('level-item')
									]),
								_List_fromArray(
									[item]));
						},
						right))
				]));
	});
var $author$project$UI$level = $author$project$UI$level_(false);
var $author$project$UI$Icon$loadingOptions = function (attributes) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$UI$Icon$icon(
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-spinner fa-spin fa-lg'),
							$author$project$UI$Icon$style('is-medium is-block has-text-grey')
						]),
					attributes))
			]));
};
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Multiselect$ClickOnComponent = {$: 2};
var $author$project$Multiselect$Toggle = {$: 4};
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$batch = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$Property = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.fC);
	});
var $rtfeldman$elm_css$Css$borderBottomWidth = $rtfeldman$elm_css$Css$prop1('border-bottom-width');
var $rtfeldman$elm_css$Css$borderColor3 = F3(
	function (c1, c2, c3) {
		var value = c1.fC + (' ' + (c2.fC + (' ' + c3.fC)));
		return A2($rtfeldman$elm_css$Css$property, 'border-color', value);
	});
var $rtfeldman$elm_css$Css$borderLeftWidth = $rtfeldman$elm_css$Css$prop1('border-left-width');
var $rtfeldman$elm_css$Css$borderRightWidth = $rtfeldman$elm_css$Css$prop1('border-right-width');
var $rtfeldman$elm_css$Css$borderStyle = $rtfeldman$elm_css$Css$prop1('border-style');
var $rtfeldman$elm_css$Css$borderTopWidth = $rtfeldman$elm_css$Css$prop1('border-top-width');
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1('height');
var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2($elm$core$String$startsWith, '#', str) ? str : A2($elm$core$String$cons, '#', str);
};
var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		eP: 1,
		eV: 0,
		bZ: 0,
		e5: 0,
		fo: 0,
		fC: $rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var $rtfeldman$elm_css$Css$validHex = F5(
	function (str, _v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		var toResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromList,
			A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
			var _v5 = results.a;
			var red = _v5.a.a;
			var green = _v5.b.a;
			var _v6 = results.b;
			var blue = _v6.a.a;
			var alpha = _v6.b.a;
			return {
				eP: alpha / 255,
				eV: blue,
				bZ: 0,
				e5: green,
				fo: red,
				fC: $rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return $rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var $rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2($elm$core$String$startsWith, '#', str) ? A2($elm$core$String$dropLeft, 1, str) : str;
	var _v0 = $elm$core$String$toList(withoutHash);
	_v0$4:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v1 = _v0.b;
				var g = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				return A5(
					$rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_v0.b.b.b.b.b) {
					var r = _v0.a;
					var _v3 = _v0.b;
					var g = _v3.a;
					var _v4 = _v3.b;
					var b = _v4.a;
					var _v5 = _v4.b;
					var a = _v5.a;
					return A5(
						$rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_v0.b.b.b.b.b.b) {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v6 = _v0.b;
							var r2 = _v6.a;
							var _v7 = _v6.b;
							var g1 = _v7.a;
							var _v8 = _v7.b;
							var g2 = _v8.a;
							var _v9 = _v8.b;
							var b1 = _v9.a;
							var _v10 = _v9.b;
							var b2 = _v10.a;
							return A5(
								$rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _v0.a;
								var _v11 = _v0.b;
								var r2 = _v11.a;
								var _v12 = _v11.b;
								var g1 = _v12.a;
								var _v13 = _v12.b;
								var g2 = _v13.a;
								var _v14 = _v13.b;
								var b1 = _v14.a;
								var _v15 = _v14.b;
								var b2 = _v15.a;
								var _v16 = _v15.b;
								var a1 = _v16.a;
								var _v17 = _v16.b;
								var a2 = _v17.a;
								return A5(
									$rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _v0$4;
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $rtfeldman$elm_css$Css$erroneousHex(str);
};
var $rtfeldman$elm_css$Css$inlineBlock = {U: 0, fC: 'inline-block'};
var $rtfeldman$elm_css$Css$position = $rtfeldman$elm_css$Css$prop1('position');
var $rtfeldman$elm_css$Css$PxUnits = 0;
var $elm$core$String$fromFloat = _String_fromNumber;
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			$9: 0,
			iF: 0,
			d6: 0,
			bg: 0,
			aa: 0,
			eb: 0,
			cw: 0,
			ec: 0,
			ed: 0,
			dg: 0,
			dh: 0,
			b2: 0,
			ee: 0,
			cE: numericValue,
			eD: 0,
			eH: unitLabel,
			fB: units,
			fC: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'px');
var $rtfeldman$elm_css$Css$relative = {fl: 0, fC: 'relative'};
var $rtfeldman$elm_css$Css$solid = {bs: 0, dI: 0, fC: 'solid'};
var $rtfeldman$elm_css$Css$transparent = {bZ: 0, fC: 'transparent'};
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $rtfeldman$elm_css$Css$UnitlessInteger = 0;
var $rtfeldman$elm_css$Css$zero = {aa: 0, eb: 0, cw: 0, ec: 0, ed: 0, dg: 0, dh: 0, mS: 0, cE: 0, gm: 0, eH: '', fB: 0, fC: '0'};
var $author$project$Multiselect$SelectCss$arrow = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$borderColor3,
			$rtfeldman$elm_css$Css$hex('#999'),
			$rtfeldman$elm_css$Css$transparent,
			$rtfeldman$elm_css$Css$transparent),
			$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$solid),
			$rtfeldman$elm_css$Css$borderTopWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderLeftWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderRightWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderBottomWidth(
			$rtfeldman$elm_css$Css$px(2.5)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]));
var $rtfeldman$elm_css$Css$top = $rtfeldman$elm_css$Css$prop1('top');
var $author$project$Multiselect$SelectCss$arrowUpside = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$borderColor3,
			$rtfeldman$elm_css$Css$transparent,
			$rtfeldman$elm_css$Css$transparent,
			$rtfeldman$elm_css$Css$hex('#999')),
			$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$solid),
			$rtfeldman$elm_css$Css$borderTopWidth(
			$rtfeldman$elm_css$Css$px(2.5)),
			$rtfeldman$elm_css$Css$borderLeftWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderRightWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderBottomWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-2.5))
		]));
var $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1('center');
var $rtfeldman$elm_css$Css$cursor = $rtfeldman$elm_css$Css$prop1('cursor');
var $rtfeldman$elm_css$Css$middle = $rtfeldman$elm_css$Css$prop1('middle');
var $rtfeldman$elm_css$Css$paddingRight = $rtfeldman$elm_css$Css$prop1('padding-right');
var $rtfeldman$elm_css$Css$pointer = {f: 0, fC: 'pointer'};
var $rtfeldman$elm_css$Css$tableCell = {U: 0, fC: 'table-cell'};
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 0:
					var str = style.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 1:
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 2:
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 3:
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 4:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 5:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '', 0);
var $rtfeldman$elm_css$Css$textAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'textAlign',
		'text-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$verticalAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'verticalAlign',
		'vertical-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$Multiselect$SelectCss$arrowWrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$tableCell),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(5))
		]));
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 0:
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.lk) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.fb, record.lk, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{lk: decl, fb: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactDeclarations = function (declarations) {
	var _v0 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v0.a;
	var compactedDeclarations = _v0.b;
	return A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
};
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.iH;
	var imports = _v0.i9;
	var namespaces = _v0.jw;
	var declarations = _v0.ll;
	return {
		iH: charset,
		ll: $rtfeldman$elm_css$Css$Structure$compactDeclarations(declarations),
		i9: imports,
		jw: namespaces
	};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $rtfeldman$elm_css$Css$String$mapJoinHelp = F4(
	function (map, sep, strs, result) {
		mapJoinHelp:
		while (true) {
			if (!strs.b) {
				return result;
			} else {
				if (!strs.b.b) {
					var first = strs.a;
					return result + (map(first) + '');
				} else {
					var first = strs.a;
					var rest = strs.b;
					var $temp$map = map,
						$temp$sep = sep,
						$temp$strs = rest,
						$temp$result = result + (map(first) + (sep + ''));
					map = $temp$map;
					sep = $temp$sep;
					strs = $temp$strs;
					result = $temp$result;
					continue mapJoinHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$Css$String$mapJoin = F3(
	function (map, sep, strs) {
		return A4($rtfeldman$elm_css$Css$String$mapJoinHelp, map, sep, strs, '');
	});
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.iZ + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.fC)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, ' and ', expressions);
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
		'\n',
		mediaQueries);
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		function (_v0) {
			var prop = _v0;
			return prop + ';';
		},
		'',
		properties);
};
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors);
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return $rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator) + (' ' + $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement));
	return A2(
		$elm$core$String$append,
		A2($elm$core$String$join, ' ', segments),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = function (_v0) {
	var firstSelector = _v0.a;
	var otherSelectors = _v0.b;
	var properties = _v0.c;
	var selectorStr = A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
		',',
		A2($elm$core$List$cons, firstSelector, otherSelectors));
	return selectorStr + ('{' + ($rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties) + '}'));
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, ', ', mediaQueries);
			var blocks = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, '\n', styleBlocks);
			return '@media ' + (query + ('{' + (blocks + '}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.fb;
			var declaration = decl.a.lk;
			return '@keyframes ' + (name + ('{' + (declaration + '}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.iH;
	var imports = _v0.i9;
	var namespaces = _v0.jw;
	var declarations = _v0.ll;
	return $rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$importToString, '\n', imports) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, '\n', namespaces) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, '\n', declarations) + '')));
};
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 2:
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $robinheghan$murmur3$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {dW: charsProcessed, d8: hash, j6: seed, ex: shift};
	});
var $robinheghan$murmur3$Murmur3$c1 = 3432918353;
var $robinheghan$murmur3$Murmur3$c2 = 461845907;
var $robinheghan$murmur3$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $robinheghan$murmur3$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $robinheghan$murmur3$Murmur3$finalize = function (data) {
	var acc = (!(!data.d8)) ? (data.j6 ^ A2(
		$robinheghan$murmur3$Murmur3$multiplyBy,
		$robinheghan$murmur3$Murmur3$c2,
		A2(
			$robinheghan$murmur3$Murmur3$rotlBy,
			15,
			A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, data.d8)))) : data.j6;
	var h0 = acc ^ data.dW;
	var h1 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $robinheghan$murmur3$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$robinheghan$murmur3$Murmur3$multiplyBy,
			5,
			A2(
				$robinheghan$murmur3$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$robinheghan$murmur3$Murmur3$multiplyBy,
					$robinheghan$murmur3$Murmur3$c2,
					A2(
						$robinheghan$murmur3$Murmur3$rotlBy,
						15,
						A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, k1))))) + 3864292196;
	});
var $robinheghan$murmur3$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.d8 | ((255 & $elm$core$Char$toCode(c)) << data.ex);
		var _v0 = data.ex;
		if (_v0 === 24) {
			return {
				dW: data.dW + 1,
				d8: 0,
				j6: A2($robinheghan$murmur3$Murmur3$mix, data.j6, res),
				ex: 0
			};
		} else {
			return {dW: data.dW + 1, d8: res, j6: data.j6, ex: data.ex + 8};
		}
	});
var $robinheghan$murmur3$Murmur3$hashString = F2(
	function (seed, str) {
		return $robinheghan$murmur3$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$robinheghan$murmur3$Murmur3$hashFold,
				A4($robinheghan$murmur3$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$initialSeed = 15739;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2($robinheghan$murmur3$Murmur3$hashString, $rtfeldman$elm_css$Hash$initialSeed, str)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_v14.a.$) && (!_v14.b.$)) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$PageRule(properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{lk: str, fb: name})
							]));
				case 4:
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$PageRule(properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.iH;
	var imports = _v0.i9;
	var namespaces = _v0.jw;
	var snippets = _v0.j8;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {iH: charset, ll: declarations, i9: imports, jw: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {iH: $elm$core$Maybe$Nothing, i9: _List_Nil, jw: _List_Nil, j8: snippets};
};
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin = '\u0007';
var $rtfeldman$elm_css$VirtualDom$Styled$templateSelector = $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$ClassSelector($rtfeldman$elm_css$VirtualDom$Styled$classnameStandin)
		]));
var $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate = function (styles) {
	if (!styles.b) {
		return '';
	} else {
		var otherwise = styles;
		return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$VirtualDom$Styled$makeSnippet, styles, $rtfeldman$elm_css$VirtualDom$Styled$templateSelector)
					])));
	}
};
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var cssTemplate = $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate(styles);
	var classProperty = A2($elm$virtual_dom$VirtualDom$attribute, '', '');
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, true, cssTemplate);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$on = F2(
	function (eventName, handler) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$on, eventName, handler),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$Multiselect$withOptions = F2(
	function (options, decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			function (m) {
				return {cz: m, gp: options.gp, gD: options.gD};
			},
			decoder);
	});
var $author$project$Multiselect$onClickNoDefault = function (message) {
	var config = {gp: true, gD: true};
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$custom,
		'click',
		A2(
			$author$project$Multiselect$withOptions,
			config,
			$elm$json$Json$Decode$succeed(message)));
};
var $rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$attribute, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$rel = $rtfeldman$elm_css$VirtualDom$Styled$attribute('rel');
var $author$project$Multiselect$arrow = function (model) {
	var arrowRel = $author$project$Multiselect$isOpened(model) ? 'arrowUpside' : 'arrow';
	var arrowCss = $author$project$Multiselect$isOpened(model) ? _List_fromArray(
		[$author$project$Multiselect$SelectCss$arrowUpside]) : _List_fromArray(
		[$author$project$Multiselect$SelectCss$arrow]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$author$project$Multiselect$SelectCss$arrowWrap])),
				$author$project$Multiselect$onClickNoDefault($author$project$Multiselect$Toggle)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(arrowCss),
						$rtfeldman$elm_css$Html$Styled$Attributes$rel(arrowRel)
					]),
				_List_Nil)
			]));
};
var $author$project$Multiselect$Clear = {$: 7};
var $rtfeldman$elm_css$Css$fontSize = $rtfeldman$elm_css$Css$prop1('font-size');
var $rtfeldman$elm_css$Css$lineHeight = $rtfeldman$elm_css$Css$prop1('line-height');
var $rtfeldman$elm_css$Css$UnitlessFloat = 0;
var $rtfeldman$elm_css$Css$num = function (val) {
	return {
		dh: 0,
		b2: 0,
		ee: 0,
		mS: 0,
		gj: 0,
		cE: val,
		eH: '',
		fB: 0,
		fC: $elm$core$String$fromFloat(val)
	};
};
var $author$project$Multiselect$SelectCss$clear = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$num(1))
		]));
var $rtfeldman$elm_css$Css$color = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'color', c.fC);
};
var $rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Css$pseudoClass = function (_class) {
	return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
		$rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
};
var $rtfeldman$elm_css$Css$hover = $rtfeldman$elm_css$Css$pseudoClass('hover');
var $author$project$Multiselect$SelectCss$clearWrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(17)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#999')),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$tableCell),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$color(
					$rtfeldman$elm_css$Css$hex('#D0021B'))
				]))
		]));
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$id = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
var $rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
	return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
		$elm$virtual_dom$VirtualDom$text(str));
};
var $rtfeldman$elm_css$Html$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $author$project$Multiselect$clear = function (_v0) {
	var model = _v0;
	return (!$elm$core$List$isEmpty(model.D)) ? A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$author$project$Multiselect$SelectCss$clearWrap])),
				$author$project$Multiselect$onClickNoDefault($author$project$Multiselect$Clear),
				$rtfeldman$elm_css$Html$Styled$Attributes$id('multiselectClear' + model.n0)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$Multiselect$SelectCss$clear]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('×')
					]))
			])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
};
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.fC);
};
var $rtfeldman$elm_css$Css$prop3 = F4(
	function (key, argA, argB, argC) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.fC + (' ' + (argB.fC + (' ' + argC.fC))));
	});
var $rtfeldman$elm_css$Css$border3 = $rtfeldman$elm_css$Css$prop3('border');
var $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1('border-radius');
var $rtfeldman$elm_css$Css$PercentageUnits = 0;
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '%');
var $rtfeldman$elm_css$Css$table = {U: 0, fC: 'table'};
var $author$project$Multiselect$SelectCss$container = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$hex('#ccc')),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(4)),
			A3(
			$rtfeldman$elm_css$Css$borderColor3,
			$rtfeldman$elm_css$Css$hex('#d9d9d9'),
			$rtfeldman$elm_css$Css$hex('#ccc'),
			$rtfeldman$elm_css$Css$hex('#b3b3b3')),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#fff')),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#333')),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(34)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$table)
		]));
var $author$project$Multiselect$controlId = function (_v0) {
	var model = _v0;
	return 'multiselectControl' + model.n0;
};
var $rtfeldman$elm_css$Css$borderColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'border-color', c.fC);
};
var $author$project$Multiselect$SelectCss$boxShadowCustom = function (p) {
	return A2($rtfeldman$elm_css$Css$property, 'box-shadow', p);
};
var $author$project$Multiselect$SelectCss$focused = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderColor(
			$rtfeldman$elm_css$Css$hex('#007eff')),
			$author$project$Multiselect$SelectCss$boxShadowCustom('inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1)')
		]));
var $author$project$Multiselect$Focused = 1;
var $author$project$Multiselect$isFocused = function (_v0) {
	var model = _v0;
	return model.S === 1;
};
var $author$project$Multiselect$OnHover = function (a) {
	return {$: 12, a: a};
};
var $author$project$Multiselect$OnSelect = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$absolute = {fl: 0, fC: 'absolute'};
var $rtfeldman$elm_css$Css$borderBottomLeftRadius = $rtfeldman$elm_css$Css$prop1('border-bottom-left-radius');
var $rtfeldman$elm_css$Css$borderBottomRightRadius = $rtfeldman$elm_css$Css$prop1('border-bottom-right-radius');
var $rtfeldman$elm_css$Css$borderTopColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'border-top-color', c.fC);
};
var $rtfeldman$elm_css$Css$prop4 = F5(
	function (key, argA, argB, argC, argD) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.fC + (' ' + (argB.fC + (' ' + (argC.fC + (' ' + argD.fC))))));
	});
var $rtfeldman$elm_css$Css$boxShadow4 = $rtfeldman$elm_css$Css$prop4('box-shadow');
var $rtfeldman$elm_css$Css$int = function (val) {
	return {
		c6: 0,
		f6: 0,
		dh: 0,
		b2: 0,
		mS: 0,
		gj: 0,
		cE: val,
		eH: '',
		fB: 0,
		fC: $elm$core$String$fromInt(val)
	};
};
var $rtfeldman$elm_css$Css$marginTop = $rtfeldman$elm_css$Css$prop1('margin-top');
var $rtfeldman$elm_css$Css$maxHeight = $rtfeldman$elm_css$Css$prop1('max-height');
var $rtfeldman$elm_css$Css$overflowY = $rtfeldman$elm_css$Css$prop1('overflow-y');
var $rtfeldman$elm_css$Css$cssFunction = F2(
	function (funcName, args) {
		return funcName + ('(' + (A2($elm$core$String$join, ',', args) + ')'));
	});
var $rtfeldman$elm_css$Css$rgba = F4(
	function (r, g, b, alpha) {
		return {
			eP: alpha,
			eV: b,
			bZ: 0,
			e5: g,
			fo: r,
			fC: A2(
				$rtfeldman$elm_css$Css$cssFunction,
				'rgba',
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$elm$core$String$fromInt,
						_List_fromArray(
							[r, g, b])),
					_List_fromArray(
						[
							$elm$core$String$fromFloat(alpha)
						])))
		};
	});
var $rtfeldman$elm_css$Css$scroll = {eS: 0, iB: 0, jd: 0, eo: 0, nz: 0, fC: 'scroll'};
var $rtfeldman$elm_css$Css$zIndex = $rtfeldman$elm_css$Css$prop1('z-index');
var $author$project$Multiselect$SelectCss$menu = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderBottomRightRadius(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$borderBottomLeftRadius(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#fff')),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$hex('#ccc')),
			$rtfeldman$elm_css$Css$borderTopColor(
			$rtfeldman$elm_css$Css$hex('#e6e6e6')),
			A4(
			$rtfeldman$elm_css$Css$boxShadow4,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$zero,
			A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.06)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-1)),
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px($author$project$Multiselect$SelectCss$menuHeight)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int(1)),
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$scroll)
		]));
var $rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.fC + (' ' + argB.fC));
	});
var $rtfeldman$elm_css$Css$padding2 = $rtfeldman$elm_css$Css$prop2('padding');
var $author$project$Multiselect$SelectCss$menuItem = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#666')),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px($author$project$Multiselect$SelectCss$itemHeight))
		]));
var $author$project$Multiselect$SelectCss$menuItemHovered = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor(
			A4($rtfeldman$elm_css$Css$rgba, 0, 126, 255, 0.08)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#333'))
		]));
var $rtfeldman$elm_css$Html$Styled$Events$on = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onMouseOver = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Multiselect$menu = function (_v0) {
	var model = _v0;
	var _v1 = model.S;
	if (_v1 === 2) {
		var hovered = function () {
			var _v3 = model.P;
			if (_v3.$ === 1) {
				return '';
			} else {
				var _v4 = _v3.a;
				var id = _v4.a;
				return id;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$Multiselect$SelectCss$menu])),
					$rtfeldman$elm_css$Html$Styled$Attributes$id('multiselectMenu' + model.n0)
				]),
			A2(
				$elm$core$List$map,
				function (_v2) {
					var name = _v2.a;
					var value = _v2.b;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_eq(name, hovered) ? _List_fromArray(
									[$author$project$Multiselect$SelectCss$menuItemHovered, $author$project$Multiselect$SelectCss$menuItem]) : _List_fromArray(
									[$author$project$Multiselect$SelectCss$menuItem])),
								$author$project$Multiselect$onClickNoDefault(
								$author$project$Multiselect$OnSelect(
									_Utils_Tuple2(name, value))),
								$rtfeldman$elm_css$Html$Styled$Events$onMouseOver(
								$author$project$Multiselect$OnHover(
									_Utils_Tuple2(name, value)))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(value)
							]));
				},
				model.M));
	} else {
		return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
	}
};
var $rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Multiselect$SelectCss$opened = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderBottomLeftRadius($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$borderBottomRightRadius($rtfeldman$elm_css$Css$zero)
		]));
var $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var $author$project$Multiselect$Adjust = function (a) {
	return {$: 11, a: a};
};
var $author$project$Multiselect$Filter = function (a) {
	return {$: 10, a: a};
};
var $author$project$Multiselect$Shortcut = function (a) {
	return {$: 13, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Attributes$classList = function (classes) {
	return $rtfeldman$elm_css$Html$Styled$Attributes$class(
		A3(
			$rtfeldman$elm_css$Css$String$mapJoin,
			$elm$core$Tuple$first,
			' ',
			A2($elm$core$List$filter, $elm$core$Tuple$second, classes)));
};
var $rtfeldman$elm_css$Html$Styled$input = $rtfeldman$elm_css$Html$Styled$node('input');
var $rtfeldman$elm_css$Css$border = $rtfeldman$elm_css$Css$prop1('border');
var $rtfeldman$elm_css$Css$initial = {iu: 0, ai: 0, eS: 0, ix: 0, dT: 0, iy: 0, dU: 0, ck: 0, bs: 0, fN: 0, bZ: 0, f: 0, U: 0, d6: 0, hg: 0, e2: 0, f2: 0, c5: 0, bg: 0, e3: 0, z: 0, c6: 0, f6: 0, jj: 0, hy: 0, aa: 0, eb: 0, cw: 0, ec: 0, ed: 0, dg: 0, dh: 0, b2: 0, ee: 0, gd: 0, i: 0, h: 0, hK: 0, mS: 0, cE: 0, gm: 0, eo: 0, bS: 0, gH: 0, eC: 0, dI: 0, eD: 0, eE: 0, dJ: 0, bB: 0, eH: '', fB: 0, fC: 'initial', fD: 0, dP: 0};
var $rtfeldman$elm_css$Css$inherit = _Utils_update(
	$rtfeldman$elm_css$Css$initial,
	{fC: 'inherit'});
var $rtfeldman$elm_css$Css$none = {dT: 0, iB: 0, bs: 0, f: 0, U: 0, lW: 0, jd: 0, hy: 0, ed: 0, dg: 0, b2: 0, i: 0, h: 0, hK: 0, gm: 0, na: 0, bS: 0, gu: 0, ny: 0, eC: 0, dJ: 0, bB: 0, F: 0, oe: 0, fC: 'none'};
var $rtfeldman$elm_css$Css$outlineStyle = $rtfeldman$elm_css$Css$prop1('outline-style');
var $rtfeldman$elm_css$Css$padding = $rtfeldman$elm_css$Css$prop1('padding');
var $rtfeldman$elm_css$Css$paddingTop = $rtfeldman$elm_css$Css$prop1('padding-top');
var $author$project$Multiselect$SelectCss$input = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$outlineStyle($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$num(1)),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(8))
		]));
var $rtfeldman$elm_css$Css$fontStyle = $rtfeldman$elm_css$Css$prop1('font-style');
var $rtfeldman$elm_css$Css$fontWeight = function (_v0) {
	var value = _v0.fC;
	return A2($rtfeldman$elm_css$Css$property, 'font-weight', value);
};
var $rtfeldman$elm_css$Css$left = $rtfeldman$elm_css$Css$prop1('left');
var $rtfeldman$elm_css$Css$normal = {i_: 0, e3: 0, c6: 0, ee: 0, jG: 0, fC: 'normal', dP: 0};
var $rtfeldman$elm_css$Css$overflow = $rtfeldman$elm_css$Css$prop1('overflow');
var $author$project$Multiselect$SelectCss$inputMirrow = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-100)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(-100)),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$scroll),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$normal),
			$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$normal),
			$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$num(1))
		]));
var $rtfeldman$elm_css$Css$marginLeft = $rtfeldman$elm_css$Css$prop1('margin-left');
var $rtfeldman$elm_css$Css$paddingBottom = $rtfeldman$elm_css$Css$prop1('padding-bottom');
var $author$project$Multiselect$SelectCss$inputWrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(8))
		]));
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $debois$elm_dom$DOM$offsetWidth = A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$previousSibling = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'previousSibling', decoder);
};
var $debois$elm_dom$DOM$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $author$project$Multiselect$onKeyDown = function (tagger) {
	var domF = $debois$elm_dom$DOM$target(
		$debois$elm_dom$DOM$previousSibling($debois$elm_dom$DOM$offsetWidth));
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keypress',
		A2($elm$json$Json$Decode$map, tagger, domF));
};
var $rtfeldman$elm_css$Html$Styled$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$Multiselect$onKeyPress = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keydown',
		A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$keyCode));
};
var $rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $author$project$Multiselect$onKeyUp = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keyup',
		A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetValue));
};
var $author$project$Multiselect$Start = {$: 0};
var $author$project$Multiselect$fromResult = function (result) {
	if (!result.$) {
		var successValue = result.a;
		return $elm$json$Json$Decode$succeed(successValue);
	} else {
		var errorMessage = result.a;
		return $elm$json$Json$Decode$fail(errorMessage);
	}
};
var $author$project$Multiselect$preventDefaultButtons = function () {
	var options = {gp: true, gD: false};
	var filterKey = function (code) {
		return (_Utils_eq(code, $author$project$Multiselect$Keycodes$upArrow) || _Utils_eq(code, $author$project$Multiselect$Keycodes$downArrow)) ? $elm$core$Result$Ok(code) : $elm$core$Result$Err('ignored input');
	};
	var decoder = A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$always($author$project$Multiselect$Start),
		A2(
			$elm$json$Json$Decode$andThen,
			A2($elm$core$Basics$composeR, filterKey, $author$project$Multiselect$fromResult),
			$rtfeldman$elm_css$Html$Styled$Events$keyCode));
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$custom,
		'keydown',
		A2($author$project$Multiselect$withOptions, options, decoder));
}();
var $rtfeldman$elm_css$Html$Styled$Attributes$property = $rtfeldman$elm_css$VirtualDom$Styled$property;
var $rtfeldman$elm_css$VirtualDom$Styled$style = F2(
	function (key, val) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$style, key, val),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$style = $rtfeldman$elm_css$VirtualDom$Styled$style;
var $rtfeldman$elm_css$Html$Styled$Attributes$value = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
var $author$project$Multiselect$input = function (_v0) {
	var model = _v0;
	var w = $elm$core$String$fromFloat(model.f5 + 23.0);
	var inputStyle = A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', w + 'px');
	var forceClear = function () {
		var _v1 = model._;
		if (_v1.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$Attributes$value('');
		} else {
			return $rtfeldman$elm_css$Html$Styled$Attributes$classList(_List_Nil);
		}
	}();
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$author$project$Multiselect$preventDefaultButtons,
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$author$project$Multiselect$SelectCss$inputWrap]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$Multiselect$SelectCss$inputMirrow]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model._))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$input,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id('multiselectInput' + model.n0),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$Multiselect$SelectCss$input])),
						$author$project$Multiselect$onKeyDown($author$project$Multiselect$Adjust),
						$author$project$Multiselect$onKeyPress($author$project$Multiselect$Shortcut),
						$author$project$Multiselect$onKeyUp($author$project$Multiselect$Filter),
						inputStyle,
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$property,
						'type',
						$elm$json$Json$Encode$string('text')),
						forceClear
					]),
				_List_Nil)
			]));
};
var $author$project$Multiselect$isMultiSelect = function (_v0) {
	var model = _v0;
	return model.ma;
};
var $author$project$Multiselect$RemoveItem = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Html$Styled$button = $rtfeldman$elm_css$Html$Styled$node('button');
var $rtfeldman$elm_css$Html$Styled$span = $rtfeldman$elm_css$Html$Styled$node('span');
var $author$project$Multiselect$Bulma$tag = F3(
	function (isRemovable, name, value) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tag is-link is-light is-medium')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(value),
					isRemovable ? A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('delete is-small'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Multiselect$RemoveItem(
								_Utils_Tuple2(name, value)))
						]),
					_List_Nil) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Multiselect$Bulma$tags = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('control p-2')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('tags')
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (_v0) {
							var name = _v0.a;
							var value = _v0.b;
							return A3(
								$author$project$Multiselect$Bulma$tag,
								$author$project$Multiselect$isMultiSelect(model),
								name,
								value);
						},
						$author$project$Multiselect$getSelectedValues(model)),
					_List_fromArray(
						[
							$author$project$Multiselect$input(model)
						])))
			]));
};
var $author$project$Multiselect$SelectCss$wrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]));
var $author$project$Multiselect$Bulma$styledView = function (model) {
	var inputCss = $author$project$Multiselect$isFocused(model) ? _List_fromArray(
		[$author$project$Multiselect$SelectCss$container, $author$project$Multiselect$SelectCss$focused]) : ($author$project$Multiselect$isOpened(model) ? _List_fromArray(
		[$author$project$Multiselect$SelectCss$container, $author$project$Multiselect$SelectCss$opened]) : _List_fromArray(
		[$author$project$Multiselect$SelectCss$container]));
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$author$project$Multiselect$SelectCss$wrap])),
				$rtfeldman$elm_css$Html$Styled$Attributes$id(
				$author$project$Multiselect$controlId(model)),
				$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Multiselect$ClickOnComponent)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(inputCss)
					]),
				_List_fromArray(
					[
						$author$project$Multiselect$Bulma$tags(model),
						$author$project$Multiselect$clear(model),
						$author$project$Multiselect$arrow(model)
					])),
				$author$project$Multiselect$menu(model)
			]));
};
var $rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				return styles;
			} else {
				return A3(
					$elm$core$Dict$insert,
					cssTemplate,
					$rtfeldman$elm_css$Hash$fromString(cssTemplate),
					styles);
			}
		} else {
			return styles;
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string(classname));
			} else {
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string('_unstyled'));
			}
		} else {
			return val;
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', classname);
			} else {
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', '_unstyled');
			}
		} else {
			return val;
		}
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$nodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_nodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration = F3(
	function (template, classname, declaration) {
		return declaration + ('\n' + A3($elm$core$String$replace, $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, classname, template));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return A3($elm$core$Dict$foldl, $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration, '', dict);
};
var $rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration = F2(
	function (scopingPrefix, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (template, classname, declaration) {
					return declaration + ('\n' + A3($elm$core$String$replace, '.' + $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, '#' + (scopingPrefix + ('.' + classname)), template));
				}),
			'',
			dict);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = F2(
	function (maybeNonce, accumulatedStyles) {
		var cssText = function () {
			if (!accumulatedStyles.$) {
				var allStyles = accumulatedStyles.a;
				return $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(allStyles);
			} else {
				var scope = accumulatedStyles.a;
				var rootStyles = accumulatedStyles.b;
				var descendantStyles = accumulatedStyles.c;
				return A2($rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration, scope, rootStyles) + ('\n' + A2($rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration, scope + ' ', descendantStyles));
			}
		}();
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			'span',
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'display: none;'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'class', 'elm-css-style-wrapper')
				]),
			_List_fromArray(
				[
					A3(
					$elm$virtual_dom$VirtualDom$node,
					'style',
					function () {
						if (!maybeNonce.$) {
							var nonce = maybeNonce.a;
							return _List_fromArray(
								[
									A2($elm$virtual_dom$VirtualDom$attribute, 'nonce', nonce)
								]);
						} else {
							return _List_Nil;
						}
					}(),
					$elm$core$List$singleton(
						$elm$virtual_dom$VirtualDom$text(cssText)))
				]));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F4(
	function (maybeNonce, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2(
			$rtfeldman$elm_css$VirtualDom$Styled$toStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles));
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F3(
	function (maybeNonce, accumulatedStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toStyleNode, maybeNonce, accumulatedStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F4(
	function (maybeNonce, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3(
			$rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles),
			keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F5(
	function (maybeNonce, ns, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3(
			$rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles),
			keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F5(
	function (maybeNonce, ns, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2(
			$rtfeldman$elm_css$VirtualDom$Styled$toStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles));
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyle, $elm$core$Maybe$Nothing, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, $elm$core$Maybe$Nothing, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $author$project$Multiselect$Bulma$view = A2($elm$core$Basics$composeR, $author$project$Multiselect$Bulma$styledView, $rtfeldman$elm_css$Html$Styled$toUnstyled);
var $author$project$UI$multiselectChoiceField = F3(
	function (t_, field, values) {
		var view = field.og;
		var valid = A2($author$project$Form$isFieldValid, field, values);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('has-errors', !valid)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$UI$fieldLabel, t_, field),
					function () {
					var _v0 = view.m_;
					if (_v0.$ === 1) {
						return $author$project$UI$Icon$loadingOptions(_List_Nil);
					} else {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$UI$attrCyData(view.cm)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									view.cf,
									$author$project$Multiselect$Bulma$view(view.fs))
								]));
					}
				}(),
					A2($author$project$UI$validationError, field, values)
				]));
	});
var $author$project$UI$section = function (content) {
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container')
					]),
				content)
			]));
};
var $author$project$UI$tag = F2(
	function (style, content) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tag'),
					$elm$html$Html$Attributes$class(style)
				]),
			content);
	});
var $author$project$Element$Counter$view = function (_v0) {
	var counter = _v0.dZ;
	var animalSelectorModel = _v0.bC;
	var session = _v0.gB;
	var animal = $author$project$Form$getMultiselectFieldSelectedValue(animalSelectorModel.bE.aN);
	return $author$project$UI$section(
		_List_fromArray(
			[
				A2(
				$author$project$UI$caption,
				session.h6,
				$author$project$Locale$Messages$NOTRANS('Itt számolhatsz bárányokat. Használd a + és - gombokat.')),
				A2(
				$author$project$UI$level,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button'),
								$elm$html$Html$Events$onClick($author$project$Element$Counter$Decrement)
							]),
						_List_fromArray(
							[
								A2($author$project$UI$caption, session.h6, $author$project$Locale$Messages$BtnCounterDecrement)
							])),
						A2(
						$author$project$UI$tag,
						'is-info is-light',
						_List_fromArray(
							[
								A2(
								$author$project$UI$caption,
								session.h6,
								A2($author$project$Locale$Messages$CounterClickCount, animal, counter))
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button'),
								$elm$html$Html$Events$onClick($author$project$Element$Counter$Increment)
							]),
						_List_fromArray(
							[
								A2($author$project$UI$caption, session.h6, $author$project$Locale$Messages$BtnCounterIncrement)
							]))
					]),
				_List_Nil),
				A3($author$project$UI$multiselectChoiceField, session.h6, animalSelectorModel.bE.aN, animalSelectorModel.eI)
			]));
};
var $author$project$Element$Counter$element = {jb: $author$project$Element$Counter$init, hP: $author$project$Element$Counter$perform, ks: $author$project$Element$Counter$update, og: $author$project$Element$Counter$view};
var $author$project$Element$CurriculumBrowser$NoEffect = 0;
var $author$project$Element$CurriculumBrowser$init = F3(
	function (config, session, _v0) {
		var model = {b_: config, gB: session};
		return _Utils_Tuple3(model, 0, $elm$core$Maybe$Nothing);
	});
var $author$project$Element$CurriculumBrowser$perform = F2(
	function (_v0, effect) {
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Element$CurriculumBrowser$update = F2(
	function (msg, model) {
		return _Utils_Tuple3(model, 0, $elm$core$Maybe$Nothing);
	});
var $author$project$Locale$Messages$CurriculumBrowserHeading = {$: 45};
var $author$project$Element$CurriculumBrowser$NoOp = 0;
var $author$project$UI$levelHorizontal = $author$project$UI$level_(true);
var $author$project$Locale$Messages$CurriculumBrowserTile1 = {$: 46};
var $author$project$Locale$Messages$CurriculumBrowserTile2 = {$: 47};
var $author$project$Locale$Messages$CurriculumBrowserTile3 = {$: 48};
var $author$project$Locale$Messages$CurriculumBrowserTile4 = {$: 49};
var $author$project$Locale$Messages$CurriculumBrowserTile5 = {$: 50};
var $elm$html$Html$article = _VirtualDom_node('article');
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$UI$tile3 = F3(
	function (styleClass, url, content) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tile is-parent'),
					$elm$html$Html$Attributes$href(url),
					$elm$html$Html$Attributes$target('_blank'),
					$elm$html$Html$Attributes$rel('noopener noreferrer'),
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$article,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tile is-parent notification ' + (styleClass + ' is-flex is-justify-content-center is-align-items-center')),
							A2($elm$html$Html$Attributes$style, 'min-width', '240px'),
							A2($elm$html$Html$Attributes$style, 'min-height', '130px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-text-centered is-uppercase has-text-weight-bold is-size-5')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(content)
								]))
						]))
				]));
	});
var $author$project$Element$CurriculumBrowser$viewTiles = function (t_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap'),
				A2($elm$html$Html$Attributes$style, 'justify-content', 'flex-start'),
				A2($elm$html$Html$Attributes$style, 'gap', '24px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tile is-parent'),
						A2($elm$html$Html$Attributes$style, 'flex', '0 1 340px')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$UI$tile3,
						'is-info',
						'https://medium.budapestschool.org/RnlXIYXGZCeDbR',
						t_($author$project$Locale$Messages$CurriculumBrowserTile1))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tile is-parent'),
						A2($elm$html$Html$Attributes$style, 'flex', '0 1 340px')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$UI$tile3,
						'is-info',
						'https://s.craft.me/08sCEqIS2JKTOf',
						t_($author$project$Locale$Messages$CurriculumBrowserTile2))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tile is-parent'),
						A2($elm$html$Html$Attributes$style, 'flex', '0 1 340px')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$UI$tile3,
						'is-info',
						'https://s.craft.me/nS3pu5t1ez7l6K',
						t_($author$project$Locale$Messages$CurriculumBrowserTile3))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tile is-parent'),
						A2($elm$html$Html$Attributes$style, 'flex', '0 1 340px')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$UI$tile3,
						'is-info',
						'https://shoes-argue-p58.craft.me/ZwqQb5PbI1Pjj6',
						t_($author$project$Locale$Messages$CurriculumBrowserTile4))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tile is-parent'),
						A2($elm$html$Html$Attributes$style, 'flex', '0 1 340px')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$UI$tile3,
						'is-info',
						'https://s.craft.me/hNIlexsMdERyFE',
						t_($author$project$Locale$Messages$CurriculumBrowserTile5))
					]))
			]));
};
var $author$project$Element$CurriculumBrowser$view = function (_v0) {
	var session = _v0.gB;
	return $author$project$UI$panel(
		{
			g$: _List_fromArray(
				[
					$author$project$Element$CurriculumBrowser$viewTiles(session.h6)
				]),
			cm: 'curriculum-browser',
			hl: _List_fromArray(
				[
					A2(
					$author$project$UI$levelHorizontal,
					_List_fromArray(
						[
							A2($author$project$UI$caption, session.h6, $author$project$Locale$Messages$CurriculumBrowserHeading)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(0),
									$elm$html$Html$Attributes$class('button is-info')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						]))
				]),
			h7: _List_Nil,
			ie: 'is-info'
		});
};
var $author$project$Element$CurriculumBrowser$element = {jb: $author$project$Element$CurriculumBrowser$init, hP: $author$project$Element$CurriculumBrowser$perform, ks: $author$project$Element$CurriculumBrowser$update, og: $author$project$Element$CurriculumBrowser$view};
var $author$project$Element$GenericProfileForm$LoadingPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$GenericProfileForm$ProfileDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Endpoint$person = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'people',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$Person$fetchProfile = F3(
	function (config, id, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$person, config, id),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$Person$personDecoder));
	});
var $author$project$Element$GenericProfileForm$init = F3(
	function (config, session, personId) {
		var model = {
			b_: config,
			bk: $author$project$Element$GenericProfileForm$LoadingPage(personId)
		};
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A3($author$project$Person$fetchProfile, config.gX, personId, $author$project$Element$GenericProfileForm$ProfileDownloaded),
			A2($author$project$Application$Boundaries$save, model, session));
	});
var $author$project$Element$GenericProfileForm$FormPage = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $author$project$Locale$Messages$FormSaveError = {$: 74};
var $author$project$Element$GenericProfileForm$NoOp = {$: 5};
var $author$project$Element$GenericProfileForm$NotFoundPage = {$: 0};
var $author$project$Element$GenericProfileForm$ProfileSaved = function (a) {
	return {$: 4, a: a};
};
var $author$project$Locale$Messages$ProfilesDownloadError = {$: 395};
var $author$project$Locale$Messages$ProfilesSaveSuccess = {$: 396};
var $author$project$Form$SavingError = 3;
var $author$project$Element$GenericProfileForm$BirthDate = function (a) {
	return {$: 11, a: a};
};
var $author$project$Element$GenericProfileForm$BirthPlaceCountry = function (a) {
	return {$: 13, a: a};
};
var $author$project$Element$GenericProfileForm$BirthPlaceTown = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$GenericProfileForm$Email = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$GenericProfileForm$FirstName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$GenericProfileForm$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$GenericProfileForm$LastName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$GenericProfileForm$PermanentAddressCountry = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$GenericProfileForm$PermanentAddressPostcode = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$GenericProfileForm$PermanentAddressStreetDoor = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$GenericProfileForm$PermanentAddressStreetName = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$GenericProfileForm$PermanentAddressStreetNumber = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$GenericProfileForm$PermanentAddressStreetType = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$GenericProfileForm$PermanentAddressTown = function (a) {
	return {$: 6, a: a};
};
var $author$project$Locale$Messages$PersonAddressCountry = {$: 321};
var $author$project$Locale$Messages$PersonAddressPostcode = {$: 322};
var $author$project$Locale$Messages$PersonAddressStreetDoor = {$: 327};
var $author$project$Locale$Messages$PersonAddressStreetName = {$: 324};
var $author$project$Locale$Messages$PersonAddressStreetNumber = {$: 326};
var $author$project$Locale$Messages$PersonAddressStreetType = {$: 325};
var $author$project$Locale$Messages$PersonAddressTown = {$: 323};
var $author$project$Locale$Messages$PersonBirthDate = {$: 330};
var $author$project$Locale$Messages$PersonBirthPlaceCountry = {$: 329};
var $author$project$Locale$Messages$PersonBirthPlaceTown = {$: 328};
var $author$project$Locale$Messages$PersonEmail = {$: 311};
var $author$project$Locale$Messages$PersonFirstName = {$: 313};
var $author$project$Locale$Messages$PersonLastName = {$: 316};
var $author$project$Locale$Messages$PersonPhone = {$: 318};
var $author$project$Element$GenericProfileForm$Phone = function (a) {
	return {$: 3, a: a};
};
var $author$project$Locale$Messages$Country = function (a) {
	return {$: 43, a: a};
};
var $rl_king$elm_iso3166_country_codes$Iso3166$AD = 0;
var $rl_king$elm_iso3166_country_codes$Iso3166$AE = 1;
var $rl_king$elm_iso3166_country_codes$Iso3166$AF = 2;
var $rl_king$elm_iso3166_country_codes$Iso3166$AG = 3;
var $rl_king$elm_iso3166_country_codes$Iso3166$AI = 4;
var $rl_king$elm_iso3166_country_codes$Iso3166$AL = 5;
var $rl_king$elm_iso3166_country_codes$Iso3166$AM = 6;
var $rl_king$elm_iso3166_country_codes$Iso3166$AO = 7;
var $rl_king$elm_iso3166_country_codes$Iso3166$AQ = 8;
var $rl_king$elm_iso3166_country_codes$Iso3166$AR = 9;
var $rl_king$elm_iso3166_country_codes$Iso3166$AS = 10;
var $rl_king$elm_iso3166_country_codes$Iso3166$AT = 11;
var $rl_king$elm_iso3166_country_codes$Iso3166$AU = 12;
var $rl_king$elm_iso3166_country_codes$Iso3166$AW = 13;
var $rl_king$elm_iso3166_country_codes$Iso3166$AX = 14;
var $rl_king$elm_iso3166_country_codes$Iso3166$AZ = 15;
var $rl_king$elm_iso3166_country_codes$Iso3166$BA = 16;
var $rl_king$elm_iso3166_country_codes$Iso3166$BB = 17;
var $rl_king$elm_iso3166_country_codes$Iso3166$BD = 18;
var $rl_king$elm_iso3166_country_codes$Iso3166$BE = 19;
var $rl_king$elm_iso3166_country_codes$Iso3166$BF = 20;
var $rl_king$elm_iso3166_country_codes$Iso3166$BG = 21;
var $rl_king$elm_iso3166_country_codes$Iso3166$BH = 22;
var $rl_king$elm_iso3166_country_codes$Iso3166$BI = 23;
var $rl_king$elm_iso3166_country_codes$Iso3166$BJ = 24;
var $rl_king$elm_iso3166_country_codes$Iso3166$BL = 25;
var $rl_king$elm_iso3166_country_codes$Iso3166$BM = 26;
var $rl_king$elm_iso3166_country_codes$Iso3166$BN = 27;
var $rl_king$elm_iso3166_country_codes$Iso3166$BO = 28;
var $rl_king$elm_iso3166_country_codes$Iso3166$BQ = 29;
var $rl_king$elm_iso3166_country_codes$Iso3166$BR = 30;
var $rl_king$elm_iso3166_country_codes$Iso3166$BS = 31;
var $rl_king$elm_iso3166_country_codes$Iso3166$BT = 32;
var $rl_king$elm_iso3166_country_codes$Iso3166$BV = 33;
var $rl_king$elm_iso3166_country_codes$Iso3166$BW = 34;
var $rl_king$elm_iso3166_country_codes$Iso3166$BY = 35;
var $rl_king$elm_iso3166_country_codes$Iso3166$BZ = 36;
var $rl_king$elm_iso3166_country_codes$Iso3166$CA = 37;
var $rl_king$elm_iso3166_country_codes$Iso3166$CC = 38;
var $rl_king$elm_iso3166_country_codes$Iso3166$CD = 39;
var $rl_king$elm_iso3166_country_codes$Iso3166$CF = 40;
var $rl_king$elm_iso3166_country_codes$Iso3166$CG = 41;
var $rl_king$elm_iso3166_country_codes$Iso3166$CH = 42;
var $rl_king$elm_iso3166_country_codes$Iso3166$CI = 43;
var $rl_king$elm_iso3166_country_codes$Iso3166$CK = 44;
var $rl_king$elm_iso3166_country_codes$Iso3166$CL = 45;
var $rl_king$elm_iso3166_country_codes$Iso3166$CM = 46;
var $rl_king$elm_iso3166_country_codes$Iso3166$CN = 47;
var $rl_king$elm_iso3166_country_codes$Iso3166$CO = 48;
var $rl_king$elm_iso3166_country_codes$Iso3166$CR = 49;
var $rl_king$elm_iso3166_country_codes$Iso3166$CU = 50;
var $rl_king$elm_iso3166_country_codes$Iso3166$CV = 51;
var $rl_king$elm_iso3166_country_codes$Iso3166$CW = 52;
var $rl_king$elm_iso3166_country_codes$Iso3166$CX = 53;
var $rl_king$elm_iso3166_country_codes$Iso3166$CY = 54;
var $rl_king$elm_iso3166_country_codes$Iso3166$CZ = 55;
var $rl_king$elm_iso3166_country_codes$Iso3166$DE = 56;
var $rl_king$elm_iso3166_country_codes$Iso3166$DJ = 57;
var $rl_king$elm_iso3166_country_codes$Iso3166$DK = 58;
var $rl_king$elm_iso3166_country_codes$Iso3166$DM = 59;
var $rl_king$elm_iso3166_country_codes$Iso3166$DO = 60;
var $rl_king$elm_iso3166_country_codes$Iso3166$DZ = 61;
var $rl_king$elm_iso3166_country_codes$Iso3166$EC = 62;
var $rl_king$elm_iso3166_country_codes$Iso3166$EE = 63;
var $rl_king$elm_iso3166_country_codes$Iso3166$EG = 64;
var $rl_king$elm_iso3166_country_codes$Iso3166$EH = 65;
var $rl_king$elm_iso3166_country_codes$Iso3166$ER = 66;
var $rl_king$elm_iso3166_country_codes$Iso3166$ES = 67;
var $rl_king$elm_iso3166_country_codes$Iso3166$ET = 68;
var $rl_king$elm_iso3166_country_codes$Iso3166$FI = 69;
var $rl_king$elm_iso3166_country_codes$Iso3166$FJ = 70;
var $rl_king$elm_iso3166_country_codes$Iso3166$FK = 71;
var $rl_king$elm_iso3166_country_codes$Iso3166$FM = 72;
var $rl_king$elm_iso3166_country_codes$Iso3166$FO = 73;
var $rl_king$elm_iso3166_country_codes$Iso3166$FR = 74;
var $rl_king$elm_iso3166_country_codes$Iso3166$GA = 75;
var $rl_king$elm_iso3166_country_codes$Iso3166$GB = 76;
var $rl_king$elm_iso3166_country_codes$Iso3166$GD = 77;
var $rl_king$elm_iso3166_country_codes$Iso3166$GE = 78;
var $rl_king$elm_iso3166_country_codes$Iso3166$GF = 79;
var $rl_king$elm_iso3166_country_codes$Iso3166$GG = 80;
var $rl_king$elm_iso3166_country_codes$Iso3166$GH = 81;
var $rl_king$elm_iso3166_country_codes$Iso3166$GI = 82;
var $rl_king$elm_iso3166_country_codes$Iso3166$GL = 83;
var $rl_king$elm_iso3166_country_codes$Iso3166$GM = 84;
var $rl_king$elm_iso3166_country_codes$Iso3166$GN = 85;
var $rl_king$elm_iso3166_country_codes$Iso3166$GP = 86;
var $rl_king$elm_iso3166_country_codes$Iso3166$GQ = 87;
var $rl_king$elm_iso3166_country_codes$Iso3166$GR = 88;
var $rl_king$elm_iso3166_country_codes$Iso3166$GS = 89;
var $rl_king$elm_iso3166_country_codes$Iso3166$GT_ = 90;
var $rl_king$elm_iso3166_country_codes$Iso3166$GU = 91;
var $rl_king$elm_iso3166_country_codes$Iso3166$GW = 92;
var $rl_king$elm_iso3166_country_codes$Iso3166$GY = 93;
var $rl_king$elm_iso3166_country_codes$Iso3166$HK = 94;
var $rl_king$elm_iso3166_country_codes$Iso3166$HM = 95;
var $rl_king$elm_iso3166_country_codes$Iso3166$HN = 96;
var $rl_king$elm_iso3166_country_codes$Iso3166$HR = 97;
var $rl_king$elm_iso3166_country_codes$Iso3166$HT = 98;
var $rl_king$elm_iso3166_country_codes$Iso3166$HU = 99;
var $rl_king$elm_iso3166_country_codes$Iso3166$ID = 100;
var $rl_king$elm_iso3166_country_codes$Iso3166$IE = 101;
var $rl_king$elm_iso3166_country_codes$Iso3166$IL = 102;
var $rl_king$elm_iso3166_country_codes$Iso3166$IM = 103;
var $rl_king$elm_iso3166_country_codes$Iso3166$IN = 104;
var $rl_king$elm_iso3166_country_codes$Iso3166$IO = 105;
var $rl_king$elm_iso3166_country_codes$Iso3166$IQ = 106;
var $rl_king$elm_iso3166_country_codes$Iso3166$IR = 107;
var $rl_king$elm_iso3166_country_codes$Iso3166$IS = 108;
var $rl_king$elm_iso3166_country_codes$Iso3166$IT = 109;
var $rl_king$elm_iso3166_country_codes$Iso3166$JE = 110;
var $rl_king$elm_iso3166_country_codes$Iso3166$JM = 111;
var $rl_king$elm_iso3166_country_codes$Iso3166$JO = 112;
var $rl_king$elm_iso3166_country_codes$Iso3166$JP = 113;
var $rl_king$elm_iso3166_country_codes$Iso3166$KE = 114;
var $rl_king$elm_iso3166_country_codes$Iso3166$KG = 115;
var $rl_king$elm_iso3166_country_codes$Iso3166$KH = 116;
var $rl_king$elm_iso3166_country_codes$Iso3166$KI = 117;
var $rl_king$elm_iso3166_country_codes$Iso3166$KM = 118;
var $rl_king$elm_iso3166_country_codes$Iso3166$KN = 119;
var $rl_king$elm_iso3166_country_codes$Iso3166$KP = 120;
var $rl_king$elm_iso3166_country_codes$Iso3166$KR = 121;
var $rl_king$elm_iso3166_country_codes$Iso3166$KW = 122;
var $rl_king$elm_iso3166_country_codes$Iso3166$KY = 123;
var $rl_king$elm_iso3166_country_codes$Iso3166$KZ = 124;
var $rl_king$elm_iso3166_country_codes$Iso3166$LA = 125;
var $rl_king$elm_iso3166_country_codes$Iso3166$LB = 126;
var $rl_king$elm_iso3166_country_codes$Iso3166$LC = 127;
var $rl_king$elm_iso3166_country_codes$Iso3166$LI = 128;
var $rl_king$elm_iso3166_country_codes$Iso3166$LK = 129;
var $rl_king$elm_iso3166_country_codes$Iso3166$LR = 130;
var $rl_king$elm_iso3166_country_codes$Iso3166$LS = 131;
var $rl_king$elm_iso3166_country_codes$Iso3166$LT_ = 132;
var $rl_king$elm_iso3166_country_codes$Iso3166$LU = 133;
var $rl_king$elm_iso3166_country_codes$Iso3166$LV = 134;
var $rl_king$elm_iso3166_country_codes$Iso3166$LY = 135;
var $rl_king$elm_iso3166_country_codes$Iso3166$MA = 136;
var $rl_king$elm_iso3166_country_codes$Iso3166$MC = 137;
var $rl_king$elm_iso3166_country_codes$Iso3166$MD = 138;
var $rl_king$elm_iso3166_country_codes$Iso3166$ME = 139;
var $rl_king$elm_iso3166_country_codes$Iso3166$MF = 140;
var $rl_king$elm_iso3166_country_codes$Iso3166$MG = 141;
var $rl_king$elm_iso3166_country_codes$Iso3166$MH = 142;
var $rl_king$elm_iso3166_country_codes$Iso3166$MK = 143;
var $rl_king$elm_iso3166_country_codes$Iso3166$ML = 144;
var $rl_king$elm_iso3166_country_codes$Iso3166$MM = 145;
var $rl_king$elm_iso3166_country_codes$Iso3166$MN = 146;
var $rl_king$elm_iso3166_country_codes$Iso3166$MO = 147;
var $rl_king$elm_iso3166_country_codes$Iso3166$MP = 148;
var $rl_king$elm_iso3166_country_codes$Iso3166$MQ = 149;
var $rl_king$elm_iso3166_country_codes$Iso3166$MR = 150;
var $rl_king$elm_iso3166_country_codes$Iso3166$MS = 151;
var $rl_king$elm_iso3166_country_codes$Iso3166$MT = 152;
var $rl_king$elm_iso3166_country_codes$Iso3166$MU = 153;
var $rl_king$elm_iso3166_country_codes$Iso3166$MV = 154;
var $rl_king$elm_iso3166_country_codes$Iso3166$MW = 155;
var $rl_king$elm_iso3166_country_codes$Iso3166$MX = 156;
var $rl_king$elm_iso3166_country_codes$Iso3166$MY = 157;
var $rl_king$elm_iso3166_country_codes$Iso3166$MZ = 158;
var $rl_king$elm_iso3166_country_codes$Iso3166$NA = 159;
var $rl_king$elm_iso3166_country_codes$Iso3166$NC = 160;
var $rl_king$elm_iso3166_country_codes$Iso3166$NE = 161;
var $rl_king$elm_iso3166_country_codes$Iso3166$NF = 162;
var $rl_king$elm_iso3166_country_codes$Iso3166$NG = 163;
var $rl_king$elm_iso3166_country_codes$Iso3166$NI = 164;
var $rl_king$elm_iso3166_country_codes$Iso3166$NL = 165;
var $rl_king$elm_iso3166_country_codes$Iso3166$NO = 166;
var $rl_king$elm_iso3166_country_codes$Iso3166$NP = 167;
var $rl_king$elm_iso3166_country_codes$Iso3166$NR = 168;
var $rl_king$elm_iso3166_country_codes$Iso3166$NU = 169;
var $rl_king$elm_iso3166_country_codes$Iso3166$NZ = 170;
var $rl_king$elm_iso3166_country_codes$Iso3166$OM = 171;
var $rl_king$elm_iso3166_country_codes$Iso3166$PA = 172;
var $rl_king$elm_iso3166_country_codes$Iso3166$PE = 173;
var $rl_king$elm_iso3166_country_codes$Iso3166$PF = 174;
var $rl_king$elm_iso3166_country_codes$Iso3166$PG = 175;
var $rl_king$elm_iso3166_country_codes$Iso3166$PH = 176;
var $rl_king$elm_iso3166_country_codes$Iso3166$PK = 177;
var $rl_king$elm_iso3166_country_codes$Iso3166$PL = 178;
var $rl_king$elm_iso3166_country_codes$Iso3166$PM = 179;
var $rl_king$elm_iso3166_country_codes$Iso3166$PN = 180;
var $rl_king$elm_iso3166_country_codes$Iso3166$PR = 181;
var $rl_king$elm_iso3166_country_codes$Iso3166$PS = 182;
var $rl_king$elm_iso3166_country_codes$Iso3166$PT = 183;
var $rl_king$elm_iso3166_country_codes$Iso3166$PW = 184;
var $rl_king$elm_iso3166_country_codes$Iso3166$PY = 185;
var $rl_king$elm_iso3166_country_codes$Iso3166$QA = 186;
var $rl_king$elm_iso3166_country_codes$Iso3166$RE = 187;
var $rl_king$elm_iso3166_country_codes$Iso3166$RO = 188;
var $rl_king$elm_iso3166_country_codes$Iso3166$RS = 189;
var $rl_king$elm_iso3166_country_codes$Iso3166$RU = 190;
var $rl_king$elm_iso3166_country_codes$Iso3166$RW = 191;
var $rl_king$elm_iso3166_country_codes$Iso3166$SA = 192;
var $rl_king$elm_iso3166_country_codes$Iso3166$SB = 193;
var $rl_king$elm_iso3166_country_codes$Iso3166$SC = 194;
var $rl_king$elm_iso3166_country_codes$Iso3166$SD = 195;
var $rl_king$elm_iso3166_country_codes$Iso3166$SE = 196;
var $rl_king$elm_iso3166_country_codes$Iso3166$SG = 197;
var $rl_king$elm_iso3166_country_codes$Iso3166$SH = 198;
var $rl_king$elm_iso3166_country_codes$Iso3166$SI = 199;
var $rl_king$elm_iso3166_country_codes$Iso3166$SJ = 200;
var $rl_king$elm_iso3166_country_codes$Iso3166$SK = 201;
var $rl_king$elm_iso3166_country_codes$Iso3166$SL = 202;
var $rl_king$elm_iso3166_country_codes$Iso3166$SM = 203;
var $rl_king$elm_iso3166_country_codes$Iso3166$SN = 204;
var $rl_king$elm_iso3166_country_codes$Iso3166$SO = 205;
var $rl_king$elm_iso3166_country_codes$Iso3166$SR = 206;
var $rl_king$elm_iso3166_country_codes$Iso3166$SS = 207;
var $rl_king$elm_iso3166_country_codes$Iso3166$ST = 208;
var $rl_king$elm_iso3166_country_codes$Iso3166$SV = 209;
var $rl_king$elm_iso3166_country_codes$Iso3166$SX = 210;
var $rl_king$elm_iso3166_country_codes$Iso3166$SY = 211;
var $rl_king$elm_iso3166_country_codes$Iso3166$SZ = 212;
var $rl_king$elm_iso3166_country_codes$Iso3166$TC = 213;
var $rl_king$elm_iso3166_country_codes$Iso3166$TD = 214;
var $rl_king$elm_iso3166_country_codes$Iso3166$TF = 215;
var $rl_king$elm_iso3166_country_codes$Iso3166$TG = 216;
var $rl_king$elm_iso3166_country_codes$Iso3166$TH = 217;
var $rl_king$elm_iso3166_country_codes$Iso3166$TJ = 218;
var $rl_king$elm_iso3166_country_codes$Iso3166$TK = 219;
var $rl_king$elm_iso3166_country_codes$Iso3166$TL = 220;
var $rl_king$elm_iso3166_country_codes$Iso3166$TM = 221;
var $rl_king$elm_iso3166_country_codes$Iso3166$TN = 222;
var $rl_king$elm_iso3166_country_codes$Iso3166$TO = 223;
var $rl_king$elm_iso3166_country_codes$Iso3166$TR = 224;
var $rl_king$elm_iso3166_country_codes$Iso3166$TT = 225;
var $rl_king$elm_iso3166_country_codes$Iso3166$TV = 226;
var $rl_king$elm_iso3166_country_codes$Iso3166$TW = 227;
var $rl_king$elm_iso3166_country_codes$Iso3166$TZ = 228;
var $rl_king$elm_iso3166_country_codes$Iso3166$UA = 229;
var $rl_king$elm_iso3166_country_codes$Iso3166$UG = 230;
var $rl_king$elm_iso3166_country_codes$Iso3166$UM = 231;
var $rl_king$elm_iso3166_country_codes$Iso3166$US = 232;
var $rl_king$elm_iso3166_country_codes$Iso3166$UY = 233;
var $rl_king$elm_iso3166_country_codes$Iso3166$UZ = 234;
var $rl_king$elm_iso3166_country_codes$Iso3166$VA = 235;
var $rl_king$elm_iso3166_country_codes$Iso3166$VC = 236;
var $rl_king$elm_iso3166_country_codes$Iso3166$VE = 237;
var $rl_king$elm_iso3166_country_codes$Iso3166$VG = 238;
var $rl_king$elm_iso3166_country_codes$Iso3166$VI = 239;
var $rl_king$elm_iso3166_country_codes$Iso3166$VN = 240;
var $rl_king$elm_iso3166_country_codes$Iso3166$VU = 241;
var $rl_king$elm_iso3166_country_codes$Iso3166$WF = 242;
var $rl_king$elm_iso3166_country_codes$Iso3166$WS = 243;
var $rl_king$elm_iso3166_country_codes$Iso3166$YE = 244;
var $rl_king$elm_iso3166_country_codes$Iso3166$YT = 245;
var $rl_king$elm_iso3166_country_codes$Iso3166$ZA = 246;
var $rl_king$elm_iso3166_country_codes$Iso3166$ZM = 247;
var $rl_king$elm_iso3166_country_codes$Iso3166$ZW = 248;
var $rl_king$elm_iso3166_country_codes$Iso3166$all = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248]);
var $rl_king$elm_iso3166_country_codes$Iso3166$toAlpha2 = function (c) {
	switch (c) {
		case 0:
			return 'ad';
		case 1:
			return 'ae';
		case 2:
			return 'af';
		case 3:
			return 'ag';
		case 4:
			return 'ai';
		case 5:
			return 'al';
		case 6:
			return 'am';
		case 7:
			return 'ao';
		case 8:
			return 'aq';
		case 9:
			return 'ar';
		case 10:
			return 'as';
		case 11:
			return 'at';
		case 12:
			return 'au';
		case 13:
			return 'aw';
		case 14:
			return 'ax';
		case 15:
			return 'az';
		case 16:
			return 'ba';
		case 17:
			return 'bb';
		case 18:
			return 'bd';
		case 19:
			return 'be';
		case 20:
			return 'bf';
		case 21:
			return 'bg';
		case 22:
			return 'bh';
		case 23:
			return 'bi';
		case 24:
			return 'bj';
		case 25:
			return 'bl';
		case 26:
			return 'bm';
		case 27:
			return 'bn';
		case 28:
			return 'bo';
		case 29:
			return 'bq';
		case 30:
			return 'br';
		case 31:
			return 'bs';
		case 32:
			return 'bt';
		case 33:
			return 'bv';
		case 34:
			return 'bw';
		case 35:
			return 'by';
		case 36:
			return 'bz';
		case 37:
			return 'ca';
		case 38:
			return 'cc';
		case 39:
			return 'cd';
		case 40:
			return 'cf';
		case 41:
			return 'cg';
		case 42:
			return 'ch';
		case 43:
			return 'ci';
		case 44:
			return 'ck';
		case 45:
			return 'cl';
		case 46:
			return 'cm';
		case 47:
			return 'cn';
		case 48:
			return 'co';
		case 49:
			return 'cr';
		case 50:
			return 'cu';
		case 51:
			return 'cv';
		case 52:
			return 'cw';
		case 53:
			return 'cx';
		case 54:
			return 'cy';
		case 55:
			return 'cz';
		case 56:
			return 'de';
		case 57:
			return 'dj';
		case 58:
			return 'dk';
		case 59:
			return 'dm';
		case 60:
			return 'do';
		case 61:
			return 'dz';
		case 62:
			return 'ec';
		case 63:
			return 'ee';
		case 64:
			return 'eg';
		case 65:
			return 'eh';
		case 66:
			return 'er';
		case 67:
			return 'es';
		case 68:
			return 'et';
		case 69:
			return 'fi';
		case 70:
			return 'fj';
		case 71:
			return 'fk';
		case 72:
			return 'fm';
		case 73:
			return 'fo';
		case 74:
			return 'fr';
		case 75:
			return 'ga';
		case 76:
			return 'gb';
		case 77:
			return 'gd';
		case 78:
			return 'ge';
		case 79:
			return 'gf';
		case 80:
			return 'gg';
		case 81:
			return 'gh';
		case 82:
			return 'gi';
		case 83:
			return 'gl';
		case 84:
			return 'gm';
		case 85:
			return 'gn';
		case 86:
			return 'gp';
		case 87:
			return 'gq';
		case 88:
			return 'gr';
		case 89:
			return 'gs';
		case 90:
			return 'gt';
		case 91:
			return 'gu';
		case 92:
			return 'gw';
		case 93:
			return 'gy';
		case 94:
			return 'hk';
		case 95:
			return 'hm';
		case 96:
			return 'hn';
		case 97:
			return 'hr';
		case 98:
			return 'ht';
		case 99:
			return 'hu';
		case 100:
			return 'id';
		case 101:
			return 'ie';
		case 102:
			return 'il';
		case 103:
			return 'im';
		case 104:
			return 'in';
		case 105:
			return 'io';
		case 106:
			return 'iq';
		case 107:
			return 'ir';
		case 108:
			return 'is';
		case 109:
			return 'it';
		case 110:
			return 'je';
		case 111:
			return 'jm';
		case 112:
			return 'jo';
		case 113:
			return 'jp';
		case 114:
			return 'ke';
		case 115:
			return 'kg';
		case 116:
			return 'kh';
		case 117:
			return 'ki';
		case 118:
			return 'km';
		case 119:
			return 'kn';
		case 120:
			return 'kp';
		case 121:
			return 'kr';
		case 122:
			return 'kw';
		case 123:
			return 'ky';
		case 124:
			return 'kz';
		case 125:
			return 'la';
		case 126:
			return 'lb';
		case 127:
			return 'lc';
		case 128:
			return 'li';
		case 129:
			return 'lk';
		case 130:
			return 'lr';
		case 131:
			return 'ls';
		case 132:
			return 'lt';
		case 133:
			return 'lu';
		case 134:
			return 'lv';
		case 135:
			return 'ly';
		case 136:
			return 'ma';
		case 137:
			return 'mc';
		case 138:
			return 'md';
		case 139:
			return 'me';
		case 140:
			return 'mf';
		case 141:
			return 'mg';
		case 142:
			return 'mh';
		case 143:
			return 'mk';
		case 144:
			return 'ml';
		case 145:
			return 'mm';
		case 146:
			return 'mn';
		case 147:
			return 'mo';
		case 148:
			return 'mp';
		case 149:
			return 'mq';
		case 150:
			return 'mr';
		case 151:
			return 'ms';
		case 152:
			return 'mt';
		case 153:
			return 'mu';
		case 154:
			return 'mv';
		case 155:
			return 'mw';
		case 156:
			return 'mx';
		case 157:
			return 'my';
		case 158:
			return 'mz';
		case 159:
			return 'na';
		case 160:
			return 'nc';
		case 161:
			return 'ne';
		case 162:
			return 'nf';
		case 163:
			return 'ng';
		case 164:
			return 'ni';
		case 165:
			return 'nl';
		case 166:
			return 'no';
		case 167:
			return 'np';
		case 168:
			return 'nr';
		case 169:
			return 'nu';
		case 170:
			return 'nz';
		case 171:
			return 'om';
		case 172:
			return 'pa';
		case 173:
			return 'pe';
		case 174:
			return 'pf';
		case 175:
			return 'pg';
		case 176:
			return 'ph';
		case 177:
			return 'pk';
		case 178:
			return 'pl';
		case 179:
			return 'pm';
		case 180:
			return 'pn';
		case 181:
			return 'pr';
		case 182:
			return 'ps';
		case 183:
			return 'pt';
		case 184:
			return 'pw';
		case 185:
			return 'py';
		case 186:
			return 'qa';
		case 187:
			return 're';
		case 188:
			return 'ro';
		case 189:
			return 'rs';
		case 190:
			return 'ru';
		case 191:
			return 'rw';
		case 192:
			return 'sa';
		case 193:
			return 'sb';
		case 194:
			return 'sc';
		case 195:
			return 'sd';
		case 196:
			return 'se';
		case 197:
			return 'sg';
		case 198:
			return 'sh';
		case 199:
			return 'si';
		case 200:
			return 'sj';
		case 201:
			return 'sk';
		case 202:
			return 'sl';
		case 203:
			return 'sm';
		case 204:
			return 'sn';
		case 205:
			return 'so';
		case 206:
			return 'sr';
		case 207:
			return 'ss';
		case 208:
			return 'st';
		case 209:
			return 'sv';
		case 210:
			return 'sx';
		case 211:
			return 'sy';
		case 212:
			return 'sz';
		case 213:
			return 'tc';
		case 214:
			return 'td';
		case 215:
			return 'tf';
		case 216:
			return 'tg';
		case 217:
			return 'th';
		case 218:
			return 'tj';
		case 219:
			return 'tk';
		case 220:
			return 'tl';
		case 221:
			return 'tm';
		case 222:
			return 'tn';
		case 223:
			return 'to';
		case 224:
			return 'tr';
		case 225:
			return 'tt';
		case 226:
			return 'tv';
		case 227:
			return 'tw';
		case 228:
			return 'tz';
		case 229:
			return 'ua';
		case 230:
			return 'ug';
		case 231:
			return 'um';
		case 232:
			return 'us';
		case 233:
			return 'uy';
		case 234:
			return 'uz';
		case 235:
			return 'va';
		case 236:
			return 'vc';
		case 237:
			return 've';
		case 238:
			return 'vg';
		case 239:
			return 'vi';
		case 240:
			return 'vn';
		case 241:
			return 'vu';
		case 242:
			return 'wf';
		case 243:
			return 'ws';
		case 244:
			return 'ye';
		case 245:
			return 'yt';
		case 246:
			return 'za';
		case 247:
			return 'zm';
		default:
			return 'zw';
	}
};
var $author$project$Person$countries = function (t_) {
	return A2(
		$elm$core$List$map,
		function (code) {
			return _Utils_Tuple2(
				$elm$core$String$toUpper(
					$rl_king$elm_iso3166_country_codes$Iso3166$toAlpha2(code)),
				t_(
					$author$project$Locale$Messages$Country(code)));
		},
		$rl_king$elm_iso3166_country_codes$Iso3166$all);
};
var $author$project$Locale$Messages$FormInvalidDate = {$: 57};
var $author$project$Form$validDateFormat = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9]{4}-[0-9]{2}-[0-9]{2}$'));
var $author$project$Form$requiredDate = F2(
	function (t_, value) {
		return (value === '') ? $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormRequiredValue)) : (A2($elm$regex$Regex$contains, $author$project$Form$validDateFormat, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormInvalidDate)));
	});
var $author$project$Locale$Messages$FormInvalidPhoneNumber = {$: 58};
var $author$project$Form$validPhoneNumberFormat = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\+\\d{9,15}$'));
var $author$project$Form$requiredPhoneNumber = F2(
	function (t_, value) {
		return (value === '') ? $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormRequiredValue)) : (A2($elm$regex$Regex$contains, $author$project$Form$validPhoneNumberFormat, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormInvalidPhoneNumber)));
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Locale$Hungarian$strCompare = F2(
	function (str1, str2) {
		var sameRanks = $elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2('á', 'a'),
					_Utils_Tuple2('é', 'e'),
					_Utils_Tuple2('í', 'i'),
					_Utils_Tuple2('ó', 'o'),
					_Utils_Tuple2('ö', 'o'),
					_Utils_Tuple2('ő', 'o'),
					_Utils_Tuple2('ú', 'u'),
					_Utils_Tuple2('ü', 'u'),
					_Utils_Tuple2('ű', 'u'),
					_Utils_Tuple2('Á', 'A'),
					_Utils_Tuple2('É', 'E'),
					_Utils_Tuple2('Í', 'I'),
					_Utils_Tuple2('Ó', 'O'),
					_Utils_Tuple2('Ö', 'O'),
					_Utils_Tuple2('Ő', 'O'),
					_Utils_Tuple2('Ú', 'U'),
					_Utils_Tuple2('Ü', 'U'),
					_Utils_Tuple2('Ű', 'U')
				]));
		var getSameRankAlpha = function (_char) {
			return A2($elm$core$Dict$get, _char, sameRanks);
		};
		var specialsToAlpha = function (str) {
			return A3(
				$elm$core$String$foldl,
				F2(
					function (c, acc) {
						return _Utils_ap(
							acc,
							$elm$core$String$fromChar(
								A2(
									$elm$core$Maybe$withDefault,
									c,
									getSameRankAlpha(c))));
					}),
				'',
				str);
		};
		return A2(
			$elm$core$Basics$compare,
			specialsToAlpha(str1),
			specialsToAlpha(str2));
	});
var $author$project$Util$List$sortBy = F2(
	function (getter, list) {
		return A2(
			$elm$core$List$sortWith,
			F2(
				function (a, b) {
					return A2(
						$author$project$Locale$Hungarian$strCompare,
						getter(a),
						getter(b));
				}),
			list);
	});
var $author$project$Form$toSortedSelectOptions = function (choices) {
	return A2(
		$elm$core$List$map,
		$author$project$Form$toSelectOption,
		A2($author$project$Util$List$sortBy, $elm$core$Tuple$second, choices));
};
var $author$project$Element$GenericProfileForm$buildForm = function (t_) {
	return {
		aP: {
			e0: false,
			fi: $author$project$Form$requiredDate(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aP: value});
				}),
			fC: function ($) {
				return $.aP;
			},
			og: {
				cm: 'birthdate',
				ea: t_($author$project$Locale$Messages$PersonBirthDate),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$BirthDate)
			}
		},
		aR: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aR: value});
				}),
			fC: function ($) {
				return $.aR;
			},
			og: {
				cm: 'birthplace_country',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonBirthPlaceCountry),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$BirthPlaceCountry),
				m_: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(
						$author$project$Person$countries(t_)))
			}
		},
		aS: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aS: value});
				}),
			fC: function ($) {
				return $.aS;
			},
			og: {
				cm: 'birthplace',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonBirthPlaceTown),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$BirthPlaceTown),
				fj: t_($author$project$Locale$Messages$PersonBirthPlaceTown),
				ii: 'text'
			}
		},
		O: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{O: value});
				}),
			fC: function ($) {
				return $.O;
			},
			og: {
				cm: 'email',
				e6: 'fa-envelope',
				ea: t_($author$project$Locale$Messages$PersonEmail),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$Email),
				fj: t_($author$project$Locale$Messages$PersonEmail),
				ii: 'email'
			}
		},
		lI: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{lI: value});
				}),
			fC: function ($) {
				return $.lI;
			},
			og: {
				cm: 'firstname',
				e6: 'fa-user',
				ea: t_($author$project$Locale$Messages$PersonFirstName),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$FirstName),
				fj: t_($author$project$Locale$Messages$PersonFirstName),
				ii: 'text'
			}
		},
		av: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{av: value});
				}),
			fC: function ($) {
				return $.av;
			},
			og: {
				cm: 'lastname',
				e6: 'fa-user',
				ea: t_($author$project$Locale$Messages$PersonLastName),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$LastName),
				fj: t_($author$project$Locale$Messages$PersonLastName),
				ii: 'text'
			}
		},
		a1: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a1: value});
				}),
			fC: function ($) {
				return $.a1;
			},
			og: {
				cm: 'permanent_address_country',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressCountry),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$PermanentAddressCountry),
				m_: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(
						$author$project$Person$countries(t_)))
			}
		},
		a2: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a2: value});
				}),
			fC: function ($) {
				return $.a2;
			},
			og: {
				cm: 'permanent_address_postcode',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressPostcode),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$PermanentAddressPostcode),
				fj: t_($author$project$Locale$Messages$PersonAddressPostcode),
				ii: 'text'
			}
		},
		a3: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a3: value});
				}),
			fC: function ($) {
				return $.a3;
			},
			og: {
				cm: 'permanent_address_street_door',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressStreetDoor),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$PermanentAddressStreetDoor),
				fj: t_($author$project$Locale$Messages$PersonAddressStreetDoor),
				ii: 'text'
			}
		},
		a4: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a4: value});
				}),
			fC: function ($) {
				return $.a4;
			},
			og: {
				cm: 'permanent_address_street_name',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressStreetName),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$PermanentAddressStreetName),
				fj: t_($author$project$Locale$Messages$PersonAddressStreetName),
				ii: 'text'
			}
		},
		a5: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a5: value});
				}),
			fC: function ($) {
				return $.a5;
			},
			og: {
				cm: 'permanent_address_street_number',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressStreetNumber),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$PermanentAddressStreetNumber),
				fj: t_($author$project$Locale$Messages$PersonAddressStreetNumber),
				ii: 'text'
			}
		},
		a6: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a6: value});
				}),
			fC: function ($) {
				return $.a6;
			},
			og: {
				cm: 'permanent_address_street_type',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressStreetType),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$PermanentAddressStreetType),
				fj: t_($author$project$Locale$Messages$PersonAddressStreetType),
				ii: 'text'
			}
		},
		a7: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a7: value});
				}),
			fC: function ($) {
				return $.a7;
			},
			og: {
				cm: 'permanent_address_town',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressTown),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$PermanentAddressTown),
				fj: t_($author$project$Locale$Messages$PersonAddressTown),
				ii: 'text'
			}
		},
		a$: {
			e0: false,
			fi: $author$project$Form$requiredPhoneNumber(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a$: value});
				}),
			fC: function ($) {
				return $.a$;
			},
			og: {
				cm: 'phone',
				e6: 'fa-phone',
				ea: t_($author$project$Locale$Messages$PersonPhone),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$Phone),
				fj: t_($author$project$Locale$Messages$PersonPhone),
				ii: 'phone'
			}
		}
	};
};
var $author$project$Element$GenericProfileForm$fillForm = function (person) {
	return {
		aP: person.aP,
		aR: person.aR,
		aS: person.aS,
		O: person.O,
		lI: person.lI,
		av: person.av,
		a1: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.le;
				},
				person.dp)),
		a2: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nb;
				},
				person.dp)),
		a3: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nP;
				},
				person.dp)),
		a4: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nQ;
				},
				person.dp)),
		a5: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nR;
				},
				person.dp)),
		a6: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nS;
				},
				person.dp)),
		a7: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ob;
				},
				person.dp)),
		a$: person.a$
	};
};
var $author$project$Element$GenericProfileForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.lI, values) && (A2($author$project$Form$isFieldValid, form.av, values) && (A2($author$project$Form$isFieldValid, form.O, values) && (A2($author$project$Form$isFieldValid, form.a$, values) && (A2($author$project$Form$isFieldValid, form.a1, values) && (A2($author$project$Form$isFieldValid, form.a2, values) && (A2($author$project$Form$isFieldValid, form.a7, values) && (A2($author$project$Form$isFieldValid, form.a4, values) && (A2($author$project$Form$isFieldValid, form.a6, values) && (A2($author$project$Form$isFieldValid, form.a5, values) && (A2($author$project$Form$isFieldValid, form.a3, values) && (A2($author$project$Form$isFieldValid, form.aP, values) && (A2($author$project$Form$isFieldValid, form.aR, values) && A2($author$project$Form$isFieldValid, form.aS, values)))))))))))));
	});
var $author$project$Log$msgEmailChange = 'email_change';
var $author$project$Log$msgProfileSave = 'profile_save';
var $author$project$Person$UnsavedProfile = function (id) {
	return function (firstName) {
		return function (lastName) {
			return function (phoneNumber) {
				return function (email) {
					return function (permanentAddress) {
						return function (temporaryAddress) {
							return function (birthDate) {
								return function (birthPlaceCountry) {
									return function (birthPlaceTown) {
										return {aP: birthDate, aR: birthPlaceCountry, aS: birthPlaceTown, O: email, lI: firstName, i8: id, av: lastName, dp: permanentAddress, a$: phoneNumber, n3: temporaryAddress};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Element$GenericProfileForm$saveForm = F3(
	function (form, values, person) {
		return $author$project$Person$UnsavedProfile(person.i8)(
			form.lI.fC(values))(
			form.av.fC(values))(
			form.a$.fC(values))(
			form.O.fC(values))(
			A9(
				$author$project$Person$Address,
				true,
				form.a1.fC(values),
				form.a7.fC(values),
				form.a2.fC(values),
				'',
				form.a4.fC(values),
				form.a6.fC(values),
				form.a5.fC(values),
				form.a3.fC(values)))($elm$core$Maybe$Nothing)(
			form.aP.fC(values))(
			form.aR.fC(values))(
			form.aS.fC(values));
	});
var $author$project$Person$addressEncoder = function (address) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'is_permanent',
				$elm$json$Json$Encode$bool(address.ji)),
				_Utils_Tuple2(
				'country',
				$elm$json$Json$Encode$string(address.le)),
				_Utils_Tuple2(
				'town',
				$elm$json$Json$Encode$string(address.ob)),
				_Utils_Tuple2(
				'postcode',
				$elm$json$Json$Encode$string(address.nb)),
				_Utils_Tuple2(
				'pob',
				$elm$json$Json$Encode$string(address.jK)),
				_Utils_Tuple2(
				'street_name',
				$elm$json$Json$Encode$string(address.nQ)),
				_Utils_Tuple2(
				'street_type',
				$elm$json$Json$Encode$string(address.nS)),
				_Utils_Tuple2(
				'street_number',
				$elm$json$Json$Encode$string(address.nR)),
				_Utils_Tuple2(
				'street_door',
				$elm$json$Json$Encode$string(address.nP))
			]));
};
var $author$project$Data$encodeNullable = function (valueEncoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(valueEncoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $author$project$Person$profileEncoder = function (profile) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(profile.i8)),
				_Utils_Tuple2(
				'first_name',
				$elm$json$Json$Encode$string(profile.lI)),
				_Utils_Tuple2(
				'last_name',
				$elm$json$Json$Encode$string(profile.av)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(profile.O)),
				_Utils_Tuple2(
				'phone_number',
				$elm$json$Json$Encode$string(profile.a$)),
				_Utils_Tuple2(
				'permanent_address',
				$author$project$Person$addressEncoder(profile.dp)),
				_Utils_Tuple2(
				'temporary_address',
				A2($author$project$Data$encodeNullable, $author$project$Person$addressEncoder, profile.n3)),
				_Utils_Tuple2(
				'birthdate',
				$elm$json$Json$Encode$string(profile.aP)),
				_Utils_Tuple2(
				'birthplace_country',
				$elm$json$Json$Encode$string(profile.aR)),
				_Utils_Tuple2(
				'birthplace',
				$elm$json$Json$Encode$string(profile.aS))
			]));
};
var $author$project$Person$saveProfile = F4(
	function (config, profile, id, callback) {
		return A5(
			$author$project$Api$put,
			A2($author$project$Api$Endpoint$person, config, id),
			config,
			$elm$http$Http$jsonBody(
				$author$project$Person$profileEncoder(profile)),
			callback,
			$author$project$Person$personDecoder);
	});
var $author$project$Ports$scrollToFormError = $author$project$Ports$scrollToElement('div[class~=has-errors]');
var $author$project$Element$GenericProfileForm$updateForm = F3(
	function (msg, form, formValues) {
		switch (msg.$) {
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							lI: $author$project$Form$markEdited(form.lI)
						}),
					A2(form.lI.ks, value, formValues));
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							av: $author$project$Form$markEdited(form.av)
						}),
					A2(form.av.ks, value, formValues));
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							O: $author$project$Form$markEdited(form.O)
						}),
					A2(form.O.ks, value, formValues));
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a$: $author$project$Form$markEdited(form.a$)
						}),
					A2(form.a$.ks, value, formValues));
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a1: $author$project$Form$markEdited(form.a1)
						}),
					A2(form.a1.ks, value, formValues));
			case 5:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a2: $author$project$Form$markEdited(form.a2)
						}),
					A2(form.a2.ks, value, formValues));
			case 6:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a7: $author$project$Form$markEdited(form.a7)
						}),
					A2(form.a7.ks, value, formValues));
			case 7:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a4: $author$project$Form$markEdited(form.a4)
						}),
					A2(form.a4.ks, value, formValues));
			case 8:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a6: $author$project$Form$markEdited(form.a6)
						}),
					A2(form.a6.ks, value, formValues));
			case 9:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a5: $author$project$Form$markEdited(form.a5)
						}),
					A2(form.a5.ks, value, formValues));
			case 10:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a3: $author$project$Form$markEdited(form.a3)
						}),
					A2(form.a3.ks, value, formValues));
			case 12:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aS: $author$project$Form$markEdited(form.aS)
						}),
					A2(form.aS.ks, value, formValues));
			case 13:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aR: $author$project$Form$markEdited(form.aR)
						}),
					A2(form.aR.ks, value, formValues));
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aP: $author$project$Form$markEdited(form.aP)
						}),
					A2(form.aP.ks, value, formValues));
		}
	});
var $author$project$Element$GenericProfileForm$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			aP: $author$project$Form$markEdited(form.aP),
			aR: $author$project$Form$markEdited(form.aR),
			aS: $author$project$Form$markEdited(form.aS),
			O: $author$project$Form$markEdited(form.O),
			lI: $author$project$Form$markEdited(form.lI),
			av: $author$project$Form$markEdited(form.av),
			a1: $author$project$Form$markEdited(form.a1),
			a2: $author$project$Form$markEdited(form.a2),
			a3: $author$project$Form$markEdited(form.a3),
			a4: $author$project$Form$markEdited(form.a4),
			a5: $author$project$Form$markEdited(form.a5),
			a6: $author$project$Form$markEdited(form.a6),
			a7: $author$project$Form$markEdited(form.a7),
			a$: $author$project$Form$markEdited(form.a$)
		});
};
var $author$project$Element$GenericProfileForm$update = F3(
	function (session, msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.bk);
		_v0$8:
		while (true) {
			switch (_v0.a.$) {
				case 2:
					if (_v0.b.$ === 2) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						var form = _v2.b;
						var person = _v2.d;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									bk: A4(
										$author$project$Element$GenericProfileForm$FormPage,
										0,
										form,
										$author$project$Element$GenericProfileForm$fillForm(person),
										person)
								}),
							session);
					} else {
						break _v0$8;
					}
				case 0:
					if (_v0.b.$ === 2) {
						var fieldMsg = _v0.a.a;
						var _v3 = _v0.b;
						var form = _v3.b;
						var values = _v3.c;
						var person = _v3.d;
						var _v4 = A3($author$project$Element$GenericProfileForm$updateForm, fieldMsg, form, values);
						var form2 = _v4.a;
						var values2 = _v4.b;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									bk: A4($author$project$Element$GenericProfileForm$FormPage, 1, form2, values2, person)
								}),
							session);
					} else {
						break _v0$8;
					}
				case 1:
					if (_v0.b.$ === 2) {
						var _v5 = _v0.a;
						var _v6 = _v0.b;
						var form = _v6.b;
						var values = _v6.c;
						var person = _v6.d;
						return A2($author$project$Element$GenericProfileForm$isFormValid, form, values) ? A2(
							$author$project$Application$Boundaries$andThenCmd,
							A4(
								$author$project$Person$saveProfile,
								model.b_.gX,
								A3($author$project$Element$GenericProfileForm$saveForm, form, values, person),
								person.i8,
								$author$project$Element$GenericProfileForm$ProfileSaved),
							A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bk: A4($author$project$Element$GenericProfileForm$FormPage, 2, form, values, person)
									}),
								session)) : A2(
							$author$project$Application$Boundaries$andThenCmd,
							$author$project$Ports$scrollToFormError,
							A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bk: A4(
											$author$project$Element$GenericProfileForm$FormPage,
											1,
											$author$project$Element$GenericProfileForm$validateForm(form),
											values,
											person)
									}),
								session));
					} else {
						break _v0$8;
					}
				case 3:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 1) {
							var person = _v0.a.a.a;
							return $author$project$Person$isTeacher(person) ? A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$author$project$Route$replaceUrl,
									model.b_.jk,
									$author$project$Route$TeacherProfilesUpdate(person.i8)),
								A2($author$project$Application$Boundaries$save, model, session)) : ($author$project$Person$isStudent(person) ? A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$author$project$Route$replaceUrl,
									model.b_.jk,
									$author$project$Route$StudentProfileUpdate(person.i8)),
								A2($author$project$Application$Boundaries$save, model, session)) : A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$ok,
									model.b_,
									_Utils_Tuple2(
										$author$project$Log$msgProfileDownload,
										_List_fromArray(
											[
												$elm$core$String$fromInt(person.i8),
												$author$project$Log$paramOk
											])),
									$elm$core$Basics$always($author$project$Element$GenericProfileForm$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bk: A4(
												$author$project$Element$GenericProfileForm$FormPage,
												0,
												$author$project$Element$GenericProfileForm$buildForm(session.h6),
												$author$project$Element$GenericProfileForm$fillForm(person),
												person)
										}),
									session)));
						} else {
							break _v0$8;
						}
					} else {
						if (_v0.b.$ === 1) {
							var error = _v0.a.a.a;
							var id = _v0.b.a;
							var session2 = A3(
								$author$project$Session$error,
								session,
								error,
								session.h6($author$project$Locale$Messages$ProfilesDownloadError));
							var model2 = _Utils_update(
								model,
								{bk: $author$project$Element$GenericProfileForm$NotFoundPage});
							var cmd = A3(
								$author$project$Log$error,
								model.b_,
								_Utils_Tuple3(
									$author$project$Log$msgProfileDownload,
									$elm$core$Maybe$Just(
										$elm$core$String$fromInt(id)),
									error),
								$elm$core$Basics$always($author$project$Element$GenericProfileForm$NoOp));
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								cmd,
								A2($author$project$Application$Boundaries$save, model2, session2));
						} else {
							break _v0$8;
						}
					}
				case 4:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 2) {
							var newPerson = _v0.a.a.a;
							var _v7 = _v0.b;
							var form = _v7.b;
							var values = _v7.c;
							var person = _v7.d;
							var session2 = A2(
								$author$project$Session$ok,
								session,
								session.h6($author$project$Locale$Messages$ProfilesSaveSuccess));
							var model2 = _Utils_update(
								model,
								{
									bk: A4($author$project$Element$GenericProfileForm$FormPage, 0, form, values, newPerson)
								});
							var cmd = $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3(
										$author$project$Log$ok,
										model.b_,
										_Utils_Tuple2(
											$author$project$Log$msgProfileSave,
											_List_fromArray(
												[
													$elm$core$String$fromInt(newPerson.i8)
												])),
										$elm$core$Basics$always($author$project$Element$GenericProfileForm$NoOp)),
										(!_Utils_eq(newPerson.O, person.O)) ? A3(
										$author$project$Log$ok,
										model.b_,
										_Utils_Tuple2(
											$author$project$Log$msgEmailChange,
											_List_fromArray(
												[person.O, newPerson.O])),
										$elm$core$Basics$always($author$project$Element$GenericProfileForm$NoOp)) : $elm$core$Platform$Cmd$none
									]));
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								cmd,
								A2($author$project$Application$Boundaries$save, model2, session2));
						} else {
							break _v0$8;
						}
					} else {
						if (_v0.b.$ === 2) {
							var error = _v0.a.a.a;
							var _v8 = _v0.b;
							var form = _v8.b;
							var values = _v8.c;
							var person = _v8.d;
							var session2 = A3(
								$author$project$Session$error,
								session,
								error,
								session.h6($author$project$Locale$Messages$FormSaveError));
							var model2 = _Utils_update(
								model,
								{
									bk: A4($author$project$Element$GenericProfileForm$FormPage, 3, form, values, person)
								});
							var cmd = A3(
								$author$project$Log$error,
								model.b_,
								_Utils_Tuple3($author$project$Log$msgProfileSave, $elm$core$Maybe$Nothing, error),
								$elm$core$Basics$always($author$project$Element$GenericProfileForm$NoOp));
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								cmd,
								A2($author$project$Application$Boundaries$save, model2, session2));
						} else {
							break _v0$8;
						}
					}
				default:
					var _v9 = _v0.a;
					return A2($author$project$Application$Boundaries$save, model, session);
			}
		}
		return A2($author$project$Application$Boundaries$save, model, session);
	});
var $author$project$Locale$Messages$ProfilesLoadingProgress = {$: 393};
var $author$project$Locale$Messages$ProfilesNotFound = {$: 394};
var $author$project$Locale$Messages$ProfilesTitle = {$: 397};
var $author$project$Locale$Messages$BtnReset = {$: 32};
var $author$project$Locale$Messages$BtnSave = {$: 33};
var $author$project$Element$GenericProfileForm$FormReset = {$: 2};
var $author$project$Element$GenericProfileForm$FormSubmitted = {$: 1};
var $author$project$Locale$Messages$PersonAddress = {$: 320};
var $author$project$Locale$Messages$ProfilesGravatar = function (a) {
	return {$: 391, a: a};
};
var $author$project$Locale$Messages$ProfilesHeading = function (a) {
	return {$: 392, a: a};
};
var $author$project$Element$GenericProfileForm$birthPlaceTownMaxLength = 60;
var $author$project$Locale$Messages$FormEmptyOptions = {$: 64};
var $author$project$Locale$Messages$FormNotSelected = {$: 66};
var $author$project$Form$SelectOption = F2(
	function (value, label) {
		return {ea: label, fC: value};
	});
var $author$project$UI$onChange = function (onChangeAction) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, onChangeAction, $elm$html$Html$Events$targetValue));
};
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$UI$selectOption = function (config) {
	return A2(
		$elm$html$Html$option,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value(config.dl.fC),
				$elm$html$Html$Attributes$selected(config.D),
				$elm$html$Html$Attributes$disabled(config.d$)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(config.dl.ea)
			]));
};
var $author$project$UI$select_ = F4(
	function (isEditable, classList_, view, options) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('control has-icons-left')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('select'),
							$elm$html$Html$Attributes$classList(classList_)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(view.cm),
									$author$project$UI$onChange(view.fe),
									$author$project$UI$attrCyData(view.cm),
									$elm$html$Html$Attributes$disabled(!isEditable)
								]),
							A2($elm$core$List$map, $author$project$UI$selectOption, options)),
							$author$project$UI$Icon$icon(
							_List_fromArray(
								[
									$author$project$UI$Icon$face(view.e6),
									$author$project$UI$Icon$style('is-left')
								]))
						]))
				]));
	});
var $author$project$UI$choiceField_ = F4(
	function (isEditable, t_, field, values) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		var selectedValue = field.fC(values);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('has-errors', !valid)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$UI$fieldLabel, t_, field),
					function () {
					var _v0 = field.og.m_;
					if (_v0.$ === 1) {
						return $author$project$UI$Icon$loadingOptions(_List_Nil);
					} else {
						if (!_v0.a.b) {
							return A4(
								$author$project$UI$select_,
								isEditable,
								A2($author$project$UI$validationClassList, field, values),
								field.og,
								_List_fromArray(
									[
										{
										d$: true,
										dl: A2(
											$author$project$Form$SelectOption,
											'',
											t_($author$project$Locale$Messages$FormEmptyOptions)),
										D: false
									}
									]));
						} else {
							var options = _v0.a;
							return A4(
								$author$project$UI$select_,
								isEditable,
								A2($author$project$UI$validationClassList, field, values),
								field.og,
								A2(
									$elm$core$List$map,
									function (option) {
										return {
											d$: false,
											dl: option,
											D: _Utils_eq(option.fC, selectedValue)
										};
									},
									A2(
										$elm$core$List$cons,
										A2(
											$author$project$Form$SelectOption,
											'',
											t_($author$project$Locale$Messages$FormNotSelected)),
										options)));
						}
					}
				}(),
					A2($author$project$UI$validationError, field, values)
				]));
	});
var $author$project$UI$choiceField = $author$project$UI$choiceField_(true);
var $author$project$UI$columns = function (cols) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('columns is-fullwidth')
			]),
		A2(
			$elm$core$List$map,
			function (c) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column')
						]),
					_List_fromArray(
						[c]));
			},
			cols));
};
var $author$project$Locale$Messages$FormDateFormat = {$: 56};
var $author$project$UI$dateField = F3(
	function (t_, field, values) {
		var fieldConfig = {
			e0: field.e0,
			fi: field.fi,
			fp: field.fp,
			ks: field.ks,
			fC: field.fC,
			og: {
				cm: field.og.cm,
				e6: 'fa-calendar',
				ea: field.og.ea,
				fe: field.og.fe,
				fj: t_($author$project$Locale$Messages$FormDateFormat),
				ii: 'date'
			}
		};
		return A3($author$project$UI$textField, t_, fieldConfig, values);
	});
var $author$project$Person$fullName = F2(
	function (t_, person) {
		return t_(
			A2($author$project$Locale$Messages$PersonFullName, person.lI, person.av));
	});
var $author$project$UI$gravatar = function (email) {
	var size = 64;
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$src(
				A2($author$project$Util$Media$gravatar, size, email)),
				$elm$html$Html$Attributes$width(size),
				$elm$html$Html$Attributes$height(size)
			]),
		_List_Nil);
};
var $author$project$UI$limitedTextField = function (limit) {
	return A2(
		$author$project$UI$editableTextField,
		true,
		$elm$core$Maybe$Just(limit));
};
var $author$project$UI$mediaObject_ = F5(
	function (size, media, content, navigation, right) {
		return A2(
			$elm$html$Html$article,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('media')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$figure,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('media-left')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('image'),
									$elm$html$Html$Attributes$class(size)
								]),
							media)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('media-content')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('content')
								]),
							content),
						navigation)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('media-right')
						]),
					right)
				]));
	});
var $author$project$UI$mediaObject = F4(
	function (media, content, navigation, right) {
		return A5($author$project$UI$mediaObject_, 'is-64x64', media, content, navigation, right);
	});
var $author$project$UI$resetButton = F4(
	function (label, disabled_, loading, toMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('control')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-link is-light'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('is-loading', loading)
								])),
							$elm$html$Html$Attributes$disabled(disabled_),
							$author$project$UI$attrCyData('reset'),
							$elm$html$Html$Events$onClick(toMsg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				]));
	});
var $author$project$Form$resetDisabled = function (formState) {
	return (!formState) || (formState === 2);
};
var $elm$html$Html$small = _VirtualDom_node('small');
var $author$project$UI$staticTextField = A2($author$project$UI$editableTextField, false, $elm$core$Maybe$Nothing);
var $author$project$Form$submissionDisabled = F2(
	function (formState, formValid) {
		return ((!formValid) && (formState === 1)) || (formState !== 1);
	});
var $author$project$Element$GenericProfileForm$viewForm = F6(
	function (t_, language, formState, form, formValues, person) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('heading')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UI$caption,
							t_,
							$author$project$Locale$Messages$ProfilesHeading(
								A2($author$project$Person$fullName, t_, person)))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A4(
							$author$project$UI$mediaObject,
							_List_fromArray(
								[
									$author$project$UI$gravatar(person.O)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$small,
									_List_Nil,
									$author$project$UI$textToHtml(
										t_(
											$author$project$Locale$Messages$ProfilesGravatar(person.O))))
								]),
							_List_Nil,
							_List_Nil)
						])),
					$author$project$UI$columns(
					language.l4 ? _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.lI, formValues),
							A3($author$project$UI$textField, t_, form.av, formValues)
						]) : _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.av, formValues),
							A3($author$project$UI$textField, t_, form.lI, formValues)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$staticTextField, t_, form.O, formValues),
							A3($author$project$UI$textField, t_, form.a$, formValues)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('heading')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PersonAddress)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.a1, formValues),
							A3($author$project$UI$textField, t_, form.a7, formValues),
							A3($author$project$UI$textField, t_, form.a2, formValues)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.a4, formValues),
							A3($author$project$UI$textField, t_, form.a6, formValues),
							A3($author$project$UI$textField, t_, form.a5, formValues),
							A3($author$project$UI$textField, t_, form.a3, formValues)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.aR, formValues),
							A4($author$project$UI$limitedTextField, $author$project$Element$GenericProfileForm$birthPlaceTownMaxLength, t_, form.aS, formValues),
							A3($author$project$UI$dateField, t_, form.aP, formValues)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('field is-grouped')
						]),
					_List_fromArray(
						[
							A4(
							$author$project$UI$submitButton,
							t_($author$project$Locale$Messages$BtnSave),
							A2($author$project$Form$submissionDisabled, formState, true),
							$author$project$Form$isProcessing(formState),
							$author$project$Element$GenericProfileForm$FormSubmitted),
							A4(
							$author$project$UI$resetButton,
							t_($author$project$Locale$Messages$BtnReset),
							$author$project$Form$resetDisabled(formState),
							$author$project$Form$isProcessing(formState),
							$author$project$Element$GenericProfileForm$FormReset)
						]))
				]));
	});
var $author$project$Element$GenericProfileForm$view = F2(
	function (session, model) {
		var t_ = session.h6;
		var _v0 = model.bk;
		switch (_v0.$) {
			case 2:
				var formState = _v0.a;
				var form = _v0.b;
				var values = _v0.c;
				var person = _v0.d;
				return $author$project$UI$panel(
					{
						g$: _List_fromArray(
							[
								A6($author$project$Element$GenericProfileForm$viewForm, t_, session.mn, formState, form, values, person)
							]),
						cm: 'profile-form',
						hl: _List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ProfilesTitle)
							]),
						h7: _List_Nil,
						ie: 'is-light'
					});
			case 1:
				return A2(
					$author$project$UI$progressBar,
					'is-primary',
					t_($author$project$Locale$Messages$ProfilesLoadingProgress));
			default:
				return $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ProfilesNotFound)
						]));
		}
	});
var $author$project$Element$GenericProfileForm$element = {jb: $author$project$Element$GenericProfileForm$init, ks: $author$project$Element$GenericProfileForm$update, og: $author$project$Element$GenericProfileForm$view};
var $author$project$Element$GradeRequestList$FetchStudentProfile = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$GradeRequestList$LoadingPage = {$: 1};
var $author$project$Element$GradeRequestList$NotFoundPage = {$: 0};
var $author$project$Element$GradeRequestList$StudentProfileDownloaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Endpoint$studentProfile = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'student-profiles',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$StudentProfile$StudentProfile = function (id) {
	return function (state) {
		return function (student) {
			return function (mothersMaidenName) {
				return function (admission) {
					return function (basicTask) {
						return function (termination) {
							return function (missedClasses) {
								return function (accidents) {
									return function (competencyTestResults) {
										return function (exams) {
											return function (disciplinaryAndCompensationCases) {
												return function (studentCardId) {
													return function (textbookSupply) {
														return function (schoolYearRepetition) {
															return function (tripAbroad) {
																return function (specialStatus) {
																	return function (isIndividualStudent) {
																		return function (currentGrade) {
																			return function (nekId) {
																				return function (firstForeignLanguage) {
																					return function (secondForeignLanguage) {
																						return function (lastReportCardUrl) {
																							return function (evaluationUrl) {
																								return function (individualStudentUrl) {
																									return function (specialStatusUrl) {
																										return function (studentCardUrl) {
																											return function (birthCertificateUrl) {
																												return function (residencePermitUrl) {
																													return function (idCardUrl) {
																														return function (taxIdUrl) {
																															return function (ssnUrl) {
																																return function (nekIdUrl) {
																																	return {ag: accidents, ah: admission, aj: basicTask, o: birthCertificateUrl, an: competencyTestResults, fT: currentGrade, ao: disciplinaryAndCompensationCases, y: evaluationUrl, aq: exams, bf: firstForeignLanguage, i8: id, q: idCardUrl, A: individualStudentUrl, as: isIndividualStudent, I: lastReportCardUrl, aw: missedClasses, aB: mothersMaidenName, m: nekId, b: nekIdUrl, s: residencePermitUrl, aE: schoolYearRepetition, bm: secondForeignLanguage, aF: specialStatus, E: specialStatusUrl, t: ssnUrl, fs: state, nT: student, aH: studentCardId, J: studentCardUrl, u: taxIdUrl, aJ: termination, aK: textbookSupply, aM: tripAbroad};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$StudentProfile$Student = function (id) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (phoneNumber) {
					return function (permanentAddress) {
						return function (temporaryAddress) {
							return function (birthDate) {
								return function (birthPlaceCountry) {
									return function (birthPlace) {
										return function (nationality) {
											return function (eduId) {
												return function (ssn) {
													return function (sponsoredBy) {
														return function (supervisingSchool) {
															return function (team) {
																return function (mentor) {
																	return {aP: birthDate, am: birthPlace, aR: birthPlaceCountry, ap: eduId, O: email, lI: firstName, i8: id, av: lastName, my: mentor, aC: nationality, dp: permanentAddress, a$: phoneNumber, nM: sponsoredBy, aG: ssn, aI: supervisingSchool, kf: team, n3: temporaryAddress};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Team$nestedTeamDecoder = $author$project$Team$teamDecoder;
var $author$project$StudentProfile$studentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'mentor',
	$elm$json$Json$Decode$nullable($author$project$Person$nestedPersonDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'team',
		$author$project$Team$nestedTeamDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'supervising_school',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sponsored_by',
				$author$project$Person$nestedPeopleDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'ssn',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'edu_id',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'nationality',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'birthplace',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'birthplace_country',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'birthdate',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'temporary_address',
											$elm$json$Json$Decode$nullable($author$project$Person$addressDecoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'permanent_address',
												$elm$json$Json$Decode$nullable($author$project$Person$addressDecoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'phone_number',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'email',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'last_name',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'first_name',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'id',
																	$elm$json$Json$Decode$int,
																	$elm$json$Json$Decode$succeed($author$project$StudentProfile$Student))))))))))))))))));
var $author$project$StudentProfile$StudentProfileId = $elm$core$Basics$identity;
var $author$project$StudentProfile$studentProfileIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$StudentProfile$studentProfileDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nek_id_url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ssn_url',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'tax_id_url',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id_card_url',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'residence_permit_url',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'birth_certificate_url',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'student_card_url',
							$elm$json$Json$Decode$string,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'special_status_report_url',
								$elm$json$Json$Decode$string,
								'',
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'individual_student_url',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'evaluation_url',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'last_report_card_url',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'second_foreign_language',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'first_foreign_language',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'nek_id',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'current_grade',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'is_individual_student',
																$elm$json$Json$Decode$bool,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'special_status_type',
																	$elm$json$Json$Decode$string,
																	'NONE',
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'trip_abroad',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'school_year_repetition',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'textbook_supply',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'student_card_id',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'disciplinary_and_compensation_cases',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'exams',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'competency_test_results',
																								$elm$json$Json$Decode$string,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'accidents',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'missed_classes',
																										$elm$json$Json$Decode$string,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'termination',
																											$elm$json$Json$Decode$string,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'basic_task',
																												$elm$json$Json$Decode$string,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'admission',
																													$elm$json$Json$Decode$string,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'mothers_name',
																														$elm$json$Json$Decode$string,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'student',
																															$author$project$StudentProfile$studentDecoder,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'state',
																																$elm$json$Json$Decode$string,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'id',
																																	$author$project$StudentProfile$studentProfileIdDecoder,
																																	$elm$json$Json$Decode$succeed($author$project$StudentProfile$StudentProfile))))))))))))))))))))))))))))))))));
var $author$project$StudentProfile$fetchStudentProfileV3 = F3(
	function (config, id, callback) {
		return {
			b_: config,
			d_: $author$project$StudentProfile$studentProfileDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2($author$project$Api$Endpoint$studentProfile, config, id)
		};
	});
var $author$project$Element$GradeRequestList$init = F3(
	function (config, session, params) {
		var model = {b_: config, bk: $author$project$Element$GradeRequestList$NotFoundPage, hO: params, eq: $elm$core$Maybe$Nothing, gB: session};
		var _v0 = params;
		var personId = _v0.a;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{bk: $author$project$Element$GradeRequestList$LoadingPage}),
			$author$project$Element$GradeRequestList$FetchStudentProfile(
				A3($author$project$StudentProfile$fetchStudentProfileV3, config.gX, personId, $author$project$Element$GradeRequestList$StudentProfileDownloaded)),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Application$V3$Boundaries$performElement = F3(
	function (key, effect_, element) {
		return A2(
			$elm$core$Platform$Cmd$map,
			element.cf,
			A2(element.ha.hP, key, effect_));
	});
var $author$project$Element$GradeRequestList$GradeRequestReasonFormEffect = $elm$core$Basics$identity;
var $author$project$Element$GradeRequestList$GradeRequestReasonFormModel = $elm$core$Basics$identity;
var $author$project$Element$GradeRequestList$GradeRequestReasonFormMsg = $elm$core$Basics$identity;
var $author$project$Element$GradeRequestList$PopupEffect = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$GradeRequestList$PopupMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$GradeRequestReasonForm$NoEffect = {$: 0};
var $author$project$Element$GradeRequestReasonForm$FormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$GradeRequestReasonFormJustification = {$: 110};
var $author$project$Element$GradeRequestReasonForm$Reason = $elm$core$Basics$identity;
var $author$project$Element$GradeRequestReasonForm$buildForm = function (t_) {
	return {
		a8: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a8: value});
				}),
			fC: function ($) {
				return $.a8;
			},
			og: {
				cm: 'reason',
				ea: t_($author$project$Locale$Messages$GradeRequestReasonFormJustification),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$GradeRequestReasonForm$FormMsg, $elm$core$Basics$identity),
				fj: t_($author$project$Locale$Messages$GradeRequestReasonFormJustification)
			}
		}
	};
};
var $author$project$Element$GradeRequestReasonForm$emptyForm = {a8: ''};
var $author$project$Element$GradeRequestReasonForm$init = F3(
	function (config, session, params) {
		var model = {
			b_: config,
			bE: $author$project$Element$GradeRequestReasonForm$buildForm(session.h6),
			bL: params.bL,
			cc: params.cc,
			gB: session,
			fs: 0,
			eI: $author$project$Element$GradeRequestReasonForm$emptyForm
		};
		return _Utils_Tuple3(model, $author$project$Element$GradeRequestReasonForm$NoEffect, $elm$core$Maybe$Nothing);
	});
var $author$project$Api$patchV2 = function (_v0) {
	var config = _v0.b_;
	var url = _v0.K;
	var decoder = _v0.d_;
	var toMsg = _v0.cf;
	var body = _v0.T;
	return $author$project$Api$Endpoint$request(
		{
			T: $elm$http$Http$jsonBody(body),
			bd: A2($author$project$Api$expectJson, toMsg, decoder),
			ar: $author$project$Api$toHeaders(config.gX),
			bj: 'PATCH',
			bp: $elm$core$Maybe$Nothing,
			bq: $elm$core$Maybe$Nothing,
			K: url
		});
};
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Element$GradeRequestReasonForm$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$GradeRequestReasonForm$perform(key),
						effects));
			case 3:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			case 5:
				var route = effect.a;
				return A2(
					$elm$browser$Browser$Navigation$pushUrl,
					key,
					$author$project$Route$toString(route));
			case 2:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			default:
				var request = effect.a;
				return $author$project$Api$patchV2(request);
		}
	});
var $author$project$Element$GradeRequestReasonForm$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$CustomError = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$GradeRequestReasonForm$Exit = 0;
var $author$project$Locale$Messages$GradeRequestSaveError = {$: 106};
var $author$project$Locale$Messages$GradeRequestSaveSuccess = {$: 107};
var $author$project$Element$GradeRequestReasonForm$LearningAssessmentUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$LearningGroupSaveError = {$: 162};
var $author$project$Element$GradeRequestReasonForm$LogError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$GradeRequestReasonForm$LogOk = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$GradeRequestReasonForm$NavRedirect = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$GradeRequestReasonForm$NoOp = {$: 4};
var $author$project$Element$GradeRequestReasonForm$UpdateLearningAssessment = function (a) {
	return {$: 4, a: a};
};
var $author$project$Log$errV2 = F3(
	function (config, _v0, toMsg) {
		var eventName = _v0.a;
		var message = _v0.b;
		var event = {iJ: config.gX.hD, c$: config.g0, cn: eventName, di: 0, cz: message};
		return {
			T: A2($author$project$Log$encodeLogEvent, config.gX.hE, event),
			b_: config,
			d_: $elm$json$Json$Decode$succeed(0),
			cf: toMsg,
			K: $author$project$Api$Endpoint$log(config.gX)
		};
	});
var $author$project$Log$errorV2 = F3(
	function (config, _v0, toMsg) {
		var eventName = _v0.a;
		var message = _v0.b;
		var error_ = _v0.c;
		if (!message.$) {
			var message_ = message.a;
			return A3(
				$author$project$Log$errV2,
				config,
				_Utils_Tuple2(
					eventName,
					_Utils_ap(
						message_,
						_Utils_ap(
							$author$project$Log$msgSeperator,
							$author$project$Api$httpErrorToRobots(error_)))),
				toMsg);
		} else {
			return A3(
				$author$project$Log$errV2,
				config,
				_Utils_Tuple2(
					eventName,
					$author$project$Api$httpErrorToRobots(error_)),
				toMsg);
		}
	});
var $author$project$Element$GradeRequestReasonForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.a8, values);
	});
var $author$project$Log$msgLearningAssessmentSave = 'learning_assessment_save';
var $author$project$Log$paramScopeGradeRequest = 'scope_graderequest';
var $author$project$LearningAssessment$UnsavedLearningAssessment = function (id) {
	return function (student) {
		return function (grade) {
			return function (type_) {
				return function (subjects) {
					return function (absenceMinutes) {
						return function (justifiedAbsenceMinutes) {
							return function (unjustifiedAbsenceMinutes) {
								return function (startDate) {
									return function (endDate) {
										return function (reportCardSupplementUrl) {
											return function (reportWithMarksUrl) {
												return function (reportWithTextAppraisalUrl) {
													return function (isLocked) {
														return function (isSupervised) {
															return function (isPassed) {
																return function (mustRepeatGrade) {
																	return function (canTakeRepeatExam) {
																		return function (canRequireMark) {
																			return function (reason) {
																				return {fF: absenceMinutes, iG: canRequireMark, fR: canTakeRepeatExam, ly: endDate, W: grade, i8: id, l9: isLocked, f8: isPassed, f9: isSupervised, ga: justifiedAbsenceMinutes, gh: mustRepeatGrade, a8: reason, gt: reportCardSupplementUrl, nj: reportWithMarksUrl, nk: reportWithTextAppraisalUrl, nN: startDate, nT: student, kb: subjects, ii: type_, gL: unjustifiedAbsenceMinutes};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$LearningAssessment$unsavedLearningAssessment = F3(
	function (learningAssessment, reason, subjects) {
		return $author$project$LearningAssessment$UnsavedLearningAssessment(learningAssessment.i8)(learningAssessment.nT)(learningAssessment.W)(learningAssessment.ii)(subjects)(learningAssessment.fF)(learningAssessment.ga)(learningAssessment.gL)(learningAssessment.nN)(learningAssessment.ly)(learningAssessment.gt)(learningAssessment.nj)(learningAssessment.nk)(learningAssessment.l9)(learningAssessment.f9)(learningAssessment.f8)(learningAssessment.gh)(learningAssessment.fR)(learningAssessment.iG)(reason);
	});
var $author$project$Element$GradeRequestReasonForm$updateForm = F3(
	function (msg, form, formValues) {
		var value = msg;
		return _Utils_Tuple2(
			_Utils_update(
				form,
				{
					a8: $author$project$Form$markEdited(form.a8)
				}),
			A2(form.a8.ks, value, formValues));
	});
var $author$project$Api$Endpoint$learningAssessment = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'learning-assessments',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$LearningAssessment$LearningAssessment = function (id) {
	return function (student) {
		return function (grade) {
			return function (type_) {
				return function (subjects) {
					return function (absenceMinutes) {
						return function (justifiedAbsenceMinutes) {
							return function (unjustifiedAbsenceMinutes) {
								return function (startDate) {
									return function (endDate) {
										return function (reportCardSupplementUrl) {
											return function (reportWithMarksUrl) {
												return function (reportWithTextAppraisalUrl) {
													return function (isLocked) {
														return function (isSupervised) {
															return function (isPassed) {
																return function (mustRepeatGrade) {
																	return function (canTakeRepeatExam) {
																		return function (canRequireMark) {
																			return {fF: absenceMinutes, iG: canRequireMark, fR: canTakeRepeatExam, ly: endDate, W: grade, i8: id, l9: isLocked, f8: isPassed, f9: isSupervised, ga: justifiedAbsenceMinutes, gh: mustRepeatGrade, gt: reportCardSupplementUrl, nj: reportWithMarksUrl, nk: reportWithTextAppraisalUrl, nN: startDate, nT: student, kb: subjects, ii: type_, gL: unjustifiedAbsenceMinutes};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$LearningAssessment$EndOfYear = 1;
var $author$project$LearningAssessment$GradingExam = 2;
var $author$project$LearningAssessment$MidYear = 0;
var $author$project$LearningAssessment$learningAssessmentTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'mid_year':
				return $elm$json$Json$Decode$succeed(0);
			case 'end_of_year':
				return $elm$json$Json$Decode$succeed(1);
			case 'grading_exam':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unknown type: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$SubjectAssessment$SubjectAssessment = function (id) {
	return function (subject) {
		return function (ignored) {
			return function (textAppraisal) {
				return function (finalMark) {
					return function (offeredMark) {
						return function (markRequired) {
							return function (isLocked) {
								return function (isWaived) {
									return function (responsibleTeachers) {
										return function (isWithRecommendation) {
											return {i$: finalMark, i8: id, lX: ignored, l9: isLocked, mg: isWaived, hx: isWithRecommendation, jp: markRequired, en: offeredMark, ab: responsibleTeachers, gE: subject, kh: textAppraisal};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Subject$Subject = F5(
	function (id, name, officialName, slug, isCore) {
		return {i8: id, l2: isCore, fb: name, gk: officialName, nG: slug};
	});
var $author$project$Subject$subjectDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_core',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'slug',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'official_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Subject$Subject))))));
var $author$project$SubjectAssessment$subjectAssessmentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_with_recommendation',
	$elm$json$Json$Decode$bool,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'responsible_teachers',
		$elm$json$Json$Decode$list($author$project$Person$nestedPersonDecoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'is_waived',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_locked',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'mark_required',
					$elm$json$Json$Decode$bool,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'offered_mark',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'final_mark',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'text_appraisal',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'ignored',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'subject',
										$author$project$Subject$subjectDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$int,
											$elm$json$Json$Decode$succeed($author$project$SubjectAssessment$SubjectAssessment))))))))))));
var $author$project$LearningAssessment$learningAssessmentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'can_require_mark',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'can_take_repeat_exam',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'must_repeat_grade',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_passed',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_supervised',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'is_locked',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'report_with_text_appraisal',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'report_with_marks',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'report_card_supplement',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'end_date',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'start_date',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'count_unjustified_absence_minutes',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'count_justified_absence_minutes',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'count_absence_minutes',
														$elm$json$Json$Decode$int,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'subjects',
															$elm$json$Json$Decode$list($author$project$SubjectAssessment$subjectAssessmentDecoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'type',
																$author$project$LearningAssessment$learningAssessmentTypeDecoder,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'grade',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'student',
																		$author$project$Person$nestedPersonDecoder,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'id',
																			$elm$json$Json$Decode$int,
																			$elm$json$Json$Decode$succeed($author$project$LearningAssessment$LearningAssessment))))))))))))))))))));
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$SubjectAssessment$subjectAssessmentEncoder = function (subjectAssessment) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(subjectAssessment.i8)),
				_Utils_Tuple2(
				'text_appraisal',
				function () {
					var _v0 = subjectAssessment.kh;
					if (!_v0.$) {
						var text = _v0.a;
						return $elm$json$Json$Encode$string(text);
					} else {
						return $elm$json$Json$Encode$null;
					}
				}()),
				_Utils_Tuple2(
				'final_mark',
				function () {
					var _v1 = subjectAssessment.i$;
					if (!_v1.$) {
						var mark = _v1.a;
						return $elm$json$Json$Encode$int(mark);
					} else {
						return $elm$json$Json$Encode$null;
					}
				}()),
				_Utils_Tuple2(
				'offered_mark',
				function () {
					var _v2 = subjectAssessment.en;
					if (!_v2.$) {
						var mark = _v2.a;
						return $elm$json$Json$Encode$int(mark);
					} else {
						return $elm$json$Json$Encode$null;
					}
				}()),
				_Utils_Tuple2(
				'mark_required',
				$elm$json$Json$Encode$bool(subjectAssessment.jp))
			]));
};
var $author$project$LearningAssessment$learningAssessmentEncoder = function (learningAssessment) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(learningAssessment.i8)),
				_Utils_Tuple2(
				'subjects',
				A2($elm$json$Json$Encode$list, $author$project$SubjectAssessment$subjectAssessmentEncoder, learningAssessment.kb)),
				_Utils_Tuple2(
				'reason',
				$elm$json$Json$Encode$string(learningAssessment.a8))
			]));
};
var $author$project$LearningAssessment$updateLearningAssessment = F3(
	function (config, learningAssessment, callback) {
		return {
			T: $author$project$LearningAssessment$learningAssessmentEncoder(learningAssessment),
			b_: config,
			d_: $author$project$LearningAssessment$learningAssessmentDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2($author$project$Api$Endpoint$learningAssessment, config.gX, learningAssessment.i8)
		};
	});
var $author$project$Element$GradeRequestReasonForm$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			a8: $author$project$Form$markEdited(form.a8)
		});
};
var $author$project$Element$GradeRequestReasonForm$update = F2(
	function (msg, model) {
		var session = model.gB;
		var config = model.b_;
		var form = model.bE;
		var values = model.eI;
		var noop = _Utils_Tuple3(model, $author$project$Element$GradeRequestReasonForm$NoEffect, $elm$core$Maybe$Nothing);
		switch (msg.$) {
			case 3:
				return _Utils_Tuple3(
					model,
					$author$project$Element$GradeRequestReasonForm$NoEffect,
					$elm$core$Maybe$Just(0));
			case 0:
				if (A2($author$project$Element$GradeRequestReasonForm$isFormValid, form, values)) {
					var updatedLearningAssessment = A3($author$project$LearningAssessment$unsavedLearningAssessment, model.bL, values.a8, model.cc);
					var updateEffect = $author$project$Element$GradeRequestReasonForm$UpdateLearningAssessment(
						A3($author$project$LearningAssessment$updateLearningAssessment, config, updatedLearningAssessment, $author$project$Element$GradeRequestReasonForm$LearningAssessmentUpdated));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fs: 2}),
						updateEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var updatedmodel = _Utils_update(
						model,
						{
							bE: $author$project$Element$GradeRequestReasonForm$validateForm(form),
							fs: 1
						});
					return _Utils_Tuple3(updatedmodel, $author$project$Element$GradeRequestReasonForm$NoEffect, $elm$core$Maybe$Nothing);
				}
			case 2:
				var data = msg.a;
				switch (data.$) {
					case 2:
						var la = data.a;
						var updatedSession = A2(
							$author$project$Session$ok,
							session,
							model.gB.h6($author$project$Locale$Messages$GradeRequestSaveSuccess));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{gB: updatedSession, fs: 0}),
							$author$project$Element$GradeRequestReasonForm$BatchEffect(
								_List_fromArray(
									[
										$author$project$Element$GradeRequestReasonForm$LogOk(
										A3(
											$author$project$Log$okV2,
											config,
											_Utils_Tuple2(
												$author$project$Log$msgLearningAssessmentSave,
												_List_fromArray(
													[
														$author$project$Log$paramScopeGradeRequest,
														$elm$core$String$fromInt(la.i8),
														$author$project$Log$paramOk
													])),
											$elm$core$Basics$always($author$project$Element$GradeRequestReasonForm$NoOp))),
										$author$project$Element$GradeRequestReasonForm$NavRedirect(
										A2(
											$author$project$Route$GradeRequestList,
											la.nT.i8,
											$elm$core$Maybe$Just(la.i8)))
									])),
							$elm$core$Maybe$Just(0));
					case 1:
						return _Utils_Tuple3(model, $author$project$Element$GradeRequestReasonForm$NoEffect, $elm$core$Maybe$Nothing);
					case 3:
						var error = data.a;
						var updatedSession = A3(
							$author$project$Session$error,
							session,
							error,
							model.gB.h6($author$project$Locale$Messages$GradeRequestSaveError));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{gB: updatedSession, fs: 3}),
							$author$project$Element$GradeRequestReasonForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgLearningAssessmentSave,
										$elm$core$Maybe$Just($author$project$Log$paramScopeGradeRequest),
										error),
									$elm$core$Basics$always($author$project$Element$GradeRequestReasonForm$NoOp))),
							$elm$core$Maybe$Nothing);
					default:
						var error = $author$project$Api$CustomError('Unexpected msg (LearningAssessmentUpdated RemoteData.NotAsked)');
						var updatedSession = A3(
							$author$project$Session$error,
							session,
							error,
							model.gB.h6($author$project$Locale$Messages$LearningGroupSaveError));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{gB: updatedSession}),
							$author$project$Element$GradeRequestReasonForm$NoEffect,
							$elm$core$Maybe$Nothing);
				}
			case 1:
				var fieldMsg = msg.a;
				var _v2 = A3($author$project$Element$GradeRequestReasonForm$updateForm, fieldMsg, form, values);
				var form2 = _v2.a;
				var values2 = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bE: form2, fs: 1, eI: values2}),
					$author$project$Element$GradeRequestReasonForm$NoEffect,
					$elm$core$Maybe$Nothing);
			default:
				return noop;
		}
	});
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$UI$bulmaTextarea = F2(
	function (field, values) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		return A2(
			$elm$html$Html$textarea,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('textarea'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('is-danger', field.e0 && (!valid)),
							_Utils_Tuple2('is-success', field.e0 && valid)
						])),
					$elm$html$Html$Attributes$placeholder(field.og.fj),
					$elm$html$Html$Attributes$value(
					field.fC(values)),
					$elm$html$Html$Events$onInput(field.og.fe),
					$author$project$UI$attrCyData(field.og.cm)
				]),
			_List_Nil);
	});
var $author$project$UI$textareaFieldWrapper = F4(
	function (t_, field, values, renderTextarea) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('has-errors', !valid)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$UI$fieldLabel, t_, field),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('control')
						]),
					_List_fromArray(
						[
							A2(renderTextarea, field, values)
						])),
					function () {
					var _v0 = _Utils_Tuple2(
						A2($author$project$Form$fieldError, field, values),
						field.e0);
					if ((!_v0.a.$) && _v0.b) {
						var error = _v0.a.a;
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('help is-danger'),
									$author$project$UI$attrCyData(field.og.cm + '-error')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(error)
								]));
					} else {
						return $author$project$UI$none;
					}
				}()
				]));
	});
var $author$project$UI$textareaField = F3(
	function (t_, field, values) {
		return A4($author$project$UI$textareaFieldWrapper, t_, field, values, $author$project$UI$bulmaTextarea);
	});
var $author$project$Element$GradeRequestReasonForm$viewForm = F3(
	function (t_, form, values) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$UI$textareaField, t_, form.a8, values)
				]));
	});
var $author$project$Element$GradeRequestReasonForm$view = function (_v0) {
	var session = _v0.gB;
	var form = _v0.bE;
	var values = _v0.eI;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A3($author$project$Element$GradeRequestReasonForm$viewForm, session.h6, form, values)
			]));
};
var $author$project$Element$GradeRequestReasonForm$element = {jb: $author$project$Element$GradeRequestReasonForm$init, hP: $author$project$Element$GradeRequestReasonForm$perform, ks: $author$project$Element$GradeRequestReasonForm$update, og: $author$project$Element$GradeRequestReasonForm$view};
var $author$project$Element$GradeRequestList$popups = {
	cL: {
		ha: $author$project$Element$GradeRequestReasonForm$element,
		kk: A2($elm$core$Basics$composeL, $author$project$Element$GradeRequestList$PopupEffect, $elm$core$Basics$identity),
		cf: A2($elm$core$Basics$composeL, $author$project$Element$GradeRequestList$PopupMsg, $elm$core$Basics$identity),
		kt: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						eq: $elm$core$Maybe$Just(model)
					});
			})
	}
};
var $author$project$Element$GradeRequestList$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 2:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 3:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			default:
				var popupEffect = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, popupEffect, $author$project$Element$GradeRequestList$popups.cL);
		}
	});
var $author$project$Element$GradeRequestList$FetchLearningAssessments = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$GradeRequestList$LearningAssessmentListDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$LearningAssessmentsDownloadError = {$: 124};
var $author$project$Element$GradeRequestList$ListPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$GradeRequestList$LogError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$GradeRequestList$NoEffect = {$: 0};
var $author$project$Element$GradeRequestList$NoOp = {$: 0};
var $author$project$Element$GradeRequestList$changeStateToMarkRequested = F2(
	function (learningAssessment, subjectAssessments) {
		var updatedSubjects = A2(
			$elm$core$List$map,
			function (subjectAssessment) {
				return A2($elm$core$List$member, subjectAssessment.i8, subjectAssessments) ? _Utils_update(
					subjectAssessment,
					{jp: true}) : subjectAssessment;
			},
			learningAssessment.kb);
		return _Utils_update(
			learningAssessment,
			{kb: updatedSubjects});
	});
var $author$project$Element$GradeRequestList$MidYear = 0;
var $author$project$LearningAssessment$blankLearningAssessmentId = -1;
var $author$project$Person$blankPersonId = -1;
var $author$project$Person$blankNestedPerson = {O: '', lI: '', i8: $author$project$Person$blankPersonId, av: ''};
var $author$project$LearningAssessment$blankLearningAssessment = {fF: 0, iG: false, fR: false, ly: 0, W: '', i8: $author$project$LearningAssessment$blankLearningAssessmentId, l9: false, f8: false, f9: false, ga: 0, gh: false, gt: $elm$core$Maybe$Nothing, nj: $elm$core$Maybe$Nothing, nk: $elm$core$Maybe$Nothing, nN: 0, nT: $author$project$Person$blankNestedPerson, kb: _List_Nil, ii: 0, gL: 0};
var $author$project$Element$GradeRequestList$defaultTab = {d3: 0, bL: $author$project$LearningAssessment$blankLearningAssessment, cc: _List_Nil, eB: 0, ii: 0};
var $author$project$LearningAssessment$learningAssessmentListDecoder = $elm$json$Json$Decode$list($author$project$LearningAssessment$learningAssessmentDecoder);
var $author$project$Api$Endpoint$learningAssessmentsByPerson = F2(
	function (config, personId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'people',
					$elm$core$String$fromInt(personId),
					'learning-assessments'
				]),
			_List_Nil);
	});
var $author$project$LearningAssessment$fetchLearningAssessmentsByPerson2 = F3(
	function (config, personId, callback) {
		return {
			b_: config,
			d_: $author$project$LearningAssessment$learningAssessmentListDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2($author$project$Api$Endpoint$learningAssessmentsByPerson, config, personId)
		};
	});
var $author$project$Element$GradeRequestList$initListPageModel = function (studentProfile) {
	return {gb: _List_Nil, cd: $elm$core$Maybe$Nothing, h5: studentProfile, gG: _List_Nil};
};
var $author$project$Element$GradeRequestList$compareTab = F2(
	function (left, right) {
		var _v0 = A2($elm$core$Basics$compare, left.eB, right.eB);
		switch (_v0) {
			case 0:
				return 0;
			case 2:
				return 2;
			default:
				var _v1 = A2($elm$core$Basics$compare, left.d3, right.d3);
				switch (_v1) {
					case 0:
						return 0;
					case 2:
						return 2;
					default:
						var _v2 = _Utils_Tuple2(left.ii, right.ii);
						_v2$3:
						while (true) {
							switch (_v2.a) {
								case 1:
									if (_v2.b === 1) {
										var _v3 = _v2.a;
										var _v4 = _v2.b;
										return 1;
									} else {
										var _v10 = _v2.a;
										return 2;
									}
								case 0:
									switch (_v2.b) {
										case 0:
											var _v5 = _v2.a;
											var _v6 = _v2.b;
											return 1;
										case 1:
											break _v2$3;
										default:
											var _v11 = _v2.a;
											var _v12 = _v2.b;
											return 2;
									}
								default:
									switch (_v2.b) {
										case 2:
											var _v7 = _v2.a;
											var _v8 = _v2.b;
											return 1;
										case 1:
											break _v2$3;
										default:
											var _v13 = _v2.a;
											var _v14 = _v2.b;
											return 0;
									}
							}
						}
						var _v9 = _v2.b;
						return 0;
				}
		}
	});
var $author$project$Element$GradeRequestList$EndOfYear = 1;
var $author$project$Element$GradeRequestList$GradingExam = 2;
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Element$GradeRequestList$learningAssessmentToTab = function (la) {
	var startYear = A2(
		$elm$time$Time$toYear,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(la.nN));
	var learningAssessmentType = function () {
		var _v0 = la.ii;
		switch (_v0) {
			case 0:
				return 0;
			case 1:
				return 1;
			default:
				return 2;
		}
	}();
	var endYear = A2(
		$elm$time$Time$toYear,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(la.ly));
	return {
		d3: _Utils_eq(startYear, endYear) ? (endYear + 1) : endYear,
		bL: la,
		cc: _List_Nil,
		eB: startYear,
		ii: learningAssessmentType
	};
};
var $author$project$Element$GradeRequestList$makeTabs = function (learningAssessments) {
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$sortWith,
			$author$project$Element$GradeRequestList$compareTab,
			A2($elm$core$List$map, $author$project$Element$GradeRequestList$learningAssessmentToTab, learningAssessments)));
};
var $author$project$Log$msgLearningAssessmentsDownload = 'learning_assessments_download';
var $author$project$Log$msgStudentProfileDownload = 'student_profile_download';
var $author$project$Application$V3$Boundaries$initElement = F4(
	function (config, session, element, params) {
		return A3(element.ha.jb, config, session, params);
	});
var $author$project$Application$V3$Boundaries$mapElement = F3(
	function (containerModel, element, _v0) {
		var elementModel = _v0.a;
		var elementEffect = _v0.b;
		var reply = _v0.c;
		return _Utils_Tuple3(
			A2(
				element.kt,
				_Utils_update(
					containerModel,
					{gB: elementModel.gB}),
				elementModel),
			element.kk(elementEffect),
			reply);
	});
var $author$project$Element$GradeRequestList$openReasonFormPopup = F3(
	function (learningAssessment, selectedSubjects, _v0) {
		var model = _v0.a;
		var params = {bL: learningAssessment, cc: selectedSubjects};
		var _v1 = A3(
			$author$project$Application$V3$Boundaries$mapElement,
			model,
			$author$project$Element$GradeRequestList$popups.cL,
			A4($author$project$Application$V3$Boundaries$initElement, model.b_, model.gB, $author$project$Element$GradeRequestList$popups.cL, params));
		var popupModel = _v1.a;
		var popupEffect = _v1.b;
		return _Utils_Tuple3(popupModel, popupEffect, $elm$core$Maybe$Nothing);
	});
var $author$project$Application$V3$Boundaries$mapModel = F2(
	function (f, _v0) {
		var prevModel = _v0.a;
		var prevEffect = _v0.b;
		var prevReply = _v0.c;
		return _Utils_Tuple3(
			f(prevModel),
			prevEffect,
			prevReply);
	});
var $author$project$Element$GradeRequestList$closePopup = function (_return) {
	return A2(
		$author$project$Application$V3$Boundaries$mapModel,
		function (model_) {
			return _Utils_update(
				model_,
				{eq: $elm$core$Maybe$Nothing});
		},
		_return);
};
var $author$project$Application$V3$Boundaries$updateElement = F4(
	function (session, msg, model, element) {
		return A2(
			element.ha.ks,
			msg,
			_Utils_update(
				model,
				{gB: session}));
	});
var $author$project$Element$GradeRequestList$updatePopup = F3(
	function (popupMsg, session, model) {
		var _v0 = _Utils_Tuple2(popupMsg, model.eq);
		if (!_v0.b.$) {
			var reasonFormMsg = _v0.a;
			var reasonFormModel = _v0.b.a;
			var _v1 = A3(
				$author$project$Application$V3$Boundaries$mapElement,
				model,
				$author$project$Element$GradeRequestList$popups.cL,
				A4($author$project$Application$V3$Boundaries$updateElement, session, reasonFormMsg, reasonFormModel, $author$project$Element$GradeRequestList$popups.cL));
			var model2 = _v1.a;
			var effect = _v1.b;
			var reply = _v1.c;
			if (!reply.$) {
				var _v3 = reply.a;
				return $author$project$Element$GradeRequestList$closePopup(
					_Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing));
			} else {
				return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
			}
		} else {
			return _Utils_Tuple3(model, $author$project$Element$GradeRequestList$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$GradeRequestList$update = F2(
	function (msg, model) {
		var config = model.b_;
		var session = model.gB;
		var noop = _Utils_Tuple3(model, $author$project$Element$GradeRequestList$NoEffect, $elm$core$Maybe$Nothing);
		var _v0 = _Utils_Tuple2(msg, model.bk);
		_v0$7:
		while (true) {
			switch (_v0.a.$) {
				case 4:
					if (_v0.b.$ === 2) {
						var values = _v0.a.a;
						var listPageModel = _v0.b.a;
						var selectedTab = A2($elm$core$Maybe$withDefault, $author$project$Element$GradeRequestList$defaultTab, listPageModel.cd);
						var updatedTab = _Utils_update(
							selectedTab,
							{cc: values});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bk: $author$project$Element$GradeRequestList$ListPage(
										_Utils_update(
											listPageModel,
											{
												cd: $elm$core$Maybe$Just(updatedTab)
											}))
								}),
							$author$project$Element$GradeRequestList$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$7;
					}
				case 6:
					if (_v0.b.$ === 2) {
						var _v1 = _v0.a;
						var listPageModel = _v0.b.a;
						var selectedTab = A2($elm$core$Maybe$withDefault, $author$project$Element$GradeRequestList$defaultTab, listPageModel.cd);
						var updatedLearningAssessment = A2($author$project$Element$GradeRequestList$changeStateToMarkRequested, selectedTab.bL, selectedTab.cc);
						var selectedSubjects = A2(
							$elm$core$List$filter,
							function (subject) {
								return A2($elm$core$List$member, subject.i8, selectedTab.cc);
							},
							updatedLearningAssessment.kb);
						return A3($author$project$Element$GradeRequestList$openReasonFormPopup, updatedLearningAssessment, selectedSubjects, noop);
					} else {
						break _v0$7;
					}
				case 5:
					var popupMsg = _v0.a.a;
					return A3($author$project$Element$GradeRequestList$updatePopup, popupMsg, session, model);
				case 1:
					if (_v0.b.$ === 2) {
						var data = _v0.a.a;
						var listPageModel = _v0.b.a;
						switch (data.$) {
							case 2:
								var learningAssessments_ = data.a;
								var tabs = $author$project$Element$GradeRequestList$makeTabs(learningAssessments_);
								var _v3 = model.hO;
								var maybeLearningAssessmentId = _v3.b;
								var selectedTab = function () {
									if (!maybeLearningAssessmentId.$) {
										var laId = maybeLearningAssessmentId.a;
										return $elm$core$Maybe$Just(
											A2(
												$elm$core$Maybe$withDefault,
												A2(
													$elm$core$Maybe$withDefault,
													$author$project$Element$GradeRequestList$defaultTab,
													$elm$core$List$head(tabs)),
												$elm$core$List$head(
													A2(
														$elm$core$List$filter,
														function (tab) {
															return _Utils_eq(tab.bL.i8, laId);
														},
														tabs))));
									} else {
										return $elm$core$List$head(tabs);
									}
								}();
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$GradeRequestList$ListPage(
											_Utils_update(
												listPageModel,
												{gb: learningAssessments_, cd: selectedTab, gG: tabs}))
									});
								return _Utils_Tuple3(model2, $author$project$Element$GradeRequestList$NoEffect, $elm$core$Maybe$Nothing);
							case 3:
								var error = data.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											gB: A3(
												$author$project$Session$error,
												session,
												error,
												session.h6($author$project$Locale$Messages$LearningAssessmentsDownloadError))
										}),
									$author$project$Element$GradeRequestList$LogError(
										A3(
											$author$project$Log$errorV2,
											config,
											_Utils_Tuple3(
												$author$project$Log$msgLearningAssessmentsDownload,
												$elm$core$Maybe$Just($author$project$Log$paramScopeGradeRequest),
												error),
											$elm$core$Basics$always($author$project$Element$GradeRequestList$NoOp))),
									$elm$core$Maybe$Nothing);
							case 1:
								return _Utils_Tuple3(model, $author$project$Element$GradeRequestList$NoEffect, $elm$core$Maybe$Nothing);
							default:
								return _Utils_Tuple3(model, $author$project$Element$GradeRequestList$NoEffect, $elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$7;
					}
				case 2:
					if (_v0.b.$ === 1) {
						var data = _v0.a.a;
						var _v5 = _v0.b;
						switch (data.$) {
							case 2:
								var studentProfile_ = data.a;
								var listPageModel = $author$project$Element$GradeRequestList$initListPageModel(studentProfile_);
								var updatedModel = _Utils_update(
									model,
									{
										bk: $author$project$Element$GradeRequestList$ListPage(listPageModel)
									});
								return _Utils_Tuple3(
									updatedModel,
									$author$project$Element$GradeRequestList$FetchLearningAssessments(
										A3($author$project$LearningAssessment$fetchLearningAssessmentsByPerson2, model.b_.gX, listPageModel.h5.nT.i8, $author$project$Element$GradeRequestList$LearningAssessmentListDownloaded)),
									$elm$core$Maybe$Nothing);
							case 3:
								var error = data.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											gB: A3(
												$author$project$Session$error,
												session,
												error,
												session.h6($author$project$Locale$Messages$ProfilesDownloadError))
										}),
									$author$project$Element$GradeRequestList$LogError(
										A3(
											$author$project$Log$errorV2,
											config,
											_Utils_Tuple3(
												$author$project$Log$msgStudentProfileDownload,
												$elm$core$Maybe$Just($author$project$Log$paramScopeGradeRequest),
												error),
											$elm$core$Basics$always($author$project$Element$GradeRequestList$NoOp))),
									$elm$core$Maybe$Nothing);
							case 1:
								return _Utils_Tuple3(model, $author$project$Element$GradeRequestList$NoEffect, $elm$core$Maybe$Nothing);
							default:
								return _Utils_Tuple3(model, $author$project$Element$GradeRequestList$NoEffect, $elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$7;
					}
				case 3:
					if (_v0.b.$ === 2) {
						var tab = _v0.a.a;
						var listPageModel = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bk: $author$project$Element$GradeRequestList$ListPage(
										_Utils_update(
											listPageModel,
											{
												cd: $elm$core$Maybe$Just(tab)
											}))
								}),
							$author$project$Element$GradeRequestList$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$7;
					}
				default:
					var _v7 = _v0.a;
					return noop;
			}
		}
		return noop;
	});
var $author$project$Locale$Messages$GradeReportsLoadingProgress = {$: 84};
var $author$project$Locale$Messages$GradeRequestNoLearningAssessment = {$: 103};
var $author$project$ACL$canViewLearningAssessmentGrades = F2(
	function (_v0, _v1) {
		return true;
	});
var $author$project$Locale$Messages$GradeReportsDownloadGradesPDF = {$: 81};
var $author$project$Locale$Messages$GradeRequestFormTitle = {$: 101};
var $author$project$Locale$Messages$GradeRequestListTitle = {$: 98};
var $author$project$Locale$Messages$GradeRequestNoSubjects = {$: 104};
var $author$project$Locale$Messages$GradeRequestNotInPeriod = {$: 97};
var $author$project$ACL$canRequestGrade = function (person) {
	return $author$project$Person$isSponsor(person);
};
var $author$project$UI$Icon$filePdf = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-file-pdf'),
			attributes));
};
var $author$project$Element$GradeRequestList$isButtonEnabled = function (tab) {
	return tab.bL.iG && (!_Utils_eq(tab.cc, _List_Nil));
};
var $author$project$SubjectAssessment$isRequestable = function (subjectAssessment) {
	return (!subjectAssessment.mg) && ((!subjectAssessment.jp) && _Utils_eq(subjectAssessment.i$, $elm$core$Maybe$Nothing));
};
var $author$project$UI$subtitle = function (content) {
	return A2(
		$elm$html$Html$h1,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('subtitle is-5')
			]),
		content);
};
var $author$project$UI$title = function (content) {
	return A2(
		$elm$html$Html$h1,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('subtitle is-4')
			]),
		content);
};
var $author$project$Locale$Messages$GradeRequestDescription = {$: 99};
var $author$project$Locale$Messages$GradeRequestFormSubmit = {$: 100};
var $author$project$Locale$Messages$LoStudentOverviewSubjects = {$: 173};
var $author$project$Element$GradeRequestList$OpenReasonForm = {$: 6};
var $author$project$Element$GradeRequestList$SetSubject = function (a) {
	return {$: 4, a: a};
};
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $author$project$Util$List$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $author$project$Util$List$findIndex = $author$project$Util$List$findIndexHelp(0);
var $author$project$Util$List$elemIndex = function (x) {
	return $author$project$Util$List$findIndex(
		$elm$core$Basics$eq(x));
};
var $author$project$Util$List$removeElem = F2(
	function (elem, list) {
		var _v0 = A2($author$project$Util$List$elemIndex, elem, list);
		if (_v0.$ === 1) {
			return list;
		} else {
			var index = _v0.a;
			return _Utils_ap(
				A2($elm$core$List$take, index, list),
				A2($elm$core$List$drop, index + 1, list));
		}
	});
var $author$project$UI$checkbox = F5(
	function (toMsg, dataTag, optionIsDisabled, selectedValues, option) {
		var checked_ = A2($elm$core$List$member, option.fC, selectedValues);
		var onClick_ = toMsg(
			checked_ ? A2($author$project$Util$List$removeElem, option.fC, selectedValues) : A2($elm$core$List$cons, option.fC, selectedValues));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('checkbox')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(onClick_),
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$name(dataTag),
									$author$project$UI$attrCyData(dataTag),
									$elm$html$Html$Attributes$checked(checked_),
									$elm$html$Html$Attributes$disabled(
									optionIsDisabled(option))
								]),
							_List_Nil),
							$elm$html$Html$text(' '),
							$elm$html$Html$text(option.ea)
						]))
				]));
	});
var $author$project$Element$GradeRequestList$fromSubjectAssessmentsToValue = function (subjectAssessments) {
	return A2($elm$core$List$map, $elm$core$String$fromInt, subjectAssessments);
};
var $author$project$Element$GradeRequestList$fromValueToSubjectAssessments = function (values) {
	return A2($elm$core$List$filterMap, $elm$core$String$toInt, values);
};
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Locale$Messages$FormSelectAll = {$: 75};
var $author$project$Locale$Messages$FormSelectNone = {$: 76};
var $elm$html$Html$fieldset = _VirtualDom_node('fieldset');
var $elm$html$Html$legend = _VirtualDom_node('legend');
var $author$project$Element$GradeRequestList$viewMultiChoices = F2(
	function (t_, _v0) {
		var data = _v0.g6;
		var toSelectMsg = _v0.ig;
		var caption = _v0.g1;
		var toOptions = _v0.$8;
		var viewOption = _v0.ij;
		var viewSelectLinks = function (lst) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('is-size-7')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$UI$actionLink,
						toSelectMsg(lst),
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$FormSelectAll)
							])),
						$elm$html$Html$text(' | '),
						A3(
						$author$project$UI$actionLink,
						toSelectMsg(_List_Nil),
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$FormSelectNone)
							]))
					]));
		};
		var view_ = function (lst) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('column')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$fieldset,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$legend,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('label')
									]),
								_List_fromArray(
									[caption])),
							$elm$core$List$isEmpty(lst) ? _List_fromArray(
								[
									$author$project$UI$Icon$loadingOptions(_List_Nil)
								]) : A2(
								$elm$core$List$map,
								viewOption,
								toOptions(lst)))),
						A2(
						$author$project$UI$when,
						!$elm$core$List$isEmpty(lst),
						viewSelectLinks(lst))
					]));
		};
		if (data.$ === 1) {
			return view_(_List_Nil);
		} else {
			if (!data.a.b) {
				return $author$project$UI$none;
			} else {
				var lst = data.a;
				return view_(lst);
			}
		}
	});
var $author$project$Element$GradeRequestList$viewRequestForm = F4(
	function (t_, maybeSubjects, selectedSubjects, isSubmitable) {
		var viewCheckbox = function (option) {
			return A5(
				$author$project$UI$checkbox,
				A2($elm$core$Basics$composeL, $author$project$Element$GradeRequestList$SetSubject, $author$project$Element$GradeRequestList$fromValueToSubjectAssessments),
				'subject-checkbox-' + option.fC,
				$elm$core$Basics$always(false),
				$author$project$Element$GradeRequestList$fromSubjectAssessmentsToValue(selectedSubjects),
				option);
		};
		var toSubjectOptions = function (subjectAssessments) {
			return $author$project$Form$toSortedSelectOptions(
				A2(
					$elm$core$List$map,
					function (subjectAssessment) {
						return _Utils_Tuple2(
							$elm$core$String$fromInt(subjectAssessment.i8),
							subjectAssessment.gE.gk);
					},
					subjectAssessments));
		};
		var filteredSubjectAssessments = function () {
			if (maybeSubjects.$ === 1) {
				return _List_Nil;
			} else {
				var subjects = maybeSubjects.a;
				return A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.gE;
						},
						function ($) {
							return $.gk;
						}),
					A2(
						$elm$core$List$filter,
						function (subject) {
							return $author$project$SubjectAssessment$isRequestable(subject);
						},
						subjects));
			}
		}();
		var viewForm = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					_Utils_eq(filteredSubjectAssessments, _List_Nil) ? $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestNoSubjects)
						])) : A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestDescription),
					A2(
					$author$project$Element$GradeRequestList$viewMultiChoices,
					t_,
					{
						g1: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LoStudentOverviewSubjects),
						g6: $elm$core$Maybe$Just(filteredSubjectAssessments),
						$8: toSubjectOptions,
						ig: A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								function ($) {
									return $.i8;
								}),
							$author$project$Element$GradeRequestList$SetSubject),
						ij: viewCheckbox
					}),
					A4(
					$author$project$UI$submitButton,
					t_($author$project$Locale$Messages$GradeRequestFormSubmit),
					!isSubmitable,
					false,
					$author$project$Element$GradeRequestList$OpenReasonForm)
				]));
		return viewForm;
	});
var $author$project$Locale$Messages$GradeReportsExempted = {$: 83};
var $author$project$Locale$Messages$GradeRequestGrade = {$: 102};
var $author$project$Locale$Messages$GradeRequestNotRequested = {$: 105};
var $author$project$Locale$Messages$GradeRequestRequested = {$: 109};
var $author$project$Locale$Messages$GradeRequestSubject = {$: 108};
var $author$project$Locale$Messages$GradeRequestWaived = {$: 112};
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Element$GradeRequestList$viewSubjectListTable = F2(
	function (t_, subjectAssessments) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('table is-striped')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestSubject)
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestGrade)
												]))
										]))
								])),
						A2(
							$elm$core$List$map,
							function (line) {
								return A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$author$project$UI$attrCyData(
											'subject-row-' + $elm$core$String$fromInt(line.i8))
										]),
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(line.gE.gk)
												])),
										line.lX ? _List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('has-text-justified'),
														$elm$html$Html$Attributes$colspan(3)
													]),
												_List_fromArray(
													[
														A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsExempted)
													]))
											]) : (line.mg ? _List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('has-text-justified'),
														$elm$html$Html$Attributes$colspan(3)
													]),
												_List_fromArray(
													[
														A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestWaived)
													]))
											]) : (line.jp ? _List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('has-text-justified')
													]),
												_List_fromArray(
													[
														A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestRequested)
													]))
											]) : ((!_Utils_eq(line.i$, $elm$core$Maybe$Nothing)) ? _List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('has-text-justified')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'',
															A2($elm$core$Maybe$map, $elm$core$String$fromInt, line.i$)))
													]))
											]) : ((!_Utils_eq(line.kh, $elm$core$Maybe$Nothing)) ? _List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('has-text-justified')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($elm$core$Maybe$withDefault, '', line.kh))
													]))
											]) : _List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('has-text-justified')
													]),
												_List_fromArray(
													[
														A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestNotRequested)
													]))
											])))))));
							},
							A2(
								$author$project$Util$List$sortBy,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.gE;
									},
									function ($) {
										return $.gk;
									}),
								subjectAssessments))))
				]));
	});
var $author$project$Element$GradeRequestList$viewLearningAssessment = F2(
	function (_v0, selectedTab) {
		var t_ = _v0.h6;
		var viewer = _v0.ok;
		var learningAssessment = selectedTab.bL;
		var selectedSubjects = selectedTab.cc;
		var viewTitle = $author$project$UI$title(
			_List_fromArray(
				[
					$elm$html$Html$text(
					t_($author$project$Locale$Messages$GradeRequestListTitle))
				]));
		var viewRequestListHeader = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block is-uppercase')
				]),
			_List_fromArray(
				[
					viewTitle,
					$author$project$UI$subtitle(
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Person$fullName, t_, learningAssessment.nT))
						]))
				]));
		var viewButton = A2(
			$author$project$UI$level,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$UI$maybe,
					learningAssessment.nj,
					function (url) {
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(url)
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$filePdf(
									_List_fromArray(
										[
											$author$project$UI$Icon$style('has-text-primary')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsDownloadGradesPDF)
										]))
								]));
					})
				]));
		var subjects = learningAssessment.kb;
		var viewTable = A2($author$project$Element$GradeRequestList$viewSubjectListTable, t_, subjects);
		var requestableSubjects = A2(
			$elm$core$List$filter,
			function (subjectAssessment) {
				return $author$project$SubjectAssessment$isRequestable(subjectAssessment);
			},
			subjects);
		var viewForm = $author$project$ACL$canRequestGrade(viewer) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$UI$title(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestFormTitle)
						])),
					(!learningAssessment.iG) ? $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestNotInPeriod)
						])) : ($elm$core$List$isEmpty(requestableSubjects) ? $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestNoSubjects)
						])) : A4(
					$author$project$Element$GradeRequestList$viewRequestForm,
					t_,
					$elm$core$Maybe$Just(subjects),
					selectedSubjects,
					$author$project$Element$GradeRequestList$isButtonEnabled(selectedTab)))
				])) : $author$project$UI$none;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					viewButton,
					viewRequestListHeader,
					A2(
					$author$project$UI$when,
					!$elm$core$List$isEmpty(subjects),
					viewTable),
					viewForm
				]));
	});
var $author$project$Element$GradeRequestReasonForm$FormSubmitted = {$: 0};
var $author$project$Locale$Messages$GradeRequestReasonFormTitle = {$: 111};
var $author$project$Element$GradeRequestReasonForm$PopupClosed = {$: 3};
var $author$project$Locale$Messages$BtnCancel = {$: 36};
var $author$project$UI$confirmDialog_ = F6(
	function (isBtnOkEnabled, isBtnCancelEnabled, t_, config, title_, content) {
		return A4(
			$author$project$UI$modalPanel,
			title_,
			_List_Nil,
			content,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-primary'),
							$elm$html$Html$Events$onClick(config.lc),
							$elm$html$Html$Attributes$disabled(!isBtnOkEnabled),
							$author$project$UI$attrCyData('confirm')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnOk)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button'),
							$elm$html$Html$Events$onClick(config.lm),
							$elm$html$Html$Attributes$disabled(!isBtnCancelEnabled),
							$author$project$UI$attrCyData('cancel')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnCancel)
						]))
				]));
	});
var $author$project$UI$confirmDialogOkCanBeDisabled = function (isBtnOkEnabled) {
	return A2($author$project$UI$confirmDialog_, isBtnOkEnabled, true);
};
var $author$project$Element$GradeRequestReasonForm$viewPopup = function (_v0) {
	var session = _v0.gB;
	var form = _v0.bE;
	var values = _v0.eI;
	var state = _v0.fs;
	return A5(
		$author$project$UI$confirmDialogOkCanBeDisabled,
		state === 1,
		session.h6,
		{lc: $author$project$Element$GradeRequestReasonForm$FormSubmitted, lm: $author$project$Element$GradeRequestReasonForm$PopupClosed},
		_List_fromArray(
			[
				A2($author$project$UI$caption, session.h6, $author$project$Locale$Messages$GradeRequestReasonFormTitle)
			]),
		_List_fromArray(
			[
				A3($author$project$Element$GradeRequestReasonForm$viewForm, session.h6, form, values)
			]));
};
var $author$project$Element$GradeRequestList$viewPopup = F2(
	function (session, model) {
		var _v0 = model.eq;
		if (!_v0.$) {
			var popupModel = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Element$GradeRequestList$popups.cL.cf,
				$author$project$Element$GradeRequestReasonForm$viewPopup(
					_Utils_update(
						popupModel,
						{gB: session})));
		} else {
			return $author$project$UI$none;
		}
	});
var $author$project$Element$GradeRequestList$TabSelected = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$Locale$Messages$GradeReportCardTabEndOfYear = F2(
	function (a, b) {
		return {$: 92, a: a, b: b};
	});
var $author$project$Locale$Messages$GradeReportCardTabGradingExam = F2(
	function (a, b) {
		return {$: 93, a: a, b: b};
	});
var $author$project$Locale$Messages$GradeReportCardTabMidYear = F2(
	function (a, b) {
		return {$: 91, a: a, b: b};
	});
var $author$project$Element$GradeRequestList$tabCaption = function (_v0) {
	var startYear = _v0.eB;
	var endYear = _v0.d3;
	var type_ = _v0.ii;
	switch (type_) {
		case 0:
			return A2($author$project$Locale$Messages$GradeReportCardTabMidYear, startYear, endYear);
		case 1:
			return A2($author$project$Locale$Messages$GradeReportCardTabEndOfYear, startYear, endYear);
		default:
			return A2($author$project$Locale$Messages$GradeReportCardTabGradingExam, startYear, endYear);
	}
};
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Element$GradeRequestList$viewTabBar = F3(
	function (t_, selected, learningAssessments) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tabs is-boxed')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (tab) {
							return A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'is-active',
												_Utils_eq(
													$elm$core$Maybe$Just(tab),
													selected))
											]))
									]),
								_List_fromArray(
									[
										A3(
										$author$project$UI$actionLink,
										$author$project$Element$GradeRequestList$TabSelected(tab),
										_List_fromArray(
											[
												$author$project$UI$attrCyData(
												'tab-' + $elm$core$String$fromInt(tab.bL.i8))
											]),
										_List_fromArray(
											[
												A2(
												$author$project$UI$caption,
												t_,
												$author$project$Element$GradeRequestList$tabCaption(tab))
											]))
									]));
						},
						learningAssessments))
				]));
	});
var $author$project$Element$GradeRequestList$viewSubjectAssessmentSection = function (model) {
	var session = model.gB;
	var page = model.bk;
	switch (page.$) {
		case 0:
			return _List_fromArray(
				[
					A2(
					$author$project$UI$progressBar,
					'is-warning',
					session.h6($author$project$Locale$Messages$LearningAssessmentsDownloadError))
				]);
		case 1:
			return _List_fromArray(
				[
					A2(
					$author$project$UI$progressBar,
					'is-info',
					session.h6($author$project$Locale$Messages$GradeReportsLoadingProgress))
				]);
		default:
			var listPageModel = page.a;
			return _List_fromArray(
				[
					function () {
					var _v1 = _Utils_Tuple2(listPageModel.cd, listPageModel.gb);
					if (!_v1.a.$) {
						var tab = _v1.a.a;
						var learningAssessment = tab.bL;
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A3($author$project$Element$GradeRequestList$viewTabBar, session.h6, listPageModel.cd, listPageModel.gG),
									A2(
									$author$project$UI$when,
									A2($author$project$ACL$canViewLearningAssessmentGrades, session.ok, learningAssessment),
									A2($author$project$Element$GradeRequestList$viewLearningAssessment, session, tab)),
									A2($author$project$Element$GradeRequestList$viewPopup, session, model)
								]));
					} else {
						if (!_v1.b.b) {
							var _v2 = _v1.a;
							return $author$project$UI$notification(
								_List_fromArray(
									[
										A2($author$project$UI$caption, session.h6, $author$project$Locale$Messages$GradeRequestNoLearningAssessment)
									]));
						} else {
							var _v3 = _v1.a;
							return $author$project$UI$none;
						}
					}
				}()
				]);
	}
};
var $author$project$Element$GradeRequestList$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$UI$section(
				$author$project$Element$GradeRequestList$viewSubjectAssessmentSection(model))
			]));
};
var $author$project$Element$GradeRequestList$element = {jb: $author$project$Element$GradeRequestList$init, hP: $author$project$Element$GradeRequestList$perform, ks: $author$project$Element$GradeRequestList$update, og: $author$project$Element$GradeRequestList$view};
var $author$project$Element$GradingPage$Cmd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$GradingPage$CurrentAssessmentPeriodDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$GradingPage$ErrorPage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$GradingPage$FetchCurrentAssessmentPeriod = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$GradingPage$FetchMarkRequests = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$GradingPageNoAccess = {$: 716};
var $author$project$Element$GradingPage$LoadingPage = {$: 0};
var $author$project$Element$GradingPage$MarkRequestsDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$GradingPage$NoEffect = {$: 0};
var $author$project$ACL$canManageGrading = function (person) {
	return A2($author$project$Person$hasAccessRole, person, 8) || A2($author$project$Person$hasAccessRole, person, 5);
};
var $author$project$Person$hasRoleAt = F3(
	function (role, teamId, person) {
		var _v0 = person.nr;
		var roles = _v0;
		return A2(
			$elm$core$List$any,
			function (_v1) {
				var role_ = _v1.a;
				var teamId_ = _v1.b;
				return _Utils_eq(role, role_) && _Utils_eq(teamId, teamId_);
			},
			roles);
	});
var $author$project$Person$teachesAt = F2(
	function (teamId, person) {
		return A3($author$project$Person$hasRoleAt, $author$project$Person$roleTeacher, teamId, person) || A3($author$project$Person$hasRoleAt, $author$project$Person$roleModuleTeacher, teamId, person);
	});
var $author$project$ACL$canViewGradingAtSchool = F2(
	function (person, teamId) {
		return A2($author$project$Person$teachesAt, teamId, person) || $author$project$ACL$canManageGrading(person);
	});
var $author$project$Element$GradingPage$Ascending = 0;
var $author$project$Element$GradingPage$emptyFilter = {i4: _List_Nil, ff: false, b4: $elm$core$Maybe$Nothing, bP: 0, ab: _List_Nil, kb: _List_Nil};
var $author$project$AssessmentPeriod$AssessmentPeriod = F4(
	function (periodType, assessmentType, startDate, endDate) {
		return {kV: assessmentType, ly: endDate, m7: periodType, nN: startDate};
	});
var $author$project$AssessmentPeriod$FinalizationPeriod = 2;
var $author$project$AssessmentPeriod$LockedPeriod = 0;
var $author$project$AssessmentPeriod$OfferingPeriod = 1;
var $author$project$AssessmentPeriod$periodTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'locked':
				return $elm$json$Json$Decode$succeed(0);
			case 'offering':
				return $elm$json$Json$Decode$succeed(1);
			case 'finalization':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unknown type: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$AssessmentPeriod$assessmentPeriodDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'end_date',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'start_date',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'assessment_type',
			$author$project$LearningAssessment$learningAssessmentTypeDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'period_type',
				$author$project$AssessmentPeriod$periodTypeDecoder,
				$elm$json$Json$Decode$succeed($author$project$AssessmentPeriod$AssessmentPeriod)))));
var $author$project$Api$Endpoint$currentAssessmentPeriod = F2(
	function (config, grade) {
		var queryParams = A3(
			$author$project$Api$Endpoint$optional,
			$elm$core$String$fromInt,
			_Utils_Tuple2('grade', grade),
			_List_Nil);
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'assessment-periods', 'current']),
			queryParams);
	});
var $author$project$AssessmentPeriod$fetchCurrentAssessmentPeriod2 = F3(
	function (config, grade, callback) {
		return {
			b_: config,
			d_: $author$project$AssessmentPeriod$assessmentPeriodDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2($author$project$Api$Endpoint$currentAssessmentPeriod, config, grade)
		};
	});
var $author$project$MarkRequest$MarkRequest = F6(
	function (student, dueDate, subjectAssessments, assessmentType, learningAssessmentId, grade) {
		return {kV: assessmentType, lv: dueDate, W: grade, dd: learningAssessmentId, nT: student, nV: subjectAssessments};
	});
var $author$project$MarkRequest$markRequestDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'grade',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'learning_assessment_id',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'assessment_type',
			$author$project$LearningAssessment$learningAssessmentTypeDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'subject_assessments',
				$elm$json$Json$Decode$list($author$project$SubjectAssessment$subjectAssessmentDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'due_date',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'student',
						$author$project$Person$nestedPersonDecoder,
						$elm$json$Json$Decode$succeed($author$project$MarkRequest$MarkRequest)))))));
var $author$project$Api$Endpoint$markRequestsForTeam = F2(
	function (config, schoolId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'teams',
					$elm$core$String$fromInt(schoolId),
					'mark-requests'
				]),
			_List_Nil);
	});
var $author$project$MarkRequest$fetchMarkRequestsForTeam2 = F3(
	function (config, teamId, callback) {
		return {
			b_: config,
			d_: $elm$json$Json$Decode$list($author$project$MarkRequest$markRequestDecoder),
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2($author$project$Api$Endpoint$markRequestsForTeam, config, teamId)
		};
	});
var $author$project$Element$GradingPage$init = F3(
	function (config, session, _v0) {
		var schoolId = _v0.fr;
		var grade = _v0.W;
		var periodical = _v0.jI;
		var canView = A2($author$project$ACL$canViewGradingAtSchool, session.ok, schoolId);
		var effect = canView ? (periodical ? $author$project$Element$GradingPage$Cmd(
			$author$project$Element$GradingPage$FetchCurrentAssessmentPeriod(
				A3($author$project$AssessmentPeriod$fetchCurrentAssessmentPeriod2, config.gX, grade, $author$project$Element$GradingPage$CurrentAssessmentPeriodDownloaded))) : $author$project$Element$GradingPage$Cmd(
			$author$project$Element$GradingPage$FetchMarkRequests(
				A3($author$project$MarkRequest$fetchMarkRequestsForTeam2, config.gX, schoolId, $author$project$Element$GradingPage$MarkRequestsDownloaded)))) : $author$project$Element$GradingPage$NoEffect;
		var page = canView ? $author$project$Element$GradingPage$LoadingPage : $author$project$Element$GradingPage$ErrorPage(
			session.h6($author$project$Locale$Messages$GradingPageNoAccess));
		return _Utils_Tuple3(
			{dS: $author$project$RemoteData$NotAsked, eQ: $author$project$RemoteData$NotAsked, b_: config, eX: false, ad: $author$project$Element$GradingPage$emptyFilter, W: grade, bk: page, fr: schoolId, gB: session},
			effect,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$GradingPage$perform = F2(
	function (_v0, effect) {
		var go = function (eff) {
			if (!eff.$) {
				return $elm$core$Platform$Cmd$none;
			} else {
				var cmd = eff.a;
				switch (cmd.$) {
					case 0:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 1:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 2:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 3:
						var request = cmd.a;
						return $author$project$Api$patchV2(request);
					case 4:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					default:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
				}
			}
		};
		return go(effect);
	});
var $author$project$Element$GradingPage$AssessmentConsentUpdated = function (a) {
	return {$: 20, a: a};
};
var $author$project$Element$GradingPage$AssessmentConsentsDownloaded = function (a) {
	return {$: 19, a: a};
};
var $author$project$Element$GradingPage$Descending = 1;
var $author$project$Element$GradingPage$Everything = 1;
var $author$project$Element$GradingPage$FetchAssessmentConsents = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$GradingPage$FetchLearningAssessmentsForTeacher = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$GradingPage$Grading = 0;
var $author$project$Element$GradingPage$GradingPage = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Locale$Messages$GradingPageConsentUpdated = {$: 710};
var $author$project$Locale$Messages$GradingPageSaveError = {$: 714};
var $author$project$Locale$Messages$GradingPageSaveSuccess = {$: 713};
var $author$project$Element$GradingPage$LearningAssessmentsForTeacherDownloaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$GradingPage$StudentSelectorPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$GradingPage$SubjectAssessmentsUpdated = function (a) {
	return {$: 21, a: a};
};
var $author$project$Element$GradingPage$UpdateAssessmentConsent = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$GradingPage$UpdateSubjectAssessments = function (a) {
	return {$: 3, a: a};
};
var $author$project$Person$displayName = F2(
	function (person, language) {
		return language.l4 ? (person.lI + (' ' + person.av)) : (person.av + (' ' + person.lI));
	});
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Element$GradingPage$sortRows = F4(
	function (maybeOrderBy, direction, language, rows) {
		if (maybeOrderBy.$ === 1) {
			return rows;
		} else {
			var orderBy = maybeOrderBy.a;
			var compareFn = function () {
				switch (orderBy) {
					case 0:
						return F2(
							function (a, b) {
								return A2(
									$elm$core$Basics$compare,
									$elm$core$String$toLower(
										A2($author$project$Person$displayName, a.nT, language)),
									$elm$core$String$toLower(
										A2($author$project$Person$displayName, b.nT, language)));
							});
					case 1:
						return F2(
							function (a, b) {
								return A2($elm$core$Basics$compare, a.W, b.W);
							});
					case 2:
						return F2(
							function (a, b) {
								return A2(
									$elm$core$Basics$compare,
									$elm$core$String$toLower(a.e.gE.fb),
									$elm$core$String$toLower(b.e.gE.fb));
							});
					default:
						return F2(
							function (a, b) {
								var bTeachers = A2(
									$elm$core$Maybe$withDefault,
									'',
									$elm$core$List$minimum(
										A2(
											$elm$core$List$map,
											function (t) {
												return $elm$core$String$toLower(
													A2($author$project$Person$displayName, t, language));
											},
											b.e.ab)));
								var aTeachers = A2(
									$elm$core$Maybe$withDefault,
									'',
									$elm$core$List$minimum(
										A2(
											$elm$core$List$map,
											function (t) {
												return $elm$core$String$toLower(
													A2($author$project$Person$displayName, t, language));
											},
											a.e.ab)));
								return A2($elm$core$Basics$compare, aTeachers, bTeachers);
							});
				}
			}();
			var sorted = A2($elm$core$List$sortWith, compareFn, rows);
			if (!direction) {
				return sorted;
			} else {
				return $elm$core$List$reverse(sorted);
			}
		}
	});
var $author$project$Element$GradingPage$applyFilter = F4(
	function (language, periodType, rows, filter) {
		return A4(
			$author$project$Element$GradingPage$sortRows,
			filter.b4,
			filter.bP,
			language,
			A2(
				$elm$core$List$map,
				function (row) {
					var teacherMatches = function () {
						var _v3 = filter.ab;
						if (!_v3.b) {
							return true;
						} else {
							var teachers = _v3;
							return A2(
								$elm$core$List$any,
								function (rowTeacher) {
									return A2(
										$elm$core$List$any,
										function (filterTeacher) {
											return _Utils_eq(filterTeacher.i8, rowTeacher.i8);
										},
										teachers);
								},
								row.e.ab);
						}
					}();
					var subjectMatches = function () {
						var _v2 = filter.kb;
						if (!_v2.b) {
							return true;
						} else {
							var subjects = _v2;
							return A2($elm$core$List$member, row.e.gE, subjects);
						}
					}();
					var sa = row.e;
					var gradeMatches = function () {
						var _v1 = filter.i4;
						if (!_v1.b) {
							return true;
						} else {
							var grades = _v1;
							return A2($elm$core$List$member, row.W, grades);
						}
					}();
					var filterIncomplete = filter.ff ? ((!sa.mg) && function () {
						switch (periodType) {
							case 1:
								return _Utils_eq(sa.kh, $elm$core$Maybe$Nothing) || (sa.jp && _Utils_eq(sa.en, $elm$core$Maybe$Nothing));
							case 2:
								return _Utils_eq(sa.kh, $elm$core$Maybe$Nothing) || (sa.jp && _Utils_eq(sa.i$, $elm$core$Maybe$Nothing));
							default:
								return false;
						}
					}()) : true;
					var isVisible = gradeMatches && (subjectMatches && (teacherMatches && filterIncomplete));
					return _Utils_update(
						row,
						{cg: isVisible});
				},
				rows));
	});
var $author$project$AssessmentConsent$AssessmentConsent = F3(
	function (teacher, isGiven, updatedAt) {
		return {l5: isGiven, n2: teacher, of: updatedAt};
	});
var $author$project$AssessmentConsent$assessmentConsentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'updated_at',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_given',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'teacher',
			$author$project$Person$nestedPersonDecoder,
			$elm$json$Json$Decode$succeed($author$project$AssessmentConsent$AssessmentConsent))));
var $author$project$Api$Endpoint$assessmentConsents = F3(
	function (config, process, learningAssessments) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'assessment-consents']),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('process_type', process),
				A2(
					$elm$core$List$map,
					function (id) {
						return _Utils_Tuple2(
							'learning_assessments',
							$elm$core$String$fromInt(id));
					},
					learningAssessments)));
	});
var $author$project$AssessmentConsent$fetchAssessmentConsentsForLearningAssessments2 = F4(
	function (config, process, learningAssessments, callback) {
		return {
			b_: config,
			d_: $elm$json$Json$Decode$list($author$project$AssessmentConsent$assessmentConsentDecoder),
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A3($author$project$Api$Endpoint$assessmentConsents, config, process, learningAssessments)
		};
	});
var $author$project$Api$Endpoint$optionalList = F3(
	function (encoder, _v0, params) {
		var name = _v0.a;
		var valueList = _v0.b;
		return _Utils_ap(
			params,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$map(
						function (value) {
							return _Utils_Tuple2(
								name,
								encoder(value));
						}),
					valueList)));
	});
var $author$project$Api$Endpoint$learningAssessmentsBySchool = F5(
	function (config, teamId, activeSchoolYearOnly, assessmentType, grade) {
		var queryParams = A3(
			$author$project$Api$Endpoint$optional,
			$elm$core$String$fromInt,
			_Utils_Tuple2('grades', grade),
			A3(
				$author$project$Api$Endpoint$optionalList,
				$elm$core$Basics$identity,
				_Utils_Tuple2(
					'assessment_types',
					$elm$core$Maybe$Just(
						_List_fromArray(
							[assessmentType]))),
				A3(
					$author$project$Api$Endpoint$optional,
					$author$project$Api$Endpoint$stringFromBool,
					_Utils_Tuple2(
						'active_school_year_only',
						$elm$core$Maybe$Just(activeSchoolYearOnly)),
					_List_Nil)));
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'schools',
					$elm$core$String$fromInt(teamId),
					'learning-assessments'
				]),
			queryParams);
	});
var $author$project$LearningAssessment$fetchLearningAssessmentsBySchool2 = F6(
	function (config, schoolId, activeSchoolYearOnly, learningAssessmentType, grade, callback) {
		var laType = function () {
			switch (learningAssessmentType) {
				case 0:
					return 'mid_year';
				case 1:
					return 'end_of_year';
				default:
					return 'grading_exam';
			}
		}();
		return {
			b_: config,
			d_: $author$project$LearningAssessment$learningAssessmentListDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A5($author$project$Api$Endpoint$learningAssessmentsBySchool, config, schoolId, activeSchoolYearOnly, laType, grade)
		};
	});
var $author$project$Util$List$find = F2(
	function (predicate, list) {
		return $elm$core$List$head(
			A2($elm$core$List$filter, predicate, list));
	});
var $author$project$Element$GradingPage$generateTableRowsFromLearningAssessments = function (learningAssessments) {
	return A2(
		$elm$core$List$concatMap,
		function (la) {
			return A2(
				$elm$core$List$map,
				function (sa) {
					return {kV: la.ii, bY: false, W: la.W, dd: la.i8, nT: la.nT, e: sa, cg: true};
				},
				la.kb);
		},
		learningAssessments);
};
var $author$project$Element$GradingPage$generateTableRowsFromMarkRequests = function (markRequests) {
	return A2(
		$elm$core$List$concatMap,
		function (markRequest) {
			return A2(
				$elm$core$List$map,
				function (sa) {
					return {kV: markRequest.kV, bY: false, W: markRequest.W, dd: markRequest.dd, nT: markRequest.nT, e: sa, cg: true};
				},
				markRequest.nV);
		},
		markRequests);
};
var $author$project$Util$List$groupBy = F2(
	function (keyFn, list) {
		var updateGroup = F2(
			function (item, maybeGroup) {
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$List$cons,
						item,
						A2($elm$core$Maybe$withDefault, _List_Nil, maybeGroup)));
			});
		return $elm$core$Dict$toList(
			A3(
				$elm$core$List$foldl,
				F2(
					function (item, groups) {
						return A3(
							$elm$core$Dict$update,
							keyFn(item),
							updateGroup(item),
							groups);
					}),
				$elm$core$Dict$empty,
				list));
	});
var $author$project$LearningAssessment$textAppraisalEndOfYearPassed = 'Teljesítetted az elvárásokat ebből a tárgyból.';
var $author$project$LearningAssessment$textAppraisalMidYearPassed = 'Az eredményeid alapján haladsz a tantárgyi elvárások teljesítésével.';
var $author$project$LearningAssessment$isPassedTextAppraisal = function (textAppraisal) {
	return _Utils_eq(textAppraisal, $author$project$LearningAssessment$textAppraisalMidYearPassed) || _Utils_eq(textAppraisal, $author$project$LearningAssessment$textAppraisalEndOfYearPassed);
};
var $author$project$AssessmentConsent$lateMarkRequest = 'late_mark_request';
var $author$project$LearningAssessment$textAppraisalEndOfYearNotPassed = 'Még nem állsz készen az évfolyamváltásra ebből a tárgyból.';
var $author$project$LearningAssessment$textAppraisalMidYearNotPassed = 'Az eredményeid még nem érik el a tantárgyi elvárások minimumát.';
var $author$project$LearningAssessment$notPassedTextAppraisalForAssessmentType = function (assessmentType) {
	return (!assessmentType) ? $author$project$LearningAssessment$textAppraisalMidYearNotPassed : $author$project$LearningAssessment$textAppraisalEndOfYearNotPassed;
};
var $author$project$LearningAssessment$passedTextAppraisalForAssessmentType = function (assessmentType) {
	return (!assessmentType) ? $author$project$LearningAssessment$textAppraisalMidYearPassed : $author$project$LearningAssessment$textAppraisalEndOfYearPassed;
};
var $author$project$Person$toNested = function (person) {
	return {O: person.O, lI: person.lI, i8: person.i8, av: person.av};
};
var $author$project$Util$List$unique = function (x) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (item, acc) {
				return A2($elm$core$List$member, item, acc) ? acc : A2($elm$core$List$cons, item, acc);
			}),
		_List_Nil,
		x);
};
var $author$project$Api$Endpoint$updateAssessmentConsents = F3(
	function (config, process, learningAssessments) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'assessment-consents', 'update-consent']),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('process_type', process),
				A2(
					$elm$core$List$map,
					function (id) {
						return _Utils_Tuple2(
							'learning_assessments',
							$elm$core$String$fromInt(id));
					},
					learningAssessments)));
	});
var $author$project$AssessmentConsent$updateAssessmentConsentForLearningAssessments2 = F5(
	function (config, process, learningAssessments, isGiven, callback) {
		return {
			T: $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'is_given',
						$elm$json$Json$Encode$bool(isGiven))
					])),
			b_: config,
			d_: $author$project$AssessmentConsent$assessmentConsentDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A3($author$project$Api$Endpoint$updateAssessmentConsents, config.gX, process, learningAssessments)
		};
	});
var $author$project$Element$GradingPage$updateRow = F3(
	function (target, fn, rows) {
		return A2(
			$elm$core$List$map,
			function (row) {
				return _Utils_eq(row.e.i8, target.e.i8) ? fn(
					_Utils_update(
						row,
						{bY: true})) : row;
			},
			rows);
	});
var $author$project$Element$GradingPage$updateMarkField = F6(
	function (updateSaFn, parseValueFn, tableRow, value, tableRows, ap) {
		var sa = tableRow.e;
		var parsedValue = A2(parseValueFn, value, tableRow);
		var marksAreEditable = sa.jp && sa.hx;
		var updatedTextAppraisal = function () {
			if (marksAreEditable) {
				if (!parsedValue.$) {
					var mark = parsedValue.a;
					return (mark >= 2) ? $elm$core$Maybe$Just(
						$author$project$LearningAssessment$passedTextAppraisalForAssessmentType(ap.kV)) : $elm$core$Maybe$Just(
						$author$project$LearningAssessment$notPassedTextAppraisalForAssessmentType(ap.kV));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return sa.kh;
			}
		}();
		return A3(
			$author$project$Element$GradingPage$updateRow,
			tableRow,
			function (r) {
				var rowSa = r.e;
				var updatedSa = function (s) {
					return _Utils_update(
						s,
						{kh: updatedTextAppraisal});
				}(
					A2(updateSaFn, rowSa, parsedValue));
				return _Utils_update(
					r,
					{e: updatedSa});
			},
			tableRows);
	});
var $author$project$Api$Endpoint$updateSubjectAssessments = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'subject-assessments', 'bulk-update']),
		_List_Nil);
};
var $author$project$SubjectAssessment$updateSubjectAssessments = F3(
	function (config, subjectAssessments, callback) {
		return {
			T: A2($elm$json$Json$Encode$list, $author$project$SubjectAssessment$subjectAssessmentEncoder, subjectAssessments),
			b_: config,
			d_: $elm$json$Json$Decode$list($author$project$SubjectAssessment$subjectAssessmentDecoder),
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: $author$project$Api$Endpoint$updateSubjectAssessments(config.gX)
		};
	});
var $author$project$Element$GradingPage$canUpdateTextAppraisal = F3(
	function (currentTab, sa, assessmentPeriod) {
		return (currentTab !== 1) && (((!sa.jp) || (!sa.hx)) && ((assessmentPeriod.m7 === 1) || (assessmentPeriod.m7 === 2)));
	});
var $author$project$Element$GradingPage$updateTextAppraisalByCheckbox = F6(
	function (textAppraisalFn, selectedTab, tableRow, isChecked, tableRows, ap) {
		var sa = tableRow.e;
		return A3($author$project$Element$GradingPage$canUpdateTextAppraisal, selectedTab, sa, ap) ? A3(
			$author$project$Element$GradingPage$updateRow,
			tableRow,
			function (row) {
				var rowSa = row.e;
				var updatedSa = _Utils_update(
					rowSa,
					{
						kh: isChecked ? $elm$core$Maybe$Just(
							textAppraisalFn(ap.kV)) : $elm$core$Maybe$Nothing
					});
				return _Utils_update(
					row,
					{e: updatedSa});
			},
			tableRows) : tableRows;
	});
var $author$project$AssessmentConsent$withRecommendation = 'with_recommendation';
var $author$project$Element$GradingPage$update = F2(
	function (msg, model) {
		var page = model.bk;
		var assessmentPeriod = model.eQ;
		var _v0 = _Utils_Tuple3(msg, page, assessmentPeriod);
		_v0$27:
		while (true) {
			switch (_v0.a.$) {
				case 1:
					if (!_v0.b.$) {
						switch (_v0.a.a.$) {
							case 3:
								var e = _v0.a.a.a;
								var _v1 = _v0.b;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bk: $author$project$Element$GradingPage$ErrorPage(
												$author$project$Api$httpErrorToHumans(e))
										}),
									$author$project$Element$GradingPage$NoEffect,
									$elm$core$Maybe$Nothing);
							case 2:
								var rdap = _v0.a.a;
								var ap = rdap.a;
								var _v3 = _v0.b;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{eQ: rdap, bk: $author$project$Element$GradingPage$LoadingPage}),
									$author$project$Element$GradingPage$Cmd(
										$author$project$Element$GradingPage$FetchLearningAssessmentsForTeacher(
											A6($author$project$LearningAssessment$fetchLearningAssessmentsBySchool2, model.b_.gX, model.fr, true, ap.kV, model.W, $author$project$Element$GradingPage$LearningAssessmentsForTeacherDownloaded))),
									$elm$core$Maybe$Nothing);
							default:
								break _v0$27;
						}
					} else {
						break _v0$27;
					}
				case 2:
					if (!_v0.b.$) {
						switch (_v0.a.a.$) {
							case 3:
								var e = _v0.a.a.a;
								var _v2 = _v0.b;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bk: $author$project$Element$GradingPage$ErrorPage(
												$author$project$Api$httpErrorToHumans(e))
										}),
									$author$project$Element$GradingPage$NoEffect,
									$elm$core$Maybe$Nothing);
							case 2:
								if (_v0.c.$ === 2) {
									var learningAssessments = _v0.a.a.a;
									var _v4 = _v0.b;
									var ap = _v0.c.a;
									var initialRows = $author$project$Element$GradingPage$generateTableRowsFromLearningAssessments(learningAssessments);
									var filter2 = _Utils_update(
										$author$project$Element$GradingPage$emptyFilter,
										{
											ab: _List_fromArray(
												[
													$author$project$Person$toNested(model.gB.ok)
												])
										});
									var filteredRows = A4($author$project$Element$GradingPage$applyFilter, model.gB.mn, ap.m7, initialRows, filter2);
									var startPage = A2(
										$elm$core$List$any,
										function ($) {
											return $.cg;
										},
										filteredRows) ? A2($author$project$Element$GradingPage$GradingPage, 0, filteredRows) : A2($author$project$Element$GradingPage$GradingPage, 1, initialRows);
									var startFilter = A2(
										$elm$core$List$any,
										function ($) {
											return $.cg;
										},
										filteredRows) ? filter2 : $author$project$Element$GradingPage$emptyFilter;
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{ad: startFilter, bk: startPage}),
										$author$project$Element$GradingPage$NoEffect,
										$elm$core$Maybe$Nothing);
								} else {
									break _v0$27;
								}
							default:
								break _v0$27;
						}
					} else {
						break _v0$27;
					}
				case 4:
					if ((_v0.b.$ === 1) && (_v0.c.$ === 2)) {
						var _v5 = _v0.a;
						var tableRow = _v5.a;
						var isChecked = _v5.b;
						var _v6 = _v0.b;
						var selectedTab = _v6.a;
						var tableRows = _v6.b;
						var ap = _v0.c.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bk: A2(
										$author$project$Element$GradingPage$GradingPage,
										selectedTab,
										A6($author$project$Element$GradingPage$updateTextAppraisalByCheckbox, $author$project$LearningAssessment$passedTextAppraisalForAssessmentType, selectedTab, tableRow, isChecked, tableRows, ap))
								}),
							$author$project$Element$GradingPage$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$27;
					}
				case 5:
					if ((_v0.b.$ === 1) && (_v0.c.$ === 2)) {
						var _v7 = _v0.a;
						var tableRow = _v7.a;
						var isChecked = _v7.b;
						var _v8 = _v0.b;
						var selectedTab = _v8.a;
						var tableRows = _v8.b;
						var ap = _v0.c.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bk: A2(
										$author$project$Element$GradingPage$GradingPage,
										selectedTab,
										A6($author$project$Element$GradingPage$updateTextAppraisalByCheckbox, $author$project$LearningAssessment$notPassedTextAppraisalForAssessmentType, selectedTab, tableRow, isChecked, tableRows, ap))
								}),
							$author$project$Element$GradingPage$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$27;
					}
				case 11:
					if ((_v0.b.$ === 1) && (_v0.c.$ === 2)) {
						var _v9 = _v0.a;
						var tableRow = _v9.a;
						var value = _v9.b;
						var _v10 = _v0.b;
						var selectedTab = _v10.a;
						var rows = _v10.b;
						var ap = _v0.c.a;
						var parseOfferedMark = F2(
							function (val, row) {
								var _v11 = $elm$core$String$toInt(val);
								if (!_v11.$) {
									var v = _v11.a;
									return ((1 <= v) && (v <= 5)) ? $elm$core$Maybe$Just(v) : row.e.en;
								} else {
									return ($elm$core$String$trim(val) === '') ? $elm$core$Maybe$Nothing : row.e.en;
								}
							});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bk: A2(
										$author$project$Element$GradingPage$GradingPage,
										selectedTab,
										A6(
											$author$project$Element$GradingPage$updateMarkField,
											F2(
												function (sa, mark) {
													return _Utils_update(
														sa,
														{en: mark});
												}),
											parseOfferedMark,
											tableRow,
											value,
											rows,
											ap))
								}),
							$author$project$Element$GradingPage$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$27;
					}
				case 12:
					if ((_v0.b.$ === 1) && (_v0.c.$ === 2)) {
						var _v12 = _v0.a;
						var tableRow = _v12.a;
						var value = _v12.b;
						var _v13 = _v0.b;
						var selectedTab = _v13.a;
						var rows = _v13.b;
						var ap = _v0.c.a;
						var parseFinalMark = F2(
							function (val, row) {
								var _v14 = $elm$core$String$toInt(val);
								if (!_v14.$) {
									var v = _v14.a;
									if ((1 <= v) && (v <= 5)) {
										var _v15 = row.e.en;
										if (!_v15.$) {
											var om = _v15.a;
											return (_Utils_cmp(v, om) > -1) ? $elm$core$Maybe$Just(v) : row.e.i$;
										} else {
											return $elm$core$Maybe$Just(v);
										}
									} else {
										return row.e.i$;
									}
								} else {
									return ($elm$core$String$trim(val) === '') ? $elm$core$Maybe$Nothing : row.e.i$;
								}
							});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bk: A2(
										$author$project$Element$GradingPage$GradingPage,
										selectedTab,
										A6(
											$author$project$Element$GradingPage$updateMarkField,
											F2(
												function (sa, mark) {
													return _Utils_update(
														sa,
														{i$: mark});
												}),
											parseFinalMark,
											tableRow,
											value,
											rows,
											ap))
								}),
							$author$project$Element$GradingPage$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$27;
					}
				case 17:
					if (((_v0.b.$ === 1) && (_v0.b.a === 1)) && (_v0.c.$ === 2)) {
						var value = _v0.a.a;
						var _v16 = _v0.b;
						var _v17 = _v16.a;
						var rows = _v16.b;
						var learningAssessmentIds = $author$project$Util$List$unique(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.dd;
								},
								rows));
						return _Utils_Tuple3(
							model,
							$author$project$Element$GradingPage$Cmd(
								$author$project$Element$GradingPage$UpdateAssessmentConsent(
									A5($author$project$AssessmentConsent$updateAssessmentConsentForLearningAssessments2, model.b_, $author$project$AssessmentConsent$withRecommendation, learningAssessmentIds, value, $author$project$Element$GradingPage$AssessmentConsentUpdated))),
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$27;
					}
				case 3:
					if ((!_v0.b.$) && (!_v0.c.$)) {
						switch (_v0.a.a.$) {
							case 2:
								var markRequests = _v0.a.a.a;
								var _v18 = _v0.b;
								var _v19 = _v0.c;
								var studentsWithMarkRequests = A2(
									$elm$core$List$map,
									function (_v20) {
										var studentId = _v20.a;
										var mrs = _v20.b;
										var _v21 = $elm$core$List$head(mrs);
										if (!_v21.$) {
											var firstMr = _v21.a;
											return _Utils_Tuple2(firstMr.nT, mrs);
										} else {
											return _Utils_Tuple2(
												{O: '', lI: '', i8: studentId, av: ''},
												mrs);
										}
									},
									A2(
										$author$project$Util$List$groupBy,
										function (mr) {
											return mr.nT.i8;
										},
										markRequests));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bk: $author$project$Element$GradingPage$StudentSelectorPage(studentsWithMarkRequests)
										}),
									$author$project$Element$GradingPage$NoEffect,
									$elm$core$Maybe$Nothing);
							case 3:
								var e = _v0.a.a.a;
								var _v22 = _v0.b;
								var _v23 = _v0.c;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bk: $author$project$Element$GradingPage$ErrorPage(
												$author$project$Api$httpErrorToHumans(e))
										}),
									$author$project$Element$GradingPage$NoEffect,
									$elm$core$Maybe$Nothing);
							default:
								break _v0$27;
						}
					} else {
						break _v0$27;
					}
				case 22:
					if ((_v0.b.$ === 2) && (!_v0.c.$)) {
						var markRequests = _v0.a.a;
						var _v24 = _v0.c;
						var initialRows = $author$project$Element$GradingPage$generateTableRowsFromMarkRequests(markRequests);
						var filter2 = _Utils_update(
							$author$project$Element$GradingPage$emptyFilter,
							{
								ab: _List_fromArray(
									[
										$author$project$Person$toNested(model.gB.ok)
									])
							});
						var tableRows = A4($author$project$Element$GradingPage$applyFilter, model.gB.mn, 2, initialRows, filter2);
						var learningAssessmentIds = $author$project$Util$List$unique(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.dd;
								},
								tableRows));
						var startTab = A2(
							$elm$core$List$any,
							function ($) {
								return $.cg;
							},
							tableRows) ? A2($author$project$Element$GradingPage$GradingPage, 0, tableRows) : A2($author$project$Element$GradingPage$GradingPage, 1, initialRows);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ad: filter2, bk: startTab}),
							$author$project$Element$GradingPage$Cmd(
								$author$project$Element$GradingPage$FetchAssessmentConsents(
									A4($author$project$AssessmentConsent$fetchAssessmentConsentsForLearningAssessments2, model.b_.gX, $author$project$AssessmentConsent$lateMarkRequest, learningAssessmentIds, $author$project$Element$GradingPage$AssessmentConsentsDownloaded))),
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$27;
					}
				case 13:
					if ((_v0.b.$ === 1) && (!_v0.c.$)) {
						var _v25 = _v0.a;
						var tableRow = _v25.a;
						var value = _v25.b;
						var _v26 = _v0.b;
						var selectedTab = _v26.a;
						var rows = _v26.b;
						var _v27 = _v0.c;
						var parseMarkRequestGrade = F2(
							function (val, row) {
								var _v28 = $elm$core$String$toInt(val);
								if (!_v28.$) {
									var v = _v28.a;
									var isPassing = A2(
										$elm$core$Maybe$withDefault,
										false,
										A2($elm$core$Maybe$map, $author$project$LearningAssessment$isPassedTextAppraisal, row.e.kh));
									return isPassing ? (((2 <= v) && (v <= 5)) ? $elm$core$Maybe$Just(v) : row.e.i$) : ((v === 1) ? $elm$core$Maybe$Just(v) : row.e.i$);
								} else {
									return ($elm$core$String$trim(val) === '') ? $elm$core$Maybe$Nothing : row.e.i$;
								}
							});
						var updatedRows = A2(
							$elm$core$List$map,
							function (row) {
								if (_Utils_eq(row, tableRow)) {
									var sa = row.e;
									var updatedSa = _Utils_update(
										sa,
										{
											i$: A2(parseMarkRequestGrade, value, row)
										});
									return _Utils_update(
										row,
										{bY: true, e: updatedSa});
								} else {
									return row;
								}
							},
							rows);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bk: A2($author$project$Element$GradingPage$GradingPage, selectedTab, updatedRows)
								}),
							$author$project$Element$GradingPage$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$27;
					}
				case 18:
					if ((_v0.b.$ === 1) && (!_v0.c.$)) {
						var value = _v0.a.a;
						var _v29 = _v0.b;
						var rows = _v29.b;
						var _v30 = _v0.c;
						var learningAssessmentIds = $author$project$Util$List$unique(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.dd;
								},
								rows));
						return _Utils_Tuple3(
							model,
							$author$project$Element$GradingPage$Cmd(
								$author$project$Element$GradingPage$UpdateAssessmentConsent(
									A5($author$project$AssessmentConsent$updateAssessmentConsentForLearningAssessments2, model.b_, $author$project$AssessmentConsent$lateMarkRequest, learningAssessmentIds, value, $author$project$Element$GradingPage$AssessmentConsentUpdated))),
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$27;
					}
				case 0:
					if (_v0.b.$ === 1) {
						var tab = _v0.a.a;
						var _v31 = _v0.b;
						var rows = _v31.b;
						var responsibleTeachers = (!tab) ? _List_fromArray(
							[
								$author$project$Person$toNested(model.gB.ok)
							]) : _List_Nil;
						var periodType = function () {
							if (assessmentPeriod.$ === 2) {
								var ap = assessmentPeriod.a;
								return ap.m7;
							} else {
								return 2;
							}
						}();
						var filter1 = model.ad;
						var filter2 = _Utils_update(
							filter1,
							{ab: responsibleTeachers});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ad: filter2,
									bk: A2(
										$author$project$Element$GradingPage$GradingPage,
										tab,
										A4($author$project$Element$GradingPage$applyFilter, model.gB.mn, periodType, rows, filter2))
								}),
							$author$project$Element$GradingPage$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$27;
					}
				case 6:
					if (_v0.b.$ === 1) {
						var select = _v0.a.a;
						var _v33 = _v0.b;
						var selectedTab = _v33.a;
						var rows = _v33.b;
						var periodType = function () {
							if (assessmentPeriod.$ === 2) {
								var ap = assessmentPeriod.a;
								return ap.m7;
							} else {
								return 2;
							}
						}();
						var filter1 = model.ad;
						var filter2 = _Utils_update(
							filter1,
							{ff: select});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ad: filter2,
									bk: A2(
										$author$project$Element$GradingPage$GradingPage,
										selectedTab,
										A4($author$project$Element$GradingPage$applyFilter, model.gB.mn, periodType, rows, filter2))
								}),
							$author$project$Element$GradingPage$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$27;
					}
				case 7:
					if (_v0.b.$ === 1) {
						var _v35 = _v0.a;
						var grade = _v35.a;
						var select = _v35.b;
						var _v36 = _v0.b;
						var selectedTab = _v36.a;
						var rows = _v36.b;
						var periodType = function () {
							if (assessmentPeriod.$ === 2) {
								var ap = assessmentPeriod.a;
								return ap.m7;
							} else {
								return 2;
							}
						}();
						var filter1 = model.ad;
						var filter2 = select ? _Utils_update(
							filter1,
							{
								i4: $author$project$Util$List$unique(
									A2($elm$core$List$cons, grade, filter1.i4))
							}) : _Utils_update(
							filter1,
							{
								i4: A2(
									$elm$core$List$filter,
									$elm$core$Basics$neq(grade),
									filter1.i4)
							});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ad: filter2,
									bk: A2(
										$author$project$Element$GradingPage$GradingPage,
										selectedTab,
										A4($author$project$Element$GradingPage$applyFilter, model.gB.mn, periodType, rows, filter2))
								}),
							$author$project$Element$GradingPage$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$27;
					}
				case 8:
					if (_v0.b.$ === 1) {
						var _v38 = _v0.a;
						var subject = _v38.a;
						var select = _v38.b;
						var _v39 = _v0.b;
						var selectedTab = _v39.a;
						var rows = _v39.b;
						var periodType = function () {
							if (assessmentPeriod.$ === 2) {
								var ap = assessmentPeriod.a;
								return ap.m7;
							} else {
								return 2;
							}
						}();
						var filter1 = model.ad;
						var filter2 = select ? _Utils_update(
							filter1,
							{
								kb: $author$project$Util$List$unique(
									A2($elm$core$List$cons, subject, filter1.kb))
							}) : _Utils_update(
							filter1,
							{
								kb: A2(
									$elm$core$List$filter,
									function (s) {
										return !_Utils_eq(s.i8, subject.i8);
									},
									filter1.kb)
							});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ad: filter2,
									bk: A2(
										$author$project$Element$GradingPage$GradingPage,
										selectedTab,
										A4($author$project$Element$GradingPage$applyFilter, model.gB.mn, periodType, rows, filter2))
								}),
							$author$project$Element$GradingPage$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$27;
					}
				case 9:
					if (_v0.b.$ === 1) {
						var _v41 = _v0.a;
						var teacher = _v41.a;
						var select = _v41.b;
						var _v42 = _v0.b;
						var selectedTab = _v42.a;
						var rows = _v42.b;
						var periodType = function () {
							if (assessmentPeriod.$ === 2) {
								var ap = assessmentPeriod.a;
								return ap.m7;
							} else {
								return 2;
							}
						}();
						var filter1 = model.ad;
						var filter2 = select ? _Utils_update(
							filter1,
							{
								ab: $author$project$Util$List$unique(
									A2($elm$core$List$cons, teacher, filter1.ab))
							}) : _Utils_update(
							filter1,
							{
								ab: A2(
									$elm$core$List$filter,
									function (t) {
										return !_Utils_eq(t.i8, teacher.i8);
									},
									filter1.ab)
							});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ad: filter2,
									bk: A2(
										$author$project$Element$GradingPage$GradingPage,
										selectedTab,
										A4($author$project$Element$GradingPage$applyFilter, model.gB.mn, periodType, rows, filter2))
								}),
							$author$project$Element$GradingPage$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$27;
					}
				case 10:
					if (_v0.b.$ === 1) {
						var orderBy = _v0.a.a;
						var _v44 = _v0.b;
						var selectedTab = _v44.a;
						var rows = _v44.b;
						var periodType = function () {
							if (assessmentPeriod.$ === 2) {
								var ap = assessmentPeriod.a;
								return ap.m7;
							} else {
								return 2;
							}
						}();
						var filter1 = model.ad;
						var filter2 = function () {
							var _v45 = _Utils_Tuple2(filter1.b4, filter1.bP);
							if (!_v45.a.$) {
								if (!_v45.b) {
									var currentOrderBy = _v45.a.a;
									var _v46 = _v45.b;
									return _Utils_eq(currentOrderBy, orderBy) ? _Utils_update(
										filter1,
										{bP: 1}) : _Utils_update(
										filter1,
										{
											b4: $elm$core$Maybe$Just(orderBy),
											bP: 0
										});
								} else {
									var currentOrderBy = _v45.a.a;
									var _v47 = _v45.b;
									return _Utils_eq(currentOrderBy, orderBy) ? _Utils_update(
										filter1,
										{b4: $elm$core$Maybe$Nothing, bP: 0}) : _Utils_update(
										filter1,
										{
											b4: $elm$core$Maybe$Just(orderBy),
											bP: 0
										});
								}
							} else {
								var _v48 = _v45.a;
								return _Utils_update(
									filter1,
									{
										b4: $elm$core$Maybe$Just(orderBy),
										bP: 0
									});
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ad: filter2,
									bk: A2(
										$author$project$Element$GradingPage$GradingPage,
										selectedTab,
										A4($author$project$Element$GradingPage$applyFilter, model.gB.mn, periodType, rows, filter2))
								}),
							$author$project$Element$GradingPage$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$27;
					}
				case 14:
					if ((_v0.b.$ === 1) && (!_v0.b.a)) {
						var _v50 = _v0.a;
						var _v51 = _v0.b;
						var _v52 = _v51.a;
						var rows = _v51.b;
						var changedSubjectAssessments = A2(
							$elm$core$List$map,
							function ($) {
								return $.e;
							},
							A2(
								$elm$core$List$filter,
								function ($) {
									return $.bY;
								},
								rows));
						return _Utils_Tuple3(
							model,
							$author$project$Element$GradingPage$Cmd(
								$author$project$Element$GradingPage$UpdateSubjectAssessments(
									A3($author$project$SubjectAssessment$updateSubjectAssessments, model.b_, changedSubjectAssessments, $author$project$Element$GradingPage$SubjectAssessmentsUpdated))),
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$27;
					}
				case 21:
					if (_v0.b.$ === 1) {
						switch (_v0.a.a.$) {
							case 2:
								var updatedAssessments = _v0.a.a.a;
								var _v53 = _v0.b;
								var selectedTab = _v53.a;
								var rows = _v53.b;
								var updatedRows = A2(
									$elm$core$List$map,
									function (row) {
										var _v54 = A2(
											$author$project$Util$List$find,
											function (sa) {
												return _Utils_eq(sa.i8, row.e.i8);
											},
											updatedAssessments);
										if (!_v54.$) {
											var updatedSa = _v54.a;
											return _Utils_update(
												row,
												{bY: false, e: updatedSa});
										} else {
											return row;
										}
									},
									rows);
								var session1 = model.gB;
								var session2 = _Utils_update(
									session1,
									{
										em: A2(
											$author$project$Notification$add,
											$author$project$Notification$ok(
												session1.h6($author$project$Locale$Messages$GradingPageSaveSuccess)),
											session1.em)
									});
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bk: A2($author$project$Element$GradingPage$GradingPage, selectedTab, updatedRows),
											gB: session2
										}),
									$author$project$Element$GradingPage$NoEffect,
									$elm$core$Maybe$Nothing);
							case 3:
								var _v55 = _v0.b;
								var session1 = model.gB;
								var session2 = _Utils_update(
									session1,
									{
										em: A2(
											$author$project$Notification$add,
											$author$project$Notification$error(
												session1.h6($author$project$Locale$Messages$GradingPageSaveError)),
											session1.em)
									});
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{gB: session2}),
									$author$project$Element$GradingPage$NoEffect,
									$elm$core$Maybe$Nothing);
							default:
								break _v0$27;
						}
					} else {
						break _v0$27;
					}
				case 15:
					if (_v0.b.$ === 1) {
						var _v56 = _v0.a;
						var _v57 = _v0.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{eX: true}),
							$author$project$Element$GradingPage$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$27;
					}
				case 16:
					var _v58 = _v0.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eX: false}),
						$author$project$Element$GradingPage$NoEffect,
						$elm$core$Maybe$Nothing);
				case 19:
					var consents = _v0.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dS: consents}),
						$author$project$Element$GradingPage$NoEffect,
						$elm$core$Maybe$Nothing);
				case 20:
					if (_v0.a.a.$ === 2) {
						var consent = _v0.a.a.a;
						var session1 = model.gB;
						var session2 = _Utils_update(
							session1,
							{
								em: A2(
									$author$project$Notification$add,
									$author$project$Notification$ok(
										model.gB.h6($author$project$Locale$Messages$GradingPageConsentUpdated)),
									model.gB.em)
							});
						var consents = function () {
							var _v59 = model.dS;
							if (_v59.$ === 2) {
								var existingConsents = _v59.a;
								return $author$project$RemoteData$Success(
									A2(
										$elm$core$List$map,
										function (ac) {
											return _Utils_eq(ac.n2.i8, consent.n2.i8) ? consent : ac;
										},
										existingConsents));
							} else {
								var other = _v59;
								return other;
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{dS: consents, gB: session2}),
							$author$project$Element$GradingPage$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$27;
					}
				default:
					break _v0$27;
			}
		}
		return _Utils_Tuple3(model, $author$project$Element$GradingPage$NoEffect, $elm$core$Maybe$Nothing);
	});
var $author$project$Locale$Messages$GradingPageError = {$: 683};
var $author$project$Locale$Messages$GradingPageLoading = {$: 682};
var $author$project$Locale$Messages$GradingPageNoMarkRequests = {$: 679};
var $author$project$Locale$Messages$GradingPageTableLocked = function (a) {
	return {$: 717, a: a};
};
var $author$project$Locale$Messages$GradingPageTitleLate = {$: 678};
var $author$project$Element$GradingPage$SetConsent = function (a) {
	return {$: 17, a: a};
};
var $author$project$Element$GradingPage$SetLateRequestConsent = function (a) {
	return {$: 18, a: a};
};
var $author$project$Locale$Messages$GradingPageEndOfYear = {$: 675};
var $author$project$Locale$Messages$GradingPageMidYear = {$: 674};
var $author$project$Locale$Messages$GradingPageTitleFinalization = {$: 677};
var $author$project$Locale$Messages$GradingPageTitleLoading = {$: 182};
var $author$project$Locale$Messages$GradingPageTitleLocked = {$: 718};
var $author$project$Locale$Messages$GradingPageTitleOffering = {$: 676};
var $author$project$Element$GradingPage$gradingProcessDescription = F4(
	function (t_, language, assessmentPeriod, student) {
		switch (assessmentPeriod.$) {
			case 2:
				var ap = assessmentPeriod.a;
				if (!ap.m7) {
					return t_($author$project$Locale$Messages$GradingPageTitleLocked);
				} else {
					var periodPart = function () {
						var _v2 = ap.m7;
						switch (_v2) {
							case 1:
								return t_($author$project$Locale$Messages$GradingPageTitleOffering);
							case 2:
								return t_($author$project$Locale$Messages$GradingPageTitleFinalization);
							default:
								return '';
						}
					}();
					var assessmentTypePart = function () {
						var _v1 = ap.kV;
						if (!_v1) {
							return t_($author$project$Locale$Messages$GradingPageMidYear);
						} else {
							return t_($author$project$Locale$Messages$GradingPageEndOfYear);
						}
					}();
					return assessmentTypePart + (' ' + periodPart);
				}
			case 0:
				return t_($author$project$Locale$Messages$GradingPageTitleLate) + (', ' + A2($author$project$Person$displayName, student, language));
			case 1:
				return t_($author$project$Locale$Messages$GradingPageTitleLoading);
			default:
				var e = assessmentPeriod.a;
				return 'Hiba (' + ($author$project$Api$httpErrorToHumans(e) + ')');
		}
	});
var $author$project$Locale$Messages$GradingPageGradeLabel = function (a) {
	return {$: 700, a: a};
};
var $author$project$Locale$Messages$GradingPageOnlyIncomplete = {$: 699};
var $author$project$Element$GradingPage$SelectGrade = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Element$GradingPage$SelectOnlyIncomplete = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$GradingPage$SelectSubject = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Element$GradingPage$viewActiveFilters = F2(
	function (t_, filter) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ml-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('field is-grouped is-align-items-center flex-wrap')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('checkbox mr-4 mb-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('checkbox'),
											$elm$html$Html$Attributes$checked(filter.ff),
											$elm$html$Html$Events$onCheck($author$project$Element$GradingPage$SelectOnlyIncomplete),
											$elm$html$Html$Attributes$class('mr-2 has-text-link')
										]),
									_List_Nil),
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageOnlyIncomplete)
								])),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								function (grade) {
									return A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('checkbox mr-4 mb-2')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Attributes$checked(true),
														$elm$html$Html$Events$onCheck(
														$author$project$Element$GradingPage$SelectGrade(grade)),
														$elm$html$Html$Attributes$class('mr-2 has-text-link')
													]),
												_List_Nil),
												A2(
												$author$project$UI$caption,
												t_,
												$author$project$Locale$Messages$GradingPageGradeLabel(grade))
											]));
								},
								filter.i4),
							A2(
								$elm$core$List$map,
								function (subject) {
									return A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('checkbox mr-4 mb-2')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Attributes$checked(true),
														$elm$html$Html$Events$onCheck(
														$author$project$Element$GradingPage$SelectSubject(subject)),
														$elm$html$Html$Attributes$class('mr-2 has-text-link')
													]),
												_List_Nil),
												$elm$html$Html$text(subject.fb)
											]));
								},
								filter.kb))))
				]));
	});
var $author$project$Element$GradingPage$CloseConsentDialog = {$: 16};
var $author$project$Locale$Messages$GradingPageConsentDialogTitle = {$: 709};
var $author$project$Locale$Messages$GradingPageConsentTableConsentGiven = {$: 707};
var $author$project$Locale$Messages$GradingPageConsentTableTeacher = {$: 706};
var $author$project$Locale$Messages$GradingPageFailedToLoadConsents = {$: 708};
var $author$project$Locale$Messages$GradingPageGiveConsent = {$: 704};
var $author$project$Locale$Messages$GradingPageIHaveCheckedAllGrades = {$: 703};
var $author$project$Locale$Messages$GradingPageLoadingConsents = {$: 702};
var $author$project$Locale$Messages$GradingPageRefuseConsent = {$: 705};
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $author$project$Element$GradingPage$viewConsentDialog = F4(
	function (t_, language, onSetConsent, consentsData) {
		var dialogContent = function () {
			switch (consentsData.$) {
				case 1:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-text-centered'),
									A2($elm$html$Html$Attributes$style, 'padding', '2rem')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$UI$progressBar,
									'is-info',
									t_($author$project$Locale$Messages$GradingPageLoadingConsents))
								]))
						]);
				case 2:
					var consents = consentsData.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-text-centered'),
									A2($elm$html$Html$Attributes$style, 'margin-bottom', '1rem'),
									A2($elm$html$Html$Attributes$style, 'font-weight', 'bold')
								]),
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageIHaveCheckedAllGrades)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('buttons is-centered'),
									A2($elm$html$Html$Attributes$style, 'margin-bottom', '1.5rem')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button is-success'),
											$elm$html$Html$Events$onClick(
											onSetConsent(true))
										]),
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageGiveConsent)
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button is-danger'),
											$elm$html$Html$Events$onClick(
											onSetConsent(false))
										]),
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageRefuseConsent)
										]))
								])),
							A2(
							$elm$html$Html$table,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('table is-fullwidth is-striped')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$th,
													_List_Nil,
													_List_fromArray(
														[
															A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageConsentTableTeacher)
														])),
													A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('has-text-centered')
														]),
													_List_fromArray(
														[
															A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageConsentTableConsentGiven)
														]))
												]))
										])),
									A2(
									$elm$html$Html$tbody,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (consent) {
											return A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$td,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																A2($author$project$Person$displayName, consent.n2, language))
															])),
														A2(
														$elm$html$Html$td,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('has-text-centered')
															]),
														_List_fromArray(
															[
																consent.l5 ? A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('icon has-text-success')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$i,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('fas fa-check')
																			]),
																		_List_Nil)
																	])) : A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('icon has-text-danger')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$i,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('fas fa-times')
																			]),
																		_List_Nil)
																	]))
															]))
													]));
										},
										consents))
								]))
						]);
				case 3:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-text-danger')
								]),
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageFailedToLoadConsents)
								]))
						]);
				default:
					return _List_Nil;
			}
		}();
		return A4(
			$author$project$UI$confirmDialogWithoutDecline,
			t_,
			{lc: $author$project$Element$GradingPage$CloseConsentDialog},
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageConsentDialogTitle)
				]),
			dialogContent);
	});
var $author$project$Locale$Messages$GradingPageConsentDisabledIncomplete = {$: 711};
var $author$project$Locale$Messages$GradingPageDueDate = {$: 715};
var $author$project$Locale$Messages$GradingPageSaveChangesButton = {$: 697};
var $author$project$Locale$Messages$GradingPageViewConsentsButton = {$: 698};
var $author$project$Element$GradingPage$OpenConsentDialog = {$: 15};
var $author$project$Element$GradingPage$SaveChanges = {$: 14};
var $author$project$Element$GradingPage$viewFooter = F6(
	function (t_, language, selectedTab, assessmentPeriod, hasUnsavedChanges, tableRows) {
		var footerText = function () {
			if (assessmentPeriod.$ === 2) {
				var ap = assessmentPeriod.a;
				return (!ap.m7) ? A2($elm$html$Html$div, _List_Nil, _List_Nil) : A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('icon')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fas fa-clock')
										]),
									_List_Nil)
								])),
							$elm$html$Html$text(
							' ' + (t_($author$project$Locale$Messages$GradingPageDueDate) + (' (' + (A4(
								$author$project$Element$GradingPage$gradingProcessDescription,
								t_,
								language,
								assessmentPeriod,
								{O: '', lI: '', i8: 0, av: ''}) + ('): ' + ap.ly)))))
						]));
			} else {
				return A2($elm$html$Html$div, _List_Nil, _List_Nil);
			}
		}();
		var buttons = function () {
			if (!selectedTab) {
				var buttonAttrs = hasUnsavedChanges ? _List_fromArray(
					[
						$elm$html$Html$Attributes$class('button is-link'),
						$elm$html$Html$Events$onClick($author$project$Element$GradingPage$SaveChanges)
					]) : _List_fromArray(
					[
						$elm$html$Html$Attributes$class('button is-light'),
						A2($elm$html$Html$Attributes$attribute, 'disabled', 'true')
					]);
				return A2(
					$elm$html$Html$button,
					buttonAttrs,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageSaveChangesButton)
						]));
			} else {
				var isConsentPeriod = function () {
					switch (assessmentPeriod.$) {
						case 2:
							var ap = assessmentPeriod.a;
							return ap.m7 === 2;
						case 0:
							return true;
						default:
							return false;
					}
				}();
				var hasIncomplete = A2(
					$elm$core$List$any,
					function (row) {
						return (!row.bY) && function () {
							var sa = row.e;
							return _Utils_eq(sa.i$, $elm$core$Maybe$Nothing) && ((!sa.mg) && sa.jp);
						}();
					},
					tableRows);
				var buttonAttrs = ((!isConsentPeriod) || hasIncomplete) ? _List_fromArray(
					[
						$elm$html$Html$Attributes$class('button is-light'),
						A2($elm$html$Html$Attributes$attribute, 'disabled', 'true'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'title',
						t_($author$project$Locale$Messages$GradingPageConsentDisabledIncomplete))
					]) : _List_fromArray(
					[
						$elm$html$Html$Attributes$class('button is-link'),
						$elm$html$Html$Events$onClick($author$project$Element$GradingPage$OpenConsentDialog)
					]);
				return A2(
					$elm$html$Html$button,
					buttonAttrs,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageViewConsentsButton)
						]));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
					A2($elm$html$Html$Attributes$style, 'bottom', '0'),
					A2($elm$html$Html$Attributes$style, 'background', 'white'),
					A2($elm$html$Html$Attributes$style, 'padding', '1rem'),
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
					A2($elm$html$Html$Attributes$style, 'border-top', '1px solid #ddd')
				]),
			_List_fromArray(
				[footerText, buttons]));
	});
var $author$project$Locale$Messages$GradingPageTitle = {$: 673};
var $author$project$Element$GradingPage$viewHeading = F2(
	function (t_, description) {
		return A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('title'),
					A2($elm$html$Html$Attributes$style, 'background-color', 'rgb(255,196,1)'),
					A2($elm$html$Html$Attributes$style, 'color', 'white'),
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					A2($elm$html$Html$Attributes$style, 'margin', '0'),
					A2($elm$html$Html$Attributes$style, 'padding', '1rem')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					t_($author$project$Locale$Messages$GradingPageTitle) + (' - ' + description))
				]));
	});
var $author$project$Locale$Messages$GradingPageTableHeaderAssessmentType = {$: 694};
var $author$project$Locale$Messages$GradingPageTableHeaderFinalGrade = {$: 693};
var $author$project$Locale$Messages$GradingPageTableHeaderGrade = {$: 687};
var $author$project$Locale$Messages$GradingPageTableHeaderNotProgressing = {$: 691};
var $author$project$Locale$Messages$GradingPageTableHeaderProgressing = {$: 690};
var $author$project$Locale$Messages$GradingPageTableHeaderResponsibleTeacher = {$: 689};
var $author$project$Locale$Messages$GradingPageTableHeaderSubject = {$: 688};
var $author$project$Locale$Messages$GradingPageTableHeaderTextAppraisalGroup = {$: 684};
var $author$project$Locale$Messages$GradingPageTableIsWaived = {$: 695};
var $author$project$Element$GradingPage$Noop = {$: 23};
var $author$project$Element$GradingPage$OrderByGrade = 1;
var $author$project$Element$GradingPage$OrderByResponsibleTeacher = 3;
var $author$project$Element$GradingPage$OrderBySubject = 2;
var $author$project$Element$GradingPage$SelectResponsibleTeacher = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Element$GradingPage$UpdateMarkRequestFinalMark = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Element$GradingPage$assessmentTypeToString = F2(
	function (t_, assessmentType) {
		switch (assessmentType) {
			case 0:
				return t_($author$project$Locale$Messages$GradingPageMidYear);
			case 1:
				return t_($author$project$Locale$Messages$GradingPageEndOfYear);
			default:
				return 'unknown';
		}
	});
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$Element$GradingPage$availableGrades = function (rows) {
	return $author$project$Util$List$unique(
		$elm$core$List$sort(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.W;
				},
				rows)));
};
var $author$project$Element$GradingPage$availableResponsibleTeachers = function (rows) {
	return $author$project$Util$List$unique(
		A2(
			$elm$core$List$concatMap,
			function (r) {
				return r.e.ab;
			},
			rows));
};
var $author$project$Element$GradingPage$availableSubjects = function (rows) {
	return $author$project$Util$List$unique(
		A2(
			$elm$core$List$map,
			function (r) {
				return r.e.gE;
			},
			rows));
};
var $author$project$UI$dropdownMultiSelect = F5(
	function (label, options, isChecked, onSelect, renderOption) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dropdown is-hoverable')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-trigger')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button is-small is-white is-shadowless'),
									A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true'),
									A2($elm$html$Html$Attributes$attribute, 'aria-controls', 'dropdown-menu'),
									A2($elm$html$Html$Attributes$style, 'box-shadow', 'none'),
									A2($elm$html$Html$Attributes$style, 'border', 'none')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[label])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('icon is-small')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fas fa-angle-down')
												]),
											_List_Nil)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-menu')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dropdown-content')
								]),
							A2(
								$elm$core$List$map,
								function (opt) {
									return A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dropdown-item is-size-6')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Attributes$checked(
														isChecked(opt)),
														$elm$html$Html$Events$onCheck(
														onSelect(opt)),
														$elm$html$Html$Attributes$class('mr-2')
													]),
												_List_Nil),
												renderOption(opt)
											]));
								},
								options))
						]))
				]));
	});
var $author$project$Element$GradingPage$viewAppraisalCheckbox = F5(
	function (isChecked, handleCheck, color, symbol, disabled) {
		var inputAttrs = disabled ? _List_fromArray(
			[
				$elm$html$Html$Attributes$type_('checkbox'),
				$elm$html$Html$Attributes$checked(isChecked),
				$elm$html$Html$Attributes$class('is-hidden'),
				A2($elm$html$Html$Attributes$attribute, 'disabled', 'true')
			]) : _List_fromArray(
			[
				$elm$html$Html$Attributes$type_('checkbox'),
				$elm$html$Html$Attributes$checked(isChecked),
				$elm$html$Html$Events$onCheck(handleCheck),
				$elm$html$Html$Attributes$class('is-hidden')
			]);
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('checkbox')
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$input, inputAttrs, _List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-inline-block has-text-white has-text-centered'),
							A2($elm$html$Html$Attributes$style, 'width', '1.5rem'),
							A2($elm$html$Html$Attributes$style, 'height', '1.5rem'),
							A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
							A2($elm$html$Html$Attributes$style, 'border', '2px solid ' + color),
							A2(
							$elm$html$Html$Attributes$style,
							'background-color',
							isChecked ? color : 'transparent'),
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
							A2($elm$html$Html$Attributes$style, 'font-size', '1rem'),
							A2(
							$elm$html$Html$Attributes$style,
							'opacity',
							disabled ? '0.5' : '1'),
							A2(
							$elm$html$Html$Attributes$style,
							'cursor',
							disabled ? 'not-allowed' : 'pointer')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							isChecked ? symbol : '')
						]))
				]));
	});
var $author$project$Locale$Messages$GradingPageCantEditMarkNow = {$: 701};
var $author$project$Element$GradingPage$viewAssessmentMarkInput = F5(
	function (t_, sa, markFn, disabled, handleInput) {
		return disabled ? A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('input is-small has-text-centered'),
					A2($elm$html$Html$Attributes$style, 'max-width', '3rem'),
					A2($elm$html$Html$Attributes$style, 'padding', '0'),
					A2($elm$html$Html$Attributes$style, 'background-color', '#f5f5f5'),
					A2($elm$html$Html$Attributes$attribute, 'disabled', 'true'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'title',
					t_($author$project$Locale$Messages$GradingPageCantEditMarkNow)),
					$elm$html$Html$Attributes$value(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$elm$core$String$fromInt,
							markFn(sa))))
				]),
			_List_Nil) : A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('input is-small has-text-centered'),
					A2($elm$html$Html$Attributes$style, 'max-width', '3rem'),
					A2($elm$html$Html$Attributes$style, 'padding', '0'),
					$elm$html$Html$Attributes$value(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$elm$core$String$fromInt,
							markFn(sa)))),
					$elm$html$Html$Events$onInput(handleInput)
				]),
			_List_Nil);
	});
var $author$project$Element$GradingPage$ToggleOrderBy = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$GradingPage$viewOrderButton = F3(
	function (filter, orderByValue, label) {
		var isActive = _Utils_eq(
			filter.b4,
			$elm$core$Maybe$Just(orderByValue));
		var icon = function () {
			var _v0 = _Utils_Tuple2(isActive, filter.bP);
			if (_v0.a) {
				if (!_v0.b) {
					var _v1 = _v0.b;
					return 'fas fa-sort-up';
				} else {
					var _v2 = _v0.b;
					return 'fas fa-sort-down';
				}
			} else {
				return 'fas fa-sort';
			}
		}();
		var buttonClass = isActive ? 'button is-small is-link is-light' : 'button is-small is-ghost';
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(buttonClass),
					$elm$html$Html$Events$onClick(
					$author$project$Element$GradingPage$ToggleOrderBy(orderByValue)),
					A2($elm$html$Html$Attributes$style, 'border', 'none'),
					A2($elm$html$Html$Attributes$style, 'background', 'transparent')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[label])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('icon is-small')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(icon)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$UI$nav_ = F3(
	function (isAlwaysHorizontal, left, right) {
		return A2(
			$elm$html$Html$nav,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('level'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('is-mobile', isAlwaysHorizontal)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('level-left')
						]),
					A2(
						$elm$core$List$filterMap,
						function (item) {
							return _Utils_eq(item, $author$project$UI$none) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								A2(
									$elm$html$Html$small,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('level-item')
										]),
									_List_fromArray(
										[item])));
						},
						left)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('level-right')
						]),
					A2(
						$elm$core$List$map,
						function (item) {
							return A2(
								$elm$html$Html$small,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('level-item')
									]),
								_List_fromArray(
									[item]));
						},
						right))
				]));
	});
var $author$project$UI$nav = F2(
	function (left, right) {
		return A3($author$project$UI$nav_, false, left, right);
	});
var $author$project$Element$GradingPage$viewSubjectLink = F3(
	function (student, subject, grade) {
		return A2(
			$author$project$UI$nav,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href(
							A2(
								$author$project$Route$SubjectFeedbackList,
								student.i8,
								{
									W: $elm$core$Maybe$Just(grade),
									mB: $elm$core$Maybe$Nothing,
									gE: $elm$core$Maybe$Just(subject.i8)
								})),
							$author$project$UI$attrCyData('subject-feedback-card'),
							A2($elm$html$Html$Attributes$attribute, 'target', '_blank')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(subject.gk)
						]))
				]),
			_List_Nil);
	});
var $author$project$Element$GradingPage$viewLateGradingTable = F5(
	function (t_, language, selectedTab, rows, filter) {
		var markCell = F2(
			function (sa, handleInput) {
				return sa.mg ? A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableIsWaived) : A5(
					$author$project$Element$GradingPage$viewAssessmentMarkInput,
					t_,
					sa,
					function ($) {
						return $.i$;
					},
					!(!selectedTab),
					handleInput);
			});
		var viewRows = A2(
			$elm$core$List$map,
			function (row) {
				var sa = row.e;
				var responsibleTeachers = A2(
					$elm$core$String$join,
					', ',
					A2(
						$elm$core$List$map,
						function (t) {
							return A2($author$project$Person$displayName, t, language);
						},
						sa.ab));
				return A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-text-centered')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(row.W)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-text-centered')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Element$GradingPage$assessmentTypeToString, t_, row.kV))
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									A3($author$project$Element$GradingPage$viewSubjectLink, row.nT, sa.gE, row.W)
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(responsibleTeachers)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-background-light has-text-centered')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A5(
											$author$project$Element$GradingPage$viewAppraisalCheckbox,
											A2(
												$elm$core$Maybe$withDefault,
												false,
												A2($elm$core$Maybe$map, $author$project$LearningAssessment$isPassedTextAppraisal, sa.kh)),
											function (_v0) {
												return $author$project$Element$GradingPage$Noop;
											},
											'#D2D2D2',
											'✔',
											true)
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-background-light has-text-centered')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A5(
											$author$project$Element$GradingPage$viewAppraisalCheckbox,
											!A2(
												$elm$core$Maybe$withDefault,
												false,
												A2($elm$core$Maybe$map, $author$project$LearningAssessment$isPassedTextAppraisal, sa.kh)),
											function (_v1) {
												return $author$project$Element$GradingPage$Noop;
											},
											'#8F8F8F',
											'✖',
											true)
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-text-centered')
								]),
							_List_fromArray(
								[
									A2(
									markCell,
									row.e,
									$author$project$Element$GradingPage$UpdateMarkRequestFinalMark(row))
								]))
						]));
			},
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.cg;
				},
				rows));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('table is-fullwidth is-striped is-hoverable'),
							A2($elm$html$Html$Attributes$style, 'overflow', 'visible')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
									A2($elm$html$Html$Attributes$style, 'top', '0'),
									A2($elm$html$Html$Attributes$style, 'z-index', '5'),
									A2($elm$html$Html$Attributes$style, 'background', 'white')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('has-text-centered')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$colspan(2),
													$elm$html$Html$Attributes$class('has-background-light')
												]),
											_List_fromArray(
												[
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderTextAppraisalGroup)
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'display', 'inline-flex'),
															A2($elm$html$Html$Attributes$style, 'align-items', 'center')
														]),
													_List_fromArray(
														[
															A5(
															$author$project$UI$dropdownMultiSelect,
															A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderGrade),
															$author$project$Element$GradingPage$availableGrades(rows),
															function (grade) {
																return A2($elm$core$List$member, grade, filter.i4);
															},
															$author$project$Element$GradingPage$SelectGrade,
															function (grade) {
																return A2(
																	$author$project$UI$caption,
																	t_,
																	$author$project$Locale$Messages$GradingPageGradeLabel(grade));
															}),
															A3(
															$author$project$Element$GradingPage$viewOrderButton,
															filter,
															1,
															$elm$html$Html$text(''))
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('has-text-centered')
												]),
											_List_fromArray(
												[
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderAssessmentType)
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'display', 'inline-flex'),
															A2($elm$html$Html$Attributes$style, 'align-items', 'center')
														]),
													_List_fromArray(
														[
															A5(
															$author$project$UI$dropdownMultiSelect,
															A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderSubject),
															$author$project$Element$GradingPage$availableSubjects(rows),
															function (subject) {
																return A2($elm$core$List$member, subject, filter.kb);
															},
															$author$project$Element$GradingPage$SelectSubject,
															function (subject) {
																return $elm$html$Html$text(subject.fb);
															}),
															A3(
															$author$project$Element$GradingPage$viewOrderButton,
															filter,
															2,
															$elm$html$Html$text(''))
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_fromArray(
												[
													(!selectedTab) ? A3(
													$author$project$Element$GradingPage$viewOrderButton,
													filter,
													3,
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderResponsibleTeacher)) : A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'display', 'inline-flex'),
															A2($elm$html$Html$Attributes$style, 'align-items', 'center')
														]),
													_List_fromArray(
														[
															A5(
															$author$project$UI$dropdownMultiSelect,
															A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderResponsibleTeacher),
															$author$project$Element$GradingPage$availableResponsibleTeachers(rows),
															function (teacher) {
																return A2($elm$core$List$member, teacher, filter.ab);
															},
															$author$project$Element$GradingPage$SelectResponsibleTeacher,
															function (teacher) {
																return $elm$html$Html$text(
																	A2($author$project$Person$displayName, teacher, language));
															}),
															A3(
															$author$project$Element$GradingPage$viewOrderButton,
															filter,
															3,
															$elm$html$Html$text(''))
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('has-background-light has-text-centered'),
													A2($elm$html$Html$Attributes$style, 'background', '#f5f5f5')
												]),
											_List_fromArray(
												[
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderProgressing)
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('has-background-light has-text-centered'),
													A2($elm$html$Html$Attributes$style, 'background', '#f5f5f5')
												]),
											_List_fromArray(
												[
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderNotProgressing)
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('has-text-centered'),
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_fromArray(
												[
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderFinalGrade)
												]))
										]))
								])),
							A2($elm$html$Html$tbody, _List_Nil, viewRows)
						]))
				]));
	});
var $author$project$Locale$Messages$GradingPageTableHeaderGradeGroup = {$: 685};
var $author$project$Locale$Messages$GradingPageTableHeaderOfferedGrade = {$: 692};
var $author$project$Locale$Messages$GradingPageTableHeaderStudentName = {$: 686};
var $author$project$Locale$Messages$GradingPageTableLateRequest = {$: 712};
var $author$project$Locale$Messages$GradingPageTableNotRequested = {$: 696};
var $author$project$Element$GradingPage$OrderByStudentName = 0;
var $author$project$Element$GradingPage$SelectIsProgressing = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Element$GradingPage$SelectNotProgressing = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Element$GradingPage$UpdateFinalMark = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Element$GradingPage$UpdateOfferedMark = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Element$GradingPage$viewPeriodicGradingTable = F6(
	function (t_, language, selectedTab, assessmentPeriod, rows, filter) {
		var markCell = F7(
			function (sa, markFn, disabled, waivedView, notRequiredView, notRecommendedView, handleInput) {
				return sa.mg ? waivedView : ((!sa.jp) ? notRequiredView : ((!sa.hx) ? notRecommendedView : A5($author$project$Element$GradingPage$viewAssessmentMarkInput, t_, sa, markFn, disabled, handleInput)));
			});
		var viewRows = A2(
			$elm$core$List$map,
			function (row) {
				var sa = row.e;
				var responsibleTeachers = A2(
					$elm$core$String$join,
					', ',
					A2(
						$elm$core$List$map,
						function (t) {
							return A2($author$project$Person$displayName, t, language);
						},
						sa.ab));
				return A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Person$displayName, row.nT, language))
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-text-centered')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(row.W)
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									A3($author$project$Element$GradingPage$viewSubjectLink, row.nT, sa.gE, row.W)
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(responsibleTeachers)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-background-light has-text-centered')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A5(
											$author$project$Element$GradingPage$viewAppraisalCheckbox,
											_Utils_eq(
												sa.kh,
												$elm$core$Maybe$Just(
													$author$project$LearningAssessment$passedTextAppraisalForAssessmentType(assessmentPeriod.kV))),
											$author$project$Element$GradingPage$SelectIsProgressing(row),
											'#4caf50',
											'✔',
											!A3($author$project$Element$GradingPage$canUpdateTextAppraisal, selectedTab, sa, assessmentPeriod))
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-background-light has-text-centered')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A5(
											$author$project$Element$GradingPage$viewAppraisalCheckbox,
											_Utils_eq(
												sa.kh,
												$elm$core$Maybe$Just(
													$author$project$LearningAssessment$notPassedTextAppraisalForAssessmentType(assessmentPeriod.kV))),
											$author$project$Element$GradingPage$SelectNotProgressing(row),
											'#325DBA',
											'✖',
											!A3($author$project$Element$GradingPage$canUpdateTextAppraisal, selectedTab, sa, assessmentPeriod))
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-text-centered')
								]),
							_List_fromArray(
								[
									A7(
									markCell,
									row.e,
									function ($) {
										return $.en;
									},
									(selectedTab === 1) || (assessmentPeriod.m7 !== 1),
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableIsWaived),
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableNotRequested),
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableLateRequest),
									$author$project$Element$GradingPage$UpdateOfferedMark(row))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-text-centered')
								]),
							_List_fromArray(
								[
									A7(
									markCell,
									row.e,
									function ($) {
										return $.i$;
									},
									(selectedTab === 1) || (assessmentPeriod.m7 !== 2),
									$elm$html$Html$text('✖'),
									$elm$html$Html$text('✖'),
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableLateRequest),
									$author$project$Element$GradingPage$UpdateFinalMark(row))
								]))
						]));
			},
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.cg;
				},
				rows));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('table is-fullwidth is-striped is-hoverable'),
							A2($elm$html$Html$Attributes$style, 'overflow', 'visible')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
									A2($elm$html$Html$Attributes$style, 'top', '0'),
									A2($elm$html$Html$Attributes$style, 'z-index', '5'),
									A2($elm$html$Html$Attributes$style, 'background', 'white')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('has-text-centered')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$colspan(2),
													$elm$html$Html$Attributes$class('has-background-light')
												]),
											_List_fromArray(
												[
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderTextAppraisalGroup)
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$colspan(2),
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_fromArray(
												[
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderGradeGroup)
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Element$GradingPage$viewOrderButton,
													filter,
													0,
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderStudentName))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'display', 'inline-flex'),
															A2($elm$html$Html$Attributes$style, 'align-items', 'center')
														]),
													_List_fromArray(
														[
															A5(
															$author$project$UI$dropdownMultiSelect,
															A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderGrade),
															$author$project$Element$GradingPage$availableGrades(rows),
															function (grade) {
																return A2($elm$core$List$member, grade, filter.i4);
															},
															$author$project$Element$GradingPage$SelectGrade,
															function (grade) {
																return A2(
																	$author$project$UI$caption,
																	t_,
																	$author$project$Locale$Messages$GradingPageGradeLabel(grade));
															}),
															A3(
															$author$project$Element$GradingPage$viewOrderButton,
															filter,
															1,
															$elm$html$Html$text(''))
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'display', 'inline-flex'),
															A2($elm$html$Html$Attributes$style, 'align-items', 'center')
														]),
													_List_fromArray(
														[
															A5(
															$author$project$UI$dropdownMultiSelect,
															A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderSubject),
															$author$project$Element$GradingPage$availableSubjects(rows),
															function (subject) {
																return A2($elm$core$List$member, subject, filter.kb);
															},
															$author$project$Element$GradingPage$SelectSubject,
															function (subject) {
																return $elm$html$Html$text(subject.fb);
															}),
															A3(
															$author$project$Element$GradingPage$viewOrderButton,
															filter,
															2,
															$elm$html$Html$text(''))
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_fromArray(
												[
													(!selectedTab) ? A3(
													$author$project$Element$GradingPage$viewOrderButton,
													filter,
													3,
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderResponsibleTeacher)) : A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'display', 'inline-flex'),
															A2($elm$html$Html$Attributes$style, 'align-items', 'center')
														]),
													_List_fromArray(
														[
															A5(
															$author$project$UI$dropdownMultiSelect,
															A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderResponsibleTeacher),
															$author$project$Element$GradingPage$availableResponsibleTeachers(rows),
															function (teacher) {
																return A2($elm$core$List$member, teacher, filter.ab);
															},
															$author$project$Element$GradingPage$SelectResponsibleTeacher,
															function (teacher) {
																return $elm$html$Html$text(
																	A2($author$project$Person$displayName, teacher, language));
															}),
															A3(
															$author$project$Element$GradingPage$viewOrderButton,
															filter,
															3,
															$elm$html$Html$text(''))
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('has-background-light has-text-centered'),
													A2($elm$html$Html$Attributes$style, 'background', '#f5f5f5')
												]),
											_List_fromArray(
												[
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderProgressing)
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('has-background-light has-text-centered'),
													A2($elm$html$Html$Attributes$style, 'background', '#f5f5f5')
												]),
											_List_fromArray(
												[
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderNotProgressing)
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('has-text-centered'),
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_fromArray(
												[
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderOfferedGrade)
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('has-text-centered'),
													A2($elm$html$Html$Attributes$style, 'background', 'white')
												]),
											_List_fromArray(
												[
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageTableHeaderFinalGrade)
												]))
										]))
								])),
							A2($elm$html$Html$tbody, _List_Nil, viewRows)
						]))
				]));
	});
var $author$project$Locale$Messages$GradingPageStudentSelectorDueDate = function (a) {
	return {$: 672, a: a};
};
var $author$project$Element$GradingPage$StudentSelected = function (a) {
	return {$: 22, a: a};
};
var $ryan_haskell$date_format$DateFormat$DayOfMonthFixed = {$: 7};
var $ryan_haskell$date_format$DateFormat$dayOfMonthFixed = $ryan_haskell$date_format$DateFormat$DayOfMonthFixed;
var $ryan_haskell$date_format$DateFormat$MonthFixed = {$: 2};
var $ryan_haskell$date_format$DateFormat$monthFixed = $ryan_haskell$date_format$DateFormat$MonthFixed;
var $author$project$Form$dateFromMillis = function (millis) {
	return A4(
		$ryan_haskell$date_format$DateFormat$formatWithLanguage,
		$ryan_haskell$date_format$DateFormat$Language$english,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$yearNumber,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$monthFixed,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed
			]),
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(millis));
};
var $author$project$UI$gravatarSmall = function (email) {
	var size = 48;
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$src(
				A2($author$project$Util$Media$gravatar, size, email)),
				$elm$html$Html$Attributes$width(size),
				$elm$html$Html$Attributes$height(size)
			]),
		_List_Nil);
};
var $author$project$Element$GradingPage$viewStudentSelector = F3(
	function (t_, language, studentsWithMarkRequests) {
		var viewStudentItem = function (_v0) {
			var student = _v0.a;
			var markRequests = _v0.b;
			var fullName = A2($author$project$Person$displayName, student, language);
			var dueDate = A2(
				$elm$core$Maybe$withDefault,
				'?',
				A2(
					$elm$core$Maybe$map,
					$author$project$Form$dateFromMillis,
					$elm$core$List$minimum(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.lv;
							},
							markRequests))));
			return A3(
				$author$project$UI$actionLink,
				$author$project$Element$GradingPage$StudentSelected(markRequests),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('box mb-3 is-clickable mark-request-item'),
						A2($elm$html$Html$Attributes$style, 'display', 'block'),
						A2($elm$html$Html$Attributes$style, 'text-decoration', 'none'),
						A2($elm$html$Html$Attributes$style, 'color', 'inherit')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('media')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('media-left')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$figure,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image is-48x48')
											]),
										_List_fromArray(
											[
												$author$project$UI$gravatarSmall(student.O)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('media-content')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('title is-5 has-text-weight-medium mb-2')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(fullName)
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('subtitle is-6 has-text-grey-light mt-1')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$UI$caption,
												t_,
												$author$project$Locale$Messages$GradingPageStudentSelectorDueDate(dueDate))
											]))
									]))
							]))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('columns is-centered')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column is-12-desktop is-12-tablet')
						]),
					A2($elm$core$List$map, viewStudentItem, studentsWithMarkRequests))
				]));
	});
var $author$project$Locale$Messages$GradingPageEverythingTabTitle = {$: 681};
var $author$project$Locale$Messages$GradingPageGradingTabTitle = {$: 680};
var $author$project$Element$GradingPage$TabSelected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$GradingPage$viewTabBar = F2(
	function (t_, selected) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tabs is-centered')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('is-active', !selected)
										]))
								]),
							_List_fromArray(
								[
									A3(
									$author$project$UI$actionLink,
									$author$project$Element$GradingPage$TabSelected(0),
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageGradingTabTitle)
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('is-active', selected === 1)
										]))
								]),
							_List_fromArray(
								[
									A3(
									$author$project$UI$actionLink,
									$author$project$Element$GradingPage$TabSelected(1),
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradingPageEverythingTabTitle)
										]))
								]))
						]))
				]));
	});
var $author$project$Element$GradingPage$view = function (_v0) {
	var session = _v0.gB;
	var page = _v0.bk;
	var filter = _v0.ad;
	var consentDialogOpen = _v0.eX;
	var assessmentConsents = _v0.dS;
	var assessmentPeriod = _v0.eQ;
	switch (page.$) {
		case 3:
			var error = page.a;
			return $author$project$UI$section(
				_List_fromArray(
					[
						A2($author$project$UI$caption, session.h6, $author$project$Locale$Messages$GradingPageError),
						$elm$html$Html$text(': ' + error)
					]));
		case 0:
			return $author$project$UI$section(
				_List_fromArray(
					[
						A2(
						$author$project$UI$progressBar,
						'is-info',
						session.h6($author$project$Locale$Messages$GradingPageLoading))
					]));
		case 2:
			var studentsWithMarkRequests = page.a;
			return $author$project$UI$section(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-4')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Element$GradingPage$viewHeading,
								session.h6,
								session.h6($author$project$Locale$Messages$GradingPageTitleLate))
							])),
						function () {
						if (!studentsWithMarkRequests.b) {
							return A2($author$project$UI$caption, session.h6, $author$project$Locale$Messages$GradingPageNoMarkRequests);
						} else {
							return A3($author$project$Element$GradingPage$viewStudentSelector, session.h6, session.mn, studentsWithMarkRequests);
						}
					}()
					]));
		default:
			var selectedTab = page.a;
			var tableRows = page.b;
			var student = A2(
				$elm$core$Maybe$withDefault,
				{O: '', lI: '', i8: 0, av: ''},
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.nT;
					},
					$elm$core$List$head(tableRows)));
			return $author$project$UI$section(
				_List_fromArray(
					[
						A2(
						$author$project$Element$GradingPage$viewHeading,
						session.h6,
						A4($author$project$Element$GradingPage$gradingProcessDescription, session.h6, session.mn, assessmentPeriod, student)),
						A2($author$project$Element$GradingPage$viewTabBar, session.h6, selectedTab),
						A2($author$project$Element$GradingPage$viewActiveFilters, session.h6, filter),
						function () {
						switch (assessmentPeriod.$) {
							case 2:
								var ap = assessmentPeriod.a;
								return ((!ap.m7) && (!$author$project$ACL$canManageGrading(session.ok))) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('is-flex is-justify-content-center is-align-items-center'),
											A2($elm$html$Html$Attributes$style, 'min-height', '12rem')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('has-text-centered')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													session.h6(
														$author$project$Locale$Messages$GradingPageTableLocked(ap.ly)))
												]))
										])) : A6($author$project$Element$GradingPage$viewPeriodicGradingTable, session.h6, session.mn, selectedTab, ap, tableRows, filter);
							case 0:
								return A5($author$project$Element$GradingPage$viewLateGradingTable, session.h6, session.mn, selectedTab, tableRows, filter);
							default:
								return A2(
									$author$project$UI$progressBar,
									'is-info',
									session.h6($author$project$Locale$Messages$GradingPageLoading));
						}
					}(),
						A6(
						$author$project$Element$GradingPage$viewFooter,
						session.h6,
						session.mn,
						selectedTab,
						assessmentPeriod,
						A2(
							$elm$core$List$any,
							function ($) {
								return $.bY;
							},
							tableRows),
						tableRows),
						function () {
						if (consentDialogOpen) {
							var consentMsg = function () {
								if (!assessmentPeriod.$) {
									return $author$project$Element$GradingPage$SetLateRequestConsent;
								} else {
									return $author$project$Element$GradingPage$SetConsent;
								}
							}();
							return A4($author$project$Element$GradingPage$viewConsentDialog, session.h6, session.mn, consentMsg, assessmentConsents);
						} else {
							return $author$project$UI$none;
						}
					}()
					]));
	}
};
var $author$project$Element$GradingPage$element = {jb: $author$project$Element$GradingPage$init, hP: $author$project$Element$GradingPage$perform, ks: $author$project$Element$GradingPage$update, og: $author$project$Element$GradingPage$view};
var $author$project$Element$HomePage$ActivityLogListDownloaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$HomePage$StudentsDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$HomePage$TimeIsNow = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Endpoint$activeAndFutureStudents = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'students']),
		_List_fromArray(
			[
				_Utils_Tuple2('state', 'active_and_future')
			]));
};
var $author$project$Student$Student = function (id) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (phoneNumber) {
					return function (mentor) {
						return function (mentorMemoUrl) {
							return function (sponsoredBy) {
								return function (activeLearningContract) {
									return function (currentGrade) {
										return function (roles) {
											return {kL: activeLearningContract, fT: currentGrade, O: email, lI: firstName, i8: id, av: lastName, my: mentor, mz: mentorMemoUrl, a$: phoneNumber, nr: roles, nM: sponsoredBy};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$LearningContract$LearningContract = F7(
	function (id, student, url, startDate, endDate, isActive, mentor) {
		return {ly: endDate, i8: id, l0: isActive, my: mentor, nN: startDate, nT: student, K: url};
	});
var $author$project$LearningContract$LearningContractId = $elm$core$Basics$identity;
var $author$project$LearningContract$learningContractIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$LearningContract$learningContractDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'mentor',
	$elm$json$Json$Decode$nullable($author$project$Person$nestedPersonDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_active',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'end_date',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'start_date',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'url',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'student',
						$author$project$Person$nestedPersonDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$author$project$LearningContract$learningContractIdDecoder,
							$elm$json$Json$Decode$succeed($author$project$LearningContract$LearningContract))))))));
var $author$project$Student$studentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'roles',
	$author$project$Person$rolesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'current_grade',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'active_learning_contract',
			$elm$json$Json$Decode$nullable($author$project$LearningContract$learningContractDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sponsored_by',
				$author$project$Person$nestedPeopleDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'mentor_memo_url',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'mentor',
						$elm$json$Json$Decode$nullable($author$project$Person$nestedPersonDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'phone_number',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'email',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'last_name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'first_name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$int,
											$elm$json$Json$Decode$succeed($author$project$Student$Student))))))))))));
var $author$project$Student$studentsDecoder = $elm$json$Json$Decode$list($author$project$Student$studentDecoder);
var $author$project$Student$fetchActiveAndFutureStudents = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$activeAndFutureStudents(config),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$Student$studentsDecoder));
	});
var $author$project$Api$Endpoint$activityLogs = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'activity-logs']),
		_List_Nil);
};
var $author$project$ActivityLog$PortfoliosActivity = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$ActivityLog$SimpleActivity = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$ActivityType$LearningContract = 0;
var $author$project$ActivityType$MentorMemo = 1;
var $author$project$ActivityType$Portfolio = 2;
var $author$project$ActivityType$Profile = 3;
var $author$project$ActivityType$UnknownActivityType = 4;
var $author$project$ActivityType$toActivityType = function (type_) {
	switch (type_) {
		case 'learning_contract':
			return 0;
		case 'mentor_memo':
			return 1;
		case 'portfolio':
			return 2;
		case 'profile':
			return 3;
		default:
			return 4;
	}
};
var $author$project$ActivityLog$activityTypeDecoder = A2($elm$json$Json$Decode$map, $author$project$ActivityType$toActivityType, $elm$json$Json$Decode$string);
var $author$project$ActivityLog$Message = F5(
	function (message_type, happened_at, activity_type, person, object_url) {
		return {kM: activity_type, lR: happened_at, mA: message_type, mT: object_url, m8: person};
	});
var $author$project$MessageType$LearningContractCreated = 0;
var $author$project$MessageType$LearningContractUpdated = 1;
var $author$project$MessageType$MentorMemoUpdated = 2;
var $author$project$MessageType$ModuleTeacherProfileUpdated = 3;
var $author$project$MessageType$PortfolioStoryCreated = 4;
var $author$project$MessageType$PortfolioStoryUpdated = 5;
var $author$project$MessageType$ProfileUpdated = 6;
var $author$project$MessageType$StudentProfileUpdated = 7;
var $author$project$MessageType$TeacherProfileUpdated = 8;
var $author$project$MessageType$UnknownMessageType = 9;
var $author$project$MessageType$toMessageType = function (type_) {
	switch (type_) {
		case 'learning_contract_created':
			return 0;
		case 'learning_contract_updated':
			return 1;
		case 'module_teacher_profile_updated':
			return 3;
		case 'portfolio_story_created':
			return 4;
		case 'portfolio_story_updated':
			return 5;
		case 'mentor_memo_updated':
			return 2;
		case 'profile_updated':
			return 6;
		case 'student_profile_updated':
			return 7;
		case 'teacher_profile_updated':
			return 8;
		default:
			return 9;
	}
};
var $author$project$ActivityLog$messageTypeDecoder = A2($elm$json$Json$Decode$map, $author$project$MessageType$toMessageType, $elm$json$Json$Decode$string);
var $author$project$ActivityLog$messageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'object_url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'person',
		$author$project$Person$nestedPersonDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'activity_type',
			$author$project$ActivityLog$activityTypeDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'happened_at',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'message_type',
					$author$project$ActivityLog$messageTypeDecoder,
					$elm$json$Json$Decode$succeed($author$project$ActivityLog$Message))))));
var $author$project$ActivityLog$PortfolioStoryMessageContext = function (media) {
	return {mw: media};
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $author$project$PortfolioStory$StoryMedia = F4(
	function (orig, small, preview, large) {
		return {jn: large, m$: orig, hQ: preview, nH: small};
	});
var $author$project$PortfolioStory$storyMediaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'large',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'preview',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'small',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'orig',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$PortfolioStory$StoryMedia)))));
var $author$project$ActivityLog$portfolioStoryMessageContextDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['extra', 'media']),
	$author$project$PortfolioStory$storyMediaDecoder,
	$elm$json$Json$Decode$succeed($author$project$ActivityLog$PortfolioStoryMessageContext));
var $author$project$ActivityLog$SimpleMessageContext = F3(
	function (from, to, extra) {
		return {lC: extra, lJ: from, n4: to};
	});
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$ActivityLog$simpleMessageContextDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'extra',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
	$elm$core$Dict$empty,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'to',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
		$elm$core$Dict$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'from',
			$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
			$elm$core$Dict$empty,
			$elm$json$Json$Decode$succeed($author$project$ActivityLog$SimpleMessageContext))));
var $author$project$ActivityLog$activityLogDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (message) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (activityType) {
				if (activityType === 2) {
					return A2(
						$elm$json$Json$Decode$map,
						function (messageContext) {
							return A2($author$project$ActivityLog$PortfoliosActivity, message, messageContext);
						},
						A2($elm$json$Json$Decode$field, 'message_context', $author$project$ActivityLog$portfolioStoryMessageContextDecoder));
				} else {
					return A2(
						$elm$json$Json$Decode$map,
						function (messageContext) {
							return A2($author$project$ActivityLog$SimpleActivity, message, messageContext);
						},
						A2($elm$json$Json$Decode$field, 'message_context', $author$project$ActivityLog$simpleMessageContextDecoder));
				}
			},
			A2($elm$json$Json$Decode$field, 'activity_type', $author$project$ActivityLog$activityTypeDecoder));
	},
	$author$project$ActivityLog$messageDecoder);
var $author$project$ActivityLog$activityLogsDecoder = $elm$json$Json$Decode$list($author$project$ActivityLog$activityLogDecoder);
var $author$project$ActivityLog$fetchActivityLogs = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$activityLogs(config),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$ActivityLog$activityLogsDecoder));
	});
var $author$project$Element$HomePage$hasPortfolioFeed = function (viewer) {
	return $author$project$Person$isActiveMember(viewer) && ($author$project$Person$isSponsor(viewer) && (!$author$project$ACL$isStaff(viewer)));
};
var $author$project$Application$V2$Boundaries$mapElement = F3(
	function (containerReturn, element, elementReturn) {
		return {
			dX: $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						containerReturn.dX,
						A2($elm$core$Platform$Cmd$map, element.cf, elementReturn.dX)
					])),
			eh: A2(element.kt, containerReturn.eh, elementReturn.eh),
			gs: elementReturn.gs,
			gB: elementReturn.gB
		};
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Element$PortfolioList$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioList$ClassroomCourseListDownloaded = function (a) {
	return {$: 14, a: a};
};
var $author$project$Element$PortfolioList$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioList$FetchClassroomCourseList = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$PortfolioList$FetchModuleDropdownList = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioList$FetchPortfolioStoryList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$PortfolioList$FetchStudentsAndTeachersList = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioList$FetchSubjectList = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioList$LoadingStories = {$: 0};
var $author$project$Element$PortfolioList$ModuleListDownloaded = function (a) {
	return {$: 11, a: a};
};
var $author$project$Element$PortfolioList$NoEffect = {$: 0};
var $author$project$Element$PortfolioList$PeopleListDownloaded = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$PortfolioList$PortfolioStoryListDownloaded = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$PortfolioList$SubjectListDownloaded = function (a) {
	return {$: 13, a: a};
};
var $author$project$PortfolioStory$defaultListPageSize = 20;
var $author$project$Api$Endpoint$categoryAll = '';
var $author$project$Api$Endpoint$categoryChildren = 'sponsored';
var $author$project$Api$Endpoint$categoryCreator = 'self';
var $author$project$Api$Endpoint$categorySchools = 'team';
var $author$project$Element$PortfolioList$listFilterToCategory = function (filter) {
	var _v0 = filter.bD;
	switch (_v0) {
		case 0:
			return $author$project$Api$Endpoint$categoryAll;
		case 1:
			return $author$project$Api$Endpoint$categorySchools;
		case 2:
			return $author$project$Api$Endpoint$categoryCreator;
		default:
			return $author$project$Api$Endpoint$categoryChildren;
	}
};
var $author$project$Api$Endpoint$typeAll = '';
var $author$project$Api$Endpoint$typeFeedback = 'feedback';
var $author$project$Api$Endpoint$typeMClosure = 'mclosure';
var $author$project$Element$PortfolioList$listFilterToType = function (filter) {
	var _v0 = filter.ii;
	switch (_v0) {
		case 0:
			return $author$project$Api$Endpoint$typeAll;
		case 1:
			return $author$project$Api$Endpoint$typeFeedback;
		default:
			return $author$project$Api$Endpoint$typeMClosure;
	}
};
var $author$project$Module$moduleIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Data$toMaybe = F2(
	function (isEmpty, value) {
		return isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value);
	});
var $author$project$Element$PortfolioList$asListParams = function (_v0) {
	var loading = _v0.dj;
	var filter = _v0.ad;
	var query = _v0.bF;
	return {
		bD: $author$project$Element$PortfolioList$listFilterToCategory(filter),
		g2: A2($author$project$Data$toMaybe, $elm$core$List$isEmpty, filter.g2),
		hb: filter.hb,
		b0: function () {
			if (loading.$ === 1) {
				var story = loading.a;
				return $elm$core$Maybe$Just(story.i8);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		hH: A2(
			$author$project$Data$toMaybe,
			$elm$core$List$isEmpty,
			A2($elm$core$List$map, $author$project$Module$moduleIdToInt, filter.hH)),
		bF: query,
		ce: $author$project$PortfolioStory$defaultListPageSize,
		h2: filter.h2,
		fv: A2($author$project$Data$toMaybe, $elm$core$List$isEmpty, filter.fv),
		fx: A2($author$project$Data$toMaybe, $elm$core$List$isEmpty, filter.fx),
		ii: $author$project$Element$PortfolioList$listFilterToType(filter)
	};
};
var $author$project$ACL$canViewClassrooms = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$Element$PortfolioList$TypeAll = 0;
var $author$project$Element$PortfolioList$TypeFeedback = 1;
var $author$project$Element$PortfolioList$FilterAll = 0;
var $author$project$Element$PortfolioList$emptyFilter = {bD: 0, g2: _List_Nil, hb: $elm$core$Maybe$Nothing, hH: _List_Nil, h2: $elm$core$Maybe$Nothing, fv: _List_Nil, fx: _List_Nil, ii: 0};
var $author$project$Element$PortfolioList$studentTypeToPeopleIds = F2(
	function (viewer, type_) {
		switch (type_.$) {
			case 0:
				return A2(
					$elm$core$List$map,
					function ($) {
						return $.i8;
					},
					viewer.nL);
			case 2:
				return _List_Nil;
			default:
				var s = type_.a;
				return s;
		}
	});
var $author$project$Element$PortfolioList$defaultFilter = F2(
	function (viewer, params) {
		return _Utils_update(
			$author$project$Element$PortfolioList$emptyFilter,
			{
				hb: params.hb,
				hH: params.hH,
				h2: params.h2,
				fv: A2($author$project$Element$PortfolioList$studentTypeToPeopleIds, viewer, params.fv),
				ii: params.mY ? 1 : 0
			});
	});
var $author$project$Module$defaultListPageSize = 20;
var $author$project$Module$defaultListParams = {ir: false, bD: '', iQ: false, i4: $elm$core$Maybe$Nothing, b0: $elm$core$Maybe$Nothing, mC: false, m6: _List_Nil, bF: '', j2: $elm$core$Maybe$Nothing, ce: $author$project$Module$defaultListPageSize, kb: $elm$core$Maybe$Nothing, fx: $elm$core$Maybe$Nothing, kr: true};
var $author$project$Module$ModuleDropdownItem = F6(
	function (id, title, team, accountableTeacher, teachers, students) {
		return {kI: accountableTeacher, i8: id, fv: students, fx: teachers, kf: team, kj: title};
	});
var $author$project$Module$moduleIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$Module$moduleDropdownItemDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'students',
	$author$project$Person$nestedPeopleDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'teachers',
		$author$project$Person$nestedPeopleDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'accountable_teacher',
			$author$project$Person$nestedPersonDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'team',
				$author$project$Team$nestedTeamDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'title',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$author$project$Module$moduleIdDecoder,
						$elm$json$Json$Decode$succeed($author$project$Module$ModuleDropdownItem)))))));
var $author$project$Module$moduleDropdownItemsDecoder = $elm$json$Json$Decode$list($author$project$Module$moduleDropdownItemDecoder);
var $author$project$Api$Endpoint$makeModulesQueryParams = function (params) {
	return A3(
		$author$project$Api$Endpoint$optional,
		$elm$core$String$fromInt,
		_Utils_Tuple2('last_seen', params.b0),
		A3(
			$author$project$Api$Endpoint$optionalList,
			$elm$core$String$fromInt,
			_Utils_Tuple2('subjects', params.kb),
			A3(
				$author$project$Api$Endpoint$optionalList,
				$elm$core$String$fromInt,
				_Utils_Tuple2('schools', params.j2),
				A3(
					$author$project$Api$Endpoint$optionalList,
					$elm$core$String$fromInt,
					_Utils_Tuple2('teachers', params.fx),
					A3(
						$author$project$Api$Endpoint$optionalList,
						$elm$core$Basics$identity,
						_Utils_Tuple2('grades', params.i4),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'size',
								$elm$core$String$fromInt(params.ce)),
								_Utils_Tuple2(
								'include_inactive',
								$author$project$Api$Endpoint$stringFromBool(!params.ir)),
								_Utils_Tuple2(
								'include_locked',
								$author$project$Api$Endpoint$stringFromBool(!params.kr)),
								_Utils_Tuple2(
								'include_before_current_school_year',
								$author$project$Api$Endpoint$stringFromBool(!params.iQ)),
								_Utils_Tuple2('q', params.bF),
								_Utils_Tuple2('cat', params.bD)
							]))))));
};
var $author$project$Api$Endpoint$modulesForDropdown = F2(
	function (config, params) {
		var reducedFieldsParam = _Utils_Tuple2('fields', 'id,title,team,accountable_teacher,teachers,students');
		var queryParams = A2(
			$elm$core$List$cons,
			reducedFieldsParam,
			$author$project$Api$Endpoint$makeModulesQueryParams(params));
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'modules']),
			queryParams);
	});
var $author$project$Module$fetchModulesForDropdown2 = F3(
	function (config, people, callback) {
		var listParams = _Utils_update(
			$author$project$Module$defaultListParams,
			{iQ: true, m6: people, ce: -1});
		return {
			b_: config,
			d_: $author$project$Module$moduleDropdownItemsDecoder,
			cf: callback,
			K: A2($author$project$Api$Endpoint$modulesForDropdown, config, listParams)
		};
	});
var $author$project$PortfolioStory$PortfolioStory = function (id) {
	return function (type_) {
		return function (description) {
			return function (media) {
				return function (module_) {
					return function (isLocked) {
						return function (createdBy) {
							return function (createdAt) {
								return function (team) {
									return function (students) {
										return function (badges) {
											return function (classroomSubmission) {
												return {eT: badges, iI: classroomSubmission, g4: createdAt, lf: createdBy, g8: description, i8: id, l9: isLocked, mw: media, hG: module_, fv: students, kf: team, ii: type_};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Badge$Badge = F6(
	function (id, description, isLocked, storyId, feedback, createdBy) {
		return {lf: createdBy, g8: description, hd: feedback, i8: id, l9: isLocked, h4: storyId};
	});
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Rubric$RubricAssessment = F3(
	function (rubricId, rubric, selected) {
		return {nt: rubric, nu: rubricId, D: selected};
	});
var $author$project$Rubric$RubricContent = F2(
	function (levels, aspects) {
		return {kU: aspects, gc: levels};
	});
var $author$project$Rubric$Aspect = F3(
	function (title, levelDescriptions, subjectId) {
		return {mt: levelDescriptions, nW: subjectId, kj: title};
	});
var $author$project$Rubric$aspectDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'subjectId',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'levelDescriptions',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Rubric$Aspect))));
var $author$project$Rubric$Scale = F2(
	function (label, levels) {
		return {ea: label, gc: levels};
	});
var $author$project$Rubric$scaleDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'levels',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Rubric$Scale)));
var $author$project$Rubric$rubricContentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'aspects',
	$elm$json$Json$Decode$list($author$project$Rubric$aspectDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'scale',
		$author$project$Rubric$scaleDecoder,
		$elm$json$Json$Decode$succeed($author$project$Rubric$RubricContent)));
var $author$project$Rubric$rubricAssessmentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'selected',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rubric',
		$author$project$Rubric$rubricContentDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'rubricId',
			$elm$json$Json$Decode$int,
			0,
			$elm$json$Json$Decode$succeed($author$project$Rubric$RubricAssessment))));
var $author$project$Badge$badgeDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Badge$Badge,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'is_locked', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'story_id', $elm$json$Json$Decode$int),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'feedback', $author$project$Rubric$rubricAssessmentDecoder)),
	A2($elm$json$Json$Decode$field, 'created_by', $author$project$Person$nestedPersonDecoder));
var $author$project$ClassroomStudentSubmission$NestedClassroomStudentSubmission = F2(
	function (id, url) {
		return {i8: id, K: url};
	});
var $author$project$ClassroomStudentSubmission$embeddedClassroomStudentSubmissionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$ClassroomStudentSubmission$NestedClassroomStudentSubmission)));
var $author$project$Module$NestedModule = F3(
	function (id, title, accountableTeacher) {
		return {kI: accountableTeacher, i8: id, kj: title};
	});
var $author$project$Module$nestedModuleDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'accountable_teacher',
	$author$project$Person$nestedPersonDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$author$project$Module$moduleIdDecoder,
			$elm$json$Json$Decode$succeed($author$project$Module$NestedModule))));
var $author$project$PortfolioStory$ModuleClosure = 1;
var $author$project$PortfolioStory$Na = 0;
var $author$project$PortfolioStory$storyTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'na':
				return $elm$json$Json$Decode$succeed(0);
			case 'mclosure':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('don\'t know ' + (s + ' type'));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$PortfolioStory$portfolioStoryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'classroom_submission',
	$elm$json$Json$Decode$nullable($author$project$ClassroomStudentSubmission$embeddedClassroomStudentSubmissionDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'badges',
		$elm$json$Json$Decode$list($author$project$Badge$badgeDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'students',
			$author$project$Person$nestedPeopleDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'team',
				$author$project$Team$nestedTeamDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_at',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'created_by',
						$author$project$Person$nestedPersonDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'is_locked',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'module',
								$elm$json$Json$Decode$nullable($author$project$Module$nestedModuleDecoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'media',
									$elm$json$Json$Decode$list($author$project$PortfolioStory$storyMediaDecoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'description',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'type',
											$author$project$PortfolioStory$storyTypeDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$int,
												$elm$json$Json$Decode$succeed($author$project$PortfolioStory$PortfolioStory)))))))))))));
var $author$project$PortfolioStory$portfolioStoriesDecoder = $elm$json$Json$Decode$list($author$project$PortfolioStory$portfolioStoryDecoder);
var $author$project$Api$Endpoint$toPortfolioStoriesListQueryParams = function (listParams) {
	return A3(
		$author$project$Api$Endpoint$optionalList,
		$elm$core$String$fromInt,
		_Utils_Tuple2('classrooms', listParams.g2),
		A3(
			$author$project$Api$Endpoint$optionalList,
			$elm$core$String$fromInt,
			_Utils_Tuple2('teachers', listParams.fx),
			A3(
				$author$project$Api$Endpoint$optionalList,
				$elm$core$String$fromInt,
				_Utils_Tuple2('students', listParams.fv),
				A3(
					$author$project$Api$Endpoint$optionalList,
					$elm$core$String$fromInt,
					_Utils_Tuple2('modules', listParams.hH),
					A3(
						$author$project$Api$Endpoint$optional,
						$elm$core$String$fromInt,
						_Utils_Tuple2('end', listParams.hb),
						A3(
							$author$project$Api$Endpoint$optional,
							$elm$core$String$fromInt,
							_Utils_Tuple2('start', listParams.h2),
							A3(
								$author$project$Api$Endpoint$optional,
								$elm$core$String$fromInt,
								_Utils_Tuple2('last_seen', listParams.b0),
								_List_fromArray(
									[
										_Utils_Tuple2(
										'size',
										$elm$core$String$fromInt(listParams.ce)),
										_Utils_Tuple2('type', listParams.ii),
										_Utils_Tuple2('q', listParams.bF),
										_Utils_Tuple2('cat', listParams.bD)
									]))))))));
};
var $author$project$Api$Endpoint$portfolioStoriesList = F2(
	function (config, listParams) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'portfolio-stories']),
			$author$project$Api$Endpoint$toPortfolioStoriesListQueryParams(listParams));
	});
var $author$project$PortfolioStory$fetchStories2 = F3(
	function (config, params, callback) {
		return {
			b_: config,
			d_: $author$project$PortfolioStory$portfolioStoriesDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2($author$project$Api$Endpoint$portfolioStoriesList, config, params)
		};
	});
var $author$project$Api$Endpoint$peopleByRoles = F2(
	function (config, roles) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'people']),
			_List_fromArray(
				[
					_Utils_Tuple2('roles', roles)
				]));
	});
var $author$project$Api$Endpoint$peopleStudentsAndTeachers = function (config) {
	return A2($author$project$Api$Endpoint$peopleByRoles, config, 'teachers,module_teachers,students');
};
var $author$project$Person$phoneBookDecoder = $elm$json$Json$Decode$list($author$project$Person$personDecoder);
var $author$project$Person$fetchStudentsAndTeachers2 = F2(
	function (config, callback) {
		return {
			b_: config,
			d_: $author$project$Person$phoneBookDecoder,
			cf: callback,
			K: $author$project$Api$Endpoint$peopleStudentsAndTeachers(config)
		};
	});
var $author$project$Api$Endpoint$subjects = F2(
	function (config, category) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'subjects']),
			_List_fromArray(
				[
					_Utils_Tuple2('cat', category)
				]));
	});
var $author$project$Subject$subjectsDecoder = $elm$json$Json$Decode$list($author$project$Subject$subjectDecoder);
var $author$project$Subject$fetchSubjectsV2 = F3(
	function (config, category, callback) {
		return {
			b_: config,
			d_: $author$project$Subject$subjectsDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2($author$project$Api$Endpoint$subjects, config, category)
		};
	});
var $author$project$Api$Endpoint$classrooms = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'classrooms']),
		_List_Nil);
};
var $author$project$ClassroomCourse$ClassroomCourse = F3(
	function (id, title, url) {
		return {i8: id, kj: title, K: url};
	});
var $author$project$ClassroomCourse$classroomCourseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$ClassroomCourse$ClassroomCourse))));
var $author$project$ClassroomCourse$classroomsDecoder = $elm$json$Json$Decode$list($author$project$ClassroomCourse$classroomCourseDecoder);
var $author$project$ClassroomCourse$fetchUserClassrooms = F2(
	function (config, callback) {
		return {
			b_: config,
			d_: $author$project$ClassroomCourse$classroomsDecoder,
			cf: callback,
			K: $author$project$Api$Endpoint$classrooms(config)
		};
	});
var $author$project$Element$PortfolioList$init = F3(
	function (config, session, params) {
		var viewer = session.ok;
		var model = {
			b_: config,
			ad: A2($author$project$Element$PortfolioList$defaultFilter, viewer, params),
			e1: false,
			dj: $author$project$Element$PortfolioList$LoadingStories,
			bF: '',
			gB: session,
			cP: $elm$core$Dict$empty,
			bo: {g2: $elm$core$Maybe$Nothing, hH: $elm$core$Maybe$Nothing, m6: $elm$core$Maybe$Nothing},
			fu: _List_Nil,
			kb: $author$project$RemoteData$NotAsked
		};
		var listParams = $author$project$Element$PortfolioList$asListParams(model);
		var effects = $author$project$Element$PortfolioList$BatchEffect(
			_List_fromArray(
				[
					$author$project$Element$PortfolioList$Cmd(
					$author$project$Element$PortfolioList$FetchModuleDropdownList(
						A3(
							$author$project$Module$fetchModulesForDropdown2,
							config.gX,
							A2(
								$elm$core$List$cons,
								viewer.i8,
								A2(
									$elm$core$List$map,
									function ($) {
										return $.i8;
									},
									viewer.nL)),
							$author$project$Element$PortfolioList$ModuleListDownloaded))),
					$author$project$Element$PortfolioList$Cmd(
					$author$project$Element$PortfolioList$FetchPortfolioStoryList(
						A3($author$project$PortfolioStory$fetchStories2, config.gX, listParams, $author$project$Element$PortfolioList$PortfolioStoryListDownloaded))),
					$author$project$Element$PortfolioList$Cmd(
					$author$project$Element$PortfolioList$FetchStudentsAndTeachersList(
						A2($author$project$Person$fetchStudentsAndTeachers2, config.gX, $author$project$Element$PortfolioList$PeopleListDownloaded))),
					$author$project$Element$PortfolioList$Cmd(
					$author$project$Element$PortfolioList$FetchSubjectList(
						A3($author$project$Subject$fetchSubjectsV2, config.gX, '', $author$project$Element$PortfolioList$SubjectListDownloaded))),
					$author$project$ACL$canViewClassrooms(session.ok) ? $author$project$Element$PortfolioList$Cmd(
					$author$project$Element$PortfolioList$FetchClassroomCourseList(
						A2($author$project$ClassroomCourse$fetchUserClassrooms, config.gX, $author$project$Element$PortfolioList$ClassroomCourseListDownloaded))) : $author$project$Element$PortfolioList$NoEffect
				]));
		return _Utils_Tuple3(model, effects, $elm$core$Maybe$Nothing);
	});
var $author$project$Util$Delay$after = F2(
	function (time, msg) {
		var delay = time * 1000;
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always(msg),
			$elm$core$Process$sleep(delay));
	});
var $author$project$Element$PortfolioList$SingleElementEffect = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Element$PortfolioList$SingleElementMsg = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Element$PortfolioSingle$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioSingle$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioSingle$FetchPortfolioStory = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$PortfolioSingle$FetchSubjectList = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioSingle$NoEffect = {$: 0};
var $author$project$Element$PortfolioSingle$PortfolioStoryDownloaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioSingle$SubjectListDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Endpoint$portfolioStory = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'portfolio-stories',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$PortfolioStory$fetchOneStory = F3(
	function (config, id, callback) {
		return {
			b_: config,
			d_: $author$project$PortfolioStory$portfolioStoryDecoder,
			cf: callback,
			K: A2($author$project$Api$Endpoint$portfolioStory, config, id)
		};
	});
var $author$project$Element$PortfolioSingle$init = F3(
	function (config, session, params) {
		var model = {b_: config, eq: $elm$core$Maybe$Nothing, gB: session, bA: $author$project$RemoteData$NotAsked, kb: params.kb, oi: params.oi};
		var _v0 = params.oi;
		if (!_v0.$) {
			var storyId = _v0.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{bA: $author$project$RemoteData$Loading}),
				$author$project$Element$PortfolioSingle$BatchEffect(
					_List_fromArray(
						[
							$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$FetchPortfolioStory(
								A3($author$project$PortfolioStory$fetchOneStory, config.gX, storyId, $author$project$Element$PortfolioSingle$PortfolioStoryDownloaded))),
							$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$FetchSubjectList(
								A3($author$project$Subject$fetchSubjectsV2, config.gX, '', $author$project$Element$PortfolioSingle$SubjectListDownloaded)))
						])),
				$elm$core$Maybe$Nothing);
		} else {
			var story = _v0.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						bA: $author$project$RemoteData$Success(story)
					}),
				$author$project$Element$PortfolioSingle$NoEffect,
				$elm$core$Maybe$Nothing);
		}
	});
var $author$project$Api$resolveWithHeaders = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$author$project$Api$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($author$project$Api$Timeout);
			case 2:
				return $elm$core$Result$Err($author$project$Api$NetworkError);
			case 3:
				var metadata = response.a;
				var body = response.b;
				return $elm$core$Result$Err(
					A3($author$project$Api$BadStatus, metadata.ft, metadata, body));
			default:
				var metadata = response.a;
				return A2(
					$elm$core$Result$mapError,
					$author$project$Api$BadBody,
					toResult(metadata));
		}
	});
var $author$project$Api$expectHeaders = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$author$project$Api$resolveWithHeaders($elm$core$Result$Ok));
};
var $author$project$Api$deleteV2 = function (_v0) {
	var config = _v0.b_;
	var url = _v0.K;
	var toMsg = _v0.cf;
	return $author$project$Api$Endpoint$request(
		{
			T: $elm$http$Http$emptyBody,
			bd: $author$project$Api$expectHeaders(toMsg),
			ar: $author$project$Api$toHeaders(config),
			bj: 'DELETE',
			bp: $elm$core$Maybe$Nothing,
			bq: $elm$core$Maybe$Nothing,
			K: url
		});
};
var $author$project$Element$PortfolioSingle$BadgeDeleteEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioSingle$BadgeDeleteModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioSingle$BadgeDeleteMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioSingle$DocumentViewerEffect = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioSingle$DocumentViewerModel = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioSingle$DocumentViewerMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioSingle$FeedbackEffect = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$PortfolioSingle$FeedbackModel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$PortfolioSingle$FeedbackMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$PortfolioSingle$PopupEffect = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioSingle$PopupMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$PortfolioSingle$StoryDeleteEffect = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioSingle$StoryDeleteModel = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioSingle$StoryDeleteMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$BadgeDelete$NoEffect = 0;
var $author$project$Element$BadgeDelete$init = F3(
	function (config, session, badge) {
		return _Utils_Tuple3(
			{gZ: badge, b_: config, gB: session},
			0,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$BadgeDelete$perform = F2(
	function (_v0, _v1) {
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Element$BadgeDelete$Exit = {$: 1};
var $author$project$Element$BadgeDelete$Ok = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$BadgeDelete$update = F2(
	function (msg, model) {
		if (!msg.$) {
			return _Utils_Tuple3(
				model,
				0,
				$elm$core$Maybe$Just($author$project$Element$BadgeDelete$Exit));
		} else {
			var badge = msg.a;
			return _Utils_Tuple3(
				model,
				0,
				$elm$core$Maybe$Just(
					$author$project$Element$BadgeDelete$Ok(badge)));
		}
	});
var $author$project$Locale$Messages$BadgeDeleteHelp = {$: 20};
var $author$project$Locale$Messages$BadgeHeadingDelete = {$: 19};
var $author$project$Element$BadgeDelete$Confirmed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$BadgeDelete$Declined = {$: 0};
var $author$project$UI$confirmDialog = A2($author$project$UI$confirmDialog_, true, true);
var $author$project$Element$BadgeDelete$view = function (_v0) {
	var session = _v0.gB;
	var badge = _v0.gZ;
	return A4(
		$author$project$UI$confirmDialog,
		session.h6,
		{
			lc: $author$project$Element$BadgeDelete$Confirmed(badge),
			lm: $author$project$Element$BadgeDelete$Declined
		},
		_List_fromArray(
			[
				A2($author$project$UI$caption, session.h6, $author$project$Locale$Messages$BadgeHeadingDelete)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$UI$caption, session.h6, $author$project$Locale$Messages$BadgeDeleteHelp)
					]))
			]));
};
var $author$project$Element$BadgeDelete$element = {jb: $author$project$Element$BadgeDelete$init, hP: $author$project$Element$BadgeDelete$perform, ks: $author$project$Element$BadgeDelete$update, og: $author$project$Element$BadgeDelete$view};
var $author$project$Element$DocumentViewer$NoEffect = 0;
var $author$project$Element$DocumentViewer$init = F3(
	function (config, session, params) {
		var model = {b_: config, fa: params.fa, gB: session, K: params.K};
		return _Utils_Tuple3(model, 0, $elm$core$Maybe$Nothing);
	});
var $author$project$Element$DocumentViewer$perform = F2(
	function (_v0, _v1) {
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Element$DocumentViewer$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, 0, $elm$core$Maybe$Nothing);
	});
var $author$project$Util$Media$ExternalViewer = 3;
var $author$project$Util$Media$ImageViewer = 0;
var $author$project$Util$Media$PdfViewer = 2;
var $author$project$Util$Media$VideoViewer = 1;
var $author$project$Util$Media$mediaViewerByExt = function (filename) {
	var _v0 = $elm$core$List$head(
		$elm$core$List$reverse(
			A2($elm$core$String$split, '.', filename)));
	_v0$5:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'jpg':
					return 0;
				case 'png':
					return 0;
				case 'mp4':
					return 1;
				case 'mov':
					return 1;
				case 'pdf':
					return 2;
				default:
					break _v0$5;
			}
		} else {
			break _v0$5;
		}
	}
	return 3;
};
var $author$project$Element$DocumentViewer$Closed = 0;
var $author$project$UI$modalCloseButton = function (toMsg) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'aria-label', 'close'),
				$elm$html$Html$Attributes$class('modal-close is-large'),
				$elm$html$Html$Events$onClick(toMsg)
			]),
		_List_Nil);
};
var $author$project$UI$modalWindow = F3(
	function (stretchContent, toCloseMsg, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal is-active')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-background')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-content'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('is-fullwidth is-fullheight', stretchContent)
								]))
						]),
					_List_fromArray(
						[content])),
					$author$project$UI$modalCloseButton(toCloseMsg)
				]));
	});
var $author$project$Element$DocumentViewer$viewImage = function (url) {
	return A3(
		$author$project$UI$modalWindow,
		false,
		0,
		A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('image'),
					$author$project$UI$attrCyData('documentviewer-image')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(url)
						]),
					_List_Nil)
				])));
};
var $elm$html$Html$iframe = _VirtualDom_node('iframe');
var $author$project$Element$DocumentViewer$viewPdf = function (url) {
	return A3(
		$author$project$UI$modalWindow,
		true,
		0,
		A2(
			$elm$html$Html$iframe,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth is-fullheight'),
					$author$project$UI$attrCyData('documentviewer-pdf'),
					$elm$html$Html$Attributes$src(url)
				]),
			_List_Nil));
};
var $elm$html$Html$Attributes$controls = $elm$html$Html$Attributes$boolProperty('controls');
var $elm$html$Html$video = _VirtualDom_node('video');
var $author$project$Element$DocumentViewer$viewVideo = function (url) {
	return A3(
		$author$project$UI$modalWindow,
		true,
		0,
		A2(
			$elm$html$Html$video,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src(url),
					$elm$html$Html$Attributes$controls(true),
					$author$project$UI$attrCyData('documentviewer-video')
				]),
			_List_Nil));
};
var $author$project$Element$DocumentViewer$view = function (_v0) {
	var url = _v0.K;
	var mime = _v0.fa;
	var _v1 = _Utils_Tuple2(
		mime,
		$author$project$Util$Media$mediaViewerByExt(url));
	_v1$6:
	while (true) {
		if (!_v1.a.$) {
			switch (_v1.a.a) {
				case 'application/pdf':
					return $author$project$Element$DocumentViewer$viewPdf(url);
				case 'image/png':
					return $author$project$Element$DocumentViewer$viewImage(url);
				case 'image/jpeg':
					return $author$project$Element$DocumentViewer$viewImage(url);
				default:
					break _v1$6;
			}
		} else {
			switch (_v1.b) {
				case 0:
					var _v2 = _v1.a;
					var _v3 = _v1.b;
					return $author$project$Element$DocumentViewer$viewImage(url);
				case 1:
					var _v4 = _v1.a;
					var _v5 = _v1.b;
					return $author$project$Element$DocumentViewer$viewVideo(url);
				case 2:
					var _v6 = _v1.a;
					var _v7 = _v1.b;
					return $author$project$Element$DocumentViewer$viewPdf(url);
				default:
					break _v1$6;
			}
		}
	}
	return $author$project$UI$none;
};
var $author$project$Element$DocumentViewer$element = {jb: $author$project$Element$DocumentViewer$init, hP: $author$project$Element$DocumentViewer$perform, ks: $author$project$Element$DocumentViewer$update, og: $author$project$Element$DocumentViewer$view};
var $author$project$Element$PortfolioStoryDelete$NoEffect = 0;
var $author$project$Element$PortfolioStoryDelete$init = F3(
	function (config, session, story) {
		return _Utils_Tuple3(
			{b_: config, gB: session, bA: story},
			0,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$PortfolioStoryDelete$perform = F2(
	function (_v0, _v1) {
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Element$PortfolioStoryDelete$Ok = $elm$core$Basics$identity;
var $author$project$Element$PortfolioStoryDelete$update = F2(
	function (msg, model) {
		if (!msg.$) {
			return _Utils_Tuple3(model, 0, $elm$core$Maybe$Nothing);
		} else {
			var story = msg.a;
			return _Utils_Tuple3(
				model,
				0,
				$elm$core$Maybe$Just(story));
		}
	});
var $author$project$Element$PortfolioStoryDelete$Confirmed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioStoryDelete$Declined = {$: 0};
var $author$project$Locale$Messages$PortfoliosDeleteHelp = {$: 380};
var $author$project$Locale$Messages$PortfoliosHeadingDelete = {$: 378};
var $author$project$Element$PortfolioStoryDelete$view = function (_v0) {
	var session = _v0.gB;
	var story = _v0.bA;
	return A4(
		$author$project$UI$confirmDialog,
		session.h6,
		{
			lc: $author$project$Element$PortfolioStoryDelete$Confirmed(story),
			lm: $author$project$Element$PortfolioStoryDelete$Declined
		},
		_List_fromArray(
			[
				A2($author$project$UI$caption, session.h6, $author$project$Locale$Messages$PortfoliosHeadingDelete)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$UI$caption, session.h6, $author$project$Locale$Messages$PortfoliosDeleteHelp)
					]))
			]));
};
var $author$project$Element$PortfolioStoryDelete$element = {jb: $author$project$Element$PortfolioStoryDelete$init, hP: $author$project$Element$PortfolioStoryDelete$perform, ks: $author$project$Element$PortfolioStoryDelete$update, og: $author$project$Element$PortfolioStoryDelete$view};
var $author$project$Element$StoryRubricAssessment$Cmd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StoryRubricAssessment$FetchModule = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StoryRubricAssessment$FetchRubrics = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$StoryRubricAssessment$ModuleDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StoryRubricAssessment$RubricsDownloaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Rubric$defaultListParams = {bD: '', bF: '', fv: $elm$core$Maybe$Nothing, ke: $elm$core$Maybe$Nothing};
var $author$project$Module$ModuleDetailed = function (id) {
	return function (title) {
		return function (description) {
			return function (goalsKnowledge) {
				return function (goalsSkills) {
					return function (goalsProduct) {
						return function (evaluation) {
							return function (materialsUrl) {
								return function (startDate) {
									return function (endDate) {
										return function (isActive) {
											return function (isLocked) {
												return function (isTemplate) {
													return function (team) {
														return function (classroomCourses) {
															return function (accountableTeacher) {
																return function (teachers) {
																	return function (students) {
																		return function (rubrics) {
																			return function (migrationReadyAt) {
																				return {kI: accountableTeacher, Y: classroomCourses, g8: description, ly: endDate, hc: evaluation, lO: goalsKnowledge, lP: goalsProduct, lQ: goalsSkills, i8: id, l0: isActive, l9: isLocked, mf: isTemplate, jq: materialsUrl, jr: migrationReadyAt, fq: rubrics, nN: startDate, fv: students, fx: teachers, kf: team, kj: title};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$ClassroomCourse$NestedClassroomCourse = F3(
	function (id, title, url) {
		return {i8: id, kj: title, K: url};
	});
var $author$project$ClassroomCourse$embeddedClassroomCourseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$ClassroomCourse$NestedClassroomCourse))));
var $author$project$Util$Json$fromResult = function (result) {
	if (!result.$) {
		var successValue = result.a;
		return $elm$json$Json$Decode$succeed(successValue);
	} else {
		var errorMessage = result.a;
		return $elm$json$Json$Decode$fail(errorMessage);
	}
};
var $author$project$Util$Json$doubleEncoded = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$author$project$Util$Json$fromResult,
				$elm$core$Result$mapError($elm$json$Json$Decode$errorToString)),
			$elm$json$Json$Decode$decodeString(decoder)),
		$elm$json$Json$Decode$string);
};
var $author$project$Rubric$WithBps = 1;
var $author$project$Rubric$WithNobody = 0;
var $author$project$Rubric$sharingDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'nobody':
				return $elm$json$Json$Decode$succeed(0);
			case 'bps':
				return $elm$json$Json$Decode$succeed(1);
			default:
				var somethingElse = str;
				return $elm$json$Json$Decode$fail('Unknown sharing option: ' + somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Rubric$rubricDecoder = function () {
	var toRubric = F6(
		function (id, title, author, sharedWith, _v0, lastUpdated) {
			var levels = _v0.gc;
			var aspects = _v0.kU;
			return {kU: aspects, k_: author, i8: id, mp: lastUpdated, gc: levels, nE: sharedWith, kj: title};
		});
	return A7(
		$elm$json$Json$Decode$map6,
		toRubric,
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'author', $author$project$Person$nestedPersonDecoder),
		A2($elm$json$Json$Decode$field, 'shared_with', $author$project$Rubric$sharingDecoder),
		A2(
			$elm$json$Json$Decode$field,
			'content',
			$author$project$Util$Json$doubleEncoded($author$project$Rubric$rubricContentDecoder)),
		A2($elm$json$Json$Decode$field, 'last_updated', $elm$json$Json$Decode$int));
}();
var $author$project$Module$moduleDetailedDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'migration_ready_at',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'rubrics',
		$elm$json$Json$Decode$list($author$project$Rubric$rubricDecoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'students',
			$author$project$Person$nestedPeopleDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'teachers',
				$author$project$Person$nestedPeopleDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'accountable_teacher',
					$author$project$Person$nestedPersonDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'classroom_courses',
						$elm$json$Json$Decode$list($author$project$ClassroomCourse$embeddedClassroomCourseDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'team',
							$author$project$Team$nestedTeamDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'is_template',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'is_locked',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'is_active',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'end_date',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'start_date',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'materials_url',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'evaluation',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'goals_product',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'goals_skills',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'goals_knowledge',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'description',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'title',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'id',
																				$author$project$Module$moduleIdDecoder,
																				$elm$json$Json$Decode$succeed($author$project$Module$ModuleDetailed)))))))))))))))))))));
var $author$project$Api$Endpoint$module_ = F2(
	function (config, id) {
		var queryParams = _List_fromArray(
			[
				_Utils_Tuple2(
				'include_inactive',
				$author$project$Api$Endpoint$stringFromBool(true)),
				_Utils_Tuple2(
				'include_locked',
				$author$project$Api$Endpoint$stringFromBool(true))
			]);
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'modules',
					$elm$core$String$fromInt(id)
				]),
			queryParams);
	});
var $author$project$Module$fetchModule = F3(
	function (config, _v0, callback) {
		var moduleId = _v0;
		return {
			b_: config,
			d_: $author$project$Module$moduleDetailedDecoder,
			cf: callback,
			K: A2($author$project$Api$Endpoint$module_, config, moduleId)
		};
	});
var $author$project$Api$Endpoint$toRubricsListQueryParams = function (listParams) {
	return A3(
		$author$project$Api$Endpoint$optionalList,
		$elm$core$String$fromInt,
		_Utils_Tuple2('students', listParams.fv),
		A3(
			$author$project$Api$Endpoint$optionalList,
			$elm$core$Basics$identity,
			_Utils_Tuple2('tags', listParams.ke),
			_List_fromArray(
				[
					_Utils_Tuple2('q', listParams.bF),
					_Utils_Tuple2('cat', listParams.bD)
				])));
};
var $author$project$Api$Endpoint$rubrics = F2(
	function (config, listParams) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'rubrics']),
			$author$project$Api$Endpoint$toRubricsListQueryParams(listParams));
	});
var $author$project$Rubric$fetchRubricsV2 = F3(
	function (config, params, callback) {
		return {
			b_: config,
			d_: $elm$json$Json$Decode$list($author$project$Rubric$rubricDecoder),
			cf: callback,
			K: A2($author$project$Api$Endpoint$rubrics, config, params)
		};
	});
var $author$project$Element$StoryRubricAssessment$init = F3(
	function (config, session, params) {
		var model = {b_: config, dw: $elm$core$Maybe$Nothing, gB: session, bA: params.bA, kb: params.kb};
		var effect = function () {
			var _v0 = params.bA.hG;
			if (_v0.$ === 1) {
				return $author$project$Element$StoryRubricAssessment$Cmd(
					$author$project$Element$StoryRubricAssessment$FetchRubrics(
						A3($author$project$Rubric$fetchRubricsV2, config.gX, $author$project$Rubric$defaultListParams, $author$project$Element$StoryRubricAssessment$RubricsDownloaded)));
			} else {
				var module_ = _v0.a;
				return $author$project$Element$StoryRubricAssessment$Cmd(
					$author$project$Element$StoryRubricAssessment$FetchModule(
						A3($author$project$Module$fetchModule, config.gX, module_.i8, $author$project$Element$StoryRubricAssessment$ModuleDownloaded)));
			}
		}();
		return _Utils_Tuple3(model, effect, $elm$core$Maybe$Nothing);
	});
var $author$project$Element$StoryRubricAssessment$RubricEditorEffect = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$StoryRubricAssessment$RubricEditorMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricAssessment$FormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricAssessment$NoEffect = {$: 0};
var $author$project$Element$RubricAssessment$RubricList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Locale$Messages$BadgeAppreciation = {$: 18};
var $author$project$Element$RubricAssessment$Description = $elm$core$Basics$identity;
var $author$project$Locale$Messages$FeedbackAppriciation = function (a) {
	return {$: 23, a: a};
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Locale$Messages$FormTooShortText = {$: 72};
var $author$project$Form$minLengthText = F3(
	function (t_, minLen, value) {
		return (_Utils_cmp(
			$elm$core$String$length(value),
			minLen) > -1) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormTooShortText));
	});
var $author$project$Form$requiredRubricTextFeedback = function (t_) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Form$requiredText(t_),
		$elm$core$Result$andThen(
			A2($author$project$Form$minLengthText, t_, 5)));
};
var $author$project$Element$RubricAssessment$buildForm = F3(
	function (t_, formMsg, children) {
		return {
			g8: {
				e0: false,
				fi: $author$project$Form$requiredRubricTextFeedback(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{g8: value});
					}),
				fC: function ($) {
					return $.g8;
				},
				og: {
					cm: 'badge-description',
					ea: t_(
						$author$project$Locale$Messages$FeedbackAppriciation(
							A2(
								$elm$core$List$map,
								$author$project$Person$fullName(t_),
								children))),
					fe: A2($elm$core$Basics$composeL, formMsg, $elm$core$Basics$identity),
					fj: t_($author$project$Locale$Messages$BadgeAppreciation)
				}
			}
		};
	});
var $author$project$Element$RubricAssessment$emptyForm = {g8: ''};
var $author$project$Element$RubricAssessment$AssessmentInProgress = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Element$RubricAssessment$LogOk = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricAssessment$NoOp = {$: 6};
var $author$project$Log$msgRubricSelect = 'rubric_select';
var $author$project$Rubric$chop = function (rubric) {
	return _Utils_update(
		rubric,
		{
			kU: A2(
				$elm$core$List$filter,
				function (aspect) {
					return aspect.kj !== '';
				},
				rubric.kU)
		});
};
var $author$project$Rubric$extractContent = function (rubric) {
	return {kU: rubric.kU, gc: rubric.gc};
};
var $author$project$Rubric$stencil = function (rubric) {
	var cleanedRubric = $author$project$Rubric$chop(
		$author$project$Rubric$extractContent(rubric));
	return {
		nt: cleanedRubric,
		nu: rubric.i8,
		D: A2(
			$elm$core$Array$initialize,
			$elm$core$List$length(cleanedRubric.kU),
			$elm$core$Basics$always($elm$core$Maybe$Nothing)),
		kj: rubric.kj
	};
};
var $author$project$Element$RubricAssessment$selectRubric = F2(
	function (rubric, model) {
		var logRequest = A3(
			$author$project$Log$okV2,
			model.b_,
			_Utils_Tuple2(
				$author$project$Log$msgRubricSelect,
				_List_fromArray(
					[
						$elm$core$String$fromInt(rubric.i8)
					])),
			$elm$core$Basics$always($author$project$Element$RubricAssessment$NoOp));
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{
					cj: A2(
						$author$project$Element$RubricAssessment$AssessmentInProgress,
						rubric,
						$author$project$Rubric$stencil(rubric)),
					ev: false
				}),
			$author$project$Element$RubricAssessment$LogOk(logRequest),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$RubricAssessment$init = F3(
	function (config, session, params) {
		var preselectedRubric = function () {
			var _v0 = params.fq;
			if (_v0.b && (!_v0.b.b)) {
				var rubric = _v0.a;
				return $elm$core$Maybe$Just(rubric);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var model = {
			cj: $author$project$Element$RubricAssessment$RubricList(params.fq),
			b_: config,
			bE: A3($author$project$Element$RubricAssessment$buildForm, session.h6, $author$project$Element$RubricAssessment$FormMsg, params.fv),
			e4: 0,
			jE: params.jE,
			ev: false,
			gB: session,
			kb: params.kb,
			eI: $author$project$Element$RubricAssessment$emptyForm
		};
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple3(model, $author$project$Element$RubricAssessment$NoEffect, $elm$core$Maybe$Nothing),
			A2(
				$elm$core$Maybe$map,
				function (rubric) {
					return A2($author$project$Element$RubricAssessment$selectRubric, rubric, model);
				},
				preselectedRubric));
	});
var $author$project$Element$RubricAssessment$perform = F2(
	function (_v0, effect) {
		if (!effect.$) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var request = effect.a;
			return $author$project$Api$postV2(request);
		}
	});
var $author$project$Element$RubricAssessment$BadgeGranted = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Element$RubricAssessment$Exit = {$: 0};
var $author$project$Log$msgRubricAssessmentSave = 'rubric_assessment_save';
var $author$project$Log$paramScopeRubricAssessment = 'scope_rubric_assessment';
var $author$project$Element$RubricAssessment$AssessmentReady = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Element$RubricAssessment$FilledRubric = function (a) {
	return {$: 2, a: a};
};
var $author$project$Rubric$ignored = -1;
var $author$project$Rubric$isAssessmentValid = function (assessment) {
	return !A2(
		$elm$core$List$all,
		$elm$core$Basics$eq($elm$core$Maybe$Nothing),
		$elm$core$Array$toList(assessment.D));
};
var $author$project$Rubric$dry = function (partial) {
	if ($author$project$Rubric$isAssessmentValid(partial)) {
		var filterSelected = function (levelSelection) {
			return A2(
				$elm$core$List$map,
				$elm$core$Maybe$withDefault($author$project$Rubric$ignored),
				$elm$core$Array$toList(levelSelection));
		};
		var assessment = partial.nt;
		return $elm$core$Maybe$Just(
			{
				nt: assessment,
				nu: partial.nu,
				D: filterSelected(partial.D)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Rubric$toggleLevelForAspect = F3(
	function (aspect, levelIndex, assessment) {
		var _v0 = A2($author$project$Util$List$elemIndex, aspect, assessment.nt.kU);
		if (_v0.$ === 1) {
			return assessment;
		} else {
			var aspectIndex = _v0.a;
			var selectLevelForAspect = _Utils_update(
				assessment,
				{
					D: A3(
						$elm$core$Array$set,
						aspectIndex,
						$elm$core$Maybe$Just(levelIndex),
						assessment.D)
				});
			var deselectLevelForAspect = _Utils_update(
				assessment,
				{
					D: A3($elm$core$Array$set, aspectIndex, $elm$core$Maybe$Nothing, assessment.D)
				});
			var aspectLevel = A2($elm$core$Array$get, aspectIndex, assessment.D);
			if (!aspectLevel.$) {
				if (!aspectLevel.a.$) {
					var levelIndex_ = aspectLevel.a.a;
					return _Utils_eq(levelIndex_, levelIndex) ? deselectLevelForAspect : selectLevelForAspect;
				} else {
					var _v2 = aspectLevel.a;
					return selectLevelForAspect;
				}
			} else {
				return assessment;
			}
		}
	});
var $author$project$Element$RubricAssessment$selectLevel = F5(
	function (aspect, levelIndex, rubric, assessment, model) {
		var assessment2 = A3($author$project$Rubric$toggleLevelForAspect, aspect, levelIndex, assessment);
		var model2 = _Utils_update(
			model,
			{
				cj: A2($author$project$Element$RubricAssessment$AssessmentInProgress, rubric, assessment2)
			});
		var _v0 = $author$project$Rubric$dry(assessment2);
		if (!_v0.$) {
			var finalAssessment = _v0.a;
			return _Utils_Tuple3(
				_Utils_update(
					model2,
					{
						cj: A3($author$project$Element$RubricAssessment$AssessmentReady, rubric, assessment2, finalAssessment)
					}),
				$author$project$Element$RubricAssessment$NoEffect,
				$elm$core$Maybe$Just(
					$author$project$Element$RubricAssessment$FilledRubric(finalAssessment)));
		} else {
			return _Utils_Tuple3(model2, $author$project$Element$RubricAssessment$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$RubricAssessment$update = F2(
	function (msg, model) {
		var noop = _Utils_Tuple3(model, $author$project$Element$RubricAssessment$NoEffect, $elm$core$Maybe$Nothing);
		switch (msg.$) {
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ev: !model.ev}),
					$author$project$Element$RubricAssessment$NoEffect,
					$elm$core$Maybe$Nothing);
			case 2:
				var fieldMsg = msg.a;
				var value = fieldMsg;
				var form = model.bE;
				var newModel = _Utils_update(
					model,
					{
						bE: _Utils_update(
							form,
							{
								g8: $author$project$Form$markEdited(model.bE.g8)
							}),
						e4: 1,
						eI: A2(form.g8.ks, value, model.eI)
					});
				return _Utils_Tuple3(newModel, $author$project$Element$RubricAssessment$NoEffect, $elm$core$Maybe$Nothing);
			case 3:
				return _Utils_Tuple3(
					model,
					$author$project$Element$RubricAssessment$NoEffect,
					$elm$core$Maybe$Just($author$project$Element$RubricAssessment$Exit));
			case 0:
				var rubric = msg.a;
				return A2($author$project$Element$RubricAssessment$selectRubric, rubric, model);
			case 5:
				var aspect = msg.a;
				var levelIndex = msg.b;
				var _v2 = model.cj;
				switch (_v2.$) {
					case 1:
						var rubric = _v2.a;
						var assessment = _v2.b;
						return A5($author$project$Element$RubricAssessment$selectLevel, aspect, levelIndex, rubric, assessment, model);
					case 2:
						var rubric = _v2.a;
						var assessment = _v2.b;
						return A5($author$project$Element$RubricAssessment$selectLevel, aspect, levelIndex, rubric, assessment, model);
					default:
						return noop;
				}
			case 4:
				var _v3 = model.cj;
				switch (_v3.$) {
					case 2:
						var rubric = _v3.a;
						var assessment = _v3.c;
						var updatedModel = _Utils_update(
							model,
							{e4: 2});
						var logRequest = A3(
							$author$project$Log$okV2,
							model.b_,
							_Utils_Tuple2(
								$author$project$Log$msgRubricAssessmentSave,
								_List_fromArray(
									[
										$author$project$Log$paramScopeRubricAssessment,
										$elm$core$String$fromInt(rubric.i8)
									])),
							$elm$core$Basics$always($author$project$Element$RubricAssessment$NoOp));
						return _Utils_Tuple3(
							updatedModel,
							$author$project$Element$RubricAssessment$LogOk(logRequest),
							$elm$core$Maybe$Just(
								A2($author$project$Element$RubricAssessment$BadgeGranted, updatedModel.eI.g8, assessment)));
					case 1:
						return noop;
					default:
						return noop;
				}
			default:
				return noop;
		}
	});
var $author$project$Locale$Messages$RubricAssessmentTitle = {$: 400};
var $author$project$Locale$Messages$RubricAssessmentSelected = function (a) {
	return {$: 399, a: a};
};
var $author$project$Element$RubricAssessment$Save = {$: 4};
var $author$project$Element$RubricAssessment$isBadgeFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.g8, values);
	});
var $author$project$Element$RubricAssessment$LevelSelected = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Subject$findSubject = F2(
	function (subjects, id) {
		return A2(
			$author$project$Util$List$find,
			function (s) {
				return _Utils_eq(
					$elm$core$Maybe$Just(s.i8),
					id);
			},
			subjects);
	});
var $author$project$Subject$findSubjectName = F2(
	function (subjects, id) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.fb;
			},
			A2($author$project$Subject$findSubject, subjects, id));
	});
var $author$project$Subject$findSubjectNameOrEmpty = F2(
	function (subjects, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($author$project$Subject$findSubjectName, subjects, id));
	});
var $author$project$Rubric$isSelected = F3(
	function (assessment, aspect, ix) {
		var _v0 = A2($author$project$Util$List$elemIndex, aspect, assessment.nt.kU);
		if (_v0.$ === 1) {
			return false;
		} else {
			var aspectIx = _v0.a;
			return _Utils_eq(
				A2($elm$core$Array$get, aspectIx, assessment.D),
				$elm$core$Maybe$Just(
					$elm$core$Maybe$Just(ix)));
		}
	});
var $author$project$Util$String$enclose = F3(
	function (left, right, t) {
		if (t === '') {
			return '';
		} else {
			return _Utils_ap(
				left,
				_Utils_ap(t, right));
		}
	});
var $author$project$Util$String$parenthesize = A2($author$project$Util$String$enclose, '(', ')');
var $author$project$Element$RubricAssessment$viewRubricFiller = F2(
	function (assessment, subjects) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table is-striped is-bordered is-narrow is-fullwidth')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2($elm$html$Html$th, _List_Nil, _List_Nil),
						A2(
							$elm$core$List$map,
							function (l) {
								return A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(l)
										]));
							},
							assessment.nt.gc.gc))),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (aspect) {
							return A2(
								$elm$html$Html$tr,
								_List_Nil,
								A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(aspect.kj),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												$elm$html$Html$text(
												$author$project$Util$String$parenthesize(
													A2($author$project$Subject$findSubjectNameOrEmpty, subjects, aspect.nW)))
											])),
									A2(
										$elm$core$List$indexedMap,
										F2(
											function (ix, desc) {
												return A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															$elm$html$Html$Events$onClick(
															A2($author$project$Element$RubricAssessment$LevelSelected, aspect, ix)),
															A3($author$project$Rubric$isSelected, assessment, aspect, ix) ? $elm$html$Html$Attributes$class('has-background-success') : $elm$html$Html$Attributes$class('has-text-weight-light')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('content is-small')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$p,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('is-small')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(desc)
																		]))
																]))
														]));
											}),
										A2(
											$elm$core$List$take,
											$elm$core$List$length(assessment.nt.gc.gc),
											aspect.mt))));
						},
						assessment.nt.kU))
				]));
	});
var $author$project$Element$RubricAssessment$viewAssessmentForm = F3(
	function (t_, model, assessment) {
		return A2(
			$elm$html$Html$fieldset,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$legend,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('label')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UI$caption,
							t_,
							$author$project$Locale$Messages$RubricAssessmentSelected(assessment.kj))
						])),
					A2($author$project$Element$RubricAssessment$viewRubricFiller, assessment, model.kb),
					(!model.jE) ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, model.bE.g8, model.eI),
							$author$project$UI$section(
							_List_fromArray(
								[
									A4(
									$author$project$UI$submitButton,
									t_($author$project$Locale$Messages$BtnSave),
									(!$author$project$Rubric$isAssessmentValid(assessment)) || (!A2($author$project$Element$RubricAssessment$isBadgeFormValid, model.bE, model.eI)),
									$author$project$Form$isProcessing(model.e4),
									$author$project$Element$RubricAssessment$Save)
								]))
						])) : $author$project$UI$none
				]));
	});
var $author$project$Locale$Messages$RubricAssessmentSelect = {$: 398};
var $author$project$Element$RubricAssessment$RubricSelected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricAssessment$ToggleRubricDropDown = {$: 1};
var $author$project$Element$RubricAssessment$viewRubricSelect = F3(
	function (t_, isDropDownOpen, rubrics) {
		return $author$project$UI$dropDownSelect(
			{
				lw: t_($author$project$Locale$Messages$FormNotSelected),
				lx: $author$project$Element$RubricAssessment$NoOp,
				l7: $elm$core$Basics$always(false),
				mb: isDropDownOpen,
				mh: function ($) {
					return $.kj;
				},
				mi: $author$project$Element$RubricAssessment$RubricSelected,
				mj: $author$project$Element$RubricAssessment$ToggleRubricDropDown,
				mk: rubrics,
				ea: t_($author$project$Locale$Messages$RubricAssessmentSelect),
				nA: $elm$core$Maybe$Nothing,
				nF: false
			});
	});
var $author$project$Element$RubricAssessment$viewContent = F2(
	function (_v0, model) {
		var t_ = _v0.h6;
		return $author$project$UI$panel(
			{
				g$: _List_fromArray(
					[
						function () {
						var _v1 = model.cj;
						switch (_v1.$) {
							case 2:
								var assessment = _v1.b;
								return A3($author$project$Element$RubricAssessment$viewAssessmentForm, t_, model, assessment);
							case 1:
								var assessment = _v1.b;
								return A3($author$project$Element$RubricAssessment$viewAssessmentForm, t_, model, assessment);
							default:
								var rubrics = _v1.a;
								return A3($author$project$Element$RubricAssessment$viewRubricSelect, t_, model.ev, rubrics);
						}
					}()
					]),
				cm: 'rubrics-feedback-form',
				hl: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricAssessmentTitle)
							]),
						_List_Nil)
					]),
				h7: _List_Nil,
				ie: 'is-light has-background-white'
			});
	});
var $author$project$Element$RubricAssessment$view = function (model) {
	var session = model.gB;
	return A2($author$project$Element$RubricAssessment$viewContent, session, model);
};
var $author$project$Element$RubricAssessment$element = {jb: $author$project$Element$RubricAssessment$init, hP: $author$project$Element$RubricAssessment$perform, ks: $author$project$Element$RubricAssessment$update, og: $author$project$Element$RubricAssessment$view};
var $author$project$Element$StoryRubricAssessment$rubricEditor = {
	ha: $author$project$Element$RubricAssessment$element,
	kk: $author$project$Element$StoryRubricAssessment$RubricEditorEffect,
	cf: $author$project$Element$StoryRubricAssessment$RubricEditorMsg,
	kt: F2(
		function (containerModel, model) {
			return _Utils_update(
				containerModel,
				{
					dw: $elm$core$Maybe$Just(model)
				});
		})
};
var $author$project$Element$StoryRubricAssessment$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var cmd = effect.a;
				switch (cmd.$) {
					case 2:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					case 0:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					default:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
				}
			default:
				var elementEffect = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, elementEffect, $author$project$Element$StoryRubricAssessment$rubricEditor);
		}
	});
var $author$project$Element$StoryRubricAssessment$Badge = function (a) {
	return {$: 1, a: a};
};
var $author$project$Badge$BadgeUnsaved = F3(
	function (description, storyId, feedback) {
		return {g8: description, hd: feedback, h4: storyId};
	});
var $author$project$Element$StoryRubricAssessment$Exit = {$: 0};
var $author$project$Element$StoryRubricAssessment$LogError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$ModulesDownloadError = {$: 234};
var $author$project$Element$StoryRubricAssessment$NoEffect = {$: 0};
var $author$project$Element$StoryRubricAssessment$NoOp = {$: 3};
var $author$project$Locale$Messages$RubricsDownloadError = {$: 411};
var $author$project$Log$msgModuleDownload = 'module_download';
var $author$project$Log$msgRubricsDownload = 'rubric_download';
var $author$project$Element$StoryRubricAssessment$openRubricEditor = F3(
	function (model, rubrics, students) {
		var session = model.gB;
		var subjects = model.kb;
		var params = {jE: false, fq: rubrics, fv: students, kb: subjects};
		var _v0 = A3(
			$author$project$Application$V3$Boundaries$mapElement,
			model,
			$author$project$Element$StoryRubricAssessment$rubricEditor,
			A4($author$project$Application$V3$Boundaries$initElement, model.b_, session, $author$project$Element$StoryRubricAssessment$rubricEditor, params));
		var model2 = _v0.a;
		var effect = _v0.b;
		return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
	});
var $author$project$Log$paramScopeStoryRubricAssessment = 'scope_story_rubric_assessment';
var $author$project$Element$StoryRubricAssessment$update = F2(
	function (msg, model) {
		var config = model.b_;
		var session = model.gB;
		var t_ = session.h6;
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var rubrics = msg.a.a;
					return A3($author$project$Element$StoryRubricAssessment$openRubricEditor, model, rubrics, model.bA.fv);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$RubricsDownloadError))
							}),
						$author$project$Element$StoryRubricAssessment$Cmd(
							$author$project$Element$StoryRubricAssessment$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgRubricsDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeStoryRubricAssessment),
										error),
									$elm$core$Basics$always($author$project$Element$StoryRubricAssessment$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 1:
				if (!msg.a.$) {
					var module_ = msg.a.a;
					return ($elm$core$List$length(module_.fq) > 0) ? A3($author$project$Element$StoryRubricAssessment$openRubricEditor, model, module_.fq, model.bA.fv) : _Utils_Tuple3(
						model,
						$author$project$Element$StoryRubricAssessment$Cmd(
							$author$project$Element$StoryRubricAssessment$FetchRubrics(
								A3($author$project$Rubric$fetchRubricsV2, model.b_.gX, $author$project$Rubric$defaultListParams, $author$project$Element$StoryRubricAssessment$RubricsDownloaded))),
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$ModulesDownloadError))
							}),
						$author$project$Element$StoryRubricAssessment$Cmd(
							$author$project$Element$StoryRubricAssessment$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgModuleDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeStoryRubricAssessment),
										error),
									$elm$core$Basics$always($author$project$Element$StoryRubricAssessment$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 2:
				var rubricEditorMsg = msg.a;
				var _v1 = model.dw;
				if (_v1.$ === 1) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3($author$project$Session$error, session, $author$project$Api$Timeout, 'wrong state 4938')
							}),
						$author$project$Element$StoryRubricAssessment$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var rubricEditorModel = _v1.a;
					var _v2 = A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						$author$project$Element$StoryRubricAssessment$rubricEditor,
						A4($author$project$Application$V3$Boundaries$updateElement, session, rubricEditorMsg, rubricEditorModel, $author$project$Element$StoryRubricAssessment$rubricEditor));
					var model2 = _v2.a;
					var effect = _v2.b;
					var reply = _v2.c;
					var noop = _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
					if (reply.$ === 1) {
						return noop;
					} else {
						var reply_ = reply.a;
						switch (reply_.$) {
							case 0:
								return _Utils_Tuple3(
									_Utils_update(
										model2,
										{dw: $elm$core$Maybe$Nothing}),
									effect,
									$elm$core$Maybe$Just($author$project$Element$StoryRubricAssessment$Exit));
							case 1:
								var appreciation = reply_.a;
								var rubricAssessment = reply_.b;
								return _Utils_Tuple3(
									_Utils_update(
										model2,
										{dw: $elm$core$Maybe$Nothing}),
									effect,
									$elm$core$Maybe$Just(
										$author$project$Element$StoryRubricAssessment$Badge(
											A3(
												$author$project$Badge$BadgeUnsaved,
												appreciation,
												model.bA.i8,
												$elm$core$Maybe$Just(rubricAssessment)))));
							default:
								return noop;
						}
					}
				}
			default:
				return _Utils_Tuple3(model, $author$project$Element$StoryRubricAssessment$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$RubricAssessment$PopupClosed = {$: 3};
var $author$project$Element$RubricAssessment$viewPopup = F2(
	function (session, model) {
		return A3(
			$author$project$UI$modalWindow,
			true,
			$author$project$Element$RubricAssessment$PopupClosed,
			$author$project$UI$section(
				_List_fromArray(
					[
						A2($author$project$Element$RubricAssessment$viewContent, session, model)
					])));
	});
var $author$project$Element$StoryRubricAssessment$view = function (model) {
	var session = model.gB;
	var _v0 = model.dw;
	if (_v0.$ === 1) {
		return $author$project$UI$none;
	} else {
		var model_ = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Element$StoryRubricAssessment$RubricEditorMsg,
			A2($author$project$Element$RubricAssessment$viewPopup, session, model_));
	}
};
var $author$project$Element$StoryRubricAssessment$element = {jb: $author$project$Element$StoryRubricAssessment$init, hP: $author$project$Element$StoryRubricAssessment$perform, ks: $author$project$Element$StoryRubricAssessment$update, og: $author$project$Element$StoryRubricAssessment$view};
var $author$project$Element$PortfolioSingle$popups = {
	cl: {
		ha: $author$project$Element$BadgeDelete$element,
		kk: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupEffect, $author$project$Element$PortfolioSingle$BadgeDeleteEffect),
		cf: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupMsg, $author$project$Element$PortfolioSingle$BadgeDeleteMsg),
		kt: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						eq: $elm$core$Maybe$Just(
							$author$project$Element$PortfolioSingle$BadgeDeleteModel(model))
					});
			})
	},
	d0: {
		ha: $author$project$Element$DocumentViewer$element,
		kk: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupEffect, $author$project$Element$PortfolioSingle$DocumentViewerEffect),
		cf: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupMsg, $author$project$Element$PortfolioSingle$DocumentViewerMsg),
		kt: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						eq: $elm$core$Maybe$Just(
							$author$project$Element$PortfolioSingle$DocumentViewerModel(model))
					});
			})
	},
	co: {
		ha: $author$project$Element$StoryRubricAssessment$element,
		kk: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupEffect, $author$project$Element$PortfolioSingle$FeedbackEffect),
		cf: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupMsg, $author$project$Element$PortfolioSingle$FeedbackMsg),
		kt: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						eq: $elm$core$Maybe$Just(
							$author$project$Element$PortfolioSingle$FeedbackModel(model))
					});
			})
	},
	cR: {
		ha: $author$project$Element$PortfolioStoryDelete$element,
		kk: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupEffect, $author$project$Element$PortfolioSingle$StoryDeleteEffect),
		cf: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupMsg, $author$project$Element$PortfolioSingle$StoryDeleteMsg),
		kt: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						eq: $elm$core$Maybe$Just(
							$author$project$Element$PortfolioSingle$StoryDeleteModel(model))
					});
			})
	}
};
var $author$project$Api$putV2 = function (_v0) {
	var config = _v0.b_;
	var url = _v0.K;
	var decoder = _v0.d_;
	var toMsg = _v0.cf;
	var body = _v0.T;
	return $author$project$Api$Endpoint$request(
		{
			T: $elm$http$Http$jsonBody(body),
			bd: A2($author$project$Api$expectJson, toMsg, decoder),
			ar: $author$project$Api$toHeaders(config.gX),
			bj: 'PUT',
			bp: $elm$core$Maybe$Nothing,
			bq: $elm$core$Maybe$Nothing,
			K: url
		});
};
var $author$project$Element$PortfolioSingle$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$PortfolioSingle$perform(key),
						effects));
			case 2:
				switch (effect.a.$) {
					case 0:
						var request = effect.a.a;
						return $author$project$Api$getV2(request);
					case 1:
						var request = effect.a.a;
						return $author$project$Api$putV2(request);
					case 2:
						var request = effect.a.a;
						return $author$project$Api$getV2(request);
					case 3:
						var request = effect.a.a;
						return $author$project$Api$postV2(request);
					case 4:
						var request = effect.a.a;
						return $author$project$Api$deleteV2(request);
					case 5:
						var request = effect.a.a;
						return $author$project$Api$deleteV2(request);
					default:
						var request = effect.a.a;
						return $author$project$Api$postV2(request);
				}
			default:
				switch (effect.a.$) {
					case 0:
						var popupEffect = effect.a.a;
						return A3($author$project$Application$V3$Boundaries$performElement, key, popupEffect, $author$project$Element$PortfolioSingle$popups.co);
					case 1:
						var popupEffect = effect.a.a;
						return A3($author$project$Application$V3$Boundaries$performElement, key, popupEffect, $author$project$Element$PortfolioSingle$popups.cl);
					case 2:
						var popupEffect = effect.a.a;
						return A3($author$project$Application$V3$Boundaries$performElement, key, popupEffect, $author$project$Element$PortfolioSingle$popups.cR);
					default:
						var popupEffect = effect.a.a;
						return A3($author$project$Application$V3$Boundaries$performElement, key, popupEffect, $author$project$Element$PortfolioSingle$popups.d0);
				}
		}
	});
var $author$project$Locale$Messages$BadgeCreated = function (a) {
	return {$: 24, a: a};
};
var $author$project$Locale$Messages$BadgeDeleteError = {$: 21};
var $author$project$Locale$Messages$BadgeDeleteSuccess = {$: 22};
var $author$project$Element$PortfolioSingle$Deleted = 0;
var $author$project$Element$PortfolioSingle$LogError = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$PortfolioSingle$NoOp = {$: 12};
var $author$project$Element$PortfolioSingle$PortfolioStorySaved = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$PortfoliosDeleteError = {$: 381};
var $author$project$Locale$Messages$PortfoliosDeleteSuccess = {$: 382};
var $author$project$Locale$Messages$PortfoliosDownloadError = {$: 357};
var $author$project$Locale$Messages$PortfoliosSaveSuccess = {$: 384};
var $author$project$Locale$Messages$SubjectListDownloadError = {$: 569};
var $author$project$Element$PortfolioSingle$UpdatePortfolioStory = function (a) {
	return {$: 1, a: a};
};
var $author$project$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 2:
				var value = data.a;
				return $author$project$RemoteData$Success(
					f(value));
			case 1:
				return $author$project$RemoteData$Loading;
			case 0:
				return $author$project$RemoteData$NotAsked;
			default:
				var error = data.a;
				return $author$project$RemoteData$Failure(error);
		}
	});
var $author$project$Log$msgBadgeDelete = 'badge_delete';
var $author$project$Log$msgBadgeSave = 'badge_save';
var $author$project$Log$msgPortfoliosDelete = 'portfolios_delete';
var $author$project$Log$msgPortfoliosDownload = 'portfolios_download';
var $author$project$Log$msgPortfoliosSave = 'portfolios_save';
var $author$project$Log$msgSubjectListDownload = 'subject_list_download';
var $author$project$Log$paramScopePortfolios = 'scope_portfolios';
var $author$project$RemoteData$toMaybe = function (data) {
	if (data.$ === 2) {
		var x = data.a;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$PortfolioStory$unfreeze = function (story) {
	return {
		lf: story.lf.i8,
		g8: story.g8,
		i8: story.i8,
		mw: A2(
			$elm$core$List$map,
			function ($) {
				return $.m$;
			},
			story.mw),
		hG: A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.i8;
			},
			story.hG),
		fv: A2(
			$elm$core$List$map,
			function ($) {
				return $.i8;
			},
			story.fv),
		ii: story.ii
	};
};
var $author$project$Element$PortfolioSingle$BadgeDeleted = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Element$PortfolioSingle$BadgeSaved = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$PortfolioSingle$CreateBadge = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioSingle$DeleteBadge = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$PortfolioSingle$DeletePortfolioStory = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$PortfolioSingle$PortfolioStoryDeleted = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$PortfolioSingle$closePopup = function (model) {
	return _Utils_update(
		model,
		{eq: $elm$core$Maybe$Nothing});
};
var $author$project$Rubric$encodeAspect = function (aspect) {
	var optionalSubjectId = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (id) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'subjectId',
						$elm$json$Json$Encode$int(id))
					]);
			},
			aspect.nW));
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$string(aspect.kj)),
					_Utils_Tuple2(
					'levelDescriptions',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, aspect.mt))
				]),
			optionalSubjectId));
};
var $author$project$Rubric$encodeScale = function (scale) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'label',
				$elm$json$Json$Encode$string(scale.ea)),
				_Utils_Tuple2(
				'levels',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, scale.gc))
			]));
};
var $author$project$Rubric$encodeRubricContent = function (rubric) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'scale',
				$author$project$Rubric$encodeScale(rubric.gc)),
				_Utils_Tuple2(
				'aspects',
				A2($elm$json$Json$Encode$list, $author$project$Rubric$encodeAspect, rubric.kU))
			]));
};
var $author$project$Rubric$rubricAssessmentEncoder = function (assessment) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'rubricId',
				$elm$json$Json$Encode$int(assessment.nu)),
				_Utils_Tuple2(
				'rubric',
				$author$project$Rubric$encodeRubricContent(assessment.nt)),
				_Utils_Tuple2(
				'selected',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, assessment.D))
			]));
};
var $author$project$Badge$badgeEncoder = function (badge) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(badge.g8)),
				_Utils_Tuple2(
				'story_id',
				$elm$json$Json$Encode$int(badge.h4)),
				_Utils_Tuple2(
				'feedback',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $author$project$Rubric$rubricAssessmentEncoder, badge.hd)))
			]));
};
var $author$project$Api$Endpoint$badges = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'badges']),
		_List_Nil);
};
var $author$project$Badge$createBadge = F3(
	function (config, badge, callback) {
		return {
			T: $author$project$Badge$badgeEncoder(badge),
			b_: config,
			d_: $author$project$Badge$badgeDecoder,
			cf: callback,
			K: $author$project$Api$Endpoint$badges(config.gX)
		};
	});
var $author$project$Api$Endpoint$badge = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'badges',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$Badge$deleteBadge = F3(
	function (config, badge, callback) {
		return {
			T: $elm$http$Http$emptyBody,
			b_: config,
			cf: callback,
			K: A2($author$project$Api$Endpoint$badge, config, badge.i8)
		};
	});
var $author$project$PortfolioStory$deleteStory = F3(
	function (config, story, callback) {
		return {
			T: $elm$http$Http$emptyBody,
			b_: config,
			cf: callback,
			K: A2($author$project$Api$Endpoint$portfolioStory, config, story.i8)
		};
	});
var $author$project$Element$PortfolioSingle$updatePopup = F3(
	function (popupMsg, popupModel, model) {
		var config = model.b_;
		var session = model.gB;
		var noop = _Utils_Tuple3(model, $author$project$Element$PortfolioSingle$NoEffect, $elm$core$Maybe$Nothing);
		var _v0 = _Utils_Tuple2(popupMsg, popupModel);
		_v0$4:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var feedbackMsg = _v0.a.a;
						var feedbackModel = _v0.b.a;
						var _v1 = A3(
							$author$project$Application$V3$Boundaries$mapElement,
							model,
							$author$project$Element$PortfolioSingle$popups.co,
							A4($author$project$Application$V3$Boundaries$updateElement, session, feedbackMsg, feedbackModel, $author$project$Element$PortfolioSingle$popups.co));
						var model2 = _v1.a;
						var effect = _v1.b;
						var reply = _v1.c;
						if (!reply.$) {
							if (!reply.a.$) {
								var _v3 = reply.a;
								return _Utils_Tuple3(
									$author$project$Element$PortfolioSingle$closePopup(model2),
									effect,
									$elm$core$Maybe$Nothing);
							} else {
								var newBadge = reply.a.a;
								return _Utils_Tuple3(
									$author$project$Element$PortfolioSingle$closePopup(model2),
									$author$project$Element$PortfolioSingle$BatchEffect(
										_List_fromArray(
											[
												effect,
												$author$project$Element$PortfolioSingle$Cmd(
												$author$project$Element$PortfolioSingle$CreateBadge(
													A3($author$project$Badge$createBadge, config, newBadge, $author$project$Element$PortfolioSingle$BadgeSaved)))
											])),
									$elm$core$Maybe$Nothing);
							}
						} else {
							return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$4;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var deleteMsg = _v0.a.a;
						var deleteModel = _v0.b.a;
						var _v4 = A3(
							$author$project$Application$V3$Boundaries$mapElement,
							model,
							$author$project$Element$PortfolioSingle$popups.cl,
							A4($author$project$Application$V3$Boundaries$updateElement, session, deleteMsg, deleteModel, $author$project$Element$PortfolioSingle$popups.cl));
						var model2 = _v4.a;
						var effect = _v4.b;
						var reply = _v4.c;
						if (!reply.$) {
							if (!reply.a.$) {
								var badge = reply.a.a;
								return _Utils_Tuple3(
									$author$project$Element$PortfolioSingle$closePopup(model),
									$author$project$Element$PortfolioSingle$Cmd(
										$author$project$Element$PortfolioSingle$DeleteBadge(
											A3(
												$author$project$Badge$deleteBadge,
												config.gX,
												badge,
												$author$project$Element$PortfolioSingle$BadgeDeleted(badge)))),
									$elm$core$Maybe$Nothing);
							} else {
								var _v6 = reply.a;
								return _Utils_Tuple3(
									$author$project$Element$PortfolioSingle$closePopup(model),
									$author$project$Element$PortfolioSingle$NoEffect,
									$elm$core$Maybe$Nothing);
							}
						} else {
							return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$4;
					}
				case 2:
					if (_v0.b.$ === 2) {
						var deleteMsg = _v0.a.a;
						var deleteModel = _v0.b.a;
						var _v7 = A3(
							$author$project$Application$V3$Boundaries$mapElement,
							model,
							$author$project$Element$PortfolioSingle$popups.cR,
							A4($author$project$Application$V3$Boundaries$updateElement, session, deleteMsg, deleteModel, $author$project$Element$PortfolioSingle$popups.cR));
						var model2 = _v7.a;
						var effect = _v7.b;
						var reply = _v7.c;
						if (!reply.$) {
							var story_ = reply.a;
							return _Utils_Tuple3(
								$author$project$Element$PortfolioSingle$closePopup(model2),
								$author$project$Element$PortfolioSingle$BatchEffect(
									_List_fromArray(
										[
											effect,
											$author$project$Element$PortfolioSingle$Cmd(
											$author$project$Element$PortfolioSingle$DeletePortfolioStory(
												A3($author$project$PortfolioStory$deleteStory, config.gX, story_, $author$project$Element$PortfolioSingle$PortfolioStoryDeleted)))
										])),
								$elm$core$Maybe$Nothing);
						} else {
							return _Utils_Tuple3(
								$author$project$Element$PortfolioSingle$closePopup(model2),
								effect,
								$elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$4;
					}
				default:
					if (_v0.b.$ === 3) {
						var documentViewerMsg = _v0.a.a;
						var documentViewerModel = _v0.b.a;
						var _v9 = A3(
							$author$project$Application$V3$Boundaries$mapElement,
							model,
							$author$project$Element$PortfolioSingle$popups.d0,
							A4($author$project$Application$V3$Boundaries$updateElement, session, documentViewerMsg, documentViewerModel, $author$project$Element$PortfolioSingle$popups.d0));
						var model2 = _v9.a;
						var effect = _v9.b;
						return _Utils_Tuple3(
							$author$project$Element$PortfolioSingle$closePopup(model2),
							effect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$4;
					}
			}
		}
		return noop;
	});
var $author$project$PortfolioStory$storyTypeEncoder = function (type_) {
	if (!type_) {
		return $elm$json$Json$Encode$string('na');
	} else {
		return $elm$json$Json$Encode$string('mclosure');
	}
};
var $author$project$PortfolioStory$portfolioStoryEncoder = function (story) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(story.i8)),
				_Utils_Tuple2(
				'type',
				$author$project$PortfolioStory$storyTypeEncoder(story.ii)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(story.g8)),
				_Utils_Tuple2(
				'media',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, story.mw)),
				_Utils_Tuple2(
				'module',
				A2(
					$author$project$Data$encodeNullable,
					A2($elm$core$Basics$composeR, $author$project$Module$moduleIdToInt, $elm$json$Json$Encode$int),
					story.hG)),
				_Utils_Tuple2(
				'created_by',
				$elm$json$Json$Encode$int(story.lf)),
				_Utils_Tuple2(
				'students',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, story.fv))
			]));
};
var $author$project$PortfolioStory$updateStory = F3(
	function (config, story, callback) {
		return {
			T: $author$project$PortfolioStory$portfolioStoryEncoder(story),
			b_: config,
			d_: $author$project$PortfolioStory$portfolioStoryDecoder,
			cf: callback,
			K: A2($author$project$Api$Endpoint$portfolioStory, config.gX, story.i8)
		};
	});
var $author$project$Element$PortfolioSingle$update = F2(
	function (msg, model) {
		var config = model.b_;
		var story = model.bA;
		var subjects = model.kb;
		var session = model.gB;
		var t_ = session.h6;
		var noop = _Utils_Tuple3(model, $author$project$Element$PortfolioSingle$NoEffect, $elm$core$Maybe$Nothing);
		switch (msg.$) {
			case 12:
				return noop;
			case 11:
				var _v1 = $author$project$RemoteData$toMaybe(story);
				if (!_v1.$) {
					var story_ = _v1.a;
					var unsavedStory = $author$project$PortfolioStory$unfreeze(
						_Utils_update(
							story_,
							{ii: 1}));
					return _Utils_Tuple3(
						model,
						$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$UpdatePortfolioStory(
								A3($author$project$PortfolioStory$updateStory, config, unsavedStory, $author$project$Element$PortfolioSingle$PortfolioStorySaved))),
						$elm$core$Maybe$Nothing);
				} else {
					return noop;
				}
			case 7:
				var _v2 = _Utils_Tuple2(
					$author$project$RemoteData$toMaybe(story),
					$author$project$RemoteData$toMaybe(subjects));
				if ((!_v2.a.$) && (!_v2.b.$)) {
					var story_ = _v2.a.a;
					var subjects_ = _v2.b.a;
					var _v3 = A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						$author$project$Element$PortfolioSingle$popups.co,
						A4(
							$author$project$Application$V3$Boundaries$initElement,
							model.b_,
							session,
							$author$project$Element$PortfolioSingle$popups.co,
							{bA: story_, kb: subjects_}));
					var model2 = _v3.a;
					var effect = _v3.b;
					return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
				} else {
					return noop;
				}
			case 8:
				var badge = msg.a;
				var _v4 = A3(
					$author$project$Application$V3$Boundaries$mapElement,
					model,
					$author$project$Element$PortfolioSingle$popups.cl,
					A4($author$project$Application$V3$Boundaries$initElement, model.b_, session, $author$project$Element$PortfolioSingle$popups.cl, badge));
				var model2 = _v4.a;
				var effect = _v4.b;
				return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
			case 6:
				var _v5 = $author$project$RemoteData$toMaybe(story);
				if (!_v5.$) {
					var story_ = _v5.a;
					var _v6 = A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						$author$project$Element$PortfolioSingle$popups.cR,
						A4($author$project$Application$V3$Boundaries$initElement, model.b_, session, $author$project$Element$PortfolioSingle$popups.cR, story_));
					var model2 = _v6.a;
					var effect = _v6.b;
					return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
				} else {
					return noop;
				}
			case 9:
				var url = msg.a;
				var _v7 = A3(
					$author$project$Application$V3$Boundaries$mapElement,
					model,
					$author$project$Element$PortfolioSingle$popups.d0,
					A4(
						$author$project$Application$V3$Boundaries$initElement,
						model.b_,
						session,
						$author$project$Element$PortfolioSingle$popups.d0,
						{fa: $elm$core$Maybe$Nothing, K: url}));
				var model2 = _v7.a;
				var effect = _v7.b;
				return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
			case 10:
				var popupMsg = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					noop,
					A2(
						$elm$core$Maybe$map,
						function (popupModel) {
							return A3($author$project$Element$PortfolioSingle$updatePopup, popupMsg, popupModel, model);
						},
						model.eq));
			case 0:
				if (!msg.a.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A2(
									$author$project$Session$ok,
									session,
									t_($author$project$Locale$Messages$PortfoliosDeleteSuccess))
							}),
						$author$project$Element$PortfolioSingle$NoEffect,
						$elm$core$Maybe$Just(0));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$PortfoliosDeleteError))
							}),
						$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgPortfoliosDelete, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$PortfolioSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 5:
				if (!msg.b.$) {
					var oldBadge = msg.a;
					var deleteBadge = F2(
						function (oldBadge_, story_) {
							return _Utils_update(
								story_,
								{
									eT: A2(
										$elm$core$List$filter,
										function (b) {
											return !_Utils_eq(b, oldBadge_);
										},
										story_.eT)
								});
						});
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A2(
									$author$project$Session$ok,
									session,
									t_($author$project$Locale$Messages$BadgeDeleteSuccess)),
								bA: A2(
									$author$project$RemoteData$map,
									deleteBadge(oldBadge),
									story)
							}),
						$author$project$Element$PortfolioSingle$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$BadgeDeleteError))
							}),
						$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgBadgeDelete, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$PortfolioSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 4:
				if (!msg.a.$) {
					var badge = msg.a.a;
					var _v8 = $author$project$RemoteData$toMaybe(story);
					if (!_v8.$) {
						var story_ = _v8.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									gB: A2(
										$author$project$Session$ok,
										session,
										t_(
											$author$project$Locale$Messages$BadgeCreated(
												A2(
													$elm$core$List$map,
													$author$project$Person$fullName(t_),
													story_.fv)))),
									bA: $author$project$RemoteData$Success(
										_Utils_update(
											story_,
											{
												eT: A2($elm$core$List$cons, badge, story_.eT)
											}))
								}),
							$author$project$Element$PortfolioSingle$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						return noop;
					}
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$FormSaveError))
							}),
						$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgBadgeSave, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$PortfolioSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 1:
				if (!msg.a.$) {
					var newStory = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A2(
									$author$project$Session$ok,
									session,
									t_($author$project$Locale$Messages$PortfoliosSaveSuccess)),
								bA: $author$project$RemoteData$Success(newStory)
							}),
						$author$project$Element$PortfolioSingle$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$FormSaveError))
							}),
						$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgPortfoliosSave,
										$elm$core$Maybe$Just($author$project$Log$paramScopePortfolios),
										error),
									$elm$core$Basics$always($author$project$Element$PortfolioSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 2:
				if (!msg.a.$) {
					var story_ = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bA: $author$project$RemoteData$Success(story_)
							}),
						$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$FetchSubjectList(
								A3($author$project$Subject$fetchSubjectsV2, config.gX, '', $author$project$Element$PortfolioSingle$SubjectListDownloaded))),
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$PortfoliosDownloadError)),
								bA: $author$project$RemoteData$Failure(error)
							}),
						$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgPortfoliosDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$PortfolioSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			default:
				switch (msg.a.$) {
					case 2:
						var subjects_ = msg.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									kb: $author$project$RemoteData$Success(subjects_)
								}),
							$author$project$Element$PortfolioSingle$NoEffect,
							$elm$core$Maybe$Nothing);
					case 3:
						var error = msg.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									gB: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$SubjectListDownloadError)),
									kb: $author$project$RemoteData$Failure(error)
								}),
							$author$project$Element$PortfolioSingle$Cmd(
								$author$project$Element$PortfolioSingle$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgSubjectListDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$PortfolioSingle$NoOp)))),
							$elm$core$Maybe$Nothing);
					default:
						return noop;
				}
		}
	});
var $author$project$Application$V3$Boundaries$viewElement = F3(
	function (session, model, element) {
		return A2(
			$elm$html$Html$map,
			element.cf,
			element.ha.og(
				_Utils_update(
					model,
					{gB: session})));
	});
var $author$project$Element$PortfolioSingle$viewPopup = F2(
	function (session, model) {
		switch (model.$) {
			case 0:
				var popupModel = model.a;
				return A3($author$project$Application$V3$Boundaries$viewElement, session, popupModel, $author$project$Element$PortfolioSingle$popups.co);
			case 1:
				var popupModel = model.a;
				return A3($author$project$Application$V3$Boundaries$viewElement, session, popupModel, $author$project$Element$PortfolioSingle$popups.cl);
			case 2:
				var popupModel = model.a;
				return A3($author$project$Application$V3$Boundaries$viewElement, session, popupModel, $author$project$Element$PortfolioSingle$popups.cR);
			default:
				var popupModel = model.a;
				return A3($author$project$Application$V3$Boundaries$viewElement, session, popupModel, $author$project$Element$PortfolioSingle$popups.d0);
		}
	});
var $author$project$Element$PortfolioSingle$OpenBadgeDeletePopup = function (a) {
	return {$: 8, a: a};
};
var $author$project$PortfolioStory$isEditable = function (story) {
	return !story.l9;
};
var $author$project$Person$isSamePerson = F2(
	function (person1, person2) {
		return _Utils_eq(person1.i8, person2.i8);
	});
var $author$project$ACL$canDeleteBadge = F2(
	function (badge, person) {
		return A2($author$project$Person$isSamePerson, badge.lf, person);
	});
var $author$project$UI$Icon$feedback = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-comment-dots'),
			attributes));
};
var $author$project$UI$mediaObjectXS = F4(
	function (media, content, navigation, right) {
		return A5($author$project$UI$mediaObject_, 'is-16x16', media, content, navigation, right);
	});
var $author$project$Util$List$filterMap2 = F4(
	function (filter, mapper, xs, ys) {
		var mapTuple = function (_v1) {
			var first = _v1.a;
			var second = _v1.b;
			return A2(mapper, first, second);
		};
		var filterTuple = function (_v0) {
			var first = _v0.a;
			var second = _v0.b;
			return A2(filter, first, second);
		};
		return A2(
			$elm$core$List$map,
			mapTuple,
			A2(
				$elm$core$List$filter,
				filterTuple,
				A3($elm$core$List$map2, $elm$core$Tuple$pair, xs, ys)));
	});
var $author$project$UI$RubricAssessment$viewDescriptionCell = F3(
	function (selectedLevel, level, desc) {
		return A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'has-background-success',
							_Utils_eq(level, selectedLevel)),
							_Utils_Tuple2(
							'has-text-weight-light',
							!_Utils_eq(level, selectedLevel))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-small')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							($elm$core$String$isEmpty(desc) && _Utils_eq(level, selectedLevel)) ? '✓' : desc)
						]))
				]));
	});
var $author$project$UI$RubricAssessment$viewLevelRow = F4(
	function (assessment, aspect, selectedLevel, subjects) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(aspect.kj),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text(
							$author$project$Util$String$parenthesize(
								A2($author$project$Subject$findSubjectNameOrEmpty, subjects, aspect.nW)))
						])),
				A2(
					$elm$core$List$indexedMap,
					$author$project$UI$RubricAssessment$viewDescriptionCell(selectedLevel),
					A2(
						$elm$core$List$take,
						$elm$core$List$length(assessment.nt.gc.gc),
						aspect.mt))));
	});
var $author$project$UI$RubricAssessment$view = F2(
	function (subjects, assessment) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table is-striped is-bordered is-narrow is-size-7')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2($elm$html$Html$th, _List_Nil, _List_Nil),
						A2(
							$elm$core$List$map,
							function (l) {
								return A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(l)
										]));
							},
							assessment.nt.gc.gc))),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A4(
						$author$project$Util$List$filterMap2,
						function (_v0) {
							return function (level) {
								return !_Utils_eq(level, $author$project$Rubric$ignored);
							};
						},
						function (aspect) {
							return function (level) {
								return A4($author$project$UI$RubricAssessment$viewLevelRow, assessment, aspect, level, subjects);
							};
						},
						assessment.nt.kU,
						assessment.D))
				]));
	});
var $author$project$UI$Icon$delete = function (attributes) {
	return $author$project$UI$Icon$icon(
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$UI$Icon$face('fa-trash-alt'),
					$author$project$UI$Icon$style('has-text-danger')
				]),
			attributes));
};
var $author$project$Element$PortfolioSingle$viewLoBadgeDeleteLink = F2(
	function (badge, toMsg) {
		return A2(
			$elm$html$Html$small,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$UI$actionLink,
					toMsg(badge),
					_List_Nil,
					_List_fromArray(
						[
							$author$project$UI$Icon$delete(
							_List_fromArray(
								[
									$author$project$UI$Icon$style('is-small')
								]))
						]))
				]));
	});
var $author$project$Element$PortfolioSingle$viewFeedbackBadge = F5(
	function (badge, feedback, subjects, showBadgeDescription, toDeleteMsg) {
		var viewFeedbackBadgeIcon = A2(
			$author$project$UI$when,
			showBadgeDescription(badge),
			$author$project$UI$Icon$feedback(_List_Nil));
		var viewFeedbackBadgeDescription = A2(
			$author$project$UI$when,
			showBadgeDescription(badge),
			A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(badge.g8)
					])));
		return A4(
			$author$project$UI$mediaObjectXS,
			_List_fromArray(
				[viewFeedbackBadgeIcon]),
			_List_fromArray(
				[
					viewFeedbackBadgeDescription,
					A2($author$project$UI$RubricAssessment$view, subjects, feedback)
				]),
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$UI$nav,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$maybe,
							toDeleteMsg,
							$author$project$Element$PortfolioSingle$viewLoBadgeDeleteLink(badge))
						]))
				]));
	});
var $author$project$Element$PortfolioSingle$viewBadges = F6(
	function (_v0, subjects, showBadgeDescription, viewer, toDeleteMsg, badges) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('badges block')
				]),
			A2(
				$elm$core$List$map,
				function (badge) {
					var canDelete = A2($author$project$ACL$canDeleteBadge, badge, viewer) && (!badge.l9);
					var _v1 = _Utils_Tuple2(badge.hd, canDelete);
					if (!_v1.a.$) {
						if (_v1.b) {
							var feedback = _v1.a.a;
							return A5($author$project$Element$PortfolioSingle$viewFeedbackBadge, badge, feedback, subjects, showBadgeDescription, toDeleteMsg);
						} else {
							var feedback = _v1.a.a;
							return A5($author$project$Element$PortfolioSingle$viewFeedbackBadge, badge, feedback, subjects, showBadgeDescription, $elm$core$Maybe$Nothing);
						}
					} else {
						return $author$project$UI$none;
					}
				},
				badges));
	});
var $author$project$Locale$Messages$PortfoliosStudentsParticipants = function (a) {
	return {$: 389, a: a};
};
var $author$project$PortfolioStory$isNotModuleClosure = function (story) {
	return story.ii !== 1;
};
var $author$project$Util$Html$markdownOptions = {
	ln: $elm$core$Maybe$Nothing,
	lN: $elm$core$Maybe$Just(
		{k4: true, n$: false}),
	nv: true,
	nI: false
};
var $elm_explorations$markdown$Markdown$toHtmlWith = _Markdown_toHtml;
var $author$project$Util$Html$markdownToHtml = function (content) {
	return A3(
		$elm_explorations$markdown$Markdown$toHtmlWith,
		$author$project$Util$Html$markdownOptions,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('content')
			]),
		content);
};
var $author$project$Element$PortfolioSingle$OpenDocumentViewer = function (a) {
	return {$: 9, a: a};
};
var $author$project$UI$Icon$file = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-file-alt'),
			attributes));
};
var $author$project$PortfolioStory$hasPreview = function (media) {
	return !_Utils_eq(media.hQ, $elm$core$Maybe$Nothing);
};
var $author$project$PortfolioStory$mediaLarge = function (media) {
	return A2($elm$core$Maybe$withDefault, media.m$, media.jn);
};
var $author$project$PortfolioStory$mediaPreview = function (media) {
	return A2($elm$core$Maybe$withDefault, media.m$, media.hQ);
};
var $author$project$Element$PortfolioSingle$viewStoryMediaItem = function (media) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('level-item')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$figure,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('image thumb')
					]),
				_List_fromArray(
					[
						function () {
						var _v0 = _Utils_Tuple2(
							$author$project$Util$Media$mediaViewerByExt(media.m$),
							$author$project$PortfolioStory$hasPreview(media));
						switch (_v0.a) {
							case 2:
								if (_v0.b) {
									var _v1 = _v0.a;
									return A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(media.m$),
												$elm$html$Html$Attributes$target('_blank'),
												$elm$html$Html$Attributes$class('media-overlay')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src(
														$author$project$PortfolioStory$mediaPreview(media))
													]),
												_List_Nil),
												$author$project$UI$Icon$filePdf(
												_List_fromArray(
													[
														$author$project$UI$Icon$face('fa-3x'),
														$author$project$UI$Icon$style('has-text-primary is-large')
													]))
											]));
								} else {
									var _v2 = _v0.a;
									return A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(media.m$),
												$elm$html$Html$Attributes$target('_blank')
											]),
										_List_fromArray(
											[
												$author$project$UI$Icon$filePdf(
												_List_fromArray(
													[
														$author$project$UI$Icon$face('fa-3x'),
														$author$project$UI$Icon$style('has-text-primary is-large')
													]))
											]));
								}
							case 3:
								var _v3 = _v0.a;
								return A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(media.m$),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$author$project$UI$Icon$file(
											_List_fromArray(
												[
													$author$project$UI$Icon$face('fa-3x'),
													$author$project$UI$Icon$style('has-text-info is-large')
												]))
										]));
							case 0:
								if (_v0.b) {
									var _v4 = _v0.a;
									return A3(
										$author$project$UI$actionLink,
										$author$project$Element$PortfolioSingle$OpenDocumentViewer(
											$author$project$PortfolioStory$mediaLarge(media)),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												$author$project$PortfolioStory$mediaLarge(media))
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src(
														$author$project$PortfolioStory$mediaPreview(media))
													]),
												_List_Nil)
											]));
								} else {
									var _v5 = _v0.a;
									return A3(
										$author$project$UI$actionLink,
										$author$project$Element$PortfolioSingle$OpenDocumentViewer(
											$author$project$PortfolioStory$mediaLarge(media)),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												$author$project$PortfolioStory$mediaLarge(media))
											]),
										_List_fromArray(
											[
												$author$project$UI$Icon$icon(
												_List_fromArray(
													[
														$author$project$UI$Icon$face('fa-file-image fa-3x'),
														$author$project$UI$Icon$style('has-text-primary is-large')
													]))
											]));
								}
							default:
								if (_v0.b) {
									var _v6 = _v0.a;
									return A3(
										$author$project$UI$actionLink,
										$author$project$Element$PortfolioSingle$OpenDocumentViewer(media.m$),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(media.m$),
												$elm$html$Html$Attributes$class('media-overlay')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src(
														$author$project$PortfolioStory$mediaPreview(media))
													]),
												_List_Nil),
												$author$project$UI$Icon$icon(
												_List_fromArray(
													[
														$author$project$UI$Icon$face('fa-play-circle fa-3x'),
														$author$project$UI$Icon$style('has-text-light is-large')
													]))
											]));
								} else {
									var _v7 = _v0.a;
									return A3(
										$author$project$UI$actionLink,
										$author$project$Element$PortfolioSingle$OpenDocumentViewer(media.m$),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(media.m$)
											]),
										_List_fromArray(
											[
												$author$project$UI$Icon$icon(
												_List_fromArray(
													[
														$author$project$UI$Icon$face('fa-file-video fa-3x'),
														$author$project$UI$Icon$style('has-text-info is-large')
													]))
											]));
								}
						}
					}()
					]))
			]));
};
var $author$project$Element$PortfolioSingle$viewStoryContent = F2(
	function (t_, story) {
		var participants = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Person$isSamePerson(story.lf),
				$elm$core$Basics$not),
			story.fv);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block mt-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							$author$project$Util$Html$markdownToHtml(story.g8)
						])),
					A2(
					$author$project$UI$when,
					!$elm$core$List$isEmpty(story.mw),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('block level')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('level-left')
									]),
								A2($elm$core$List$map, $author$project$Element$PortfolioSingle$viewStoryMediaItem, story.mw))
							]))),
					A2(
					$author$project$UI$when,
					$author$project$PortfolioStory$isNotModuleClosure(story) && (!$elm$core$List$isEmpty(participants)),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('block has-text-grey')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$UI$caption,
								t_,
								$author$project$Locale$Messages$PortfoliosStudentsParticipants(
									A2(
										$elm$core$List$map,
										$author$project$Person$fullName(t_),
										participants)))
							])))
				]));
	});
var $author$project$Locale$Messages$PortfoliosClosed = {$: 347};
var $author$project$Locale$Messages$PortfoliosClosedEdit = {$: 348};
var $author$project$Locale$Messages$PortfoliosModuleClosed = F3(
	function (a, b, c) {
		return {$: 388, a: a, b: b, c: c};
	});
var $author$project$Locale$Messages$PortfoliosStoryShared = function (a) {
	return {$: 387, a: a};
};
var $author$project$Locale$Messages$TimeDateTimeFormat = F2(
	function (a, b) {
		return {$: 602, a: a, b: b};
	});
var $author$project$Locale$Messages$TooltipModule = function (a) {
	return {$: 638, a: a};
};
var $author$project$PortfolioStory$isCreator = F2(
	function (person, story) {
		return A2($author$project$Person$isSamePerson, story.lf, person);
	});
var $author$project$ACL$canManagePortfolio = F2(
	function (story, person) {
		return A2($author$project$PortfolioStory$isCreator, person, story);
	});
var $author$project$PortfolioStory$isModuleClosure = function (story) {
	return story.ii === 1;
};
var $author$project$UI$Icon$locked = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-lock'),
			attributes));
};
var $author$project$UI$mediaObjectHighlights = function (items) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('has-text-grey is-size-7 inline-list')
			]),
		A2(
			$elm$core$List$filterMap,
			function (item) {
				return _Utils_eq(item, $author$project$UI$none) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[item])));
			},
			items));
};
var $author$project$UI$mediaObjectSmall = F4(
	function (media, content, navigation, right) {
		return A5($author$project$UI$mediaObject_, 'is-48x48', media, content, navigation, right);
	});
var $author$project$UI$Icon$module_ = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-cube'),
			attributes));
};
var $author$project$Element$PortfolioSingle$viewStoryMeta = F3(
	function (t_, viewer, story) {
		var viewStandardStoryText = A2(
			$author$project$UI$caption,
			t_,
			$author$project$Locale$Messages$PortfoliosStoryShared(
				A2($author$project$Person$fullName, t_, story.lf)));
		var viewModuleLink = function (module_) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$author$project$Route$href(
						$author$project$Route$ModulesDetail(
							$author$project$Module$moduleIdToInt(module_.i8))),
						$elm$html$Html$Attributes$title(
						t_(
							$author$project$Locale$Messages$TooltipModule(module_.kj)))
					]),
				_List_fromArray(
					[
						$author$project$UI$Icon$module_(_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(module_.kj)
							]))
					]));
		};
		var viewLock = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(
					A2($author$project$ACL$canManagePortfolio, story, viewer) ? t_($author$project$Locale$Messages$PortfoliosClosedEdit) : t_($author$project$Locale$Messages$PortfoliosClosed))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$locked(_List_Nil)
				]));
		var viewDateLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$PortfoliosDetail(story.i8))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$UI$caption,
					t_,
					A2(
						$author$project$Locale$Messages$TimeDateTimeFormat,
						$elm$time$Time$utc,
						$elm$time$Time$millisToPosix(story.g4)))
				]));
		var viewNoModuleMeta = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('has-text-grey')
					]),
				_List_fromArray(
					[
						A2($author$project$UI$when, story.l9, viewLock),
						viewStandardStoryText
					])),
				$author$project$UI$mediaObjectHighlights(
				_List_fromArray(
					[viewDateLink]))
			]);
		var viewClosureStoryText = function (module_) {
			return A2(
				$author$project$UI$caption,
				t_,
				A3(
					$author$project$Locale$Messages$PortfoliosModuleClosed,
					A2($author$project$Person$fullName, t_, story.lf),
					A2(
						$elm$core$List$map,
						$author$project$Person$fullName(t_),
						story.fv),
					module_.kj));
		};
		var viewModuleMeta = function (module_) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('has-text-grey')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$when, story.l9, viewLock),
							$author$project$PortfolioStory$isModuleClosure(story) ? viewClosureStoryText(module_) : viewStandardStoryText
						])),
					$author$project$UI$mediaObjectHighlights(
					_List_fromArray(
						[
							viewModuleLink(module_),
							viewDateLink
						]))
				]);
		};
		return A4(
			$author$project$UI$mediaObjectSmall,
			_List_fromArray(
				[
					$author$project$UI$gravatarSmall(story.lf.O)
				]),
			A2(
				$elm$core$Maybe$withDefault,
				viewNoModuleMeta,
				A2($elm$core$Maybe$map, viewModuleMeta, story.hG)),
			_List_Nil,
			_List_Nil);
	});
var $author$project$ACL$canGiveFeedbackToPortfolios = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$Data$toBool = function (value) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(true),
			value));
};
var $author$project$PortfolioStory$hasFeedback = function (story) {
	return A2(
		$elm$core$List$any,
		function (badge) {
			return $author$project$Data$toBool(badge.hd);
		},
		story.eT);
};
var $author$project$PortfolioStory$hasModule = function (story) {
	return $author$project$Data$toBool(story.hG);
};
var $author$project$PortfolioStory$isDeletable = function (story) {
	return $elm$core$List$isEmpty(story.eT) && (!story.l9);
};
var $author$project$Locale$Messages$PortfoliosBtnClassroom = {$: 345};
var $author$project$UI$Icon$IconFaCategory = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Icon$category = function (category_) {
	return $author$project$UI$Icon$IconFaCategory(category_);
};
var $author$project$UI$Icon$google = function (attributes) {
	return $author$project$UI$Icon$icon(
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$UI$Icon$face('fa-google'),
					$author$project$UI$Icon$category('fab')
				]),
			attributes));
};
var $author$project$Element$PortfolioSingle$viewClassroomSubmissionLink = F2(
	function (t_, submission) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$UI$attrCyData('portfolios-item-classroom'),
					$elm$html$Html$Attributes$href(submission.K),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$google(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-link-dark')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosBtnClassroom)
				]));
	});
var $author$project$Locale$Messages$BtnDelete = {$: 29};
var $author$project$Element$PortfolioSingle$OpenStoryDeletePopup = {$: 6};
var $author$project$Element$PortfolioSingle$viewStoryDeleteLink = function (t_) {
	return A3(
		$author$project$UI$actionLink,
		$author$project$Element$PortfolioSingle$OpenStoryDeletePopup,
		_List_fromArray(
			[
				$author$project$UI$attrCyData('portfolios-item-delete')
			]),
		_List_fromArray(
			[
				$author$project$UI$Icon$delete(_List_Nil),
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnDelete)
			]));
};
var $author$project$Locale$Messages$BtnEdit = {$: 30};
var $author$project$UI$Icon$edit = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-edit'),
			attributes));
};
var $author$project$Element$PortfolioSingle$viewStoryEditLink = F2(
	function (t_, story) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$PortfoliosUpdate(story.i8)),
					$author$project$UI$attrCyData('portfolios-item-edit')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$edit(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnEdit)
				]));
	});
var $author$project$Element$PortfolioSingle$OpenFeedbackPopup = {$: 7};
var $author$project$Locale$Messages$PortfoliosBtnAddFeedback = {$: 344};
var $author$project$Element$PortfolioSingle$viewStoryFeedbackBadgeLink = function (t_) {
	return A3(
		$author$project$UI$actionLink,
		$author$project$Element$PortfolioSingle$OpenFeedbackPopup,
		_List_fromArray(
			[
				$author$project$UI$attrCyData('portfolios-item-add-feedback')
			]),
		_List_fromArray(
			[
				$author$project$UI$Icon$feedback(
				_List_fromArray(
					[
						$author$project$UI$Icon$style('has-text-info')
					])),
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosBtnAddFeedback)
			]));
};
var $author$project$Element$PortfolioSingle$MarkStoryAsModuleClosing = {$: 11};
var $author$project$Locale$Messages$PortfoliosBtnMarkClosing = {$: 346};
var $author$project$Element$PortfolioSingle$viewStoryModuleClosingLink = function (t_) {
	return A3(
		$author$project$UI$actionLink,
		$author$project$Element$PortfolioSingle$MarkStoryAsModuleClosing,
		_List_fromArray(
			[
				$author$project$UI$attrCyData('portfolios-item-mark-closing')
			]),
		_List_fromArray(
			[
				$author$project$UI$Icon$module_(_List_Nil),
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosBtnMarkClosing)
			]));
};
var $author$project$Element$PortfolioSingle$viewStoryNavLinks = F3(
	function (t_, viewer, story) {
		return A2(
			$author$project$UI$nav,
			_List_fromArray(
				[
					A2(
					$author$project$UI$maybe,
					story.iI,
					$author$project$Element$PortfolioSingle$viewClassroomSubmissionLink(t_)),
					A2(
					$author$project$UI$when,
					A2($author$project$ACL$canManagePortfolio, story, viewer) && ($author$project$PortfolioStory$isEditable(story) && $author$project$PortfolioStory$isNotModuleClosure(story)),
					A2($author$project$Element$PortfolioSingle$viewStoryEditLink, t_, story)),
					A2(
					$author$project$UI$when,
					$author$project$ACL$canGiveFeedbackToPortfolios(viewer) && ($author$project$PortfolioStory$isNotModuleClosure(story) && $author$project$PortfolioStory$isEditable(story)),
					$author$project$Element$PortfolioSingle$viewStoryFeedbackBadgeLink(t_)),
					A2(
					$author$project$UI$when,
					$author$project$PortfolioStory$isNotModuleClosure(story) && (($elm$core$List$length(story.fv) === 1) && ($author$project$PortfolioStory$hasFeedback(story) && ($author$project$PortfolioStory$hasModule(story) && (A2($author$project$ACL$canManagePortfolio, story, viewer) && $author$project$PortfolioStory$isEditable(story))))),
					$author$project$Element$PortfolioSingle$viewStoryModuleClosingLink(t_)),
					A2(
					$author$project$UI$when,
					A2($author$project$ACL$canManagePortfolio, story, viewer) && $author$project$PortfolioStory$isDeletable(story),
					$author$project$Element$PortfolioSingle$viewStoryDeleteLink(t_))
				]),
			_List_Nil);
	});
var $author$project$Element$PortfolioSingle$viewStoryItem = F4(
	function (t_, subjects, viewer, story) {
		var badgeDescriptionDiffersFromStoryDescription = function (badge) {
			return !_Utils_eq(story.g8, badge.g8);
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('portfolios-item is-fullwidth')
				]),
			_List_fromArray(
				[
					A3($author$project$Element$PortfolioSingle$viewStoryMeta, t_, viewer, story),
					A2($author$project$Element$PortfolioSingle$viewStoryContent, t_, story),
					A6(
					$author$project$Element$PortfolioSingle$viewBadges,
					t_,
					subjects,
					badgeDescriptionDiffersFromStoryDescription,
					viewer,
					$author$project$PortfolioStory$isEditable(story) ? $elm$core$Maybe$Just($author$project$Element$PortfolioSingle$OpenBadgeDeletePopup) : $elm$core$Maybe$Nothing,
					story.eT),
					A3($author$project$Element$PortfolioSingle$viewStoryNavLinks, t_, viewer, story)
				]));
	});
var $author$project$Element$PortfolioSingle$viewItem = function (_v0) {
	var session = _v0.gB;
	var story = _v0.bA;
	var subjects = _v0.kb;
	var popupModel = _v0.eq;
	var subjects_ = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		$author$project$RemoteData$toMaybe(subjects));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$UI$maybe,
				popupModel,
				$author$project$Element$PortfolioSingle$viewPopup(session)),
				A2(
				$author$project$UI$maybe,
				$author$project$RemoteData$toMaybe(story),
				A3($author$project$Element$PortfolioSingle$viewStoryItem, session.h6, subjects_, session.ok))
			]));
};
var $author$project$Locale$Messages$PortfoliosTitle = {$: 390};
var $author$project$Element$PortfolioSingle$viewPage = function (model) {
	var session = model.gB;
	return $author$project$UI$panel(
		{
			g$: _List_fromArray(
				[
					$author$project$Element$PortfolioSingle$viewItem(model)
				]),
			cm: 'portfolios-list',
			hl: _List_fromArray(
				[
					A2($author$project$UI$caption, session.h6, $author$project$Locale$Messages$PortfoliosTitle)
				]),
			h7: _List_Nil,
			ie: 'is-link'
		});
};
var $author$project$Element$PortfolioSingle$view = function (model) {
	var _v0 = model.oi;
	if (!_v0.$) {
		return $author$project$Element$PortfolioSingle$viewPage(model);
	} else {
		return $author$project$Element$PortfolioSingle$viewItem(model);
	}
};
var $author$project$Element$PortfolioSingle$element = {jb: $author$project$Element$PortfolioSingle$init, hP: $author$project$Element$PortfolioSingle$perform, ks: $author$project$Element$PortfolioSingle$update, og: $author$project$Element$PortfolioSingle$view};
var $author$project$Element$PortfolioList$singleElement = function (storyId) {
	return {
		ha: $author$project$Element$PortfolioSingle$element,
		kk: $author$project$Element$PortfolioList$SingleElementEffect(storyId),
		cf: $author$project$Element$PortfolioList$SingleElementMsg(storyId),
		kt: F2(
			function (containerModel, model) {
				var singleElements2 = A3(
					$elm$core$Dict$update,
					storyId,
					$elm$core$Basics$always(
						$elm$core$Maybe$Just(model)),
					containerModel.cP);
				return _Utils_update(
					containerModel,
					{cP: singleElements2});
			})
	};
};
var $author$project$Element$PortfolioList$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$PortfolioList$perform(key),
						effects));
			case 2:
				var cmd = effect.a;
				switch (cmd.$) {
					case 6:
						var seconds = cmd.a;
						var toMsg = cmd.b;
						return A2($author$project$Util$Delay$after, seconds, toMsg);
					case 5:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					case 0:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 1:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 2:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 3:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					default:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
				}
			default:
				var storyId = effect.a;
				var elementEffect = effect.b;
				return A3(
					$author$project$Application$V3$Boundaries$performElement,
					key,
					elementEffect,
					$author$project$Element$PortfolioList$singleElement(storyId));
		}
	});
var $author$project$Locale$Messages$ClassroomCourseListDownloadError = {$: 40};
var $author$project$Element$PortfolioList$Delay = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Element$PortfolioList$DelayedGotListQuery = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$PortfolioSingle$ListItem = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioList$LogError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$PortfolioList$NoOp = {$: 16};
var $author$project$Locale$Messages$PortfoliosPeopleDownloadError = {$: 358};
var $author$project$Element$PortfolioList$NoMoreStories = {$: 2};
var $author$project$Element$PortfolioList$StoriesLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioList$addNewStories = F2(
	function (newStories, model) {
		var loading = model.dj;
		var stories = model.fu;
		var _v0 = _Utils_Tuple3(
			loading,
			stories,
			$elm$core$List$reverse(newStories));
		switch (_v0.a.$) {
			case 0:
				if (!_v0.c.b) {
					if (!_v0.b.b) {
						var _v1 = _v0.a;
						return _Utils_update(
							model,
							{dj: $author$project$Element$PortfolioList$NoMoreStories, fu: newStories});
					} else {
						var _v4 = _v0.a;
						return _Utils_update(
							model,
							{dj: $author$project$Element$PortfolioList$NoMoreStories});
					}
				} else {
					if (!_v0.b.b) {
						var _v2 = _v0.a;
						var _v3 = _v0.c;
						var lastStory = _v3.a;
						return _Utils_update(
							model,
							{
								dj: $author$project$Element$PortfolioList$StoriesLoaded(lastStory),
								fu: newStories
							});
					} else {
						var _v5 = _v0.a;
						var stories_ = _v0.b;
						var _v6 = _v0.c;
						var lastStory = _v6.a;
						return _Utils_update(
							model,
							{
								dj: $author$project$Element$PortfolioList$StoriesLoaded(lastStory),
								fu: _Utils_ap(stories_, newStories)
							});
					}
				}
			case 1:
				return model;
			default:
				var _v7 = _v0.a;
				return model;
		}
	});
var $author$project$Element$PortfolioList$batchEffect = F2(
	function (newEffect, effect) {
		switch (effect.$) {
			case 0:
				return newEffect;
			case 1:
				var effects = effect.a;
				return $author$project$Element$PortfolioList$BatchEffect(
					A2($elm$core$List$cons, newEffect, effects));
			case 2:
				return $author$project$Element$PortfolioList$BatchEffect(
					_List_fromArray(
						[newEffect, effect]));
			default:
				return $author$project$Element$PortfolioList$BatchEffect(
					_List_fromArray(
						[newEffect, effect]));
		}
	});
var $author$project$Element$PortfolioList$emptyResults = function (model) {
	return _Utils_update(
		model,
		{dj: $author$project$Element$PortfolioList$LoadingStories, fu: _List_Nil});
};
var $author$project$Element$PortfolioList$filterStories = F2(
	function (model, newFilter) {
		var model2 = $author$project$Element$PortfolioList$emptyResults(
			_Utils_update(
				model,
				{ad: newFilter}));
		var listParams = $author$project$Element$PortfolioList$asListParams(model2);
		return _Utils_Tuple3(
			model2,
			$author$project$Element$PortfolioList$Cmd(
				$author$project$Element$PortfolioList$FetchPortfolioStoryList(
					A3($author$project$PortfolioStory$fetchStories2, model.b_.gX, listParams, $author$project$Element$PortfolioList$PortfolioStoryListDownloaded))),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$PortfolioList$TypeMClosure = 2;
var $author$project$Element$PortfolioList$formToFilter = function (value) {
	switch (value) {
		case '':
			return 0;
		case 'feedback':
			return 1;
		case 'mclosure':
			return 2;
		default:
			return 0;
	}
};
var $author$project$Log$msgClassroomsDownload = 'classroom_courses_download';
var $author$project$Log$msgModulesDownload = 'modules_download';
var $author$project$Log$msgPortfoliosPeopleDownload = 'portfolios_people_download';
var $author$project$Element$PortfolioList$update = F2(
	function (msg, model) {
		var config = model.b_;
		var store = model.bo;
		var filter = model.ad;
		var session = model.gB;
		var t_ = session.h6;
		var noop = _Utils_Tuple3(model, $author$project$Element$PortfolioList$NoEffect, $elm$core$Maybe$Nothing);
		switch (msg.$) {
			case 9:
				var listParams = $author$project$Element$PortfolioList$asListParams(model);
				var _v1 = model.dj;
				switch (_v1.$) {
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{dj: $author$project$Element$PortfolioList$LoadingStories}),
							$author$project$Element$PortfolioList$Cmd(
								$author$project$Element$PortfolioList$FetchPortfolioStoryList(
									A3($author$project$PortfolioStory$fetchStories2, config.gX, listParams, $author$project$Element$PortfolioList$PortfolioStoryListDownloaded))),
							$elm$core$Maybe$Nothing);
					case 0:
						return noop;
					default:
						return noop;
				}
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{e1: !model.e1}),
					$author$project$Element$PortfolioList$NoEffect,
					$elm$core$Maybe$Nothing);
			case 1:
				var values = msg.a;
				var classroomIds = A2($elm$core$List$filterMap, $elm$core$String$toInt, values);
				return A2(
					$author$project$Element$PortfolioList$filterStories,
					model,
					_Utils_update(
						filter,
						{g2: classroomIds}));
			case 2:
				var values = msg.a;
				var moduleIds = A2(
					$elm$core$List$filterMap,
					function (id) {
						return A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$identity,
							$elm$core$String$toInt(id));
					},
					values);
				return A2(
					$author$project$Element$PortfolioList$filterStories,
					model,
					_Utils_update(
						filter,
						{hH: moduleIds}));
			case 3:
				var values = msg.a;
				var studentIds = A2($elm$core$List$filterMap, $elm$core$String$toInt, values);
				return A2(
					$author$project$Element$PortfolioList$filterStories,
					model,
					_Utils_update(
						filter,
						{fv: studentIds}));
			case 4:
				var values = msg.a;
				var teacherIds = A2($elm$core$List$filterMap, $elm$core$String$toInt, values);
				return A2(
					$author$project$Element$PortfolioList$filterStories,
					model,
					_Utils_update(
						filter,
						{fx: teacherIds}));
			case 5:
				var value = msg.a;
				return A2(
					$author$project$Element$PortfolioList$filterStories,
					model,
					_Utils_update(
						filter,
						{
							ii: $author$project$Element$PortfolioList$formToFilter(value)
						}));
			case 6:
				var categoryFilter = msg.a;
				return A2(
					$author$project$Element$PortfolioList$filterStories,
					model,
					_Utils_update(
						filter,
						{bD: categoryFilter}));
			case 7:
				var query = msg.a;
				return _Utils_Tuple3(
					$author$project$Element$PortfolioList$emptyResults(
						_Utils_update(
							model,
							{bF: query})),
					$author$project$Element$PortfolioList$Cmd(
						A2(
							$author$project$Element$PortfolioList$Delay,
							0.5,
							$author$project$Element$PortfolioList$DelayedGotListQuery(query))),
					$elm$core$Maybe$Nothing);
			case 8:
				var newQuery = msg.a;
				var listParams = $author$project$Element$PortfolioList$asListParams(model);
				var effect = _Utils_eq(newQuery, model.bF) ? $author$project$Element$PortfolioList$Cmd(
					$author$project$Element$PortfolioList$FetchPortfolioStoryList(
						A3($author$project$PortfolioStory$fetchStories2, config.gX, listParams, $author$project$Element$PortfolioList$PortfolioStoryListDownloaded))) : $author$project$Element$PortfolioList$NoEffect;
				return _Utils_Tuple3(model, effect, $elm$core$Maybe$Nothing);
			case 15:
				var storyId = msg.a;
				var singleMsg = msg.b;
				var updateSingleElement = function (singleModel_) {
					var single = $author$project$Element$PortfolioList$singleElement(storyId);
					var _v2 = A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						single,
						A4($author$project$Application$V3$Boundaries$updateElement, session, singleMsg, singleModel_, single));
					var model2 = _v2.a;
					var effect = _v2.b;
					var reply = _v2.c;
					if (!reply.$) {
						var _v4 = reply.a;
						return _Utils_Tuple3(
							_Utils_update(
								model2,
								{
									cP: A2($elm$core$Dict$remove, storyId, model.cP)
								}),
							effect,
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
					}
				};
				var singleModel = A2($elm$core$Dict$get, storyId, model.cP);
				return A2(
					$elm$core$Maybe$withDefault,
					noop,
					A2($elm$core$Maybe$map, updateSingleElement, singleModel));
			case 10:
				var newStories = msg.a;
				switch (newStories.$) {
					case 3:
						var error = newStories.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									gB: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$PortfoliosDownloadError))
								}),
							$author$project$Element$PortfolioList$Cmd(
								$author$project$Element$PortfolioList$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgPortfoliosDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$PortfolioList$NoOp)))),
							$elm$core$Maybe$Nothing);
					case 2:
						var newStories_ = newStories.a;
						var startModel = A2($author$project$Element$PortfolioList$addNewStories, newStories_, model);
						return A3(
							$elm$core$List$foldl,
							F2(
								function (story, _v6) {
									var model_ = _v6.a;
									var effect_ = _v6.b;
									var single = $author$project$Element$PortfolioList$singleElement(story.i8);
									var params = {
										kb: model.kb,
										oi: $author$project$Element$PortfolioSingle$ListItem(story)
									};
									var _v7 = A3(
										$author$project$Application$V3$Boundaries$mapElement,
										model_,
										single,
										A4($author$project$Application$V3$Boundaries$initElement, model_.b_, model_.gB, single, params));
									var model2 = _v7.a;
									var effect2 = _v7.b;
									return _Utils_Tuple3(
										model2,
										A2($author$project$Element$PortfolioList$batchEffect, effect2, effect_),
										$elm$core$Maybe$Nothing);
								}),
							_Utils_Tuple3(startModel, $author$project$Element$PortfolioList$NoEffect, $elm$core$Maybe$Nothing),
							newStories_);
					case 0:
						return noop;
					default:
						return noop;
				}
			case 13:
				var subjects = msg.a;
				switch (subjects.$) {
					case 3:
						var error = subjects.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									gB: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$SubjectListDownloadError))
								}),
							$author$project$Element$PortfolioList$Cmd(
								$author$project$Element$PortfolioList$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgSubjectListDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$PortfolioList$NoOp)))),
							$elm$core$Maybe$Nothing);
					case 2:
						var subjects_ = subjects.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									kb: $author$project$RemoteData$Success(subjects_)
								}),
							$author$project$Element$PortfolioList$NoEffect,
							$elm$core$Maybe$Nothing);
					case 0:
						return noop;
					default:
						return noop;
				}
			case 14:
				if (!msg.a.$) {
					var classrooms = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bo: _Utils_update(
									store,
									{
										g2: $elm$core$Maybe$Just(classrooms)
									})
							}),
						$author$project$Element$PortfolioList$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$ClassroomCourseListDownloadError))
							}),
						$author$project$Element$PortfolioList$Cmd(
							$author$project$Element$PortfolioList$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgClassroomsDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopePortfolios),
										error),
									$elm$core$Basics$always($author$project$Element$PortfolioList$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 11:
				if (!msg.a.$) {
					var modules = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bo: _Utils_update(
									store,
									{
										hH: $elm$core$Maybe$Just(modules)
									})
							}),
						$author$project$Element$PortfolioList$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$ModulesDownloadError))
							}),
						$author$project$Element$PortfolioList$Cmd(
							$author$project$Element$PortfolioList$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgModulesDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopePortfolios),
										error),
									$elm$core$Basics$always($author$project$Element$PortfolioList$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 12:
				if (!msg.a.$) {
					var people = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bo: _Utils_update(
									store,
									{
										m6: $elm$core$Maybe$Just(people)
									})
							}),
						$author$project$Element$PortfolioList$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$PortfoliosPeopleDownloadError))
							}),
						$author$project$Element$PortfolioList$Cmd(
							$author$project$Element$PortfolioList$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgPortfoliosPeopleDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$PortfolioList$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			default:
				return noop;
		}
	});
var $author$project$Locale$Messages$BtnToggleFilters = {$: 39};
var $author$project$Element$PortfolioList$GotListQuery = function (a) {
	return {$: 7, a: a};
};
var $author$project$Locale$Messages$PortfoliosEmptyResults = {$: 383};
var $author$project$Locale$Messages$PortfoliosSearch = {$: 386};
var $author$project$Element$PortfolioList$ToggleFilterPanel = {$: 0};
var $author$project$UI$Icon$add = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-plus-square'),
			attributes));
};
var $author$project$ACL$canCreateModules = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$UI$Icon$warning = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-exclamation-circle'),
			attributes));
};
var $author$project$UI$List$emptyResultsInfo = F2(
	function (t_, message) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container has-text-centered')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mr-1')
						]),
					_List_fromArray(
						[
							$author$project$UI$Icon$warning(
							_List_fromArray(
								[
									$author$project$UI$Icon$style('has-text-link')
								]))
						])),
					A2($author$project$UI$caption, t_, message)
				]));
	});
var $author$project$UI$Icon$filter = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-sliders-h'),
			attributes));
};
var $author$project$Person$isSponsorOf = F2(
	function (person, child) {
		return A2(
			$elm$core$List$any,
			$author$project$Person$isSamePerson(child),
			person.nL);
	});
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $author$project$UI$keyedPanel = function (_v0) {
	var theme = _v0.ie;
	var dataTag = _v0.cm;
	var heading = _v0.hl;
	var tabs = _v0.h7;
	var blocks = _v0.g$;
	var keyedBlocks = _v0.mm;
	return A3(
		$elm$html$Html$Keyed$node,
		'div',
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panel'),
				$elm$html$Html$Attributes$class(theme),
				$author$project$UI$attrCyData(dataTag)
			]),
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'panel-heading-0',
				A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel-heading')
						]),
					heading)),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'panel-tabs-0',
					A2(
						$elm$html$Html$nav,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('panel-tabs')
							]),
						tabs)),
				_Utils_ap(
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (idx, block) {
								return _Utils_Tuple2(
									'panel-block-' + $elm$core$String$fromInt(idx),
									$author$project$UI$panelBlock(block));
							}),
						blocks),
					A2(
						$elm$core$List$map,
						function (_v1) {
							var key = _v1.a;
							var block = _v1.b;
							return _Utils_Tuple2(
								'panel-block-key-' + key,
								$author$project$UI$panelBlock(block));
						},
						keyedBlocks)))));
};
var $author$project$UI$List$resultsLoadingProgressBar = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('container has-text-centered')
		]),
	_List_fromArray(
		[
			$author$project$UI$Icon$icon(
			_List_fromArray(
				[
					$author$project$UI$Icon$face('fa-spinner fa-spin fa-2x'),
					$author$project$UI$Icon$style('is-large has-text-grey')
				]))
		]));
var $author$project$UI$List$searchBar = function (params) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('control has-icons-left')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('input'),
						$elm$html$Html$Attributes$placeholder(params.fj),
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Events$onInput(params.fe),
						$author$project$UI$attrCyData('query'),
						$elm$html$Html$Attributes$value(params.bF)
					]),
				_List_Nil),
				$author$project$UI$Icon$icon(
				_List_fromArray(
					[
						$author$project$UI$Icon$face('fa-search'),
						$author$project$UI$Icon$style('is-left')
					]))
			]));
};
var $author$project$Person$students = $elm$core$List$filter($author$project$Person$isStudent);
var $author$project$Person$teachers = $elm$core$List$filter(
	function (person) {
		return $author$project$Person$isTeacher(person) || $author$project$Person$isModuleTeacher(person);
	});
var $author$project$Locale$Messages$PortfoliosFilterActive = {$: 359};
var $author$project$Locale$Messages$PortfoliosFilterClassrooms = {$: 364};
var $author$project$Locale$Messages$PortfoliosFilterModules = {$: 365};
var $author$project$Locale$Messages$PortfoliosFilterStudents = {$: 368};
var $author$project$Locale$Messages$PortfoliosFilterTeachers = {$: 369};
var $author$project$Locale$Messages$PortfoliosFilterType = {$: 370};
var $author$project$Element$PortfolioList$SetClassroomFilter = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioList$SetModuleFilter = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioList$SetStudentFilter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioList$SetTeacherFilter = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$PortfolioList$SetTypeFilter = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$PortfolioList$viewActiveFilters = F2(
	function (t_, filter) {
		var viewFilterPill = F2(
			function (caption, resetMsg) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('control')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tags has-addons')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$UI$tag,
									'is-info',
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, caption)
										])),
									A3(
									$author$project$UI$actionLink,
									resetMsg,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('tag is-delete')
										]),
									_List_fromArray(
										[$author$project$UI$none]))
								]))
						]));
			});
		var empty = $author$project$Element$PortfolioList$emptyFilter;
		var hasActiveFilter = (!_Utils_eq(empty.g2, filter.g2)) || ((!_Utils_eq(empty.hH, filter.hH)) || ((!_Utils_eq(empty.fv, filter.fv)) || ((!_Utils_eq(empty.fx, filter.fx)) || (!_Utils_eq(empty.ii, filter.ii)))));
		return hasActiveFilter ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('field is-grouped is-grouped-multiline')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('heading mr-2')
							]),
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosFilterActive)
							])),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.g2, filter.g2),
						A2(
							viewFilterPill,
							$author$project$Locale$Messages$PortfoliosFilterClassrooms,
							$author$project$Element$PortfolioList$SetClassroomFilter(_List_Nil))),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.hH, filter.hH),
						A2(
							viewFilterPill,
							$author$project$Locale$Messages$PortfoliosFilterModules,
							$author$project$Element$PortfolioList$SetModuleFilter(_List_Nil))),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.fv, filter.fv),
						A2(
							viewFilterPill,
							$author$project$Locale$Messages$PortfoliosFilterStudents,
							$author$project$Element$PortfolioList$SetStudentFilter(_List_Nil))),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.fx, filter.fx),
						A2(
							viewFilterPill,
							$author$project$Locale$Messages$PortfoliosFilterTeachers,
							$author$project$Element$PortfolioList$SetTeacherFilter(_List_Nil))),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.ii, filter.ii),
						A2(
							viewFilterPill,
							$author$project$Locale$Messages$PortfoliosFilterType,
							$author$project$Element$PortfolioList$SetTypeFilter('')))
					]))
			]) : _List_Nil;
	});
var $author$project$Locale$Messages$PortfoliosFilterNone = {$: 367};
var $author$project$UI$filterOptions = function (viewConfig) {
	var view = function (content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$fieldset,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$legend,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[viewConfig.g1])),
						content))
				]));
	};
	var _v0 = _Utils_Tuple2(viewConfig.m_, viewConfig.lT);
	if (_v0.a.$ === 1) {
		var _v1 = _v0.a;
		return view(
			_List_fromArray(
				[
					$author$project$UI$Icon$loadingOptions(_List_Nil)
				]));
	} else {
		if (!_v0.a.a.b) {
			return $author$project$UI$none;
		} else {
			if ((!_v0.a.a.b.b) && _v0.b) {
				var _v2 = _v0.a.a;
				return $author$project$UI$none;
			} else {
				var lst = _v0.a.a;
				return view(
					viewConfig.oj(lst));
			}
		}
	}
};
var $author$project$Element$PortfolioList$viewClassroomFilters = F3(
	function (t_, maybeClassrooms, filter) {
		var selectedClassrooms = A2($elm$core$List$map, $elm$core$String$fromInt, filter.g2);
		var viewClassroomOptions = function (classrooms) {
			return A2(
				$elm$core$List$map,
				A4(
					$author$project$UI$checkbox,
					$author$project$Element$PortfolioList$SetClassroomFilter,
					'portfolios-filter-classrooms',
					$elm$core$Basics$always(false),
					selectedClassrooms),
				$author$project$Form$toSelectOptions(
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'-1',
								t_($author$project$Locale$Messages$PortfoliosFilterNone))
							]),
						A2(
							$elm$core$List$map,
							function (classroom) {
								return _Utils_Tuple2(
									$elm$core$String$fromInt(classroom.i8),
									classroom.kj);
							},
							A2(
								$author$project$Util$List$sortBy,
								function ($) {
									return $.kj;
								},
								classrooms)))));
		};
		return $author$project$UI$filterOptions(
			{
				g1: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosFilterClassrooms),
				lT: true,
				m_: maybeClassrooms,
				oj: viewClassroomOptions
			});
	});
var $author$project$Locale$Messages$PortfoliosFilterOwnModules = {$: 366};
var $author$project$Element$PortfolioList$viewModuleFilters = F3(
	function (t_, maybeModules, filter) {
		var selectedModules = A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, $author$project$Module$moduleIdToInt, $elm$core$String$fromInt),
			filter.hH);
		var viewModuleOptions = function (modules) {
			return A2(
				$elm$core$List$map,
				A4(
					$author$project$UI$checkbox,
					$author$project$Element$PortfolioList$SetModuleFilter,
					'portfolios-filter-modules',
					$elm$core$Basics$always(false),
					selectedModules),
				$author$project$Form$toSortedSelectOptions(
					A2(
						$elm$core$List$map,
						function (module_) {
							return _Utils_Tuple2(
								$elm$core$String$fromInt(
									$author$project$Module$moduleIdToInt(module_.i8)),
								module_.kj);
						},
						modules)));
		};
		return $author$project$UI$filterOptions(
			{
				g1: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosFilterOwnModules),
				lT: true,
				m_: maybeModules,
				oj: viewModuleOptions
			});
	});
var $author$project$Element$PortfolioList$viewSingleElement = F3(
	function (session, story, singleElementModel) {
		var single = $author$project$Element$PortfolioList$singleElement(story.i8);
		return A3($author$project$Application$V3$Boundaries$viewElement, session, singleElementModel, single);
	});
var $author$project$Form$toPeopleOptions = F2(
	function (t_, people) {
		return A2(
			$elm$core$List$map,
			function (person) {
				return $author$project$Form$toSelectOption(
					_Utils_Tuple2(
						$elm$core$String$fromInt(person.i8),
						A2($author$project$Person$fullName, t_, person)));
			},
			A2(
				$author$project$Util$List$sortBy,
				$author$project$Person$fullName(t_),
				people));
	});
var $author$project$Element$PortfolioList$viewStudentFilters = F3(
	function (t_, maybeStudents, filter) {
		var selectedStudents = A2($elm$core$List$map, $elm$core$String$fromInt, filter.fv);
		var viewStudentOptions = function (students) {
			return A2(
				$elm$core$List$map,
				A4(
					$author$project$UI$checkbox,
					$author$project$Element$PortfolioList$SetStudentFilter,
					'portfolios-filter-students',
					$elm$core$Basics$always(false),
					selectedStudents),
				A2($author$project$Form$toPeopleOptions, t_, students));
		};
		return $author$project$UI$filterOptions(
			{
				g1: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosFilterStudents),
				lT: true,
				m_: maybeStudents,
				oj: viewStudentOptions
			});
	});
var $author$project$Element$PortfolioList$FilterChildren = 3;
var $author$project$Element$PortfolioList$FilterCreator = 2;
var $author$project$Element$PortfolioList$FilterSchools = 1;
var $author$project$Element$PortfolioList$GotCategoryFilter = function (a) {
	return {$: 6, a: a};
};
var $author$project$Locale$Messages$PortfoliosFilterAll = {$: 360};
var $author$project$Locale$Messages$PortfoliosFilterChildren = {$: 361};
var $author$project$Locale$Messages$PortfoliosFilterOwnPortfolios = {$: 363};
var $author$project$Locale$Messages$PortfoliosFilterOwnSchools = {$: 362};
var $author$project$ACL$canViewPortfoliosAll = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$ACL$isAuditor(person);
};
var $author$project$UI$List$filterBar = F3(
	function (t_, _v0, filters) {
		var toMsg = _v0.a;
		var currentFilter = _v0.b;
		var hideSingleTab = function (filters_) {
			return ($elm$core$List$length(filters_) > 1) ? filters_ : _List_Nil;
		};
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var filter = _v1.ad;
				var dataTag = _v1.cm;
				var label = _v1.ea;
				var isEnabled = _v1.hv;
				return A3(
					$author$project$UI$actionLink,
					toMsg(filter),
					_List_fromArray(
						[
							$author$project$UI$attrCyData('filter-' + dataTag),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'is-active',
									_Utils_eq(currentFilter, filter)),
									_Utils_Tuple2('is-disabled has-text-grey-light', !isEnabled)
								]))
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, label)
						]));
			},
			hideSingleTab(
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.hw;
					},
					filters)));
	});
var $author$project$Element$PortfolioList$viewTabFilters = F3(
	function (t_, viewer, filter) {
		return A3(
			$author$project$UI$List$filterBar,
			t_,
			_Utils_Tuple2($author$project$Element$PortfolioList$GotCategoryFilter, filter),
			_List_fromArray(
				[
					{
					cm: 'mine',
					ad: 2,
					hv: true,
					hw: $author$project$ACL$canCreatePortfolios(viewer),
					ea: $author$project$Locale$Messages$PortfoliosFilterOwnPortfolios
				},
					{
					cm: 'children',
					ad: 3,
					hv: true,
					hw: $author$project$Person$isSponsor(viewer),
					ea: $author$project$Locale$Messages$PortfoliosFilterChildren
				},
					{
					cm: 'own-schools',
					ad: 1,
					hv: true,
					hw: $author$project$ACL$canViewPortfoliosSchool(viewer),
					ea: $author$project$Locale$Messages$PortfoliosFilterOwnSchools
				},
					{
					cm: 'all',
					ad: 0,
					hv: true,
					hw: $author$project$ACL$canViewPortfoliosAll(viewer),
					ea: $author$project$Locale$Messages$PortfoliosFilterAll
				}
				]));
	});
var $author$project$Element$PortfolioList$viewTeacherFilters = F3(
	function (t_, maybeTeachers, filter) {
		var selectedTeachers = A2($elm$core$List$map, $elm$core$String$fromInt, filter.fx);
		var viewTeacherOptions = function (teachers) {
			return A2(
				$elm$core$List$map,
				A4(
					$author$project$UI$checkbox,
					$author$project$Element$PortfolioList$SetTeacherFilter,
					'portfolios-filter-teachers',
					$elm$core$Basics$always(false),
					selectedTeachers),
				A2($author$project$Form$toPeopleOptions, t_, teachers));
		};
		return $author$project$UI$filterOptions(
			{
				g1: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosFilterTeachers),
				lT: true,
				m_: maybeTeachers,
				oj: viewTeacherOptions
			});
	});
var $author$project$Locale$Messages$PortfoliosFilterTypeAll = {$: 371};
var $author$project$Locale$Messages$PortfoliosFilterTypeFeedback = {$: 372};
var $author$project$Locale$Messages$PortfoliosFilterTypeMClosure = {$: 373};
var $author$project$Element$PortfolioList$filterToForm = function (type_) {
	switch (type_) {
		case 0:
			return '';
		case 1:
			return 'feedback';
		default:
			return 'mclosure';
	}
};
var $author$project$UI$radioButton = F4(
	function (toMsg, dataTag, selectedValue, option) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('radio')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									toMsg(option.fC)),
									$elm$html$Html$Attributes$type_('radio'),
									$elm$html$Html$Attributes$name(dataTag),
									$author$project$UI$attrCyData(dataTag),
									$elm$html$Html$Attributes$checked(
									_Utils_eq(selectedValue, option.fC))
								]),
							_List_Nil),
							$elm$html$Html$text(' '),
							$elm$html$Html$text(option.ea)
						]))
				]));
	});
var $author$project$Element$PortfolioList$viewTypeFilter = F2(
	function (t_, filter) {
		var viewOption = function (option) {
			return A4(
				$author$project$UI$radioButton,
				$author$project$Element$PortfolioList$SetTypeFilter,
				'option-type-' + option.fC,
				$author$project$Element$PortfolioList$filterToForm(filter.ii),
				option);
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$fieldset,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$legend,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosFilterType)
								])),
							viewOption(
							{
								ea: t_($author$project$Locale$Messages$PortfoliosFilterTypeAll),
								fC: ''
							}),
							viewOption(
							{
								ea: t_($author$project$Locale$Messages$PortfoliosFilterTypeFeedback),
								fC: 'feedback'
							}),
							viewOption(
							{
								ea: t_($author$project$Locale$Messages$PortfoliosFilterTypeMClosure),
								fC: 'mclosure'
							})
						]))
				]));
	});
var $author$project$Element$PortfolioList$viewStoryList = F3(
	function (session, _v0, model) {
		var t_ = session.h6;
		var viewer = session.ok;
		var modules = _v0.hH;
		var people = _v0.m6;
		var classrooms = _v0.g2;
		var filter = model.ad;
		var stories = model.fu;
		var viewLoadingState = function () {
			var _v1 = _Utils_Tuple2(model.dj, stories);
			if (!_v1.b.b) {
				switch (_v1.a.$) {
					case 0:
						var _v2 = _v1.a;
						return _List_fromArray(
							[$author$project$UI$List$resultsLoadingProgressBar]);
					case 1:
						return _List_fromArray(
							[
								A2($author$project$UI$List$emptyResultsInfo, t_, $author$project$Locale$Messages$PortfoliosEmptyResults)
							]);
					default:
						var _v3 = _v1.a;
						return _List_fromArray(
							[
								A2($author$project$UI$List$emptyResultsInfo, t_, $author$project$Locale$Messages$PortfoliosEmptyResults)
							]);
				}
			} else {
				return _List_Nil;
			}
		}();
		var viewKeyedItem = function (story) {
			return _Utils_Tuple2(
				$elm$core$String$fromInt(story.i8),
				A2(
					$author$project$UI$maybe,
					A2($elm$core$Dict$get, story.i8, model.cP),
					A2($author$project$Element$PortfolioList$viewSingleElement, session, story)));
		};
		var viewFilterButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button'),
					$elm$html$Html$Events$onClick($author$project$Element$PortfolioList$ToggleFilterPanel),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('is-info', model.e1),
							_Utils_Tuple2('is-info is-light', !model.e1)
						]))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$filter(_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnToggleFilters)
						]))
				]));
		var students = ($author$project$ACL$isStaff(viewer) || $author$project$Person$isModuleTeacher(viewer)) ? A2($elm$core$Maybe$map, $author$project$Person$students, people) : ($author$project$Person$isSponsor(viewer) ? A2(
			$elm$core$Maybe$map,
			$elm$core$List$filter(
				$author$project$Person$isSponsorOf(viewer)),
			people) : $elm$core$Maybe$Just(
			_List_fromArray(
				[viewer])));
		var viewFilterPanel = model.e1 ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container columns')
					]),
				_List_fromArray(
					[
						A2($author$project$Element$PortfolioList$viewTypeFilter, t_, filter),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canCreateModules(viewer),
						A3($author$project$Element$PortfolioList$viewModuleFilters, t_, modules, filter)),
						A3($author$project$Element$PortfolioList$viewStudentFilters, t_, students, filter),
						A3(
						$author$project$Element$PortfolioList$viewTeacherFilters,
						t_,
						A2($elm$core$Maybe$map, $author$project$Person$teachers, people),
						filter),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewClassrooms(viewer),
						A3($author$project$Element$PortfolioList$viewClassroomFilters, t_, classrooms, filter))
					]))
			]) : A2($author$project$Element$PortfolioList$viewActiveFilters, t_, filter);
		var maybeModuleId = A2(
			$elm$core$Maybe$map,
			$author$project$Module$moduleIdToInt,
			$elm$core$List$head(filter.hH));
		return $author$project$UI$keyedPanel(
			{
				g$: A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('columns container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('column')
									]),
								_List_fromArray(
									[
										$author$project$UI$List$searchBar(
										{
											fe: $author$project$Element$PortfolioList$GotListQuery,
											fj: t_($author$project$Locale$Messages$PortfoliosSearch),
											bF: model.bF
										})
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('column is-narrow')
									]),
								_List_fromArray(
									[viewFilterButton]))
							])),
					_Utils_ap(viewFilterPanel, viewLoadingState)),
				cm: 'portfolios-list',
				hl: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosTitle)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$UI$when,
								$author$project$ACL$canCreatePortfolios(viewer),
								A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Route$href(
											$author$project$Route$PortfoliosCreate(maybeModuleId)),
											$elm$html$Html$Attributes$title(
											t_($author$project$Locale$Messages$NavPortfoliosNew))
										]),
									_List_fromArray(
										[
											$author$project$UI$Icon$add(
											_List_fromArray(
												[
													$author$project$UI$Icon$style('has-text-white')
												]))
										])))
							]))
					]),
				mm: A2($elm$core$List$map, viewKeyedItem, stories),
				h7: A3($author$project$Element$PortfolioList$viewTabFilters, t_, viewer, filter.bD),
				ie: 'is-link'
			});
	});
var $author$project$Locale$Messages$PortfoliosListLoadMore = {$: 374};
var $author$project$UI$Icon$sync = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-sync'),
			attributes));
};
var $author$project$Element$PortfolioList$viewStoryListPager = F2(
	function (t_, _v0) {
		var loading = _v0.dj;
		var stories = _v0.fu;
		var _v1 = _Utils_Tuple2(loading, stories);
		switch (_v1.a.$) {
			case 0:
				if (!_v1.b.b) {
					var _v2 = _v1.a;
					return $author$project$UI$none;
				} else {
					var _v3 = _v1.a;
					return $author$project$UI$List$resultsLoadingProgressBar;
				}
			case 1:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container has-text-centered')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$UI$actionLink,
							$author$project$Element$PortfolioList$LoadMoreStories,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-link')
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$sync(_List_Nil),
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosListLoadMore)
								]))
						]));
			default:
				var _v4 = _v1.a;
				return $author$project$UI$none;
		}
	});
var $author$project$Element$PortfolioList$view = function (model) {
	var store = model.bo;
	var session = model.gB;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A3($author$project$Element$PortfolioList$viewStoryList, session, store, model),
				A2($author$project$Element$PortfolioList$viewStoryListPager, session.h6, model)
			]));
};
var $author$project$Element$PortfolioList$element = {jb: $author$project$Element$PortfolioList$init, hP: $author$project$Element$PortfolioList$perform, ks: $author$project$Element$PortfolioList$update, og: $author$project$Element$PortfolioList$view};
var $author$project$Element$HomePage$portfolios = {
	ha: $author$project$Element$PortfolioList$element,
	cf: $author$project$Element$HomePage$ListElementMsg,
	kt: F2(
		function (containerModel, model) {
			return _Utils_update(
				containerModel,
				{
					fk: $elm$core$Maybe$Just(model)
				});
		})
};
var $author$project$Element$HomePage$init = F3(
	function (config, session, _v0) {
		var params = $author$project$Element$PortfolioList$defaultParams;
		var model = {fG: $elm$core$Maybe$Nothing, b_: config, fd: $elm$core$Maybe$Nothing, fk: $elm$core$Maybe$Nothing, fv: $elm$core$Maybe$Nothing};
		var noop = A2($author$project$Application$Boundaries$save, model, session);
		var openPortfolios = A3(
			$author$project$Application$V2$Boundaries$mapElement,
			noop,
			$author$project$Element$HomePage$portfolios,
			A5(
				$author$project$Application$V2$Boundaries$initElement,
				config.jk,
				$author$project$Application$V2$SharedConfig$fromV1(config),
				session,
				$author$project$Element$HomePage$portfolios,
				_Utils_update(
					params,
					{mY: true})));
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Task$perform, $author$project$Element$HomePage$TimeIsNow, $elm$time$Time$now),
					A2($author$project$Student$fetchActiveAndFutureStudents, config.gX, $author$project$Element$HomePage$StudentsDownloaded),
					A2($author$project$ActivityLog$fetchActivityLogs, config.gX, $author$project$Element$HomePage$ActivityLogListDownloaded)
				]));
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			$author$project$Element$HomePage$hasPortfolioFeed(session.ok) ? {dX: openPortfolios.dX, eh: openPortfolios.eh, gs: $elm$core$Maybe$Nothing, gB: openPortfolios.gB} : noop);
	});
var $author$project$Locale$Messages$ActivityLogsDownloadError = {$: 4};
var $author$project$Route$AnalyticsLearningContract = {$: 48};
var $author$project$Element$HomePage$NoOp = {$: 1};
var $author$project$Locale$Messages$StudentListDownloadError = {$: 540};
var $author$project$Log$msgActivityLogsDownload = 'activitylogs_download';
var $author$project$Log$msgStudentsDownload = 'students_download';
var $author$project$Locale$Messages$AnalyticsLearningContractTitle = {$: 17};
var $author$project$Locale$Messages$CompanyContractPageTitle = {$: 547};
var $author$project$Locale$Messages$CounterPageTitle = {$: 42};
var $author$project$Locale$Messages$GenericPageTitle = {$: 78};
var $author$project$Locale$Messages$GradeReportsPageTitle = {$: 89};
var $author$project$Locale$Messages$LearningContractsTitle = {$: 139};
var $author$project$Locale$Messages$LearningGroupListTitle = {$: 161};
var $author$project$Locale$Messages$LoginPageTitle = {$: 169};
var $author$project$Locale$Messages$ModuleClosureOverviewPageTitle = {$: 193};
var $author$project$Locale$Messages$ModuleTeacherProfilesPageTitle = {$: 217};
var $author$project$Locale$Messages$ModulesClosurePageTitle = {$: 232};
var $author$project$Locale$Messages$ModulesTitle = {$: 284};
var $author$project$Locale$Messages$NotificationsTitle = {$: 310};
var $author$project$Locale$Messages$PhoneBookTitle = {$: 343};
var $author$project$Locale$Messages$ReconciliationPageTitle = {$: 719};
var $author$project$Locale$Messages$RubricSubjectOverviewTitle = {$: 427};
var $author$project$Locale$Messages$StudentListTitleStudents = {$: 544};
var $author$project$Locale$Messages$StudentProfileFormPageTitle = {$: 534};
var $author$project$Locale$Messages$SubjectFeedbackListTitle = {$: 559};
var $author$project$Locale$Messages$TeacherProfilesPageTitle = {$: 596};
var $author$project$Locale$Messages$TimetablePageTitle = {$: 624};
var $author$project$Locale$Messages$TrimesterFeedbackReportPageTitle = {$: 650};
var $author$project$Route$pageTitle = F2(
	function (t_, route) {
		switch (route.$) {
			case 48:
				return t_($author$project$Locale$Messages$AnalyticsLearningContractTitle);
			case 0:
				return t_($author$project$Locale$Messages$GenericPageTitle);
			case 1:
				return t_($author$project$Locale$Messages$LoginPageTitle);
			case 2:
				return t_($author$project$Locale$Messages$GenericPageTitle);
			case 3:
				return t_($author$project$Locale$Messages$GenericPageTitle);
			case 4:
				return t_($author$project$Locale$Messages$CounterPageTitle);
			case 49:
				return t_($author$project$Locale$Messages$CurriculumBrowserTitle);
			case 5:
				return t_(
					$author$project$Locale$Messages$NOTRANS('Hiányzások'));
			case 6:
				return t_($author$project$Locale$Messages$GradeReportsPageTitle);
			case 7:
				return t_($author$project$Locale$Messages$GradeRequestListTitle);
			case 8:
				return t_($author$project$Locale$Messages$GenericPageTitle);
			case 9:
				return t_($author$project$Locale$Messages$LearningContractsTitle);
			case 10:
				return t_($author$project$Locale$Messages$LearningContractsTitle);
			case 11:
				return t_($author$project$Locale$Messages$LearningContractsTitle);
			case 12:
				return t_($author$project$Locale$Messages$LearningGroupListTitle);
			case 13:
				return t_($author$project$Locale$Messages$LearningGroupListTitle);
			case 15:
				return t_($author$project$Locale$Messages$LearningGroupListTitle);
			case 16:
				return t_($author$project$Locale$Messages$ModuleClosureOverviewPageTitle);
			case 17:
				return t_($author$project$Locale$Messages$ModulesClosurePageTitle);
			case 18:
				return t_($author$project$Locale$Messages$ModuleTeacherProfilesPageTitle);
			case 19:
				return t_($author$project$Locale$Messages$ModulesTitle);
			case 20:
				return t_($author$project$Locale$Messages$ModulesTitle);
			case 21:
				return t_($author$project$Locale$Messages$ModulesTitle);
			case 22:
				return t_($author$project$Locale$Messages$ModulesTitle);
			case 23:
				return t_($author$project$Locale$Messages$ModulesTitle);
			case 24:
				return t_($author$project$Locale$Messages$ModulesTitle);
			case 25:
				return t_($author$project$Locale$Messages$NotificationsTitle);
			case 26:
				return t_($author$project$Locale$Messages$PhoneBookTitle);
			case 27:
				return t_($author$project$Locale$Messages$PortfoliosTitle);
			case 28:
				return t_($author$project$Locale$Messages$PortfoliosTitle);
			case 29:
				return t_($author$project$Locale$Messages$PortfoliosTitle);
			case 30:
				return t_($author$project$Locale$Messages$PortfoliosTitle);
			case 31:
				return t_($author$project$Locale$Messages$PortfoliosTitle);
			case 32:
				return t_($author$project$Locale$Messages$ProfilesTitle);
			case 33:
				return t_($author$project$Locale$Messages$RubricsTitle);
			case 34:
				return t_($author$project$Locale$Messages$RubricsTitle);
			case 37:
				return t_($author$project$Locale$Messages$RubricSubjectOverviewTitle);
			case 35:
				return t_($author$project$Locale$Messages$RubricsTitle);
			case 36:
				return t_($author$project$Locale$Messages$RubricsTitle);
			case 38:
				return t_($author$project$Locale$Messages$StudentProfileFormPageTitle);
			case 39:
				return t_($author$project$Locale$Messages$StudentProfileFormPageTitle);
			case 40:
				return t_($author$project$Locale$Messages$StudentListTitleStudents);
			case 41:
				return t_($author$project$Locale$Messages$SubjectFeedbackListTitle);
			case 42:
				return t_($author$project$Locale$Messages$TeacherProfilesPageTitle);
			case 43:
				return t_($author$project$Locale$Messages$TimetablePageTitle);
			case 44:
				return t_($author$project$Locale$Messages$TimetablePageTitle);
			case 45:
				return t_($author$project$Locale$Messages$TimetablePageTitle);
			case 46:
				return t_($author$project$Locale$Messages$TrimesterFeedbackReportPageTitle);
			case 14:
				return t_($author$project$Locale$Messages$CompanyContractPageTitle);
			case 47:
				return t_($author$project$Locale$Messages$GradingPageTitle);
			default:
				return t_($author$project$Locale$Messages$ReconciliationPageTitle);
		}
	});
var $author$project$Log$paramScopeHome = 'scope_home';
var $author$project$Ports$sendPageView = _Platform_outgoingPort(
	'sendPageView',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pagePath',
					$elm$json$Json$Encode$string($.m1)),
					_Utils_Tuple2(
					'pageTitle',
					$elm$json$Json$Encode$string($.m2))
				]));
	});
var $author$project$Application$V2$Boundaries$updateElement = F5(
	function (key, session, msg, model, element) {
		var _v0 = A2(
			element.ha.ks,
			msg,
			_Utils_update(
				model,
				{gB: session}));
		var model2 = _v0.a;
		var effect = _v0.b;
		var reply = _v0.c;
		var cmd = A2(element.ha.hP, key, effect);
		return A2(
			$author$project$Application$V2$Boundaries$andThenCmd,
			cmd,
			A2(
				$author$project$Application$V2$Boundaries$addReply,
				reply,
				A2($author$project$Application$V2$Boundaries$save, model2, model2.gB)));
	});
var $author$project$Element$HomePage$update = F3(
	function (session, msg, model) {
		var t_ = session.h6;
		var noop = A2($author$project$Application$Boundaries$save, model, session);
		var updatePortfolios = F2(
			function (portfoliosMsg, portfoliosModel) {
				return A3(
					$author$project$Application$V2$Boundaries$mapElement,
					noop,
					$author$project$Element$HomePage$portfolios,
					A5($author$project$Application$V2$Boundaries$updateElement, model.b_.jk, session, portfoliosMsg, portfoliosModel, $author$project$Element$HomePage$portfolios));
			});
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var list = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								fG: $elm$core$Maybe$Just(list)
							}),
						session);
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							model.b_,
							_Utils_Tuple3(
								$author$project$Log$msgActivityLogsDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeHome),
								error),
							$elm$core$Basics$always($author$project$Element$HomePage$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								session.h6($author$project$Locale$Messages$ActivityLogsDownloadError))));
				}
			case 1:
				return noop;
			case 2:
				var posix = msg.a;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{
							fd: $elm$core$Maybe$Just(posix)
						}),
					session);
			case 3:
				if (!msg.a.$) {
					var students = msg.a.a;
					var isSponsoredOrViewer = function (student) {
						return A2($author$project$Person$isSponsorOf, session.ok, student) || A2($author$project$Person$isSamePerson, session.ok, student);
					};
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$ok,
							model.b_,
							_Utils_Tuple2(
								$author$project$Log$msgStudentsDownload,
								_List_fromArray(
									[$author$project$Log$paramScopeHome, $author$project$Log$paramOk])),
							$elm$core$Basics$always($author$project$Element$HomePage$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									fv: $elm$core$Maybe$Just(
										A2($elm$core$List$filter, isSponsoredOrViewer, students))
								}),
							session));
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							model.b_,
							_Utils_Tuple3(
								$author$project$Log$msgStudentsDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeHome),
								error),
							$elm$core$Basics$always($author$project$Element$HomePage$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$StudentListDownloadError))));
				}
			case 4:
				var cmd = $author$project$Ports$sendPageView(
					{
						m1: $author$project$Route$toString($author$project$Route$AnalyticsLearningContract),
						m2: A2($author$project$Route$pageTitle, t_, $author$project$Route$AnalyticsLearningContract)
					});
				return A2($author$project$Application$Boundaries$andThenCmd, cmd, noop);
			default:
				var portfoliosMsg = msg.a;
				var _v1 = model.fk;
				if (!_v1.$) {
					var portfoliosModel = _v1.a;
					var portfoliosUpdated = A2(updatePortfolios, portfoliosMsg, portfoliosModel);
					return {dX: portfoliosUpdated.dX, eh: portfoliosUpdated.eh, gs: $elm$core$Maybe$Nothing, gB: portfoliosUpdated.gB};
				} else {
					return noop;
				}
		}
	});
var $author$project$Element$HomePage$hasStudentTiles = function (viewer) {
	return $author$project$Person$isSponsor(viewer) || $author$project$Person$isStudent(viewer);
};
var $author$project$Element$HomePage$hasTeacherTiles = function (viewer) {
	return $author$project$ACL$isStaff(viewer) || $author$project$Person$isModuleTeacher(viewer);
};
var $author$project$Locale$Messages$ActivityLogsEmpty = {$: 8};
var $author$project$Locale$Messages$ActivityLogsLoadingProgress = {$: 7};
var $author$project$Locale$Messages$ActivityLogsTitle = {$: 15};
var $author$project$Locale$Messages$ActivityLogsView = {$: 16};
var $author$project$Locale$Messages$TimeDateFormat = F2(
	function (a, b) {
		return {$: 601, a: a, b: b};
	});
var $author$project$Locale$Messages$TimeSingleFormat = F2(
	function (a, b) {
		return {$: 603, a: a, b: b};
	});
var $author$project$UI$Icon$learningContract = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-handshake'),
			attributes));
};
var $author$project$UI$Icon$mentorMemo = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-clipboard'),
			attributes));
};
var $author$project$Element$NotificationList$activityTypeToIcon = function (type_) {
	switch (type_) {
		case 0:
			return $author$project$UI$Icon$learningContract(_List_Nil);
		case 2:
			return $author$project$UI$Icon$icon(
				_List_fromArray(
					[
						$author$project$UI$Icon$face('fa-image')
					]));
		case 3:
			return $author$project$UI$Icon$icon(
				_List_fromArray(
					[
						$author$project$UI$Icon$face('fa-id-card')
					]));
		case 1:
			return $author$project$UI$Icon$mentorMemo(_List_Nil);
		default:
			return $author$project$UI$none;
	}
};
var $author$project$Locale$Messages$ActivityLogsChangesCaption = {$: 1};
var $author$project$Locale$Messages$ActivityLogsChangesItem = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$ActivityLogsChangesItemDiff = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$ActivityLog$changes = F2(
	function (dict1, dict2) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var field = _v0.a;
				var oldValue = _v0.b;
				var v = A2($elm$core$Dict$get, field, dict2);
				if (!v.$) {
					var newValue = v.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(field, oldValue, newValue));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			$elm$core$Dict$toList(dict1));
	});
var $author$project$Locale$Messages$LearningContractsEndDate = {$: 125};
var $author$project$Locale$Messages$LearningContractsStartDate = {$: 126};
var $author$project$Locale$Messages$LearningContractsStudent = {$: 127};
var $author$project$Locale$Messages$LearningContractsUrl = {$: 128};
var $author$project$LearningContract$fieldLabel = F2(
	function (t_, field) {
		switch (field) {
			case 'student':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$LearningContractsStudent));
			case 'end_date':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$LearningContractsEndDate));
			case 'start_date':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$LearningContractsStartDate));
			case 'url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$LearningContractsUrl));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Locale$Messages$ModuleTeacherProfilesCompetencies = {$: 214};
var $author$project$Locale$Messages$ModuleTeacherProfilesResidenceAddress = {$: 213};
var $author$project$Locale$Messages$ModuleTeacherProfilesResidencePermit = {$: 212};
var $author$project$ModuleTeacherProfile$fieldLabel = F2(
	function (t_, field) {
		switch (field) {
			case 'residence_permit':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$ModuleTeacherProfilesResidencePermit));
			case 'residence_address':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$ModuleTeacherProfilesResidenceAddress));
			case 'competencies':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$ModuleTeacherProfilesCompetencies));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Locale$Messages$PersonEduId = {$: 333};
var $author$project$Locale$Messages$PersonNationality = {$: 331};
var $author$project$Locale$Messages$PersonSsn = {$: 332};
var $author$project$Locale$Messages$PersonSupervisingSchool = {$: 334};
var $author$project$Locale$Messages$PersonTeam = {$: 319};
var $author$project$Person$fieldLabel = F2(
	function (t_, field) {
		switch (field) {
			case 'first_name':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonFirstName));
			case 'last_name':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonLastName));
			case 'phone_number':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonPhone));
			case 'email':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonEmail));
			case 'birthplace':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonBirthPlaceTown));
			case 'birthplace_country':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonBirthPlaceCountry));
			case 'birthdate':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonBirthDate));
			case 'nationality':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonNationality));
			case 'edu_id':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonEduId));
			case 'ssn':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonSsn));
			case 'supervising_school':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonSupervisingSchool));
			case 'address':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonAddress));
			case 'team':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonTeam));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Locale$Messages$PortfolioStoryCreatedAt = {$: 354};
var $author$project$Locale$Messages$PortfolioStoryCreatedBy = {$: 353};
var $author$project$Locale$Messages$PortfolioStoryDescription = {$: 350};
var $author$project$Locale$Messages$PortfolioStoryMedia = {$: 351};
var $author$project$Locale$Messages$PortfolioStoryModule = {$: 352};
var $author$project$Locale$Messages$PortfolioStoryStudents = {$: 356};
var $author$project$Locale$Messages$PortfolioStoryTeam = {$: 355};
var $author$project$PortfolioStory$fieldLabel = F2(
	function (t_, field) {
		switch (field) {
			case 'description':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PortfolioStoryDescription));
			case 'media':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PortfolioStoryMedia));
			case 'module':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PortfolioStoryModule));
			case 'created_by':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PortfolioStoryCreatedBy));
			case 'created_at':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PortfolioStoryCreatedAt));
			case 'team':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PortfolioStoryTeam));
			case 'students':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PortfolioStoryStudents));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Locale$Messages$StudentProfileFormAccidents = {$: 499};
var $author$project$Locale$Messages$StudentProfileFormAdmission = {$: 494};
var $author$project$Locale$Messages$StudentProfileFormBasicTask = {$: 496};
var $author$project$Locale$Messages$StudentProfileFormBirthCertificateUrl = {$: 518};
var $author$project$Locale$Messages$StudentProfileFormCompetencyTestResults = {$: 500};
var $author$project$Locale$Messages$StudentProfileFormCurrentGrade = {$: 514};
var $author$project$Locale$Messages$StudentProfileFormDisciplinaryAndCompensationCases = {$: 504};
var $author$project$Locale$Messages$StudentProfileFormEvaluationUrl = {$: 502};
var $author$project$Locale$Messages$StudentProfileFormExams = {$: 503};
var $author$project$Locale$Messages$StudentProfileFormFirstForeignLanguage = {$: 515};
var $author$project$Locale$Messages$StudentProfileFormIdCardUrl = {$: 519};
var $author$project$Locale$Messages$StudentProfileFormIndividualStudentUrl = {$: 513};
var $author$project$Locale$Messages$StudentProfileFormIsIndividualStudent = {$: 512};
var $author$project$Locale$Messages$StudentProfileFormLastReportCardUrl = {$: 501};
var $author$project$Locale$Messages$StudentProfileFormMissedClasses = {$: 498};
var $author$project$Locale$Messages$StudentProfileFormMothersMaidenName = {$: 495};
var $author$project$Locale$Messages$StudentProfileFormNekId = {$: 523};
var $author$project$Locale$Messages$StudentProfileFormNekIdUrl = {$: 524};
var $author$project$Locale$Messages$StudentProfileFormResidencePermitUrl = {$: 493};
var $author$project$Locale$Messages$StudentProfileFormSchoolYearRepetition = {$: 507};
var $author$project$Locale$Messages$StudentProfileFormSecondForeignLanguage = {$: 516};
var $author$project$Locale$Messages$StudentProfileFormSpecialStatus = {$: 509};
var $author$project$Locale$Messages$StudentProfileFormSpecialStatusUrl = {$: 511};
var $author$project$Locale$Messages$StudentProfileFormSsnUrl = {$: 522};
var $author$project$Locale$Messages$StudentProfileFormState = {$: 492};
var $author$project$Locale$Messages$StudentProfileFormStudentCardId = {$: 505};
var $author$project$Locale$Messages$StudentProfileFormTaxIdUrl = {$: 521};
var $author$project$Locale$Messages$StudentProfileFormTermination = {$: 497};
var $author$project$Locale$Messages$StudentProfileFormTextbookSupply = {$: 506};
var $author$project$Locale$Messages$StudentProfileFormTripAbroad = {$: 508};
var $author$project$StudentProfile$fieldLabel = F2(
	function (t_, field) {
		switch (field) {
			case 'state':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormState));
			case 'mothers_name':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormMothersMaidenName));
			case 'admission':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormAdmission));
			case 'basic_task':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormBasicTask));
			case 'termination':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormTermination));
			case 'missed_classes':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormMissedClasses));
			case 'accidents':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormAccidents));
			case 'competency_test_results':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormCompetencyTestResults));
			case 'exams':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormExams));
			case 'disciplinary_and_compensation_cases':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormDisciplinaryAndCompensationCases));
			case 'student_card_id':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormStudentCardId));
			case 'textbook_supply':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormTextbookSupply));
			case 'school_year_repetition':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormSchoolYearRepetition));
			case 'trip_abroad':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormTripAbroad));
			case 'sni_status':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormSpecialStatus));
			case 'is_individual_student':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormIsIndividualStudent));
			case 'current_grade':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormCurrentGrade));
			case 'first_foreign_language':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormFirstForeignLanguage));
			case 'second_foreign_language':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormSecondForeignLanguage));
			case 'last_report_card_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormLastReportCardUrl));
			case 'evaluation_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormEvaluationUrl));
			case 'individual_student_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormIndividualStudentUrl));
			case 'sni_report_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormSpecialStatusUrl));
			case 'student_card_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormStudentCardId));
			case 'birth_certificate_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormBirthCertificateUrl));
			case 'residence_permit_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormResidencePermitUrl));
			case 'id_card_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormIdCardUrl));
			case 'tax_id_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormTaxIdUrl));
			case 'ssn_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormSsnUrl));
			case 'nek_id':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormNekId));
			case 'nek_id_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormNekIdUrl));
			default:
				var field_ = field;
				return A2($elm$core$String$startsWith, 'student_', field_) ? A2(
					$author$project$Person$fieldLabel,
					t_,
					A3($elm$core$String$replace, 'student_', '', field_)) : $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Locale$Messages$TeacherProfileApprenticeshipYears = {$: 584};
var $author$project$Locale$Messages$TeacherProfileBirthFirstName = {$: 576};
var $author$project$Locale$Messages$TeacherProfileBirthHasFamilyNameFirst = {$: 578};
var $author$project$Locale$Messages$TeacherProfileBirthLastName = {$: 577};
var $author$project$Locale$Messages$TeacherProfileDiplomaUrl = {$: 586};
var $author$project$Locale$Messages$TeacherProfileHighestEducationLevel = {$: 583};
var $author$project$Locale$Messages$TeacherProfileIsAcademicMember = {$: 585};
var $author$project$Locale$Messages$TeacherProfileMotherFirstName = {$: 580};
var $author$project$Locale$Messages$TeacherProfileMotherHasFamilyNameFirst = {$: 582};
var $author$project$Locale$Messages$TeacherProfileMotherLastName = {$: 581};
var $author$project$Locale$Messages$TeacherProfileMotherNamePrefix = {$: 579};
var $author$project$Locale$Messages$TeacherProfileState = {$: 574};
var $author$project$Locale$Messages$TeacherProfileTeacher = {$: 575};
var $author$project$TeacherProfile$fieldLabel = F2(
	function (t_, field) {
		switch (field) {
			case 'state':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileState));
			case 'teacher':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileTeacher));
			case 'birth_first_name':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileBirthFirstName));
			case 'birth_last_name':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileBirthLastName));
			case 'birth_has_family_name_first':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileBirthHasFamilyNameFirst));
			case 'mother_name_prefix':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileMotherNamePrefix));
			case 'mother_first_name':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileMotherFirstName));
			case 'mother_last_name':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileMotherLastName));
			case 'mother_has_family_name_first':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileMotherHasFamilyNameFirst));
			case 'highest_education_level':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileHighestEducationLevel));
			case 'apprenticeship_years':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileApprenticeshipYears));
			case 'is_academic_member':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileIsAcademicMember));
			case 'diploma_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileDiplomaUrl));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Element$NotificationList$fieldLabel = F3(
	function (t_, messageType, field) {
		var noTrans = F2(
			function (_v1, x) {
				return $elm$core$Maybe$Just(x);
			});
		var label = function () {
			switch (messageType) {
				case 0:
					return $author$project$LearningContract$fieldLabel;
				case 1:
					return $author$project$LearningContract$fieldLabel;
				case 2:
					return noTrans;
				case 3:
					return $author$project$ModuleTeacherProfile$fieldLabel;
				case 4:
					return $author$project$PortfolioStory$fieldLabel;
				case 5:
					return $author$project$PortfolioStory$fieldLabel;
				case 6:
					return $author$project$Person$fieldLabel;
				case 7:
					return $author$project$StudentProfile$fieldLabel;
				case 8:
					return $author$project$TeacherProfile$fieldLabel;
				default:
					return noTrans;
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			field,
			A2(label, t_, field));
	});
var $author$project$StudentProfile$studentDocumentFields = _List_fromArray(
	['last_report_card_url', 'evaluation_url', 'individual_student_url', 'sni_report_url', 'student_card_url', 'birth_certificate_url', 'residence_permit_url', 'id_card_url', 'tax_id_url', 'ssn_url', 'nek_id_url']);
var $author$project$TeacherProfile$teacherDocumentFields = _List_fromArray(
	['diploma_url']);
var $author$project$Element$NotificationList$viewChanges = F3(
	function (t_, msg, context) {
		var diffToText = function (_v1) {
			var fieldName = _v1.a;
			var oldValue = _v1.b;
			var newValue = _v1.c;
			return A2($elm$core$List$member, fieldName, $author$project$StudentProfile$studentDocumentFields) ? t_(
				$author$project$Locale$Messages$ActivityLogsChangesItem(
					A3($author$project$Element$NotificationList$fieldLabel, t_, msg.mA, fieldName))) : (A2($elm$core$List$member, fieldName, $author$project$TeacherProfile$teacherDocumentFields) ? t_(
				$author$project$Locale$Messages$ActivityLogsChangesItem(
					A3($author$project$Element$NotificationList$fieldLabel, t_, msg.mA, fieldName))) : t_(
				A3(
					$author$project$Locale$Messages$ActivityLogsChangesItemDiff,
					A3($author$project$Element$NotificationList$fieldLabel, t_, msg.mA, fieldName),
					oldValue,
					newValue)));
		};
		var changes = A2($author$project$ActivityLog$changes, context.lJ, context.n4);
		var changesText = A2(
			$elm$core$String$join,
			', ',
			A2($elm$core$List$map, diffToText, changes));
		if (!changes.b) {
			return $author$project$UI$none;
		} else {
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('is-size-7')
					]),
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ActivityLogsChangesCaption),
						$elm$html$Html$text(changesText)
					]));
		}
	});
var $author$project$Locale$Messages$ActivityLogsLearningContractCreated = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Locale$Messages$ActivityLogsLearningContractUpdated = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Locale$Messages$ActivityLogsMentorMemoUpdated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Locale$Messages$ActivityLogsModuleTeacherProfileUpdated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Locale$Messages$ActivityLogsPortfolioStoryCreated = function (a) {
	return {$: 11, a: a};
};
var $author$project$Locale$Messages$ActivityLogsProfileUpdated = function (a) {
	return {$: 12, a: a};
};
var $author$project$Locale$Messages$ActivityLogsStudentProfileUpdated = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Locale$Messages$ActivityLogsTeacherProfileUpdated = function (a) {
	return {$: 14, a: a};
};
var $author$project$Element$NotificationList$viewMessage = F2(
	function (t_, log) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-marginless')
				]),
			_List_fromArray(
				[
					function () {
					if (!log.$) {
						var msg = log.a;
						var context = log.b;
						var _v1 = msg.mA;
						switch (_v1) {
							case 1:
								var teacher = A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Dict$get, 'teacher', context.lC));
								var student = A2($author$project$Person$fullName, t_, msg.m8);
								return A2(
									$elm$html$Html$span,
									_List_Nil,
									$author$project$UI$textToHtml(
										t_(
											A2($author$project$Locale$Messages$ActivityLogsLearningContractUpdated, teacher, student))));
							case 0:
								var teacher = A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Dict$get, 'teacher', context.lC));
								var student = A2($author$project$Person$fullName, t_, msg.m8);
								return A2(
									$elm$html$Html$span,
									_List_Nil,
									$author$project$UI$textToHtml(
										t_(
											A2($author$project$Locale$Messages$ActivityLogsLearningContractCreated, teacher, student))));
							case 6:
								var person = A2($author$project$Person$fullName, t_, msg.m8);
								return A2(
									$elm$html$Html$span,
									_List_Nil,
									$author$project$UI$textToHtml(
										t_(
											$author$project$Locale$Messages$ActivityLogsProfileUpdated(person))));
							case 7:
								var student = A2($author$project$Person$fullName, t_, msg.m8);
								var approvedBy = A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Dict$get, 'approved_by', context.lC));
								return A2(
									$elm$html$Html$span,
									_List_Nil,
									$author$project$UI$textToHtml(
										t_(
											A2($author$project$Locale$Messages$ActivityLogsStudentProfileUpdated, approvedBy, student))));
							case 8:
								var teacher = A2($author$project$Person$fullName, t_, msg.m8);
								return A2(
									$elm$html$Html$span,
									_List_Nil,
									$author$project$UI$textToHtml(
										t_(
											$author$project$Locale$Messages$ActivityLogsTeacherProfileUpdated(teacher))));
							case 3:
								var teacher = A2($author$project$Person$fullName, t_, msg.m8);
								return A2(
									$elm$html$Html$span,
									_List_Nil,
									$author$project$UI$textToHtml(
										t_(
											$author$project$Locale$Messages$ActivityLogsModuleTeacherProfileUpdated(teacher))));
							case 2:
								var person = A2($author$project$Person$fullName, t_, msg.m8);
								return A2(
									$elm$html$Html$span,
									_List_Nil,
									$author$project$UI$textToHtml(
										t_(
											$author$project$Locale$Messages$ActivityLogsMentorMemoUpdated(person))));
							default:
								return $author$project$UI$none;
						}
					} else {
						var msg = log.a;
						var context = log.b;
						var _v2 = msg.mA;
						switch (_v2) {
							case 4:
								var viewMedia = function (media) {
									return A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												function () {
												var _v3 = $author$project$Util$Media$mediaViewerByExt(media);
												if (!_v3) {
													return A2(
														$elm$html$Html$img,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$src(media)
															]),
														_List_Nil);
												} else {
													return $author$project$UI$none;
												}
											}()
											]));
								};
								var student = A2($author$project$Person$fullName, t_, msg.m8);
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$UI$caption,
													t_,
													$author$project$Locale$Messages$ActivityLogsPortfolioStoryCreated(student))
												])),
											A2($author$project$UI$maybe, context.mw.nH, viewMedia)
										]));
							case 5:
								return $author$project$UI$none;
							default:
								return $author$project$UI$none;
						}
					}
				}()
				]));
	});
var $author$project$Element$NotificationList$viewActivityLog = F3(
	function (t_, now, log) {
		var viewTime = function (msg) {
			if (!now.$) {
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$caption,
							t_,
							A2(
								$author$project$Locale$Messages$TimeDateFormat,
								$elm$time$Time$utc,
								$elm$time$Time$millisToPosix(msg.lR))),
							$elm$html$Html$text(' '),
							A2(
							$author$project$UI$caption,
							t_,
							A2(
								$author$project$Locale$Messages$TimeSingleFormat,
								$elm$time$Time$utc,
								$elm$time$Time$millisToPosix(msg.lR)))
						]));
			} else {
				return $author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-spinner fa-spin fa-sm'),
							$author$project$UI$Icon$style('is-small')
						]));
			}
		};
		var viewLink = function (msg) {
			return A2(
				$author$project$UI$when,
				!$elm$core$String$isEmpty(msg.mT),
				A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(msg.mT),
							$elm$html$Html$Attributes$class('mr-4')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ActivityLogsView)
						])));
		};
		var viewNav = function (msg) {
			return A2(
				$author$project$UI$nav,
				_List_fromArray(
					[
						viewLink(msg),
						viewTime(msg)
					]),
				_List_Nil);
		};
		var viewIcon = function (msg) {
			return $author$project$Element$NotificationList$activityTypeToIcon(msg.kM);
		};
		if (!log.$) {
			var msg = log.a;
			var context = log.b;
			return A4(
				$author$project$UI$mediaObjectXS,
				_List_fromArray(
					[
						viewIcon(msg)
					]),
				_List_fromArray(
					[
						A2($author$project$Element$NotificationList$viewMessage, t_, log),
						A3($author$project$Element$NotificationList$viewChanges, t_, msg, context)
					]),
				_List_fromArray(
					[
						viewNav(msg)
					]),
				_List_Nil);
		} else {
			var msg = log.a;
			return A4(
				$author$project$UI$mediaObjectXS,
				_List_fromArray(
					[
						viewIcon(msg)
					]),
				_List_fromArray(
					[
						A2($author$project$Element$NotificationList$viewMessage, t_, log)
					]),
				_List_fromArray(
					[
						viewNav(msg)
					]),
				_List_Nil);
		}
	});
var $author$project$Element$NotificationList$viewActivityLogs = F3(
	function (t_, now, maybeLogs) {
		if (!maybeLogs.$) {
			if (!maybeLogs.a.b) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tile is-child')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ActivityLogsEmpty)
						]));
			} else {
				var logs = maybeLogs.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tile is-child')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('heading')
								]),
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ActivityLogsTitle)
								])),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list')
								]),
							A2(
								$elm$core$List$map,
								function (log) {
									return A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('list-item')
											]),
										_List_fromArray(
											[
												A3($author$project$Element$NotificationList$viewActivityLog, t_, now, log)
											]));
								},
								A2(
									$elm$core$List$filter,
									function (log) {
										if (!log.$) {
											var msg = log.a;
											return msg.mA !== 9;
										} else {
											var msg = log.a;
											return msg.mA !== 9;
										}
									},
									logs)))
						]));
			}
		} else {
			return A2(
				$author$project$UI$progressBar,
				'is-link',
				t_($author$project$Locale$Messages$ActivityLogsLoadingProgress));
		}
	});
var $author$project$Application$V2$Boundaries$viewElement = F3(
	function (session, model, element) {
		return A2(
			$elm$html$Html$map,
			element.cf,
			element.ha.og(
				_Utils_update(
					model,
					{gB: session})));
	});
var $author$project$Element$HomePage$viewPortfolios = F2(
	function (session, model) {
		return A3($author$project$Application$V2$Boundaries$viewElement, session, model, $author$project$Element$HomePage$portfolios);
	});
var $author$project$Locale$Messages$HomePhoneBookTileContent = {$: 115};
var $author$project$Locale$Messages$HomePhoneBookTileTitle = {$: 116};
var $author$project$UI$tile = F4(
	function (style, route, title_, content) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tile is-parent'),
					$author$project$Route$href(route)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$article,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tile is-child notification'),
							$elm$html$Html$Attributes$class(style)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title_)
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(content)
								]))
						]))
				]));
	});
var $author$project$Element$HomePage$viewTilePhonebook = function (t_) {
	return A4(
		$author$project$UI$tile,
		'is-success',
		$author$project$Route$PhoneBook,
		t_($author$project$Locale$Messages$HomePhoneBookTileTitle),
		t_($author$project$Locale$Messages$HomePhoneBookTileContent));
};
var $author$project$Locale$Messages$HomeStudentsTileContent = {$: 117};
var $author$project$Locale$Messages$HomeStudentsTileTitle = {$: 118};
var $author$project$Element$HomePage$viewTileStudents = function (t_) {
	return A4(
		$author$project$UI$tile,
		'is-warning',
		$author$project$Route$StudentList,
		t_($author$project$Locale$Messages$HomeStudentsTileTitle),
		t_($author$project$Locale$Messages$HomeStudentsTileContent));
};
var $author$project$Locale$Messages$StudentListLoadingProgress = {$: 543};
var $author$project$Locale$Messages$HomeChildrenSponsors = {$: 114};
var $author$project$ACL$canSignCompanyContract = F2(
	function (person, now) {
		var isNowWithinSigningWindow = function () {
			var month = A2($elm$time$Time$toMonth, $elm$time$Time$utc, now);
			var day = A2($elm$time$Time$toDay, $elm$time$Time$utc, now);
			return !function () {
				switch (month) {
					case 1:
						return false;
					case 2:
						return day >= 15;
					case 3:
						return true;
					case 4:
						return day <= 31;
					default:
						return false;
				}
			}();
		}();
		return $author$project$Person$isSponsor(person) && isNowWithinSigningWindow;
	});
var $author$project$ACL$canViewGradeRequests = function (person) {
	return $author$project$ACL$isStaff(person) || ($author$project$Person$isModuleTeacher(person) || ($author$project$Person$isTeacher(person) || $author$project$Person$isSponsor(person)));
};
var $author$project$ACL$canViewProfiles = function (_v0) {
	return $author$project$ACL$everyone;
};
var $author$project$ACL$canViewStudentFeedbacks = function (person) {
	return $author$project$Person$isActiveMember(person) && $author$project$ACL$isSchoolMember(person);
};
var $author$project$ACL$canViewTimetables = function (person) {
	return $author$project$Person$isActiveMember(person) && $author$project$ACL$isSchoolMember(person);
};
var $author$project$UI$Icon$graduate = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-user-graduate'),
			attributes));
};
var $author$project$UI$Icon$profile = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-user'),
			attributes));
};
var $author$project$UI$tile2 = F2(
	function (style, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tile is-parent')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$article,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tile is-child notification'),
							$elm$html$Html$Attributes$class(style)
						]),
					content)
				]));
	});
var $author$project$Element$HomePage$LearningContractOpened = {$: 4};
var $author$project$Locale$Messages$StudentListSignCompanyContract = {$: 548};
var $author$project$Element$HomePage$viewCompanyContractCreateLink = F2(
	function (t_, child) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick($author$project$Element$HomePage$LearningContractOpened),
					$author$project$Route$href(
					$author$project$Route$CompanyContractCreate(child.i8)),
					$elm$html$Html$Attributes$target('_blank'),
					$author$project$UI$attrCyData('home-companycontract-view'),
					$elm$html$Html$Attributes$class('button')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$learningContract(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-info')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListSignCompanyContract)
						]))
				]));
	});
var $author$project$Locale$Messages$StudentListViewGradeReport = {$: 550};
var $author$project$UI$Icon$grades = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-award'),
			attributes));
};
var $author$project$Element$HomePage$viewGradeReportsLink = F2(
	function (t_, child) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$LearningAssessmentCard(child.i8)),
					$author$project$UI$attrCyData(
					'learning-assessment-view' + A2($elm$core$Maybe$withDefault, '', child.O)),
					$elm$html$Html$Attributes$class('button')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$grades(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-primary')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewGradeReport)
						]))
				]));
	});
var $author$project$Element$HomePage$viewGradeRequestsLink = F2(
	function (t_, child) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					A2($author$project$Route$GradeRequestList, child.i8, $elm$core$Maybe$Nothing)),
					$author$project$UI$attrCyData(
					'grade-request-view' + A2($elm$core$Maybe$withDefault, '', child.O)),
					$elm$html$Html$Attributes$class('button')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$grades(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-primary')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestListTitle)
						]))
				]));
	});
var $author$project$Locale$Messages$StudentListViewLearningContract = {$: 546};
var $author$project$UI$Icon$noData = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-ban'),
			attributes));
};
var $author$project$Element$HomePage$viewLearningContractLink = F2(
	function (t_, child) {
		var _v0 = child.kL;
		if (!_v0.$) {
			var contract = _v0.a;
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Element$HomePage$LearningContractOpened),
						$elm$html$Html$Attributes$href(contract.K),
						$elm$html$Html$Attributes$target('_blank'),
						$author$project$UI$attrCyData('home-learningcontracts-view'),
						$elm$html$Html$Attributes$class('button')
					]),
				_List_fromArray(
					[
						$author$project$UI$Icon$learningContract(
						_List_fromArray(
							[
								$author$project$UI$Icon$style('has-text-info')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewLearningContract)
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$UI$Icon$noData(_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewLearningContract)
							]))
					]));
		}
	});
var $author$project$Locale$Messages$StudentMentor = function (a) {
	return {$: 458, a: a};
};
var $author$project$Locale$Messages$StudentMissingMentor = {$: 459};
var $elm$html$Html$mark = _VirtualDom_node('mark');
var $author$project$Element$StudentList$viewMentorText = F2(
	function (t_, maybeMentor) {
		if (!maybeMentor.$) {
			var mentor = maybeMentor.a;
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$UI$caption,
						t_,
						$author$project$Locale$Messages$StudentMentor(
							A2($author$project$Person$fullName, t_, mentor)))
					]));
		} else {
			return A2(
				$elm$html$Html$mark,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentMissingMentor)
					]));
		}
	});
var $author$project$Locale$Messages$HomeStudentsProfile = {$: 119};
var $author$project$Element$HomePage$viewProfileLink = F2(
	function (t_, child) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$StudentProfileUpdate(child.i8)),
					$author$project$UI$attrCyData('home-student-edit'),
					$elm$html$Html$Attributes$class('button')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$profile(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-link')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$HomeStudentsProfile)
						]))
				]));
	});
var $author$project$Locale$Messages$StudentListViewStudentAbsenceList = {$: 551};
var $author$project$UI$Icon$absence = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-helicopter'),
			attributes));
};
var $author$project$Element$HomePage$viewStudentAbsencesLink = F2(
	function (t_, child) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('https://intezmenykereso.e-kreta.hu/#'),
					$author$project$UI$attrCyData(
					'student-absence-view ' + A2($elm$core$Maybe$withDefault, '', child.O)),
					$elm$html$Html$Attributes$class('button')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$absence(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-primary')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewStudentAbsenceList)
						]))
				]));
	});
var $author$project$Locale$Messages$StudentListViewSubjectFeedback = {$: 554};
var $author$project$Element$HomePage$viewSubjectFeedbackLink = F2(
	function (t_, child) {
		var params = {W: $elm$core$Maybe$Nothing, mB: $elm$core$Maybe$Nothing, gE: $elm$core$Maybe$Nothing};
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					A2($author$project$Route$SubjectFeedbackList, child.i8, params)),
					$author$project$UI$attrCyData(
					'subject-feedback-card-view ' + A2($elm$core$Maybe$withDefault, '', child.O)),
					$elm$html$Html$Attributes$class('button')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$filter(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-primary')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewSubjectFeedback)
						]))
				]));
	});
var $author$project$Locale$Messages$StudentListViewTimetable = {$: 552};
var $author$project$UI$Icon$moduleEvent = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-clock'),
			attributes));
};
var $author$project$Element$HomePage$viewTimetableLink = F2(
	function (t_, student) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button'),
					$author$project$Route$href(
					$author$project$Route$TimetableCalendar(
						_List_fromArray(
							[student.i8]))),
					$author$project$UI$attrCyData('timetable-view')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$moduleEvent(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-dark')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewTimetable)
						]))
				]));
	});
var $author$project$Locale$Messages$StudentListViewTrimesterFeedback = {$: 553};
var $author$project$Element$HomePage$viewTrimesterFeedbacksLink = F2(
	function (t_, child) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$TrimesterFeedbackReport(child.i8)),
					$author$project$UI$attrCyData(
					'trimester-feedback-report-view ' + A2($elm$core$Maybe$withDefault, '', child.O)),
					$elm$html$Html$Attributes$class('button')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$feedback(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-primary')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewTrimesterFeedback)
						]))
				]));
	});
var $author$project$Element$HomePage$viewTileChild = F4(
	function (t_, viewer, now, child) {
		var viewSponsorLink = function (sponsor) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$author$project$Route$href(
						$author$project$Route$GenericProfileUpdate(sponsor.i8)),
						$author$project$UI$attrCyData('home-sponsor-edit')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Person$fullName, t_, sponsor))
					]));
		};
		var viewSponsors = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-2 mt-2 flex items-center flex-wrap')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$profile(_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-2 mr-2 font-medium')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$HomeChildrenSponsors)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center flex-wrap')
						]),
					A2(
						$elm$core$List$intersperse,
						$elm$html$Html$text(' • '),
						A2($elm$core$List$map, viewSponsorLink, child.nM)))
				]));
		var viewMentor = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-2 mt-2'),
					$author$project$UI$attrCyData('home-mentor')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$graduate(_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-2 mr-2 font-medium')
						]),
					_List_fromArray(
						[
							A2($author$project$Element$StudentList$viewMentorText, t_, child.my)
						]))
				]));
		var viewMedia = A4(
			$author$project$UI$mediaObject,
			_List_fromArray(
				[
					$author$project$UI$gravatar(
					A2($elm$core$Maybe$withDefault, '', child.O))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-size-3 is-size-4-mobile mb-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Person$fullName, t_, child))
						])),
					A2(
					$author$project$UI$maybe,
					child.O,
					function (email) {
						return A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(email)
								]));
					})
				]),
			_List_Nil,
			_List_Nil);
		var viewActions = A2(
			$elm$html$Html$nav,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('columns is-multiline mt-2')
				]),
			A2(
				$elm$core$List$filterMap,
				function (link) {
					return (!_Utils_eq(link, $author$project$UI$none)) ? $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column is-narrow')
								]),
							_List_fromArray(
								[link]))) : $elm$core$Maybe$Nothing;
				},
				_List_fromArray(
					[
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewLearningContracts(viewer),
						A2($author$project$Element$HomePage$viewLearningContractLink, t_, child)),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewProfiles(viewer),
						A2($author$project$Element$HomePage$viewStudentAbsencesLink, t_, child)),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewTimetables(viewer),
						A2($author$project$Element$HomePage$viewTimetableLink, t_, child)),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewStudentFeedbacks(viewer),
						A2($author$project$Element$HomePage$viewTrimesterFeedbacksLink, t_, child)),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewStudentFeedbacks(viewer),
						A2($author$project$Element$HomePage$viewSubjectFeedbackLink, t_, child)),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewStudentFeedbacks(viewer),
						A2($author$project$Element$HomePage$viewGradeReportsLink, t_, child)),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewGradeRequests(viewer),
						A2($author$project$Element$HomePage$viewGradeRequestsLink, t_, child)),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewProfiles(viewer),
						A2($author$project$Element$HomePage$viewProfileLink, t_, child)),
						A2(
						$author$project$UI$when,
						A2($author$project$ACL$canSignCompanyContract, viewer, now),
						A2($author$project$Element$HomePage$viewCompanyContractCreateLink, t_, child))
					])));
		return A2(
			$author$project$UI$tile2,
			'is-light',
			_List_fromArray(
				[viewMedia, viewSponsors, viewMentor, viewActions]));
	});
var $author$project$Element$HomePage$viewTilesChildren = F4(
	function (t_, viewer, maybeStudents, now) {
		var viewGrid = F2(
			function (size, children) {
				return (_Utils_cmp(
					$elm$core$List$length(children),
					size) > 0) ? _Utils_ap(
					A2(
						viewGrid,
						size,
						A2($elm$core$List$take, size, children)),
					A2(
						viewGrid,
						size,
						A2($elm$core$List$drop, size, children))) : _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tile is-ancestor')
							]),
						A2(
							$elm$core$List$map,
							A3($author$project$Element$HomePage$viewTileChild, t_, viewer, now),
							children))
					]);
			});
		if (maybeStudents.$ === 1) {
			return A2(
				$author$project$UI$progressBar,
				'is-info',
				t_($author$project$Locale$Messages$StudentListLoadingProgress));
		} else {
			if (!maybeStudents.a.b) {
				return $author$project$UI$none;
			} else {
				var students = maybeStudents.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					A2(viewGrid, 2, students));
			}
		}
	});
var $author$project$Element$HomePage$view = F2(
	function (session, model) {
		var t_ = session.h6;
		var viewer = session.ok;
		var now = model.fd;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$UI$when,
					$author$project$Element$HomePage$hasTeacherTiles(viewer),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tile is-ancestor')
							]),
						_List_fromArray(
							[
								$author$project$Element$HomePage$viewTileStudents(t_),
								$author$project$Element$HomePage$viewTilePhonebook(t_)
							]))),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							if (!now.$) {
								var posix = now.a;
								return A2(
									$author$project$UI$when,
									$author$project$Element$HomePage$hasStudentTiles(viewer),
									A4($author$project$Element$HomePage$viewTilesChildren, t_, viewer, model.fv, posix));
							} else {
								return $author$project$UI$Icon$loadingOptions(_List_Nil);
							}
						}()
						])),
					A2(
					$author$project$UI$when,
					!$author$project$Element$HomePage$hasPortfolioFeed(viewer),
					A3($author$project$Element$NotificationList$viewActivityLogs, t_, model.fd, model.fG)),
					A2(
					$author$project$UI$maybe,
					model.fk,
					$author$project$Element$HomePage$viewPortfolios(session))
				]));
	});
var $author$project$Element$HomePage$element = {jb: $author$project$Element$HomePage$init, ks: $author$project$Element$HomePage$update, og: $author$project$Element$HomePage$view};
var $author$project$Element$LearningAssessmentCard$PortfolioStoriesDownloading = {$: 0};
var $author$project$Element$LearningAssessmentCard$StoriesDownloadResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LearningAssessmentCard$StudentProfileDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningAssessmentCard$SubjectListDownloaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$PortfolioStory$fetchAllStudentStories = F3(
	function (config, personId, callback) {
		var params = {
			bD: '',
			g2: $elm$core$Maybe$Nothing,
			hb: $elm$core$Maybe$Nothing,
			b0: $elm$core$Maybe$Nothing,
			hH: $elm$core$Maybe$Nothing,
			bF: '',
			ce: -1,
			h2: $elm$core$Maybe$Nothing,
			fv: $elm$core$Maybe$Just(
				_List_fromArray(
					[personId])),
			fx: $elm$core$Maybe$Nothing,
			ii: 'feedback'
		};
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$portfolioStoriesList, config, params),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$PortfolioStory$portfolioStoriesDecoder));
	});
var $author$project$StudentProfile$fetchStudentProfileV2 = F3(
	function (config, id, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$studentProfile, config, id),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$StudentProfile$studentProfileDecoder));
	});
var $author$project$Subject$fetchSubjects = F2(
	function (config, callback) {
		var noCategory = '';
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$subjects, config, noCategory),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$Subject$subjectsDecoder));
	});
var $author$project$Element$LearningAssessmentCard$init = F3(
	function (config, session, params) {
		var model = {b_: config, e7: $author$project$RemoteData$NotAsked, ei: $elm$core$Dict$empty, go: $author$project$Element$LearningAssessmentCard$PortfolioStoriesDownloading, cd: $elm$core$Maybe$Nothing, h5: $author$project$RemoteData$Loading, kb: $author$project$RemoteData$Loading, gG: _List_Nil};
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$StudentProfile$fetchStudentProfileV2, config.gX, params.hA, $author$project$Element$LearningAssessmentCard$StudentProfileDownloaded),
					A3($author$project$PortfolioStory$fetchAllStudentStories, config.gX, params.hA, $author$project$Element$LearningAssessmentCard$StoriesDownloadResponse),
					A2($author$project$Subject$fetchSubjects, config.gX, $author$project$Element$LearningAssessmentCard$SubjectListDownloaded)
				]));
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A2($author$project$Application$Boundaries$save, model, session));
	});
var $author$project$Element$LearningAssessmentCard$ModuleDownloadResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$LearningAssessmentCard$NoOp = {$: 6};
var $author$project$Element$LearningAssessmentCard$PortfolioStoriesDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$StudentProfileFormDownloadError = {$: 531};
var $author$project$Element$LearningAssessmentCard$LearningAssessmentListDownloadedResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$LearningAssessment$fetchLearningAssessmentsByPerson = F3(
	function (config, personId, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$learningAssessmentsByPerson, config, personId),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$LearningAssessment$learningAssessmentListDecoder));
	});
var $author$project$Element$LearningAssessmentCard$downloadGrades = F3(
	function (session, model, studentProfile) {
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A3($author$project$LearningAssessment$fetchLearningAssessmentsByPerson, model.b_.gX, studentProfile.nT.i8, $author$project$Element$LearningAssessmentCard$LearningAssessmentListDownloadedResponse),
			A2(
				$author$project$Application$Boundaries$save,
				_Utils_update(
					model,
					{
						h5: $author$project$RemoteData$Success(studentProfile)
					}),
				session));
	});
var $author$project$Module$fetchOneModule = F3(
	function (config, id, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$module_, config, id),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$Module$moduleDetailedDecoder));
	});
var $author$project$Element$LearningAssessmentCard$compareTab = F2(
	function (left, right) {
		var _v0 = A2($elm$core$Basics$compare, left.eB, right.eB);
		switch (_v0) {
			case 0:
				return 0;
			case 2:
				return 2;
			default:
				var _v1 = A2($elm$core$Basics$compare, left.d3, right.d3);
				switch (_v1) {
					case 0:
						return 0;
					case 2:
						return 2;
					default:
						var _v2 = _Utils_Tuple2(left.ii, right.ii);
						_v2$3:
						while (true) {
							switch (_v2.a) {
								case 1:
									if (_v2.b === 1) {
										var _v3 = _v2.a;
										var _v4 = _v2.b;
										return 1;
									} else {
										var _v10 = _v2.a;
										return 2;
									}
								case 0:
									switch (_v2.b) {
										case 0:
											var _v5 = _v2.a;
											var _v6 = _v2.b;
											return 1;
										case 1:
											break _v2$3;
										default:
											var _v11 = _v2.a;
											var _v12 = _v2.b;
											return 2;
									}
								default:
									switch (_v2.b) {
										case 2:
											var _v7 = _v2.a;
											var _v8 = _v2.b;
											return 1;
										case 1:
											break _v2$3;
										default:
											var _v13 = _v2.a;
											var _v14 = _v2.b;
											return 0;
									}
							}
						}
						var _v9 = _v2.b;
						return 0;
				}
		}
	});
var $author$project$Element$LearningAssessmentCard$EndOfYear = 1;
var $author$project$Element$LearningAssessmentCard$GradingExam = 2;
var $author$project$Element$LearningAssessmentCard$MidYear = 0;
var $author$project$Element$LearningAssessmentCard$learningAssessmentToTab = function (la) {
	var startMonth = A2(
		$elm$time$Time$toMonth,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(la.nN));
	var rawStartYear = A2(
		$elm$time$Time$toYear,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(la.nN));
	var rawEndYear = A2(
		$elm$time$Time$toYear,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(la.ly));
	var learningAssessmentType = function () {
		var _v2 = la.ii;
		switch (_v2) {
			case 0:
				return 0;
			case 1:
				return 1;
			default:
				return 2;
		}
	}();
	var _v0 = function () {
		if (la.ii === 2) {
			switch (startMonth) {
				case 8:
					return _Utils_Tuple2(rawStartYear, rawStartYear + 1);
				case 9:
					return _Utils_Tuple2(rawStartYear, rawStartYear + 1);
				case 10:
					return _Utils_Tuple2(rawStartYear, rawStartYear + 1);
				case 11:
					return _Utils_Tuple2(rawStartYear, rawStartYear + 1);
				default:
					return _Utils_Tuple2(rawEndYear - 1, rawEndYear);
			}
		} else {
			if (_Utils_eq(rawStartYear, rawEndYear)) {
				return _Utils_Tuple2(rawStartYear, rawEndYear + 1);
			} else {
				return _Utils_Tuple2(rawStartYear, rawEndYear);
			}
		}
	}();
	var startYear = _v0.a;
	var endYear = _v0.b;
	return {d3: endYear, bL: la, eB: startYear, ii: learningAssessmentType};
};
var $author$project$Element$LearningAssessmentCard$makeTabs = function (learningAssessments) {
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$sortWith,
			$author$project$Element$LearningAssessmentCard$compareTab,
			A2($elm$core$List$map, $author$project$Element$LearningAssessmentCard$learningAssessmentToTab, learningAssessments)));
};
var $author$project$Log$paramScopeGradeReport = 'scope_gradereport';
var $author$project$Log$paramScopeLearningAssessment = 'scope_learning_assessment';
var $author$project$Element$LearningAssessmentCard$update = F3(
	function (session, msg, model) {
		var t_ = session.h6;
		var config = model.b_;
		switch (msg.$) {
			case 1:
				var profileData = msg.a;
				switch (profileData.$) {
					case 2:
						var studentProfile = profileData.a;
						return A3($author$project$Element$LearningAssessmentCard$downloadGrades, session, model, studentProfile);
					case 3:
						var error = profileData.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgStudentProfileDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeGradeReport),
									error),
								$elm$core$Basics$always($author$project$Element$LearningAssessmentCard$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$StudentProfileFormDownloadError))));
					case 0:
						return A2($author$project$Application$Boundaries$save, model, session);
					default:
						return A2($author$project$Application$Boundaries$save, model, session);
				}
			case 2:
				switch (msg.a.$) {
					case 2:
						var subjects = msg.a.a;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									kb: $author$project$RemoteData$Success(subjects)
								}),
							session);
					case 3:
						var error = msg.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgSubjectListDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeGradeReport),
									error),
								$elm$core$Basics$always($author$project$Element$LearningAssessmentCard$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$SubjectListDownloadError))));
					default:
						var data = msg.a;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{kb: data}),
							session);
				}
			case 0:
				var learningAssessmentData = msg.a;
				switch (learningAssessmentData.$) {
					case 2:
						var learningAssessments = learningAssessmentData.a;
						var tabs = $author$project$Element$LearningAssessmentCard$makeTabs(learningAssessments);
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									e7: $author$project$RemoteData$Success(learningAssessments),
									cd: $elm$core$List$head(tabs),
									gG: tabs
								}),
							session);
					case 3:
						var error = learningAssessmentData.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgLearningAssessmentsDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeLearningAssessment),
									error),
								$elm$core$Basics$always($author$project$Element$LearningAssessmentCard$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$LearningAssessmentsDownloadError))));
					default:
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{e7: learningAssessmentData}),
							session);
				}
			case 3:
				if (!msg.a.$) {
					var stories = msg.a.a;
					var referencedModules = $author$project$Util$List$unique(
						$elm$core$List$sort(
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.i8;
									},
									$author$project$Module$moduleIdToInt),
								A2(
									$elm$core$List$filterMap,
									function ($) {
										return $.hG;
									},
									stories))));
					var emptyCache = $elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (id) {
								return _Utils_Tuple2(id, $elm$core$Maybe$Nothing);
							},
							referencedModules));
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$map,
								function (id) {
									return A3($author$project$Module$fetchOneModule, config.gX, id, $author$project$Element$LearningAssessmentCard$ModuleDownloadResponse);
								},
								referencedModules)),
						A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									ei: emptyCache,
									go: $author$project$Element$LearningAssessmentCard$PortfolioStoriesDownloaded(stories)
								}),
							session));
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgPortfoliosDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeGradeReport),
								error),
							$elm$core$Basics$always($author$project$Element$LearningAssessmentCard$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$PortfoliosDownloadError))));
				}
			case 4:
				if (!msg.a.$) {
					var module_ = msg.a.a;
					var updatedCache = A3(
						$elm$core$Dict$insert,
						$author$project$Module$moduleIdToInt(module_.i8),
						$elm$core$Maybe$Just(module_),
						model.ei);
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{ei: updatedCache}),
						session);
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgModulesDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeGradeReport),
								error),
							$elm$core$Basics$always($author$project$Element$LearningAssessmentCard$NoOp)),
						A2($author$project$Application$Boundaries$save, model, session));
				}
			case 5:
				var tab = msg.a;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{
							cd: $elm$core$Maybe$Just(tab)
						}),
					session);
			default:
				return A2($author$project$Application$Boundaries$save, model, session);
		}
	});
var $author$project$Locale$Messages$GradeReportsNoGradesNotification = {$: 88};
var $author$project$Locale$Messages$GradeReportsDownloadError = {$: 80};
var $author$project$Locale$Messages$GradeReportsNone = {$: 85};
var $author$project$StudentProfile$asStudent = function (profile) {
	var student = profile.nT;
	return {kL: $elm$core$Maybe$Nothing, fT: profile.fT, O: student.O, lI: student.lI, i8: student.i8, av: student.av, my: $elm$core$Maybe$Nothing, mz: '', a$: student.a$, nr: $author$project$Person$emptyRoles, nM: student.nM};
};
var $author$project$Locale$Messages$GradeReportsDownloadFeedbackPDF = {$: 82};
var $author$project$Locale$Messages$GradeReportsSubject = {$: 86};
var $author$project$Locale$Messages$GradeReportsTextAppraisal = {$: 87};
var $author$project$Locale$Messages$GradeReportsTitleEndYear = {$: 95};
var $author$project$Locale$Messages$GradeReportsTitleGradingExam = {$: 96};
var $author$project$Locale$Messages$GradeReportsTitleMidYear = {$: 94};
var $author$project$Element$LearningAssessmentCard$viewSubjectLink = F4(
	function (student, subject, grade, midYear) {
		var params = {
			W: $elm$core$Maybe$Just(grade),
			mB: $elm$core$Maybe$Just(midYear),
			gE: $elm$core$Maybe$Just(subject.i8)
		};
		return _List_fromArray(
			[
				A2(
				$author$project$UI$nav,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$Route$href(
								A2($author$project$Route$SubjectFeedbackList, student.i8, params)),
								$author$project$UI$attrCyData('subject-feedback-card')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(subject.gk)
							]))
					]),
				_List_Nil)
			]);
	});
var $author$project$Element$LearningAssessmentCard$viewLearningAssessment = F3(
	function (t_, student, learningAssessment) {
		var viewTitle = $author$project$UI$title(
			_List_fromArray(
				[
					$elm$html$Html$text(
					function () {
						var _v2 = learningAssessment.ii;
						switch (_v2) {
							case 0:
								return t_($author$project$Locale$Messages$GradeReportsTitleMidYear);
							case 1:
								return t_($author$project$Locale$Messages$GradeReportsTitleEndYear);
							default:
								return t_($author$project$Locale$Messages$GradeReportsTitleGradingExam);
						}
					}())
				]));
		var viewReportHeader = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block  is-uppercase')
				]),
			_List_fromArray(
				[
					viewTitle,
					$author$project$UI$subtitle(
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Person$fullName, t_, learningAssessment.nT))
						]))
				]));
		var viewMark = function (item) {
			var _v0 = item.kh;
			if (!_v0.$) {
				var txt = _v0.a;
				return txt;
			} else {
				var _v1 = item.i$;
				if (!_v1.$) {
					var n = _v1.a;
					return $elm$core$String$fromInt(n);
				} else {
					return '-';
				}
			}
		};
		var viewReportBody = A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table is-striped'),
					$author$project$UI$attrCyData('learning-assessment')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsSubject)
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsTextAppraisal)
										]))
								]))
						])),
				A2(
					$elm$core$List$map,
					function (line) {
						return A2(
							$elm$html$Html$tr,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$td,
									_List_Nil,
									A4($author$project$Element$LearningAssessmentCard$viewSubjectLink, student, line.gE, learningAssessment.W, !learningAssessment.ii)),
								line.lX ? _List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('has-text-justified'),
												$elm$html$Html$Attributes$colspan(3)
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsExempted)
											]))
									]) : _List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('has-text-justified')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												viewMark(line))
											]))
									])));
					},
					A2(
						$author$project$Util$List$sortBy,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.gE;
							},
							function ($) {
								return $.gk;
							}),
						learningAssessment.kb))));
		var viewButtons = A2(
			$author$project$UI$level,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$UI$maybe,
					learningAssessment.nj,
					function (url) {
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(url)
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$filePdf(
									_List_fromArray(
										[
											$author$project$UI$Icon$style('has-text-primary')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsDownloadGradesPDF)
										]))
								]));
					}),
					A2(
					$author$project$UI$maybe,
					learningAssessment.nk,
					function (url) {
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(url)
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$filePdf(
									_List_fromArray(
										[
											$author$project$UI$Icon$style('has-text-primary')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsDownloadFeedbackPDF)
										]))
								]));
					})
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					viewButtons,
					viewReportHeader,
					A2(
					$author$project$UI$when,
					!$elm$core$List$isEmpty(learningAssessment.kb),
					viewReportBody)
				]));
	});
var $author$project$Element$LearningAssessmentCard$TabSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$LearningAssessmentCard$tabCaption = function (_v0) {
	var startYear = _v0.eB;
	var endYear = _v0.d3;
	var type_ = _v0.ii;
	switch (type_) {
		case 0:
			return A2($author$project$Locale$Messages$GradeReportCardTabMidYear, startYear, endYear);
		case 1:
			return A2($author$project$Locale$Messages$GradeReportCardTabEndOfYear, startYear, endYear);
		default:
			return A2($author$project$Locale$Messages$GradeReportCardTabGradingExam, startYear, endYear);
	}
};
var $author$project$Element$LearningAssessmentCard$viewTabBar = F3(
	function (t_, selected, reports) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tabs is-boxed')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (tab) {
							return A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'is-active',
												_Utils_eq(
													$elm$core$Maybe$Just(tab),
													selected))
											]))
									]),
								_List_fromArray(
									[
										A3(
										$author$project$UI$actionLink,
										$author$project$Element$LearningAssessmentCard$TabSelected(tab),
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$UI$caption,
												t_,
												$author$project$Element$LearningAssessmentCard$tabCaption(tab))
											]))
									]));
						},
						reports))
				]));
	});
var $author$project$Element$LearningAssessmentCard$viewGradeReportsSection = F2(
	function (_v0, model) {
		var t_ = _v0.h6;
		var viewer = _v0.ok;
		var studentProfile = model.h5;
		var learningAssessmentState = model.e7;
		var _v1 = _Utils_Tuple2(studentProfile, learningAssessmentState);
		_v1$3:
		while (true) {
			switch (_v1.a.$) {
				case 1:
					var _v2 = _v1.a;
					return _List_fromArray(
						[
							A2(
							$author$project$UI$progressBar,
							'is-info',
							t_($author$project$Locale$Messages$GradeReportsLoadingProgress))
						]);
				case 2:
					if (_v1.b.$ === 2) {
						if (!_v1.b.a.b) {
							return _List_fromArray(
								[
									$author$project$UI$notification(
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsNone)
										]))
								]);
						} else {
							var sp = _v1.a.a;
							return _List_fromArray(
								[
									A3($author$project$Element$LearningAssessmentCard$viewTabBar, t_, model.cd, model.gG),
									function () {
									var _v3 = model.cd;
									if (!_v3.$) {
										var tab = _v3.a;
										return A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$UI$when,
													A2($author$project$ACL$canViewLearningAssessmentGrades, viewer, tab.bL),
													A3(
														$author$project$Element$LearningAssessmentCard$viewLearningAssessment,
														t_,
														$author$project$StudentProfile$asStudent(sp),
														tab.bL))
												]));
									} else {
										return $author$project$UI$none;
									}
								}()
								]);
						}
					} else {
						break _v1$3;
					}
				default:
					break _v1$3;
			}
		}
		return _List_fromArray(
			[
				A2(
				$author$project$UI$progressBar,
				'is-warning',
				t_($author$project$Locale$Messages$GradeReportsDownloadError))
			]);
	});
var $author$project$Locale$Messages$PortfoliosLoadingProgress = {$: 379};
var $author$project$Element$LearningAssessmentCard$storiesRelatedToReport = F2(
	function (report, stories) {
		return A2(
			$elm$core$List$filter,
			function (story) {
				return (_Utils_cmp(report.nN, story.g4) < 1) && (_Utils_cmp(report.ly, story.g4) > -1);
			},
			stories);
	});
var $author$project$Locale$Messages$GradeReportsClosedModules = {$: 79};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Locale$Messages$ModulesAccountableTeacher = function (a) {
	return {$: 220, a: a};
};
var $author$project$UI$contentElem = function (cont) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('content')
			]),
		cont);
};
var $author$project$Locale$Messages$ModulesFieldGoals = {$: 244};
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$Element$ModulesMain$viewModuleGoals = F2(
	function (t_, module_) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('subtitle')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFieldGoals)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							$author$project$Util$Html$markdownToHtml(module_.lO)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							$author$project$Util$Html$markdownToHtml(module_.lQ)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							$author$project$Util$Html$markdownToHtml(module_.lP)
						]))
				]));
	});
var $author$project$Element$LearningAssessmentCard$viewClosedModule = F2(
	function (t_, module_) {
		return $author$project$UI$panel(
			{
				g$: _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('block')
							]),
						_List_fromArray(
							[
								$author$project$UI$contentElem(
								_List_fromArray(
									[
										A2(
										$author$project$UI$caption,
										t_,
										$author$project$Locale$Messages$ModulesAccountableTeacher(
											A2($author$project$Person$fullName, t_, module_.kI)))
									])),
								$author$project$UI$section(
								_List_fromArray(
									[
										$elm$html$Html$text(module_.g8)
									])),
								$author$project$UI$section(
								_List_fromArray(
									[
										A2($author$project$Element$ModulesMain$viewModuleGoals, t_, module_)
									]))
							]))
					]),
				cm: 'module-close',
				hl: _List_fromArray(
					[
						$elm$html$Html$text(module_.kj)
					]),
				h7: _List_Nil,
				ie: 'is-link'
			});
	});
var $author$project$Element$LearningAssessmentCard$viewModules = F3(
	function (t_, modules, stories) {
		var closedModules = A2(
			$elm$core$List$map,
			function (id) {
				return A2($elm$core$Dict$get, id, modules);
			},
			$elm$core$Set$toList(
				$elm$core$Set$fromList(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.i8;
							},
							$author$project$Module$moduleIdToInt),
						A2(
							$elm$core$List$filterMap,
							function ($) {
								return $.hG;
							},
							A2($elm$core$List$filter, $author$project$PortfolioStory$isModuleClosure, stories))))));
		return (!$elm$core$List$isEmpty(closedModules)) ? A2(
			$elm$core$List$cons,
			$author$project$UI$title(
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsClosedModules)
					])),
			A2(
				$elm$core$List$map,
				function (moduleDetail) {
					if ((!moduleDetail.$) && (!moduleDetail.a.$)) {
						var module_ = moduleDetail.a.a;
						return A2($author$project$Element$LearningAssessmentCard$viewClosedModule, t_, module_);
					} else {
						return $author$project$UI$Icon$loadingOptions(_List_Nil);
					}
				},
				closedModules)) : _List_Nil;
	});
var $author$project$Locale$Messages$BtnDetail = {$: 35};
var $author$project$Element$LearningAssessmentCard$viewStoryMediaItem = function (maybeMedia) {
	if (maybeMedia.$ === 1) {
		return $author$project$UI$none;
	} else {
		var media = maybeMedia.a;
		var _v1 = $author$project$Util$Media$mediaViewerByExt(media.m$);
		switch (_v1) {
			case 2:
				return $author$project$UI$Icon$filePdf(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-3x'),
							$author$project$UI$Icon$style('has-text-grey is-large')
						]));
			case 3:
				return $author$project$UI$Icon$file(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-3x'),
							$author$project$UI$Icon$style('has-text-info is-large')
						]));
			default:
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(
							$author$project$PortfolioStory$mediaPreview(media))
						]),
					_List_Nil);
		}
	}
};
var $author$project$Element$LearningAssessmentCard$viewPortfolioStories = F4(
	function (t_, stories, title, addModuleName) {
		var viewModuleText = function (story) {
			var _v0 = story.hG;
			if (!_v0.$) {
				var module_ = _v0.a;
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(' @ '),
							$elm$html$Html$text(module_.kj)
						]));
			} else {
				return $author$project$UI$none;
			}
		};
		return (!$elm$core$List$isEmpty(stories)) ? A2(
			$elm$core$List$cons,
			$author$project$UI$title(
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					])),
			A2(
				$elm$core$List$map,
				function (story) {
					return A4(
						$author$project$UI$mediaObject,
						_List_fromArray(
							[
								$author$project$Element$LearningAssessmentCard$viewStoryMediaItem(
								$elm$core$List$head(story.mw))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$UI$caption,
												t_,
												A2(
													$author$project$Locale$Messages$TimeDateFormat,
													$elm$time$Time$utc,
													$elm$time$Time$millisToPosix(story.g4))),
												$elm$html$Html$text(' — '),
												$elm$html$Html$text(
												A2($author$project$Person$fullName, t_, story.lf)),
												A2(
												$author$project$UI$when,
												addModuleName,
												viewModuleText(story))
											])),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										$elm$html$Html$text(story.g8)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$UI$nav,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$author$project$Route$href(
												$author$project$Route$PortfoliosDetail(story.i8)),
												$author$project$UI$attrCyData('portfolios-item-detail')
											]),
										_List_fromArray(
											[
												$author$project$UI$Icon$icon(
												_List_fromArray(
													[
														$author$project$UI$Icon$face('fa-eye')
													])),
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnDetail)
											]))
									]),
								_List_Nil)
							]),
						_List_Nil);
				},
				stories)) : _List_Nil;
	});
var $author$project$Element$LearningAssessmentCard$viewPortfolioStoriesSection = F2(
	function (_v0, model) {
		var t_ = _v0.h6;
		var _v1 = _Utils_Tuple2(model.go, model.cd);
		_v1$2:
		while (true) {
			if (_v1.a.$ === 1) {
				if (!_v1.b.$) {
					var stories = _v1.a.a;
					var tab = _v1.b.a;
					var reportStories = A2($author$project$Element$LearningAssessmentCard$storiesRelatedToReport, tab.bL, stories);
					var nonModuleClosureStories = A2($elm$core$List$filter, $author$project$PortfolioStory$isNotModuleClosure, reportStories);
					return _Utils_ap(
						A3($author$project$Element$LearningAssessmentCard$viewModules, t_, model.ei, reportStories),
						A4(
							$author$project$Element$LearningAssessmentCard$viewPortfolioStories,
							t_,
							nonModuleClosureStories,
							t_($author$project$Locale$Messages$PortfoliosTitle),
							true));
				} else {
					break _v1$2;
				}
			} else {
				if (!_v1.b.$) {
					var _v2 = _v1.a;
					return _List_fromArray(
						[
							A2(
							$author$project$UI$progressBar,
							'is-link',
							t_($author$project$Locale$Messages$PortfoliosLoadingProgress))
						]);
				} else {
					break _v1$2;
				}
			}
		}
		return _List_Nil;
	});
var $author$project$Locale$Messages$GradeReportsSubjectFeedbackNotification = {$: 90};
var $author$project$Element$LearningAssessmentCard$viewSubjectFeedbackNotification = F2(
	function (_v0, _v1) {
		var t_ = _v0.h6;
		var studentProfile = _v1.h5;
		var params = {W: $elm$core$Maybe$Nothing, mB: $elm$core$Maybe$Nothing, gE: $elm$core$Maybe$Nothing};
		if (studentProfile.$ === 2) {
			var sp = studentProfile.a;
			return _List_fromArray(
				[
					$author$project$UI$notification(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href(
									A2($author$project$Route$SubjectFeedbackList, sp.nT.i8, params))
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$filter(_List_Nil),
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsSubjectFeedbackNotification)
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Element$LearningAssessmentCard$view = F2(
	function (session, model) {
		var t_ = session.h6;
		var viewer = session.ok;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$UI$when,
					$author$project$Person$isSponsor(viewer),
					$author$project$UI$notification(
						$author$project$UI$textToHtml(
							t_($author$project$Locale$Messages$GradeReportsNoGradesNotification)))),
					$author$project$UI$section(
					A2($author$project$Element$LearningAssessmentCard$viewGradeReportsSection, session, model)),
					$author$project$UI$section(
					A2($author$project$Element$LearningAssessmentCard$viewSubjectFeedbackNotification, session, model)),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					$author$project$UI$section(
					A2($author$project$Element$LearningAssessmentCard$viewPortfolioStoriesSection, session, model))
				]));
	});
var $author$project$Element$LearningAssessmentCard$element = {jb: $author$project$Element$LearningAssessmentCard$init, ks: $author$project$Element$LearningAssessmentCard$update, og: $author$project$Element$LearningAssessmentCard$view};
var $author$project$Element$LearningContracts$NotFoundPage = {$: 0};
var $author$project$Element$LearningContracts$FormPage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LearningContracts$LearningContractListDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningContracts$LoadingPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningContracts$EndDate = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$LearningContracts$StartDate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$LearningContracts$Student = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$LearningContracts$Url = function (a) {
	return {$: 6, a: a};
};
var $author$project$Form$requiredPersonSelected = F2(
	function (t_, value) {
		var maybeId = $elm$core$String$toInt(value);
		if (!maybeId.$) {
			var id = maybeId.a;
			return (!_Utils_eq(id, $author$project$Person$blankPersonId)) ? $elm$core$Result$Ok(id) : $elm$core$Result$Err(
				t_($author$project$Locale$Messages$FormRequiredSelection));
		} else {
			return $elm$core$Result$Err(
				t_($author$project$Locale$Messages$FormRequiredSelection));
		}
	});
var $author$project$Locale$Messages$FormInvalidUrl = {$: 59};
var $author$project$Form$validUrlFormat = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^https?://.+$'));
var $author$project$Form$requiredUrl = F2(
	function (t_, value) {
		return (value === '') ? $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormRequiredValue)) : (A2($elm$regex$Regex$contains, $author$project$Form$validUrlFormat, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormInvalidUrl)));
	});
var $author$project$Element$LearningContracts$buildForm = function (t_) {
	return {
		ly: {
			e0: false,
			fi: $author$project$Form$requiredDate(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ly: value});
				}),
			fC: function ($) {
				return $.ly;
			},
			og: {
				cm: 'end_date',
				ea: t_($author$project$Locale$Messages$LearningContractsEndDate),
				fe: $author$project$Element$LearningContracts$EndDate
			}
		},
		nN: {
			e0: false,
			fi: $author$project$Form$requiredDate(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{nN: value});
				}),
			fC: function ($) {
				return $.nN;
			},
			og: {
				cm: 'start_date',
				ea: t_($author$project$Locale$Messages$LearningContractsStartDate),
				fe: $author$project$Element$LearningContracts$StartDate
			}
		},
		nT: {
			e0: false,
			fi: $author$project$Form$requiredPersonSelected(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{nT: value});
				}),
			fC: function ($) {
				return $.nT;
			},
			og: {
				cm: 'student',
				e6: 'fa-user',
				ea: t_($author$project$Locale$Messages$LearningContractsStudent),
				fe: $author$project$Element$LearningContracts$Student,
				m_: $elm$core$Maybe$Nothing
			}
		},
		K: {
			e0: false,
			fi: $author$project$Form$requiredUrl(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{K: value});
				}),
			fC: function ($) {
				return $.K;
			},
			og: {
				cm: 'url',
				e6: 'fa-link',
				ea: t_($author$project$Locale$Messages$LearningContractsUrl),
				fe: $author$project$Element$LearningContracts$Url,
				fj: 'https://',
				ii: 'text'
			}
		}
	};
};
var $author$project$Element$LearningContracts$emptyForm = {ly: '', nN: '', nT: '', K: ''};
var $author$project$Api$Endpoint$learningContracts = F2(
	function (config, query) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'learning-contracts']),
			_List_fromArray(
				[
					_Utils_Tuple2('include_inactive', '1'),
					_Utils_Tuple2('q', query)
				]));
	});
var $author$project$LearningContract$learningContractsDecoder = $elm$json$Json$Decode$list($author$project$LearningContract$learningContractDecoder);
var $author$project$LearningContract$fetchLearningContracts = F3(
	function (config, query, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$learningContracts, config, query),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$LearningContract$learningContractsDecoder));
	});
var $author$project$Form$fillFieldOptions = F2(
	function (options, field) {
		var view = field.og;
		return _Utils_update(
			field,
			{
				og: _Utils_update(
					view,
					{
						m_: $elm$core$Maybe$Just(options)
					})
			});
	});
var $author$project$Element$LearningContracts$toStudentOptions = F2(
	function (t_, mentees) {
		return A2($author$project$Form$toPeopleOptions, t_, mentees);
	});
var $author$project$Element$LearningContracts$initPage = F3(
	function (pageType, session, model) {
		var t_ = session.h6;
		var viewer = session.ok;
		switch (pageType.$) {
			case 0:
				var form = $author$project$Element$LearningContracts$buildForm(t_);
				var page = $author$project$Element$LearningContracts$FormPage(
					{
						iq: $author$project$Form$Create(0),
						bE: _Utils_update(
							form,
							{
								nT: A2(
									$author$project$Form$fillFieldOptions,
									A2($author$project$Element$LearningContracts$toStudentOptions, t_, viewer.mx),
									form.nT)
							}),
						fs: 0,
						dM: {c3: true},
						eI: $author$project$Element$LearningContracts$emptyForm
					});
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{bk: page}),
					session);
			case 2:
				var id = pageType.a;
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A3($author$project$LearningContract$fetchLearningContracts, model.b_.gX, '', $author$project$Element$LearningContracts$LearningContractListDownloaded),
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								bk: $author$project$Element$LearningContracts$LoadingPage(
									$elm$core$Maybe$Just(id))
							}),
						session));
			default:
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A3($author$project$LearningContract$fetchLearningContracts, model.b_.gX, '', $author$project$Element$LearningContracts$LearningContractListDownloaded),
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								bk: $author$project$Element$LearningContracts$LoadingPage($elm$core$Maybe$Nothing)
							}),
						session));
		}
	});
var $author$project$Element$LearningContracts$init = F3(
	function (config, session, pageType) {
		return A3(
			$author$project$Element$LearningContracts$initPage,
			pageType,
			session,
			{b_: config, bk: $author$project$Element$LearningContracts$NotFoundPage, ew: ''});
	});
var $author$project$Element$LearningContracts$DelayedSearchQueryChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$LearningContracts$LearningContractSaved = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$LearningContractsDownloadError = {$: 129};
var $author$project$Locale$Messages$LearningContractsSaveSuccess = {$: 136};
var $author$project$Element$LearningContracts$ListPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LearningContracts$NoOp = {$: 10};
var $author$project$Form$Update = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$areDatesValid = F3(
	function (field1, field2, values) {
		var date2 = $author$project$Form$dateToMillis(
			field2.fC(values));
		var date1 = $author$project$Form$dateToMillis(
			field1.fC(values));
		var _v0 = A2($elm$core$Basics$compare, date1, date2);
		switch (_v0) {
			case 0:
				return true;
			case 1:
				return true;
			default:
				return false;
		}
	});
var $author$project$LearningContract$idToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$LearningContract$learningContractEncoder = function (contract) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(
					$author$project$LearningContract$idToInt(contract.i8))),
				_Utils_Tuple2(
				'student',
				$elm$json$Json$Encode$int(contract.nT)),
				_Utils_Tuple2(
				'url',
				$elm$json$Json$Encode$string(contract.K)),
				_Utils_Tuple2(
				'start_date',
				$elm$json$Json$Encode$int(contract.nN)),
				_Utils_Tuple2(
				'end_date',
				$elm$json$Json$Encode$int(contract.ly))
			]));
};
var $author$project$LearningContract$createLearningContract = F3(
	function (config, contract, callback) {
		return A5(
			$author$project$Api$post,
			A2($author$project$Api$Endpoint$learningContracts, config, ''),
			config,
			$elm$http$Http$jsonBody(
				$author$project$LearningContract$learningContractEncoder(contract)),
			callback,
			$author$project$LearningContract$learningContractDecoder);
	});
var $author$project$Element$LearningContracts$fillForm = function (contract) {
	return {
		ly: $author$project$Form$dateFromMillis(contract.ly),
		nN: $author$project$Form$dateFromMillis(contract.nN),
		nT: $elm$core$String$fromInt(contract.nT.i8),
		K: contract.K
	};
};
var $author$project$LearningContract$findLearningContract = F2(
	function (id, list) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (c) {
					return _Utils_eq(c.i8, id);
				},
				list));
	});
var $author$project$Element$LearningContracts$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.nT, values) && (A2($author$project$Form$isFieldValid, form.K, values) && (A2($author$project$Form$isFieldValid, form.nN, values) && (A2($author$project$Form$isFieldValid, form.ly, values) && A3($author$project$Form$areDatesValid, form.nN, form.ly, values))));
	});
var $author$project$Log$msgLearningContractSave = 'learningcontract_save';
var $author$project$Log$msgLearningContractsDownload = 'learningcontracts_download';
var $author$project$LearningContract$LearningContractUnsaved = F5(
	function (id, student, url, startDate, endDate) {
		return {ly: endDate, i8: id, nN: startDate, nT: student, K: url};
	});
var $author$project$Person$decodePersonId = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toInt,
	$elm$core$Maybe$withDefault($author$project$Person$blankPersonId));
var $author$project$Element$LearningContracts$saveForm = F3(
	function (form, values, contract) {
		return A5(
			$author$project$LearningContract$LearningContractUnsaved,
			A2(
				$elm$core$Maybe$withDefault,
				-1,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.i8;
					},
					contract)),
			$author$project$Person$decodePersonId(
				form.nT.fC(values)),
			form.K.fC(values),
			$author$project$Form$dateToMillis(
				form.nN.fC(values)),
			$author$project$Form$dateToMillis(
				form.ly.fC(values)));
	});
var $author$project$Util$Delay$searchBarDelay = 0.5;
var $author$project$Api$Endpoint$learningContract = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'learning-contracts',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$LearningContract$updateLearningContract = F3(
	function (config, contract, callback) {
		return A5(
			$author$project$Api$put,
			A2(
				$author$project$Api$Endpoint$learningContract,
				config,
				$author$project$LearningContract$idToInt(contract.i8)),
			config,
			$elm$http$Http$jsonBody(
				$author$project$LearningContract$learningContractEncoder(contract)),
			callback,
			$author$project$LearningContract$learningContractDecoder);
	});
var $author$project$Element$LearningContracts$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			ly: $author$project$Form$markEdited(form.ly),
			nN: $author$project$Form$markEdited(form.nN),
			nT: $author$project$Form$markEdited(form.nT),
			K: $author$project$Form$markEdited(form.K)
		});
};
var $author$project$Element$LearningContracts$update = F3(
	function (session, msg, model) {
		var t_ = session.h6;
		var viewer = session.ok;
		var _v0 = _Utils_Tuple2(msg, model.bk);
		_v0$13:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var id = _v0.a.a;
					return A3(
						$author$project$Element$LearningContracts$initPage,
						$author$project$Element$LearningContracts$Update(id),
						session,
						model);
				case 3:
					var query = _v0.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A2(
							$author$project$Util$Delay$after,
							$author$project$Util$Delay$searchBarDelay,
							$author$project$Element$LearningContracts$DelayedSearchQueryChanged(query)),
						A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{ew: query}),
							session));
				case 4:
					var query = _v0.a.a;
					return _Utils_eq(query, model.ew) ? A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3($author$project$LearningContract$fetchLearningContracts, model.b_.gX, query, $author$project$Element$LearningContracts$LearningContractListDownloaded),
						A2($author$project$Application$Boundaries$save, model, session)) : A2($author$project$Application$Boundaries$save, model, session);
				case 1:
					if (!_v0.a.a.$) {
						if ((_v0.b.$ === 1) && (!_v0.b.a.$)) {
							var list = _v0.a.a.a;
							var id = _v0.b.a.a;
							var maybeContract = A2($author$project$LearningContract$findLearningContract, id, list);
							if (!maybeContract.$) {
								var contract = maybeContract.a;
								var form = $author$project$Element$LearningContracts$buildForm(t_);
								var formPage = $author$project$Element$LearningContracts$FormPage(
									{
										iq: $author$project$Form$Update(contract),
										bE: _Utils_update(
											form,
											{
												nT: A2(
													$author$project$Form$fillFieldOptions,
													A2($author$project$Element$LearningContracts$toStudentOptions, t_, viewer.mx),
													form.nT)
											}),
										fs: 0,
										dM: {c3: true},
										eI: $author$project$Element$LearningContracts$fillForm(contract)
									});
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{bk: formPage}),
									session);
							} else {
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{bk: $author$project$Element$LearningContracts$NotFoundPage}),
									session);
							}
						} else {
							var list = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bk: $author$project$Element$LearningContracts$ListPage(list)
									}),
								session);
						}
					} else {
						var error = _v0.a.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								model.b_,
								_Utils_Tuple3($author$project$Log$msgLearningContractsDownload, $elm$core$Maybe$Nothing, error),
								$elm$core$Basics$always($author$project$Element$LearningContracts$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$LearningContractsDownloadError))));
					}
				case 9:
					if (_v0.b.$ === 3) {
						var _v2 = _v0.a;
						var formPage = _v0.b.a;
						var action = formPage.iq;
						var form = formPage.bE;
						var values = formPage.eI;
						if (A2($author$project$Element$LearningContracts$isFormValid, form, values)) {
							var formCmd = function () {
								if (!action.$) {
									var contractUnsaved = A3($author$project$Element$LearningContracts$saveForm, form, values, $elm$core$Maybe$Nothing);
									return A3($author$project$LearningContract$createLearningContract, model.b_.gX, contractUnsaved, $author$project$Element$LearningContracts$LearningContractSaved);
								} else {
									var contract = action.a;
									var contractUnsaved = A3(
										$author$project$Element$LearningContracts$saveForm,
										form,
										values,
										$elm$core$Maybe$Just(contract));
									return A3($author$project$LearningContract$updateLearningContract, model.b_.gX, contractUnsaved, $author$project$Element$LearningContracts$LearningContractSaved);
								}
							}();
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								formCmd,
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bk: $author$project$Element$LearningContracts$FormPage(
												_Utils_update(
													formPage,
													{fs: 2}))
										}),
									session));
						} else {
							var areDatesValid = A3($author$project$Form$areDatesValid, form.nN, form.ly, values);
							var page = $author$project$Element$LearningContracts$FormPage(
								_Utils_update(
									formPage,
									{
										bE: $author$project$Element$LearningContracts$validateForm(form),
										fs: 1,
										dM: {c3: areDatesValid}
									}));
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								$author$project$Ports$scrollToFormError,
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{bk: page}),
									session));
						}
					} else {
						break _v0$13;
					}
				case 2:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 3) {
							var newContract = _v0.a.a.a;
							var formPage = _v0.b.a;
							var page = $author$project$Element$LearningContracts$FormPage(
								_Utils_update(
									formPage,
									{
										iq: $author$project$Form$Update(newContract),
										fs: 0
									}));
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{bk: page}),
								A2(
									$author$project$Session$ok,
									session,
									t_($author$project$Locale$Messages$LearningContractsSaveSuccess)));
						} else {
							break _v0$13;
						}
					} else {
						if (_v0.b.$ === 3) {
							var error = _v0.a.a.a;
							var formPage = _v0.b.a;
							var session2 = A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$FormSaveError));
							var model2 = _Utils_update(
								model,
								{
									bk: $author$project$Element$LearningContracts$FormPage(
										_Utils_update(
											formPage,
											{fs: 3}))
								});
							var cmd = A3(
								$author$project$Log$error,
								model.b_,
								_Utils_Tuple3($author$project$Log$msgLearningContractSave, $elm$core$Maybe$Nothing, error),
								$elm$core$Basics$always($author$project$Element$LearningContracts$NoOp));
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								cmd,
								A2($author$project$Application$Boundaries$save, model2, session2));
						} else {
							break _v0$13;
						}
					}
				case 5:
					if (_v0.b.$ === 3) {
						var value = _v0.a.a;
						var formPage = _v0.b.a;
						var form = formPage.bE;
						var values = formPage.eI;
						var page = $author$project$Element$LearningContracts$FormPage(
							_Utils_update(
								formPage,
								{
									bE: _Utils_update(
										form,
										{
											nT: $author$project$Form$markEdited(form.nT)
										}),
									fs: 1,
									eI: A2(form.nT.ks, value, values)
								}));
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{bk: page}),
							session);
					} else {
						break _v0$13;
					}
				case 6:
					if (_v0.b.$ === 3) {
						var value = _v0.a.a;
						var formPage = _v0.b.a;
						var form = formPage.bE;
						var values = formPage.eI;
						var page = $author$project$Element$LearningContracts$FormPage(
							_Utils_update(
								formPage,
								{
									bE: _Utils_update(
										form,
										{
											K: $author$project$Form$markEdited(form.K)
										}),
									fs: 1,
									eI: A2(form.K.ks, value, values)
								}));
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{bk: page}),
							session);
					} else {
						break _v0$13;
					}
				case 7:
					if (_v0.b.$ === 3) {
						var value = _v0.a.a;
						var formPage = _v0.b.a;
						var form = formPage.bE;
						var values = formPage.eI;
						var page = $author$project$Element$LearningContracts$FormPage(
							_Utils_update(
								formPage,
								{
									bE: _Utils_update(
										form,
										{
											nN: $author$project$Form$markEdited(form.nN)
										}),
									fs: 1,
									dM: {c3: true},
									eI: A2(form.nN.ks, value, values)
								}));
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{bk: page}),
							session);
					} else {
						break _v0$13;
					}
				case 8:
					if (_v0.b.$ === 3) {
						var value = _v0.a.a;
						var formPage = _v0.b.a;
						var form = formPage.bE;
						var values = formPage.eI;
						var page = $author$project$Element$LearningContracts$FormPage(
							_Utils_update(
								formPage,
								{
									bE: _Utils_update(
										form,
										{
											ly: $author$project$Form$markEdited(form.ly)
										}),
									fs: 1,
									dM: {c3: true},
									eI: A2(form.ly.ks, value, values)
								}));
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{bk: page}),
							session);
					} else {
						break _v0$13;
					}
				default:
					break _v0$13;
			}
		}
		return A2($author$project$Application$Boundaries$save, model, session);
	});
var $author$project$Locale$Messages$LearningContractsLoadingProgress = {$: 132};
var $author$project$Locale$Messages$LearningContractsNotFound = {$: 135};
var $author$project$Locale$Messages$LearningContractsNoResultsFound = {$: 141};
var $author$project$Locale$Messages$LearningContractsNoneForSponsor = {$: 133};
var $author$project$Locale$Messages$LearningContractsNoneForTeacher = {$: 134};
var $author$project$Element$LearningContracts$viewEmpty = F2(
	function (_v0, query) {
		var t_ = _v0.h6;
		var viewer = _v0.ok;
		return (query !== '') ? $author$project$UI$notification(
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningContractsNoResultsFound)
				])) : ($author$project$ACL$isStaff(viewer) ? $author$project$UI$notification(
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningContractsNoneForTeacher)
				])) : $author$project$UI$notification(
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningContractsNoneForSponsor)
				])));
	});
var $author$project$Locale$Messages$FormEndDateBeforeStartDate = {$: 63};
var $author$project$Locale$Messages$LearningContractsHeadingEdit = {$: 137};
var $author$project$Locale$Messages$LearningContractsHeadingNew = {$: 138};
var $author$project$Element$LearningContracts$ResetForm = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$LearningContracts$SaveLearningContract = {$: 9};
var $author$project$Locale$Messages$BtnCreate = {$: 28};
var $author$project$UI$formButtons = F5(
	function (t_, formAction, formState, submitMsg, resetMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field is-grouped')
				]),
			function () {
				if (!formAction.$) {
					return _List_fromArray(
						[
							A4(
							$author$project$UI$submitButton,
							t_($author$project$Locale$Messages$BtnCreate),
							formState !== 1,
							$author$project$Form$isProcessing(formState),
							submitMsg)
						]);
				} else {
					var x = formAction.a;
					return _List_fromArray(
						[
							A4(
							$author$project$UI$submitButton,
							t_($author$project$Locale$Messages$BtnSave),
							formState !== 1,
							$author$project$Form$isProcessing(formState),
							submitMsg),
							A4(
							$author$project$UI$resetButton,
							t_($author$project$Locale$Messages$BtnReset),
							$author$project$Form$resetDisabled(formState),
							$author$project$Form$isProcessing(formState),
							resetMsg(x))
						]);
				}
			}());
	});
var $author$project$UI$withErrorText = F3(
	function (t_, message, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('has-errors')
				]),
			_List_fromArray(
				[
					content,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-top', '-8px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$small,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('help is-danger')
								]),
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, message)
								]))
						]))
				]));
	});
var $author$project$Element$LearningContracts$viewForm = F2(
	function (t_, _v0) {
		var action = _v0.iq;
		var state = _v0.fs;
		var form = _v0.bE;
		var values = _v0.eI;
		var validations = _v0.dM;
		var validationError = function (content) {
			return (state === 1) ? (validations.c3 ? content : A3($author$project$UI$withErrorText, t_, $author$project$Locale$Messages$FormEndDateBeforeStartDate, content)) : content;
		};
		var heading = function () {
			if (!action.$) {
				return t_($author$project$Locale$Messages$LearningContractsHeadingNew);
			} else {
				return t_($author$project$Locale$Messages$LearningContractsHeadingEdit);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('heading')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(heading)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.nT, values),
							A3($author$project$UI$textField, t_, form.K, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$dateField, t_, form.nN, values),
							validationError(
							A3($author$project$UI$dateField, t_, form.ly, values))
						])),
					A5(
					$author$project$UI$formButtons,
					t_,
					action,
					state,
					$author$project$Element$LearningContracts$SaveLearningContract,
					function (contract) {
						return $author$project$Element$LearningContracts$ResetForm(
							$author$project$LearningContract$idToInt(contract.i8));
					})
				]));
	});
var $author$project$Locale$Messages$ItemTagActive = {$: 120};
var $author$project$Locale$Messages$ItemTagInactive = {$: 121};
var $author$project$Locale$Messages$LearningContractsItemDate = F3(
	function (a, b, c) {
		return {$: 130, a: a, b: b, c: c};
	});
var $author$project$Locale$Messages$LearningContractsItemName = function (a) {
	return {$: 131, a: a};
};
var $author$project$Person$isMentorOf = F2(
	function (mentee, person) {
		return A2(
			$elm$core$List$any,
			$author$project$Person$isSamePerson(mentee),
			person.mx);
	});
var $author$project$ACL$canManageLearningContract = F2(
	function (contract, person) {
		return A2($author$project$Person$isMentorOf, contract.nT, person);
	});
var $author$project$Element$LearningContracts$viewItem = F2(
	function (_v0, contract) {
		var t_ = _v0.h6;
		var viewer = _v0.ok;
		var viewEditLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$LearningContractsUpdate(
						$author$project$LearningContract$idToInt(contract.i8))),
					$author$project$UI$attrCyData('learningcontracts-edit')
				]),
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnEdit),
					$author$project$UI$Icon$edit(_List_Nil)
				]));
		var viewActiveTag = contract.l0 ? A2(
			$author$project$UI$tag,
			'is-success',
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ItemTagActive)
				])) : A2(
			$author$project$UI$tag,
			'is-warning is-light',
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ItemTagInactive)
				]));
		return A4(
			$author$project$UI$mediaObject,
			_List_fromArray(
				[viewActiveTag]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$author$project$UI$attrCyData('learningcontracts-item')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(contract.K)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$UI$caption,
									t_,
									$author$project$Locale$Messages$LearningContractsItemName(
										A2($author$project$Person$fullName, t_, contract.nT))),
									$author$project$UI$Icon$icon(
									_List_fromArray(
										[
											$author$project$UI$Icon$face('fa-link')
										]))
								])),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2(
							$author$project$UI$caption,
							t_,
							A3(
								$author$project$Locale$Messages$LearningContractsItemDate,
								$elm$time$Time$utc,
								$elm$time$Time$millisToPosix(contract.nN),
								$elm$time$Time$millisToPosix(contract.ly))),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2($author$project$Element$StudentList$viewMentorText, t_, contract.my)
						]))
				]),
			A2($author$project$ACL$canManageLearningContract, contract, viewer) ? _List_fromArray(
				[viewEditLink]) : _List_Nil,
			_List_Nil);
	});
var $author$project$Locale$Messages$LearningContractsSearchPlaceholder = {$: 140};
var $author$project$Element$LearningContracts$SearchQueryChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LearningContracts$viewSearchBar = F2(
	function (t_, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('control mt-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('input'),
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Attributes$placeholder(
									t_($author$project$Locale$Messages$LearningContractsSearchPlaceholder)),
									$elm$html$Html$Attributes$value(model.ew),
									$elm$html$Html$Events$onInput($author$project$Element$LearningContracts$SearchQueryChanged)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Element$LearningContracts$view = F2(
	function (session, model) {
		var t_ = session.h6;
		var _v0 = model.bk;
		switch (_v0.$) {
			case 2:
				if (!_v0.a.b) {
					return $author$project$UI$panel(
						{
							g$: _List_fromArray(
								[
									A2($author$project$Element$LearningContracts$viewEmpty, session, model.ew)
								]),
							cm: 'learningcontracts-list',
							hl: _List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningContractsTitle),
									A2($author$project$Element$LearningContracts$viewSearchBar, t_, model)
								]),
							h7: _List_Nil,
							ie: 'is-primary'
						});
				} else {
					var contracts = _v0.a;
					return $author$project$UI$panel(
						{
							g$: A2(
								$elm$core$List$map,
								$author$project$Element$LearningContracts$viewItem(session),
								contracts),
							cm: 'learningcontracts-list',
							hl: _List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningContractsTitle),
									A2($author$project$Element$LearningContracts$viewSearchBar, t_, model)
								]),
							h7: _List_Nil,
							ie: 'is-primary'
						});
				}
			case 0:
				return $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningContractsNotFound)
						]));
			case 1:
				return A2(
					$author$project$UI$progressBar,
					'is-info',
					t_($author$project$Locale$Messages$LearningContractsLoadingProgress));
			default:
				var formPage = _v0.a;
				return $author$project$UI$panel(
					{
						g$: _List_fromArray(
							[
								A2($author$project$Element$LearningContracts$viewForm, t_, formPage)
							]),
						cm: 'learningcontracts-form',
						hl: _List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningContractsTitle)
							]),
						h7: _List_Nil,
						ie: 'is-light'
					});
		}
	});
var $author$project$Element$LearningContracts$element = {jb: $author$project$Element$LearningContracts$init, ks: $author$project$Element$LearningContracts$update, og: $author$project$Element$LearningContracts$view};
var $author$project$Element$LearningGroupForm$LoadingPage = {$: 0};
var $author$project$Element$LearningGroupForm$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupForm$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LearningGroupForm$FetchLearningGroup = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LearningGroupForm$FetchSchools = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$LearningGroupForm$FetchStudents = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$LearningGroupForm$FormPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupForm$LearningGroupDownloadedForEdit = function (a) {
	return {$: 1, a: a};
};
var $author$project$LearningGroup$LearningGroupId = $elm$core$Basics$identity;
var $author$project$Element$LearningGroupForm$LogOk = $elm$core$Basics$identity;
var $author$project$Element$LearningGroupForm$NoOp = {$: 0};
var $author$project$Element$LearningGroupForm$SchoolListDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LearningGroupForm$StudentListDownloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$LearningGroupForm$FormMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$LearningGroupForm$IsShared = function (a) {
	return {$: 3, a: a};
};
var $author$project$Locale$Messages$LearningGroupFieldIsShared = {$: 148};
var $author$project$Locale$Messages$LearningGroupFieldName = {$: 149};
var $author$project$Locale$Messages$LearningGroupFieldSchool = {$: 150};
var $author$project$Locale$Messages$LearningGroupFieldStudents = {$: 151};
var $author$project$Element$LearningGroupForm$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$LearningGroupForm$School = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupForm$initStudentsField = function (options) {
	var defaultConfig = $author$project$Multiselect$defaultConfig;
	return $author$project$Multiselect$initModel(
		_Utils_update(
			defaultConfig,
			{
				n0: 'Students',
				eI: $author$project$Form$toMultiselectValues(options)
			}));
};
var $author$project$Form$requiredPeopleSelected = F2(
	function (t_, value) {
		var _v0 = A2($elm$core$List$filterMap, $elm$core$String$toInt, value);
		if (!_v0.b) {
			return $elm$core$Result$Err(
				t_($author$project$Locale$Messages$FormRequiredSelection));
		} else {
			var list = _v0;
			return $elm$core$Result$Ok(list);
		}
	});
var $author$project$Team$blankTeamId = -1;
var $author$project$Form$requiredTeamSelected = F2(
	function (t_, value) {
		var maybeId = A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$identity,
			$elm$core$String$toInt(value));
		if (!maybeId.$) {
			var id = maybeId.a;
			return (!_Utils_eq(id, $author$project$Team$blankTeamId)) ? $elm$core$Result$Ok(id) : $elm$core$Result$Err(
				t_($author$project$Locale$Messages$FormRequiredSelection));
		} else {
			return $elm$core$Result$Err(
				t_($author$project$Locale$Messages$FormRequiredSelection));
		}
	});
var $author$project$Element$LearningGroupForm$buildForm = F4(
	function (t_, schoolOptions, studentOptions, learningGroup) {
		var studentsField = {
			e0: false,
			fi: $author$project$Form$requiredPeopleSelected(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{fv: value});
				}),
			fC: function ($) {
				return $.fv;
			},
			og: {
				cm: 'students',
				e6: 'fa-users',
				ea: t_($author$project$Locale$Messages$LearningGroupFieldStudents),
				m_: studentOptions,
				fs: $author$project$Element$LearningGroupForm$initStudentsField(studentOptions),
				cf: $author$project$Element$LearningGroupForm$StudentsFieldMsg
			}
		};
		return {
			au: {
				e0: false,
				fi: $elm$core$Result$Ok,
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{au: value});
					}),
				fC: function ($) {
					return $.au;
				},
				og: {
					cm: 'is_shared',
					e6: 'fa-share',
					ea: t_($author$project$Locale$Messages$LearningGroupFieldIsShared),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$LearningGroupForm$FormMsg, $author$project$Element$LearningGroupForm$IsShared)
				}
			},
			fb: {
				e0: false,
				fi: $author$project$Form$requiredText(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{fb: value});
					}),
				fC: function ($) {
					return $.fb;
				},
				og: {
					cm: 'name',
					e6: 'fa-keyboard',
					ea: t_($author$project$Locale$Messages$LearningGroupFieldName),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$LearningGroupForm$FormMsg, $author$project$Element$LearningGroupForm$Name),
					fj: '',
					ii: 'text'
				}
			},
			Q: {
				e0: false,
				fi: $author$project$Form$requiredTeamSelected(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{Q: value});
					}),
				fC: function ($) {
					return $.Q;
				},
				og: {
					cm: 'school',
					e6: 'fa-school',
					ea: t_($author$project$Locale$Messages$LearningGroupFieldSchool),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$LearningGroupForm$FormMsg, $author$project$Element$LearningGroupForm$School),
					m_: schoolOptions
				}
			},
			fv: A2(
				$elm$core$Maybe$withDefault,
				studentsField,
				A2(
					$elm$core$Maybe$map,
					function (group_) {
						return A2(
							$author$project$Form$setMultiselectSelection,
							A2($author$project$Form$toPeopleOptions, t_, group_.fv),
							studentsField);
					},
					learningGroup))
		};
	});
var $author$project$Element$LearningGroupForm$emptyForm = {au: false, fb: '', Q: '', fv: _List_Nil};
var $author$project$Api$Endpoint$learningGroup = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'learning-groups',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$LearningGroup$LearningGroup = F6(
	function (id, name, creator, team, sharedWith, students) {
		return {iO: creator, i8: id, fb: name, nE: sharedWith, fv: students, kf: team};
	});
var $author$project$LearningGroup$learningGroupIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$LearningGroup$WithNobody = 0;
var $author$project$LearningGroup$WithTeam = 1;
var $author$project$LearningGroup$sharingDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'nobody':
				return $elm$json$Json$Decode$succeed(0);
			case 'team':
				return $elm$json$Json$Decode$succeed(1);
			default:
				var somethingElse = str;
				return $elm$json$Json$Decode$fail('Unknown sharing option: ' + somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$LearningGroup$learningGroupDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'students_detail',
	$author$project$Person$nestedPeopleDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'shared_with',
		$author$project$LearningGroup$sharingDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'team_detail',
			$author$project$Team$teamDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'created_by_detail',
				$author$project$Person$nestedPersonDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$author$project$LearningGroup$learningGroupIdDecoder,
						$elm$json$Json$Decode$succeed($author$project$LearningGroup$LearningGroup)))))));
var $author$project$LearningGroup$learningGroupIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$LearningGroup$fetchLearningGroup = F3(
	function (config, id, callback) {
		return {
			b_: config,
			d_: $author$project$LearningGroup$learningGroupDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2(
				$author$project$Api$Endpoint$learningGroup,
				config,
				$author$project$LearningGroup$learningGroupIdToInt(id))
		};
	});
var $author$project$Team$fetchSchools2 = F2(
	function (config, callback) {
		return {
			b_: config,
			d_: $author$project$Team$teamsDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: $author$project$Api$Endpoint$schools(config)
		};
	});
var $author$project$Api$Endpoint$peopleStudents = function (config) {
	return A2($author$project$Api$Endpoint$peopleByRoles, config, 'students');
};
var $author$project$Person$fetchStudents2 = F2(
	function (config, callback) {
		return {
			b_: config,
			d_: $author$project$Person$phoneBookDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: $author$project$Api$Endpoint$peopleStudents(config)
		};
	});
var $author$project$Log$msgLearningGroupCreate = 'learning_group_create';
var $author$project$Log$paramScopeLearningGroups = 'scope_learning_groups';
var $author$project$Element$LearningGroupForm$initPageByParams = F3(
	function (params, session, model) {
		var fetchStudents = $author$project$Element$LearningGroupForm$FetchStudents(
			A2($author$project$Person$fetchStudents2, model.b_.gX, $author$project$Element$LearningGroupForm$StudentListDownloaded));
		var fetchSchool = $author$project$Element$LearningGroupForm$FetchSchools(
			A2($author$project$Team$fetchSchools2, model.b_.gX, $author$project$Element$LearningGroupForm$SchoolListDownloaded));
		if (!params.$) {
			var store = {j2: $author$project$RemoteData$Loading, fv: $author$project$RemoteData$Loading};
			var page = $author$project$Element$LearningGroupForm$FormPage(
				{
					iq: $author$project$Form$Create(0),
					bE: A4($author$project$Element$LearningGroupForm$buildForm, session.h6, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
					fs: 0,
					eI: $author$project$Element$LearningGroupForm$emptyForm
				});
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{bk: page, bo: store}),
				$author$project$Element$LearningGroupForm$BatchEffect(
					_List_fromArray(
						[
							fetchSchool,
							fetchStudents,
							$author$project$Element$LearningGroupForm$Cmd(
							A3(
								$author$project$Log$okV2,
								model.b_,
								_Utils_Tuple2(
									$author$project$Log$msgLearningGroupCreate,
									_List_fromArray(
										[$author$project$Log$paramScopeLearningGroups, $author$project$Log$paramOk])),
								$elm$core$Basics$always($author$project$Element$LearningGroupForm$NoOp)))
						])),
				$elm$core$Maybe$Nothing);
		} else {
			var learningGroupId = params.a;
			var effect = $author$project$Element$LearningGroupForm$BatchEffect(
				_List_fromArray(
					[
						fetchStudents,
						fetchSchool,
						$author$project$Element$LearningGroupForm$FetchLearningGroup(
						A3($author$project$LearningGroup$fetchLearningGroup, model.b_.gX, learningGroupId, $author$project$Element$LearningGroupForm$LearningGroupDownloadedForEdit))
					]));
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{bk: $author$project$Element$LearningGroupForm$LoadingPage}),
				effect,
				$elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$LearningGroupForm$init = F3(
	function (config, session, params) {
		var model = {
			b_: config,
			bk: $author$project$Element$LearningGroupForm$LoadingPage,
			gB: session,
			bo: {j2: $author$project$RemoteData$NotAsked, fv: $author$project$RemoteData$NotAsked}
		};
		return A3($author$project$Element$LearningGroupForm$initPageByParams, params, session, model);
	});
var $author$project$Element$LearningGroupForm$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$LearningGroupForm$perform(key),
						effects));
			case 2:
				var cmd = effect.a;
				var request = cmd;
				return $author$project$Api$postV2(request);
			case 3:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 4:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 5:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 6:
				var toMsg = effect.a;
				var effect_ = effect.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					toMsg,
					$author$project$Multiselect$perform(effect_));
			case 7:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			case 8:
				var request = effect.a;
				return $author$project$Api$putV2(request);
			case 9:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			case 10:
				return $author$project$Ports$scrollToFormError;
			default:
				var route = effect.a;
				return A2(
					$elm$browser$Browser$Navigation$pushUrl,
					key,
					$author$project$Route$toString(route));
		}
	});
var $author$project$Element$LearningGroupForm$CreateLearningGroup = function (a) {
	return {$: 7, a: a};
};
var $author$project$Locale$Messages$LearningGroupDownloadError = {$: 146};
var $author$project$Locale$Messages$LearningGroupSaveSuccess = {$: 163};
var $author$project$Element$LearningGroupForm$LearningGroupSaved = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LearningGroupForm$LogError = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$LearningGroupForm$MultiselectEffect = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Element$LearningGroupForm$NavRedirect = function (a) {
	return {$: 11, a: a};
};
var $author$project$Element$LearningGroupForm$NoEffect = {$: 0};
var $author$project$Element$LearningGroupForm$ScrollToFormError = {$: 10};
var $author$project$Element$LearningGroupForm$Students = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LearningGroupForm$UpdateLearningGroup = function (a) {
	return {$: 8, a: a};
};
var $author$project$LearningGroup$encodedLearningGroupToBackend = function (learningGroup) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(
					$author$project$LearningGroup$learningGroupIdToInt(learningGroup.i8))),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(learningGroup.fb)),
				_Utils_Tuple2(
				'team',
				$elm$json$Json$Encode$int(
					$author$project$Team$teamIdToInt(learningGroup.kf))),
				_Utils_Tuple2(
				'shared_with',
				$elm$json$Json$Encode$string(
					function () {
						var _v0 = learningGroup.nE;
						if (!_v0) {
							return 'nobody';
						} else {
							return 'team';
						}
					}())),
				_Utils_Tuple2(
				'students',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, learningGroup.fv))
			]));
};
var $author$project$Api$Endpoint$learningGroupCreate = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'learning-groups']),
		_List_Nil);
};
var $author$project$LearningGroup$createLearningGroup = F3(
	function (config, learningGroup, callback) {
		return {
			T: $author$project$LearningGroup$encodedLearningGroupToBackend(learningGroup),
			b_: config,
			d_: $author$project$LearningGroup$learningGroupDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: $author$project$Api$Endpoint$learningGroupCreate(config.gX)
		};
	});
var $author$project$Form$getMultiselectFieldSelectedValues = function (field) {
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$first,
		$author$project$Multiselect$getSelectedValues(field.og.fs));
};
var $author$project$Element$LearningGroupForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.fb, values) && (A2($author$project$Form$isFieldValid, form.Q, values) && (A2($author$project$Form$isFieldValid, form.fv, values) && A2($author$project$Form$isFieldValid, form.au, values)));
	});
var $author$project$Log$msgLearningGroupsDownload = 'learning_groups_download';
var $author$project$Element$LearningGroupForm$fillForm = function (learningGroup) {
	return {
		au: learningGroup.nE === 1,
		fb: learningGroup.fb,
		Q: $elm$core$String$fromInt(
			$author$project$Team$teamIdToInt(learningGroup.kf.i8)),
		fv: A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.i8;
				},
				$elm$core$String$fromInt),
			learningGroup.fv)
	};
};
var $author$project$Person$teamsAsStudent = function (person) {
	var _v0 = person.nr;
	var roles = _v0;
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$second,
		A2(
			$elm$core$List$filter,
			function (role) {
				return _Utils_eq(role.a, $author$project$Person$roleStudent);
			},
			roles));
};
var $author$project$Person$teamsAsTeacher = function (person) {
	var _v0 = person.nr;
	var roles = _v0;
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$second,
		A2(
			$elm$core$List$filter,
			function (role) {
				return _Utils_eq(role.a, $author$project$Person$roleTeacher) || _Utils_eq(role.a, $author$project$Person$roleModuleTeacher);
			},
			roles));
};
var $author$project$Person$isTeacherOf = F2(
	function (teacher, student) {
		return A2(
			$elm$core$List$any,
			function (team) {
				return A2(
					$elm$core$List$member,
					team,
					$author$project$Person$teamsAsTeacher(teacher));
			},
			$author$project$Person$teamsAsStudent(student));
	});
var $author$project$Element$LearningGroupForm$filterPersonsToSelectOptions = F3(
	function (t_, viewer, people) {
		return A2(
			$author$project$Form$toPeopleOptions,
			t_,
			A2(
				$elm$core$List$filter,
				$author$project$Person$isTeacherOf(viewer),
				people));
	});
var $author$project$Person$teams = function (person) {
	var _v0 = person.nr;
	var roles = _v0;
	return $author$project$Util$List$unique(
		A2($elm$core$List$map, $elm$core$Tuple$second, roles));
};
var $author$project$Person$isMemberOf = F2(
	function (teamId, person) {
		return A2(
			$elm$core$List$member,
			teamId,
			$author$project$Person$teams(person));
	});
var $author$project$Person$filterPersonTeams = F2(
	function (teams_, person) {
		return A2(
			$elm$core$List$filter,
			function (team) {
				return A2($author$project$Person$isMemberOf, team.i8, person);
			},
			teams_);
	});
var $author$project$Team$encodeTeamId = A2($elm$core$Basics$composeR, $author$project$Team$teamIdToInt, $elm$core$String$fromInt);
var $author$project$Form$toTeamOptions = function (teams) {
	return A2(
		$elm$core$List$map,
		function (team) {
			return $author$project$Form$toSelectOption(
				_Utils_Tuple2(
					$author$project$Team$encodeTeamId(team.i8),
					team.lp));
		},
		A2(
			$author$project$Util$List$sortBy,
			function ($) {
				return $.lp;
			},
			teams));
};
var $author$project$Element$LearningGroupForm$toViewerSchoolOptions = F2(
	function (viewer, schools) {
		return $author$project$Form$toTeamOptions(
			A2($author$project$Person$filterPersonTeams, schools, viewer));
	});
var $author$project$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 2) {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var $author$project$Element$LearningGroupForm$openUpdateForm = F3(
	function (learningGroup, _v0, model) {
		var t_ = _v0.h6;
		var viewer = _v0.ok;
		var store = model.bo;
		var studentOptions = A3(
			$author$project$Element$LearningGroupForm$filterPersonsToSelectOptions,
			t_,
			viewer,
			A2($author$project$RemoteData$withDefault, _List_Nil, store.fv));
		var schoolOptions = A2(
			$author$project$Element$LearningGroupForm$toViewerSchoolOptions,
			viewer,
			A2($author$project$RemoteData$withDefault, _List_Nil, store.j2));
		var page = $author$project$Element$LearningGroupForm$FormPage(
			{
				iq: $author$project$Form$Update(learningGroup),
				bE: A4(
					$author$project$Element$LearningGroupForm$buildForm,
					t_,
					$elm$core$Maybe$Just(schoolOptions),
					$elm$core$Maybe$Just(studentOptions),
					$elm$core$Maybe$Just(learningGroup)),
				fs: 0,
				eI: $author$project$Element$LearningGroupForm$fillForm(learningGroup)
			});
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{bk: page}),
			$author$project$Element$LearningGroupForm$NoEffect,
			$elm$core$Maybe$Nothing);
	});
var $author$project$LearningGroup$LearningGroupUnsaved = F6(
	function (id, name, creator, team, sharedWith, students) {
		return {iO: creator, i8: id, fb: name, nE: sharedWith, fv: students, kf: team};
	});
var $author$project$Element$LearningGroupForm$boolToSharing = function (sharing) {
	return sharing ? 1 : 0;
};
var $author$project$Element$LearningGroupForm$saveForm = F4(
	function (form, values, viewer, maybeLearningGroup) {
		return A6(
			$author$project$LearningGroup$LearningGroupUnsaved,
			A2(
				$elm$core$Maybe$withDefault,
				-1,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.i8;
					},
					maybeLearningGroup)),
			form.fb.fC(values),
			viewer.i8,
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Team$blankTeamId,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$identity,
					$elm$core$String$toInt(
						form.Q.fC(values)))),
			$author$project$Element$LearningGroupForm$boolToSharing(
				form.au.fC(values)),
			A2(
				$elm$core$List$filterMap,
				$elm$core$String$toInt,
				form.fv.fC(values)));
	});
var $author$project$Element$LearningGroupForm$resetFormStudents = F2(
	function (session, _v0) {
		var form = _v0.a;
		var values = _v0.b;
		var studentsField = A2(
			$author$project$Form$setMultiselectSelection,
			A2($author$project$Form$toPeopleOptions, session.h6, _List_Nil),
			form.fv);
		return _Utils_Tuple2(
			_Utils_update(
				form,
				{fv: studentsField}),
			A2(form.fv.ks, _List_Nil, values));
	});
var $author$project$Team$decodeTeamId = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Decode$decodeString($author$project$Team$teamIdDecoder),
	$elm$core$Result$withDefault($author$project$Team$blankTeamId));
var $author$project$Form$setMultiselectOptions = F2(
	function (options, field) {
		var view = field.og;
		var updatedState = A3(
			$author$project$Multiselect$populateValues,
			view.fs,
			$author$project$Form$toMultiselectValues(
				$elm$core$Maybe$Just(options)),
			$author$project$Multiselect$getSelectedValues(view.fs));
		return A2(
			$author$project$Form$fillFieldOptions,
			options,
			A2(
				$author$project$Form$mapMultiselect,
				$elm$core$Basics$always(updatedState),
				field));
	});
var $author$project$Person$studentsInTeams = F2(
	function (teamIds, people) {
		return A2(
			$elm$core$List$filter,
			function (person) {
				return A2(
					$elm$core$List$any,
					function (teamId) {
						return A3($author$project$Person$hasRoleAt, $author$project$Person$roleStudent, teamId, person);
					},
					teamIds);
			},
			people);
	});
var $author$project$Element$LearningGroupForm$updateFormStudentsBySchool = F3(
	function (session, store, _v0) {
		var form = _v0.a;
		var values = _v0.b;
		var viewer = session.ok;
		var t_ = session.h6;
		var _v1 = _Utils_Tuple2(store.j2, store.fv);
		if ((_v1.a.$ === 2) && (_v1.b.$ === 2)) {
			var students_ = _v1.b.a;
			var schoolId = $author$project$Team$decodeTeamId(
				form.Q.fC(values));
			var schoolStudents = _Utils_eq(schoolId, $author$project$Team$blankTeamId) ? students_ : A2(
				$author$project$Person$studentsInTeams,
				_List_fromArray(
					[schoolId]),
				students_);
			var studentOptions = A3($author$project$Element$LearningGroupForm$filterPersonsToSelectOptions, t_, viewer, schoolStudents);
			var studentsField = A2($author$project$Form$setMultiselectOptions, studentOptions, form.fv);
			var studentValues = _Utils_eq(schoolId, $author$project$Team$blankTeamId) ? _List_Nil : A2(
				$elm$core$List$map,
				function (student) {
					return $elm$core$String$fromInt(student.i8);
				},
				schoolStudents);
			return _Utils_Tuple2(
				_Utils_update(
					form,
					{fv: studentsField}),
				A2(form.fv.ks, studentValues, values));
		} else {
			return _Utils_Tuple2(form, values);
		}
	});
var $author$project$Element$LearningGroupForm$updateForm = F5(
	function (session, store, msg, form, formValues) {
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							fb: $author$project$Form$markEdited(form.fb)
						}),
					A2(form.fb.ks, value, formValues));
			case 1:
				var value = msg.a;
				return A2(
					$author$project$Element$LearningGroupForm$resetFormStudents,
					session,
					A3(
						$author$project$Element$LearningGroupForm$updateFormStudentsBySchool,
						session,
						store,
						_Utils_Tuple2(
							_Utils_update(
								form,
								{
									Q: $author$project$Form$markEdited(form.Q)
								}),
							A2(form.Q.ks, value, formValues))));
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							fv: $author$project$Form$markEdited(form.fv)
						}),
					A2(form.fv.ks, value, formValues));
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							au: $author$project$Form$markEdited(form.au)
						}),
					A2(form.au.ks, value, formValues));
		}
	});
var $author$project$Locale$Messages$TeamListDownloadError = {$: 600};
var $author$project$Log$msgTeamsDownload = 'teams_download';
var $author$project$Element$LearningGroupForm$updateFormWithSchools = F4(
	function (data, formPage, _v0, model) {
		var action = formPage.iq;
		var form = formPage.bE;
		var values = formPage.eI;
		var t_ = _v0.h6;
		var viewer = _v0.ok;
		var config = model.b_;
		var session = model.gB;
		var store = model.bo;
		var updatedModel = _Utils_update(
			model,
			{
				bo: _Utils_update(
					store,
					{j2: data})
			});
		switch (data.$) {
			case 2:
				var schools = data.a;
				var teamValue = function () {
					if (action.$ === 1) {
						return form.Q.fC(values);
					} else {
						var _v4 = A2($author$project$Person$filterPersonTeams, schools, viewer);
						if (_v4.b && (!_v4.b.b)) {
							var school = _v4.a;
							return $elm$core$String$fromInt(
								$author$project$Team$teamIdToInt(school.i8));
						} else {
							return '';
						}
					}
				}();
				var values2 = _Utils_update(
					values,
					{Q: teamValue});
				var schoolOptions = A2($author$project$Element$LearningGroupForm$toViewerSchoolOptions, viewer, schools);
				var form2 = _Utils_update(
					form,
					{
						Q: A2($author$project$Form$fillFieldOptions, schoolOptions, form.Q)
					});
				var _v2 = A3(
					$author$project$Element$LearningGroupForm$updateFormStudentsBySchool,
					session,
					updatedModel.bo,
					_Utils_Tuple2(form2, values2));
				var form3 = _v2.a;
				var values3 = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						updatedModel,
						{
							bk: $author$project$Element$LearningGroupForm$FormPage(
								_Utils_update(
									formPage,
									{bE: form3, eI: values3}))
						}),
					$author$project$Element$LearningGroupForm$NoEffect,
					$elm$core$Maybe$Nothing);
			case 3:
				var error = data.a;
				return _Utils_Tuple3(
					_Utils_update(
						updatedModel,
						{
							gB: A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$TeamListDownloadError))
						}),
					$author$project$Element$LearningGroupForm$LogError(
						A3(
							$author$project$Log$errorV2,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgTeamsDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeLearningGroups),
								error),
							$elm$core$Basics$always($author$project$Element$LearningGroupForm$NoOp))),
					$elm$core$Maybe$Nothing);
			case 0:
				return _Utils_Tuple3(updatedModel, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
			default:
				return _Utils_Tuple3(updatedModel, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Locale$Messages$PhoneBookDownloadError = {$: 337};
var $author$project$Log$msgPeopleDownload = 'people_download';
var $author$project$Element$LearningGroupForm$updateFormWithStudents = F4(
	function (data, formPage, _v0, model) {
		var form = formPage.bE;
		var values = formPage.eI;
		var viewer = _v0.ok;
		var t_ = _v0.h6;
		var config = model.b_;
		var session = model.gB;
		var store = model.bo;
		var updatedModel = _Utils_update(
			model,
			{
				bo: _Utils_update(
					store,
					{fv: data})
			});
		switch (data.$) {
			case 2:
				var students = data.a;
				var studentOptions = A3($author$project$Element$LearningGroupForm$filterPersonsToSelectOptions, t_, viewer, students);
				var studentsField = A2($author$project$Form$setMultiselectOptions, studentOptions, form.fv);
				var form2 = _Utils_update(
					form,
					{fv: studentsField});
				var _v2 = A3(
					$author$project$Element$LearningGroupForm$updateFormStudentsBySchool,
					session,
					updatedModel.bo,
					_Utils_Tuple2(form2, values));
				var form3 = _v2.a;
				var values2 = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						updatedModel,
						{
							bk: $author$project$Element$LearningGroupForm$FormPage(
								_Utils_update(
									formPage,
									{bE: form3, eI: values2}))
						}),
					$author$project$Element$LearningGroupForm$NoEffect,
					$elm$core$Maybe$Nothing);
			case 3:
				var error = data.a;
				return _Utils_Tuple3(
					_Utils_update(
						updatedModel,
						{
							gB: A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$PhoneBookDownloadError))
						}),
					$author$project$Element$LearningGroupForm$LogError(
						A3(
							$author$project$Log$errorV2,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgPeopleDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeLearningGroups),
								error),
							$elm$core$Basics$always($author$project$Element$LearningGroupForm$NoOp))),
					$elm$core$Maybe$Nothing);
			case 0:
				return _Utils_Tuple3(updatedModel, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
			default:
				return _Utils_Tuple3(updatedModel, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$LearningGroup$updateLearningGroup = F3(
	function (config, learningGroup, callback) {
		return {
			T: $author$project$LearningGroup$encodedLearningGroupToBackend(learningGroup),
			b_: config,
			d_: $author$project$LearningGroup$learningGroupDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2(
				$author$project$Api$Endpoint$learningGroup,
				config.gX,
				$author$project$LearningGroup$learningGroupIdToInt(learningGroup.i8))
		};
	});
var $author$project$Element$LearningGroupForm$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			au: $author$project$Form$markEdited(form.au),
			fb: $author$project$Form$markEdited(form.fb),
			Q: $author$project$Form$markEdited(form.Q),
			fv: $author$project$Form$markEdited(form.fv)
		});
};
var $author$project$Element$LearningGroupForm$update = F2(
	function (msg, model) {
		var config = model.b_;
		var session = model.gB;
		var store = model.bo;
		var viewer = session.ok;
		var t_ = session.h6;
		var noop = _Utils_Tuple3(model, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
		var _v0 = _Utils_Tuple2(msg, model.bk);
		_v0$11:
		while (true) {
			switch (_v0.a.$) {
				case 1:
					if (!_v0.b.$) {
						var data = _v0.a.a;
						var _v1 = _v0.b;
						switch (data.$) {
							case 2:
								var learningGroup = data.a;
								return A3($author$project$Element$LearningGroupForm$openUpdateForm, learningGroup, session, model);
							case 3:
								var error = data.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											gB: A3(
												$author$project$Session$error,
												session,
												error,
												t_($author$project$Locale$Messages$LearningGroupDownloadError))
										}),
									$author$project$Element$LearningGroupForm$LogError(
										A3(
											$author$project$Log$errorV2,
											config,
											_Utils_Tuple3(
												$author$project$Log$msgLearningGroupsDownload,
												$elm$core$Maybe$Just($author$project$Log$paramScopeLearningGroups),
												error),
											$elm$core$Basics$always($author$project$Element$LearningGroupForm$NoOp))),
									$elm$core$Maybe$Nothing);
							case 1:
								return _Utils_Tuple3(model, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
							default:
								return _Utils_Tuple3(model, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$11;
					}
				case 2:
					if (_v0.b.$ === 1) {
						var data = _v0.a.a;
						switch (data.$) {
							case 2:
								var updatedSession = A2(
									$author$project$Session$ok,
									session,
									t_($author$project$Locale$Messages$LearningGroupSaveSuccess));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{gB: updatedSession}),
									$author$project$Element$LearningGroupForm$NavRedirect($author$project$Route$LearningGroupList),
									$elm$core$Maybe$Nothing);
							case 1:
								return _Utils_Tuple3(model, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
							case 3:
								var error = data.a;
								var updatedSession = A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$LearningGroupSaveError));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{gB: updatedSession}),
									$author$project$Element$LearningGroupForm$NoEffect,
									$elm$core$Maybe$Nothing);
							default:
								var error = $author$project$Api$CustomError('Unexpected msg (LearningGroupSaved RemoteData.NotAsked)');
								var updatedSession = A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$LearningGroupSaveError));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{gB: updatedSession}),
									$author$project$Element$LearningGroupForm$NoEffect,
									$elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$11;
					}
				case 3:
					if (_v0.b.$ === 1) {
						var data = _v0.a.a;
						var formPage = _v0.b.a;
						return A4($author$project$Element$LearningGroupForm$updateFormWithSchools, data, formPage, session, model);
					} else {
						var data = _v0.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bo: _Utils_update(
										store,
										{j2: data})
								}),
							$author$project$Element$LearningGroupForm$NoEffect,
							$elm$core$Maybe$Nothing);
					}
				case 4:
					if (_v0.b.$ === 1) {
						var data = _v0.a.a;
						var formPage = _v0.b.a;
						return A4($author$project$Element$LearningGroupForm$updateFormWithStudents, data, formPage, session, model);
					} else {
						var data = _v0.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bo: _Utils_update(
										store,
										{fv: data})
								}),
							$author$project$Element$LearningGroupForm$NoEffect,
							$elm$core$Maybe$Nothing);
					}
				case 8:
					if (_v0.b.$ === 1) {
						var fieldMsg = _v0.a.a;
						var formPage = _v0.b.a;
						var form = formPage.bE;
						var field = form.fv;
						var _v4 = A2($author$project$Form$updateMultiselectField, fieldMsg, field);
						var updatedField = _v4.a;
						var effect = _v4.b;
						var outMsg = _v4.c;
						var formMsg = $author$project$Element$LearningGroupForm$Students(
							$author$project$Form$getMultiselectFieldSelectedValues(updatedField));
						var formPage2 = _Utils_update(
							formPage,
							{
								bE: _Utils_update(
									form,
									{fv: updatedField})
							});
						var _v5 = function () {
							if (!outMsg.$) {
								return A5($author$project$Element$LearningGroupForm$updateForm, session, store, formMsg, formPage2.bE, formPage2.eI);
							} else {
								return _Utils_Tuple2(formPage2.bE, formPage2.eI);
							}
						}();
						var form3 = _v5.a;
						var values3 = _v5.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bk: $author$project$Element$LearningGroupForm$FormPage(
										_Utils_update(
											formPage,
											{bE: form3, fs: 1, eI: values3}))
								}),
							A2($author$project$Element$LearningGroupForm$MultiselectEffect, $author$project$Element$LearningGroupForm$StudentsFieldMsg, effect),
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$11;
					}
				case 5:
					if (_v0.b.$ === 1) {
						var fieldMsg = _v0.a.a;
						var formPage = _v0.b.a;
						var _v7 = A5($author$project$Element$LearningGroupForm$updateForm, session, store, fieldMsg, formPage.bE, formPage.eI);
						var form2 = _v7.a;
						var values2 = _v7.b;
						var page2 = $author$project$Element$LearningGroupForm$FormPage(
							_Utils_update(
								formPage,
								{bE: form2, fs: 1, eI: values2}));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bk: page2}),
							$author$project$Element$LearningGroupForm$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$11;
					}
				case 7:
					if (_v0.b.$ === 1) {
						var _v8 = _v0.a;
						var action = _v0.b.a.iq;
						if (action.$ === 1) {
							var learningGroup = action.a;
							return A3($author$project$Element$LearningGroupForm$openUpdateForm, learningGroup, session, model);
						} else {
							return _Utils_Tuple3(model, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$11;
					}
				case 6:
					if (_v0.b.$ === 1) {
						var _v10 = _v0.a;
						var formPage = _v0.b.a;
						var action = formPage.iq;
						var form = formPage.bE;
						var values = formPage.eI;
						if (A2($author$project$Element$LearningGroupForm$isFormValid, form, values)) {
							var page = $author$project$Element$LearningGroupForm$FormPage(
								_Utils_update(
									formPage,
									{fs: 2}));
							var effect = function () {
								if (!action.$) {
									var unsavedLearningGroup = A4($author$project$Element$LearningGroupForm$saveForm, form, values, viewer, $elm$core$Maybe$Nothing);
									return $author$project$Element$LearningGroupForm$CreateLearningGroup(
										A3($author$project$LearningGroup$createLearningGroup, config, unsavedLearningGroup, $author$project$Element$LearningGroupForm$LearningGroupSaved));
								} else {
									var learningGroup = action.a;
									var unsavedLearningGroup = A4(
										$author$project$Element$LearningGroupForm$saveForm,
										form,
										values,
										viewer,
										$elm$core$Maybe$Just(learningGroup));
									return $author$project$Element$LearningGroupForm$UpdateLearningGroup(
										A3($author$project$LearningGroup$updateLearningGroup, config, unsavedLearningGroup, $author$project$Element$LearningGroupForm$LearningGroupSaved));
								}
							}();
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{bk: page}),
								effect,
								$elm$core$Maybe$Nothing);
						} else {
							var page = $author$project$Element$LearningGroupForm$FormPage(
								_Utils_update(
									formPage,
									{
										bE: $author$project$Element$LearningGroupForm$validateForm(form),
										fs: 1
									}));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{bk: page}),
								$author$project$Element$LearningGroupForm$ScrollToFormError,
								$elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$11;
					}
				case 9:
					if (_v0.b.$ === 1) {
						var _v12 = _v0.a;
						return _Utils_Tuple3(
							model,
							$author$project$Element$LearningGroupForm$NavRedirect($author$project$Route$LearningGroupList),
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$11;
					}
				default:
					break _v0$11;
			}
		}
		return noop;
	});
var $author$project$Locale$Messages$LearningGroupListLoadingProgress = {$: 157};
var $author$project$Element$LearningGroupForm$Exit = {$: 9};
var $author$project$Element$LearningGroupForm$FormReset = {$: 7};
var $author$project$Element$LearningGroupForm$FormSubmitted = {$: 6};
var $author$project$Locale$Messages$LearningGroupBtnOwn = {$: 142};
var $author$project$Locale$Messages$LearningGroupBtnSchool = {$: 143};
var $author$project$Locale$Messages$LearningGroupHeadingEdit = {$: 152};
var $author$project$Locale$Messages$LearningGroupHeadingNew = {$: 153};
var $author$project$Element$LearningGroupForm$viewForm = F2(
	function (t_, _v0) {
		var action = _v0.iq;
		var state = _v0.fs;
		var form = _v0.bE;
		var values = _v0.eI;
		var stringFromBool = function (value) {
			return value ? 'True' : 'False';
		};
		var viewFormFields = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth')
				]),
			_List_fromArray(
				[
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.fb, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.Q, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$multiselectChoiceField, t_, form.fv, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('buttons has-addons')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button is-rounded'),
											A2($elm$html$Html$Attributes$style, 'z-index', '0'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'is-selected is-link is-light',
													stringFromBool(
														form.au.fC(values)) === 'False')
												])),
											$elm$html$Html$Events$onClick(
											$author$project$Element$LearningGroupForm$FormMsg(
												$author$project$Element$LearningGroupForm$IsShared(false)))
										]),
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningGroupBtnOwn)
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button is-rounded'),
											A2($elm$html$Html$Attributes$style, 'z-index', '0'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'is-selected is-link is-light',
													stringFromBool(
														form.au.fC(values)) === 'True')
												])),
											$elm$html$Html$Events$onClick(
											$author$project$Element$LearningGroupForm$FormMsg(
												$author$project$Element$LearningGroupForm$IsShared(true)))
										]),
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningGroupBtnSchool)
										]))
								]))
						]))
				]));
		var headingText = function () {
			if (!action.$) {
				return $author$project$Locale$Messages$LearningGroupHeadingNew;
			} else {
				return $author$project$Locale$Messages$LearningGroupHeadingEdit;
			}
		}();
		return $author$project$UI$panel(
			{
				g$: _List_fromArray(
					[
						viewFormFields,
						A2(
						$author$project$UI$nav,
						_List_fromArray(
							[
								A5(
								$author$project$UI$formButtons,
								t_,
								action,
								state,
								$author$project$Element$LearningGroupForm$FormSubmitted,
								$elm$core$Basics$always($author$project$Element$LearningGroupForm$FormReset)),
								A3(
								$author$project$UI$actionLink,
								$author$project$Element$LearningGroupForm$Exit,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button is-light')
									]),
								_List_fromArray(
									[
										A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnCancel)
									]))
							]),
						_List_Nil)
					]),
				cm: 'learninggroup-form',
				hl: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, headingText)
							]),
						_List_Nil)
					]),
				h7: _List_Nil,
				ie: 'is-light'
			});
	});
var $author$project$Element$LearningGroupForm$view = function (_v0) {
	var session = _v0.gB;
	var page = _v0.bk;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				if (page.$ === 1) {
					var formPage = page.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Element$LearningGroupForm$viewForm, session.h6, formPage)
							]));
				} else {
					return A2(
						$author$project$UI$progressBar,
						'is-link',
						session.h6($author$project$Locale$Messages$LearningGroupListLoadingProgress));
				}
			}()
			]));
};
var $author$project$Element$LearningGroupForm$element = {jb: $author$project$Element$LearningGroupForm$init, hP: $author$project$Element$LearningGroupForm$perform, ks: $author$project$Element$LearningGroupForm$update, og: $author$project$Element$LearningGroupForm$view};
var $author$project$Element$LearningGroupList$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LearningGroupList$FetchLearningGroupList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$LearningGroupList$LearningGroupListDownloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$LearningGroupList$ListQuery = $elm$core$Basics$identity;
var $author$project$Element$LearningGroupList$LoadingLearningGroups = 0;
var $author$project$Element$LearningGroupList$getListQuery = function (_v0) {
	var query = _v0;
	return query;
};
var $author$project$Element$LearningGroupList$listFilterToCategory = function (filter) {
	var _v0 = filter.bD;
	switch (_v0) {
		case 0:
			return $author$project$Api$Endpoint$categoryAll;
		case 1:
			return $author$project$Api$Endpoint$categorySchools;
		default:
			return $author$project$Api$Endpoint$categoryCreator;
	}
};
var $author$project$Element$LearningGroupList$asListParams = function (_v0) {
	var filter = _v0.ad;
	var query = _v0.bF;
	return {
		bD: $author$project$Element$LearningGroupList$listFilterToCategory(filter),
		bF: $author$project$Element$LearningGroupList$getListQuery(query)
	};
};
var $author$project$Element$LearningGroupList$FilterAll = 0;
var $author$project$Element$LearningGroupList$ListFilter = function (category) {
	return {bD: category};
};
var $author$project$Element$LearningGroupList$defaultFilter = $author$project$Element$LearningGroupList$ListFilter(0);
var $author$project$Api$Endpoint$toLearningGroupListQueryParams = function (listParams) {
	return _List_fromArray(
		[
			_Utils_Tuple2('cat', listParams.bD),
			_Utils_Tuple2('q', listParams.bF)
		]);
};
var $author$project$Api$Endpoint$learningGroups = F2(
	function (config, listParams) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'learning-groups']),
			$author$project$Api$Endpoint$toLearningGroupListQueryParams(listParams));
	});
var $author$project$LearningGroup$fetchLearningGroups = F3(
	function (config, params, callback) {
		return {
			b_: config,
			d_: $elm$json$Json$Decode$list($author$project$LearningGroup$learningGroupDecoder),
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2($author$project$Api$Endpoint$learningGroups, config, params)
		};
	});
var $author$project$Element$LearningGroupList$init = F3(
	function (config, session, _v0) {
		var model = {b_: config, ad: $author$project$Element$LearningGroupList$defaultFilter, cv: _List_Nil, dj: 0, bF: '', gB: session, cP: $elm$core$Dict$empty};
		var listParams = $author$project$Element$LearningGroupList$asListParams(model);
		return _Utils_Tuple3(
			model,
			$author$project$Element$LearningGroupList$Cmd(
				$author$project$Element$LearningGroupList$FetchLearningGroupList(
					A3($author$project$LearningGroup$fetchLearningGroups, config.gX, listParams, $author$project$Element$LearningGroupList$LearningGroupListDownloaded))),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$LearningGroupList$SingleElementEffect = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Element$LearningGroupList$SingleElementMsg = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Element$LearningGroupSingle$NoEffect = {$: 0};
var $author$project$Element$LearningGroupSingle$init = F3(
	function (config, session, _v0) {
		var learningGroup = _v0.mq;
		var highlight = _v0.lU;
		var model = {b_: config, lU: highlight, mq: learningGroup, gB: session};
		return _Utils_Tuple3(model, $author$project$Element$LearningGroupSingle$NoEffect, $elm$core$Maybe$Nothing);
	});
var $author$project$Element$LearningGroupSingle$perform = F2(
	function (key, effect) {
		if (!effect.$) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var cmd = effect.a;
			switch (cmd.$) {
				case 0:
					var request = cmd.a;
					return $author$project$Api$deleteV2(request);
				case 2:
					var route = cmd.a;
					return A2(
						$elm$browser$Browser$Navigation$pushUrl,
						key,
						$author$project$Route$toString(route));
				default:
					var request = cmd.a;
					return $author$project$Api$postV2(request);
			}
		}
	});
var $author$project$Element$LearningGroupSingle$Cmd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupSingle$DeleteLearningGroup = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$LearningGroupSingle$Deleted = 0;
var $author$project$Locale$Messages$LearningGroupDeleteError = {$: 144};
var $author$project$Locale$Messages$LearningGroupDeleteSuccess = {$: 145};
var $author$project$Element$LearningGroupSingle$LearningGroupDeleted = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupSingle$LogError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupSingle$NavRedirect = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LearningGroupSingle$NoOp = {$: 2};
var $author$project$LearningGroup$deleteLearningGroup = F3(
	function (config, learningGroup, callback) {
		return {
			T: $elm$http$Http$emptyBody,
			b_: config,
			cf: callback,
			K: A2(
				$author$project$Api$Endpoint$learningGroup,
				config,
				$author$project$LearningGroup$learningGroupIdToInt(learningGroup.i8))
		};
	});
var $author$project$Log$msgLearningGroupDelete = 'learning_group_delete';
var $author$project$Element$LearningGroupSingle$update = F2(
	function (msg, model) {
		var config = model.b_;
		var session = model.gB;
		switch (msg.$) {
			case 0:
				var learningGroup = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Element$LearningGroupSingle$Cmd(
						$author$project$Element$LearningGroupSingle$DeleteLearningGroup(
							A3($author$project$LearningGroup$deleteLearningGroup, config.gX, learningGroup, $author$project$Element$LearningGroupSingle$LearningGroupDeleted))),
					$elm$core$Maybe$Nothing);
			case 1:
				if (!msg.a.$) {
					var model2 = _Utils_update(
						model,
						{
							gB: A2(
								$author$project$Session$ok,
								session,
								session.h6($author$project$Locale$Messages$LearningGroupDeleteSuccess))
						});
					return _Utils_Tuple3(
						model2,
						$author$project$Element$LearningGroupSingle$Cmd(
							$author$project$Element$LearningGroupSingle$NavRedirect($author$project$Route$LearningGroupList)),
						$elm$core$Maybe$Just(0));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$LearningGroupDeleteError))
							}),
						$author$project$Element$LearningGroupSingle$Cmd(
							$author$project$Element$LearningGroupSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgLearningGroupDelete, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$LearningGroupSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			default:
				return _Utils_Tuple3(model, $author$project$Element$LearningGroupSingle$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$LearningGroupSingle$LearningGroupRemovalRequested = function (a) {
	return {$: 0, a: a};
};
var $author$project$ACL$canDeleteLearningGroup = F2(
	function (learningGroup, person) {
		return A2($author$project$Person$isSamePerson, learningGroup.iO, person);
	});
var $author$project$ACL$canEditLearningGroup = F2(
	function (learningGroup, person) {
		return A2($author$project$Person$isSamePerson, learningGroup.iO, person) || A2(
			$elm$core$List$member,
			learningGroup.kf.i8,
			$author$project$Person$teams(person));
	});
var $author$project$Element$LearningGroupSingle$viewLearningGroupHighlights = F2(
	function (t_, learningGroup) {
		return $author$project$UI$mediaObjectHighlights(
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Person$fullName, t_, learningGroup.iO)),
					$elm$html$Html$text(learningGroup.kf.lp)
				]));
	});
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $author$project$Util$Html$needle = function (needles) {
	return $elm$parser$Parser$getChompedString(
		$elm$parser$Parser$oneOf(
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeL, $elm$parser$Parser$backtrackable, $elm$parser$Parser$token),
				needles)));
};
var $elm$parser$Parser$Advanced$chompUntilEndOr = function (str) {
	return function (s) {
		var _v0 = A5(_Parser_findSubString, str, s.d, s.ns, s.k9, s.c);
		var newOffset = _v0.a;
		var newRow = _v0.b;
		var newCol = _v0.c;
		var adjustedOffset = (newOffset < 0) ? $elm$core$String$length(s.c) : newOffset;
		return A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.d, adjustedOffset) < 0,
			0,
			{k9: newCol, l: s.l, r: s.r, d: adjustedOffset, ns: newRow, c: s.c});
	};
};
var $elm$parser$Parser$chompUntilEndOr = $elm$parser$Parser$Advanced$chompUntilEndOr;
var $author$project$Util$Html$notNeedle = function (needles) {
	return $elm$parser$Parser$getChompedString(
		$elm$parser$Parser$oneOf(
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeL, $elm$parser$Parser$backtrackable, $elm$parser$Parser$chompUntilEndOr),
				needles)));
};
var $author$project$Util$Html$fuzzyMatchTextHelp = F4(
	function (needles, mapNeedle, mapNotNeedle, revItems) {
		var stop = $elm$parser$Parser$map(
			$elm$core$Basics$always(
				$elm$parser$Parser$Done(
					$elm$core$List$reverse(revItems))));
		var next = $elm$parser$Parser$map(
			function (item) {
				return $elm$parser$Parser$Loop(
					A2($elm$core$List$cons, item, revItems));
			});
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					stop($elm$parser$Parser$end),
					next(
					A2(
						$elm$parser$Parser$map,
						mapNeedle,
						$author$project$Util$Html$needle(needles))),
					next(
					A2(
						$elm$parser$Parser$map,
						mapNotNeedle,
						$author$project$Util$Html$notNeedle(needles)))
				]));
	});
var $author$project$Util$Html$fuzzyMatchText = F4(
	function (needle_, haystack, mapNeedle, mapNotNeedle) {
		var regex = A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			A2(
				$elm$regex$Regex$fromStringWith,
				{k6: true, mJ: false},
				needle_));
		var needles = A2(
			$elm$core$List$map,
			function ($) {
				return $.mu;
			},
			A2($elm$regex$Regex$find, regex, haystack));
		return $elm$core$List$isEmpty(needles) ? A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, mapNotNeedle, $elm$core$List$singleton),
			$elm$parser$Parser$succeed(haystack)) : A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			A3($author$project$Util$Html$fuzzyMatchTextHelp, needles, mapNeedle, mapNotNeedle));
	});
var $author$project$UI$withHighlightedText = F2(
	function (highlight_, content) {
		var toHtml = $elm$html$Html$text;
		var highlightToHtml = function (match) {
			return A2(
				$elm$html$Html$mark,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(match)
					]));
		};
		return $elm$core$String$isEmpty(highlight_) ? toHtml(content) : A2(
			$elm$core$Result$withDefault,
			toHtml(content),
			A2(
				$elm$core$Result$map,
				$elm$html$Html$span(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('has-match')
						])),
				A2(
					$elm$parser$Parser$run,
					A4($author$project$Util$Html$fuzzyMatchText, highlight_, content, highlightToHtml, toHtml),
					content)));
	});
var $author$project$Element$LearningGroupSingle$viewLearningGroupName = F2(
	function (learningGroup, highlight) {
		return A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('title is-size-6 mb-2')
				]),
			_List_fromArray(
				[
					A2($author$project$UI$withHighlightedText, highlight, learningGroup.fb)
				]));
	});
var $author$project$Locale$Messages$LearningGroupEmptyStudents = {$: 147};
var $author$project$Element$LearningGroupSingle$viewStudents = F3(
	function (t_, learningGroup, highlight) {
		var studentNames = $elm$core$List$isEmpty(learningGroup.fv) ? t_($author$project$Locale$Messages$LearningGroupEmptyStudents) : A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$author$project$Person$fullName(t_),
				learningGroup.fv));
		return A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$UI$withHighlightedText, highlight, studentNames)
				]));
	});
var $author$project$Element$LearningGroupSingle$viewLearningGroupItem = F4(
	function (t_, viewer, learningGroup, highlight) {
		var viewMediaObject = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-2')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$UI$mediaObjectSmall,
					_List_fromArray(
						[
							$author$project$UI$gravatar(learningGroup.iO.O)
						]),
					_List_fromArray(
						[
							A2($author$project$Element$LearningGroupSingle$viewLearningGroupName, learningGroup, highlight),
							A2($author$project$Element$LearningGroupSingle$viewLearningGroupHighlights, t_, learningGroup)
						]),
					_List_Nil,
					_List_Nil)
				]));
		var editLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$LearningGroupUpdate(
						$author$project$LearningGroup$learningGroupIdToInt(learningGroup.i8))),
					$author$project$UI$attrCyData('learninggroup-item-edit')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$edit(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnEdit)
				]));
		var deleteLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$LearningGroupSingle$LearningGroupRemovalRequested(learningGroup),
			_List_fromArray(
				[
					$author$project$UI$attrCyData('learninggroup-item-delete')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$delete(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnDelete)
				]));
		var viewNav = A2(
			$author$project$UI$nav,
			_List_fromArray(
				[
					A2($author$project$ACL$canEditLearningGroup, learningGroup, viewer) ? editLink : $author$project$UI$none,
					A2($author$project$ACL$canDeleteLearningGroup, learningGroup, viewer) ? deleteLink : $author$project$UI$none
				]),
			_List_Nil);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$UI$attrCyData('learninggroup-item'),
					$elm$html$Html$Attributes$class('box'),
					A2($elm$html$Html$Attributes$style, 'width', '100%')
				]),
			_List_fromArray(
				[
					viewMediaObject,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							A3($author$project$Element$LearningGroupSingle$viewStudents, t_, learningGroup, highlight)
						])),
					viewNav
				]));
	});
var $author$project$Element$LearningGroupSingle$view = function (_v0) {
	var session = _v0.gB;
	var learningGroup = _v0.mq;
	var highlight = _v0.lU;
	return A4($author$project$Element$LearningGroupSingle$viewLearningGroupItem, session.h6, session.ok, learningGroup, highlight);
};
var $author$project$Element$LearningGroupSingle$element = {jb: $author$project$Element$LearningGroupSingle$init, hP: $author$project$Element$LearningGroupSingle$perform, ks: $author$project$Element$LearningGroupSingle$update, og: $author$project$Element$LearningGroupSingle$view};
var $author$project$Element$LearningGroupList$singleElement = function (learningGroupId) {
	return {
		ha: $author$project$Element$LearningGroupSingle$element,
		kk: $author$project$Element$LearningGroupList$SingleElementEffect(learningGroupId),
		cf: $author$project$Element$LearningGroupList$SingleElementMsg(learningGroupId),
		kt: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						cP: A3(
							$elm$core$Dict$update,
							$author$project$LearningGroup$learningGroupIdToInt(learningGroupId),
							$elm$core$Basics$always(
								$elm$core$Maybe$Just(model)),
							containerModel.cP)
					});
			})
	};
};
var $author$project$Element$LearningGroupList$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 3:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$LearningGroupList$perform(key),
						effects));
			case 2:
				var cmd = effect.a;
				switch (cmd.$) {
					case 2:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					case 0:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					default:
						var seconds = cmd.a;
						var toMsg = cmd.b;
						return A2($author$project$Util$Delay$after, seconds, toMsg);
				}
			default:
				var learningGroupId = effect.a;
				var elementEffect = effect.b;
				return A3(
					$author$project$Application$V3$Boundaries$performElement,
					key,
					elementEffect,
					$author$project$Element$LearningGroupList$singleElement(learningGroupId));
		}
	});
var $author$project$Element$LearningGroupList$Delay = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Element$LearningGroupList$DelayedGotListQuery = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LearningGroupList$LogError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LearningGroupList$NoEffect = {$: 3};
var $author$project$Element$LearningGroupList$NoOp = {$: 5};
var $author$project$Element$LearningGroupList$LearningGroupsLoaded = 1;
var $author$project$Element$LearningGroupList$addNewLearningGroups = F2(
	function (newGroups, model) {
		var loading = model.dj;
		var learningGroups = model.cv;
		var _v0 = _Utils_Tuple3(loading, learningGroups, newGroups);
		if ((!_v0.a) && (!_v0.b.b)) {
			var _v1 = _v0.a;
			return _Utils_update(
				model,
				{cv: newGroups, dj: 1});
		} else {
			return model;
		}
	});
var $author$project$Element$LearningGroupList$emptyList = function (model) {
	return _Utils_update(
		model,
		{cv: _List_Nil, dj: 0});
};
var $author$project$Element$LearningGroupList$filterLearningGroups = F2(
	function (model, newFilter) {
		var filter = model.ad;
		var model_ = $author$project$Element$LearningGroupList$emptyList(
			_Utils_update(
				model,
				{
					ad: _Utils_update(
						filter,
						{bD: newFilter})
				}));
		var listParams = $author$project$Element$LearningGroupList$asListParams(model_);
		return _Utils_Tuple3(
			model_,
			$author$project$Element$LearningGroupList$Cmd(
				$author$project$Element$LearningGroupList$FetchLearningGroupList(
					A3($author$project$LearningGroup$fetchLearningGroups, model.b_.gX, listParams, $author$project$Element$LearningGroupList$LearningGroupListDownloaded))),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$LearningGroupList$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupList$batchEffect = F2(
	function (newEffect, effect) {
		switch (effect.$) {
			case 3:
				return newEffect;
			case 1:
				var effects = effect.a;
				return $author$project$Element$LearningGroupList$BatchEffect(
					A2($elm$core$List$cons, newEffect, effects));
			case 2:
				return $author$project$Element$LearningGroupList$BatchEffect(
					_List_fromArray(
						[newEffect, effect]));
			default:
				return $author$project$Element$LearningGroupList$BatchEffect(
					_List_fromArray(
						[newEffect, effect]));
		}
	});
var $author$project$Element$LearningGroupList$initLearningGroupSingles = F2(
	function (model, learningGroups) {
		var startModel = _Utils_update(
			model,
			{cv: learningGroups, dj: 1});
		var initLearningGroupSingle = F2(
			function (learningGroup, _v1) {
				var model_ = _v1.a;
				var effect_ = _v1.b;
				var single = $author$project$Element$LearningGroupList$singleElement(learningGroup.i8);
				var params = {
					lU: $author$project$Element$LearningGroupList$getListQuery(model.bF),
					mq: learningGroup
				};
				var _v0 = A3(
					$author$project$Application$V3$Boundaries$mapElement,
					model_,
					single,
					A4($author$project$Application$V3$Boundaries$initElement, model_.b_, model_.gB, single, params));
				var model2 = _v0.a;
				var effect2 = _v0.b;
				return _Utils_Tuple3(
					model2,
					A2($author$project$Element$LearningGroupList$batchEffect, effect2, effect_),
					$elm$core$Maybe$Nothing);
			});
		return A3(
			$elm$core$List$foldl,
			initLearningGroupSingle,
			_Utils_Tuple3(startModel, $author$project$Element$LearningGroupList$NoEffect, $elm$core$Maybe$Nothing),
			learningGroups);
	});
var $author$project$Element$LearningGroupList$update = F2(
	function (msg, model) {
		var config = model.b_;
		var session = model.gB;
		var t_ = session.h6;
		var noop = _Utils_Tuple3(model, $author$project$Element$LearningGroupList$NoEffect, $elm$core$Maybe$Nothing);
		switch (msg.$) {
			case 0:
				var learningGroupId = msg.a;
				var singleMsg = msg.b;
				var updateSingleElement = function (singleModel_) {
					var single = $author$project$Element$LearningGroupList$singleElement(learningGroupId);
					var _v1 = A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						single,
						A4($author$project$Application$V3$Boundaries$updateElement, session, singleMsg, singleModel_, single));
					var model2 = _v1.a;
					var effect = _v1.b;
					var reply = _v1.c;
					if (!reply.$) {
						var _v3 = reply.a;
						return _Utils_Tuple3(
							_Utils_update(
								model2,
								{
									cP: A2(
										$elm$core$Dict$remove,
										$author$project$LearningGroup$learningGroupIdToInt(learningGroupId),
										model.cP)
								}),
							effect,
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
					}
				};
				var singleModel = A2(
					$elm$core$Dict$get,
					$author$project$LearningGroup$learningGroupIdToInt(learningGroupId),
					model.cP);
				return A2(
					$elm$core$Maybe$withDefault,
					noop,
					A2($elm$core$Maybe$map, updateSingleElement, singleModel));
			case 1:
				var newFilter = msg.a;
				return A2($author$project$Element$LearningGroupList$filterLearningGroups, model, newFilter);
			case 2:
				var query = msg.a;
				return _Utils_Tuple3(
					$author$project$Element$LearningGroupList$emptyList(
						_Utils_update(
							model,
							{bF: query})),
					$author$project$Element$LearningGroupList$Cmd(
						A2(
							$author$project$Element$LearningGroupList$Delay,
							$author$project$Util$Delay$searchBarDelay,
							$author$project$Element$LearningGroupList$DelayedGotListQuery(query))),
					$elm$core$Maybe$Nothing);
			case 3:
				var newQuery = msg.a;
				var cmd = _Utils_eq(newQuery, model.bF) ? $author$project$Element$LearningGroupList$Cmd(
					$author$project$Element$LearningGroupList$FetchLearningGroupList(
						A3(
							$author$project$LearningGroup$fetchLearningGroups,
							config.gX,
							$author$project$Element$LearningGroupList$asListParams(model),
							$author$project$Element$LearningGroupList$LearningGroupListDownloaded))) : $author$project$Element$LearningGroupList$NoEffect;
				return _Utils_Tuple3(model, cmd, $elm$core$Maybe$Nothing);
			case 4:
				var data = msg.a;
				switch (data.$) {
					case 2:
						var learningGroups = data.a;
						var updatedModel = A2($author$project$Element$LearningGroupList$addNewLearningGroups, learningGroups, model);
						return A2($author$project$Element$LearningGroupList$initLearningGroupSingles, updatedModel, updatedModel.cv);
					case 3:
						var error = data.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									gB: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$LearningGroupDownloadError))
								}),
							$author$project$Element$LearningGroupList$Cmd(
								$author$project$Element$LearningGroupList$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgLearningGroupsDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$LearningGroupList$NoOp)))),
							$elm$core$Maybe$Nothing);
					case 1:
						return noop;
					default:
						return noop;
				}
			default:
				return noop;
		}
	});
var $author$project$Element$LearningGroupList$FilterOwn = 2;
var $author$project$Element$LearningGroupList$FilterTeam = 1;
var $author$project$Element$LearningGroupList$GotCategoryFilter = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupList$GotListQuery = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$LearningGroupListAllFilter = {$: 155};
var $author$project$Locale$Messages$LearningGroupListEmptyResults = {$: 156};
var $author$project$Locale$Messages$LearningGroupListOwnFilter = {$: 158};
var $author$project$Locale$Messages$LearningGroupListSchoolFilter = {$: 159};
var $author$project$Locale$Messages$LearningGroupListSearch = {$: 160};
var $author$project$Locale$Messages$LearningGroupTitle = {$: 167};
var $author$project$ACL$canCreateLearningGroup = function (person) {
	return $author$project$ACL$isStaff(person) || ($author$project$Person$isTeacher(person) || $author$project$Person$isModuleTeacher(person));
};
var $author$project$Element$LearningGroupList$viewSingleElement = F3(
	function (session, leaningGroup, singleModel) {
		return A3(
			$author$project$Application$V3$Boundaries$viewElement,
			session,
			singleModel,
			$author$project$Element$LearningGroupList$singleElement(leaningGroup.i8));
	});
var $author$project$Element$LearningGroupList$viewLearningGroupList = function (_v0) {
	var learningGroups = _v0.cv;
	var filter = _v0.ad;
	var query = _v0.bF;
	var singleElements = _v0.cP;
	var session = _v0.gB;
	var loading = _v0.dj;
	var viewer = session.ok;
	var viewKeyedItem = function (learningGroup) {
		return _Utils_Tuple2(
			$elm$core$String$fromInt(
				$author$project$LearningGroup$learningGroupIdToInt(learningGroup.i8)),
			A2(
				$author$project$UI$maybe,
				A2(
					$elm$core$Dict$get,
					$author$project$LearningGroup$learningGroupIdToInt(learningGroup.i8),
					singleElements),
				A2($author$project$Element$LearningGroupList$viewSingleElement, session, learningGroup)));
	};
	var t_ = session.h6;
	var viewCreateLink = A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$author$project$Route$href($author$project$Route$LearningGroupCreate),
				$author$project$UI$attrCyData('learninggroup-create'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$BtnCreate))
			]),
		_List_fromArray(
			[
				$author$project$UI$Icon$add(
				_List_fromArray(
					[
						$author$project$UI$Icon$style('has-text-white')
					]))
			]));
	var viewFilterLinks = A3(
		$author$project$UI$List$filterBar,
		t_,
		_Utils_Tuple2($author$project$Element$LearningGroupList$GotCategoryFilter, filter.bD),
		_List_fromArray(
			[
				{
				cm: 'all',
				ad: 0,
				hv: true,
				hw: $author$project$ACL$canViewLearningGroup(viewer),
				ea: $author$project$Locale$Messages$LearningGroupListAllFilter
			},
				{
				cm: 'team',
				ad: 1,
				hv: true,
				hw: $author$project$ACL$canViewLearningGroup(viewer),
				ea: $author$project$Locale$Messages$LearningGroupListSchoolFilter
			},
				{
				cm: 'own',
				ad: 2,
				hv: true,
				hw: $author$project$ACL$canViewLearningGroup(viewer),
				ea: $author$project$Locale$Messages$LearningGroupListOwnFilter
			}
			]));
	var viewHeading = A2(
		$author$project$UI$levelHorizontal,
		_List_fromArray(
			[
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningGroupTitle)
			]),
		$author$project$ACL$canCreateLearningGroup(viewer) ? _List_fromArray(
			[viewCreateLink]) : _List_Nil);
	var viewLoadingState = function () {
		var _v1 = _Utils_Tuple2(loading, learningGroups);
		_v1$2:
		while (true) {
			if (!_v1.a) {
				if (!_v1.b.b) {
					var _v2 = _v1.a;
					return _List_fromArray(
						[$author$project$UI$List$resultsLoadingProgressBar]);
				} else {
					break _v1$2;
				}
			} else {
				if (!_v1.b.b) {
					var _v3 = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$UI$List$emptyResultsInfo, t_, $author$project$Locale$Messages$LearningGroupListEmptyResults)
						]);
				} else {
					break _v1$2;
				}
			}
		}
		return _List_Nil;
	}();
	return $author$project$UI$keyedPanel(
		{
			g$: A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('columns container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column')
								]),
							_List_fromArray(
								[
									$author$project$UI$List$searchBar(
									{
										fe: function (input) {
											return $author$project$Element$LearningGroupList$GotListQuery(input);
										},
										fj: t_($author$project$Locale$Messages$LearningGroupListSearch),
										bF: $author$project$Element$LearningGroupList$getListQuery(query)
									})
								]))
						])),
				viewLoadingState),
			cm: 'learninggroup-list',
			hl: _List_fromArray(
				[viewHeading]),
			mm: A2($elm$core$List$map, viewKeyedItem, learningGroups),
			h7: viewFilterLinks,
			ie: 'is-warning'
		});
};
var $author$project$Element$LearningGroupList$view = $author$project$Element$LearningGroupList$viewLearningGroupList;
var $author$project$Element$LearningGroupList$element = {jb: $author$project$Element$LearningGroupList$init, hP: $author$project$Element$LearningGroupList$perform, ks: $author$project$Element$LearningGroupList$update, og: $author$project$Element$LearningGroupList$view};
var $author$project$Element$LearningGroupSelector$LoadingPage = {$: 0};
var $author$project$Element$LearningGroupSelector$FetchLearningGroups = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LearningGroupSelector$FormPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupSelector$LearningGroupListDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$LearningGroupSelectorFieldGroups = {$: 164};
var $author$project$Element$LearningGroupSelector$initLearningGroupsField = function (options) {
	var defaultConfig = $author$project$Multiselect$defaultConfig;
	return $author$project$Multiselect$initModel(
		_Utils_update(
			defaultConfig,
			{
				n0: 'LearningGroups',
				eI: $author$project$Form$toMultiselectValues(options)
			}));
};
var $author$project$Form$requiredLearningGroups = F2(
	function (_v0, value) {
		return $elm$core$Result$Ok(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$identity,
						$elm$core$Maybe$withDefault(0)),
					$elm$core$String$toInt),
				value));
	});
var $author$project$Element$LearningGroupSelector$buildForm = F2(
	function (t_, learningGroupOptions) {
		var viewF = {
			cm: 'groups',
			e6: 'fa-people-group',
			ea: t_($author$project$Locale$Messages$LearningGroupSelectorFieldGroups),
			m_: learningGroupOptions,
			fs: $author$project$Element$LearningGroupSelector$initLearningGroupsField(learningGroupOptions),
			cf: $author$project$Element$LearningGroupSelector$LearningGroupsFieldMsg
		};
		var options = A2($elm$core$Maybe$withDefault, _List_Nil, learningGroupOptions);
		var learninGroupsField = {
			e0: false,
			fi: $author$project$Form$requiredLearningGroups(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{cv: value});
				}),
			fC: function ($) {
				return $.cv;
			},
			og: viewF
		};
		return {
			cv: A2($author$project$Form$setMultiselectSelection, options, learninGroupsField)
		};
	});
var $author$project$LearningGroup$defaultListParams = {bD: $author$project$Api$Endpoint$categoryAll, bF: ''};
var $author$project$Element$LearningGroupSelector$emptyForm = {cv: _List_Nil};
var $author$project$Element$LearningGroupSelector$initPageByParams = F3(
	function (params, session, model) {
		var page = $author$project$Element$LearningGroupSelector$FormPage(
			{
				bE: A2($author$project$Element$LearningGroupSelector$buildForm, session.h6, $elm$core$Maybe$Nothing),
				fs: 0,
				eI: $author$project$Element$LearningGroupSelector$emptyForm
			});
		var updatedModel = _Utils_update(
			model,
			{
				bk: page,
				Q: params.Q,
				bo: {cv: $author$project$RemoteData$Loading}
			});
		var listParams = $author$project$LearningGroup$defaultListParams;
		return _Utils_Tuple3(
			updatedModel,
			$author$project$Element$LearningGroupSelector$FetchLearningGroups(
				A3($author$project$LearningGroup$fetchLearningGroups, model.b_.gX, listParams, $author$project$Element$LearningGroupSelector$LearningGroupListDownloaded)),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$LearningGroupSelector$init = F3(
	function (config, session, params) {
		var model = {
			b_: config,
			bk: $author$project$Element$LearningGroupSelector$LoadingPage,
			Q: params.Q,
			j7: _List_Nil,
			gB: session,
			bo: {cv: $author$project$RemoteData$NotAsked}
		};
		return A3($author$project$Element$LearningGroupSelector$initPageByParams, params, session, model);
	});
var $author$project$Element$LearningGroupSelector$perform = F2(
	function (_v0, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			case 2:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			default:
				var toMsg = effect.a;
				var effect_ = effect.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					toMsg,
					$author$project$Multiselect$perform(effect_));
		}
	});
var $author$project$Element$LearningGroupSelector$Cmd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupSelector$Exit = {$: 0};
var $author$project$Element$LearningGroupSelector$FormMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LearningGroupSelector$LearningGroups = $elm$core$Basics$identity;
var $author$project$Element$LearningGroupSelector$LogError = $elm$core$Basics$identity;
var $author$project$Element$LearningGroupSelector$MultiselectEffect = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Element$LearningGroupSelector$NoEffect = {$: 0};
var $author$project$Element$LearningGroupSelector$NoOp = {$: 5};
var $author$project$Element$LearningGroupSelector$SelectedStudents = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupSelector$makeStudentSet = function (groups) {
	var addIfNotExists = F2(
		function (group, acc) {
			return A3(
				$elm$core$List$foldl,
				F2(
					function (student, acc_) {
						return A2($elm$core$List$member, student, acc_) ? acc_ : A2($elm$core$List$cons, student, acc_);
					}),
				acc,
				group.fv);
		});
	return A3($elm$core$List$foldl, addIfNotExists, _List_Nil, groups);
};
var $author$project$Form$toGroupsOptions = function (groups) {
	return A2(
		$elm$core$List$map,
		function (group) {
			return $author$project$Form$toSelectOption(
				_Utils_Tuple2(
					$elm$core$String$fromInt(
						$author$project$LearningGroup$learningGroupIdToInt(group.i8)),
					group.fb));
		},
		A2(
			$author$project$Util$List$sortBy,
			function ($) {
				return $.fb;
			},
			groups));
};
var $author$project$Element$LearningGroupSelector$updateForm = F2(
	function (msg, formPage) {
		var form = formPage.bE;
		var values = formPage.eI;
		var editedFormPage = _Utils_update(
			formPage,
			{fs: 1});
		if (msg.$ === 3) {
			var formMsg = msg.a;
			var groupIds = formMsg;
			return _Utils_update(
				editedFormPage,
				{
					bE: _Utils_update(
						form,
						{
							cv: $author$project$Form$markEdited(form.cv)
						}),
					eI: A2(form.cv.ks, groupIds, values)
				});
		} else {
			return formPage;
		}
	});
var $author$project$Element$LearningGroupSelector$update = F2(
	function (msg, model) {
		var noop = _Utils_Tuple3(model, $author$project$Element$LearningGroupSelector$NoEffect, $elm$core$Maybe$Nothing);
		var _v0 = _Utils_Tuple2(msg, model.bk);
		_v0$6:
		while (true) {
			switch (_v0.a.$) {
				case 1:
					if (_v0.b.$ === 1) {
						var data = _v0.a.a;
						var formPage = _v0.b.a;
						var form = formPage.bE;
						var store = model.bo;
						var updatedModel = _Utils_update(
							model,
							{
								bo: _Utils_update(
									store,
									{cv: data})
							});
						switch (data.$) {
							case 2:
								var groups = data.a;
								var schoolGroups = A2(
									$elm$core$List$filter,
									function (group) {
										return _Utils_eq(group.kf.i8, model.Q);
									},
									groups);
								var groupsOptions = $author$project$Form$toGroupsOptions(schoolGroups);
								var multiselectGroupsField = A2($author$project$Form$setMultiselectOptions, groupsOptions, form.cv);
								var form2 = _Utils_update(
									form,
									{cv: multiselectGroupsField});
								return _Utils_Tuple3(
									_Utils_update(
										updatedModel,
										{
											bk: $author$project$Element$LearningGroupSelector$FormPage(
												_Utils_update(
													formPage,
													{bE: form2}))
										}),
									$author$project$Element$LearningGroupSelector$NoEffect,
									$elm$core$Maybe$Nothing);
							case 3:
								var error = data.a;
								var updatedSession = A3(
									$author$project$Session$error,
									model.gB,
									error,
									model.gB.h6($author$project$Locale$Messages$LearningGroupDownloadError));
								return _Utils_Tuple3(
									_Utils_update(
										updatedModel,
										{gB: updatedSession}),
									$author$project$Element$LearningGroupSelector$Cmd(
										A3(
											$author$project$Log$errorV2,
											model.b_,
											_Utils_Tuple3(
												$author$project$Log$msgLearningGroupsDownload,
												$elm$core$Maybe$Just($author$project$Log$paramScopeLearningGroups),
												error),
											$elm$core$Basics$always($author$project$Element$LearningGroupSelector$NoOp))),
									$elm$core$Maybe$Nothing);
							case 1:
								return _Utils_Tuple3(updatedModel, $author$project$Element$LearningGroupSelector$NoEffect, $elm$core$Maybe$Nothing);
							default:
								return _Utils_Tuple3(updatedModel, $author$project$Element$LearningGroupSelector$NoEffect, $elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$6;
					}
				case 2:
					var _v2 = _v0.a;
					return _Utils_Tuple3(
						model,
						$author$project$Element$LearningGroupSelector$NoEffect,
						$elm$core$Maybe$Just($author$project$Element$LearningGroupSelector$Exit));
				case 0:
					var _v3 = _v0.a;
					var page = _v0.b;
					var selectedGroupIds = function () {
						if (page.$ === 1) {
							var formPageModel = page.a;
							return A2(
								$elm$core$List$map,
								$elm$core$Maybe$withDefault(0),
								A2(
									$elm$core$List$map,
									$elm$core$String$toInt,
									formPageModel.bE.cv.fC(formPageModel.eI)));
						} else {
							return _List_Nil;
						}
					}();
					var selectedGroups = A2(
						$author$project$RemoteData$map,
						function (groups) {
							return A2(
								$elm$core$List$filter,
								function (group) {
									return A2(
										$elm$core$List$member,
										$author$project$LearningGroup$learningGroupIdToInt(group.i8),
										selectedGroupIds);
								},
								groups);
						},
						model.bo.cv);
					var selectedStudents = $author$project$Element$LearningGroupSelector$makeStudentSet(
						A2($author$project$RemoteData$withDefault, _List_Nil, selectedGroups));
					return _Utils_Tuple3(
						model,
						$author$project$Element$LearningGroupSelector$NoEffect,
						$elm$core$Maybe$Just(
							$author$project$Element$LearningGroupSelector$SelectedStudents(selectedStudents)));
				case 4:
					if (_v0.b.$ === 1) {
						var fieldMsg = _v0.a.a;
						var formPage = _v0.b.a;
						var form = formPage.bE;
						var field = form.cv;
						var _v5 = A2($author$project$Form$updateMultiselectField, fieldMsg, field);
						var updatedField = _v5.a;
						var effect = _v5.b;
						var outMsg = _v5.c;
						var formMsg = $author$project$Element$LearningGroupSelector$FormMsg(
							$author$project$Form$getMultiselectFieldSelectedValues(updatedField));
						var formPage2 = _Utils_update(
							formPage,
							{
								bE: _Utils_update(
									form,
									{cv: updatedField})
							});
						var formPage3 = function () {
							if (!outMsg.$) {
								return A2($author$project$Element$LearningGroupSelector$updateForm, formMsg, formPage2);
							} else {
								return formPage2;
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bk: $author$project$Element$LearningGroupSelector$FormPage(formPage3)
								}),
							A2($author$project$Element$LearningGroupSelector$MultiselectEffect, $author$project$Element$LearningGroupSelector$LearningGroupsFieldMsg, effect),
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$6;
					}
				case 3:
					if (_v0.b.$ === 1) {
						var fieldMsg = _v0.a.a;
						var formPage = _v0.b.a;
						var formPage2 = $author$project$Element$LearningGroupSelector$FormPage(
							A2(
								$author$project$Element$LearningGroupSelector$updateForm,
								$author$project$Element$LearningGroupSelector$FormMsg(fieldMsg),
								formPage));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bk: formPage2}),
							$author$project$Element$LearningGroupSelector$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						return noop;
					}
				default:
					break _v0$6;
			}
		}
		return noop;
	});
var $author$project$Locale$Messages$LearningGroupSelectorInstruction = {$: 165};
var $author$project$Locale$Messages$LearningGroupSelectorTitle = {$: 166};
var $author$project$Element$LearningGroupSelector$viewForm = F2(
	function (t_, _v0) {
		var form = _v0.bE;
		var values = _v0.eI;
		var viewFormFields = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					$author$project$UI$columns(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('is-italic has-text-grey')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t_($author$project$Locale$Messages$LearningGroupSelectorInstruction))
										]))
								]))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A3($author$project$UI$multiselectChoiceField, t_, form.cv, values)
								]))
						]))
				]));
		return $author$project$UI$panel(
			{
				g$: _List_fromArray(
					[viewFormFields]),
				cm: 'modules-form',
				hl: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningGroupSelectorTitle)
							]),
						_List_Nil)
					]),
				h7: _List_Nil,
				ie: 'is-primary has-background-white'
			});
	});
var $author$project$Element$LearningGroupSelector$PopupClosed = {$: 2};
var $author$project$Element$LearningGroupSelector$LearningGroupsSelected = {$: 0};
var $author$project$Element$LearningGroupSelector$viewSelectorNav = function (t_) {
	return A2(
		$elm$html$Html$nav,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('navbar is-fixed-bottom has-background-link-light')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('navbar-end')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-item')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('buttons')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$UI$actionLink,
										$author$project$Element$LearningGroupSelector$LearningGroupsSelected,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button is-link')
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnOk)
											])),
										A3(
										$author$project$UI$actionLink,
										$author$project$Element$LearningGroupSelector$PopupClosed,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button is-light')
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnCancel)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Element$LearningGroupSelector$viewPopup = function (_v0) {
	var session = _v0.gB;
	var page = _v0.bk;
	if (page.$ === 1) {
		var formPageModel = page.a;
		return A3(
			$author$project$UI$modalWindow,
			true,
			$author$project$Element$LearningGroupSelector$PopupClosed,
			$author$project$UI$section(
				_List_fromArray(
					[
						A2($author$project$Element$LearningGroupSelector$viewForm, session.h6, formPageModel),
						$author$project$Element$LearningGroupSelector$viewSelectorNav(session.h6)
					])));
	} else {
		return $author$project$UI$section(_List_Nil);
	}
};
var $author$project$Element$LearningGroupSelector$view = function (model) {
	var _v0 = model.bk;
	if (_v0.$ === 1) {
		var formPage = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Element$LearningGroupSelector$viewForm, model.gB.h6, formPage)
				]));
	} else {
		return $author$project$UI$section(
			_List_fromArray(
				[
					A2(
					$author$project$UI$progressBar,
					'is-info',
					model.gB.h6($author$project$Locale$Messages$LearningGroupListLoadingProgress)),
					$author$project$Element$LearningGroupSelector$viewPopup(model)
				]));
	}
};
var $author$project$Element$LearningGroupSelector$element = {jb: $author$project$Element$LearningGroupSelector$init, hP: $author$project$Element$LearningGroupSelector$perform, ks: $author$project$Element$LearningGroupSelector$update, og: $author$project$Element$LearningGroupSelector$view};
var $author$project$Element$ModuleClosureOverview$ModuleListDownloaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModuleClosureOverview$PageError = {$: 3};
var $author$project$Element$ModuleClosureOverview$PageInit = {$: 0};
var $author$project$Element$ModuleClosureOverview$PageLoading = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleClosureOverview$PortfolioStoryListDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleClosureOverview$StudentListDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Endpoint$modules = F2(
	function (config, params) {
		var queryParams = $author$project$Api$Endpoint$makeModulesQueryParams(params);
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'modules']),
			queryParams);
	});
var $author$project$Module$ModuleListItem = function (id) {
	return function (title) {
		return function (description) {
			return function (goalsKnowledge) {
				return function (goalsSkills) {
					return function (goalsProduct) {
						return function (evaluation) {
							return function (materialsUrl) {
								return function (startDate) {
									return function (endDate) {
										return function (isActive) {
											return function (isLocked) {
												return function (isTemplate) {
													return function (team) {
														return function (accountableTeacher) {
															return function (teachers) {
																return function (students) {
																	return function (rubrics) {
																		return function (migrationReadyAt) {
																			return {kI: accountableTeacher, g8: description, ly: endDate, hc: evaluation, lO: goalsKnowledge, lP: goalsProduct, lQ: goalsSkills, i8: id, l0: isActive, l9: isLocked, mf: isTemplate, jq: materialsUrl, jr: migrationReadyAt, fq: rubrics, nN: startDate, fv: students, fx: teachers, kf: team, kj: title};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Module$moduleListItemDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'migration_ready_at',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'rubrics',
		$elm$json$Json$Decode$list($author$project$Rubric$rubricDecoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'students',
			$author$project$Person$nestedPeopleDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'teachers',
				$author$project$Person$nestedPeopleDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'accountable_teacher',
					$author$project$Person$nestedPersonDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'team',
						$author$project$Team$nestedTeamDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'is_template',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'is_locked',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'is_active',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'end_date',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'start_date',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'materials_url',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'evaluation',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'goals_product',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'goals_skills',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'goals_knowledge',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'description',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'title',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'id',
																			$author$project$Module$moduleIdDecoder,
																			$elm$json$Json$Decode$succeed($author$project$Module$ModuleListItem))))))))))))))))))));
var $author$project$Module$modulesDecoder = $elm$json$Json$Decode$list($author$project$Module$moduleListItemDecoder);
var $author$project$Module$fetchModules = F3(
	function (config, params, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$modules, config, params),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$Module$modulesDecoder));
	});
var $author$project$PortfolioStory$fetchStories = F3(
	function (config, params, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$portfolioStoriesList, config, params),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$PortfolioStory$portfolioStoriesDecoder));
	});
var $author$project$Person$fetchStudents = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$peopleStudents(config),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$Person$phoneBookDecoder));
	});
var $author$project$Element$ModuleClosureOverview$defaultOnlyMentees = false;
var $author$project$Person$teamsAsTom = function (person) {
	var _v0 = person.nr;
	var roles = _v0;
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$second,
		A2(
			$elm$core$List$filter,
			function (_v1) {
				var role = _v1.a;
				return _Utils_eq(role, $author$project$Person$roleTeacher) || (_Utils_eq(role, $author$project$Person$roleModuleTeacher) || _Utils_eq(role, $author$project$Person$roleOperator));
			},
			roles));
};
var $author$project$Element$ModuleClosureOverview$defaultTeamId = A2($elm$core$Basics$composeR, $author$project$Person$teamsAsTom, $elm$core$List$head);
var $author$project$Element$ModuleClosureOverview$initFilter = F2(
	function (viewer, _v0) {
		var school = _v0.Q;
		var onlyMentees = _v0.cH;
		var selectedTeam = A2($elm$core$Maybe$map, $elm$core$Basics$identity, school);
		var selectedOnlyMentees = A2($elm$core$Maybe$withDefault, $author$project$Element$ModuleClosureOverview$defaultOnlyMentees, onlyMentees);
		var makeFilter = function (team) {
			return {cH: selectedOnlyMentees, Q: team};
		};
		var defaultTeam = $author$project$Element$ModuleClosureOverview$defaultTeamId(viewer);
		var _v1 = _Utils_Tuple2(selectedTeam, defaultTeam);
		if (!_v1.a.$) {
			var team = _v1.a.a;
			return $elm$core$Result$Ok(
				makeFilter(team));
		} else {
			if (!_v1.b.$) {
				var _v2 = _v1.a;
				var team = _v1.b.a;
				return $elm$core$Result$Ok(
					makeFilter(team));
			} else {
				var _v3 = _v1.a;
				var _v4 = _v1.b;
				return $elm$core$Result$Err(0);
			}
		}
	});
var $author$project$Element$ModuleClosureOverview$moduleListParams = function () {
	var defaults = $author$project$Module$defaultListParams;
	return _Utils_update(
		defaults,
		{bD: $author$project$Api$Endpoint$categorySchools, iQ: true, ce: -1});
}();
var $author$project$Api$Endpoint$allPortfoliosListParams = {bD: $author$project$Api$Endpoint$categoryAll, g2: $elm$core$Maybe$Nothing, hb: $elm$core$Maybe$Nothing, b0: $elm$core$Maybe$Nothing, hH: $elm$core$Maybe$Nothing, bF: '', ce: -1, h2: $elm$core$Maybe$Nothing, fv: $elm$core$Maybe$Nothing, fx: $elm$core$Maybe$Nothing, ii: $author$project$Api$Endpoint$typeAll};
var $author$project$Element$ModuleClosureOverview$trimesterEnd = 1701644340000;
var $author$project$Element$ModuleClosureOverview$trimesterStart = 1693519200000;
var $author$project$Element$ModuleClosureOverview$portfoliosListParams = function () {
	var defaults = $author$project$Api$Endpoint$allPortfoliosListParams;
	return _Utils_update(
		defaults,
		{
			bD: $author$project$Api$Endpoint$categorySchools,
			hb: $elm$core$Maybe$Just($author$project$Element$ModuleClosureOverview$trimesterEnd),
			h2: $elm$core$Maybe$Just($author$project$Element$ModuleClosureOverview$trimesterStart),
			ii: $author$project$Api$Endpoint$typeMClosure
		});
}();
var $author$project$Element$ModuleClosureOverview$filterToQuery = function (filter) {
	var blankQuery = $author$project$Route$blankModuleClosureOverviewListQuery;
	return _Utils_update(
		blankQuery,
		{
			cH: $elm$core$Maybe$Just(filter.cH),
			Q: $elm$core$Maybe$Just(
				$author$project$Team$teamIdToInt(filter.Q))
		});
};
var $author$project$Element$ModuleClosureOverview$updateFilterUrl = F2(
	function (config, filter) {
		return A2(
			$author$project$Route$replaceUrl,
			config.jk,
			$author$project$Route$ModuleClosureOverview(
				$author$project$Element$ModuleClosureOverview$filterToQuery(filter)));
	});
var $author$project$Element$ModuleClosureOverview$init = F3(
	function (config, session, params) {
		var viewer = session.ok;
		var model = {b_: config, bM: $author$project$RemoteData$NotAsked, hH: $author$project$RemoteData$NotAsked, bk: $author$project$Element$ModuleClosureOverview$PageInit, fv: $author$project$RemoteData$NotAsked};
		var filter = A2($author$project$Element$ModuleClosureOverview$initFilter, viewer, params);
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Person$fetchStudents, config.gX, $author$project$Element$ModuleClosureOverview$StudentListDownloaded),
					A3($author$project$Module$fetchModules, config.gX, $author$project$Element$ModuleClosureOverview$moduleListParams, $author$project$Element$ModuleClosureOverview$ModuleListDownloaded),
					A3($author$project$PortfolioStory$fetchStories, config.gX, $author$project$Element$ModuleClosureOverview$portfoliosListParams, $author$project$Element$ModuleClosureOverview$PortfolioStoryListDownloaded),
					A2(
					$elm$core$Result$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Result$map,
						$author$project$Element$ModuleClosureOverview$updateFilterUrl(config),
						filter))
				]));
		if (filter.$ === 1) {
			return A2(
				$author$project$Application$Boundaries$save,
				_Utils_update(
					model,
					{bk: $author$project$Element$ModuleClosureOverview$PageError}),
				session);
		} else {
			var filter_ = filter.a;
			return A2(
				$author$project$Application$Boundaries$andThenCmd,
				cmd,
				A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{
							bk: $author$project$Element$ModuleClosureOverview$PageLoading(filter_)
						}),
					session));
		}
	});
var $author$project$Element$ModuleClosureOverview$NoOp = {$: 0};
var $author$project$Element$ModuleClosureOverview$PageLoaded = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Element$ModuleClosureOverview$filterModulesByPeriod = F2(
	function (_v0, modules) {
		var start = _v0.a;
		var end = _v0.b;
		var isModuleOutOfPeriod = function (module_) {
			return (_Utils_cmp(module_.ly, start) < 0) || (_Utils_cmp(module_.nN, end) > 0);
		};
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isModuleOutOfPeriod),
			modules);
	});
var $author$project$Module$hasTeacher = F2(
	function (person, module_) {
		return A2($author$project$Person$isSamePerson, module_.kI, person) || A2(
			$elm$core$List$any,
			$author$project$Person$isSamePerson(person),
			module_.fx);
	});
var $NoRedInk$elm_sortable_table$Table$State = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $NoRedInk$elm_sortable_table$Table$initialSort = function (header) {
	return A2($NoRedInk$elm_sortable_table$Table$State, header, false);
};
var $author$project$Element$ModuleClosureOverview$TableDataItem = F3(
	function (student, module_, mclosures) {
		return {bM: mclosures, hG: module_, nT: student};
	});
var $author$project$Element$ModuleClosureOverview$filterModulesByStudent = F2(
	function (student, modules) {
		return A2(
			$elm$core$List$filter,
			function (m) {
				return A2(
					$elm$core$List$any,
					function (s) {
						return A2($author$project$Person$isSamePerson, s, student);
					},
					m.fv);
			},
			modules);
	});
var $author$project$Module$isSameModule = F2(
	function (module1, module2) {
		return _Utils_eq(module1.i8, module2.i8);
	});
var $author$project$Element$ModuleClosureOverview$filterStoriesByModule = F2(
	function (module_, stories) {
		var isSameModule = function (maybeModule) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$author$project$Module$isSameModule(module_),
					maybeModule));
		};
		return A2(
			$elm$core$List$filter,
			function (story) {
				return isSameModule(story.hG);
			},
			stories);
	});
var $author$project$Element$ModuleClosureOverview$filterStoriesByStudent = F2(
	function (student, stories) {
		return A2(
			$elm$core$List$filter,
			function (story) {
				return A2(
					$elm$core$List$any,
					function (s) {
						return A2($author$project$Person$isSamePerson, s, student);
					},
					story.fv);
			},
			stories);
	});
var $author$project$Element$ModuleClosureOverview$makeTableData = F3(
	function (students, modules, mclosures) {
		var getModuleClosuresByStudent = function (student) {
			var studentModules = A2($author$project$Element$ModuleClosureOverview$filterModulesByStudent, student, modules);
			var studentModuleClosures = function (module_) {
				return A2(
					$author$project$Element$ModuleClosureOverview$filterStoriesByModule,
					module_,
					A2($author$project$Element$ModuleClosureOverview$filterStoriesByStudent, student, mclosures));
			};
			return A2(
				$elm$core$List$map,
				function (module_) {
					return A3(
						$author$project$Element$ModuleClosureOverview$TableDataItem,
						student,
						module_,
						studentModuleClosures(module_));
				},
				studentModules);
		};
		return A2($elm$core$List$concatMap, getModuleClosuresByStudent, students);
	});
var $author$project$Element$ModuleClosureOverview$initPageLoaded = F3(
	function (_v0, _v1, filter) {
		var viewer = _v0.ok;
		var t_ = _v0.h6;
		var students = _v1.fv;
		var modules = _v1.hH;
		var mclosures = _v1.bM;
		var tableState = $NoRedInk$elm_sortable_table$Table$initialSort('');
		var sortedStudents = A2(
			$author$project$Util$List$sortBy,
			$author$project$Person$fullName(t_),
			students);
		var activeModules = A2(
			$author$project$Element$ModuleClosureOverview$filterModulesByPeriod,
			_Utils_Tuple2($author$project$Element$ModuleClosureOverview$trimesterStart, $author$project$Element$ModuleClosureOverview$trimesterEnd),
			modules);
		var filteredModules = $author$project$Person$isModuleTeacher(viewer) ? A2(
			$elm$core$List$filter,
			$author$project$Module$hasTeacher(viewer),
			activeModules) : activeModules;
		var tableData = A3($author$project$Element$ModuleClosureOverview$makeTableData, sortedStudents, filteredModules, mclosures);
		return A3($author$project$Element$ModuleClosureOverview$PageLoaded, filter, tableState, tableData);
	});
var $author$project$Element$ModuleClosureOverview$mapPageLoading = F2(
	function (updater, model) {
		var _v0 = model.bk;
		switch (_v0.$) {
			case 0:
				return model;
			case 1:
				var filter = _v0.a;
				return _Utils_update(
					model,
					{
						bk: updater(filter)
					});
			case 2:
				return model;
			default:
				return model;
		}
	});
var $author$project$Element$ModuleClosureOverview$andThenSetTableData = function (_return) {
	var session = _return.gB;
	var model = _return.eh;
	var _v0 = _Utils_Tuple3(model.fv, model.hH, model.bM);
	if (((_v0.a.$ === 2) && (_v0.b.$ === 2)) && (_v0.c.$ === 2)) {
		var students = _v0.a.a;
		var modules = _v0.b.a;
		var mclosures = _v0.c.a;
		var data = {bM: mclosures, hH: modules, fv: students};
		var pageLoaded = A2($author$project$Element$ModuleClosureOverview$initPageLoaded, session, data);
		return A2(
			$author$project$Application$Boundaries$save,
			A2($author$project$Element$ModuleClosureOverview$mapPageLoading, pageLoaded, model),
			session);
	} else {
		return _return;
	}
};
var $author$project$Log$paramScopeModuleClosureOverview = 'scope_module_closure_overview';
var $author$project$Element$ModuleClosureOverview$mapPageLoaded = F2(
	function (updater, model) {
		var _v0 = model.bk;
		switch (_v0.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				var filter = _v0.a;
				var tableState = _v0.b;
				var tableData = _v0.c;
				var _v1 = A3(updater, filter, tableState, tableData);
				var page = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bk: page}),
					cmd);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Element$ModuleClosureOverview$updateFilter = F3(
	function (updater, session, model) {
		var _v0 = A2(
			$author$project$Element$ModuleClosureOverview$mapPageLoaded,
			F3(
				function (filter, tableState, tableData) {
					var updatedFilter = updater(filter);
					return _Utils_Tuple2(
						A3($author$project$Element$ModuleClosureOverview$PageLoaded, updatedFilter, tableState, tableData),
						A2($author$project$Element$ModuleClosureOverview$updateFilterUrl, model.b_, updatedFilter));
				}),
			model);
		var model2 = _v0.a;
		var cmd = _v0.b;
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A2($author$project$Application$Boundaries$save, model2, session));
	});
var $author$project$Element$ModuleClosureOverview$updateTableState = F3(
	function (newTableState, session, model) {
		var _v0 = A2(
			$author$project$Element$ModuleClosureOverview$mapPageLoaded,
			F3(
				function (filter, _v1, tableData) {
					return _Utils_Tuple2(
						A3($author$project$Element$ModuleClosureOverview$PageLoaded, filter, newTableState, tableData),
						$elm$core$Platform$Cmd$none);
				}),
			model);
		var model2 = _v0.a;
		return A2($author$project$Application$Boundaries$save, model2, session);
	});
var $author$project$Element$ModuleClosureOverview$update = F3(
	function (session, msg, model) {
		var t_ = session.h6;
		var config = model.b_;
		var noop = A2($author$project$Application$Boundaries$save, model, session);
		switch (msg.$) {
			case 0:
				return noop;
			case 4:
				var newTableState = msg.a;
				return A3($author$project$Element$ModuleClosureOverview$updateTableState, newTableState, session, model);
			case 5:
				var maybeTeamId = msg.a;
				if (!maybeTeamId.$) {
					var teamId = maybeTeamId.a;
					return A3(
						$author$project$Element$ModuleClosureOverview$updateFilter,
						function (filter) {
							return _Utils_update(
								filter,
								{Q: teamId});
						},
						session,
						model);
				} else {
					return noop;
				}
			case 6:
				var onlyMentees = msg.a;
				return A3(
					$author$project$Element$ModuleClosureOverview$updateFilter,
					function (filter) {
						return _Utils_update(
							filter,
							{cH: onlyMentees});
					},
					session,
					model);
			case 1:
				var students = msg.a;
				var model2 = _Utils_update(
					model,
					{fv: students});
				switch (students.$) {
					case 3:
						var error = students.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgStudentsDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeModuleClosureOverview),
									error),
								$elm$core$Basics$always($author$project$Element$ModuleClosureOverview$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model2,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$StudentListDownloadError))));
					case 2:
						return $author$project$Element$ModuleClosureOverview$andThenSetTableData(
							A2($author$project$Application$Boundaries$save, model2, session));
					case 0:
						return A2($author$project$Application$Boundaries$save, model2, session);
					default:
						return A2($author$project$Application$Boundaries$save, model2, session);
				}
			case 2:
				var modules = msg.a;
				var model2 = _Utils_update(
					model,
					{hH: modules});
				switch (modules.$) {
					case 3:
						var error = modules.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgModulesDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeModuleClosureOverview),
									error),
								$elm$core$Basics$always($author$project$Element$ModuleClosureOverview$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model2,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$ModulesDownloadError))));
					case 2:
						return $author$project$Element$ModuleClosureOverview$andThenSetTableData(
							A2($author$project$Application$Boundaries$save, model2, session));
					case 0:
						return A2($author$project$Application$Boundaries$save, model2, session);
					default:
						return A2($author$project$Application$Boundaries$save, model2, session);
				}
			default:
				var mclosures = msg.a;
				var model2 = _Utils_update(
					model,
					{bM: mclosures});
				switch (mclosures.$) {
					case 3:
						var error = mclosures.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgPortfoliosDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeModuleClosureOverview),
									error),
								$elm$core$Basics$always($author$project$Element$ModuleClosureOverview$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model2,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$PortfoliosDownloadError))));
					case 2:
						return $author$project$Element$ModuleClosureOverview$andThenSetTableData(
							A2($author$project$Application$Boundaries$save, model2, session));
					case 0:
						return A2($author$project$Application$Boundaries$save, model2, session);
					default:
						return A2($author$project$Application$Boundaries$save, model2, session);
				}
		}
	});
var $author$project$Module$hasTeam = F2(
	function (teamId, module_) {
		return A2($author$project$Team$isSameTeam, teamId, module_.kf);
	});
var $author$project$Element$ModuleClosureOverview$filterTableData = F3(
	function (viewer, filter, tableData) {
		var matches = function (item) {
			return A2($author$project$Module$hasTeam, filter.Q, item.hG) && (filter.cH ? A2($author$project$Person$isMentorOf, item.nT, viewer) : true);
		};
		return A2($elm$core$List$filter, matches, tableData);
	});
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $elm$html$Html$Lazy$lazy3 = $elm$virtual_dom$VirtualDom$lazy3;
var $author$project$Locale$Messages$ModuleClosureOverviewSchool = {$: 197};
var $author$project$Element$ModuleClosureOverview$SetSchoolFilter = function (a) {
	return {$: 5, a: a};
};
var $author$project$Team$fromTeamToValue = function (teamId) {
	return $elm$core$String$fromInt(
		$author$project$Team$teamIdToInt(teamId));
};
var $author$project$Team$fromValueToTeam = function (value) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Basics$identity,
		$elm$core$String$toInt(value));
};
var $author$project$Element$ModuleClosureOverview$viewTeamFilter = F3(
	function (t_, schools, _v0) {
		var school = _v0.Q;
		var viewSchoolOptions = function (schools_) {
			return A2(
				$elm$core$List$map,
				A3(
					$author$project$UI$radioButton,
					A2($elm$core$Basics$composeL, $author$project$Element$ModuleClosureOverview$SetSchoolFilter, $author$project$Team$fromValueToTeam),
					'filter-school',
					$author$project$Team$fromTeamToValue(school)),
				$author$project$Form$toTeamOptions(schools_));
		};
		return $author$project$UI$filterOptions(
			{
				g1: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModuleClosureOverviewSchool),
				lT: false,
				m_: $elm$core$Maybe$Just(schools),
				oj: viewSchoolOptions
			});
	});
var $author$project$Locale$Messages$ModuleClosureOverviewOnlyMentees = {$: 198};
var $author$project$Locale$Messages$ModuleClosureOverviewType = {$: 199};
var $author$project$Element$ModuleClosureOverview$SetMenteesFilter = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$ModuleClosureOverview$formValueMentees = 'mentees';
var $author$project$Element$ModuleClosureOverview$fromMenteesToValues = function (bool) {
	return bool ? _List_fromArray(
		[$author$project$Element$ModuleClosureOverview$formValueMentees]) : _List_Nil;
};
var $author$project$Element$ModuleClosureOverview$fromValueToMentees = function (values) {
	return A2($elm$core$List$member, $author$project$Element$ModuleClosureOverview$formValueMentees, values);
};
var $author$project$Element$ModuleClosureOverview$viewTypeFilter = F2(
	function (t_, filter) {
		var viewOption = function (option) {
			return A5(
				$author$project$UI$checkbox,
				A2($elm$core$Basics$composeL, $author$project$Element$ModuleClosureOverview$SetMenteesFilter, $author$project$Element$ModuleClosureOverview$fromValueToMentees),
				'filter-only-mentees',
				$elm$core$Basics$always(false),
				$author$project$Element$ModuleClosureOverview$fromMenteesToValues(filter.cH),
				option);
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$fieldset,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$legend,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModuleClosureOverviewType)
								])),
							viewOption(
							{
								ea: t_($author$project$Locale$Messages$ModuleClosureOverviewOnlyMentees),
								fC: $author$project$Element$ModuleClosureOverview$formValueMentees
							})
						]))
				]));
	});
var $author$project$Element$ModuleClosureOverview$viewFilters = F3(
	function (t_, filter, modules) {
		var schools = $author$project$Util$List$unique(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.kf;
				},
				modules));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container columns')
				]),
			_List_fromArray(
				[
					A3($author$project$Element$ModuleClosureOverview$viewTeamFilter, t_, schools, filter),
					A2($author$project$Element$ModuleClosureOverview$viewTypeFilter, t_, filter)
				]));
	});
var $author$project$Locale$Messages$ModuleClosureOverviewHeading = {$: 191};
var $author$project$Element$ModuleClosureOverview$viewPageHeading = function (t_) {
	return $author$project$UI$title(
		_List_fromArray(
			[
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModuleClosureOverviewHeading)
			]));
};
var $author$project$Locale$Messages$ModuleClosureOverviewLoadingProgress = {$: 192};
var $author$project$Element$ModuleClosureOverview$viewProgressBar = function (t_) {
	return A2(
		$author$project$UI$progressBar,
		'is-info',
		t_($author$project$Locale$Messages$ModuleClosureOverviewLoadingProgress));
};
var $author$project$Locale$Messages$ModuleClosureOverviewModule = {$: 195};
var $author$project$Locale$Messages$ModuleClosureOverviewModuleClosure = {$: 196};
var $author$project$Locale$Messages$ModuleClosureOverviewStudent = {$: 194};
var $author$project$Element$ModuleClosureOverview$SetTableState = function (a) {
	return {$: 4, a: a};
};
var $NoRedInk$elm_sortable_table$Table$Config = $elm$core$Basics$identity;
var $NoRedInk$elm_sortable_table$Table$customConfig = function (_v0) {
	var toId = _v0.n6;
	var toMsg = _v0.cf;
	var columns = _v0.la;
	var customizations = _v0.li;
	return {
		la: A2(
			$elm$core$List$map,
			function (_v1) {
				var cData = _v1;
				return cData;
			},
			columns),
		li: customizations,
		n6: toId,
		cf: toMsg
	};
};
var $NoRedInk$elm_sortable_table$Table$simpleRowAttrs = function (_v0) {
	return _List_Nil;
};
var $NoRedInk$elm_sortable_table$Table$HtmlDetails = F2(
	function (attributes, children) {
		return {eR: attributes, eW: children};
	});
var $NoRedInk$elm_sortable_table$Table$darkGrey = function (symbol) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'color', '#555')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(' ' + symbol)
			]));
};
var $NoRedInk$elm_sortable_table$Table$lightGrey = function (symbol) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'color', '#ccc')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(' ' + symbol)
			]));
};
var $NoRedInk$elm_sortable_table$Table$simpleTheadHelp = function (_v0) {
	var name = _v0.a;
	var status = _v0.b;
	var onClick_ = _v0.c;
	var content = function () {
		switch (status.$) {
			case 0:
				return _List_fromArray(
					[
						$elm$html$Html$text(name)
					]);
			case 1:
				var selected = status.a;
				return _List_fromArray(
					[
						$elm$html$Html$text(name),
						selected ? $NoRedInk$elm_sortable_table$Table$darkGrey('↓') : $NoRedInk$elm_sortable_table$Table$lightGrey('↓')
					]);
			default:
				if (status.a.$ === 1) {
					var _v2 = status.a;
					return _List_fromArray(
						[
							$elm$html$Html$text(name),
							$NoRedInk$elm_sortable_table$Table$lightGrey('↕')
						]);
				} else {
					var isReversed = status.a.a;
					return _List_fromArray(
						[
							$elm$html$Html$text(name),
							$NoRedInk$elm_sortable_table$Table$darkGrey(
							isReversed ? '↑' : '↓')
						]);
				}
		}
	}();
	return A2(
		$elm$html$Html$th,
		_List_fromArray(
			[onClick_]),
		content);
};
var $NoRedInk$elm_sortable_table$Table$simpleThead = function (headers) {
	return A2(
		$NoRedInk$elm_sortable_table$Table$HtmlDetails,
		_List_Nil,
		A2($elm$core$List$map, $NoRedInk$elm_sortable_table$Table$simpleTheadHelp, headers));
};
var $NoRedInk$elm_sortable_table$Table$defaultCustomizations = {g1: $elm$core$Maybe$Nothing, hS: $NoRedInk$elm_sortable_table$Table$simpleRowAttrs, n_: _List_Nil, h8: _List_Nil, ic: $elm$core$Maybe$Nothing, id: $NoRedInk$elm_sortable_table$Table$simpleThead};
var $NoRedInk$elm_sortable_table$Table$IncOrDec = function (a) {
	return {$: 3, a: a};
};
var $NoRedInk$elm_sortable_table$Table$increasingOrDecreasingBy = function (toComparable) {
	return $NoRedInk$elm_sortable_table$Table$IncOrDec(
		$elm$core$List$sortBy(toComparable));
};
var $NoRedInk$elm_sortable_table$Table$Column = $elm$core$Basics$identity;
var $NoRedInk$elm_sortable_table$Table$veryCustomColumn = $elm$core$Basics$identity;
var $author$project$UI$Table$htmlColumn = F3(
	function (name, toComparable, toHtml) {
		return $NoRedInk$elm_sortable_table$Table$veryCustomColumn(
			{
				fb: name,
				nJ: $NoRedInk$elm_sortable_table$Table$increasingOrDecreasingBy(toComparable),
				oh: function (content) {
					return A2(
						$NoRedInk$elm_sortable_table$Table$HtmlDetails,
						_List_Nil,
						_List_fromArray(
							[
								toHtml(content)
							]));
				}
			});
	});
var $NoRedInk$elm_sortable_table$Table$textDetails = function (str) {
	return A2(
		$NoRedInk$elm_sortable_table$Table$HtmlDetails,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $NoRedInk$elm_sortable_table$Table$stringColumn = F2(
	function (name, toStr) {
		return {
			fb: name,
			nJ: $NoRedInk$elm_sortable_table$Table$increasingOrDecreasingBy(toStr),
			oh: A2($elm$core$Basics$composeL, $NoRedInk$elm_sortable_table$Table$textDetails, toStr)
		};
	});
var $author$project$UI$Icon$badge = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-medal'),
			attributes));
};
var $author$project$Element$ModuleClosureOverview$viewModuleClosuresItem = function (mclosures) {
	var viewModuleClosureLink = function (story) {
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href(
							$author$project$Route$PortfoliosDetail(story.i8))
						]),
					_List_fromArray(
						[
							$author$project$UI$Icon$badge(
							_List_fromArray(
								[
									$author$project$UI$Icon$style('has-text-success')
								]))
						]))
				]));
	};
	return A2(
		$elm$html$Html$ul,
		_List_Nil,
		A2($elm$core$List$map, viewModuleClosureLink, mclosures));
};
var $author$project$Locale$Messages$ModulesMissingStudents = {$: 275};
var $author$project$Locale$Messages$ModulesTerm = F3(
	function (a, b, c) {
		return {$: 280, a: a, b: b, c: c};
	});
var $author$project$Element$ModulesMain$viewModuleHighlights = F2(
	function (t_, module_) {
		return $author$project$UI$mediaObjectHighlights(
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Person$fullName, t_, module_.kI)),
					$elm$html$Html$text(module_.kf.lp),
					A2(
					$author$project$UI$caption,
					t_,
					A3(
						$author$project$Locale$Messages$ModulesTerm,
						$elm$time$Time$utc,
						$elm$time$Time$millisToPosix(module_.nN),
						$elm$time$Time$millisToPosix(module_.ly))),
					A2(
					$author$project$UI$when,
					$elm$core$List$isEmpty(module_.fv),
					A2(
						$elm$html$Html$mark,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesMissingStudents)
							])))
				]));
	});
var $author$project$Locale$Messages$ModulesClosed = {$: 230};
var $author$project$Locale$Messages$ModulesClosedEdit = {$: 231};
var $author$project$ACL$canManageModule = F2(
	function (module_, person) {
		return ($author$project$ACL$isStaff(person) && A2(
			$elm$core$List$member,
			module_.kf.i8,
			$author$project$Person$teams(person))) || (($author$project$Person$isModuleTeacher(person) && A2($author$project$Module$hasTeacher, person, module_)) || A2($author$project$Person$isSamePerson, person, module_.kI));
	});
var $author$project$Element$ModulesMain$viewModuleTitle = F3(
	function (_v0, isListItem, module_) {
		var t_ = _v0.h6;
		var viewer = _v0.ok;
		var viewLockFlag = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(
					A2($author$project$ACL$canManageModule, module_, viewer) ? t_($author$project$Locale$Messages$ModulesClosedEdit) : t_($author$project$Locale$Messages$ModulesClosed))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$locked(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('is-small')
						]))
				]));
		var viewActiveFlag = $author$project$UI$Icon$icon(
			_List_fromArray(
				[
					$author$project$UI$Icon$face('fa-volume-up'),
					$author$project$UI$Icon$style('is-small')
				]));
		return A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('title is-size-6 mb-2')
				]),
			_List_fromArray(
				[
					A2($author$project$UI$when, module_.l9, viewLockFlag),
					A2($author$project$UI$when, module_.l0, viewActiveFlag),
					$elm$html$Html$text(' '),
					isListItem ? A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href(
							$author$project$Route$ModulesDetail(
								$author$project$Module$moduleIdToInt(module_.i8))),
							$author$project$UI$attrCyData('modules-item-view modules-item-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(module_.kj)
						])) : A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$UI$attrCyData('modules-item-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(module_.kj)
						]))
				]));
	});
var $author$project$Element$ModuleClosureOverview$viewModuleItem = F2(
	function (session, module_) {
		var t_ = session.h6;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$Element$ModulesMain$viewModuleTitle, session, true, module_),
					A2($author$project$Element$ModulesMain$viewModuleHighlights, t_, module_)
				]));
	});
var $author$project$Element$ModuleClosureOverview$tableViewConfig = function (session) {
	var t_ = session.h6;
	var toId = function (item) {
		return $elm$core$String$fromInt(item.nT.i8) + ('-' + $elm$core$String$fromInt(
			$author$project$Module$moduleIdToInt(item.hG.i8)));
	};
	var moduleItemSorter = A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.hG;
		},
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.i8;
			},
			$author$project$Module$moduleIdToInt));
	var mclosureItemSorter = A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.bM;
		},
		$elm$core$List$length);
	var customizations = $NoRedInk$elm_sortable_table$Table$defaultCustomizations;
	return $NoRedInk$elm_sortable_table$Table$customConfig(
		{
			la: _List_fromArray(
				[
					A2(
					$NoRedInk$elm_sortable_table$Table$stringColumn,
					t_($author$project$Locale$Messages$ModuleClosureOverviewStudent),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.nT;
						},
						$author$project$Person$fullName(t_))),
					A3(
					$author$project$UI$Table$htmlColumn,
					t_($author$project$Locale$Messages$ModuleClosureOverviewModule),
					moduleItemSorter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.hG;
						},
						$author$project$Element$ModuleClosureOverview$viewModuleItem(session))),
					A3(
					$author$project$UI$Table$htmlColumn,
					t_($author$project$Locale$Messages$ModuleClosureOverviewModuleClosure),
					mclosureItemSorter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.bM;
						},
						$author$project$Element$ModuleClosureOverview$viewModuleClosuresItem))
				]),
			li: _Utils_update(
				customizations,
				{
					n_: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('table is-fullwidth is-bordered is-striped is-narrow')
						])
				}),
			n6: toId,
			cf: $author$project$Element$ModuleClosureOverview$SetTableState
		});
};
var $elm$html$Html$caption = _VirtualDom_node('caption');
var $NoRedInk$elm_sortable_table$Table$applySorter = F3(
	function (isReversed, sorter, data) {
		switch (sorter.$) {
			case 0:
				return data;
			case 1:
				var sort_ = sorter.a;
				return sort_(data);
			case 2:
				var sort_ = sorter.a;
				return $elm$core$List$reverse(
					sort_(data));
			case 3:
				var sort_ = sorter.a;
				return isReversed ? $elm$core$List$reverse(
					sort_(data)) : sort_(data);
			default:
				var sort_ = sorter.a;
				return isReversed ? sort_(data) : $elm$core$List$reverse(
					sort_(data));
		}
	});
var $NoRedInk$elm_sortable_table$Table$findSorter = F2(
	function (selectedColumn, columnData) {
		findSorter:
		while (true) {
			if (!columnData.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var name = columnData.a.fb;
				var sorter = columnData.a.nJ;
				var remainingColumnData = columnData.b;
				if (_Utils_eq(name, selectedColumn)) {
					return $elm$core$Maybe$Just(sorter);
				} else {
					var $temp$selectedColumn = selectedColumn,
						$temp$columnData = remainingColumnData;
					selectedColumn = $temp$selectedColumn;
					columnData = $temp$columnData;
					continue findSorter;
				}
			}
		}
	});
var $NoRedInk$elm_sortable_table$Table$sort = F3(
	function (_v0, columnData, data) {
		var selectedColumn = _v0.a;
		var isReversed = _v0.b;
		var _v1 = A2($NoRedInk$elm_sortable_table$Table$findSorter, selectedColumn, columnData);
		if (_v1.$ === 1) {
			return data;
		} else {
			var sorter = _v1.a;
			return A3($NoRedInk$elm_sortable_table$Table$applySorter, isReversed, sorter, data);
		}
	});
var $elm$html$Html$tfoot = _VirtualDom_node('tfoot');
var $NoRedInk$elm_sortable_table$Table$Reversible = function (a) {
	return {$: 2, a: a};
};
var $NoRedInk$elm_sortable_table$Table$Sortable = function (a) {
	return {$: 1, a: a};
};
var $NoRedInk$elm_sortable_table$Table$Unsortable = {$: 0};
var $NoRedInk$elm_sortable_table$Table$onClick = F3(
	function (name, isReversed, toMsg) {
		return A2(
			$elm$html$Html$Events$on,
			'click',
			A2(
				$elm$json$Json$Decode$map,
				toMsg,
				A3(
					$elm$json$Json$Decode$map2,
					$NoRedInk$elm_sortable_table$Table$State,
					$elm$json$Json$Decode$succeed(name),
					$elm$json$Json$Decode$succeed(isReversed))));
	});
var $NoRedInk$elm_sortable_table$Table$toHeaderInfo = F3(
	function (_v0, toMsg, _v1) {
		var sortName = _v0.a;
		var isReversed = _v0.b;
		var name = _v1.fb;
		var sorter = _v1.nJ;
		switch (sorter.$) {
			case 0:
				return _Utils_Tuple3(
					name,
					$NoRedInk$elm_sortable_table$Table$Unsortable,
					A3($NoRedInk$elm_sortable_table$Table$onClick, sortName, isReversed, toMsg));
			case 1:
				return _Utils_Tuple3(
					name,
					$NoRedInk$elm_sortable_table$Table$Sortable(
						_Utils_eq(name, sortName)),
					A3($NoRedInk$elm_sortable_table$Table$onClick, name, false, toMsg));
			case 2:
				return _Utils_Tuple3(
					name,
					$NoRedInk$elm_sortable_table$Table$Sortable(
						_Utils_eq(name, sortName)),
					A3($NoRedInk$elm_sortable_table$Table$onClick, name, false, toMsg));
			case 3:
				return _Utils_eq(name, sortName) ? _Utils_Tuple3(
					name,
					$NoRedInk$elm_sortable_table$Table$Reversible(
						$elm$core$Maybe$Just(isReversed)),
					A3($NoRedInk$elm_sortable_table$Table$onClick, name, !isReversed, toMsg)) : _Utils_Tuple3(
					name,
					$NoRedInk$elm_sortable_table$Table$Reversible($elm$core$Maybe$Nothing),
					A3($NoRedInk$elm_sortable_table$Table$onClick, name, false, toMsg));
			default:
				return _Utils_eq(name, sortName) ? _Utils_Tuple3(
					name,
					$NoRedInk$elm_sortable_table$Table$Reversible(
						$elm$core$Maybe$Just(isReversed)),
					A3($NoRedInk$elm_sortable_table$Table$onClick, name, !isReversed, toMsg)) : _Utils_Tuple3(
					name,
					$NoRedInk$elm_sortable_table$Table$Reversible($elm$core$Maybe$Nothing),
					A3($NoRedInk$elm_sortable_table$Table$onClick, name, false, toMsg));
		}
	});
var $NoRedInk$elm_sortable_table$Table$viewCell = F2(
	function (data, _v0) {
		var viewData = _v0.oh;
		var details = viewData(data);
		return A2($elm$html$Html$td, details.eR, details.eW);
	});
var $NoRedInk$elm_sortable_table$Table$viewRowHelp = F3(
	function (columns, toRowAttrs, data) {
		return A2(
			$elm$html$Html$tr,
			toRowAttrs(data),
			A2(
				$elm$core$List$map,
				$NoRedInk$elm_sortable_table$Table$viewCell(data),
				columns));
	});
var $NoRedInk$elm_sortable_table$Table$viewRow = F4(
	function (toId, columns, toRowAttrs, data) {
		return _Utils_Tuple2(
			toId(data),
			A4($elm$html$Html$Lazy$lazy3, $NoRedInk$elm_sortable_table$Table$viewRowHelp, columns, toRowAttrs, data));
	});
var $NoRedInk$elm_sortable_table$Table$view = F3(
	function (_v0, state, data) {
		var toId = _v0.n6;
		var toMsg = _v0.cf;
		var columns = _v0.la;
		var customizations = _v0.li;
		var theadDetails = customizations.id(
			A2(
				$elm$core$List$map,
				A2($NoRedInk$elm_sortable_table$Table$toHeaderInfo, state, toMsg),
				columns));
		var thead = A2($elm$html$Html$thead, theadDetails.eR, theadDetails.eW);
		var sortedData = A3($NoRedInk$elm_sortable_table$Table$sort, state, columns, data);
		var tbody = A3(
			$elm$html$Html$Keyed$node,
			'tbody',
			customizations.h8,
			A2(
				$elm$core$List$map,
				A3($NoRedInk$elm_sortable_table$Table$viewRow, toId, columns, customizations.hS),
				sortedData));
		var withFoot = function () {
			var _v2 = customizations.ic;
			if (_v2.$ === 1) {
				return A2($elm$core$List$cons, tbody, _List_Nil);
			} else {
				var attributes = _v2.a.eR;
				var children = _v2.a.eW;
				return A2(
					$elm$core$List$cons,
					A2($elm$html$Html$tfoot, attributes, children),
					A2($elm$core$List$cons, tbody, _List_Nil));
			}
		}();
		return A2(
			$elm$html$Html$table,
			customizations.n_,
			function () {
				var _v1 = customizations.g1;
				if (_v1.$ === 1) {
					return A2($elm$core$List$cons, thead, withFoot);
				} else {
					var attributes = _v1.a.eR;
					var children = _v1.a.eW;
					return A2(
						$elm$core$List$cons,
						A2($elm$html$Html$caption, attributes, children),
						A2($elm$core$List$cons, thead, withFoot));
				}
			}());
	});
var $author$project$Element$ModuleClosureOverview$viewTable = F3(
	function (session, tableState, tableData) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('box')
				]),
			_List_fromArray(
				[
					A3(
					$NoRedInk$elm_sortable_table$Table$view,
					$author$project$Element$ModuleClosureOverview$tableViewConfig(session),
					tableState,
					tableData)
				]));
	});
var $author$project$Element$ModuleClosureOverview$view = F2(
	function (session, _v0) {
		var t_ = session.h6;
		var viewer = session.ok;
		var page = _v0.bk;
		var modules = _v0.hH;
		switch (page.$) {
			case 0:
				return $author$project$Element$ModuleClosureOverview$viewProgressBar(t_);
			case 1:
				return $author$project$Element$ModuleClosureOverview$viewProgressBar(t_);
			case 3:
				return $author$project$Element$ModuleClosureOverview$viewProgressBar(t_);
			default:
				var filter = page.a;
				var tableState = page.b;
				var tableData = page.c;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Element$ModuleClosureOverview$viewPageHeading(t_),
							A3(
							$author$project$Element$ModuleClosureOverview$viewFilters,
							t_,
							filter,
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$RemoteData$toMaybe(modules))),
							A4(
							$elm$html$Html$Lazy$lazy3,
							$author$project$Element$ModuleClosureOverview$viewTable,
							session,
							tableState,
							A3($author$project$Element$ModuleClosureOverview$filterTableData, viewer, filter, tableData))
						]));
		}
	});
var $author$project$Element$ModuleClosureOverview$element = {jb: $author$project$Element$ModuleClosureOverview$init, ks: $author$project$Element$ModuleClosureOverview$update, og: $author$project$Element$ModuleClosureOverview$view};
var $author$project$Element$ModuleSingle$Closed = {$: 1};
var $author$project$Element$ModuleSingle$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModuleSingle$FetchModule = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModuleSingle$LoadingPage = {$: 0};
var $author$project$Element$ModuleSingle$ModuleDetailDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleSingle$init = F3(
	function (config, session, params) {
		var _v0 = function () {
			if (!params.$) {
				var moduleId_ = params.a;
				return _Utils_Tuple2(moduleId_, false);
			} else {
				var moduleId_ = params.a;
				return _Utils_Tuple2(moduleId_, true);
			}
		}();
		var moduleId = _v0.a;
		var hasClosurePopup = _v0.b;
		return _Utils_Tuple3(
			{
				b_: config,
				e$: $author$project$Element$ModuleSingle$Closed,
				hk: hasClosurePopup,
				ej: $elm$core$Maybe$Nothing,
				bk: $author$project$Element$ModuleSingle$LoadingPage,
				ep: $elm$core$Maybe$Nothing,
				er: $elm$core$Maybe$Nothing,
				gB: session,
				bo: {gg: $author$project$RemoteData$NotAsked, kb: $author$project$RemoteData$NotAsked}
			},
			$author$project$Element$ModuleSingle$Cmd(
				$author$project$Element$ModuleSingle$FetchModule(
					A3($author$project$Module$fetchModule, config.gX, moduleId, $author$project$Element$ModuleSingle$ModuleDetailDownloaded))),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$ModuleSingle$ModuleClosureEffect = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$ModuleSingle$ModuleClosureMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$ModuleClosure$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModuleClosure$DataDownloading = {$: 0};
var $author$project$Element$ModuleClosure$FetchPortfolioStoryList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleClosure$PortfolioStoryListDownloaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModuleClosure$init = F3(
	function (config, session, params) {
		var moduleId_ = $author$project$Module$moduleIdToInt(params.hG.i8);
		var model = {b_: config, hG: params.hG, gB: session, fs: $author$project$Element$ModuleClosure$DataDownloading, fu: $author$project$RemoteData$NotAsked, cT: false, kb: params.kb};
		var allPortfoliosListParams = $author$project$Api$Endpoint$allPortfoliosListParams;
		var portfoliosListParams = _Utils_update(
			allPortfoliosListParams,
			{
				hH: $elm$core$Maybe$Just(
					_List_fromArray(
						[moduleId_])),
				ii: $author$project$Api$Endpoint$typeMClosure
			});
		return _Utils_Tuple3(
			model,
			$author$project$Element$ModuleClosure$Cmd(
				$author$project$Element$ModuleClosure$FetchPortfolioStoryList(
					A3($author$project$PortfolioStory$fetchStories2, config.gX, portfoliosListParams, $author$project$Element$ModuleClosure$PortfolioStoryListDownloaded))),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$ModuleClosure$RubricAssessmentEffect = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleClosure$RubricAssessmentMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleClosure$RubricSelecting = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Element$ModuleClosure$embeddedRubricAssessment = function () {
	var updateElementModel = F2(
		function (containerModel, model) {
			var _v0 = containerModel.fs;
			switch (_v0.$) {
				case 2:
					var person = _v0.a;
					var module_ = _v0.b;
					return _Utils_update(
						containerModel,
						{
							fs: A3($author$project$Element$ModuleClosure$RubricSelecting, person, module_, model)
						});
				case 3:
					var person = _v0.a;
					var module_ = _v0.b;
					return _Utils_update(
						containerModel,
						{
							fs: A3($author$project$Element$ModuleClosure$RubricSelecting, person, module_, model)
						});
				case 0:
					return containerModel;
				case 1:
					return containerModel;
				default:
					return containerModel;
			}
		});
	return {ha: $author$project$Element$RubricAssessment$element, kk: $author$project$Element$ModuleClosure$RubricAssessmentEffect, cf: $author$project$Element$ModuleClosure$RubricAssessmentMsg, kt: updateElementModel};
}();
var $author$project$Element$ModuleClosure$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$ModuleClosure$perform(key),
						effects));
			case 2:
				switch (effect.a.$) {
					case 2:
						var request = effect.a.a;
						return $author$project$Api$postV2(request);
					case 3:
						var request = effect.a.a;
						return $author$project$Api$postV2(request);
					case 0:
						var request = effect.a.a;
						return $author$project$Api$getV2(request);
					case 1:
						var request = effect.a.a;
						return $author$project$Api$postV2(request);
					default:
						var request = effect.a.a;
						return $author$project$Api$postV2(request);
				}
			default:
				var elementEffect = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, elementEffect, $author$project$Element$ModuleClosure$embeddedRubricAssessment);
		}
	});
var $author$project$Element$ModuleClosure$BadgeSaved = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Element$ModuleClosure$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleClosure$CreateBadge = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$ModuleClosure$CreatePortfolioStory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleClosure$Exit = 0;
var $author$project$Element$ModuleClosure$LogError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleClosure$LogOk = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$ModuleClosureSaveError = {$: 188};
var $author$project$Locale$Messages$ModuleClosureSaveSuccess = {$: 189};
var $author$project$Locale$Messages$ModuleClosureTooManyStudents = {$: 190};
var $author$project$Element$ModuleClosure$NoEffect = {$: 0};
var $author$project$Element$ModuleClosure$NoOp = {$: 7};
var $author$project$Element$ModuleClosure$PortfolioStorySaved = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$PortfolioStory$PortfolioStoryUnsaved = F7(
	function (id, type_, description, media, module_, createdBy, students) {
		return {lf: createdBy, g8: description, i8: id, mw: media, hG: module_, fv: students, ii: type_};
	});
var $author$project$Locale$Messages$PortfoliosSaveError = {$: 385};
var $author$project$Element$ModuleClosure$Saved = 1;
var $author$project$Element$ModuleClosure$StudentSelected_ = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Element$ModuleClosure$StudentSelecting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Endpoint$portfolioStoriesCreate = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'portfolio-stories']),
		_List_Nil);
};
var $author$project$PortfolioStory$createStory = F3(
	function (config, story, callback) {
		return {
			T: $author$project$PortfolioStory$portfolioStoryEncoder(story),
			b_: config,
			d_: $author$project$PortfolioStory$portfolioStoryDecoder,
			cf: callback,
			K: $author$project$Api$Endpoint$portfolioStoriesCreate(config.gX)
		};
	});
var $author$project$Log$paramScopeModuleClosure = 'scope_module_closure';
var $author$project$Element$ModuleClosure$NoRubricError = {$: 4};
var $author$project$Element$ModuleClosure$switchToStudentSelecting = function (model) {
	var module_ = model.hG;
	var config = model.b_;
	var session = model.gB;
	var _v0 = model.fu;
	switch (_v0.$) {
		case 2:
			return ($elm$core$List$length(module_.fq) > 0) ? _Utils_Tuple3(
				_Utils_update(
					model,
					{
						fs: $author$project$Element$ModuleClosure$StudentSelecting(module_)
					}),
				$author$project$Element$ModuleClosure$NoEffect,
				$elm$core$Maybe$Nothing) : _Utils_Tuple3(
				_Utils_update(
					model,
					{fs: $author$project$Element$ModuleClosure$NoRubricError}),
				$author$project$Element$ModuleClosure$NoEffect,
				$elm$core$Maybe$Nothing);
		case 3:
			var error = _v0.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						gB: A3(
							$author$project$Session$error,
							session,
							error,
							session.h6($author$project$Locale$Messages$PortfoliosDownloadError))
					}),
				$author$project$Element$ModuleClosure$Cmd(
					$author$project$Element$ModuleClosure$LogError(
						A3(
							$author$project$Log$errorV2,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgPortfoliosDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeModuleClosure),
								error),
							$elm$core$Basics$always($author$project$Element$ModuleClosure$NoOp)))),
				$elm$core$Maybe$Nothing);
		case 0:
			return _Utils_Tuple3(model, $author$project$Element$ModuleClosure$NoEffect, $elm$core$Maybe$Nothing);
		default:
			return _Utils_Tuple3(model, $author$project$Element$ModuleClosure$NoEffect, $elm$core$Maybe$Nothing);
	}
};
var $author$project$Element$ModuleClosure$update = F2(
	function (msg, model) {
		var config = model.b_;
		var session = model.gB;
		var t_ = session.h6;
		var _v0 = _Utils_Tuple2(msg, model.fs);
		_v0$10:
		while (true) {
			switch (_v0.a.$) {
				case 2:
					if (!_v0.b.$) {
						var stories = _v0.a.a;
						var _v1 = _v0.b;
						return $author$project$Element$ModuleClosure$switchToStudentSelecting(
							_Utils_update(
								model,
								{fu: stories}));
					} else {
						break _v0$10;
					}
				case 6:
					var _v2 = _v0.a;
					return _Utils_Tuple3(
						model,
						$author$project$Element$ModuleClosure$NoEffect,
						$elm$core$Maybe$Just(0));
				case 4:
					var _v3 = _v0.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cT: !model.cT}),
						$author$project$Element$ModuleClosure$NoEffect,
						$elm$core$Maybe$Nothing);
				case 5:
					switch (_v0.b.$) {
						case 1:
							var student = _v0.a.a;
							var module_ = _v0.b.a;
							var params = {
								jE: false,
								fq: module_.fq,
								fv: _List_fromArray(
									[student]),
								kb: model.kb
							};
							var _v4 = A3(
								$author$project$Application$V3$Boundaries$mapElement,
								_Utils_update(
									model,
									{
										fs: A2($author$project$Element$ModuleClosure$StudentSelected_, student, module_),
										cT: false
									}),
								$author$project$Element$ModuleClosure$embeddedRubricAssessment,
								A4($author$project$Application$V3$Boundaries$initElement, config, session, $author$project$Element$ModuleClosure$embeddedRubricAssessment, params));
							var model2 = _v4.a;
							var effect = _v4.b;
							return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
						case 3:
							var student = _v0.a.a;
							var _v5 = _v0.b;
							var module_ = _v5.b;
							var params = {
								jE: false,
								fq: module_.fq,
								fv: _List_fromArray(
									[student]),
								kb: model.kb
							};
							var _v6 = A3(
								$author$project$Application$V3$Boundaries$mapElement,
								_Utils_update(
									model,
									{
										fs: A2($author$project$Element$ModuleClosure$StudentSelected_, student, module_),
										cT: false
									}),
								$author$project$Element$ModuleClosure$embeddedRubricAssessment,
								A4($author$project$Application$V3$Boundaries$initElement, config, session, $author$project$Element$ModuleClosure$embeddedRubricAssessment, params));
							var model2 = _v6.a;
							var effect = _v6.b;
							return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
						default:
							break _v0$10;
					}
				case 0:
					if (_v0.b.$ === 3) {
						var rubricAssessmentMsg = _v0.a.a;
						var _v7 = _v0.b;
						var student = _v7.a;
						var module_ = _v7.b;
						var model_ = _v7.c;
						var _v8 = A3(
							$author$project$Application$V3$Boundaries$mapElement,
							model,
							$author$project$Element$ModuleClosure$embeddedRubricAssessment,
							A4($author$project$Application$V3$Boundaries$updateElement, session, rubricAssessmentMsg, model_, $author$project$Element$ModuleClosure$embeddedRubricAssessment));
						var model2 = _v8.a;
						var effect = _v8.b;
						var reply = _v8.c;
						if (reply.$ === 1) {
							return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
						} else {
							var reply_ = reply.a;
							switch (reply_.$) {
								case 0:
									return _Utils_Tuple3(
										model2,
										effect,
										$elm$core$Maybe$Just(0));
								case 1:
									var appreciation = reply_.a;
									var rubricAssessment = reply_.b;
									var storyUnsaved = A7(
										$author$project$PortfolioStory$PortfolioStoryUnsaved,
										-1,
										1,
										appreciation,
										_List_Nil,
										$elm$core$Maybe$Just(module_.i8),
										session.ok.i8,
										_List_fromArray(
											[student.i8]));
									var logRequest = A3(
										$author$project$Log$okV2,
										model.b_,
										_Utils_Tuple2(
											$author$project$Log$msgRubricAssessmentSave,
											_List_fromArray(
												[
													$author$project$Log$paramScopeModuleClosure,
													$elm$core$String$fromInt(rubricAssessment.nu)
												])),
										$elm$core$Basics$always($author$project$Element$ModuleClosure$NoOp));
									var createPortfolioStoryRequest = A3(
										$author$project$PortfolioStory$createStory,
										config,
										storyUnsaved,
										$author$project$Element$ModuleClosure$PortfolioStorySaved(rubricAssessment));
									return _Utils_Tuple3(
										model2,
										$author$project$Element$ModuleClosure$BatchEffect(
											_List_fromArray(
												[
													$author$project$Element$ModuleClosure$Cmd(
													$author$project$Element$ModuleClosure$CreatePortfolioStory(createPortfolioStoryRequest)),
													$author$project$Element$ModuleClosure$Cmd(
													$author$project$Element$ModuleClosure$LogOk(logRequest))
												])),
										$elm$core$Maybe$Nothing);
								default:
									return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
							}
						}
					} else {
						break _v0$10;
					}
				case 1:
					if (_v0.a.b.$ === 1) {
						var _v11 = _v0.a;
						var error = _v11.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									gB: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$PortfoliosSaveError))
								}),
							$author$project$Element$ModuleClosure$Cmd(
								$author$project$Element$ModuleClosure$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgPortfoliosSave,
											$elm$core$Maybe$Just($author$project$Log$paramScopeModuleClosure),
											error),
										$elm$core$Basics$always($author$project$Element$ModuleClosure$NoOp)))),
							$elm$core$Maybe$Nothing);
					} else {
						var _v12 = _v0.a;
						var rubricAssessment = _v12.a;
						var story = _v12.b.a;
						var unsavedBadge = A3(
							$author$project$Badge$BadgeUnsaved,
							story.g8,
							story.i8,
							$elm$core$Maybe$Just(rubricAssessment));
						var _v13 = story.fv;
						if (_v13.b && (!_v13.b.b)) {
							var student = _v13.a;
							return _Utils_Tuple3(
								model,
								$author$project$Element$ModuleClosure$BatchEffect(
									_List_fromArray(
										[
											$author$project$Element$ModuleClosure$Cmd(
											$author$project$Element$ModuleClosure$CreateBadge(
												A3(
													$author$project$Badge$createBadge,
													config,
													unsavedBadge,
													$author$project$Element$ModuleClosure$BadgeSaved(student)))),
											$author$project$Element$ModuleClosure$Cmd(
											$author$project$Element$ModuleClosure$LogOk(
												A3(
													$author$project$Log$okV2,
													config,
													_Utils_Tuple2(
														$author$project$Log$msgPortfoliosSave,
														_List_fromArray(
															[
																$author$project$Log$paramScopeModuleClosure,
																$elm$core$String$fromInt(story.i8),
																$elm$core$String$fromInt(student.i8),
																$author$project$Log$paramOk
															])),
													$elm$core$Basics$always($author$project$Element$ModuleClosure$NoOp))))
										])),
								$elm$core$Maybe$Nothing);
						} else {
							var error = $author$project$Api$CustomError(
								'module_closure_too_many_students ' + $elm$core$String$fromInt(story.i8));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										gB: A3(
											$author$project$Session$error,
											session,
											error,
											t_($author$project$Locale$Messages$ModuleClosureTooManyStudents))
									}),
								$author$project$Element$ModuleClosure$Cmd(
									$author$project$Element$ModuleClosure$LogError(
										A3(
											$author$project$Log$errorV2,
											config,
											_Utils_Tuple3(
												$author$project$Log$msgPortfoliosSave,
												$elm$core$Maybe$Just($author$project$Log$paramScopeModuleClosure),
												error),
											$elm$core$Basics$always($author$project$Element$ModuleClosure$NoOp)))),
								$elm$core$Maybe$Nothing);
						}
					}
				case 3:
					if (_v0.a.b.$ === 1) {
						var _v14 = _v0.a;
						var error = _v14.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									gB: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$ModuleClosureSaveError))
								}),
							$author$project$Element$ModuleClosure$Cmd(
								$author$project$Element$ModuleClosure$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgBadgeSave,
											$elm$core$Maybe$Just($author$project$Log$paramScopeModuleClosure),
											error),
										$elm$core$Basics$always($author$project$Element$ModuleClosure$NoOp)))),
							$elm$core$Maybe$Just(0));
					} else {
						if (_v0.b.$ === 3) {
							var _v15 = _v0.a;
							var student = _v15.a;
							var badge = _v15.b.a;
							var _v16 = _v0.b;
							var module_ = _v16.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										gB: A2(
											$author$project$Session$ok,
											session,
											t_($author$project$Locale$Messages$ModuleClosureSaveSuccess)),
										fs: $author$project$Element$ModuleClosure$StudentSelecting(module_)
									}),
								$author$project$Element$ModuleClosure$Cmd(
									$author$project$Element$ModuleClosure$LogOk(
										A3(
											$author$project$Log$okV2,
											config,
											_Utils_Tuple2(
												$author$project$Log$msgBadgeSave,
												_List_fromArray(
													[
														$author$project$Log$paramScopeModuleClosure,
														$elm$core$String$fromInt(badge.i8),
														$elm$core$String$fromInt(student.i8),
														$author$project$Log$paramOk
													])),
											$elm$core$Basics$always($author$project$Element$ModuleClosure$NoOp)))),
								$elm$core$Maybe$Just(1));
						} else {
							break _v0$10;
						}
					}
				default:
					break _v0$10;
			}
		}
		return _Utils_Tuple3(model, $author$project$Element$ModuleClosure$NoEffect, $elm$core$Maybe$Nothing);
	});
var $author$project$Element$ModuleClosure$PopupClosed = {$: 6};
var $author$project$Locale$Messages$ModuleClosureHeading = {$: 184};
var $author$project$Locale$Messages$ModuleClosureInfo = {$: 185};
var $author$project$Locale$Messages$ModuleClosureMissingRubrics = {$: 186};
var $author$project$Locale$Messages$ModuleClosureStudent = {$: 187};
var $author$project$Element$ModuleClosure$StudentSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$ModuleClosure$ToggleStudentDown = {$: 4};
var $author$project$Element$ModuleClosure$hasStudentFeedback = F2(
	function (stories, student) {
		var students = $author$project$Util$List$unique(
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.fv;
				},
				stories));
		return A2(
			$elm$core$List$any,
			$author$project$Person$isSamePerson(student),
			students);
	});
var $author$project$Element$ModuleClosure$viewStudentSelector = F5(
	function (t_, isOpen, selectedStudent, module_, stories) {
		var students = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$not,
				$author$project$Element$ModuleClosure$hasStudentFeedback(stories)),
			module_.fv);
		var isActive = function (student) {
			if (!selectedStudent.$) {
				var student_ = selectedStudent.a;
				return _Utils_eq(student_, student);
			} else {
				return false;
			}
		};
		return $author$project$UI$dropDownSelect(
			{
				lw: t_($author$project$Locale$Messages$FormNotSelected),
				lx: $author$project$Element$ModuleClosure$NoOp,
				l7: isActive,
				mb: isOpen,
				mh: $author$project$Person$fullName(t_),
				mi: $author$project$Element$ModuleClosure$StudentSelected,
				mj: $author$project$Element$ModuleClosure$ToggleStudentDown,
				mk: students,
				ea: t_($author$project$Locale$Messages$ModuleClosureStudent),
				nA: selectedStudent,
				nF: false
			});
	});
var $author$project$Element$ModuleClosure$viewContent = function (model) {
	var session = model.gB;
	var t_ = session.h6;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('box')
			]),
		_List_fromArray(
			[
				$author$project$UI$title(
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModuleClosureHeading)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('block')
					]),
				_List_fromArray(
					[
						$author$project$UI$notification(
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModuleClosureInfo)
							]))
					])),
				function () {
				var _v0 = _Utils_Tuple2(model.fs, model.fu);
				_v0$4:
				while (true) {
					switch (_v0.a.$) {
						case 0:
							var _v1 = _v0.a;
							return A2(
								$author$project$UI$progressBar,
								'is-info',
								t_($author$project$Locale$Messages$PortfoliosLoadingProgress));
						case 1:
							if (_v0.b.$ === 2) {
								var module_ = _v0.a.a;
								var stories = _v0.b.a;
								return A5($author$project$Element$ModuleClosure$viewStudentSelector, t_, model.cT, $elm$core$Maybe$Nothing, module_, stories);
							} else {
								break _v0$4;
							}
						case 3:
							if (_v0.b.$ === 2) {
								var _v2 = _v0.a;
								var student = _v2.a;
								var module_ = _v2.b;
								var model_ = _v2.c;
								var stories = _v0.b.a;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A5(
											$author$project$Element$ModuleClosure$viewStudentSelector,
											t_,
											model.cT,
											$elm$core$Maybe$Just(student),
											module_,
											stories),
											A3($author$project$Application$V3$Boundaries$viewElement, session, model_, $author$project$Element$ModuleClosure$embeddedRubricAssessment)
										]));
							} else {
								break _v0$4;
							}
						case 4:
							var _v3 = _v0.a;
							return A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModuleClosureMissingRubrics);
						default:
							break _v0$4;
					}
				}
				return $author$project$UI$none;
			}()
			]));
};
var $author$project$Element$ModuleClosure$view = function (model) {
	return A3(
		$author$project$UI$modalWindow,
		true,
		$author$project$Element$ModuleClosure$PopupClosed,
		$author$project$UI$section(
			_List_fromArray(
				[
					$author$project$Element$ModuleClosure$viewContent(model)
				])));
};
var $author$project$Element$ModuleClosure$element = {jb: $author$project$Element$ModuleClosure$init, hP: $author$project$Element$ModuleClosure$perform, ks: $author$project$Element$ModuleClosure$update, og: $author$project$Element$ModuleClosure$view};
var $author$project$Element$ModuleSingle$popups = {
	cB: {
		ha: $author$project$Element$ModuleClosure$element,
		kk: $author$project$Element$ModuleSingle$ModuleClosureEffect,
		cf: $author$project$Element$ModuleSingle$ModuleClosureMsg,
		kt: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						ej: $elm$core$Maybe$Just(model)
					});
			})
	}
};
var $author$project$Element$ModuleSingle$PortfolioListEffect = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleSingle$portfolioList = {
	ha: $author$project$Element$PortfolioList$element,
	kk: $author$project$Element$ModuleSingle$PortfolioListEffect,
	cf: $author$project$Element$ModuleSingle$PortfolioListMsg,
	kt: F2(
		function (model, elementModel) {
			return _Utils_update(
				model,
				{
					er: $elm$core$Maybe$Just(elementModel)
				});
		})
};
var $author$project$Element$ModuleSingle$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$ModuleSingle$perform(key),
						effects));
			case 2:
				var cmd = effect.a;
				switch (cmd.$) {
					case 0:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					case 1:
						var route = cmd.a;
						return A2(
							$elm$browser$Browser$Navigation$pushUrl,
							key,
							$author$project$Route$toString(route));
					case 2:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 3:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 4:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					default:
						var request = cmd.a;
						return $author$project$Api$deleteV2(request);
				}
			case 3:
				var elementEffect = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, elementEffect, $author$project$Element$ModuleSingle$portfolioList);
			default:
				var elementEffect = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, elementEffect, $author$project$Element$ModuleSingle$popups.cB);
		}
	});
var $author$project$Element$ModuleSingle$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleSingle$DeleteModule = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$ModuleSingle$DetailPage = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Element$ModuleSingle$FetchModuleEventList = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleSingle$FetchSubjectList = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$ModuleSingle$LogError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleSingle$ModuleDeleted = function (a) {
	return {$: 10, a: a};
};
var $author$project$Locale$Messages$ModuleEventsDownloadError = {$: 210};
var $author$project$Element$ModuleSingle$ModuleEventsDownloaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$ModulesDeleteError = {$: 271};
var $author$project$Locale$Messages$ModulesDeleteSuccess = {$: 272};
var $author$project$Element$ModuleSingle$NavRedirect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleSingle$NoEffect = {$: 0};
var $author$project$Element$ModuleSingle$NoOp = {$: 0};
var $author$project$Element$ModuleSingle$Open = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleSingle$SubjectListDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleSingle$andThenIf = F3(
	function (pred, mapFn, _return) {
		return pred ? mapFn(_return) : _return;
	});
var $author$project$Element$ModuleSingle$closePopup = function (model) {
	return _Utils_update(
		model,
		{ej: $elm$core$Maybe$Nothing});
};
var $author$project$Module$deleteModule2 = F3(
	function (config, moduleId, callback) {
		return {
			T: $elm$http$Http$emptyBody,
			b_: config,
			cf: callback,
			K: A2(
				$author$project$Api$Endpoint$module_,
				config,
				$author$project$Module$moduleIdToInt(moduleId))
		};
	});
var $author$project$ModuleEvent$ModuleEventDetailed = F9(
	function (id, module_, title, notes, rrule, startTime, endTime, startDate, endDate) {
		return {ly: endDate, G: endTime, i8: id, hG: module_, aZ: notes, hT: rrule, nN: startDate, R: startTime, kj: title};
	});
var $elm$parser$Parser$deadEndsToString = function (deadEnds) {
	return 'TODO deadEndsToString';
};
var $author$project$RRule$RRule = F6(
	function (dtStart, frequency, interval, weekStart, until, weekdays) {
		return {lu: dtStart, V: frequency, jg: interval, od: until, kz: weekStart, N: weekdays};
	});
var $elm$parser$Parser$ExpectingVariable = {$: 7};
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm$parser$Parser$Advanced$varHelp = F7(
	function (isGood, offset, row, col, src, indent, context) {
		varHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, src);
			if (_Utils_eq(newOffset, -1)) {
				return {k9: col, l: context, r: indent, d: offset, ns: row, c: src};
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$src = src,
						$temp$indent = indent,
						$temp$context = context;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					src = $temp$src;
					indent = $temp$indent;
					context = $temp$context;
					continue varHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$src = src,
						$temp$indent = indent,
						$temp$context = context;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					src = $temp$src;
					indent = $temp$indent;
					context = $temp$context;
					continue varHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$variable = function (i) {
	return function (s) {
		var firstOffset = A3($elm$parser$Parser$Advanced$isSubChar, i.h2, s.d, s.c);
		if (_Utils_eq(firstOffset, -1)) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, i.iY));
		} else {
			var s1 = _Utils_eq(firstOffset, -2) ? A7($elm$parser$Parser$Advanced$varHelp, i.je, s.d + 1, s.ns + 1, 1, s.c, s.r, s.l) : A7($elm$parser$Parser$Advanced$varHelp, i.je, firstOffset, s.ns, s.k9 + 1, s.c, s.r, s.l);
			var name = A3($elm$core$String$slice, s.d, s1.d, s.c);
			return A2($elm$core$Set$member, name, i.j$) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, i.iY)) : A3($elm$parser$Parser$Advanced$Good, true, name, s1);
		}
	};
};
var $elm$parser$Parser$variable = function (i) {
	return $elm$parser$Parser$Advanced$variable(
		{iY: $elm$parser$Parser$ExpectingVariable, je: i.je, j$: i.j$, h2: i.h2});
};
var $author$project$RRule$datetime = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed(
			F2(
				function (date_, time_) {
					return date_ + ('T' + time_);
				})),
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$variable(
				{je: $elm$core$Char$isDigit, j$: $elm$core$Set$empty, h2: $elm$core$Char$isDigit}),
			$elm$parser$Parser$symbol('T'))),
	$elm$parser$Parser$variable(
		{je: $elm$core$Char$isDigit, j$: $elm$core$Set$empty, h2: $elm$core$Char$isDigit}));
var $elm$parser$Parser$ExpectingKeyword = function (a) {
	return {$: 9, a: a};
};
var $elm$parser$Parser$Advanced$keyword = function (_v0) {
	var kwd = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(kwd);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, kwd, s.d, s.ns, s.k9, s.c);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return (_Utils_eq(newOffset, -1) || (0 <= A3(
			$elm$parser$Parser$Advanced$isSubChar,
			function (c) {
				return $elm$core$Char$isAlphaNum(c) || (c === '_');
			},
			newOffset,
			s.c))) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{k9: newCol, l: s.l, r: s.r, d: newOffset, ns: newRow, c: s.c});
	};
};
var $elm$parser$Parser$keyword = function (kwd) {
	return $elm$parser$Parser$Advanced$keyword(
		A2(
			$elm$parser$Parser$Advanced$Token,
			kwd,
			$elm$parser$Parser$ExpectingKeyword(kwd)));
};
var $author$project$RRule$mainSep = $elm$parser$Parser$symbol(':');
var $author$project$RRule$dtStart = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Maybe$Just),
					$elm$parser$Parser$keyword('DTSTART')),
				$author$project$RRule$mainSep),
			A2(
				$elm$parser$Parser$ignorer,
				$author$project$RRule$datetime,
				$elm$parser$Parser$symbol('\n'))),
			$elm$parser$Parser$succeed($elm$core$Maybe$Nothing)
		]));
var $author$project$RRule$Daily = 1;
var $author$project$RRule$Monthly = 2;
var $author$project$RRule$Weekly = 0;
var $author$project$RRule$frequency = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$keyword('FREQ')),
		$elm$parser$Parser$symbol('=')),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(1),
				$elm$parser$Parser$keyword('DAILY')),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$keyword('WEEKLY')),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(2),
				$elm$parser$Parser$keyword('MONTHLY'))
			])));
var $author$project$RRule$ruleSep = $elm$parser$Parser$symbol(';');
var $author$project$RRule$interval = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Maybe$Just),
						$elm$parser$Parser$backtrackable($author$project$RRule$ruleSep)),
					$elm$parser$Parser$keyword('INTERVAL')),
				$elm$parser$Parser$symbol('=')),
			$elm$parser$Parser$int),
			$elm$parser$Parser$succeed($elm$core$Maybe$Nothing)
		]));
var $author$project$RRule$until = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Maybe$Just),
						$elm$parser$Parser$backtrackable($author$project$RRule$ruleSep)),
					$elm$parser$Parser$keyword('UNTIL')),
				$elm$parser$Parser$symbol('=')),
			$author$project$RRule$datetime),
			$elm$parser$Parser$succeed($elm$core$Maybe$Nothing)
		]));
var $author$project$RRule$weekday = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed('MO'),
			$elm$parser$Parser$keyword('MO')),
			A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed('TU'),
			$elm$parser$Parser$keyword('TU')),
			A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed('WE'),
			$elm$parser$Parser$keyword('WE')),
			A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed('TH'),
			$elm$parser$Parser$keyword('TH')),
			A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed('FR'),
			$elm$parser$Parser$keyword('FR')),
			A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed('SA'),
			$elm$parser$Parser$keyword('SA')),
			A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed('SU'),
			$elm$parser$Parser$keyword('SU'))
		]));
var $author$project$RRule$weekStart = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Maybe$Just),
						$elm$parser$Parser$backtrackable($author$project$RRule$ruleSep)),
					$elm$parser$Parser$keyword('WKST')),
				$elm$parser$Parser$symbol('=')),
			$author$project$RRule$weekday),
			$elm$parser$Parser$succeed($elm$core$Maybe$Nothing)
		]));
var $elm$parser$Parser$Forbidden = 0;
var $elm$parser$Parser$Advanced$revAlways = F2(
	function (_v0, b) {
		return b;
	});
var $elm$parser$Parser$Advanced$skip = F2(
	function (iParser, kParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$parser$Parser$Advanced$revAlways, iParser, kParser);
	});
var $elm$parser$Parser$Advanced$sequenceEndForbidden = F5(
	function (ender, ws, parseItem, sep, revItems) {
		var chompRest = function (item) {
			return A5(
				$elm$parser$Parser$Advanced$sequenceEndForbidden,
				ender,
				ws,
				parseItem,
				sep,
				A2($elm$core$List$cons, item, revItems));
		};
		return A2(
			$elm$parser$Parser$Advanced$skip,
			ws,
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$Advanced$skip,
						sep,
						A2(
							$elm$parser$Parser$Advanced$skip,
							ws,
							A2(
								$elm$parser$Parser$Advanced$map,
								function (item) {
									return $elm$parser$Parser$Advanced$Loop(
										A2($elm$core$List$cons, item, revItems));
								},
								parseItem))),
						A2(
						$elm$parser$Parser$Advanced$map,
						function (_v0) {
							return $elm$parser$Parser$Advanced$Done(
								$elm$core$List$reverse(revItems));
						},
						ender)
					])));
	});
var $elm$parser$Parser$Advanced$sequenceEndMandatory = F4(
	function (ws, parseItem, sep, revItems) {
		return $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$map,
					function (item) {
						return $elm$parser$Parser$Advanced$Loop(
							A2($elm$core$List$cons, item, revItems));
					},
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						parseItem,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							ws,
							A2($elm$parser$Parser$Advanced$ignorer, sep, ws)))),
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return $elm$parser$Parser$Advanced$Done(
							$elm$core$List$reverse(revItems));
					},
					$elm$parser$Parser$Advanced$succeed(0))
				]));
	});
var $elm$parser$Parser$Advanced$sequenceEndOptional = F5(
	function (ender, ws, parseItem, sep, revItems) {
		var parseEnd = A2(
			$elm$parser$Parser$Advanced$map,
			function (_v0) {
				return $elm$parser$Parser$Advanced$Done(
					$elm$core$List$reverse(revItems));
			},
			ender);
		return A2(
			$elm$parser$Parser$Advanced$skip,
			ws,
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$Advanced$skip,
						sep,
						A2(
							$elm$parser$Parser$Advanced$skip,
							ws,
							$elm$parser$Parser$Advanced$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$Advanced$map,
										function (item) {
											return $elm$parser$Parser$Advanced$Loop(
												A2($elm$core$List$cons, item, revItems));
										},
										parseItem),
										parseEnd
									])))),
						parseEnd
					])));
	});
var $elm$parser$Parser$Advanced$sequenceEnd = F5(
	function (ender, ws, parseItem, sep, trailing) {
		var chompRest = function (item) {
			switch (trailing) {
				case 0:
					return A2(
						$elm$parser$Parser$Advanced$loop,
						_List_fromArray(
							[item]),
						A4($elm$parser$Parser$Advanced$sequenceEndForbidden, ender, ws, parseItem, sep));
				case 1:
					return A2(
						$elm$parser$Parser$Advanced$loop,
						_List_fromArray(
							[item]),
						A4($elm$parser$Parser$Advanced$sequenceEndOptional, ender, ws, parseItem, sep));
				default:
					return A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$skip,
							ws,
							A2(
								$elm$parser$Parser$Advanced$skip,
								sep,
								A2(
									$elm$parser$Parser$Advanced$skip,
									ws,
									A2(
										$elm$parser$Parser$Advanced$loop,
										_List_fromArray(
											[item]),
										A3($elm$parser$Parser$Advanced$sequenceEndMandatory, ws, parseItem, sep))))),
						ender);
			}
		};
		return $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2($elm$parser$Parser$Advanced$andThen, chompRest, parseItem),
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return _List_Nil;
					},
					ender)
				]));
	});
var $elm$parser$Parser$Advanced$sequence = function (i) {
	return A2(
		$elm$parser$Parser$Advanced$skip,
		$elm$parser$Parser$Advanced$token(i.h2),
		A2(
			$elm$parser$Parser$Advanced$skip,
			i.nK,
			A5(
				$elm$parser$Parser$Advanced$sequenceEnd,
				$elm$parser$Parser$Advanced$token(i.hb),
				i.nK,
				i.B,
				$elm$parser$Parser$Advanced$token(i.nC),
				i.oc)));
};
var $elm$parser$Parser$Advanced$Forbidden = 0;
var $elm$parser$Parser$Advanced$Mandatory = 2;
var $elm$parser$Parser$Advanced$Optional = 1;
var $elm$parser$Parser$toAdvancedTrailing = function (trailing) {
	switch (trailing) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $elm$parser$Parser$sequence = function (i) {
	return $elm$parser$Parser$Advanced$sequence(
		{
			hb: $elm$parser$Parser$toToken(i.hb),
			B: i.B,
			nC: $elm$parser$Parser$toToken(i.nC),
			nK: i.nK,
			h2: $elm$parser$Parser$toToken(i.h2),
			oc: $elm$parser$Parser$toAdvancedTrailing(i.oc)
		});
};
var $elm$parser$Parser$Advanced$spaces = $elm$parser$Parser$Advanced$chompWhile(
	function (c) {
		return (c === ' ') || ((c === '\n') || (c === '\r'));
	});
var $elm$parser$Parser$spaces = $elm$parser$Parser$Advanced$spaces;
var $author$project$RRule$weekdays = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Maybe$Just),
						$elm$parser$Parser$backtrackable($author$project$RRule$ruleSep)),
					$elm$parser$Parser$keyword('BYDAY')),
				$elm$parser$Parser$symbol('=')),
			$elm$parser$Parser$sequence(
				{hb: '', B: $author$project$RRule$weekday, nC: ',', nK: $elm$parser$Parser$spaces, h2: '', oc: 0})),
			$elm$parser$Parser$succeed($elm$core$Maybe$Nothing)
		]));
var $author$project$RRule$rRuleParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($author$project$RRule$RRule),
						A2(
							$elm$parser$Parser$ignorer,
							A2(
								$elm$parser$Parser$ignorer,
								$author$project$RRule$dtStart,
								$elm$parser$Parser$keyword('RRULE')),
							$author$project$RRule$mainSep)),
					$author$project$RRule$frequency),
				$author$project$RRule$interval),
			$author$project$RRule$weekStart),
		$author$project$RRule$until),
	A2($elm$parser$Parser$ignorer, $author$project$RRule$weekdays, $elm$parser$Parser$end));
var $author$project$RRule$parse = function (s) {
	return A2($elm$parser$Parser$run, $author$project$RRule$rRuleParser, s);
};
var $author$project$RRule$decodeString = function (str) {
	var _v0 = $author$project$RRule$parse(str);
	if (!_v0.$) {
		var rrule = _v0.a;
		return $elm$json$Json$Decode$succeed(rrule);
	} else {
		var errors = _v0.a;
		return $elm$json$Json$Decode$fail(
			'Invalid RRULE: ' + $elm$parser$Parser$deadEndsToString(errors));
	}
};
var $author$project$ModuleEvent$ModuleEventId = $elm$core$Basics$identity;
var $author$project$ModuleEvent$moduleEventIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$ModuleEvent$moduleEventDetailedDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'end_date',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'start_date',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'end_time',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'start_time',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'rrule',
					A2($elm$json$Json$Decode$andThen, $author$project$RRule$decodeString, $elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'notes',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'title',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'module',
								$author$project$Module$moduleIdDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$author$project$ModuleEvent$moduleEventIdDecoder,
									$elm$json$Json$Decode$succeed($author$project$ModuleEvent$ModuleEventDetailed))))))))));
var $author$project$ModuleEvent$moduleEventDetailedListDecoder = $elm$json$Json$Decode$list($author$project$ModuleEvent$moduleEventDetailedDecoder);
var $author$project$Api$Endpoint$makeModuleEventsQueryParams = function (params) {
	return A3(
		$author$project$Api$Endpoint$optional,
		$elm$core$String$fromInt,
		_Utils_Tuple2('module_id', params.js),
		_List_Nil);
};
var $author$project$Api$Endpoint$moduleEvents = F2(
	function (config, params) {
		var queryParams = $author$project$Api$Endpoint$makeModuleEventsQueryParams(params);
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'module-events']),
			queryParams);
	});
var $author$project$ModuleEvent$fetchModuleEvents2 = F3(
	function (config, params, callback) {
		return {
			b_: config,
			d_: $author$project$ModuleEvent$moduleEventDetailedListDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2($author$project$Api$Endpoint$moduleEvents, config, params)
		};
	});
var $author$project$Element$ModuleSingle$fillDetailPage = F2(
	function (_v0, moduleDetailed) {
		var model = _v0.a;
		var store = model.bo;
		var effect = _v0.b;
		var reply = _v0.c;
		var _v1 = _Utils_Tuple2(store.kb, store.gg);
		if ((_v1.a.$ === 2) && (_v1.b.$ === 2)) {
			var subjects = _v1.a.a;
			var moduleEvents = _v1.b.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						bk: A3(
							$author$project$Element$ModuleSingle$DetailPage,
							moduleDetailed,
							subjects,
							$elm$core$Maybe$Just(moduleEvents))
					}),
				effect,
				reply);
		} else {
			return _Utils_Tuple3(model, effect, reply);
		}
	});
var $author$project$Log$msgModuleDelete = 'module_delete';
var $author$project$Log$msgModuleEventsDownload = 'module_events_download';
var $author$project$Element$ModuleSingle$openModuleClosurePopup = F3(
	function (module_, subjects, _v0) {
		var model = _v0.a;
		var session = model.gB;
		var effect = _v0.b;
		var _v1 = A3(
			$author$project$Application$V3$Boundaries$mapElement,
			model,
			$author$project$Element$ModuleSingle$popups.cB,
			A4(
				$author$project$Application$V3$Boundaries$initElement,
				model.b_,
				session,
				$author$project$Element$ModuleSingle$popups.cB,
				{hG: module_, kb: subjects}));
		var model2 = _v1.a;
		var effect2 = _v1.b;
		return _Utils_Tuple3(
			model2,
			$author$project$Element$ModuleSingle$BatchEffect(
				_List_fromArray(
					[effect, effect2])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$ModuleSingle$openRelatedPortfolios = F2(
	function (module_, _v0) {
		var model = _v0.a;
		var session = model.gB;
		var effect = _v0.b;
		var params = $author$project$Element$PortfolioList$defaultParams;
		var _v1 = A3(
			$author$project$Application$V3$Boundaries$mapElement,
			model,
			$author$project$Element$ModuleSingle$portfolioList,
			A4(
				$author$project$Application$V3$Boundaries$initElement,
				model.b_,
				session,
				$author$project$Element$ModuleSingle$portfolioList,
				_Utils_update(
					params,
					{
						hH: _List_fromArray(
							[module_.i8])
					})));
		var model2 = _v1.a;
		var effect2 = _v1.b;
		return _Utils_Tuple3(
			model2,
			$author$project$Element$ModuleSingle$BatchEffect(
				_List_fromArray(
					[effect, effect2])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Log$paramScopeModules = 'scope_modules';
var $author$project$Element$ModuleSingle$ErrorPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModuleSingle$processModuleDownloadError = F2(
	function (model, error) {
		var session = model.gB;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{
					bk: $author$project$Element$ModuleSingle$ErrorPage(error),
					gB: A3(
						$author$project$Session$error,
						session,
						error,
						session.h6($author$project$Locale$Messages$ModulesDownloadError))
				}),
			$author$project$Element$ModuleSingle$Cmd(
				$author$project$Element$ModuleSingle$LogError(
					A3(
						$author$project$Log$errorV2,
						model.b_,
						_Utils_Tuple3(
							$author$project$Log$msgModuleDownload,
							$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
							error),
						$elm$core$Basics$always($author$project$Element$ModuleSingle$NoOp)))),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$ModuleSingle$update = F2(
	function (msg, model) {
		var config = model.b_;
		var session = model.gB;
		var noop = _Utils_Tuple3(model, $author$project$Element$ModuleSingle$NoEffect, $elm$core$Maybe$Nothing);
		switch (msg.$) {
			case 0:
				return noop;
			case 6:
				var moduleId = msg.a;
				var toggleDropdown = function () {
					var _v1 = model.e$;
					if (!_v1.$) {
						var m = _v1.a;
						return _Utils_eq(m, moduleId) ? $author$project$Element$ModuleSingle$Closed : $author$project$Element$ModuleSingle$Open(moduleId);
					} else {
						return $author$project$Element$ModuleSingle$Open(moduleId);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{e$: toggleDropdown}),
					$author$project$Element$ModuleSingle$NoEffect,
					$elm$core$Maybe$Nothing);
			case 1:
				if (!msg.a.$) {
					var module_ = msg.a.a;
					var params = {
						js: $elm$core$Maybe$Just(
							$author$project$Module$moduleIdToInt(module_.i8))
					};
					var model2 = _Utils_update(
						model,
						{
							bk: A3($author$project$Element$ModuleSingle$DetailPage, module_, _List_Nil, $elm$core$Maybe$Nothing),
							er: $elm$core$Maybe$Nothing
						});
					var effects = $author$project$Element$ModuleSingle$BatchEffect(
						_List_fromArray(
							[
								$author$project$Element$ModuleSingle$Cmd(
								$author$project$Element$ModuleSingle$FetchSubjectList(
									A3($author$project$Subject$fetchSubjectsV2, config.gX, '', $author$project$Element$ModuleSingle$SubjectListDownloaded))),
								$author$project$Element$ModuleSingle$Cmd(
								$author$project$Element$ModuleSingle$FetchModuleEventList(
									A3($author$project$ModuleEvent$fetchModuleEvents2, config.gX, params, $author$project$Element$ModuleSingle$ModuleEventsDownloaded)))
							]));
					return A2(
						$author$project$Element$ModuleSingle$openRelatedPortfolios,
						module_,
						_Utils_Tuple3(model2, effects, $elm$core$Maybe$Nothing));
				} else {
					var error = msg.a.a;
					return A2($author$project$Element$ModuleSingle$processModuleDownloadError, model, error);
				}
			case 3:
				var data = msg.a;
				var _v2 = _Utils_Tuple2(data, model.bk);
				switch (_v2.a.$) {
					case 2:
						switch (_v2.b.$) {
							case 1:
								var subjects = _v2.a.a;
								var _v3 = _v2.b;
								var moduleDetailed = _v3.a;
								var store = model.bo;
								var updatedStore = _Utils_update(
									store,
									{kb: data});
								return A3(
									$author$project$Element$ModuleSingle$andThenIf,
									model.hk,
									A2($author$project$Element$ModuleSingle$openModuleClosurePopup, moduleDetailed, subjects),
									A2(
										$author$project$Element$ModuleSingle$fillDetailPage,
										_Utils_Tuple3(
											_Utils_update(
												model,
												{bo: updatedStore}),
											$author$project$Element$ModuleSingle$NoEffect,
											$elm$core$Maybe$Nothing),
										moduleDetailed));
							case 0:
								var _v6 = _v2.b;
								return noop;
							default:
								return noop;
						}
					case 3:
						var error = _v2.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									gB: A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$SubjectListDownloadError))
								}),
							$author$project$Element$ModuleSingle$Cmd(
								$author$project$Element$ModuleSingle$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgSubjectListDownload,
											$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
											error),
										$elm$core$Basics$always($author$project$Element$ModuleSingle$NoOp)))),
							$elm$core$Maybe$Nothing);
					case 0:
						var _v4 = _v2.a;
						return noop;
					default:
						var _v5 = _v2.a;
						return noop;
				}
			case 2:
				var data = msg.a;
				var _v7 = _Utils_Tuple2(data, model.bk);
				switch (_v7.a.$) {
					case 2:
						if (_v7.b.$ === 1) {
							var _v8 = _v7.b;
							var moduleDetailed = _v8.a;
							var store = model.bo;
							var updatedStore = _Utils_update(
								store,
								{gg: data});
							return A2(
								$author$project$Element$ModuleSingle$fillDetailPage,
								_Utils_Tuple3(
									_Utils_update(
										model,
										{bo: updatedStore}),
									$author$project$Element$ModuleSingle$NoEffect,
									$elm$core$Maybe$Nothing),
								moduleDetailed);
						} else {
							return noop;
						}
					case 3:
						var error = _v7.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									gB: A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$ModuleEventsDownloadError))
								}),
							$author$project$Element$ModuleSingle$Cmd(
								$author$project$Element$ModuleSingle$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgModuleEventsDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$ModuleSingle$NoOp)))),
							$elm$core$Maybe$Nothing);
					case 1:
						var _v9 = _v7.a;
						return noop;
					default:
						var _v10 = _v7.a;
						return noop;
				}
			case 10:
				if (!msg.a.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A2(
									$author$project$Session$ok,
									session,
									session.h6($author$project$Locale$Messages$ModulesDeleteSuccess))
							}),
						$author$project$Element$ModuleSingle$Cmd(
							$author$project$Element$ModuleSingle$NavRedirect($author$project$Route$ModulesList)),
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$ModulesDeleteError))
							}),
						$author$project$Element$ModuleSingle$Cmd(
							$author$project$Element$ModuleSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgModuleDelete,
										$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
										error),
									$elm$core$Basics$always($author$project$Element$ModuleSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 7:
				var module_ = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ep: $elm$core$Maybe$Just(module_)
						}),
					$author$project$Element$ModuleSingle$NoEffect,
					$elm$core$Maybe$Nothing);
			case 8:
				var module_ = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ep: $elm$core$Maybe$Nothing}),
					$author$project$Element$ModuleSingle$Cmd(
						$author$project$Element$ModuleSingle$DeleteModule(
							A3($author$project$Module$deleteModule2, config.gX, module_.i8, $author$project$Element$ModuleSingle$ModuleDeleted))),
					$elm$core$Maybe$Nothing);
			case 9:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ep: $elm$core$Maybe$Nothing}),
					$author$project$Element$ModuleSingle$NoEffect,
					$elm$core$Maybe$Nothing);
			case 4:
				var portfolioListMsg = msg.a;
				var _v11 = model.er;
				if (!_v11.$) {
					var portfolioModel = _v11.a;
					var _v12 = A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						$author$project$Element$ModuleSingle$portfolioList,
						A4($author$project$Application$V3$Boundaries$updateElement, session, portfolioListMsg, portfolioModel, $author$project$Element$ModuleSingle$portfolioList));
					var model2 = _v12.a;
					var effect = _v12.b;
					return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
				} else {
					return noop;
				}
			default:
				var moduleClosureMsg = msg.a;
				var _v13 = _Utils_Tuple2(model.ej, model.bk);
				if ((!_v13.a.$) && (_v13.b.$ === 1)) {
					var moduleClosureModel = _v13.a.a;
					var _v14 = _v13.b;
					var module_ = _v14.a;
					var redirectToModulePage = function () {
						var _v19 = model.bk;
						switch (_v19.$) {
							case 1:
								var moduleDetailed = _v19.a;
								return $author$project$Element$ModuleSingle$Cmd(
									$author$project$Element$ModuleSingle$NavRedirect(
										$author$project$Route$ModulesDetail(
											$author$project$Module$moduleIdToInt(moduleDetailed.i8))));
							case 0:
								return $author$project$Element$ModuleSingle$NoEffect;
							default:
								return $author$project$Element$ModuleSingle$NoEffect;
						}
					}();
					var _v15 = A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						$author$project$Element$ModuleSingle$popups.cB,
						A4($author$project$Application$V3$Boundaries$updateElement, session, moduleClosureMsg, moduleClosureModel, $author$project$Element$ModuleSingle$popups.cB));
					var model2 = _v15.a;
					var effect = _v15.b;
					var reply = _v15.c;
					var closePopupAndRedirectToModule = _Utils_Tuple3(
						$author$project$Element$ModuleSingle$closePopup(model2),
						$author$project$Element$ModuleSingle$BatchEffect(
							_List_fromArray(
								[effect, redirectToModulePage])),
						$elm$core$Maybe$Nothing);
					if (!reply.$) {
						if (!reply.a) {
							var _v17 = reply.a;
							return closePopupAndRedirectToModule;
						} else {
							var _v18 = reply.a;
							return A2($author$project$Element$ModuleSingle$openRelatedPortfolios, module_, closePopupAndRedirectToModule);
						}
					} else {
						return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
					}
				} else {
					return noop;
				}
		}
	});
var $author$project$Locale$Messages$ModulesLoadingProgress = {$: 267};
var $author$project$Element$ModuleSingle$ModuleDeleteConfirmed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$ModuleSingle$ModuleDeleteDeclined = {$: 9};
var $author$project$Locale$Messages$ModulesActionDelete = {$: 221};
var $author$project$Locale$Messages$ModulesDeleteHelp = function (a) {
	return {$: 233, a: a};
};
var $author$project$Element$ModuleSingle$viewConfirmDialog = F2(
	function (t_, module_) {
		return A4(
			$author$project$UI$confirmDialog,
			t_,
			{
				lc: $author$project$Element$ModuleSingle$ModuleDeleteConfirmed(module_),
				lm: $author$project$Element$ModuleSingle$ModuleDeleteDeclined
			},
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesActionDelete)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					$author$project$UI$textToHtml(
						t_(
							$author$project$Locale$Messages$ModulesDeleteHelp(module_.kj))))
				]));
	});
var $author$project$Locale$Messages$ModulesFieldEvaluation = {$: 243};
var $author$project$Locale$Messages$ModulesFieldMaterialsUrl = {$: 239};
var $author$project$Locale$Messages$ModulesFieldStudents = {$: 251};
var $author$project$Module$asListItem = function (module_) {
	return {kI: module_.kI, g8: module_.g8, ly: module_.ly, hc: module_.hc, lO: module_.lO, lP: module_.lP, lQ: module_.lQ, i8: module_.i8, l0: module_.l0, l9: module_.l9, mf: module_.mf, jq: module_.jq, jr: module_.jr, fq: module_.fq, nN: module_.nN, fv: module_.fv, fx: module_.fx, kf: module_.kf, kj: module_.kj};
};
var $author$project$Element$ModuleSingle$viewModuleDescription = function (module_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('block')
			]),
		_List_fromArray(
			[
				$author$project$Util$Html$markdownToHtml(module_.g8)
			]));
};
var $author$project$Locale$Messages$ModulesModuleEvents = {$: 276};
var $author$project$Locale$Messages$ModuleModuleEvent = function (a) {
	return {$: 211, a: a};
};
var $author$project$RRule$frequencyToString = function (freq) {
	switch (freq) {
		case 0:
			return 'Weekly';
		case 1:
			return 'Daily';
		default:
			return 'Monthly';
	}
};
var $author$project$ModuleEvent$fromDateToValue = function (dt) {
	var yyyy = A3($elm$core$String$slice, 0, 4, dt);
	var mm = A3($elm$core$String$slice, 4, 6, dt);
	var dd = A3($elm$core$String$slice, 6, 8, dt);
	return yyyy + ('-' + (mm + ('-' + dd)));
};
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$ModuleEvent$isRecurring = function (event) {
	return A2(
		$elm$core$Maybe$withDefault,
		true,
		A3(
			$elm$core$Maybe$map2,
			F2(
				function (dtStart, until) {
					return !_Utils_eq(
						$author$project$ModuleEvent$fromDateToValue(dtStart),
						$author$project$ModuleEvent$fromDateToValue(until));
				}),
			event.hT.lu,
			event.hT.od));
};
var $author$project$Element$ModuleSingle$viewModuleEvent = F2(
	function (_v0, moduleEvent) {
		var t_ = _v0.h6;
		var params = {
			ly: $author$project$Form$dateFromMillis(moduleEvent.ly),
			G: A2($elm$core$Maybe$withDefault, '', moduleEvent.G),
			V: $author$project$RRule$frequencyToString(moduleEvent.hT.V),
			jg: moduleEvent.hT.jg,
			md: $author$project$ModuleEvent$isRecurring(moduleEvent),
			nN: $author$project$Form$dateFromMillis(moduleEvent.nN),
			R: A2($elm$core$Maybe$withDefault, '', moduleEvent.R),
			kj: moduleEvent.kj,
			N: moduleEvent.hT.N
		};
		return $elm$html$Html$text(
			t_(
				$author$project$Locale$Messages$ModuleModuleEvent(params)));
	});
var $author$project$Element$ModuleSingle$viewModuleEvents = F2(
	function (session, moduleEvents) {
		var t_ = session.h6;
		var moduleEventBullets = function () {
			if (!moduleEvents.$) {
				var events = moduleEvents.a;
				return $author$project$UI$contentElem(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (moduleEvent) {
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Element$ModuleSingle$viewModuleEvent, session, moduleEvent)
											]));
								},
								events))
						]));
			} else {
				return $author$project$UI$List$resultsLoadingProgressBar;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('subtitle')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesModuleEvents)
						])),
					moduleEventBullets
				]));
	});
var $author$project$Element$ModuleSingle$viewModuleGoals = F2(
	function (t_, module_) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('subtitle')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFieldGoals)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							$author$project$Util$Html$markdownToHtml(module_.lO)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							$author$project$Util$Html$markdownToHtml(module_.lQ)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							$author$project$Util$Html$markdownToHtml(module_.lP)
						]))
				]));
	});
var $author$project$Element$ModuleSingle$NavToggled = function (a) {
	return {$: 6, a: a};
};
var $author$project$Locale$Messages$BtnActions = {$: 25};
var $author$project$UI$Icon$IconAlt = function (a) {
	return {$: 3, a: a};
};
var $author$project$UI$Icon$alt = function (text_) {
	return $author$project$UI$Icon$IconAlt(text_);
};
var $author$project$UI$actionLinksDropdown = F4(
	function (t_, isActiveNav, triggerMsg, actionLinks) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dropdown is-right'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('is-active', isActiveNav)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-trigger'),
							$elm$html$Html$Events$onClick(triggerMsg)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'aria-controls', 'dropdown-menu'),
									A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true'),
									$elm$html$Html$Attributes$class('button is-small is-dark is-inverted'),
									$author$project$UI$attrCyData('modules-item-nav')
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$icon(
									_List_fromArray(
										[
											$author$project$UI$Icon$face('fa-ellipsis-h'),
											$author$project$UI$Icon$alt(
											t_($author$project$Locale$Messages$BtnActions))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-menu'),
							$elm$html$Html$Attributes$id('dropdown-menu'),
							A2($elm$html$Html$Attributes$attribute, 'role', 'menu')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$nav,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dropdown-content')
								]),
							actionLinks)
						]))
				]));
	});
var $author$project$Element$ModuleSingle$ModuleDeleteRequested = function (a) {
	return {$: 7, a: a};
};
var $author$project$Locale$Messages$ModulesBtnCreateFromTemplate = {$: 225};
var $author$project$Locale$Messages$ModulesBtnDuplicate = {$: 223};
var $author$project$Locale$Messages$ModulesBtnFeedback = {$: 222};
var $author$project$Locale$Messages$ModulesBtnPortfolioStory = {$: 228};
var $author$project$Locale$Messages$ModulesBtnSchedule = {$: 227};
var $author$project$Locale$Messages$ModulesMissingRubrics = {$: 274};
var $author$project$UI$Icon$portfolio = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-drum'),
			attributes));
};
var $author$project$Element$ModuleSingle$viewModuleActionLinks = F3(
	function (t_, viewer, module_) {
		var viewEditLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesUpdate(
						$author$project$Module$moduleIdToInt(module_.i8))),
					$author$project$UI$attrCyData('modules-item-edit'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$edit(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-warning')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnEdit)
				]));
		var viewDuplicateLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesDuplicate(
						$author$project$Module$moduleIdToInt(module_.i8))),
					$author$project$UI$attrCyData('modules-item-duplicate'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-clone'),
							$author$project$UI$Icon$style('has-text-grey')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnDuplicate)
				]));
		var viewDeleteLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$ModuleSingle$ModuleDeleteRequested(module_),
			_List_fromArray(
				[
					$author$project$UI$attrCyData('modules-item-delete'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$delete(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnDelete)
				]));
		var viewCreateFromTemplateLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesCreateFromTemplate(
						$author$project$Module$moduleIdToInt(module_.i8))),
					$author$project$UI$attrCyData('modules-item-create'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$add(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-grey')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnCreateFromTemplate)
				]));
		var inactiveAttrsNoStudents = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('dropdown-item has-text-grey-light'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$ModulesMissingStudents))
			]);
		var inactiveAttrsNoRubrics = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('dropdown-item has-text-grey-light'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$ModulesMissingRubrics))
			]);
		var hasStudents = !$elm$core$List$isEmpty(module_.fv);
		var viewPortfolioStoryLink = function () {
			var linkAttrs = _List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$PortfoliosCreate(
						$elm$core$Maybe$Just(
							$author$project$Module$moduleIdToInt(module_.i8)))),
					$author$project$UI$attrCyData('modules-item-story'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]);
			var caption = _List_fromArray(
				[
					$author$project$UI$Icon$portfolio(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-link')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnPortfolioStory)
				]);
			return hasStudents ? A2($elm$html$Html$a, linkAttrs, caption) : A2($elm$html$Html$span, inactiveAttrsNoStudents, caption);
		}();
		var viewScheduleLink = function () {
			var linkAttrs = _List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$TimetableCreateEvent(
						{
							hb: $elm$core$Maybe$Nothing,
							js: $elm$core$Maybe$Just(
								$author$project$Module$moduleIdToInt(module_.i8)),
							h2: $elm$core$Maybe$Nothing
						})),
					$author$project$UI$attrCyData('modules-item-schedule'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]);
			var caption = _List_fromArray(
				[
					$author$project$UI$Icon$moduleEvent(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-info')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnSchedule)
				]);
			return hasStudents ? A2($elm$html$Html$a, linkAttrs, caption) : A2($elm$html$Html$span, inactiveAttrsNoStudents, caption);
		}();
		var hasRubrics = !$elm$core$List$isEmpty(module_.fq);
		var viewFinalEvaluationLink = function () {
			var linkAttrs = _List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesClosure(
						$author$project$Module$moduleIdToInt(module_.i8))),
					$author$project$UI$attrCyData('modules-item-evaluate'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]);
			var caption = _List_fromArray(
				[
					$author$project$UI$Icon$feedback(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnFeedback)
				]);
			return (hasStudents && hasRubrics) ? A2($elm$html$Html$a, linkAttrs, caption) : ((!hasRubrics) ? A2($elm$html$Html$span, inactiveAttrsNoRubrics, caption) : A2($elm$html$Html$span, inactiveAttrsNoStudents, caption));
		}();
		var _v0 = _Utils_Tuple3(
			module_.l9,
			$author$project$ACL$canCreateModules(viewer),
			A2($author$project$ACL$canManageModule, module_, viewer));
		_v0$5:
		while (true) {
			if (_v0.a) {
				if (_v0.b) {
					if (_v0.c) {
						return _List_fromArray(
							[viewDuplicateLink]);
					} else {
						return _List_fromArray(
							[viewDuplicateLink]);
					}
				} else {
					break _v0$5;
				}
			} else {
				if (_v0.b) {
					if (!_v0.c) {
						return _List_fromArray(
							[viewDuplicateLink]);
					} else {
						return _List_fromArray(
							[
								viewEditLink,
								A2($author$project$UI$when, module_.mf, viewCreateFromTemplateLink),
								viewDuplicateLink,
								viewFinalEvaluationLink,
								viewScheduleLink,
								viewPortfolioStoryLink,
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown-divider')
									]),
								_List_Nil),
								viewDeleteLink
							]);
					}
				} else {
					if (_v0.c) {
						return _List_fromArray(
							[
								viewEditLink,
								viewFinalEvaluationLink,
								viewScheduleLink,
								viewPortfolioStoryLink,
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown-divider')
									]),
								_List_Nil),
								viewDeleteLink
							]);
					} else {
						break _v0$5;
					}
				}
			}
		}
		return _List_Nil;
	});
var $author$project$Element$ModuleSingle$viewModuleHighlights = F2(
	function (t_, module_) {
		return $author$project$UI$mediaObjectHighlights(
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Person$fullName, t_, module_.kI)),
					$elm$html$Html$text(module_.kf.lp),
					A2(
					$author$project$UI$when,
					$elm$core$List$isEmpty(module_.fv),
					A2(
						$elm$html$Html$mark,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesMissingStudents)
							])))
				]));
	});
var $author$project$Element$ModuleSingle$viewModuleTitle = F3(
	function (_v0, isListItem, module_) {
		var t_ = _v0.h6;
		var viewer = _v0.ok;
		var viewLockFlag = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(
					A2($author$project$ACL$canManageModule, module_, viewer) ? t_($author$project$Locale$Messages$ModulesClosedEdit) : t_($author$project$Locale$Messages$ModulesClosed))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$locked(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('is-small')
						]))
				]));
		var viewActiveFlag = $author$project$UI$Icon$icon(
			_List_fromArray(
				[
					$author$project$UI$Icon$face('fa-volume-up'),
					$author$project$UI$Icon$style('is-small')
				]));
		return A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('title is-size-6 mb-2')
				]),
			_List_fromArray(
				[
					A2($author$project$UI$when, module_.l9, viewLockFlag),
					A2($author$project$UI$when, module_.l0, viewActiveFlag),
					$elm$html$Html$text(' '),
					isListItem ? A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href(
							$author$project$Route$ModulesDetail(
								$author$project$Module$moduleIdToInt(module_.i8))),
							$author$project$UI$attrCyData('modules-item-view modules-item-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(module_.kj)
						])) : A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$UI$attrCyData('modules-item-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(module_.kj)
						]))
				]));
	});
var $author$project$Element$ModuleSingle$viewModuleMeta = F4(
	function (session, isListItem, dropdown, module_) {
		var t_ = session.h6;
		var viewer = session.ok;
		var isActiveNav = _Utils_eq(
			dropdown,
			$author$project$Element$ModuleSingle$Open(module_.i8));
		var viewActionLinksDropdown = A4(
			$author$project$UI$actionLinksDropdown,
			t_,
			isActiveNav,
			$author$project$Element$ModuleSingle$NavToggled(module_.i8),
			A3($author$project$Element$ModuleSingle$viewModuleActionLinks, t_, viewer, module_));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-2 panel-block')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$UI$mediaObjectSmall,
					_List_fromArray(
						[
							$author$project$UI$gravatar(module_.kI.O)
						]),
					_List_fromArray(
						[
							A3($author$project$Element$ModuleSingle$viewModuleTitle, session, isListItem, module_),
							A2($author$project$Element$ModuleSingle$viewModuleHighlights, t_, module_)
						]),
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$when,
							A2($author$project$ACL$canManageModule, module_, viewer) || $author$project$ACL$canCreateModules(viewer),
							viewActionLinksDropdown)
						]))
				]));
	});
var $author$project$Locale$Messages$RubricAspect = {$: 401};
var $author$project$Element$RubricsSingle$viewRubricTable = F4(
	function (t_, rubric, subjects, highlight_) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table is-striped is-bordered is-size-7')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricAspect)
										])),
								A2(
									$elm$core$List$map,
									function (l) {
										return A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$UI$withHighlightedText, highlight_, l)
												]));
									},
									rubric.gc.gc)))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (aspect) {
							return A2(
								$elm$html$Html$tr,
								_List_Nil,
								A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$UI$withHighlightedText, highlight_, aspect.kj),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												$elm$html$Html$text(
												$author$project$Util$String$parenthesize(
													A2($author$project$Subject$findSubjectNameOrEmpty, subjects, aspect.nW)))
											])),
									A2(
										$elm$core$List$map,
										function (desc) {
											return A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2($author$project$UI$withHighlightedText, highlight_, desc)
													]));
										},
										A2(
											$elm$core$List$take,
											$elm$core$List$length(rubric.gc.gc),
											aspect.mt))));
						},
						rubric.kU))
				]));
	});
var $author$project$Element$ModuleSingle$viewModulePage = F4(
	function (_v0, module_, allSubjects, allModuleEvents) {
		var dropdown = _v0.e$;
		var session = _v0.gB;
		var t_ = session.h6;
		var viewEvaluation = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('subtitle')
							]),
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFieldEvaluation)
							])),
						A2(
						$author$project$UI$when,
						!$elm$core$String$isEmpty(module_.hc),
						$author$project$Util$Html$markdownToHtml(module_.hc))
					]),
				A2(
					$elm$core$List$map,
					function (rubric) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('block')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('subtitle is-6')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(rubric.kj)
										])),
									A4($author$project$Element$RubricsSingle$viewRubricTable, t_, rubric, allSubjects, '')
								]));
					},
					module_.fq)));
		var viewMaterialsLink = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(module_.jq),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFieldMaterialsUrl)
						]))
				]));
		var viewStudents = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('subtitle')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFieldStudents)
						])),
					$author$project$UI$contentElem(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (student) {
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($author$project$Person$fullName, t_, student))
											]));
								},
								module_.fv))
						]))
				]));
		return $author$project$UI$panel(
			{
				g$: _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$UI$attrCyData('modules-item'),
								$elm$html$Html$Attributes$class('container')
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Element$ModuleSingle$viewModuleMeta,
								session,
								false,
								dropdown,
								$author$project$Module$asListItem(module_)),
								$author$project$Element$ModuleSingle$viewModuleDescription(
								$author$project$Module$asListItem(module_)),
								A2($author$project$Element$ModuleSingle$viewModuleGoals, t_, module_),
								A2(
								$author$project$UI$when,
								(!$elm$core$String$isEmpty(module_.hc)) || (!$elm$core$List$isEmpty(module_.fq)),
								viewEvaluation),
								viewStudents,
								A2($author$project$Element$ModuleSingle$viewModuleEvents, session, allModuleEvents),
								A2(
								$author$project$UI$when,
								!$elm$core$String$isEmpty(module_.jq),
								viewMaterialsLink)
							]))
					]),
				cm: 'modules-detail',
				hl: _List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesTitle)
					]),
				h7: _List_Nil,
				ie: 'is-info'
			});
	});
var $author$project$Element$ModuleSingle$viewPopup = function (model) {
	var _v0 = model.ej;
	if (!_v0.$) {
		var popupModel = _v0.a;
		return A3($author$project$Application$V3$Boundaries$viewElement, model.gB, popupModel, $author$project$Element$ModuleSingle$popups.cB);
	} else {
		return $author$project$UI$none;
	}
};
var $author$project$Element$ModuleSingle$viewPortfolioList = F2(
	function (session, model) {
		return A3($author$project$Application$V3$Boundaries$viewElement, session, model, $author$project$Element$ModuleSingle$portfolioList);
	});
var $author$project$Element$ModuleSingle$view = function (model) {
	var session = model.gB;
	var page = model.bk;
	var t_ = session.h6;
	switch (page.$) {
		case 0:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$UI$progressBar,
						'is-info',
						t_($author$project$Locale$Messages$ModulesLoadingProgress)),
						$author$project$Element$ModuleSingle$viewPopup(model)
					]));
		case 2:
			var error = page.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('notification is-danger')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('title is-5')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												t_($author$project$Locale$Messages$ModulesDownloadError))
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$httpErrorToHumans(error))
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-4')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('#'),
														$author$project$Route$href($author$project$Route$ModulesList)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('← '),
														$elm$html$Html$text(
														t_($author$project$Locale$Messages$NavModules))
													]))
											]))
									]))
							]))
					]));
		default:
			var module_ = page.a;
			var subjects_ = page.b;
			var moduleEvents_ = page.c;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Element$ModuleSingle$viewPopup(model),
						A4($author$project$Element$ModuleSingle$viewModulePage, model, module_, subjects_, moduleEvents_),
						A2(
						$author$project$UI$maybe,
						model.er,
						$author$project$Element$ModuleSingle$viewPortfolioList(session)),
						A2(
						$author$project$UI$maybe,
						model.ep,
						$author$project$Element$ModuleSingle$viewConfirmDialog(t_))
					]));
	}
};
var $author$project$Element$ModuleSingle$element = {jb: $author$project$Element$ModuleSingle$init, hP: $author$project$Element$ModuleSingle$perform, ks: $author$project$Element$ModuleSingle$update, og: $author$project$Element$ModuleSingle$view};
var $author$project$Element$ModuleTeacherProfiles$NotFoundPage = {$: 0};
var $author$project$Element$ModuleTeacherProfiles$LoadingPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleTeacherProfiles$ModuleTeacherProfileDownloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Endpoint$moduleTeacherProfile = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'module-teacher-profiles',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$ModuleTeacherProfile$ModuleTeacherProfile = F6(
	function (id, state, teacher, residence_permit, residence_address, competencies) {
		return {bb: competencies, i8: id, nl: residence_address, nm: residence_permit, fs: state, n2: teacher};
	});
var $author$project$ModuleTeacherProfile$ModuleTeacherProfileId = $elm$core$Basics$identity;
var $author$project$ModuleTeacherProfile$teacherProfileIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$ModuleTeacherProfile$teacherProfileDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'competencies',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'residence_address',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'residence_permit',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'teacher',
				$author$project$Person$nestedPersonDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'state',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$author$project$ModuleTeacherProfile$teacherProfileIdDecoder,
						$elm$json$Json$Decode$succeed($author$project$ModuleTeacherProfile$ModuleTeacherProfile)))))));
var $author$project$ModuleTeacherProfile$fetchTeacherProfile = F3(
	function (config, id, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$moduleTeacherProfile, config, id),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$ModuleTeacherProfile$teacherProfileDecoder));
	});
var $author$project$Element$ModuleTeacherProfiles$openFormPage = F3(
	function (id, session, model) {
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A3($author$project$ModuleTeacherProfile$fetchTeacherProfile, model.b_.gX, id, $author$project$Element$ModuleTeacherProfiles$ModuleTeacherProfileDownloaded),
			A2(
				$author$project$Application$Boundaries$save,
				_Utils_update(
					model,
					{
						bk: $author$project$Element$ModuleTeacherProfiles$LoadingPage(id)
					}),
				session));
	});
var $author$project$Element$ModuleTeacherProfiles$init = F3(
	function (config, session, id) {
		return A3(
			$author$project$Element$ModuleTeacherProfiles$openFormPage,
			id,
			session,
			{b_: config, bk: $author$project$Element$ModuleTeacherProfiles$NotFoundPage});
	});
var $author$project$Element$ModuleTeacherProfiles$FormPage = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $author$project$Locale$Messages$ModuleTeacherProfilesDownloadError = {$: 215};
var $author$project$Locale$Messages$ModuleTeacherProfilesSaveSuccess = {$: 216};
var $author$project$Element$ModuleTeacherProfiles$NoOp = {$: 5};
var $author$project$Element$ModuleTeacherProfiles$ProfileSaved = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleTeacherProfiles$Competencies = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModuleTeacherProfiles$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleTeacherProfiles$ResidenceAddress = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleTeacherProfiles$ResidencePermit = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleTeacherProfiles$buildForm = function (t_) {
	return {
		bb: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{bb: value});
				}),
			fC: function ($) {
				return $.bb;
			},
			og: {
				cm: 'competencies',
				e6: 'fa-keyboard',
				ea: t_($author$project$Locale$Messages$ModuleTeacherProfilesCompetencies),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$ModuleTeacherProfiles$FormMsg, $author$project$Element$ModuleTeacherProfiles$Competencies),
				fj: t_($author$project$Locale$Messages$ModuleTeacherProfilesCompetencies),
				ii: 'text'
			}
		},
		by: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{by: value});
				}),
			fC: function ($) {
				return $.by;
			},
			og: {
				cm: 'residence_address',
				e6: 'fa-keyboard',
				ea: t_($author$project$Locale$Messages$ModuleTeacherProfilesResidenceAddress),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$ModuleTeacherProfiles$FormMsg, $author$project$Element$ModuleTeacherProfiles$ResidenceAddress),
				fj: t_($author$project$Locale$Messages$ModuleTeacherProfilesResidenceAddress),
				ii: 'text'
			}
		},
		bz: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{bz: value});
				}),
			fC: function ($) {
				return $.bz;
			},
			og: {
				cm: 'residence_permit',
				e6: 'fa-keyboard',
				ea: t_($author$project$Locale$Messages$ModuleTeacherProfilesResidencePermit),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$ModuleTeacherProfiles$FormMsg, $author$project$Element$ModuleTeacherProfiles$ResidencePermit),
				fj: t_($author$project$Locale$Messages$ModuleTeacherProfilesResidencePermit),
				ii: 'text'
			}
		}
	};
};
var $author$project$Element$ModuleTeacherProfiles$fillForm = function (moduleTeacherProfile) {
	return {bb: moduleTeacherProfile.bb, by: moduleTeacherProfile.nl, bz: moduleTeacherProfile.nm};
};
var $author$project$Log$msgModuleTeacherProfileDownload = 'module_teacher_profile_download';
var $author$project$Log$msgModuleTeacherProfileSave = 'module_teacher_profile_save';
var $author$project$ModuleTeacherProfile$ModuleTeacherProfileUnsaved = F6(
	function (id, state, teacher, residence_permit, residence_address, competencies) {
		return {bb: competencies, i8: id, nl: residence_address, nm: residence_permit, fs: state, n2: teacher};
	});
var $author$project$Element$ModuleTeacherProfiles$saveForm = F3(
	function (form, values, moduleTeacherProfile) {
		return A6(
			$author$project$ModuleTeacherProfile$ModuleTeacherProfileUnsaved,
			moduleTeacherProfile.i8,
			moduleTeacherProfile.fs,
			moduleTeacherProfile.n2.i8,
			form.bz.fC(values),
			form.by.fC(values),
			form.bb.fC(values));
	});
var $author$project$Element$ModuleTeacherProfiles$updateForm = F3(
	function (msg, form, formValues) {
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							bz: $author$project$Form$markEdited(form.bz)
						}),
					A2(form.bz.ks, value, formValues));
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							by: $author$project$Form$markEdited(form.by)
						}),
					A2(form.by.ks, value, formValues));
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							bb: $author$project$Form$markEdited(form.bb)
						}),
					A2(form.bb.ks, value, formValues));
		}
	});
var $author$project$ModuleTeacherProfile$teacherProfileIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$ModuleTeacherProfile$teacherProfileEncoder = function (teacherProfile) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(
					$author$project$ModuleTeacherProfile$teacherProfileIdToInt(teacherProfile.i8))),
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(teacherProfile.fs)),
				_Utils_Tuple2(
				'teacher',
				$elm$json$Json$Encode$int(teacherProfile.n2)),
				_Utils_Tuple2(
				'residence_permit',
				$elm$json$Json$Encode$string(teacherProfile.nm)),
				_Utils_Tuple2(
				'residence_address',
				$elm$json$Json$Encode$string(teacherProfile.nl)),
				_Utils_Tuple2(
				'competencies',
				$elm$json$Json$Encode$string(teacherProfile.bb))
			]));
};
var $author$project$ModuleTeacherProfile$updateTeacherProfile = F3(
	function (config, profile, callback) {
		return A5(
			$author$project$Api$put,
			A2($author$project$Api$Endpoint$moduleTeacherProfile, config, profile.n2),
			config,
			$elm$http$Http$jsonBody(
				$author$project$ModuleTeacherProfile$teacherProfileEncoder(profile)),
			callback,
			$author$project$ModuleTeacherProfile$teacherProfileDecoder);
	});
var $author$project$Element$ModuleTeacherProfiles$update = F3(
	function (session, msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.bk);
		_v0$8:
		while (true) {
			switch (_v0.a.$) {
				case 2:
					var id = _v0.a.a;
					return A3($author$project$Element$ModuleTeacherProfiles$openFormPage, id, session, model);
				case 4:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 1) {
							var profile = _v0.a.a.a;
							var teacherId = _v0.b.a;
							var blankForm = $author$project$Element$ModuleTeacherProfiles$buildForm(session.h6);
							return _Utils_eq(profile.n2.i8, teacherId) ? A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bk: A4(
											$author$project$Element$ModuleTeacherProfiles$FormPage,
											0,
											blankForm,
											$author$project$Element$ModuleTeacherProfiles$fillForm(profile),
											profile)
									}),
								session) : A2($author$project$Application$Boundaries$save, model, session);
						} else {
							break _v0$8;
						}
					} else {
						var error = _v0.a.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								model.b_,
								_Utils_Tuple3($author$project$Log$msgModuleTeacherProfileDownload, $elm$core$Maybe$Nothing, error),
								$elm$core$Basics$always($author$project$Element$ModuleTeacherProfiles$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$ModuleTeacherProfilesDownloadError))));
					}
				case 0:
					if (_v0.b.$ === 2) {
						var fieldMsg = _v0.a.a;
						var _v1 = _v0.b;
						var form = _v1.b;
						var values = _v1.c;
						var profile = _v1.d;
						var _v2 = A3($author$project$Element$ModuleTeacherProfiles$updateForm, fieldMsg, form, values);
						var form2 = _v2.a;
						var values2 = _v2.b;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									bk: A4($author$project$Element$ModuleTeacherProfiles$FormPage, 1, form2, values2, profile)
								}),
							session);
					} else {
						break _v0$8;
					}
				case 1:
					if (_v0.b.$ === 2) {
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						var form = _v4.b;
						var values = _v4.c;
						var profile = _v4.d;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$ModuleTeacherProfile$updateTeacherProfile,
								model.b_.gX,
								A3($author$project$Element$ModuleTeacherProfiles$saveForm, form, values, profile),
								$author$project$Element$ModuleTeacherProfiles$ProfileSaved),
							A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bk: A4($author$project$Element$ModuleTeacherProfiles$FormPage, 2, form, values, profile)
									}),
								session));
					} else {
						break _v0$8;
					}
				case 3:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 2) {
							var newProfile = _v0.a.a.a;
							var _v5 = _v0.b;
							var form = _v5.b;
							var values = _v5.c;
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bk: A4($author$project$Element$ModuleTeacherProfiles$FormPage, 0, form, values, newProfile)
									}),
								A2(
									$author$project$Session$ok,
									session,
									session.h6($author$project$Locale$Messages$ModuleTeacherProfilesSaveSuccess)));
						} else {
							break _v0$8;
						}
					} else {
						if (_v0.b.$ === 2) {
							var error = _v0.a.a.a;
							var _v6 = _v0.b;
							var form = _v6.b;
							var values = _v6.c;
							var profile = _v6.d;
							var session2 = A3(
								$author$project$Session$error,
								session,
								error,
								session.h6($author$project$Locale$Messages$FormSaveError));
							var model2 = _Utils_update(
								model,
								{
									bk: A4($author$project$Element$ModuleTeacherProfiles$FormPage, 3, form, values, profile)
								});
							var cmd = A3(
								$author$project$Log$error,
								model.b_,
								_Utils_Tuple3($author$project$Log$msgModuleTeacherProfileSave, $elm$core$Maybe$Nothing, error),
								$elm$core$Basics$always($author$project$Element$ModuleTeacherProfiles$NoOp));
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								cmd,
								A2($author$project$Application$Boundaries$save, model2, session2));
						} else {
							break _v0$8;
						}
					}
				default:
					var _v7 = _v0.a;
					return A2($author$project$Application$Boundaries$save, model, session);
			}
		}
		return A2($author$project$Application$Boundaries$save, model, session);
	});
var $author$project$Locale$Messages$ModuleTeacherProfilesLoadingProgress = {$: 218};
var $author$project$Locale$Messages$ModuleTeacherProfilesNotFound = {$: 219};
var $author$project$Element$ModuleTeacherProfiles$FormReset = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModuleTeacherProfiles$FormSubmitted = {$: 1};
var $author$project$Locale$Messages$TeacherProfilesTitle = function (a) {
	return {$: 597, a: a};
};
var $author$project$Element$ModuleTeacherProfiles$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.bz, values) && (A2($author$project$Form$isFieldValid, form.by, values) && A2($author$project$Form$isFieldValid, form.bb, values));
	});
var $author$project$Element$ModuleTeacherProfiles$viewForm = F5(
	function (t_, formState, form, formValues, profile) {
		return $author$project$UI$panel(
			{
				g$: _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$UI$columns(
								_List_fromArray(
									[
										A3($author$project$UI$textField, t_, form.bz, formValues)
									])),
								$author$project$UI$columns(
								_List_fromArray(
									[
										A3($author$project$UI$textField, t_, form.by, formValues)
									])),
								$author$project$UI$columns(
								_List_fromArray(
									[
										A3($author$project$UI$textField, t_, form.bb, formValues)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('field is-grouped')
							]),
						_List_fromArray(
							[
								A4(
								$author$project$UI$submitButton,
								t_($author$project$Locale$Messages$BtnSave),
								A2(
									$author$project$Form$submissionDisabled,
									formState,
									A2($author$project$Element$ModuleTeacherProfiles$isFormValid, form, formValues)),
								$author$project$Form$isProcessing(formState),
								$author$project$Element$ModuleTeacherProfiles$FormSubmitted),
								A4(
								$author$project$UI$resetButton,
								t_($author$project$Locale$Messages$BtnReset),
								$author$project$Form$resetDisabled(formState),
								$author$project$Form$isProcessing(formState),
								$author$project$Element$ModuleTeacherProfiles$FormReset(profile.n2.i8))
							]))
					]),
				cm: 'teacher-profile-form',
				hl: _List_fromArray(
					[
						A2(
						$author$project$UI$caption,
						t_,
						$author$project$Locale$Messages$TeacherProfilesTitle(
							A2($author$project$Person$fullName, t_, profile.n2)))
					]),
				h7: _List_Nil,
				ie: 'is-light'
			});
	});
var $author$project$Element$ModuleTeacherProfiles$view = F2(
	function (_v0, model) {
		var t_ = _v0.h6;
		var _v1 = model.bk;
		switch (_v1.$) {
			case 2:
				var formState = _v1.a;
				var form = _v1.b;
				var values = _v1.c;
				var profile = _v1.d;
				return A5($author$project$Element$ModuleTeacherProfiles$viewForm, t_, formState, form, values, profile);
			case 1:
				return A2(
					$author$project$UI$progressBar,
					'is-primary',
					t_($author$project$Locale$Messages$ModuleTeacherProfilesLoadingProgress));
			default:
				return $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModuleTeacherProfilesNotFound)
						]));
		}
	});
var $author$project$Element$ModuleTeacherProfiles$element = {jb: $author$project$Element$ModuleTeacherProfiles$init, ks: $author$project$Element$ModuleTeacherProfiles$update, og: $author$project$Element$ModuleTeacherProfiles$view};
var $author$project$Element$ModulesMain$Closed = {$: 1};
var $author$project$Element$ModulesMain$NotFoundPage = {$: 0};
var $author$project$Element$ModulesMain$LoadingPage = {$: 1};
var $author$project$Element$ModulesMain$ModuleDetailDownloadedForDuplicate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModulesMain$ModuleDetailDownloadedForEdit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModulesMain$ModuleDetailDownloadedForTemplate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModulesMain$NoOp = {$: 20};
var $author$project$Element$ModulesMain$Create = {$: 0};
var $author$project$Element$ModulesMain$FormPage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModulesMain$ClassroomCourseListDownloaded = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$ModulesMain$PeopleDownloaded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$ModulesMain$SchoolListDownloaded = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$ModulesMain$StudentListDownloaded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Endpoint$teachers = function (config) {
	return A2($author$project$Api$Endpoint$peopleByRoles, config, 'teachers,module_teachers');
};
var $author$project$Person$fetchTeachers = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$teachers(config),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$Person$phoneBookDecoder));
	});
var $author$project$Application$Boundaries$mapModel = F2(
	function (f, prev) {
		return _Utils_update(
			prev,
			{
				eh: f(prev.eh)
			});
	});
var $author$project$Element$ModulesMain$andFetchFormDependencies = function (_return) {
	var model = _return.eh;
	return A2(
		$author$project$Application$Boundaries$andThenCmd,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Team$fetchSchools, model.b_.gX, $author$project$Element$ModulesMain$SchoolListDownloaded),
					A2($author$project$Person$fetchTeachers, model.b_.gX, $author$project$Element$ModulesMain$PeopleDownloaded),
					A2($author$project$Person$fetchStudents, model.b_.gX, $author$project$Element$ModulesMain$StudentListDownloaded),
					$author$project$Api$getV2(
					A2($author$project$ClassroomCourse$fetchUserClassrooms, model.b_.gX, $author$project$Element$ModulesMain$ClassroomCourseListDownloaded))
				])),
		A2(
			$author$project$Application$Boundaries$mapModel,
			function (model_) {
				return _Utils_update(
					model_,
					{j2: $author$project$RemoteData$Loading, fv: $author$project$RemoteData$Loading});
			},
			_return));
};
var $author$project$Element$ModulesMain$AccountableTeacher = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$ModulesMain$ClassroomCourses = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$ModulesMain$Description = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModulesMain$EndDate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$ModulesMain$GoalsKnowledge = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModulesMain$GoalsProduct = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$ModulesMain$GoalsSkills = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$ModulesMain$IsMigratable = function (a) {
	return {$: 13, a: a};
};
var $author$project$Element$ModulesMain$MaterialsUrl = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$ModulesFieldAccountableTeacher = {$: 235};
var $author$project$Locale$Messages$ModulesFieldClassroomCourse = {$: 236};
var $author$project$Locale$Messages$ModulesFieldDescription = {$: 237};
var $author$project$Locale$Messages$ModulesFieldDescriptionPlaceholder = {$: 238};
var $author$project$Locale$Messages$ModulesFieldEndDate = {$: 256};
var $author$project$Locale$Messages$ModulesFieldGoalsKnowledge = {$: 245};
var $author$project$Locale$Messages$ModulesFieldGoalsKnowledgePlaceholder = {$: 246};
var $author$project$Locale$Messages$ModulesFieldGoalsProduct = {$: 249};
var $author$project$Locale$Messages$ModulesFieldGoalsProductPlaceholder = {$: 250};
var $author$project$Locale$Messages$ModulesFieldGoalsSkills = {$: 247};
var $author$project$Locale$Messages$ModulesFieldGoalsSkillsPlaceholder = {$: 248};
var $author$project$Locale$Messages$ModulesFieldIsMigratable = {$: 240};
var $author$project$Locale$Messages$ModulesFieldSchool = {$: 253};
var $author$project$Locale$Messages$ModulesFieldStartDate = {$: 255};
var $author$project$Locale$Messages$ModulesFieldTeachers = {$: 252};
var $author$project$Locale$Messages$ModulesFieldTitle = {$: 254};
var $author$project$Element$ModulesMain$School = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$ModulesMain$StartDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$ModulesMain$Teachers = function (a) {
	return {$: 11, a: a};
};
var $author$project$Element$ModulesMain$Title = function (a) {
	return {$: 0, a: a};
};
var $author$project$Form$optionalPeople = F2(
	function (_v0, value) {
		return $elm$core$Result$Ok(
			A2($elm$core$List$filterMap, $elm$core$String$toInt, value));
	});
var $author$project$Form$optionalUrl = F2(
	function (t_, value) {
		return (value === '') ? $elm$core$Result$Ok(value) : (A2($elm$regex$Regex$contains, $author$project$Form$validUrlFormat, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormInvalidUrl)));
	});
var $author$project$Element$ModulesMain$buildForm = F2(
	function (t_, studentOptions) {
		var toMsg_ = A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$Students);
		var initStudentsField = function () {
			var defaultConfig = $author$project$Multiselect$defaultConfig;
			return $author$project$Multiselect$initModel(
				_Utils_update(
					defaultConfig,
					{ma: true, n0: 'Students'}));
		}();
		var studentsField = {
			e0: false,
			fi: $author$project$Form$optionalPeople(t_),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{fv: value});
				}),
			fC: function ($) {
				return $.fv;
			},
			og: {
				cm: 'students',
				e6: 'fa-users',
				ea: t_($author$project$Locale$Messages$ModulesFieldStudents),
				m_: $elm$core$Maybe$Nothing,
				fs: initStudentsField,
				cf: toMsg_
			}
		};
		return {
			kI: {
				e0: false,
				fi: $author$project$Form$requiredPersonSelected(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{kI: value});
					}),
				fC: function ($) {
					return $.kI;
				},
				og: {
					cm: 'accountable_teacher',
					e6: 'fa-user',
					ea: t_($author$project$Locale$Messages$ModulesFieldAccountableTeacher),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$AccountableTeacher),
					m_: $elm$core$Maybe$Nothing
				}
			},
			Y: {
				e0: false,
				fi: A2(
					$elm$core$Basics$composeL,
					$elm$core$Result$Ok,
					$elm$core$List$filterMap($elm$core$String$toInt)),
				fp: false,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{Y: value});
					}),
				fC: function ($) {
					return $.Y;
				},
				og: {
					cm: 'classroom',
					lo: $elm$core$Maybe$Nothing,
					e6: 'fa-chalkboard-teacher',
					ea: t_($author$project$Locale$Messages$ModulesFieldClassroomCourse),
					mU: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$ClassroomCourses),
					m_: $elm$core$Maybe$Nothing
				}
			},
			g8: {
				e0: false,
				fi: $author$project$Form$requiredText(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{g8: value});
					}),
				fC: function ($) {
					return $.g8;
				},
				og: {
					cm: 'description',
					ea: t_($author$project$Locale$Messages$ModulesFieldDescription),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$Description),
					fj: t_($author$project$Locale$Messages$ModulesFieldDescriptionPlaceholder)
				}
			},
			ly: {
				e0: false,
				fi: $author$project$Form$requiredDate(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{ly: value});
					}),
				fC: function ($) {
					return $.ly;
				},
				og: {
					cm: 'end_date',
					ea: t_($author$project$Locale$Messages$ModulesFieldEndDate),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$EndDate)
				}
			},
			lO: {
				e0: false,
				fi: $author$project$Form$requiredText(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{lO: value});
					}),
				fC: function ($) {
					return $.lO;
				},
				og: {
					cm: 'goals_knowledge',
					ea: t_($author$project$Locale$Messages$ModulesFieldGoalsKnowledge),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$GoalsKnowledge),
					fj: t_($author$project$Locale$Messages$ModulesFieldGoalsKnowledgePlaceholder)
				}
			},
			lP: {
				e0: false,
				fi: $author$project$Form$requiredText(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{lP: value});
					}),
				fC: function ($) {
					return $.lP;
				},
				og: {
					cm: 'goals_product',
					ea: t_($author$project$Locale$Messages$ModulesFieldGoalsProduct),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$GoalsProduct),
					fj: t_($author$project$Locale$Messages$ModulesFieldGoalsProductPlaceholder)
				}
			},
			lQ: {
				e0: false,
				fi: $author$project$Form$requiredText(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{lQ: value});
					}),
				fC: function ($) {
					return $.lQ;
				},
				og: {
					cm: 'goals_skills',
					ea: t_($author$project$Locale$Messages$ModulesFieldGoalsSkills),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$GoalsSkills),
					fj: t_($author$project$Locale$Messages$ModulesFieldGoalsSkillsPlaceholder)
				}
			},
			at: {
				e0: false,
				fi: $elm$core$Result$Ok,
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{at: value});
					}),
				fC: function ($) {
					return $.at;
				},
				og: {
					cm: 'is_migratable',
					e6: 'fa-list',
					ea: t_($author$project$Locale$Messages$ModulesFieldIsMigratable),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$IsMigratable)
				}
			},
			jq: {
				e0: false,
				fi: $author$project$Form$optionalUrl(t_),
				fp: false,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{jq: value});
					}),
				fC: function ($) {
					return $.jq;
				},
				og: {
					cm: 'url',
					e6: 'fa-link',
					ea: t_($author$project$Locale$Messages$ModulesFieldMaterialsUrl),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$MaterialsUrl),
					fj: 'https://',
					ii: 'text'
				}
			},
			Q: {
				e0: false,
				fi: $author$project$Form$requiredTeamSelected(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{Q: value});
					}),
				fC: function ($) {
					return $.Q;
				},
				og: {
					cm: 'school',
					e6: 'fa-school',
					ea: t_($author$project$Locale$Messages$ModulesFieldSchool),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$School),
					m_: $elm$core$Maybe$Nothing
				}
			},
			nN: {
				e0: false,
				fi: $author$project$Form$requiredDate(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{nN: value});
					}),
				fC: function ($) {
					return $.nN;
				},
				og: {
					cm: 'start_date',
					ea: t_($author$project$Locale$Messages$ModulesFieldStartDate),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$StartDate)
				}
			},
			fv: A2($author$project$Form$setMultiselectSelection, studentOptions, studentsField),
			fx: {
				e0: false,
				fi: $author$project$Form$optionalPeople(t_),
				fp: false,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{fx: value});
					}),
				fC: function ($) {
					return $.fx;
				},
				og: {
					cm: 'teachers',
					lo: $elm$core$Maybe$Nothing,
					e6: 'fa-users',
					ea: t_($author$project$Locale$Messages$ModulesFieldTeachers),
					mU: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$Teachers),
					m_: $elm$core$Maybe$Nothing
				}
			},
			kj: {
				e0: false,
				fi: $author$project$Form$requiredText(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{kj: value});
					}),
				fC: function ($) {
					return $.kj;
				},
				og: {
					cm: 'title',
					e6: 'fa-keyboard',
					ea: t_($author$project$Locale$Messages$ModulesFieldTitle),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$Title),
					fj: '',
					ii: 'text'
				}
			}
		};
	});
var $author$project$Element$ModulesMain$emptyForm = {kI: '', Y: _List_Nil, g8: '', ly: '', lO: '', lP: '', lQ: '', at: false, jq: '', Q: '', nN: '', fv: _List_Nil, fx: _List_Nil, kj: ''};
var $author$project$Log$msgModuleCreate = 'module_create';
var $author$project$Element$ModulesMain$buildFormPage = F2(
	function (session, model) {
		var t_ = session.h6;
		var page = $author$project$Element$ModulesMain$FormPage(
			{
				iq: $author$project$Element$ModulesMain$Create,
				bH: false,
				bE: A2($author$project$Element$ModulesMain$buildForm, t_, _List_Nil),
				cs: false,
				hC: false,
				gf: false,
				fd: $elm$core$Maybe$Nothing,
				cO: _List_Nil,
				fs: 0,
				dM: {c3: true},
				eI: $author$project$Element$ModulesMain$emptyForm
			});
		return $author$project$Element$ModulesMain$andFetchFormDependencies(
			A2(
				$author$project$Application$Boundaries$andThenCmd,
				A3(
					$author$project$Log$ok,
					model.b_,
					_Utils_Tuple2(
						$author$project$Log$msgModuleCreate,
						_List_fromArray(
							[$author$project$Log$paramScopeModules, $author$project$Log$paramOk])),
					$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
				A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{bk: page}),
					session)));
	});
var $author$project$Element$ModulesMain$ModuleListDownloaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModulesMain$SubjectListDownloaded = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$ModulesMain$listFilterToCategory = function (_v0) {
	var category = _v0.bD;
	switch (category) {
		case 0:
			return $author$project$Api$Endpoint$categoryAll;
		case 1:
			return $author$project$Api$Endpoint$categorySchools;
		case 2:
			return $author$project$Api$Endpoint$categoryCreator;
		default:
			return 'templates';
	}
};
var $author$project$Element$ModulesMain$asListParams = function (listPage) {
	var filter = listPage.ad;
	var defaults = $author$project$Module$defaultListParams;
	return _Utils_update(
		defaults,
		{
			bD: $author$project$Element$ModulesMain$listFilterToCategory(filter),
			i4: A2($author$project$Data$toMaybe, $elm$core$List$isEmpty, filter.i4),
			b0: function () {
				var _v0 = listPage.dj;
				if (_v0.$ === 1) {
					var module_ = _v0.a;
					return $elm$core$Maybe$Just(
						$author$project$Module$moduleIdToInt(module_.i8));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}(),
			bF: listPage.bF,
			j2: A2(
				$author$project$Data$toMaybe,
				$elm$core$List$isEmpty,
				A2($elm$core$List$map, $author$project$Team$teamIdToInt, filter.j2)),
			kb: A2($author$project$Data$toMaybe, $elm$core$List$isEmpty, filter.kb),
			fx: A2($author$project$Data$toMaybe, $elm$core$List$isEmpty, filter.fx),
			kr: false
		});
};
var $author$project$Element$ModulesMain$LoadingModules = {$: 0};
var $author$project$Element$ModulesMain$FilterAll = 0;
var $author$project$Element$ModulesMain$FilterCreator = 2;
var $author$project$Element$ModulesMain$emptyFilter = {bD: 0, i4: _List_Nil, j2: _List_Nil, kb: _List_Nil, fx: _List_Nil};
var $author$project$Element$ModulesMain$defaultFilter = function (viewer) {
	return _Utils_update(
		$author$project$Element$ModulesMain$emptyFilter,
		{
			bD: $author$project$ACL$canCreateModules(viewer) ? 2 : 0
		});
};
var $author$project$Element$ModulesMain$emptyList = function (viewer) {
	return {
		ad: $author$project$Element$ModulesMain$defaultFilter(viewer),
		e1: false,
		dj: $author$project$Element$ModulesMain$LoadingModules,
		hH: _List_Nil,
		bF: ''
	};
};
var $author$project$Module$fetchModules_ = F3(
	function (config, params, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$modules, config, params),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$Module$modulesDecoder));
	});
var $author$project$Element$ModulesMain$openListPage = F2(
	function (session, model) {
		var viewer = session.ok;
		var config = model.b_;
		var emptyList_ = $author$project$Element$ModulesMain$emptyList(viewer);
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3(
					$author$project$Module$fetchModules_,
					config.gX,
					$author$project$Element$ModulesMain$asListParams(emptyList_),
					$author$project$Element$ModulesMain$ModuleListDownloaded),
					A2($author$project$Team$fetchSchools, config.gX, $author$project$Element$ModulesMain$SchoolListDownloaded),
					A2($author$project$Person$fetchTeachers, config.gX, $author$project$Element$ModulesMain$PeopleDownloaded),
					A2($author$project$Subject$fetchSubjects, config.gX, $author$project$Element$ModulesMain$SubjectListDownloaded),
					$author$project$ACL$canViewClassrooms(viewer) ? $author$project$Api$getV2(
					A2($author$project$ClassroomCourse$fetchUserClassrooms, config.gX, $author$project$Element$ModulesMain$ClassroomCourseListDownloaded)) : $elm$core$Platform$Cmd$none
				]));
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A2(
				$author$project$Application$Boundaries$save,
				_Utils_update(
					model,
					{bk: $author$project$Element$ModulesMain$LoadingPage}),
				session));
	});
var $author$project$Log$paramModulesDuplicate = 'duplicate';
var $author$project$Log$paramModulesTemplate = 'template';
var $author$project$Element$ModulesMain$initPageByParam = F3(
	function (params, session, model) {
		var config = model.b_;
		switch (params.$) {
			case 0:
				return A2($author$project$Element$ModulesMain$buildFormPage, session, model);
			case 1:
				var moduleId = params.a;
				var cmd = $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A3(
							$author$project$Module$fetchOneModule,
							config.gX,
							$author$project$Module$moduleIdToInt(moduleId),
							$author$project$Element$ModulesMain$ModuleDetailDownloadedForTemplate),
							A3(
							$author$project$Log$ok,
							config,
							_Utils_Tuple2(
								$author$project$Log$msgModuleCreate,
								_List_fromArray(
									[$author$project$Log$paramScopeModules, $author$project$Log$paramModulesTemplate])),
							$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp))
						]));
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					cmd,
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{bk: $author$project$Element$ModulesMain$LoadingPage}),
						session));
			case 2:
				return A2($author$project$Element$ModulesMain$openListPage, session, model);
			case 3:
				var moduleId = params.a;
				var cmd = $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A3(
							$author$project$Module$fetchOneModule,
							config.gX,
							$author$project$Module$moduleIdToInt(moduleId),
							$author$project$Element$ModulesMain$ModuleDetailDownloadedForDuplicate),
							A3(
							$author$project$Log$ok,
							config,
							_Utils_Tuple2(
								$author$project$Log$msgModuleCreate,
								_List_fromArray(
									[$author$project$Log$paramScopeModules, $author$project$Log$paramModulesDuplicate])),
							$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp))
						]));
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					cmd,
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{bk: $author$project$Element$ModulesMain$LoadingPage}),
						session));
			default:
				var moduleId = params.a;
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A3(
						$author$project$Module$fetchOneModule,
						config.gX,
						$author$project$Module$moduleIdToInt(moduleId),
						$author$project$Element$ModulesMain$ModuleDetailDownloadedForEdit),
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{bk: $author$project$Element$ModulesMain$LoadingPage}),
						session));
		}
	});
var $author$project$Element$ModulesMain$init = F3(
	function (config, session, params) {
		var model = {g2: _List_Nil, b_: config, e$: $author$project$Element$ModulesMain$Closed, bk: $author$project$Element$ModulesMain$NotFoundPage, ep: $elm$core$Maybe$Nothing, eq: $elm$core$Maybe$Nothing, j2: $author$project$RemoteData$NotAsked, fv: $author$project$RemoteData$NotAsked, kb: $author$project$RemoteData$NotAsked, fx: $author$project$RemoteData$NotAsked};
		return A3($author$project$Element$ModulesMain$initPageByParam, params, session, model);
	});
var $author$project$Element$ModulesMain$CreateFromDuplicate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModulesMain$CreateFromTemplate = {$: 1};
var $author$project$Element$ModulesMain$DelayedGotListQuery = function (a) {
	return {$: 29, a: a};
};
var $author$project$Element$ModulesMain$ListPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModulesMain$ModuleDeleted = function (a) {
	return {$: 14, a: a};
};
var $author$project$Element$ModulesMain$ModuleSaved = function (a) {
	return {$: 10, a: a};
};
var $author$project$Locale$Messages$ModulesCopyTitle = function (a) {
	return {$: 229, a: a};
};
var $author$project$Locale$Messages$ModulesSaveSuccess = {$: 277};
var $author$project$Element$ModulesMain$Open = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModulesMain$TimeIsNow = function (a) {
	return {$: 21, a: a};
};
var $author$project$Element$ModulesMain$Update = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModulesMain$ModulesLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModulesMain$NoMoreModules = {$: 2};
var $author$project$Element$ModulesMain$addNewModules = F2(
	function (newModules, listPage) {
		var loading = listPage.dj;
		var modules = listPage.hH;
		var _v0 = _Utils_Tuple3(
			loading,
			modules,
			$elm$core$List$reverse(newModules));
		switch (_v0.a.$) {
			case 0:
				if (!_v0.c.b) {
					if (!_v0.b.b) {
						var _v1 = _v0.a;
						return _Utils_update(
							listPage,
							{dj: $author$project$Element$ModulesMain$NoMoreModules, hH: newModules});
					} else {
						var _v4 = _v0.a;
						return _Utils_update(
							listPage,
							{dj: $author$project$Element$ModulesMain$NoMoreModules});
					}
				} else {
					if (!_v0.b.b) {
						var _v2 = _v0.a;
						var _v3 = _v0.c;
						var lastStory = _v3.a;
						return _Utils_update(
							listPage,
							{
								dj: $author$project$Element$ModulesMain$ModulesLoaded(lastStory),
								hH: newModules
							});
					} else {
						var _v5 = _v0.a;
						var _v6 = _v0.c;
						var lastStory = _v6.a;
						return _Utils_update(
							listPage,
							{
								dj: $author$project$Element$ModulesMain$ModulesLoaded(lastStory),
								hH: _Utils_ap(modules, newModules)
							});
					}
				}
			case 1:
				return listPage;
			default:
				var _v7 = _v0.a;
				return listPage;
		}
	});
var $author$project$Element$ModulesMain$ModuleEventListDownloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$ModuleEvent$fetchModuleEvents = F3(
	function (config, params, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$moduleEvents, config, params),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$ModuleEvent$moduleEventDetailedListDecoder));
	});
var $author$project$Element$ModulesMain$andFetchFormDependenciesWithModuleEvents = F2(
	function (moduleId, _return) {
		var model = _return.eh;
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A3(
				$author$project$ModuleEvent$fetchModuleEvents,
				model.b_.gX,
				{
					js: $elm$core$Maybe$Just(
						$author$project$Module$moduleIdToInt(moduleId))
				},
				$author$project$Element$ModulesMain$ModuleEventListDownloaded),
			$author$project$Element$ModulesMain$andFetchFormDependencies(_return));
	});
var $author$project$Module$isMigrationReady = function (module_) {
	return !_Utils_eq(module_.jr, $elm$core$Maybe$Nothing);
};
var $author$project$Element$ModulesMain$fillForm = function (module_) {
	return {
		kI: $elm$core$String$fromInt(module_.kI.i8),
		Y: A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.i8;
				},
				$elm$core$String$fromInt),
			module_.Y),
		g8: module_.g8,
		ly: $author$project$Form$dateFromMillis(module_.ly),
		lO: module_.lO,
		lP: module_.lP,
		lQ: module_.lQ,
		at: $author$project$Module$isMigrationReady(module_),
		jq: module_.jq,
		Q: $author$project$Team$encodeTeamId(module_.kf.i8),
		nN: $author$project$Form$dateFromMillis(module_.nN),
		fv: A2(
			$elm$core$List$map,
			function (student) {
				return $elm$core$String$fromInt(student.i8);
			},
			module_.fv),
		fx: A2(
			$elm$core$List$map,
			function (teacher) {
				return $elm$core$String$fromInt(teacher.i8);
			},
			module_.fx),
		kj: module_.kj
	};
};
var $author$project$Element$ModulesMain$namedPersonsToFormSelectOptions = F2(
	function (t_, students) {
		return A2($author$project$Form$toPeopleOptions, t_, students);
	});
var $author$project$Element$ModulesMain$buildFormPageFromModule = F4(
	function (session, model, action, module_) {
		var t_ = session.h6;
		var values = $author$project$Element$ModulesMain$fillForm(module_);
		var values2 = function () {
			switch (action.$) {
				case 1:
					return _Utils_update(
						values,
						{at: false});
				case 2:
					return _Utils_update(
						values,
						{at: false});
				default:
					return values;
			}
		}();
		var selectedStudents = A2($author$project$Element$ModulesMain$namedPersonsToFormSelectOptions, t_, module_.fv);
		var page = $author$project$Element$ModulesMain$FormPage(
			{
				iq: action,
				bH: module_.mf,
				bE: A2($author$project$Element$ModulesMain$buildForm, t_, selectedStudents),
				cs: false,
				hC: false,
				gf: false,
				fd: $elm$core$Maybe$Nothing,
				cO: module_.fq,
				fs: 0,
				dM: {c3: true},
				eI: values2
			});
		return A2(
			$author$project$Element$ModulesMain$andFetchFormDependenciesWithModuleEvents,
			module_.i8,
			A2(
				$author$project$Application$Boundaries$save,
				_Utils_update(
					model,
					{bk: page}),
				session));
	});
var $author$project$Module$moduleEncoder = function (module_) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(
					$author$project$Module$moduleIdToInt(module_.i8))),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(module_.kj)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(module_.g8)),
				_Utils_Tuple2(
				'goals_knowledge',
				$elm$json$Json$Encode$string(module_.lO)),
				_Utils_Tuple2(
				'goals_skills',
				$elm$json$Json$Encode$string(module_.lQ)),
				_Utils_Tuple2(
				'goals_product',
				$elm$json$Json$Encode$string(module_.lP)),
				_Utils_Tuple2(
				'evaluation',
				$elm$json$Json$Encode$string(module_.hc)),
				_Utils_Tuple2(
				'materials_url',
				$elm$json$Json$Encode$string(module_.jq)),
				_Utils_Tuple2(
				'start_date',
				$elm$json$Json$Encode$int(module_.nN)),
				_Utils_Tuple2(
				'end_date',
				$elm$json$Json$Encode$int(module_.ly)),
				_Utils_Tuple2(
				'is_template',
				$elm$json$Json$Encode$bool(module_.mf)),
				_Utils_Tuple2(
				'team',
				$elm$json$Json$Encode$int(
					$author$project$Team$teamIdToInt(module_.kf))),
				_Utils_Tuple2(
				'classroom_courses',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, module_.Y)),
				_Utils_Tuple2(
				'accountable_teacher',
				$elm$json$Json$Encode$int(module_.kI)),
				_Utils_Tuple2(
				'teachers',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, module_.fx)),
				_Utils_Tuple2(
				'students',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, module_.fv)),
				_Utils_Tuple2(
				'rubrics',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$int,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.i8;
						},
						module_.fq))),
				_Utils_Tuple2(
				'migration_ready_at',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, module_.jr)))
			]));
};
var $author$project$Module$createModule = F3(
	function (config, module_, callback) {
		return A5(
			$author$project$Api$post,
			A2($author$project$Api$Endpoint$modules, config, $author$project$Module$defaultListParams),
			config,
			$elm$http$Http$jsonBody(
				$author$project$Module$moduleEncoder(module_)),
			callback,
			$author$project$Module$moduleDetailedDecoder);
	});
var $author$project$Api$delete = F3(
	function (url, config, toMsg) {
		return $author$project$Api$Endpoint$request(
			{
				T: $elm$http$Http$emptyBody,
				bd: $author$project$Api$expectHeaders(toMsg),
				ar: $author$project$Api$toHeaders(config),
				bj: 'DELETE',
				bp: $elm$core$Maybe$Nothing,
				bq: $elm$core$Maybe$Nothing,
				K: url
			});
	});
var $author$project$Module$deleteModule = F3(
	function (config, moduleId, callback) {
		return A3(
			$author$project$Api$delete,
			A2(
				$author$project$Api$Endpoint$module_,
				config,
				$author$project$Module$moduleIdToInt(moduleId)),
			config,
			callback);
	});
var $author$project$Element$ModulesMain$emptyResults = function (listPage) {
	return _Utils_update(
		listPage,
		{dj: $author$project$Element$ModulesMain$LoadingModules, hH: _List_Nil});
};
var $author$project$Element$ModulesMain$filterModules = F4(
	function (session, model, listPage, newFilter) {
		var filteredPage = $author$project$Element$ModulesMain$emptyResults(
			_Utils_update(
				listPage,
				{ad: newFilter}));
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A3(
				$author$project$Module$fetchModules_,
				model.b_.gX,
				$author$project$Element$ModulesMain$asListParams(filteredPage),
				$author$project$Element$ModulesMain$ModuleListDownloaded),
			A2(
				$author$project$Application$Boundaries$save,
				_Utils_update(
					model,
					{
						bk: $author$project$Element$ModulesMain$ListPage(filteredPage)
					}),
				session));
	});
var $author$project$Element$ModulesMain$formVariation = F3(
	function (form, t_, isTemplate) {
		var students = form.fv;
		return _Utils_update(
			form,
			{
				fv: isTemplate ? _Utils_update(
					students,
					{
						fi: $author$project$Form$optionalPeople(t_)
					}) : _Utils_update(
					students,
					{
						fi: $author$project$Form$requiredPeopleSelected(t_)
					})
			});
	});
var $author$project$Element$ModulesMain$isCreateAction = function (model) {
	var _v0 = model.bk;
	if (_v0.$ === 3) {
		var formPageModel = _v0.a;
		return A2(
			$elm$core$List$member,
			formPageModel.iq,
			_List_fromArray(
				[$author$project$Element$ModulesMain$Create, $author$project$Element$ModulesMain$CreateFromTemplate]));
	} else {
		return false;
	}
};
var $author$project$Element$ModulesMain$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.kj, values) && (A2($author$project$Form$isFieldValid, form.g8, values) && (A2($author$project$Form$isFieldValid, form.jq, values) && (A2($author$project$Form$isFieldValid, form.lO, values) && (A2($author$project$Form$isFieldValid, form.lQ, values) && (A2($author$project$Form$isFieldValid, form.lP, values) && (A2($author$project$Form$isFieldValid, form.nN, values) && (A2($author$project$Form$isFieldValid, form.ly, values) && (A2($author$project$Form$isFieldValid, form.kI, values) && (A2($author$project$Form$isFieldValid, form.Q, values) && (A2($author$project$Form$isFieldValid, form.Y, values) && (A2($author$project$Form$isFieldValid, form.fx, values) && (A2($author$project$Form$isFieldValid, form.fv, values) && A3($author$project$Form$areDatesValid, form.nN, form.ly, values)))))))))))));
	});
var $author$project$Log$msgModuleSave = 'module_save';
var $author$project$Element$ModulesMain$LearningGroupSelectorModel = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModulesMain$RubricsFormModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModulesMain$RubricsFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModulesMain$RubricsListModel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModulesMain$RubricsListMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricsForm$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricsForm$CreateRubric = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsForm$FetchRubric = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricsForm$Loading = {$: 0};
var $author$project$Element$RubricsForm$NewRubricCreated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$RubricsForm$RubricDetailDownloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Rubric$standard = {
	ea: 'Standard',
	gc: _List_fromArray(
		['Felülmúltad a várt szintet', 'Teljesítetted a szintet', 'Megközelítetted a várt szintet', 'Még nem érted el a megfelelő szintet'])
};
var $author$project$Rubric$blankRubric = function (author) {
	return {kU: _List_Nil, k_: author, i8: -1, mp: 0, gc: $author$project$Rubric$standard, nE: 0, kj: '(no title)'};
};
var $author$project$Rubric$encodedRubricToBackend = function (rubric) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(rubric.i8)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(rubric.kj)),
				_Utils_Tuple2(
				'author',
				$elm$json$Json$Encode$int(rubric.k_.i8)),
				_Utils_Tuple2(
				'shared_with',
				$elm$json$Json$Encode$string(
					function () {
						var _v0 = rubric.nE;
						if (!_v0) {
							return 'nobody';
						} else {
							return 'bps';
						}
					}())),
				_Utils_Tuple2(
				'content',
				$elm$json$Json$Encode$string(
					A2(
						$elm$json$Json$Encode$encode,
						4,
						$author$project$Rubric$encodeRubricContent(
							$author$project$Rubric$extractContent(rubric)))))
			]));
};
var $author$project$Api$Endpoint$rubricsCreate = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'rubrics']),
		_List_Nil);
};
var $author$project$Rubric$createRubric = F3(
	function (config, rubric, callback) {
		return {
			T: $author$project$Rubric$encodedRubricToBackend(rubric),
			b_: config,
			d_: $author$project$Rubric$rubricDecoder,
			cf: callback,
			K: $author$project$Api$Endpoint$rubricsCreate(config.gX)
		};
	});
var $author$project$Api$Endpoint$rubric = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'rubrics',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$Rubric$fetchRubric = F3(
	function (config, id, callback) {
		return {
			b_: config,
			d_: $author$project$Rubric$rubricDecoder,
			cf: callback,
			K: A2($author$project$Api$Endpoint$rubric, config, id)
		};
	});
var $author$project$Element$RubricsForm$init = F3(
	function (config, session, params) {
		var viewer = session.ok;
		var model = {b_: config, mc: params.mc, bR: $author$project$Element$RubricsForm$Loading, gB: session, kb: $author$project$RemoteData$Loading};
		var cmd = function () {
			var _v0 = params.nt;
			if (_v0.$ === 1) {
				return $author$project$Element$RubricsForm$CreateRubric(
					A3(
						$author$project$Rubric$createRubric,
						config,
						$author$project$Rubric$blankRubric(
							$author$project$Person$toNested(viewer)),
						$author$project$Element$RubricsForm$NewRubricCreated));
			} else {
				var rubricId = _v0.a;
				return $author$project$Element$RubricsForm$FetchRubric(
					A3($author$project$Rubric$fetchRubric, config.gX, rubricId, $author$project$Element$RubricsForm$RubricDetailDownloaded));
			}
		}();
		return _Utils_Tuple3(
			model,
			$author$project$Element$RubricsForm$Cmd(cmd),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$RubricsForm$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$RubricsForm$perform(key),
						effects));
			default:
				var cmd = effect.a;
				switch (cmd.$) {
					case 0:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 1:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					case 2:
						var request = cmd.a;
						return $author$project$Api$putV2(request);
					case 3:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 4:
						var route = cmd.a;
						return A2(
							$elm$browser$Browser$Navigation$pushUrl,
							key,
							$author$project$Route$toString(route));
					case 5:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					case 6:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					default:
						var elementName = cmd.a;
						var toMsg = cmd.b;
						return A2(
							$elm$core$Task$attempt,
							toMsg,
							$elm$browser$Browser$Dom$focus(elementName));
				}
		}
	});
var $author$project$Element$RubricsForm$Exit = 0;
var $author$project$Element$RubricsForm$LogError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$RubricsForm$NavRedirect = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$RubricsForm$NoEdit = {$: 0};
var $author$project$Element$RubricsForm$NoEffect = {$: 0};
var $author$project$Element$RubricsForm$NoOp = {$: 0};
var $author$project$Element$RubricsForm$RubricLoaded = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Locale$Messages$RubricsCreateError = {$: 403};
var $author$project$Locale$Messages$RubricsSaveError = {$: 407};
var $author$project$Locale$Messages$RubricsSaveSuccess = {$: 406};
var $author$project$Element$RubricsForm$SaveError = {$: 6};
var $author$project$Element$RubricsForm$AddAspect = {$: 11};
var $author$project$Element$RubricsForm$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsForm$FetchSubjectList = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$RubricsForm$SubjectListDownloaded = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$RubricsForm$AspectTitle = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Element$RubricsForm$LevelDimension = {$: 3};
var $author$project$Element$RubricsForm$LogOk = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$RubricsForm$RubricTitle = {$: 4};
var $author$project$Element$RubricsForm$RubricUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$RubricsForm$Saving = {$: 5};
var $author$project$Element$RubricsForm$ScaleCell = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Element$RubricsForm$Submit = {$: 10};
var $author$project$Element$RubricsForm$UpdateRubric = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricsForm$FocusInput = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Element$RubricsForm$focusTextEditor = $author$project$Element$RubricsForm$Cmd(
	A2(
		$author$project$Element$RubricsForm$FocusInput,
		'text-editor',
		$elm$core$Basics$always($author$project$Element$RubricsForm$NoOp)));
var $author$project$Util$List$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $author$project$Util$List$insertAt = F3(
	function (index, items, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			var head = A2($elm$core$List$take, index, list);
			return _Utils_ap(
				head,
				_Utils_ap(items, tail));
		}
	});
var $author$project$Element$RubricsForm$insertAspects = F3(
	function (index, newAspects, aspects) {
		return A3($author$project$Util$List$insertAt, index, newAspects, aspects);
	});
var $author$project$Element$RubricsForm$isBlank = function (string) {
	var regexFromString = A2(
		$elm$core$Basics$composeR,
		$elm$regex$Regex$fromString,
		$elm$core$Maybe$withDefault($elm$regex$Regex$never));
	return A2(
		$elm$regex$Regex$contains,
		regexFromString('^\\s*$'),
		string);
};
var $author$project$Util$List$splitAt = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n, xs),
			A2($elm$core$List$drop, n, xs));
	});
var $author$project$Util$List$uncons = function (list) {
	if (!list.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var first = list.a;
		var rest = list.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(first, rest));
	}
};
var $author$project$Util$List$swapAt = F3(
	function (index1, index2, l) {
		swapAt:
		while (true) {
			if (_Utils_eq(index1, index2) || (index1 < 0)) {
				return l;
			} else {
				if (_Utils_cmp(index1, index2) > 0) {
					var $temp$index1 = index2,
						$temp$index2 = index1,
						$temp$l = l;
					index1 = $temp$index1;
					index2 = $temp$index2;
					l = $temp$l;
					continue swapAt;
				} else {
					var _v0 = A2($author$project$Util$List$splitAt, index1, l);
					var part1 = _v0.a;
					var tail1 = _v0.b;
					var _v1 = A2($author$project$Util$List$splitAt, index2 - index1, tail1);
					var head2 = _v1.a;
					var tail2 = _v1.b;
					var _v2 = _Utils_Tuple2(
						$author$project$Util$List$uncons(head2),
						$author$project$Util$List$uncons(tail2));
					if ((!_v2.a.$) && (!_v2.b.$)) {
						var _v3 = _v2.a.a;
						var value1 = _v3.a;
						var part2 = _v3.b;
						var _v4 = _v2.b.a;
						var value2 = _v4.a;
						var part3 = _v4.b;
						return $elm$core$List$concat(
							_List_fromArray(
								[
									part1,
									A2($elm$core$List$cons, value2, part2),
									A2($elm$core$List$cons, value1, part3)
								]));
					} else {
						return l;
					}
				}
			}
		}
	});
var $author$project$Util$List$moveAhead = F2(
	function (index, list) {
		if (!index) {
			return list;
		} else {
			var i = index;
			return A3($author$project$Util$List$swapAt, i - 1, i, list);
		}
	});
var $author$project$Util$List$moveBack = F2(
	function (index, list) {
		var last = $elm$core$List$length(list) - 1;
		return (_Utils_cmp(index, last) > 0) ? list : A3($author$project$Util$List$swapAt, index, index + 1, list);
	});
var $author$project$Log$msgRubricPaste = 'rubric_paste';
var $author$project$Rubric$numOfScaleLevels = function (rubric) {
	return $elm$core$List$length(rubric.gc.gc);
};
var $author$project$Rubric$parseTsv = function (value) {
	var lineSeparator = '\n';
	var cellSeparator = '\t';
	var parseAspect = function (line) {
		var _v0 = A2($elm$core$String$split, cellSeparator, line);
		if (_v0.b) {
			if (!_v0.b.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = _v0.a;
				var xs = _v0.b;
				return $elm$core$Maybe$Just(
					{
						mt: A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
							xs),
						nW: $elm$core$Maybe$Nothing,
						kj: x
					});
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return A2(
		$elm$core$List$filterMap,
		parseAspect,
		A2($elm$core$String$split, lineSeparator, value));
};
var $author$project$Util$List$removeAt = F2(
	function (index, list) {
		var tail = A2($elm$core$List$drop, index + 1, list);
		var head = A2($elm$core$List$take, index, list);
		return _Utils_ap(head, tail);
	});
var $author$project$Element$RubricsForm$removeBlankAspects = function (rubric) {
	var isAspectEmpty = function (aspect) {
		return $author$project$Element$RubricsForm$isBlank(aspect.kj) && A2(
			$elm$core$List$all,
			$elm$core$Basics$eq(true),
			A2($elm$core$List$map, $author$project$Element$RubricsForm$isBlank, aspect.mt));
	};
	return _Utils_update(
		rubric,
		{
			kU: A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAspectEmpty),
				rubric.kU)
		});
};
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Util$List$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			var head = A2($elm$core$List$take, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					head,
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $author$project$Util$List$setAt = F2(
	function (index, value) {
		return A2(
			$author$project$Util$List$updateAt,
			index,
			$elm$core$Basics$always(value));
	});
var $author$project$Element$RubricsForm$updateAspects = F3(
	function (index, updatedAspect, aspects) {
		return A3($author$project$Util$List$setAt, index, updatedAspect, aspects);
	});
var $author$project$Rubric$updateRubric = F3(
	function (config, rubric, callback) {
		return {
			T: $author$project$Rubric$encodedRubricToBackend(rubric),
			b_: config,
			d_: $author$project$Rubric$rubricDecoder,
			cf: callback,
			K: A2($author$project$Api$Endpoint$rubric, config.gX, rubric.i8)
		};
	});
var $author$project$Element$RubricsForm$submitPendingEdit = F3(
	function (config, editState, rubric) {
		var _v15 = A4($author$project$Element$RubricsForm$updateEditor, config, $author$project$Element$RubricsForm$Submit, editState, rubric);
		var rubric2 = _v15.b;
		var effect = _v15.c;
		return _Utils_Tuple2(rubric2, effect);
	});
var $author$project$Element$RubricsForm$updateEditor = F4(
	function (config, editMsg, editState, rubric) {
		var noop = _Utils_Tuple3($author$project$Element$RubricsForm$NoEdit, rubric, $author$project$Element$RubricsForm$NoEffect);
		switch (editMsg.$) {
			case 4:
				var _v1 = A3($author$project$Element$RubricsForm$submitPendingEdit, config, editState, rubric);
				var rubric2 = _v1.a;
				var effect = _v1.b;
				switch (editState.$) {
					case 1:
						return _Utils_Tuple3($author$project$Element$RubricsForm$LevelDimension, rubric2, effect);
					case 0:
						return _Utils_Tuple3($author$project$Element$RubricsForm$LevelDimension, rubric2, effect);
					case 2:
						return noop;
					case 3:
						return noop;
					case 4:
						return noop;
					case 5:
						return noop;
					default:
						return noop;
				}
			case 3:
				var sharing = editMsg.a;
				var _v3 = A3($author$project$Element$RubricsForm$submitPendingEdit, config, editState, rubric);
				var rubric2 = _v3.a;
				var effect = _v3.b;
				return _Utils_Tuple3(
					$author$project$Element$RubricsForm$NoEdit,
					_Utils_update(
						rubric2,
						{nE: sharing}),
					effect);
			case 2:
				return _Utils_Tuple3($author$project$Element$RubricsForm$RubricTitle, rubric, $author$project$Element$RubricsForm$NoEffect);
			case 0:
				var rowIndex = editMsg.a;
				var maybeAspect = A2($author$project$Util$List$getAt, rowIndex, rubric.kU);
				var _v4 = A3($author$project$Element$RubricsForm$submitPendingEdit, config, editState, rubric);
				var rubric2 = _v4.a;
				var effect = _v4.b;
				if (!maybeAspect.$) {
					var aspect = maybeAspect.a;
					return _Utils_Tuple3(
						A2($author$project$Element$RubricsForm$AspectTitle, aspect, rowIndex),
						rubric2,
						$author$project$Element$RubricsForm$BatchEffect(
							_List_fromArray(
								[effect, $author$project$Element$RubricsForm$focusTextEditor])));
				} else {
					return noop;
				}
			case 1:
				var rowIndex = editMsg.a;
				var levelIndex = editMsg.b;
				var maybeAspect = A2($author$project$Util$List$getAt, rowIndex, rubric.kU);
				var _v6 = A3($author$project$Element$RubricsForm$submitPendingEdit, config, editState, rubric);
				var rubric2 = _v6.a;
				var effect = _v6.b;
				if (!maybeAspect.$) {
					var aspect = maybeAspect.a;
					return _Utils_Tuple3(
						A3($author$project$Element$RubricsForm$ScaleCell, aspect, rowIndex, levelIndex),
						rubric2,
						$author$project$Element$RubricsForm$BatchEffect(
							_List_fromArray(
								[effect, $author$project$Element$RubricsForm$focusTextEditor])));
				} else {
					return noop;
				}
			case 6:
				var value = editMsg.a;
				if (editState.$ === 1) {
					var aspect = editState.a;
					var rowIndex = editState.b;
					var newLevelDescriptions = function () {
						switch (value) {
							case 'Önállóság':
								return _List_fromArray(
									['Egyedül hozol döntéseket, javaslatokat teszel, mikor, mi történjen, felismered és kezeled a saját szükségleteidet', 'Jelzed ha valamire szükséged van, de már a megoldást is ismered', 'Még nem minden esetben ismered fel saját szükségleteidet', 'Még szükséged van mások segítségére abban, hogy felismerd és megoldást találj szükségleteid kielégítésére']);
							case 'Figyelem, aktivitás':
								return _List_fromArray(
									['Addig tudsz figyelni, míg kész nem vagy a rád bízott feladattal, társaidnak segítesz ha elakadnak, részt veszel a munka előkészítésében, utómunkáiban', 'Sokáig tudsz figyelni, észre veszed ha valakinek segítségre van szüksége, elvégzed a feladatot', 'Vannak napok amikor sikerül figyelned, befejezni a feladatot, máskor kevesebb erőd van hozzá', 'Nem szeretsz a társaiddal együtt részt venni a munkában, nem érdekel, mit csinálnak']);
							default:
								return aspect.mt;
						}
					}();
					var updatedAspect = _Utils_update(
						aspect,
						{mt: newLevelDescriptions, kj: value});
					var _v9 = _Utils_Tuple2(
						$author$project$Element$RubricsForm$isBlank(aspect.kj),
						$author$project$Rubric$parseTsv(value));
					if (!_v9.a) {
						return _Utils_Tuple3(
							A2($author$project$Element$RubricsForm$AspectTitle, updatedAspect, rowIndex),
							_Utils_update(
								rubric,
								{
									kU: A3($author$project$Element$RubricsForm$updateAspects, rowIndex, updatedAspect, rubric.kU)
								}),
							$author$project$Element$RubricsForm$NoEffect);
					} else {
						if (!_v9.b.b) {
							return _Utils_Tuple3(
								A2($author$project$Element$RubricsForm$AspectTitle, updatedAspect, rowIndex),
								_Utils_update(
									rubric,
									{
										kU: A3($author$project$Element$RubricsForm$updateAspects, rowIndex, updatedAspect, rubric.kU)
									}),
								$author$project$Element$RubricsForm$NoEffect);
						} else {
							var pastedAspects = _v9.b;
							return _Utils_Tuple3(
								A2(
									$author$project$Element$RubricsForm$AspectTitle,
									aspect,
									rowIndex + $elm$core$List$length(pastedAspects)),
								_Utils_update(
									rubric,
									{
										kU: A3($author$project$Element$RubricsForm$insertAspects, rowIndex, pastedAspects, rubric.kU)
									}),
								$author$project$Element$RubricsForm$Cmd(
									$author$project$Element$RubricsForm$LogOk(
										A3(
											$author$project$Log$okV2,
											config,
											_Utils_Tuple2(
												$author$project$Log$msgRubricPaste,
												_List_fromArray(
													[
														$elm$core$String$fromInt(rubric.i8),
														$elm$core$String$fromInt(
														$elm$core$List$length(pastedAspects))
													])),
											$elm$core$Basics$always($author$project$Element$RubricsForm$NoOp)))));
						}
					}
				} else {
					return _Utils_Tuple3(editState, rubric, $author$project$Element$RubricsForm$NoEffect);
				}
			case 7:
				var aspect = editMsg.a;
				var rowIndex = editMsg.b;
				var subjectIdAsString = editMsg.c;
				var updatedAspect = _Utils_update(
					aspect,
					{
						nW: $elm$core$String$toInt(subjectIdAsString)
					});
				return _Utils_Tuple3(
					A2($author$project$Element$RubricsForm$AspectTitle, aspect, rowIndex),
					_Utils_update(
						rubric,
						{
							kU: A3($author$project$Element$RubricsForm$updateAspects, rowIndex, updatedAspect, rubric.kU)
						}),
					$author$project$Element$RubricsForm$focusTextEditor);
			case 9:
				var aspect = editMsg.a;
				var rowIndex = editMsg.b;
				var level = editMsg.c;
				var value = editMsg.d;
				var newLevelDescriptions = A3($author$project$Util$List$setAt, level, value, aspect.mt);
				var updatedAspect = _Utils_update(
					aspect,
					{mt: newLevelDescriptions});
				return _Utils_Tuple3(
					A3($author$project$Element$RubricsForm$ScaleCell, updatedAspect, rowIndex, level),
					_Utils_update(
						rubric,
						{
							kU: A3($author$project$Element$RubricsForm$updateAspects, rowIndex, updatedAspect, rubric.kU)
						}),
					$author$project$Element$RubricsForm$NoEffect);
			case 5:
				var levels = editMsg.a;
				return _Utils_Tuple3(
					$author$project$Element$RubricsForm$NoEdit,
					_Utils_update(
						rubric,
						{gc: levels}),
					$author$project$Element$RubricsForm$NoEffect);
			case 8:
				var value = editMsg.a;
				return _Utils_Tuple3(
					$author$project$Element$RubricsForm$RubricTitle,
					_Utils_update(
						rubric,
						{kj: value}),
					$author$project$Element$RubricsForm$NoEffect);
			case 14:
				var rowIndex = editMsg.a;
				switch (editState.$) {
					case 0:
						return noop;
					case 3:
						return noop;
					case 5:
						return noop;
					case 6:
						return noop;
					case 4:
						return noop;
					case 2:
						return noop;
					default:
						var aspect = editState.a;
						var newRowIndex = (!rowIndex) ? rowIndex : (rowIndex - 1);
						return _Utils_Tuple3(
							A2($author$project$Element$RubricsForm$AspectTitle, aspect, newRowIndex),
							_Utils_update(
								rubric,
								{
									kU: A2($author$project$Util$List$moveAhead, rowIndex, rubric.kU)
								}),
							$author$project$Element$RubricsForm$NoEffect);
				}
			case 15:
				var rowIndex = editMsg.a;
				switch (editState.$) {
					case 0:
						return noop;
					case 3:
						return noop;
					case 5:
						return noop;
					case 6:
						return noop;
					case 4:
						return noop;
					case 2:
						return noop;
					default:
						var aspect = editState.a;
						var newRowIndex = _Utils_eq(
							rowIndex,
							$elm$core$List$length(rubric.kU) - 1) ? rowIndex : (rowIndex + 1);
						return _Utils_Tuple3(
							A2($author$project$Element$RubricsForm$AspectTitle, aspect, newRowIndex),
							_Utils_update(
								rubric,
								{
									kU: A2($author$project$Util$List$moveBack, rowIndex, rubric.kU)
								}),
							$author$project$Element$RubricsForm$NoEffect);
				}
			case 12:
				var rowIndex = editMsg.a;
				return _Utils_Tuple3(
					$author$project$Element$RubricsForm$NoEdit,
					_Utils_update(
						rubric,
						{
							kU: A2($author$project$Util$List$removeAt, rowIndex, rubric.kU)
						}),
					$author$project$Element$RubricsForm$NoEffect);
			case 10:
				switch (editState.$) {
					case 0:
						return _Utils_Tuple3($author$project$Element$RubricsForm$NoEdit, rubric, $author$project$Element$RubricsForm$NoEffect);
					case 3:
						return _Utils_Tuple3($author$project$Element$RubricsForm$NoEdit, rubric, $author$project$Element$RubricsForm$NoEffect);
					case 5:
						return _Utils_Tuple3($author$project$Element$RubricsForm$NoEdit, rubric, $author$project$Element$RubricsForm$NoEffect);
					case 6:
						return _Utils_Tuple3($author$project$Element$RubricsForm$NoEdit, rubric, $author$project$Element$RubricsForm$NoEffect);
					case 4:
						return _Utils_Tuple3($author$project$Element$RubricsForm$NoEdit, rubric, $author$project$Element$RubricsForm$NoEffect);
					case 2:
						var aspect = editState.a;
						var rowIndex = editState.b;
						var scaleIx = editState.c;
						return (_Utils_cmp(
							scaleIx,
							$author$project$Rubric$numOfScaleLevels(rubric) - 1) < 0) ? _Utils_Tuple3(
							A3($author$project$Element$RubricsForm$ScaleCell, aspect, rowIndex, scaleIx + 1),
							rubric,
							$author$project$Element$RubricsForm$focusTextEditor) : _Utils_Tuple3($author$project$Element$RubricsForm$NoEdit, rubric, $author$project$Element$RubricsForm$NoEffect);
					default:
						return noop;
				}
			case 11:
				var lastIndex = $elm$core$List$length(rubric.kU);
				var emptyAspect = {
					mt: A2(
						$elm$core$List$repeat,
						$author$project$Rubric$numOfScaleLevels(rubric),
						''),
					nW: $elm$core$Maybe$Nothing,
					kj: ''
				};
				return _Utils_Tuple3(
					A2($author$project$Element$RubricsForm$AspectTitle, emptyAspect, lastIndex),
					_Utils_update(
						rubric,
						{
							kU: A3(
								$author$project$Element$RubricsForm$insertAspects,
								lastIndex,
								_List_fromArray(
									[emptyAspect]),
								rubric.kU)
						}),
					$author$project$Element$RubricsForm$focusTextEditor);
			default:
				var _v14 = A3($author$project$Element$RubricsForm$submitPendingEdit, config, editState, rubric);
				var rubric2 = _v14.a;
				var effect = _v14.b;
				var rubric3 = $author$project$Element$RubricsForm$removeBlankAspects(rubric2);
				var effect2 = _Utils_eq(rubric3.i8, -1) ? $author$project$Element$RubricsForm$Cmd(
					$author$project$Element$RubricsForm$CreateRubric(
						A3($author$project$Rubric$createRubric, config, rubric3, $author$project$Element$RubricsForm$RubricUpdated))) : $author$project$Element$RubricsForm$Cmd(
					$author$project$Element$RubricsForm$UpdateRubric(
						A3($author$project$Rubric$updateRubric, config, rubric3, $author$project$Element$RubricsForm$RubricUpdated)));
				return _Utils_Tuple3(
					$author$project$Element$RubricsForm$Saving,
					rubric3,
					$author$project$Element$RubricsForm$BatchEffect(
						_List_fromArray(
							[effect, effect2])));
		}
	});
var $author$project$Element$RubricsForm$initEditor = F2(
	function (model, rubric) {
		var _v0 = A4($author$project$Element$RubricsForm$updateEditor, model.b_, $author$project$Element$RubricsForm$AddAspect, $author$project$Element$RubricsForm$NoEdit, rubric);
		var editState = _v0.a;
		var rubric_ = _v0.b;
		var effect = _v0.c;
		var effect2 = $author$project$Element$RubricsForm$BatchEffect(
			_List_fromArray(
				[
					$author$project$Element$RubricsForm$Cmd(
					$author$project$Element$RubricsForm$FetchSubjectList(
						A3($author$project$Subject$fetchSubjectsV2, model.b_.gX, '', $author$project$Element$RubricsForm$SubjectListDownloaded))),
					effect
				]));
		return (!$elm$core$List$length(rubric.kU)) ? _Utils_Tuple3(
			_Utils_update(
				model,
				{
					bR: A3($author$project$Element$RubricsForm$RubricLoaded, rubric_, editState, false)
				}),
			effect2,
			$elm$core$Maybe$Nothing) : _Utils_Tuple3(
			_Utils_update(
				model,
				{
					bR: A3($author$project$Element$RubricsForm$RubricLoaded, rubric, $author$project$Element$RubricsForm$NoEdit, false)
				}),
			effect2,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Log$msgRubricCreate = 'rubric_create';
var $author$project$Log$msgRubricSave = 'rubric_save';
var $author$project$Element$RubricsForm$update = F2(
	function (msg, model) {
		var config = model.b_;
		var session = model.gB;
		var t_ = session.h6;
		var noop = _Utils_Tuple3(model, $author$project$Element$RubricsForm$NoEffect, $elm$core$Maybe$Nothing);
		switch (msg.$) {
			case 0:
				return noop;
			case 1:
				return _Utils_Tuple3(
					model,
					$author$project$Element$RubricsForm$NoEffect,
					$elm$core$Maybe$Just(0));
			case 5:
				if (!msg.a.$) {
					var rubric = msg.a.a;
					return model.mc ? A2($author$project$Element$RubricsForm$initEditor, model, rubric) : _Utils_Tuple3(
						model,
						$author$project$Element$RubricsForm$Cmd(
							$author$project$Element$RubricsForm$NavRedirect(
								$author$project$Route$RubricsUpdate(rubric.i8))),
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$RubricsCreateError))
							}),
						$author$project$Element$RubricsForm$Cmd(
							$author$project$Element$RubricsForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgRubricCreate, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$RubricsForm$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 3:
				if (!msg.a.$) {
					var rubric_ = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bR: A3($author$project$Element$RubricsForm$RubricLoaded, rubric_, $author$project$Element$RubricsForm$NoEdit, false),
								gB: A2(
									$author$project$Session$ok,
									session,
									t_($author$project$Locale$Messages$RubricsSaveSuccess))
							}),
						$author$project$Element$RubricsForm$NoEffect,
						$elm$core$Maybe$Just(0));
				} else {
					var error = msg.a.a;
					var _v1 = model.bR;
					if ((_v1.$ === 1) && (_v1.b.$ === 5)) {
						var rubric = _v1.a;
						var _v2 = _v1.b;
						var hasChanged = _v1.c;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bR: A3($author$project$Element$RubricsForm$RubricLoaded, rubric, $author$project$Element$RubricsForm$SaveError, hasChanged),
									gB: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$RubricsSaveError))
								}),
							$author$project$Element$RubricsForm$Cmd(
								$author$project$Element$RubricsForm$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgRubricSave,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(rubric.i8)),
											error),
										$elm$core$Basics$always($author$project$Element$RubricsForm$NoOp)))),
							$elm$core$Maybe$Nothing);
					} else {
						return noop;
					}
				}
			case 4:
				if (!msg.a.$) {
					var rubric = msg.a.a;
					return A2($author$project$Element$RubricsForm$initEditor, model, rubric);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$RubricsDownloadError))
							}),
						$author$project$Element$RubricsForm$Cmd(
							$author$project$Element$RubricsForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgRubricsDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$RubricsForm$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 6:
				var data = msg.a;
				var updatedModel = _Utils_update(
					model,
					{kb: data});
				switch (data.$) {
					case 2:
						return _Utils_Tuple3(updatedModel, $author$project$Element$RubricsForm$NoEffect, $elm$core$Maybe$Nothing);
					case 3:
						var error = data.a;
						return _Utils_Tuple3(
							_Utils_update(
								updatedModel,
								{
									gB: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$SubjectListDownloadError))
								}),
							$author$project$Element$RubricsForm$Cmd(
								$author$project$Element$RubricsForm$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgSubjectListDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$RubricsForm$NoOp)))),
							$elm$core$Maybe$Nothing);
					default:
						return _Utils_Tuple3(updatedModel, $author$project$Element$RubricsForm$NoEffect, $elm$core$Maybe$Nothing);
				}
			default:
				var editMsg = msg.a;
				var _v4 = model.bR;
				if (_v4.$ === 1) {
					var rubric = _v4.a;
					var editState = _v4.b;
					var hasChanged = _v4.c;
					var _v5 = A4($author$project$Element$RubricsForm$updateEditor, config, editMsg, editState, rubric);
					var editState_ = _v5.a;
					var rubric_ = _v5.b;
					var effect = _v5.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bR: A3(
									$author$project$Element$RubricsForm$RubricLoaded,
									rubric_,
									editState_,
									hasChanged || (!_Utils_eq(rubric, rubric_)))
							}),
						effect,
						$elm$core$Maybe$Nothing);
				} else {
					return noop;
				}
		}
	});
var $author$project$Locale$Messages$RubricsHeadingEdit = {$: 417};
var $author$project$Locale$Messages$RubricsHelpCreate = {$: 418};
var $author$project$Locale$Messages$RubricsLoadingProgress = {$: 420};
var $author$project$UI$Icon$help = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-question-circle'),
			attributes));
};
var $author$project$Element$RubricsForm$EditMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricsForm$OpenAspectSelector = {$: 4};
var $author$project$Locale$Messages$RubricsBtnPrivate = {$: 408};
var $author$project$Locale$Messages$RubricsBtnSharedWithBps = {$: 410};
var $author$project$Locale$Messages$RubricsHelpEdit = {$: 419};
var $author$project$Element$RubricsForm$Save = {$: 13};
var $author$project$Element$RubricsForm$SetSharing = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$RubricsForm$AspectTitleInput = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$RubricsForm$MoveAspectDown = function (a) {
	return {$: 15, a: a};
};
var $author$project$Element$RubricsForm$MoveAspectUp = function (a) {
	return {$: 14, a: a};
};
var $author$project$Element$RubricsForm$StartEditAspectTitle = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricsForm$columns = F2(
	function (left, right) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('columns')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column is-10')
						]),
					right),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column')
						]),
					left)
				]));
	});
var $author$project$Element$RubricsForm$Delete = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$RubricsForm$viewControls = function (rowIndex) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button is-small'),
					$elm$html$Html$Events$onClick(
					$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$Submit)),
					$elm$html$Html$Attributes$title('Done')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$check(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('is-small')
						]))
				])),
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button is-small'),
					$elm$html$Html$Events$onClick(
					$author$project$Element$RubricsForm$EditMsg(
						$author$project$Element$RubricsForm$Delete(rowIndex))),
					$elm$html$Html$Attributes$title('Delete')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-minus'),
							$author$project$UI$Icon$style('is-small')
						]))
				]))
		]);
};
var $author$project$Element$RubricsForm$AspectSubjectInput = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Locale$Messages$RubricAspectSubject = {$: 402};
var $author$project$Element$RubricsForm$viewSubjectSelector = F4(
	function (t_, subjects, aspect, rowIndex) {
		var subjectsFormValues = {
			gF: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $elm$core$String$fromInt, aspect.nW))
		};
		var subjectOptions = function () {
			switch (subjects.$) {
				case 2:
					var subjectList = subjects.a;
					return A3(
						$elm$core$List$map2,
						$elm$core$Tuple$pair,
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.i8;
								},
								$elm$core$String$fromInt),
							subjectList),
						A2(
							$elm$core$List$map,
							function ($) {
								return $.fb;
							},
							subjectList));
				case 3:
					return _List_Nil;
				default:
					return _List_Nil;
			}
		}();
		var subjectsFormFields = {
			e0: false,
			fi: function (_v0) {
				return $elm$core$Result$Ok('?');
			},
			fp: false,
			ks: F2(
				function (_v1, _v2) {
					return {gF: ''};
				}),
			fC: function ($) {
				return $.gF;
			},
			og: {
				cm: 'subject',
				e6: '',
				ea: t_($author$project$Locale$Messages$RubricAspectSubject),
				fe: A2(
					$elm$core$Basics$composeL,
					$author$project$Element$RubricsForm$EditMsg,
					A2($author$project$Element$RubricsForm$AspectSubjectInput, aspect, rowIndex)),
				m_: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(subjectOptions))
			}
		};
		return A3($author$project$UI$choiceField, t_, subjectsFormFields, subjectsFormValues);
	});
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$Util$Html$onEnter = function (msg) {
	var isEnter = function (code) {
		return (code === 13) ? $elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)) : $elm$json$Json$Decode$fail('not ENTER');
	};
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'keydown',
		A2($elm$json$Json$Decode$andThen, isEnter, $elm$html$Html$Events$keyCode));
};
var $author$project$Element$RubricsForm$viewTextAreaEditor = F3(
	function (value_, onInput_, onEnter_) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(value_),
					A2(
					$elm$html$Html$textarea,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('textarea is-info'),
							A2($elm$html$Html$Attributes$style, 'min-height', '1em'),
							A2($elm$html$Html$Attributes$style, 'width', '100%'),
							A2($elm$html$Html$Attributes$style, 'height', '100%'),
							A2($elm$html$Html$Attributes$style, 'top', '0'),
							A2($elm$html$Html$Attributes$style, 'right', '0'),
							A2($elm$html$Html$Attributes$style, 'left', '0'),
							A2($elm$html$Html$Attributes$style, 'bottom', '0'),
							A2($elm$html$Html$Attributes$style, 'resize', 'none'),
							A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
							$elm$html$Html$Attributes$id('text-editor'),
							$elm$html$Html$Attributes$value(value_),
							$elm$html$Html$Events$onInput(onInput_),
							$author$project$Util$Html$onEnter(onEnter_)
						]),
					_List_Nil)
				]));
	});
var $author$project$Element$RubricsForm$viewAspectTitleCell = F6(
	function (t_, editing, isLastRow, rowIndex, aspect, subjects) {
		var buttonMoveUp = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button is-small'),
					A2($elm$html$Html$Attributes$style, 'width', '10px'),
					A2($elm$html$Html$Attributes$style, 'height', '10px'),
					A2($elm$html$Html$Attributes$style, 'left', '-20px'),
					A2($elm$html$Html$Attributes$style, 'top', '50%'),
					A2($elm$html$Html$Attributes$style, 'resize', 'none'),
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					$elm$html$Html$Events$onClick(
					$author$project$Element$RubricsForm$EditMsg(
						$author$project$Element$RubricsForm$MoveAspectUp(rowIndex)))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-arrow-up fa-sm'),
							$author$project$UI$Icon$style('is-small')
						]))
				]));
		var buttonMoveDown = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button is-small'),
					A2($elm$html$Html$Attributes$style, 'width', '10px'),
					A2($elm$html$Html$Attributes$style, 'height', '10px'),
					A2($elm$html$Html$Attributes$style, 'left', '-20px'),
					A2($elm$html$Html$Attributes$style, 'top', '70%'),
					A2($elm$html$Html$Attributes$style, 'resize', 'none'),
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					$elm$html$Html$Events$onClick(
					$author$project$Element$RubricsForm$EditMsg(
						$author$project$Element$RubricsForm$MoveAspectDown(rowIndex)))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-arrow-down fa-sm'),
							$author$project$UI$Icon$style('is-small')
						]))
				]));
		return editing ? A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'relative')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Element$RubricsForm$columns,
					$author$project$Element$RubricsForm$viewControls(rowIndex),
					_List_fromArray(
						[
							A3(
							$author$project$Element$RubricsForm$viewTextAreaEditor,
							aspect.kj,
							A2($elm$core$Basics$composeL, $author$project$Element$RubricsForm$EditMsg, $author$project$Element$RubricsForm$AspectTitleInput),
							$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$Submit)),
							A4($author$project$Element$RubricsForm$viewSubjectSelector, t_, subjects, aspect, rowIndex)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$when, rowIndex > 0, buttonMoveUp),
							A2($author$project$UI$when, !isLastRow, buttonMoveDown)
						]))
				])) : A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Element$RubricsForm$EditMsg(
						$author$project$Element$RubricsForm$StartEditAspectTitle(rowIndex)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(aspect.kj),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					function () {
					if (subjects.$ === 2) {
						var subjects_ = subjects.a;
						var subjectName = A2($author$project$Subject$findSubjectNameOrEmpty, subjects_, aspect.nW);
						return $elm$html$Html$text(
							$author$project$Util$String$parenthesize(subjectName));
					} else {
						return $author$project$UI$none;
					}
				}()
				]));
	});
var $author$project$Element$RubricsForm$AspectLevelDescriptionInput = F4(
	function (a, b, c, d) {
		return {$: 9, a: a, b: b, c: c, d: d};
	});
var $author$project$Element$RubricsForm$StartEditScaleCell = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Element$RubricsForm$viewScaleDescriptionCell = F5(
	function (editing, value_, aspect, rowIndex, cellIndex) {
		return (!editing) ? A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Element$RubricsForm$EditMsg(
						A2($author$project$Element$RubricsForm$StartEditScaleCell, rowIndex, cellIndex)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(value_)
				])) : A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'relative')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Element$RubricsForm$viewTextAreaEditor,
					value_,
					A2(
						$elm$core$Basics$composeL,
						$author$project$Element$RubricsForm$EditMsg,
						A3($author$project$Element$RubricsForm$AspectLevelDescriptionInput, aspect, rowIndex, cellIndex)),
					$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$Submit))
				]));
	});
var $author$project$Element$RubricsForm$viewAspectRow = F6(
	function (t_, rubric, editState, subjects, rowIndex, aspect) {
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('has-text-left')
				]),
			A2(
				$elm$core$List$cons,
				A6(
					$author$project$Element$RubricsForm$viewAspectTitleCell,
					t_,
					_Utils_eq(
						editState,
						A2($author$project$Element$RubricsForm$AspectTitle, aspect, rowIndex)),
					_Utils_eq(
						$elm$core$List$length(rubric.kU) - 1,
						rowIndex),
					rowIndex,
					aspect,
					subjects),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (cellIndex, value) {
							return A5(
								$author$project$Element$RubricsForm$viewScaleDescriptionCell,
								_Utils_eq(
									editState,
									A3($author$project$Element$RubricsForm$ScaleCell, aspect, rowIndex, cellIndex)),
								value,
								aspect,
								rowIndex,
								cellIndex);
						}),
					A2(
						$elm$core$List$take,
						$elm$core$List$length(rubric.gc.gc),
						aspect.mt))));
	});
var $author$project$Element$RubricsForm$SetScale = function (a) {
	return {$: 5, a: a};
};
var $author$project$Rubric$growthMindset = {
	ea: 'Erőfeszítés',
	gc: _List_fromArray(
		['Nagyon sok erőfeszítést tettél', 'Sokat tettél érte', 'Valamit tettél érte', 'Nem sokat tettél érte'])
};
var $author$project$Rubric$sikerult = {
	ea: 'Sikerült - még nem',
	gc: _List_fromArray(
		['Sikerült', 'Sikerült és még...', 'Már haladsz', 'Még nem'])
};
var $author$project$Rubric$skill = {
	ea: 'Standard',
	gc: _List_fromArray(
		['Mester', 'Haladó', 'Középhaladó', 'Újonc'])
};
var $author$project$Rubric$yesAndNotYetBut = {
	ea: 'Hogy ment?',
	gc: _List_fromArray(
		['Jól ment', 'Már megy, és még...', 'Még nem megy, de már...', 'Még nem megy'])
};
var $author$project$Rubric$allAvailableLevelStructure = _List_fromArray(
	[$author$project$Rubric$standard, $author$project$Rubric$sikerult, $author$project$Rubric$yesAndNotYetBut, $author$project$Rubric$skill, $author$project$Rubric$growthMindset]);
var $author$project$Element$RubricsForm$viewAspectSelector = function (activeLevels) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('dropdown', true),
						_Utils_Tuple2('is-active', true)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dropdown-menu'),
						$elm$html$Html$Attributes$id('dropdown-menu'),
						A2($elm$html$Html$Attributes$attribute, 'role', 'menu')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dropdown-content')
							]),
						A2(
							$elm$core$List$map,
							function (levels) {
								return A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('dropdown-item', true),
													_Utils_Tuple2(
													'is-active',
													_Utils_eq(levels, activeLevels))
												])),
											$elm$html$Html$Events$onClick(
											$author$project$Element$RubricsForm$EditMsg(
												$author$project$Element$RubricsForm$SetScale(levels)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(levels.ea)
										]));
							},
							$author$project$Rubric$allAvailableLevelStructure))
					]))
			]));
};
var $author$project$Element$RubricsForm$RubricTitleInput = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$RubricsForm$StartEditTitle = {$: 2};
var $author$project$Element$RubricsForm$viewRubricTitle = F3(
	function (_v0, rubric, editState) {
		if (editState.$ === 4) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('field has-addons')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('control')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('input'),
										$elm$html$Html$Attributes$value(rubric.kj),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$Element$RubricsForm$EditMsg, $author$project$Element$RubricsForm$RubricTitleInput)),
										$author$project$Util$Html$onEnter(
										$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$Submit))
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('control')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button'),
										$elm$html$Html$Events$onClick(
										$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$Submit))
									]),
								_List_fromArray(
									[
										$author$project$UI$Icon$check(
										_List_fromArray(
											[
												$author$project$UI$Icon$style('is-small')
											]))
									]))
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('subtitle is-inline-block')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(rubric.kj)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$StartEditTitle)),
								$elm$html$Html$Attributes$class('ml-2')
							]),
						_List_fromArray(
							[
								$author$project$UI$Icon$edit(_List_Nil)
							]))
					]));
		}
	});
var $author$project$Element$RubricsForm$viewEditorForm = F5(
	function (t_, rubric, editState, subjects, hasChanged) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$UI$notification(
					$author$project$UI$textToHtml(
						t_($author$project$Locale$Messages$RubricsHelpEdit))),
					A3($author$project$Element$RubricsForm$viewRubricTitle, t_, rubric, editState),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$table,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('table is-striped is-bordered')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$thead,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('has-background-info-light')
										]),
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricAspect),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-2'),
																	$elm$html$Html$Events$onClick(
																	$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$OpenAspectSelector))
																]),
															_List_fromArray(
																[
																	$author$project$UI$Icon$edit(_List_Nil)
																]))
														])),
													A2(
													$author$project$UI$when,
													_Utils_eq(editState, $author$project$Element$RubricsForm$LevelDimension),
													$author$project$Element$RubricsForm$viewAspectSelector(rubric.gc))
												])),
										A2(
											$elm$core$List$map,
											function (l) {
												return A2(
													$elm$html$Html$th,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(l)
														]));
											},
											rubric.gc.gc))),
									A2(
									$elm$html$Html$tbody,
									_List_Nil,
									_Utils_ap(
										A2(
											$elm$core$List$indexedMap,
											A4($author$project$Element$RubricsForm$viewAspectRow, t_, rubric, editState, subjects),
											rubric.kU),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$td,
														_List_fromArray(
															[
																$elm$html$Html$Events$onClick(
																$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$AddAspect))
															]),
														_List_fromArray(
															[
																$author$project$UI$Icon$add(_List_Nil)
															]))
													]))
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('buttons has-addons')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button is-rounded'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('is-selected is-info is-light', !rubric.nE)
												])),
											$elm$html$Html$Events$onClick(
											$author$project$Element$RubricsForm$EditMsg(
												$author$project$Element$RubricsForm$SetSharing(0)))
										]),
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricsBtnPrivate)
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button is-rounded'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('is-selected is-info is-light', rubric.nE === 1)
												])),
											$elm$html$Html$Events$onClick(
											$author$project$Element$RubricsForm$EditMsg(
												$author$project$Element$RubricsForm$SetSharing(1)))
										]),
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricsBtnSharedWithBps)
										]))
								])),
							A4(
							$author$project$UI$submitButton,
							t_($author$project$Locale$Messages$BtnSave),
							!hasChanged,
							_Utils_eq(editState, $author$project$Element$RubricsForm$Saving),
							$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$Save))
						]))
				]));
	});
var $author$project$Element$RubricsForm$viewEditorPane = F3(
	function (t_, pageState, subjects) {
		return $author$project$UI$panel(
			{
				g$: _List_fromArray(
					[
						function () {
						if (pageState.$ === 1) {
							var rubric = pageState.a;
							var editState = pageState.b;
							var hasChanged = pageState.c;
							return A5($author$project$Element$RubricsForm$viewEditorForm, t_, rubric, editState, subjects, hasChanged);
						} else {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('container')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$UI$progressBar,
										'is-primary',
										t_($author$project$Locale$Messages$RubricsLoadingProgress))
									]));
						}
					}()
					]),
				cm: 'rubrics-form',
				hl: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricsHeadingEdit)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('https://www.loom.com/share/8860843645944c8eaef60cb14a1f152e'),
										$elm$html$Html$Attributes$target('_blank'),
										$elm$html$Html$Attributes$title(
										t_($author$project$Locale$Messages$RubricsHelpCreate))
									]),
								_List_fromArray(
									[
										$author$project$UI$Icon$help(
										_List_fromArray(
											[
												$author$project$UI$Icon$style('has-text-info')
											]))
									]))
							]))
					]),
				h7: _List_Nil,
				ie: 'is-light has-background-white'
			});
	});
var $author$project$Element$RubricsForm$PopupClosed = {$: 1};
var $author$project$Element$RubricsForm$withPopup = F2(
	function (isPopup, view_) {
		return isPopup ? A3(
			$author$project$UI$modalWindow,
			true,
			$author$project$Element$RubricsForm$PopupClosed,
			$author$project$UI$section(
				_List_fromArray(
					[view_]))) : view_;
	});
var $author$project$Element$RubricsForm$view = function (model) {
	var session = model.gB;
	return A2(
		$author$project$Element$RubricsForm$withPopup,
		model.mc,
		A3($author$project$Element$RubricsForm$viewEditorPane, session.h6, model.bR, model.kb));
};
var $author$project$Element$RubricsForm$element = {jb: $author$project$Element$RubricsForm$init, hP: $author$project$Element$RubricsForm$perform, ks: $author$project$Element$RubricsForm$update, og: $author$project$Element$RubricsForm$view};
var $author$project$Element$RubricsList$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsList$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricsList$FetchRubrics = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricsList$FetchSubjects = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsList$FilterAll = 0;
var $author$project$Element$RubricsList$FilterCreator = 1;
var $author$project$Element$RubricsList$FilterSelected = 2;
var $author$project$Element$RubricsList$RubricsListDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$RubricsList$SubjectListDownloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$RubricsList$listFilterToCategory = function (filter) {
	switch (filter) {
		case 0:
			return $author$project$Api$Endpoint$categoryAll;
		case 1:
			return $author$project$Api$Endpoint$categoryCreator;
		default:
			return $author$project$Api$Endpoint$categoryAll;
	}
};
var $author$project$Element$RubricsList$asListParams = function (_v0) {
	var filter = _v0.ad;
	var query = _v0.bF;
	var params = $author$project$Rubric$defaultListParams;
	return _Utils_update(
		params,
		{
			bD: $author$project$Element$RubricsList$listFilterToCategory(filter),
			bF: query
		});
};
var $author$project$ACL$canCreateRubric = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$Element$RubricsList$init = F3(
	function (config, session, viewMode) {
		var viewer = session.ok;
		var model = {
			b_: config,
			ad: function () {
				if ((viewMode.$ === 1) && viewMode.a.b) {
					var _v1 = viewMode.a;
					return 2;
				} else {
					return $author$project$ACL$canCreateRubric(viewer) ? 1 : 0;
				}
			}(),
			bF: '',
			fq: $elm$core$Maybe$Nothing,
			gB: session,
			cP: $elm$core$Dict$empty,
			kb: $author$project$RemoteData$NotAsked,
			oi: viewMode
		};
		return _Utils_Tuple3(
			model,
			$author$project$Element$RubricsList$BatchEffect(
				_List_fromArray(
					[
						$author$project$Element$RubricsList$Cmd(
						$author$project$Element$RubricsList$FetchRubrics(
							A3(
								$author$project$Rubric$fetchRubricsV2,
								config.gX,
								$author$project$Element$RubricsList$asListParams(model),
								$author$project$Element$RubricsList$RubricsListDownloaded))),
						$author$project$Element$RubricsList$Cmd(
						$author$project$Element$RubricsList$FetchSubjects(
							A3($author$project$Subject$fetchSubjectsV2, config.gX, '', $author$project$Element$RubricsList$SubjectListDownloaded)))
					])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$RubricsList$SingleElementEffect = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Element$RubricsList$SingleElementMsg = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Element$RubricsSingle$Cmd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsSingle$FetchRubric = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricsSingle$NoEffect = {$: 0};
var $author$project$Element$RubricsSingle$RubricDetailDownloaded = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$RubricsSingle$init = F3(
	function (config, session, viewMode) {
		var subjects = function () {
			switch (viewMode.$) {
				case 0:
					return $author$project$RemoteData$NotAsked;
				case 1:
					var subjects_ = viewMode.b;
					return $author$project$RemoteData$Success(subjects_);
				default:
					var subjects_ = viewMode.b;
					return $author$project$RemoteData$Success(subjects_);
			}
		}();
		var model = {b_: config, nt: $author$project$RemoteData$NotAsked, gB: session, kb: subjects, oi: viewMode};
		switch (viewMode.$) {
			case 0:
				var rubricId = viewMode.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nt: $author$project$RemoteData$Loading}),
					$author$project$Element$RubricsSingle$Cmd(
						$author$project$Element$RubricsSingle$FetchRubric(
							A3($author$project$Rubric$fetchRubric, config.gX, rubricId, $author$project$Element$RubricsSingle$RubricDetailDownloaded))),
					$elm$core$Maybe$Nothing);
			case 1:
				var rubric_ = viewMode.a;
				var subjects_ = viewMode.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							nt: $author$project$RemoteData$Success(rubric_),
							kb: $author$project$RemoteData$Success(subjects_)
						}),
					$author$project$Element$RubricsSingle$NoEffect,
					$elm$core$Maybe$Nothing);
			default:
				var rubric_ = viewMode.a;
				var subjects_ = viewMode.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							nt: $author$project$RemoteData$Success(rubric_),
							kb: $author$project$RemoteData$Success(subjects_)
						}),
					$author$project$Element$RubricsSingle$NoEffect,
					$elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$RubricsSingle$perform = F2(
	function (key, effect) {
		if (!effect.$) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var cmd = effect.a;
			switch (cmd.$) {
				case 0:
					var request = cmd.a;
					return $author$project$Api$getV2(request);
				case 1:
					var request = cmd.a;
					return $author$project$Api$postV2(request);
				case 2:
					var request = cmd.a;
					return $author$project$Api$deleteV2(request);
				case 4:
					var route = cmd.a;
					return A2(
						$elm$browser$Browser$Navigation$pushUrl,
						key,
						$author$project$Route$toString(route));
				case 3:
					var request = cmd.a;
					return $author$project$Api$getV2(request);
				default:
					var request = cmd.a;
					return $author$project$Api$postV2(request);
			}
		}
	});
var $author$project$Element$RubricsSingle$CopyRubric = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsSingle$DeleteRubric = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricsSingle$DeletedRubric = {$: 2};
var $author$project$Element$RubricsSingle$DeselectRubric = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsSingle$FetchSubjectList = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$RubricsSingle$LogError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$RubricsSingle$NavRedirect = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$RubricsSingle$NoOp = {$: 8};
var $author$project$Element$RubricsSingle$RubricCopied = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$RubricsSingle$RubricDeleted = function (a) {
	return {$: 4, a: a};
};
var $author$project$Locale$Messages$RubricsDeleteError = {$: 405};
var $author$project$Locale$Messages$RubricsDeleteSuccess = {$: 404};
var $author$project$Element$RubricsSingle$SelectRubric = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricsSingle$SelectableListItem = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $author$project$Element$RubricsSingle$SubjectListDownloaded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Rubric$deleteRubric = F3(
	function (config, id, callback) {
		return {
			T: $elm$http$Http$emptyBody,
			b_: config,
			cf: callback,
			K: A2($author$project$Api$Endpoint$rubric, config, id)
		};
	});
var $author$project$Element$RubricsSingle$highlight = function (viewMode) {
	switch (viewMode.$) {
		case 0:
			return '';
		case 1:
			var highlight_ = viewMode.c;
			return highlight_;
		default:
			var highlight_ = viewMode.c;
			return highlight_;
	}
};
var $author$project$Log$msgRubricDelete = 'rubric_delete';
var $author$project$Element$RubricsSingle$update = F2(
	function (msg, model) {
		var config = model.b_;
		var session = model.gB;
		var combineMaybe = F2(
			function (left, right) {
				return A3(
					$elm$core$Maybe$map2,
					function (x) {
						return function (y) {
							return _Utils_Tuple2(x, y);
						};
					},
					left,
					right);
			});
		switch (msg.$) {
			case 0:
				var rubric = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Element$RubricsSingle$Cmd(
						$author$project$Element$RubricsSingle$DeleteRubric(
							A3($author$project$Rubric$deleteRubric, config.gX, rubric.i8, $author$project$Element$RubricsSingle$RubricDeleted))),
					$elm$core$Maybe$Nothing);
			case 1:
				var rubric = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Element$RubricsSingle$Cmd(
						$author$project$Element$RubricsSingle$CopyRubric(
							A3($author$project$Rubric$createRubric, config, rubric, $author$project$Element$RubricsSingle$RubricCopied))),
					$elm$core$Maybe$Nothing);
			case 2:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(model, $author$project$Element$RubricsSingle$NoEffect, $elm$core$Maybe$Nothing),
					A2(
						$elm$core$Maybe$map,
						function (_v1) {
							var rubric = _v1.a;
							var subjects = _v1.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										oi: A4(
											$author$project$Element$RubricsSingle$SelectableListItem,
											rubric,
											subjects,
											$author$project$Element$RubricsSingle$highlight(model.oi),
											true)
									}),
								$author$project$Element$RubricsSingle$NoEffect,
								$elm$core$Maybe$Just(
									$author$project$Element$RubricsSingle$SelectRubric(rubric)));
						},
						A2(
							combineMaybe,
							$author$project$RemoteData$toMaybe(model.nt),
							$author$project$RemoteData$toMaybe(model.kb))));
			case 3:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(model, $author$project$Element$RubricsSingle$NoEffect, $elm$core$Maybe$Nothing),
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var rubric = _v2.a;
							var subjects = _v2.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										oi: A4(
											$author$project$Element$RubricsSingle$SelectableListItem,
											rubric,
											subjects,
											$author$project$Element$RubricsSingle$highlight(model.oi),
											false)
									}),
								$author$project$Element$RubricsSingle$NoEffect,
								$elm$core$Maybe$Just(
									$author$project$Element$RubricsSingle$DeselectRubric(rubric)));
						},
						A2(
							combineMaybe,
							$author$project$RemoteData$toMaybe(model.nt),
							$author$project$RemoteData$toMaybe(model.kb))));
			case 4:
				if (!msg.a.$) {
					var model2 = _Utils_update(
						model,
						{
							gB: A2(
								$author$project$Session$ok,
								session,
								session.h6($author$project$Locale$Messages$RubricsDeleteSuccess))
						});
					var _v3 = model.oi;
					switch (_v3.$) {
						case 0:
							return _Utils_Tuple3(
								model2,
								$author$project$Element$RubricsSingle$Cmd(
									$author$project$Element$RubricsSingle$NavRedirect($author$project$Route$RubricsList)),
								$elm$core$Maybe$Nothing);
						case 1:
							return _Utils_Tuple3(
								model2,
								$author$project$Element$RubricsSingle$NoEffect,
								$elm$core$Maybe$Just($author$project$Element$RubricsSingle$DeletedRubric));
						default:
							return _Utils_Tuple3(
								model2,
								$author$project$Element$RubricsSingle$NoEffect,
								$elm$core$Maybe$Just($author$project$Element$RubricsSingle$DeletedRubric));
					}
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$RubricsDeleteError))
							}),
						$author$project$Element$RubricsSingle$Cmd(
							$author$project$Element$RubricsSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgRubricDelete, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$RubricsSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 5:
				if (!msg.a.$) {
					var rubric = msg.a.a;
					return _Utils_Tuple3(
						model,
						$author$project$Element$RubricsSingle$Cmd(
							$author$project$Element$RubricsSingle$NavRedirect(
								$author$project$Route$RubricsUpdate(rubric.i8))),
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$RubricsCreateError))
							}),
						$author$project$Element$RubricsSingle$Cmd(
							$author$project$Element$RubricsSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgRubricCreate, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$RubricsSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 6:
				if (!msg.a.$) {
					var rubric = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								nt: $author$project$RemoteData$Success(rubric)
							}),
						$author$project$Element$RubricsSingle$Cmd(
							$author$project$Element$RubricsSingle$FetchSubjectList(
								A3($author$project$Subject$fetchSubjectsV2, config.gX, '', $author$project$Element$RubricsSingle$SubjectListDownloaded))),
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								nt: $author$project$RemoteData$Failure(error),
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$RubricsDownloadError))
							}),
						$author$project$Element$RubricsSingle$Cmd(
							$author$project$Element$RubricsSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgRubricsDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$RubricsSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 7:
				switch (msg.a.$) {
					case 2:
						var subjects = msg.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									kb: $author$project$RemoteData$Success(subjects)
								}),
							$author$project$Element$RubricsSingle$NoEffect,
							$elm$core$Maybe$Nothing);
					case 3:
						var error = msg.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									gB: A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$SubjectListDownloadError)),
									kb: $author$project$RemoteData$Failure(error)
								}),
							$author$project$Element$RubricsSingle$Cmd(
								$author$project$Element$RubricsSingle$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgSubjectListDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$RubricsSingle$NoOp)))),
							$elm$core$Maybe$Nothing);
					default:
						return _Utils_Tuple3(model, $author$project$Element$RubricsSingle$NoEffect, $elm$core$Maybe$Nothing);
				}
			default:
				return _Utils_Tuple3(model, $author$project$Element$RubricsSingle$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Locale$Messages$SubjectListLoadingProgress = {$: 568};
var $author$project$Locale$Messages$BtnDeselect = {$: 38};
var $author$project$Locale$Messages$BtnSelect = {$: 37};
var $author$project$Element$RubricsSingle$RubricCopyRequested = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsSingle$RubricDeselected = {$: 3};
var $author$project$Element$RubricsSingle$RubricRemovalRequested = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricsSingle$RubricSelected = {$: 2};
var $author$project$Locale$Messages$RubricsBtnRemix = {$: 409};
var $author$project$ACL$canManageRubric = F2(
	function (rubric, person) {
		return A2($author$project$Person$isSamePerson, rubric.k_, person);
	});
var $author$project$UI$Icon$toggleCheck = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-check-circle'),
			attributes));
};
var $author$project$Element$RubricsSingle$viewRubricItem = F5(
	function (t_, viewer, rubric, subjects, viewMode) {
		var selectLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$RubricsSingle$RubricSelected,
			_List_fromArray(
				[
					$author$project$UI$attrCyData('rubric-item-select'),
					$elm$html$Html$Attributes$title(
					t_($author$project$Locale$Messages$BtnSelect))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$toggleCheck(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-lg'),
							$author$project$UI$Icon$style('has-text-grey-lighter')
						]))
				]));
		var highlight_ = $author$project$Element$RubricsSingle$highlight(viewMode);
		var viewMeta = $author$project$UI$mediaObjectHighlights(
			_List_fromArray(
				[
					A2(
					$author$project$UI$withHighlightedText,
					highlight_,
					A2($author$project$Person$fullName, t_, rubric.k_)),
					A2(
					$author$project$UI$caption,
					t_,
					A2(
						$author$project$Locale$Messages$TimeDateTimeFormat,
						$elm$time$Time$utc,
						$elm$time$Time$millisToPosix(rubric.mp)))
				]));
		var viewTitle = A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('title is-size-6 mb-2')
				]),
			_List_fromArray(
				[
					function () {
					switch (viewMode.$) {
						case 0:
							return A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$author$project$Route$href(
										$author$project$Route$RubricsView(rubric.i8))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(rubric.kj)
									]));
						case 1:
							return A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$author$project$Route$href(
										$author$project$Route$RubricsView(rubric.i8))
									]),
								_List_fromArray(
									[
										A2($author$project$UI$withHighlightedText, highlight_, rubric.kj)
									]));
						default:
							return A2($author$project$UI$withHighlightedText, highlight_, rubric.kj);
					}
				}()
				]));
		var editLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$RubricsUpdate(rubric.i8)),
					$author$project$UI$attrCyData('rubric-item-edit')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$edit(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnEdit)
				]));
		var deselectLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$RubricsSingle$RubricDeselected,
			_List_fromArray(
				[
					$author$project$UI$attrCyData('rubric-item-deselect'),
					$elm$html$Html$Attributes$title(
					t_($author$project$Locale$Messages$BtnDeselect))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$toggleCheck(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-lg'),
							$author$project$UI$Icon$style('has-text-success')
						]))
				]));
		var viewRightAction = function () {
			if (viewMode.$ === 2) {
				if (viewMode.d) {
					return deselectLink;
				} else {
					return selectLink;
				}
			} else {
				return $author$project$UI$none;
			}
		}();
		var viewMediaObject = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-2')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$UI$mediaObjectSmall,
					_List_fromArray(
						[
							$author$project$UI$gravatar(rubric.k_.O)
						]),
					_List_fromArray(
						[viewTitle, viewMeta]),
					_List_Nil,
					_List_fromArray(
						[viewRightAction]))
				]));
		var deleteLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$RubricsSingle$RubricRemovalRequested(rubric),
			_List_fromArray(
				[
					$author$project$UI$attrCyData('rubric-item-delete')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$delete(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnDelete)
				]));
		var copyLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$RubricsSingle$RubricCopyRequested(rubric),
			_List_fromArray(
				[
					$author$project$UI$attrCyData('rubric-item-copy')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-copy'),
							$author$project$UI$Icon$style('has-text-info')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricsBtnRemix)
				]));
		var viewNav = function () {
			switch (viewMode.$) {
				case 0:
					return A2(
						$author$project$UI$nav,
						_List_fromArray(
							[
								A2(
								$author$project$UI$when,
								A2($author$project$ACL$canManageRubric, rubric, viewer),
								editLink),
								A2(
								$author$project$UI$when,
								$author$project$ACL$canCreateRubric(viewer),
								copyLink),
								A2(
								$author$project$UI$when,
								A2($author$project$ACL$canManageRubric, rubric, viewer),
								deleteLink)
							]),
						_List_Nil);
				case 1:
					return $author$project$UI$none;
				default:
					return $author$project$UI$none;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$UI$attrCyData('rubrics-item'),
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					viewMediaObject,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							A4($author$project$Element$RubricsSingle$viewRubricTable, t_, rubric, subjects, highlight_)
						])),
					viewNav
				]));
	});
var $author$project$Element$RubricsSingle$viewPage = F4(
	function (_v0, rubric, subjects, viewMode) {
		var t_ = _v0.h6;
		var viewer = _v0.ok;
		return $author$project$UI$panel(
			{
				g$: _List_fromArray(
					[
						A5($author$project$Element$RubricsSingle$viewRubricItem, t_, viewer, rubric, subjects, viewMode)
					]),
				cm: 'rubrics-list',
				hl: _List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricsTitle)
					]),
				h7: _List_Nil,
				ie: 'is-primary'
			});
	});
var $author$project$Element$RubricsSingle$view = function (model) {
	var session = model.gB;
	var _v0 = _Utils_Tuple3(
		$author$project$RemoteData$toMaybe(model.nt),
		$author$project$RemoteData$toMaybe(model.kb),
		model.oi);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			switch (_v0.c.$) {
				case 0:
					var rubric = _v0.a.a;
					var subjects = _v0.b.a;
					return A4($author$project$Element$RubricsSingle$viewPage, session, rubric, subjects, model.oi);
				case 1:
					var rubric = _v0.a.a;
					var subjects = _v0.b.a;
					var _v1 = _v0.c;
					return A5($author$project$Element$RubricsSingle$viewRubricItem, session.h6, session.ok, rubric, subjects, model.oi);
				default:
					var rubric = _v0.a.a;
					var subjects = _v0.b.a;
					var _v2 = _v0.c;
					return A5($author$project$Element$RubricsSingle$viewRubricItem, session.h6, session.ok, rubric, subjects, model.oi);
			}
		} else {
			var _v4 = _v0.b;
			return A2(
				$author$project$UI$progressBar,
				'is-primary',
				session.h6($author$project$Locale$Messages$SubjectListLoadingProgress));
		}
	} else {
		var _v3 = _v0.a;
		return A2(
			$author$project$UI$progressBar,
			'is-primary',
			session.h6($author$project$Locale$Messages$RubricsLoadingProgress));
	}
};
var $author$project$Element$RubricsSingle$element = {jb: $author$project$Element$RubricsSingle$init, hP: $author$project$Element$RubricsSingle$perform, ks: $author$project$Element$RubricsSingle$update, og: $author$project$Element$RubricsSingle$view};
var $author$project$Element$RubricsList$singleElement = function (rubricId) {
	return {
		ha: $author$project$Element$RubricsSingle$element,
		kk: $author$project$Element$RubricsList$SingleElementEffect(rubricId),
		cf: $author$project$Element$RubricsList$SingleElementMsg(rubricId),
		kt: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						cP: A3(
							$elm$core$Dict$update,
							rubricId,
							$elm$core$Basics$always(
								$elm$core$Maybe$Just(model)),
							containerModel.cP)
					});
			})
	};
};
var $author$project$Element$RubricsList$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$RubricsList$perform(key),
						effects));
			case 2:
				var cmd = effect.a;
				switch (cmd.$) {
					case 0:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 1:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 2:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					default:
						var seconds = cmd.a;
						var toMsg = cmd.b;
						return A2($author$project$Util$Delay$after, seconds, toMsg);
				}
			default:
				var rubricId = effect.a;
				var elementEffect = effect.b;
				return A3(
					$author$project$Application$V3$Boundaries$performElement,
					key,
					elementEffect,
					$author$project$Element$RubricsList$singleElement(rubricId));
		}
	});
var $author$project$Element$RubricsList$CreateRubric = {$: 2};
var $author$project$Element$RubricsList$Delay = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Element$RubricsList$DelayedGotListQuery = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricsList$Exit = {$: 0};
var $author$project$Element$RubricsList$LogError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricsList$NoEffect = {$: 0};
var $author$project$Element$RubricsList$NoOp = {$: 9};
var $author$project$Element$RubricsList$SelectedRubrics = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsList$Selector = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsList$emptyResults = function (model) {
	return _Utils_update(
		model,
		{fq: $elm$core$Maybe$Nothing});
};
var $author$project$Element$RubricsList$filterRubrics = F2(
	function (model, newFilter) {
		var newModel = $author$project$Element$RubricsList$emptyResults(
			_Utils_update(
				model,
				{ad: newFilter}));
		return _Utils_Tuple3(
			newModel,
			$author$project$Element$RubricsList$BatchEffect(
				_List_fromArray(
					[
						$author$project$Element$RubricsList$Cmd(
						$author$project$Element$RubricsList$FetchRubrics(
							A3(
								$author$project$Rubric$fetchRubricsV2,
								model.b_.gX,
								$author$project$Element$RubricsList$asListParams(newModel),
								$author$project$Element$RubricsList$RubricsListDownloaded))),
						$author$project$Element$RubricsList$Cmd(
						$author$project$Element$RubricsList$FetchSubjects(
							A3($author$project$Subject$fetchSubjectsV2, model.b_.gX, '', $author$project$Element$RubricsList$SubjectListDownloaded)))
					])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$RubricsSingle$ListItem = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Element$RubricsList$batchEffect = F2(
	function (newEffect, effect) {
		switch (effect.$) {
			case 0:
				return newEffect;
			case 1:
				var effects = effect.a;
				return $author$project$Element$RubricsList$BatchEffect(
					A2($elm$core$List$cons, newEffect, effects));
			case 2:
				return $author$project$Element$RubricsList$BatchEffect(
					_List_fromArray(
						[newEffect, effect]));
			default:
				return $author$project$Element$RubricsList$BatchEffect(
					_List_fromArray(
						[newEffect, effect]));
		}
	});
var $author$project$Element$RubricsList$initRubricsSingles = F2(
	function (model, rubrics) {
		var subjects = A2($author$project$RemoteData$withDefault, _List_Nil, model.kb);
		var makeParams = function (rubric) {
			var _v4 = model.oi;
			if (!_v4.$) {
				return A3($author$project$Element$RubricsSingle$ListItem, rubric, subjects, model.bF);
			} else {
				var selected = _v4.a;
				return A4(
					$author$project$Element$RubricsSingle$SelectableListItem,
					rubric,
					subjects,
					model.bF,
					A2($elm$core$List$member, rubric, selected));
			}
		};
		var initRubricSingle = F2(
			function (rubric, _v3) {
				var model_ = _v3.a;
				var effect_ = _v3.b;
				var single = $author$project$Element$RubricsList$singleElement(rubric.i8);
				var params = makeParams(rubric);
				var _v2 = A3(
					$author$project$Application$V3$Boundaries$mapElement,
					model_,
					single,
					A4($author$project$Application$V3$Boundaries$initElement, model_.b_, model_.gB, single, params));
				var model2 = _v2.a;
				var effect2 = _v2.b;
				return _Utils_Tuple3(
					model2,
					A2($author$project$Element$RubricsList$batchEffect, effect2, effect_),
					$elm$core$Maybe$Nothing);
			});
		var filterRubricsForSelected = function (selected) {
			return A2(
				$elm$core$List$filter,
				function (r) {
					return A2($elm$core$List$member, r, selected);
				},
				rubrics);
		};
		var addSelectedRubrics = F2(
			function (selected, rubrics_) {
				return $author$project$Util$List$unique(
					_Utils_ap(rubrics_, selected));
			});
		var allRubricsToShow = function () {
			var _v0 = _Utils_Tuple2(model.ad, model.oi);
			if (_v0.b.$ === 1) {
				if (_v0.a === 2) {
					var _v1 = _v0.a;
					var selected = _v0.b.a;
					return A2(
						addSelectedRubrics,
						selected,
						filterRubricsForSelected(selected));
				} else {
					var selected = _v0.b.a;
					return A2(addSelectedRubrics, selected, rubrics);
				}
			} else {
				return rubrics;
			}
		}();
		var startModel = _Utils_update(
			model,
			{
				fq: $elm$core$Maybe$Just(allRubricsToShow)
			});
		return A3(
			$elm$core$List$foldl,
			initRubricSingle,
			_Utils_Tuple3(startModel, $author$project$Element$RubricsList$NoEffect, $elm$core$Maybe$Nothing),
			allRubricsToShow);
	});
var $author$project$Element$RubricsList$listQueryDelaySeconds = 0.5;
var $author$project$Element$RubricsList$update = F2(
	function (msg, model) {
		var config = model.b_;
		var session = model.gB;
		var t_ = session.h6;
		switch (msg.$) {
			case 0:
				var filter = msg.a;
				return A2($author$project$Element$RubricsList$filterRubrics, model, filter);
			case 1:
				var query = msg.a;
				var newModel = $author$project$Element$RubricsList$emptyResults(
					_Utils_update(
						model,
						{bF: query}));
				return _Utils_Tuple3(
					newModel,
					$author$project$Element$RubricsList$Cmd(
						A2(
							$author$project$Element$RubricsList$Delay,
							$author$project$Element$RubricsList$listQueryDelaySeconds,
							$author$project$Element$RubricsList$DelayedGotListQuery(query))),
					$elm$core$Maybe$Nothing);
			case 2:
				var newQuery = msg.a;
				var listParams = $author$project$Element$RubricsList$asListParams(model);
				return _Utils_Tuple3(
					model,
					_Utils_eq(newQuery, model.bF) ? $author$project$Element$RubricsList$Cmd(
						$author$project$Element$RubricsList$FetchRubrics(
							A3($author$project$Rubric$fetchRubricsV2, config.gX, listParams, $author$project$Element$RubricsList$RubricsListDownloaded))) : $author$project$Element$RubricsList$NoEffect,
					$elm$core$Maybe$Nothing);
			case 5:
				var rubricId = msg.a;
				var singleMsg = msg.b;
				var updateSingleElement = F2(
					function (singleModel_, single) {
						var _v1 = A3(
							$author$project$Application$V3$Boundaries$mapElement,
							model,
							single,
							A4($author$project$Application$V3$Boundaries$updateElement, session, singleMsg, singleModel_, single));
						var model2 = _v1.a;
						var effect = _v1.b;
						var reply = _v1.c;
						var noop = _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
						var _v2 = _Utils_Tuple2(reply, model2.oi);
						if (!_v2.a.$) {
							switch (_v2.a.a.$) {
								case 2:
									if (!_v2.b.$) {
										var _v3 = _v2.a.a;
										var _v4 = _v2.b;
										return _Utils_Tuple3(
											_Utils_update(
												model2,
												{
													cP: A2($elm$core$Dict$remove, rubricId, model.cP)
												}),
											effect,
											$elm$core$Maybe$Nothing);
									} else {
										var _v5 = _v2.a.a;
										return noop;
									}
								case 0:
									if (_v2.b.$ === 1) {
										var rubric = _v2.a.a.a;
										var selected = _v2.b.a;
										return _Utils_Tuple3(
											_Utils_update(
												model2,
												{
													oi: $author$project$Element$RubricsList$Selector(
														A2($elm$core$List$cons, rubric, selected))
												}),
											effect,
											$elm$core$Maybe$Nothing);
									} else {
										return noop;
									}
								default:
									if (_v2.b.$ === 1) {
										var rubric = _v2.a.a.a;
										var selected = _v2.b.a;
										return _Utils_Tuple3(
											_Utils_update(
												model2,
												{
													oi: $author$project$Element$RubricsList$Selector(
														A2($author$project$Util$List$removeElem, rubric, selected))
												}),
											effect,
											$elm$core$Maybe$Nothing);
									} else {
										return noop;
									}
							}
						} else {
							var _v6 = _v2.a;
							return noop;
						}
					});
				var singleModel = A2($elm$core$Dict$get, rubricId, model.cP);
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(model, $author$project$Element$RubricsList$NoEffect, $elm$core$Maybe$Nothing),
					A2(
						$elm$core$Maybe$map,
						function (singleModel_) {
							return A2(
								updateSingleElement,
								singleModel_,
								$author$project$Element$RubricsList$singleElement(rubricId));
						},
						singleModel));
			case 6:
				return _Utils_Tuple3(
					model,
					$author$project$Element$RubricsList$NoEffect,
					$elm$core$Maybe$Just($author$project$Element$RubricsList$Exit));
			case 7:
				var _v7 = model.oi;
				if (_v7.$ === 1) {
					var rubrics = _v7.a;
					return _Utils_Tuple3(
						model,
						$author$project$Element$RubricsList$NoEffect,
						$elm$core$Maybe$Just(
							$author$project$Element$RubricsList$SelectedRubrics(rubrics)));
				} else {
					return _Utils_Tuple3(model, $author$project$Element$RubricsList$NoEffect, $elm$core$Maybe$Nothing);
				}
			case 8:
				return _Utils_Tuple3(
					model,
					$author$project$Element$RubricsList$NoEffect,
					$elm$core$Maybe$Just($author$project$Element$RubricsList$CreateRubric));
			case 3:
				if (!msg.a.$) {
					var rubrics = msg.a.a;
					return A2($author$project$Element$RubricsList$initRubricsSingles, model, rubrics);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$RubricsDownloadError))
							}),
						$author$project$Element$RubricsList$Cmd(
							$author$project$Element$RubricsList$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgRubricsDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$RubricsList$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 4:
				switch (msg.a.$) {
					case 2:
						var subjects = msg.a.a;
						var listParams = $author$project$Element$RubricsList$asListParams(model);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									kb: $author$project$RemoteData$Success(subjects)
								}),
							$author$project$Element$RubricsList$Cmd(
								$author$project$Element$RubricsList$FetchRubrics(
									A3($author$project$Rubric$fetchRubricsV2, model.b_.gX, listParams, $author$project$Element$RubricsList$RubricsListDownloaded))),
							$elm$core$Maybe$Nothing);
					case 3:
						var error = msg.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									gB: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$SubjectListDownloadError)),
									kb: $author$project$RemoteData$Failure(error)
								}),
							$author$project$Element$RubricsList$Cmd(
								$author$project$Element$RubricsList$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgSubjectListDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$RubricsList$NoOp)))),
							$elm$core$Maybe$Nothing);
					default:
						var subjects = msg.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kb: subjects}),
							$author$project$Element$RubricsList$NoEffect,
							$elm$core$Maybe$Nothing);
				}
			default:
				return _Utils_Tuple3(model, $author$project$Element$RubricsList$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$RubricsList$FilterSet = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricsList$GotListQuery = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsList$OpenCreatePopup = {$: 8};
var $author$project$Locale$Messages$RubricSelectorTitle = {$: 423};
var $author$project$Locale$Messages$RubricsEmptyResults = {$: 413};
var $author$project$Locale$Messages$RubricsFilterAllShared = {$: 415};
var $author$project$Locale$Messages$RubricsFilterOwnRubrics = {$: 414};
var $author$project$Locale$Messages$RubricsFilterSelected = {$: 416};
var $author$project$Locale$Messages$RubricsSearch = {$: 421};
var $author$project$Element$RubricsList$automaticallyGeneratedRubricTitle = 'Visszajelzésből automatikusan generálva';
var $author$project$Element$RubricsList$viewSingleElement = F3(
	function (session, rubric, singleModel) {
		return A3(
			$author$project$Application$V3$Boundaries$viewElement,
			session,
			singleModel,
			$author$project$Element$RubricsList$singleElement(rubric.i8));
	});
var $author$project$Element$RubricsList$viewRubricsList = function (_v0) {
	var filter = _v0.ad;
	var query = _v0.bF;
	var rubrics = _v0.fq;
	var singleElements = _v0.cP;
	var session = _v0.gB;
	var viewMode = _v0.oi;
	var viewer = session.ok;
	var viewKeyedItem = function (rubric) {
		return _Utils_Tuple2(
			$elm$core$String$fromInt(rubric.i8),
			A2(
				$author$project$UI$maybe,
				A2($elm$core$Dict$get, rubric.i8, singleElements),
				A2($author$project$Element$RubricsList$viewSingleElement, session, rubric)));
	};
	var t_ = session.h6;
	var viewCreateLink = A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$author$project$Route$href($author$project$Route$RubricsCreate),
				$author$project$UI$attrCyData('rubrics-create'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$BtnCreate))
			]),
		_List_fromArray(
			[
				$author$project$UI$Icon$add(
				_List_fromArray(
					[
						$author$project$UI$Icon$style('has-text-white')
					]))
			]));
	var viewCreatePopupLink = A3(
		$author$project$UI$actionLink,
		$author$project$Element$RubricsList$OpenCreatePopup,
		_List_fromArray(
			[
				$author$project$UI$attrCyData('rubrics-create-popup'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$BtnCreate))
			]),
		_List_fromArray(
			[
				$author$project$UI$Icon$add(
				_List_fromArray(
					[
						$author$project$UI$Icon$style('has-text-white')
					]))
			]));
	var viewFilterLinks = A3(
		$author$project$UI$List$filterBar,
		t_,
		_Utils_Tuple2($author$project$Element$RubricsList$FilterSet, filter),
		_List_fromArray(
			[
				{
				cm: 'selected',
				ad: 2,
				hv: true,
				hw: !_Utils_eq(viewMode, $author$project$Element$RubricsList$Page),
				ea: $author$project$Locale$Messages$RubricsFilterSelected
			},
				{
				cm: 'mine',
				ad: 1,
				hv: true,
				hw: $author$project$ACL$canCreateRubric(viewer),
				ea: $author$project$Locale$Messages$RubricsFilterOwnRubrics
			},
				{
				cm: 'all',
				ad: 0,
				hv: true,
				hw: $author$project$ACL$canViewRubrics(viewer),
				ea: $author$project$Locale$Messages$RubricsFilterAllShared
			}
			]));
	var viewHelpLink = A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href('https://www.loom.com/share/8860843645944c8eaef60cb14a1f152e'),
				$elm$html$Html$Attributes$target('_blank'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$RubricsHelpCreate))
			]),
		_List_fromArray(
			[
				$author$project$UI$Icon$help(
				_List_fromArray(
					[
						$author$project$UI$Icon$style('has-text-white')
					]))
			]));
	var viewHeading = function () {
		if (!viewMode.$) {
			return A2(
				$author$project$UI$levelHorizontal,
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricsTitle)
					]),
				$author$project$ACL$canCreateRubric(viewer) ? _List_fromArray(
					[viewCreateLink, viewHelpLink]) : _List_Nil);
		} else {
			return A2(
				$author$project$UI$levelHorizontal,
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricSelectorTitle)
					]),
				$author$project$ACL$canCreateRubric(viewer) ? _List_fromArray(
					[viewCreatePopupLink, viewHelpLink]) : _List_Nil);
		}
	}();
	var viewLoadingState = function () {
		if (rubrics.$ === 1) {
			return _List_fromArray(
				[$author$project$UI$List$resultsLoadingProgressBar]);
		} else {
			if (!rubrics.a.b) {
				return _List_fromArray(
					[
						A2($author$project$UI$List$emptyResultsInfo, t_, $author$project$Locale$Messages$RubricsEmptyResults)
					]);
			} else {
				return _List_Nil;
			}
		}
	}();
	var hideAutomaticallyGeneratedRubrics = function (rubrics_) {
		return A2(
			$elm$core$List$filter,
			function (r) {
				return !_Utils_eq(r.kj, $author$project$Element$RubricsList$automaticallyGeneratedRubricTitle);
			},
			rubrics_);
	};
	return $author$project$UI$keyedPanel(
		{
			g$: A2(
				$elm$core$List$cons,
				$author$project$UI$List$searchBar(
					{
						fe: $author$project$Element$RubricsList$GotListQuery,
						fj: t_($author$project$Locale$Messages$RubricsSearch),
						bF: query
					}),
				viewLoadingState),
			cm: 'rubric-list',
			hl: _List_fromArray(
				[viewHeading]),
			mm: A2(
				$elm$core$List$map,
				viewKeyedItem,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, hideAutomaticallyGeneratedRubrics, rubrics))),
			h7: viewFilterLinks,
			ie: 'is-primary has-background-white'
		});
};
var $author$project$Element$RubricsList$view = $author$project$Element$RubricsList$viewRubricsList;
var $author$project$Element$RubricsList$element = {jb: $author$project$Element$RubricsList$init, hP: $author$project$Element$RubricsList$perform, ks: $author$project$Element$RubricsList$update, og: $author$project$Element$RubricsList$view};
var $author$project$Element$ModulesMain$popups = {
	df: {
		ha: $author$project$Element$LearningGroupSelector$element,
		cf: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$PopupMsg, $author$project$Element$ModulesMain$LearningGroupSelectorMsg),
		kt: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						eq: $elm$core$Maybe$Just(
							$author$project$Element$ModulesMain$LearningGroupSelectorModel(model))
					});
			})
	},
	dx: {
		ha: $author$project$Element$RubricsForm$element,
		cf: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$PopupMsg, $author$project$Element$ModulesMain$RubricsFormMsg),
		kt: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						eq: $elm$core$Maybe$Just(
							$author$project$Element$ModulesMain$RubricsFormModel(model))
					});
			})
	},
	dz: {
		ha: $author$project$Element$RubricsList$element,
		cf: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$PopupMsg, $author$project$Element$ModulesMain$RubricsListMsg),
		kt: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						eq: $elm$core$Maybe$Just(
							$author$project$Element$ModulesMain$RubricsListModel(model))
					});
			})
	}
};
var $author$project$Element$ModulesMain$openGroupSelectorPopup = F2(
	function (formPage, _return) {
		var session = _return.gB;
		var model = _return.eh;
		var cmd = _return.dX;
		var selectedTeamId = A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$identity,
			$elm$core$String$toInt(
				formPage.bE.Q.fC(formPage.eI)));
		if (!selectedTeamId.$) {
			var teamId = selectedTeamId.a;
			var params = {Q: teamId};
			var selectorPopup = A2(
				$author$project$Application$Boundaries$andThenCmd,
				cmd,
				A3(
					$author$project$Application$V2$Boundaries$mapElement,
					A2($author$project$Application$Boundaries$save, model, session),
					$author$project$Element$ModulesMain$popups.df,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						model.b_.jk,
						$author$project$Application$V2$SharedConfig$fromV1(model.b_),
						session,
						$author$project$Element$ModulesMain$popups.df,
						params)));
			return {dX: selectorPopup.dX, eh: selectorPopup.eh, gs: $elm$core$Maybe$Nothing, gB: selectorPopup.gB};
		} else {
			return _return;
		}
	});
var $author$project$Element$ModulesMain$openRubricsListPopup = F2(
	function (formPage, _v0) {
		var session = _v0.gB;
		var model = _v0.eh;
		var cmd = _v0.dX;
		var params = $author$project$Element$RubricsList$Selector(formPage.cO);
		var openRubricsList = A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A3(
				$author$project$Application$V2$Boundaries$mapElement,
				A2($author$project$Application$Boundaries$save, model, session),
				$author$project$Element$ModulesMain$popups.dz,
				A5(
					$author$project$Application$V2$Boundaries$initElement,
					model.b_.jk,
					$author$project$Application$V2$SharedConfig$fromV1(model.b_),
					session,
					$author$project$Element$ModulesMain$popups.dz,
					params)));
		return {dX: openRubricsList.dX, eh: openRubricsList.eh, gs: $elm$core$Maybe$Nothing, gB: openRubricsList.gB};
	});
var $author$project$Element$ModulesMain$processModuleDownloadError = F3(
	function (session, model, error) {
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A3(
				$author$project$Log$error,
				model.b_,
				_Utils_Tuple3(
					$author$project$Log$msgModuleDownload,
					$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
					error),
				$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
			A2(
				$author$project$Application$Boundaries$save,
				model,
				A3(
					$author$project$Session$error,
					session,
					error,
					session.h6($author$project$Locale$Messages$ModulesDownloadError))));
	});
var $author$project$Module$ModuleUnsaved = function (id) {
	return function (title) {
		return function (description) {
			return function (goalsKnowledge) {
				return function (goalsSkills) {
					return function (goalsProduct) {
						return function (evaluation) {
							return function (materialsUrl) {
								return function (startDate) {
									return function (endDate) {
										return function (isTemplate) {
											return function (team) {
												return function (classroomCourses) {
													return function (accountableTeacher) {
														return function (teachers) {
															return function (students) {
																return function (rubrics) {
																	return function (migrationReadyAt) {
																		return {kI: accountableTeacher, Y: classroomCourses, g8: description, ly: endDate, hc: evaluation, lO: goalsKnowledge, lP: goalsProduct, lQ: goalsSkills, i8: id, mf: isTemplate, jq: materialsUrl, jr: migrationReadyAt, fq: rubrics, nN: startDate, fv: students, fx: teachers, kf: team, kj: title};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Element$ModulesMain$saveForm = F5(
	function (form, values, module_, selectedRubrics, time) {
		var fromBoolToDate = function (value) {
			return value ? $elm$core$Maybe$Just(
				$elm$time$Time$posixToMillis(time)) : $elm$core$Maybe$Nothing;
		};
		return $author$project$Module$ModuleUnsaved(
			A2(
				$elm$core$Maybe$withDefault,
				-1,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.i8;
					},
					module_)))(
			form.kj.fC(values))(
			form.g8.fC(values))(
			form.lO.fC(values))(
			form.lQ.fC(values))(
			form.lP.fC(values))(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.hc;
					},
					module_)))(
			form.jq.fC(values))(
			$author$project$Form$dateToMillis(
				form.nN.fC(values)))(
			$author$project$Form$dateToMillis(
				form.ly.fC(values)))(
			A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.mf;
					},
					module_)))(
			$author$project$Team$decodeTeamId(
				form.Q.fC(values)))(
			A2(
				$elm$core$List$filterMap,
				$elm$core$String$toInt,
				form.Y.fC(values)))(
			$author$project$Person$decodePersonId(
				form.kI.fC(values)))(
			A2(
				$elm$core$List$map,
				$author$project$Person$decodePersonId,
				form.fx.fC(values)))(
			A2(
				$elm$core$List$map,
				$author$project$Person$decodePersonId,
				form.fv.fC(values)))(selectedRubrics)(
			fromBoolToDate(
				form.at.fC(values)));
	});
var $author$project$Element$ModulesMain$toClassroomOptions = function (classrooms) {
	return $author$project$Form$toSortedSelectOptions(
		A2(
			$elm$core$List$map,
			function (course) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(course.i8),
					course.kj);
			},
			classrooms));
};
var $author$project$Element$ModulesMain$resetFormStudents = F2(
	function (session, _v0) {
		var form = _v0.a;
		var values = _v0.b;
		var studentsField = A2(
			$author$project$Form$setMultiselectSelection,
			A2($author$project$Form$toPeopleOptions, session.h6, _List_Nil),
			form.fv);
		return _Utils_Tuple2(
			_Utils_update(
				form,
				{fv: studentsField}),
			A2(form.fv.ks, _List_Nil, values));
	});
var $author$project$Element$ModulesMain$updateFormStudentsBySchool = F4(
	function (_v0, schools, students, _v1) {
		var t_ = _v0.h6;
		var form = _v1.a;
		var values = _v1.b;
		var _v2 = _Utils_Tuple2(schools, students);
		if ((_v2.a.$ === 2) && (_v2.b.$ === 2)) {
			var students_ = _v2.b.a;
			var selectedStudentIds = form.fv.fC(values);
			var schoolId = $author$project$Team$decodeTeamId(
				form.Q.fC(values));
			var schoolStudents = _Utils_eq(schoolId, $author$project$Team$blankTeamId) ? students_ : A2(
				$author$project$Person$studentsInTeams,
				_List_fromArray(
					[schoolId]),
				students_);
			var schoolStudentIds = A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.i8;
					},
					$elm$core$String$fromInt),
				schoolStudents);
			var selectedStudentIds2 = $elm$core$List$isEmpty(selectedStudentIds) ? schoolStudentIds : A2(
				$elm$core$List$filter,
				function (studentId) {
					return A2($elm$core$List$member, studentId, schoolStudentIds);
				},
				selectedStudentIds);
			var selectedStudents = A2(
				$elm$core$List$filter,
				function (student) {
					return A2(
						$elm$core$List$member,
						$elm$core$String$fromInt(student.i8),
						schoolStudentIds);
				},
				students_);
			var studentsOptions = A2($author$project$Form$toPeopleOptions, t_, selectedStudents);
			var multiselectStudentsField = $author$project$Form$markEdited(
				A2($author$project$Form$setMultiselectOptions, studentsOptions, form.fv));
			return _Utils_Tuple2(
				_Utils_update(
					form,
					{fv: multiselectStudentsField}),
				A2(form.fv.ks, selectedStudentIds2, values));
		} else {
			return _Utils_Tuple2(form, values);
		}
	});
var $author$project$Person$teachersInTeams = F2(
	function (teamIds, people) {
		return A2(
			$elm$core$List$filter,
			function (person) {
				return A2(
					$elm$core$List$any,
					function (teamId) {
						return A2($author$project$Person$teachesAt, teamId, person);
					},
					teamIds);
			},
			people);
	});
var $author$project$Element$ModulesMain$toTeacherOptions = F3(
	function (t_, viewer, people) {
		return A2(
			$author$project$Form$toPeopleOptions,
			t_,
			A2(
				$author$project$Person$teachersInTeams,
				$author$project$Person$teamsAsTeacher(viewer),
				people));
	});
var $author$project$Element$ModulesMain$updateFormTeachersBySchool = F4(
	function (_v0, schools, teachers, _v1) {
		var viewer = _v0.ok;
		var t_ = _v0.h6;
		var form = _v1.a;
		var values = _v1.b;
		var _v2 = _Utils_Tuple2(schools, teachers);
		if ((_v2.a.$ === 2) && (_v2.b.$ === 2)) {
			var teachers_ = _v2.b.a;
			var selectedTeacherIds = form.fx.fC(values);
			var selectedAccountableTeacherId = form.kI.fC(values);
			var schoolId = $author$project$Team$decodeTeamId(
				form.Q.fC(values));
			var schoolTeachers = _Utils_eq(schoolId, $author$project$Team$blankTeamId) ? teachers_ : A2(
				$author$project$Person$teachersInTeams,
				_List_fromArray(
					[schoolId]),
				teachers_);
			var schoolTeacherIds = A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.i8;
					},
					$elm$core$String$fromInt),
				schoolTeachers);
			var selectedAccountableTeacherId2 = A2($elm$core$List$member, selectedAccountableTeacherId, schoolTeacherIds) ? selectedAccountableTeacherId : '';
			var selectedTeacherIds2 = A2(
				$elm$core$List$filter,
				function (teacherId) {
					return A2($elm$core$List$member, teacherId, schoolTeacherIds);
				},
				selectedTeacherIds);
			var teachersField = $author$project$Form$markEdited(
				A2(
					$author$project$Form$fillFieldOptions,
					A3($author$project$Element$ModulesMain$toTeacherOptions, t_, viewer, schoolTeachers),
					form.fx));
			var accountableTeacherField = $author$project$Form$markEdited(
				A2(
					$author$project$Form$fillFieldOptions,
					A3($author$project$Element$ModulesMain$toTeacherOptions, t_, viewer, schoolTeachers),
					form.kI));
			return _Utils_Tuple2(
				_Utils_update(
					form,
					{kI: accountableTeacherField, fx: teachersField}),
				A2(
					form.kI.ks,
					selectedAccountableTeacherId2,
					A2(form.fx.ks, selectedTeacherIds2, values)));
		} else {
			return _Utils_Tuple2(form, values);
		}
	});
var $author$project$Element$ModulesMain$updateForm = F5(
	function (session, _v0, msg, form, formValues) {
		var schools = _v0.j2;
		var teachers = _v0.fx;
		var students = _v0.fv;
		switch (msg.$) {
			case 0:
				var title = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							kj: $author$project$Form$markEdited(form.kj)
						}),
					A2(form.kj.ks, title, formValues));
			case 1:
				var description = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							g8: $author$project$Form$markEdited(form.g8)
						}),
					A2(form.g8.ks, description, formValues));
			case 2:
				var url = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							jq: $author$project$Form$markEdited(form.jq)
						}),
					A2(form.jq.ks, url, formValues));
			case 3:
				var knowledge = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							lO: $author$project$Form$markEdited(form.lO)
						}),
					A2(form.lO.ks, knowledge, formValues));
			case 4:
				var skills = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							lQ: $author$project$Form$markEdited(form.lQ)
						}),
					A2(form.lQ.ks, skills, formValues));
			case 5:
				var product = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							lP: $author$project$Form$markEdited(form.lP)
						}),
					A2(form.lP.ks, product, formValues));
			case 6:
				var startDate = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							nN: $author$project$Form$markEdited(form.nN)
						}),
					A2(form.nN.ks, startDate, formValues));
			case 7:
				var endDate = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ly: $author$project$Form$markEdited(form.ly)
						}),
					A2(form.ly.ks, endDate, formValues));
			case 8:
				var teacherId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							kI: $author$project$Form$markEdited(form.kI)
						}),
					A2(form.kI.ks, teacherId, formValues));
			case 9:
				var schoolId = msg.a;
				return A2(
					$author$project$Element$ModulesMain$resetFormStudents,
					session,
					A4(
						$author$project$Element$ModulesMain$updateFormStudentsBySchool,
						session,
						schools,
						students,
						A4(
							$author$project$Element$ModulesMain$updateFormTeachersBySchool,
							session,
							schools,
							teachers,
							_Utils_Tuple2(
								_Utils_update(
									form,
									{
										Q: $author$project$Form$markEdited(form.Q)
									}),
								A2(form.Q.ks, schoolId, formValues)))));
			case 10:
				var ids = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							Y: $author$project$Form$markEdited(form.Y)
						}),
					A2(form.Y.ks, ids, formValues));
			case 11:
				var teacherIds = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							fx: $author$project$Form$markEdited(form.fx)
						}),
					A2(form.fx.ks, teacherIds, formValues));
			case 12:
				var fieldMsg = msg.a;
				var field = form.fv;
				var _v2 = A2($author$project$Form$updateMultiselectField, fieldMsg, field);
				var updatedField = _v2.a;
				var studentIds = $author$project$Form$getMultiselectFieldSelectedValues(updatedField);
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							fv: $author$project$Form$markEdited(updatedField)
						}),
					A2(form.fv.ks, studentIds, formValues));
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							at: $author$project$Form$markEdited(form.at)
						}),
					A2(form.at.ks, value, formValues));
		}
	});
var $author$project$Element$ModulesMain$toViewerSchoolOptions = F2(
	function (viewer, schools) {
		return $author$project$Form$toTeamOptions(
			A2($author$project$Person$filterPersonTeams, schools, viewer));
	});
var $author$project$Element$ModulesMain$updateFormWithSchools = F4(
	function (data, formPage, session, model) {
		var action = formPage.iq;
		var form = formPage.bE;
		var values = formPage.eI;
		var viewer = session.ok;
		var config = model.b_;
		var updatedModel = _Utils_update(
			model,
			{j2: data});
		switch (data.$) {
			case 2:
				var schools = data.a;
				var teamValue = function () {
					switch (action.$) {
						case 3:
							return form.Q.fC(values);
						case 2:
							return form.Q.fC(values);
						default:
							var _v3 = A2($author$project$Person$filterPersonTeams, schools, viewer);
							if (_v3.b && (!_v3.b.b)) {
								var school = _v3.a;
								return $elm$core$String$fromInt(
									$author$project$Team$teamIdToInt(school.i8));
							} else {
								return '';
							}
					}
				}();
				var values2 = _Utils_update(
					values,
					{Q: teamValue});
				var schoolOptions = A2($author$project$Element$ModulesMain$toViewerSchoolOptions, viewer, schools);
				var form2 = _Utils_update(
					form,
					{
						Q: A2($author$project$Form$fillFieldOptions, schoolOptions, form.Q)
					});
				var _v1 = A4(
					$author$project$Element$ModulesMain$updateFormStudentsBySchool,
					session,
					updatedModel.j2,
					updatedModel.fv,
					A4(
						$author$project$Element$ModulesMain$updateFormTeachersBySchool,
						session,
						updatedModel.j2,
						updatedModel.fx,
						_Utils_Tuple2(form2, values2)));
				var form3 = _v1.a;
				var values3 = _v1.b;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						updatedModel,
						{
							bk: $author$project$Element$ModulesMain$FormPage(
								_Utils_update(
									formPage,
									{bE: form3, eI: values3}))
						}),
					session);
			case 3:
				var error = data.a;
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A3(
						$author$project$Log$error,
						config,
						_Utils_Tuple3(
							$author$project$Log$msgTeamsDownload,
							$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
							error),
						$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
					A2(
						$author$project$Application$Boundaries$save,
						updatedModel,
						A3(
							$author$project$Session$error,
							session,
							error,
							session.h6($author$project$Locale$Messages$TeamListDownloadError))));
			case 0:
				return A2($author$project$Application$Boundaries$save, updatedModel, session);
			default:
				return A2($author$project$Application$Boundaries$save, updatedModel, session);
		}
	});
var $author$project$Element$ModulesMain$filterPersonsToSelectOptions = F3(
	function (t_, viewer, people) {
		return A2(
			$author$project$Form$toPeopleOptions,
			t_,
			A2(
				$elm$core$List$filter,
				$author$project$Person$isTeacherOf(viewer),
				people));
	});
var $author$project$Element$ModulesMain$updateFormWithStudents = F4(
	function (data, formPage, session, model) {
		var form = formPage.bE;
		var values = formPage.eI;
		var viewer = session.ok;
		var t_ = session.h6;
		var config = model.b_;
		var updatedModel = _Utils_update(
			model,
			{fv: data});
		switch (data.$) {
			case 2:
				var students = data.a;
				var studentOptions = A3($author$project$Element$ModulesMain$filterPersonsToSelectOptions, t_, viewer, students);
				var studentsField = A2($author$project$Form$setMultiselectOptions, studentOptions, form.fv);
				var form2 = _Utils_update(
					form,
					{fv: studentsField});
				var _v1 = A4(
					$author$project$Element$ModulesMain$updateFormStudentsBySchool,
					session,
					updatedModel.j2,
					updatedModel.fv,
					_Utils_Tuple2(form2, values));
				var form3 = _v1.a;
				var values2 = _v1.b;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						updatedModel,
						{
							bk: $author$project$Element$ModulesMain$FormPage(
								_Utils_update(
									formPage,
									{bE: form3, eI: values2}))
						}),
					session);
			case 3:
				var error = data.a;
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A3(
						$author$project$Log$error,
						config,
						_Utils_Tuple3(
							$author$project$Log$msgPeopleDownload,
							$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
							error),
						$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
					A2(
						$author$project$Application$Boundaries$save,
						updatedModel,
						A3(
							$author$project$Session$error,
							session,
							error,
							session.h6($author$project$Locale$Messages$PhoneBookDownloadError))));
			case 0:
				return A2($author$project$Application$Boundaries$save, updatedModel, session);
			default:
				return A2($author$project$Application$Boundaries$save, updatedModel, session);
		}
	});
var $author$project$Element$ModulesMain$updateFormWithTeachers = F4(
	function (data, formPage, session, model) {
		var action = formPage.iq;
		var form = formPage.bE;
		var values = formPage.eI;
		var viewer = session.ok;
		var config = model.b_;
		var updatedModel = _Utils_update(
			model,
			{fx: data});
		switch (data.$) {
			case 2:
				var teachers = data.a;
				var teacherOptions = A3($author$project$Element$ModulesMain$toTeacherOptions, session.h6, viewer, teachers);
				var form2 = _Utils_update(
					form,
					{
						kI: A2($author$project$Form$fillFieldOptions, teacherOptions, form.kI),
						fx: A2($author$project$Form$fillFieldOptions, teacherOptions, form.fx)
					});
				var defaultAccountableTeacherId = function () {
					if (!action.$) {
						return $elm$core$String$fromInt(viewer.i8);
					} else {
						return form.kI.fC(values);
					}
				}();
				var values2 = _Utils_update(
					values,
					{kI: defaultAccountableTeacherId});
				var _v1 = A4(
					$author$project$Element$ModulesMain$updateFormStudentsBySchool,
					session,
					updatedModel.j2,
					updatedModel.fv,
					A4(
						$author$project$Element$ModulesMain$updateFormTeachersBySchool,
						session,
						updatedModel.j2,
						updatedModel.fx,
						_Utils_Tuple2(form2, values2)));
				var form3 = _v1.a;
				var values3 = _v1.b;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						updatedModel,
						{
							bk: $author$project$Element$ModulesMain$FormPage(
								_Utils_update(
									formPage,
									{bE: form3, eI: values3}))
						}),
					session);
			case 3:
				var error = data.a;
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A3(
						$author$project$Log$error,
						config,
						_Utils_Tuple3(
							$author$project$Log$msgPeopleDownload,
							$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
							error),
						$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
					A2(
						$author$project$Application$Boundaries$save,
						updatedModel,
						A3(
							$author$project$Session$error,
							session,
							error,
							session.h6($author$project$Locale$Messages$PhoneBookDownloadError))));
			case 0:
				return A2($author$project$Application$Boundaries$save, updatedModel, session);
			default:
				return A2($author$project$Application$Boundaries$save, updatedModel, session);
		}
	});
var $author$project$Module$updateModule = F3(
	function (config, module_, callback) {
		return A5(
			$author$project$Api$put,
			A2(
				$author$project$Api$Endpoint$module_,
				config,
				$author$project$Module$moduleIdToInt(module_.i8)),
			config,
			$elm$http$Http$jsonBody(
				$author$project$Module$moduleEncoder(module_)),
			callback,
			$author$project$Module$moduleDetailedDecoder);
	});
var $author$project$Element$ModulesMain$closePopup = function (_return) {
	return A2(
		$author$project$Application$Boundaries$mapModel,
		function (model_) {
			return _Utils_update(
				model_,
				{eq: $elm$core$Maybe$Nothing});
		},
		_return);
};
var $author$project$Utils$mergeIntoSet = F2(
	function (targetList, sourceList) {
		var initialList = targetList;
		var newList = A3(
			$elm$core$List$foldl,
			F2(
				function (item, acc) {
					return A2($elm$core$List$member, item, acc) ? acc : A2($elm$core$List$cons, item, acc);
				}),
			initialList,
			sourceList);
		return newList;
	});
var $author$project$Element$ModulesMain$openRubricsFormPopup = F2(
	function (params, _v0) {
		var session = _v0.gB;
		var model = _v0.eh;
		var cmd = _v0.dX;
		var openRubricsForm = A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A3(
				$author$project$Application$V2$Boundaries$mapElement,
				A2($author$project$Application$Boundaries$save, model, session),
				$author$project$Element$ModulesMain$popups.dx,
				A5(
					$author$project$Application$V2$Boundaries$initElement,
					model.b_.jk,
					$author$project$Application$V2$SharedConfig$fromV1(model.b_),
					session,
					$author$project$Element$ModulesMain$popups.dx,
					params)));
		return {dX: openRubricsForm.dX, eh: openRubricsForm.eh, gs: $elm$core$Maybe$Nothing, gB: openRubricsForm.gB};
	});
var $author$project$Element$ModulesMain$updatePopup = F4(
	function (popupMsg, page, session, model) {
		var config = model.b_;
		var _v0 = _Utils_Tuple3(popupMsg, model.eq, page);
		_v0$3:
		while (true) {
			if ((!_v0.b.$) && (_v0.c.$ === 3)) {
				switch (_v0.a.$) {
					case 1:
						if (_v0.b.a.$ === 1) {
							var rubricsFormMsg = _v0.a.a;
							var rubricsFormModel = _v0.b.a.a;
							var formPage = _v0.c.a;
							var _return = A3(
								$author$project$Application$V2$Boundaries$mapElement,
								A2($author$project$Application$Boundaries$save, model, session),
								$author$project$Element$ModulesMain$popups.dx,
								A5($author$project$Application$V2$Boundaries$updateElement, config.jk, session, rubricsFormMsg, rubricsFormModel, $author$project$Element$ModulesMain$popups.dx));
							var _v1 = _return.gs;
							if (!_v1.$) {
								var _v2 = _v1.a;
								return A2($author$project$Element$ModulesMain$openRubricsListPopup, formPage, _return);
							} else {
								return {dX: _return.dX, eh: _return.eh, gs: $elm$core$Maybe$Nothing, gB: _return.gB};
							}
						} else {
							break _v0$3;
						}
					case 0:
						if (!_v0.b.a.$) {
							var rubricsListMsg = _v0.a.a;
							var rubricsListModel = _v0.b.a.a;
							var formPage = _v0.c.a;
							var _return = A5($author$project$Application$V2$Boundaries$updateElement, model.b_.jk, session, rubricsListMsg, rubricsListModel, $author$project$Element$ModulesMain$popups.dz);
							var _v3 = _return.gs;
							if (!_v3.$) {
								var reply = _v3.a;
								switch (reply.$) {
									case 1:
										var rubrics = reply.a;
										var hasChanged = !_Utils_eq(rubrics, formPage.cO);
										var newFormState = hasChanged ? 1 : formPage.fs;
										var page2 = $author$project$Element$ModulesMain$FormPage(
											_Utils_update(
												formPage,
												{cO: rubrics, fs: newFormState}));
										return $author$project$Element$ModulesMain$closePopup(
											A2(
												$author$project$Application$Boundaries$save,
												_Utils_update(
													model,
													{bk: page2}),
												_return.gB));
									case 2:
										return A2(
											$author$project$Element$ModulesMain$openRubricsFormPopup,
											{mc: true, nt: $elm$core$Maybe$Nothing},
											A2($author$project$Application$Boundaries$save, model, _return.gB));
									default:
										return $author$project$Element$ModulesMain$closePopup(
											A2($author$project$Application$Boundaries$save, model, _return.gB));
								}
							} else {
								var rubricsListReturn = A3(
									$author$project$Application$V2$Boundaries$mapElement,
									A2($author$project$Application$Boundaries$save, model, session),
									$author$project$Element$ModulesMain$popups.dz,
									_return);
								return {dX: rubricsListReturn.dX, eh: rubricsListReturn.eh, gs: $elm$core$Maybe$Nothing, gB: rubricsListReturn.gB};
							}
						} else {
							break _v0$3;
						}
					default:
						if (_v0.b.a.$ === 2) {
							var groupSelectorMsg = _v0.a.a;
							var groupSelectorModel = _v0.b.a.a;
							var formPage = _v0.c.a;
							var _return = A5($author$project$Application$V2$Boundaries$updateElement, model.b_.jk, session, groupSelectorMsg, groupSelectorModel, $author$project$Element$ModulesMain$popups.df);
							var _v5 = _return.gs;
							if (!_v5.$) {
								var reply = _v5.a;
								if (reply.$ === 1) {
									var students = reply.a;
									var values = formPage.eI;
									var newSelectedStudents = A2(
										$author$project$Utils$mergeIntoSet,
										A2(
											$elm$core$List$map,
											function (person) {
												return $elm$core$String$fromInt(person.i8);
											},
											students),
										formPage.bE.fv.fC(formPage.eI));
									var newSelectedStudentIDs = A2(
										$elm$core$List$map,
										function (id) {
											return $author$project$Person$decodePersonId(id);
										},
										newSelectedStudents);
									var newSelectedStudents_ = A2(
										$elm$core$List$filter,
										function (student) {
											return A2($elm$core$List$member, student.i8, newSelectedStudentIDs);
										},
										A2($author$project$RemoteData$withDefault, _List_Nil, model.fv));
									var form = formPage.bE;
									var schoolId = $author$project$Team$decodeTeamId(
										form.Q.fC(values));
									var optionalStudents = A2(
										$author$project$Person$studentsInTeams,
										_List_fromArray(
											[schoolId]),
										A2($author$project$RemoteData$withDefault, _List_Nil, model.fv));
									var studentOptions = A2($author$project$Form$toPeopleOptions, session.h6, optionalStudents);
									var multiselectModuleField = A2(
										$author$project$Form$setMultiselectSelection,
										A2($author$project$Form$toPeopleOptions, session.h6, newSelectedStudents_),
										A2($author$project$Form$setMultiselectOptions, studentOptions, form.fv));
									var page2 = $author$project$Element$ModulesMain$FormPage(
										_Utils_update(
											formPage,
											{
												bE: _Utils_update(
													form,
													{fv: multiselectModuleField}),
												fs: 1,
												eI: _Utils_update(
													values,
													{fv: newSelectedStudents})
											}));
									return $author$project$Element$ModulesMain$closePopup(
										A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{bk: page2}),
											_return.gB));
								} else {
									return $author$project$Element$ModulesMain$closePopup(
										A2($author$project$Application$Boundaries$save, model, _return.gB));
								}
							} else {
								var studentsReturn = A3(
									$author$project$Application$V2$Boundaries$mapElement,
									A2($author$project$Application$Boundaries$save, model, session),
									$author$project$Element$ModulesMain$popups.df,
									_return);
								return {dX: studentsReturn.dX, eh: studentsReturn.eh, gs: $elm$core$Maybe$Nothing, gB: studentsReturn.gB};
							}
						} else {
							break _v0$3;
						}
				}
			} else {
				break _v0$3;
			}
		}
		return A2($author$project$Application$Boundaries$save, model, session);
	});
var $author$project$Element$ModulesMain$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			kI: $author$project$Form$markEdited(form.kI),
			Y: $author$project$Form$markEdited(form.Y),
			g8: $author$project$Form$markEdited(form.g8),
			ly: $author$project$Form$markEdited(form.ly),
			lO: $author$project$Form$markEdited(form.lO),
			lP: $author$project$Form$markEdited(form.lP),
			lQ: $author$project$Form$markEdited(form.lQ),
			jq: $author$project$Form$markEdited(form.jq),
			Q: $author$project$Form$markEdited(form.Q),
			nN: $author$project$Form$markEdited(form.nN),
			fv: $author$project$Form$markEdited(form.fv),
			fx: $author$project$Form$markEdited(form.fx),
			kj: $author$project$Form$markEdited(form.kj)
		});
};
var $author$project$Element$ModulesMain$update = F3(
	function (session, msg, model) {
		var viewer = session.ok;
		var config = model.b_;
		var noop = A2($author$project$Application$Boundaries$save, model, session);
		var _v0 = _Utils_Tuple2(msg, model.bk);
		_v0$44:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.a.a.$) {
						switch (_v0.b.$) {
							case 1:
								var modules = _v0.a.a.a;
								var _v1 = _v0.b;
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bk: $author$project$Element$ModulesMain$ListPage(
												A2(
													$author$project$Element$ModulesMain$addNewModules,
													modules,
													$author$project$Element$ModulesMain$emptyList(viewer)))
										}),
									session);
							case 2:
								var modules = _v0.a.a.a;
								var listPage = _v0.b.a;
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bk: $author$project$Element$ModulesMain$ListPage(
												A2($author$project$Element$ModulesMain$addNewModules, modules, listPage))
										}),
									session);
							default:
								break _v0$44;
						}
					} else {
						var error = _v0.a.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgModulesDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
									error),
								$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$ModulesDownloadError))));
					}
				case 1:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 1) {
							var module_ = _v0.a.a.a;
							var _v2 = _v0.b;
							return A4(
								$author$project$Element$ModulesMain$buildFormPageFromModule,
								session,
								model,
								$author$project$Element$ModulesMain$Update(module_),
								module_);
						} else {
							break _v0$44;
						}
					} else {
						var error = _v0.a.a.a;
						return A3($author$project$Element$ModulesMain$processModuleDownloadError, session, model, error);
					}
				case 2:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 1) {
							var module_ = _v0.a.a.a;
							var _v3 = _v0.b;
							var copy = _Utils_update(
								module_,
								{
									kj: session.h6(
										$author$project$Locale$Messages$ModulesCopyTitle(module_.kj))
								});
							return A4(
								$author$project$Element$ModulesMain$buildFormPageFromModule,
								session,
								model,
								$author$project$Element$ModulesMain$CreateFromDuplicate(module_),
								copy);
						} else {
							break _v0$44;
						}
					} else {
						var error = _v0.a.a.a;
						return A3($author$project$Element$ModulesMain$processModuleDownloadError, session, model, error);
					}
				case 3:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 1) {
							var module_ = _v0.a.a.a;
							var _v4 = _v0.b;
							return A4($author$project$Element$ModulesMain$buildFormPageFromModule, session, model, $author$project$Element$ModulesMain$CreateFromTemplate, module_);
						} else {
							break _v0$44;
						}
					} else {
						var error = _v0.a.a.a;
						return A3($author$project$Element$ModulesMain$processModuleDownloadError, session, model, error);
					}
				case 6:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 3) {
							var classrooms = _v0.a.a.a;
							var formPage = _v0.b.a;
							var form = formPage.bE;
							var page = $author$project$Element$ModulesMain$FormPage(
								_Utils_update(
									formPage,
									{
										bE: _Utils_update(
											form,
											{
												Y: A2(
													$author$project$Form$fillFieldOptions,
													$author$project$Element$ModulesMain$toClassroomOptions(classrooms),
													form.Y)
											})
									}));
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{g2: classrooms, bk: page}),
								session);
						} else {
							var classrooms = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{g2: classrooms}),
								session);
						}
					} else {
						var error = _v0.a.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgClassroomsDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
									error),
								$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$ClassroomCourseListDownloadError))));
					}
				case 5:
					if (_v0.b.$ === 3) {
						var data = _v0.a.a;
						var formPage = _v0.b.a;
						return A4($author$project$Element$ModulesMain$updateFormWithSchools, data, formPage, session, model);
					} else {
						var data = _v0.a.a;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{j2: data}),
							session);
					}
				case 7:
					if (_v0.b.$ === 3) {
						var data = _v0.a.a;
						var formPage = _v0.b.a;
						return A4($author$project$Element$ModulesMain$updateFormWithTeachers, data, formPage, session, model);
					} else {
						var data = _v0.a.a;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{fx: data}),
							session);
					}
				case 8:
					if (_v0.b.$ === 3) {
						var data = _v0.a.a;
						var formPage = _v0.b.a;
						return A4($author$project$Element$ModulesMain$updateFormWithStudents, data, formPage, session, model);
					} else {
						var data = _v0.a.a;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{fv: data}),
							session);
					}
				case 9:
					var data = _v0.a.a;
					var page = _v0.b;
					var updatedModel = _Utils_update(
						model,
						{kb: data});
					var _v5 = _Utils_Tuple2(data, page);
					if (_v5.a.$ === 3) {
						var error = _v5.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgSubjectListDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
									error),
								$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								updatedModel,
								A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$SubjectListDownloadError))));
					} else {
						return A2($author$project$Application$Boundaries$save, updatedModel, session);
					}
				case 4:
					if (_v0.b.$ === 3) {
						var data = _v0.a.a;
						var formpage = _v0.b.a;
						switch (data.$) {
							case 2:
								var events = data.a;
								var _v7 = formpage.iq;
								if (_v7.$ === 1) {
									return A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bk: $author$project$Element$ModulesMain$FormPage(
													_Utils_update(
														formpage,
														{cs: false}))
											}),
										session);
								} else {
									return A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bk: $author$project$Element$ModulesMain$FormPage(
													_Utils_update(
														formpage,
														{
															cs: !$elm$core$List$isEmpty(events)
														}))
											}),
										session);
								}
							case 3:
								var error = data.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgModuleEventsDownload,
											$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
											error),
										$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.h6($author$project$Locale$Messages$ModuleEventsDownloadError))));
							default:
								return noop;
						}
					} else {
						break _v0$44;
					}
				case 16:
					if (_v0.b.$ === 2) {
						var _v8 = _v0.a;
						var listPage = _v0.b.a;
						var listParams = $author$project$Element$ModulesMain$asListParams(listPage);
						var _v9 = listPage.dj;
						if (_v9.$ === 1) {
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3($author$project$Module$fetchModules_, config.gX, listParams, $author$project$Element$ModulesMain$ModuleListDownloaded),
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bk: $author$project$Element$ModulesMain$ListPage(
												_Utils_update(
													listPage,
													{dj: $author$project$Element$ModulesMain$LoadingModules}))
										}),
									session));
						} else {
							return noop;
						}
					} else {
						break _v0$44;
					}
				case 22:
					if (_v0.b.$ === 2) {
						var _v10 = _v0.a;
						var listPage = _v0.b.a;
						var filtersExpanded = listPage.e1;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									bk: $author$project$Element$ModulesMain$ListPage(
										_Utils_update(
											listPage,
											{e1: !filtersExpanded}))
								}),
							session);
					} else {
						break _v0$44;
					}
				case 23:
					if (_v0.b.$ === 2) {
						var values = _v0.a.a;
						var listPage = _v0.b.a;
						var filter = listPage.ad;
						return A4(
							$author$project$Element$ModulesMain$filterModules,
							session,
							model,
							listPage,
							_Utils_update(
								filter,
								{i4: values}));
					} else {
						break _v0$44;
					}
				case 24:
					if (_v0.b.$ === 2) {
						var values = _v0.a.a;
						var listPage = _v0.b.a;
						var filter = listPage.ad;
						var teacherIds = A2($elm$core$List$filterMap, $elm$core$String$toInt, values);
						return A4(
							$author$project$Element$ModulesMain$filterModules,
							session,
							model,
							listPage,
							_Utils_update(
								filter,
								{fx: teacherIds}));
					} else {
						break _v0$44;
					}
				case 25:
					if (_v0.b.$ === 2) {
						var values = _v0.a.a;
						var listPage = _v0.b.a;
						var filter = listPage.ad;
						var schoolIds = A2(
							$elm$core$List$filterMap,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$String$toInt,
								$elm$core$Maybe$map($elm$core$Basics$identity)),
							values);
						return A4(
							$author$project$Element$ModulesMain$filterModules,
							session,
							model,
							listPage,
							_Utils_update(
								filter,
								{j2: schoolIds}));
					} else {
						break _v0$44;
					}
				case 26:
					if (_v0.b.$ === 2) {
						var values = _v0.a.a;
						var listPage = _v0.b.a;
						var filter = listPage.ad;
						var subjectIds = A2($elm$core$List$filterMap, $elm$core$String$toInt, values);
						return A4(
							$author$project$Element$ModulesMain$filterModules,
							session,
							model,
							listPage,
							_Utils_update(
								filter,
								{kb: subjectIds}));
					} else {
						break _v0$44;
					}
				case 27:
					if (_v0.b.$ === 2) {
						var category = _v0.a.a;
						var listPage = _v0.b.a;
						var filter = listPage.ad;
						var newFilter = _Utils_update(
							filter,
							{bD: category});
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A2($author$project$Subject$fetchSubjects, config.gX, $author$project$Element$ModulesMain$SubjectListDownloaded),
							A4($author$project$Element$ModulesMain$filterModules, session, model, listPage, newFilter));
					} else {
						break _v0$44;
					}
				case 28:
					if (_v0.b.$ === 2) {
						var query = _v0.a.a;
						var listPage = _v0.b.a;
						var delayCmd = A2(
							$author$project$Util$Delay$after,
							$author$project$Util$Delay$searchBarDelay,
							$author$project$Element$ModulesMain$DelayedGotListQuery(query));
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							delayCmd,
							A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bk: $author$project$Element$ModulesMain$ListPage(
											$author$project$Element$ModulesMain$emptyResults(
												_Utils_update(
													listPage,
													{bF: query})))
									}),
								session));
					} else {
						break _v0$44;
					}
				case 29:
					if (_v0.b.$ === 2) {
						var newQuery = _v0.a.a;
						var listPage = _v0.b.a;
						var cmd = _Utils_eq(newQuery, listPage.bF) ? A3(
							$author$project$Module$fetchModules_,
							config.gX,
							$author$project$Element$ModulesMain$asListParams(listPage),
							$author$project$Element$ModulesMain$ModuleListDownloaded) : $elm$core$Platform$Cmd$none;
						return A2($author$project$Application$Boundaries$andThenCmd, cmd, noop);
					} else {
						break _v0$44;
					}
				case 15:
					if (_v0.b.$ === 3) {
						var fieldMsg = _v0.a.a;
						var formPage = _v0.b.a;
						var form = formPage.bE;
						var values = formPage.eI;
						var formPage2 = _Utils_eq(
							fieldMsg,
							$author$project$Element$ModulesMain$IsMigratable(true)) ? _Utils_update(
							formPage,
							{gf: true}) : formPage;
						var _v11 = A5($author$project$Element$ModulesMain$updateForm, session, model, fieldMsg, form, values);
						var form2 = _v11.a;
						var values2 = _v11.b;
						var page = function () {
							var dateValidation = function () {
								switch (fieldMsg.$) {
									case 6:
										return true;
									case 7:
										return true;
									default:
										return formPage2.dM.c3;
								}
							}();
							return $author$project$Element$ModulesMain$FormPage(
								_Utils_update(
									formPage2,
									{
										bE: form2,
										fs: 1,
										dM: {c3: dateValidation},
										eI: values2
									}));
						}();
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{bk: page}),
							session);
					} else {
						break _v0$44;
					}
				case 18:
					if (_v0.b.$ === 3) {
						var _v13 = _v0.a;
						return A2($author$project$Element$ModulesMain$buildFormPage, session, model);
					} else {
						break _v0$44;
					}
				case 17:
					if (_v0.b.$ === 3) {
						var asTemplate = _v0.a.a.bH;
						var formPage = _v0.b.a;
						var action = formPage.iq;
						var form = formPage.bE;
						var values = formPage.eI;
						var _v14 = _Utils_Tuple2(
							A2(
								$author$project$Element$ModulesMain$isFormValid,
								A3($author$project$Element$ModulesMain$formVariation, form, session.h6, asTemplate),
								values),
							action);
						if (_v14.a) {
							var cmd = A2($elm$core$Task$perform, $author$project$Element$ModulesMain$TimeIsNow, $elm$time$Time$now);
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								cmd,
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bk: $author$project$Element$ModulesMain$FormPage(
												_Utils_update(
													formPage,
													{bH: asTemplate}))
										}),
									session));
						} else {
							var areDatesValid = A3($author$project$Form$areDatesValid, form.nN, form.ly, values);
							var page = $author$project$Element$ModulesMain$FormPage(
								_Utils_update(
									formPage,
									{
										bE: $author$project$Element$ModulesMain$validateForm(
											A3($author$project$Element$ModulesMain$formVariation, form, session.h6, asTemplate)),
										fs: 1,
										dM: {c3: areDatesValid}
									}));
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								$author$project$Ports$scrollToFormError,
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{bk: page}),
									session));
						}
					} else {
						break _v0$44;
					}
				case 10:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 3) {
							var newModule = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								($author$project$Element$ModulesMain$isCreateAction(model) && (!newModule.mf)) ? A2(
									$elm$browser$Browser$Navigation$pushUrl,
									config.jk,
									$author$project$Route$toString(
										$author$project$Route$TimetableCreateEvent(
											{
												hb: $elm$core$Maybe$Nothing,
												js: $elm$core$Maybe$Just(
													$author$project$Module$moduleIdToInt(newModule.i8)),
												h2: $elm$core$Maybe$Nothing
											}))) : A2(
									$elm$browser$Browser$Navigation$pushUrl,
									config.jk,
									$author$project$Route$toString(
										$author$project$Route$ModulesDetail(
											$author$project$Module$moduleIdToInt(newModule.i8)))),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A2(
										$author$project$Session$ok,
										session,
										session.h6($author$project$Locale$Messages$ModulesSaveSuccess))));
						} else {
							break _v0$44;
						}
					} else {
						if (_v0.b.$ === 3) {
							var error = _v0.a.a.a;
							var formPage = _v0.b.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgModuleSave, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bk: $author$project$Element$ModulesMain$FormPage(
												_Utils_update(
													formPage,
													{fs: 3}))
										}),
									A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$FormSaveError))));
						} else {
							break _v0$44;
						}
					}
				case 14:
					if (!_v0.a.a.$) {
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								config.jk,
								$author$project$Route$toString($author$project$Route$ModulesList)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A2(
									$author$project$Session$ok,
									session,
									session.h6($author$project$Locale$Messages$ModulesDeleteSuccess))));
					} else {
						var error = _v0.a.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgModuleDelete,
									$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
									error),
								$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$ModulesDeleteError))));
					}
				case 21:
					if (_v0.b.$ === 3) {
						var time = _v0.a.a;
						var formPage = _v0.b.a;
						var action = formPage.iq;
						var form = formPage.bE;
						var values = formPage.eI;
						var selectedRubrics = formPage.cO;
						var asTemplate = formPage.bH;
						if (action.$ === 3) {
							var module_ = action.a;
							var migrationReadyAtAsPosix = A2(
								$elm$core$Maybe$withDefault,
								time,
								A2($elm$core$Maybe$map, $elm$time$Time$millisToPosix, module_.jr));
							var cmd = _Utils_eq(module_.jr, $elm$core$Maybe$Nothing) ? A3(
								$author$project$Module$updateModule,
								config.gX,
								A5(
									$author$project$Element$ModulesMain$saveForm,
									form,
									values,
									$elm$core$Maybe$Just(module_),
									selectedRubrics,
									time),
								$author$project$Element$ModulesMain$ModuleSaved) : A3(
								$author$project$Module$updateModule,
								config.gX,
								A5(
									$author$project$Element$ModulesMain$saveForm,
									form,
									values,
									$elm$core$Maybe$Just(module_),
									selectedRubrics,
									migrationReadyAtAsPosix),
								$author$project$Element$ModulesMain$ModuleSaved);
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								cmd,
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bk: $author$project$Element$ModulesMain$FormPage(
												_Utils_update(
													formPage,
													{fs: 2}))
										}),
									session));
						} else {
							var module_ = A5($author$project$Element$ModulesMain$saveForm, form, values, $elm$core$Maybe$Nothing, selectedRubrics, time);
							var cmd = A3(
								$author$project$Module$createModule,
								config.gX,
								_Utils_update(
									module_,
									{mf: asTemplate}),
								$author$project$Element$ModulesMain$ModuleSaved);
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								cmd,
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bk: $author$project$Element$ModulesMain$FormPage(
												_Utils_update(
													formPage,
													{fs: 2}))
										}),
									session));
						}
					} else {
						break _v0$44;
					}
				case 11:
					var module_ = _v0.a.a;
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								ep: $elm$core$Maybe$Just(module_)
							}),
						session);
				case 12:
					var module_ = _v0.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3($author$project$Module$deleteModule, config.gX, module_.i8, $author$project$Element$ModulesMain$ModuleDeleted),
						A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{ep: $elm$core$Maybe$Nothing}),
							session));
				case 13:
					var _v16 = _v0.a;
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{ep: $elm$core$Maybe$Nothing}),
						session);
				case 31:
					if (_v0.b.$ === 3) {
						var _v17 = _v0.a;
						var formPage = _v0.b.a;
						return A2($author$project$Element$ModulesMain$openRubricsListPopup, formPage, noop);
					} else {
						break _v0$44;
					}
				case 32:
					if (_v0.b.$ === 3) {
						var _v18 = _v0.a;
						var formPage = _v0.b.a;
						return A2($author$project$Element$ModulesMain$openGroupSelectorPopup, formPage, noop);
					} else {
						break _v0$44;
					}
				case 30:
					var popupMsg = _v0.a.a;
					var page = _v0.b;
					return A4($author$project$Element$ModulesMain$updatePopup, popupMsg, page, session, model);
				case 19:
					var moduleId = _v0.a.a;
					var toggleDropdown = function () {
						var _v19 = model.e$;
						if (!_v19.$) {
							var m = _v19.a;
							return _Utils_eq(m, moduleId) ? $author$project$Element$ModulesMain$Closed : $author$project$Element$ModulesMain$Open(moduleId);
						} else {
							return $author$project$Element$ModulesMain$Open(moduleId);
						}
					}();
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{e$: toggleDropdown}),
						session);
				default:
					break _v0$44;
			}
		}
		return noop;
	});
var $author$project$Locale$Messages$ModulesNotFound = {$: 270};
var $author$project$Element$ModulesMain$ModuleDeleteConfirmed = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$ModulesMain$ModuleDeleteDeclined = {$: 13};
var $author$project$Element$ModulesMain$viewConfirmDialog = F2(
	function (t_, module_) {
		return A4(
			$author$project$UI$confirmDialog,
			t_,
			{
				lc: $author$project$Element$ModulesMain$ModuleDeleteConfirmed(module_),
				lm: $author$project$Element$ModulesMain$ModuleDeleteDeclined
			},
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesActionDelete)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					$author$project$UI$textToHtml(
						t_(
							$author$project$Locale$Messages$ModulesDeleteHelp(module_.kj))))
				]));
	});
var $author$project$Locale$Messages$FormMultiSelectionHelp = {$: 68};
var $author$project$Element$ModulesMain$FormReset = {$: 18};
var $author$project$Element$ModulesMain$FormSubmitted = function (a) {
	return {$: 17, a: a};
};
var $author$project$Locale$Messages$ModulesBtnCreateAndAddModuleEvent = {$: 224};
var $author$project$Locale$Messages$ModulesBtnSaveAsTemplate = {$: 226};
var $author$project$Locale$Messages$ModulesFieldIsMigratableFalse = {$: 241};
var $author$project$Locale$Messages$ModulesFieldIsMigratableTrue = {$: 242};
var $author$project$Locale$Messages$ModulesGroupsBtnAdd = {$: 279};
var $author$project$Locale$Messages$ModulesHeadingCreate = {$: 282};
var $author$project$Locale$Messages$ModulesHeadingCreateFromTemplate = {$: 283};
var $author$project$Locale$Messages$ModulesHeadingEdit = {$: 281};
var $author$project$Locale$Messages$ModulesHelpCreate = {$: 266};
var $author$project$Element$ModulesMain$OpenGroupSelector = {$: 32};
var $elm$html$Html$Attributes$multiple = $elm$html$Html$Attributes$boolProperty('multiple');
var $author$project$UI$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $author$project$UI$targetSelectedOptions = function () {
	var options = A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'selectedOptions']),
		$elm$json$Json$Decode$keyValuePairs(
			A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string)));
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$map($elm$core$Tuple$second),
		options);
}();
var $author$project$UI$onMultiSelect = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'change',
		A2(
			$elm$json$Json$Decode$map,
			$author$project$UI$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $author$project$UI$targetSelectedOptions)));
};
var $author$project$UI$multiSelect_ = F3(
	function (classList_, view, options) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('control has-icons-left')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('select is-multiple'),
							$elm$html$Html$Attributes$classList(classList_)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(view.cm),
									$author$project$UI$onMultiSelect(view.mU),
									$elm$html$Html$Attributes$multiple(true),
									$author$project$UI$attrCyData(view.cm)
								]),
							A2($elm$core$List$map, $author$project$UI$selectOption, options)),
							$author$project$UI$Icon$icon(
							_List_fromArray(
								[
									$author$project$UI$Icon$face(view.e6),
									$author$project$UI$Icon$style('is-left')
								]))
						]))
				]));
	});
var $author$project$UI$multiChoiceField = F3(
	function (t_, field, values) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('has-errors', !valid)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$UI$fieldLabel, t_, field),
					function () {
					var _v0 = field.og.m_;
					if (_v0.$ === 1) {
						return $author$project$UI$Icon$loadingOptions(_List_Nil);
					} else {
						if (!_v0.a.b) {
							return A3(
								$author$project$UI$multiSelect_,
								A2($author$project$UI$validationClassList, field, values),
								field.og,
								_List_fromArray(
									[
										{
										d$: true,
										dl: A2(
											$author$project$Form$SelectOption,
											'',
											t_($author$project$Locale$Messages$FormEmptyOptions)),
										D: false
									}
									]));
						} else {
							var options = _v0.a;
							return A3(
								$author$project$UI$multiSelect_,
								A2($author$project$UI$validationClassList, field, values),
								field.og,
								A2(
									$elm$core$List$map,
									function (option) {
										return {
											d$: false,
											dl: option,
											D: A2(
												$elm$core$List$member,
												option.fC,
												field.fC(values))
										};
									},
									options));
						}
					}
				}(),
					A2($author$project$UI$validationError, field, values)
				]));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $author$project$UI$richTextEditor = F2(
	function (field, values) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		return A3(
			$elm$html$Html$node,
			'rich-text-editor',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('textarea rich-text-editor'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('is-danger', field.e0 && (!valid)),
							_Utils_Tuple2('is-success', field.e0 && valid)
						])),
					A2(
					$elm$html$Html$Attributes$property,
					'placeholder',
					$elm$json$Json$Encode$string(field.og.fj)),
					A2(
					$elm$html$Html$Attributes$property,
					'initial',
					$elm$json$Json$Encode$string(
						field.fC(values))),
					A2(
					$elm$html$Html$Events$on,
					'contentChanged',
					A2(
						$elm$json$Json$Decode$map,
						field.og.fe,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['detail']),
							$elm$json$Json$Decode$string))),
					$author$project$UI$attrCyData(field.og.cm)
				]),
			_List_Nil);
	});
var $author$project$UI$richTextEditorField = F3(
	function (t_, field, values) {
		return A4($author$project$UI$textareaFieldWrapper, t_, field, values, $author$project$UI$richTextEditor);
	});
var $author$project$Locale$Messages$ModulesRubricsBtnChoose = {$: 287};
var $author$project$Locale$Messages$ModulesRubricsBtnNew = {$: 286};
var $author$project$Locale$Messages$ModulesRubricsHeading = {$: 285};
var $author$project$Element$ModulesMain$OpenRubricsList = {$: 31};
var $author$project$Element$ModulesMain$viewRubricsList = F2(
	function (t_, rubrics) {
		var viewExcerpt = function (rubric) {
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('has-text-weight-semibold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(rubric.kj)
							])),
						$elm$html$Html$text(' ('),
						$elm$html$Html$text(
						A2(
							$elm$core$String$join,
							', ',
							A2(
								$elm$core$List$map,
								function ($) {
									return $.kj;
								},
								rubric.kU))),
						$elm$html$Html$text(')')
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('content')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('label')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesRubricsHeading)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					A2($elm$core$List$map, viewExcerpt, rubrics)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('field')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button is-link is-light'),
									$author$project$UI$attrCyData('add-rubrics'),
									$elm$html$Html$Events$onClick($author$project$Element$ModulesMain$OpenRubricsList)
								]),
							_List_fromArray(
								[
									function () {
									if (!rubrics.b) {
										return A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesRubricsBtnNew);
									} else {
										return A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesRubricsBtnChoose);
									}
								}()
								]))
						]))
				]));
	});
var $author$project$UI$Icon$info = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-info-circle'),
			attributes));
};
var $author$project$UI$withInfoText = F4(
	function (attributes, t_, message, content) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					content,
					A2(
					$elm$html$Html$div,
					attributes,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-text-link')
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$info(_List_Nil)
								])),
							A2(
							$elm$html$Html$small,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, message)
								]))
						]))
				]));
	});
var $author$project$Element$ModulesMain$viewForm = F2(
	function (t_, formPage) {
		var action = formPage.iq;
		var state = formPage.fs;
		var form = formPage.bE;
		var values = formPage.eI;
		var selectedRubrics = formPage.cO;
		var validations = formPage.dM;
		var viewTemplateButton = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('control')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-link is-light'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'is-loading',
									$author$project$Form$isProcessing(state))
								])),
							$elm$html$Html$Attributes$disabled(state !== 1),
							$author$project$UI$attrCyData('template'),
							$elm$html$Html$Events$onClick(
							$author$project$Element$ModulesMain$FormSubmitted(
								{bH: true}))
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnSaveAsTemplate)
						]))
				]));
		var validationError = function (content) {
			return (state === 1) ? (validations.c3 ? content : A3($author$project$UI$withErrorText, t_, $author$project$Locale$Messages$FormEndDateBeforeStartDate, content)) : content;
		};
		var stringFromBool = function (value) {
			return value ? 'True' : 'False';
		};
		var viewMigratableToggleButton = function () {
			var isEnabled = function () {
				switch (action.$) {
					case 3:
						var module_ = action.a;
						return (!$elm$core$List$isEmpty(
							form.fv.fC(values))) && (formPage.cs && ((!$author$project$Module$isMigrationReady(module_)) && (!module_.mf)));
					case 2:
						var module_ = action.a;
						return (!$elm$core$List$isEmpty(
							form.fv.fC(values))) && (formPage.cs && ((!$author$project$Module$isMigrationReady(module_)) && (!module_.mf)));
					default:
						return (!$elm$core$List$isEmpty(
							form.fv.fC(values))) && formPage.cs;
				}
			}();
			return $author$project$UI$columns(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'display', 'flex'),
								A2($elm$html$Html$Attributes$style, 'flex-direction', 'column')
							]),
						_List_fromArray(
							[
								A2($author$project$UI$fieldLabel, t_, form.at),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('buttons has-addons')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button is-rounded'),
												A2($elm$html$Html$Attributes$style, 'z-index', '0'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'is-selected is-link is-light',
														stringFromBool(
															form.at.fC(values)) === 'False')
													])),
												$elm$html$Html$Events$onClick(
												$author$project$Element$ModulesMain$FormMsg(
													$author$project$Element$ModulesMain$IsMigratable(false))),
												$elm$html$Html$Attributes$disabled(!isEnabled),
												$author$project$UI$attrCyData('migratable-false')
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFieldIsMigratableFalse)
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button is-rounded'),
												A2($elm$html$Html$Attributes$style, 'z-index', '0'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'is-selected is-link is-light',
														stringFromBool(
															form.at.fC(values)) === 'True')
													])),
												$elm$html$Html$Events$onClick(
												$author$project$Element$ModulesMain$FormMsg(
													$author$project$Element$ModulesMain$IsMigratable(true))),
												$elm$html$Html$Attributes$disabled(!isEnabled),
												$author$project$UI$attrCyData('migratable-true')
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFieldIsMigratableTrue)
											]))
									]))
							]))
					]));
		}();
		var createView = _List_fromArray(
			[
				A4(
				$author$project$UI$submitButton,
				t_($author$project$Locale$Messages$ModulesBtnCreateAndAddModuleEvent),
				state !== 1,
				$author$project$Form$isProcessing(state),
				$author$project$Element$ModulesMain$FormSubmitted(
					{bH: false})),
				viewTemplateButton
			]);
		var viewFormButtons = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field is-grouped')
				]),
			function () {
				switch (action.$) {
					case 0:
						return createView;
					case 2:
						return createView;
					case 1:
						return _List_fromArray(
							[
								A4(
								$author$project$UI$submitButton,
								t_($author$project$Locale$Messages$ModulesBtnCreateAndAddModuleEvent),
								state !== 1,
								$author$project$Form$isProcessing(state),
								$author$project$Element$ModulesMain$FormSubmitted(
									{bH: false}))
							]);
					default:
						var module_ = action.a;
						return _List_fromArray(
							[
								A4(
								$author$project$UI$submitButton,
								t_($author$project$Locale$Messages$BtnSave),
								state !== 1,
								$author$project$Form$isProcessing(state),
								$author$project$Element$ModulesMain$FormSubmitted(
									{bH: module_.mf})),
								A4(
								$author$project$UI$resetButton,
								t_($author$project$Locale$Messages$BtnReset),
								$author$project$Form$resetDisabled(state),
								$author$project$Form$isProcessing(state),
								$author$project$Element$ModulesMain$FormReset)
							]);
				}
			}());
		var createHeadingText = t_($author$project$Locale$Messages$ModulesHeadingCreate);
		var headingText = function () {
			switch (action.$) {
				case 0:
					return createHeadingText;
				case 2:
					return createHeadingText;
				case 1:
					return t_($author$project$Locale$Messages$ModulesHeadingCreateFromTemplate);
				default:
					return t_($author$project$Locale$Messages$ModulesHeadingEdit);
			}
		}();
		var buttonDisabled = $elm$core$String$isEmpty(
			form.Q.fC(values));
		var viewFormFields = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('heading')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(headingText)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.kj, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$richTextEditorField, t_, form.g8, values),
							A3($author$project$UI$richTextEditorField, t_, form.lO, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$richTextEditorField, t_, form.lQ, values),
							A3($author$project$UI$richTextEditorField, t_, form.lP, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.jq, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A2($author$project$Element$ModulesMain$viewRubricsList, t_, selectedRubrics)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$dateField, t_, form.nN, values),
							validationError(
							A3($author$project$UI$dateField, t_, form.ly, values))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.kI, values),
							A3($author$project$UI$choiceField, t_, form.Q, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A4(
									$author$project$UI$withInfoText,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('is-hidden-touch')
										]),
									t_,
									$author$project$Locale$Messages$FormMultiSelectionHelp,
									A3($author$project$UI$multiChoiceField, t_, form.fx, values))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A3($author$project$UI$multiselectChoiceField, t_, form.fv, values),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button is-link is-light'),
											$author$project$UI$attrCyData('add-groups'),
											$elm$html$Html$Events$onClick($author$project$Element$ModulesMain$OpenGroupSelector),
											$elm$html$Html$Attributes$disabled(buttonDisabled)
										]),
									_List_fromArray(
										[
											$author$project$UI$Icon$icon(
											_List_fromArray(
												[
													$author$project$UI$Icon$face('fa-people-group')
												])),
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesGroupsBtnAdd)
										]))
								]))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A4(
							$author$project$UI$withInfoText,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-hidden-touch')
								]),
							t_,
							$author$project$Locale$Messages$FormMultiSelectionHelp,
							A3($author$project$UI$multiChoiceField, t_, form.Y, values)),
							viewMigratableToggleButton
						]))
				]));
		return $author$project$UI$panel(
			{
				g$: _List_fromArray(
					[viewFormFields, viewFormButtons]),
				cm: 'modules-form',
				hl: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesTitle)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('https://www.loom.com/share/10dae6d08e3b44059c03a14e7368e481'),
										$elm$html$Html$Attributes$target('_blank'),
										$elm$html$Html$Attributes$title(
										t_($author$project$Locale$Messages$ModulesHelpCreate))
									]),
								_List_fromArray(
									[
										$author$project$UI$Icon$help(
										_List_fromArray(
											[
												$author$project$UI$Icon$style('has-text-info')
											]))
									]))
							]))
					]),
				h7: _List_Nil,
				ie: 'is-light'
			});
	});
var $author$project$Element$ModulesMain$FilterTemplates = 3;
var $author$project$Element$ModulesMain$GotListQuery = function (a) {
	return {$: 28, a: a};
};
var $author$project$Locale$Messages$ModulesEmptyResults = {$: 269};
var $author$project$Locale$Messages$ModulesSearch = {$: 278};
var $author$project$Element$ModulesMain$ToggleFilterPanel = {$: 22};
var $author$project$ACL$canFilterModules = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Element$ModulesMain$schoolYearRange = function (subjects) {
	var getYears = function (range) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$String$toInt,
			A2($elm$core$String$split, '-', range));
	};
	var getYearRanges = function (subject) {
		return $elm$core$List$head(
			$elm$core$List$reverse(
				A2($elm$core$String$split, '@', subject.fb)));
	};
	var years = A2(
		$elm$core$List$concatMap,
		getYears,
		A2($elm$core$List$filterMap, getYearRanges, subjects));
	var max = $elm$core$List$maximum(years);
	var min = $elm$core$List$minimum(years);
	var _v0 = _Utils_Tuple2(min, max);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var min_ = _v0.a.a;
		var max_ = _v0.b.a;
		return A2($elm$core$List$range, min_, max_);
	} else {
		return _List_Nil;
	}
};
var $author$project$Locale$Messages$ModulesFilterActive = {$: 261};
var $author$project$Locale$Messages$ModulesFilterGrades = {$: 257};
var $author$project$Locale$Messages$ModulesFilterSchools = {$: 259};
var $author$project$Locale$Messages$ModulesFilterSubjects = {$: 260};
var $author$project$Locale$Messages$ModulesFilterTeachers = {$: 258};
var $author$project$Element$ModulesMain$SetGradeFilter = function (a) {
	return {$: 23, a: a};
};
var $author$project$Element$ModulesMain$SetSchoolFilter = function (a) {
	return {$: 25, a: a};
};
var $author$project$Element$ModulesMain$SetSubjectFilter = function (a) {
	return {$: 26, a: a};
};
var $author$project$Element$ModulesMain$SetTeacherFilter = function (a) {
	return {$: 24, a: a};
};
var $author$project$Element$ModulesMain$viewActiveFilters = F2(
	function (t_, filter) {
		var viewFilterPill = F2(
			function (caption, toMsg) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('control')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tags has-addons')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$UI$tag,
									'is-info',
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, caption)
										])),
									A3(
									$author$project$UI$actionLink,
									toMsg(_List_Nil),
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('tag is-delete')
										]),
									_List_fromArray(
										[$author$project$UI$none]))
								]))
						]));
			});
		var empty = $author$project$Element$ModulesMain$emptyFilter;
		var hasActiveFilter = (!_Utils_eq(empty.i4, filter.i4)) || ((!_Utils_eq(empty.fx, filter.fx)) || ((!_Utils_eq(empty.j2, filter.j2)) || (!_Utils_eq(empty.kb, filter.kb))));
		return hasActiveFilter ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('field is-grouped is-grouped-multiline')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('heading mr-2')
							]),
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFilterActive)
							])),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.i4, filter.i4),
						A2(viewFilterPill, $author$project$Locale$Messages$ModulesFilterGrades, $author$project$Element$ModulesMain$SetGradeFilter)),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.fx, filter.fx),
						A2(viewFilterPill, $author$project$Locale$Messages$ModulesFilterTeachers, $author$project$Element$ModulesMain$SetTeacherFilter)),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.j2, filter.j2),
						A2(viewFilterPill, $author$project$Locale$Messages$ModulesFilterSchools, $author$project$Element$ModulesMain$SetSchoolFilter)),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.kb, filter.kb),
						A2(viewFilterPill, $author$project$Locale$Messages$ModulesFilterSubjects, $author$project$Element$ModulesMain$SetSubjectFilter))
					]))
			]) : _List_Nil;
	});
var $author$project$Element$ModulesMain$viewGradeFilters = F3(
	function (t_, grades, filter) {
		var viewGradeOptions = function (grades_) {
			return A2(
				$elm$core$List$map,
				A4(
					$author$project$UI$checkbox,
					$author$project$Element$ModulesMain$SetGradeFilter,
					'modules-filter-grades',
					$elm$core$Basics$always(false),
					filter.i4),
				$author$project$Form$toSelectOptions(
					A2(
						$elm$core$List$map,
						function (g) {
							return _Utils_Tuple2(
								$elm$core$String$fromInt(g),
								$elm$core$String$fromInt(g));
						},
						grades_)));
		};
		return $author$project$UI$filterOptions(
			{
				g1: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFilterGrades),
				lT: true,
				m_: grades,
				oj: viewGradeOptions
			});
	});
var $author$project$Element$ModulesMain$viewModuleDescription = function (module_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('block')
			]),
		_List_fromArray(
			[
				$author$project$Util$Html$markdownToHtml(module_.g8)
			]));
};
var $author$project$Element$ModulesMain$NavToggled = function (a) {
	return {$: 19, a: a};
};
var $author$project$Element$ModulesMain$ModuleDeleteRequested = function (a) {
	return {$: 11, a: a};
};
var $author$project$Locale$Messages$ModulesMigrationDateSet = {$: 273};
var $author$project$Element$ModulesMain$viewModuleActionLinks = F3(
	function (t_, viewer, module_) {
		var viewEditLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesUpdate(
						$author$project$Module$moduleIdToInt(module_.i8))),
					$author$project$UI$attrCyData('modules-item-edit'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$edit(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-warning')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnEdit)
				]));
		var viewDuplicateLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesDuplicate(
						$author$project$Module$moduleIdToInt(module_.i8))),
					$author$project$UI$attrCyData('modules-item-duplicate'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-clone'),
							$author$project$UI$Icon$style('has-text-grey')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnDuplicate)
				]));
		var viewDeleteLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$ModulesMain$ModuleDeleteRequested(module_),
			_List_fromArray(
				[
					$author$project$UI$attrCyData('modules-item-delete'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$delete(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnDelete)
				]));
		var viewCreateFromTemplateLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesCreateFromTemplate(
						$author$project$Module$moduleIdToInt(module_.i8))),
					$author$project$UI$attrCyData('modules-item-create'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$add(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-grey')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnCreateFromTemplate)
				]));
		var inactiveAttrsNoStudents = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('dropdown-item has-text-grey-light'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$ModulesMissingStudents))
			]);
		var inactiveAttrsNoRubrics = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('dropdown-item has-text-grey-light'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$ModulesMissingRubrics))
			]);
		var inactiveAttrsMigrationDateSet = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('dropdown-item has-text-grey-light'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$ModulesMigrationDateSet))
			]);
		var hasStudents = !$elm$core$List$isEmpty(module_.fv);
		var viewPortfolioStoryLink = function () {
			var linkAttrs = _List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$PortfoliosCreate(
						$elm$core$Maybe$Just(
							$author$project$Module$moduleIdToInt(module_.i8)))),
					$author$project$UI$attrCyData('modules-item-story'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]);
			var caption = _List_fromArray(
				[
					$author$project$UI$Icon$portfolio(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-link')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnPortfolioStory)
				]);
			return hasStudents ? A2($elm$html$Html$a, linkAttrs, caption) : A2($elm$html$Html$span, inactiveAttrsNoStudents, caption);
		}();
		var viewScheduleLink = function () {
			var linkAttrs = _List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$TimetableCreateEvent(
						{
							hb: $elm$core$Maybe$Nothing,
							js: $elm$core$Maybe$Just(
								$author$project$Module$moduleIdToInt(module_.i8)),
							h2: $elm$core$Maybe$Nothing
						})),
					$author$project$UI$attrCyData('modules-item-schedule'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]);
			if (hasStudents) {
				var caption = _List_fromArray(
					[
						$author$project$UI$Icon$moduleEvent(
						_List_fromArray(
							[
								$author$project$UI$Icon$style('has-text-info')
							])),
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnSchedule)
					]);
				return A2($elm$html$Html$a, linkAttrs, caption);
			} else {
				var caption = _List_fromArray(
					[
						$author$project$UI$Icon$moduleEvent(_List_Nil),
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnSchedule)
					]);
				return A2($elm$html$Html$span, inactiveAttrsMigrationDateSet, caption);
			}
		}();
		var hasRubrics = !$elm$core$List$isEmpty(module_.fq);
		var viewFinalEvaluationLink = function () {
			var linkAttrs = _List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesClosure(
						$author$project$Module$moduleIdToInt(module_.i8))),
					$author$project$UI$attrCyData('modules-item-evaluate'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]);
			var caption = _List_fromArray(
				[
					$author$project$UI$Icon$feedback(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnFeedback)
				]);
			return (hasStudents && hasRubrics) ? A2($elm$html$Html$a, linkAttrs, caption) : ((!hasRubrics) ? A2($elm$html$Html$span, inactiveAttrsNoRubrics, caption) : A2($elm$html$Html$span, inactiveAttrsNoStudents, caption));
		}();
		var _v0 = _Utils_Tuple3(
			module_.l9,
			$author$project$ACL$canCreateModules(viewer),
			A2($author$project$ACL$canManageModule, module_, viewer));
		_v0$5:
		while (true) {
			if (_v0.a) {
				if (_v0.b) {
					if (_v0.c) {
						return _List_fromArray(
							[viewDuplicateLink]);
					} else {
						return _List_fromArray(
							[viewDuplicateLink]);
					}
				} else {
					break _v0$5;
				}
			} else {
				if (_v0.b) {
					if (!_v0.c) {
						return _List_fromArray(
							[viewDuplicateLink]);
					} else {
						return _List_fromArray(
							[
								viewEditLink,
								A2($author$project$UI$when, module_.mf, viewCreateFromTemplateLink),
								viewDuplicateLink,
								viewFinalEvaluationLink,
								viewScheduleLink,
								viewPortfolioStoryLink,
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown-divider')
									]),
								_List_Nil),
								viewDeleteLink
							]);
					}
				} else {
					if (_v0.c) {
						return _List_fromArray(
							[
								viewEditLink,
								viewFinalEvaluationLink,
								viewScheduleLink,
								viewPortfolioStoryLink,
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown-divider')
									]),
								_List_Nil),
								viewDeleteLink
							]);
					} else {
						break _v0$5;
					}
				}
			}
		}
		return _List_Nil;
	});
var $author$project$Element$ModulesMain$viewModuleMeta = F4(
	function (session, isListItem, dropdown, module_) {
		var t_ = session.h6;
		var viewer = session.ok;
		var isActiveNav = _Utils_eq(
			dropdown,
			$author$project$Element$ModulesMain$Open(module_.i8));
		var viewActionLinksDropdown = A4(
			$author$project$UI$actionLinksDropdown,
			t_,
			isActiveNav,
			$author$project$Element$ModulesMain$NavToggled(module_.i8),
			A3($author$project$Element$ModulesMain$viewModuleActionLinks, t_, viewer, module_));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-2')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$UI$mediaObjectSmall,
					_List_fromArray(
						[
							$author$project$UI$gravatar(module_.kI.O)
						]),
					_List_fromArray(
						[
							A3($author$project$Element$ModulesMain$viewModuleTitle, session, isListItem, module_),
							A2($author$project$Element$ModulesMain$viewModuleHighlights, t_, module_)
						]),
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$when,
							A2($author$project$ACL$canManageModule, module_, viewer) || $author$project$ACL$canCreateModules(viewer),
							viewActionLinksDropdown)
						]))
				]));
	});
var $author$project$Element$ModulesMain$viewItem = F3(
	function (session, dropdown, module_) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container'),
					$author$project$UI$attrCyData('modules-item')
				]),
			_List_fromArray(
				[
					A4($author$project$Element$ModulesMain$viewModuleMeta, session, true, dropdown, module_),
					$author$project$Element$ModulesMain$viewModuleDescription(module_)
				]));
	});
var $author$project$Element$ModulesMain$viewSchoolFilters = F4(
	function (t_, viewer, maybeSchools, filter) {
		var selectedSchools = A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, $author$project$Team$teamIdToInt, $elm$core$String$fromInt),
			filter.j2);
		var viewSchoolOptions = function (schools) {
			return A2(
				$elm$core$List$map,
				A4(
					$author$project$UI$checkbox,
					$author$project$Element$ModulesMain$SetSchoolFilter,
					'modules-filter-schools',
					$elm$core$Basics$always(false),
					selectedSchools),
				$author$project$Form$toTeamOptions(schools));
		};
		var filterByCategory = function (schools) {
			var _v0 = filter.bD;
			switch (_v0) {
				case 0:
					return schools;
				case 1:
					return A2($author$project$Person$filterPersonTeams, schools, viewer);
				default:
					return _List_Nil;
			}
		};
		return $author$project$UI$filterOptions(
			{
				g1: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFilterSchools),
				lT: true,
				m_: A2($elm$core$Maybe$map, filterByCategory, maybeSchools),
				oj: viewSchoolOptions
			});
	});
var $author$project$Element$ModulesMain$viewSubjectFilters = F3(
	function (t_, maybeSubjects, filter) {
		var selectedSubjects = A2($elm$core$List$map, $elm$core$String$fromInt, filter.kb);
		var viewSubjectOptions = function (subjects) {
			return A2(
				$elm$core$List$map,
				A4(
					$author$project$UI$checkbox,
					$author$project$Element$ModulesMain$SetSubjectFilter,
					'modules-filter-subjects',
					$elm$core$Basics$always(false),
					selectedSubjects),
				$author$project$Form$toSortedSelectOptions(
					A2(
						$elm$core$List$map,
						function (s) {
							return _Utils_Tuple2(
								$elm$core$String$fromInt(s.i8),
								s.fb);
						},
						subjects)));
		};
		return $author$project$UI$filterOptions(
			{
				g1: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFilterSubjects),
				lT: true,
				m_: maybeSubjects,
				oj: viewSubjectOptions
			});
	});
var $author$project$Element$ModulesMain$FilterSchools = 1;
var $author$project$Element$ModulesMain$GotCategoryFilter = function (a) {
	return {$: 27, a: a};
};
var $author$project$Locale$Messages$ModulesFilterAll = {$: 262};
var $author$project$Locale$Messages$ModulesFilterCreator = {$: 264};
var $author$project$Locale$Messages$ModulesFilterSchool = {$: 263};
var $author$project$Locale$Messages$ModulesFilterTemplates = {$: 265};
var $author$project$ACL$canViewModulesAll = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$ACL$isAuditor(person);
};
var $author$project$Element$ModulesMain$viewTabFilters = F3(
	function (t_, viewer, _v0) {
		var category = _v0.bD;
		return A3(
			$author$project$UI$List$filterBar,
			t_,
			_Utils_Tuple2($author$project$Element$ModulesMain$GotCategoryFilter, category),
			_List_fromArray(
				[
					{
					cm: 'teacher',
					ad: 2,
					hv: true,
					hw: $author$project$ACL$canCreateModules(viewer),
					ea: $author$project$Locale$Messages$ModulesFilterCreator
				},
					{
					cm: 'school',
					ad: 1,
					hv: true,
					hw: $author$project$ACL$canCreateModules(viewer),
					ea: $author$project$Locale$Messages$ModulesFilterSchool
				},
					{
					cm: 'all',
					ad: 0,
					hv: true,
					hw: $author$project$ACL$canViewModulesAll(viewer),
					ea: $author$project$Locale$Messages$ModulesFilterAll
				},
					{
					cm: 'templates',
					ad: 3,
					hv: true,
					hw: $author$project$ACL$canCreateModules(viewer),
					ea: $author$project$Locale$Messages$ModulesFilterTemplates
				}
				]));
	});
var $author$project$Element$ModulesMain$viewTeacherFilters = F4(
	function (t_, viewer, maybeTeachers, filter) {
		var selectedTeachers = A2($elm$core$List$map, $elm$core$String$fromInt, filter.fx);
		var viewTeacherOptions = function (teachers) {
			return A2(
				$elm$core$List$map,
				A4(
					$author$project$UI$checkbox,
					$author$project$Element$ModulesMain$SetTeacherFilter,
					'modules-filter-teachers',
					$elm$core$Basics$always(false),
					selectedTeachers),
				A2($author$project$Form$toPeopleOptions, t_, teachers));
		};
		var filterByCategory = function (teachers) {
			var _v0 = filter.bD;
			switch (_v0) {
				case 0:
					return teachers;
				case 1:
					return A2(
						$author$project$Person$teachersInTeams,
						$author$project$Person$teams(viewer),
						teachers);
				default:
					return _List_Nil;
			}
		};
		return $author$project$UI$filterOptions(
			{
				g1: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFilterTeachers),
				lT: true,
				m_: A2($elm$core$Maybe$map, filterByCategory, maybeTeachers),
				oj: viewTeacherOptions
			});
	});
var $author$project$Element$ModulesMain$viewModuleList = F4(
	function (session, dropdown, store, listPage) {
		var t_ = session.h6;
		var viewer = session.ok;
		var filter = listPage.ad;
		var query = listPage.bF;
		var modules = listPage.hH;
		var filtersExpanded = listPage.e1;
		var viewLoadingState = function () {
			var _v0 = _Utils_Tuple2(listPage.dj, modules);
			if (!_v0.b.b) {
				switch (_v0.a.$) {
					case 0:
						var _v1 = _v0.a;
						return _List_fromArray(
							[$author$project$UI$List$resultsLoadingProgressBar]);
					case 1:
						return _List_fromArray(
							[
								A2($author$project$UI$List$emptyResultsInfo, t_, $author$project$Locale$Messages$ModulesEmptyResults)
							]);
					default:
						var _v2 = _v0.a;
						return _List_fromArray(
							[
								A2($author$project$UI$List$emptyResultsInfo, t_, $author$project$Locale$Messages$ModulesEmptyResults)
							]);
				}
			} else {
				return _List_Nil;
			}
		}();
		var viewKeyedItem = function (module_) {
			return _Utils_Tuple2(
				$elm$core$String$fromInt(
					$author$project$Module$moduleIdToInt(module_.i8)),
				A3($author$project$Element$ModulesMain$viewItem, session, dropdown, module_));
		};
		var viewFilterPanel = filtersExpanded ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container columns')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Element$ModulesMain$viewGradeFilters,
						t_,
						A2(
							$elm$core$Maybe$map,
							$author$project$Element$ModulesMain$schoolYearRange,
							$author$project$RemoteData$toMaybe(store.kb)),
						filter),
						A4(
						$author$project$Element$ModulesMain$viewTeacherFilters,
						t_,
						viewer,
						$author$project$RemoteData$toMaybe(store.fx),
						filter),
						A4(
						$author$project$Element$ModulesMain$viewSchoolFilters,
						t_,
						viewer,
						$author$project$RemoteData$toMaybe(store.j2),
						filter),
						A3(
						$author$project$Element$ModulesMain$viewSubjectFilters,
						t_,
						$author$project$RemoteData$toMaybe(store.kb),
						filter)
					]))
			]) : A2($author$project$Element$ModulesMain$viewActiveFilters, t_, filter);
		var viewFilterButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button'),
					$elm$html$Html$Attributes$disabled(filter.bD === 3),
					$elm$html$Html$Events$onClick($author$project$Element$ModulesMain$ToggleFilterPanel),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('is-info', filtersExpanded),
							_Utils_Tuple2('is-info is-light', !filtersExpanded)
						]))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$filter(_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnToggleFilters)
						]))
				]));
		return $author$project$UI$keyedPanel(
			{
				g$: A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('columns container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('column')
									]),
								_List_fromArray(
									[
										$author$project$UI$List$searchBar(
										{
											fe: $author$project$Element$ModulesMain$GotListQuery,
											fj: t_($author$project$Locale$Messages$ModulesSearch),
											bF: query
										})
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('column is-narrow')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$UI$when,
										$author$project$ACL$canFilterModules(viewer),
										viewFilterButton)
									]))
							])),
					_Utils_ap(
						($author$project$ACL$canFilterModules(viewer) && (filter.bD !== 3)) ? viewFilterPanel : _List_Nil,
						viewLoadingState)),
				cm: 'modules-list',
				hl: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesTitle)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$UI$when,
								$author$project$ACL$canManageModules(viewer),
								A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Route$href($author$project$Route$ModulesCreate),
											$elm$html$Html$Attributes$title(
											t_($author$project$Locale$Messages$NavModulesNew))
										]),
									_List_fromArray(
										[
											$author$project$UI$Icon$add(
											_List_fromArray(
												[
													$author$project$UI$Icon$style('has-text-white')
												]))
										])))
							]))
					]),
				mm: A2($elm$core$List$map, viewKeyedItem, modules),
				h7: A3($author$project$Element$ModulesMain$viewTabFilters, t_, viewer, filter),
				ie: 'is-info'
			});
	});
var $author$project$Locale$Messages$ModulesListLoadMore = {$: 268};
var $author$project$Element$ModulesMain$viewModuleListPager = F2(
	function (t_, _v0) {
		var loading = _v0.dj;
		var modules = _v0.hH;
		var _v1 = _Utils_Tuple2(loading, modules);
		switch (_v1.a.$) {
			case 0:
				if (!_v1.b.b) {
					var _v2 = _v1.a;
					return $author$project$UI$none;
				} else {
					var _v3 = _v1.a;
					return $author$project$UI$List$resultsLoadingProgressBar;
				}
			case 1:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container has-text-centered')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$UI$actionLink,
							$author$project$Element$ModulesMain$LoadMoreModules,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-link')
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$sync(_List_Nil),
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesListLoadMore)
								]))
						]));
			default:
				var _v4 = _v1.a;
				return $author$project$UI$none;
		}
	});
var $author$project$Element$RubricsList$PopupClosed = {$: 6};
var $author$project$Element$RubricsList$RubricsSelected = {$: 7};
var $author$project$Element$RubricsList$viewSelectorNav = function (t_) {
	return A2(
		$elm$html$Html$nav,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('navbar is-fixed-bottom has-background-link-light')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('navbar-end')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-item')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('buttons')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$UI$actionLink,
										$author$project$Element$RubricsList$RubricsSelected,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button is-link')
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnOk)
											])),
										A3(
										$author$project$UI$actionLink,
										$author$project$Element$RubricsList$PopupClosed,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button is-light')
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnCancel)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Element$RubricsList$viewPopup = function (model) {
	var session = model.gB;
	return A3(
		$author$project$UI$modalWindow,
		true,
		$author$project$Element$RubricsList$PopupClosed,
		$author$project$UI$section(
			_List_fromArray(
				[
					$author$project$Element$RubricsList$viewRubricsList(model),
					$author$project$Element$RubricsList$viewSelectorNav(session.h6)
				])));
};
var $author$project$Element$ModulesMain$viewPopup = F2(
	function (session, model) {
		var _v0 = model.eq;
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 0:
					var popupModel = _v0.a.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Element$ModulesMain$popups.dz.cf,
						$author$project$Element$RubricsList$viewPopup(
							_Utils_update(
								popupModel,
								{gB: session})));
				case 1:
					var popupModel = _v0.a.a;
					return A3($author$project$Application$V2$Boundaries$viewElement, session, popupModel, $author$project$Element$ModulesMain$popups.dx);
				default:
					var popupModel = _v0.a.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Element$ModulesMain$popups.df.cf,
						$author$project$Element$LearningGroupSelector$viewPopup(
							_Utils_update(
								popupModel,
								{gB: session})));
			}
		} else {
			return $author$project$UI$none;
		}
	});
var $author$project$Element$ModulesMain$view = F2(
	function (session, model) {
		var t_ = session.h6;
		var _v0 = model.bk;
		switch (_v0.$) {
			case 2:
				var listPage = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A4($author$project$Element$ModulesMain$viewModuleList, session, model.e$, model, listPage),
							A2($author$project$Element$ModulesMain$viewModuleListPager, t_, listPage),
							A2(
							$author$project$UI$maybe,
							model.ep,
							$author$project$Element$ModulesMain$viewConfirmDialog(t_))
						]));
			case 3:
				var formPage = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Element$ModulesMain$viewPopup, session, model),
							A2($author$project$Element$ModulesMain$viewForm, t_, formPage)
						]));
			case 0:
				return $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesNotFound)
						]));
			default:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$progressBar,
							'is-info',
							t_($author$project$Locale$Messages$ModulesLoadingProgress)),
							A2($author$project$Element$ModulesMain$viewPopup, session, model)
						]));
		}
	});
var $author$project$Element$ModulesMain$element = {jb: $author$project$Element$ModulesMain$init, ks: $author$project$Element$ModulesMain$update, og: $author$project$Element$ModulesMain$view};
var $author$project$Element$NotificationList$ActivityLogListDownloaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$NotificationList$TimeIsNow = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$NotificationList$init = F3(
	function (config, session, _v0) {
		var model = {fG: $elm$core$Maybe$Nothing, b_: config, fd: $elm$core$Maybe$Nothing};
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Task$perform, $author$project$Element$NotificationList$TimeIsNow, $elm$time$Time$now),
					A2($author$project$ActivityLog$fetchActivityLogs, config.gX, $author$project$Element$NotificationList$ActivityLogListDownloaded)
				]));
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A2($author$project$Application$Boundaries$save, model, session));
	});
var $author$project$Element$NotificationList$NoOp = {$: 1};
var $author$project$Log$paramScopeNotifications = 'scope_notifications';
var $author$project$Element$NotificationList$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var list = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								fG: $elm$core$Maybe$Just(list)
							}),
						session);
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							model.b_,
							_Utils_Tuple3(
								$author$project$Log$msgActivityLogsDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeNotifications),
								error),
							$elm$core$Basics$always($author$project$Element$NotificationList$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								session.h6($author$project$Locale$Messages$ActivityLogsDownloadError))));
				}
			case 1:
				return A2($author$project$Application$Boundaries$save, model, session);
			default:
				var posix = msg.a;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{
							fd: $elm$core$Maybe$Just(posix)
						}),
					session);
		}
	});
var $author$project$Element$NotificationList$view = F2(
	function (_v0, model) {
		var t_ = _v0.h6;
		return A3($author$project$Element$NotificationList$viewActivityLogs, t_, model.fd, model.fG);
	});
var $author$project$Element$NotificationList$element = {jb: $author$project$Element$NotificationList$init, ks: $author$project$Element$NotificationList$update, og: $author$project$Element$NotificationList$view};
var $author$project$Element$PhoneBook$All = 0;
var $author$project$Element$PhoneBook$FetchPhoneBook = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PhoneBook$GotPhoneBook = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Endpoint$people = function (config) {
	return A2($author$project$Api$Endpoint$peopleByRoles, config, 'operators,teachers,sponsors,module_teachers');
};
var $author$project$Person$fetchPhoneBookV2 = F2(
	function (config, toMsg) {
		return {
			b_: config,
			d_: $author$project$Person$phoneBookDecoder,
			cf: toMsg,
			K: $author$project$Api$Endpoint$people(config)
		};
	});
var $author$project$Element$PhoneBook$init = F3(
	function (config, session, _v0) {
		var model = {b_: config, ad: 0, gn: $elm$core$Maybe$Nothing, bF: '', gB: session, dH: $elm$core$Maybe$Nothing};
		var fetchRequest = A2($author$project$Person$fetchPhoneBookV2, config.gX, $author$project$Element$PhoneBook$GotPhoneBook);
		return _Utils_Tuple3(
			model,
			$author$project$Element$PhoneBook$FetchPhoneBook(fetchRequest),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$SwitchUserForm$NoEffect = {$: 0};
var $author$project$Element$SwitchUserForm$SetFormReason = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$SwitchUserFormReason = {$: 571};
var $author$project$Element$SwitchUserForm$buildForm = function (t_) {
	return {
		a8: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a8: value});
				}),
			fC: function ($) {
				return $.a8;
			},
			og: {
				cm: 'reason',
				ea: t_($author$project$Locale$Messages$SwitchUserFormReason),
				fe: $author$project$Element$SwitchUserForm$SetFormReason,
				fj: ''
			}
		}
	};
};
var $author$project$Element$SwitchUserForm$emptyForm = {a8: ''};
var $author$project$Element$SwitchUserForm$init = F3(
	function (config, session, person) {
		var t_ = session.h6;
		var model = {
			b_: config,
			bE: $author$project$Element$SwitchUserForm$buildForm(t_),
			m8: person,
			gB: session,
			eI: $author$project$Element$SwitchUserForm$emptyForm
		};
		return _Utils_Tuple3(model, $author$project$Element$SwitchUserForm$NoEffect, $elm$core$Maybe$Nothing);
	});
var $author$project$Element$SwitchUserForm$perform = F2(
	function (_v0, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var cmd = effect.a;
				return cmd;
			case 2:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			default:
				var request = effect.a;
				return $author$project$Api$postV2(request);
		}
	});
var $author$project$Element$SwitchUserForm$Error = 1;
var $author$project$Element$SwitchUserForm$Exit = 0;
var $author$project$Element$SwitchUserForm$LogError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$SwitchUserForm$LogOk = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$SwitchUserForm$NoOp = {$: 0};
var $author$project$Element$SwitchUserForm$SwitchUserAttempt = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$SwitchUserAttemptSuccess = function (a) {
	return {$: 572, a: a};
};
var $author$project$Element$SwitchUserForm$UserSwitched = 2;
var $author$project$Log$msgSwitchUser = 'su';
var $author$project$Element$SwitchUserForm$saveForm = F2(
	function (form, values) {
		return form.a8.fC(values);
	});
var $author$project$Ports$switchUserRequest = _Platform_outgoingPort(
	'switchUserRequest',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'apiBase',
					$elm$json$Json$Encode$string($.fK)),
					_Utils_Tuple2(
					'csrfToken',
					$elm$json$Json$Encode$string($.lg)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string($.O)),
					_Utils_Tuple2(
					'reason',
					$elm$json$Json$Encode$string($.a8))
				]));
	});
var $author$project$SwitchUser$switchUser = F2(
	function (config, data) {
		var csrfToken = function () {
			var _v0 = config.gX.lg;
			if (!_v0.$) {
				var token = _v0.a;
				return token;
			} else {
				return '';
			}
		}();
		return $author$project$Ports$switchUserRequest(
			{fK: config.gX.fK, lg: csrfToken, O: data.O, a8: data.a8});
	});
var $author$project$Element$SwitchUserForm$update = F2(
	function (msg, model) {
		var config = model.b_;
		var session = model.gB;
		var form = model.bE;
		var values = model.eI;
		var person = model.m8;
		var t_ = session.h6;
		switch (msg.$) {
			case 2:
				return _Utils_Tuple3(
					model,
					$author$project$Element$SwitchUserForm$NoEffect,
					$elm$core$Maybe$Just(0));
			case 3:
				var data = {
					O: person.O,
					a8: A2($author$project$Element$SwitchUserForm$saveForm, form, values)
				};
				return _Utils_Tuple3(
					model,
					$author$project$Element$SwitchUserForm$SwitchUserAttempt(
						A2($author$project$SwitchUser$switchUser, config, data)),
					$elm$core$Maybe$Nothing);
			case 1:
				var value = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bE: _Utils_update(
								form,
								{
									a8: $author$project$Form$markEdited(form.a8)
								}),
							eI: A2(form.a8.ks, value, values)
						}),
					$author$project$Element$SwitchUserForm$NoEffect,
					$elm$core$Maybe$Nothing);
			case 4:
				var response = msg.a;
				if (response.nZ) {
					var successMsg = t_(
						$author$project$Locale$Messages$SwitchUserAttemptSuccess(
							A2($author$project$Person$fullName, t_, person)));
					var updatedSession = A2($author$project$Session$ok, session, successMsg);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gB: updatedSession}),
						$author$project$Element$SwitchUserForm$LogOk(
							A3(
								$author$project$Log$okV2,
								config,
								_Utils_Tuple2(
									$author$project$Log$msgSwitchUser,
									_List_fromArray(
										[person.O])),
								$elm$core$Basics$always($author$project$Element$SwitchUserForm$NoOp))),
						$elm$core$Maybe$Just(2));
				} else {
					var errorMsg = function () {
						var _v1 = response.lz;
						if (!_v1.$) {
							var err = _v1.a;
							return err;
						} else {
							return t_($author$project$Locale$Messages$FormSaveError);
						}
					}();
					var customError = $author$project$Api$CustomError(errorMsg);
					var updatedSession = A3($author$project$Session$error, session, customError, errorMsg);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gB: updatedSession}),
						$author$project$Element$SwitchUserForm$LogError(
							A3(
								$author$project$Log$errorV2,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgSwitchUser,
									$elm$core$Maybe$Just(person.O),
									customError),
								$elm$core$Basics$always($author$project$Element$SwitchUserForm$NoOp))),
						$elm$core$Maybe$Just(1));
				}
			default:
				return _Utils_Tuple3(model, $author$project$Element$SwitchUserForm$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$SwitchUserForm$ClosePopup = {$: 2};
var $author$project$Element$SwitchUserForm$SubmitForm = {$: 3};
var $author$project$Locale$Messages$SwitchUserTitle = {$: 573};
var $author$project$UI$closeButton = function (toMsg) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'aria-label', 'close'),
				$elm$html$Html$Attributes$class('delete'),
				$elm$html$Html$Events$onClick(toMsg)
			]),
		_List_Nil);
};
var $author$project$Element$SwitchUserForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.a8, values);
	});
var $author$project$Element$SwitchUserForm$view = function (_v0) {
	var session = _v0.gB;
	var form = _v0.bE;
	var values = _v0.eI;
	var t_ = session.h6;
	return A4(
		$author$project$UI$modalPanel,
		_List_fromArray(
			[
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$SwitchUserTitle)
			]),
		_List_fromArray(
			[
				$author$project$UI$closeButton($author$project$Element$SwitchUserForm$ClosePopup)
			]),
		_List_fromArray(
			[
				A3($author$project$UI$textareaField, t_, form.a8, values)
			]),
		_List_fromArray(
			[
				A4(
				$author$project$UI$submitButton,
				t_($author$project$Locale$Messages$BtnSave),
				!A2($author$project$Element$SwitchUserForm$isFormValid, form, values),
				false,
				$author$project$Element$SwitchUserForm$SubmitForm),
				A4(
				$author$project$UI$resetButton,
				t_($author$project$Locale$Messages$BtnCancel),
				false,
				false,
				$author$project$Element$SwitchUserForm$ClosePopup)
			]));
};
var $author$project$Element$SwitchUserForm$element = {jb: $author$project$Element$SwitchUserForm$init, hP: $author$project$Element$SwitchUserForm$perform, ks: $author$project$Element$SwitchUserForm$update, og: $author$project$Element$SwitchUserForm$view};
var $author$project$Element$PhoneBook$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 2:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			case 3:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			default:
				var formEffect = effect.a;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Element$PhoneBook$SwitchUserFormMsg,
					A2($author$project$Element$SwitchUserForm$element.hP, key, formEffect));
		}
	});
var $author$project$Element$PhoneBook$LogError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PhoneBook$LogOk = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PhoneBook$NoEffect = {$: 0};
var $author$project$Element$PhoneBook$NoOp = {$: 0};
var $author$project$Element$PhoneBook$SwitchUserFormEffect = function (a) {
	return {$: 4, a: a};
};
var $author$project$Log$paramScopePhoneBook = 'scope_phonebook';
var $author$project$Element$PhoneBook$update = F2(
	function (msg, model) {
		var session = model.gB;
		var config = model.b_;
		var t_ = session.h6;
		switch (msg.$) {
			case 1:
				if (!msg.a.$) {
					var phonebook = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gn: $elm$core$Maybe$Just(phonebook)
							}),
						$author$project$Element$PhoneBook$LogOk(
							A3(
								$author$project$Log$okV2,
								config,
								_Utils_Tuple2(
									$author$project$Log$msgPeopleDownload,
									_List_fromArray(
										[$author$project$Log$paramOk])),
								$elm$core$Basics$always($author$project$Element$PhoneBook$NoOp))),
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					var updatedSession = A3(
						$author$project$Session$error,
						session,
						error,
						t_($author$project$Locale$Messages$PhoneBookDownloadError));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gB: updatedSession}),
						$author$project$Element$PhoneBook$LogError(
							A3(
								$author$project$Log$errorV2,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgPeopleDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopePhoneBook),
									error),
								$elm$core$Basics$always($author$project$Element$PhoneBook$NoOp))),
						$elm$core$Maybe$Nothing);
				}
			case 2:
				var f = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ad: f}),
					$author$project$Element$PhoneBook$NoEffect,
					$elm$core$Maybe$Nothing);
			case 3:
				var q = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bF: q}),
					$author$project$Element$PhoneBook$NoEffect,
					$elm$core$Maybe$Nothing);
			case 4:
				var person = msg.a;
				var _v1 = A3($author$project$Element$SwitchUserForm$element.jb, config, session, person);
				var formModel = _v1.a;
				var formEffect = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dH: $elm$core$Maybe$Just(formModel)
						}),
					$author$project$Element$PhoneBook$SwitchUserFormEffect(formEffect),
					$elm$core$Maybe$Nothing);
			case 5:
				var formMsg = msg.a;
				var _v2 = model.dH;
				if (!_v2.$) {
					var formModel = _v2.a;
					var _v3 = A2($author$project$Element$SwitchUserForm$element.ks, formMsg, formModel);
					var newFormModel = _v3.a;
					var formEffect = _v3.b;
					var maybeReply = _v3.c;
					var updatedSession = newFormModel.gB;
					var _v4 = function () {
						if (!maybeReply.$) {
							return _Utils_Tuple2($elm$core$Maybe$Nothing, updatedSession);
						} else {
							return _Utils_Tuple2(
								$elm$core$Maybe$Just(newFormModel),
								updatedSession);
						}
					}();
					var finalFormModel = _v4.a;
					var finalSession = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gB: finalSession, dH: finalFormModel}),
						$author$project$Element$PhoneBook$SwitchUserFormEffect(formEffect),
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple3(model, $author$project$Element$PhoneBook$NoEffect, $elm$core$Maybe$Nothing);
				}
			default:
				return _Utils_Tuple3(model, $author$project$Element$PhoneBook$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Locale$Messages$PhoneBookLoadingProgress = {$: 341};
var $author$project$Element$PhoneBook$FilterSet = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$PhoneBookFilterAll = {$: 338};
var $author$project$Locale$Messages$PhoneBookFilterSponsors = {$: 339};
var $author$project$Locale$Messages$PhoneBookFilterTeachers = {$: 340};
var $author$project$Locale$Messages$PhoneBookSearch = {$: 342};
var $author$project$Element$PhoneBook$Query = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PhoneBook$Sponsors = 1;
var $author$project$Element$PhoneBook$Teachers = 2;
var $author$project$Element$PhoneBook$matches = F2(
	function (filter, person) {
		switch (filter) {
			case 0:
				return true;
			case 1:
				return $author$project$Person$isSponsor(person);
			default:
				return $author$project$Person$isTeacher(person) || $author$project$Person$isModuleTeacher(person);
		}
	});
var $author$project$Data$toCharAscii = function (chr) {
	var conversionTable = $elm$core$Dict$fromList(
		_List_fromArray(
			[
				_Utils_Tuple2('á', 'a'),
				_Utils_Tuple2('é', 'e'),
				_Utils_Tuple2('í', 'i'),
				_Utils_Tuple2('ó', 'o'),
				_Utils_Tuple2('ö', 'o'),
				_Utils_Tuple2('ő', 'o'),
				_Utils_Tuple2('ú', 'u'),
				_Utils_Tuple2('ü', 'u'),
				_Utils_Tuple2('ű', 'u')
			]));
	return A2(
		$elm$core$Maybe$withDefault,
		chr,
		A2($elm$core$Dict$get, chr, conversionTable));
};
var $author$project$Data$toSearchKeyword = function (string) {
	return A3(
		$elm$core$String$foldl,
		F2(
			function (chr, acc) {
				return _Utils_ap(
					acc,
					$elm$core$String$fromChar(
						$author$project$Data$toCharAscii(chr)));
			}),
		'',
		$elm$core$String$toLower(string));
};
var $author$project$Element$PhoneBook$queryMatches = F3(
	function (t_, query, person) {
		var name = $author$project$Data$toSearchKeyword(
			A2($author$project$Person$fullName, t_, person));
		var keyword = $author$project$Data$toSearchKeyword(
			$elm$core$String$trim(query));
		return A2($elm$core$String$contains, keyword, name);
	});
var $author$project$Element$PhoneBook$filterPhoneBook = F4(
	function (t_, filter, query, phonebook) {
		return A2(
			$elm$core$List$filter,
			A2($author$project$Element$PhoneBook$queryMatches, t_, query),
			A2(
				$elm$core$List$filter,
				$author$project$Element$PhoneBook$matches(filter),
				phonebook));
	});
var $author$project$Locale$Messages$SwitchUserAction = {$: 570};
var $author$project$Element$PhoneBook$SwitchUserRequested = function (a) {
	return {$: 4, a: a};
};
var $author$project$ACL$canSwitchUser = function (person) {
	return A2($author$project$Person$hasAccessRole, person, 2);
};
var $author$project$UI$protoLink = F2(
	function (protocol, data) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(
					$elm$core$String$concat(
						_List_fromArray(
							[protocol, data])))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(data)
				]));
	});
var $author$project$Element$PhoneBook$viewContact = F3(
	function (t_, viewer, person) {
		var viewSuLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$PhoneBook$SwitchUserRequested(person),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(
					t_($author$project$Locale$Messages$SwitchUserAction))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-theater-masks')
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$UI$mediaObject,
					_List_fromArray(
						[
							$author$project$UI$gravatar(person.O)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_fromArray(
										[
											$author$project$UI$attrCyData('contact')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Person$fullName, t_, person)),
											$elm$html$Html$text(' ')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (child) {
											return A2(
												$elm$html$Html$small,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($author$project$Person$fullName, t_, child)),
														$elm$html$Html$text(' ')
													]));
										},
										person.nL)),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2($author$project$UI$protoLink, 'tel:', person.a$),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2($author$project$UI$protoLink, 'mailto:', person.O)
								]))
						]),
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$when,
							$author$project$ACL$canSwitchUser(viewer),
							viewSuLink)
						]))
				]));
	});
var $author$project$Element$PhoneBook$viewPhoneBook = F4(
	function (t_, viewer, model, phonebook) {
		var viewFilterLinks = A3(
			$author$project$UI$List$filterBar,
			t_,
			_Utils_Tuple2($author$project$Element$PhoneBook$FilterSet, model.ad),
			_List_fromArray(
				[
					{cm: 'all', ad: 0, hv: true, hw: true, ea: $author$project$Locale$Messages$PhoneBookFilterAll},
					{cm: 'sponsor', ad: 1, hv: true, hw: true, ea: $author$project$Locale$Messages$PhoneBookFilterSponsors},
					{cm: 'teacher', ad: 2, hv: true, hw: true, ea: $author$project$Locale$Messages$PhoneBookFilterTeachers}
				]));
		var filteredPhoneBook = A2(
			$author$project$Util$List$sortBy,
			$author$project$Person$fullName(t_),
			A4($author$project$Element$PhoneBook$filterPhoneBook, t_, model.ad, model.bF, phonebook));
		return $author$project$UI$panel(
			{
				g$: A2(
					$elm$core$List$cons,
					$author$project$UI$List$searchBar(
						{
							fe: $author$project$Element$PhoneBook$Query,
							fj: t_($author$project$Locale$Messages$PhoneBookSearch),
							bF: model.bF
						}),
					A2(
						$elm$core$List$map,
						A2($author$project$Element$PhoneBook$viewContact, t_, viewer),
						filteredPhoneBook)),
				cm: 'phonebook',
				hl: _List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PhoneBookTitle)
					]),
				h7: viewFilterLinks,
				ie: 'is-success'
			});
	});
var $author$project$Element$PhoneBook$viewSwitchUserPopup = function (formModel) {
	return A2(
		$elm$html$Html$map,
		$author$project$Element$PhoneBook$SwitchUserFormMsg,
		$author$project$Element$SwitchUserForm$element.og(formModel));
};
var $author$project$Element$PhoneBook$view = function (model) {
	var session = model.gB;
	var phonebook = model.gn;
	var switchUserForm = model.dH;
	var viewer = session.ok;
	var t_ = session.h6;
	if (phonebook.$ === 1) {
		return A2(
			$author$project$UI$progressBar,
			'is-primary',
			t_($author$project$Locale$Messages$PhoneBookLoadingProgress));
	} else {
		var pb = phonebook.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A4($author$project$Element$PhoneBook$viewPhoneBook, t_, viewer, model, pb),
					function () {
					if (!switchUserForm.$) {
						var formModel = switchUserForm.a;
						return $author$project$Element$PhoneBook$viewSwitchUserPopup(formModel);
					} else {
						return $author$project$UI$none;
					}
				}()
				]));
	}
};
var $author$project$Element$PhoneBook$element = {jb: $author$project$Element$PhoneBook$init, hP: $author$project$Element$PhoneBook$perform, ks: $author$project$Element$PhoneBook$update, og: $author$project$Element$PhoneBook$view};
var $author$project$Element$PortfolioForm$LoadingPage = {$: 0};
var $author$project$Element$PortfolioForm$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioForm$FetchModuleDropdownList = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioForm$FetchStudentsAndTeachersList = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioForm$FormPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioForm$ModuleListDownloaded = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Element$PortfolioForm$PeopleListDownloaded = function (a) {
	return {$: 14, a: a};
};
var $author$project$Element$PortfolioForm$Description = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$PortfolioForm$FormMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$PortfolioForm$MediaUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioForm$acceptedMimeTypes = _List_fromArray(
	['application/pdf', 'image/jpeg', 'image/png', 'video/mp4', 'video/quicktime']);
var $author$project$Element$PortfolioForm$initModuleField = function (options) {
	var defaultConfig = $author$project$Multiselect$defaultConfig;
	return $author$project$Multiselect$initModel(
		_Utils_update(
			defaultConfig,
			{
				ma: false,
				n0: 'Module',
				eI: $author$project$Form$toMultiselectValues(options)
			}));
};
var $author$project$Element$PortfolioForm$initStudentsField = function (options) {
	var defaultConfig = $author$project$Multiselect$defaultConfig;
	return $author$project$Multiselect$initModel(
		_Utils_update(
			defaultConfig,
			{
				n0: 'Students',
				eI: $author$project$Form$toMultiselectValues(options)
			}));
};
var $author$project$Element$PortfolioForm$maxFileSize = (400 * 1024) * 1024;
var $author$project$Locale$Messages$FormInvalidFileMime = function (a) {
	return {$: 60, a: a};
};
var $author$project$Locale$Messages$FormTooLargeFileSize = function (a) {
	return {$: 62, a: a};
};
var $elm$file$File$mime = _File_mime;
var $elm$file$File$size = _File_size;
var $author$project$Form$validateFile = F3(
	function (t_, _v0, file) {
		var maxSize = _v0.mv;
		var acceptedMimeTypes = _v0.kH;
		return (!A2(
			$elm$core$List$member,
			$elm$file$File$mime(file),
			acceptedMimeTypes)) ? $elm$core$Result$Err(
			t_(
				$author$project$Locale$Messages$FormInvalidFileMime(
					$elm$file$File$mime(file)))) : ((_Utils_cmp(
			$elm$file$File$size(file),
			maxSize) > 0) ? $elm$core$Result$Err(
			t_(
				$author$project$Locale$Messages$FormTooLargeFileSize(
					$elm$file$File$size(file)))) : $elm$core$Result$Ok(''));
	});
var $author$project$Form$optionalFile = F3(
	function (t_, constraints, value) {
		switch (value.$) {
			case 0:
				return $elm$core$Result$Ok('');
			case 1:
				var file = value.a;
				return A3($author$project$Form$validateFile, t_, constraints, file);
			case 3:
				var file = value.a;
				return A3($author$project$Form$validateFile, t_, constraints, file);
			default:
				var url = value.a;
				return $elm$core$Result$Ok(url);
		}
	});
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $author$project$Element$PortfolioForm$parseOptionalModuleId = F2(
	function (t_, value) {
		return $elm$core$String$isEmpty(value) ? $elm$core$Result$Ok($elm$core$Maybe$Nothing) : A2(
			$elm$core$Result$map,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$core$Maybe$Just),
			A2(
				$elm$core$Result$fromMaybe,
				t_($author$project$Locale$Messages$FormRequiredSelection),
				$elm$core$String$toInt(value)));
	});
var $author$project$Module$fromModuleToValue = function (id) {
	return $elm$core$String$fromInt(
		$author$project$Module$moduleIdToInt(id));
};
var $author$project$Element$PortfolioForm$toModuleOptions = function (modules) {
	return A2(
		$elm$core$List$map,
		function (m) {
			return $author$project$Form$toSelectOption(
				_Utils_Tuple2(
					$author$project$Module$fromModuleToValue(m.i8),
					m.kj));
		},
		modules);
};
var $author$project$Element$PortfolioForm$buildForm = F4(
	function (t_, moduleOptions, studentOptions, story) {
		var studentsField = {
			e0: false,
			fi: $author$project$Form$requiredPeopleSelected(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{fv: value});
				}),
			fC: function ($) {
				return $.fv;
			},
			og: {
				cm: 'students',
				e6: 'fa-users',
				ea: t_($author$project$Locale$Messages$PortfolioStoryStudents),
				m_: studentOptions,
				fs: $author$project$Element$PortfolioForm$initStudentsField(studentOptions),
				cf: $author$project$Element$PortfolioForm$StudentsFieldMsg
			}
		};
		var moduleField = {
			e0: false,
			fi: $author$project$Element$PortfolioForm$parseOptionalModuleId(t_),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{hG: value});
				}),
			fC: function ($) {
				return $.hG;
			},
			og: {
				cm: 'module',
				e6: 'fa-cube',
				ea: t_($author$project$Locale$Messages$PortfolioStoryModule),
				m_: moduleOptions,
				fs: $author$project$Element$PortfolioForm$initModuleField(moduleOptions),
				cf: $author$project$Element$PortfolioForm$ModuleFieldMsg
			}
		};
		return {
			g8: {
				e0: false,
				fi: $author$project$Form$requiredText(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{g8: value});
					}),
				fC: function ($) {
					return $.g8;
				},
				og: {
					cm: 'description',
					ea: t_($author$project$Locale$Messages$PortfolioStoryDescription),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioForm$FormMsg, $author$project$Element$PortfolioForm$Description),
					fj: t_($author$project$Locale$Messages$PortfolioStoryDescription)
				}
			},
			w: {
				e0: false,
				fi: A2(
					$author$project$Form$optionalFile,
					t_,
					{kH: $author$project$Element$PortfolioForm$acceptedMimeTypes, mv: $author$project$Element$PortfolioForm$maxFileSize}),
				fp: false,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{w: value});
					}),
				fC: function ($) {
					return $.w;
				},
				og: {
					cm: 'portfolios',
					e6: 'fa-image',
					ea: t_($author$project$Locale$Messages$PortfolioStoryMedia),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioForm$FormMsg, $author$project$Element$PortfolioForm$MediaUrl),
					fj: t_($author$project$Locale$Messages$PortfolioStoryMedia)
				}
			},
			hG: A2(
				$elm$core$Maybe$withDefault,
				moduleField,
				A2(
					$elm$core$Maybe$map,
					function (m) {
						return A2(
							$author$project$Form$setMultiselectSelection,
							$author$project$Element$PortfolioForm$toModuleOptions(
								_List_fromArray(
									[m])),
							moduleField);
					},
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.hG;
						},
						story))),
			fv: A2(
				$elm$core$Maybe$withDefault,
				studentsField,
				A2(
					$elm$core$Maybe$map,
					function (story_) {
						return A2(
							$author$project$Form$setMultiselectSelection,
							A2($author$project$Form$toPeopleOptions, t_, story_.fv),
							studentsField);
					},
					story))
		};
	});
var $author$project$Form$NoFile = {$: 0};
var $author$project$Element$PortfolioForm$emptyForm = F2(
	function (viewer, maybeModuleId) {
		return {
			g8: '',
			w: $author$project$Form$NoFile,
			hG: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Module$moduleIdToInt, $elm$core$String$fromInt),
					maybeModuleId)),
			fv: $author$project$Person$isStudent(viewer) ? _List_fromArray(
				[
					$elm$core$String$fromInt(viewer.i8)
				]) : _List_Nil
		};
	});
var $author$project$Module$fetchViewerModulesForDropdown = F3(
	function (config, viewer, callback) {
		return A3(
			$author$project$Module$fetchModulesForDropdown2,
			config,
			A2(
				$elm$core$List$cons,
				viewer.i8,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.i8;
					},
					viewer.nL)),
			callback);
	});
var $author$project$Element$PortfolioForm$openCreateForm = F3(
	function (maybeModuleId, _v0, model) {
		var t_ = _v0.h6;
		var viewer = _v0.ok;
		var config = model.b_;
		var page = $author$project$Element$PortfolioForm$FormPage(
			{
				iq: $author$project$Form$Create(maybeModuleId),
				bE: A4($author$project$Element$PortfolioForm$buildForm, t_, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
				fs: 0,
				eI: A2($author$project$Element$PortfolioForm$emptyForm, viewer, maybeModuleId)
			});
		var effect = $author$project$Element$PortfolioForm$BatchEffect(
			_List_fromArray(
				[
					$author$project$Element$PortfolioForm$FetchModuleDropdownList(
					A3(
						$author$project$Module$fetchViewerModulesForDropdown,
						config.gX,
						viewer,
						$author$project$Element$PortfolioForm$ModuleListDownloaded(maybeModuleId))),
					$author$project$Element$PortfolioForm$FetchStudentsAndTeachersList(
					A2($author$project$Person$fetchStudentsAndTeachers2, config.gX, $author$project$Element$PortfolioForm$PeopleListDownloaded))
				]));
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{bk: page}),
			effect,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$PortfolioForm$FetchPortfolioStory = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$PortfolioForm$PortfolioStoryDownloadedForEdit = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$PortfolioForm$openUpdateFormStep1 = F3(
	function (storyId, _v0, model) {
		var viewer = _v0.ok;
		var config = model.b_;
		var effect = $author$project$Element$PortfolioForm$BatchEffect(
			_List_fromArray(
				[
					$author$project$Element$PortfolioForm$FetchModuleDropdownList(
					A3(
						$author$project$Module$fetchViewerModulesForDropdown,
						config.gX,
						viewer,
						$author$project$Element$PortfolioForm$ModuleListDownloaded($elm$core$Maybe$Nothing))),
					$author$project$Element$PortfolioForm$FetchStudentsAndTeachersList(
					A2($author$project$Person$fetchStudentsAndTeachers2, config.gX, $author$project$Element$PortfolioForm$PeopleListDownloaded)),
					$author$project$Element$PortfolioForm$FetchPortfolioStory(
					A3($author$project$PortfolioStory$fetchOneStory, config.gX, storyId, $author$project$Element$PortfolioForm$PortfolioStoryDownloadedForEdit))
				]));
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{bk: $author$project$Element$PortfolioForm$LoadingPage}),
			effect,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$PortfolioForm$init = F3(
	function (config, session, params) {
		var model = {
			b_: config,
			d0: $elm$core$Maybe$Nothing,
			bk: $author$project$Element$PortfolioForm$LoadingPage,
			gB: session,
			bo: {g2: $elm$core$Maybe$Nothing, hH: $elm$core$Maybe$Nothing, m6: $elm$core$Maybe$Nothing}
		};
		if (!params.$) {
			var maybeModuleId = params.a;
			return A3(
				$author$project$Element$PortfolioForm$openCreateForm,
				A2($elm$core$Maybe$map, $elm$core$Basics$identity, maybeModuleId),
				session,
				model);
		} else {
			var moduleId = params.a;
			return A3($author$project$Element$PortfolioForm$openUpdateFormStep1, moduleId, session, model);
		}
	});
var $author$project$Element$PortfolioForm$DocumentViewerEffect = function (a) {
	return {$: 14, a: a};
};
var $author$project$Element$PortfolioForm$DocumentViewerMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioForm$documentViewer = {
	ha: $author$project$Element$DocumentViewer$element,
	kk: $author$project$Element$PortfolioForm$DocumentViewerEffect,
	cf: $author$project$Element$PortfolioForm$DocumentViewerMsg,
	kt: F2(
		function (containerModel, model) {
			return _Utils_update(
				containerModel,
				{
					d0: $elm$core$Maybe$Just(model)
				});
		})
};
var $elm$file$File$Select$file = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			_File_uploadOne(mimes));
	});
var $author$project$Api$postExpectingHeadersV2 = function (_v0) {
	var config = _v0.b_;
	var url = _v0.K;
	var toMsg = _v0.cf;
	var body = _v0.T;
	return $author$project$Api$Endpoint$request(
		{
			T: body,
			bd: $author$project$Api$expectHeaders(toMsg),
			ar: $author$project$Api$toHeaders(config),
			bj: 'POST',
			bp: $elm$core$Maybe$Nothing,
			bq: $elm$core$Maybe$Nothing,
			K: url
		});
};
var $author$project$Element$PortfolioForm$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$PortfolioForm$perform(key),
						effects));
			case 2:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 3:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 4:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 5:
				var toMsg = effect.a;
				var effect_ = effect.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					toMsg,
					$author$project$Multiselect$perform(effect_));
			case 6:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			case 7:
				var request = effect.a;
				return $author$project$Api$putV2(request);
			case 8:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			case 9:
				return $author$project$Ports$scrollToFormError;
			case 10:
				var route = effect.a;
				return A2(
					$elm$browser$Browser$Navigation$pushUrl,
					key,
					$author$project$Route$toString(route));
			case 11:
				var mimeTypes = effect.a;
				var toMsg = effect.b;
				return A2($elm$file$File$Select$file, mimeTypes, toMsg);
			case 12:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 13:
				var request = effect.a;
				return $author$project$Api$postExpectingHeadersV2(request);
			default:
				var effect_ = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, effect_, $author$project$Element$PortfolioForm$documentViewer);
		}
	});
var $author$project$Api$BadHeader = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$PortfolioForm$CreatePortfolioStory = function (a) {
	return {$: 6, a: a};
};
var $author$project$Form$FileSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$FormFileUploadError = {$: 65};
var $author$project$Form$InvalidFile = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioForm$LogError = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$PortfolioForm$MediaFileSelected = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$Element$PortfolioForm$MediaFileUploaded = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Element$PortfolioForm$MediaPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Element$PortfolioForm$Module = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioForm$MultiselectEffect = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Element$PortfolioForm$NavRedirect = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$PortfolioForm$NoEffect = {$: 0};
var $author$project$Element$PortfolioForm$NoOp = {$: 0};
var $author$project$Element$PortfolioForm$PortfolioStorySaved = function (a) {
	return {$: 13, a: a};
};
var $author$project$Element$PortfolioForm$RequestPolicy = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$PortfolioForm$ScrollToFormError = {$: 9};
var $author$project$Element$PortfolioForm$SelectFile = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Element$PortfolioForm$Students = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioForm$UpdatePortfolioStory = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$PortfolioForm$UploadFile = function (a) {
	return {$: 13, a: a};
};
var $author$project$Element$PortfolioForm$awsPolicyScope = 'portfolio';
var $author$project$S3$headerLocation = 'location';
var $author$project$Element$PortfolioForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.g8, values) && (A2($author$project$Form$isFieldValid, form.w, values) && A2($author$project$Form$isFieldValid, form.fv, values));
	});
var $author$project$Log$msgAwsPolicyDownload = 'aws_policy_download';
var $author$project$Log$msgFileUpload = 'file_upload';
var $author$project$Form$FileUploaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Form$fromFileUrl = function (url) {
	return $elm$core$String$isEmpty(url) ? $author$project$Form$NoFile : $author$project$Form$FileUploaded(url);
};
var $author$project$Element$PortfolioForm$fillForm = function (story) {
	return {
		g8: story.g8,
		w: $author$project$Form$fromFileUrl(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.m$;
					},
					$elm$core$List$head(story.mw)))),
		hG: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.i8;
					},
					$author$project$Module$fromModuleToValue),
				story.hG)),
		fv: A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.i8;
				},
				$elm$core$String$fromInt),
			story.fv)
	};
};
var $author$project$Module$schoolModules = F2(
	function (viewer, modules) {
		return A2(
			$elm$core$List$filter,
			function (module_) {
				return A2($author$project$Person$isMemberOf, module_.kf.i8, viewer) || ($author$project$Person$isSponsor(viewer) && A2(
					$elm$core$List$any,
					$author$project$Person$isSponsorOf(viewer),
					module_.fv));
			},
			modules);
	});
var $author$project$Module$toSchoolModuleOptions = F2(
	function (viewer, modules) {
		return $author$project$Form$toSortedSelectOptions(
			A2(
				$elm$core$List$map,
				function (module_) {
					return _Utils_Tuple2(
						$author$project$Module$fromModuleToValue(module_.i8),
						module_.kj);
				},
				A2($author$project$Module$schoolModules, viewer, modules)));
	});
var $author$project$ACL$canCreatePortfolioForStudent = F2(
	function (person, student) {
		return A2($author$project$Person$isTeacherOf, person, student) || (A2($author$project$Person$isSponsorOf, person, student) || A2($author$project$Person$isSamePerson, person, student));
	});
var $author$project$Element$PortfolioForm$toStudentOptions = F3(
	function (t_, viewer, people) {
		return A2(
			$author$project$Form$toPeopleOptions,
			t_,
			A2(
				$elm$core$List$filter,
				$author$project$ACL$canCreatePortfolioForStudent(viewer),
				people));
	});
var $author$project$Element$PortfolioForm$openUpdateFormStep2 = F3(
	function (story, _v0, model) {
		var t_ = _v0.h6;
		var viewer = _v0.ok;
		var store = model.bo;
		var studentOptions = A2(
			$elm$core$Maybe$map,
			A2($author$project$Element$PortfolioForm$toStudentOptions, t_, viewer),
			store.m6);
		var moduleOptions = A2(
			$elm$core$Maybe$map,
			$author$project$Module$toSchoolModuleOptions(viewer),
			store.hH);
		var page = $author$project$Element$PortfolioForm$FormPage(
			{
				iq: $author$project$Form$Update(story),
				bE: A4(
					$author$project$Element$PortfolioForm$buildForm,
					t_,
					moduleOptions,
					studentOptions,
					$elm$core$Maybe$Just(story)),
				fs: 0,
				eI: $author$project$Element$PortfolioForm$fillForm(story)
			});
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{bk: page}),
			$author$project$Element$PortfolioForm$NoEffect,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Api$Endpoint$awsPolicy = F3(
	function (config, scope, params) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'aws-policy', scope]),
			params);
	});
var $author$project$S3$PostPolicy = function (bucketName) {
	return function (bucketKey) {
		return function (s3RegionEndpoint) {
			return function (xAmzAlgorithm) {
				return function (xAmzCredential) {
					return function (xAmzDate) {
						return function (xAmzSignature) {
							return function (xAmzExpires) {
								return function (xAmzContentDisposition) {
									return function (xAmzContentType) {
										return function (policy) {
											return function (acl) {
												return {ip: acl, fO: bucketKey, fP: bucketName, jL: policy, gz: s3RegionEndpoint, gN: xAmzAlgorithm, kC: xAmzContentDisposition, kD: xAmzContentType, gO: xAmzCredential, gP: xAmzDate, im: xAmzExpires, gQ: xAmzSignature};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$S3$postPolicyDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'acl',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'policy',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'content_type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'content_disposition',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'x_amz_expires',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'x_amz_signature',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'x_amz_date',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'x_amz_credential',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'x_amz_algorithm',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										's3_region_endpoint',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'bucket_key',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'bucket_name',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$S3$PostPolicy)))))))))))));
var $author$project$S3$requestPolicyV2 = F3(
	function (config, _v0, callback) {
		var scope = _v0.nx;
		var personId = _v0.m9;
		var documentType = _v0.ls;
		var mimeType = _v0.mD;
		var params = _List_fromArray(
			[
				_Utils_Tuple2('person_id', personId),
				_Utils_Tuple2('document_type', documentType),
				_Utils_Tuple2('mime_type', mimeType)
			]);
		return {
			b_: config,
			d_: $author$project$S3$postPolicyDecoder,
			cf: callback,
			K: A3($author$project$Api$Endpoint$awsPolicy, config, scope, params)
		};
	});
var $author$project$Form$toFileUrl = function (value) {
	if (value.$ === 2) {
		var url = value.a;
		return url;
	} else {
		return '';
	}
};
var $author$project$Element$PortfolioForm$saveFormMedia = F3(
	function (form, values, maybeStory) {
		var classroomSubmission = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.iI;
			},
			maybeStory);
		var _v0 = _Utils_Tuple3(
			maybeStory,
			classroomSubmission,
			form.w.fC(values));
		if (!_v0.b.$) {
			if (!_v0.a.$) {
				var story = _v0.a.a;
				return A2(
					$elm$core$List$map,
					function ($) {
						return $.m$;
					},
					story.mw);
			} else {
				return _List_Nil;
			}
		} else {
			if (!_v0.c.$) {
				var _v1 = _v0.b;
				var _v2 = _v0.c;
				return _List_Nil;
			} else {
				var _v3 = _v0.b;
				var file = _v0.c;
				return _List_fromArray(
					[
						$author$project$Form$toFileUrl(file)
					]);
			}
		}
	});
var $author$project$Element$PortfolioForm$saveForm = F4(
	function (form, values, viewer, maybeStory) {
		return A7(
			$author$project$PortfolioStory$PortfolioStoryUnsaved,
			A2(
				$elm$core$Maybe$withDefault,
				-1,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.i8;
					},
					maybeStory)),
			A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.ii;
					},
					maybeStory)),
			form.g8.fC(values),
			A3($author$project$Element$PortfolioForm$saveFormMedia, form, values, maybeStory),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$identity,
				$elm$core$String$toInt(
					form.hG.fC(values))),
			viewer.i8,
			A2(
				$elm$core$List$filterMap,
				$elm$core$String$toInt,
				form.fv.fC(values)));
	});
var $author$project$Module$findModule = F2(
	function (id, modules) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (module_) {
					return _Utils_eq(module_.i8, id);
				},
				modules));
	});
var $author$project$Person$findPerson = F2(
	function (id, people) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (person) {
					return _Utils_eq(person.i8, id);
				},
				people));
	});
var $author$project$Element$PortfolioForm$updateModuleField = F6(
	function (t_, viewer, modules, maybePeople, value, formPage) {
		var form = formPage.bE;
		var values = formPage.eI;
		var maybeModule = A2(
			$elm$core$Maybe$andThen,
			function (id) {
				return A2($author$project$Module$findModule, id, modules);
			},
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$identity,
				$elm$core$String$toInt(value)));
		var formPageWithNewModule = _Utils_update(
			formPage,
			{
				bE: _Utils_update(
					form,
					{
						hG: $author$project$Form$markEdited(form.hG)
					}),
				eI: A2(form.hG.ks, value, values)
			});
		var formWithNewModule = formPageWithNewModule.bE;
		var _v0 = _Utils_Tuple2(maybeModule, maybePeople);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var module_ = _v0.a.a;
					var people = _v0.b.a;
					var valuesWithNewModule = formPageWithNewModule.eI;
					var selectedStudentOptions = A2(
						$elm$core$List$filter,
						function (s) {
							return A2(
								$elm$core$List$member,
								$elm$core$String$fromInt(s.i8),
								form.fv.fC(values));
						},
						people);
					var selectedValues = A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.i8;
							},
							$elm$core$String$fromInt),
						selectedStudentOptions);
					var moduleStudents = A2(
						$elm$core$List$filterMap,
						function (s) {
							return A2($author$project$Person$findPerson, s.i8, people);
						},
						module_.fv);
					var studentOptions = A3($author$project$Element$PortfolioForm$toStudentOptions, t_, viewer, moduleStudents);
					return _Utils_update(
						formPageWithNewModule,
						{
							bE: _Utils_update(
								formWithNewModule,
								{
									fv: $author$project$Form$markEdited(
										A2(
											$author$project$Form$setMultiselectSelection,
											A2($author$project$Form$toPeopleOptions, t_, selectedStudentOptions),
											A2($author$project$Form$setMultiselectOptions, studentOptions, form.fv)))
								}),
							eI: A2(form.fv.ks, selectedValues, valuesWithNewModule)
						});
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var people = _v0.b.a;
					var studentOptions = A3($author$project$Element$PortfolioForm$toStudentOptions, t_, viewer, people);
					return _Utils_update(
						formPageWithNewModule,
						{
							bE: _Utils_update(
								formWithNewModule,
								{
									fv: $author$project$Form$markEdited(
										A2($author$project$Form$setMultiselectOptions, studentOptions, form.fv))
								})
						});
				} else {
					break _v0$2;
				}
			}
		}
		return formPageWithNewModule;
	});
var $author$project$Element$PortfolioForm$updateForm = F5(
	function (t_, viewer, store, msg, formPage) {
		var form = formPage.bE;
		var values = formPage.eI;
		var editedFormPage = _Utils_update(
			formPage,
			{fs: 1});
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_update(
					editedFormPage,
					{
						bE: _Utils_update(
							form,
							{
								g8: $author$project$Form$markEdited(form.g8)
							}),
						eI: A2(form.g8.ks, value, values)
					});
			case 1:
				var value = msg.a;
				return _Utils_update(
					editedFormPage,
					{
						bE: _Utils_update(
							form,
							{
								w: $author$project$Form$markEdited(form.w)
							}),
						eI: A2(
							form.w.ks,
							$author$project$Form$fromFileUrl(value),
							values)
					});
			case 2:
				var value = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					formPage,
					A2(
						$elm$core$Maybe$map,
						function (modules) {
							return A6($author$project$Element$PortfolioForm$updateModuleField, t_, viewer, modules, store.m6, value, editedFormPage);
						},
						store.hH));
			default:
				var value = msg.a;
				return _Utils_update(
					editedFormPage,
					{
						bE: _Utils_update(
							form,
							{
								fv: $author$project$Form$markEdited(form.fv)
							}),
						eI: A2(form.fv.ks, value, values)
					});
		}
	});
var $elm$http$Http$filePart = _Http_pair;
var $author$project$S3$makeFormData = F2(
	function (policy, file) {
		return $elm$http$Http$multipartBody(
			_List_fromArray(
				[
					A2($elm$http$Http$stringPart, 'key', policy.fO),
					A2($elm$http$Http$stringPart, 'acl', policy.ip),
					A2($elm$http$Http$stringPart, 'x-amz-algorithm', policy.gN),
					A2($elm$http$Http$stringPart, 'x-amz-credential', policy.gO),
					A2($elm$http$Http$stringPart, 'x-amz-date', policy.gP),
					A2($elm$http$Http$stringPart, 'x-amz-signature', policy.gQ),
					A2($elm$http$Http$stringPart, 'content-disposition', policy.kC),
					A2($elm$http$Http$stringPart, 'content-type', policy.kD),
					A2($elm$http$Http$stringPart, 'success_action_status', '200'),
					A2($elm$http$Http$stringPart, 'policy', policy.jL),
					A2($elm$http$Http$filePart, 'file', file)
				]));
	});
var $author$project$S3$s3Endpoint = function (postPolicy) {
	var host = 'https://' + postPolicy.gz;
	return A3(
		$elm$url$Url$Builder$crossOrigin,
		host,
		_List_fromArray(
			[postPolicy.fP]),
		_List_Nil);
};
var $author$project$S3$uploadFileV2 = F4(
	function (config, postPolicy, file, callback) {
		return {
			T: A2($author$project$S3$makeFormData, postPolicy, file),
			b_: config,
			cf: callback,
			K: $author$project$S3$s3Endpoint(postPolicy)
		};
	});
var $author$project$Element$PortfolioForm$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			g8: $author$project$Form$markEdited(form.g8),
			w: $author$project$Form$markEdited(form.w),
			hG: $author$project$Form$markEdited(form.hG),
			fv: $author$project$Form$markEdited(form.fv)
		});
};
var $author$project$Element$PortfolioForm$update = F2(
	function (msg, model) {
		update:
		while (true) {
			var config = model.b_;
			var session = model.gB;
			var store = model.bo;
			var viewer = session.ok;
			var t_ = session.h6;
			var noop = _Utils_Tuple3(model, $author$project$Element$PortfolioForm$NoEffect, $elm$core$Maybe$Nothing);
			var _v0 = _Utils_Tuple2(msg, model.bk);
			_v0$24:
			while (true) {
				switch (_v0.a.$) {
					case 2:
						if (_v0.b.$ === 1) {
							var location = _v0.a.a;
							return A3(
								$author$project$Application$V3$Boundaries$mapElement,
								model,
								$author$project$Element$PortfolioForm$documentViewer,
								A4(
									$author$project$Application$V3$Boundaries$initElement,
									config,
									session,
									$author$project$Element$PortfolioForm$documentViewer,
									{fa: $elm$core$Maybe$Nothing, K: location}));
						} else {
							break _v0$24;
						}
					case 1:
						if (_v0.b.$ === 1) {
							var documentViewerMsg = _v0.a.a;
							var _v1 = model.d0;
							if (!_v1.$) {
								var documentViewerModel = _v1.a;
								var _v2 = A3(
									$author$project$Application$V3$Boundaries$mapElement,
									model,
									$author$project$Element$PortfolioForm$documentViewer,
									A4($author$project$Application$V3$Boundaries$updateElement, session, documentViewerMsg, documentViewerModel, $author$project$Element$PortfolioForm$documentViewer));
								var model2 = _v2.a;
								var effect = _v2.b;
								return _Utils_Tuple3(
									_Utils_update(
										model2,
										{d0: $elm$core$Maybe$Nothing}),
									effect,
									$elm$core$Maybe$Nothing);
							} else {
								return noop;
							}
						} else {
							break _v0$24;
						}
					case 6:
						if (_v0.b.$ === 1) {
							var fieldMsg = _v0.a.a;
							var formPage = _v0.b.a;
							var form = formPage.bE;
							var field = form.hG;
							var _v3 = A2($author$project$Form$updateMultiselectField, fieldMsg, field);
							var updatedField = _v3.a;
							var effect = _v3.b;
							var outMsg = _v3.c;
							var formMsg = $author$project$Element$PortfolioForm$Module(
								$author$project$Form$getMultiselectFieldSelectedValue(updatedField));
							var formPage2 = _Utils_update(
								formPage,
								{
									bE: _Utils_update(
										form,
										{hG: updatedField})
								});
							var formPage3 = function () {
								if (!outMsg.$) {
									return A5($author$project$Element$PortfolioForm$updateForm, t_, viewer, store, formMsg, formPage2);
								} else {
									return formPage2;
								}
							}();
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bk: $author$project$Element$PortfolioForm$FormPage(formPage3)
									}),
								A2($author$project$Element$PortfolioForm$MultiselectEffect, $author$project$Element$PortfolioForm$ModuleFieldMsg, effect),
								$elm$core$Maybe$Nothing);
						} else {
							break _v0$24;
						}
					case 7:
						if (_v0.b.$ === 1) {
							var fieldMsg = _v0.a.a;
							var formPage = _v0.b.a;
							var form = formPage.bE;
							var field = form.fv;
							var _v5 = A2($author$project$Form$updateMultiselectField, fieldMsg, field);
							var updatedField = _v5.a;
							var effect = _v5.b;
							var outMsg = _v5.c;
							var formMsg = $author$project$Element$PortfolioForm$Students(
								$author$project$Form$getMultiselectFieldSelectedValues(updatedField));
							var formPage2 = _Utils_update(
								formPage,
								{
									bE: _Utils_update(
										form,
										{fv: updatedField})
								});
							var formPage3 = function () {
								if (!outMsg.$) {
									return A5($author$project$Element$PortfolioForm$updateForm, t_, viewer, store, formMsg, formPage2);
								} else {
									return formPage2;
								}
							}();
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bk: $author$project$Element$PortfolioForm$FormPage(formPage3)
									}),
								A2($author$project$Element$PortfolioForm$MultiselectEffect, $author$project$Element$PortfolioForm$StudentsFieldMsg, effect),
								$elm$core$Maybe$Nothing);
						} else {
							break _v0$24;
						}
					case 5:
						if (_v0.b.$ === 1) {
							var fieldMsg = _v0.a.a;
							var formPage = _v0.b.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bk: $author$project$Element$PortfolioForm$FormPage(
											A5($author$project$Element$PortfolioForm$updateForm, t_, viewer, store, fieldMsg, formPage))
									}),
								$author$project$Element$PortfolioForm$NoEffect,
								$elm$core$Maybe$Nothing);
						} else {
							break _v0$24;
						}
					case 4:
						if (_v0.b.$ === 1) {
							var _v7 = _v0.a;
							var action = _v0.b.a.iq;
							if (action.$ === 1) {
								var story = action.a;
								return A3($author$project$Element$PortfolioForm$openUpdateFormStep2, story, session, model);
							} else {
								var maybeModuleId = action.a;
								return A3($author$project$Element$PortfolioForm$openCreateForm, maybeModuleId, session, model);
							}
						} else {
							break _v0$24;
						}
					case 3:
						if (_v0.b.$ === 1) {
							var _v9 = _v0.a;
							var formPage = _v0.b.a;
							var action = formPage.iq;
							var form = formPage.bE;
							var values = formPage.eI;
							if (A2($author$project$Element$PortfolioForm$isFormValid, form, values)) {
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{fs: 2}));
								var effect = function () {
									if (!action.$) {
										var unsavedStory = A4($author$project$Element$PortfolioForm$saveForm, form, values, viewer, $elm$core$Maybe$Nothing);
										return $author$project$Element$PortfolioForm$CreatePortfolioStory(
											A3($author$project$PortfolioStory$createStory, config, unsavedStory, $author$project$Element$PortfolioForm$PortfolioStorySaved));
									} else {
										var story = action.a;
										var unsavedStory = A4(
											$author$project$Element$PortfolioForm$saveForm,
											form,
											values,
											viewer,
											$elm$core$Maybe$Just(story));
										return $author$project$Element$PortfolioForm$UpdatePortfolioStory(
											A3($author$project$PortfolioStory$updateStory, config, unsavedStory, $author$project$Element$PortfolioForm$PortfolioStorySaved));
									}
								}();
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{bk: page}),
									effect,
									$elm$core$Maybe$Nothing);
							} else {
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: $author$project$Element$PortfolioForm$validateForm(form),
											fs: 1
										}));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{bk: page}),
									$author$project$Element$PortfolioForm$ScrollToFormError,
									$elm$core$Maybe$Nothing);
							}
						} else {
							break _v0$24;
						}
					case 15:
						if (!_v0.a.b.$) {
							if (_v0.b.$ === 1) {
								var _v11 = _v0.a;
								var moduleId = _v11.a;
								var modules = _v11.b.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var selectedModule = $elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (m) {
											return _Utils_eq(
												$elm$core$Maybe$Just(m.i8),
												moduleId);
										},
										modules));
								var moduleOptions = A2($author$project$Module$toSchoolModuleOptions, viewer, modules);
								var multiselectModuleField = function () {
									if (!selectedModule.$) {
										var selected = selectedModule.a;
										return A2(
											$author$project$Form$setMultiselectSelection,
											$author$project$Element$PortfolioForm$toModuleOptions(
												_List_fromArray(
													[selected])),
											A2($author$project$Form$setMultiselectOptions, moduleOptions, form.hG));
									} else {
										return A2($author$project$Form$setMultiselectOptions, moduleOptions, form.hG);
									}
								}();
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{hG: multiselectModuleField})
										}));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bk: page,
											bo: _Utils_update(
												store,
												{
													hH: $elm$core$Maybe$Just(modules)
												})
										}),
									$author$project$Element$PortfolioForm$NoEffect,
									$elm$core$Maybe$Nothing);
							} else {
								var _v13 = _v0.a;
								var modules = _v13.b.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bo: _Utils_update(
												store,
												{
													hH: $elm$core$Maybe$Just(modules)
												})
										}),
									$author$project$Element$PortfolioForm$NoEffect,
									$elm$core$Maybe$Nothing);
							}
						} else {
							var _v14 = _v0.a;
							var error = _v14.b.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										gB: A3(
											$author$project$Session$error,
											session,
											error,
											t_($author$project$Locale$Messages$ModulesDownloadError))
									}),
								$author$project$Element$PortfolioForm$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgModulesDownload,
											$elm$core$Maybe$Just($author$project$Log$paramScopePortfolios),
											error),
										$elm$core$Basics$always($author$project$Element$PortfolioForm$NoOp))),
								$elm$core$Maybe$Nothing);
						}
					case 14:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 1) {
								var people = _v0.a.a.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var studentOptions = A3($author$project$Element$PortfolioForm$toStudentOptions, t_, viewer, people);
								var multiselectStudentsField = A2($author$project$Form$setMultiselectOptions, studentOptions, form.fv);
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{fv: multiselectStudentsField})
										}));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bk: page,
											bo: _Utils_update(
												store,
												{
													m6: $elm$core$Maybe$Just(people)
												})
										}),
									$author$project$Element$PortfolioForm$NoEffect,
									$elm$core$Maybe$Nothing);
							} else {
								var people = _v0.a.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bo: _Utils_update(
												store,
												{
													m6: $elm$core$Maybe$Just(people)
												})
										}),
									$author$project$Element$PortfolioForm$NoEffect,
									$elm$core$Maybe$Nothing);
							}
						} else {
							var error = _v0.a.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										gB: A3(
											$author$project$Session$error,
											session,
											error,
											session.h6($author$project$Locale$Messages$PortfoliosPeopleDownloadError))
									}),
								$author$project$Element$PortfolioForm$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgPortfoliosPeopleDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$PortfolioForm$NoOp))),
								$elm$core$Maybe$Nothing);
						}
					case 12:
						if (!_v0.a.a.$) {
							if (!_v0.b.$) {
								var story = _v0.a.a.a;
								var _v15 = _v0.b;
								return A3($author$project$Element$PortfolioForm$openUpdateFormStep2, story, session, model);
							} else {
								break _v0$24;
							}
						} else {
							var error = _v0.a.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										gB: A3(
											$author$project$Session$error,
											session,
											error,
											t_($author$project$Locale$Messages$PortfoliosDownloadError))
									}),
								$author$project$Element$PortfolioForm$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgPortfoliosDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$PortfolioForm$NoOp))),
								$elm$core$Maybe$Nothing);
						}
					case 13:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 1) {
								var newStory = _v0.a.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											gB: A2(
												$author$project$Session$ok,
												session,
												t_($author$project$Locale$Messages$PortfoliosSaveSuccess))
										}),
									$author$project$Element$PortfolioForm$NavRedirect(
										$author$project$Route$PortfoliosDetail(newStory.i8)),
									$elm$core$Maybe$Nothing);
							} else {
								break _v0$24;
							}
						} else {
							if (_v0.b.$ === 1) {
								var error = _v0.a.a.a;
								var formPage = _v0.b.a;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$FormSaveError));
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{fs: 3}));
								var effect = $author$project$Element$PortfolioForm$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgPortfoliosSave,
											$elm$core$Maybe$Just($author$project$Log$paramScopePortfolios),
											error),
										$elm$core$Basics$always($author$project$Element$PortfolioForm$NoOp)));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{bk: page, gB: session2}),
									effect,
									$elm$core$Maybe$Nothing);
							} else {
								break _v0$24;
							}
						}
					case 8:
						if (_v0.b.$ === 1) {
							var _v16 = _v0.a;
							var documentAvailableMsg = _v16.a;
							var documentType = _v16.b;
							return _Utils_Tuple3(
								model,
								A2(
									$author$project$Element$PortfolioForm$SelectFile,
									$author$project$Element$PortfolioForm$acceptedMimeTypes,
									A2($author$project$Element$PortfolioForm$MediaFileSelected, documentAvailableMsg, documentType)),
								$elm$core$Maybe$Nothing);
						} else {
							break _v0$24;
						}
					case 9:
						if (_v0.b.$ === 1) {
							var _v17 = _v0.a;
							var documentAvailableMsg = _v17.a;
							var documentType = _v17.b;
							var file = _v17.c;
							var formPage = _v0.b.a;
							var form = formPage.bE;
							var values = formPage.eI;
							var valuesWithFileSelected = A2(
								form.w.ks,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.w.ks,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								ls: documentType,
								mD: $elm$file$File$mime(file),
								m9: $elm$core$String$fromInt(session.ok.i8),
								nx: $author$project$Element$PortfolioForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.w, valuesWithFileSelected)) {
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													w: $author$project$Form$markEdited(form.w)
												}),
											eI: valuesWithFileSelected
										}));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{bk: page}),
									$author$project$Element$PortfolioForm$RequestPolicy(
										A3(
											$author$project$S3$requestPolicyV2,
											config.gX,
											params,
											A2($author$project$Element$PortfolioForm$MediaPolicyDownloaded, documentAvailableMsg, file))),
									$elm$core$Maybe$Nothing);
							} else {
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													w: $author$project$Form$markEdited(form.w)
												}),
											eI: valuesWithFileError
										}));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{bk: page}),
									$author$project$Element$PortfolioForm$NoEffect,
									$elm$core$Maybe$Nothing);
							}
						} else {
							break _v0$24;
						}
					case 10:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 1) {
								var _v18 = _v0.a;
								var documentAvailableMsg = _v18.a;
								var file = _v18.b;
								var policy = _v18.c.a;
								return _Utils_Tuple3(
									model,
									$author$project$Element$PortfolioForm$UploadFile(
										A4(
											$author$project$S3$uploadFileV2,
											config.gX,
											policy,
											file,
											A2($author$project$Element$PortfolioForm$MediaFileUploaded, documentAvailableMsg, file))),
									$elm$core$Maybe$Nothing);
							} else {
								break _v0$24;
							}
						} else {
							if (_v0.b.$ === 1) {
								var _v19 = _v0.a;
								var error = _v19.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$FormFileUploadError));
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{
											eI: A2(form.w.ks, $author$project$Form$NoFile, values)
										}));
								var effect = $author$project$Element$PortfolioForm$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$PortfolioForm$NoOp)));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{bk: page, gB: session2}),
									effect,
									$elm$core$Maybe$Nothing);
							} else {
								break _v0$24;
							}
						}
					case 11:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 1) {
								var _v20 = _v0.a;
								var documentAvailableMsg = _v20.a;
								var file = _v20.b;
								var metadata = _v20.c.a;
								var _v21 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ar);
								if (!_v21.$) {
									var location = _v21.a;
									var $temp$msg = documentAvailableMsg(location),
										$temp$model = model;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$msg = A3(
										$author$project$Element$PortfolioForm$MediaFileUploaded,
										documentAvailableMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$24;
							}
						} else {
							if (_v0.b.$ === 1) {
								var _v22 = _v0.a;
								var error = _v22.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$FormFileUploadError));
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{
											eI: A2(form.w.ks, $author$project$Form$NoFile, values)
										}));
								var effect = $author$project$Element$PortfolioForm$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgFileUpload,
											$elm$core$Maybe$Just($author$project$Log$paramScopePortfolios),
											error),
										$elm$core$Basics$always($author$project$Element$PortfolioForm$NoOp)));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{bk: page, gB: session2}),
									effect,
									$elm$core$Maybe$Nothing);
							} else {
								break _v0$24;
							}
						}
					default:
						var _v23 = _v0.a;
						return noop;
				}
			}
			return noop;
		}
	});
var $author$project$Element$PortfolioForm$viewDocumentViewer = F2(
	function (session, documentModel) {
		return A3($author$project$Application$V3$Boundaries$viewElement, session, documentModel, $author$project$Element$PortfolioForm$documentViewer);
	});
var $author$project$Element$PortfolioForm$FormReset = {$: 4};
var $author$project$Element$PortfolioForm$FormSubmitted = {$: 3};
var $author$project$Element$PortfolioForm$MediaFileUploadRequested = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Element$PortfolioForm$OpenDocumentViewer = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$PortfoliosHeadingEdit = {$: 376};
var $author$project$Locale$Messages$PortfoliosHeadingNew = {$: 377};
var $author$project$Locale$Messages$PortfoliosHelpCreate = {$: 349};
var $author$project$Locale$Messages$PortfoliosMediaUploadHelp = function (a) {
	return {$: 375, a: a};
};
var $author$project$Locale$Messages$StudentProfileFormDocumentUploaded = {$: 528};
var $author$project$Locale$Messages$StudentProfileFormDocumentView = {$: 527};
var $author$project$Locale$Messages$StudentProfileFormNewDocument = {$: 526};
var $author$project$UI$fieldCustomLabel = F3(
	function (t_, field, message) {
		return A4($author$project$UI$label_, $elm$html$Html$label, t_, message, field);
	});
var $author$project$Form$isUploading = F2(
	function (fileField, values) {
		var _v0 = fileField.fC(values);
		if (_v0.$ === 1) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$UI$fileField_ = F6(
	function (t_, field, customLabel, values, toUploadMsg, toDownloadMsg) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		var uploadButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'is-loading',
							A2($author$project$Form$isUploading, field, values))
						])),
					$elm$html$Html$Events$onClick(
					A2(toUploadMsg, field.og.fe, field.og.cm))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face(field.og.e6)
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentProfileFormNewDocument)
						]))
				]));
		var hiddenInput = function () {
			var _v1 = field.fC(values);
			if (_v1.$ === 2) {
				var location = _v1.a;
				return A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('hidden'),
							$elm$html$Html$Attributes$value(location),
							$author$project$UI$attrCyData(field.og.cm)
						]),
					_List_Nil);
			} else {
				return A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('hidden'),
							$elm$html$Html$Attributes$value(''),
							$author$project$UI$attrCyData(field.og.cm)
						]),
					_List_Nil);
			}
		}();
		var fileCaption = function () {
			var _v0 = field.fC(values);
			if (_v0.$ === 2) {
				var location = _v0.a;
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							(field.e0 && valid) ? $author$project$UI$Icon$check(
							_List_fromArray(
								[
									$author$project$UI$Icon$style('has-text-grey')
								])) : $author$project$UI$none,
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentProfileFormDocumentUploaded),
							A3(
							$author$project$UI$actionLink,
							toDownloadMsg(location),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(location),
									$author$project$UI$attrCyData(field.og.cm + '-preview')
								]),
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentProfileFormDocumentView)
								]))
						]));
			} else {
				return $author$project$UI$none;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('has-errors', !valid)
						]))
				]),
			_List_fromArray(
				[
					A3($author$project$UI$fieldCustomLabel, t_, field, customLabel),
					hiddenInput,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('control block')
						]),
					_List_fromArray(
						[uploadButton])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[fileCaption])),
					A2($author$project$UI$validationError, field, values)
				]));
	});
var $author$project$UI$fileField = F5(
	function (t_, field, values, toUploadMsg, toDownloadMsg) {
		return A6($author$project$UI$fileField_, t_, field, $elm$core$Maybe$Nothing, values, toUploadMsg, toDownloadMsg);
	});
var $author$project$Form$toSavedObject = function (action) {
	if (!action.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var x = action.a;
		return $elm$core$Maybe$Just(x);
	}
};
var $author$project$Element$PortfolioForm$viewForm = F2(
	function (t_, _v0) {
		var action = _v0.iq;
		var state = _v0.fs;
		var form = _v0.bE;
		var values = _v0.eI;
		var maxFileSizeInMb = ((($author$project$Element$PortfolioForm$maxFileSize / 1024) | 0) / 1024) | 0;
		var viewFormFields = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth')
				]),
			_List_fromArray(
				[
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$richTextEditorField, t_, form.g8, values)
						])),
					function () {
					var _v2 = A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.iI;
						},
						$author$project$Form$toSavedObject(action));
					if (!_v2.$) {
						return $author$project$UI$none;
					} else {
						return $author$project$UI$columns(
							_List_fromArray(
								[
									A4(
									$author$project$UI$withInfoText,
									_List_Nil,
									t_,
									$author$project$Locale$Messages$PortfoliosMediaUploadHelp(maxFileSizeInMb),
									A5($author$project$UI$fileField, t_, form.w, values, $author$project$Element$PortfolioForm$MediaFileUploadRequested, $author$project$Element$PortfolioForm$OpenDocumentViewer))
								]));
					}
				}(),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$multiselectChoiceField, t_, form.fv, values),
							A3($author$project$UI$multiselectChoiceField, t_, form.hG, values)
						]))
				]));
		var headingText = function () {
			if (!action.$) {
				return $author$project$Locale$Messages$PortfoliosHeadingNew;
			} else {
				return $author$project$Locale$Messages$PortfoliosHeadingEdit;
			}
		}();
		var formState = A2($author$project$Form$isUploading, form.w, values) ? 2 : state;
		return $author$project$UI$panel(
			{
				g$: _List_fromArray(
					[
						viewFormFields,
						A5(
						$author$project$UI$formButtons,
						t_,
						action,
						formState,
						$author$project$Element$PortfolioForm$FormSubmitted,
						$elm$core$Basics$always($author$project$Element$PortfolioForm$FormReset))
					]),
				cm: 'portfolios-form',
				hl: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, headingText)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('https://www.loom.com/share/2a59b4e4d08049ff9aa74019f5289474'),
										$elm$html$Html$Attributes$target('_blank'),
										$elm$html$Html$Attributes$title(
										t_($author$project$Locale$Messages$PortfoliosHelpCreate))
									]),
								_List_fromArray(
									[
										$author$project$UI$Icon$help(
										_List_fromArray(
											[
												$author$project$UI$Icon$style('has-text-info')
											]))
									]))
							]))
					]),
				h7: _List_Nil,
				ie: 'is-light'
			});
	});
var $author$project$Element$PortfolioForm$view = function (model) {
	var page = model.bk;
	var session = model.gB;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				if (page.$ === 1) {
					var formPage = page.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Element$PortfolioForm$viewForm, session.h6, formPage),
								A2(
								$author$project$UI$maybe,
								model.d0,
								$author$project$Element$PortfolioForm$viewDocumentViewer(session))
							]));
				} else {
					return A2(
						$author$project$UI$progressBar,
						'is-link',
						session.h6($author$project$Locale$Messages$PortfoliosLoadingProgress));
				}
			}()
			]));
};
var $author$project$Element$PortfolioForm$element = {jb: $author$project$Element$PortfolioForm$init, hP: $author$project$Element$PortfolioForm$perform, ks: $author$project$Element$PortfolioForm$update, og: $author$project$Element$PortfolioForm$view};
var $author$project$Element$ReconciliationPage$Allocatable = 0;
var $author$project$Element$ReconciliationPage$Ascending = 0;
var $author$project$Element$ReconciliationPage$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ReconciliationPage$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ReconciliationPage$FetchPayments = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ReconciliationPage$FetchTuitionFeeObligations = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ReconciliationPage$NoDrag = {$: 2};
var $author$project$Element$ReconciliationPage$PartnerCardsView = 0;
var $author$project$Element$ReconciliationPage$PaymentsDownloaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ReconciliationPage$TuitionFeeObligationsDownloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Obligation$TuitionFeeType = 1;
var $author$project$Payment$Payment = function (id) {
	return function (amount) {
		return function (date) {
			return function (partner) {
				return function (partnerAccount) {
					return function (reference) {
						return function (internalComment) {
							return function (category) {
								return function (ignored) {
									return function (reconciliations) {
										return {x: amount, bD: category, lj: date, i8: id, lX: ignored, b$: internalComment, m3: partner, m4: partnerAccount, es: reconciliations, ne: reference};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Payment$Deposit = 1;
var $author$project$Payment$Other = 2;
var $author$project$Payment$StartupFee = 0;
var $author$project$Payment$paymentCategoryDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'startup_fee':
				return $elm$json$Json$Decode$succeed(0);
			case 'deposit':
				return $elm$json$Json$Decode$succeed(1);
			case 'other':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unknown type: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Payment$Reconciliation = F3(
	function (id, obligation, amount) {
		return {x: amount, i8: id, n: obligation};
	});
var $author$project$Obligation$CompanyContract = function (a) {
	return {$: 0, a: a};
};
var $author$project$Obligation$TuitionFee = function (a) {
	return {$: 1, a: a};
};
var $author$project$Obligation$CompanyContractObligation = F7(
	function (id, dueDate, completionDate, amount, annotatedReceivable, student, companyName) {
		return {x: amount, fJ: annotatedReceivable, iL: companyName, iM: completionDate, lv: dueDate, i8: id, nT: student};
	});
var $author$project$Obligation$NestedPersonWithXeroId = F5(
	function (id, firstName, lastName, email, xeroId) {
		return {O: email, lI: firstName, i8: id, av: lastName, op: xeroId};
	});
var $author$project$Obligation$nestedPersonWithXeroIdDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'xero_id',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'email',
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'last_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'first_name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Obligation$NestedPersonWithXeroId))))));
var $author$project$Obligation$companyContractObligationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'company_name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'student',
		$author$project$Obligation$nestedPersonWithXeroIdDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'annotated_receivable',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'amount',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'completion_date',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'due_date',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Obligation$CompanyContractObligation))))))));
var $author$project$Obligation$TuitionFeeObligation = F7(
	function (id, dueDate, completionDate, amount, annotatedReceivable, student, invoiceNumber) {
		return {x: amount, fJ: annotatedReceivable, iM: completionDate, lv: dueDate, i8: id, hu: invoiceNumber, nT: student};
	});
var $author$project$Obligation$tuitionFeeObligationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'invoice_number',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'student',
		$author$project$Obligation$nestedPersonWithXeroIdDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'annotated_receivable',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'amount',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'completion_date',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'due_date',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Obligation$TuitionFeeObligation))))))));
var $author$project$Payment$reconciledObligationDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (contentType) {
		switch (contentType) {
			case 'company-contract':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Obligation$CompanyContract,
					A2($elm$json$Json$Decode$field, 'obligation', $author$project$Obligation$companyContractObligationDecoder));
			case 'tuition-fee':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Obligation$TuitionFee,
					A2($elm$json$Json$Decode$field, 'obligation', $author$project$Obligation$tuitionFeeObligationDecoder));
			default:
				return $elm$json$Json$Decode$fail('Unknown content_type: ' + contentType);
		}
	},
	A2($elm$json$Json$Decode$field, 'content_type', $elm$json$Json$Decode$string));
var $author$project$Payment$reconciliationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amount',
	$elm$json$Json$Decode$int,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Payment$reconciledObligationDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'id',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Payment$Reconciliation))));
var $author$project$Payment$paymentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'reconciliations',
	$elm$json$Json$Decode$list($author$project$Payment$reconciliationDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ignored',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'category',
			$elm$json$Json$Decode$nullable($author$project$Payment$paymentCategoryDecoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'internal_comment',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'reference',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'partner_account',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'partner',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'date',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'amount',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$int,
										$elm$json$Json$Decode$succeed($author$project$Payment$Payment)))))))))));
var $author$project$Api$Endpoint$makePaymentsQueryParams = F7(
	function (params, search, isIgnored, categories, isAllocatable, obligationId, obligationType) {
		return A3(
			$author$project$Api$Endpoint$optional,
			$elm$core$Basics$identity,
			_Utils_Tuple2('obligation_type', obligationType),
			A3(
				$author$project$Api$Endpoint$optional,
				$elm$core$String$fromInt,
				_Utils_Tuple2('obligation_id', obligationId),
				A3(
					$author$project$Api$Endpoint$optional,
					$elm$core$String$fromInt,
					_Utils_Tuple2('last_seen', params.b0),
					A3(
						$author$project$Api$Endpoint$optionalList,
						$elm$core$Basics$identity,
						_Utils_Tuple2(
							'categories',
							$elm$core$Maybe$Just(categories)),
						A3(
							$author$project$Api$Endpoint$optional,
							$author$project$Api$Endpoint$stringFromBool,
							_Utils_Tuple2('is_allocatable', isAllocatable),
							_List_fromArray(
								[
									_Utils_Tuple2(
									'size',
									$elm$core$String$fromInt(params.ce)),
									_Utils_Tuple2('q', search),
									_Utils_Tuple2(
									'is_ignored',
									$author$project$Api$Endpoint$stringFromBool(isIgnored))
								]))))));
	});
var $author$project$Api$Endpoint$payments = F8(
	function (config, search, isIgnored, categories, isAllocatable, params, obligationId, obligationType) {
		var queryParams = A7($author$project$Api$Endpoint$makePaymentsQueryParams, params, search, isIgnored, categories, isAllocatable, obligationId, obligationType);
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'payments']),
			queryParams);
	});
var $author$project$Payment$fetchPayments2 = F9(
	function (config, search, isIgnored, categories, isAllocatable, params, obligationId, obligationType, callback) {
		var categoryStrings = A2(
			$elm$core$List$map,
			function (cat) {
				switch (cat) {
					case 0:
						return 'startup_fee';
					case 1:
						return 'deposit';
					default:
						return 'other';
				}
			},
			categories);
		return {
			b_: config,
			d_: $elm$json$Json$Decode$list($author$project$Payment$paymentDecoder),
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A8($author$project$Api$Endpoint$payments, config, search, isIgnored, categoryStrings, isAllocatable, params, obligationId, obligationType)
		};
	});
var $author$project$Obligation$tuitionFeeObligationAsObligationDecoder = A2($elm$json$Json$Decode$map, $author$project$Obligation$TuitionFee, $author$project$Obligation$tuitionFeeObligationDecoder);
var $author$project$Api$Endpoint$tuitionFeeObligations = F2(
	function (config, search) {
		var queryParams = _List_fromArray(
			[
				_Utils_Tuple2('q', search)
			]);
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'tuition-fee-obligations']),
			queryParams);
	});
var $author$project$Obligation$fetchTuitionFeeObligations2 = F3(
	function (config, search, callback) {
		return {
			b_: config,
			d_: $elm$json$Json$Decode$list($author$project$Obligation$tuitionFeeObligationAsObligationDecoder),
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2($author$project$Api$Endpoint$tuitionFeeObligations, config, search)
		};
	});
var $author$project$Element$ReconciliationPage$pageSize = 20;
var $author$project$Element$ReconciliationPage$init = F3(
	function (config, session, _v0) {
		var initialPaymentParams = {b0: $elm$core$Maybe$Nothing, ce: $author$project$Element$ReconciliationPage$pageSize};
		return _Utils_Tuple3(
			{
				cZ: 1,
				br: 0,
				b_: config,
				bJ: $elm$core$Maybe$Nothing,
				p: {Z: $elm$core$Maybe$Nothing, B: $author$project$Element$ReconciliationPage$NoDrag},
				dk: '',
				cF: $author$project$RemoteData$Loading,
				bl: '',
				af: $author$project$RemoteData$Loading,
				cJ: false,
				g: _List_Nil,
				gB: session,
				ez: 0,
				eA: $elm$core$Maybe$Nothing,
				oi: 0
			},
			$author$project$Element$ReconciliationPage$BatchEffect(
				_List_fromArray(
					[
						$author$project$Element$ReconciliationPage$Cmd(
						$author$project$Element$ReconciliationPage$FetchPayments(
							A9(
								$author$project$Payment$fetchPayments2,
								config.gX,
								'',
								false,
								_List_Nil,
								$elm$core$Maybe$Just(true),
								initialPaymentParams,
								$elm$core$Maybe$Nothing,
								$elm$core$Maybe$Nothing,
								$author$project$Element$ReconciliationPage$PaymentsDownloaded))),
						$author$project$Element$ReconciliationPage$Cmd(
						$author$project$Element$ReconciliationPage$FetchTuitionFeeObligations(
							A3($author$project$Obligation$fetchTuitionFeeObligations2, config.gX, '', $author$project$Element$ReconciliationPage$TuitionFeeObligationsDownloaded)))
					])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$ReconciliationPage$perform = F2(
	function (_v0, effect) {
		var go = function (eff) {
			switch (eff.$) {
				case 0:
					return $elm$core$Platform$Cmd$none;
				case 1:
					var effects = eff.a;
					return $elm$core$Platform$Cmd$batch(
						A2($elm$core$List$map, go, effects));
				default:
					var cmd = eff.a;
					switch (cmd.$) {
						case 0:
							var request = cmd.a;
							return $author$project$Api$getV2(request);
						case 1:
							var request = cmd.a;
							return $author$project$Api$getV2(request);
						case 2:
							var request = cmd.a;
							return $author$project$Api$getV2(request);
						case 3:
							var seconds = cmd.a;
							var toMsg = cmd.b;
							return A2($author$project$Util$Delay$after, seconds, toMsg);
						default:
							var request = cmd.a;
							return $author$project$Api$patchV2(request);
					}
			}
		};
		return go(effect);
	});
var $author$project$Element$ReconciliationPage$Delay = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Element$ReconciliationPage$DelayedObligationSearchQueryChanged = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$ReconciliationPage$DelayedPaymentCommentUpdate = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Element$ReconciliationPage$DelayedPaymentSearchQueryChanged = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$ReconciliationPage$Deleted = 2;
var $author$project$Element$ReconciliationPage$Descending = 1;
var $author$project$Element$ReconciliationPage$DragObligation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ReconciliationPage$DragPayment = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ReconciliationPage$MorePaymentsDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ReconciliationPage$NoEffect = {$: 0};
var $author$project$Element$ReconciliationPage$PaymentUpdated = function (a) {
	return {$: 27, a: a};
};
var $author$project$Element$ReconciliationPage$Pending = 0;
var $author$project$Element$ReconciliationPage$Reconciled = 1;
var $author$project$Element$ReconciliationPage$Saved = 1;
var $author$project$Element$ReconciliationPage$UpdatePayment = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$ReconciliationPage$addNotification = F2(
	function (notification, model) {
		var session1 = model.gB;
		var session2 = _Utils_update(
			session1,
			{
				em: A2($author$project$Notification$add, notification, session1.em)
			});
		return _Utils_update(
			model,
			{gB: session2});
	});
var $author$project$Obligation$obligationStudent = function (obligation) {
	if (!obligation.$) {
		var o = obligation.a;
		return o.nT;
	} else {
		var o = obligation.a;
		return o.nT;
	}
};
var $author$project$Element$ReconciliationPage$aggregateObligationsByStudent = function (obligations) {
	var groupByStudent = A3(
		$elm$core$List$foldl,
		F2(
			function (ob, acc) {
				var student = $author$project$Obligation$obligationStudent(ob);
				var studentId = student.i8;
				var others = A2(
					$elm$core$List$filter,
					function (p) {
						return !_Utils_eq(p.m8.i8, studentId);
					},
					acc);
				var existing = A2(
					$elm$core$List$filter,
					function (p) {
						return _Utils_eq(p.m8.i8, studentId);
					},
					acc);
				if (existing.b && (!existing.b.b)) {
					var partner = existing.a;
					return A2(
						$elm$core$List$cons,
						_Utils_update(
							partner,
							{
								cX: _Utils_ap(
									partner.cX,
									_List_fromArray(
										[ob]))
							}),
						others);
				} else {
					return A2(
						$elm$core$List$cons,
						{
							m8: student,
							cX: _List_fromArray(
								[ob])
						},
						acc);
				}
			}),
		_List_Nil,
		obligations);
	return groupByStudent;
};
var $author$project$Element$ReconciliationPage$CompanyObligationsDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ReconciliationPage$FetchCompanyObligations = function (a) {
	return {$: 1, a: a};
};
var $author$project$Obligation$companyContractObligationAsObligationDecoder = A2($elm$json$Json$Decode$map, $author$project$Obligation$CompanyContract, $author$project$Obligation$companyContractObligationDecoder);
var $author$project$Api$Endpoint$companyContractObligations = F2(
	function (config, search) {
		var queryParams = _List_fromArray(
			[
				_Utils_Tuple2('q', search)
			]);
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'company-contract-obligations']),
			queryParams);
	});
var $author$project$Obligation$fetchCompanyContractObligations2 = F3(
	function (config, search, callback) {
		return {
			b_: config,
			d_: $elm$json$Json$Decode$list($author$project$Obligation$companyContractObligationAsObligationDecoder),
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2($author$project$Api$Endpoint$companyContractObligations, config, search)
		};
	});
var $author$project$Element$ReconciliationPage$fetchObligationsEffect = F3(
	function (obligationType, search, config) {
		if (!obligationType) {
			return $author$project$Element$ReconciliationPage$FetchCompanyObligations(
				A3($author$project$Obligation$fetchCompanyContractObligations2, config, search, $author$project$Element$ReconciliationPage$CompanyObligationsDownloaded));
		} else {
			return $author$project$Element$ReconciliationPage$FetchTuitionFeeObligations(
				A3($author$project$Obligation$fetchTuitionFeeObligations2, config, search, $author$project$Element$ReconciliationPage$TuitionFeeObligationsDownloaded));
		}
	});
var $author$project$Element$ReconciliationPage$fetchPaymentsEffect = F5(
	function (filterType, search, obligationId, obligationType, config) {
		var paymentParams = {b0: $elm$core$Maybe$Nothing, ce: $author$project$Element$ReconciliationPage$pageSize};
		switch (filterType) {
			case 0:
				return $author$project$Element$ReconciliationPage$FetchPayments(
					A9(
						$author$project$Payment$fetchPayments2,
						config,
						search,
						false,
						_List_Nil,
						$elm$core$Maybe$Just(true),
						paymentParams,
						obligationId,
						obligationType,
						$author$project$Element$ReconciliationPage$PaymentsDownloaded));
			case 1:
				return $author$project$Element$ReconciliationPage$FetchPayments(
					A9(
						$author$project$Payment$fetchPayments2,
						config,
						search,
						false,
						_List_Nil,
						$elm$core$Maybe$Just(false),
						paymentParams,
						obligationId,
						obligationType,
						$author$project$Element$ReconciliationPage$PaymentsDownloaded));
			case 2:
				return $author$project$Element$ReconciliationPage$FetchPayments(
					A9(
						$author$project$Payment$fetchPayments2,
						config,
						search,
						true,
						_List_fromArray(
							[0]),
						$elm$core$Maybe$Nothing,
						paymentParams,
						obligationId,
						obligationType,
						$author$project$Element$ReconciliationPage$PaymentsDownloaded));
			case 3:
				return $author$project$Element$ReconciliationPage$FetchPayments(
					A9(
						$author$project$Payment$fetchPayments2,
						config,
						search,
						true,
						_List_fromArray(
							[1]),
						$elm$core$Maybe$Nothing,
						paymentParams,
						obligationId,
						obligationType,
						$author$project$Element$ReconciliationPage$PaymentsDownloaded));
			case 4:
				return $author$project$Element$ReconciliationPage$FetchPayments(
					A9(
						$author$project$Payment$fetchPayments2,
						config,
						search,
						true,
						_List_fromArray(
							[2]),
						$elm$core$Maybe$Nothing,
						paymentParams,
						obligationId,
						obligationType,
						$author$project$Element$ReconciliationPage$PaymentsDownloaded));
			default:
				return $author$project$Element$ReconciliationPage$FetchPayments(
					A9($author$project$Payment$fetchPayments2, config, search, true, _List_Nil, $elm$core$Maybe$Nothing, paymentParams, obligationId, obligationType, $author$project$Element$ReconciliationPage$PaymentsDownloaded));
		}
	});
var $author$project$Element$ReconciliationPage$localReconciliationItems = $elm$core$List$filter(
	function (_v0) {
		var state = _v0.c;
		return (!state) || (state === 2);
	});
var $author$project$Obligation$obligationId = function (obligation) {
	if (!obligation.$) {
		var o = obligation.a;
		return o.i8;
	} else {
		var o = obligation.a;
		return o.i8;
	}
};
var $author$project$Obligation$obligationAnnotatedReceivable = function (obligation) {
	if (!obligation.$) {
		var o = obligation.a;
		return o.fJ;
	} else {
		var o = obligation.a;
		return o.fJ;
	}
};
var $author$project$Obligation$obligationsEqual = F2(
	function (item1, item2) {
		var _v0 = _Utils_Tuple2(item1, item2);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var o1 = _v0.a.a;
					var o2 = _v0.b.a;
					return _Utils_eq(o1.i8, o2.i8);
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b.$ === 1) {
					var o1 = _v0.a.a;
					var o2 = _v0.b.a;
					return _Utils_eq(o1.i8, o2.i8);
				} else {
					break _v0$2;
				}
			}
		}
		return false;
	});
var $author$project$Element$ReconciliationPage$obligationReceivable = F2(
	function (obligation, reconciliationItems) {
		var totalReconciled = A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, acc) {
					var r = _v0.b;
					var state = _v0.c;
					return (A2($author$project$Obligation$obligationsEqual, r.n, obligation) && (!state)) ? (acc + r.x) : acc;
				}),
			0,
			reconciliationItems);
		return $author$project$Obligation$obligationAnnotatedReceivable(obligation) - totalReconciled;
	});
var $author$project$Element$ReconciliationPage$reconciliationsForPayment = function (payment) {
	return $elm$core$List$filter(
		function (_v0) {
			var p = _v0.a;
			return _Utils_eq(p.i8, payment.i8);
		});
};
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, _List_Nil, list, _List_Nil);
	});
var $author$project$Api$Endpoint$payment = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'payments',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$Payment$paymentPayloadEncoder = function (payment) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(payment.i8)),
				_Utils_Tuple2(
				'internal_comment',
				function () {
					var _v0 = payment.b$;
					if (!_v0.$) {
						var ic = _v0.a;
						return $elm$json$Json$Encode$string(ic);
					} else {
						return $elm$json$Json$Encode$null;
					}
				}()),
				_Utils_Tuple2(
				'category',
				function () {
					var _v1 = payment.bD;
					if (!_v1.$) {
						var c = _v1.a;
						switch (c) {
							case 0:
								return $elm$json$Json$Encode$string('startup_fee');
							case 1:
								return $elm$json$Json$Encode$string('deposit');
							default:
								return $elm$json$Json$Encode$string('other');
						}
					} else {
						return $elm$json$Json$Encode$null;
					}
				}()),
				_Utils_Tuple2(
				'reconciliations',
				function () {
					var _v3 = payment.es;
					if (!_v3.$) {
						var recs = _v3.a;
						return A2(
							$elm$json$Json$Encode$list,
							function (rec) {
								return $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'id',
											function () {
												var _v4 = rec.i8;
												if (!_v4.$) {
													var rid = _v4.a;
													return $elm$json$Json$Encode$int(rid);
												} else {
													return $elm$json$Json$Encode$null;
												}
											}()),
											_Utils_Tuple2(
											'obligation_type',
											function () {
												var _v5 = rec.n;
												if (!_v5.$) {
													return $elm$json$Json$Encode$string('company-contract');
												} else {
													return $elm$json$Json$Encode$string('tuition-fee');
												}
											}()),
											_Utils_Tuple2(
											'obligation_id',
											function () {
												var _v6 = rec.n;
												if (!_v6.$) {
													var o = _v6.a;
													return $elm$json$Json$Encode$int(o.i8);
												} else {
													var o = _v6.a;
													return $elm$json$Json$Encode$int(o.i8);
												}
											}()),
											_Utils_Tuple2(
											'amount',
											$elm$json$Json$Encode$int(rec.x))
										]));
							},
							recs);
					} else {
						return $elm$json$Json$Encode$null;
					}
				}())
			]));
};
var $author$project$Payment$updatePayment = F3(
	function (config, payment, callback) {
		return {
			T: $author$project$Payment$paymentPayloadEncoder(payment),
			b_: config,
			d_: $author$project$Payment$paymentDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2($author$project$Api$Endpoint$payment, config.gX, payment.i8)
		};
	});
var $author$project$Element$ReconciliationPage$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var data = msg.a;
				var reconciliations2 = function () {
					if (data.$ === 2) {
						var payments = data.a;
						var serverRecs = A3(
							$elm$core$List$foldl,
							F2(
								function (payment, acc) {
									var tuples = A2(
										$elm$core$List$map,
										function (rec) {
											return _Utils_Tuple3(payment, rec, 1);
										},
										payment.es);
									return _Utils_ap(acc, tuples);
								}),
							_List_Nil,
							payments);
						return A2(
							$elm_community$list_extra$List$Extra$uniqueBy,
							function (_v2) {
								var payment = _v2.a;
								var rec = _v2.b;
								return _Utils_Tuple2(
									payment.i8,
									$author$project$Obligation$obligationId(rec.n));
							},
							_Utils_ap(
								$author$project$Element$ReconciliationPage$localReconciliationItems(model.g),
								serverRecs));
					} else {
						return model.g;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{af: data, cJ: false, g: reconciliations2}),
					$author$project$Element$ReconciliationPage$NoEffect,
					$elm$core$Maybe$Nothing);
			case 1:
				var data = msg.a;
				var _v3 = _Utils_Tuple2(model.af, data);
				if ((_v3.a.$ === 2) && (_v3.b.$ === 2)) {
					var existingPayments = _v3.a.a;
					var newPayments = _v3.b.a;
					var allPayments = A2(
						$elm_community$list_extra$List$Extra$uniqueBy,
						function ($) {
							return $.i8;
						},
						_Utils_ap(existingPayments, newPayments));
					var serverRecs = A3(
						$elm$core$List$foldl,
						F2(
							function (payment, acc) {
								var tuples = A2(
									$elm$core$List$map,
									function (rec) {
										return _Utils_Tuple3(payment, rec, 1);
									},
									payment.es);
								return _Utils_ap(acc, tuples);
							}),
						_List_Nil,
						allPayments);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								af: $author$project$RemoteData$Success(allPayments),
								cJ: false,
								g: A2(
									$elm_community$list_extra$List$Extra$uniqueBy,
									function (_v4) {
										var payment = _v4.a;
										var rec = _v4.b;
										return _Utils_Tuple2(
											payment.i8,
											$author$project$Obligation$obligationId(rec.n));
									},
									_Utils_ap(
										$author$project$Element$ReconciliationPage$localReconciliationItems(model.g),
										serverRecs))
							}),
						$author$project$Element$ReconciliationPage$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cJ: false}),
						$author$project$Element$ReconciliationPage$NoEffect,
						$elm$core$Maybe$Nothing);
				}
			case 2:
				var _v5 = model.af;
				if (_v5.$ === 2) {
					var existingPayments = _v5.a;
					if (model.cJ) {
						return _Utils_Tuple3(model, $author$project$Element$ReconciliationPage$NoEffect, $elm$core$Maybe$Nothing);
					} else {
						var lastPaymentId = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.i8;
							},
							$elm$core$List$head(
								$elm$core$List$reverse(existingPayments)));
						var paymentParams = {b0: lastPaymentId, ce: $author$project$Element$ReconciliationPage$pageSize};
						var effect = function () {
							var _v6 = model.br;
							switch (_v6) {
								case 0:
									return $author$project$Element$ReconciliationPage$FetchPayments(
										A9(
											$author$project$Payment$fetchPayments2,
											model.b_.gX,
											model.bl,
											false,
											_List_Nil,
											$elm$core$Maybe$Just(true),
											paymentParams,
											$elm$core$Maybe$Nothing,
											$elm$core$Maybe$Nothing,
											$author$project$Element$ReconciliationPage$MorePaymentsDownloaded));
								case 1:
									return $author$project$Element$ReconciliationPage$FetchPayments(
										A9(
											$author$project$Payment$fetchPayments2,
											model.b_.gX,
											model.bl,
											false,
											_List_Nil,
											$elm$core$Maybe$Just(false),
											paymentParams,
											$elm$core$Maybe$Nothing,
											$elm$core$Maybe$Nothing,
											$author$project$Element$ReconciliationPage$MorePaymentsDownloaded));
								case 2:
									return $author$project$Element$ReconciliationPage$FetchPayments(
										A9(
											$author$project$Payment$fetchPayments2,
											model.b_.gX,
											model.bl,
											true,
											_List_fromArray(
												[0]),
											$elm$core$Maybe$Nothing,
											paymentParams,
											$elm$core$Maybe$Nothing,
											$elm$core$Maybe$Nothing,
											$author$project$Element$ReconciliationPage$MorePaymentsDownloaded));
								case 3:
									return $author$project$Element$ReconciliationPage$FetchPayments(
										A9(
											$author$project$Payment$fetchPayments2,
											model.b_.gX,
											model.bl,
											true,
											_List_fromArray(
												[1]),
											$elm$core$Maybe$Nothing,
											paymentParams,
											$elm$core$Maybe$Nothing,
											$elm$core$Maybe$Nothing,
											$author$project$Element$ReconciliationPage$MorePaymentsDownloaded));
								case 4:
									return $author$project$Element$ReconciliationPage$FetchPayments(
										A9(
											$author$project$Payment$fetchPayments2,
											model.b_.gX,
											model.bl,
											true,
											_List_fromArray(
												[2]),
											$elm$core$Maybe$Nothing,
											paymentParams,
											$elm$core$Maybe$Nothing,
											$elm$core$Maybe$Nothing,
											$author$project$Element$ReconciliationPage$MorePaymentsDownloaded));
								default:
									return $author$project$Element$ReconciliationPage$FetchPayments(
										A9($author$project$Payment$fetchPayments2, model.b_.gX, model.bl, true, _List_Nil, $elm$core$Maybe$Nothing, paymentParams, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $author$project$Element$ReconciliationPage$MorePaymentsDownloaded));
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cJ: true}),
							$author$project$Element$ReconciliationPage$Cmd(effect),
							$elm$core$Maybe$Nothing);
					}
				} else {
					return _Utils_Tuple3(model, $author$project$Element$ReconciliationPage$NoEffect, $elm$core$Maybe$Nothing);
				}
			case 3:
				var data = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cF: data}),
					$author$project$Element$ReconciliationPage$NoEffect,
					$elm$core$Maybe$Nothing);
			case 4:
				var data = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cF: data}),
					$author$project$Element$ReconciliationPage$NoEffect,
					$elm$core$Maybe$Nothing);
			case 5:
				var query = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bl: query, af: $author$project$RemoteData$Loading}),
					$author$project$Element$ReconciliationPage$Cmd(
						A2(
							$author$project$Element$ReconciliationPage$Delay,
							$author$project$Util$Delay$searchBarDelay,
							$author$project$Element$ReconciliationPage$DelayedPaymentSearchQueryChanged(query))),
					$elm$core$Maybe$Nothing);
			case 6:
				var query = msg.a;
				var effect = _Utils_eq(query, model.bl) ? $author$project$Element$ReconciliationPage$Cmd(
					A5($author$project$Element$ReconciliationPage$fetchPaymentsEffect, model.br, query, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, model.b_.gX)) : $author$project$Element$ReconciliationPage$NoEffect;
				return _Utils_Tuple3(model, effect, $elm$core$Maybe$Nothing);
			case 7:
				var query = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dk: query, cF: $author$project$RemoteData$Loading}),
					$author$project$Element$ReconciliationPage$Cmd(
						A2(
							$author$project$Element$ReconciliationPage$Delay,
							$author$project$Util$Delay$searchBarDelay,
							$author$project$Element$ReconciliationPage$DelayedObligationSearchQueryChanged(query))),
					$elm$core$Maybe$Nothing);
			case 8:
				var query = msg.a;
				var effect = _Utils_eq(query, model.dk) ? $author$project$Element$ReconciliationPage$Cmd(
					A3($author$project$Element$ReconciliationPage$fetchObligationsEffect, model.cZ, query, model.b_.gX)) : $author$project$Element$ReconciliationPage$NoEffect;
				return _Utils_Tuple3(model, effect, $elm$core$Maybe$Nothing);
			case 9:
				var obligationType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cZ: obligationType, dk: '', cF: $author$project$RemoteData$Loading}),
					$author$project$Element$ReconciliationPage$Cmd(
						A3($author$project$Element$ReconciliationPage$fetchObligationsEffect, obligationType, '', model.b_.gX)),
					$elm$core$Maybe$Nothing);
			case 10:
				var filterType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{br: filterType, bl: '', af: $author$project$RemoteData$Loading, g: _List_Nil}),
					$author$project$Element$ReconciliationPage$Cmd(
						A5($author$project$Element$ReconciliationPage$fetchPaymentsEffect, filterType, '', $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, model.b_.gX)),
					$elm$core$Maybe$Nothing);
			case 13:
				var payment = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							p: {
								Z: $elm$core$Maybe$Nothing,
								B: $author$project$Element$ReconciliationPage$DragPayment(payment)
							}
						}),
					$author$project$Element$ReconciliationPage$NoEffect,
					$elm$core$Maybe$Nothing);
			case 14:
				var obligationItem = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							p: {
								Z: $elm$core$Maybe$Nothing,
								B: $author$project$Element$ReconciliationPage$DragObligation(obligationItem)
							}
						}),
					$author$project$Element$ReconciliationPage$NoEffect,
					$elm$core$Maybe$Nothing);
			case 15:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							p: {Z: $elm$core$Maybe$Nothing, B: $author$project$Element$ReconciliationPage$NoDrag}
						}),
					$author$project$Element$ReconciliationPage$NoEffect,
					$elm$core$Maybe$Nothing);
			case 16:
				var paymentId = msg.a;
				var newDragState = {
					Z: $elm$core$Maybe$Just(paymentId),
					B: model.p.B
				};
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{p: newDragState}),
					$author$project$Element$ReconciliationPage$NoEffect,
					$elm$core$Maybe$Nothing);
			case 17:
				var partnerId = msg.a;
				var newDragState = {
					Z: $elm$core$Maybe$Just(partnerId),
					B: model.p.B
				};
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{p: newDragState}),
					$author$project$Element$ReconciliationPage$NoEffect,
					$elm$core$Maybe$Nothing);
			case 18:
				var newDragState = {Z: $elm$core$Maybe$Nothing, B: model.p.B};
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{p: newDragState}),
					$author$project$Element$ReconciliationPage$NoEffect,
					$elm$core$Maybe$Nothing);
			case 19:
				var newDragState = {Z: $elm$core$Maybe$Nothing, B: model.p.B};
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{p: newDragState}),
					$author$project$Element$ReconciliationPage$NoEffect,
					$elm$core$Maybe$Nothing);
			case 20:
				var payment = msg.a;
				var ctrlOrCmdPressed = msg.b;
				var _v7 = model.p.B;
				if (_v7.$ === 1) {
					var obligationItem = _v7.a;
					var reconciledAmount = A3(
						$elm$core$List$foldl,
						F2(
							function (_v12, acc) {
								var r = _v12.b;
								return acc + r.x;
							}),
						0,
						A2(
							$elm$core$List$filter,
							function (_v13) {
								var s = _v13.c;
								return s !== 2;
							},
							A2($author$project$Element$ReconciliationPage$reconciliationsForPayment, payment, model.g)));
					var receivable = A2($author$project$Element$ReconciliationPage$obligationReceivable, obligationItem, model.g);
					var availablePaymentAmount = payment.x - reconciledAmount;
					var maxAmount = A2($elm$core$Basics$min, availablePaymentAmount, receivable);
					if (ctrlOrCmdPressed && (maxAmount > 0)) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bJ: $elm$core$Maybe$Just(
										{
											bI: $elm$core$String$fromInt(maxAmount),
											cy: maxAmount,
											n: obligationItem,
											cI: payment,
											fn: reconciledAmount
										}),
									p: {Z: $elm$core$Maybe$Nothing, B: $author$project$Element$ReconciliationPage$NoDrag}
								}),
							$author$project$Element$ReconciliationPage$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						if ((_Utils_cmp(receivable, availablePaymentAmount) > 0) && (availablePaymentAmount > 0)) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bJ: $elm$core$Maybe$Just(
											{
												bI: $elm$core$String$fromInt(maxAmount),
												cy: maxAmount,
												n: obligationItem,
												cI: payment,
												fn: reconciledAmount
											}),
										p: {Z: $elm$core$Maybe$Nothing, B: $author$project$Element$ReconciliationPage$NoDrag}
									}),
								$author$project$Element$ReconciliationPage$NoEffect,
								$elm$core$Maybe$Nothing);
						} else {
							if (_Utils_cmp(availablePaymentAmount, receivable) > -1) {
								var existingReconciliationItem = $elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (_v11) {
											var p = _v11.a;
											var r = _v11.b;
											return _Utils_eq(p.i8, payment.i8) && A2($author$project$Obligation$obligationsEqual, r.n, obligationItem);
										},
										model.g));
								var updatedReconciliations = function () {
									if (!existingReconciliationItem.$) {
										return A2(
											$elm$core$List$map,
											function (_v9) {
												var p = _v9.a;
												var r = _v9.b;
												var s = _v9.c;
												if (_Utils_eq(p.i8, payment.i8) && A2($author$project$Obligation$obligationsEqual, r.n, obligationItem)) {
													var amount = function () {
														if (s === 2) {
															return receivable;
														} else {
															return r.x + receivable;
														}
													}();
													return _Utils_Tuple3(
														payment,
														_Utils_update(
															r,
															{x: amount}),
														0);
												} else {
													return _Utils_Tuple3(p, r, s);
												}
											},
											model.g);
									} else {
										return _Utils_ap(
											model.g,
											_List_fromArray(
												[
													_Utils_Tuple3(
													payment,
													{x: receivable, i8: $elm$core$Maybe$Nothing, n: obligationItem},
													0)
												]));
									}
								}();
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											p: {Z: $elm$core$Maybe$Nothing, B: $author$project$Element$ReconciliationPage$NoDrag},
											g: updatedReconciliations
										}),
									$author$project$Element$ReconciliationPage$NoEffect,
									$elm$core$Maybe$Nothing);
							} else {
								return _Utils_Tuple3(
									A2(
										$author$project$Element$ReconciliationPage$addNotification,
										$author$project$Notification$error('Ez a befizetés már teljesen fel van használva'),
										_Utils_update(
											model,
											{
												p: {Z: $elm$core$Maybe$Nothing, B: $author$project$Element$ReconciliationPage$NoDrag}
											})),
									$author$project$Element$ReconciliationPage$NoEffect,
									$elm$core$Maybe$Nothing);
							}
						}
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								p: {Z: $elm$core$Maybe$Nothing, B: $author$project$Element$ReconciliationPage$NoDrag}
							}),
						$author$project$Element$ReconciliationPage$NoEffect,
						$elm$core$Maybe$Nothing);
				}
			case 21:
				var partnerId = msg.a;
				var _v14 = model.p.B;
				if (!_v14.$) {
					var payment = _v14.a;
					var partnerObligations = function () {
						var _v19 = model.cF;
						if (_v19.$ === 2) {
							var obligations = _v19.a;
							return A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.cX;
									},
									$elm$core$List$head(
										A2(
											$elm$core$List$filter,
											function (p) {
												return _Utils_eq(p.m8.i8, partnerId);
											},
											$author$project$Element$ReconciliationPage$aggregateObligationsByStudent(obligations)))));
						} else {
							return _List_Nil;
						}
					}();
					var newDragState = {Z: $elm$core$Maybe$Nothing, B: $author$project$Element$ReconciliationPage$NoDrag};
					var availableAmount = payment.x - A3(
						$elm$core$List$foldl,
						F2(
							function (_v17, acc) {
								var r = _v17.b;
								return acc + r.x;
							}),
						0,
						A2(
							$elm$core$List$filter,
							function (_v18) {
								var s = _v18.c;
								return s !== 2;
							},
							A2($author$project$Element$ReconciliationPage$reconciliationsForPayment, payment, model.g)));
					var _v15 = A3(
						$elm$core$List$foldl,
						F2(
							function (obligationItem, _v16) {
								var reconciliations = _v16.a;
								var remaining = _v16.b;
								var obligationAmount = A2($author$project$Element$ReconciliationPage$obligationReceivable, obligationItem, model.g);
								return (_Utils_cmp(remaining, obligationAmount) > -1) ? _Utils_Tuple2(
									_Utils_ap(
										reconciliations,
										_List_fromArray(
											[
												_Utils_Tuple3(
												payment,
												{x: obligationAmount, i8: $elm$core$Maybe$Nothing, n: obligationItem},
												0)
											])),
									remaining - obligationAmount) : _Utils_Tuple2(reconciliations, remaining);
							}),
						_Utils_Tuple2(_List_Nil, availableAmount),
						partnerObligations);
					var newReconciliations = _v15.a;
					var updatedReconciliations = _Utils_ap(model.g, newReconciliations);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{p: newDragState, g: updatedReconciliations}),
						$author$project$Element$ReconciliationPage$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								p: {Z: $elm$core$Maybe$Nothing, B: $author$project$Element$ReconciliationPage$NoDrag}
							}),
						$author$project$Element$ReconciliationPage$NoEffect,
						$elm$core$Maybe$Nothing);
				}
			case 22:
				var payment = msg.a;
				var obligationItem = msg.b;
				var removedReconciliation = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v30) {
							var p = _v30.a;
							var r = _v30.b;
							return _Utils_eq(p.i8, payment.i8) && A2($author$project$Obligation$obligationsEqual, r.n, obligationItem);
						},
						model.g));
				var updatedReconciliations = function () {
					_v20$2:
					while (true) {
						if (!removedReconciliation.$) {
							switch (removedReconciliation.a.c) {
								case 1:
									var _v21 = removedReconciliation.a;
									var _v22 = _v21.c;
									return A2(
										$elm$core$List$map,
										function (_v23) {
											var p = _v23.a;
											var r = _v23.b;
											var state = _v23.c;
											return (_Utils_eq(p.i8, payment.i8) && A2($author$project$Obligation$obligationsEqual, r.n, obligationItem)) ? _Utils_Tuple3(p, r, 2) : _Utils_Tuple3(p, r, state);
										},
										model.g);
								case 2:
									var _v24 = removedReconciliation.a;
									var _v25 = _v24.c;
									var reconciledForThisPayment = A2($author$project$Element$ReconciliationPage$reconciliationsForPayment, payment, model.g);
									var reconciledAmount = A3(
										$elm$core$List$foldl,
										F2(
											function (_v27, acc) {
												var r = _v27.b;
												return acc + r.x;
											}),
										0,
										A2(
											$elm$core$List$filter,
											function (_v28) {
												var s = _v28.c;
												return s !== 2;
											},
											reconciledForThisPayment));
									var reconciledRemainder = function (a) {
										return (payment.x - reconciledAmount) - a;
									};
									return A2(
										$elm$core$List$map,
										function (_v26) {
											var p = _v26.a;
											var r = _v26.b;
											var state = _v26.c;
											return (_Utils_eq(p.i8, payment.i8) && (A2($author$project$Obligation$obligationsEqual, r.n, obligationItem) && (reconciledRemainder(r.x) >= 0))) ? _Utils_Tuple3(p, r, 1) : _Utils_Tuple3(p, r, state);
										},
										model.g);
								default:
									break _v20$2;
							}
						} else {
							break _v20$2;
						}
					}
					return A2(
						$elm$core$List$filter,
						function (_v29) {
							var p = _v29.a;
							var r = _v29.b;
							return !(_Utils_eq(p.i8, payment.i8) && A2($author$project$Obligation$obligationsEqual, r.n, obligationItem));
						},
						model.g);
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{g: updatedReconciliations}),
					$author$project$Element$ReconciliationPage$NoEffect,
					$elm$core$Maybe$Nothing);
			case 23:
				var payment = msg.a;
				var newCategory = msg.b;
				var updatedPayments = function () {
					var _v31 = model.af;
					if (_v31.$ === 2) {
						var payments = _v31.a;
						return $author$project$RemoteData$Success(
							A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_eq(p.i8, payment.i8) ? _Utils_update(
										p,
										{bD: newCategory}) : p;
								},
								payments));
					} else {
						var other = _v31;
						return other;
					}
				}();
				var payload = {bD: newCategory, i8: payment.i8, b$: payment.b$, es: $elm$core$Maybe$Nothing};
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{af: updatedPayments}),
					$author$project$Element$ReconciliationPage$Cmd(
						$author$project$Element$ReconciliationPage$UpdatePayment(
							A3($author$project$Payment$updatePayment, model.b_, payload, $author$project$Element$ReconciliationPage$PaymentUpdated))),
					$elm$core$Maybe$Nothing);
			case 24:
				var payment = msg.a;
				var comment = msg.b;
				var updatedPayments = function () {
					var _v32 = model.af;
					if (_v32.$ === 2) {
						var payments = _v32.a;
						return $author$project$RemoteData$Success(
							A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_eq(p.i8, payment.i8) ? _Utils_update(
										p,
										{
											b$: $elm$core$Maybe$Just(comment)
										}) : p;
								},
								payments));
					} else {
						var other = _v32;
						return other;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{af: updatedPayments}),
					$author$project$Element$ReconciliationPage$Cmd(
						A2(
							$author$project$Element$ReconciliationPage$Delay,
							1,
							A2($author$project$Element$ReconciliationPage$DelayedPaymentCommentUpdate, payment, comment))),
					$elm$core$Maybe$Nothing);
			case 25:
				var payment = msg.a;
				var comment = msg.b;
				var payload = {
					bD: payment.bD,
					i8: payment.i8,
					b$: $elm$core$Maybe$Just(comment),
					es: $elm$core$Maybe$Nothing
				};
				var currentPayment = function () {
					var _v34 = model.af;
					if (_v34.$ === 2) {
						var payments = _v34.a;
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (p) {
									return _Utils_eq(p.i8, payment.i8);
								},
								payments));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var effect = function () {
					if (!currentPayment.$) {
						var currentP = currentPayment.a;
						return (_Utils_eq(
							A2($elm$core$Maybe$withDefault, '', currentP.b$),
							comment) && (!_Utils_eq(
							comment,
							A2($elm$core$Maybe$withDefault, '', payment.b$)))) ? $author$project$Element$ReconciliationPage$Cmd(
							$author$project$Element$ReconciliationPage$UpdatePayment(
								A3($author$project$Payment$updatePayment, model.b_, payload, $author$project$Element$ReconciliationPage$PaymentUpdated))) : $author$project$Element$ReconciliationPage$NoEffect;
					} else {
						return $author$project$Element$ReconciliationPage$NoEffect;
					}
				}();
				return _Utils_Tuple3(model, effect, $elm$core$Maybe$Nothing);
			case 26:
				var payment = msg.a;
				var pendingReconciliationItems = A2(
					$elm$core$List$filter,
					function (_v36) {
						var p = _v36.a;
						var s = _v36.c;
						return _Utils_eq(p.i8, payment.i8) && (s !== 2);
					},
					model.g);
				var payload = {
					bD: payment.bD,
					i8: payment.i8,
					b$: payment.b$,
					es: $elm$core$Maybe$Just(
						A2(
							$elm$core$List$map,
							function (_v35) {
								var r = _v35.b;
								return r;
							},
							pendingReconciliationItems))
				};
				return _Utils_Tuple3(
					model,
					$author$project$Element$ReconciliationPage$Cmd(
						$author$project$Element$ReconciliationPage$UpdatePayment(
							A3($author$project$Payment$updatePayment, model.b_, payload, $author$project$Element$ReconciliationPage$PaymentUpdated))),
					$elm$core$Maybe$Nothing);
			case 27:
				var data = msg.a;
				if (data.$ === 2) {
					var updatedPayment = data.a;
					var updatedReconciliationItems = A2(
						$elm$core$List$map,
						function (_v39) {
							var payment = _v39.a;
							var reconciliation = _v39.b;
							var state = _v39.c;
							if (_Utils_eq(payment.i8, updatedPayment.i8) && (!state)) {
								var matchingServerReconciliation = $elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (serverRec) {
											return A2($author$project$Obligation$obligationsEqual, serverRec.n, reconciliation.n) && _Utils_eq(serverRec.x, reconciliation.x);
										},
										updatedPayment.es));
								if (!matchingServerReconciliation.$) {
									var serverRec = matchingServerReconciliation.a;
									return _Utils_Tuple3(
										updatedPayment,
										_Utils_update(
											reconciliation,
											{i8: serverRec.i8}),
										1);
								} else {
									return _Utils_Tuple3(payment, reconciliation, state);
								}
							} else {
								return _Utils_Tuple3(payment, reconciliation, state);
							}
						},
						A2(
							$elm$core$List$filter,
							function (_v41) {
								var s = _v41.c;
								return s !== 2;
							},
							model.g));
					var updatedPayments = function () {
						var _v38 = model.af;
						if (_v38.$ === 2) {
							var payments = _v38.a;
							return $author$project$RemoteData$Success(
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_eq(p.i8, updatedPayment.i8) ? updatedPayment : p;
									},
									payments));
						} else {
							var other = _v38;
							return other;
						}
					}();
					return _Utils_Tuple3(
						A2(
							$author$project$Element$ReconciliationPage$addNotification,
							$author$project$Notification$ok('Elmentettem a befizetést'),
							_Utils_update(
								model,
								{af: updatedPayments, g: updatedReconciliationItems})),
						$author$project$Element$ReconciliationPage$Cmd(
							A3($author$project$Element$ReconciliationPage$fetchObligationsEffect, model.cZ, model.dk, model.b_.gX)),
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple3(
						A2(
							$author$project$Element$ReconciliationPage$addNotification,
							$author$project$Notification$error('Nem tudtam elmenteni a befizetést'),
							model),
						$author$project$Element$ReconciliationPage$NoEffect,
						$elm$core$Maybe$Nothing);
				}
			case 28:
				var amountStr = msg.a;
				var _v42 = model.bJ;
				if (!_v42.$) {
					var dialog = _v42.a;
					var updatedDialog = _Utils_update(
						dialog,
						{bI: amountStr});
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bJ: $elm$core$Maybe$Just(updatedDialog)
							}),
						$author$project$Element$ReconciliationPage$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple3(model, $author$project$Element$ReconciliationPage$NoEffect, $elm$core$Maybe$Nothing);
				}
			case 29:
				var _v43 = model.bJ;
				if (!_v43.$) {
					var dialog = _v43.a;
					var _v44 = $elm$core$String$toInt(dialog.bI);
					if (!_v44.$) {
						var amount = _v44.a;
						if ((amount > 0) && (_Utils_cmp(amount, dialog.cy) < 1)) {
							var existingReconciliation = $elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (_v48) {
										var p = _v48.a;
										var r = _v48.b;
										return _Utils_eq(p.i8, dialog.cI.i8) && A2($author$project$Obligation$obligationsEqual, r.n, dialog.n);
									},
									model.g));
							var updatedReconciliations = function () {
								if (!existingReconciliation.$) {
									return A2(
										$elm$core$List$map,
										function (_v46) {
											var p = _v46.a;
											var r = _v46.b;
											var s = _v46.c;
											if (_Utils_eq(p.i8, dialog.cI.i8) && A2($author$project$Obligation$obligationsEqual, r.n, dialog.n)) {
												var newAmount = function () {
													if (s === 2) {
														return amount;
													} else {
														return r.x + amount;
													}
												}();
												return _Utils_Tuple3(
													dialog.cI,
													_Utils_update(
														r,
														{x: newAmount}),
													0);
											} else {
												return _Utils_Tuple3(p, r, s);
											}
										},
										model.g);
								} else {
									return _Utils_ap(
										model.g,
										_List_fromArray(
											[
												_Utils_Tuple3(
												dialog.cI,
												{x: amount, i8: $elm$core$Maybe$Nothing, n: dialog.n},
												0)
											]));
								}
							}();
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{bJ: $elm$core$Maybe$Nothing, g: updatedReconciliations}),
								$author$project$Element$ReconciliationPage$NoEffect,
								$elm$core$Maybe$Nothing);
						} else {
							return _Utils_Tuple3(model, $author$project$Element$ReconciliationPage$NoEffect, $elm$core$Maybe$Nothing);
						}
					} else {
						return _Utils_Tuple3(model, $author$project$Element$ReconciliationPage$NoEffect, $elm$core$Maybe$Nothing);
					}
				} else {
					return _Utils_Tuple3(model, $author$project$Element$ReconciliationPage$NoEffect, $elm$core$Maybe$Nothing);
				}
			case 30:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bJ: $elm$core$Maybe$Nothing}),
					$author$project$Element$ReconciliationPage$NoEffect,
					$elm$core$Maybe$Nothing);
			case 31:
				var obligationItem = msg.a;
				var obligationType = function () {
					if (!obligationItem.$) {
						return $elm$core$Maybe$Just('company-contract');
					} else {
						return $elm$core$Maybe$Just('tuition-fee');
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{br: 1, bl: '', af: $author$project$RemoteData$Loading}),
					$author$project$Element$ReconciliationPage$Cmd(
						A5(
							$author$project$Element$ReconciliationPage$fetchPaymentsEffect,
							1,
							'',
							$elm$core$Maybe$Just(
								$author$project$Obligation$obligationId(obligationItem)),
							obligationType,
							model.b_.gX)),
					$elm$core$Maybe$Nothing);
			case 11:
				var viewMode = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oi: viewMode}),
					$author$project$Element$ReconciliationPage$NoEffect,
					$elm$core$Maybe$Nothing);
			case 12:
				var field = msg.a;
				var newDirection = function () {
					var _v50 = model.eA;
					if (!_v50.$) {
						var currentField = _v50.a;
						if (_Utils_eq(currentField, field)) {
							var _v51 = model.ez;
							if (!_v51) {
								return 1;
							} else {
								return 0;
							}
						} else {
							return 0;
						}
					} else {
						return 0;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ez: newDirection,
							eA: $elm$core$Maybe$Just(field)
						}),
					$author$project$Element$ReconciliationPage$NoEffect,
					$elm$core$Maybe$Nothing);
			default:
				return _Utils_Tuple3(model, $author$project$Element$ReconciliationPage$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$ReconciliationPage$DragEnd = {$: 15};
var $author$project$Element$ReconciliationPage$LoadMorePayments = {$: 2};
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Element$ReconciliationPage$onScroll = A2(
	$elm$html$Html$Events$on,
	'scroll',
	A4(
		$elm$json$Json$Decode$map3,
		F3(
			function (scrollTop, scrollHeight, clientHeight) {
				var distanceFromBottom = (scrollHeight - scrollTop) - clientHeight;
				var isNearBottom = distanceFromBottom < 100;
				return isNearBottom ? $author$project$Element$ReconciliationPage$LoadMorePayments : $author$project$Element$ReconciliationPage$DragEnd;
			}),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target', 'scrollTop']),
			$elm$json$Json$Decode$float),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target', 'scrollHeight']),
			$elm$json$Json$Decode$float),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target', 'clientHeight']),
			$elm$json$Json$Decode$float)));
var $author$project$Element$ReconciliationPage$CancelCustomReconciliation = {$: 30};
var $author$project$Element$ReconciliationPage$ConfirmCustomReconciliation = {$: 29};
var $author$project$Element$ReconciliationPage$UpdateCustomReconciliationAmount = function (a) {
	return {$: 28, a: a};
};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $author$project$Element$ReconciliationPage$ViewReconciledPaymentsForObligation = function (a) {
	return {$: 31, a: a};
};
var $author$project$Obligation$obligationAmount = function (obligation) {
	if (!obligation.$) {
		var o = obligation.a;
		return o.x;
	} else {
		var o = obligation.a;
		return o.x;
	}
};
var $author$project$Obligation$obligationCompletionDate = function (obligation) {
	if (!obligation.$) {
		var o = obligation.a;
		return o.iM;
	} else {
		var o = obligation.a;
		return o.iM;
	}
};
var $author$project$Obligation$obligationDueDate = function (obligation) {
	if (!obligation.$) {
		var o = obligation.a;
		return o.lv;
	} else {
		var o = obligation.a;
		return o.lv;
	}
};
var $author$project$Element$ReconciliationPage$viewObligationCardBase = F2(
	function (obligation, reconciliationItems) {
		var receivableAmount = A2($author$project$Element$ReconciliationPage$obligationReceivable, obligation, reconciliationItems);
		var amount = $author$project$Obligation$obligationAmount(obligation);
		var hasPartiallyPaid = (amount - receivableAmount) > 0;
		var paidAmount = amount - receivableAmount;
		var _v0 = function () {
			if (!obligation.$) {
				var o = obligation.a;
				return _Utils_Tuple2('Cégnév:', o.iL);
			} else {
				var o = obligation.a;
				return _Utils_Tuple2(
					'Sorszám:',
					A2($elm$core$Maybe$withDefault, 'N/A', o.hu));
			}
		}();
		var firstFieldLabel = _v0.a;
		var firstFieldValue = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card'),
					$elm$html$Html$Attributes$class(
					hasPartiallyPaid ? 'has-background-info-light' : 'has-background-light')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card-content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('content')
								]),
							_Utils_ap(
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('columns mb-1')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('column is-5')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(firstFieldLabel)
															]))
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('column is-7')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(firstFieldValue)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('columns mb-1')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('column is-5')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Határidő:')
															]))
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('column is-7')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Obligation$obligationDueDate(obligation))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('columns  mb-1')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('column is-5')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Teljesítés:')
															]))
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('column is-7')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Obligation$obligationCompletionDate(obligation))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('columns  mb-1')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('column is-5')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Összeg:')
															]))
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('column is-7')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Locale$Hungarian$displayHungaryMoney(amount))
															]))
													]))
											]))
									]),
								hasPartiallyPaid ? _List_fromArray(
									[
										A2(
										$elm$html$Html$hr,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('my-2 has-background-secondary-light')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('columns is-clickable notification p-0'),
												$elm$html$Html$Events$onClick(
												$author$project$Element$ReconciliationPage$ViewReconciledPaymentsForObligation(obligation))
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('column is-6')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('has-text-centered')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('is-size-7 has-text-secondary')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('icon is-small')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$i,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('fas fa-search')
																					]),
																				_List_Nil)
																			])),
																		$elm$html$Html$text(' Fizetett')
																	])),
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('is-size-7 has-text-weight-bold')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Locale$Hungarian$displayHungaryMoney(paidAmount))
																	]))
															]))
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('column is-6')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('has-text-centered')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('is-size-7 has-text-grey')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Fizetendő')
																	])),
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('is-size-7 has-text-weight-bold')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Locale$Hungarian$displayHungaryMoney(receivableAmount))
																	]))
															]))
													]))
											]))
									]) : _List_Nil))
						]))
				]));
	});
var $author$project$Element$ReconciliationPage$SetPaymentCategory = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Element$ReconciliationPage$UpdatePaymentComment = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $elm$html$Html$Attributes$draggable = _VirtualDom_attribute('draggable');
var $author$project$Element$ReconciliationPage$viewPaymentCardBase = F2(
	function (payment, reconciledAmount) {
		var categories = _List_fromArray(
			[
				_Utils_Tuple2(0, 'Iskolaalapítás'),
				_Utils_Tuple2(1, 'Kaució'),
				_Utils_Tuple2(2, 'Egyéb')
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('content')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('columns is-mobile is-vcentered mb-1')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column is-5')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Közlemény:')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column is-7')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($elm$core$Maybe$withDefault, 'N/A', payment.ne))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('columns is-mobile is-vcentered mb-1')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column is-5')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Partner neve:')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column is-7')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($elm$core$Maybe$withDefault, 'N/A', payment.m3))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('columns is-mobile is-vcentered mb-1')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column is-5')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Bankszámla:')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column is-7')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($elm$core$Maybe$withDefault, 'N/A', payment.m4))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('columns is-mobile is-vcentered mb-1')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column is-5')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Összeg:')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column is-7')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Locale$Hungarian$displayHungaryMoney(payment.x))
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('columns is-mobile is-vcentered mb-1')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column is-5')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Idő:')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column is-7')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(payment.lj)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('columns is-mobile is-vcentered mb-1')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column is-5')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Kategória:')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column is-7')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('buttons are-small')
												]),
											A2(
												$elm$core$List$map,
												function (_v0) {
													var category = _v0.a;
													var label = _v0.b;
													return A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('button'),
																$elm$html$Html$Attributes$classList(
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		'is-info',
																		_Utils_eq(
																			payment.bD,
																			$elm$core$Maybe$Just(category))),
																		_Utils_Tuple2(
																		'is-light',
																		!_Utils_eq(
																			payment.bD,
																			$elm$core$Maybe$Just(category)))
																	])),
																$elm$html$Html$Events$onClick(
																A2(
																	$author$project$Element$ReconciliationPage$SetPaymentCategory,
																	payment,
																	_Utils_eq(
																		payment.bD,
																		$elm$core$Maybe$Just(category)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(category)))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(label)
															]));
												},
												categories))
										]))
								])),
							(!_Utils_eq(payment.bD, $elm$core$Maybe$Nothing)) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('columns is-mobile is-vcentered mb-1')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column is-5')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Megjegyzés:')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column is-7')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('input is-small'),
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Attributes$draggable('false'),
													$elm$html$Html$Attributes$placeholder('Belső megjegyzés...'),
													$elm$html$Html$Attributes$value(
													A2($elm$core$Maybe$withDefault, '', payment.b$)),
													$elm$html$Html$Events$onInput(
													$author$project$Element$ReconciliationPage$UpdatePaymentComment(payment))
												]),
											_List_Nil)
										]))
								])) : $elm$html$Html$text('')
						])),
					A2(
					$elm$html$Html$hr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('my-2')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('columns is-mobile is-vcentered mb-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column is-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('has-text-centered')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('is-size-7 has-text-grey')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Felhasznált')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('has-text-weight-bold')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Locale$Hungarian$displayHungaryMoney(reconciledAmount))
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column is-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('has-text-centered')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('is-size-7 has-text-grey')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Elérhető')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('has-text-weight-bold')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Locale$Hungarian$displayHungaryMoney(payment.x - reconciledAmount))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Element$ReconciliationPage$viewCustomReconciliationDialog = function (dialog) {
	var paymentReconciledAmount = function () {
		var _v1 = $elm$core$String$toInt(dialog.bI);
		if (!_v1.$) {
			var amount = _v1.a;
			return amount + dialog.fn;
		} else {
			return dialog.fn;
		}
	}();
	var isValidAmount = function () {
		var _v0 = $elm$core$String$toInt(dialog.bI);
		if (!_v0.$) {
			var amount = _v0.a;
			return (amount > 0) && (_Utils_cmp(amount, dialog.cy) < 1);
		} else {
			return false;
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal is-active'),
				A2($elm$html$Html$Attributes$style, 'backdrop-filter', 'blur(16px)'),
				A2($elm$html$Html$Attributes$style, '-webkit-backdrop-filter', 'blur(16px)')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-background'),
						$elm$html$Html$Events$onClick($author$project$Element$ReconciliationPage$CancelCustomReconciliation),
						A2($elm$html$Html$Attributes$style, 'background', 'rgba(0,0,0,0.25)')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-card'),
						A2($elm$html$Html$Attributes$style, 'width', '800px'),
						A2($elm$html$Html$Attributes$style, 'background', 'transparent'),
						A2($elm$html$Html$Attributes$style, 'backdrop-filter', 'blur(20px)'),
						A2($elm$html$Html$Attributes$style, '-webkit-backdrop-filter', 'blur(20px)'),
						A2($elm$html$Html$Attributes$style, 'border-radius', '20px'),
						A2($elm$html$Html$Attributes$style, 'border', '1px solid rgba(255, 255, 255, 0.3)')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Element$ReconciliationPage$CancelCustomReconciliation)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-card'),
								A2($elm$html$Html$Attributes$style, 'width', '800px')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal-card-head')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('modal-card-title')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Mennyivel törleszti ez a befizetés ezt a tartozást?')
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('delete'),
												$elm$html$Html$Events$onClick($author$project$Element$ReconciliationPage$CancelCustomReconciliation),
												A2($elm$html$Html$Attributes$attribute, 'aria-label', 'close')
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal-card-body')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('columns is-vcentered')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('card column is-5')
													]),
												_List_fromArray(
													[
														A2($author$project$Element$ReconciliationPage$viewPaymentCardBase, dialog.cI, paymentReconciledAmount)
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('column is-2 has-text-centered')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('icon is-large has-text-secondary')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$i,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('fas fa-arrow-right fa-2x')
																	]),
																_List_Nil)
															]))
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('column is-5')
													]),
												_List_fromArray(
													[
														A2($author$project$Element$ReconciliationPage$viewObligationCardBase, dialog.n, _List_Nil)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('box mt-4 has-background-light')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('field')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('label')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																'Max: ' + $author$project$Locale$Hungarian$displayHungaryMoney(dialog.cy))
															])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('control')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$input,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('input'),
																		$elm$html$Html$Attributes$classList(
																		_List_fromArray(
																			[
																				_Utils_Tuple2(
																				'is-danger',
																				(!isValidAmount) && (!$elm$core$String$isEmpty(dialog.bI)))
																			])),
																		$elm$html$Html$Attributes$type_('number'),
																		$elm$html$Html$Attributes$min('1'),
																		$elm$html$Html$Attributes$max(
																		$elm$core$String$fromInt(dialog.cy)),
																		$elm$html$Html$Attributes$value(dialog.bI),
																		$elm$html$Html$Events$onInput($author$project$Element$ReconciliationPage$UpdateCustomReconciliationAmount),
																		$elm$html$Html$Attributes$placeholder('Írja be az összeget')
																	]),
																_List_Nil)
															])),
														((!isValidAmount) && (!$elm$core$String$isEmpty(dialog.bI))) ? A2(
														$elm$html$Html$p,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('help is-danger')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																'Az összegnek 1 és ' + ($author$project$Locale$Hungarian$displayHungaryMoney(dialog.cy) + ' között kell lennie'))
															])) : $elm$html$Html$text('')
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal-card-foot')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button is-success'),
												$elm$html$Html$Events$onClick($author$project$Element$ReconciliationPage$ConfirmCustomReconciliation),
												$elm$html$Html$Attributes$disabled(!isValidAmount)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Megerősítés')
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button'),
												$elm$html$Html$Events$onClick($author$project$Element$ReconciliationPage$CancelCustomReconciliation)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Mégse')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Obligation$CompanyContractType = 0;
var $author$project$Element$ReconciliationPage$ObligationSearchQueryChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$ReconciliationPage$TabChanged = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$ReconciliationPage$TableView = 1;
var $author$project$Element$ReconciliationPage$ViewModeChanged = function (a) {
	return {$: 11, a: a};
};
var $author$project$Element$ReconciliationPage$glassStyles = _List_fromArray(
	[
		A2($elm$html$Html$Attributes$style, 'backdrop-filter', 'blur(12px)'),
		A2($elm$html$Html$Attributes$style, '-webkit-backdrop-filter', 'blur(12px)'),
		A2($elm$html$Html$Attributes$style, 'background', 'rgba(255, 255, 255, 0.55)'),
		A2($elm$html$Html$Attributes$style, 'border', '1px solid rgba(255, 255, 255, 0.3)'),
		A2($elm$html$Html$Attributes$style, 'box-shadow', '0 4px 20px rgba(0, 0, 0, 0.05)'),
		A2($elm$html$Html$Attributes$style, 'border-radius', '12px')
	]);
var $author$project$Element$ReconciliationPage$Noop = {$: 32};
var $author$project$Element$ReconciliationPage$viewDropdown = function (items) {
	var _v0 = function () {
		var _v1 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (_v2) {
					var isActive = _v2.c;
					return isActive;
				},
				items));
		if (!_v1.$) {
			var _v3 = _v1.a;
			var label = _v3.a;
			var msg = _v3.b;
			return _Utils_Tuple2(label, msg);
		} else {
			return _Utils_Tuple2('Válassz...', $author$project$Element$ReconciliationPage$Noop);
		}
	}();
	var activeLabel = _v0.a;
	var activeMsg = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dropdown is-hoverable')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dropdown-trigger')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button is-medium p-0 has-text-weight-bold'),
								A2($elm$html$Html$Attributes$style, 'border', 'none'),
								A2($elm$html$Html$Attributes$style, 'background', 'transparent'),
								A2($elm$html$Html$Attributes$style, 'box-shadow', 'none'),
								$elm$html$Html$Events$onClick(activeMsg),
								A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true'),
								A2($elm$html$Html$Attributes$attribute, 'aria-controls', 'dropdown-menu')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(activeLabel)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('icon')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$i,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fas fa-angle-down')
											]),
										_List_Nil)
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dropdown-menu'),
						A2($elm$html$Html$Attributes$attribute, 'id', 'dropdown-menu'),
						A2($elm$html$Html$Attributes$attribute, 'role', 'menu')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dropdown-content')
							]),
						A2(
							$elm$core$List$map,
							function (_v4) {
								var label = _v4.a;
								var msg = _v4.b;
								var isActive = _v4.c;
								return A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('dropdown-item has-background-white'),
											A2($elm$html$Html$Attributes$style, 'border', 'none'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('has-background-light', isActive)
												])),
											$elm$html$Html$Events$onClick(msg),
											A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										]));
							},
							items))
					]))
			]));
};
var $author$project$Element$ReconciliationPage$viewObligationsColumnHeader = function (model) {
	var dropdownItems = _List_fromArray(
		[
			_Utils_Tuple3(
			'Céges tartozások',
			$author$project$Element$ReconciliationPage$TabChanged(0),
			!model.cZ),
			_Utils_Tuple3(
			'Díjbekérők',
			$author$project$Element$ReconciliationPage$TabChanged(1),
			model.cZ === 1)
		]);
	return A2(
		$elm$html$Html$div,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('box'),
					A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
					A2($elm$html$Html$Attributes$style, 'top', '0'),
					A2($elm$html$Html$Attributes$style, 'z-index', '2')
				]),
			$author$project$Element$ReconciliationPage$glassStyles),
		_List_fromArray(
			[
				$author$project$Element$ReconciliationPage$viewDropdown(dropdownItems),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button is-small is-pulled-right'),
						A2($elm$html$Html$Attributes$style, 'background', 'transparent'),
						A2($elm$html$Html$Attributes$style, 'border', 'none'),
						$elm$html$Html$Events$onClick(
						$author$project$Element$ReconciliationPage$ViewModeChanged(
							function () {
								var _v0 = model.oi;
								if (!_v0) {
									return 1;
								} else {
									return 0;
								}
							}()))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('icon is-small')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										function () {
											var _v1 = model.oi;
											if (!_v1) {
												return 'fas fa-table';
											} else {
												return 'fas fa-id-card';
											}
										}())
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('field')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('control')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('input is-small'),
										A2($elm$html$Html$Attributes$style, 'background', 'transparent'),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$placeholder('Tartozások keresése...'),
										$elm$html$Html$Attributes$value(model.dk),
										$elm$html$Html$Events$onInput($author$project$Element$ReconciliationPage$ObligationSearchQueryChanged)
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Element$ReconciliationPage$SortByAmount = 3;
var $author$project$Element$ReconciliationPage$SortByCompletionDate = 2;
var $author$project$Element$ReconciliationPage$SortByDueDate = 1;
var $author$project$Element$ReconciliationPage$SortByField = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$ReconciliationPage$SortByName = 0;
var $author$project$Element$ReconciliationPage$SortByPaid = 4;
var $author$project$Element$ReconciliationPage$SortByReceivable = 5;
var $author$project$Element$ReconciliationPage$obligationStudentName = function (obligation) {
	var student = $author$project$Obligation$obligationStudent(obligation);
	return student.av + (' ' + student.lI);
};
var $author$project$Element$ReconciliationPage$sortObligations = F4(
	function (sortField, direction, reconciliationItems, obligations) {
		var filteredObligations = A2(
			$elm$core$List$filter,
			function (o) {
				return A2($author$project$Element$ReconciliationPage$obligationReceivable, o, reconciliationItems) > 0;
			},
			obligations);
		var compareFn = function () {
			if (!sortField.$) {
				switch (sortField.a) {
					case 0:
						var _v2 = sortField.a;
						return F2(
							function (a, b) {
								return A2(
									$elm$core$Basics$compare,
									$author$project$Element$ReconciliationPage$obligationStudentName(a),
									$author$project$Element$ReconciliationPage$obligationStudentName(b));
							});
					case 1:
						var _v3 = sortField.a;
						return F2(
							function (a, b) {
								return A2(
									$elm$core$Basics$compare,
									$author$project$Obligation$obligationDueDate(a),
									$author$project$Obligation$obligationDueDate(b));
							});
					case 2:
						var _v4 = sortField.a;
						return F2(
							function (a, b) {
								return A2(
									$elm$core$Basics$compare,
									$author$project$Obligation$obligationCompletionDate(a),
									$author$project$Obligation$obligationCompletionDate(b));
							});
					case 3:
						var _v5 = sortField.a;
						return F2(
							function (a, b) {
								return A2(
									$elm$core$Basics$compare,
									$author$project$Obligation$obligationAmount(a),
									$author$project$Obligation$obligationAmount(b));
							});
					case 4:
						var _v6 = sortField.a;
						return F2(
							function (a, b) {
								return A2(
									$elm$core$Basics$compare,
									$author$project$Obligation$obligationAmount(a) - A2($author$project$Element$ReconciliationPage$obligationReceivable, a, reconciliationItems),
									$author$project$Obligation$obligationAmount(b) - A2($author$project$Element$ReconciliationPage$obligationReceivable, b, reconciliationItems));
							});
					default:
						var _v7 = sortField.a;
						return F2(
							function (a, b) {
								return A2(
									$elm$core$Basics$compare,
									A2($author$project$Element$ReconciliationPage$obligationReceivable, a, reconciliationItems),
									A2($author$project$Element$ReconciliationPage$obligationReceivable, b, reconciliationItems));
							});
				}
			} else {
				return F2(
					function (a, b) {
						return A2(
							$elm$core$Basics$compare,
							$author$project$Obligation$obligationId(a),
							$author$project$Obligation$obligationId(b));
					});
			}
		}();
		var sorted = A2($elm$core$List$sortWith, compareFn, filteredObligations);
		if (!direction) {
			return sorted;
		} else {
			return $elm$core$List$reverse(sorted);
		}
	});
var $author$project$Element$ReconciliationPage$DragStartObligation = function (a) {
	return {$: 14, a: a};
};
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$Element$ReconciliationPage$onDragEnd = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'dragend',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Element$ReconciliationPage$onDragStart = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'dragstart',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Element$ReconciliationPage$viewObligationTableRow = F2(
	function (reconciliationItems, obligation) {
		var student = $author$project$Obligation$obligationStudent(obligation);
		var receivable = A2($author$project$Element$ReconciliationPage$obligationReceivable, obligation, reconciliationItems);
		var companyOrInvoice = function () {
			if (!obligation.$) {
				var o = obligation.a;
				return o.iL;
			} else {
				var o = obligation.a;
				return A2($elm$core$Maybe$withDefault, 'N/A', o.hu);
			}
		}();
		var amount = $author$project$Obligation$obligationAmount(obligation);
		var paid = amount - receivable;
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$draggable('true'),
					$author$project$Element$ReconciliationPage$onDragStart(
					$author$project$Element$ReconciliationPage$DragStartObligation(obligation)),
					$author$project$Element$ReconciliationPage$onDragEnd($author$project$Element$ReconciliationPage$DragEnd),
					A2($elm$html$Html$Attributes$style, 'cursor', 'grab'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('has-background-info-light', paid > 0)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(student.av + (' ' + student.lI))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(companyOrInvoice)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Obligation$obligationDueDate(obligation))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Obligation$obligationCompletionDate(obligation))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Locale$Hungarian$displayHungaryMoney(amount))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							(paid > 0) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-clickable'),
									$elm$html$Html$Events$onClick(
									$author$project$Element$ReconciliationPage$ViewReconciledPaymentsForObligation(obligation))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('icon is-small')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fas fa-search')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('has-text-weight-bold')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Locale$Hungarian$displayHungaryMoney(paid))
										]))
								])) : $elm$html$Html$text('-')
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Locale$Hungarian$displayHungaryMoney(receivable))
								]))
						]))
				]));
	});
var $author$project$Element$ReconciliationPage$viewObligationsTable = F2(
	function (model, obligations) {
		var sortedObligations = A4($author$project$Element$ReconciliationPage$sortObligations, model.eA, model.ez, model.g, obligations);
		var sortIcon = function (field) {
			var _v0 = model.eA;
			if (!_v0.$) {
				var f = _v0.a;
				if (_Utils_eq(f, field)) {
					var _v1 = model.ez;
					if (!_v1) {
						return A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-sort-up ml-1')
								]),
							_List_Nil);
					} else {
						return A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-sort-down ml-1')
								]),
							_List_Nil);
					}
				} else {
					return A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fas fa-sort ml-1')
							]),
						_List_Nil);
				}
			} else {
				return A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fas fa-sort ml-1')
						]),
					_List_Nil);
			}
		};
		return $elm$core$List$isEmpty(sortedObligations) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('notification is-light')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Nem találtam tartozást')
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card'),
					A2($elm$html$Html$Attributes$style, 'max-height', '90vh'),
					A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('table is-fullwidth is-hoverable is-striped')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('is-clickable has-background-white'),
													A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
													A2($elm$html$Html$Attributes$style, 'top', '0'),
													A2($elm$html$Html$Attributes$style, 'z-index', '2'),
													$elm$html$Html$Events$onClick(
													$author$project$Element$ReconciliationPage$SortByField(0))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Név'),
															sortIcon(0)
														]))
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
													A2($elm$html$Html$Attributes$style, 'top', '0'),
													A2($elm$html$Html$Attributes$style, 'z-index', '2'),
													$elm$html$Html$Attributes$class('has-background-white')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Infó')
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('is-clickable has-background-white'),
													A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
													A2($elm$html$Html$Attributes$style, 'top', '0'),
													A2($elm$html$Html$Attributes$style, 'z-index', '2'),
													$elm$html$Html$Events$onClick(
													$author$project$Element$ReconciliationPage$SortByField(1))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Határidő'),
															sortIcon(1)
														]))
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('is-clickable has-background-white'),
													A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
													A2($elm$html$Html$Attributes$style, 'top', '0'),
													A2($elm$html$Html$Attributes$style, 'z-index', '2'),
													$elm$html$Html$Events$onClick(
													$author$project$Element$ReconciliationPage$SortByField(2))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Teljesítés'),
															sortIcon(2)
														]))
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('is-clickable has-background-white'),
													A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
													A2($elm$html$Html$Attributes$style, 'top', '0'),
													A2($elm$html$Html$Attributes$style, 'z-index', '2'),
													$elm$html$Html$Events$onClick(
													$author$project$Element$ReconciliationPage$SortByField(3))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Összeg'),
															sortIcon(3)
														]))
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('is-clickable has-background-white'),
													A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
													A2($elm$html$Html$Attributes$style, 'top', '0'),
													A2($elm$html$Html$Attributes$style, 'z-index', '2'),
													$elm$html$Html$Events$onClick(
													$author$project$Element$ReconciliationPage$SortByField(4))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Fizetett'),
															sortIcon(4)
														]))
												])),
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('is-clickable has-background-white'),
													A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
													A2($elm$html$Html$Attributes$style, 'top', '0'),
													A2($elm$html$Html$Attributes$style, 'z-index', '2'),
													$elm$html$Html$Events$onClick(
													$author$project$Element$ReconciliationPage$SortByField(5))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Fizetendő'),
															sortIcon(5)
														]))
												]))
										]))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Element$ReconciliationPage$viewObligationTableRow(model.g),
								sortedObligations))
						]))
				]));
	});
var $author$project$Element$ReconciliationPage$DragLeavePartner = {$: 19};
var $author$project$Element$ReconciliationPage$DragOverPartner = function (a) {
	return {$: 17, a: a};
};
var $author$project$Element$ReconciliationPage$DropOnPartner = function (a) {
	return {$: 21, a: a};
};
var $author$project$UI$gravatarMicro = function (email) {
	var size = 32;
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$src(
				A2($author$project$Util$Media$gravatar, size, email)),
				$elm$html$Html$Attributes$width(size),
				$elm$html$Html$Attributes$height(size)
			]),
		_List_Nil);
};
var $author$project$Element$ReconciliationPage$onDragLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'dragleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Element$ReconciliationPage$onDragOver = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'dragover',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $author$project$Element$ReconciliationPage$onDrop = function (toMsg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'drop',
		A2(
			$elm$json$Json$Decode$map,
			function (ctrlOrMeta) {
				return _Utils_Tuple2(
					toMsg(ctrlOrMeta),
					true);
			},
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
						A2($elm$json$Json$Decode$field, 'metaKey', $elm$json$Json$Decode$bool)
					]))));
};
var $author$project$Element$ReconciliationPage$viewObligationPartnerItem = F3(
	function (shouldShrink, reconciliationItems, obligation) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('column is-4'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'obligation-shrinking',
							shouldShrink(obligation))
						])),
					$author$project$Element$ReconciliationPage$onDragStart(
					$author$project$Element$ReconciliationPage$DragStartObligation(obligation)),
					$author$project$Element$ReconciliationPage$onDragEnd($author$project$Element$ReconciliationPage$DragEnd),
					$elm$html$Html$Attributes$draggable('true'),
					A2($elm$html$Html$Attributes$style, 'cursor', 'grab')
				]),
			_List_fromArray(
				[
					A2($author$project$Element$ReconciliationPage$viewObligationCardBase, obligation, reconciliationItems)
				]));
	});
var $author$project$Element$ReconciliationPage$viewPartnerSection = F2(
	function (model, partner) {
		var shouldShrink = function (obligation) {
			var _v1 = model.p.B;
			if (!_v1.$) {
				var payment = _v1.a;
				if (_Utils_eq(
					model.p.Z,
					$elm$core$Maybe$Just(partner.m8.i8))) {
					var availableAmount = payment.x - A3(
						$elm$core$List$foldl,
						F2(
							function (_v4, acc) {
								var r = _v4.b;
								return acc + r.x;
							}),
						0,
						A2(
							$elm$core$List$filter,
							function (_v5) {
								var s = _v5.c;
								return s !== 2;
							},
							A2($author$project$Element$ReconciliationPage$reconciliationsForPayment, payment, model.g)));
					var _v2 = A3(
						$elm$core$List$foldl,
						F2(
							function (ob, _v3) {
								var remaining = _v3.a;
								var covered = _v3.b;
								var obReceivable = A2($author$project$Element$ReconciliationPage$obligationReceivable, ob, model.g);
								return (_Utils_cmp(remaining, obReceivable) > -1) ? _Utils_Tuple2(
									remaining - obReceivable,
									A2(
										$elm$core$List$cons,
										$author$project$Obligation$obligationId(ob),
										covered)) : _Utils_Tuple2(remaining, covered);
							}),
						_Utils_Tuple2(availableAmount, _List_Nil),
						partner.cX);
					var coveredObligations = _v2.b;
					return A2(
						$elm$core$List$member,
						$author$project$Obligation$obligationId(obligation),
						coveredObligations);
				} else {
					return false;
				}
			} else {
				return false;
			}
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-4 has-background-light p-4 box'),
					$author$project$Element$ReconciliationPage$onDragOver(
					$author$project$Element$ReconciliationPage$DragOverPartner(partner.m8.i8)),
					$author$project$Element$ReconciliationPage$onDragLeave($author$project$Element$ReconciliationPage$DragLeavePartner),
					$author$project$Element$ReconciliationPage$onDrop(
					function (_v0) {
						return $author$project$Element$ReconciliationPage$DropOnPartner(partner.m8.i8);
					})
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title is-6 is-flex is-align-items-center')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('is-flex-shrink-0 mr-2')
										]),
									_List_fromArray(
										[
											$author$project$UI$gravatarMicro(partner.m8.O)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('is-flex is-align-items-center is-flex-wrap-wrap')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mr-3')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(partner.m8.av + (' ' + partner.m8.lI))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('tag is-success mr-3')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(partner.m8.op)
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('has-text-grey')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$elm$core$List$length(partner.cX)) + ' tartozás')
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('columns is-multiline')
						]),
					A2(
						$elm$core$List$map,
						function (o) {
							return A3($author$project$Element$ReconciliationPage$viewObligationPartnerItem, shouldShrink, model.g, o);
						},
						partner.cX))
				]));
	});
var $author$project$Element$ReconciliationPage$viewObligationsColumn = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'position', 'relative')
			]),
		_List_fromArray(
			[
				$author$project$Element$ReconciliationPage$viewObligationsColumnHeader(model),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('p-3')
					]),
				_List_fromArray(
					[
						function () {
						var _v0 = model.cF;
						switch (_v0.$) {
							case 0:
								return $elm$html$Html$text('Nem töltött be');
							case 1:
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('has-text-centered p-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('icon is-large')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('fas fa-spinner fa-pulse fa-2x')
														]),
													_List_Nil)
												]))
										]));
							case 3:
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('notification is-danger')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Nem tudtam betölteni a tartozásokat')
										]));
							default:
								var obligations = _v0.a;
								var _v1 = model.oi;
								if (!_v1) {
									var partners = $author$project$Element$ReconciliationPage$aggregateObligationsByStudent(
										A2(
											$elm$core$List$filter,
											function (o) {
												return A2($author$project$Element$ReconciliationPage$obligationReceivable, o, model.g) > 0;
											},
											obligations));
									return $elm$core$List$isEmpty(partners) ? A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('notification is-light')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Nem találtam tartozást')
											])) : A2(
										$elm$html$Html$div,
										_List_Nil,
										A2(
											$elm$core$List$map,
											$author$project$Element$ReconciliationPage$viewPartnerSection(model),
											partners));
								} else {
									return A2($author$project$Element$ReconciliationPage$viewObligationsTable, model, obligations);
								}
						}
					}()
					]))
			]));
};
var $author$project$Element$ReconciliationPage$DragLeavePayment = {$: 18};
var $author$project$Element$ReconciliationPage$DragOverPayment = function (a) {
	return {$: 16, a: a};
};
var $author$project$Element$ReconciliationPage$DragStartPayment = function (a) {
	return {$: 13, a: a};
};
var $author$project$Element$ReconciliationPage$DropOnPayment = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Element$ReconciliationPage$SavePayment = function (a) {
	return {$: 26, a: a};
};
var $author$project$Element$ReconciliationPage$RollbackReconciliation = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $elm$html$Html$s = _VirtualDom_node('s');
var $author$project$Element$ReconciliationPage$viewReconciliationItem = function (_v0) {
	var payment = _v0.a;
	var reconciliation = _v0.b;
	var state = _v0.c;
	var trimText = F2(
		function (maxLength, text) {
			return (_Utils_cmp(
				$elm$core$String$length(text),
				maxLength) > 0) ? (A2($elm$core$String$left, maxLength, text) + '...') : text;
		});
	var label = function () {
		var _v4 = reconciliation.n;
		if (!_v4.$) {
			var obligation = _v4.a;
			return A2(trimText, 14, obligation.nT.av + (' ' + obligation.nT.lI)) + (' · ' + (A2(trimText, 15, obligation.iL) + (' · ' + (obligation.iM + (' · ' + $author$project$Locale$Hungarian$displayHungaryMoney(reconciliation.x))))));
		} else {
			var obligation = _v4.a;
			return A2(trimText, 20, obligation.nT.av + (' ' + obligation.nT.lI)) + (' · ' + (A2($elm$core$Maybe$withDefault, 'N/A', obligation.hu) + (' · ' + (obligation.iM + (' · ' + $author$project$Locale$Hungarian$displayHungaryMoney(reconciliation.x))))));
		}
	}();
	var labelSpan = function () {
		if (state === 2) {
			return A2(
				$elm$html$Html$s,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('has-text-grey-light')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('has-text-weight-semibold')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]));
		}
	}();
	var _v1 = function () {
		switch (state) {
			case 1:
				return _Utils_Tuple3(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('box is-size-7 mb-2 has-background-light p-2 mr-1')
						]),
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('delete is-small has-background-dark'),
								$elm$html$Html$Events$onClick(
								A2($author$project$Element$ReconciliationPage$RollbackReconciliation, payment, reconciliation.n)),
								A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
							]),
						_List_Nil),
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('icon is-small')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fas fa-plus')
									]),
								_List_Nil)
							])));
			case 0:
				return _Utils_Tuple3(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('box is-size-7 mb-2 has-background-light p-2')
						]),
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('delete is-small has-background-dark'),
								$elm$html$Html$Events$onClick(
								A2($author$project$Element$ReconciliationPage$RollbackReconciliation, payment, reconciliation.n)),
								A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
							]),
						_List_Nil),
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('icon is-small')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fas fa-plus')
									]),
								_List_Nil)
							])));
			default:
				return _Utils_Tuple3(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('box is-size-7 mb-2 has-background-light p-2'),
							A2($elm$html$Html$Attributes$style, 'background-image', 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,.5) 10px, rgba(255,255,255,.5) 20px)')
						]),
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pill'),
								$elm$html$Html$Events$onClick(
								A2($author$project$Element$ReconciliationPage$RollbackReconciliation, payment, reconciliation.n)),
								A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
								A2($elm$html$Html$Attributes$style, 'background-color', 'transparent'),
								A2($elm$html$Html$Attributes$style, 'color', 'inherit'),
								A2($elm$html$Html$Attributes$style, 'border', 'none')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('icon is-small')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$i,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fas fa-undo')
											]),
										_List_Nil)
									]))
							])),
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('icon is-small')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fas fa-minus')
									]),
								_List_Nil)
							])));
		}
	}();
	var containerStyles = _v1.a;
	var deleteButton = _v1.b;
	var stateDot = _v1.c;
	return A2(
		$elm$html$Html$div,
		containerStyles,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('level mb-0')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('level-left')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('level-item')
									]),
								_List_fromArray(
									[
										stateDot,
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('ml-2')
											]),
										_List_fromArray(
											[labelSpan]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('level-right')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('level-item')
									]),
								_List_fromArray(
									[deleteButton]))
							]))
					]))
			]));
};
var $author$project$Element$ReconciliationPage$viewPaymentListItem = F2(
	function (model, payment) {
		var reconciledForThisPayment = A2($author$project$Element$ReconciliationPage$reconciliationsForPayment, payment, model.g);
		var reconciledAmount = A3(
			$elm$core$List$foldl,
			F2(
				function (_v2, acc) {
					var r = _v2.b;
					return acc + r.x;
				}),
			0,
			A2(
				$elm$core$List$filter,
				function (_v3) {
					var s = _v3.c;
					return s !== 2;
				},
				reconciledForThisPayment));
		var isDropZoneActive = _Utils_eq(
			model.p.Z,
			$elm$core$Maybe$Just(payment.i8));
		var isDragging = function () {
			var _v1 = model.p.B;
			if (!_v1.$) {
				var p = _v1.a;
				return _Utils_eq(p.i8, payment.i8);
			} else {
				return false;
			}
		}();
		var hasUnsavedChanges = A2(
			$elm$core$List$any,
			function (_v0) {
				var s = _v0.c;
				return (!s) || (s === 2);
			},
			reconciledForThisPayment);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('dragging', isDragging)
						])),
					$elm$html$Html$Attributes$draggable('true'),
					$author$project$Element$ReconciliationPage$onDragStart(
					$author$project$Element$ReconciliationPage$DragStartPayment(payment)),
					$author$project$Element$ReconciliationPage$onDragEnd($author$project$Element$ReconciliationPage$DragEnd),
					$author$project$Element$ReconciliationPage$onDragOver(
					$author$project$Element$ReconciliationPage$DragOverPayment(payment.i8)),
					$author$project$Element$ReconciliationPage$onDragLeave($author$project$Element$ReconciliationPage$DragLeavePayment),
					$author$project$Element$ReconciliationPage$onDrop(
					$author$project$Element$ReconciliationPage$DropOnPayment(payment))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card mb-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-content'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('has-background-light', isDropZoneActive),
											_Utils_Tuple2('drop-zone-hover', isDropZoneActive)
										]))
								]),
							_List_fromArray(
								[
									A2($author$project$Element$ReconciliationPage$viewPaymentCardBase, payment, reconciledAmount),
									$elm$core$List$isEmpty(reconciledForThisPayment) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('has-text-centered has-text-grey-light is-size-7 is-italic')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Húzz rám egy tartozást')
										])) : A2(
									$elm$html$Html$div,
									_List_Nil,
									A2($elm$core$List$map, $author$project$Element$ReconciliationPage$viewReconciliationItem, reconciledForThisPayment)),
									hasUnsavedChanges ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-3')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button'),
													$elm$html$Html$Attributes$class('is-fullwidth is-success'),
													$elm$html$Html$Events$onClick(
													$author$project$Element$ReconciliationPage$SavePayment(payment))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Mentés')
												]))
										])) : $elm$html$Html$text('')
								]))
						]))
				]));
	});
var $author$project$Element$ReconciliationPage$DepositFilter = 3;
var $author$project$Element$ReconciliationPage$Hidden = 5;
var $author$project$Element$ReconciliationPage$OtherFilter = 4;
var $author$project$Element$ReconciliationPage$PaymentFilterChanged = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$ReconciliationPage$PaymentSearchQueryChanged = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$ReconciliationPage$StartupFeeFilter = 2;
var $author$project$Element$ReconciliationPage$viewPaymentsColumnHeader = function (model) {
	var dropdownItems = _List_fromArray(
		[
			_Utils_Tuple3(
			'Aktuális befizetések',
			$author$project$Element$ReconciliationPage$PaymentFilterChanged(0),
			!model.br),
			_Utils_Tuple3(
			'Rekonsziliált befizetések',
			$author$project$Element$ReconciliationPage$PaymentFilterChanged(1),
			model.br === 1),
			_Utils_Tuple3(
			'Iskolaalapítás',
			$author$project$Element$ReconciliationPage$PaymentFilterChanged(2),
			model.br === 2),
			_Utils_Tuple3(
			'Kaució',
			$author$project$Element$ReconciliationPage$PaymentFilterChanged(3),
			model.br === 3),
			_Utils_Tuple3(
			'Egyéb',
			$author$project$Element$ReconciliationPage$PaymentFilterChanged(4),
			model.br === 4),
			_Utils_Tuple3(
			'Rejtett',
			$author$project$Element$ReconciliationPage$PaymentFilterChanged(5),
			model.br === 5)
		]);
	return A2(
		$elm$html$Html$div,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('box'),
					A2($elm$html$Html$Attributes$style, 'position', 'sticky'),
					A2($elm$html$Html$Attributes$style, 'top', '0'),
					A2($elm$html$Html$Attributes$style, 'z-index', '2')
				]),
			$author$project$Element$ReconciliationPage$glassStyles),
		_List_fromArray(
			[
				$author$project$Element$ReconciliationPage$viewDropdown(dropdownItems),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('field')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('control')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('input is-small'),
										A2($elm$html$Html$Attributes$style, 'background', 'transparent'),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$placeholder('Befizetések keresése...'),
										$elm$html$Html$Attributes$value(model.bl),
										$elm$html$Html$Events$onInput($author$project$Element$ReconciliationPage$PaymentSearchQueryChanged)
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Element$ReconciliationPage$viewPaymentsColumn = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'position', 'relative'),
				$author$project$Element$ReconciliationPage$onScroll
			]),
		_List_fromArray(
			[
				$author$project$Element$ReconciliationPage$viewPaymentsColumnHeader(model),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('p-3')
					]),
				_List_fromArray(
					[
						function () {
						var _v0 = model.af;
						switch (_v0.$) {
							case 0:
								return $elm$html$Html$text('Nem töltött be');
							case 1:
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('has-text-centered p-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('icon is-large')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('fas fa-spinner fa-pulse fa-2x')
														]),
													_List_Nil)
												]))
										]));
							case 3:
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('notification is-danger')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Nem tudtam betölteni a befizetéseket')
										]));
							default:
								var payments = _v0.a;
								return $elm$core$List$isEmpty(payments) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('notification is-light')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Nincs megjeleníthető befizetés')
										])) : A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_Nil,
											A2(
												$elm$core$List$map,
												$author$project$Element$ReconciliationPage$viewPaymentListItem(model),
												payments)),
											model.cJ ? A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('has-text-centered p-4')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('icon is-medium')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$i,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('fas fa-spinner fa-pulse')
																]),
															_List_Nil)
														])),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('is-size-7 has-text-grey mt-2')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Betöltés...')
														]))
												])) : (((!(!A2(
											$elm$core$Basics$modBy,
											$author$project$Element$ReconciliationPage$pageSize,
											$elm$core$List$length(payments)))) || (_Utils_cmp(
											$elm$core$List$length(payments),
											$author$project$Element$ReconciliationPage$pageSize) < 0)) ? A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('has-text-centered p-4')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$hr,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('my-2')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('is-size-7 has-text-grey')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Ez itt a befizetések vége')
														]))
												])) : $elm$html$Html$text(''))
										]));
						}
					}()
					]))
			]));
};
var $author$project$Element$ReconciliationPage$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('columns')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('column is-5'),
								A2($elm$html$Html$Attributes$style, 'max-height', '100vh'),
								A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto'),
								$author$project$Element$ReconciliationPage$onScroll
							]),
						_List_fromArray(
							[
								$author$project$Element$ReconciliationPage$viewPaymentsColumn(model)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('column is-7'),
								A2($elm$html$Html$Attributes$style, 'max-height', '100vh'),
								A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto')
							]),
						_List_fromArray(
							[
								$author$project$Element$ReconciliationPage$viewObligationsColumn(model)
							]))
					])),
				function () {
				var _v0 = model.bJ;
				if (!_v0.$) {
					var dialog = _v0.a;
					return $author$project$Element$ReconciliationPage$viewCustomReconciliationDialog(dialog);
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]));
};
var $author$project$Element$ReconciliationPage$element = {jb: $author$project$Element$ReconciliationPage$init, hP: $author$project$Element$ReconciliationPage$perform, ks: $author$project$Element$ReconciliationPage$update, og: $author$project$Element$ReconciliationPage$view};
var $author$project$Element$RubricSubjectOverview$EvaluationsDownloaded = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Endpoint$evaluation = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'evaluation']),
		_List_Nil);
};
var $author$project$Evaluation$Evaluation = F2(
	function (student, subjects) {
		return {nT: student, kb: subjects};
	});
var $author$project$Evaluation$Student = F6(
	function (id, firstName, lastName, email, school, grade) {
		return {O: email, lI: firstName, W: grade, i8: id, av: lastName, Q: school};
	});
var $author$project$Evaluation$studentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'grade',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'school',
		$author$project$Team$nestedTeamDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'email',
			$elm$json$Json$Decode$string,
			'',
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'last_name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'first_name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Evaluation$Student)))))));
var $author$project$Evaluation$Subject = F4(
	function (subject, available, achievedUntilMidYear, achievedUntilEndOfYear) {
		return {kJ: achievedUntilEndOfYear, kK: achievedUntilMidYear, k$: available, gE: subject};
	});
var $author$project$Evaluation$subjectDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'achieved_until_end_of_year',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'achieved_until_midyear',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'available',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'subject',
				$author$project$Subject$subjectDecoder,
				$elm$json$Json$Decode$succeed($author$project$Evaluation$Subject)))));
var $author$project$Evaluation$evaluationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'subjects',
	$elm$json$Json$Decode$list($author$project$Evaluation$subjectDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'student',
		$author$project$Evaluation$studentDecoder,
		$elm$json$Json$Decode$succeed($author$project$Evaluation$Evaluation)));
var $author$project$Evaluation$fetchEvaluations = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$evaluation(config),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$elm$json$Json$Decode$list($author$project$Evaluation$evaluationDecoder)));
	});
var $author$project$Element$RubricSubjectOverview$andThenFetchEvaluations = function (_return) {
	var model = _return.eh;
	var fetchEvaluations_ = A2(
		$author$project$Application$Boundaries$andThenCmd,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					_return.dX,
					A2($author$project$Evaluation$fetchEvaluations, model.b_.gX, $author$project$Element$RubricSubjectOverview$EvaluationsDownloaded)
				])),
		A2(
			$author$project$Application$Boundaries$save,
			_Utils_update(
				model,
				{d4: $author$project$RemoteData$Loading}),
			_return.gB));
	return fetchEvaluations_;
};
var $author$project$Element$RubricSubjectOverview$StudentListDownloaded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Endpoint$makeStudentsQueryParams = function (params) {
	return A3(
		$author$project$Api$Endpoint$optional,
		$elm$core$String$fromInt,
		_Utils_Tuple2('last_seen', params.b0),
		_List_fromArray(
			[
				_Utils_Tuple2(
				'size',
				$elm$core$String$fromInt(params.ce)),
				_Utils_Tuple2('q', params.bF),
				_Utils_Tuple2('cat', params.bD)
			]));
};
var $author$project$Api$Endpoint$activeStudents = F2(
	function (config, params) {
		var queryParams = $author$project$Api$Endpoint$makeStudentsQueryParams(params);
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'students']),
			queryParams);
	});
var $author$project$Student$fetchActiveStudents_ = F3(
	function (config, params, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$activeStudents, config, params),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$Student$studentsDecoder));
	});
var $author$project$Student$defaultListPageSize = 20;
var $author$project$Student$defaultListParams = {bD: '', b0: $elm$core$Maybe$Nothing, bF: '', ce: $author$project$Student$defaultListPageSize};
var $author$project$Element$RubricSubjectOverview$studentListParams = $author$project$Student$defaultListParams;
var $author$project$Element$RubricSubjectOverview$andThenFetchStudents = function (_return) {
	var model = _return.eh;
	var fetchStudents = A2(
		$author$project$Application$Boundaries$andThenCmd,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					_return.dX,
					A3($author$project$Student$fetchActiveStudents_, model.b_.gX, $author$project$Element$RubricSubjectOverview$studentListParams, $author$project$Element$RubricSubjectOverview$StudentListDownloaded)
				])),
		A2(
			$author$project$Application$Boundaries$save,
			_Utils_update(
				model,
				{fv: $author$project$RemoteData$Loading}),
			_return.gB));
	return fetchStudents;
};
var $author$project$Element$RubricSubjectOverview$SubjectListDownloaded = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$RubricSubjectOverview$andThenFetchSubjects = function (_return) {
	var model = _return.eh;
	var fetchSubjects = A2(
		$author$project$Application$Boundaries$andThenCmd,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					_return.dX,
					A2($author$project$Subject$fetchSubjects, model.b_.gX, $author$project$Element$RubricSubjectOverview$SubjectListDownloaded)
				])),
		A2(
			$author$project$Application$Boundaries$save,
			_Utils_update(
				model,
				{kb: $author$project$RemoteData$Loading}),
			_return.gB));
	return fetchSubjects;
};
var $author$project$Element$RubricSubjectOverview$SchoolListDownloaded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$RubricSubjectOverview$andThenMaybeFetchSchools = function (_return) {
	var model = _return.eh;
	var fetchSchools = A2(
		$author$project$Application$Boundaries$andThenCmd,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					_return.dX,
					A2($author$project$Team$fetchSchools, model.b_.gX, $author$project$Element$RubricSubjectOverview$SchoolListDownloaded)
				])),
		A2(
			$author$project$Application$Boundaries$save,
			_Utils_update(
				model,
				{j2: $author$project$RemoteData$Loading}),
			_return.gB));
	return A2(
		$author$project$RemoteData$withDefault,
		fetchSchools,
		A2(
			$author$project$RemoteData$map,
			$elm$core$Basics$always(_return),
			model.j2));
};
var $author$project$Element$RubricSubjectOverview$andThenFetchData = function (_v0) {
	var model = _v0.eh;
	var session = _v0.gB;
	var cmd = _v0.dX;
	return $author$project$Element$RubricSubjectOverview$andThenFetchEvaluations(
		$author$project$Element$RubricSubjectOverview$andThenFetchSubjects(
			$author$project$Element$RubricSubjectOverview$andThenFetchStudents(
				$author$project$Element$RubricSubjectOverview$andThenMaybeFetchSchools(
					A2(
						$author$project$Application$Boundaries$andThenCmd,
						cmd,
						A2($author$project$Application$Boundaries$save, model, session))))));
};
var $author$project$Element$RubricSubjectOverview$defaultFilter = F2(
	function (teamId, moduleId) {
		return {i4: _List_Nil, hG: moduleId, Q: teamId, fv: _List_Nil, kb: _List_Nil};
	});
var $author$project$Element$RubricSubjectOverview$defaultTeamId = A2($elm$core$Basics$composeR, $author$project$Person$teamsAsTom, $elm$core$List$head);
var $author$project$Element$RubricSubjectOverview$initPage = F3(
	function (query, session, model) {
		var viewer = session.ok;
		var _v0 = _Utils_Tuple3(
			query.Q,
			query.fv,
			$author$project$Element$RubricSubjectOverview$defaultTeamId(viewer));
		if (_v0.a.$ === 1) {
			if (!_v0.c.$) {
				var _v1 = _v0.a;
				var teamId = _v0.c.a;
				var initFilter = A2(
					$author$project$Element$RubricSubjectOverview$defaultFilter,
					teamId,
					A2($elm$core$Maybe$map, $elm$core$Basics$identity, query.hG));
				return $author$project$Element$RubricSubjectOverview$andThenFetchData(
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								ad: $elm$core$Maybe$Just(initFilter)
							}),
						session));
			} else {
				return A2($author$project$Application$Boundaries$save, model, session);
			}
		} else {
			if (!_v0.b.b) {
				var teamId = _v0.a.a;
				var initFilter = A2(
					$author$project$Element$RubricSubjectOverview$defaultFilter,
					teamId,
					A2($elm$core$Maybe$map, $elm$core$Basics$identity, query.hG));
				return $author$project$Element$RubricSubjectOverview$andThenFetchData(
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								ad: $elm$core$Maybe$Just(initFilter)
							}),
						session));
			} else {
				var teamId = _v0.a.a;
				var studentIds = _v0.b;
				var initFilter = {
					i4: _List_Nil,
					hG: A2($elm$core$Maybe$map, $elm$core$Basics$identity, query.hG),
					Q: teamId,
					fv: studentIds,
					kb: query.kb
				};
				return $author$project$Element$RubricSubjectOverview$andThenFetchData(
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								ad: $elm$core$Maybe$Just(initFilter)
							}),
						session));
			}
		}
	});
var $author$project$Element$RubricSubjectOverview$init = F3(
	function (config, session, params) {
		var model = {
			b_: config,
			d4: $author$project$RemoteData$NotAsked,
			ad: $elm$core$Maybe$Nothing,
			i4: $elm$core$Maybe$Nothing,
			j2: $author$project$RemoteData$NotAsked,
			fv: $author$project$RemoteData$NotAsked,
			kb: $author$project$RemoteData$NotAsked,
			gI: $NoRedInk$elm_sortable_table$Table$initialSort('')
		};
		var query = params;
		return A3($author$project$Element$RubricSubjectOverview$initPage, query, session, model);
	});
var $author$project$Locale$Messages$EvaluationListDownloadError = {$: 55};
var $author$project$Element$RubricSubjectOverview$NoOp = {$: 0};
var $author$project$Util$List$flatten = function (nestedList) {
	return A3($elm$core$List$foldl, $elm$core$Basics$append, _List_Nil, nestedList);
};
var $author$project$Element$RubricSubjectOverview$extractSubjectsFromEvaluations = function (evaluations) {
	return $author$project$Util$List$unique(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.gE;
			},
			$author$project$Util$List$flatten(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kb;
					},
					evaluations))));
};
var $author$project$Element$RubricSubjectOverview$filterEvaluationsWithStudents = F2(
	function (evals, students) {
		var studentIds = A2(
			$elm$core$List$map,
			function ($) {
				return $.i8;
			},
			A2($author$project$RemoteData$withDefault, _List_Nil, students));
		return A2(
			$elm$core$List$filter,
			function (e) {
				return $elm$core$List$isEmpty(studentIds) || A2($elm$core$List$member, e.nT.i8, studentIds);
			},
			evals);
	});
var $author$project$Student$goesToSchool = function (student) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(true),
			$elm$core$String$toInt(student.fT)));
};
var $author$project$Element$RubricSubjectOverview$Exempted = {$: 1};
var $author$project$Element$RubricSubjectOverview$Grade = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricSubjectOverview$NotApplicable = {$: 2};
var $author$project$Element$RubricSubjectOverview$gradeFromString = function (string) {
	switch (string) {
		case 'exempted':
			return $author$project$Element$RubricSubjectOverview$Exempted;
		case 'n/a':
			return $author$project$Element$RubricSubjectOverview$NotApplicable;
		default:
			var grade_as_string = string;
			var maybe_grade = $elm$core$String$toInt(grade_as_string);
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Element$RubricSubjectOverview$NotApplicable,
				A2($elm$core$Maybe$map, $author$project$Element$RubricSubjectOverview$Grade, maybe_grade));
	}
};
var $author$project$Log$msgEvaluationsDownload = 'evaluations_download';
var $author$project$Log$paramScopeRubricSubjectOverview = 'scope_rubric_subject_overview';
var $author$project$Element$RubricSubjectOverview$schoolStudents = F2(
	function (school, students) {
		return A2(
			$elm$core$List$filter,
			$author$project$Student$goesToSchool,
			A2(
				$author$project$Person$studentsInTeams,
				_List_fromArray(
					[school]),
				students));
	});
var $author$project$Element$RubricSubjectOverview$filterToQuery = function (filter) {
	var blankQuery = $author$project$Route$blankLoStudentOverviewListQuery;
	return _Utils_update(
		blankQuery,
		{
			hG: A2($elm$core$Maybe$map, $author$project$Module$moduleIdToInt, filter.hG),
			Q: $elm$core$Maybe$Just(
				$author$project$Team$teamIdToInt(filter.Q)),
			fv: filter.fv,
			kb: filter.kb
		});
};
var $author$project$Element$RubricSubjectOverview$updateFilterUrl = F2(
	function (config, filter) {
		return A2(
			$author$project$Route$replaceUrl,
			config.jk,
			$author$project$Route$RubricSubjectOverview(
				$author$project$Element$RubricSubjectOverview$filterToQuery(filter)));
	});
var $author$project$Element$RubricSubjectOverview$updateFilter = F3(
	function (updater, model, session) {
		var _v0 = model.ad;
		if (!_v0.$) {
			var filter_ = _v0.a;
			var newFilter = updater(filter_);
			return A2(
				$author$project$Application$Boundaries$andThenCmd,
				A2($author$project$Element$RubricSubjectOverview$updateFilterUrl, model.b_, newFilter),
				A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{
							ad: $elm$core$Maybe$Just(newFilter)
						}),
					session));
		} else {
			return A2($author$project$Application$Boundaries$save, model, session);
		}
	});
var $author$project$Element$RubricSubjectOverview$update = F3(
	function (session, msg, model) {
		var t_ = session.h6;
		var viewer = session.ok;
		var config = model.b_;
		var noop = A2($author$project$Application$Boundaries$save, model, session);
		switch (msg.$) {
			case 0:
				return A2($author$project$Application$Boundaries$save, model, session);
			case 1:
				var newState = msg.a;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{gI: newState}),
					session);
			case 5:
				var values = msg.a;
				return A3(
					$author$project$Element$RubricSubjectOverview$updateFilter,
					function (filter_) {
						return _Utils_update(
							filter_,
							{i4: values});
					},
					model,
					session);
			case 2:
				var values = msg.a;
				return A3(
					$author$project$Element$RubricSubjectOverview$updateFilter,
					function (filter_) {
						return _Utils_update(
							filter_,
							{kb: values});
					},
					model,
					session);
			case 3:
				var values = msg.a;
				var _return = A3(
					$author$project$Element$RubricSubjectOverview$updateFilter,
					function (filter_) {
						return _Utils_update(
							filter_,
							{fv: values});
					},
					model,
					session);
				return _return;
			case 4:
				var value = msg.a;
				if (!value.$) {
					var teamId = value.a;
					return $author$project$Element$RubricSubjectOverview$andThenFetchData(
						A3(
							$author$project$Element$RubricSubjectOverview$updateFilter,
							function (filter_) {
								return _Utils_update(
									filter_,
									{Q: teamId, fv: _List_Nil, kb: _List_Nil});
							},
							_Utils_update(
								model,
								{kb: $author$project$RemoteData$NotAsked}),
							session));
				} else {
					return noop;
				}
			case 6:
				var data = msg.a;
				var model2 = _Utils_update(
					model,
					{d4: data});
				switch (data.$) {
					case 2:
						var evals = data.a;
						var model3 = _Utils_update(
							model2,
							{
								kb: $author$project$RemoteData$Success(
									$author$project$Element$RubricSubjectOverview$extractSubjectsFromEvaluations(
										A2($author$project$Element$RubricSubjectOverview$filterEvaluationsWithStudents, evals, model.fv)))
							});
						return A2($author$project$Application$Boundaries$save, model3, session);
					case 3:
						var error = data.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgEvaluationsDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeRubricSubjectOverview),
									error),
								$elm$core$Basics$always($author$project$Element$RubricSubjectOverview$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model2,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$EvaluationListDownloadError))));
					default:
						return A2($author$project$Application$Boundaries$save, model2, session);
				}
			case 7:
				var data = msg.a;
				var model2 = _Utils_update(
					model,
					{
						j2: A2(
							$author$project$RemoteData$map,
							function (schools) {
								return A2($author$project$Person$filterPersonTeams, schools, viewer);
							},
							data)
					});
				switch (data.$) {
					case 2:
						return A2($author$project$Application$Boundaries$save, model2, session);
					case 3:
						var error = data.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgTeamsDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeRubricSubjectOverview),
									error),
								$elm$core$Basics$always($author$project$Element$RubricSubjectOverview$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model2,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$TeamListDownloadError))));
					default:
						return A2($author$project$Application$Boundaries$save, model2, session);
				}
			case 9:
				var data = msg.a;
				var model2 = _Utils_update(
					model,
					{kb: data});
				var _v4 = _Utils_Tuple2(model.ad, data);
				_v4$2:
				while (true) {
					switch (_v4.b.$) {
						case 2:
							if (!_v4.a.$) {
								var filter = _v4.a.a;
								var subjects = _v4.b.a;
								var validSubjectIds = A2(
									$elm$core$List$map,
									function ($) {
										return $.i8;
									},
									subjects);
								var updatedFilter = _Utils_update(
									filter,
									{kb: validSubjectIds});
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model2,
										{
											ad: $elm$core$Maybe$Just(updatedFilter)
										}),
									session);
							} else {
								break _v4$2;
							}
						case 3:
							var error = _v4.b.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgPeopleDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeRubricSubjectOverview),
										error),
									$elm$core$Basics$always($author$project$Element$RubricSubjectOverview$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model2,
									A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$PhoneBookDownloadError))));
						default:
							break _v4$2;
					}
				}
				return A2($author$project$Application$Boundaries$save, model2, session);
			default:
				var data = msg.a;
				var model2 = _Utils_update(
					model,
					{fv: data});
				var _v5 = _Utils_Tuple2(model.ad, data);
				_v5$2:
				while (true) {
					switch (_v5.b.$) {
						case 2:
							if (!_v5.a.$) {
								var filter = _v5.a.a;
								var students = _v5.b.a;
								var validStudentIds = A2(
									$elm$core$List$filter,
									function (s) {
										return $elm$core$List$isEmpty(filter.fv) || A2($elm$core$List$member, s, filter.fv);
									},
									A2(
										$elm$core$List$map,
										function ($) {
											return $.i8;
										},
										A2($author$project$Element$RubricSubjectOverview$schoolStudents, filter.Q, students)));
								var validStudentGrades = A2(
									$elm$core$List$map,
									$author$project$Element$RubricSubjectOverview$gradeFromString,
									$author$project$Util$List$unique(
										$elm$core$List$sort(
											A2(
												$elm$core$List$map,
												function ($) {
													return $.fT;
												},
												A2($author$project$Element$RubricSubjectOverview$schoolStudents, filter.Q, students)))));
								var updatedFilter = _Utils_update(
									filter,
									{i4: validStudentGrades, fv: validStudentIds});
								var model3 = _Utils_update(
									model2,
									{
										i4: $elm$core$Maybe$Just(validStudentGrades),
										fv: A2(
											$author$project$RemoteData$map,
											$elm$core$List$filter($author$project$Student$goesToSchool),
											data)
									});
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model3,
										{
											ad: $elm$core$Maybe$Just(updatedFilter)
										}),
									session);
							} else {
								break _v5$2;
							}
						case 3:
							var error = _v5.b.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgPeopleDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeRubricSubjectOverview),
										error),
									$elm$core$Basics$always($author$project$Element$RubricSubjectOverview$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model2,
									A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$PhoneBookDownloadError))));
						default:
							break _v5$2;
					}
				}
				return A2($author$project$Application$Boundaries$save, model2, session);
		}
	});
var $author$project$Locale$Messages$RubricSubjectOverviewNoStudents = {$: 425};
var $author$project$Locale$Messages$RubricSubjectOverviewProgress = {$: 426};
var $author$project$Locale$Messages$RubricSubjectOverviewNoEvaluations = {$: 424};
var $author$project$Locale$Messages$RubricSubjectOverviewSummary = {$: 428};
var $author$project$Locale$Messages$RubricSubjectOverviewAvailableFeedbackCount = {$: 433};
var $author$project$Locale$Messages$RubricSubjectOverviewGrade = {$: 431};
var $author$project$Locale$Messages$RubricSubjectOverviewMidYearFeedbackCount = {$: 434};
var $author$project$Locale$Messages$RubricSubjectOverviewName = {$: 430};
var $author$project$Locale$Messages$RubricSubjectOverviewSchool = {$: 429};
var $author$project$Locale$Messages$RubricSubjectOverviewSchoolYearFeedbackCount = {$: 435};
var $author$project$Locale$Messages$RubricSubjectOverviewSubject = {$: 432};
var $author$project$Element$RubricSubjectOverview$SetTableState = function (a) {
	return {$: 1, a: a};
};
var $NoRedInk$elm_sortable_table$Table$intColumn = F2(
	function (name, toInt) {
		return {
			fb: name,
			nJ: $NoRedInk$elm_sortable_table$Table$increasingOrDecreasingBy(toInt),
			oh: A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $NoRedInk$elm_sortable_table$Table$textDetails, $elm$core$String$fromInt),
				toInt)
		};
	});
var $author$project$Element$RubricSubjectOverview$tableViewConfig = function (t_) {
	var viewStudentText = A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.nT;
		},
		$author$project$Person$fullName(t_));
	var viewStudentLink = function (ess) {
		var params = {
			W: $elm$core$Maybe$Nothing,
			mB: $elm$core$Maybe$Nothing,
			gE: $elm$core$Maybe$Just(ess.gE.gE.i8)
		};
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					A2($author$project$Route$SubjectFeedbackList, ess.nT.i8, params))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					viewStudentText(ess))
				]));
	};
	var toId = function (ess) {
		return $elm$core$String$fromInt(ess.nT.i8) + ('x' + $elm$core$String$fromInt(ess.gE.gE.i8));
	};
	var customizations = $NoRedInk$elm_sortable_table$Table$defaultCustomizations;
	return $NoRedInk$elm_sortable_table$Table$customConfig(
		{
			la: _List_fromArray(
				[
					A2(
					$NoRedInk$elm_sortable_table$Table$stringColumn,
					t_($author$project$Locale$Messages$RubricSubjectOverviewSchool),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.nT;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Q;
							},
							function ($) {
								return $.lp;
							}))),
					A3(
					$author$project$UI$Table$htmlColumn,
					t_($author$project$Locale$Messages$RubricSubjectOverviewName),
					viewStudentText,
					viewStudentLink),
					A2(
					$NoRedInk$elm_sortable_table$Table$intColumn,
					t_($author$project$Locale$Messages$RubricSubjectOverviewGrade),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.nT;
						},
						function ($) {
							return $.W;
						})),
					A2(
					$NoRedInk$elm_sortable_table$Table$stringColumn,
					t_($author$project$Locale$Messages$RubricSubjectOverviewSubject),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.gE;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.gE;
							},
							function ($) {
								return $.fb;
							}))),
					A2(
					$NoRedInk$elm_sortable_table$Table$intColumn,
					t_($author$project$Locale$Messages$RubricSubjectOverviewAvailableFeedbackCount),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.gE;
						},
						function ($) {
							return $.k$;
						})),
					A2(
					$NoRedInk$elm_sortable_table$Table$intColumn,
					t_($author$project$Locale$Messages$RubricSubjectOverviewMidYearFeedbackCount),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.gE;
						},
						function ($) {
							return $.kK;
						})),
					A2(
					$NoRedInk$elm_sortable_table$Table$intColumn,
					t_($author$project$Locale$Messages$RubricSubjectOverviewSchoolYearFeedbackCount),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.gE;
						},
						function ($) {
							return $.kJ;
						}))
				]),
			li: _Utils_update(
				customizations,
				{
					n_: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('table is-fullwidth is-bordered is-striped is-narrow is-size-7')
						])
				}),
			n6: toId,
			cf: $author$project$Element$RubricSubjectOverview$SetTableState
		});
};
var $author$project$Element$RubricSubjectOverview$SetGradesFilter = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$RubricSubjectOverview$gradeToString = function (grade) {
	switch (grade.$) {
		case 0:
			var g = grade.a;
			return $elm$core$String$fromInt(g);
		case 1:
			return 'exempted';
		default:
			return 'n/a';
	}
};
var $author$project$Element$RubricSubjectOverview$viewMultiChoicesFilter = F2(
	function (t_, _v0) {
		var data = _v0.g6;
		var toSelectMsg = _v0.ig;
		var caption = _v0.g1;
		var toOptions = _v0.$8;
		var viewOption = _v0.ij;
		var viewSelectLinks = function (lst) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('is-size-7')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$UI$actionLink,
						toSelectMsg(lst),
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$FormSelectAll)
							])),
						$elm$html$Html$text(' | '),
						A3(
						$author$project$UI$actionLink,
						toSelectMsg(_List_Nil),
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$FormSelectNone)
							]))
					]));
		};
		var view_ = function (lst) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('column')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$fieldset,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$legend,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('label')
									]),
								_List_fromArray(
									[caption])),
							$elm$core$List$isEmpty(lst) ? _List_fromArray(
								[
									$author$project$UI$Icon$loadingOptions(_List_Nil)
								]) : A2(
								$elm$core$List$map,
								viewOption,
								toOptions(lst)))),
						A2(
						$author$project$UI$when,
						!$elm$core$List$isEmpty(lst),
						viewSelectLinks(lst))
					]));
		};
		if (data.$ === 1) {
			return view_(_List_Nil);
		} else {
			if (!data.a.b) {
				return $author$project$UI$none;
			} else {
				var lst = data.a;
				return view_(lst);
			}
		}
	});
var $author$project$Element$RubricSubjectOverview$viewGradeFilter = F3(
	function (t_, options, selected) {
		var viewGradeOption = function (option) {
			return A5(
				$author$project$UI$checkbox,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map($author$project$Element$RubricSubjectOverview$gradeFromString),
					$author$project$Element$RubricSubjectOverview$SetGradesFilter),
				'grades-filter-schoolyear',
				$elm$core$Basics$always(false),
				A2($elm$core$List$map, $author$project$Element$RubricSubjectOverview$gradeToString, selected),
				option);
		};
		var toGradeChoice = function (grade) {
			return _Utils_Tuple2(
				$author$project$Element$RubricSubjectOverview$gradeToString(grade),
				$author$project$Element$RubricSubjectOverview$gradeToString(grade));
		};
		return A2(
			$author$project$Element$RubricSubjectOverview$viewMultiChoicesFilter,
			t_,
			{
				g1: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricSubjectOverviewGrade),
				g6: options,
				$8: A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(toGradeChoice),
					$author$project$Form$toSelectOptions),
				ig: $author$project$Element$RubricSubjectOverview$SetGradesFilter,
				ij: viewGradeOption
			});
	});
var $author$project$Element$RubricSubjectOverview$viewPageHeading = function (t_) {
	return $author$project$UI$title(
		_List_fromArray(
			[
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricSubjectOverviewTitle)
			]));
};
var $author$project$Locale$Messages$LoStudentOverviewStudentOptionLabel = F2(
	function (a, b) {
		return {$: 172, a: a, b: b};
	});
var $author$project$Element$RubricSubjectOverview$SetStudentFilter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$RubricSubjectOverview$fromStudentsToValue = function (students) {
	return A2($elm$core$List$map, $elm$core$String$fromInt, students);
};
var $author$project$Element$RubricSubjectOverview$fromValueToStudents = function (values) {
	return A2($elm$core$List$filterMap, $elm$core$String$toInt, values);
};
var $author$project$Element$RubricSubjectOverview$viewStudentFilter = F3(
	function (t_, maybeStudents, filter) {
		var viewCheckbox = A4(
			$author$project$UI$checkbox,
			A2($elm$core$Basics$composeL, $author$project$Element$RubricSubjectOverview$SetStudentFilter, $author$project$Element$RubricSubjectOverview$fromValueToStudents),
			'filter-students',
			$elm$core$Basics$always(false),
			$author$project$Element$RubricSubjectOverview$fromStudentsToValue(filter.fv));
		var toStudentOptions = function (students) {
			return A2(
				$elm$core$List$map,
				function (student) {
					var name = A2($author$project$Person$fullName, t_, student);
					return $author$project$Form$toSelectOption(
						_Utils_Tuple2(
							$elm$core$String$fromInt(student.i8),
							t_(
								A2($author$project$Locale$Messages$LoStudentOverviewStudentOptionLabel, name, student.fT))));
				},
				A2(
					$author$project$Util$List$sortBy,
					$author$project$Person$fullName(t_),
					students));
		};
		return A2(
			$author$project$Element$RubricSubjectOverview$viewMultiChoicesFilter,
			t_,
			{
				g1: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosFilterStudents),
				g6: A2(
					$elm$core$Maybe$map,
					$author$project$Element$RubricSubjectOverview$schoolStudents(filter.Q),
					maybeStudents),
				$8: toStudentOptions,
				ig: A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						function ($) {
							return $.i8;
						}),
					$author$project$Element$RubricSubjectOverview$SetStudentFilter),
				ij: viewCheckbox
			});
	});
var $author$project$Element$RubricSubjectOverview$SetSubjectFilter = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricSubjectOverview$fromSubjectsToValue = function (subjects) {
	return A2($elm$core$List$map, $elm$core$String$fromInt, subjects);
};
var $author$project$Element$RubricSubjectOverview$fromValueToSubjects = function (values) {
	return A2($elm$core$List$filterMap, $elm$core$String$toInt, values);
};
var $author$project$Element$RubricSubjectOverview$viewSubjectFilter = F3(
	function (t_, maybeSubjects, selectedSubjects) {
		var viewCheckbox = A4(
			$author$project$UI$checkbox,
			A2($elm$core$Basics$composeL, $author$project$Element$RubricSubjectOverview$SetSubjectFilter, $author$project$Element$RubricSubjectOverview$fromValueToSubjects),
			'filter-subject',
			$elm$core$Basics$always(false),
			$author$project$Element$RubricSubjectOverview$fromSubjectsToValue(selectedSubjects));
		var toSubjectOptions = function (subjects) {
			return $author$project$Form$toSortedSelectOptions(
				A2(
					$elm$core$List$map,
					function (subject) {
						return _Utils_Tuple2(
							$elm$core$String$fromInt(subject.i8),
							subject.fb);
					},
					subjects));
		};
		return A2(
			$author$project$Element$RubricSubjectOverview$viewMultiChoicesFilter,
			t_,
			{
				g1: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LoStudentOverviewSubjects),
				g6: maybeSubjects,
				$8: toSubjectOptions,
				ig: A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						function ($) {
							return $.i8;
						}),
					$author$project$Element$RubricSubjectOverview$SetSubjectFilter),
				ij: viewCheckbox
			});
	});
var $author$project$Locale$Messages$GradesOverviewSchool = {$: 113};
var $author$project$Element$RubricSubjectOverview$SetSchoolFilter = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$RubricSubjectOverview$viewTeamFilter = F3(
	function (t_, maybeSchools, selectedSchool) {
		var viewSchoolOptions = function (schools) {
			return A2(
				$elm$core$List$map,
				A3(
					$author$project$UI$radioButton,
					A2($elm$core$Basics$composeL, $author$project$Element$RubricSubjectOverview$SetSchoolFilter, $author$project$Team$fromValueToTeam),
					'filter-school',
					$author$project$Team$fromTeamToValue(selectedSchool)),
				$author$project$Form$toTeamOptions(schools));
		};
		return $author$project$UI$filterOptions(
			{
				g1: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradesOverviewSchool),
				lT: false,
				m_: maybeSchools,
				oj: viewSchoolOptions
			});
	});
var $author$project$Element$RubricSubjectOverview$viewPage = F3(
	function (t_, _v0, filter) {
		var tableState = _v0.gI;
		var schools = _v0.j2;
		var students = _v0.fv;
		var subjects = _v0.kb;
		var evaluations = _v0.d4;
		var grades = _v0.i4;
		var viewFilters = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container columns')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Element$RubricSubjectOverview$viewTeamFilter,
					t_,
					$author$project$RemoteData$toMaybe(schools),
					filter.Q),
					A3(
					$author$project$Element$RubricSubjectOverview$viewStudentFilter,
					t_,
					$author$project$RemoteData$toMaybe(students),
					filter),
					A3(
					$author$project$Element$RubricSubjectOverview$viewSubjectFilter,
					t_,
					$author$project$RemoteData$toMaybe(subjects),
					filter.kb),
					A3($author$project$Element$RubricSubjectOverview$viewGradeFilter, t_, grades, filter.i4)
				]));
		var flattenEval = function (_eval) {
			return A2(
				$elm$core$List$map,
				function (s) {
					return {nT: _eval.nT, gE: s};
				},
				_eval.kb);
		};
		var flattenEvals = function (evals) {
			return $author$project$Util$List$flatten(
				A2($elm$core$List$map, flattenEval, evals));
		};
		var filterEvals = A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$List$filter(
					function (_eval) {
						return A2($elm$core$List$member, _eval.gE.gE.i8, filter.kb);
					}),
				$elm$core$List$filter(
					function (_eval) {
						return A2($elm$core$List$member, _eval.nT.i8, filter.fv);
					})),
			$elm$core$List$filter(
				function (_eval) {
					return A2(
						$elm$core$List$member,
						$author$project$Element$RubricSubjectOverview$Grade(_eval.nT.W),
						filter.i4);
				}));
		var filteredEvals = function (evals) {
			return filterEvals(
				flattenEvals(evals));
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Element$RubricSubjectOverview$viewPageHeading(t_),
					$author$project$UI$notification(
					$author$project$UI$textToHtml(
						t_($author$project$Locale$Messages$RubricSubjectOverviewSummary))),
					viewFilters,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-relative')
						]),
					_List_fromArray(
						[
							function () {
							if (evaluations.$ === 2) {
								if (!evaluations.a.b) {
									return $author$project$UI$notification(
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricSubjectOverviewNoEvaluations)
											]));
								} else {
									var evals = evaluations.a;
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('box')
											]),
										_List_fromArray(
											[
												A3(
												$NoRedInk$elm_sortable_table$Table$view,
												$author$project$Element$RubricSubjectOverview$tableViewConfig(t_),
												tableState,
												filteredEvals(evals))
											]));
								}
							} else {
								return $author$project$UI$List$resultsLoadingProgressBar;
							}
						}()
						]))
				]));
	});
var $author$project$Element$RubricSubjectOverview$view = F2(
	function (_v0, model) {
		var t_ = _v0.h6;
		var viewPageLoadingBar = A2(
			$author$project$UI$progressBar,
			'is-info',
			t_($author$project$Locale$Messages$RubricSubjectOverviewProgress));
		var _v1 = _Utils_Tuple2(model.d4, model.ad);
		_v1$2:
		while (true) {
			if (_v1.a.$ === 2) {
				if (!_v1.a.a.b) {
					return $author$project$UI$notification(
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricSubjectOverviewNoStudents)
							]));
				} else {
					if (!_v1.b.$) {
						var filter = _v1.b.a;
						return A3($author$project$Element$RubricSubjectOverview$viewPage, t_, model, filter);
					} else {
						break _v1$2;
					}
				}
			} else {
				break _v1$2;
			}
		}
		return viewPageLoadingBar;
	});
var $author$project$Element$RubricSubjectOverview$element = {jb: $author$project$Element$RubricSubjectOverview$init, ks: $author$project$Element$RubricSubjectOverview$update, og: $author$project$Element$RubricSubjectOverview$view};
var $author$project$Element$StudentAbsenceList$AbsencesDownloaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$StudentAbsenceList$BatchEffect = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$StudentAbsenceList$Cmd = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$StudentAbsenceList$DownloadAbsences = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StudentAbsenceList$DownloadStudent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$StudentAbsenceList$StudentDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Endpoint$studentAbsenceList = F2(
	function (config, studentId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'people',
					$elm$core$String$fromInt(studentId),
					'absences'
				]),
			_List_Nil);
	});
var $author$project$StudentAbsence$StudentAbsence = F9(
	function (id, student, isJustified, state, startDate, endDate, minutes, reasonText, reasonUrl) {
		return {ly: endDate, i8: id, l8: isJustified, mG: minutes, jU: reasonText, gr: reasonUrl, nN: startDate, fs: state, nT: student};
	});
var $author$project$StudentAbsence$JustifiedByDoctor = 2;
var $author$project$StudentAbsence$JustifiedByMentor = 3;
var $author$project$StudentAbsence$JustifiedByParent = 1;
var $author$project$StudentAbsence$Questioned = 4;
var $author$project$StudentAbsence$Unjustified = 0;
var $author$project$StudentAbsence$absenceStateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'unjustified':
				return $elm$json$Json$Decode$succeed(0);
			case 'justified_by_parent':
				return $elm$json$Json$Decode$succeed(1);
			case 'justified_by_doctor':
				return $elm$json$Json$Decode$succeed(2);
			case 'justified_by_mentor':
				return $elm$json$Json$Decode$succeed(3);
			case 'questioned':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid StudentAbsence.state value ' + str);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$StudentAbsence$studentAbsenceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'reason_url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'reason_text',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'minutes',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'end_date',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'start_date',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'state',
						$author$project$StudentAbsence$absenceStateDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'is_justified',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'student',
								$author$project$Person$nestedPersonDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$int,
									$elm$json$Json$Decode$succeed($author$project$StudentAbsence$StudentAbsence))))))))));
var $author$project$StudentAbsence$studentAbsenceListDecoder = $elm$json$Json$Decode$list($author$project$StudentAbsence$studentAbsenceDecoder);
var $author$project$StudentAbsence$fetchStudentAbsenceList = F3(
	function (config, studentId, callback) {
		return {
			b_: config,
			d_: $author$project$StudentAbsence$studentAbsenceListDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2($author$project$Api$Endpoint$studentAbsenceList, config, studentId)
		};
	});
var $author$project$Element$StudentAbsenceList$Description = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$StudentAbsenceList$JustificationFormMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$StudentAbsenceList$MediaUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$StudentAbsenceJustificationDescription = {$: 443};
var $author$project$Locale$Messages$StudentAbsenceJustificationMedia = {$: 444};
var $author$project$Element$StudentAbsenceList$acceptedMimeTypes = _List_fromArray(
	['application/pdf', 'image/jpeg', 'image/png']);
var $author$project$Element$StudentAbsenceList$maxFileSize = (20 * 1024) * 1024;
var $author$project$Element$StudentAbsenceList$initJustificationForm = function (t_) {
	return {
		g8: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{g8: value});
				}),
			fC: function ($) {
				return $.g8;
			},
			og: {
				cm: 'description',
				e6: 'fa-edit',
				ea: '',
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentAbsenceList$JustificationFormMsg, $author$project$Element$StudentAbsenceList$Description),
				fj: t_($author$project$Locale$Messages$StudentAbsenceJustificationDescription),
				ii: 'text'
			}
		},
		w: {
			e0: false,
			fi: A2(
				$author$project$Form$optionalFile,
				t_,
				{kH: $author$project$Element$StudentAbsenceList$acceptedMimeTypes, mv: $author$project$Element$StudentAbsenceList$maxFileSize}),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{mw: value});
				}),
			fC: function ($) {
				return $.mw;
			},
			og: {
				cm: 'justification',
				e6: 'fa-image',
				ea: t_($author$project$Locale$Messages$StudentAbsenceJustificationMedia),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentAbsenceList$JustificationFormMsg, $author$project$Element$StudentAbsenceList$MediaUrl),
				fj: t_($author$project$Locale$Messages$StudentAbsenceJustificationMedia)
			}
		}
	};
};
var $author$project$Element$StudentAbsenceList$initJustificationFormValues = F2(
	function (desc, media) {
		return {g8: desc, mw: media};
	});
var $author$project$Element$StudentAbsenceList$initJustificationFormModel = function (t_) {
	return {
		bE: $author$project$Element$StudentAbsenceList$initJustificationForm(t_),
		fs: 0,
		eI: A2($author$project$Element$StudentAbsenceList$initJustificationFormValues, '', $author$project$Form$NoFile)
	};
};
var $author$project$Element$StudentAbsenceList$init = F3(
	function (config, session, _v0) {
		var studentId = _v0.dE;
		return _Utils_Tuple3(
			{
				dR: $author$project$RemoteData$NotAsked,
				b_: config,
				d0: $elm$core$Maybe$Nothing,
				H: $author$project$Element$StudentAbsenceList$initJustificationFormModel(session.h6),
				dn: $elm$core$Maybe$Nothing,
				$7: $elm$core$Maybe$Nothing,
				gB: session,
				nT: $author$project$RemoteData$NotAsked
			},
			$author$project$Element$StudentAbsenceList$BatchEffect(
				_List_fromArray(
					[
						$author$project$Element$StudentAbsenceList$Cmd(
						$author$project$Element$StudentAbsenceList$DownloadStudent(
							A3($author$project$StudentProfile$fetchStudentProfileV3, config.gX, studentId, $author$project$Element$StudentAbsenceList$StudentDownloaded))),
						$author$project$Element$StudentAbsenceList$Cmd(
						$author$project$Element$StudentAbsenceList$DownloadAbsences(
							A3($author$project$StudentAbsence$fetchStudentAbsenceList, config.gX, studentId, $author$project$Element$StudentAbsenceList$AbsencesDownloaded)))
					])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$StudentAbsenceList$DocumentViewerEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StudentAbsenceList$DocumentViewerMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$StudentAbsenceList$documentViewer = {
	ha: $author$project$Element$DocumentViewer$element,
	kk: $author$project$Element$StudentAbsenceList$DocumentViewerEffect,
	cf: $author$project$Element$StudentAbsenceList$DocumentViewerMsg,
	kt: F2(
		function (containerModel, model) {
			return _Utils_update(
				containerModel,
				{
					d0: $elm$core$Maybe$Just(model)
				});
		})
};
var $author$project$Element$StudentAbsenceList$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effect_ = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, effect_, $author$project$Element$StudentAbsenceList$documentViewer);
			case 2:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$StudentAbsenceList$perform(key),
						effects));
			default:
				var cmd = effect.a;
				switch (cmd.$) {
					case 0:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 1:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 2:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					case 3:
						var mimeTypes = cmd.a;
						var toMsg = cmd.b;
						return A2($elm$file$File$Select$file, mimeTypes, toMsg);
					case 4:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 5:
						var request = cmd.a;
						return $author$project$Api$postExpectingHeadersV2(request);
					case 6:
						var request = cmd.a;
						return $author$project$Api$patchV2(request);
					default:
						var request = cmd.a;
						return $author$project$Api$patchV2(request);
				}
		}
	});
var $author$project$Element$StudentAbsenceList$JustifyStudentAbsence = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$StudentAbsenceList$LogError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$StudentAbsenceList$MediaFileSelected = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Element$StudentAbsenceList$MediaFileUploaded = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Element$StudentAbsenceList$MediaPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Element$StudentAbsenceList$NoEffect = {$: 0};
var $author$project$Element$StudentAbsenceList$NoOp = {$: 0};
var $author$project$Element$StudentAbsenceList$QuestionStudentAbsence = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$StudentAbsenceList$RequestPolicy = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$StudentAbsenceList$SelectFile = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Locale$Messages$StudentAbsenceJustificationError = {$: 447};
var $author$project$Locale$Messages$StudentAbsenceJustificationSaveSuccess = {$: 446};
var $author$project$Element$StudentAbsenceList$StudentAbsenceSaved = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$StudentAbsenceList$UploadFile = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$StudentAbsenceList$awsPolicyScope = 'portfolio';
var $author$project$Log$msgStudentAbsenceJustificationUnknownError = 'student_absence_unknown_error';
var $author$project$Element$StudentAbsenceList$customErrorNotificationAndLog = F3(
	function (config, session, customMessage) {
		var error = $author$project$Api$CustomError(customMessage);
		return _Utils_Tuple2(
			A3(
				$author$project$Session$error,
				session,
				error,
				session.h6($author$project$Locale$Messages$StudentAbsenceJustificationError)),
			$author$project$Element$StudentAbsenceList$Cmd(
				$author$project$Element$StudentAbsenceList$LogError(
					A3(
						$author$project$Log$errorV2,
						config,
						_Utils_Tuple3($author$project$Log$msgStudentAbsenceJustificationUnknownError, $elm$core$Maybe$Nothing, error),
						$elm$core$Basics$always($author$project$Element$StudentAbsenceList$NoOp)))));
	});
var $author$project$Element$StudentAbsenceList$isJustificationFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.g8, values) && A2($author$project$Form$isFieldValid, form.w, values);
	});
var $author$project$Api$Endpoint$studentAbsence = F2(
	function (config, absenceId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'absences',
					$elm$core$String$fromInt(absenceId)
				]),
			_List_Nil);
	});
var $author$project$StudentAbsence$absenceStateEncoder = function (state) {
	switch (state) {
		case 0:
			return $elm$json$Json$Encode$string('unjustified');
		case 1:
			return $elm$json$Json$Encode$string('justified_by_parent');
		case 2:
			return $elm$json$Json$Encode$string('justified_by_doctor');
		case 3:
			return $elm$json$Json$Encode$string('justified_by_mentor');
		default:
			return $elm$json$Json$Encode$string('questioned');
	}
};
var $author$project$StudentAbsence$studentAbsenceEncoder = function (absence) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(absence.i8)),
				_Utils_Tuple2(
				'state',
				$author$project$StudentAbsence$absenceStateEncoder(absence.fs)),
				_Utils_Tuple2(
				'reason_text',
				$elm$json$Json$Encode$string(absence.jU)),
				_Utils_Tuple2(
				'reason_url',
				$elm$json$Json$Encode$string(absence.gr))
			]));
};
var $author$project$StudentAbsence$justifyAbsence = F3(
	function (config, absence, callback) {
		return {
			T: $author$project$StudentAbsence$studentAbsenceEncoder(absence),
			b_: config,
			d_: $author$project$StudentAbsence$studentAbsenceDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2($author$project$Api$Endpoint$studentAbsence, config.gX, absence.i8)
		};
	});
var $author$project$Log$paramScopeStudentAbsenceList = 'scope_student_absence_list';
var $author$project$Locale$Messages$JustifyingDocumentRequired = {$: 122};
var $author$project$Form$requiredFileWithCustomMessage = F4(
	function (t_, constraints, errorMessage, value) {
		switch (value.$) {
			case 0:
				return $elm$core$Result$Err(
					t_(errorMessage));
			case 1:
				var file = value.a;
				return A3($author$project$Form$validateFile, t_, constraints, file);
			case 3:
				var file = value.a;
				return A3($author$project$Form$validateFile, t_, constraints, file);
			default:
				var url = value.a;
				return $elm$core$Result$Ok(url);
		}
	});
var $author$project$Element$StudentAbsenceList$requireMedia = F2(
	function (t_, formModel) {
		var mediaUrl = formModel.bE.w;
		var form = formModel.bE;
		var errorMessage = $author$project$Locale$Messages$JustifyingDocumentRequired;
		var updatedParser = A3(
			$author$project$Form$requiredFileWithCustomMessage,
			t_,
			{kH: $author$project$Element$StudentAbsenceList$acceptedMimeTypes, mv: $author$project$Element$StudentAbsenceList$maxFileSize},
			errorMessage);
		return _Utils_update(
			formModel,
			{
				bE: _Utils_update(
					form,
					{
						w: _Utils_update(
							mediaUrl,
							{fi: updatedParser, fp: true})
					})
			});
	});
var $author$project$Element$StudentAbsenceList$saveJustificationForm = F2(
	function (_v0, _v1) {
		var form = _v0.bE;
		var values = _v0.eI;
		var type_ = _v1.ii;
		var absence = _v1.dQ;
		var state = function () {
			switch (type_) {
				case 0:
					return 2;
				case 1:
					return 1;
				default:
					return 3;
			}
		}();
		var saveMediaUrl = function () {
			var _v2 = form.w.fC(values);
			if (!_v2.$) {
				return '';
			} else {
				var file = _v2;
				return $author$project$Form$toFileUrl(file);
			}
		}();
		return _Utils_update(
			absence,
			{jU: values.g8, gr: saveMediaUrl, fs: state});
	});
var $author$project$Element$StudentAbsenceList$updateJustificationFormModel = F2(
	function (formMsg, formModel) {
		var form = formModel.bE;
		var values = formModel.eI;
		var editedFormModel = _Utils_update(
			formModel,
			{fs: 1});
		switch (formMsg.$) {
			case 0:
				var value = formMsg.a;
				return _Utils_update(
					editedFormModel,
					{
						bE: _Utils_update(
							form,
							{
								g8: $author$project$Form$markEdited(form.g8)
							}),
						eI: A2(form.g8.ks, value, values)
					});
			case 1:
				var value = formMsg.a;
				return _Utils_update(
					editedFormModel,
					{
						bE: _Utils_update(
							form,
							{
								w: $author$project$Form$markEdited(form.w)
							}),
						eI: A2(
							form.w.ks,
							$author$project$Form$fromFileUrl(value),
							values)
					});
			default:
				return formModel;
		}
	});
var $author$project$Util$List$updateWhen = F2(
	function (tester, updater) {
		return $elm$core$List$map(
			function (elem) {
				return tester(elem) ? updater(elem) : elem;
			});
	});
var $author$project$Element$StudentAbsenceList$validateJustificationForm = function (form) {
	return _Utils_update(
		form,
		{
			g8: $author$project$Form$markEdited(form.g8),
			w: $author$project$Form$markEdited(form.w)
		});
};
var $author$project$Element$StudentAbsenceList$update = F2(
	function (msg, model) {
		update:
		while (true) {
			var config = model.b_;
			var session = model.gB;
			switch (msg.$) {
				case 1:
					var data = msg.a;
					switch (data.$) {
						case 2:
							var studentProfile = data.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										nT: $author$project$RemoteData$Success(
											$author$project$StudentProfile$asStudent(studentProfile))
									}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
						case 3:
							var error = data.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										gB: A3(
											$author$project$Session$error,
											model.gB,
											error,
											session.h6($author$project$Locale$Messages$StudentProfileFormDownloadError))
									}),
								$author$project$Element$StudentAbsenceList$Cmd(
									$author$project$Element$StudentAbsenceList$LogError(
										A3(
											$author$project$Log$errorV2,
											config,
											_Utils_Tuple3(
												$author$project$Log$msgStudentProfileDownload,
												$elm$core$Maybe$Just($author$project$Log$paramScopeStudentAbsenceList),
												error),
											$elm$core$Basics$always($author$project$Element$StudentAbsenceList$NoOp)))),
								$elm$core$Maybe$Nothing);
						case 1:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{nT: $author$project$RemoteData$Loading}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
						default:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{nT: $author$project$RemoteData$NotAsked}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
					}
				case 2:
					var data = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dR: data}),
						$author$project$Element$StudentAbsenceList$NoEffect,
						$elm$core$Maybe$Nothing);
				case 6:
					var request = msg.a;
					var initialModel = _Utils_update(
						model,
						{
							H: $author$project$Element$StudentAbsenceList$initJustificationFormModel(model.gB.h6),
							dn: $elm$core$Maybe$Just(request)
						});
					var updatedModel = function () {
						var _v2 = request.ii;
						if (!_v2) {
							return _Utils_update(
								initialModel,
								{
									H: A2($author$project$Element$StudentAbsenceList$requireMedia, session.h6, initialModel.H)
								});
						} else {
							return initialModel;
						}
					}();
					return _Utils_Tuple3(updatedModel, $author$project$Element$StudentAbsenceList$NoEffect, $elm$core$Maybe$Nothing);
				case 7:
					var formModel = model.H;
					var form = formModel.bE;
					var _v3 = model.dn;
					if (!_v3.$) {
						var request = _v3.a;
						if (A2($author$project$Element$StudentAbsenceList$isJustificationFormValid, model.H.bE, model.H.eI)) {
							var justifiedAbsence = A2($author$project$Element$StudentAbsenceList$saveJustificationForm, formModel, request);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										H: $author$project$Element$StudentAbsenceList$initJustificationFormModel(model.gB.h6),
										dn: $elm$core$Maybe$Nothing
									}),
								$author$project$Element$StudentAbsenceList$Cmd(
									$author$project$Element$StudentAbsenceList$JustifyStudentAbsence(
										A3($author$project$StudentAbsence$justifyAbsence, config, justifiedAbsence, $author$project$Element$StudentAbsenceList$StudentAbsenceSaved))),
								$elm$core$Maybe$Nothing);
						} else {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										H: _Utils_update(
											formModel,
											{
												bE: $author$project$Element$StudentAbsenceList$validateJustificationForm(form)
											})
									}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
						}
					} else {
						var _v4 = A3($author$project$Element$StudentAbsenceList$customErrorNotificationAndLog, model.b_, session, 'Expected but missing StudentAbsenceList.Model.pendingJustificationRequest');
						var updatedSession = _v4.a;
						var effect = _v4.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{gB: updatedSession}),
							effect,
							$elm$core$Maybe$Nothing);
					}
				case 8:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								H: $author$project$Element$StudentAbsenceList$initJustificationFormModel(model.gB.h6),
								dn: $elm$core$Maybe$Nothing
							}),
						$author$project$Element$StudentAbsenceList$NoEffect,
						$elm$core$Maybe$Nothing);
				case 3:
					var absence = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								$7: $elm$core$Maybe$Just(absence)
							}),
						$author$project$Element$StudentAbsenceList$NoEffect,
						$elm$core$Maybe$Nothing);
				case 4:
					var _v5 = model.$7;
					if (!_v5.$) {
						var absence = _v5.a;
						var questionedAbsence = _Utils_update(
							absence,
							{fs: 4});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{$7: $elm$core$Maybe$Nothing}),
							$author$project$Element$StudentAbsenceList$Cmd(
								$author$project$Element$StudentAbsenceList$QuestionStudentAbsence(
									A3($author$project$StudentAbsence$justifyAbsence, config, questionedAbsence, $author$project$Element$StudentAbsenceList$StudentAbsenceSaved))),
							$elm$core$Maybe$Nothing);
					} else {
						var _v6 = A3($author$project$Element$StudentAbsenceList$customErrorNotificationAndLog, model.b_, session, 'Expected but missing StudentAbsenceList.Model.pendingQuestionedAbsence');
						var updatedSession = _v6.a;
						var effect = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{gB: updatedSession}),
							effect,
							$elm$core$Maybe$Nothing);
					}
				case 5:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{$7: $elm$core$Maybe$Nothing}),
						$author$project$Element$StudentAbsenceList$NoEffect,
						$elm$core$Maybe$Nothing);
				case 9:
					var data = msg.a;
					switch (data.$) {
						case 2:
							var updatedAbsence = data.a;
							var updatedSession = A2(
								$author$project$Session$ok,
								session,
								session.h6($author$project$Locale$Messages$StudentAbsenceJustificationSaveSuccess));
							var updateAbsenceList = A2(
								$author$project$Util$List$updateWhen,
								function (a) {
									return _Utils_eq(a.i8, updatedAbsence.i8);
								},
								$elm$core$Basics$always(updatedAbsence));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										dR: A2($author$project$RemoteData$map, updateAbsenceList, model.dR),
										gB: updatedSession
									}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
						case 1:
							return _Utils_Tuple3(model, $author$project$Element$StudentAbsenceList$NoEffect, $elm$core$Maybe$Nothing);
						case 3:
							var error = data.a;
							var updatedSession = A3(
								$author$project$Session$error,
								session,
								error,
								session.h6($author$project$Locale$Messages$StudentAbsenceJustificationError));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{gB: updatedSession}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
						default:
							var error = $author$project$Api$CustomError('Unexpected msg (StudentAbsenceSaved RemoteData.NotAsked)');
							var updatedSession = A3(
								$author$project$Session$error,
								session,
								error,
								session.h6($author$project$Locale$Messages$StudentAbsenceJustificationError));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{gB: updatedSession}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
					}
				case 11:
					var location = msg.a;
					return A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						$author$project$Element$StudentAbsenceList$documentViewer,
						A4(
							$author$project$Application$V3$Boundaries$initElement,
							config,
							session,
							$author$project$Element$StudentAbsenceList$documentViewer,
							{fa: $elm$core$Maybe$Nothing, K: location}));
				case 12:
					var documentViewerMsg = msg.a;
					var _v8 = model.d0;
					if (!_v8.$) {
						var documentViewerModel = _v8.a;
						var _v9 = A3(
							$author$project$Application$V3$Boundaries$mapElement,
							model,
							$author$project$Element$StudentAbsenceList$documentViewer,
							A4($author$project$Application$V3$Boundaries$updateElement, session, documentViewerMsg, documentViewerModel, $author$project$Element$StudentAbsenceList$documentViewer));
						var model2 = _v9.a;
						var effect = _v9.b;
						return _Utils_Tuple3(
							_Utils_update(
								model2,
								{d0: $elm$core$Maybe$Nothing}),
							effect,
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple3(model, $author$project$Element$StudentAbsenceList$NoEffect, $elm$core$Maybe$Nothing);
					}
				case 10:
					var formMsg = msg.a;
					switch (formMsg.$) {
						case 0:
							var formModel = model.H;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										H: A2($author$project$Element$StudentAbsenceList$updateJustificationFormModel, formMsg, formModel)
									}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
						case 1:
							var formModel = model.H;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										H: A2($author$project$Element$StudentAbsenceList$updateJustificationFormModel, formMsg, formModel)
									}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
						case 2:
							var documentAvailableMsg = formMsg.a;
							var documentType = formMsg.b;
							return _Utils_Tuple3(
								model,
								$author$project$Element$StudentAbsenceList$Cmd(
									A2(
										$author$project$Element$StudentAbsenceList$SelectFile,
										$author$project$Element$StudentAbsenceList$acceptedMimeTypes,
										A2(
											$elm$core$Basics$composeL,
											$author$project$Element$StudentAbsenceList$JustificationFormMsg,
											A2($author$project$Element$StudentAbsenceList$MediaFileSelected, documentAvailableMsg, documentType)))),
								$elm$core$Maybe$Nothing);
						case 4:
							if (!formMsg.c.$) {
								var documentAvailableMsg = formMsg.a;
								var file = formMsg.b;
								var policy = formMsg.c.a;
								return _Utils_Tuple3(
									model,
									$author$project$Element$StudentAbsenceList$Cmd(
										$author$project$Element$StudentAbsenceList$UploadFile(
											A4(
												$author$project$S3$uploadFileV2,
												config.gX,
												policy,
												file,
												A2(
													$elm$core$Basics$composeL,
													$author$project$Element$StudentAbsenceList$JustificationFormMsg,
													A2($author$project$Element$StudentAbsenceList$MediaFileUploaded, documentAvailableMsg, file))))),
									$elm$core$Maybe$Nothing);
							} else {
								var error = formMsg.c.a;
								var updatedSession = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var removeMediaUrl = function (_v11) {
									var state = _v11.fs;
									var form = _v11.bE;
									var values = _v11.eI;
									return {
										bE: form,
										fs: state,
										eI: A2(form.w.ks, $author$project$Form$NoFile, values)
									};
								};
								var effect = $author$project$Element$StudentAbsenceList$Cmd(
									$author$project$Element$StudentAbsenceList$LogError(
										A3(
											$author$project$Log$errorV2,
											config,
											_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
											$elm$core$Basics$always($author$project$Element$StudentAbsenceList$NoOp))));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											H: removeMediaUrl(model.H),
											gB: updatedSession
										}),
									effect,
									$elm$core$Maybe$Nothing);
							}
						case 3:
							var documentAvailableMsg = formMsg.a;
							var documentType = formMsg.b;
							var file = formMsg.c;
							var params = {
								ls: documentType,
								mD: $elm$file$File$mime(file),
								m9: $elm$core$String$fromInt(session.ok.i8),
								nx: $author$project$Element$StudentAbsenceList$awsPolicyScope
							};
							var formModel = model.H;
							var values = formModel.eI;
							var form = formModel.bE;
							var mediaUrl = form.w;
							var valuesWithFileError = A2(
								mediaUrl.ks,
								$author$project$Form$InvalidFile(file),
								values);
							var valuesWithFileSelected = A2(
								mediaUrl.ks,
								$author$project$Form$FileSelected(file),
								values);
							if (A2($author$project$Form$isFieldValid, mediaUrl, valuesWithFileSelected)) {
								var justificationFormModel = _Utils_update(
									formModel,
									{
										bE: _Utils_update(
											form,
											{
												w: $author$project$Form$markEdited(form.w)
											}),
										eI: valuesWithFileSelected
									});
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{H: justificationFormModel}),
									$author$project$Element$StudentAbsenceList$Cmd(
										$author$project$Element$StudentAbsenceList$RequestPolicy(
											A3(
												$author$project$S3$requestPolicyV2,
												config.gX,
												params,
												A2(
													$elm$core$Basics$composeL,
													$author$project$Element$StudentAbsenceList$JustificationFormMsg,
													A2($author$project$Element$StudentAbsenceList$MediaPolicyDownloaded, documentAvailableMsg, file))))),
									$elm$core$Maybe$Nothing);
							} else {
								var justificationFormModel = _Utils_update(
									formModel,
									{
										bE: _Utils_update(
											form,
											{
												w: $author$project$Form$markEdited(form.w)
											}),
										eI: valuesWithFileError
									});
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{H: justificationFormModel}),
									$author$project$Element$StudentAbsenceList$NoEffect,
									$elm$core$Maybe$Nothing);
							}
						default:
							if (!formMsg.c.$) {
								var documentAvailableMsg = formMsg.a;
								var file = formMsg.b;
								var metadata = formMsg.c.a;
								var _v12 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ar);
								if (!_v12.$) {
									var location = _v12.a;
									var $temp$msg = documentAvailableMsg(location),
										$temp$model = model;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$msg = $author$project$Element$StudentAbsenceList$JustificationFormMsg(
										A3(
											$author$project$Element$StudentAbsenceList$MediaFileUploaded,
											documentAvailableMsg,
											file,
											$elm$core$Result$Err(
												$author$project$Api$BadHeader(metadata)))),
										$temp$model = model;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								var error = formMsg.c.a;
								var updatedSession = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var removeMediaUrl = function (_v13) {
									var state = _v13.fs;
									var form = _v13.bE;
									var values = _v13.eI;
									return {
										bE: form,
										fs: state,
										eI: A2(form.w.ks, $author$project$Form$NoFile, values)
									};
								};
								var effect = $author$project$Element$StudentAbsenceList$Cmd(
									$author$project$Element$StudentAbsenceList$LogError(
										A3(
											$author$project$Log$errorV2,
											config,
											_Utils_Tuple3(
												$author$project$Log$msgFileUpload,
												$elm$core$Maybe$Just($author$project$Log$paramScopeStudentAbsenceList),
												error),
											$elm$core$Basics$always($author$project$Element$StudentAbsenceList$NoOp))));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											H: removeMediaUrl(model.H),
											gB: updatedSession
										}),
									effect,
									$elm$core$Maybe$Nothing);
							}
					}
				default:
					return _Utils_Tuple3(model, $author$project$Element$StudentAbsenceList$NoEffect, $elm$core$Maybe$Nothing);
			}
		}
	});
var $author$project$Locale$Messages$StudentAbsenceListLoadingError = {$: 449};
var $author$project$Locale$Messages$StudentAbsenceListLoadingProgress = {$: 450};
var $author$project$Locale$Messages$StudentAbsenceListNoAbsences = {$: 451};
var $author$project$Locale$Messages$StudentAbsenceListTitle = function (a) {
	return {$: 452, a: a};
};
var $author$project$Element$StudentAbsenceList$defaultFilterAbsences = function () {
	var absenceHasMinutes = function (absence) {
		return absence.mG > 0;
	};
	return $elm$core$List$filter(absenceHasMinutes);
}();
var $author$project$Locale$Messages$StudentAbsenceListItemDetails = F3(
	function (a, b, c) {
		return {$: 448, a: a, b: b, c: c};
	});
var $author$project$UI$columnsWithAttribs = function (cols) {
	var col = function (_v0) {
		var attribs = _v0.a;
		var c = _v0.b;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('column'),
				attribs),
			_List_fromArray(
				[c]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('columns is-fullwidth')
			]),
		A2($elm$core$List$map, col, cols));
};
var $author$project$Element$StudentAbsenceList$OpenDocumentViewer = function (a) {
	return {$: 11, a: a};
};
var $author$project$Util$String$surround = F2(
	function (_with, t) {
		return A3($author$project$Util$String$enclose, _with, _with, t);
	});
var $author$project$Util$String$quote = $author$project$Util$String$surround('\"');
var $author$project$Element$StudentAbsenceList$viewAbsenceMeta = function (absence) {
	var reasonText = A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('is-italic')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Util$String$quote(absence.jU))
			]));
	return _List_fromArray(
		[
			$elm$core$String$isEmpty(absence.gr) ? reasonText : A3(
			$author$project$UI$actionLink,
			$author$project$Element$StudentAbsenceList$OpenDocumentViewer(absence.gr),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(absence.gr),
					$author$project$UI$attrCyData('absence-reason-url-preview')
				]),
			_List_fromArray(
				[reasonText]))
		]);
};
var $author$project$Locale$Messages$StudentAbsenceStateJustifiedByDoctor = {$: 454};
var $author$project$Locale$Messages$StudentAbsenceStateJustifiedByMentor = {$: 456};
var $author$project$Locale$Messages$StudentAbsenceStateJustifiedByParent = {$: 455};
var $author$project$Locale$Messages$StudentAbsenceStateQuestioned = {$: 457};
var $author$project$Locale$Messages$StudentAbsenceStateUnjustified = {$: 453};
var $author$project$Element$StudentAbsenceList$viewAbsenceState = F2(
	function (t_, state) {
		var style = function () {
			switch (state) {
				case 0:
					return 'is-info';
				case 2:
					return 'is-success';
				case 1:
					return 'is-success';
				case 3:
					return 'is-success';
				default:
					return 'is-warning';
			}
		}();
		var stateMessage = function () {
			switch (state) {
				case 0:
					return $author$project$Locale$Messages$StudentAbsenceStateUnjustified;
				case 2:
					return $author$project$Locale$Messages$StudentAbsenceStateJustifiedByDoctor;
				case 1:
					return $author$project$Locale$Messages$StudentAbsenceStateJustifiedByParent;
				case 3:
					return $author$project$Locale$Messages$StudentAbsenceStateJustifiedByMentor;
				default:
					return $author$project$Locale$Messages$StudentAbsenceStateQuestioned;
			}
		}();
		return A2(
			$author$project$UI$tag,
			'is-light' + (' ' + style),
			_List_fromArray(
				[
					$elm$html$Html$text(
					t_(stateMessage))
				]));
	});
var $author$project$Element$StudentAbsenceList$ByMentor = 2;
var $author$project$Element$StudentAbsenceList$JustificationRequested = function (a) {
	return {$: 6, a: a};
};
var $author$project$Locale$Messages$StudentAbsenceActionJustifyByMentor = {$: 438};
var $author$project$Element$StudentAbsenceList$requestJustification = F3(
	function (type_, absence, viewer) {
		return {dQ: absence, ii: type_, ok: viewer};
	});
var $author$project$Element$StudentAbsenceList$viewSmallButton = F3(
	function (t_, m, onClick) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button'),
					$elm$html$Html$Attributes$class('is-small'),
					$elm$html$Html$Events$onClick(onClick)
				]),
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, m)
				]));
	});
var $author$project$Element$StudentAbsenceList$viewActionsForMentor = F4(
	function (t_, student, viewer, absence) {
		return A2($author$project$Person$isMentorOf, student, viewer) ? _List_fromArray(
			[
				A3(
				$author$project$Element$StudentAbsenceList$viewSmallButton,
				t_,
				$author$project$Locale$Messages$StudentAbsenceActionJustifyByMentor,
				$author$project$Element$StudentAbsenceList$JustificationRequested(
					A3($author$project$Element$StudentAbsenceList$requestJustification, 2, absence, viewer)))
			]) : _List_Nil;
	});
var $author$project$Element$StudentAbsenceList$ByDoctor = 0;
var $author$project$Element$StudentAbsenceList$ByParent = 1;
var $author$project$Element$StudentAbsenceList$QuestionAbsenceRequested = function (a) {
	return {$: 3, a: a};
};
var $author$project$Locale$Messages$StudentAbsenceActionJustifyByDoctor = {$: 436};
var $author$project$Locale$Messages$StudentAbsenceActionJustifyByParent = {$: 437};
var $author$project$Locale$Messages$StudentAbsenceActionQuestion = {$: 441};
var $author$project$Element$StudentAbsenceList$viewActionsForParent = F4(
	function (t_, student, viewer, absence) {
		return A2($author$project$Person$isSponsorOf, viewer, student) ? _List_fromArray(
			[
				A3(
				$author$project$Element$StudentAbsenceList$viewSmallButton,
				t_,
				$author$project$Locale$Messages$StudentAbsenceActionJustifyByDoctor,
				$author$project$Element$StudentAbsenceList$JustificationRequested(
					A3($author$project$Element$StudentAbsenceList$requestJustification, 0, absence, viewer))),
				A3(
				$author$project$Element$StudentAbsenceList$viewSmallButton,
				t_,
				$author$project$Locale$Messages$StudentAbsenceActionJustifyByParent,
				$author$project$Element$StudentAbsenceList$JustificationRequested(
					A3($author$project$Element$StudentAbsenceList$requestJustification, 1, absence, viewer))),
				A3(
				$author$project$Element$StudentAbsenceList$viewSmallButton,
				t_,
				$author$project$Locale$Messages$StudentAbsenceActionQuestion,
				$author$project$Element$StudentAbsenceList$QuestionAbsenceRequested(absence))
			]) : _List_Nil;
	});
var $author$project$Element$StudentAbsenceList$viewActions = F4(
	function (t_, student, viewer, absence) {
		var actionsForParent = A4($author$project$Element$StudentAbsenceList$viewActionsForParent, t_, student, viewer, absence);
		var actionsForMentor = A4($author$project$Element$StudentAbsenceList$viewActionsForMentor, t_, student, viewer, absence);
		return _Utils_ap(actionsForMentor, actionsForParent);
	});
var $author$project$Element$StudentAbsenceList$viewAbsence = F3(
	function (t_, viewer, absence) {
		var student = absence.nT;
		var startDate = absence.nN;
		var endDate = absence.ly;
		var state = absence.fs;
		var paragraph = A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$html$Html$p(_List_Nil),
				$author$project$UI$textToHtml),
			t_);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth')
				]),
			_List_fromArray(
				[
					$author$project$UI$columnsWithAttribs(
					_List_fromArray(
						[
							_Utils_Tuple2(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-one-fifth')
								]),
							paragraph(
								A3(
									$author$project$Locale$Messages$StudentAbsenceListItemDetails,
									$elm$time$Time$utc,
									$elm$time$Time$millisToPosix(startDate),
									$elm$time$Time$millisToPosix(endDate)))),
							_Utils_Tuple2(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-one-fifth')
								]),
							A2($author$project$Element$StudentAbsenceList$viewAbsenceState, t_, state)),
							_Utils_Tuple2(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-three-fifths')
								]),
							A2(
								$author$project$UI$level,
								function () {
									switch (state) {
										case 0:
											return A4($author$project$Element$StudentAbsenceList$viewActions, t_, student, viewer, absence);
										case 2:
											return $author$project$Element$StudentAbsenceList$viewAbsenceMeta(absence);
										case 1:
											return $author$project$Element$StudentAbsenceList$viewAbsenceMeta(absence);
										case 3:
											return $author$project$Element$StudentAbsenceList$viewAbsenceMeta(absence);
										default:
											return _List_Nil;
									}
								}(),
								_List_Nil))
						]))
				]));
	});
var $author$project$Element$StudentAbsenceList$viewAbsenceList = F4(
	function (t_, viewer, student, absences) {
		var viewCaption = A2(
			$author$project$UI$caption,
			t_,
			$author$project$Locale$Messages$StudentAbsenceListTitle(
				A2($author$project$Person$fullName, t_, student)));
		var filteredAbsences = $author$project$Element$StudentAbsenceList$defaultFilterAbsences(absences);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$UI$panel(
					{
						g$: A2(
							$elm$core$List$map,
							A2($author$project$Element$StudentAbsenceList$viewAbsence, t_, viewer),
							filteredAbsences),
						cm: 'student-absence',
						hl: _List_fromArray(
							[viewCaption]),
						h7: _List_Nil,
						ie: 'is-info'
					}),
					A2(
					$author$project$UI$when,
					$elm$core$List$isEmpty(filteredAbsences),
					$author$project$UI$notification(
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentAbsenceListNoAbsences)
							])))
				]));
	});
var $author$project$Element$StudentAbsenceList$viewDocumentViewer = F2(
	function (session, documentModel) {
		return A3($author$project$Application$V3$Boundaries$viewElement, session, documentModel, $author$project$Element$StudentAbsenceList$documentViewer);
	});
var $author$project$Element$StudentAbsenceList$JustificationConfirmed = {$: 7};
var $author$project$Element$StudentAbsenceList$JustificationDeclined = {$: 8};
var $author$project$Locale$Messages$StudentAbsenceActionJustifyByDoctorHelp = F4(
	function (a, b, c, d) {
		return {$: 440, a: a, b: b, c: c, d: d};
	});
var $author$project$Locale$Messages$StudentAbsenceActionJustifyHelp = F4(
	function (a, b, c, d) {
		return {$: 439, a: a, b: b, c: c, d: d};
	});
var $author$project$Locale$Messages$JustifyingDocumentStorage = {$: 123};
var $author$project$Element$StudentAbsenceList$MediaFileUploadRequested = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Locale$Messages$StudentAbsenceJustificationMediaUploadHelp = function (a) {
	return {$: 445, a: a};
};
var $author$project$Element$StudentAbsenceList$composeL12 = F4(
	function (g, f, x, y) {
		return g(
			A2(f, x, y));
	});
var $author$project$Element$StudentAbsenceList$viewJustificationForm = F2(
	function (t_, _v0) {
		var form = _v0.bE;
		var values = _v0.eI;
		var mediaFileUploadRequested = A2($author$project$Element$StudentAbsenceList$composeL12, $author$project$Element$StudentAbsenceList$JustificationFormMsg, $author$project$Element$StudentAbsenceList$MediaFileUploadRequested);
		var maxFileSizeInMb = ((($author$project$Element$StudentAbsenceList$maxFileSize / 1024) | 0) / 1024) | 0;
		var viewFormFields = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth')
				]),
			_List_fromArray(
				[
					A3($author$project$UI$textField, t_, form.g8, values),
					A4(
					$author$project$UI$withInfoText,
					_List_Nil,
					t_,
					$author$project$Locale$Messages$JustifyingDocumentStorage,
					A4(
						$author$project$UI$withInfoText,
						_List_Nil,
						t_,
						$author$project$Locale$Messages$StudentAbsenceJustificationMediaUploadHelp(maxFileSizeInMb),
						A5($author$project$UI$fileField, t_, form.w, values, mediaFileUploadRequested, $author$project$Element$StudentAbsenceList$OpenDocumentViewer)))
				]));
		return A2(
			$author$project$UI$level,
			_List_fromArray(
				[viewFormFields]),
			_List_Nil);
	});
var $author$project$Element$StudentAbsenceList$viewJustificationDialog = F3(
	function (t_, formModel, request) {
		var form = formModel.bE;
		var state = formModel.fs;
		var values = formModel.eI;
		var student = request.dQ.nT;
		var startDate = request.dQ.nN;
		var formState = A2($author$project$Form$isUploading, form.w, values) ? 2 : state;
		var endDate = request.dQ.ly;
		var helpText = function () {
			var _v1 = request.ii;
			if (!_v1) {
				return t_(
					A4(
						$author$project$Locale$Messages$StudentAbsenceActionJustifyByDoctorHelp,
						A2($author$project$Person$fullName, t_, student),
						$elm$time$Time$utc,
						$elm$time$Time$millisToPosix(startDate),
						$elm$time$Time$millisToPosix(endDate)));
			} else {
				return t_(
					A4(
						$author$project$Locale$Messages$StudentAbsenceActionJustifyHelp,
						A2($author$project$Person$fullName, t_, student),
						$elm$time$Time$utc,
						$elm$time$Time$millisToPosix(startDate),
						$elm$time$Time$millisToPosix(endDate)));
			}
		}();
		var dialogTitle = function () {
			var _v0 = request.ii;
			switch (_v0) {
				case 2:
					return $author$project$Locale$Messages$StudentAbsenceActionJustifyByMentor;
				case 0:
					return $author$project$Locale$Messages$StudentAbsenceActionJustifyByDoctor;
				default:
					return $author$project$Locale$Messages$StudentAbsenceActionJustifyByParent;
			}
		}();
		return A5(
			$author$project$UI$confirmDialogOkCanBeDisabled,
			formState === 1,
			t_,
			{lc: $author$project$Element$StudentAbsenceList$JustificationConfirmed, lm: $author$project$Element$StudentAbsenceList$JustificationDeclined},
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, dialogTitle)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					$author$project$UI$textToHtml(helpText)),
					A2($author$project$Element$StudentAbsenceList$viewJustificationForm, t_, formModel)
				]));
	});
var $author$project$Element$StudentAbsenceList$QuestionAbsenceConfirmed = {$: 4};
var $author$project$Element$StudentAbsenceList$QuestionAbsenceDeclined = {$: 5};
var $author$project$Locale$Messages$StudentAbsenceActionQuestionHelp = F3(
	function (a, b, c) {
		return {$: 442, a: a, b: b, c: c};
	});
var $author$project$Element$StudentAbsenceList$viewQuestionAbsenceConfirmDialog = F2(
	function (t_, _v0) {
		var startDate = _v0.nN;
		var endDate = _v0.ly;
		return A4(
			$author$project$UI$confirmDialog,
			t_,
			{lc: $author$project$Element$StudentAbsenceList$QuestionAbsenceConfirmed, lm: $author$project$Element$StudentAbsenceList$QuestionAbsenceDeclined},
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentAbsenceActionQuestion)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					$author$project$UI$textToHtml(
						t_(
							A3(
								$author$project$Locale$Messages$StudentAbsenceActionQuestionHelp,
								$elm$time$Time$utc,
								$elm$time$Time$millisToPosix(startDate),
								$elm$time$Time$millisToPosix(endDate)))))
				]));
	});
var $author$project$Element$StudentAbsenceList$view = function (model) {
	var session = model.gB;
	var _v0 = _Utils_Tuple2(model.nT, model.dR);
	_v0$1:
	while (true) {
		_v0$2:
		while (true) {
			_v0$3:
			while (true) {
				_v0$4:
				while (true) {
					_v0$5:
					while (true) {
						switch (_v0.a.$) {
							case 2:
								switch (_v0.b.$) {
									case 2:
										var student_ = _v0.a.a;
										var absences_ = _v0.b.a;
										return A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A4($author$project$Element$StudentAbsenceList$viewAbsenceList, session.h6, session.ok, student_, absences_),
													A2(
													$author$project$UI$maybe,
													model.dn,
													A2($author$project$Element$StudentAbsenceList$viewJustificationDialog, session.h6, model.H)),
													A2(
													$author$project$UI$maybe,
													model.$7,
													$author$project$Element$StudentAbsenceList$viewQuestionAbsenceConfirmDialog(session.h6)),
													A2(
													$author$project$UI$maybe,
													model.d0,
													$author$project$Element$StudentAbsenceList$viewDocumentViewer(session))
												]));
									case 1:
										break _v0$1;
									case 3:
										break _v0$4;
									default:
										break _v0$5;
								}
							case 1:
								switch (_v0.b.$) {
									case 1:
										break _v0$1;
									case 3:
										break _v0$2;
									default:
										break _v0$2;
								}
							case 3:
								switch (_v0.b.$) {
									case 1:
										break _v0$1;
									case 3:
										break _v0$3;
									default:
										break _v0$3;
								}
							default:
								switch (_v0.b.$) {
									case 1:
										break _v0$1;
									case 3:
										break _v0$4;
									default:
										break _v0$5;
								}
						}
					}
					return A2(
						$author$project$UI$progressBar,
						'is-info',
						session.h6($author$project$Locale$Messages$StudentAbsenceListLoadingProgress));
				}
				return A2(
					$author$project$UI$progressBar,
					'is-warning',
					session.h6($author$project$Locale$Messages$StudentAbsenceListLoadingError));
			}
			return A2(
				$author$project$UI$progressBar,
				'is-warning',
				session.h6($author$project$Locale$Messages$StudentAbsenceListLoadingError));
		}
		var _v2 = _v0.a;
		return A2(
			$author$project$UI$progressBar,
			'is-success',
			session.h6($author$project$Locale$Messages$StudentAbsenceListLoadingProgress));
	}
	var _v1 = _v0.b;
	return A2(
		$author$project$UI$progressBar,
		'is-success',
		session.h6($author$project$Locale$Messages$StudentAbsenceListLoadingProgress));
};
var $author$project$Element$StudentAbsenceList$element = {jb: $author$project$Element$StudentAbsenceList$init, hP: $author$project$Element$StudentAbsenceList$perform, ks: $author$project$Element$StudentAbsenceList$update, og: $author$project$Element$StudentAbsenceList$view};
var $author$project$Element$StudentList$LoadingPage = {$: 1};
var $author$project$Element$StudentList$NotFoundPage = {$: 0};
var $author$project$Element$StudentList$StudentListDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StudentList$getListQuery = function (_v0) {
	var query = _v0;
	return query;
};
var $author$project$Api$Endpoint$categoryMentees = 'mentored';
var $author$project$Element$StudentList$listFilterToCategory = function (filter) {
	if (!filter) {
		return $author$project$Api$Endpoint$categoryAll;
	} else {
		return $author$project$Api$Endpoint$categoryMentees;
	}
};
var $author$project$Element$StudentList$asListParams = function (listPage) {
	var defaults = $author$project$Student$defaultListParams;
	return _Utils_update(
		defaults,
		{
			bD: $author$project$Element$StudentList$listFilterToCategory(listPage.ad),
			b0: function () {
				var _v0 = listPage.dj;
				if (_v0.$ === 1) {
					var student_ = _v0.a;
					return $elm$core$Maybe$Just(student_.nT.i8);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}(),
			bF: $author$project$Element$StudentList$getListQuery(listPage.bF)
		});
};
var $author$project$Element$StudentList$FilterAll = 0;
var $author$project$Element$StudentList$ListQuery = $elm$core$Basics$identity;
var $author$project$Element$StudentList$LoadingStudents = {$: 0};
var $author$project$Element$StudentList$emptyList = {ad: 0, dj: $author$project$Element$StudentList$LoadingStudents, bF: '', fv: _List_Nil};
var $author$project$Student$fetchActiveStudents = F3(
	function (config, params, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$activeStudents, config, params),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$Student$studentsDecoder));
	});
var $author$project$Element$StudentList$init = F3(
	function (config, session, _v0) {
		var model = {b_: config, bk: $author$project$Element$StudentList$NotFoundPage};
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A3(
				$author$project$Student$fetchActiveStudents,
				config.gX,
				$author$project$Element$StudentList$asListParams($author$project$Element$StudentList$emptyList),
				$author$project$Element$StudentList$StudentListDownloaded),
			A2(
				$author$project$Application$Boundaries$save,
				_Utils_update(
					model,
					{bk: $author$project$Element$StudentList$LoadingPage}),
				session));
	});
var $author$project$Element$StudentList$DelayedGotListQuery = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$StudentList$ListPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$StudentList$NoOp = {$: 0};
var $author$project$Element$StudentList$NoMoreStudents = {$: 2};
var $author$project$Element$StudentList$StudentsLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StudentList$toStudentListItem = F2(
	function (query, student) {
		return {
			lU: $author$project$Element$StudentList$getListQuery(query),
			nT: student
		};
	});
var $author$project$Element$StudentList$addNewStudents = F2(
	function (newStudents, listPage) {
		var loading = listPage.dj;
		var students = listPage.fv;
		var query = listPage.bF;
		var toAdd = A2(
			$elm$core$List$map,
			$author$project$Element$StudentList$toStudentListItem(query),
			newStudents);
		var _v0 = _Utils_Tuple3(
			loading,
			students,
			$elm$core$List$reverse(toAdd));
		switch (_v0.a.$) {
			case 0:
				if (!_v0.c.b) {
					if (!_v0.b.b) {
						var _v1 = _v0.a;
						return _Utils_update(
							listPage,
							{dj: $author$project$Element$StudentList$NoMoreStudents, fv: toAdd});
					} else {
						var _v4 = _v0.a;
						return _Utils_update(
							listPage,
							{dj: $author$project$Element$StudentList$NoMoreStudents});
					}
				} else {
					if (!_v0.b.b) {
						var _v2 = _v0.a;
						var _v3 = _v0.c;
						var lastStudent = _v3.a;
						return _Utils_update(
							listPage,
							{
								dj: $author$project$Element$StudentList$StudentsLoaded(lastStudent),
								fv: toAdd
							});
					} else {
						var _v5 = _v0.a;
						var _v6 = _v0.c;
						var lastStory = _v6.a;
						return _Utils_update(
							listPage,
							{
								dj: $author$project$Element$StudentList$StudentsLoaded(lastStory),
								fv: _Utils_ap(students, toAdd)
							});
					}
				}
			case 1:
				return listPage;
			default:
				var _v7 = _v0.a;
				return listPage;
		}
	});
var $author$project$Element$StudentList$initialList = function (listPage) {
	return _Utils_update(
		listPage,
		{dj: $author$project$Element$StudentList$LoadingStudents, fv: _List_Nil});
};
var $author$project$Log$paramScopeStudents = 'scope_students';
var $author$project$Element$StudentList$update = F3(
	function (session, msg, model) {
		var t_ = session.h6;
		var config = model.b_;
		var noop = A2($author$project$Application$Boundaries$save, model, session);
		var _v0 = _Utils_Tuple2(msg, model.bk);
		_v0$9:
		while (true) {
			switch (_v0.a.$) {
				case 3:
					if (_v0.b.$ === 2) {
						var category = _v0.a.a;
						var newListPage = _Utils_update(
							$author$project$Element$StudentList$emptyList,
							{ad: category});
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Student$fetchActiveStudents,
								config.gX,
								$author$project$Element$StudentList$asListParams(newListPage),
								$author$project$Element$StudentList$StudentListDownloaded),
							A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bk: $author$project$Element$StudentList$ListPage(newListPage)
									}),
								session));
					} else {
						break _v0$9;
					}
				case 6:
					if (_v0.b.$ === 2) {
						var _v1 = _v0.a;
						var listPage = _v0.b.a;
						var listParams = $author$project$Element$StudentList$asListParams(listPage);
						var _v2 = listPage.dj;
						if (_v2.$ === 1) {
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3($author$project$Student$fetchActiveStudents, config.gX, listParams, $author$project$Element$StudentList$StudentListDownloaded),
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bk: $author$project$Element$StudentList$ListPage(
												_Utils_update(
													listPage,
													{dj: $author$project$Element$StudentList$LoadingStudents}))
										}),
									session));
						} else {
							return noop;
						}
					} else {
						break _v0$9;
					}
				case 1:
					if (!_v0.a.a.$) {
						switch (_v0.b.$) {
							case 1:
								var students = _v0.a.a.a;
								var _v3 = _v0.b;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$ok,
										config,
										_Utils_Tuple2(
											$author$project$Log$msgStudentsDownload,
											_List_fromArray(
												[$author$project$Log$paramScopeStudents, $author$project$Log$paramOk])),
										$elm$core$Basics$always($author$project$Element$StudentList$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bk: $author$project$Element$StudentList$ListPage(
													A2($author$project$Element$StudentList$addNewStudents, students, $author$project$Element$StudentList$emptyList))
											}),
										session));
							case 2:
								var students = _v0.a.a.a;
								var listPage = _v0.b.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$ok,
										config,
										_Utils_Tuple2(
											$author$project$Log$msgStudentsDownload,
											_List_fromArray(
												[$author$project$Log$paramScopeStudents, $author$project$Log$paramOk])),
										$elm$core$Basics$always($author$project$Element$StudentList$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bk: $author$project$Element$StudentList$ListPage(
													A2($author$project$Element$StudentList$addNewStudents, students, listPage))
											}),
										session));
							default:
								break _v0$9;
						}
					} else {
						var error = _v0.a.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgStudentsDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeStudents),
									error),
								$elm$core$Basics$always($author$project$Element$StudentList$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$StudentListDownloadError))));
					}
				case 2:
					var _v4 = _v0.a;
					var cmd = $author$project$Ports$sendPageView(
						{
							m1: $author$project$Route$toString($author$project$Route$AnalyticsLearningContract),
							m2: A2($author$project$Route$pageTitle, t_, $author$project$Route$AnalyticsLearningContract)
						});
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						cmd,
						A2($author$project$Application$Boundaries$save, model, session));
				case 4:
					var query = _v0.a.a;
					var _v5 = model.bk;
					if (_v5.$ === 2) {
						var listPageModel = _v5.a;
						var delayCmd = A2(
							$author$project$Util$Delay$after,
							$author$project$Util$Delay$searchBarDelay,
							$author$project$Element$StudentList$DelayedGotListQuery(query));
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							delayCmd,
							A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bk: $author$project$Element$StudentList$ListPage(
											$author$project$Element$StudentList$initialList(
												_Utils_update(
													listPageModel,
													{bF: query})))
									}),
								session));
					} else {
						return noop;
					}
				case 5:
					var newQuery = _v0.a.a;
					var _v6 = model.bk;
					if (_v6.$ === 2) {
						var listPageModel = _v6.a;
						var cmd = _Utils_eq(newQuery, listPageModel.bF) ? A3(
							$author$project$Student$fetchActiveStudents,
							config.gX,
							$author$project$Element$StudentList$asListParams(listPageModel),
							$author$project$Element$StudentList$StudentListDownloaded) : $elm$core$Platform$Cmd$none;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							cmd,
							A2($author$project$Application$Boundaries$save, model, session));
					} else {
						return noop;
					}
				default:
					var _v7 = _v0.a;
					return noop;
			}
		}
		return noop;
	});
var $author$project$Locale$Messages$StudentsNotFound = {$: 461};
var $author$project$Element$StudentList$FilterMentees = 1;
var $author$project$Element$StudentList$GotCategoryFilter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$StudentList$GotListQuery = function (a) {
	return {$: 4, a: a};
};
var $author$project$Locale$Messages$StudentListFilterAll = {$: 541};
var $author$project$Locale$Messages$StudentListFilterMyMentees = {$: 542};
var $author$project$Locale$Messages$StudentSearch = {$: 555};
var $author$project$Locale$Messages$StudentsEmptyResults = {$: 460};
var $author$project$Element$StudentList$typeFilter = F3(
	function (filter, mentor, student) {
		return (!filter) || ((filter === 1) && A2($author$project$Person$isMentorOf, student, mentor));
	});
var $author$project$Element$StudentList$filterStudents = F3(
	function (currentFilter, mentor, studentListItems) {
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nT;
				},
				A2($author$project$Element$StudentList$typeFilter, currentFilter, mentor)),
			studentListItems);
	});
var $author$project$Person$hasMentees = function (person) {
	return !$elm$core$List$isEmpty(person.mx);
};
var $author$project$Locale$Messages$StudentSponsors = function (a) {
	return {$: 462, a: a};
};
var $author$project$Element$StudentList$viewGradeReportLink = F2(
	function (t_, student) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$LearningAssessmentCard(student.i8)),
					$author$project$UI$attrCyData(
					'learning-assessment-view ' + A2($elm$core$Maybe$withDefault, '', student.O))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$grades(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-primary')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewGradeReport)
				]));
	});
var $author$project$Element$StudentList$viewGradeRequestsLink = F2(
	function (t_, id) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					A2($author$project$Route$GradeRequestList, id, $elm$core$Maybe$Nothing)),
					$author$project$UI$attrCyData('grade-request-view')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$grades(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-primary')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestListTitle)
				]));
	});
var $author$project$Element$StudentList$LearningContractOpened = {$: 2};
var $author$project$Locale$Messages$StudentListAddLearningContract = {$: 545};
var $author$project$ACL$canCreateLearningContract = F2(
	function (student, person) {
		return A2($author$project$Person$isMentorOf, student, person);
	});
var $author$project$Element$StudentList$viewLearningContractLink = F3(
	function (t_, viewer, student) {
		var viewLink = function (contract) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Element$StudentList$LearningContractOpened),
						$elm$html$Html$Attributes$href(contract.K),
						$elm$html$Html$Attributes$target('_blank'),
						$author$project$UI$attrCyData('learningcontracts-view')
					]),
				_List_fromArray(
					[
						$author$project$UI$Icon$learningContract(_List_Nil),
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewLearningContract)
					]));
		};
		var createLink = A2(
			$author$project$UI$when,
			A2($author$project$ACL$canCreateLearningContract, student, viewer),
			A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$author$project$Route$href($author$project$Route$LearningContractsCreate),
						$author$project$UI$attrCyData('learningcontracts-new')
					]),
				_List_fromArray(
					[
						$author$project$UI$Icon$learningContract(
						_List_fromArray(
							[
								$author$project$UI$Icon$style('has-text-warning')
							])),
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListAddLearningContract)
					])));
		return A2(
			$elm$core$Maybe$withDefault,
			createLink,
			A2($elm$core$Maybe$map, viewLink, student.kL));
	});
var $author$project$Locale$Messages$StudentListViewProfile = {$: 549};
var $author$project$Element$StudentList$viewProfileLink = F2(
	function (t_, id) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$StudentProfileUpdate(id)),
					$author$project$UI$attrCyData('studentprofiles-view')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$profile(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-primary')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewProfile)
				]));
	});
var $author$project$Element$StudentList$viewStudentAbsenceListLink = F2(
	function (t_, student) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$StudentAbsenceList(student.i8))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$absence(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-link')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewStudentAbsenceList)
				]));
	});
var $author$project$Element$StudentList$viewSubjectFeedbacksLink = F2(
	function (t_, student) {
		var params = {W: $elm$core$Maybe$Nothing, mB: $elm$core$Maybe$Nothing, gE: $elm$core$Maybe$Nothing};
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					A2($author$project$Route$SubjectFeedbackList, student.i8, params))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$filter(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-link')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewSubjectFeedback)
				]));
	});
var $author$project$Element$StudentList$viewTimetableLink = F2(
	function (t_, id) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$TimetableCalendar(
						_List_fromArray(
							[id]))),
					$author$project$UI$attrCyData('timetable-view')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$moduleEvent(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-dark')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewTimetable)
				]));
	});
var $author$project$Element$StudentList$viewTrimesterFeedbacksLink = F2(
	function (t_, student) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$TrimesterFeedbackReport(student.i8))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$feedback(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-link')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewTrimesterFeedback)
				]));
	});
var $author$project$Element$StudentList$viewStudent = F3(
	function (t_, viewer, _v0) {
		var student = _v0.nT;
		var highlight = _v0.lU;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$UI$mediaObject,
					_List_fromArray(
						[
							$author$project$UI$gravatar(
							A2($elm$core$Maybe$withDefault, '', student.O))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_fromArray(
										[
											$author$project$UI$attrCyData('students-item')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$UI$withHighlightedText,
											highlight,
											A2($author$project$Person$fullName, t_, student)),
											$elm$html$Html$text(' ')
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$small,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$UI$caption,
											t_,
											$author$project$Locale$Messages$StudentSponsors(
												A2(
													$elm$core$List$map,
													$author$project$Person$fullName(t_),
													student.nM)))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$small,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Element$StudentList$viewMentorText, t_, student.my)
										])),
									function () {
									var _v1 = student.a$;
									if (!_v1.$) {
										var phoneNumber = _v1.a;
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													A2($elm$html$Html$br, _List_Nil, _List_Nil),
													A2($author$project$UI$protoLink, 'tel:', phoneNumber)
												]));
									} else {
										return $author$project$UI$none;
									}
								}(),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									function () {
									var _v2 = student.O;
									if (!_v2.$) {
										var email = _v2.a;
										return A2($author$project$UI$protoLink, 'mailto:', email);
									} else {
										return $author$project$UI$none;
									}
								}()
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UI$nav,
							_List_fromArray(
								[
									A3($author$project$Element$StudentList$viewLearningContractLink, t_, viewer, student),
									A2($author$project$Element$StudentList$viewTimetableLink, t_, student.i8),
									A2($author$project$Element$StudentList$viewStudentAbsenceListLink, t_, student),
									A2($author$project$Element$StudentList$viewTrimesterFeedbacksLink, t_, student),
									A2($author$project$Element$StudentList$viewSubjectFeedbacksLink, t_, student),
									A2($author$project$Element$StudentList$viewGradeReportLink, t_, student),
									A2($author$project$Element$StudentList$viewGradeRequestsLink, t_, student.i8),
									A2($author$project$Element$StudentList$viewProfileLink, t_, student.i8)
								]),
							_List_Nil)
						]),
					_List_Nil)
				]));
	});
var $author$project$Element$StudentList$viewStudentList = F2(
	function (_v0, _v1) {
		var t_ = _v0.h6;
		var viewer = _v0.ok;
		var filter = _v1.ad;
		var query = _v1.bF;
		var students = _v1.fv;
		var loading = _v1.dj;
		var viewLoadingState = function () {
			var _v2 = _Utils_Tuple2(loading, students);
			if (!_v2.b.b) {
				switch (_v2.a.$) {
					case 0:
						var _v3 = _v2.a;
						return _List_fromArray(
							[$author$project$UI$List$resultsLoadingProgressBar]);
					case 1:
						return _List_fromArray(
							[
								A2($author$project$UI$List$emptyResultsInfo, t_, $author$project$Locale$Messages$StudentsEmptyResults)
							]);
					default:
						var _v4 = _v2.a;
						return _List_fromArray(
							[
								A2($author$project$UI$List$emptyResultsInfo, t_, $author$project$Locale$Messages$StudentsEmptyResults)
							]);
				}
			} else {
				return _List_Nil;
			}
		}();
		var viewFilterLinks = A3(
			$author$project$UI$List$filterBar,
			t_,
			_Utils_Tuple2($author$project$Element$StudentList$GotCategoryFilter, filter),
			_List_fromArray(
				[
					{cm: 'all', ad: 0, hv: true, hw: true, ea: $author$project$Locale$Messages$StudentListFilterAll},
					{
					cm: 'mentees',
					ad: 1,
					hv: true,
					hw: $author$project$Person$hasMentees(viewer),
					ea: $author$project$Locale$Messages$StudentListFilterMyMentees
				}
				]));
		var sortStudents = $author$project$Util$List$sortBy(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nT;
				},
				$author$project$Person$fullName(t_)));
		return $author$project$UI$panel(
			{
				g$: A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('columns container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('column')
									]),
								_List_fromArray(
									[
										$author$project$UI$List$searchBar(
										{
											fe: function (input) {
												return $author$project$Element$StudentList$GotListQuery(input);
											},
											fj: t_($author$project$Locale$Messages$StudentSearch),
											bF: $author$project$Element$StudentList$getListQuery(query)
										})
									]))
							])),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							A2($author$project$Element$StudentList$viewStudent, t_, viewer),
							sortStudents(
								A3($author$project$Element$StudentList$filterStudents, filter, viewer, students))),
						viewLoadingState)),
				cm: 'students-list',
				hl: _List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListTitleStudents)
					]),
				h7: viewFilterLinks,
				ie: 'is-warning'
			});
	});
var $author$project$Locale$Messages$StudentListLoadMore = {$: 463};
var $author$project$Element$StudentList$viewStudentListPager = F2(
	function (t_, _v0) {
		var loading = _v0.dj;
		var students = _v0.fv;
		var _v1 = _Utils_Tuple2(loading, students);
		switch (_v1.a.$) {
			case 0:
				if (!_v1.b.b) {
					var _v2 = _v1.a;
					return $author$project$UI$none;
				} else {
					var _v3 = _v1.a;
					return $author$project$UI$List$resultsLoadingProgressBar;
				}
			case 1:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container has-text-centered')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$UI$actionLink,
							$author$project$Element$StudentList$LoadMoreStudents,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-link')
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$sync(_List_Nil),
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListLoadMore)
								]))
						]));
			default:
				var _v4 = _v1.a;
				return $author$project$UI$none;
		}
	});
var $author$project$Element$StudentList$view = F2(
	function (session, model) {
		var t_ = session.h6;
		var _v0 = model.bk;
		switch (_v0.$) {
			case 2:
				var listPage = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Element$StudentList$viewStudentList, session, listPage),
							A2($author$project$Element$StudentList$viewStudentListPager, t_, listPage)
						]));
			case 0:
				return $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentsNotFound)
						]));
			default:
				return A2(
					$author$project$UI$progressBar,
					'is-warning',
					t_($author$project$Locale$Messages$StudentListLoadingProgress));
		}
	});
var $author$project$Element$StudentList$element = {jb: $author$project$Element$StudentList$init, ks: $author$project$Element$StudentList$update, og: $author$project$Element$StudentList$view};
var $author$project$Element$StudentProfileForm$NotFoundPage = {$: 0};
var $author$project$Element$StudentProfileForm$LoadingNekPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$StudentProfileForm$LoadingPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StudentProfileForm$PhoneBookDownloaded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$StudentProfileForm$SchoolListDownloaded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$StudentProfileForm$StudentProfileDownloaded = function (a) {
	return {$: 6, a: a};
};
var $author$project$ACL$canManageStudentAdminData = $author$project$ACL$isStaff;
var $author$project$Person$fetchPhoneBook = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$people(config),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$Person$phoneBookDecoder));
	});
var $author$project$StudentProfile$fetchStudentProfile = F3(
	function (config, id, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$studentProfile, config, id),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$StudentProfile$studentProfileDecoder));
	});
var $author$project$Element$StudentProfileForm$initPage = F3(
	function (pageType, session, model) {
		var viewer = session.ok;
		var config = model.b_;
		if (!pageType.$) {
			var id = pageType.a;
			var model2 = _Utils_update(
				model,
				{
					bk: $author$project$Element$StudentProfileForm$LoadingPage(id),
					j2: $author$project$RemoteData$Loading
				});
			var cmd = $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$StudentProfile$fetchStudentProfile, config.gX, id, $author$project$Element$StudentProfileForm$StudentProfileDownloaded),
						A2($author$project$Team$fetchSchools, config.gX, $author$project$Element$StudentProfileForm$SchoolListDownloaded),
						$author$project$ACL$canManageStudentAdminData(viewer) ? A2($author$project$Person$fetchPhoneBook, config.gX, $author$project$Element$StudentProfileForm$PhoneBookDownloaded) : $elm$core$Platform$Cmd$none
					]));
			return A2(
				$author$project$Application$Boundaries$andThenCmd,
				cmd,
				A2($author$project$Application$Boundaries$save, model2, session));
		} else {
			var id = pageType.a;
			return A2(
				$author$project$Application$Boundaries$andThenCmd,
				A3($author$project$StudentProfile$fetchStudentProfile, config.gX, id, $author$project$Element$StudentProfileForm$StudentProfileDownloaded),
				A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{
							bk: $author$project$Element$StudentProfileForm$LoadingNekPage(id)
						}),
					session));
		}
	});
var $author$project$Element$StudentProfileForm$init = F3(
	function (config, session, pageType) {
		var model = {b_: config, bk: $author$project$Element$StudentProfileForm$NotFoundPage, gn: _List_Nil, eq: $elm$core$Maybe$Nothing, j2: $author$project$RemoteData$NotAsked};
		return A3($author$project$Element$StudentProfileForm$initPage, pageType, session, model);
	});
var $author$project$Element$StudentProfileForm$BirthCertificateFileSelected = F3(
	function (a, b, c) {
		return {$: 12, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$BirthCertificateFileUploaded = F3(
	function (a, b, c) {
		return {$: 14, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$BirthCertificatePolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 13, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$BirthCertificateSignatureDownloaded = function (a) {
	return {$: 16, a: a};
};
var $author$project$Element$StudentProfileForm$EvaluationFileSelected = F3(
	function (a, b, c) {
		return {$: 66, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$EvaluationFileUploaded = F3(
	function (a, b, c) {
		return {$: 68, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$EvaluationPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 67, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$EvaluationSignatureDownloaded = function (a) {
	return {$: 70, a: a};
};
var $author$project$Element$StudentProfileForm$FormPage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$StudentProfileForm$IdCardFileSelected = F3(
	function (a, b, c) {
		return {$: 36, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$IdCardFileUploaded = F3(
	function (a, b, c) {
		return {$: 38, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$IdCardPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 37, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$IdCardSignatureDownloaded = function (a) {
	return {$: 40, a: a};
};
var $author$project$Element$StudentProfileForm$IndividualStudentFileSelected = F3(
	function (a, b, c) {
		return {$: 60, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$IndividualStudentFileUploaded = F3(
	function (a, b, c) {
		return {$: 62, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$IndividualStudentPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 61, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$IndividualStudentSignatureDownloaded = function (a) {
	return {$: 64, a: a};
};
var $author$project$Element$StudentProfileForm$LastReportCardFileSelected = F3(
	function (a, b, c) {
		return {$: 54, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$LastReportCardPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 55, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$LastReportCardSignatureDownloaded = function (a) {
	return {$: 58, a: a};
};
var $author$project$Element$StudentProfileForm$LastReportCardUploaded = F3(
	function (a, b, c) {
		return {$: 56, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$NekFormPage = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$StudentProfileForm$NekIdFileSelected = F3(
	function (a, b, c) {
		return {$: 72, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$NekIdFileUploaded = F3(
	function (a, b, c) {
		return {$: 74, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$NekIdPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 73, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$NekIdSignatureDownloaded = function (a) {
	return {$: 76, a: a};
};
var $author$project$Element$StudentProfileForm$NoOp = {$: 10};
var $author$project$Element$StudentProfileForm$ProfileSaved = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$StudentProfileForm$ResidencePermitFileSelected = F3(
	function (a, b, c) {
		return {$: 18, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$ResidencePermitFileUploaded = F3(
	function (a, b, c) {
		return {$: 20, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$ResidencePermitPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 19, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$ResidencePermitSignatureDownloaded = function (a) {
	return {$: 22, a: a};
};
var $author$project$Element$StudentProfileForm$SpecialStatusFileSelected = F3(
	function (a, b, c) {
		return {$: 48, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$SpecialStatusFileUploaded = F3(
	function (a, b, c) {
		return {$: 50, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$SpecialStatusReportPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 49, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$SpecialStatusReportSignatureDownloaded = function (a) {
	return {$: 52, a: a};
};
var $author$project$Element$StudentProfileForm$SsnFileSelected = F3(
	function (a, b, c) {
		return {$: 24, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$SsnFileUploaded = F3(
	function (a, b, c) {
		return {$: 26, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$SsnPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 25, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$SsnSignatureDownloaded = function (a) {
	return {$: 28, a: a};
};
var $author$project$Element$StudentProfileForm$StudentCardFileSelected = F3(
	function (a, b, c) {
		return {$: 30, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$StudentCardFileUploaded = F3(
	function (a, b, c) {
		return {$: 32, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$StudentCardPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 31, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$StudentCardSignatureDownloaded = function (a) {
	return {$: 34, a: a};
};
var $author$project$Locale$Messages$StudentProfileFormFileDownloadError = {$: 532};
var $author$project$Locale$Messages$StudentProfileFormSaveSuccess = {$: 533};
var $author$project$Element$StudentProfileForm$TaxIdFileSelected = F3(
	function (a, b, c) {
		return {$: 42, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$TaxIdFileUploaded = F3(
	function (a, b, c) {
		return {$: 44, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$TaxIdPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 43, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$TaxIdSignatureDownloaded = function (a) {
	return {$: 46, a: a};
};
var $author$project$Element$StudentProfileForm$acceptedMimeTypes = _List_fromArray(
	['application/pdf', 'image/png', 'image/jpeg']);
var $author$project$Element$StudentProfileForm$awsPolicyScope = 'people';
var $author$project$Element$StudentProfileForm$Accidents = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$StudentProfileForm$Admission = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StudentProfileForm$BasicTask = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$StudentProfileForm$BirthCertificateUrl = function (a) {
	return {$: 24, a: a};
};
var $author$project$Element$StudentProfileForm$BirthDate = function (a) {
	return {$: 43, a: a};
};
var $author$project$Element$StudentProfileForm$BirthPlace = function (a) {
	return {$: 42, a: a};
};
var $author$project$Element$StudentProfileForm$BirthPlaceCountry = function (a) {
	return {$: 41, a: a};
};
var $author$project$Element$StudentProfileForm$CompetencyTestResults = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$StudentProfileForm$CurrentGrade = function (a) {
	return {$: 15, a: a};
};
var $author$project$Element$StudentProfileForm$DisciplinaryAndCompensationCases = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$StudentProfileForm$EduId = function (a) {
	return {$: 46, a: a};
};
var $author$project$Element$StudentProfileForm$Email = function (a) {
	return {$: 30, a: a};
};
var $author$project$Element$StudentProfileForm$EvaluationUrl = function (a) {
	return {$: 20, a: a};
};
var $author$project$Element$StudentProfileForm$Exams = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$StudentProfileForm$FirstForeignLanguage = function (a) {
	return {$: 17, a: a};
};
var $author$project$Element$StudentProfileForm$FirstName = function (a) {
	return {$: 31, a: a};
};
var $author$project$Element$StudentProfileForm$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$StudentProfileForm$IdCardUrl = function (a) {
	return {$: 26, a: a};
};
var $author$project$Element$StudentProfileForm$IndividualStudentUrl = function (a) {
	return {$: 21, a: a};
};
var $author$project$Element$StudentProfileForm$IsIndividualStudent = function (a) {
	return {$: 14, a: a};
};
var $author$project$Element$StudentProfileForm$LastName = function (a) {
	return {$: 32, a: a};
};
var $author$project$Element$StudentProfileForm$LastReportCardUrl = function (a) {
	return {$: 19, a: a};
};
var $author$project$Element$StudentProfileForm$Mentor = function (a) {
	return {$: 49, a: a};
};
var $author$project$Element$StudentProfileForm$MissedClasses = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$StudentProfileForm$MothersMaidenName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$StudentProfileForm$Nationality = function (a) {
	return {$: 44, a: a};
};
var $author$project$Element$StudentProfileForm$PermanentAddressCountry = function (a) {
	return {$: 34, a: a};
};
var $author$project$Element$StudentProfileForm$PermanentAddressPostcode = function (a) {
	return {$: 35, a: a};
};
var $author$project$Element$StudentProfileForm$PermanentAddressStreetDoor = function (a) {
	return {$: 40, a: a};
};
var $author$project$Element$StudentProfileForm$PermanentAddressStreetName = function (a) {
	return {$: 37, a: a};
};
var $author$project$Element$StudentProfileForm$PermanentAddressStreetNumber = function (a) {
	return {$: 39, a: a};
};
var $author$project$Element$StudentProfileForm$PermanentAddressStreetType = function (a) {
	return {$: 38, a: a};
};
var $author$project$Element$StudentProfileForm$PermanentAddressTown = function (a) {
	return {$: 36, a: a};
};
var $author$project$Locale$Messages$PersonMentor = {$: 317};
var $author$project$Element$StudentProfileForm$PhoneNumber = function (a) {
	return {$: 33, a: a};
};
var $author$project$Element$StudentProfileForm$ProfileNekId = function (a) {
	return {$: 16, a: a};
};
var $author$project$Element$StudentProfileForm$ProfileNekIdUrl = function (a) {
	return {$: 29, a: a};
};
var $author$project$Element$StudentProfileForm$ResidencePermitUrl = function (a) {
	return {$: 25, a: a};
};
var $author$project$Element$StudentProfileForm$SchoolYearRepetition = function (a) {
	return {$: 11, a: a};
};
var $author$project$Element$StudentProfileForm$SecondForeignLanguage = function (a) {
	return {$: 18, a: a};
};
var $author$project$Element$StudentProfileForm$SpecialStatus = function (a) {
	return {$: 13, a: a};
};
var $author$project$Element$StudentProfileForm$SpecialStatusUrl = function (a) {
	return {$: 22, a: a};
};
var $author$project$Element$StudentProfileForm$Ssn = function (a) {
	return {$: 45, a: a};
};
var $author$project$Element$StudentProfileForm$SsnUrl = function (a) {
	return {$: 28, a: a};
};
var $author$project$Element$StudentProfileForm$StudentCardId = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$StudentProfileForm$StudentCardUrl = function (a) {
	return {$: 23, a: a};
};
var $author$project$Locale$Messages$StudentProfileFormStudentCardUrl = {$: 517};
var $author$project$Element$StudentProfileForm$SupervisingSchool = function (a) {
	return {$: 47, a: a};
};
var $author$project$Element$StudentProfileForm$TaxIdUrl = function (a) {
	return {$: 27, a: a};
};
var $author$project$Element$StudentProfileForm$Team = function (a) {
	return {$: 48, a: a};
};
var $author$project$Element$StudentProfileForm$Termination = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$StudentProfileForm$TextbookSupply = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$StudentProfileForm$TripAbroad = function (a) {
	return {$: 12, a: a};
};
var $author$project$Locale$Messages$StudentProfileBasicTaskC = {$: 464};
var $author$project$Locale$Messages$StudentProfileBasicTaskG = {$: 465};
var $author$project$Locale$Messages$StudentProfileBasicTaskI = {$: 466};
var $author$project$StudentProfile$basicTaskOptions = function (t_) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'C',
			t_($author$project$Locale$Messages$StudentProfileBasicTaskC)),
			_Utils_Tuple2(
			'G',
			t_($author$project$Locale$Messages$StudentProfileBasicTaskG)),
			_Utils_Tuple2(
			'I',
			t_($author$project$Locale$Messages$StudentProfileBasicTaskI))
		]);
};
var $author$project$Locale$Messages$StudentProfileForeignLanguageEnglish = {$: 471};
var $author$project$Locale$Messages$StudentProfileForeignLanguageFrench = {$: 473};
var $author$project$Locale$Messages$StudentProfileForeignLanguageGerman = {$: 472};
var $author$project$Locale$Messages$StudentProfileForeignLanguageItalian = {$: 475};
var $author$project$Locale$Messages$StudentProfileForeignLanguageSpanish = {$: 474};
var $author$project$StudentProfile$foreignLanguageEnglish = 'Angol';
var $author$project$StudentProfile$foreignLanguageFrench = 'Francia';
var $author$project$StudentProfile$foreignLanguageGerman = 'Német';
var $author$project$StudentProfile$foreignLanguageItalian = 'Olasz';
var $author$project$StudentProfile$foreignLanguageSpanish = 'Spanyol';
var $author$project$StudentProfile$foreignLanguageOptions = function (t_) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			$author$project$StudentProfile$foreignLanguageEnglish,
			t_($author$project$Locale$Messages$StudentProfileForeignLanguageEnglish)),
			_Utils_Tuple2(
			$author$project$StudentProfile$foreignLanguageGerman,
			t_($author$project$Locale$Messages$StudentProfileForeignLanguageGerman)),
			_Utils_Tuple2(
			$author$project$StudentProfile$foreignLanguageFrench,
			t_($author$project$Locale$Messages$StudentProfileForeignLanguageFrench)),
			_Utils_Tuple2(
			$author$project$StudentProfile$foreignLanguageSpanish,
			t_($author$project$Locale$Messages$StudentProfileForeignLanguageSpanish)),
			_Utils_Tuple2(
			$author$project$StudentProfile$foreignLanguageItalian,
			t_($author$project$Locale$Messages$StudentProfileForeignLanguageItalian))
		]);
};
var $author$project$Element$StudentProfileForm$maxFileSize = (10 * 1024) * 1024;
var $author$project$Locale$Messages$PersonInvalidEduId = {$: 335};
var $author$project$Person$validEduIdFormat = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9]{11}$'));
var $author$project$Person$optionalEduId = F2(
	function (t_, value) {
		return (value === '') ? $elm$core$Result$Ok(value) : (A2($elm$regex$Regex$contains, $author$project$Person$validEduIdFormat, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$PersonInvalidEduId)));
	});
var $author$project$StudentProfile$validForeignLanguages = _List_fromArray(
	[$author$project$StudentProfile$foreignLanguageEnglish, $author$project$StudentProfile$foreignLanguageGerman, $author$project$StudentProfile$foreignLanguageSpanish, $author$project$StudentProfile$foreignLanguageFrench, $author$project$StudentProfile$foreignLanguageItalian]);
var $author$project$StudentProfile$optionalForeignLanguage = F2(
	function (t_, value) {
		var cleanValue = $elm$core$String$trim(value);
		return (cleanValue === '') ? $elm$core$Result$Ok(cleanValue) : (A2($elm$core$List$member, cleanValue, $author$project$StudentProfile$validForeignLanguages) ? $elm$core$Result$Ok(cleanValue) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormRequiredSelection)));
	});
var $author$project$Locale$Messages$StudentProfileInvalidNekId = {$: 476};
var $author$project$StudentProfile$validNekIdFormat = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9a-zA-Z]{16}$'));
var $author$project$StudentProfile$optionalNekId = F2(
	function (t_, value) {
		var cleanValue = $elm$core$String$trim(value);
		return (cleanValue === '') ? $elm$core$Result$Ok(cleanValue) : (A2($elm$regex$Regex$contains, $author$project$StudentProfile$validNekIdFormat, cleanValue) ? $elm$core$Result$Ok(cleanValue) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$StudentProfileInvalidNekId)));
	});
var $author$project$Form$optionalPhoneNumber = F2(
	function (t_, value) {
		return (value === '') ? $elm$core$Result$Ok(value) : (A2($elm$regex$Regex$contains, $author$project$Form$validPhoneNumberFormat, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormInvalidPhoneNumber)));
	});
var $author$project$Locale$Messages$PersonInvalidSsn = {$: 336};
var $author$project$Person$validSsnFormat = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9]{9}$'));
var $author$project$Person$requireValidSsn = F2(
	function (t_, value) {
		var cleanValue = $elm$core$String$trim(value);
		return A2($elm$regex$Regex$contains, $author$project$Person$validSsnFormat, cleanValue) ? $elm$core$Result$Ok(cleanValue) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$PersonInvalidSsn));
	});
var $author$project$Locale$Messages$FormRequiredFile = {$: 69};
var $author$project$Form$requiredFile = F3(
	function (t_, constraints, value) {
		var defaultErrorMessage = $author$project$Locale$Messages$FormRequiredFile;
		return A4($author$project$Form$requiredFileWithCustomMessage, t_, constraints, defaultErrorMessage, value);
	});
var $author$project$Locale$Messages$StudentProfileSchoolYear1 = {$: 480};
var $author$project$Locale$Messages$StudentProfileSchoolYear10 = {$: 489};
var $author$project$Locale$Messages$StudentProfileSchoolYear11 = {$: 490};
var $author$project$Locale$Messages$StudentProfileSchoolYear12 = {$: 491};
var $author$project$Locale$Messages$StudentProfileSchoolYear2 = {$: 481};
var $author$project$Locale$Messages$StudentProfileSchoolYear3 = {$: 482};
var $author$project$Locale$Messages$StudentProfileSchoolYear4 = {$: 483};
var $author$project$Locale$Messages$StudentProfileSchoolYear5 = {$: 484};
var $author$project$Locale$Messages$StudentProfileSchoolYear6 = {$: 485};
var $author$project$Locale$Messages$StudentProfileSchoolYear7 = {$: 486};
var $author$project$Locale$Messages$StudentProfileSchoolYear8 = {$: 487};
var $author$project$Locale$Messages$StudentProfileSchoolYear9 = {$: 488};
var $author$project$Locale$Messages$StudentProfileSchoolYearKindergarten1 = {$: 477};
var $author$project$Locale$Messages$StudentProfileSchoolYearKindergarten2 = {$: 478};
var $author$project$Locale$Messages$StudentProfileSchoolYearKindergarten3 = {$: 479};
var $author$project$StudentProfile$schoolYearOptions = function (t_) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'ovi 1',
			t_($author$project$Locale$Messages$StudentProfileSchoolYearKindergarten1)),
			_Utils_Tuple2(
			'ovi 2',
			t_($author$project$Locale$Messages$StudentProfileSchoolYearKindergarten2)),
			_Utils_Tuple2(
			'ovi 3',
			t_($author$project$Locale$Messages$StudentProfileSchoolYearKindergarten3)),
			_Utils_Tuple2(
			'1',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear1)),
			_Utils_Tuple2(
			'2',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear2)),
			_Utils_Tuple2(
			'3',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear3)),
			_Utils_Tuple2(
			'4',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear4)),
			_Utils_Tuple2(
			'5',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear5)),
			_Utils_Tuple2(
			'6',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear6)),
			_Utils_Tuple2(
			'7',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear7)),
			_Utils_Tuple2(
			'8',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear8)),
			_Utils_Tuple2(
			'9',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear9)),
			_Utils_Tuple2(
			'10',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear10)),
			_Utils_Tuple2(
			'11',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear11)),
			_Utils_Tuple2(
			'12',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear12))
		]);
};
var $author$project$Locale$Messages$StudentProfileSpecialStatusBtmn = {$: 467};
var $author$project$Locale$Messages$StudentProfileSpecialStatusNone = {$: 470};
var $author$project$Locale$Messages$StudentProfileSpecialStatusSni1 = {$: 468};
var $author$project$Locale$Messages$StudentProfileSpecialStatusSni2 = {$: 469};
var $author$project$StudentProfile$specialStatusOptions = function (t_) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'BTMN',
			t_($author$project$Locale$Messages$StudentProfileSpecialStatusBtmn)),
			_Utils_Tuple2(
			'SNI1',
			t_($author$project$Locale$Messages$StudentProfileSpecialStatusSni1)),
			_Utils_Tuple2(
			'SNI2',
			t_($author$project$Locale$Messages$StudentProfileSpecialStatusSni2)),
			_Utils_Tuple2(
			'NONE',
			t_($author$project$Locale$Messages$StudentProfileSpecialStatusNone))
		]);
};
var $author$project$Locale$Messages$StudentProfileFormInvalidStudentCardId = {$: 530};
var $author$project$StudentProfile$validStudentCardIdFormat = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9]{10}$'));
var $author$project$StudentProfile$validStudentCardId = F2(
	function (t_, value) {
		var cleanValue = $elm$core$String$trim(value);
		return (cleanValue === '') ? $elm$core$Result$Ok(cleanValue) : (A2($elm$regex$Regex$contains, $author$project$StudentProfile$validStudentCardIdFormat, cleanValue) ? $elm$core$Result$Ok(cleanValue) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$StudentProfileFormInvalidStudentCardId)));
	});
var $author$project$Element$StudentProfileForm$buildForm = function (t_) {
	return {
		ag: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ag: value});
				}),
			fC: function ($) {
				return $.ag;
			},
			og: {
				cm: 'accidents',
				ea: t_($author$project$Locale$Messages$StudentProfileFormAccidents),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Accidents),
				fj: t_($author$project$Locale$Messages$StudentProfileFormAccidents)
			}
		},
		ah: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ah: value});
				}),
			fC: function ($) {
				return $.ah;
			},
			og: {
				cm: 'admission',
				ea: t_($author$project$Locale$Messages$StudentProfileFormAdmission),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Admission),
				fj: t_($author$project$Locale$Messages$StudentProfileFormAdmission)
			}
		},
		aj: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aj: value});
				}),
			fC: function ($) {
				return $.aj;
			},
			og: {
				cm: 'basic_task',
				e6: 'fa-list',
				ea: t_($author$project$Locale$Messages$StudentProfileFormBasicTask),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$BasicTask),
				m_: $elm$core$Maybe$Just(
					$author$project$Form$toSelectOptions(
						$author$project$StudentProfile$basicTaskOptions(t_)))
			}
		},
		o: {
			e0: false,
			fi: A2(
				$author$project$Form$requiredFile,
				t_,
				{kH: $author$project$Element$StudentProfileForm$acceptedMimeTypes, mv: $author$project$Element$StudentProfileForm$maxFileSize}),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{o: value});
				}),
			fC: function ($) {
				return $.o;
			},
			og: {
				cm: 'birth_certificate',
				e6: 'fa-file-pdf',
				ea: t_($author$project$Locale$Messages$StudentProfileFormBirthCertificateUrl),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$BirthCertificateUrl),
				fj: t_($author$project$Locale$Messages$StudentProfileFormBirthCertificateUrl)
			}
		},
		aP: {
			e0: false,
			fi: $author$project$Form$requiredDate(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aP: value});
				}),
			fC: function ($) {
				return $.aP;
			},
			og: {
				cm: 'birth_date',
				ea: t_($author$project$Locale$Messages$PersonBirthDate),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$BirthDate)
			}
		},
		am: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{am: value});
				}),
			fC: function ($) {
				return $.am;
			},
			og: {
				cm: 'birth_place',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonBirthPlaceTown),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$BirthPlace),
				fj: t_($author$project$Locale$Messages$PersonBirthPlaceTown),
				ii: 'text'
			}
		},
		aR: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aR: value});
				}),
			fC: function ($) {
				return $.aR;
			},
			og: {
				cm: 'birthplace_country',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonBirthPlaceCountry),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$BirthPlaceCountry),
				m_: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(
						$author$project$Person$countries(t_)))
			}
		},
		an: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{an: value});
				}),
			fC: function ($) {
				return $.an;
			},
			og: {
				cm: 'survey_id',
				ea: t_($author$project$Locale$Messages$StudentProfileFormCompetencyTestResults),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$CompetencyTestResults),
				fj: t_($author$project$Locale$Messages$StudentProfileFormCompetencyTestResults)
			}
		},
		fT: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{fT: value});
				}),
			fC: function ($) {
				return $.fT;
			},
			og: {
				cm: 'is_individual_student',
				e6: 'fa-calendar',
				ea: t_($author$project$Locale$Messages$StudentProfileFormCurrentGrade),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$CurrentGrade),
				m_: $elm$core$Maybe$Just(
					$author$project$Form$toSelectOptions(
						$author$project$StudentProfile$schoolYearOptions(t_)))
			}
		},
		ao: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ao: value});
				}),
			fC: function ($) {
				return $.ao;
			},
			og: {
				cm: 'disciplinary_and_compensation_cases',
				ea: t_($author$project$Locale$Messages$StudentProfileFormDisciplinaryAndCompensationCases),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$DisciplinaryAndCompensationCases),
				fj: t_($author$project$Locale$Messages$StudentProfileFormDisciplinaryAndCompensationCases)
			}
		},
		ap: {
			e0: false,
			fi: $author$project$Person$optionalEduId(t_),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ap: value});
				}),
			fC: function ($) {
				return $.ap;
			},
			og: {
				cm: 'edu_id',
				e6: 'fa-id-card',
				ea: t_($author$project$Locale$Messages$PersonEduId),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$EduId),
				fj: t_($author$project$Locale$Messages$PersonEduId),
				ii: 'text'
			}
		},
		O: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{O: value});
				}),
			fC: function ($) {
				return $.O;
			},
			og: {
				cm: 'email',
				e6: 'fa-envelope',
				ea: t_($author$project$Locale$Messages$PersonEmail),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Email),
				fj: t_($author$project$Locale$Messages$PersonEmail),
				ii: 'email'
			}
		},
		y: {
			e0: false,
			fi: A2(
				$author$project$Form$optionalFile,
				t_,
				{kH: $author$project$Element$StudentProfileForm$acceptedMimeTypes, mv: $author$project$Element$StudentProfileForm$maxFileSize}),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{y: value});
				}),
			fC: function ($) {
				return $.y;
			},
			og: {
				cm: 'evaluation',
				e6: 'fa-file-pdf',
				ea: t_($author$project$Locale$Messages$StudentProfileFormEvaluationUrl),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$EvaluationUrl),
				fj: t_($author$project$Locale$Messages$StudentProfileFormEvaluationUrl)
			}
		},
		aq: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aq: value});
				}),
			fC: function ($) {
				return $.aq;
			},
			og: {
				cm: 'exams',
				ea: t_($author$project$Locale$Messages$StudentProfileFormExams),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Exams),
				fj: t_($author$project$Locale$Messages$StudentProfileFormExams)
			}
		},
		bf: {
			e0: false,
			fi: $author$project$StudentProfile$optionalForeignLanguage(t_),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{bf: value});
				}),
			fC: function ($) {
				return $.bf;
			},
			og: {
				cm: 'first_foreign_language',
				e6: 'fa-flag',
				ea: t_($author$project$Locale$Messages$StudentProfileFormFirstForeignLanguage),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$FirstForeignLanguage),
				m_: $elm$core$Maybe$Just(
					$author$project$Form$toSelectOptions(
						$author$project$StudentProfile$foreignLanguageOptions(t_)))
			}
		},
		lI: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{lI: value});
				}),
			fC: function ($) {
				return $.lI;
			},
			og: {
				cm: 'firstname',
				e6: 'fa-user',
				ea: t_($author$project$Locale$Messages$PersonFirstName),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$FirstName),
				fj: t_($author$project$Locale$Messages$PersonFirstName),
				ii: 'text'
			}
		},
		q: {
			e0: false,
			fi: A2(
				$author$project$Form$requiredFile,
				t_,
				{kH: $author$project$Element$StudentProfileForm$acceptedMimeTypes, mv: $author$project$Element$StudentProfileForm$maxFileSize}),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{q: value});
				}),
			fC: function ($) {
				return $.q;
			},
			og: {
				cm: 'id_card',
				e6: 'fa-file-pdf',
				ea: t_($author$project$Locale$Messages$StudentProfileFormIdCardUrl),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$IdCardUrl),
				fj: t_($author$project$Locale$Messages$StudentProfileFormIdCardUrl)
			}
		},
		A: {
			e0: false,
			fi: A2(
				$author$project$Form$optionalFile,
				t_,
				{kH: $author$project$Element$StudentProfileForm$acceptedMimeTypes, mv: $author$project$Element$StudentProfileForm$maxFileSize}),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{A: value});
				}),
			fC: function ($) {
				return $.A;
			},
			og: {
				cm: 'individual_student',
				e6: 'fa-file-pdf',
				ea: t_($author$project$Locale$Messages$StudentProfileFormIndividualStudentUrl),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$IndividualStudentUrl),
				fj: t_($author$project$Locale$Messages$StudentProfileFormIndividualStudentUrl)
			}
		},
		as: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{as: value});
				}),
			fC: function ($) {
				return $.as;
			},
			og: {
				cm: 'is_individual_student',
				e6: 'fa-list',
				ea: t_($author$project$Locale$Messages$StudentProfileFormIsIndividualStudent),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$IsIndividualStudent)
			}
		},
		av: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{av: value});
				}),
			fC: function ($) {
				return $.av;
			},
			og: {
				cm: 'lastname',
				e6: 'fa-user',
				ea: t_($author$project$Locale$Messages$PersonLastName),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$LastName),
				fj: t_($author$project$Locale$Messages$PersonLastName),
				ii: 'text'
			}
		},
		I: {
			e0: false,
			fi: A2(
				$author$project$Form$optionalFile,
				t_,
				{kH: $author$project$Element$StudentProfileForm$acceptedMimeTypes, mv: $author$project$Element$StudentProfileForm$maxFileSize}),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{I: value});
				}),
			fC: function ($) {
				return $.I;
			},
			og: {
				cm: 'last_report_card',
				e6: 'fa-file-pdf',
				ea: t_($author$project$Locale$Messages$StudentProfileFormLastReportCardUrl),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$LastReportCardUrl),
				fj: t_($author$project$Locale$Messages$StudentProfileFormLastReportCardUrl)
			}
		},
		my: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{my: value});
				}),
			fC: function ($) {
				return $.my;
			},
			og: {
				cm: 'mentor',
				e6: 'fa-user',
				ea: t_($author$project$Locale$Messages$PersonMentor),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Mentor),
				m_: $elm$core$Maybe$Nothing
			}
		},
		aw: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aw: value});
				}),
			fC: function ($) {
				return $.aw;
			},
			og: {
				cm: 'missed_classes',
				e6: 'fa-keyboard',
				ea: t_($author$project$Locale$Messages$StudentProfileFormMissedClasses),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$MissedClasses),
				fj: t_($author$project$Locale$Messages$StudentProfileFormMissedClasses),
				ii: 'text'
			}
		},
		aB: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aB: value});
				}),
			fC: function ($) {
				return $.aB;
			},
			og: {
				cm: 'mothers_name',
				e6: 'fa-user',
				ea: t_($author$project$Locale$Messages$StudentProfileFormMothersMaidenName),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$MothersMaidenName),
				fj: t_($author$project$Locale$Messages$StudentProfileFormMothersMaidenName),
				ii: 'text'
			}
		},
		aC: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aC: value});
				}),
			fC: function ($) {
				return $.aC;
			},
			og: {
				cm: 'nationality',
				e6: 'fa-flag',
				ea: t_($author$project$Locale$Messages$PersonNationality),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Nationality),
				m_: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(
						$author$project$Person$countries(t_)))
			}
		},
		m: {
			e0: false,
			fi: $author$project$StudentProfile$optionalNekId(t_),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{m: value});
				}),
			fC: function ($) {
				return $.m;
			},
			og: {
				cm: 'nek_id',
				e6: 'fa-id-card',
				ea: t_($author$project$Locale$Messages$StudentProfileFormNekId),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$ProfileNekId),
				fj: t_($author$project$Locale$Messages$StudentProfileFormNekId),
				ii: 'text'
			}
		},
		b: {
			e0: false,
			fi: A2(
				$author$project$Form$optionalFile,
				t_,
				{kH: $author$project$Element$StudentProfileForm$acceptedMimeTypes, mv: $author$project$Element$StudentProfileForm$maxFileSize}),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{b: value});
				}),
			fC: function ($) {
				return $.b;
			},
			og: {
				cm: 'nek_id',
				e6: 'fa-file-pdf',
				ea: t_($author$project$Locale$Messages$StudentProfileFormNekIdUrl),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$ProfileNekIdUrl),
				fj: t_($author$project$Locale$Messages$StudentProfileFormNekIdUrl)
			}
		},
		a1: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a1: value});
				}),
			fC: function ($) {
				return $.a1;
			},
			og: {
				cm: 'permanent_address_country',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressCountry),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$PermanentAddressCountry),
				m_: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(
						$author$project$Person$countries(t_)))
			}
		},
		a2: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a2: value});
				}),
			fC: function ($) {
				return $.a2;
			},
			og: {
				cm: 'permanent_address_postcode',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressPostcode),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$PermanentAddressPostcode),
				fj: t_($author$project$Locale$Messages$PersonAddressPostcode),
				ii: 'text'
			}
		},
		a3: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a3: value});
				}),
			fC: function ($) {
				return $.a3;
			},
			og: {
				cm: 'permanent_address_street_door',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressStreetDoor),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$PermanentAddressStreetDoor),
				fj: t_($author$project$Locale$Messages$PersonAddressStreetDoor),
				ii: 'text'
			}
		},
		a4: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a4: value});
				}),
			fC: function ($) {
				return $.a4;
			},
			og: {
				cm: 'permanent_address_street_name',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressStreetName),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$PermanentAddressStreetName),
				fj: t_($author$project$Locale$Messages$PersonAddressStreetName),
				ii: 'text'
			}
		},
		a5: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a5: value});
				}),
			fC: function ($) {
				return $.a5;
			},
			og: {
				cm: 'permanent_address_street_number',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressStreetNumber),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$PermanentAddressStreetNumber),
				fj: t_($author$project$Locale$Messages$PersonAddressStreetNumber),
				ii: 'text'
			}
		},
		a6: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a6: value});
				}),
			fC: function ($) {
				return $.a6;
			},
			og: {
				cm: 'permanent_address_street_type',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressStreetType),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$PermanentAddressStreetType),
				fj: t_($author$project$Locale$Messages$PersonAddressStreetType),
				ii: 'text'
			}
		},
		a7: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a7: value});
				}),
			fC: function ($) {
				return $.a7;
			},
			og: {
				cm: 'permanent_address_town',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressTown),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$PermanentAddressTown),
				fj: t_($author$project$Locale$Messages$PersonAddressTown),
				ii: 'text'
			}
		},
		a$: {
			e0: false,
			fi: $author$project$Form$optionalPhoneNumber(t_),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a$: value});
				}),
			fC: function ($) {
				return $.a$;
			},
			og: {
				cm: 'phone',
				e6: 'fa-phone',
				ea: t_($author$project$Locale$Messages$PersonPhone),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$PhoneNumber),
				fj: t_($author$project$Locale$Messages$PersonPhone),
				ii: 'phone'
			}
		},
		s: {
			e0: false,
			fi: A2(
				$author$project$Form$requiredFile,
				t_,
				{kH: $author$project$Element$StudentProfileForm$acceptedMimeTypes, mv: $author$project$Element$StudentProfileForm$maxFileSize}),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{s: value});
				}),
			fC: function ($) {
				return $.s;
			},
			og: {
				cm: 'residence_permit',
				e6: 'fa-file-pdf',
				ea: t_($author$project$Locale$Messages$StudentProfileFormResidencePermitUrl),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$ResidencePermitUrl),
				fj: t_($author$project$Locale$Messages$StudentProfileFormResidencePermitUrl)
			}
		},
		aE: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aE: value});
				}),
			fC: function ($) {
				return $.aE;
			},
			og: {
				cm: 'school_year_repetition',
				ea: t_($author$project$Locale$Messages$StudentProfileFormSchoolYearRepetition),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$SchoolYearRepetition),
				fj: t_($author$project$Locale$Messages$StudentProfileFormSchoolYearRepetition)
			}
		},
		bm: {
			e0: false,
			fi: $author$project$StudentProfile$optionalForeignLanguage(t_),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{bm: value});
				}),
			fC: function ($) {
				return $.bm;
			},
			og: {
				cm: 'second_foreign_language',
				e6: 'fa-flag',
				ea: t_($author$project$Locale$Messages$StudentProfileFormSecondForeignLanguage),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$SecondForeignLanguage),
				m_: $elm$core$Maybe$Just(
					$author$project$Form$toSelectOptions(
						$author$project$StudentProfile$foreignLanguageOptions(t_)))
			}
		},
		aF: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aF: value});
				}),
			fC: function ($) {
				return $.aF;
			},
			og: {
				cm: 'sni_status',
				e6: 'fa-list',
				ea: t_($author$project$Locale$Messages$StudentProfileFormSpecialStatus),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$SpecialStatus),
				m_: $elm$core$Maybe$Just(
					$author$project$Form$toSelectOptions(
						$author$project$StudentProfile$specialStatusOptions(t_)))
			}
		},
		E: {
			e0: false,
			fi: A2(
				$author$project$Form$optionalFile,
				t_,
				{kH: $author$project$Element$StudentProfileForm$acceptedMimeTypes, mv: $author$project$Element$StudentProfileForm$maxFileSize}),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{E: value});
				}),
			fC: function ($) {
				return $.E;
			},
			og: {
				cm: 'sni_report',
				e6: 'fa-file-pdf',
				ea: t_($author$project$Locale$Messages$StudentProfileFormSpecialStatusUrl),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$SpecialStatusUrl),
				fj: t_($author$project$Locale$Messages$StudentProfileFormSpecialStatusUrl)
			}
		},
		aG: {
			e0: false,
			fi: $author$project$Person$requireValidSsn(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aG: value});
				}),
			fC: function ($) {
				return $.aG;
			},
			og: {
				cm: 'ssn',
				e6: 'fa-id-card',
				ea: t_($author$project$Locale$Messages$PersonSsn),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Ssn),
				fj: t_($author$project$Locale$Messages$PersonSsn),
				ii: 'text'
			}
		},
		t: {
			e0: false,
			fi: A2(
				$author$project$Form$requiredFile,
				t_,
				{kH: $author$project$Element$StudentProfileForm$acceptedMimeTypes, mv: $author$project$Element$StudentProfileForm$maxFileSize}),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{t: value});
				}),
			fC: function ($) {
				return $.t;
			},
			og: {
				cm: 'ssn',
				e6: 'fa-file-pdf',
				ea: t_($author$project$Locale$Messages$StudentProfileFormSsnUrl),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$SsnUrl),
				fj: t_($author$project$Locale$Messages$StudentProfileFormSsnUrl)
			}
		},
		aH: {
			e0: false,
			fi: $author$project$StudentProfile$validStudentCardId(t_),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aH: value});
				}),
			fC: function ($) {
				return $.aH;
			},
			og: {
				cm: 'student_card_id',
				e6: 'fa-id-card',
				ea: t_($author$project$Locale$Messages$StudentProfileFormStudentCardId),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$StudentCardId),
				fj: t_($author$project$Locale$Messages$StudentProfileFormStudentCardId),
				ii: 'text'
			}
		},
		J: {
			e0: false,
			fi: A2(
				$author$project$Form$optionalFile,
				t_,
				{kH: $author$project$Element$StudentProfileForm$acceptedMimeTypes, mv: $author$project$Element$StudentProfileForm$maxFileSize}),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{J: value});
				}),
			fC: function ($) {
				return $.J;
			},
			og: {
				cm: 'student_card',
				e6: 'fa-file-pdf',
				ea: t_($author$project$Locale$Messages$StudentProfileFormStudentCardUrl),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$StudentCardUrl),
				fj: t_($author$project$Locale$Messages$StudentProfileFormStudentCardUrl)
			}
		},
		aI: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aI: value});
				}),
			fC: function ($) {
				return $.aI;
			},
			og: {
				cm: 'supervising_school',
				e6: 'fa-school',
				ea: t_($author$project$Locale$Messages$PersonSupervisingSchool),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$SupervisingSchool),
				fj: t_($author$project$Locale$Messages$PersonSupervisingSchool),
				ii: 'text'
			}
		},
		u: {
			e0: false,
			fi: A2(
				$author$project$Form$requiredFile,
				t_,
				{kH: $author$project$Element$StudentProfileForm$acceptedMimeTypes, mv: $author$project$Element$StudentProfileForm$maxFileSize}),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{u: value});
				}),
			fC: function ($) {
				return $.u;
			},
			og: {
				cm: 'tax_id',
				e6: 'fa-file-pdf',
				ea: t_($author$project$Locale$Messages$StudentProfileFormTaxIdUrl),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$TaxIdUrl),
				fj: t_($author$project$Locale$Messages$StudentProfileFormTaxIdUrl)
			}
		},
		kf: {
			e0: false,
			fi: $author$project$Form$requiredTeamSelected(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{kf: value});
				}),
			fC: function ($) {
				return $.kf;
			},
			og: {
				cm: 'team',
				e6: 'fa-school',
				ea: t_($author$project$Locale$Messages$PersonTeam),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Team),
				m_: $elm$core$Maybe$Nothing
			}
		},
		aJ: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aJ: value});
				}),
			fC: function ($) {
				return $.aJ;
			},
			og: {
				cm: 'termination',
				ea: t_($author$project$Locale$Messages$StudentProfileFormTermination),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Termination),
				fj: t_($author$project$Locale$Messages$StudentProfileFormTermination)
			}
		},
		aK: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aK: value});
				}),
			fC: function ($) {
				return $.aK;
			},
			og: {
				cm: 'textbook_supply',
				ea: t_($author$project$Locale$Messages$StudentProfileFormTextbookSupply),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$TextbookSupply),
				fj: t_($author$project$Locale$Messages$StudentProfileFormTextbookSupply)
			}
		},
		aM: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aM: value});
				}),
			fC: function ($) {
				return $.aM;
			},
			og: {
				cm: 'trip_abroad',
				ea: t_($author$project$Locale$Messages$StudentProfileFormTripAbroad),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$TripAbroad),
				fj: t_($author$project$Locale$Messages$StudentProfileFormTripAbroad)
			}
		}
	};
};
var $author$project$Element$StudentProfileForm$NekFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StudentProfileForm$NekId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$StudentProfileForm$NekIdUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$StudentProfile$requiredNekId = F2(
	function (t_, value) {
		var cleanValue = $elm$core$String$trim(value);
		return A2($elm$regex$Regex$contains, $author$project$StudentProfile$validNekIdFormat, cleanValue) ? $elm$core$Result$Ok(cleanValue) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$StudentProfileInvalidNekId));
	});
var $author$project$Element$StudentProfileForm$buildNekForm = function (t_) {
	return {
		m: {
			e0: false,
			fi: $author$project$StudentProfile$requiredNekId(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{m: value});
				}),
			fC: function ($) {
				return $.m;
			},
			og: {
				cm: 'nek_id',
				e6: 'fa-id-card',
				ea: t_($author$project$Locale$Messages$StudentProfileFormNekId),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$NekFormMsg, $author$project$Element$StudentProfileForm$NekId),
				fj: t_($author$project$Locale$Messages$StudentProfileFormNekId),
				ii: 'text'
			}
		},
		b: {
			e0: false,
			fi: A2(
				$author$project$Form$requiredFile,
				t_,
				{kH: $author$project$Element$StudentProfileForm$acceptedMimeTypes, mv: $author$project$Element$StudentProfileForm$maxFileSize}),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{b: value});
				}),
			fC: function ($) {
				return $.b;
			},
			og: {
				cm: 'nek_id',
				e6: 'fa-file-pdf',
				ea: t_($author$project$Locale$Messages$StudentProfileFormNekIdUrl),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$NekFormMsg, $author$project$Element$StudentProfileForm$NekIdUrl),
				fj: t_($author$project$Locale$Messages$StudentProfileFormNekIdUrl)
			}
		}
	};
};
var $author$project$S3$mime = function (signature) {
	return signature.g3;
};
var $author$project$S3$url = function (signature) {
	var params = _List_fromArray(
		[
			_Utils_Tuple2('X-Amz-Algorithm', signature.gN),
			_Utils_Tuple2('X-Amz-Credential', signature.gO),
			_Utils_Tuple2('X-Amz-Date', signature.gP),
			_Utils_Tuple2(
			'X-Amz-Expires',
			$elm$core$String$fromInt(signature.im)),
			_Utils_Tuple2('X-Amz-SignedHeaders', signature.kE),
			_Utils_Tuple2('X-Amz-Signature', signature.gQ),
			_Utils_Tuple2('response-content-disposition', 'inline'),
			_Utils_Tuple2('response-content-type', signature.g3)
		]);
	var host = 'https://' + signature.gz;
	return A3(
		$author$project$Api$Endpoint$url,
		host,
		_List_fromArray(
			[signature.fP, signature.fO]),
		params);
};
var $author$project$S3$document = function (signature) {
	return {
		fa: $author$project$S3$mime(signature),
		K: $author$project$S3$url(signature)
	};
};
var $author$project$Element$StudentProfileForm$fillForm = function (profile) {
	var student = profile.nT;
	return {
		ag: profile.ag,
		ah: profile.ah,
		aj: profile.aj,
		o: $author$project$Form$fromFileUrl(profile.o),
		aP: A2($elm$core$Maybe$withDefault, '', student.aP),
		am: A2($elm$core$Maybe$withDefault, '', student.am),
		aR: student.aR,
		an: profile.an,
		fT: profile.fT,
		ao: profile.ao,
		ap: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $elm$core$String$fromInt, student.ap)),
		O: A2($elm$core$Maybe$withDefault, '', student.O),
		y: $author$project$Form$fromFileUrl(profile.y),
		aq: profile.aq,
		bf: profile.bf,
		lI: student.lI,
		q: $author$project$Form$fromFileUrl(profile.q),
		A: $author$project$Form$fromFileUrl(profile.A),
		as: profile.as,
		av: student.av,
		I: $author$project$Form$fromFileUrl(profile.I),
		my: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.i8;
					},
					$elm$core$String$fromInt),
				student.my)),
		aw: profile.aw,
		aB: profile.aB,
		aC: student.aC,
		m: profile.m,
		b: $author$project$Form$fromFileUrl(profile.b),
		a1: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.le;
				},
				student.dp)),
		a2: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nb;
				},
				student.dp)),
		a3: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nP;
				},
				student.dp)),
		a4: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nQ;
				},
				student.dp)),
		a5: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nR;
				},
				student.dp)),
		a6: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nS;
				},
				student.dp)),
		a7: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ob;
				},
				student.dp)),
		a$: A2($elm$core$Maybe$withDefault, '', student.a$),
		s: $author$project$Form$fromFileUrl(profile.s),
		aE: profile.aE,
		bm: profile.bm,
		aF: profile.aF,
		E: $author$project$Form$fromFileUrl(profile.E),
		aG: student.aG,
		t: $author$project$Form$fromFileUrl(profile.t),
		aH: profile.aH,
		J: $author$project$Form$fromFileUrl(profile.J),
		aI: A2($elm$core$Maybe$withDefault, '', student.aI),
		u: $author$project$Form$fromFileUrl(profile.u),
		kf: $elm$core$String$fromInt(
			$author$project$Team$teamIdToInt(student.kf.i8)),
		aJ: profile.aJ,
		aK: profile.aK,
		aM: profile.aM
	};
};
var $author$project$Element$StudentProfileForm$fillNekForm = function (profile) {
	return {
		m: profile.m,
		b: $author$project$Form$fromFileUrl(profile.b)
	};
};
var $author$project$Element$StudentProfileForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.ah, values) && (A2($author$project$Form$isFieldValid, form.aB, values) && (A2($author$project$Form$isFieldValid, form.aj, values) && (A2($author$project$Form$isFieldValid, form.aJ, values) && (A2($author$project$Form$isFieldValid, form.aw, values) && (A2($author$project$Form$isFieldValid, form.ag, values) && (A2($author$project$Form$isFieldValid, form.an, values) && (A2($author$project$Form$isFieldValid, form.aq, values) && (A2($author$project$Form$isFieldValid, form.ao, values) && (A2($author$project$Form$isFieldValid, form.aH, values) && (A2($author$project$Form$isFieldValid, form.aK, values) && (A2($author$project$Form$isFieldValid, form.aE, values) && (A2($author$project$Form$isFieldValid, form.aM, values) && (A2($author$project$Form$isFieldValid, form.aF, values) && (A2($author$project$Form$isFieldValid, form.as, values) && (A2($author$project$Form$isFieldValid, form.fT, values) && (A2($author$project$Form$isFieldValid, form.I, values) && (A2($author$project$Form$isFieldValid, form.y, values) && (A2($author$project$Form$isFieldValid, form.A, values) && (A2($author$project$Form$isFieldValid, form.E, values) && (A2($author$project$Form$isFieldValid, form.o, values) && (A2($author$project$Form$isFieldValid, form.s, values) && (A2($author$project$Form$isFieldValid, form.q, values) && (A2($author$project$Form$isFieldValid, form.u, values) && (A2($author$project$Form$isFieldValid, form.t, values) && (A2($author$project$Form$isFieldValid, form.lI, values) && (A2($author$project$Form$isFieldValid, form.av, values) && (A2($author$project$Form$isFieldValid, form.O, values) && (A2($author$project$Form$isFieldValid, form.a$, values) && (A2($author$project$Form$isFieldValid, form.a1, values) && (A2($author$project$Form$isFieldValid, form.a2, values) && (A2($author$project$Form$isFieldValid, form.a7, values) && (A2($author$project$Form$isFieldValid, form.a4, values) && (A2($author$project$Form$isFieldValid, form.a6, values) && (A2($author$project$Form$isFieldValid, form.a5, values) && (A2($author$project$Form$isFieldValid, form.a3, values) && (A2($author$project$Form$isFieldValid, form.aR, values) && (A2($author$project$Form$isFieldValid, form.am, values) && (A2($author$project$Form$isFieldValid, form.aP, values) && (A2($author$project$Form$isFieldValid, form.aC, values) && (A2($author$project$Form$isFieldValid, form.aG, values) && (A2($author$project$Form$isFieldValid, form.ap, values) && (A2($author$project$Form$isFieldValid, form.aI, values) && (A2($author$project$Form$isFieldValid, form.kf, values) && (A2($author$project$Form$isFieldValid, form.my, values) && (A2($author$project$Form$isFieldValid, form.m, values) && A2($author$project$Form$isFieldValid, form.b, values))))))))))))))))))))))))))))))))))))))))))))));
	});
var $author$project$Element$StudentProfileForm$isNekFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.m, values) && A2($author$project$Form$isFieldValid, form.b, values);
	});
var $author$project$Log$msgAwsSignatureDownload = 'aws_signature_download';
var $author$project$Log$msgStudentProfileSave = 'student_profile_save';
var $author$project$Element$StudentProfileForm$DocumentViewerModel = $elm$core$Basics$identity;
var $author$project$Element$StudentProfileForm$DocumentViewerMsg = $elm$core$Basics$identity;
var $author$project$Element$StudentProfileForm$PopupMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$StudentProfileForm$popups = {
	d0: {
		ha: $author$project$Element$DocumentViewer$element,
		cf: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$PopupMsg, $elm$core$Basics$identity),
		kt: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						eq: $elm$core$Maybe$Just(model)
					});
			})
	}
};
var $author$project$Element$StudentProfileForm$openDocumentViewer = F3(
	function (session, model, doc) {
		return A3(
			$author$project$Application$V2$Boundaries$mapElement,
			A2($author$project$Application$Boundaries$save, model, session),
			$author$project$Element$StudentProfileForm$popups.d0,
			A5(
				$author$project$Application$V2$Boundaries$initElement,
				model.b_.jk,
				$author$project$Application$V2$SharedConfig$fromV1(model.b_),
				session,
				$author$project$Element$StudentProfileForm$popups.d0,
				{
					fa: $elm$core$Maybe$Just(doc.fa),
					K: doc.K
				}));
	});
var $author$project$Log$paramScopeStudentProfiles = 'scope_student_profiles';
var $author$project$S3$requestPolicy = F3(
	function (config, _v0, callback) {
		var scope = _v0.nx;
		var personId = _v0.m9;
		var documentType = _v0.ls;
		var mimeType = _v0.mD;
		var params = _List_fromArray(
			[
				_Utils_Tuple2('person_id', personId),
				_Utils_Tuple2('document_type', documentType),
				_Utils_Tuple2('mime_type', mimeType)
			]);
		return A3(
			$author$project$Api$get,
			A3($author$project$Api$Endpoint$awsPolicy, config, scope, params),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$S3$postPolicyDecoder));
	});
var $author$project$Api$Endpoint$awsSignature = F3(
	function (config, scope, params) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'aws-signature', scope]),
			params);
	});
var $author$project$S3$Signature = function (bucketName) {
	return function (bucketKey) {
		return function (s3RegionEndpoint) {
			return function (xAmzAlgorithm) {
				return function (xAmzCredential) {
					return function (xAmzDate) {
						return function (xAmzSignature) {
							return function (xAmzExpires) {
								return function (xAmzSignedHeaders) {
									return function (xAmzContent) {
										return function (contentType) {
											return {fO: bucketKey, fP: bucketName, g3: contentType, gz: s3RegionEndpoint, gN: xAmzAlgorithm, oo: xAmzContent, gO: xAmzCredential, gP: xAmzDate, im: xAmzExpires, gQ: xAmzSignature, kE: xAmzSignedHeaders};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$S3$getSignatureDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'content_type',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'x_amz_content_sha256',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'x_amz_signed_headers',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'x_amz_expires',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'x_amz_signature',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'x_amz_date',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'x_amz_credential',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'x_amz_algorithm',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									's3_region_endpoint',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'bucket_key',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'bucket_name',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$S3$Signature))))))))))));
var $author$project$S3$requestSignature = F3(
	function (config, _v0, callback) {
		var scope = _v0.nx;
		var documentUrl = _v0.bt;
		var params = _List_fromArray(
			[
				_Utils_Tuple2('document_url', documentUrl)
			]);
		return A3(
			$author$project$Api$get,
			A3($author$project$Api$Endpoint$awsSignature, config, scope, params),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$S3$getSignatureDecoder));
	});
var $author$project$StudentProfile$StudentProfileUnsaved = function (id) {
	return function (state) {
		return function (student) {
			return function (mothersMaidenName) {
				return function (admission) {
					return function (basicTask) {
						return function (termination) {
							return function (missedClasses) {
								return function (accidents) {
									return function (competencyTestResults) {
										return function (exams) {
											return function (disciplinaryAndCompensationCases) {
												return function (studentCardId) {
													return function (textbookSupply) {
														return function (schoolYearRepetition) {
															return function (tripAbroad) {
																return function (specialStatus) {
																	return function (isIndividualStudent) {
																		return function (currentGrade) {
																			return function (nekId) {
																				return function (firstForeignLanguage) {
																					return function (secondForeignLanguage) {
																						return function (lastReportCardUrl) {
																							return function (evaluationUrl) {
																								return function (individualStudentUrl) {
																									return function (specialStatusUrl) {
																										return function (studentCardUrl) {
																											return function (birthCertificateUrl) {
																												return function (residencePermitUrl) {
																													return function (idCardUrl) {
																														return function (taxIdUrl) {
																															return function (ssnUrl) {
																																return function (nekIdUrl) {
																																	return {ag: accidents, ah: admission, aj: basicTask, o: birthCertificateUrl, an: competencyTestResults, fT: currentGrade, ao: disciplinaryAndCompensationCases, y: evaluationUrl, aq: exams, bf: firstForeignLanguage, i8: id, q: idCardUrl, A: individualStudentUrl, as: isIndividualStudent, I: lastReportCardUrl, aw: missedClasses, aB: mothersMaidenName, m: nekId, b: nekIdUrl, s: residencePermitUrl, aE: schoolYearRepetition, bm: secondForeignLanguage, aF: specialStatus, E: specialStatusUrl, t: ssnUrl, fs: state, nT: student, aH: studentCardId, J: studentCardUrl, u: taxIdUrl, aJ: termination, aK: textbookSupply, aM: tripAbroad};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$StudentProfile$StudentUnsaved = function (id) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (phoneNumber) {
					return function (permanentAddress) {
						return function (temporaryAddress) {
							return function (birthDate) {
								return function (birthPlaceCountry) {
									return function (birthPlace) {
										return function (nationality) {
											return function (eduId) {
												return function (ssn) {
													return function (supervisingSchool) {
														return function (team) {
															return function (mentor) {
																return {aP: birthDate, am: birthPlace, aR: birthPlaceCountry, ap: eduId, O: email, lI: firstName, i8: id, av: lastName, my: mentor, aC: nationality, dp: permanentAddress, a$: phoneNumber, aG: ssn, aI: supervisingSchool, kf: team, n3: temporaryAddress};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Element$StudentProfileForm$saveForm = F3(
	function (form, values, profile) {
		var studentUnsaved = $author$project$StudentProfile$StudentUnsaved(profile.nT.i8)(
			form.lI.fC(values))(
			form.av.fC(values))(
			A2(
				$author$project$Data$toMaybe,
				$elm$core$String$isEmpty,
				form.O.fC(values)))(
			A2(
				$author$project$Data$toMaybe,
				$elm$core$String$isEmpty,
				form.a$.fC(values)))(
			$elm$core$Maybe$Just(
				A9(
					$author$project$Person$Address,
					true,
					form.a1.fC(values),
					form.a7.fC(values),
					form.a2.fC(values),
					'',
					form.a4.fC(values),
					form.a6.fC(values),
					form.a5.fC(values),
					form.a3.fC(values))))($elm$core$Maybe$Nothing)(
			A2(
				$author$project$Data$toMaybe,
				$elm$core$String$isEmpty,
				form.aP.fC(values)))(
			form.aR.fC(values))(
			A2(
				$author$project$Data$toMaybe,
				$elm$core$String$isEmpty,
				form.am.fC(values)))(
			form.aC.fC(values))(
			$elm$core$String$toInt(
				form.ap.fC(values)))(
			form.aG.fC(values))(
			A2(
				$author$project$Data$toMaybe,
				$elm$core$String$isEmpty,
				form.aI.fC(values)))(
			$author$project$Team$decodeTeamId(
				form.kf.fC(values)))(
			$elm$core$String$toInt(
				form.my.fC(values)));
		return $author$project$StudentProfile$StudentProfileUnsaved(profile.i8)(profile.fs)(studentUnsaved)(
			form.aB.fC(values))(
			form.ah.fC(values))(
			form.aj.fC(values))(
			form.aJ.fC(values))(
			form.aw.fC(values))(
			form.ag.fC(values))(
			form.an.fC(values))(
			form.aq.fC(values))(
			form.ao.fC(values))(
			form.aH.fC(values))(
			form.aK.fC(values))(
			form.aE.fC(values))(
			form.aM.fC(values))(
			form.aF.fC(values))(
			form.as.fC(values))(
			form.fT.fC(values))(
			form.m.fC(values))(
			form.bf.fC(values))(
			form.bm.fC(values))(
			$author$project$Form$toFileUrl(
				form.I.fC(values)))(
			$author$project$Form$toFileUrl(
				form.y.fC(values)))(
			$author$project$Form$toFileUrl(
				form.A.fC(values)))(
			$author$project$Form$toFileUrl(
				form.E.fC(values)))(
			$author$project$Form$toFileUrl(
				form.J.fC(values)))(
			$author$project$Form$toFileUrl(
				form.o.fC(values)))(
			$author$project$Form$toFileUrl(
				form.s.fC(values)))(
			$author$project$Form$toFileUrl(
				form.q.fC(values)))(
			$author$project$Form$toFileUrl(
				form.u.fC(values)))(
			$author$project$Form$toFileUrl(
				form.t.fC(values)))(
			$author$project$Form$toFileUrl(
				form.b.fC(values)));
	});
var $author$project$Element$StudentProfileForm$saveNekForm = F3(
	function (form, values, profile) {
		var student = profile.nT;
		return $author$project$StudentProfile$StudentProfileUnsaved(profile.i8)(profile.fs)(
			$author$project$StudentProfile$StudentUnsaved(student.i8)(student.lI)(student.av)(student.O)(student.a$)(student.dp)(student.n3)(student.aP)(student.aR)(student.am)(student.aC)(student.ap)(student.aG)(student.aI)(student.kf.i8)(
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.i8;
					},
					student.my)))(profile.aB)(profile.ah)(profile.aj)(profile.aJ)(profile.aw)(profile.ag)(profile.an)(profile.aq)(profile.ao)(profile.aH)(profile.aK)(profile.aE)(profile.aM)(profile.aF)(profile.as)(profile.fT)(
			form.m.fC(values))(profile.bf)(profile.bm)(profile.I)(profile.y)(profile.A)(profile.E)(profile.J)(profile.o)(profile.s)(profile.q)(profile.u)(profile.t)(
			$author$project$Form$toFileUrl(
				form.b.fC(values)));
	});
var $author$project$StudentProfile$studentProfileIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Element$StudentProfileForm$updateForm = F3(
	function (msg, form, formValues) {
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aB: $author$project$Form$markEdited(form.aB)
						}),
					A2(form.aB.ks, value, formValues));
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ah: $author$project$Form$markEdited(form.ah)
						}),
					A2(form.ah.ks, value, formValues));
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aj: $author$project$Form$markEdited(form.aj)
						}),
					A2(form.aj.ks, value, formValues));
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aJ: $author$project$Form$markEdited(form.aJ)
						}),
					A2(form.aJ.ks, value, formValues));
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aw: $author$project$Form$markEdited(form.aw)
						}),
					A2(form.aw.ks, value, formValues));
			case 5:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ag: $author$project$Form$markEdited(form.ag)
						}),
					A2(form.ag.ks, value, formValues));
			case 6:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							an: $author$project$Form$markEdited(form.an)
						}),
					A2(form.an.ks, value, formValues));
			case 7:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aq: $author$project$Form$markEdited(form.aq)
						}),
					A2(form.aq.ks, value, formValues));
			case 8:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ao: $author$project$Form$markEdited(form.ao)
						}),
					A2(form.ao.ks, value, formValues));
			case 9:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aH: $author$project$Form$markEdited(form.aH)
						}),
					A2(form.aH.ks, value, formValues));
			case 10:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aK: $author$project$Form$markEdited(form.aK)
						}),
					A2(form.aK.ks, value, formValues));
			case 11:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aE: $author$project$Form$markEdited(form.aE)
						}),
					A2(form.aE.ks, value, formValues));
			case 12:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aM: $author$project$Form$markEdited(form.aM)
						}),
					A2(form.aM.ks, value, formValues));
			case 13:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aF: $author$project$Form$markEdited(form.aF)
						}),
					A2(form.aF.ks, value, formValues));
			case 14:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							as: $author$project$Form$markEdited(form.as)
						}),
					A2(form.as.ks, value, formValues));
			case 15:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							fT: $author$project$Form$markEdited(form.fT)
						}),
					A2(form.fT.ks, value, formValues));
			case 16:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							m: $author$project$Form$markEdited(form.m)
						}),
					A2(form.m.ks, value, formValues));
			case 17:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							bf: $author$project$Form$markEdited(form.bf)
						}),
					A2(form.bf.ks, value, formValues));
			case 18:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							bm: $author$project$Form$markEdited(form.bm)
						}),
					A2(form.bm.ks, value, formValues));
			case 31:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							lI: $author$project$Form$markEdited(form.lI)
						}),
					A2(form.lI.ks, value, formValues));
			case 32:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							av: $author$project$Form$markEdited(form.av)
						}),
					A2(form.av.ks, value, formValues));
			case 30:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							O: $author$project$Form$markEdited(form.O)
						}),
					A2(form.O.ks, value, formValues));
			case 33:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a$: $author$project$Form$markEdited(form.a$)
						}),
					A2(form.a$.ks, value, formValues));
			case 34:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a1: $author$project$Form$markEdited(form.a1)
						}),
					A2(form.a1.ks, value, formValues));
			case 35:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a2: $author$project$Form$markEdited(form.a2)
						}),
					A2(form.a2.ks, value, formValues));
			case 36:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a7: $author$project$Form$markEdited(form.a7)
						}),
					A2(form.a7.ks, value, formValues));
			case 37:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a4: $author$project$Form$markEdited(form.a4)
						}),
					A2(form.a4.ks, value, formValues));
			case 38:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a6: $author$project$Form$markEdited(form.a6)
						}),
					A2(form.a6.ks, value, formValues));
			case 39:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a5: $author$project$Form$markEdited(form.a5)
						}),
					A2(form.a5.ks, value, formValues));
			case 40:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a3: $author$project$Form$markEdited(form.a3)
						}),
					A2(form.a3.ks, value, formValues));
			case 41:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aR: $author$project$Form$markEdited(form.aR)
						}),
					A2(form.aR.ks, value, formValues));
			case 42:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							am: $author$project$Form$markEdited(form.am)
						}),
					A2(form.am.ks, value, formValues));
			case 43:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aP: $author$project$Form$markEdited(form.aP)
						}),
					A2(form.aP.ks, value, formValues));
			case 44:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aC: $author$project$Form$markEdited(form.aC)
						}),
					A2(form.aC.ks, value, formValues));
			case 45:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aG: $author$project$Form$markEdited(form.aG)
						}),
					A2(form.aG.ks, value, formValues));
			case 46:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ap: $author$project$Form$markEdited(form.ap)
						}),
					A2(form.ap.ks, value, formValues));
			case 47:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aI: $author$project$Form$markEdited(form.aI)
						}),
					A2(form.aI.ks, value, formValues));
			case 48:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							kf: $author$project$Form$markEdited(form.kf)
						}),
					A2(form.kf.ks, value, formValues));
			case 49:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							my: $author$project$Form$markEdited(form.my)
						}),
					A2(form.my.ks, value, formValues));
			case 19:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							I: $author$project$Form$markEdited(form.I)
						}),
					A2(
						form.I.ks,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 25:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							s: $author$project$Form$markEdited(form.s)
						}),
					A2(
						form.s.ks,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 20:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							y: $author$project$Form$markEdited(form.y)
						}),
					A2(
						form.y.ks,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 22:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							E: $author$project$Form$markEdited(form.E)
						}),
					A2(
						form.E.ks,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 21:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							A: $author$project$Form$markEdited(form.A)
						}),
					A2(
						form.A.ks,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 23:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							J: $author$project$Form$markEdited(form.J)
						}),
					A2(
						form.J.ks,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 24:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							o: $author$project$Form$markEdited(form.o)
						}),
					A2(
						form.o.ks,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 26:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							q: $author$project$Form$markEdited(form.q)
						}),
					A2(
						form.q.ks,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 27:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							u: $author$project$Form$markEdited(form.u)
						}),
					A2(
						form.u.ks,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 28:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							t: $author$project$Form$markEdited(form.t)
						}),
					A2(
						form.t.ks,
						$author$project$Form$FileUploaded(location),
						formValues));
			default:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							b: $author$project$Form$markEdited(form.b)
						}),
					A2(
						form.b.ks,
						$author$project$Form$FileUploaded(location),
						formValues));
		}
	});
var $author$project$Element$StudentProfileForm$toTeacherOptions = F3(
	function (t_, student, people) {
		return A2(
			$author$project$Form$toPeopleOptions,
			t_,
			A2(
				$author$project$Person$teachersInTeams,
				_List_fromArray(
					[student.kf.i8]),
				people));
	});
var $author$project$Element$StudentProfileForm$updateMentorOptions = F4(
	function (t_, student, mentors, form) {
		if (!mentors.b) {
			return form;
		} else {
			var people = mentors;
			return _Utils_update(
				form,
				{
					my: A2(
						$author$project$Form$fillFieldOptions,
						A3($author$project$Element$StudentProfileForm$toTeacherOptions, t_, student, people),
						form.my)
				});
		}
	});
var $author$project$Element$StudentProfileForm$updateNekForm = F3(
	function (msg, form, formValues) {
		if (!msg.$) {
			var value = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					form,
					{
						m: $author$project$Form$markEdited(form.m)
					}),
				A2(form.m.ks, value, formValues));
		} else {
			var location = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					form,
					{
						b: $author$project$Form$markEdited(form.b)
					}),
				A2(
					form.b.ks,
					$author$project$Form$fromFileUrl(location),
					formValues));
		}
	});
var $author$project$Element$StudentProfileForm$updateSchoolOptions = F2(
	function (schools, form) {
		if (!schools.$) {
			if (!schools.a.b) {
				return form;
			} else {
				var schools_ = schools.a;
				return _Utils_update(
					form,
					{
						kf: A2(
							$author$project$Form$fillFieldOptions,
							$author$project$Form$toTeamOptions(schools_),
							form.kf)
					});
			}
		} else {
			return form;
		}
	});
var $author$project$StudentProfile$studentEncoder = function (student) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(student.i8)),
				_Utils_Tuple2(
				'first_name',
				$elm$json$Json$Encode$string(student.lI)),
				_Utils_Tuple2(
				'last_name',
				$elm$json$Json$Encode$string(student.av)),
				_Utils_Tuple2(
				'email',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, student.O)),
				_Utils_Tuple2(
				'phone_number',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, student.a$)),
				_Utils_Tuple2(
				'permanent_address',
				A2($author$project$Data$encodeNullable, $author$project$Person$addressEncoder, student.dp)),
				_Utils_Tuple2(
				'temporary_address',
				A2($author$project$Data$encodeNullable, $author$project$Person$addressEncoder, student.n3)),
				_Utils_Tuple2(
				'birthdate',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, student.aP)),
				_Utils_Tuple2(
				'birthplace_country',
				$elm$json$Json$Encode$string(student.aR)),
				_Utils_Tuple2(
				'birthplace',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, student.am)),
				_Utils_Tuple2(
				'nationality',
				$elm$json$Json$Encode$string(student.aC)),
				_Utils_Tuple2(
				'edu_id',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$int, student.ap)),
				_Utils_Tuple2(
				'ssn',
				$elm$json$Json$Encode$string(student.aG)),
				_Utils_Tuple2(
				'supervising_school',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, student.aI)),
				_Utils_Tuple2(
				'team',
				$elm$json$Json$Encode$int(
					$author$project$Team$teamIdToInt(student.kf))),
				_Utils_Tuple2(
				'mentor',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$int, student.my))
			]));
};
var $author$project$StudentProfile$studentProfileEncoder = function (profile) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(
					$author$project$StudentProfile$studentProfileIdToInt(profile.i8))),
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(profile.fs)),
				_Utils_Tuple2(
				'student',
				$author$project$StudentProfile$studentEncoder(profile.nT)),
				_Utils_Tuple2(
				'mothers_name',
				$elm$json$Json$Encode$string(profile.aB)),
				_Utils_Tuple2(
				'admission',
				$elm$json$Json$Encode$string(profile.ah)),
				_Utils_Tuple2(
				'basic_task',
				$elm$json$Json$Encode$string(profile.aj)),
				_Utils_Tuple2(
				'termination',
				$elm$json$Json$Encode$string(profile.aJ)),
				_Utils_Tuple2(
				'missed_classes',
				$elm$json$Json$Encode$string(profile.aw)),
				_Utils_Tuple2(
				'accidents',
				$elm$json$Json$Encode$string(profile.ag)),
				_Utils_Tuple2(
				'competency_test_results',
				$elm$json$Json$Encode$string(profile.an)),
				_Utils_Tuple2(
				'exams',
				$elm$json$Json$Encode$string(profile.aq)),
				_Utils_Tuple2(
				'disciplinary_and_compensation_cases',
				$elm$json$Json$Encode$string(profile.ao)),
				_Utils_Tuple2(
				'student_card_id',
				$elm$json$Json$Encode$string(profile.aH)),
				_Utils_Tuple2(
				'textbook_supply',
				$elm$json$Json$Encode$string(profile.aK)),
				_Utils_Tuple2(
				'school_year_repetition',
				$elm$json$Json$Encode$string(profile.aE)),
				_Utils_Tuple2(
				'trip_abroad',
				$elm$json$Json$Encode$string(profile.aM)),
				_Utils_Tuple2(
				'sni_status',
				$elm$json$Json$Encode$string(profile.aF)),
				_Utils_Tuple2(
				'is_individual_student',
				$elm$json$Json$Encode$bool(profile.as)),
				_Utils_Tuple2(
				'current_grade',
				$elm$json$Json$Encode$string(profile.fT)),
				_Utils_Tuple2(
				'nek_id',
				$elm$json$Json$Encode$string(profile.m)),
				_Utils_Tuple2(
				'first_foreign_language',
				$elm$json$Json$Encode$string(profile.bf)),
				_Utils_Tuple2(
				'second_foreign_language',
				$elm$json$Json$Encode$string(profile.bm)),
				_Utils_Tuple2(
				'last_report_card_url',
				$elm$json$Json$Encode$string(profile.I)),
				_Utils_Tuple2(
				'evaluation_url',
				$elm$json$Json$Encode$string(profile.y)),
				_Utils_Tuple2(
				'individual_student_url',
				$elm$json$Json$Encode$string(profile.A)),
				_Utils_Tuple2(
				'sni_report_url',
				$elm$json$Json$Encode$string(profile.E)),
				_Utils_Tuple2(
				'student_card_url',
				$elm$json$Json$Encode$string(profile.J)),
				_Utils_Tuple2(
				'birth_certificate_url',
				$elm$json$Json$Encode$string(profile.o)),
				_Utils_Tuple2(
				'residence_permit_url',
				$elm$json$Json$Encode$string(profile.s)),
				_Utils_Tuple2(
				'id_card_url',
				$elm$json$Json$Encode$string(profile.q)),
				_Utils_Tuple2(
				'tax_id_url',
				$elm$json$Json$Encode$string(profile.u)),
				_Utils_Tuple2(
				'ssn_url',
				$elm$json$Json$Encode$string(profile.t)),
				_Utils_Tuple2(
				'nek_id_url',
				$elm$json$Json$Encode$string(profile.b))
			]));
};
var $author$project$StudentProfile$updateStudentProfile = F3(
	function (config, profile, callback) {
		return A5(
			$author$project$Api$put,
			A2($author$project$Api$Endpoint$studentProfile, config, profile.nT.i8),
			config,
			$elm$http$Http$jsonBody(
				$author$project$StudentProfile$studentProfileEncoder(profile)),
			callback,
			$author$project$StudentProfile$studentProfileDecoder);
	});
var $author$project$Api$postExpectingHeaders = F4(
	function (url, config, body, toMsg) {
		return $author$project$Api$Endpoint$request(
			{
				T: body,
				bd: $author$project$Api$expectHeaders(toMsg),
				ar: $author$project$Api$toHeaders(config),
				bj: 'POST',
				bp: $elm$core$Maybe$Nothing,
				bq: $elm$core$Maybe$Nothing,
				K: url
			});
	});
var $author$project$S3$uploadFile = F4(
	function (config, postPolicy, file, callback) {
		return A4(
			$author$project$Api$postExpectingHeaders,
			$author$project$S3$s3Endpoint(postPolicy),
			config,
			A2($author$project$S3$makeFormData, postPolicy, file),
			callback);
	});
var $author$project$Element$StudentProfileForm$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			ag: $author$project$Form$markEdited(form.ag),
			ah: $author$project$Form$markEdited(form.ah),
			aj: $author$project$Form$markEdited(form.aj),
			o: $author$project$Form$markEdited(form.o),
			aP: $author$project$Form$markEdited(form.aP),
			am: $author$project$Form$markEdited(form.am),
			aR: $author$project$Form$markEdited(form.aR),
			an: $author$project$Form$markEdited(form.an),
			fT: $author$project$Form$markEdited(form.fT),
			ao: $author$project$Form$markEdited(form.ao),
			ap: $author$project$Form$markEdited(form.ap),
			O: $author$project$Form$markEdited(form.O),
			y: $author$project$Form$markEdited(form.y),
			aq: $author$project$Form$markEdited(form.aq),
			lI: $author$project$Form$markEdited(form.lI),
			q: $author$project$Form$markEdited(form.q),
			A: $author$project$Form$markEdited(form.A),
			as: $author$project$Form$markEdited(form.as),
			av: $author$project$Form$markEdited(form.av),
			I: $author$project$Form$markEdited(form.I),
			my: $author$project$Form$markEdited(form.my),
			aw: $author$project$Form$markEdited(form.aw),
			aB: $author$project$Form$markEdited(form.aB),
			aC: $author$project$Form$markEdited(form.aC),
			m: $author$project$Form$markEdited(form.m),
			b: $author$project$Form$markEdited(form.b),
			a1: $author$project$Form$markEdited(form.a1),
			a2: $author$project$Form$markEdited(form.a2),
			a3: $author$project$Form$markEdited(form.a3),
			a4: $author$project$Form$markEdited(form.a4),
			a5: $author$project$Form$markEdited(form.a5),
			a6: $author$project$Form$markEdited(form.a6),
			a7: $author$project$Form$markEdited(form.a7),
			a$: $author$project$Form$markEdited(form.a$),
			s: $author$project$Form$markEdited(form.s),
			aE: $author$project$Form$markEdited(form.aE),
			aF: $author$project$Form$markEdited(form.aF),
			E: $author$project$Form$markEdited(form.E),
			aG: $author$project$Form$markEdited(form.aG),
			t: $author$project$Form$markEdited(form.t),
			aH: $author$project$Form$markEdited(form.aH),
			J: $author$project$Form$markEdited(form.J),
			aI: $author$project$Form$markEdited(form.aI),
			u: $author$project$Form$markEdited(form.u),
			kf: $author$project$Form$markEdited(form.kf),
			aJ: $author$project$Form$markEdited(form.aJ),
			aK: $author$project$Form$markEdited(form.aK),
			aM: $author$project$Form$markEdited(form.aM)
		});
};
var $author$project$Element$StudentProfileForm$validateNekForm = function (form) {
	return _Utils_update(
		form,
		{
			m: $author$project$Form$markEdited(form.m),
			b: $author$project$Form$markEdited(form.b)
		});
};
var $author$project$Element$StudentProfileForm$update = F3(
	function (session, msg, model) {
		update:
		while (true) {
			var viewer = session.ok;
			var config = model.b_;
			var _v0 = _Utils_Tuple2(msg, model.bk);
			_v0$127:
			while (true) {
				switch (_v0.a.$) {
					case 9:
						var popupMsg = _v0.a.a;
						var _v1 = _Utils_Tuple2(popupMsg, model.eq);
						if (!_v1.b.$) {
							var documentViewerMsg = _v1.a;
							var documentViewerModel = _v1.b.a;
							var _return = A5($author$project$Application$V2$Boundaries$updateElement, config.jk, session, documentViewerMsg, documentViewerModel, $author$project$Element$StudentProfileForm$popups.d0);
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{eq: $elm$core$Maybe$Nothing}),
								_return.gB);
						} else {
							return A2($author$project$Application$Boundaries$save, model, session);
						}
					case 15:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gX,
									{bt: documentUrl, nx: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$BirthCertificateSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 16:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.i8))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.h6($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 21:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gX,
									{bt: documentUrl, nx: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$ResidencePermitSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 22:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.i8))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.h6($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 27:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gX,
									{bt: documentUrl, nx: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$SsnSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 28:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.i8))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.h6($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 33:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gX,
									{bt: documentUrl, nx: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$StudentCardSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 34:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.i8))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.h6($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 39:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gX,
									{bt: documentUrl, nx: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$IdCardSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 40:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.i8))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.h6($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 45:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gX,
									{bt: documentUrl, nx: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$TaxIdSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 46:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.i8))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.h6($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 51:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gX,
									{bt: documentUrl, nx: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$SpecialStatusReportSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 52:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.i8))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.h6($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 57:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gX,
									{bt: documentUrl, nx: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$LastReportCardSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 58:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.i8))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.h6($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 63:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gX,
									{bt: documentUrl, nx: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$IndividualStudentSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 64:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.i8))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.h6($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 69:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gX,
									{bt: documentUrl, nx: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$EvaluationSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 70:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.i8))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.h6($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 65:
						if (_v0.b.$ === 3) {
							var _v2 = _v0.a;
							var fieldMsg = _v2.a;
							var documentType = _v2.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$EvaluationFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 66:
						if (_v0.b.$ === 3) {
							var _v3 = _v0.a;
							var fieldMsg = _v3.a;
							var documentType = _v3.b;
							var file = _v3.c;
							var formPage = _v0.b.a;
							var form = formPage.bE;
							var values = formPage.eI;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.y.ks,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.y.ks,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								ls: documentType,
								mD: $elm$file$File$mime(file),
								m9: $elm$core$String$fromInt(profile.nT.i8),
								nx: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.y, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													y: $author$project$Form$markEdited(form.y)
												}),
											eI: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gX,
										params,
										A2($author$project$Element$StudentProfileForm$EvaluationPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										session));
							} else {
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bk: $author$project$Element$StudentProfileForm$FormPage(
													_Utils_update(
														formPage,
														{eI: valuesWithFileError}))
											}),
										session));
							}
						} else {
							break _v0$127;
						}
					case 67:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v4 = _v0.a;
								var fieldMsg = _v4.a;
								var file = _v4.b;
								var policy = _v4.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gX,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$EvaluationFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v5 = _v0.a;
								var error = _v5.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.y.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 68:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v6 = _v0.a;
								var fieldMsg = _v6.a;
								var file = _v6.b;
								var metadata = _v6.c.a;
								var _v7 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ar);
								if (!_v7.$) {
									var location = _v7.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$EvaluationFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v8 = _v0.a;
								var error = _v8.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.y.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 53:
						if (_v0.b.$ === 3) {
							var _v9 = _v0.a;
							var fieldMsg = _v9.a;
							var documentType = _v9.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$LastReportCardFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 54:
						if (_v0.b.$ === 3) {
							var _v10 = _v0.a;
							var fieldMsg = _v10.a;
							var documentType = _v10.b;
							var file = _v10.c;
							var formPage = _v0.b.a;
							var form = formPage.bE;
							var values = formPage.eI;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.I.ks,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.I.ks,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								ls: documentType,
								mD: $elm$file$File$mime(file),
								m9: $elm$core$String$fromInt(profile.nT.i8),
								nx: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.I, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													I: $author$project$Form$markEdited(form.I)
												}),
											eI: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gX,
										params,
										A2($author$project$Element$StudentProfileForm$LastReportCardPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										session));
							} else {
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bk: $author$project$Element$StudentProfileForm$FormPage(
													_Utils_update(
														formPage,
														{eI: valuesWithFileError}))
											}),
										session));
							}
						} else {
							break _v0$127;
						}
					case 55:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v11 = _v0.a;
								var fieldMsg = _v11.a;
								var file = _v11.b;
								var policy = _v11.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gX,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$LastReportCardUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v12 = _v0.a;
								var error = _v12.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.I.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 56:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v13 = _v0.a;
								var fieldMsg = _v13.a;
								var file = _v13.b;
								var metadata = _v13.c.a;
								var _v14 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ar);
								if (!_v14.$) {
									var location = _v14.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$LastReportCardUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v15 = _v0.a;
								var error = _v15.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.I.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 59:
						if (_v0.b.$ === 3) {
							var _v16 = _v0.a;
							var fieldMsg = _v16.a;
							var documentType = _v16.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$IndividualStudentFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 60:
						if (_v0.b.$ === 3) {
							var _v17 = _v0.a;
							var fieldMsg = _v17.a;
							var documentType = _v17.b;
							var file = _v17.c;
							var formPage = _v0.b.a;
							var form = formPage.bE;
							var values = formPage.eI;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.A.ks,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.A.ks,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								ls: documentType,
								mD: $elm$file$File$mime(file),
								m9: $elm$core$String$fromInt(profile.nT.i8),
								nx: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.A, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													A: $author$project$Form$markEdited(form.A)
												}),
											eI: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gX,
										params,
										A2($author$project$Element$StudentProfileForm$IndividualStudentPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										session));
							} else {
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bk: $author$project$Element$StudentProfileForm$FormPage(
													_Utils_update(
														formPage,
														{eI: valuesWithFileError}))
											}),
										session));
							}
						} else {
							break _v0$127;
						}
					case 61:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v18 = _v0.a;
								var fieldMsg = _v18.a;
								var file = _v18.b;
								var policy = _v18.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gX,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$IndividualStudentFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v19 = _v0.a;
								var error = _v19.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.A.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 62:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v20 = _v0.a;
								var fieldMsg = _v20.a;
								var file = _v20.b;
								var metadata = _v20.c.a;
								var _v21 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ar);
								if (!_v21.$) {
									var location = _v21.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$IndividualStudentFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v22 = _v0.a;
								var error = _v22.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.A.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 47:
						if (_v0.b.$ === 3) {
							var _v23 = _v0.a;
							var fieldMsg = _v23.a;
							var documentType = _v23.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$SpecialStatusFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 48:
						if (_v0.b.$ === 3) {
							var _v24 = _v0.a;
							var fieldMsg = _v24.a;
							var documentType = _v24.b;
							var file = _v24.c;
							var formPage = _v0.b.a;
							var form = formPage.bE;
							var values = formPage.eI;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.E.ks,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.E.ks,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								ls: documentType,
								mD: $elm$file$File$mime(file),
								m9: $elm$core$String$fromInt(profile.nT.i8),
								nx: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.E, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													E: $author$project$Form$markEdited(form.E)
												}),
											eI: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gX,
										params,
										A2($author$project$Element$StudentProfileForm$SpecialStatusReportPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										session));
							} else {
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bk: $author$project$Element$StudentProfileForm$FormPage(
													_Utils_update(
														formPage,
														{eI: valuesWithFileError}))
											}),
										session));
							}
						} else {
							break _v0$127;
						}
					case 49:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v25 = _v0.a;
								var fieldMsg = _v25.a;
								var file = _v25.b;
								var policy = _v25.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gX,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$SpecialStatusFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v26 = _v0.a;
								var error = _v26.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.E.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 50:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v27 = _v0.a;
								var fieldMsg = _v27.a;
								var file = _v27.b;
								var metadata = _v27.c.a;
								var _v28 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ar);
								if (!_v28.$) {
									var location = _v28.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$SpecialStatusFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v29 = _v0.a;
								var error = _v29.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.E.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 29:
						if (_v0.b.$ === 3) {
							var _v30 = _v0.a;
							var fieldMsg = _v30.a;
							var documentType = _v30.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$StudentCardFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 30:
						if (_v0.b.$ === 3) {
							var _v31 = _v0.a;
							var fieldMsg = _v31.a;
							var documentType = _v31.b;
							var file = _v31.c;
							var formPage = _v0.b.a;
							var form = formPage.bE;
							var values = formPage.eI;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.J.ks,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.J.ks,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								ls: documentType,
								mD: $elm$file$File$mime(file),
								m9: $elm$core$String$fromInt(profile.nT.i8),
								nx: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.J, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													J: $author$project$Form$markEdited(form.J)
												}),
											eI: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gX,
										params,
										A2($author$project$Element$StudentProfileForm$StudentCardPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										session));
							} else {
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bk: $author$project$Element$StudentProfileForm$FormPage(
													_Utils_update(
														formPage,
														{eI: valuesWithFileError}))
											}),
										session));
							}
						} else {
							break _v0$127;
						}
					case 31:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v32 = _v0.a;
								var fieldMsg = _v32.a;
								var file = _v32.b;
								var policy = _v32.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gX,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$StudentCardFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v33 = _v0.a;
								var error = _v33.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.J.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 32:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v34 = _v0.a;
								var fieldMsg = _v34.a;
								var file = _v34.b;
								var metadata = _v34.c.a;
								var _v35 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ar);
								if (!_v35.$) {
									var location = _v35.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$StudentCardFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v36 = _v0.a;
								var error = _v36.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.J.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 11:
						if (_v0.b.$ === 3) {
							var _v37 = _v0.a;
							var fieldMsg = _v37.a;
							var documentType = _v37.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$BirthCertificateFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 12:
						if (_v0.b.$ === 3) {
							var _v38 = _v0.a;
							var fieldMsg = _v38.a;
							var documentType = _v38.b;
							var file = _v38.c;
							var formPage = _v0.b.a;
							var form = formPage.bE;
							var values = formPage.eI;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.o.ks,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.o.ks,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								ls: documentType,
								mD: $elm$file$File$mime(file),
								m9: $elm$core$String$fromInt(profile.nT.i8),
								nx: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.o, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													o: $author$project$Form$markEdited(form.o)
												}),
											eI: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gX,
										params,
										A2($author$project$Element$StudentProfileForm$BirthCertificatePolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										session));
							} else {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													o: $author$project$Form$markEdited(form.o)
												}),
											eI: valuesWithFileError
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										session));
							}
						} else {
							break _v0$127;
						}
					case 13:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v39 = _v0.a;
								var fieldMsg = _v39.a;
								var file = _v39.b;
								var policy = _v39.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gX,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$BirthCertificateFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v40 = _v0.a;
								var error = _v40.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.o.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 14:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v41 = _v0.a;
								var fieldMsg = _v41.a;
								var file = _v41.b;
								var metadata = _v41.c.a;
								var _v42 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ar);
								if (!_v42.$) {
									var location = _v42.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$BirthCertificateFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v43 = _v0.a;
								var error = _v43.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.o.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 17:
						if (_v0.b.$ === 3) {
							var _v44 = _v0.a;
							var fieldMsg = _v44.a;
							var documentType = _v44.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$ResidencePermitFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 18:
						if (_v0.b.$ === 3) {
							var _v45 = _v0.a;
							var fieldMsg = _v45.a;
							var documentType = _v45.b;
							var file = _v45.c;
							var formPage = _v0.b.a;
							var form = formPage.bE;
							var values = formPage.eI;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.s.ks,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.s.ks,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								ls: documentType,
								mD: $elm$file$File$mime(file),
								m9: $elm$core$String$fromInt(profile.nT.i8),
								nx: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.s, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													s: $author$project$Form$markEdited(form.s)
												}),
											eI: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gX,
										params,
										A2($author$project$Element$StudentProfileForm$ResidencePermitPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										session));
							} else {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													s: $author$project$Form$markEdited(form.s)
												}),
											eI: valuesWithFileError
										}));
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{bk: page}),
									session);
							}
						} else {
							break _v0$127;
						}
					case 19:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v46 = _v0.a;
								var fieldMsg = _v46.a;
								var file = _v46.b;
								var policy = _v46.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gX,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$ResidencePermitFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v47 = _v0.a;
								var error = _v47.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.s.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 20:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v48 = _v0.a;
								var fieldMsg = _v48.a;
								var file = _v48.b;
								var metadata = _v48.c.a;
								var _v49 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ar);
								if (!_v49.$) {
									var location = _v49.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$ResidencePermitFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v50 = _v0.a;
								var error = _v50.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.s.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 35:
						if (_v0.b.$ === 3) {
							var _v51 = _v0.a;
							var fieldMsg = _v51.a;
							var documentType = _v51.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$IdCardFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 36:
						if (_v0.b.$ === 3) {
							var _v52 = _v0.a;
							var fieldMsg = _v52.a;
							var documentType = _v52.b;
							var file = _v52.c;
							var formPage = _v0.b.a;
							var form = formPage.bE;
							var values = formPage.eI;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.q.ks,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.q.ks,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								ls: documentType,
								mD: $elm$file$File$mime(file),
								m9: $elm$core$String$fromInt(profile.nT.i8),
								nx: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.q, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													q: $author$project$Form$markEdited(form.q)
												}),
											eI: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gX,
										params,
										A2($author$project$Element$StudentProfileForm$IdCardPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										session));
							} else {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													q: $author$project$Form$markEdited(form.q)
												}),
											eI: valuesWithFileError
										}));
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{bk: page}),
									session);
							}
						} else {
							break _v0$127;
						}
					case 37:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v53 = _v0.a;
								var fieldMsg = _v53.a;
								var file = _v53.b;
								var policy = _v53.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gX,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$IdCardFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v54 = _v0.a;
								var error = _v54.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.q.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 38:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v55 = _v0.a;
								var fieldMsg = _v55.a;
								var file = _v55.b;
								var metadata = _v55.c.a;
								var _v56 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ar);
								if (!_v56.$) {
									var location = _v56.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$IdCardFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v57 = _v0.a;
								var error = _v57.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.q.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 41:
						if (_v0.b.$ === 3) {
							var _v58 = _v0.a;
							var fieldMsg = _v58.a;
							var documentType = _v58.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$TaxIdFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 42:
						if (_v0.b.$ === 3) {
							var _v59 = _v0.a;
							var fieldMsg = _v59.a;
							var documentType = _v59.b;
							var file = _v59.c;
							var formPage = _v0.b.a;
							var form = formPage.bE;
							var values = formPage.eI;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.u.ks,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.u.ks,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								ls: documentType,
								mD: $elm$file$File$mime(file),
								m9: $elm$core$String$fromInt(profile.nT.i8),
								nx: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.u, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													u: $author$project$Form$markEdited(form.u)
												}),
											eI: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gX,
										params,
										A2($author$project$Element$StudentProfileForm$TaxIdPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										session));
							} else {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													u: $author$project$Form$markEdited(form.u)
												}),
											eI: valuesWithFileError
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										session));
							}
						} else {
							break _v0$127;
						}
					case 43:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v60 = _v0.a;
								var fieldMsg = _v60.a;
								var file = _v60.b;
								var policy = _v60.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gX,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$TaxIdFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v61 = _v0.a;
								var error = _v61.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.u.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 44:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v62 = _v0.a;
								var fieldMsg = _v62.a;
								var file = _v62.b;
								var metadata = _v62.c.a;
								var _v63 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ar);
								if (!_v63.$) {
									var location = _v63.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$TaxIdFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v64 = _v0.a;
								var error = _v64.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.u.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 23:
						if (_v0.b.$ === 3) {
							var _v65 = _v0.a;
							var fieldMsg = _v65.a;
							var documentType = _v65.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$SsnFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 24:
						if (_v0.b.$ === 3) {
							var _v66 = _v0.a;
							var fieldMsg = _v66.a;
							var documentType = _v66.b;
							var file = _v66.c;
							var formPage = _v0.b.a;
							var form = formPage.bE;
							var values = formPage.eI;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.t.ks,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.t.ks,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								ls: documentType,
								mD: $elm$file$File$mime(file),
								m9: $elm$core$String$fromInt(profile.nT.i8),
								nx: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.t, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													t: $author$project$Form$markEdited(form.t)
												}),
											eI: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gX,
										params,
										A2($author$project$Element$StudentProfileForm$SsnPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										session));
							} else {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													t: $author$project$Form$markEdited(form.t)
												}),
											eI: valuesWithFileError
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										session));
							}
						} else {
							break _v0$127;
						}
					case 25:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v67 = _v0.a;
								var fieldMsg = _v67.a;
								var file = _v67.b;
								var policy = _v67.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gX,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$SsnFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v68 = _v0.a;
								var error = _v68.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.t.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 26:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v69 = _v0.a;
								var fieldMsg = _v69.a;
								var file = _v69.b;
								var metadata = _v69.c.a;
								var _v70 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ar);
								if (!_v70.$) {
									var location = _v70.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$SsnFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v71 = _v0.a;
								var error = _v71.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.h6($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													eI: A2(form.t.ks, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 75:
						switch (_v0.b.$) {
							case 3:
								var documentUrl = _v0.a.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestSignature,
										config.gX,
										{bt: documentUrl, nx: $author$project$Element$StudentProfileForm$awsPolicyScope},
										$author$project$Element$StudentProfileForm$NekIdSignatureDownloaded),
									A2($author$project$Application$Boundaries$save, model, session));
							case 4:
								var documentUrl = _v0.a.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestSignature,
										config.gX,
										{bt: documentUrl, nx: $author$project$Element$StudentProfileForm$awsPolicyScope},
										$author$project$Element$StudentProfileForm$NekIdSignatureDownloaded),
									A2($author$project$Application$Boundaries$save, model, session));
							default:
								break _v0$127;
						}
					case 76:
						if (!_v0.a.a.$) {
							switch (_v0.b.$) {
								case 3:
									var signature = _v0.a.a.a;
									return A3(
										$author$project$Element$StudentProfileForm$openDocumentViewer,
										session,
										model,
										$author$project$S3$document(signature));
								case 4:
									var signature = _v0.a.a.a;
									return A3(
										$author$project$Element$StudentProfileForm$openDocumentViewer,
										session,
										model,
										$author$project$S3$document(signature));
								default:
									break _v0$127;
							}
						} else {
							switch (_v0.b.$) {
								case 3:
									var error = _v0.a.a.a;
									var profile = _v0.b.a.j;
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A3(
											$author$project$Log$error,
											config,
											_Utils_Tuple3(
												$author$project$Log$msgAwsSignatureDownload,
												$elm$core$Maybe$Just(
													$elm$core$String$fromInt(
														$author$project$StudentProfile$studentProfileIdToInt(profile.i8))),
												error),
											$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
										A2(
											$author$project$Application$Boundaries$save,
											model,
											A3(
												$author$project$Session$error,
												session,
												error,
												session.h6($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
								case 4:
									var error = _v0.a.a.a;
									var profile = _v0.b.a.j;
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A3(
											$author$project$Log$error,
											config,
											_Utils_Tuple3(
												$author$project$Log$msgAwsSignatureDownload,
												$elm$core$Maybe$Just(
													$elm$core$String$fromInt(
														$author$project$StudentProfile$studentProfileIdToInt(profile.i8))),
												error),
											$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
										A2(
											$author$project$Application$Boundaries$save,
											model,
											A3(
												$author$project$Session$error,
												session,
												error,
												session.h6($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
								default:
									break _v0$127;
							}
						}
					case 71:
						switch (_v0.b.$) {
							case 3:
								var _v72 = _v0.a;
								var fieldMsg = _v72.a;
								var documentType = _v72.b;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A2(
										$elm$file$File$Select$file,
										$author$project$Element$StudentProfileForm$acceptedMimeTypes,
										A2($author$project$Element$StudentProfileForm$NekIdFileSelected, fieldMsg, documentType)),
									A2($author$project$Application$Boundaries$save, model, session));
							case 4:
								var _v79 = _v0.a;
								var fieldMsg = _v79.a;
								var documentType = _v79.b;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A2(
										$elm$file$File$Select$file,
										$author$project$Element$StudentProfileForm$acceptedMimeTypes,
										A2($author$project$Element$StudentProfileForm$NekIdFileSelected, fieldMsg, documentType)),
									A2($author$project$Application$Boundaries$save, model, session));
							default:
								break _v0$127;
						}
					case 72:
						switch (_v0.b.$) {
							case 3:
								var _v73 = _v0.a;
								var fieldMsg = _v73.a;
								var documentType = _v73.b;
								var file = _v73.c;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var profile = formPage.j;
								var valuesWithFileSelected = A2(
									form.b.ks,
									$author$project$Form$FileSelected(file),
									values);
								var valuesWithFileError = A2(
									form.b.ks,
									$author$project$Form$InvalidFile(file),
									values);
								var params = {
									ls: documentType,
									mD: $elm$file$File$mime(file),
									m9: $elm$core$String$fromInt(profile.nT.i8),
									nx: $author$project$Element$StudentProfileForm$awsPolicyScope
								};
								if (A2($author$project$Form$isFieldValid, form.b, valuesWithFileSelected)) {
									var page = $author$project$Element$StudentProfileForm$FormPage(
										_Utils_update(
											formPage,
											{
												bE: _Utils_update(
													form,
													{
														b: $author$project$Form$markEdited(form.b)
													}),
												eI: valuesWithFileSelected
											}));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A3(
											$author$project$S3$requestPolicy,
											config.gX,
											params,
											A2($author$project$Element$StudentProfileForm$NekIdPolicyDownloaded, fieldMsg, file)),
										A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{bk: page}),
											session));
								} else {
									var page = $author$project$Element$StudentProfileForm$FormPage(
										_Utils_update(
											formPage,
											{
												bE: _Utils_update(
													form,
													{
														b: $author$project$Form$markEdited(form.b)
													}),
												eI: valuesWithFileError
											}));
									return A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										session);
								}
							case 4:
								var _v80 = _v0.a;
								var fieldMsg = _v80.a;
								var documentType = _v80.b;
								var file = _v80.c;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var profile = formPage.j;
								var valuesWithFileSelected = A2(
									form.b.ks,
									$author$project$Form$FileSelected(file),
									values);
								var valuesWithFileError = A2(
									form.b.ks,
									$author$project$Form$InvalidFile(file),
									values);
								var params = {
									ls: documentType,
									mD: $elm$file$File$mime(file),
									m9: $elm$core$String$fromInt(profile.nT.i8),
									nx: $author$project$Element$StudentProfileForm$awsPolicyScope
								};
								if (A2($author$project$Form$isFieldValid, form.b, valuesWithFileSelected)) {
									var page = $author$project$Element$StudentProfileForm$NekFormPage(
										_Utils_update(
											formPage,
											{
												bE: _Utils_update(
													form,
													{
														b: $author$project$Form$markEdited(form.b)
													}),
												eI: valuesWithFileSelected
											}));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A3(
											$author$project$S3$requestPolicy,
											config.gX,
											params,
											A2($author$project$Element$StudentProfileForm$NekIdPolicyDownloaded, fieldMsg, file)),
										A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{bk: page}),
											session));
								} else {
									var page = $author$project$Element$StudentProfileForm$NekFormPage(
										_Utils_update(
											formPage,
											{
												bE: _Utils_update(
													form,
													{
														b: $author$project$Form$markEdited(form.b)
													}),
												eI: valuesWithFileError
											}));
									return A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										session);
								}
							default:
								break _v0$127;
						}
					case 73:
						if (!_v0.a.c.$) {
							switch (_v0.b.$) {
								case 3:
									var _v74 = _v0.a;
									var fieldMsg = _v74.a;
									var file = _v74.b;
									var policy = _v74.c.a;
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A4(
											$author$project$S3$uploadFile,
											config.gX,
											policy,
											file,
											A2($author$project$Element$StudentProfileForm$NekIdFileUploaded, fieldMsg, file)),
										A2($author$project$Application$Boundaries$save, model, session));
								case 4:
									var _v81 = _v0.a;
									var fieldMsg = _v81.a;
									var file = _v81.b;
									var policy = _v81.c.a;
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A4(
											$author$project$S3$uploadFile,
											config.gX,
											policy,
											file,
											A2($author$project$Element$StudentProfileForm$NekIdFileUploaded, fieldMsg, file)),
										A2($author$project$Application$Boundaries$save, model, session));
								default:
									break _v0$127;
							}
						} else {
							switch (_v0.b.$) {
								case 3:
									var _v75 = _v0.a;
									var error = _v75.c.a;
									var formPage = _v0.b.a;
									var form = formPage.bE;
									var values = formPage.eI;
									var session2 = A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$FormFileUploadError));
									var model2 = _Utils_update(
										model,
										{
											bk: $author$project$Element$StudentProfileForm$FormPage(
												_Utils_update(
													formPage,
													{
														eI: A2(form.b.ks, $author$project$Form$NoFile, values)
													}))
										});
									var cmd = A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										cmd,
										A2($author$project$Application$Boundaries$save, model2, session2));
								case 4:
									var _v82 = _v0.a;
									var error = _v82.c.a;
									var formPage = _v0.b.a;
									var form = formPage.bE;
									var values = formPage.eI;
									var session2 = A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$FormFileUploadError));
									var model2 = _Utils_update(
										model,
										{
											bk: $author$project$Element$StudentProfileForm$NekFormPage(
												_Utils_update(
													formPage,
													{
														eI: A2(form.b.ks, $author$project$Form$NoFile, values)
													}))
										});
									var cmd = A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										cmd,
										A2($author$project$Application$Boundaries$save, model2, session2));
								default:
									break _v0$127;
							}
						}
					case 74:
						if (!_v0.a.c.$) {
							switch (_v0.b.$) {
								case 3:
									var _v76 = _v0.a;
									var fieldMsg = _v76.a;
									var file = _v76.b;
									var metadata = _v76.c.a;
									var _v77 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ar);
									if (!_v77.$) {
										var location = _v77.a;
										var $temp$session = session,
											$temp$msg = fieldMsg(location),
											$temp$model = model;
										session = $temp$session;
										msg = $temp$msg;
										model = $temp$model;
										continue update;
									} else {
										var $temp$session = session,
											$temp$msg = A3(
											$author$project$Element$StudentProfileForm$NekIdFileUploaded,
											fieldMsg,
											file,
											$elm$core$Result$Err(
												$author$project$Api$BadHeader(metadata))),
											$temp$model = model;
										session = $temp$session;
										msg = $temp$msg;
										model = $temp$model;
										continue update;
									}
								case 4:
									var _v83 = _v0.a;
									var fieldMsg = _v83.a;
									var file = _v83.b;
									var metadata = _v83.c.a;
									var _v84 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ar);
									if (!_v84.$) {
										var location = _v84.a;
										var $temp$session = session,
											$temp$msg = fieldMsg(location),
											$temp$model = model;
										session = $temp$session;
										msg = $temp$msg;
										model = $temp$model;
										continue update;
									} else {
										var $temp$session = session,
											$temp$msg = A3(
											$author$project$Element$StudentProfileForm$NekIdFileUploaded,
											fieldMsg,
											file,
											$elm$core$Result$Err(
												$author$project$Api$BadHeader(metadata))),
											$temp$model = model;
										session = $temp$session;
										msg = $temp$msg;
										model = $temp$model;
										continue update;
									}
								default:
									break _v0$127;
							}
						} else {
							switch (_v0.b.$) {
								case 3:
									var _v78 = _v0.a;
									var error = _v78.c.a;
									var formPage = _v0.b.a;
									var form = formPage.bE;
									var values = formPage.eI;
									var session2 = A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$FormFileUploadError));
									var model2 = _Utils_update(
										model,
										{
											bk: $author$project$Element$StudentProfileForm$FormPage(
												_Utils_update(
													formPage,
													{
														eI: A2(form.b.ks, $author$project$Form$NoFile, values)
													}))
										});
									var cmd = A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgFileUpload,
											$elm$core$Maybe$Just('student_profiles'),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										cmd,
										A2($author$project$Application$Boundaries$save, model2, session2));
								case 4:
									var _v85 = _v0.a;
									var error = _v85.c.a;
									var formPage = _v0.b.a;
									var form = formPage.bE;
									var values = formPage.eI;
									var session2 = A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$FormFileUploadError));
									var model2 = _Utils_update(
										model,
										{
											bk: $author$project$Element$StudentProfileForm$NekFormPage(
												_Utils_update(
													formPage,
													{
														eI: A2(form.b.ks, $author$project$Form$NoFile, values)
													}))
										});
									var cmd = A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgFileUpload,
											$elm$core$Maybe$Just('student_profiles'),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										cmd,
										A2($author$project$Application$Boundaries$save, model2, session2));
								default:
									break _v0$127;
							}
						}
					case 3:
						var id = _v0.a.a;
						var model2 = _Utils_update(
							model,
							{
								bk: $author$project$Element$StudentProfileForm$LoadingPage(id),
								j2: $author$project$RemoteData$Loading
							});
						var cmd = $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3($author$project$StudentProfile$fetchStudentProfile, config.gX, id, $author$project$Element$StudentProfileForm$StudentProfileDownloaded),
									A2($author$project$Team$fetchSchools, config.gX, $author$project$Element$StudentProfileForm$SchoolListDownloaded),
									$author$project$ACL$canManageStudentAdminData(viewer) ? A2($author$project$Person$fetchPhoneBook, config.gX, $author$project$Element$StudentProfileForm$PhoneBookDownloaded) : $elm$core$Platform$Cmd$none
								]));
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							cmd,
							A2($author$project$Application$Boundaries$save, model2, session));
					case 4:
						var id = _v0.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3($author$project$StudentProfile$fetchStudentProfile, config.gX, id, $author$project$Element$StudentProfileForm$StudentProfileDownloaded),
							A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bk: $author$project$Element$StudentProfileForm$LoadingNekPage(id)
									}),
								session));
					case 6:
						if (!_v0.a.a.$) {
							switch (_v0.b.$) {
								case 1:
									var profile = _v0.a.a.a;
									var studentId = _v0.b.a;
									if (_Utils_eq(profile.nT.i8, studentId)) {
										var form = A4(
											$author$project$Element$StudentProfileForm$updateMentorOptions,
											session.h6,
											profile.nT,
											model.gn,
											A2(
												$author$project$Element$StudentProfileForm$updateSchoolOptions,
												$author$project$RemoteData$toMaybe(model.j2),
												$author$project$Element$StudentProfileForm$buildForm(session.h6)));
										var page = $author$project$Element$StudentProfileForm$FormPage(
											{
												bE: form,
												j: profile,
												fs: 0,
												eI: $author$project$Element$StudentProfileForm$fillForm(profile)
											});
										return A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{bk: page}),
											session);
									} else {
										return A2($author$project$Application$Boundaries$save, model, session);
									}
								case 2:
									var profile = _v0.a.a.a;
									var studentId = _v0.b.a;
									if (_Utils_eq(profile.nT.i8, studentId)) {
										var page = $author$project$Element$StudentProfileForm$NekFormPage(
											{
												bE: $author$project$Element$StudentProfileForm$buildNekForm(session.h6),
												j: profile,
												fs: 0,
												eI: $author$project$Element$StudentProfileForm$fillNekForm(profile)
											});
										return A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{bk: page}),
											session);
									} else {
										return A2($author$project$Application$Boundaries$save, model, session);
									}
								default:
									break _v0$127;
							}
						} else {
							var error = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgStudentProfileDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$StudentProfileFormDownloadError))));
						}
					case 7:
						var data = _v0.a.a;
						var page = _v0.b;
						var model2 = _Utils_update(
							model,
							{j2: data});
						var _v86 = _Utils_Tuple2(data, page);
						_v86$2:
						while (true) {
							switch (_v86.a.$) {
								case 2:
									if (_v86.b.$ === 3) {
										var schools = _v86.a.a;
										var formPage = _v86.b.a;
										var form = formPage.bE;
										var form2 = A2(
											$author$project$Element$StudentProfileForm$updateSchoolOptions,
											$elm$core$Maybe$Just(schools),
											form);
										var page2 = $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{bE: form2}));
										return A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model2,
												{bk: page2}),
											session);
									} else {
										break _v86$2;
									}
								case 3:
									var error = _v86.a.a;
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A3(
											$author$project$Log$error,
											config,
											_Utils_Tuple3($author$project$Log$msgTeamsDownload, $elm$core$Maybe$Nothing, error),
											$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
										A2(
											$author$project$Application$Boundaries$save,
											model2,
											A3(
												$author$project$Session$error,
												session,
												error,
												session.h6($author$project$Locale$Messages$TeamListDownloadError))));
								default:
									break _v86$2;
							}
						}
						return A2($author$project$Application$Boundaries$save, model2, session);
					case 8:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var phonebook = _v0.a.a.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var profile = formPage.j;
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: A4($author$project$Element$StudentProfileForm$updateMentorOptions, session.h6, profile.nT, phonebook, form)
										}));
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{bk: page, gn: phonebook}),
									session);
							} else {
								var phonebook = _v0.a.a.a;
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{gn: phonebook}),
									session);
							}
						} else {
							var error = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgPeopleDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeStudentProfiles),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$PhoneBookDownloadError))));
						}
					case 0:
						if (_v0.b.$ === 3) {
							var fieldMsg = _v0.a.a;
							var formPage = _v0.b.a;
							var _v87 = A3($author$project$Element$StudentProfileForm$updateForm, fieldMsg, formPage.bE, formPage.eI);
							var form2 = _v87.a;
							var values2 = _v87.b;
							var page = $author$project$Element$StudentProfileForm$FormPage(
								_Utils_update(
									formPage,
									{bE: form2, fs: 1, eI: values2}));
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{bk: page}),
								session);
						} else {
							break _v0$127;
						}
					case 1:
						if (_v0.b.$ === 4) {
							var fieldMsg = _v0.a.a;
							var formPage = _v0.b.a;
							var _v89 = A3($author$project$Element$StudentProfileForm$updateNekForm, fieldMsg, formPage.bE, formPage.eI);
							var form2 = _v89.a;
							var values2 = _v89.b;
							var page = $author$project$Element$StudentProfileForm$NekFormPage(
								_Utils_update(
									formPage,
									{bE: form2, fs: 1, eI: values2}));
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{bk: page}),
								session);
						} else {
							break _v0$127;
						}
					case 2:
						switch (_v0.b.$) {
							case 3:
								var _v88 = _v0.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var profile = formPage.j;
								if (A2($author$project$Element$StudentProfileForm$isFormValid, form, values)) {
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A3(
											$author$project$StudentProfile$updateStudentProfile,
											config.gX,
											A3($author$project$Element$StudentProfileForm$saveForm, form, values, profile),
											$author$project$Element$StudentProfileForm$ProfileSaved),
										A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{
													bk: $author$project$Element$StudentProfileForm$FormPage(
														_Utils_update(
															formPage,
															{fs: 2}))
												}),
											session));
								} else {
									var page = $author$project$Element$StudentProfileForm$FormPage(
										_Utils_update(
											formPage,
											{
												bE: $author$project$Element$StudentProfileForm$validateForm(form),
												fs: 1
											}));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										$author$project$Ports$scrollToFormError,
										A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{bk: page}),
											session));
								}
							case 4:
								var _v90 = _v0.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var profile = formPage.j;
								if (A2($author$project$Element$StudentProfileForm$isNekFormValid, form, values)) {
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A3(
											$author$project$StudentProfile$updateStudentProfile,
											config.gX,
											A3($author$project$Element$StudentProfileForm$saveNekForm, form, values, profile),
											$author$project$Element$StudentProfileForm$ProfileSaved),
										A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{
													bk: $author$project$Element$StudentProfileForm$NekFormPage(
														_Utils_update(
															formPage,
															{fs: 2}))
												}),
											session));
								} else {
									var page = $author$project$Element$StudentProfileForm$NekFormPage(
										_Utils_update(
											formPage,
											{
												bE: $author$project$Element$StudentProfileForm$validateNekForm(form),
												fs: 1
											}));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										$author$project$Ports$scrollToFormError,
										A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{bk: page}),
											session));
								}
							default:
								break _v0$127;
						}
					case 5:
						if (!_v0.a.a.$) {
							switch (_v0.b.$) {
								case 3:
									var formPage = _v0.b.a;
									return A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bk: $author$project$Element$StudentProfileForm$FormPage(
													_Utils_update(
														formPage,
														{fs: 0}))
											}),
										A2(
											$author$project$Session$ok,
											session,
											session.h6($author$project$Locale$Messages$StudentProfileFormSaveSuccess)));
								case 4:
									var formPage = _v0.b.a;
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										$elm$core$Platform$Cmd$none,
										A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{
													bk: $author$project$Element$StudentProfileForm$NekFormPage(
														_Utils_update(
															formPage,
															{fs: 0}))
												}),
											A2(
												$author$project$Session$ok,
												session,
												session.h6($author$project$Locale$Messages$StudentProfileFormSaveSuccess))));
								default:
									break _v0$127;
							}
						} else {
							switch (_v0.b.$) {
								case 3:
									var error = _v0.a.a.a;
									var formPage = _v0.b.a;
									var session2 = A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$FormSaveError));
									var model2 = _Utils_update(
										model,
										{
											bk: $author$project$Element$StudentProfileForm$FormPage(
												_Utils_update(
													formPage,
													{fs: 3}))
										});
									var cmd = A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3($author$project$Log$msgStudentProfileSave, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										cmd,
										A2($author$project$Application$Boundaries$save, model2, session2));
								case 4:
									var error = _v0.a.a.a;
									var formPage = _v0.b.a;
									var session2 = A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$FormSaveError));
									var model2 = _Utils_update(
										model,
										{
											bk: $author$project$Element$StudentProfileForm$NekFormPage(
												_Utils_update(
													formPage,
													{fs: 3}))
										});
									var cmd = A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3($author$project$Log$msgStudentProfileSave, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										cmd,
										A2($author$project$Application$Boundaries$save, model2, session2));
								default:
									break _v0$127;
							}
						}
					default:
						var _v91 = _v0.a;
						return A2($author$project$Application$Boundaries$save, model, session);
				}
			}
			return A2($author$project$Application$Boundaries$save, model, session);
		}
	});
var $author$project$Locale$Messages$StudentProfileFormLoadingProgress = {$: 538};
var $author$project$Locale$Messages$StudentProfileFormNotFound = {$: 539};
var $author$project$Element$StudentProfileForm$BirthCertificateFileDownloadRequested = function (a) {
	return {$: 15, a: a};
};
var $author$project$Element$StudentProfileForm$BirthCertificateFileUploadRequested = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$EvaluationFileDownloadRequested = function (a) {
	return {$: 69, a: a};
};
var $author$project$Element$StudentProfileForm$EvaluationFileUploadRequested = F2(
	function (a, b) {
		return {$: 65, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$FormPageSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$StudentProfileForm$FormSubmitted = {$: 2};
var $author$project$Element$StudentProfileForm$IdCardFileDownloadRequested = function (a) {
	return {$: 39, a: a};
};
var $author$project$Element$StudentProfileForm$IdCardFileUploadRequested = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$IndividualStudentFileDownloadRequested = function (a) {
	return {$: 63, a: a};
};
var $author$project$Element$StudentProfileForm$IndividualStudentFileUploadRequested = F2(
	function (a, b) {
		return {$: 59, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$LastReportCardFileDownloadRequested = function (a) {
	return {$: 57, a: a};
};
var $author$project$Element$StudentProfileForm$LastReportCardFileUploadRequested = F2(
	function (a, b) {
		return {$: 53, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$NekIdFileDownloadRequested = function (a) {
	return {$: 75, a: a};
};
var $author$project$Element$StudentProfileForm$NekIdFileUploadRequested = F2(
	function (a, b) {
		return {$: 71, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$ResidencePermitFileDownloadRequested = function (a) {
	return {$: 21, a: a};
};
var $author$project$Element$StudentProfileForm$ResidencePermitFileUploadRequested = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$SpecialStatusFileDownloadRequested = function (a) {
	return {$: 51, a: a};
};
var $author$project$Element$StudentProfileForm$SpecialStatusFileUploadRequested = F2(
	function (a, b) {
		return {$: 47, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$SsnFileDownloadRequested = function (a) {
	return {$: 27, a: a};
};
var $author$project$Element$StudentProfileForm$SsnFileUploadRequested = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$StudentCardFileDownloadRequested = function (a) {
	return {$: 33, a: a};
};
var $author$project$Element$StudentProfileForm$StudentCardFileUploadRequested = F2(
	function (a, b) {
		return {$: 29, a: a, b: b};
	});
var $author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp = {$: 529};
var $author$project$Locale$Messages$StudentProfileFormHeadingSchool = {$: 537};
var $author$project$Locale$Messages$StudentProfileFormHeadingSponsor = {$: 536};
var $author$project$Locale$Messages$StudentProfileFormRequiredIfStudentGoesToSchool = {$: 520};
var $author$project$Locale$Messages$StudentProfileFormSpecialStatusHelp = {$: 510};
var $author$project$Locale$Messages$StudentProfileFormTitle = function (a) {
	return {$: 535, a: a};
};
var $author$project$Element$StudentProfileForm$TaxIdFileDownloadRequested = function (a) {
	return {$: 45, a: a};
};
var $author$project$Element$StudentProfileForm$TaxIdFileUploadRequested = F2(
	function (a, b) {
		return {$: 41, a: a, b: b};
	});
var $author$project$UI$frozenChoiceField = $author$project$UI$choiceField_(false);
var $author$project$UI$toggleField = F3(
	function (_v0, field, values) {
		var on = field.fC(values);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('checkbox')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									field.og.fe(!on)),
									$elm$html$Html$Attributes$type_('checkbox'),
									$author$project$UI$attrCyData(field.og.cm),
									$elm$html$Html$Attributes$checked(on)
								]),
							_List_Nil),
							$elm$html$Html$text(field.og.ea)
						]))
				]));
	});
var $author$project$Locale$Messages$StudentProfileFormSponsors = function (a) {
	return {$: 525, a: a};
};
var $author$project$Element$StudentProfileForm$viewSponsors = F2(
	function (t_, sponsors) {
		var viewSponsorLink = function (person) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$author$project$Route$href(
						$author$project$Route$GenericProfileUpdate(person.i8))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Person$fullName, t_, person))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('label')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UI$caption,
							t_,
							$author$project$Locale$Messages$StudentProfileFormSponsors(
								$elm$core$List$length(sponsors)))
						])),
					A2(
					$author$project$UI$level,
					A2($elm$core$List$map, viewSponsorLink, sponsors),
					_List_Nil)
				]));
	});
var $author$project$Element$StudentProfileForm$viewForm = F4(
	function (t_, language, viewer, _v0) {
		var state = _v0.fs;
		var form = _v0.bE;
		var values = _v0.eI;
		var profile = _v0.j;
		var heading = function (caption) {
			return A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('heading has-background-light')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('has-text-info')
							]),
						_List_fromArray(
							[
								$author$project$UI$Icon$profile(
								_List_fromArray(
									[
										$author$project$UI$Icon$face('fa-lg'),
										$author$project$UI$Icon$style('is-medium')
									]))
							])),
						caption
					]));
		};
		var viewFormFieldsAdmin = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth')
				]),
			_List_fromArray(
				[
					$author$project$UI$columns(
					_List_fromArray(
						[
							heading(
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentProfileFormHeadingSchool))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.my, values),
							A3($author$project$UI$choiceField, t_, form.aj, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.kf, values),
							A3($author$project$UI$textField, t_, form.aI, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$frozenChoiceField, t_, form.fT, values),
							A3($author$project$UI$textField, t_, form.aw, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.bf, values),
							A3($author$project$UI$choiceField, t_, form.bm, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.m, values),
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.b, values, $author$project$Element$StudentProfileForm$NekIdFileUploadRequested, $author$project$Element$StudentProfileForm$NekIdFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.aJ, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.ag, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.an, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.y, values, $author$project$Element$StudentProfileForm$EvaluationFileUploadRequested, $author$project$Element$StudentProfileForm$EvaluationFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.aq, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.ah, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.ao, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.aK, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.aE, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.aM, values)
						]))
				]));
		var viewFormFieldsBasics = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth')
				]),
			_List_fromArray(
				[
					$author$project$UI$columns(
					_List_fromArray(
						[
							heading(
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentProfileFormHeadingSponsor))
						])),
					$author$project$UI$columns(
					language.l4 ? _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.lI, values),
							A3($author$project$UI$textField, t_, form.av, values)
						]) : _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.av, values),
							A3($author$project$UI$textField, t_, form.lI, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$staticTextField, t_, form.O, values),
							A3($author$project$UI$textField, t_, form.a$, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.aR, values),
							A3($author$project$UI$textField, t_, form.am, values),
							A3($author$project$UI$dateField, t_, form.aP, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.aB, values),
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.o, values, $author$project$Element$StudentProfileForm$BirthCertificateFileUploadRequested, $author$project$Element$StudentProfileForm$BirthCertificateFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.aC, values),
							$author$project$UI$none
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('heading')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PersonAddress)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.a1, values),
							A3($author$project$UI$textField, t_, form.a7, values),
							A3($author$project$UI$textField, t_, form.a2, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.a4, values),
							A3($author$project$UI$textField, t_, form.a6, values),
							A3($author$project$UI$textField, t_, form.a5, values),
							A3($author$project$UI$textField, t_, form.a3, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.s, values, $author$project$Element$StudentProfileForm$ResidencePermitFileUploadRequested, $author$project$Element$StudentProfileForm$ResidencePermitFileDownloadRequested)),
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.q, values, $author$project$Element$StudentProfileForm$IdCardFileUploadRequested, $author$project$Element$StudentProfileForm$IdCardFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.aG, values),
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.t, values, $author$project$Element$StudentProfileForm$SsnFileUploadRequested, $author$project$Element$StudentProfileForm$SsnFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.ap, values),
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.u, values, $author$project$Element$StudentProfileForm$TaxIdFileUploadRequested, $author$project$Element$StudentProfileForm$TaxIdFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.aH, values),
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.J, values, $author$project$Element$StudentProfileForm$StudentCardFileUploadRequested, $author$project$Element$StudentProfileForm$StudentCardFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							$author$project$UI$none,
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A6(
								$author$project$UI$fileField_,
								t_,
								form.I,
								$elm$core$Maybe$Just($author$project$Locale$Messages$StudentProfileFormRequiredIfStudentGoesToSchool),
								values,
								$author$project$Element$StudentProfileForm$LastReportCardFileUploadRequested,
								$author$project$Element$StudentProfileForm$LastReportCardFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormSpecialStatusHelp,
							A3($author$project$UI$choiceField, t_, form.aF, values)),
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.E, values, $author$project$Element$StudentProfileForm$SpecialStatusFileUploadRequested, $author$project$Element$StudentProfileForm$SpecialStatusFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$toggleField, t_, form.as, values),
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.A, values, $author$project$Element$StudentProfileForm$IndividualStudentFileUploadRequested, $author$project$Element$StudentProfileForm$IndividualStudentFileDownloadRequested))
						]))
				]));
		var formState = (A2($author$project$Form$isUploading, form.y, values) || (A2($author$project$Form$isUploading, form.A, values) || (A2($author$project$Form$isUploading, form.E, values) || (A2($author$project$Form$isUploading, form.J, values) || (A2($author$project$Form$isUploading, form.o, values) || (A2($author$project$Form$isUploading, form.s, values) || (A2($author$project$Form$isUploading, form.q, values) || (A2($author$project$Form$isUploading, form.u, values) || A2($author$project$Form$isUploading, form.t, values))))))))) ? 2 : state;
		return $author$project$UI$panel(
			{
				g$: _List_fromArray(
					[
						A2($author$project$Element$StudentProfileForm$viewSponsors, t_, profile.nT.nM),
						viewFormFieldsBasics,
						A2(
						$author$project$UI$when,
						$author$project$ACL$canManageStudentAdminData(viewer),
						viewFormFieldsAdmin),
						A5(
						$author$project$UI$formButtons,
						t_,
						$author$project$Form$Update(profile),
						formState,
						$author$project$Element$StudentProfileForm$FormSubmitted,
						function (profile_) {
							return $author$project$Element$StudentProfileForm$FormPageSelected(profile_.nT.i8);
						})
					]),
				cm: 'student-profile-form',
				hl: _List_fromArray(
					[
						A2(
						$author$project$UI$caption,
						t_,
						$author$project$Locale$Messages$StudentProfileFormTitle(
							A2($author$project$Person$fullName, t_, profile.nT)))
					]),
				h7: _List_Nil,
				ie: 'is-light'
			});
	});
var $author$project$Element$StudentProfileForm$NekFormPageSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$StudentProfileForm$viewNekForm = F2(
	function (t_, _v0) {
		var state = _v0.fs;
		var form = _v0.bE;
		var values = _v0.eI;
		var profile = _v0.j;
		var formState = A2($author$project$Form$isUploading, form.b, values) ? 2 : state;
		return $author$project$UI$panel(
			{
				g$: _List_fromArray(
					[
						$author$project$UI$columns(
						_List_fromArray(
							[
								A3($author$project$UI$textField, t_, form.m, values),
								A4(
								$author$project$UI$withInfoText,
								_List_Nil,
								t_,
								$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
								A5($author$project$UI$fileField, t_, form.b, values, $author$project$Element$StudentProfileForm$NekIdFileUploadRequested, $author$project$Element$StudentProfileForm$NekIdFileDownloadRequested))
							])),
						A5(
						$author$project$UI$formButtons,
						t_,
						$author$project$Form$Update(profile),
						formState,
						$author$project$Element$StudentProfileForm$FormSubmitted,
						function (profile_) {
							return $author$project$Element$StudentProfileForm$NekFormPageSelected(profile_.nT.i8);
						})
					]),
				cm: 'nek-form',
				hl: _List_fromArray(
					[
						A2(
						$author$project$UI$caption,
						t_,
						$author$project$Locale$Messages$StudentProfileFormTitle(
							A2($author$project$Person$fullName, t_, profile.nT)))
					]),
				h7: _List_Nil,
				ie: 'is-light'
			});
	});
var $author$project$Element$StudentProfileForm$viewPopup = F2(
	function (session, model) {
		var popupModel = model;
		return A3($author$project$Application$V2$Boundaries$viewElement, session, popupModel, $author$project$Element$StudentProfileForm$popups.d0);
	});
var $author$project$Element$StudentProfileForm$view = F2(
	function (session, model) {
		var t_ = session.h6;
		var _v0 = model.bk;
		switch (_v0.$) {
			case 3:
				var formPage = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$maybe,
							model.eq,
							$author$project$Element$StudentProfileForm$viewPopup(session)),
							A4($author$project$Element$StudentProfileForm$viewForm, t_, session.mn, session.ok, formPage)
						]));
			case 4:
				var formPage = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$maybe,
							model.eq,
							$author$project$Element$StudentProfileForm$viewPopup(session)),
							A2($author$project$Element$StudentProfileForm$viewNekForm, t_, formPage)
						]));
			case 1:
				return A2(
					$author$project$UI$progressBar,
					'is-primary',
					t_($author$project$Locale$Messages$StudentProfileFormLoadingProgress));
			case 2:
				return A2(
					$author$project$UI$progressBar,
					'is-link',
					t_($author$project$Locale$Messages$StudentProfileFormLoadingProgress));
			default:
				return $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentProfileFormNotFound)
						]));
		}
	});
var $author$project$Element$StudentProfileForm$element = {jb: $author$project$Element$StudentProfileForm$init, ks: $author$project$Element$StudentProfileForm$update, og: $author$project$Element$StudentProfileForm$view};
var $author$project$Element$SubjectFeedbackList$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$SubjectFeedbackList$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$SubjectFeedbackList$FetchLearningAssessments = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$SubjectFeedbackList$LearningAssessmentListDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$SubjectFeedbackList$LoadingPage = {$: 1};
var $author$project$Element$SubjectFeedbackList$NotFoundPage = {$: 0};
var $author$project$Element$SubjectFeedbackList$init = F3(
	function (config, session, _v0) {
		var studentId = _v0.dE;
		var subjectId = _v0.nW;
		var grade = _v0.W;
		var midYear = _v0.mB;
		var model = {b_: config, mB: midYear, bk: $author$project$Element$SubjectFeedbackList$NotFoundPage, ca: grade, cb: studentId, bU: subjectId, gB: session, fw: false, dG: $author$project$RemoteData$Loading, kb: $author$project$RemoteData$Loading};
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{bk: $author$project$Element$SubjectFeedbackList$LoadingPage}),
			$author$project$Element$SubjectFeedbackList$BatchEffect(
				_List_fromArray(
					[
						$author$project$Element$SubjectFeedbackList$Cmd(
						$author$project$Element$SubjectFeedbackList$FetchLearningAssessments(
							A3($author$project$LearningAssessment$fetchLearningAssessmentsByPerson2, config.gX, studentId, $author$project$Element$SubjectFeedbackList$LearningAssessmentListDownloaded)))
					])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$SubjectFeedbackList$updateFilterUrl = F5(
	function (key, selectedStudentId, selectedSubjectId, grade, midYear) {
		return A2(
			$author$project$Route$replaceUrl,
			key,
			A2(
				$author$project$Route$SubjectFeedbackList,
				selectedStudentId,
				{
					W: grade,
					mB: $elm$core$Maybe$Just(midYear),
					gE: selectedSubjectId
				}));
	});
var $author$project$Element$SubjectFeedbackList$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$SubjectFeedbackList$perform(key),
						effects));
			case 2:
				var cmd = effect.a;
				switch (cmd.$) {
					case 0:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 2:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 3:
						var studentId = cmd.a;
						var maybeSubjectId = cmd.b;
						var maybeGrade = cmd.c;
						var midYear = cmd.d;
						return A5($author$project$Element$SubjectFeedbackList$updateFilterUrl, key, studentId, maybeSubjectId, maybeGrade, midYear);
					case 4:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					default:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
				}
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Element$SubjectFeedbackList$FetchSubjectFeedbacks = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$SubjectFeedbackList$FetchSubjectList = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$SubjectFeedbackList$ListPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$SubjectFeedbackList$LogError = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$SubjectFeedbackList$NoEffect = {$: 0};
var $author$project$Element$SubjectFeedbackList$NoOp = {$: 7};
var $author$project$Locale$Messages$SubjectFeedbacksDownloadError = {$: 564};
var $author$project$Element$SubjectFeedbackList$SubjectFeedbacksDownloaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$SubjectFeedbackList$SubjectListDownloaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$SubjectFeedbackList$UpdateFilterUrl = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $author$project$Api$Endpoint$peopleSubjectFeedbackList = F5(
	function (config, personId, subjectId, grade, midYear) {
		var queryParams = A3(
			$author$project$Api$Endpoint$optional,
			$author$project$Api$Endpoint$stringFromBool,
			_Utils_Tuple2(
				'mid_year',
				$elm$core$Maybe$Just(midYear)),
			A3(
				$author$project$Api$Endpoint$optional,
				$elm$core$Basics$identity,
				_Utils_Tuple2('grade', grade),
				A3(
					$author$project$Api$Endpoint$optional,
					$elm$core$String$fromInt,
					_Utils_Tuple2('subject', subjectId),
					_List_Nil)));
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'people',
					$elm$core$String$fromInt(personId),
					'subject-feedbacks'
				]),
			queryParams);
	});
var $author$project$SubjectFeedback$SubjectFeedbackPayload = F4(
	function (student, studentProfile, subject, feedbacks) {
		return {lH: feedbacks, nT: student, h5: studentProfile, gE: subject};
	});
var $author$project$SubjectFeedback$SubjectFeedback = F9(
	function (feedbackType, feedbackId, feedbackUrl, baseFeedbackId, createdAt, updatedAt, createdBy, relatedModule, assessment) {
		return {cj: assessment, k2: baseFeedbackId, g4: createdAt, lf: createdBy, lE: feedbackId, lF: feedbackType, lG: feedbackUrl, ng: relatedModule, of: updatedAt};
	});
var $author$project$SubjectFeedback$subjectFeedbackDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rubric_assessment',
	$author$project$Rubric$rubricAssessmentDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'related_module',
		$elm$json$Json$Decode$maybe($author$project$Module$nestedModuleDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_by',
			$author$project$Person$nestedPersonDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'updated_at',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_at',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'base_feedback_id',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'feedback_url',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'feedback_id',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'feedback_type',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$SubjectFeedback$SubjectFeedback))))))))));
var $author$project$SubjectFeedback$subjectFeedbackListDecoder = $elm$json$Json$Decode$list($author$project$SubjectFeedback$subjectFeedbackDecoder);
var $author$project$SubjectFeedback$subjectFeedbackPayloadDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'feedbacks',
	$author$project$SubjectFeedback$subjectFeedbackListDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'subject',
		$elm$json$Json$Decode$maybe($author$project$Subject$subjectDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'student_profile',
			$author$project$StudentProfile$studentProfileDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'student',
				$author$project$Person$nestedPersonDecoder,
				$elm$json$Json$Decode$succeed($author$project$SubjectFeedback$SubjectFeedbackPayload)))));
var $author$project$SubjectFeedback$fetchSubjectFeedbacks = F6(
	function (config, personId, subjectId, grade, midYear, callback) {
		return {
			b_: config,
			d_: $author$project$SubjectFeedback$subjectFeedbackPayloadDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A5($author$project$Api$Endpoint$peopleSubjectFeedbackList, config, personId, subjectId, grade, midYear)
		};
	});
var $author$project$Api$Endpoint$subjectsByGrade = F2(
	function (config, grade) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'subjects']),
			A3(
				$author$project$Api$Endpoint$optional,
				$elm$core$Basics$identity,
				_Utils_Tuple2('grade', grade),
				_List_fromArray(
					[
						_Utils_Tuple2('cat', 'student')
					])));
	});
var $author$project$Subject$fetchSubjectsByGradeV2 = F3(
	function (config, grade, callback) {
		return {
			b_: config,
			d_: $author$project$Subject$subjectsDecoder,
			cf: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			K: A2($author$project$Api$Endpoint$subjectsByGrade, config, grade)
		};
	});
var $author$project$Element$SubjectFeedbackList$compareTab = F2(
	function (left, right) {
		return A2($elm$core$Basics$compare, left.eB, right.eB);
	});
var $author$project$Element$SubjectFeedbackList$learningAssessmentToTab = function (la) {
	var startYear = A2(
		$elm$time$Time$toYear,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(la.nN));
	var endYear = A2(
		$elm$time$Time$toYear,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(la.ly));
	return {
		d3: _Utils_eq(startYear, endYear) ? (endYear + 1) : endYear,
		W: la.W,
		eB: startYear
	};
};
var $author$project$Element$SubjectFeedbackList$makeTabs = function (learningAssessments) {
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$sortWith,
			$author$project$Element$SubjectFeedbackList$compareTab,
			A2(
				$elm_community$list_extra$List$Extra$uniqueBy,
				function ($) {
					return $.eB;
				},
				A2($elm$core$List$map, $author$project$Element$SubjectFeedbackList$learningAssessmentToTab, learningAssessments))));
};
var $author$project$Log$msgSubjectFeedbacksDownload = 'subject_feedbacks_download';
var $author$project$Log$paramScopeSubjectFeedbackList = 'scope_subject_feedback_list';
var $author$project$Element$SubjectFeedbackList$update = F2(
	function (msg, model) {
		var config = model.b_;
		var session = model.gB;
		var _v0 = _Utils_Tuple2(msg, model.bk);
		_v0$7:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var result = _v0.a.a;
					switch (result.$) {
						case 2:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{dG: result}),
								$author$project$Element$SubjectFeedbackList$NoEffect,
								$elm$core$Maybe$Nothing);
						case 1:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{dG: result}),
								$author$project$Element$SubjectFeedbackList$NoEffect,
								$elm$core$Maybe$Nothing);
						case 0:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{dG: result}),
								$author$project$Element$SubjectFeedbackList$NoEffect,
								$elm$core$Maybe$Nothing);
						default:
							var error = result.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										gB: A3(
											$author$project$Session$error,
											model.gB,
											error,
											model.gB.h6($author$project$Locale$Messages$SubjectFeedbacksDownloadError)),
										dG: result
									}),
								$author$project$Element$SubjectFeedbackList$Cmd(
									$author$project$Element$SubjectFeedbackList$LogError(
										A3(
											$author$project$Log$errorV2,
											model.b_,
											_Utils_Tuple3(
												$author$project$Log$msgSubjectFeedbacksDownload,
												$elm$core$Maybe$Just($author$project$Log$paramScopeSubjectFeedbackList),
												error),
											$elm$core$Basics$always($author$project$Element$SubjectFeedbackList$NoOp)))),
								$elm$core$Maybe$Nothing);
					}
				case 2:
					var result = _v0.a.a;
					switch (result.$) {
						case 2:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{kb: result}),
								$author$project$Element$SubjectFeedbackList$NoEffect,
								$elm$core$Maybe$Nothing);
						case 1:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{kb: result}),
								$author$project$Element$SubjectFeedbackList$NoEffect,
								$elm$core$Maybe$Nothing);
						case 0:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{kb: result}),
								$author$project$Element$SubjectFeedbackList$NoEffect,
								$elm$core$Maybe$Nothing);
						default:
							var error = result.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										gB: A3(
											$author$project$Session$error,
											model.gB,
											error,
											model.gB.h6($author$project$Locale$Messages$SubjectListDownloadError)),
										kb: result
									}),
								$author$project$Element$SubjectFeedbackList$Cmd(
									$author$project$Element$SubjectFeedbackList$LogError(
										A3(
											$author$project$Log$errorV2,
											model.b_,
											_Utils_Tuple3(
												$author$project$Log$msgSubjectListDownload,
												$elm$core$Maybe$Just($author$project$Log$paramScopeSubjectFeedbackList),
												error),
											$elm$core$Basics$always($author$project$Element$SubjectFeedbackList$NoOp)))),
								$elm$core$Maybe$Nothing);
					}
				case 1:
					if (_v0.b.$ === 1) {
						var data = _v0.a.a;
						var _v3 = _v0.b;
						switch (data.$) {
							case 2:
								var learningAssessments_ = data.a;
								var tabs = $author$project$Element$SubjectFeedbackList$makeTabs(learningAssessments_);
								var selectedGrade = function () {
									var _v5 = model.ca;
									if (!_v5.$) {
										var grade = _v5.a;
										return $elm$core$Maybe$Just(grade);
									} else {
										return A2(
											$elm$core$Maybe$map,
											function (la) {
												return la.W;
											},
											$elm$core$List$head(
												$elm$core$List$reverse(learningAssessments_)));
									}
								}();
								var selectedTab = $elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (tab) {
											return _Utils_eq(
												$elm$core$Maybe$Just(tab.W),
												selectedGrade);
										},
										tabs));
								var page = $author$project$Element$SubjectFeedbackList$ListPage(
									{cd: selectedTab, gG: tabs});
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{bk: page, ca: selectedGrade}),
									$author$project$Element$SubjectFeedbackList$BatchEffect(
										_List_fromArray(
											[
												$author$project$Element$SubjectFeedbackList$Cmd(
												$author$project$Element$SubjectFeedbackList$FetchSubjectFeedbacks(
													A6($author$project$SubjectFeedback$fetchSubjectFeedbacks, config.gX, model.cb, model.bU, selectedGrade, model.mB, $author$project$Element$SubjectFeedbackList$SubjectFeedbacksDownloaded))),
												$author$project$Element$SubjectFeedbackList$Cmd(
												$author$project$Element$SubjectFeedbackList$FetchSubjectList(
													A3($author$project$Subject$fetchSubjectsByGradeV2, config.gX, selectedGrade, $author$project$Element$SubjectFeedbackList$SubjectListDownloaded)))
											])),
									$elm$core$Maybe$Nothing);
							case 3:
								var error = data.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											gB: A3(
												$author$project$Session$error,
												session,
												error,
												session.h6($author$project$Locale$Messages$LearningAssessmentsDownloadError))
										}),
									$author$project$Element$SubjectFeedbackList$Cmd(
										$author$project$Element$SubjectFeedbackList$LogError(
											A3(
												$author$project$Log$errorV2,
												config,
												_Utils_Tuple3(
													$author$project$Log$msgLearningAssessmentsDownload,
													$elm$core$Maybe$Just($author$project$Log$paramScopeGradeRequest),
													error),
												$elm$core$Basics$always($author$project$Element$SubjectFeedbackList$NoOp)))),
									$elm$core$Maybe$Nothing);
							case 1:
								return _Utils_Tuple3(model, $author$project$Element$SubjectFeedbackList$NoEffect, $elm$core$Maybe$Nothing);
							default:
								return _Utils_Tuple3(model, $author$project$Element$SubjectFeedbackList$NoEffect, $elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$7;
					}
				case 3:
					var maybeSubjectId = _v0.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bU: maybeSubjectId}),
						$author$project$Element$SubjectFeedbackList$BatchEffect(
							_List_fromArray(
								[
									$author$project$Element$SubjectFeedbackList$Cmd(
									$author$project$Element$SubjectFeedbackList$FetchSubjectFeedbacks(
										A6($author$project$SubjectFeedback$fetchSubjectFeedbacks, model.b_.gX, model.cb, maybeSubjectId, model.ca, model.mB, $author$project$Element$SubjectFeedbackList$SubjectFeedbacksDownloaded))),
									$author$project$Element$SubjectFeedbackList$Cmd(
									A4($author$project$Element$SubjectFeedbackList$UpdateFilterUrl, model.cb, maybeSubjectId, model.ca, model.mB))
								])),
						$elm$core$Maybe$Nothing);
				case 4:
					var midYear = _v0.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{mB: midYear}),
						$author$project$Element$SubjectFeedbackList$BatchEffect(
							_List_fromArray(
								[
									$author$project$Element$SubjectFeedbackList$Cmd(
									$author$project$Element$SubjectFeedbackList$FetchSubjectFeedbacks(
										A6($author$project$SubjectFeedback$fetchSubjectFeedbacks, model.b_.gX, model.cb, model.bU, model.ca, midYear, $author$project$Element$SubjectFeedbackList$SubjectFeedbacksDownloaded))),
									$author$project$Element$SubjectFeedbackList$Cmd(
									A4($author$project$Element$SubjectFeedbackList$UpdateFilterUrl, model.cb, model.bU, model.ca, midYear))
								])),
						$elm$core$Maybe$Nothing);
				case 5:
					if (_v0.b.$ === 2) {
						var tab = _v0.a.a;
						var listPageModel = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bk: $author$project$Element$SubjectFeedbackList$ListPage(
										_Utils_update(
											listPageModel,
											{
												cd: $elm$core$Maybe$Just(tab)
											})),
									ca: $elm$core$Maybe$Just(tab.W),
									bU: $elm$core$Maybe$Nothing
								}),
							$author$project$Element$SubjectFeedbackList$BatchEffect(
								_List_fromArray(
									[
										$author$project$Element$SubjectFeedbackList$Cmd(
										$author$project$Element$SubjectFeedbackList$FetchSubjectFeedbacks(
											A6(
												$author$project$SubjectFeedback$fetchSubjectFeedbacks,
												config.gX,
												model.cb,
												model.bU,
												$elm$core$Maybe$Just(tab.W),
												false,
												$author$project$Element$SubjectFeedbackList$SubjectFeedbacksDownloaded))),
										$author$project$Element$SubjectFeedbackList$Cmd(
										$author$project$Element$SubjectFeedbackList$FetchSubjectList(
											A3(
												$author$project$Subject$fetchSubjectsByGradeV2,
												config.gX,
												$elm$core$Maybe$Just(tab.W),
												$author$project$Element$SubjectFeedbackList$SubjectListDownloaded))),
										$author$project$Element$SubjectFeedbackList$Cmd(
										A4(
											$author$project$Element$SubjectFeedbackList$UpdateFilterUrl,
											model.cb,
											$elm$core$Maybe$Nothing,
											$elm$core$Maybe$Just(tab.W),
											false))
									])),
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$7;
					}
				case 6:
					var _v6 = _v0.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fw: !model.fw}),
						$author$project$Element$SubjectFeedbackList$NoEffect,
						$elm$core$Maybe$Nothing);
				default:
					break _v0$7;
			}
		}
		return _Utils_Tuple3(model, $author$project$Element$SubjectFeedbackList$NoEffect, $elm$core$Maybe$Nothing);
	});
var $author$project$Locale$Messages$SubjectFeedbackListNoLearningAssessment = {$: 567};
var $author$project$Locale$Messages$SubjectFeedbacksLoadingProgress = {$: 565};
var $author$project$Locale$Messages$TrimesterClosureFeedbackGiven = F2(
	function (a, b) {
		return {$: 639, a: a, b: b};
	});
var $author$project$Element$SubjectFeedbackList$viewFeedbackMeta = F3(
	function (t_, student, feedback) {
		var viewModuleLink = function (module_) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$author$project$Route$href(
						$author$project$Route$ModulesDetail(
							$author$project$Module$moduleIdToInt(module_.i8))),
						$elm$html$Html$Attributes$title(
						t_(
							$author$project$Locale$Messages$TooltipModule(module_.kj)))
					]),
				_List_fromArray(
					[
						$author$project$UI$Icon$module_(_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(module_.kj)
							]))
					]));
		};
		var viewFeedbackText = function () {
			var _v1 = feedback.lF;
			switch (_v1) {
				case 'portfolio_story':
					return A2(
						$author$project$UI$caption,
						t_,
						$author$project$Locale$Messages$PortfoliosStoryShared(
							A2($author$project$Person$fullName, t_, feedback.lf)));
				case 'trimester_feedback':
					return A2(
						$author$project$UI$caption,
						t_,
						A2(
							$author$project$Locale$Messages$TrimesterClosureFeedbackGiven,
							A2($author$project$Person$fullName, t_, feedback.lf),
							A2($author$project$Person$fullName, t_, student)));
				default:
					return $elm$html$Html$text('?');
			}
		}();
		var createdAtFormatted = t_(
			A2(
				$author$project$Locale$Messages$TimeDateTimeFormat,
				$elm$time$Time$utc,
				$elm$time$Time$millisToPosix(feedback.g4)));
		var viewFeedbackHighlights = $author$project$UI$mediaObjectHighlights(
			_List_fromArray(
				[
					A2($author$project$UI$maybe, feedback.ng, viewModuleLink),
					function () {
					var _v0 = feedback.lG;
					if (!_v0.$) {
						var url = _v0.a;
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(url)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(createdAtFormatted)
								]));
					} else {
						return $elm$html$Html$text(createdAtFormatted);
					}
				}()
				]));
		return A4(
			$author$project$UI$mediaObjectSmall,
			_List_fromArray(
				[
					$author$project$UI$gravatarSmall(feedback.lf.O)
				]),
			_List_fromArray(
				[viewFeedbackText, viewFeedbackHighlights]),
			_List_Nil,
			_List_Nil);
	});
var $author$project$Element$SubjectFeedbackList$viewFeedbacks = F4(
	function (t_, subjects, student, subjectFeedbacks) {
		var viewFeedback = function (fb) {
			return _List_fromArray(
				[
					A3($author$project$Element$SubjectFeedbackList$viewFeedbackMeta, t_, student, fb),
					A2($author$project$UI$RubricAssessment$view, subjects, fb.cj)
				]);
		};
		return $author$project$Util$List$flatten(
			A2($elm$core$List$map, viewFeedback, subjectFeedbacks));
	});
var $author$project$Element$SubjectFeedbackList$SetMidYearFilter = function (a) {
	return {$: 4, a: a};
};
var $author$project$Locale$Messages$SubjectFeedbackListBtnEverything = {$: 562};
var $author$project$Locale$Messages$SubjectFeedbackListBtnOnlyMidYear = {$: 563};
var $author$project$Locale$Messages$SubjectFeedbackListType = {$: 561};
var $author$project$Element$SubjectFeedbackList$viewMidYearSelector = F2(
	function (t_, isMidYearSelected) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('label')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$SubjectFeedbackListType)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('buttons has-addons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button is-rounded'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('is-selected is-link is-light', !isMidYearSelected)
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Element$SubjectFeedbackList$SetMidYearFilter(false))
								]),
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$SubjectFeedbackListBtnEverything)
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button is-rounded'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('is-selected is-link is-light', isMidYearSelected)
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Element$SubjectFeedbackList$SetMidYearFilter(true))
								]),
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$SubjectFeedbackListBtnOnlyMidYear)
								]))
						]))
				]));
	});
var $author$project$Locale$Messages$SubjectFeedbackListHeading = F3(
	function (a, b, c) {
		return {$: 557, a: a, b: b, c: c};
	});
var $author$project$Element$SubjectFeedbackList$viewPageHeading = F4(
	function (t_, subjects, profile, subjectId) {
		var subjectName = A2($author$project$Subject$findSubjectName, subjects, subjectId);
		var message = A3(
			$author$project$Locale$Messages$SubjectFeedbackListHeading,
			A2($author$project$Person$fullName, t_, profile.nT),
			profile.fT,
			subjectName);
		return _List_fromArray(
			[
				$author$project$UI$title(
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, message)
					]))
			]);
	});
var $author$project$Locale$Messages$SubjectFeedbackListSummary = {$: 558};
var $author$project$Element$SubjectFeedbackList$viewPageSummary = function (t_) {
	return $author$project$UI$notification(
		$author$project$UI$textToHtml(
			t_($author$project$Locale$Messages$SubjectFeedbackListSummary)));
};
var $author$project$Element$SubjectFeedbackList$SetSubjectFilter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Locale$Messages$SubjectFeedbackListAllSubjects = {$: 556};
var $author$project$Locale$Messages$SubjectFeedbackListSelectSubject = {$: 560};
var $author$project$Element$SubjectFeedbackList$ToggleSubjectDropdown = {$: 6};
var $author$project$Element$SubjectFeedbackList$viewSubjectSelector = F4(
	function (t_, isOpen, subjects, selectedSubjectId) {
		var label = t_($author$project$Locale$Messages$SubjectFeedbackListSelectSubject);
		var items = A2($elm$core$Maybe$withDefault, _List_Nil, subjects);
		var selectedItem = A2($author$project$Subject$findSubject, items, selectedSubjectId);
		var itemLabel = function ($) {
			return $.fb;
		};
		var isActive = function (subject) {
			if (!selectedSubjectId.$) {
				var subjectId = selectedSubjectId.a;
				return _Utils_eq(subject.i8, subjectId);
			} else {
				return false;
			}
		};
		return $author$project$UI$dropDownSelect(
			{
				lw: t_($author$project$Locale$Messages$SubjectFeedbackListAllSubjects),
				lx: $author$project$Element$SubjectFeedbackList$SetSubjectFilter($elm$core$Maybe$Nothing),
				l7: isActive,
				mb: isOpen,
				mh: itemLabel,
				mi: A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Element$SubjectFeedbackList$SetSubjectFilter, $elm$core$Maybe$Just),
					function ($) {
						return $.i8;
					}),
				mj: $author$project$Element$SubjectFeedbackList$ToggleSubjectDropdown,
				mk: items,
				ea: label,
				nA: selectedItem,
				nF: true
			});
	});
var $author$project$Element$SubjectFeedbackList$viewSubjectFeedbacks = function (model) {
	var _v0 = model.dG;
	switch (_v0.$) {
		case 1:
			return A2(
				$author$project$UI$progressBar,
				'is-info',
				model.gB.h6($author$project$Locale$Messages$SubjectFeedbacksLoadingProgress));
		case 2:
			var subjectFeedbacksForStudent = _v0.a;
			var viewFilters = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'gap', '20px')
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Element$SubjectFeedbackList$viewSubjectSelector,
						model.gB.h6,
						model.fw,
						$author$project$RemoteData$toMaybe(model.kb),
						model.bU),
						A2($author$project$Element$SubjectFeedbackList$viewMidYearSelector, model.gB.h6, model.mB)
					]));
			var subjects = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$author$project$RemoteData$toMaybe(model.kb));
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$UI$section(
						A4($author$project$Element$SubjectFeedbackList$viewPageHeading, model.gB.h6, subjects, subjectFeedbacksForStudent.h5, model.bU)),
						$author$project$Element$SubjectFeedbackList$viewPageSummary(model.gB.h6),
						viewFilters,
						A2($elm$html$Html$hr, _List_Nil, _List_Nil),
						$author$project$UI$section(
						A4($author$project$Element$SubjectFeedbackList$viewFeedbacks, model.gB.h6, subjects, subjectFeedbacksForStudent.nT, subjectFeedbacksForStudent.lH))
					]));
		default:
			return $author$project$UI$none;
	}
};
var $author$project$Element$SubjectFeedbackList$TabSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Locale$Messages$SubjectFeedbackListTab = F2(
	function (a, b) {
		return {$: 566, a: a, b: b};
	});
var $author$project$Element$SubjectFeedbackList$tabCaption = function (_v0) {
	var startYear = _v0.eB;
	var endYear = _v0.d3;
	return A2($author$project$Locale$Messages$SubjectFeedbackListTab, startYear, endYear);
};
var $author$project$Element$SubjectFeedbackList$viewTabBar = F3(
	function (t_, selected, tabs) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tabs is-boxed')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (tab) {
							return A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'is-active',
												_Utils_eq(
													$elm$core$Maybe$Just(tab),
													selected))
											]))
									]),
								_List_fromArray(
									[
										A3(
										$author$project$UI$actionLink,
										$author$project$Element$SubjectFeedbackList$TabSelected(tab),
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$UI$caption,
												t_,
												$author$project$Element$SubjectFeedbackList$tabCaption(tab))
											]))
									]));
						},
						tabs))
				]));
	});
var $author$project$Element$SubjectFeedbackList$view = function (model) {
	var session = model.gB;
	var page = model.bk;
	switch (page.$) {
		case 0:
			return $author$project$UI$section(
				_List_fromArray(
					[
						A2(
						$author$project$UI$progressBar,
						'is-warning',
						session.h6($author$project$Locale$Messages$SubjectFeedbacksDownloadError))
					]));
		case 1:
			return $author$project$UI$section(
				_List_fromArray(
					[
						A2(
						$author$project$UI$progressBar,
						'is-info',
						session.h6($author$project$Locale$Messages$SubjectFeedbacksLoadingProgress))
					]));
		default:
			var listPageModel = page.a;
			return $author$project$UI$section(
				_List_fromArray(
					[
						function () {
						var _v1 = listPageModel.cd;
						if (!_v1.$) {
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A3($author$project$Element$SubjectFeedbackList$viewTabBar, session.h6, listPageModel.cd, listPageModel.gG),
										$author$project$Element$SubjectFeedbackList$viewSubjectFeedbacks(model)
									]));
						} else {
							return $author$project$UI$notification(
								_List_fromArray(
									[
										A2($author$project$UI$caption, session.h6, $author$project$Locale$Messages$SubjectFeedbackListNoLearningAssessment)
									]));
						}
					}()
					]));
	}
};
var $author$project$Element$SubjectFeedbackList$element = {jb: $author$project$Element$SubjectFeedbackList$init, hP: $author$project$Element$SubjectFeedbackList$perform, ks: $author$project$Element$SubjectFeedbackList$update, og: $author$project$Element$SubjectFeedbackList$view};
var $author$project$Element$TeacherProfileForm$NotFoundPage = {$: 0};
var $author$project$Element$TeacherProfileForm$LoadingPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TeacherProfileForm$PhoneBookDownloaded = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$TeacherProfileForm$TeacherProfileDownloaded = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Endpoint$teacherProfile = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'teacher-profiles',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$TeacherProfile$TeacherProfile = function (id) {
	return function (state) {
		return function (teacher) {
			return function (birthFirstName) {
				return function (birthLastName) {
					return function (birthHasFamilyNameFirst) {
						return function (motherNamePrefix) {
							return function (motherFirstName) {
								return function (motherLastName) {
									return function (motherHasFamilyNameFirst) {
										return function (highestEducationLevel) {
											return function (apprenticeshipYears) {
												return function (isAcademicMember) {
													return function (diplomaUrl) {
														return {aO: apprenticeshipYears, ak: birthFirstName, aQ: birthHasFamilyNameFirst, al: birthLastName, v: diplomaUrl, aU: highestEducationLevel, i8: id, aV: isAcademicMember, ay: motherFirstName, aX: motherHasFamilyNameFirst, az: motherLastName, aA: motherNamePrefix, fs: state, n2: teacher};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$TeacherProfile$Teacher = function (id) {
	return function (namePrefix) {
		return function (firstName) {
			return function (lastName) {
				return function (isFamilyNameFirst) {
					return function (email) {
						return function (phoneNumber) {
							return function (permanentAddress) {
								return function (temporaryAddress) {
									return function (birthDate) {
										return function (birthPlaceCountry) {
											return function (birthPlaceTown) {
												return function (nationality) {
													return function (eduId) {
														return function (mentor) {
															return {aP: birthDate, aR: birthPlaceCountry, aS: birthPlaceTown, ap: eduId, O: email, lI: firstName, i8: id, bh: isFamilyNameFirst, av: lastName, my: mentor, aY: namePrefix, aC: nationality, dp: permanentAddress, a$: phoneNumber, n3: temporaryAddress};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$TeacherProfile$teacherDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'mentor',
	$elm$json$Json$Decode$nullable($author$project$Person$nestedPersonDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'edu_id',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'nationality',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'birthplace',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'birthplace_country',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'birthdate',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'temporary_address',
							$elm$json$Json$Decode$nullable($author$project$Person$addressDecoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'permanent_address',
								$elm$json$Json$Decode$nullable($author$project$Person$addressDecoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'phone_number',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'email',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'is_family_name_first',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'last_name',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'first_name',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'name_prefix',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'id',
															$elm$json$Json$Decode$int,
															$elm$json$Json$Decode$succeed($author$project$TeacherProfile$Teacher))))))))))))))));
var $author$project$TeacherProfile$TeacherProfileId = $elm$core$Basics$identity;
var $author$project$TeacherProfile$teacherProfileIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$TeacherProfile$teacherProfileDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'diploma_url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_academic_member',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'apprenticeship_years',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'highest_education_level',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'mother_has_family_name_first',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'mother_last_name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'mother_first_name',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'mother_name_prefix',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'birth_has_family_name_first',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'birth_last_name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'birth_first_name',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'teacher',
												$author$project$TeacherProfile$teacherDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'state',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$author$project$TeacherProfile$teacherProfileIdDecoder,
														$elm$json$Json$Decode$succeed($author$project$TeacherProfile$TeacherProfile)))))))))))))));
var $author$project$TeacherProfile$fetchTeacherProfile = F3(
	function (config, id, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$teacherProfile, config, id),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$TeacherProfile$teacherProfileDecoder));
	});
var $author$project$Element$TeacherProfileForm$openFormPage = F3(
	function (personId, session, model) {
		var config = model.b_;
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$TeacherProfile$fetchTeacherProfile, config.gX, personId, $author$project$Element$TeacherProfileForm$TeacherProfileDownloaded),
					A2($author$project$Person$fetchPhoneBook, config.gX, $author$project$Element$TeacherProfileForm$PhoneBookDownloaded)
				]));
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A2(
				$author$project$Application$Boundaries$save,
				_Utils_update(
					model,
					{
						bk: $author$project$Element$TeacherProfileForm$LoadingPage(personId)
					}),
				session));
	});
var $author$project$Element$TeacherProfileForm$init = F3(
	function (config, session, personId) {
		var model = {b_: config, bk: $author$project$Element$TeacherProfileForm$NotFoundPage, gn: _List_Nil, eq: $elm$core$Maybe$Nothing};
		return A3($author$project$Element$TeacherProfileForm$openFormPage, personId, session, model);
	});
var $author$project$Element$TeacherProfileForm$DiplomaFileSelected = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$Element$TeacherProfileForm$DiplomaFileUploaded = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Element$TeacherProfileForm$DiplomaPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Element$TeacherProfileForm$DiplomaSignatureDownloaded = function (a) {
	return {$: 13, a: a};
};
var $author$project$Element$TeacherProfileForm$FormPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$TeacherProfileForm$NoOp = {$: 7};
var $author$project$Element$TeacherProfileForm$ProfileSaved = function (a) {
	return {$: 4, a: a};
};
var $author$project$Locale$Messages$TeacherProfilesDownloadError = {$: 593};
var $author$project$Locale$Messages$TeacherProfilesSaveSuccess = {$: 595};
var $author$project$Element$TeacherProfileForm$acceptedMimeTypes = _List_fromArray(
	['application/pdf', 'image/png', 'image/jpeg']);
var $author$project$Element$TeacherProfileForm$awsPolicyScope = 'people';
var $author$project$Element$TeacherProfileForm$ApprenticeshipYears = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$TeacherProfileForm$BirthDate = function (a) {
	return {$: 26, a: a};
};
var $author$project$Element$TeacherProfileForm$BirthFirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$TeacherProfileForm$BirthHasFamilyNameFirst = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$TeacherProfileForm$BirthLastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TeacherProfileForm$BirthPlaceCountry = function (a) {
	return {$: 24, a: a};
};
var $author$project$Element$TeacherProfileForm$BirthPlaceTown = function (a) {
	return {$: 25, a: a};
};
var $author$project$Element$TeacherProfileForm$DiplomaUrl = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$TeacherProfileForm$EduId = function (a) {
	return {$: 28, a: a};
};
var $author$project$Element$TeacherProfileForm$Email = function (a) {
	return {$: 11, a: a};
};
var $author$project$Element$TeacherProfileForm$FirstName = function (a) {
	return {$: 13, a: a};
};
var $author$project$Element$TeacherProfileForm$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$TeacherProfileForm$HighestEducationLevel = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$TeacherProfileForm$IsAcademicMember = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$TeacherProfileForm$IsFamilyNameFirst = function (a) {
	return {$: 15, a: a};
};
var $author$project$Element$TeacherProfileForm$LastName = function (a) {
	return {$: 14, a: a};
};
var $author$project$Element$TeacherProfileForm$Mentor = function (a) {
	return {$: 29, a: a};
};
var $author$project$Element$TeacherProfileForm$MotherFirstName = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$TeacherProfileForm$MotherHasFamilyNameFirst = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$TeacherProfileForm$MotherLastName = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$TeacherProfileForm$MotherNamePrefix = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$TeacherProfileForm$NamePrefix = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$TeacherProfileForm$Nationality = function (a) {
	return {$: 27, a: a};
};
var $author$project$Element$TeacherProfileForm$PermanentAddressCountry = function (a) {
	return {$: 17, a: a};
};
var $author$project$Element$TeacherProfileForm$PermanentAddressPostcode = function (a) {
	return {$: 18, a: a};
};
var $author$project$Element$TeacherProfileForm$PermanentAddressStreetDoor = function (a) {
	return {$: 23, a: a};
};
var $author$project$Element$TeacherProfileForm$PermanentAddressStreetName = function (a) {
	return {$: 20, a: a};
};
var $author$project$Element$TeacherProfileForm$PermanentAddressStreetNumber = function (a) {
	return {$: 22, a: a};
};
var $author$project$Element$TeacherProfileForm$PermanentAddressStreetType = function (a) {
	return {$: 21, a: a};
};
var $author$project$Element$TeacherProfileForm$PermanentAddressTown = function (a) {
	return {$: 19, a: a};
};
var $author$project$Locale$Messages$PersonIsFamilyNameFirst = {$: 315};
var $author$project$Locale$Messages$PersonNamePrefix = {$: 312};
var $author$project$Element$TeacherProfileForm$PhoneNumber = function (a) {
	return {$: 16, a: a};
};
var $author$project$Locale$Messages$TeacherProfileEducationLevelBachelor = {$: 588};
var $author$project$Locale$Messages$TeacherProfileEducationLevelMaster = {$: 587};
var $author$project$Locale$Messages$TeacherProfileEducationLevelSecondary = {$: 589};
var $author$project$TeacherProfile$educationLevels = function (t_) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'0',
			t_($author$project$Locale$Messages$TeacherProfileEducationLevelMaster)),
			_Utils_Tuple2(
			'1',
			t_($author$project$Locale$Messages$TeacherProfileEducationLevelBachelor)),
			_Utils_Tuple2(
			'2',
			t_($author$project$Locale$Messages$TeacherProfileEducationLevelSecondary))
		]);
};
var $author$project$Element$TeacherProfileForm$maxFileSize = (10 * 1024) * 1024;
var $author$project$Element$TeacherProfileForm$buildForm = function (t_) {
	return {
		aO: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aO: value});
				}),
			fC: function ($) {
				return $.aO;
			},
			og: {
				cm: 'apprenticeship_years',
				e6: 'fa-graduation-cap',
				ea: t_($author$project$Locale$Messages$TeacherProfileApprenticeshipYears),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$ApprenticeshipYears),
				fj: t_($author$project$Locale$Messages$TeacherProfileApprenticeshipYears),
				ii: 'text'
			}
		},
		aP: {
			e0: false,
			fi: $author$project$Form$requiredDate(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aP: value});
				}),
			fC: function ($) {
				return $.aP;
			},
			og: {
				cm: 'birth_date',
				ea: t_($author$project$Locale$Messages$PersonBirthDate),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$BirthDate)
			}
		},
		ak: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ak: value});
				}),
			fC: function ($) {
				return $.ak;
			},
			og: {
				cm: 'birth_first_name',
				e6: 'fa-keyboard',
				ea: t_($author$project$Locale$Messages$TeacherProfileBirthFirstName),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$BirthFirstName),
				fj: t_($author$project$Locale$Messages$TeacherProfileBirthFirstName),
				ii: 'text'
			}
		},
		aQ: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aQ: value});
				}),
			fC: function ($) {
				return $.aQ;
			},
			og: {
				cm: 'birth_has_family_name_first',
				e6: 'fa-user',
				ea: t_($author$project$Locale$Messages$TeacherProfileBirthHasFamilyNameFirst),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$BirthHasFamilyNameFirst)
			}
		},
		al: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{al: value});
				}),
			fC: function ($) {
				return $.al;
			},
			og: {
				cm: 'birth_last_name',
				e6: 'fa-keyboard',
				ea: t_($author$project$Locale$Messages$TeacherProfileBirthLastName),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$BirthLastName),
				fj: t_($author$project$Locale$Messages$TeacherProfileBirthLastName),
				ii: 'text'
			}
		},
		aR: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aR: value});
				}),
			fC: function ($) {
				return $.aR;
			},
			og: {
				cm: 'birthplace_country',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonBirthPlaceCountry),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$BirthPlaceCountry),
				m_: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(
						$author$project$Person$countries(t_)))
			}
		},
		aS: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aS: value});
				}),
			fC: function ($) {
				return $.aS;
			},
			og: {
				cm: 'birth_place_town',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonBirthPlaceTown),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$BirthPlaceTown),
				fj: t_($author$project$Locale$Messages$PersonBirthPlaceTown),
				ii: 'text'
			}
		},
		v: {
			e0: false,
			fi: A2(
				$author$project$Form$requiredFile,
				t_,
				{kH: $author$project$Element$TeacherProfileForm$acceptedMimeTypes, mv: $author$project$Element$TeacherProfileForm$maxFileSize}),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{v: value});
				}),
			fC: function ($) {
				return $.v;
			},
			og: {
				cm: 'diploma',
				e6: 'fa-file-pdf',
				ea: t_($author$project$Locale$Messages$TeacherProfileDiplomaUrl),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$DiplomaUrl),
				fj: t_($author$project$Locale$Messages$TeacherProfileDiplomaUrl)
			}
		},
		ap: {
			e0: false,
			fi: $author$project$Person$optionalEduId(t_),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ap: value});
				}),
			fC: function ($) {
				return $.ap;
			},
			og: {
				cm: 'edu_id',
				e6: 'fa-id-card',
				ea: t_($author$project$Locale$Messages$PersonEduId),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$EduId),
				fj: t_($author$project$Locale$Messages$PersonEduId),
				ii: 'text'
			}
		},
		O: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{O: value});
				}),
			fC: function ($) {
				return $.O;
			},
			og: {
				cm: 'email',
				e6: 'fa-envelope',
				ea: t_($author$project$Locale$Messages$PersonEmail),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$Email),
				fj: t_($author$project$Locale$Messages$PersonEmail),
				ii: 'email'
			}
		},
		lI: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{lI: value});
				}),
			fC: function ($) {
				return $.lI;
			},
			og: {
				cm: 'firstname',
				e6: 'fa-user',
				ea: t_($author$project$Locale$Messages$PersonFirstName),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$FirstName),
				fj: t_($author$project$Locale$Messages$PersonFirstName),
				ii: 'text'
			}
		},
		aU: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aU: value});
				}),
			fC: function ($) {
				return $.aU;
			},
			og: {
				cm: 'highest_education_level',
				e6: 'fa-graduation-cap',
				ea: t_($author$project$Locale$Messages$TeacherProfileHighestEducationLevel),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$HighestEducationLevel),
				m_: $elm$core$Maybe$Just(
					$author$project$Form$toSelectOptions(
						$author$project$TeacherProfile$educationLevels(t_)))
			}
		},
		aV: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aV: value});
				}),
			fC: function ($) {
				return $.aV;
			},
			og: {
				cm: 'is_academic_member',
				e6: 'keyboard-user',
				ea: t_($author$project$Locale$Messages$TeacherProfileIsAcademicMember),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$IsAcademicMember)
			}
		},
		bh: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{bh: value});
				}),
			fC: function ($) {
				return $.bh;
			},
			og: {
				cm: 'is_family_name_first',
				e6: 'fa-user',
				ea: t_($author$project$Locale$Messages$PersonIsFamilyNameFirst),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$IsFamilyNameFirst)
			}
		},
		av: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{av: value});
				}),
			fC: function ($) {
				return $.av;
			},
			og: {
				cm: 'lastname',
				e6: 'fa-user',
				ea: t_($author$project$Locale$Messages$PersonLastName),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$LastName),
				fj: t_($author$project$Locale$Messages$PersonLastName),
				ii: 'text'
			}
		},
		my: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{my: value});
				}),
			fC: function ($) {
				return $.my;
			},
			og: {
				cm: 'mentor',
				e6: 'fa-user',
				ea: t_($author$project$Locale$Messages$PersonMentor),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$Mentor),
				m_: $elm$core$Maybe$Nothing
			}
		},
		ay: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ay: value});
				}),
			fC: function ($) {
				return $.ay;
			},
			og: {
				cm: 'mother_first_name',
				e6: 'fa-keyboard',
				ea: t_($author$project$Locale$Messages$TeacherProfileMotherFirstName),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$MotherFirstName),
				fj: t_($author$project$Locale$Messages$TeacherProfileMotherFirstName),
				ii: 'text'
			}
		},
		aX: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aX: value});
				}),
			fC: function ($) {
				return $.aX;
			},
			og: {
				cm: 'mother_has_family_name_first',
				e6: 'fa-user',
				ea: t_($author$project$Locale$Messages$TeacherProfileMotherHasFamilyNameFirst),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$MotherHasFamilyNameFirst)
			}
		},
		az: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{az: value});
				}),
			fC: function ($) {
				return $.az;
			},
			og: {
				cm: 'mother_last_name',
				e6: 'fa-keyboard',
				ea: t_($author$project$Locale$Messages$TeacherProfileMotherLastName),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$MotherLastName),
				fj: t_($author$project$Locale$Messages$TeacherProfileMotherLastName),
				ii: 'text'
			}
		},
		aA: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aA: value});
				}),
			fC: function ($) {
				return $.aA;
			},
			og: {
				cm: 'mother_name_prefix',
				e6: 'fa-keyboard',
				ea: t_($author$project$Locale$Messages$TeacherProfileMotherNamePrefix),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$MotherNamePrefix),
				fj: t_($author$project$Locale$Messages$TeacherProfileMotherNamePrefix),
				ii: 'text'
			}
		},
		aY: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aY: value});
				}),
			fC: function ($) {
				return $.aY;
			},
			og: {
				cm: 'name_prefix',
				e6: 'fa-keyboard',
				ea: t_($author$project$Locale$Messages$PersonNamePrefix),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$NamePrefix),
				fj: t_($author$project$Locale$Messages$PersonNamePrefix),
				ii: 'text'
			}
		},
		aC: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aC: value});
				}),
			fC: function ($) {
				return $.aC;
			},
			og: {
				cm: 'nationality',
				e6: 'fa-flag',
				ea: t_($author$project$Locale$Messages$PersonNationality),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$Nationality),
				m_: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(
						$author$project$Person$countries(t_)))
			}
		},
		a1: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a1: value});
				}),
			fC: function ($) {
				return $.a1;
			},
			og: {
				cm: 'permanent_address_country',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressCountry),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$PermanentAddressCountry),
				m_: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(
						$author$project$Person$countries(t_)))
			}
		},
		a2: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a2: value});
				}),
			fC: function ($) {
				return $.a2;
			},
			og: {
				cm: 'permanent_address_postcode',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressPostcode),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$PermanentAddressPostcode),
				fj: t_($author$project$Locale$Messages$PersonAddressPostcode),
				ii: 'text'
			}
		},
		a3: {
			e0: false,
			fi: $elm$core$Result$Ok,
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a3: value});
				}),
			fC: function ($) {
				return $.a3;
			},
			og: {
				cm: 'permanent_address_street_door',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressStreetDoor),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$PermanentAddressStreetDoor),
				fj: t_($author$project$Locale$Messages$PersonAddressStreetDoor),
				ii: 'text'
			}
		},
		a4: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a4: value});
				}),
			fC: function ($) {
				return $.a4;
			},
			og: {
				cm: 'permanent_address_street_name',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressStreetName),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$PermanentAddressStreetName),
				fj: t_($author$project$Locale$Messages$PersonAddressStreetName),
				ii: 'text'
			}
		},
		a5: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a5: value});
				}),
			fC: function ($) {
				return $.a5;
			},
			og: {
				cm: 'permanent_address_street_number',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressStreetNumber),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$PermanentAddressStreetNumber),
				fj: t_($author$project$Locale$Messages$PersonAddressStreetNumber),
				ii: 'text'
			}
		},
		a6: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a6: value});
				}),
			fC: function ($) {
				return $.a6;
			},
			og: {
				cm: 'permanent_address_street_type',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressStreetType),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$PermanentAddressStreetType),
				fj: t_($author$project$Locale$Messages$PersonAddressStreetType),
				ii: 'text'
			}
		},
		a7: {
			e0: false,
			fi: $author$project$Form$requiredText(t_),
			fp: true,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a7: value});
				}),
			fC: function ($) {
				return $.a7;
			},
			og: {
				cm: 'permanent_address_town',
				e6: 'fa-map-marker',
				ea: t_($author$project$Locale$Messages$PersonAddressTown),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$PermanentAddressTown),
				fj: t_($author$project$Locale$Messages$PersonAddressTown),
				ii: 'text'
			}
		},
		a$: {
			e0: false,
			fi: $author$project$Form$optionalPhoneNumber(t_),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a$: value});
				}),
			fC: function ($) {
				return $.a$;
			},
			og: {
				cm: 'phone',
				e6: 'fa-phone',
				ea: t_($author$project$Locale$Messages$PersonPhone),
				fe: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$PhoneNumber),
				fj: t_($author$project$Locale$Messages$PersonPhone),
				ii: 'phone'
			}
		}
	};
};
var $author$project$Element$TeacherProfileForm$fillForm = function (profile) {
	var teacher = profile.n2;
	return {
		aO: $elm$core$String$fromInt(profile.aO),
		aP: A2($elm$core$Maybe$withDefault, '', teacher.aP),
		ak: profile.ak,
		aQ: profile.aQ,
		al: profile.al,
		aR: teacher.aR,
		aS: A2($elm$core$Maybe$withDefault, '', teacher.aS),
		v: $author$project$Form$fromFileUrl(profile.v),
		ap: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $elm$core$String$fromInt, teacher.ap)),
		O: A2($elm$core$Maybe$withDefault, '', teacher.O),
		lI: teacher.lI,
		aU: $elm$core$String$fromInt(profile.aU),
		aV: profile.aV,
		bh: teacher.bh,
		av: teacher.av,
		my: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.i8;
					},
					$elm$core$String$fromInt),
				teacher.my)),
		ay: profile.ay,
		aX: profile.aX,
		az: profile.az,
		aA: profile.aA,
		aY: teacher.aY,
		aC: teacher.aC,
		a1: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.le;
				},
				teacher.dp)),
		a2: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nb;
				},
				teacher.dp)),
		a3: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nP;
				},
				teacher.dp)),
		a4: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nQ;
				},
				teacher.dp)),
		a5: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nR;
				},
				teacher.dp)),
		a6: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nS;
				},
				teacher.dp)),
		a7: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ob;
				},
				teacher.dp)),
		a$: A2($elm$core$Maybe$withDefault, '', teacher.a$)
	};
};
var $author$project$Element$TeacherProfileForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.ak, values) && (A2($author$project$Form$isFieldValid, form.al, values) && (A2($author$project$Form$isFieldValid, form.aQ, values) && (A2($author$project$Form$isFieldValid, form.aA, values) && (A2($author$project$Form$isFieldValid, form.ay, values) && (A2($author$project$Form$isFieldValid, form.az, values) && (A2($author$project$Form$isFieldValid, form.aX, values) && (A2($author$project$Form$isFieldValid, form.aU, values) && (A2($author$project$Form$isFieldValid, form.aO, values) && (A2($author$project$Form$isFieldValid, form.aV, values) && (A2($author$project$Form$isFieldValid, form.v, values) && (A2($author$project$Form$isFieldValid, form.aY, values) && (A2($author$project$Form$isFieldValid, form.lI, values) && (A2($author$project$Form$isFieldValid, form.av, values) && (A2($author$project$Form$isFieldValid, form.bh, values) && (A2($author$project$Form$isFieldValid, form.O, values) && (A2($author$project$Form$isFieldValid, form.a$, values) && (A2($author$project$Form$isFieldValid, form.a1, values) && (A2($author$project$Form$isFieldValid, form.a2, values) && (A2($author$project$Form$isFieldValid, form.a7, values) && (A2($author$project$Form$isFieldValid, form.a4, values) && (A2($author$project$Form$isFieldValid, form.a6, values) && (A2($author$project$Form$isFieldValid, form.a5, values) && (A2($author$project$Form$isFieldValid, form.a3, values) && (A2($author$project$Form$isFieldValid, form.aR, values) && (A2($author$project$Form$isFieldValid, form.aS, values) && (A2($author$project$Form$isFieldValid, form.aP, values) && (A2($author$project$Form$isFieldValid, form.aC, values) && (A2($author$project$Form$isFieldValid, form.ap, values) && A2($author$project$Form$isFieldValid, form.my, values)))))))))))))))))))))))))))));
	});
var $author$project$Log$msgTeacherProfileDownload = 'teacher_profile_download';
var $author$project$Log$msgTeacherProfileSave = 'teacher_profile_save';
var $author$project$Log$paramScopeTeacherProfiles = 'scope_teacher_profiles';
var $author$project$Element$TeacherProfileForm$DocumentViewerModel = $elm$core$Basics$identity;
var $author$project$Element$TeacherProfileForm$DocumentViewerMsg = $elm$core$Basics$identity;
var $author$project$Element$TeacherProfileForm$PopupMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$TeacherProfileForm$popups = {
	d0: {
		ha: $author$project$Element$DocumentViewer$element,
		cf: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$PopupMsg, $elm$core$Basics$identity),
		kt: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						eq: $elm$core$Maybe$Just(model)
					});
			})
	}
};
var $author$project$TeacherProfile$TeacherProfileUnsaved = function (id) {
	return function (state) {
		return function (teacher) {
			return function (birthFirstName) {
				return function (birthLastName) {
					return function (birthHasFamilyNameFirst) {
						return function (motherNamePrefix) {
							return function (motherFirstName) {
								return function (motherLastName) {
									return function (motherHasFamilyNameFirst) {
										return function (highestEducationLevel) {
											return function (apprenticeshipYears) {
												return function (isAcademicMember) {
													return function (diplomaUrl) {
														return {aO: apprenticeshipYears, ak: birthFirstName, aQ: birthHasFamilyNameFirst, al: birthLastName, v: diplomaUrl, aU: highestEducationLevel, i8: id, aV: isAcademicMember, ay: motherFirstName, aX: motherHasFamilyNameFirst, az: motherLastName, aA: motherNamePrefix, fs: state, n2: teacher};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$TeacherProfile$TeacherUnsaved = function (id) {
	return function (namePrefix) {
		return function (firstName) {
			return function (lastName) {
				return function (isFamilyNameFirst) {
					return function (email) {
						return function (phoneNumber) {
							return function (permanentAddress) {
								return function (temporaryAddress) {
									return function (birthDate) {
										return function (birthPlaceCountry) {
											return function (birthPlaceTown) {
												return function (nationality) {
													return function (eduId) {
														return function (mentor) {
															return {aP: birthDate, aR: birthPlaceCountry, aS: birthPlaceTown, ap: eduId, O: email, lI: firstName, i8: id, bh: isFamilyNameFirst, av: lastName, my: mentor, aY: namePrefix, aC: nationality, dp: permanentAddress, a$: phoneNumber, n3: temporaryAddress};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Element$TeacherProfileForm$saveForm = F3(
	function (form, values, profile) {
		return $author$project$TeacherProfile$TeacherProfileUnsaved(profile.i8)(profile.fs)(
			$author$project$TeacherProfile$TeacherUnsaved(profile.n2.i8)(
				form.aY.fC(values))(
				form.lI.fC(values))(
				form.av.fC(values))(
				form.bh.fC(values))(
				A2(
					$author$project$Data$toMaybe,
					$elm$core$String$isEmpty,
					form.O.fC(values)))(
				A2(
					$author$project$Data$toMaybe,
					$elm$core$String$isEmpty,
					form.a$.fC(values)))(
				$elm$core$Maybe$Just(
					A9(
						$author$project$Person$Address,
						true,
						form.a1.fC(values),
						form.a7.fC(values),
						form.a2.fC(values),
						'',
						form.a4.fC(values),
						form.a6.fC(values),
						form.a5.fC(values),
						form.a3.fC(values))))($elm$core$Maybe$Nothing)(
				A2(
					$author$project$Data$toMaybe,
					$elm$core$String$isEmpty,
					form.aP.fC(values)))(
				form.aR.fC(values))(
				A2(
					$author$project$Data$toMaybe,
					$elm$core$String$isEmpty,
					form.aS.fC(values)))(
				form.aC.fC(values))(
				$elm$core$String$toInt(
					form.ap.fC(values)))(
				$elm$core$String$toInt(
					form.my.fC(values))))(
			form.ak.fC(values))(
			form.al.fC(values))(
			form.aQ.fC(values))(
			form.aA.fC(values))(
			form.ay.fC(values))(
			form.az.fC(values))(
			form.aX.fC(values))(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					form.aU.fC(values))))(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					form.aO.fC(values))))(
			form.aV.fC(values))(
			$author$project$Form$toFileUrl(
				form.v.fC(values)));
	});
var $author$project$TeacherProfile$teacherProfileIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Element$TeacherProfileForm$updateForm = F3(
	function (msg, form, formValues) {
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ak: $author$project$Form$markEdited(form.ak)
						}),
					A2(form.ak.ks, value, formValues));
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							al: $author$project$Form$markEdited(form.al)
						}),
					A2(form.al.ks, value, formValues));
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aQ: $author$project$Form$markEdited(form.aQ)
						}),
					A2(form.aQ.ks, value, formValues));
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aA: $author$project$Form$markEdited(form.aA)
						}),
					A2(form.aA.ks, value, formValues));
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ay: $author$project$Form$markEdited(form.ay)
						}),
					A2(form.ay.ks, value, formValues));
			case 5:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							az: $author$project$Form$markEdited(form.az)
						}),
					A2(form.az.ks, value, formValues));
			case 6:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aX: $author$project$Form$markEdited(form.aX)
						}),
					A2(form.aX.ks, value, formValues));
			case 7:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aU: $author$project$Form$markEdited(form.aU)
						}),
					A2(form.aU.ks, value, formValues));
			case 8:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aO: $author$project$Form$markEdited(form.aO)
						}),
					A2(form.aO.ks, value, formValues));
			case 9:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aV: $author$project$Form$markEdited(form.aV)
						}),
					A2(form.aV.ks, value, formValues));
			case 10:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							v: $author$project$Form$markEdited(form.v)
						}),
					A2(
						form.v.ks,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 12:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aY: $author$project$Form$markEdited(form.aY)
						}),
					A2(form.aY.ks, value, formValues));
			case 13:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							lI: $author$project$Form$markEdited(form.lI)
						}),
					A2(form.lI.ks, value, formValues));
			case 14:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							av: $author$project$Form$markEdited(form.av)
						}),
					A2(form.av.ks, value, formValues));
			case 15:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							bh: $author$project$Form$markEdited(form.bh)
						}),
					A2(form.bh.ks, value, formValues));
			case 11:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							O: $author$project$Form$markEdited(form.O)
						}),
					A2(form.O.ks, value, formValues));
			case 16:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a$: $author$project$Form$markEdited(form.a$)
						}),
					A2(form.a$.ks, value, formValues));
			case 17:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a1: $author$project$Form$markEdited(form.a1)
						}),
					A2(form.a1.ks, value, formValues));
			case 18:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a2: $author$project$Form$markEdited(form.a2)
						}),
					A2(form.a2.ks, value, formValues));
			case 19:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a7: $author$project$Form$markEdited(form.a7)
						}),
					A2(form.a7.ks, value, formValues));
			case 20:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a4: $author$project$Form$markEdited(form.a4)
						}),
					A2(form.a4.ks, value, formValues));
			case 21:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a6: $author$project$Form$markEdited(form.a6)
						}),
					A2(form.a6.ks, value, formValues));
			case 22:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a5: $author$project$Form$markEdited(form.a5)
						}),
					A2(form.a5.ks, value, formValues));
			case 23:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a3: $author$project$Form$markEdited(form.a3)
						}),
					A2(form.a3.ks, value, formValues));
			case 24:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aR: $author$project$Form$markEdited(form.aR)
						}),
					A2(form.aR.ks, value, formValues));
			case 25:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aS: $author$project$Form$markEdited(form.aS)
						}),
					A2(form.aS.ks, value, formValues));
			case 26:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aP: $author$project$Form$markEdited(form.aP)
						}),
					A2(form.aP.ks, value, formValues));
			case 27:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aC: $author$project$Form$markEdited(form.aC)
						}),
					A2(form.aC.ks, value, formValues));
			case 28:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ap: $author$project$Form$markEdited(form.ap)
						}),
					A2(form.ap.ks, value, formValues));
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							my: $author$project$Form$markEdited(form.my)
						}),
					A2(form.my.ks, value, formValues));
		}
	});
var $author$project$Person$canBeMentor = function (person) {
	return $author$project$Person$isTeacher(person) || ($author$project$Person$isModuleTeacher(person) || $author$project$Person$isOperator(person));
};
var $author$project$Element$TeacherProfileForm$toMentorOptions = F2(
	function (t_, people) {
		return A2(
			$author$project$Form$toPeopleOptions,
			t_,
			A2($elm$core$List$filter, $author$project$Person$canBeMentor, people));
	});
var $author$project$Element$TeacherProfileForm$updateMentorOptions = F3(
	function (t_, people, form) {
		if (!people.b) {
			return form;
		} else {
			var people_ = people;
			return _Utils_update(
				form,
				{
					my: A2(
						$author$project$Form$fillFieldOptions,
						A2($author$project$Element$TeacherProfileForm$toMentorOptions, t_, people_),
						form.my)
				});
		}
	});
var $author$project$TeacherProfile$teacherEncoder = function (teacher) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(teacher.i8)),
				_Utils_Tuple2(
				'name_prefix',
				$elm$json$Json$Encode$string(teacher.aY)),
				_Utils_Tuple2(
				'first_name',
				$elm$json$Json$Encode$string(teacher.lI)),
				_Utils_Tuple2(
				'last_name',
				$elm$json$Json$Encode$string(teacher.av)),
				_Utils_Tuple2(
				'is_family_name_first',
				$elm$json$Json$Encode$bool(teacher.bh)),
				_Utils_Tuple2(
				'email',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, teacher.O)),
				_Utils_Tuple2(
				'phone_number',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, teacher.a$)),
				_Utils_Tuple2(
				'permanent_address',
				A2($author$project$Data$encodeNullable, $author$project$Person$addressEncoder, teacher.dp)),
				_Utils_Tuple2(
				'temporary_address',
				A2($author$project$Data$encodeNullable, $author$project$Person$addressEncoder, teacher.n3)),
				_Utils_Tuple2(
				'birthdate',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, teacher.aP)),
				_Utils_Tuple2(
				'birthplace_country',
				$elm$json$Json$Encode$string(teacher.aR)),
				_Utils_Tuple2(
				'birthplace',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, teacher.aS)),
				_Utils_Tuple2(
				'nationality',
				$elm$json$Json$Encode$string(teacher.aC)),
				_Utils_Tuple2(
				'edu_id',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$int, teacher.ap)),
				_Utils_Tuple2(
				'mentor',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$int, teacher.my))
			]));
};
var $author$project$TeacherProfile$teacherProfileEncoder = function (profile) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(
					$author$project$TeacherProfile$teacherProfileIdToInt(profile.i8))),
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(profile.fs)),
				_Utils_Tuple2(
				'teacher',
				$author$project$TeacherProfile$teacherEncoder(profile.n2)),
				_Utils_Tuple2(
				'birth_first_name',
				$elm$json$Json$Encode$string(profile.ak)),
				_Utils_Tuple2(
				'birth_last_name',
				$elm$json$Json$Encode$string(profile.al)),
				_Utils_Tuple2(
				'birth_has_family_name_first',
				$elm$json$Json$Encode$bool(profile.aQ)),
				_Utils_Tuple2(
				'mother_name_prefix',
				$elm$json$Json$Encode$string(profile.aA)),
				_Utils_Tuple2(
				'mother_first_name',
				$elm$json$Json$Encode$string(profile.ay)),
				_Utils_Tuple2(
				'mother_last_name',
				$elm$json$Json$Encode$string(profile.az)),
				_Utils_Tuple2(
				'mother_has_family_name_first',
				$elm$json$Json$Encode$bool(profile.aX)),
				_Utils_Tuple2(
				'highest_education_level',
				$elm$json$Json$Encode$int(profile.aU)),
				_Utils_Tuple2(
				'apprenticeship_years',
				$elm$json$Json$Encode$int(profile.aO)),
				_Utils_Tuple2(
				'is_academic_member',
				$elm$json$Json$Encode$bool(profile.aV)),
				_Utils_Tuple2(
				'diploma_url',
				$elm$json$Json$Encode$string(profile.v))
			]));
};
var $author$project$TeacherProfile$updateTeacherProfile = F3(
	function (config, profile, callback) {
		return A5(
			$author$project$Api$put,
			A2($author$project$Api$Endpoint$teacherProfile, config, profile.n2.i8),
			config,
			$elm$http$Http$jsonBody(
				$author$project$TeacherProfile$teacherProfileEncoder(profile)),
			callback,
			$author$project$TeacherProfile$teacherProfileDecoder);
	});
var $author$project$Element$TeacherProfileForm$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			aO: $author$project$Form$markEdited(form.aO),
			aP: $author$project$Form$markEdited(form.aP),
			ak: $author$project$Form$markEdited(form.ak),
			aQ: $author$project$Form$markEdited(form.aQ),
			al: $author$project$Form$markEdited(form.al),
			aR: $author$project$Form$markEdited(form.aR),
			aS: $author$project$Form$markEdited(form.aS),
			v: $author$project$Form$markEdited(form.v),
			ap: $author$project$Form$markEdited(form.ap),
			O: $author$project$Form$markEdited(form.O),
			lI: $author$project$Form$markEdited(form.lI),
			aU: $author$project$Form$markEdited(form.aU),
			aV: $author$project$Form$markEdited(form.aV),
			av: $author$project$Form$markEdited(form.av),
			my: $author$project$Form$markEdited(form.my),
			ay: $author$project$Form$markEdited(form.ay),
			aX: $author$project$Form$markEdited(form.aX),
			az: $author$project$Form$markEdited(form.az),
			aA: $author$project$Form$markEdited(form.aA),
			aY: $author$project$Form$markEdited(form.lI),
			aC: $author$project$Form$markEdited(form.aC),
			a1: $author$project$Form$markEdited(form.a1),
			a2: $author$project$Form$markEdited(form.a2),
			a3: $author$project$Form$markEdited(form.a3),
			a4: $author$project$Form$markEdited(form.a4),
			a5: $author$project$Form$markEdited(form.a5),
			a6: $author$project$Form$markEdited(form.a6),
			a7: $author$project$Form$markEdited(form.a7),
			a$: $author$project$Form$markEdited(form.a$)
		});
};
var $author$project$Element$TeacherProfileForm$update = F3(
	function (session, msg, model) {
		update:
		while (true) {
			var config = model.b_;
			var noop = A2($author$project$Application$Boundaries$save, model, session);
			var _v0 = _Utils_Tuple2(msg, model.bk);
			_v0$21:
			while (true) {
				switch (_v0.a.$) {
					case 3:
						var popupMsg = _v0.a.a;
						var _v1 = _Utils_Tuple2(popupMsg, model.eq);
						if (!_v1.b.$) {
							var documentViewerMsg = _v1.a;
							var documentViewerModel = _v1.b.a;
							var _return = A5($author$project$Application$V2$Boundaries$updateElement, config.jk, session, documentViewerMsg, documentViewerModel, $author$project$Element$TeacherProfileForm$popups.d0);
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{eq: $elm$core$Maybe$Nothing}),
								_return.gB);
						} else {
							return noop;
						}
					case 5:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 1) {
								var profile = _v0.a.a.a;
								var teacherId = _v0.b.a;
								var formValues = $author$project$Element$TeacherProfileForm$fillForm(profile);
								var form = A3(
									$author$project$Element$TeacherProfileForm$updateMentorOptions,
									session.h6,
									model.gn,
									$author$project$Element$TeacherProfileForm$buildForm(session.h6));
								if (_Utils_eq(profile.n2.i8, teacherId)) {
									var page = $author$project$Element$TeacherProfileForm$FormPage(
										{bE: form, j: profile, fs: 0, eI: formValues});
									return A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										session);
								} else {
									return noop;
								}
							} else {
								break _v0$21;
							}
						} else {
							var error = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgTeacherProfileDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$TeacherProfileForm$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$TeacherProfilesDownloadError))));
						}
					case 6:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 2) {
								var phonebook = _v0.a.a.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var page = $author$project$Element$TeacherProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: A3($author$project$Element$TeacherProfileForm$updateMentorOptions, session.h6, phonebook, form)
										}));
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{bk: page, gn: phonebook}),
									session);
							} else {
								var phonebook = _v0.a.a.a;
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{gn: phonebook}),
									session);
							}
						} else {
							var error = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgPeopleDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeTeacherProfiles),
										error),
									$elm$core$Basics$always($author$project$Element$TeacherProfileForm$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$PhoneBookDownloadError))));
						}
					case 12:
						if (_v0.b.$ === 2) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gX,
									{bt: documentUrl, nx: $author$project$Element$TeacherProfileForm$awsPolicyScope},
									$author$project$Element$TeacherProfileForm$DiplomaSignatureDownloaded),
								noop);
						} else {
							break _v0$21;
						}
					case 13:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 2) {
								var signature = _v0.a.a.a;
								var doc = $author$project$S3$document(signature);
								var params = {
									fa: $elm$core$Maybe$Just(doc.fa),
									K: doc.K
								};
								return A3(
									$author$project$Application$V2$Boundaries$mapElement,
									A2($author$project$Application$Boundaries$save, model, session),
									$author$project$Element$TeacherProfileForm$popups.d0,
									A5(
										$author$project$Application$V2$Boundaries$initElement,
										model.b_.jk,
										$author$project$Application$V2$SharedConfig$fromV1(model.b_),
										session,
										$author$project$Element$TeacherProfileForm$popups.d0,
										params));
							} else {
								break _v0$21;
							}
						} else {
							if (_v0.b.$ === 2) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$TeacherProfile$teacherProfileIdToInt(profile.i8))),
											error),
										$elm$core$Basics$always($author$project$Element$TeacherProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.h6($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$21;
							}
						}
					case 8:
						if (_v0.b.$ === 2) {
							var _v2 = _v0.a;
							var fieldMsg = _v2.a;
							var documentType = _v2.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$TeacherProfileForm$acceptedMimeTypes,
									A2($author$project$Element$TeacherProfileForm$DiplomaFileSelected, fieldMsg, documentType)),
								noop);
						} else {
							break _v0$21;
						}
					case 9:
						if (_v0.b.$ === 2) {
							var _v3 = _v0.a;
							var fieldMsg = _v3.a;
							var documentType = _v3.b;
							var file = _v3.c;
							var formPage = _v0.b.a;
							var form = formPage.bE;
							var values = formPage.eI;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.v.ks,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.v.ks,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								ls: documentType,
								mD: $elm$file$File$mime(file),
								m9: $elm$core$String$fromInt(profile.n2.i8),
								nx: $author$project$Element$TeacherProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.v, valuesWithFileSelected)) {
								var page = $author$project$Element$TeacherProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													v: $author$project$Form$markEdited(form.v)
												}),
											eI: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gX,
										params,
										A2($author$project$Element$TeacherProfileForm$DiplomaPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										session));
							} else {
								var page = $author$project$Element$TeacherProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bE: _Utils_update(
												form,
												{
													v: $author$project$Form$markEdited(form.v)
												}),
											eI: valuesWithFileError
										}));
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{bk: page}),
									session);
							}
						} else {
							break _v0$21;
						}
					case 10:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 2) {
								var _v4 = _v0.a;
								var fieldMsg = _v4.a;
								var file = _v4.b;
								var policy = _v4.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gX,
										policy,
										file,
										A2($author$project$Element$TeacherProfileForm$DiplomaFileUploaded, fieldMsg, file)),
									noop);
							} else {
								break _v0$21;
							}
						} else {
							if (_v0.b.$ === 2) {
								var _v5 = _v0.a;
								var error = _v5.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var page = $author$project$Element$TeacherProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											eI: A2(form.v.ks, $author$project$Form$NoFile, values)
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$TeacherProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										A3(
											$author$project$Session$error,
											session,
											error,
											session.h6($author$project$Locale$Messages$FormFileUploadError))));
							} else {
								break _v0$21;
							}
						}
					case 11:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 2) {
								var _v6 = _v0.a;
								var fieldMsg = _v6.a;
								var file = _v6.b;
								var metadata = _v6.c.a;
								var _v7 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ar);
								if (!_v7.$) {
									var location = _v7.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$TeacherProfileForm$DiplomaFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$21;
							}
						} else {
							if (_v0.b.$ === 2) {
								var _v8 = _v0.a;
								var error = _v8.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bE;
								var values = formPage.eI;
								var page = $author$project$Element$TeacherProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											eI: A2(form.v.ks, $author$project$Form$NoFile, values)
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgFileUpload,
											$elm$core$Maybe$Just('teacher_profiles'),
											error),
										$elm$core$Basics$always($author$project$Element$TeacherProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bk: page}),
										A3(
											$author$project$Session$error,
											session,
											error,
											session.h6($author$project$Locale$Messages$FormFileUploadError))));
							} else {
								break _v0$21;
							}
						}
					case 0:
						if (_v0.b.$ === 2) {
							var fieldMsg = _v0.a.a;
							var formPage = _v0.b.a;
							var _v9 = A3($author$project$Element$TeacherProfileForm$updateForm, fieldMsg, formPage.bE, formPage.eI);
							var form = _v9.a;
							var values = _v9.b;
							var page = $author$project$Element$TeacherProfileForm$FormPage(
								_Utils_update(
									formPage,
									{bE: form, fs: 1, eI: values}));
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{bk: page}),
								session);
						} else {
							break _v0$21;
						}
					case 2:
						if (_v0.b.$ === 2) {
							var personId = _v0.a.a;
							return A3($author$project$Element$TeacherProfileForm$openFormPage, personId, session, model);
						} else {
							break _v0$21;
						}
					case 1:
						if (_v0.b.$ === 2) {
							var _v10 = _v0.a;
							var formPage = _v0.b.a;
							var form = formPage.bE;
							var values = formPage.eI;
							var profile = formPage.j;
							return A2($author$project$Element$TeacherProfileForm$isFormValid, form, values) ? A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$TeacherProfile$updateTeacherProfile,
									config.gX,
									A3($author$project$Element$TeacherProfileForm$saveForm, form, values, profile),
									$author$project$Element$TeacherProfileForm$ProfileSaved),
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bk: $author$project$Element$TeacherProfileForm$FormPage(
												_Utils_update(
													formPage,
													{fs: 2}))
										}),
									session)) : A2(
								$author$project$Application$Boundaries$andThenCmd,
								$author$project$Ports$scrollToFormError,
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bk: $author$project$Element$TeacherProfileForm$FormPage(
												_Utils_update(
													formPage,
													{
														bE: $author$project$Element$TeacherProfileForm$validateForm(form),
														fs: 1
													}))
										}),
									session));
						} else {
							break _v0$21;
						}
					case 4:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 2) {
								var newProfile = _v0.a.a.a;
								var formPage = _v0.b.a;
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bk: $author$project$Element$TeacherProfileForm$FormPage(
												_Utils_update(
													formPage,
													{j: newProfile, fs: 0}))
										}),
									A2(
										$author$project$Session$ok,
										session,
										session.h6($author$project$Locale$Messages$TeacherProfilesSaveSuccess)));
							} else {
								break _v0$21;
							}
						} else {
							if (_v0.b.$ === 2) {
								var error = _v0.a.a.a;
								var formPage = _v0.b.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3($author$project$Log$msgTeacherProfileSave, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$TeacherProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bk: $author$project$Element$TeacherProfileForm$FormPage(
													_Utils_update(
														formPage,
														{fs: 3}))
											}),
										A3(
											$author$project$Session$error,
											session,
											error,
											session.h6($author$project$Locale$Messages$FormSaveError))));
							} else {
								break _v0$21;
							}
						}
					default:
						var _v11 = _v0.a;
						return noop;
				}
			}
			return noop;
		}
	});
var $author$project$Locale$Messages$TeacherProfilesLoadingProgress = {$: 598};
var $author$project$Locale$Messages$TeacherProfilesNotFound = {$: 599};
var $author$project$Element$TeacherProfileForm$DiplomaFileDownloadRequested = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$TeacherProfileForm$DiplomaFileUploadRequested = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Element$TeacherProfileForm$FormReset = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$TeacherProfileForm$FormSubmitted = {$: 1};
var $author$project$Locale$Messages$TeacherProfilesDocumentUploadHelp = {$: 594};
var $author$project$Locale$Messages$TeacherProfilesHeadingBirth = {$: 590};
var $author$project$Locale$Messages$TeacherProfilesHeadingContact = {$: 591};
var $author$project$Locale$Messages$TeacherProfilesHeadingProfessional = {$: 592};
var $author$project$Element$TeacherProfileForm$viewForm = F3(
	function (t_, language, _v0) {
		var state = _v0.fs;
		var form = _v0.bE;
		var values = _v0.eI;
		var profile = _v0.j;
		var heading = function (caption) {
			return A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('heading has-background-light')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('has-text-info')
							]),
						_List_fromArray(
							[
								$author$project$UI$Icon$profile(
								_List_fromArray(
									[
										$author$project$UI$Icon$face('fa-lg'),
										$author$project$UI$Icon$style('is-medium')
									]))
							])),
						caption
					]));
		};
		var viewFormFields = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth')
				]),
			_List_fromArray(
				[
					function () {
					var _v1 = profile.n2.O;
					if (!_v1.$) {
						var email = _v1.a;
						return $author$project$UI$columns(
							_List_fromArray(
								[
									A4(
									$author$project$UI$mediaObject,
									_List_fromArray(
										[
											$author$project$UI$gravatar(email)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$small,
											_List_Nil,
											$author$project$UI$textToHtml(
												t_(
													$author$project$Locale$Messages$ProfilesGravatar(email))))
										]),
									_List_Nil,
									_List_Nil)
								]));
					} else {
						return $author$project$UI$none;
					}
				}(),
					$author$project$UI$columns(
					language.l4 ? _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.aY, values),
							A3($author$project$UI$textField, t_, form.lI, values),
							A3($author$project$UI$textField, t_, form.av, values)
						]) : _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.aY, values),
							A3($author$project$UI$textField, t_, form.av, values),
							A3($author$project$UI$textField, t_, form.lI, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$toggleField, t_, form.bh, values)
						])),
					heading(
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TeacherProfilesHeadingBirth)),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.aR, values),
							A3($author$project$UI$textField, t_, form.aS, values),
							A3($author$project$UI$dateField, t_, form.aP, values)
						])),
					$author$project$UI$columns(
					language.l4 ? _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.ak, values),
							A3($author$project$UI$textField, t_, form.al, values)
						]) : _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.al, values),
							A3($author$project$UI$textField, t_, form.ak, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$toggleField, t_, form.aQ, values)
						])),
					$author$project$UI$columns(
					language.l4 ? _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.aA, values),
							A3($author$project$UI$textField, t_, form.ay, values),
							A3($author$project$UI$textField, t_, form.az, values)
						]) : _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.aA, values),
							A3($author$project$UI$textField, t_, form.az, values),
							A3($author$project$UI$textField, t_, form.ay, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$toggleField, t_, form.aX, values),
							A3($author$project$UI$choiceField, t_, form.aC, values)
						])),
					heading(
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TeacherProfilesHeadingContact)),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$staticTextField, t_, form.O, values),
							A3($author$project$UI$textField, t_, form.a$, values)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('heading')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PersonAddress)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.a1, values),
							A3($author$project$UI$textField, t_, form.a7, values),
							A3($author$project$UI$textField, t_, form.a2, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.a4, values),
							A3($author$project$UI$textField, t_, form.a6, values),
							A3($author$project$UI$textField, t_, form.a5, values),
							A3($author$project$UI$textField, t_, form.a3, values)
						])),
					heading(
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TeacherProfilesHeadingProfessional)),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.aU, values),
							A3($author$project$UI$textField, t_, form.aO, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$TeacherProfilesDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.v, values, $author$project$Element$TeacherProfileForm$DiplomaFileUploadRequested, $author$project$Element$TeacherProfileForm$DiplomaFileDownloadRequested)),
							A3($author$project$UI$textField, t_, form.ap, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$toggleField, t_, form.aV, values),
							A3($author$project$UI$choiceField, t_, form.my, values)
						]))
				]));
		var formState = A2($author$project$Form$isUploading, form.v, values) ? 2 : state;
		return $author$project$UI$panel(
			{
				g$: _List_fromArray(
					[
						viewFormFields,
						A5(
						$author$project$UI$formButtons,
						t_,
						$author$project$Form$Update(profile.n2.i8),
						formState,
						$author$project$Element$TeacherProfileForm$FormSubmitted,
						$author$project$Element$TeacherProfileForm$FormReset)
					]),
				cm: 'teacher-profile-form',
				hl: _List_fromArray(
					[
						A2(
						$author$project$UI$caption,
						t_,
						$author$project$Locale$Messages$TeacherProfilesTitle(
							A2($author$project$Person$fullName, t_, profile.n2)))
					]),
				h7: _List_Nil,
				ie: 'is-light'
			});
	});
var $author$project$Element$TeacherProfileForm$viewPopup = F2(
	function (session, model) {
		var popupModel = model;
		return A3($author$project$Application$V2$Boundaries$viewElement, session, popupModel, $author$project$Element$TeacherProfileForm$popups.d0);
	});
var $author$project$Element$TeacherProfileForm$view = F2(
	function (session, model) {
		var t_ = session.h6;
		var _v0 = model.bk;
		switch (_v0.$) {
			case 2:
				var formPage = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$maybe,
							model.eq,
							$author$project$Element$TeacherProfileForm$viewPopup(session)),
							A3($author$project$Element$TeacherProfileForm$viewForm, t_, session.mn, formPage)
						]));
			case 1:
				return A2(
					$author$project$UI$progressBar,
					'is-primary',
					t_($author$project$Locale$Messages$TeacherProfilesLoadingProgress));
			default:
				return $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TeacherProfilesNotFound)
						]));
		}
	});
var $author$project$Element$TeacherProfileForm$element = {jb: $author$project$Element$TeacherProfileForm$init, ks: $author$project$Element$TeacherProfileForm$update, og: $author$project$Element$TeacherProfileForm$view};
var $author$project$Element$TimetableCalendar$PeopleSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$Timetable$TimetableCalendarMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Application$Boundaries$wrap = F4(
	function (mapModel_, msgMap, reply2, return_) {
		return {
			dX: A2($elm$core$Platform$Cmd$map, msgMap, return_.dX),
			eh: mapModel_(return_.eh),
			gs: reply2,
			gB: return_.gB
		};
	});
var $author$project$Application$Boundaries$mapElement = F3(
	function (bigModel, element, return_) {
		return A4(
			$author$project$Application$Boundaries$wrap,
			element.iz(bigModel),
			element.jv,
			$elm$core$Maybe$Nothing,
			return_);
	});
var $author$project$Element$TimetableCalendar$PeopleListDownloaded = function (a) {
	return {$: 12, a: a};
};
var $author$project$ACL$canViewTimetablesOther = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$Element$TimetableCalendar$emptyFilters = {m6: _List_Nil, h9: _List_Nil};
var $author$project$Person$fetchStudentsAndTeachers = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$peopleStudentsAndTeachers(config),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$Person$phoneBookDecoder));
	});
var $author$project$Element$TimetableCalendar$updatePeopleSelected = F3(
	function (viewer, selected, filter) {
		return _Utils_update(
			filter,
			{
				m6: $elm$core$List$isEmpty(selected) ? _List_fromArray(
					[viewer.i8]) : selected
			});
	});
var $author$project$Element$TimetableCalendar$init = F3(
	function (config, session, params) {
		var model = {
			b_: config,
			bc: $elm$core$Dict$empty,
			ad: A3($author$project$Element$TimetableCalendar$updatePeopleSelected, session.ok, params, $author$project$Element$TimetableCalendar$emptyFilters),
			m6: $elm$core$Maybe$Nothing,
			dN: $elm$core$Maybe$Nothing
		};
		var cmd = $author$project$ACL$canViewTimetablesOther(session.ok) ? A2($author$project$Person$fetchStudentsAndTeachers, config.gX, $author$project$Element$TimetableCalendar$PeopleListDownloaded) : $elm$core$Platform$Cmd$none;
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A2($author$project$Application$Boundaries$save, model, session));
	});
var $author$project$Element$TimetableCalendar$CreateForm = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$TimetableCalendar$DetailView = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TimetableCalendar$ModuleEventOccurenceResized = function (a) {
	return {$: 11, a: a};
};
var $author$project$Element$TimetableCalendar$NoOp = {$: 0};
var $author$project$Element$TimetableCalendar$RecordDailyAttendance = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$TimetableDownloadError = {$: 609};
var $author$project$Locale$Messages$TimetableOccurenceSaveError = {$: 626};
var $author$project$Locale$Messages$TimetableOccurenceSaveSuccess = {$: 625};
var $author$project$Element$TimetableCalendar$ModuleEventOccurencesDownloaded = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$ModuleEvent$defaultTimetableListParams = {jg: $elm$core$Maybe$Nothing, jH: $elm$core$Maybe$Nothing, j0: $elm$core$Maybe$Nothing, kz: $elm$core$Maybe$Nothing};
var $author$project$ModuleEvent$ModuleEventOccurence = function (id) {
	return function (module_) {
		return function (moduleEvent) {
			return function (startTime) {
				return function (endTime) {
					return function (isRescheduled) {
						return function (isCancelled) {
							return function (modificationReason) {
								return function (attendants) {
									return function (absentees) {
										return function (conferenceUrl) {
											return {gR: absentees, gW: attendants, lb: conferenceUrl, G: endTime, i8: id, l1: isCancelled, me: isRescheduled, mI: modificationReason, ek: moduleEvent, hG: module_, R: startTime};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$ModuleEvent$ModuleEventOccurenceId = $elm$core$Basics$identity;
var $author$project$ModuleEvent$moduleEventOccurenceIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$ModuleEvent$NestedModuleEvent = F3(
	function (id, title, notes) {
		return {i8: id, aZ: notes, kj: title};
	});
var $author$project$ModuleEvent$nestedModuleEventDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'notes',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$author$project$ModuleEvent$moduleEventIdDecoder,
			$elm$json$Json$Decode$succeed($author$project$ModuleEvent$NestedModuleEvent))));
var $author$project$ModuleEvent$moduleEventOccurenceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'conference_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'absentees',
		$author$project$Person$nestedPeopleDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'attendants',
			$author$project$Person$nestedPeopleDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'modification_reason',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_cancelled',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'is_rescheduled',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'end_time',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'start_time',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'module_event',
									$author$project$ModuleEvent$nestedModuleEventDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'module',
										$author$project$Module$nestedModuleDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$author$project$ModuleEvent$moduleEventOccurenceIdDecoder,
											$elm$json$Json$Decode$succeed($author$project$ModuleEvent$ModuleEventOccurence))))))))))));
var $author$project$ModuleEvent$moduleEventOccurencesDecoder = $elm$json$Json$Decode$list($author$project$ModuleEvent$moduleEventOccurenceDecoder);
var $author$project$Api$Endpoint$timetable = F2(
	function (config, _v0) {
		var role = _v0.j0;
		var people_ = _v0.jH;
		var weekStart = _v0.kz;
		var interval = _v0.jg;
		var params = A3(
			$author$project$Api$Endpoint$optionalList,
			$elm$core$String$fromInt,
			_Utils_Tuple2('p', people_),
			A3(
				$author$project$Api$Endpoint$optional,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$String$fromInt),
				_Utils_Tuple2('end', interval),
				A3(
					$author$project$Api$Endpoint$optional,
					A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$String$fromInt),
					_Utils_Tuple2('start', interval),
					A3(
						$author$project$Api$Endpoint$optional,
						$elm$core$String$fromInt,
						_Utils_Tuple2('week_start', weekStart),
						A3(
							$author$project$Api$Endpoint$optional,
							$elm$core$Basics$identity,
							_Utils_Tuple2('role', role),
							_List_Nil)))));
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'module-event-occurences']),
			params);
	});
var $author$project$ModuleEvent$fetchOccurences = F4(
	function (config, interval, personId, callback) {
		return A3(
			$author$project$Api$get,
			A2(
				$author$project$Api$Endpoint$timetable,
				config,
				_Utils_update(
					$author$project$ModuleEvent$defaultTimetableListParams,
					{
						jg: $elm$core$Maybe$Just(interval),
						jH: $elm$core$Maybe$Just(
							_List_fromArray(
								[personId]))
					})),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$ModuleEvent$moduleEventOccurencesDecoder));
	});
var $author$project$Element$TimetableCalendar$prefetchInterval = F3(
	function (personId, viewState, eventStore) {
		if (!viewState.$) {
			var currentDate = viewState.a.g5;
			var monthInMillis = (((1000 * 60) * 60) * 24) * 30;
			var prefetchRadiusInMillis = monthInMillis * 2;
			var start_ = currentDate - prefetchRadiusInMillis;
			var end_ = currentDate + prefetchRadiusInMillis;
			var _v1 = A2($elm$core$Dict$get, personId, eventStore);
			if (!_v1.$) {
				var dataStart = _v1.a.e_;
				var dataEnd = _v1.a.eZ;
				return (_Utils_cmp(start_, dataStart) < 0) ? $elm$core$Maybe$Just(
					_Utils_Tuple2(start_, dataStart)) : ((_Utils_cmp(end_, dataEnd) > 0) ? $elm$core$Maybe$Just(
					_Utils_Tuple2(dataEnd, end_)) : $elm$core$Maybe$Nothing);
			} else {
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(start_, end_));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Element$TimetableCalendar$fetchTimetable = function (_v0) {
	var config = _v0.b_;
	var viewState = _v0.dN;
	var filter = _v0.ad;
	var eventStore = _v0.bc;
	var fetchInterval = function (personId) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				function (interval) {
					return A4(
						$author$project$ModuleEvent$fetchOccurences,
						config.gX,
						interval,
						personId,
						A2($author$project$Element$TimetableCalendar$ModuleEventOccurencesDownloaded, interval, personId));
				},
				A3($author$project$Element$TimetableCalendar$prefetchInterval, personId, viewState, eventStore)));
	};
	return $elm$core$Platform$Cmd$batch(
		A2($elm$core$List$map, fetchInterval, filter.m6));
};
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $author$project$ModuleEvent$isSameOccurence = F2(
	function (occ1, occ2) {
		return _Utils_eq(occ1.i8, occ2.i8);
	});
var $author$project$Element$TimetableCalendar$andRefetchStaleTimetables = F2(
	function (occurence, _return) {
		var model = _return.eh;
		var wipeStaleTimetables = $elm$core$Dict$filter(
			F2(
				function (_v0, _v1) {
					var occurences = _v1.cG;
					return !A2(
						$elm$core$List$any,
						$author$project$ModuleEvent$isSameOccurence(occurence),
						occurences);
				}));
		var model2 = _Utils_update(
			model,
			{
				bc: wipeStaleTimetables(model.bc)
			});
		return _Utils_update(
			_return,
			{
				dX: $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							_return.dX,
							$author$project$Element$TimetableCalendar$fetchTimetable(model2)
						])),
				eh: model2
			});
	});
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Element$TimetableCalendar$andUpdateLocalTimetables = F2(
	function (occurence, _return) {
		var model = _return.eh;
		var updateStaleTimetables = $elm$core$Dict$map(
			F2(
				function (_v0, data) {
					return _Utils_update(
						data,
						{
							cG: A3(
								$author$project$Util$List$updateWhen,
								$author$project$ModuleEvent$isSameOccurence(occurence),
								$elm$core$Basics$always(occurence),
								data.cG)
						});
				}));
		var model2 = _Utils_update(
			model,
			{
				bc: updateStaleTimetables(model.bc)
			});
		return _Utils_update(
			_return,
			{eh: model2});
	});
var $author$project$Log$msgModuleEventOccurenceSave = 'module_event_occurence_save';
var $author$project$Log$paramScopeTimetable = 'scope_timetable';
var $author$project$ModuleEvent$unfreeze = function (occ) {
	return {
		gW: A2(
			$elm$core$List$map,
			function ($) {
				return $.i8;
			},
			occ.gW),
		G: occ.G,
		i8: occ.i8,
		R: occ.R
	};
};
var $author$project$Element$TimetableCalendar$updateEventStoreByPerson = F4(
	function (personId, _v0, newOccurences, eventStore) {
		var start = _v0.a;
		var end = _v0.b;
		var updatePersonStore = function (_v1) {
			var dataStart = _v1.e_;
			var dataEnd = _v1.eZ;
			var occurences = _v1.cG;
			return {
				eZ: (_Utils_cmp(end, dataEnd) > 0) ? end : dataEnd,
				e_: (_Utils_cmp(start, dataStart) < 0) ? start : dataStart,
				cG: $author$project$Util$List$unique(
					_Utils_ap(occurences, newOccurences))
			};
		};
		var initialStore = {eZ: end, e_: start, cG: newOccurences};
		var personStore = A2(
			$elm$core$Maybe$withDefault,
			initialStore,
			A2(
				$elm$core$Maybe$map,
				updatePersonStore,
				A2($elm$core$Dict$get, personId, eventStore)));
		return A3($elm$core$Dict$insert, personId, personStore, eventStore);
	});
var $author$project$Api$Endpoint$moduleEventOccurence = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'module-event-occurences',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$ModuleEvent$moduleEventOccurenceIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$ModuleEvent$moduleEventOccurenceEncoder = function (occurence) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(
					$author$project$ModuleEvent$moduleEventOccurenceIdToInt(occurence.i8))),
				_Utils_Tuple2(
				'start_time',
				$elm$json$Json$Encode$int(occurence.R)),
				_Utils_Tuple2(
				'end_time',
				$elm$json$Json$Encode$int(occurence.G)),
				_Utils_Tuple2(
				'attendants',
				A2(
					$elm$json$Json$Encode$list,
					function (student) {
						return $elm$json$Json$Encode$int(student);
					},
					occurence.gW))
			]));
};
var $author$project$ModuleEvent$updateModuleEventOccurence = F3(
	function (config, occurence, callback) {
		return A5(
			$author$project$Api$put,
			A2(
				$author$project$Api$Endpoint$moduleEventOccurence,
				config,
				$author$project$ModuleEvent$moduleEventOccurenceIdToInt(occurence.i8)),
			config,
			$elm$http$Http$jsonBody(
				$author$project$ModuleEvent$moduleEventOccurenceEncoder(occurence)),
			callback,
			$author$project$ModuleEvent$moduleEventOccurenceDecoder);
	});
var $author$project$Element$TimetableCalendar$update = F3(
	function (session, msg, model) {
		var t_ = session.h6;
		var viewer = session.ok;
		var config = model.b_;
		var filter = model.ad;
		switch (msg.$) {
			case 0:
				return A2($author$project$Application$Boundaries$save, model, session);
			case 2:
				var emptyStore = _Utils_update(
					model,
					{bc: $elm$core$Dict$empty});
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					$author$project$Element$TimetableCalendar$fetchTimetable(emptyStore),
					A2($author$project$Application$Boundaries$save, emptyStore, session));
			case 4:
				var occurence = msg.a;
				return A2(
					$author$project$Element$TimetableCalendar$andUpdateLocalTimetables,
					occurence,
					A2($author$project$Application$Boundaries$save, model, session));
			case 3:
				var occurence = msg.a;
				return A2(
					$author$project$Element$TimetableCalendar$andRefetchStaleTimetables,
					occurence,
					A2($author$project$Application$Boundaries$save, model, session));
			case 7:
				var occurence = msg.a.jB;
				var start = msg.a.h2;
				var end = msg.a.hb;
				var occurenceUpdated = _Utils_update(
					occurence,
					{G: end, R: start});
				var occurenceUnsaved = $author$project$ModuleEvent$unfreeze(occurence);
				var occurenceUnsaved2 = _Utils_update(
					occurenceUnsaved,
					{G: end, R: start});
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A3($author$project$ModuleEvent$updateModuleEventOccurence, config.gX, occurenceUnsaved2, $author$project$Element$TimetableCalendar$ModuleEventOccurenceResized),
					A2(
						$author$project$Element$TimetableCalendar$andUpdateLocalTimetables,
						occurenceUpdated,
						A2($author$project$Application$Boundaries$save, model, session)));
			case 5:
				var occurence = msg.a;
				return A2(
					$author$project$Application$Boundaries$reply,
					$author$project$Element$TimetableCalendar$DetailView(occurence),
					A2($author$project$Application$Boundaries$save, model, session));
			case 6:
				var viewState = msg.a;
				var model2 = _Utils_update(
					model,
					{
						dN: $elm$core$Maybe$Just(viewState)
					});
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					$author$project$Element$TimetableCalendar$fetchTimetable(model2),
					A2($author$project$Application$Boundaries$save, model2, session));
			case 8:
				var slot = msg.a;
				return A2(
					$author$project$Application$Boundaries$reply,
					$author$project$Element$TimetableCalendar$CreateForm(slot),
					A2($author$project$Application$Boundaries$save, model, session));
			case 1:
				var peopleIds = msg.a;
				var model2 = _Utils_update(
					model,
					{
						ad: A3($author$project$Element$TimetableCalendar$updatePeopleSelected, viewer, peopleIds, filter)
					});
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					$author$project$Element$TimetableCalendar$fetchTimetable(model2),
					A2($author$project$Application$Boundaries$save, model2, session));
			case 12:
				if (!msg.a.$) {
					var people = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								m6: $elm$core$Maybe$Just(people)
							}),
						session);
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgPeopleDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
								error),
							$elm$core$Basics$always($author$project$Element$TimetableCalendar$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$PortfoliosPeopleDownloadError))));
				}
			case 10:
				if (!msg.c.$) {
					var interval = msg.a;
					var personId = msg.b;
					var newOccurences = msg.c.a;
					var eventStore = A4($author$project$Element$TimetableCalendar$updateEventStoreByPerson, personId, interval, newOccurences, model.bc);
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{bc: eventStore}),
						session);
				} else {
					var error = msg.c.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							model.b_,
							_Utils_Tuple3(
								$author$project$Log$msgModuleEventsDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
								error),
							$elm$core$Basics$always($author$project$Element$TimetableCalendar$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								session.h6($author$project$Locale$Messages$TimetableDownloadError))));
				}
			case 11:
				if (!msg.a.$) {
					return A2(
						$author$project$Application$Boundaries$save,
						model,
						A2(
							$author$project$Session$ok,
							session,
							session.h6($author$project$Locale$Messages$TimetableOccurenceSaveSuccess)));
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgModuleEventOccurenceSave,
								$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
								error),
							$elm$core$Basics$always($author$project$Element$TimetableCalendar$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								session.h6($author$project$Locale$Messages$TimetableOccurenceSaveError))));
				}
			default:
				var date = msg.a;
				return A2(
					$author$project$Application$Boundaries$reply,
					$author$project$Element$TimetableCalendar$RecordDailyAttendance(date),
					A2($author$project$Application$Boundaries$save, model, session));
		}
	});
var $author$project$Locale$Messages$TimetableLoadingProgress = {$: 623};
var $author$project$Locale$Messages$TimetableStudents = {$: 622};
var $author$project$Locale$Messages$TimetableTeachers = {$: 621};
var $elm$html$Html$aside = _VirtualDom_node('aside');
var $author$project$UI$checkboxStyled = F5(
	function (style, toMsg, dataTag, selectedValues, option) {
		var checked_ = A2($elm$core$List$member, option.fC, selectedValues);
		var onClick_ = toMsg(
			checked_ ? A2($author$project$Util$List$removeElem, option.fC, selectedValues) : A2($elm$core$List$cons, option.fC, selectedValues));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(onClick_)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(dataTag),
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$class('is-checkradio ' + style),
							$elm$html$Html$Attributes$name(dataTag),
							$author$project$UI$attrCyData(dataTag),
							$elm$html$Html$Attributes$checked(checked_)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(dataTag)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(option.ea)
						]))
				]));
	});
var $author$project$Form$decodePersonIdList = $elm$core$List$filterMap($elm$core$String$toInt);
var $author$project$Element$TimetableCalendar$colorPaletteSize = 12;
var $author$project$Element$TimetableCalendar$getColorIndexByPerson = F2(
	function (viewer, personId) {
		return _Utils_eq(viewer.i8, personId) ? 0 : (personId % $author$project$Element$TimetableCalendar$colorPaletteSize);
	});
var $author$project$Element$TimetableCalendar$personHasMissingEvents = F3(
	function (viewState, eventStore, personId) {
		var _v0 = _Utils_Tuple2(
			A2($elm$core$Dict$get, personId, eventStore),
			viewState);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var dataStart = _v0.a.a.e_;
			var dataEnd = _v0.a.a.eZ;
			var viewStart = _v0.b.a.kw;
			var viewEnd = _v0.b.a.kv;
			return (_Utils_cmp(viewStart, dataStart) < 0) || (_Utils_cmp(viewEnd, dataEnd) > 0);
		} else {
			return true;
		}
	});
var $author$project$Element$TimetableCalendar$personEventsLoading = F4(
	function (viewState, filter, eventStore, person) {
		return A2($elm$core$List$member, person.i8, filter.m6) && A3($author$project$Element$TimetableCalendar$personHasMissingEvents, viewState, eventStore, person.i8);
	});
var $author$project$Element$TimetableCalendar$viewCalendarsSidebar = F3(
	function (_v0, model, people) {
		var viewer = _v0.ok;
		var t_ = _v0.h6;
		var teachersInViewerTeams = A2(
			$author$project$Person$teachersInTeams,
			$author$project$Person$teamsAsTom(viewer),
			people);
		var studentsInViewerTeams = A2(
			$author$project$Person$studentsInTeams,
			$author$project$Person$teamsAsTom(viewer),
			people);
		var selectedValues = A2($elm$core$List$map, $elm$core$String$fromInt, model.ad.m6);
		var viewCheckboxes = F2(
			function (dataTag, people_) {
				return A2(
					$elm$core$List$map,
					function (person) {
						var dataTagWithParam = dataTag + (' ' + person.O);
						var computedStyle = 'has-background-color is-small is-calendar-' + $elm$core$String$fromInt(
							A2($author$project$Element$TimetableCalendar$getColorIndexByPerson, viewer, person.i8));
						return A4($author$project$Element$TimetableCalendar$personEventsLoading, model.dN, model.ad, model.bc, person) ? A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('field')
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$icon(
									_List_fromArray(
										[
											$author$project$UI$Icon$face('fa-spinner fa-spin'),
											$author$project$UI$Icon$style('icon-calendar')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('is-size-7')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Person$fullName, t_, person))
										]))
								])) : A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('field')
								]),
							_List_fromArray(
								[
									A5(
									$author$project$UI$checkboxStyled,
									computedStyle,
									A2($elm$core$Basics$composeL, $author$project$Element$TimetableCalendar$PeopleSelected, $author$project$Form$decodePersonIdList),
									dataTagWithParam,
									selectedValues,
									$author$project$Form$toSelectOption(
										_Utils_Tuple2(
											$elm$core$String$fromInt(person.i8),
											A2($author$project$Person$fullName, t_, person))))
								]));
					},
					A2(
						$author$project$Util$List$sortBy,
						$author$project$Person$fullName(t_),
						people_));
			});
		return A2(
			$elm$html$Html$aside,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('menu menu-calendar')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('menu-label')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableTeachers)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('menu-list')
						]),
					A2(viewCheckboxes, 'timetable-filter-teachers', teachersInViewerTeams)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('menu-label')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableStudents)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('menu-list')
						]),
					A2(viewCheckboxes, 'timetable-filter-students', studentsInViewerTeams))
				]));
	});
var $author$project$Element$TimetableCalendar$CalendarViewChanged = function (a) {
	return {$: 6, a: a};
};
var $author$project$Locale$Messages$DailyAttendanceButtonText = {$: 51};
var $author$project$Element$TimetableCalendar$DailyAttendanceSelected = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$TimetableCalendar$OccurenceDetailViewSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$TimetableCalendar$OccurenceTimeChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$TimetableCalendar$TimeSlotSelected = function (a) {
	return {$: 8, a: a};
};
var $author$project$ACL$canManageDailyAttendance = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isTeacher(person);
};
var $author$project$ACL$canManageTimetable = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$Element$TimetableCalendar$CalendarView = F4(
	function (currentDate, viewStart, viewEnd, viewType) {
		return {g5: currentDate, kv: viewEnd, kw: viewStart, kx: viewType};
	});
var $author$project$Element$TimetableCalendar$decodeIso8601 = A2(
	$elm$json$Json$Decode$andThen,
	function (dateStr) {
		return A2(
			$elm$core$Result$withDefault,
			$elm$json$Json$Decode$fail('Invalid date format, ISO8601 expected: ' + dateStr),
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$json$Json$Decode$succeed),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateStr)));
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Element$TimetableCalendar$decodeCalendarView = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail']),
	A5(
		$elm$json$Json$Decode$map4,
		$author$project$Element$TimetableCalendar$CalendarView,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['currentDate']),
			$author$project$Element$TimetableCalendar$decodeIso8601),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['viewStart']),
			$author$project$Element$TimetableCalendar$decodeIso8601),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['viewEnd']),
			$author$project$Element$TimetableCalendar$decodeIso8601),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['viewType']),
			$elm$json$Json$Decode$string)));
var $author$project$Element$TimetableCalendar$decodeDate = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail', 'date']),
	$author$project$Element$TimetableCalendar$decodeIso8601);
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Element$TimetableCalendar$findOccurenceById = F2(
	function (eventStore, id) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (occ) {
					return _Utils_eq(occ.i8, id);
				},
				A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.cG;
					},
					$elm$core$Dict$values(eventStore))));
	});
var $author$project$Element$TimetableCalendar$decodeOccurence = function (eventStore) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (id) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Decode$fail('Module event occurence was not found: ' + id),
				A2(
					$elm$core$Maybe$map,
					$elm$json$Json$Decode$succeed,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Basics$identity,
							$author$project$Element$TimetableCalendar$findOccurenceById(eventStore)),
						$elm$core$String$toInt(id))));
		},
		$elm$json$Json$Decode$string);
};
var $author$project$Element$TimetableCalendar$decodeOccurenceDetail = function (eventStore) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['detail']),
		$author$project$Element$TimetableCalendar$decodeOccurence(eventStore));
};
var $author$project$Element$TimetableCalendar$OccurenceTimeChange = F3(
	function (occurence, start, end) {
		return {hb: end, jB: occurence, h2: start};
	});
var $author$project$Element$TimetableCalendar$decodeOccurenceTimeChange = function (eventStore) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['detail']),
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$Element$TimetableCalendar$OccurenceTimeChange,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['eventId']),
				$author$project$Element$TimetableCalendar$decodeOccurence(eventStore)),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['start']),
				$author$project$Element$TimetableCalendar$decodeIso8601),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['end']),
				$author$project$Element$TimetableCalendar$decodeIso8601)));
};
var $author$project$Element$TimetableCalendar$decodeTimeSlot = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail']),
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Tuple$pair,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['start']),
			$author$project$Element$TimetableCalendar$decodeIso8601),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['end']),
			$author$project$Element$TimetableCalendar$decodeIso8601)));
var $author$project$Element$TimetableCalendar$HSLColor = F3(
	function (hue, saturation, lightness) {
		return {hn: hue, hB: lightness, hU: saturation};
	});
var $author$project$Element$TimetableCalendar$colorByPerson = F2(
	function (viewer, personId) {
		var saturation = 71;
		var lightness = 44;
		var idx = A2($author$project$Element$TimetableCalendar$getColorIndexByPerson, viewer, personId);
		var brandBlueHue = 217;
		var hue = brandBlueHue + (((360 / $author$project$Element$TimetableCalendar$colorPaletteSize) | 0) * idx);
		return A3($author$project$Element$TimetableCalendar$HSLColor, hue, saturation, lightness);
	});
var $author$project$Element$TimetableCalendar$encodeHSLColor = function (_v0) {
	var hue = _v0.hn;
	var saturation = _v0.hU;
	var lightness = _v0.hB;
	return $elm$json$Json$Encode$string(
		'hsl(' + ($elm$core$String$fromInt(hue) + (',' + ($elm$core$String$fromInt(saturation) + ('%,' + ($elm$core$String$fromInt(lightness) + '%)'))))));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			'0',
			$elm$core$String$fromInt(time));
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $author$project$Element$TimetableCalendar$encodeCalendarEvent = F3(
	function (hslColor, personId, occ) {
		var makeLighter = $elm$core$Basics$add(35);
		var modifyColor = function (_v1) {
			var hue = _v1.hn;
			var saturation = _v1.hU;
			var lightness = _v1.hB;
			var _v0 = A2(
				$author$project$Util$List$find,
				function (person) {
					return _Utils_eq(person.i8, personId);
				},
				occ.gR);
			if (!_v0.$) {
				return A3(
					$author$project$Element$TimetableCalendar$HSLColor,
					hue,
					saturation,
					makeLighter(lightness));
			} else {
				return hslColor;
			}
		};
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int(
						$author$project$ModuleEvent$moduleEventOccurenceIdToInt(occ.i8))),
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$string(occ.ek.kj)),
					_Utils_Tuple2(
					'start',
					$elm$json$Json$Encode$string(
						$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(
							$elm$time$Time$millisToPosix(occ.R)))),
					_Utils_Tuple2(
					'end',
					$elm$json$Json$Encode$string(
						$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(
							$elm$time$Time$millisToPosix(occ.G)))),
					_Utils_Tuple2(
					'backgroundColor',
					$author$project$Element$TimetableCalendar$encodeHSLColor(
						modifyColor(hslColor)))
				]));
	});
var $author$project$Element$TimetableCalendar$encodeCalendarEventSources = F2(
	function (viewer, eventStore) {
		var encodeCalendarEventSource = function (_v1) {
			var personId = _v1.a;
			var occurences = _v1.b;
			var color = _v1.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$int(personId)),
						_Utils_Tuple2(
						'events',
						A2(
							$elm$json$Json$Encode$list,
							A2($author$project$Element$TimetableCalendar$encodeCalendarEvent, color, personId),
							occurences)),
						_Utils_Tuple2(
						'color',
						$author$project$Element$TimetableCalendar$encodeHSLColor(color))
					]));
		};
		return A2(
			$elm$json$Json$Encode$list,
			encodeCalendarEventSource,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var personId = _v0.a;
					var occurences = _v0.b.cG;
					return _Utils_Tuple3(
						personId,
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$not,
								function ($) {
									return $.l1;
								}),
							occurences),
						A2($author$project$Element$TimetableCalendar$colorByPerson, viewer, personId));
				},
				$elm$core$Dict$toList(eventStore)));
	});
var $author$project$Element$TimetableCalendar$encodeIso8601 = function (millis) {
	return $elm$json$Json$Encode$string(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(
			$elm$time$Time$millisToPosix(millis)));
};
var $author$project$Element$TimetableCalendar$viewEvents = F2(
	function (_v0, _v1) {
		var language = _v0.mn;
		var viewer = _v0.ok;
		var t_ = _v0.h6;
		var filter = _v1.ad;
		var viewState = _v1.dN;
		var eventStore = _v1.bc;
		var selectedStore = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$filter,
				function (_v2) {
					var personId = _v2.a;
					return A2($elm$core$List$member, personId, filter.m6);
				},
				$elm$core$Dict$toList(eventStore)));
		var viewFullCalendar = A3(
			$elm$html$Html$node,
			'full-calendar',
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$UI$attrCyData('timetable-calendar'),
						A2(
						$elm$html$Html$Attributes$property,
						'locale',
						$elm$json$Json$Encode$string(language.k8)),
						A2(
						$elm$html$Html$Attributes$property,
						'eventSources',
						A2($author$project$Element$TimetableCalendar$encodeCalendarEventSources, viewer, selectedStore)),
						A2(
						$elm$html$Html$Attributes$property,
						'canManageEvents',
						$elm$json$Json$Encode$bool(
							$author$project$ACL$canManageTimetable(viewer))),
						A2(
						$elm$html$Html$Attributes$property,
						'canManageDailyAttendance',
						$elm$json$Json$Encode$bool(
							$author$project$ACL$canManageDailyAttendance(viewer))),
						A2(
						$elm$html$Html$Attributes$property,
						'dailyAttendanceText',
						$elm$json$Json$Encode$string(
							t_($author$project$Locale$Messages$DailyAttendanceButtonText))),
						A2(
						$elm$html$Html$Events$on,
						'eventClicked',
						A2(
							$elm$json$Json$Decode$map,
							$author$project$Element$TimetableCalendar$OccurenceDetailViewSelected,
							$author$project$Element$TimetableCalendar$decodeOccurenceDetail(eventStore))),
						A2(
						$elm$html$Html$Events$on,
						'eventTimeChanged',
						A2(
							$elm$json$Json$Decode$map,
							$author$project$Element$TimetableCalendar$OccurenceTimeChanged,
							$author$project$Element$TimetableCalendar$decodeOccurenceTimeChange(eventStore))),
						A2(
						$elm$html$Html$Events$on,
						'viewChanged',
						A2($elm$json$Json$Decode$map, $author$project$Element$TimetableCalendar$CalendarViewChanged, $author$project$Element$TimetableCalendar$decodeCalendarView)),
						A2(
						$elm$html$Html$Events$on,
						'timeSlotSelected',
						A2($elm$json$Json$Decode$map, $author$project$Element$TimetableCalendar$TimeSlotSelected, $author$project$Element$TimetableCalendar$decodeTimeSlot)),
						A2(
						$elm$html$Html$Events$on,
						'fullDayAbsenceButtonClicked',
						A2($elm$json$Json$Decode$map, $author$project$Element$TimetableCalendar$DailyAttendanceSelected, $author$project$Element$TimetableCalendar$decodeDate))
					]),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (viewState_) {
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$Attributes$property,
									'initialDate',
									$author$project$Element$TimetableCalendar$encodeIso8601(viewState_.g5)),
									A2(
									$elm$html$Html$Attributes$property,
									'initialView',
									$elm$json$Json$Encode$string(viewState_.kx))
								]);
						},
						viewState))),
			_List_Nil);
		return viewFullCalendar;
	});
var $author$project$Element$TimetableCalendar$view = F2(
	function (session, model) {
		var t_ = session.h6;
		var viewer = session.ok;
		var _v0 = _Utils_Tuple2(
			$author$project$ACL$canViewTimetablesOther(viewer),
			model.m6);
		if (_v0.a) {
			if (!_v0.b.$) {
				var people = _v0.b.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('columns is-flex-direction-row-reverse')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column timetable-calendar-wrapper')
								]),
							_List_fromArray(
								[
									A2($author$project$Element$TimetableCalendar$viewEvents, session, model)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column is-one-fifth')
								]),
							_List_fromArray(
								[
									A3($author$project$Element$TimetableCalendar$viewCalendarsSidebar, session, model, people)
								]))
						]));
			} else {
				return A2(
					$author$project$UI$progressBar,
					'is-link',
					t_($author$project$Locale$Messages$TimetableLoadingProgress));
			}
		} else {
			return A2($author$project$Element$TimetableCalendar$viewEvents, session, model);
		}
	});
var $author$project$Element$TimetableCalendar$element = {jb: $author$project$Element$TimetableCalendar$init, ks: $author$project$Element$TimetableCalendar$update, og: $author$project$Element$TimetableCalendar$view};
var $author$project$Element$Timetable$timetableCalendar = {
	iz: F2(
		function (model, x) {
			return _Utils_update(
				model,
				{
					dV: $elm$core$Maybe$Just(x)
				});
		}),
	ha: $author$project$Element$TimetableCalendar$element,
	jv: $author$project$Element$Timetable$TimetableCalendarMsg
};
var $author$project$Locale$Messages$DailyAttendanceDownloadError = {$: 52};
var $author$project$Element$Timetable$DailyAttendanceFormView = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$Timetable$DeleteView = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Element$Timetable$DetailView = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$Timetable$DetailViewLoaded = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Element$TimetableCalendar$EventDeleted = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$TimetableCalendar$EventsChanged = {$: 2};
var $author$project$Element$Timetable$ModuleEventDeleted = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Element$Timetable$ModuleEventOccurenceCanceled = function (a) {
	return {$: 13, a: a};
};
var $author$project$Element$Timetable$NoOp = {$: 0};
var $author$project$Element$TimetableCalendar$OccurenceChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Locale$Messages$TimetableModuleEventDeleteError = {$: 634};
var $author$project$Locale$Messages$TimetableModuleEventDeleteSuccess = {$: 633};
var $author$project$Locale$Messages$TimetableModuleEventOccurenceCancelSuccess = {$: 636};
var $author$project$Api$cancel = F4(
	function (url, config, toMsg, decoder) {
		return $author$project$Api$Endpoint$request(
			{
				T: $elm$http$Http$emptyBody,
				bd: A2($author$project$Api$expectJson, toMsg, decoder),
				ar: $author$project$Api$toHeaders(config),
				bj: 'DELETE',
				bp: $elm$core$Maybe$Nothing,
				bq: $elm$core$Maybe$Nothing,
				K: url
			});
	});
var $author$project$ModuleEvent$cancelModuleEventOccurence = F3(
	function (config, _v0, callback) {
		var id = _v0;
		return A4(
			$author$project$Api$cancel,
			A2($author$project$Api$Endpoint$moduleEventOccurence, config, id),
			config,
			callback,
			$author$project$ModuleEvent$moduleEventOccurenceDecoder);
	});
var $author$project$Element$Timetable$closePopup = function (_return) {
	return A2(
		$author$project$Application$Boundaries$mapModel,
		function (model_) {
			return _Utils_update(
				model_,
				{dr: $elm$core$Maybe$Nothing});
		},
		_return);
};
var $author$project$Api$Endpoint$moduleEventsDeleteAfter = F3(
	function (config, eventId, occId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'module-events',
					$elm$core$String$fromInt(eventId)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'start',
					$elm$core$String$fromInt(occId))
				]));
	});
var $author$project$ModuleEvent$deleteAfterModuleEvent = F4(
	function (config, _v0, _v1, callback) {
		var eventId = _v0;
		var occId = _v1;
		return A3(
			$author$project$Api$delete,
			A3($author$project$Api$Endpoint$moduleEventsDeleteAfter, config, eventId, occId),
			config,
			callback);
	});
var $author$project$Api$Endpoint$moduleEventsDeleteAll = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'module-events',
					$elm$core$String$fromInt(id)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2('force_delete', '1')
				]));
	});
var $author$project$ModuleEvent$deleteAllModuleEvent = F3(
	function (config, _v0, callback) {
		var id = _v0;
		return A3(
			$author$project$Api$delete,
			A2($author$project$Api$Endpoint$moduleEventsDeleteAll, config, id),
			config,
			callback);
	});
var $author$project$Element$Timetable$DailyAttendanceDownloaded = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Endpoint$dailyAttendance = F2(
	function (config, date) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'daily-attendance']),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'day',
					$elm$core$String$fromInt(date))
				]));
	});
var $author$project$DailyAttendance$DailyAttendance = F3(
	function (day, attendants, absentees) {
		return {gR: absentees, gW: attendants, fY: day};
	});
var $author$project$DailyAttendance$dailyAttendanceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'absentees',
	$author$project$Person$nestedPeopleDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'attendants',
		$author$project$Person$nestedPeopleDecoder,
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'day',
			$elm$json$Json$Decode$int,
			0,
			$elm$json$Json$Decode$succeed($author$project$DailyAttendance$DailyAttendance))));
var $author$project$DailyAttendance$fetchDailyAttendance = F3(
	function (config, date, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$dailyAttendance, config, date),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$DailyAttendance$dailyAttendanceDecoder));
	});
var $author$project$Element$Timetable$downloadDailyAttendance = F2(
	function (date, _return) {
		var model = _return.eh;
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A3($author$project$DailyAttendance$fetchDailyAttendance, model.b_.gX, date, $author$project$Element$Timetable$DailyAttendanceDownloaded),
			_return);
	});
var $author$project$Element$Timetable$isAttendanceFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.gW, values);
	});
var $author$project$Element$Timetable$DetailViewLoading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$Timetable$ModuleEventDetailDownloaded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Endpoint$moduleEvent = F3(
	function (config, eventId, occId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'module-events',
					$elm$core$String$fromInt(eventId)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'occurence',
					$elm$core$String$fromInt(occId))
				]));
	});
var $author$project$ModuleEvent$fetchOneEvent = F4(
	function (config, eventId, occId, callback) {
		return A3(
			$author$project$Api$get,
			A3($author$project$Api$Endpoint$moduleEvent, config, eventId, occId),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$ModuleEvent$moduleEventDetailedDecoder));
	});
var $author$project$ModuleEvent$moduleEventIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Element$Timetable$updatePopup = F2(
	function (popup, _return) {
		return A2(
			$author$project$Application$Boundaries$mapModel,
			function (model_) {
				return _Utils_update(
					model_,
					{
						dr: $elm$core$Maybe$Just(popup)
					});
			},
			_return);
	});
var $author$project$Element$Timetable$openPopup = F2(
	function (popup, _return) {
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A2(
				$elm$core$Task$attempt,
				$elm$core$Basics$always($author$project$Element$Timetable$NoOp),
				$elm$browser$Browser$Dom$focus('timetable-popup')),
			A2($author$project$Element$Timetable$updatePopup, popup, _return));
	});
var $author$project$Element$Timetable$loadDetailView = F2(
	function (occurence, _return) {
		var model = _return.eh;
		var occId = $author$project$ModuleEvent$moduleEventOccurenceIdToInt(occurence.i8);
		var eventId = $author$project$ModuleEvent$moduleEventIdToInt(occurence.ek.i8);
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A4($author$project$ModuleEvent$fetchOneEvent, model.b_.gX, eventId, occId, $author$project$Element$Timetable$ModuleEventDetailDownloaded),
			A2(
				$author$project$Element$Timetable$openPopup,
				$author$project$Element$Timetable$DetailView(
					$author$project$Element$Timetable$DetailViewLoading(occurence)),
				_return));
	});
var $author$project$Element$Timetable$markAttendanceFormEdited = function (form) {
	return _Utils_update(
		form,
		{
			gW: $author$project$Form$markEdited(form.gW)
		});
};
var $author$project$Element$Timetable$EventFormView = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$Timetable$ModuleEventFormMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Element$ModuleEventForm$NotFoundPage = {$: 3};
var $author$project$Element$ModuleEventForm$Cmd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleEventForm$CreateEventFormLoadingPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleEventForm$FetchModule = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleEventForm$Module = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleEventForm$ModuleDetailDownloaded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$ModuleEventForm$NoEffect = {$: 0};
var $author$project$Element$ModuleEventForm$FetchModuleList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleEventForm$ModuleListDownloaded = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$ModuleEventForm$TimeSlot = function (a) {
	return {$: 1, a: a};
};
var $author$project$Module$fetchAllModulesByPeople = F3(
	function (config, people, callback) {
		var params = _Utils_update(
			$author$project$Module$defaultListParams,
			{m6: people, ce: -1});
		return {
			b_: config,
			d_: $author$project$Module$modulesDecoder,
			cf: callback,
			K: A2($author$project$Api$Endpoint$modules, config, params)
		};
	});
var $author$project$Module$fetchViewerModules = F3(
	function (config, viewer, callback) {
		return A3(
			$author$project$Module$fetchAllModulesByPeople,
			config,
			A2(
				$elm$core$List$cons,
				viewer.i8,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.i8;
					},
					viewer.nL)),
			callback);
	});
var $author$project$Element$ModuleEventForm$EventFormPage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleEventForm$NotTouched = 0;
var $author$project$RRule$blank = {lu: $elm$core$Maybe$Nothing, V: 0, jg: $elm$core$Maybe$Nothing, od: $elm$core$Maybe$Nothing, kz: $elm$core$Maybe$Nothing, N: $elm$core$Maybe$Nothing};
var $author$project$ModuleEvent$blankEvent = {ly: 0, G: $elm$core$Maybe$Nothing, i8: -1, hG: -1, aZ: '', hT: $author$project$RRule$blank, nN: 0, R: $elm$core$Maybe$Nothing, kj: ''};
var $author$project$Element$ModuleEventForm$EndDate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$ModuleEventForm$EndTime = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$ModuleEventForm$Frequency = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$ModuleEventEndDate = {$: 209};
var $author$project$Locale$Messages$ModuleEventEndTime = {$: 206};
var $author$project$Element$ModuleEventForm$ModuleEventFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$ModuleEventFrequency = {$: 203};
var $author$project$Locale$Messages$ModuleEventModule = {$: 200};
var $author$project$Locale$Messages$ModuleEventNotes = {$: 202};
var $author$project$Locale$Messages$ModuleEventStartDate = {$: 208};
var $author$project$Locale$Messages$ModuleEventStartTime = {$: 205};
var $author$project$Locale$Messages$ModuleEventTitle = {$: 201};
var $author$project$Locale$Messages$ModuleEventWeekdays = {$: 204};
var $author$project$Element$ModuleEventForm$Module_ = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$ModuleEventForm$Notes = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleEventForm$StartDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$ModuleEventForm$StartTime = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$ModuleEventForm$Title = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleEventForm$Weekdays = function (a) {
	return {$: 3, a: a};
};
var $author$project$Locale$Messages$TimetableRRuleBiweekly = {$: 606};
var $author$project$Locale$Messages$TimetableRRuleSingle = {$: 607};
var $author$project$Locale$Messages$TimetableRRuleWeekly = {$: 605};
var $author$project$Element$ModuleEventForm$frequencyOptions = function (t_) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'WEEKLY',
			t_($author$project$Locale$Messages$TimetableRRuleWeekly)),
			_Utils_Tuple2(
			'BIWEEKLY',
			t_($author$project$Locale$Messages$TimetableRRuleBiweekly)),
			_Utils_Tuple2(
			'NOREPEAT',
			t_($author$project$Locale$Messages$TimetableRRuleSingle))
		]);
};
var $author$project$Form$requiredSelection = F2(
	function (t_, values) {
		if (!values.b) {
			return $elm$core$Result$Err(
				t_($author$project$Locale$Messages$FormRequiredSelection));
		} else {
			var list = values;
			return $elm$core$Result$Ok(list);
		}
	});
var $author$project$Locale$Messages$FormInvalidTime = {$: 61};
var $author$project$Form$validTimeFormat = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9]{2}:[0-9]{2}$'));
var $author$project$Form$requiredTime = F2(
	function (t_, value) {
		return (value === '') ? $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormRequiredValue)) : (A2($elm$regex$Regex$contains, $author$project$Form$validTimeFormat, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormInvalidTime)));
	});
var $author$project$Locale$Messages$TimetableWeekday = function (a) {
	return {$: 608, a: a};
};
var $author$project$Element$ModuleEventForm$weekdayOptions = function (t_) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'MO',
			t_(
				$author$project$Locale$Messages$TimetableWeekday(0))),
			_Utils_Tuple2(
			'TU',
			t_(
				$author$project$Locale$Messages$TimetableWeekday(1))),
			_Utils_Tuple2(
			'WE',
			t_(
				$author$project$Locale$Messages$TimetableWeekday(2))),
			_Utils_Tuple2(
			'TH',
			t_(
				$author$project$Locale$Messages$TimetableWeekday(3))),
			_Utils_Tuple2(
			'FR',
			t_(
				$author$project$Locale$Messages$TimetableWeekday(4))),
			_Utils_Tuple2(
			'SA',
			t_(
				$author$project$Locale$Messages$TimetableWeekday(5))),
			_Utils_Tuple2(
			'SU',
			t_(
				$author$project$Locale$Messages$TimetableWeekday(6)))
		]);
};
var $author$project$Element$ModuleEventForm$buildModuleEventForm = F2(
	function (t_, moduleOptions) {
		return {
			ly: {
				e0: false,
				fi: $author$project$Form$requiredDate(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{ly: value});
					}),
				fC: function ($) {
					return $.ly;
				},
				og: {
					cm: 'end_date',
					ea: t_($author$project$Locale$Messages$ModuleEventEndDate),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$EndDate)
				}
			},
			G: {
				e0: false,
				fi: $author$project$Form$requiredTime(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{G: value});
					}),
				fC: function ($) {
					return $.G;
				},
				og: {
					cm: 'end_time',
					ea: t_($author$project$Locale$Messages$ModuleEventEndTime),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$EndTime)
				}
			},
			V: {
				e0: false,
				fi: $author$project$Form$requiredText(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{V: value});
					}),
				fC: function ($) {
					return $.V;
				},
				og: {
					cm: 'frequency',
					e6: 'fa-keyboard',
					ea: t_($author$project$Locale$Messages$ModuleEventFrequency),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$Frequency),
					m_: $elm$core$Maybe$Just(
						$author$project$Form$toSelectOptions(
							$author$project$Element$ModuleEventForm$frequencyOptions(t_)))
				}
			},
			hG: {
				e0: false,
				fi: A2($author$project$Form$requiredChoice, t_, '-1'),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{hG: value});
					}),
				fC: function ($) {
					return $.hG;
				},
				og: {
					cm: 'module',
					e6: 'fa-cube',
					ea: t_($author$project$Locale$Messages$ModuleEventModule),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$Module_),
					m_: moduleOptions
				}
			},
			aZ: {
				e0: false,
				fi: $elm$core$Result$Ok,
				fp: false,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{aZ: value});
					}),
				fC: function ($) {
					return $.aZ;
				},
				og: {
					cm: 'notes',
					e6: 'fa-keyboard',
					ea: t_($author$project$Locale$Messages$ModuleEventNotes),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$Notes),
					fj: t_($author$project$Locale$Messages$ModuleEventNotes),
					ii: 'text'
				}
			},
			nN: {
				e0: false,
				fi: $author$project$Form$requiredDate(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{nN: value});
					}),
				fC: function ($) {
					return $.nN;
				},
				og: {
					cm: 'start_date',
					ea: t_($author$project$Locale$Messages$ModuleEventStartDate),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$StartDate)
				}
			},
			R: {
				e0: false,
				fi: $author$project$Form$requiredTime(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{R: value});
					}),
				fC: function ($) {
					return $.R;
				},
				og: {
					cm: 'start_time',
					ea: t_($author$project$Locale$Messages$ModuleEventStartTime),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$StartTime)
				}
			},
			kj: {
				e0: false,
				fi: $author$project$Form$requiredText(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{kj: value});
					}),
				fC: function ($) {
					return $.kj;
				},
				og: {
					cm: 'title',
					e6: 'fa-keyboard',
					ea: t_($author$project$Locale$Messages$ModuleEventTitle),
					fe: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$Title),
					fj: t_($author$project$Locale$Messages$ModuleEventTitle),
					ii: 'text'
				}
			},
			N: {
				e0: false,
				fi: $author$project$Form$requiredSelection(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{N: value});
					}),
				fC: function ($) {
					return $.N;
				},
				og: {
					cm: 'weekdays',
					lo: $elm$core$Maybe$Nothing,
					e6: 'fa-keyboard',
					ea: t_($author$project$Locale$Messages$ModuleEventWeekdays),
					mU: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$Weekdays),
					m_: $elm$core$Maybe$Just(
						$author$project$Form$toSelectOptions(
							$author$project$Element$ModuleEventForm$weekdayOptions(t_)))
				}
			}
		};
	});
var $author$project$RRule$encodeWeekday = function (weekday_) {
	switch (weekday_) {
		case 0:
			return 'MO';
		case 1:
			return 'TU';
		case 2:
			return 'WE';
		case 3:
			return 'TH';
		case 4:
			return 'FR';
		case 5:
			return 'SA';
		default:
			return 'SU';
	}
};
var $author$project$ModuleEvent$fromFrequencyToValue = function (event) {
	var rrule = event.hT;
	var _v0 = _Utils_Tuple3(
		$author$project$ModuleEvent$isRecurring(event),
		rrule.V,
		rrule.jg);
	if (!_v0.a) {
		return 'NOREPEAT';
	} else {
		if (((!_v0.b) && (!_v0.c.$)) && (_v0.c.a === 2)) {
			var _v1 = _v0.b;
			return 'BIWEEKLY';
		} else {
			return 'WEEKLY';
		}
	}
};
var $author$project$Element$ModuleEventForm$fillModuleEventForm = function (event) {
	return {
		ly: $author$project$Form$dateFromMillis(event.ly),
		G: A2($elm$core$Maybe$withDefault, '09:00', event.G),
		V: $author$project$ModuleEvent$fromFrequencyToValue(event),
		hG: $elm$core$String$fromInt(
			$author$project$Module$moduleIdToInt(event.hG)),
		aZ: event.aZ,
		nN: $author$project$Form$dateFromMillis(event.nN),
		R: A2($elm$core$Maybe$withDefault, '08:00', event.R),
		kj: event.kj,
		N: A2($elm$core$Maybe$withDefault, _List_Nil, event.hT.N)
	};
};
var $ryan_haskell$date_format$DateFormat$HourMilitaryFixed = {$: 25};
var $ryan_haskell$date_format$DateFormat$hourMilitaryFixed = $ryan_haskell$date_format$DateFormat$HourMilitaryFixed;
var $author$project$Form$timeFromMillis = function (millis) {
	return A4(
		$ryan_haskell$date_format$DateFormat$formatWithLanguage,
		$ryan_haskell$date_format$DateFormat$Language$english,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$minuteFixed
			]),
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(millis));
};
var $author$project$Locale$Messages$TimetableModuleOption = F4(
	function (a, b, c, d) {
		return {$: 637, a: a, b: b, c: c, d: d};
	});
var $author$project$Element$ModuleEventForm$toModuleOptions = F2(
	function (t_, modules) {
		return $author$project$Form$toSortedSelectOptions(
			A2(
				$elm$core$List$map,
				function (m) {
					return _Utils_Tuple2(
						$author$project$Module$fromModuleToValue(m.i8),
						t_(
							A4(
								$author$project$Locale$Messages$TimetableModuleOption,
								m.kj,
								$elm$time$Time$utc,
								$elm$time$Time$millisToPosix(m.nN),
								$elm$time$Time$millisToPosix(m.ly))));
				},
				modules));
	});
var $author$project$Element$ModuleEventForm$toWeekday = function (millis) {
	return A2(
		$elm$time$Time$toWeekday,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(millis));
};
var $author$project$Element$ModuleEventForm$updatePage = F2(
	function (page, model) {
		return _Utils_update(
			model,
			{bk: page});
	});
var $author$project$Element$ModuleEventForm$openCreateForm = F4(
	function (session, model, _v0, modules) {
		var start = _v0.a;
		var end = _v0.b;
		var blankRecurrence = $author$project$RRule$blank;
		var blankEvent = $author$project$ModuleEvent$blankEvent;
		var event = _Utils_update(
			blankEvent,
			{
				ly: end,
				G: $elm$core$Maybe$Just(
					$author$project$Form$timeFromMillis(end)),
				hT: _Utils_update(
					blankRecurrence,
					{
						N: $elm$core$Maybe$Just(
							_List_fromArray(
								[
									$author$project$RRule$encodeWeekday(
									$author$project$Element$ModuleEventForm$toWeekday(start))
								]))
					}),
				nN: start,
				R: $elm$core$Maybe$Just(
					$author$project$Form$timeFromMillis(start))
			});
		var activeModulesWithStudents = A2(
			$elm$core$List$filter,
			function (m) {
				return (_Utils_cmp(m.nN, start) < 1) && ((_Utils_cmp(m.ly, end) > -1) && ((!$elm$core$List$isEmpty(m.fv)) && (!$author$project$Module$isMigrationReady(m))));
			},
			modules);
		var moduleOptions = A2(
			$author$project$Element$ModuleEventForm$toModuleOptions,
			session.h6,
			A2($author$project$Module$schoolModules, session.ok, activeModulesWithStudents));
		var form = A2(
			$author$project$Element$ModuleEventForm$buildModuleEventForm,
			session.h6,
			$elm$core$Maybe$Just(moduleOptions));
		var formModel = {
			iq: $author$project$Form$Create($elm$core$Maybe$Nothing),
			bE: _Utils_update(
				form,
				{
					G: $author$project$Form$markEdited(form.G),
					nN: $author$project$Form$markEdited(form.nN),
					R: $author$project$Form$markEdited(form.R),
					N: $author$project$Form$markEdited(form.N)
				}),
			fs: 0,
			dM: {c3: true},
			eI: $author$project$Element$ModuleEventForm$fillModuleEventForm(event)
		};
		return A2(
			$author$project$Element$ModuleEventForm$updatePage,
			$author$project$Element$ModuleEventForm$EventFormPage(formModel),
			model);
	});
var $author$project$Element$ModuleEventForm$loadCreateFormWithTimeSlot = F3(
	function (session, model, timeslot) {
		var config = model.b_;
		var _v0 = model.hH;
		if (!_v0.$) {
			var modules = _v0.a;
			return _Utils_Tuple3(
				A4($author$project$Element$ModuleEventForm$openCreateForm, session, model, timeslot, modules),
				$author$project$Element$ModuleEventForm$NoEffect,
				$elm$core$Maybe$Nothing);
		} else {
			return _Utils_Tuple3(
				A2(
					$author$project$Element$ModuleEventForm$updatePage,
					$author$project$Element$ModuleEventForm$CreateEventFormLoadingPage(
						$author$project$Element$ModuleEventForm$TimeSlot(timeslot)),
					model),
				$author$project$Element$ModuleEventForm$Cmd(
					$author$project$Element$ModuleEventForm$FetchModuleList(
						A3($author$project$Module$fetchViewerModules, config.gX, session.ok, $author$project$Element$ModuleEventForm$ModuleListDownloaded))),
				$elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$ModuleEventForm$loadCreateForm = F3(
	function (session, model, query) {
		var config = model.b_;
		var _v0 = _Utils_Tuple3(query.js, query.h2, query.hb);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if ((_v0.b.$ === 1) && (_v0.c.$ === 1)) {
					var moduleId = _v0.a.a;
					var _v1 = _v0.b;
					var _v2 = _v0.c;
					return _Utils_Tuple3(
						A2(
							$author$project$Element$ModuleEventForm$updatePage,
							$author$project$Element$ModuleEventForm$CreateEventFormLoadingPage(
								$author$project$Element$ModuleEventForm$Module(moduleId)),
							model),
						$author$project$Element$ModuleEventForm$Cmd(
							$author$project$Element$ModuleEventForm$FetchModule(
								A3($author$project$Module$fetchModule, config.gX, moduleId, $author$project$Element$ModuleEventForm$ModuleDetailDownloaded))),
						$elm$core$Maybe$Nothing);
				} else {
					break _v0$2;
				}
			} else {
				if ((!_v0.b.$) && (!_v0.c.$)) {
					var _v3 = _v0.a;
					var start = _v0.b.a;
					var end = _v0.c.a;
					return A3(
						$author$project$Element$ModuleEventForm$loadCreateFormWithTimeSlot,
						session,
						model,
						_Utils_Tuple2(start, end));
				} else {
					break _v0$2;
				}
			}
		}
		return _Utils_Tuple3(model, $author$project$Element$ModuleEventForm$NoEffect, $elm$core$Maybe$Nothing);
	});
var $author$project$Element$ModuleEventForm$FetchModuleEvent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModuleEventForm$ModuleEventDetailDownloaded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$ModuleEventForm$UpdateEventFormLoadingPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$ModuleEvent$fetchModuleEvent = F4(
	function (config, _v0, _v1, callback) {
		var eventId = _v0;
		var occId = _v1;
		return {
			b_: config,
			d_: $author$project$ModuleEvent$moduleEventDetailedDecoder,
			cf: callback,
			K: A3($author$project$Api$Endpoint$moduleEvent, config, eventId, occId)
		};
	});
var $author$project$Element$ModuleEventForm$loadUpdateForm = F2(
	function (model, params) {
		var config = model.b_;
		var eventId = params.iX;
		var occId = params.hL;
		return _Utils_Tuple3(
			A2(
				$author$project$Element$ModuleEventForm$updatePage,
				$author$project$Element$ModuleEventForm$UpdateEventFormLoadingPage(params),
				model),
			$author$project$Element$ModuleEventForm$Cmd(
				$author$project$Element$ModuleEventForm$FetchModuleEvent(
					A4($author$project$ModuleEvent$fetchModuleEvent, config.gX, eventId, occId, $author$project$Element$ModuleEventForm$ModuleEventDetailDownloaded))),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$ModuleEventForm$init = F3(
	function (config, session, params) {
		var model = {b_: config, hH: $elm$core$Maybe$Nothing, bk: $author$project$Element$ModuleEventForm$NotFoundPage, gB: session};
		if (!params.$) {
			var query = params.a;
			return A3($author$project$Element$ModuleEventForm$loadCreateForm, session, model, query);
		} else {
			var query = params.a;
			return A2($author$project$Element$ModuleEventForm$loadUpdateForm, model, query);
		}
	});
var $author$project$Element$ModuleEventForm$perform = F2(
	function (_v0, effect) {
		if (!effect.$) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var cmd = effect.a;
			switch (cmd.$) {
				case 0:
					var request = cmd.a;
					return $author$project$Api$getV2(request);
				case 1:
					var request = cmd.a;
					return $author$project$Api$getV2(request);
				case 2:
					var request = cmd.a;
					return $author$project$Api$getV2(request);
				case 3:
					var request = cmd.a;
					return $author$project$Api$postV2(request);
				case 4:
					var request = cmd.a;
					return $author$project$Api$putV2(request);
				case 5:
					var request = cmd.a;
					return $author$project$Api$putV2(request);
				case 6:
					return $author$project$Ports$scrollToFormError;
				default:
					var request = cmd.a;
					return $author$project$Api$postV2(request);
			}
		}
	});
var $author$project$Element$ModuleEventForm$CreateModuleEvent = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleEventForm$EditedButNotSaved = 1;
var $author$project$Element$ModuleEventForm$EventSaveOk = 0;
var $author$project$Element$ModuleEventForm$Exit = 1;
var $author$project$Element$ModuleEventForm$LogError = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$ModuleEventForm$ModuleEventSaved = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$ModuleEventForm$NoOp = {$: 0};
var $author$project$Element$ModuleEventForm$Saving = 3;
var $author$project$Element$ModuleEventForm$SavingError = 4;
var $author$project$Element$ModuleEventForm$ScrollToFormError = {$: 6};
var $author$project$Locale$Messages$TimetableModuleEventSaveSuccess = {$: 635};
var $author$project$Element$ModuleEventForm$UpdateAllOccurences = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$ModuleEventForm$UpdateScopeRequired = 2;
var $author$project$Element$ModuleEventForm$UpdateThisAndFutureOccurences = function (a) {
	return {$: 4, a: a};
};
var $author$project$ModuleEvent$defaultEventListParams = {js: $elm$core$Maybe$Nothing};
var $author$project$ModuleEvent$moduleEventEncoder = function (event) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(
					$author$project$ModuleEvent$moduleEventIdToInt(event.i8))),
				_Utils_Tuple2(
				'module',
				$elm$json$Json$Encode$int(
					$author$project$Module$moduleIdToInt(event.hG))),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(event.kj)),
				_Utils_Tuple2(
				'notes',
				$elm$json$Json$Encode$string(event.aZ)),
				_Utils_Tuple2(
				'rrule',
				$elm$json$Json$Encode$string(event.hT)),
				_Utils_Tuple2(
				'start_time',
				$elm$json$Json$Encode$string(event.R)),
				_Utils_Tuple2(
				'end_time',
				$elm$json$Json$Encode$string(event.G))
			]));
};
var $author$project$ModuleEvent$createModuleEvent = F3(
	function (config, event, callback) {
		return {
			T: $author$project$ModuleEvent$moduleEventEncoder(event),
			b_: config,
			d_: $author$project$ModuleEvent$moduleEventDetailedDecoder,
			cf: callback,
			K: A2($author$project$Api$Endpoint$moduleEvents, config.gX, $author$project$ModuleEvent$defaultEventListParams)
		};
	});
var $author$project$Element$ModuleEventForm$isModuleEventFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.kj, values) && (A2($author$project$Form$isFieldValid, form.aZ, values) && (A2($author$project$Form$isFieldValid, form.V, values) && (A2($author$project$Form$isFieldValid, form.N, values) && (A2($author$project$Form$isFieldValid, form.R, values) && (A2($author$project$Form$isFieldValid, form.G, values) && (A2($author$project$Form$isFieldValid, form.nN, values) && (A2($author$project$Form$isFieldValid, form.ly, values) && (A2($author$project$Form$isFieldValid, form.hG, values) && A3($author$project$Form$areDatesValid, form.nN, form.ly, values)))))))));
	});
var $author$project$Element$ModuleEventForm$markModuleEventFormEdited = function (form) {
	return _Utils_update(
		form,
		{
			ly: $author$project$Form$markEdited(form.ly),
			G: $author$project$Form$markEdited(form.G),
			V: $author$project$Form$markEdited(form.V),
			hG: $author$project$Form$markEdited(form.hG),
			aZ: $author$project$Form$markEdited(form.aZ),
			nN: $author$project$Form$markEdited(form.nN),
			R: $author$project$Form$markEdited(form.R),
			kj: $author$project$Form$markEdited(form.kj),
			N: $author$project$Form$markEdited(form.N)
		});
};
var $author$project$Log$msgModuleEventDownload = 'module_event_download';
var $author$project$Log$msgModuleEventSave = 'module_event_save';
var $author$project$Element$ModuleEventForm$openUpdateForm = F3(
	function (session, model, module_) {
		var moduleOptions = A2(
			$author$project$Element$ModuleEventForm$toModuleOptions,
			session.h6,
			_List_fromArray(
				[
					$author$project$Module$asListItem(module_)
				]));
		var form = A2(
			$author$project$Element$ModuleEventForm$buildModuleEventForm,
			session.h6,
			$elm$core$Maybe$Just(moduleOptions));
		var blankEvent = $author$project$ModuleEvent$blankEvent;
		var newModuleEvent = _Utils_update(
			blankEvent,
			{ly: module_.ly, G: $elm$core$Maybe$Nothing, hG: module_.i8, hT: $author$project$RRule$blank, nN: module_.nN, R: $elm$core$Maybe$Nothing, kj: module_.kj});
		var formModel = {
			iq: $author$project$Form$Create(
				$elm$core$Maybe$Just(
					$author$project$Module$asListItem(module_))),
			bE: _Utils_update(
				form,
				{
					ly: $author$project$Form$markEdited(form.ly),
					nN: $author$project$Form$markEdited(form.nN),
					kj: $author$project$Form$markEdited(form.kj)
				}),
			fs: 0,
			dM: {c3: true},
			eI: $author$project$Element$ModuleEventForm$fillModuleEventForm(newModuleEvent)
		};
		return A2(
			$author$project$Element$ModuleEventForm$updatePage,
			$author$project$Element$ModuleEventForm$EventFormPage(formModel),
			model);
	});
var $author$project$Api$Endpoint$moduleEventsUpdateAll = F2(
	function (config, eventId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'module-events',
					$elm$core$String$fromInt(eventId)
				]),
			_List_Nil);
	});
var $author$project$ModuleEvent$replaceModuleEventOccurences = F3(
	function (config, event, callback) {
		return {
			T: $author$project$ModuleEvent$moduleEventEncoder(event),
			b_: config,
			d_: $author$project$ModuleEvent$moduleEventDetailedDecoder,
			cf: callback,
			K: A2(
				$author$project$Api$Endpoint$moduleEventsUpdateAll,
				config.gX,
				$author$project$ModuleEvent$moduleEventIdToInt(event.i8))
		};
	});
var $author$project$ModuleEvent$ModuleEventUnsaved = F7(
	function (id, module_, title, notes, rrule, startTime, endTime) {
		return {G: endTime, i8: id, hG: module_, aZ: notes, hT: rrule, R: startTime, kj: title};
	});
var $author$project$RRule$encodeDtStart = function (dtStart_) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (value) {
				return 'DTSTART:' + (value + '\n');
			},
			dtStart_));
};
var $author$project$RRule$encodeFrequency = function (freq) {
	switch (freq) {
		case 1:
			return 'DAILY';
		case 0:
			return 'WEEKLY';
		default:
			return 'MONTHLY';
	}
};
var $author$project$RRule$encodeOptional = F3(
	function (field, encoder, maybeValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (value) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							field,
							encoder(value))
						]);
				},
				maybeValue));
	});
var $author$project$RRule$encodeRequired = F3(
	function (field, encoder, value) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				field,
				encoder(value))
			]);
	});
var $author$project$RRule$encode = function (rrule) {
	var ruleParts = _Utils_ap(
		A3($author$project$RRule$encodeRequired, 'FREQ', $author$project$RRule$encodeFrequency, rrule.V),
		_Utils_ap(
			A3($author$project$RRule$encodeOptional, 'INTERVAL', $elm$core$String$fromInt, rrule.jg),
			_Utils_ap(
				A3($author$project$RRule$encodeOptional, 'WKST', $elm$core$Basics$identity, rrule.kz),
				_Utils_ap(
					A3($author$project$RRule$encodeOptional, 'UNTIL', $elm$core$Basics$identity, rrule.od),
					A3(
						$author$project$RRule$encodeOptional,
						'BYDAY',
						$elm$core$String$join(','),
						rrule.N)))));
	return A2(
		$elm$core$String$append,
		$author$project$RRule$encodeDtStart(rrule.lu),
		A2(
			$elm$core$String$append,
			'RRULE:',
			A2(
				$elm$core$String$join,
				';',
				A2(
					$elm$core$List$map,
					function (_v0) {
						var part = _v0.a;
						var value = _v0.b;
						return part + ('=' + value);
					},
					ruleParts))));
};
var $author$project$ModuleEvent$fromValueToFrequency = function (freqValue) {
	switch (freqValue) {
		case 'WEEKLY':
			return 0;
		case 'BIWEEKLY':
			return 0;
		default:
			return 1;
	}
};
var $author$project$ModuleEvent$fromValueToInterval = function (interval) {
	if (interval === 'BIWEEKLY') {
		return $elm$core$Maybe$Just(2);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ModuleEvent$fromValueToDateTime = F2(
	function (isMin, dateValue) {
		var yyyy = A3($elm$core$String$slice, 0, 4, dateValue);
		var time = isMin ? 'T000000' : 'T235959';
		var mm = A3($elm$core$String$slice, 5, 7, dateValue);
		var dd = A3($elm$core$String$slice, 8, 10, dateValue);
		return $elm$core$String$isEmpty(dateValue) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			_Utils_ap(
				yyyy,
				_Utils_ap(
					mm,
					_Utils_ap(dd, time))));
	});
var $author$project$ModuleEvent$fromValueToMaxDateTime = $author$project$ModuleEvent$fromValueToDateTime(false);
var $author$project$ModuleEvent$fromValueToMinDateTime = $author$project$ModuleEvent$fromValueToDateTime(true);
var $author$project$Element$ModuleEventForm$saveRRule = F2(
	function (form, values) {
		var weekdays = A2(
			$author$project$Data$toMaybe,
			$elm$core$List$isEmpty,
			form.N.fC(values));
		var until = $author$project$ModuleEvent$fromValueToMaxDateTime(
			form.ly.fC(values));
		var interval = $author$project$ModuleEvent$fromValueToInterval(
			form.V.fC(values));
		var freq = $author$project$ModuleEvent$fromValueToFrequency(
			form.V.fC(values));
		var dtStart = $author$project$ModuleEvent$fromValueToMinDateTime(
			form.nN.fC(values));
		return {lu: dtStart, V: freq, jg: interval, od: until, kz: $elm$core$Maybe$Nothing, N: weekdays};
	});
var $author$project$Element$ModuleEventForm$saveModuleEventForm = F3(
	function (form, values, event) {
		return A7(
			$author$project$ModuleEvent$ModuleEventUnsaved,
			A2(
				$elm$core$Maybe$withDefault,
				-1,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.i8;
					},
					event)),
			A2(
				$elm$core$Maybe$withDefault,
				-1,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$identity,
					$elm$core$String$toInt(
						form.hG.fC(values)))),
			form.kj.fC(values),
			form.aZ.fC(values),
			$author$project$RRule$encode(
				A2($author$project$Element$ModuleEventForm$saveRRule, form, values)),
			form.R.fC(values),
			form.G.fC(values));
	});
var $author$project$Api$Endpoint$moduleEventsUpdateFuture = F3(
	function (config, eventId, occId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'module-events',
					$elm$core$String$fromInt(eventId)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'start',
					$elm$core$String$fromInt(occId))
				]));
	});
var $author$project$ModuleEvent$updateFutureModuleEventOccurences = F4(
	function (config, event, occId, callback) {
		return {
			T: $author$project$ModuleEvent$moduleEventEncoder(event),
			b_: config,
			d_: $author$project$ModuleEvent$moduleEventDetailedDecoder,
			cf: callback,
			K: A3(
				$author$project$Api$Endpoint$moduleEventsUpdateFuture,
				config.gX,
				$author$project$ModuleEvent$moduleEventIdToInt(event.i8),
				$author$project$ModuleEvent$moduleEventOccurenceIdToInt(occId))
		};
	});
var $author$project$Util$Time$adjustEndTime = F3(
	function (oldStartTime, newStartTime, endTime) {
		var duration = (!endTime) ? ((60 * 60) * 1000) : (endTime - oldStartTime);
		return newStartTime + duration;
	});
var $author$project$Element$ModuleEventForm$andThenUpdateWeekdays = function (_v0) {
	var form = _v0.a;
	var formValues = _v0.b;
	return (form.V.fC(formValues) === 'NOREPEAT') ? _Utils_Tuple2(
		_Utils_update(
			form,
			{
				ly: $author$project$Form$markEdited(form.ly),
				N: $author$project$Form$markEdited(form.N)
			}),
		A2(
			form.N.ks,
			_List_fromArray(
				[
					$author$project$RRule$encodeWeekday(
					$author$project$Element$ModuleEventForm$toWeekday(
						$author$project$Form$dateToMillis(
							form.nN.fC(formValues))))
				]),
			A2(
				form.ly.ks,
				form.nN.fC(formValues),
				formValues))) : _Utils_Tuple2(form, formValues);
};
var $author$project$Element$ModuleEventForm$findModuleByFormValue = F2(
	function (idStr, modules) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (m) {
					return _Utils_eq(
						$elm$core$Maybe$Just(
							$author$project$Module$moduleIdToInt(m.i8)),
						$elm$core$String$toInt(idStr));
				},
				modules));
	});
var $author$project$Locale$isoTimeFormatter = A2(
	$ryan_haskell$date_format$DateFormat$formatWithLanguage,
	$ryan_haskell$date_format$DateFormat$Language$english,
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed
		]));
var $author$project$Util$Time$toMillis = function (timeStr) {
	var mins = A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toInt(
			A2($elm$core$String$right, 2, timeStr)));
	var hours = A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toInt(
			A2($elm$core$String$left, 2, timeStr)));
	return (((hours * 60) * 60) * 1000) + ((mins * 60) * 1000);
};
var $author$project$Element$ModuleEventForm$updateModuleEventForm = F4(
	function (msg, form, formValues, modules) {
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							kj: $author$project$Form$markEdited(form.kj)
						}),
					A2(form.kj.ks, value, formValues));
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aZ: $author$project$Form$markEdited(form.aZ)
						}),
					A2(form.aZ.ks, value, formValues));
			case 2:
				var value = msg.a;
				return $author$project$Element$ModuleEventForm$andThenUpdateWeekdays(
					_Utils_Tuple2(
						_Utils_update(
							form,
							{
								V: $author$project$Form$markEdited(form.V)
							}),
						A2(form.V.ks, value, formValues)));
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							N: $author$project$Form$markEdited(form.N)
						}),
					A2(form.N.ks, value, formValues));
			case 4:
				var startTimeValue = msg.a;
				var oldStartTime = $author$project$Util$Time$toMillis(
					form.R.fC(formValues));
				var newStartTime = $author$project$Util$Time$toMillis(startTimeValue);
				var endTime = $author$project$Util$Time$toMillis(
					form.G.fC(formValues));
				var newEndTimeValue = A2(
					$author$project$Locale$isoTimeFormatter,
					$elm$time$Time$utc,
					$elm$time$Time$millisToPosix(
						A3($author$project$Util$Time$adjustEndTime, oldStartTime, newStartTime, endTime)));
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							G: $author$project$Form$markEdited(form.G),
							R: $author$project$Form$markEdited(form.R)
						}),
					A2(
						form.G.ks,
						newEndTimeValue,
						A2(form.R.ks, startTimeValue, formValues)));
			case 5:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							G: $author$project$Form$markEdited(form.G)
						}),
					A2(form.G.ks, value, formValues));
			case 6:
				var value = msg.a;
				return $author$project$Element$ModuleEventForm$andThenUpdateWeekdays(
					_Utils_Tuple2(
						_Utils_update(
							form,
							{
								nN: $author$project$Form$markEdited(form.nN)
							}),
						A2(form.nN.ks, value, formValues)));
			case 7:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ly: $author$project$Form$markEdited(form.ly)
						}),
					A2(form.ly.ks, value, formValues));
			default:
				var moduleIdValue = msg.a;
				var prefillForm = function (module_) {
					return _Utils_Tuple2(
						_Utils_update(
							form,
							{
								ly: $author$project$Form$markEdited(form.ly),
								hG: $author$project$Form$markEdited(form.hG),
								kj: $author$project$Form$markEdited(form.kj)
							}),
						A2(
							form.ly.ks,
							$author$project$Form$dateFromMillis(module_.ly),
							A2(
								form.kj.ks,
								module_.kj,
								A2(form.hG.ks, moduleIdValue, formValues))));
				};
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(form, formValues),
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Element$ModuleEventForm$findModuleByFormValue(moduleIdValue),
							$elm$core$Maybe$map(prefillForm)),
						modules));
		}
	});
var $author$project$Element$ModuleEventForm$updateSession = F2(
	function (session, model) {
		return _Utils_update(
			model,
			{gB: session});
	});
var $author$project$Element$ModuleEventForm$update = F2(
	function (msg, model) {
		var config = model.b_;
		var session = model.gB;
		var t_ = session.h6;
		var noop = _Utils_Tuple3(model, $author$project$Element$ModuleEventForm$NoEffect, $elm$core$Maybe$Nothing);
		var _v0 = _Utils_Tuple2(msg, model.bk);
		switch (_v0.a.$) {
			case 0:
				var _v1 = _v0.a;
				return noop;
			case 10:
				var _v2 = _v0.a;
				return _Utils_Tuple3(
					model,
					$author$project$Element$ModuleEventForm$NoEffect,
					$elm$core$Maybe$Just(1));
			case 1:
				if (!_v0.b.$) {
					var fieldMsg = _v0.a.a;
					var formModel = _v0.b.a;
					var _v3 = A4($author$project$Element$ModuleEventForm$updateModuleEventForm, fieldMsg, formModel.bE, formModel.eI, model.hH);
					var form = _v3.a;
					var values = _v3.b;
					var eventForm = _Utils_update(
						formModel,
						{bE: form, fs: 1, eI: values});
					var page = function () {
						var dateValidation = function () {
							switch (fieldMsg.$) {
								case 6:
									return true;
								case 7:
									return true;
								default:
									return formModel.dM.c3;
							}
						}();
						return $author$project$Element$ModuleEventForm$EventFormPage(
							_Utils_update(
								eventForm,
								{
									dM: {c3: dateValidation}
								}));
					}();
					return _Utils_Tuple3(
						A2($author$project$Element$ModuleEventForm$updatePage, page, model),
						$author$project$Element$ModuleEventForm$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					return noop;
				}
			case 3:
				var params = _v0.a.a;
				return A2($author$project$Element$ModuleEventForm$loadUpdateForm, model, params);
			case 2:
				if (!_v0.b.$) {
					var _v5 = _v0.a;
					var formPage = _v0.b.a;
					var action = formPage.iq;
					var form = formPage.bE;
					var values = formPage.eI;
					var _v6 = _Utils_Tuple2(
						A2($author$project$Element$ModuleEventForm$isModuleEventFormValid, form, values),
						action);
					if (_v6.a) {
						if (!_v6.b.$) {
							var page = $author$project$Element$ModuleEventForm$EventFormPage(
								_Utils_update(
									formPage,
									{fs: 3}));
							return _Utils_Tuple3(
								A2($author$project$Element$ModuleEventForm$updatePage, page, model),
								$author$project$Element$ModuleEventForm$Cmd(
									$author$project$Element$ModuleEventForm$CreateModuleEvent(
										A3(
											$author$project$ModuleEvent$createModuleEvent,
											config,
											A3($author$project$Element$ModuleEventForm$saveModuleEventForm, form, values, $elm$core$Maybe$Nothing),
											$author$project$Element$ModuleEventForm$ModuleEventSaved))),
								$elm$core$Maybe$Nothing);
						} else {
							var page = $author$project$Element$ModuleEventForm$EventFormPage(
								_Utils_update(
									formPage,
									{fs: 2}));
							return _Utils_Tuple3(
								A2($author$project$Element$ModuleEventForm$updatePage, page, model),
								$author$project$Element$ModuleEventForm$NoEffect,
								$elm$core$Maybe$Nothing);
						}
					} else {
						var areDatesValid = A3($author$project$Form$areDatesValid, form.nN, form.ly, values);
						var page = $author$project$Element$ModuleEventForm$EventFormPage(
							_Utils_update(
								formPage,
								{
									bE: $author$project$Element$ModuleEventForm$markModuleEventFormEdited(form),
									fs: 1,
									dM: {c3: areDatesValid}
								}));
						return _Utils_Tuple3(
							A2($author$project$Element$ModuleEventForm$updatePage, page, model),
							$author$project$Element$ModuleEventForm$Cmd($author$project$Element$ModuleEventForm$ScrollToFormError),
							$elm$core$Maybe$Nothing);
					}
				} else {
					var _v7 = _v0.a;
					return noop;
				}
			case 5:
				if (!_v0.b.$) {
					var _v8 = _v0.a;
					var formModel = _v0.b.a;
					var page = $author$project$Element$ModuleEventForm$EventFormPage(
						_Utils_update(
							formModel,
							{fs: 1}));
					return _Utils_Tuple3(
						A2($author$project$Element$ModuleEventForm$updatePage, page, model),
						$author$project$Element$ModuleEventForm$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var _v9 = _v0.a;
					return noop;
				}
			case 4:
				if (!_v0.b.$) {
					var scope = _v0.a.a;
					var formModel = _v0.b.a;
					var action = formModel.iq;
					var form = formModel.bE;
					var values = formModel.eI;
					if (action.$ === 1) {
						var _v11 = action.a;
						var event = _v11.a;
						var occId = _v11.b;
						var page = $author$project$Element$ModuleEventForm$EventFormPage(
							_Utils_update(
								formModel,
								{fs: 3}));
						var cmd = function () {
							if (!scope) {
								return $author$project$Element$ModuleEventForm$UpdateThisAndFutureOccurences(
									A4(
										$author$project$ModuleEvent$updateFutureModuleEventOccurences,
										config,
										A3(
											$author$project$Element$ModuleEventForm$saveModuleEventForm,
											form,
											values,
											$elm$core$Maybe$Just(event)),
										occId,
										$author$project$Element$ModuleEventForm$ModuleEventSaved));
							} else {
								return $author$project$Element$ModuleEventForm$UpdateAllOccurences(
									A3(
										$author$project$ModuleEvent$replaceModuleEventOccurences,
										config,
										A3(
											$author$project$Element$ModuleEventForm$saveModuleEventForm,
											form,
											values,
											$elm$core$Maybe$Just(event)),
										$author$project$Element$ModuleEventForm$ModuleEventSaved));
							}
						}();
						return _Utils_Tuple3(
							A2($author$project$Element$ModuleEventForm$updatePage, page, model),
							$author$project$Element$ModuleEventForm$Cmd(cmd),
							$elm$core$Maybe$Nothing);
					} else {
						return noop;
					}
				} else {
					return noop;
				}
			case 6:
				if (!_v0.a.a.$) {
					return _Utils_Tuple3(
						A2(
							$author$project$Element$ModuleEventForm$updateSession,
							A2(
								$author$project$Session$ok,
								session,
								session.h6($author$project$Locale$Messages$TimetableModuleEventSaveSuccess)),
							model),
						$author$project$Element$ModuleEventForm$NoEffect,
						$elm$core$Maybe$Just(0));
				} else {
					if (!_v0.b.$) {
						var error = _v0.a.a.a;
						var formModel = _v0.b.a;
						var action = formModel.iq;
						var session2 = A3(
							$author$project$Session$error,
							session,
							error,
							session.h6($author$project$Locale$Messages$FormSaveError));
						var page = $author$project$Element$ModuleEventForm$EventFormPage(
							_Utils_update(
								formModel,
								{fs: 4}));
						var occId = A2(
							$elm$core$Maybe$withDefault,
							'-1',
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$second,
									A2($elm$core$Basics$composeR, $author$project$ModuleEvent$moduleEventOccurenceIdToInt, $elm$core$String$fromInt)),
								$author$project$Form$toSavedObject(action)));
						var model2 = A2(
							$author$project$Element$ModuleEventForm$updateSession,
							session2,
							A2($author$project$Element$ModuleEventForm$updatePage, page, model));
						var effect = $author$project$Element$ModuleEventForm$Cmd(
							$author$project$Element$ModuleEventForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgModuleEventSave,
										$elm$core$Maybe$Just(occId),
										error),
									$elm$core$Basics$always($author$project$Element$ModuleEventForm$NoOp))));
						return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
					} else {
						return noop;
					}
				}
			case 7:
				if (_v0.a.a.$ === 1) {
					var error = _v0.a.a.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Element$ModuleEventForm$updateSession,
							A3(
								$author$project$Session$error,
								session,
								error,
								session.h6($author$project$Locale$Messages$ModulesDownloadError)),
							model),
						$author$project$Element$ModuleEventForm$Cmd(
							$author$project$Element$ModuleEventForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgModuleDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
										error),
									$elm$core$Basics$always($author$project$Element$ModuleEventForm$NoOp)))),
						$elm$core$Maybe$Nothing);
				} else {
					if ((_v0.b.$ === 1) && (!_v0.b.a.$)) {
						var module_ = _v0.a.a.a;
						var moduleId = _v0.b.a.a;
						return _Utils_eq(module_.i8, moduleId) ? _Utils_Tuple3(
							A3($author$project$Element$ModuleEventForm$openUpdateForm, session, model, module_),
							$author$project$Element$ModuleEventForm$NoEffect,
							$elm$core$Maybe$Nothing) : noop;
					} else {
						return noop;
					}
				}
			case 8:
				if (_v0.a.a.$ === 1) {
					var error = _v0.a.a.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Element$ModuleEventForm$updateSession,
							A3(
								$author$project$Session$error,
								session,
								error,
								session.h6($author$project$Locale$Messages$ModulesDownloadError)),
							model),
						$author$project$Element$ModuleEventForm$Cmd(
							$author$project$Element$ModuleEventForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgModuleEventDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$ModuleEventForm$NoOp)))),
						$elm$core$Maybe$Nothing);
				} else {
					if (_v0.b.$ === 2) {
						var event = _v0.a.a.a;
						var occId = _v0.b.a.hL;
						var formModel = {
							iq: $author$project$Form$Update(
								_Utils_Tuple2(event, occId)),
							bE: A2($author$project$Element$ModuleEventForm$buildModuleEventForm, session.h6, $elm$core$Maybe$Nothing),
							fs: 0,
							dM: {c3: true},
							eI: $author$project$Element$ModuleEventForm$fillModuleEventForm(event)
						};
						return _Utils_Tuple3(
							A2(
								$author$project$Element$ModuleEventForm$updatePage,
								$author$project$Element$ModuleEventForm$EventFormPage(formModel),
								model),
							$author$project$Element$ModuleEventForm$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						return noop;
					}
				}
			default:
				if (!_v0.a.a.$) {
					if ((_v0.b.$ === 1) && (_v0.b.a.$ === 1)) {
						var modules = _v0.a.a.a;
						var timeslot = _v0.b.a.a;
						return _Utils_Tuple3(
							A4(
								$author$project$Element$ModuleEventForm$openCreateForm,
								session,
								_Utils_update(
									model,
									{
										hH: $elm$core$Maybe$Just(modules)
									}),
								timeslot,
								modules),
							$author$project$Element$ModuleEventForm$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						return noop;
					}
				} else {
					var error = _v0.a.a.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Element$ModuleEventForm$updateSession,
							A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$ModulesDownloadError)),
							model),
						$author$project$Element$ModuleEventForm$Cmd(
							$author$project$Element$ModuleEventForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgModulesDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
										error),
									$elm$core$Basics$always($author$project$Element$ModuleEventForm$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
		}
	});
var $author$project$Element$ModuleEventForm$EventFormReset = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleEventForm$EventFormSubmitted = {$: 2};
var $author$project$Locale$Messages$ModuleEventDate = {$: 207};
var $author$project$Element$ModuleEventForm$PopupClosed = {$: 10};
var $author$project$Locale$Messages$TimetableHeadingEdit = {$: 611};
var $author$project$Locale$Messages$TimetableHeadingNew = {$: 610};
var $author$project$UI$fieldLegend = F2(
	function (t_, field) {
		return A4($author$project$UI$label_, $elm$html$Html$legend, t_, $elm$core$Maybe$Nothing, field);
	});
var $author$project$UI$checkboxField = F3(
	function (t_, field, values) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		var selectedValues = field.fC(values);
		var checkboxIsDisabled = function (option) {
			var _v1 = field.og.lo;
			if (!_v1.$) {
				var listOfDisabledOptions = _v1.a;
				return A2($elm$core$List$member, option, listOfDisabledOptions);
			} else {
				return false;
			}
		};
		var viewCheckboxes = $elm$core$List$map(
			A4($author$project$UI$checkbox, field.og.mU, field.og.cm, checkboxIsDisabled, selectedValues));
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('has-errors', !valid)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$UI$fieldLegend, t_, field),
					function () {
					var _v0 = field.og.m_;
					if (_v0.$ === 1) {
						return $author$project$UI$Icon$loadingOptions(_List_Nil);
					} else {
						var options = _v0.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('control has-icons-right'),
									$elm$html$Html$Attributes$classList(
									A2($author$project$UI$validationClassList, field, values))
								]),
							_Utils_ap(
								viewCheckboxes(options),
								_List_fromArray(
									[
										A2($author$project$UI$fieldValidationStatus, field.e0, valid)
									])));
					}
				}(),
					A2($author$project$UI$validationError, field, values)
				]));
	});
var $author$project$UI$radioField = F3(
	function (t_, field, values) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		var selectedValue = field.fC(values);
		var viewButtons = $elm$core$List$map(
			A3($author$project$UI$radioButton, field.og.fe, field.og.cm, selectedValue));
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('has-errors', !valid)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$UI$fieldLegend, t_, field),
					function () {
					var _v0 = field.og.m_;
					if (_v0.$ === 1) {
						return $author$project$UI$Icon$loadingOptions(_List_Nil);
					} else {
						var options = _v0.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('control has-icons-right'),
									$elm$html$Html$Attributes$classList(
									A2($author$project$UI$validationClassList, field, values))
								]),
							_Utils_ap(
								viewButtons(options),
								_List_fromArray(
									[
										A2($author$project$UI$fieldValidationStatus, field.e0, valid)
									])));
					}
				}(),
					A2($author$project$UI$validationError, field, values)
				]));
	});
var $author$project$Locale$Messages$FormTimeFormat = {$: 77};
var $author$project$UI$timeField = F3(
	function (t_, field, values) {
		return A3(
			$author$project$UI$textField,
			t_,
			{
				e0: field.e0,
				fi: field.fi,
				fp: field.fp,
				ks: field.ks,
				fC: field.fC,
				og: {
					cm: field.og.cm,
					e6: 'fa-clock',
					ea: field.og.ea,
					fe: field.og.fe,
					fj: t_($author$project$Locale$Messages$FormTimeFormat),
					ii: 'time'
				}
			},
			values);
	});
var $author$project$Element$ModuleEventForm$toGenericFormState = function (state) {
	switch (state) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Element$ModuleEventForm$viewForm = F2(
	function (t_, _v0) {
		var action = _v0.iq;
		var state = _v0.fs;
		var form = _v0.bE;
		var values = _v0.eI;
		var validations = _v0.dM;
		var viewSingleOccurenceFields = function () {
			var startDateView = form.nN.og;
			var startDate = form.nN;
			var nonRecurringDateField = _Utils_update(
				startDate,
				{
					og: _Utils_update(
						startDateView,
						{
							ea: t_($author$project$Locale$Messages$ModuleEventDate)
						})
				});
			return _List_fromArray(
				[
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$radioField, t_, form.V, values),
							A3($author$project$UI$dateField, t_, nonRecurringDateField, values)
						]))
				]);
		}();
		var viewModuleField = function () {
			if (!action.$) {
				if (action.a.$ === 1) {
					var _v5 = action.a;
					return $author$project$UI$columns(
						_List_fromArray(
							[
								A3($author$project$UI$choiceField, t_, form.hG, values)
							]));
				} else {
					return $author$project$UI$columns(
						_List_fromArray(
							[
								A3($author$project$UI$frozenChoiceField, t_, form.hG, values)
							]));
				}
			} else {
				return $author$project$UI$none;
			}
		}();
		var viewHeadingText = function () {
			if (!action.$) {
				return A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableHeadingNew);
			} else {
				return A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableHeadingEdit);
			}
		}();
		var viewCommonFields = _List_fromArray(
			[
				viewModuleField,
				$author$project$UI$columns(
				_List_fromArray(
					[
						A3($author$project$UI$textField, t_, form.kj, values),
						A3($author$project$UI$textField, t_, form.aZ, values)
					])),
				$author$project$UI$columns(
				_List_fromArray(
					[
						A3($author$project$UI$timeField, t_, form.R, values),
						A3($author$project$UI$timeField, t_, form.G, values)
					]))
			]);
		var viewButtons = A5(
			$author$project$UI$formButtons,
			t_,
			action,
			$author$project$Element$ModuleEventForm$toGenericFormState(state),
			$author$project$Element$ModuleEventForm$EventFormSubmitted,
			function (_v2) {
				var event = _v2.a;
				var occId = _v2.b;
				return $author$project$Element$ModuleEventForm$EventFormReset(
					{
						iX: $author$project$ModuleEvent$moduleEventIdToInt(event.i8),
						hL: $author$project$ModuleEvent$moduleEventOccurenceIdToInt(occId)
					});
			});
		var validationError = function (content) {
			return (state === 1) ? (validations.c3 ? content : A3($author$project$UI$withErrorText, t_, $author$project$Locale$Messages$FormEndDateBeforeStartDate, content)) : content;
		};
		var viewRecurringFields = _List_fromArray(
			[
				$author$project$UI$columns(
				_List_fromArray(
					[
						A3($author$project$UI$radioField, t_, form.V, values),
						A3($author$project$UI$checkboxField, t_, form.N, values)
					])),
				$author$project$UI$columns(
				function () {
					if (!action.$) {
						return _List_fromArray(
							[
								A3($author$project$UI$dateField, t_, form.nN, values),
								validationError(
								A3($author$project$UI$dateField, t_, form.ly, values))
							]);
					} else {
						return _List_fromArray(
							[
								$author$project$UI$none,
								validationError(
								A3($author$project$UI$dateField, t_, form.ly, values))
							]);
					}
				}())
			]);
		var isRecurring = form.V.fC(values) !== 'NOREPEAT';
		return A4(
			$author$project$UI$modalPanel,
			_List_fromArray(
				[viewHeadingText]),
			_List_fromArray(
				[
					$author$project$UI$closeButton($author$project$Element$ModuleEventForm$PopupClosed)
				]),
			_Utils_ap(
				viewCommonFields,
				isRecurring ? viewRecurringFields : viewSingleOccurenceFields),
			_List_fromArray(
				[viewButtons]));
	});
var $author$project$Element$ModuleEventForm$viewProgressBar = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('is-overlay is-extra-small')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$progress,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('progress is-extra-small')
				]),
			_List_Nil)
		]));
var $author$project$Element$ModuleEventForm$EventUpdateScopeSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Locale$Messages$TimetableBtnEditAllOccurences = {$: 620};
var $author$project$Locale$Messages$TimetableBtnEditThisAndFutureOccurences = {$: 619};
var $author$project$Locale$Messages$TimetableModuleEventChangeHeading = {$: 629};
var $author$project$Locale$Messages$TimetableModuleEventChangeHelp = {$: 630};
var $author$project$Element$ModuleEventForm$UpdateAll = 1;
var $author$project$Element$ModuleEventForm$UpdateScopeNotSelected = {$: 5};
var $author$project$Element$ModuleEventForm$UpdateThisAndFuture = 0;
var $author$project$Element$ModuleEventForm$viewUpdateSelectionModal = function (t_) {
	return A4(
		$author$project$UI$modalPanel,
		_List_fromArray(
			[
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableModuleEventChangeHeading)
			]),
		_List_fromArray(
			[
				$author$project$UI$closeButton($author$project$Element$ModuleEventForm$UpdateScopeNotSelected)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content')
					]),
				$author$project$UI$textToHtml(
					t_($author$project$Locale$Messages$TimetableModuleEventChangeHelp)))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button is-link'),
						$elm$html$Html$Events$onClick(
						$author$project$Element$ModuleEventForm$EventUpdateScopeSelected(0))
					]),
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableBtnEditThisAndFutureOccurences)
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button is-warning'),
						$elm$html$Html$Events$onClick(
						$author$project$Element$ModuleEventForm$EventUpdateScopeSelected(1))
					]),
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableBtnEditAllOccurences)
					]))
			]));
};
var $author$project$Element$ModuleEventForm$view = function (model) {
	var session = model.gB;
	var _v0 = model.bk;
	switch (_v0.$) {
		case 3:
			return $author$project$Element$ModuleEventForm$viewProgressBar;
		case 1:
			return $author$project$Element$ModuleEventForm$viewProgressBar;
		case 2:
			return $author$project$Element$ModuleEventForm$viewProgressBar;
		default:
			var formModel = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Element$ModuleEventForm$viewForm, session.h6, formModel),
						function () {
						var _v1 = formModel.fs;
						if (_v1 === 2) {
							return $author$project$Element$ModuleEventForm$viewUpdateSelectionModal(session.h6);
						} else {
							return $author$project$UI$none;
						}
					}()
					]));
	}
};
var $author$project$Element$ModuleEventForm$element = {jb: $author$project$Element$ModuleEventForm$init, hP: $author$project$Element$ModuleEventForm$perform, ks: $author$project$Element$ModuleEventForm$update, og: $author$project$Element$ModuleEventForm$view};
var $author$project$Element$Timetable$moduleEventForm = {
	ha: $author$project$Element$ModuleEventForm$element,
	cf: $author$project$Element$Timetable$ModuleEventFormMsg,
	kt: F2(
		function (containerModel, model) {
			return _Utils_update(
				containerModel,
				{
					dr: $elm$core$Maybe$Just(
						$author$project$Element$Timetable$EventFormView(model))
				});
		})
};
var $author$project$Log$msgDailyAttendanceDownload = 'daily_attendance_download';
var $author$project$Log$msgDailyAttendanceSave = 'daily_attendance_save';
var $author$project$Log$msgModuleEventDelete = 'module_event_delete';
var $author$project$Element$ModuleEventForm$CreateEvent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$Timetable$openCreateForm = F2(
	function (query, _return) {
		var session = _return.gB;
		var model = _return.eh;
		var createFormOpened = A3(
			$author$project$Application$V2$Boundaries$mapElement,
			_return,
			$author$project$Element$Timetable$moduleEventForm,
			A5(
				$author$project$Application$V2$Boundaries$initElement,
				model.b_.jk,
				$author$project$Application$V2$SharedConfig$fromV1(model.b_),
				session,
				$author$project$Element$Timetable$moduleEventForm,
				$author$project$Element$ModuleEventForm$CreateEvent(query)));
		return {dX: createFormOpened.dX, eh: createFormOpened.eh, gs: $elm$core$Maybe$Nothing, gB: createFormOpened.gB};
	});
var $author$project$Element$Timetable$Daily = $elm$core$Basics$identity;
var $author$project$Element$Timetable$FieldAttendantsSet = function (a) {
	return {$: 10, a: a};
};
var $author$project$Locale$Messages$TimetableAttendanceParticipants = {$: 627};
var $author$project$Element$Timetable$buildAttendanceForm = function (t_) {
	return {
		gW: {
			e0: false,
			fi: $author$project$Form$optionalPeople(t_),
			fp: false,
			ks: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{gW: value});
				}),
			fC: function ($) {
				return $.gW;
			},
			og: {
				cm: 'attendants',
				lo: $elm$core$Maybe$Nothing,
				e6: 'fa-users',
				ea: t_($author$project$Locale$Messages$TimetableAttendanceParticipants),
				mU: $author$project$Element$Timetable$FieldAttendantsSet,
				m_: $elm$core$Maybe$Nothing
			}
		}
	};
};
var $author$project$Element$Timetable$dailyAttendanceToStudentOptions = F2(
	function (t_, _v0) {
		var attendants = _v0.gW;
		var absentees = _v0.gR;
		return A2(
			$author$project$Form$toPeopleOptions,
			t_,
			$author$project$Util$List$unique(
				_Utils_ap(attendants, absentees)));
	});
var $author$project$Element$Timetable$fillAttendanceForm = function (attendants) {
	return {
		gW: A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.i8;
				},
				$elm$core$String$fromInt),
			attendants)
	};
};
var $author$project$Element$Timetable$openDailyAttendanceForm = F2(
	function (attendance, _return) {
		var session = _return.gB;
		var blankForm = $author$project$Element$Timetable$buildAttendanceForm(session.h6);
		var attendantIdsAsString = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.i8;
				},
				$elm$core$String$fromInt),
			attendance.gW);
		var absenteeIdsAsString = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.i8;
				},
				$elm$core$String$fromInt),
			attendance.gR);
		var isFullDayAbsent = function (personIdAsString) {
			return A2($elm$core$List$member, personIdAsString, absenteeIdsAsString) && (!A2($elm$core$List$member, personIdAsString, attendantIdsAsString));
		};
		var fillFieldOptionsDisableNotSelected = F2(
			function (options, field) {
				return _Utils_update(
					field,
					{
						og: {
							cm: field.og.cm,
							lo: $elm$core$Maybe$Just(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeL,
										isFullDayAbsent,
										function ($) {
											return $.fC;
										}),
									options)),
							e6: field.og.e6,
							ea: field.og.ea,
							mU: field.og.mU,
							m_: $elm$core$Maybe$Just(options)
						}
					});
			});
		var formModel = {
			fX: attendance,
			bE: _Utils_update(
				blankForm,
				{
					gW: A2(
						fillFieldOptionsDisableNotSelected,
						A2($author$project$Element$Timetable$dailyAttendanceToStudentOptions, session.h6, attendance),
						blankForm.gW)
				}),
			fs: 0,
			eI: $author$project$Element$Timetable$fillAttendanceForm(attendance.gW)
		};
		return A2(
			$author$project$Element$Timetable$openPopup,
			$author$project$Element$Timetable$DailyAttendanceFormView(formModel),
			_return);
	});
var $author$project$Element$ModuleEventForm$UpdateEvent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$Timetable$openUpdateForm = F2(
	function (query, _return) {
		var session = _return.gB;
		var model = _return.eh;
		var updateFormOpened = A2(
			$author$project$Application$Boundaries$andThenCmd,
			A2(
				$elm$core$Task$attempt,
				$elm$core$Basics$always($author$project$Element$Timetable$NoOp),
				$elm$browser$Browser$Dom$focus('timetable-popup')),
			A3(
				$author$project$Application$V2$Boundaries$mapElement,
				_return,
				$author$project$Element$Timetable$moduleEventForm,
				A5(
					$author$project$Application$V2$Boundaries$initElement,
					model.b_.jk,
					$author$project$Application$V2$SharedConfig$fromV1(model.b_),
					session,
					$author$project$Element$Timetable$moduleEventForm,
					$author$project$Element$ModuleEventForm$UpdateEvent(query))));
		return {dX: updateFormOpened.dX, eh: updateFormOpened.eh, gs: $elm$core$Maybe$Nothing, gB: updateFormOpened.gB};
	});
var $author$project$Element$Timetable$DailyAttendanceSaved = function (a) {
	return {$: 12, a: a};
};
var $author$project$DailyAttendance$DailyAttendanceUnsaved = F3(
	function (day, attendants, absentees) {
		return {gR: absentees, gW: attendants, fY: day};
	});
var $author$project$Util$List$subtract = F2(
	function (x, y) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (item, acc) {
					return A2($elm$core$List$member, item, y) ? acc : A2($elm$core$List$cons, item, acc);
				}),
			_List_Nil,
			x);
	});
var $author$project$DailyAttendance$dailyAttendanceEncoder = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'day',
				$elm$json$Json$Encode$int(data.fY)),
				_Utils_Tuple2(
				'attendants',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, data.gW)),
				_Utils_Tuple2(
				'absentees',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, data.gR))
			]));
};
var $author$project$Api$patch = F5(
	function (url, config, body, toMsg, decoder) {
		return $author$project$Api$Endpoint$request(
			{
				T: body,
				bd: A2($author$project$Api$expectJson, toMsg, decoder),
				ar: $author$project$Api$toHeaders(config),
				bj: 'PATCH',
				bp: $elm$core$Maybe$Nothing,
				bq: $elm$core$Maybe$Nothing,
				K: url
			});
	});
var $author$project$DailyAttendance$updateDailyAttendance = F3(
	function (config, data, callback) {
		return A5(
			$author$project$Api$patch,
			A2($author$project$Api$Endpoint$dailyAttendance, config, data.fY),
			config,
			$elm$http$Http$jsonBody(
				$author$project$DailyAttendance$dailyAttendanceEncoder(data)),
			callback,
			$author$project$DailyAttendance$dailyAttendanceDecoder);
	});
var $author$project$Element$Timetable$updateAttendance = F2(
	function (config, _v0) {
		var form = _v0.bE;
		var values = _v0.eI;
		var dataSource = _v0.fX;
		var attendance = dataSource;
		var newAttendants = A2(
			$elm$core$List$map,
			$author$project$Person$decodePersonId,
			form.gW.fC(values));
		var attendantIds = A2(
			$elm$core$List$map,
			function ($) {
				return $.i8;
			},
			attendance.gW);
		var absenteeIds = A2(
			$elm$core$List$map,
			function ($) {
				return $.i8;
			},
			attendance.gR);
		var allStudents = $author$project$Util$List$unique(
			_Utils_ap(attendantIds, absenteeIds));
		var attendanceUnsaved = A3(
			$author$project$DailyAttendance$DailyAttendanceUnsaved,
			attendance.fY,
			newAttendants,
			A2($author$project$Util$List$subtract, allStudents, newAttendants));
		return A3($author$project$DailyAttendance$updateDailyAttendance, config.gX, attendanceUnsaved, $author$project$Element$Timetable$DailyAttendanceSaved);
	});
var $author$project$Element$Timetable$update = F3(
	function (session, msg, model) {
		update:
		while (true) {
			var t_ = session.h6;
			var config = model.b_;
			var noop = A2($author$project$Application$Boundaries$save, model, session);
			var _v0 = _Utils_Tuple2(msg, model.dr);
			_v0$31:
			while (true) {
				switch (_v0.a.$) {
					case 2:
						var query = _v0.a.a;
						return A2($author$project$Element$Timetable$openCreateForm, query, noop);
					case 3:
						var query = _v0.a.a;
						return A2($author$project$Element$Timetable$openUpdateForm, query, noop);
					case 4:
						if (!_v0.b.$) {
							if ((_v0.b.a.$ === 1) && (_v0.b.a.a.$ === 1)) {
								var _v1 = _v0.a;
								var _v2 = _v0.b.a.a;
								var event = _v2.a;
								var occurence = _v2.b;
								return A2(
									$author$project$Element$Timetable$openPopup,
									A2($author$project$Element$Timetable$DeleteView, event, occurence),
									noop);
							} else {
								break _v0$31;
							}
						} else {
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							return noop;
						}
					case 6:
						var _v5 = _v0.a;
						return $author$project$Element$Timetable$closePopup(noop);
					case 5:
						var _v6 = _v0.a;
						var scope = _v6.a;
						var occurence = _v6.b;
						var cmd = function () {
							switch (scope) {
								case 0:
									return A3($author$project$ModuleEvent$cancelModuleEventOccurence, config.gX, occurence.i8, $author$project$Element$Timetable$ModuleEventOccurenceCanceled);
								case 1:
									return A4(
										$author$project$ModuleEvent$deleteAfterModuleEvent,
										config.gX,
										occurence.ek.i8,
										occurence.i8,
										$author$project$Element$Timetable$ModuleEventDeleted(occurence));
								default:
									return A3(
										$author$project$ModuleEvent$deleteAllModuleEvent,
										config.gX,
										occurence.ek.i8,
										$author$project$Element$Timetable$ModuleEventDeleted(occurence));
							}
						}();
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							cmd,
							$author$project$Element$Timetable$closePopup(noop));
					case 14:
						if (!_v0.a.b.$) {
							var _v8 = _v0.a;
							var occurence = _v8.a;
							var $temp$session = A2(
								$author$project$Session$ok,
								session,
								session.h6($author$project$Locale$Messages$TimetableModuleEventDeleteSuccess)),
								$temp$msg = $author$project$Element$Timetable$TimetableCalendarMsg(
								$author$project$Element$TimetableCalendar$EventDeleted(occurence)),
								$temp$model = model;
							session = $temp$session;
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						} else {
							var _v9 = _v0.a;
							var error = _v9.b.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgModuleEventDelete,
										$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
										error),
									$elm$core$Basics$always($author$project$Element$Timetable$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$TimetableModuleEventDeleteError))));
						}
					case 13:
						if (!_v0.a.a.$) {
							var occurence = _v0.a.a.a;
							var $temp$session = A2(
								$author$project$Session$ok,
								session,
								session.h6($author$project$Locale$Messages$TimetableModuleEventOccurenceCancelSuccess)),
								$temp$msg = $author$project$Element$Timetable$TimetableCalendarMsg(
								$author$project$Element$TimetableCalendar$OccurenceChanged(occurence)),
								$temp$model = model;
							session = $temp$session;
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						} else {
							var error = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgModuleEventOccurenceSave,
										$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
										error),
									$elm$core$Basics$always($author$project$Element$Timetable$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$TimetableOccurenceSaveError))));
						}
					case 7:
						if (_v0.a.a.$ === 1) {
							var error = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgModuleEventDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$Timetable$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$ModulesDownloadError))));
						} else {
							if (!_v0.b.$) {
								if ((_v0.b.a.$ === 1) && (!_v0.b.a.a.$)) {
									var event = _v0.a.a.a;
									var occurence = _v0.b.a.a.a;
									return A2(
										$author$project$Element$Timetable$openPopup,
										$author$project$Element$Timetable$DetailView(
											A2($author$project$Element$Timetable$DetailViewLoaded, event, occurence)),
										noop);
								} else {
									break _v0$31;
								}
							} else {
								var _v10 = _v0.b;
								return noop;
							}
						}
					case 9:
						if (!_v0.a.a.$) {
							var attendance = _v0.a.a.a;
							return A2($author$project$Element$Timetable$openDailyAttendanceForm, attendance, noop);
						} else {
							var error = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgDailyAttendanceDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
										error),
									$elm$core$Basics$always($author$project$Element$Timetable$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$DailyAttendanceDownloadError))));
						}
					case 1:
						switch (_v0.a.a) {
							case 0:
								var _v11 = _v0.a.a;
								return $author$project$Element$Timetable$closePopup(noop);
							case 1:
								if (((!_v0.b.$) && (_v0.b.a.$ === 1)) && (_v0.b.a.a.$ === 1)) {
									var _v12 = _v0.a.a;
									var _v13 = _v0.b.a.a;
									var event = _v13.a;
									var occurence = _v13.b;
									return A2(
										$author$project$Element$Timetable$openPopup,
										A2($author$project$Element$Timetable$DeleteView, event, occurence),
										noop);
								} else {
									break _v0$31;
								}
							default:
								var _v14 = _v0.a.a;
								return noop;
						}
					case 8:
						var _v15 = _v0.a;
						return $author$project$Element$Timetable$closePopup(noop);
					case 10:
						if (!_v0.b.$) {
							if (_v0.b.a.$ === 2) {
								var value = _v0.a.a;
								var formModel = _v0.b.a.a;
								var form = formModel.bE;
								var values = formModel.eI;
								var popup = $author$project$Element$Timetable$DailyAttendanceFormView(
									_Utils_update(
										formModel,
										{
											bE: _Utils_update(
												form,
												{
													gW: $author$project$Form$markEdited(form.gW)
												}),
											fs: 1,
											eI: A2(form.gW.ks, value, values)
										}));
								return A2($author$project$Element$Timetable$updatePopup, popup, noop);
							} else {
								break _v0$31;
							}
						} else {
							var _v16 = _v0.b;
							return noop;
						}
					case 11:
						if (!_v0.b.$) {
							if (_v0.b.a.$ === 2) {
								var _v17 = _v0.a;
								var formModel = _v0.b.a.a;
								var form = formModel.bE;
								var values = formModel.eI;
								if (A2($author$project$Element$Timetable$isAttendanceFormValid, form, values)) {
									var popup = $author$project$Element$Timetable$DailyAttendanceFormView(
										_Utils_update(
											formModel,
											{fs: 2}));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A2($author$project$Element$Timetable$updateAttendance, config, formModel),
										A2($author$project$Element$Timetable$updatePopup, popup, noop));
								} else {
									var popup = $author$project$Element$Timetable$DailyAttendanceFormView(
										_Utils_update(
											formModel,
											{
												bE: $author$project$Element$Timetable$markAttendanceFormEdited(form),
												fs: 1
											}));
									return A2($author$project$Element$Timetable$updatePopup, popup, noop);
								}
							} else {
								break _v0$31;
							}
						} else {
							var _v18 = _v0.a;
							var _v19 = _v0.b;
							return noop;
						}
					case 12:
						if (!_v0.a.a.$) {
							if (!_v0.b.$) {
								if (_v0.b.a.$ === 2) {
									return $author$project$Element$Timetable$closePopup(
										A3(
											$author$project$Element$Timetable$update,
											A2(
												$author$project$Session$ok,
												session,
												session.h6($author$project$Locale$Messages$TimetableOccurenceSaveSuccess)),
											$author$project$Element$Timetable$TimetableCalendarMsg($author$project$Element$TimetableCalendar$EventsChanged),
											model));
								} else {
									break _v0$31;
								}
							} else {
								var _v20 = _v0.b;
								return noop;
							}
						} else {
							if (!_v0.b.$) {
								if (_v0.b.a.$ === 2) {
									var error = _v0.a.a.a;
									var formModel = _v0.b.a.a;
									var session2 = A3(
										$author$project$Session$error,
										session,
										error,
										session.h6($author$project$Locale$Messages$FormSaveError));
									var popup = $author$project$Element$Timetable$DailyAttendanceFormView(
										_Utils_update(
											formModel,
											{fs: 3}));
									var cmd = A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgDailyAttendanceSave,
											$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
											error),
										$elm$core$Basics$always($author$project$Element$Timetable$NoOp));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										cmd,
										A2(
											$author$project$Element$Timetable$openPopup,
											popup,
											A2($author$project$Application$Boundaries$save, model, session2)));
								} else {
									break _v0$31;
								}
							} else {
								var _v21 = _v0.b;
								return noop;
							}
						}
					case 15:
						var calendarMsg = _v0.a.a;
						var _v22 = model.dV;
						if (!_v22.$) {
							var calendarModel = _v22.a;
							var _return = A3($author$project$Element$Timetable$timetableCalendar.ha.ks, session, calendarMsg, calendarModel);
							var _v23 = _return.gs;
							if (!_v23.$) {
								switch (_v23.a.$) {
									case 0:
										var timeslot = _v23.a.a;
										var query = {
											hb: $elm$core$Maybe$Just(timeslot.b),
											js: $elm$core$Maybe$Nothing,
											h2: $elm$core$Maybe$Just(timeslot.a)
										};
										return A2($author$project$Element$Timetable$openCreateForm, query, noop);
									case 1:
										var occurence = _v23.a.a;
										return A2($author$project$Element$Timetable$loadDetailView, occurence, noop);
									default:
										var date = _v23.a.a;
										return A2($author$project$Element$Timetable$downloadDailyAttendance, date, noop);
								}
							} else {
								return A3($author$project$Application$Boundaries$mapElement, model, $author$project$Element$Timetable$timetableCalendar, _return);
							}
						} else {
							return noop;
						}
					case 16:
						if ((!_v0.b.$) && (!_v0.b.a.$)) {
							var eventFormMsg = _v0.a.a;
							var eventFormModel = _v0.b.a.a;
							var _return = A5($author$project$Application$V2$Boundaries$updateElement, config.jk, session, eventFormMsg, eventFormModel, $author$project$Element$Timetable$moduleEventForm);
							var _v24 = _return.gs;
							if (!_v24.$) {
								var reply = _v24.a;
								if (!reply) {
									return $author$project$Element$Timetable$closePopup(
										A3(
											$author$project$Element$Timetable$update,
											_return.gB,
											$author$project$Element$Timetable$TimetableCalendarMsg($author$project$Element$TimetableCalendar$EventsChanged),
											model));
								} else {
									return $author$project$Element$Timetable$closePopup(
										A2($author$project$Application$Boundaries$save, model, _return.gB));
								}
							} else {
								var moduleEventFormReturn = A3(
									$author$project$Application$V2$Boundaries$mapElement,
									A2($author$project$Application$Boundaries$save, model, session),
									$author$project$Element$Timetable$moduleEventForm,
									_return);
								return {dX: moduleEventFormReturn.dX, eh: moduleEventFormReturn.eh, gs: $elm$core$Maybe$Nothing, gB: moduleEventFormReturn.gB};
							}
						} else {
							return noop;
						}
					default:
						var _v26 = _v0.a;
						return noop;
				}
			}
			return noop;
		}
	});
var $author$project$Element$Timetable$loadCalendar = F3(
	function (people, session, model) {
		var selectPeopleInCalendar = function (people_) {
			return A3(
				$author$project$Element$Timetable$update,
				session,
				$author$project$Element$Timetable$TimetableCalendarMsg(
					$author$project$Element$TimetableCalendar$PeopleSelected(people_)),
				model);
		};
		var _return = A3(
			$author$project$Application$Boundaries$mapElement,
			model,
			$author$project$Element$Timetable$timetableCalendar,
			A4($author$project$Application$Boundaries$initElement, model.b_, session, $author$project$Element$Timetable$timetableCalendar, people));
		return A2(
			$elm$core$Maybe$withDefault,
			_return,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always(
					selectPeopleInCalendar(people)),
				model.dV));
	});
var $author$project$Element$Timetable$init = F3(
	function (config, session, params) {
		var model = {dV: $elm$core$Maybe$Nothing, b_: config, hH: $elm$core$Maybe$Nothing, dr: $elm$core$Maybe$Nothing};
		switch (params.$) {
			case 0:
				var people = params.a;
				return A3($author$project$Element$Timetable$loadCalendar, people, session, model);
			case 1:
				var query = params.a;
				return A2(
					$author$project$Element$Timetable$openCreateForm,
					query,
					A3($author$project$Element$Timetable$loadCalendar, _List_Nil, session, model));
			default:
				var query = params.a;
				return A2(
					$author$project$Element$Timetable$openUpdateForm,
					query,
					A3($author$project$Element$Timetable$loadCalendar, _List_Nil, session, model));
		}
	});
var $author$project$Element$Timetable$KeyEvent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TimetableCalendar$anyEventsLoading = F3(
	function (viewState, filter, eventStore) {
		return A2(
			$elm$core$List$any,
			A2($author$project$Element$TimetableCalendar$personHasMissingEvents, viewState, eventStore),
			filter.m6);
	});
var $author$project$Element$TimetableCalendar$isBusy = F2(
	function (viewer, _v0) {
		var filter = _v0.ad;
		var viewState = _v0.dN;
		var eventStore = _v0.bc;
		var people = _v0.m6;
		var isLoaded = function () {
			var _v1 = _Utils_Tuple2(
				$author$project$ACL$canViewTimetablesOther(viewer),
				people);
			if (_v1.a) {
				if (!_v1.b.$) {
					return true;
				} else {
					return false;
				}
			} else {
				return true;
			}
		}();
		return isLoaded && A3($author$project$Element$TimetableCalendar$anyEventsLoading, viewState, filter, eventStore);
	});
var $author$project$KeyEvents$Delete = 1;
var $author$project$KeyEvents$Escape = 0;
var $author$project$KeyEvents$Other = 2;
var $author$project$KeyEvents$keyDecoder = F2(
	function (isPreventDefaultOn, toMsg) {
		return A2(
			$elm$json$Json$Decode$map,
			function (key) {
				switch (key) {
					case 'Delete':
						return _Utils_Tuple2(
							toMsg(1),
							isPreventDefaultOn);
					case 'Backspace':
						return _Utils_Tuple2(
							toMsg(1),
							isPreventDefaultOn);
					case 'Escape':
						return _Utils_Tuple2(
							toMsg(0),
							isPreventDefaultOn);
					default:
						return _Utils_Tuple2(
							toMsg(2),
							isPreventDefaultOn);
				}
			},
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	});
var $author$project$KeyEvents$onKeyDown = function (toMsg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'keydown',
		A2($author$project$KeyEvents$keyDecoder, false, toMsg));
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$Element$Timetable$DailyAttendanceFormSubmitted = {$: 11};
var $author$project$Element$Timetable$PopupClosed = {$: 8};
var $author$project$UI$modalDialog = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal is-active')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-background')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-content')
					]),
				_List_fromArray(
					[content]))
			]));
};
var $author$project$Element$Timetable$resetAttendanceForm = function (data) {
	var attendance = data;
	return $author$project$Element$Timetable$DailyAttendanceDownloaded(
		$elm$core$Result$Ok(attendance));
};
var $author$project$Locale$Messages$DailyAttendanceFormInstructions = {$: 54};
var $author$project$Locale$Messages$DailyAttendanceFormTitle = {$: 53};
var $author$project$Element$Timetable$viewDailyAttendanceMeta = F2(
	function (t_, attendance) {
		var viewTime = A2(
			$author$project$UI$caption,
			t_,
			A2(
				$author$project$Locale$Messages$TimeDateFormat,
				$elm$time$Time$utc,
				$elm$time$Time$millisToPosix(attendance.fY)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title is-6 mb-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t_($author$project$Locale$Messages$DailyAttendanceFormTitle))
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-size-7 inline-list')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[viewTime]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							t_($author$project$Locale$Messages$DailyAttendanceFormInstructions))
						]))
				]));
	});
var $author$project$Element$Timetable$viewAttendanceForm = F2(
	function (t_, _v0) {
		var state = _v0.fs;
		var form = _v0.bE;
		var values = _v0.eI;
		var dataSource = _v0.fX;
		var submitForm_ = $author$project$Element$Timetable$DailyAttendanceFormSubmitted;
		var viewForm_ = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$checkboxField, t_, form.gW, values)
						])),
					A5(
					$author$project$UI$formButtons,
					t_,
					$author$project$Form$Update(dataSource),
					state,
					submitForm_,
					$author$project$Element$Timetable$resetAttendanceForm)
				]));
		var attendance = dataSource;
		return $author$project$UI$modalDialog(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('box')
					]),
				_List_fromArray(
					[
						A4(
						$author$project$UI$mediaObject,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Element$Timetable$viewDailyAttendanceMeta, t_, attendance),
								viewForm_
							]),
						_List_Nil,
						_List_fromArray(
							[
								$author$project$UI$closeButton($author$project$Element$Timetable$PopupClosed)
							]))
					])));
	});
var $author$project$Element$Timetable$DeleteThis = 0;
var $author$project$Element$Timetable$ModuleEventDeleteConfirmed = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Element$Timetable$ModuleEventDeleteDeclined = {$: 6};
var $author$project$Locale$Messages$TimetableActionModuleEventDelete = {$: 615};
var $author$project$Locale$Messages$TimetableBtnDeleteThisOccurence = {$: 617};
var $author$project$Locale$Messages$TimetableModuleEventNonRecurringDeleteHelp = {$: 632};
var $author$project$Element$Timetable$viewNonRecurringDeleteDialog = F2(
	function (t_, occurence) {
		return A4(
			$author$project$UI$modalPanel,
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableActionModuleEventDelete)
				]),
			_List_fromArray(
				[
					$author$project$UI$closeButton($author$project$Element$Timetable$ModuleEventDeleteDeclined)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableModuleEventNonRecurringDeleteHelp)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-grey'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Element$Timetable$ModuleEventDeleteConfirmed, 0, occurence))
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableBtnDeleteThisOccurence)
						]))
				]));
	});
var $author$project$Locale$Messages$TimetableAttendanceAbsents = {$: 628};
var $author$project$Element$Timetable$viewAttendanceSheet = F2(
	function (t_, occ) {
		var viewPersonName = function (person) {
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Person$fullName, t_, person))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$UI$when,
					!$elm$core$List$isEmpty(occ.gW),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('block')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('is-size-6')
									]),
								_List_fromArray(
									[
										A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableAttendanceParticipants)
									])),
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('is-size-6')
									]),
								A2($elm$core$List$map, viewPersonName, occ.gW))
							]))),
					A2(
					$author$project$UI$when,
					!$elm$core$List$isEmpty(occ.gR),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('block')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('is-size-6')
									]),
								_List_fromArray(
									[
										A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableAttendanceAbsents)
									])),
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('is-size-6')
									]),
								A2($elm$core$List$map, viewPersonName, occ.gR))
							])))
				]));
	});
var $author$project$Element$Timetable$ModuleEventDeleteRequested = {$: 4};
var $author$project$Locale$Messages$TimetableActionAttendanceEdit = {$: 613};
var $author$project$Locale$Messages$TimetableActionModuleEventEdit = {$: 614};
var $author$project$Locale$Messages$TimetableGoogleMeet = {$: 612};
var $author$project$UI$navHorizontal = F2(
	function (left, right) {
		return A3($author$project$UI$nav_, true, left, right);
	});
var $author$project$Element$Timetable$viewNavLinks = F3(
	function (t_, viewer, occ) {
		var viewConferenceLink = function (url) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(url),
						$elm$html$Html$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$author$project$UI$Icon$google(
						_List_fromArray(
							[
								$author$project$UI$Icon$style('has-text-link-dark')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableGoogleMeet)
							]))
					]));
		};
		var leftLinks = _List_fromArray(
			[
				A2($author$project$UI$maybe, occ.lb, viewConferenceLink)
			]);
		var isEmptyUI = A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filter(
				$elm$core$Basics$neq($author$project$UI$none)),
			$elm$core$List$isEmpty);
		var editRoute = $author$project$Route$TimetableUpdateEvent(
			{
				iX: $author$project$ModuleEvent$moduleEventIdToInt(occ.ek.i8),
				hL: $author$project$ModuleEvent$moduleEventOccurenceIdToInt(occ.i8)
			});
		var editEventLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(editRoute),
					$elm$html$Html$Attributes$title(
					t_($author$project$Locale$Messages$TimetableActionModuleEventEdit))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$edit(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-link')
						]))
				]));
		var editAttendanceLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('https://intezmenykereso.e-kreta.hu/'),
					$elm$html$Html$Attributes$title(
					t_($author$project$Locale$Messages$TimetableActionAttendanceEdit))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$profile(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-info')
						]))
				]));
		var deleteEventLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$Timetable$ModuleEventDeleteRequested,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(
					t_($author$project$Locale$Messages$TimetableActionModuleEventDelete))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$delete(_List_Nil)
				]));
		var rightLinks = $author$project$ACL$canManageTimetable(viewer) ? _List_fromArray(
			[editAttendanceLink, editEventLink, deleteEventLink]) : _List_Nil;
		return isEmptyUI(
			_Utils_ap(leftLinks, rightLinks)) ? $author$project$UI$none : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$hr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('my-2')
						]),
					_List_Nil),
					A2($author$project$UI$navHorizontal, leftLinks, rightLinks)
				]));
	});
var $author$project$Locale$Messages$TimeDateTimeRangeFormat = F3(
	function (a, b, c) {
		return {$: 604, a: a, b: b, c: c};
	});
var $author$project$Element$Timetable$viewOccurenceMeta = F2(
	function (t_, occ) {
		var viewTime = A2(
			$author$project$UI$caption,
			t_,
			A3(
				$author$project$Locale$Messages$TimeDateTimeRangeFormat,
				$elm$time$Time$utc,
				$elm$time$Time$millisToPosix(occ.R),
				$elm$time$Time$millisToPosix(occ.G)));
		var viewModuleLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesDetail(
						$author$project$Module$moduleIdToInt(occ.hG.i8)))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$module_(_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(occ.hG.kj)
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title is-6 mb-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(occ.ek.kj)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-size-7 inline-list')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[viewTime])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[viewModuleLink]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(occ.ek.aZ)
						]))
				]));
	});
var $author$project$Element$Timetable$viewOccurence = F2(
	function (_v0, occ) {
		var t_ = _v0.h6;
		var viewer = _v0.ok;
		return $author$project$UI$modalDialog(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('box'),
						$author$project$UI$attrCyData('timetable-detail')
					]),
				_List_fromArray(
					[
						A4(
						$author$project$UI$mediaObject,
						_List_fromArray(
							[
								$author$project$UI$gravatar(occ.hG.kI.O)
							]),
						_List_fromArray(
							[
								A2($author$project$Element$Timetable$viewOccurenceMeta, t_, occ),
								A2($author$project$Element$Timetable$viewAttendanceSheet, t_, occ)
							]),
						_List_fromArray(
							[
								A3($author$project$Element$Timetable$viewNavLinks, t_, viewer, occ)
							]),
						_List_fromArray(
							[
								$author$project$UI$closeButton($author$project$Element$Timetable$PopupClosed)
							]))
					])));
	});
var $author$project$Element$Timetable$DeleteAll = 2;
var $author$project$Element$Timetable$DeleteThisAndFuture = 1;
var $author$project$Locale$Messages$TimetableBtnDeleteAllOccurences = {$: 616};
var $author$project$Locale$Messages$TimetableBtnDeleteThisAndFutureOccurences = {$: 618};
var $author$project$Locale$Messages$TimetableModuleEventRecurringDeleteHelp = {$: 631};
var $author$project$Element$Timetable$viewRecurringDeleteDialog = F2(
	function (t_, occurence) {
		return A4(
			$author$project$UI$modalPanel,
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableActionModuleEventDelete)
				]),
			_List_fromArray(
				[
					$author$project$UI$closeButton($author$project$Element$Timetable$ModuleEventDeleteDeclined)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableModuleEventRecurringDeleteHelp)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-grey'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Element$Timetable$ModuleEventDeleteConfirmed, 0, occurence))
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableBtnDeleteThisOccurence)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-grey'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Element$Timetable$ModuleEventDeleteConfirmed, 1, occurence))
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableBtnDeleteThisAndFutureOccurences)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-danger'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Element$Timetable$ModuleEventDeleteConfirmed, 2, occurence))
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableBtnDeleteAllOccurences)
						]))
				]));
	});
var $author$project$Element$Timetable$view = F2(
	function (session, _v0) {
		var t_ = session.h6;
		var viewer = session.ok;
		var calendar = _v0.dV;
		var popup = _v0.dr;
		var viewProgressBar = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-overlay is-extra-small')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$progress,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('progress is-extra-small')
						]),
					_List_Nil)
				]));
		var viewModuleEventForm = function (formModel) {
			return A3($author$project$Application$V2$Boundaries$viewElement, session, formModel, $author$project$Element$Timetable$moduleEventForm);
		};
		var viewClosablePanel = function (content) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('timetable-popup'),
						$author$project$KeyEvents$onKeyDown($author$project$Element$Timetable$KeyEvent),
						$elm$html$Html$Attributes$tabindex(0)
					]),
				content);
		};
		var viewCalendar = function (calendarModel) {
			return A2(
				$elm$html$Html$map,
				$author$project$Element$Timetable$timetableCalendar.jv,
				A2($author$project$Element$Timetable$timetableCalendar.ha.og, session, calendarModel));
		};
		if (!calendar.$) {
			var calendarModel = calendar.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('is-relative pt-3')
					]),
				_List_fromArray(
					[
						viewCalendar(calendarModel),
						A2(
						$author$project$UI$when,
						A2($author$project$Element$TimetableCalendar$isBusy, viewer, calendarModel),
						viewProgressBar),
						function () {
						if (popup.$ === 1) {
							return $author$project$UI$none;
						} else {
							switch (popup.a.$) {
								case 1:
									if (popup.a.a.$ === 1) {
										var _v3 = popup.a.a;
										var occurence = _v3.b;
										return viewClosablePanel(
											_List_fromArray(
												[
													A2($author$project$Element$Timetable$viewOccurence, session, occurence)
												]));
									} else {
										return viewProgressBar;
									}
								case 3:
									var _v4 = popup.a;
									var event = _v4.a;
									var occurence = _v4.b;
									return $author$project$ModuleEvent$isRecurring(event) ? viewClosablePanel(
										_List_fromArray(
											[
												A2($author$project$Element$Timetable$viewRecurringDeleteDialog, t_, occurence)
											])) : viewClosablePanel(
										_List_fromArray(
											[
												A2($author$project$Element$Timetable$viewNonRecurringDeleteDialog, t_, occurence)
											]));
								case 2:
									var formModel = popup.a.a;
									return viewClosablePanel(
										_List_fromArray(
											[
												A2($author$project$Element$Timetable$viewAttendanceForm, t_, formModel)
											]));
								default:
									var formModel = popup.a.a;
									return viewClosablePanel(
										_List_fromArray(
											[
												viewModuleEventForm(formModel)
											]));
							}
						}
					}()
					]));
		} else {
			return A2(
				$author$project$UI$progressBar,
				'is-info',
				t_($author$project$Locale$Messages$TimetableLoadingProgress));
		}
	});
var $author$project$Element$Timetable$element = {jb: $author$project$Element$Timetable$init, ks: $author$project$Element$Timetable$update, og: $author$project$Element$Timetable$view};
var $author$project$Element$TrimesterFeedbackReport$NotFoundPage = {$: 4};
var $author$project$Element$TrimesterFeedbackReport$SubjectListDownloaded = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$TrimesterFeedbackReport$TrimesterFeedbackReportsDownloaded = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Endpoint$trimesterFeedbackList = F2(
	function (config, studentId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'trimester-feedback']),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'student',
					$elm$core$String$fromInt(studentId))
				]));
	});
var $author$project$TrimesterFeedback$TrimesterFeedbackReport = function (id) {
	return function (startYear) {
		return function (trimester) {
			return function (startDate) {
				return function (endDate) {
					return function (adminStartDate) {
						return function (adminEndDate) {
							return function (student) {
								return function (url) {
									return function (trimesterFeedback) {
										return function (isDisabled) {
											return function (isInCurrentTrimester) {
												return function (isInCurrentSchoolYear) {
													return {kN: adminEndDate, kO: adminStartDate, ly: endDate, i8: id, l3: isDisabled, jh: isInCurrentSchoolYear, l6: isInCurrentTrimester, nN: startDate, eB: startYear, nT: student, kp: trimester, ih: trimesterFeedback, K: url};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$TrimesterFeedback$TrimesterFeedback = F6(
	function (id, description, feedback, createdBy, createdAt, report) {
		return {g4: createdAt, lf: createdBy, g8: description, hd: feedback, i8: id, dv: report};
	});
var $author$project$TrimesterFeedback$trimesterFeedbackDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'report',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'created_at',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_by',
			$author$project$Person$nestedPersonDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'feedback',
				$elm$json$Json$Decode$nullable($author$project$Rubric$rubricAssessmentDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'description',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$TrimesterFeedback$TrimesterFeedback)))))));
var $author$project$TrimesterFeedback$trimesterFeedbackReportDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_in_current_school_year',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_in_current_trimester',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'is_disabled',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'trimester_feedback',
				$elm$json$Json$Decode$nullable($author$project$TrimesterFeedback$trimesterFeedbackDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'url',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'student',
						$author$project$Person$nestedPersonDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'admin_end_date',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'admin_start_date',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'end_date',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'start_date',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'trimester',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'school_year_start_year',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$int,
													$elm$json$Json$Decode$succeed($author$project$TrimesterFeedback$TrimesterFeedbackReport))))))))))))));
var $author$project$TrimesterFeedback$trimesterFeedbackReportListDecoder = $elm$json$Json$Decode$list($author$project$TrimesterFeedback$trimesterFeedbackReportDecoder);
var $author$project$TrimesterFeedback$fetchTrimesterFeedbackReports = F3(
	function (config, studentId, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$trimesterFeedbackList, config, studentId),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$TrimesterFeedback$trimesterFeedbackReportListDecoder));
	});
var $author$project$Element$TrimesterFeedbackReport$init = F3(
	function (config, session, params) {
		var studentId = params.dE;
		var model = {
			b_: config,
			dZ: $elm$core$String$length(session.ok.lI),
			bk: $author$project$Element$TrimesterFeedbackReport$NotFoundPage,
			b8: $author$project$RemoteData$NotAsked,
			et: $author$project$RemoteData$NotAsked,
			dE: params.dE,
			kb: $author$project$RemoteData$NotAsked,
			dK: $elm$core$Maybe$Nothing
		};
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$TrimesterFeedback$fetchTrimesterFeedbackReports, config.gX, studentId, $author$project$Element$TrimesterFeedbackReport$TrimesterFeedbackReportsDownloaded),
					A2($author$project$Subject$fetchSubjects, config.gX, $author$project$Element$TrimesterFeedbackReport$SubjectListDownloaded)
				]));
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A2($author$project$Application$Boundaries$save, model, session));
	});
var $author$project$Element$TrimesterFeedbackReport$NoOp = {$: 9};
var $author$project$Locale$Messages$TrimesterFeedbackDeleteError = {$: 663};
var $author$project$Locale$Messages$TrimesterFeedbackDeleteSuccess = {$: 661};
var $author$project$Element$TrimesterFeedbackReport$TrimesterFeedbackDeleted = function (a) {
	return {$: 8, a: a};
};
var $author$project$Locale$Messages$TrimesterFeedbackReportDownloadError = {$: 653};
var $author$project$Element$TrimesterFeedbackReport$PortfolioStoriesDownloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Endpoint$pageSizeNoPaging = -1;
var $author$project$Element$TrimesterFeedbackReport$asListParams = F2(
	function (studentId, report) {
		return {
			bD: '',
			g2: $elm$core$Maybe$Nothing,
			hb: $elm$core$Maybe$Just(report.kN),
			b0: $elm$core$Maybe$Nothing,
			hH: $elm$core$Maybe$Nothing,
			bF: '',
			ce: $author$project$Api$Endpoint$pageSizeNoPaging,
			h2: $elm$core$Maybe$Just(report.kO),
			fv: $elm$core$Maybe$Just(
				_List_fromArray(
					[studentId])),
			fx: $elm$core$Maybe$Nothing,
			ii: $author$project$Api$Endpoint$typeMClosure
		};
	});
var $author$project$PortfolioStory$fetchStories_ = F3(
	function (config, params, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$portfolioStoriesList, config, params),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$PortfolioStory$portfolioStoriesDecoder));
	});
var $author$project$Element$TrimesterFeedbackReport$pageToReport = function (page) {
	switch (page.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var report = page.a;
			return $elm$core$Maybe$Just(report);
		case 2:
			var report = page.a;
			return $elm$core$Maybe$Just(report);
		case 3:
			var report = page.a;
			return $elm$core$Maybe$Just(report);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Element$TrimesterFeedbackReport$andThenFetchModuleClosures = function (_return) {
	var model = _return.eh;
	var model2 = _Utils_update(
		model,
		{b8: $author$project$RemoteData$Loading});
	var fetchParams = function (report) {
		return A2($author$project$Element$TrimesterFeedbackReport$asListParams, model.dE, report);
	};
	var fetch = function (report) {
		return A3(
			$author$project$PortfolioStory$fetchStories_,
			model.b_.gX,
			fetchParams(report),
			$author$project$Element$TrimesterFeedbackReport$PortfolioStoriesDownloaded);
	};
	return A2(
		$elm$core$Maybe$withDefault,
		A2($author$project$Application$Boundaries$save, model, _return.gB),
		A2(
			$elm$core$Maybe$map,
			function (report) {
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					fetch(report),
					A2($author$project$Application$Boundaries$save, model2, _return.gB));
			},
			$author$project$Element$TrimesterFeedbackReport$pageToReport(model.bk)));
};
var $author$project$Element$TrimesterFeedbackReport$PreviousYearsTab = 0;
var $author$project$Element$TrimesterFeedbackReport$FirstTrimesterPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TrimesterFeedbackReport$PreviousYearsPage = {$: 0};
var $author$project$Element$TrimesterFeedbackReport$SecondTrimesterPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$TrimesterFeedbackReport$ThirdTrimesterPage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$TrimesterFeedbackReport$findReportByTrimester = F2(
	function (reports, trimester) {
		return A2(
			$author$project$Util$List$find,
			function (r) {
				return r.jh && _Utils_eq(trimester, r.kp);
			},
			reports);
	});
var $author$project$Element$TrimesterFeedbackReport$switchTab = F2(
	function (reports, tab) {
		switch (tab) {
			case 1:
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Element$TrimesterFeedbackReport$NotFoundPage,
					A2(
						$elm$core$Maybe$map,
						$author$project$Element$TrimesterFeedbackReport$FirstTrimesterPage,
						A2($author$project$Element$TrimesterFeedbackReport$findReportByTrimester, reports, 1)));
			case 2:
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Element$TrimesterFeedbackReport$NotFoundPage,
					A2(
						$elm$core$Maybe$map,
						$author$project$Element$TrimesterFeedbackReport$SecondTrimesterPage,
						A2($author$project$Element$TrimesterFeedbackReport$findReportByTrimester, reports, 2)));
			case 3:
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Element$TrimesterFeedbackReport$NotFoundPage,
					A2(
						$elm$core$Maybe$map,
						$author$project$Element$TrimesterFeedbackReport$ThirdTrimesterPage,
						A2($author$project$Element$TrimesterFeedbackReport$findReportByTrimester, reports, 3)));
			case 0:
				return $author$project$Element$TrimesterFeedbackReport$PreviousYearsPage;
			default:
				return $author$project$Element$TrimesterFeedbackReport$NotFoundPage;
		}
	});
var $author$project$Element$TrimesterFeedbackReport$FirstTrimesterTab = 1;
var $author$project$Element$TrimesterFeedbackReport$SecondTrimesterTab = 2;
var $author$project$Element$TrimesterFeedbackReport$ThirdTrimesterTab = 3;
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{ae: nodeList, X: nodeListSize, ac: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $author$project$Element$TrimesterFeedbackReport$tabs = $elm$core$Array$fromList(
	_List_fromArray(
		[0, 1, 2, 3]));
var $author$project$Element$TrimesterFeedbackReport$andThenInitPage = F2(
	function (reports, _return) {
		var model = _return.eh;
		var currentReport = A2(
			$author$project$Util$List$find,
			function ($) {
				return $.l6;
			},
			reports);
		var currentTab = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Array$get,
				A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.kp;
						},
						currentReport)),
				$author$project$Element$TrimesterFeedbackReport$tabs));
		var page = A2($author$project$Element$TrimesterFeedbackReport$switchTab, reports, currentTab);
		var model2 = _Utils_update(
			model,
			{
				bk: page,
				et: $author$project$RemoteData$Success(reports)
			});
		return A2($author$project$Application$Boundaries$save, model2, _return.gB);
	});
var $author$project$Element$TrimesterFeedbackReport$PortfolioSingleElementMsg = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Element$TrimesterFeedbackReport$portfolioSingle = function (storyId) {
	return {
		ha: $author$project$Element$PortfolioSingle$element,
		cf: $author$project$Element$TrimesterFeedbackReport$PortfolioSingleElementMsg(storyId),
		kt: F2(
			function (containerModel, model) {
				var portfolioSinglesModel2 = A2(
					$author$project$RemoteData$map,
					A2(
						$elm$core$Dict$update,
						storyId,
						$elm$core$Basics$always(
							$elm$core$Maybe$Just(model))),
					containerModel.b8);
				return _Utils_update(
					containerModel,
					{b8: portfolioSinglesModel2});
			})
	};
};
var $author$project$Element$TrimesterFeedbackReport$andThenInitPortfolioSingleElements = F2(
	function (stories, _return) {
		var returnNoReply = function (return_) {
			return {dX: return_.dX, eh: return_.eh, gs: $elm$core$Maybe$Nothing, gB: return_.gB};
		};
		return returnNoReply(
			A3(
				$elm$core$List$foldl,
				F2(
					function (story, return_) {
						var model = return_.eh;
						var singleElement = $author$project$Element$TrimesterFeedbackReport$portfolioSingle(story.i8);
						var params = {
							kb: model.kb,
							oi: $author$project$Element$PortfolioSingle$ListItem(story)
						};
						var elementReturn = A5(
							$author$project$Application$V2$Boundaries$initElement,
							model.b_.jk,
							$author$project$Application$V2$SharedConfig$fromV1(model.b_),
							return_.gB,
							singleElement,
							params);
						var return2 = returnNoReply(
							A3($author$project$Application$V2$Boundaries$mapElement, return_, singleElement, elementReturn));
						return return2;
					}),
				_return,
				stories));
	});
var $author$project$Api$Endpoint$trimesterFeedbackDelete = F2(
	function (config, feedbackId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'trimester-feedback',
					$elm$core$String$fromInt(feedbackId)
				]),
			_List_Nil);
	});
var $author$project$TrimesterFeedback$deleteTrimesterFeedback = F3(
	function (config, feedback, callback) {
		return A3(
			$author$project$Api$delete,
			A2($author$project$Api$Endpoint$trimesterFeedbackDelete, config, feedback.dv),
			config,
			callback);
	});
var $author$project$Element$TrimesterFeedbackReport$mapTrimesterPage = F2(
	function (func, page) {
		switch (page.$) {
			case 0:
				return $author$project$Element$TrimesterFeedbackReport$PreviousYearsPage;
			case 1:
				var report = page.a;
				return $author$project$Element$TrimesterFeedbackReport$FirstTrimesterPage(
					func(report));
			case 2:
				var report = page.a;
				return $author$project$Element$TrimesterFeedbackReport$SecondTrimesterPage(
					func(report));
			case 3:
				var report = page.a;
				return $author$project$Element$TrimesterFeedbackReport$ThirdTrimesterPage(
					func(report));
			default:
				return $author$project$Element$TrimesterFeedbackReport$NotFoundPage;
		}
	});
var $author$project$Log$msgTrimesterFeedbackDelete = 'trimester_feedback_delete';
var $author$project$Log$msgTrimesterFeedbackDownload = 'trimester_feedback_download';
var $author$project$Element$TrimesterFeedbackReport$TrimesterFeedbackFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$CurrentTrimesterDownloaded = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$FetchCurrentTrimester = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$FetchRubrics = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$FetchStudentProfile = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$RubricsListDownloaded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$StudentProfileDownloaded = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$FormMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$TextFeedback = $elm$core$Basics$identity;
var $author$project$Locale$Messages$TrimesterFeedbackFormTextFeedback = function (a) {
	return {$: 641, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$buildForm = F2(
	function (t_, student) {
		var studentName = A2($author$project$Person$fullName, t_, student);
		return {
			a9: {
				e0: false,
				fi: $author$project$Form$requiredRubricTextFeedback(t_),
				fp: true,
				ks: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{a9: value});
					}),
				fC: function ($) {
					return $.a9;
				},
				og: {
					cm: 'trimester-text-feedback',
					ea: '',
					fe: A2($elm$core$Basics$composeL, $author$project$Element$TrimesterFeedbackForm$FormMsg, $elm$core$Basics$identity),
					fj: t_(
						$author$project$Locale$Messages$TrimesterFeedbackFormTextFeedback(studentName))
				}
			}
		};
	});
var $author$project$Element$TrimesterFeedbackForm$emptyForm = {a9: ''};
var $author$project$Api$Endpoint$trimesterCurrent = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'trimesters', 'current']),
		_List_Nil);
};
var $author$project$Trimester$Trimester = F2(
	function (school_year, trimester_number) {
		return {nw: school_year, kq: trimester_number};
	});
var $author$project$Trimester$trimesterDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'trimester_number',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'school_year',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Trimester$Trimester)));
var $author$project$Trimester$fetchCurrentTrimester = F2(
	function (config, callback) {
		return {
			b_: config,
			d_: $author$project$Trimester$trimesterDecoder,
			cf: callback,
			K: $author$project$Api$Endpoint$trimesterCurrent(config)
		};
	});
var $author$project$StudentProfile$fetchStudentProfileV4 = F3(
	function (config, id, callback) {
		return {
			b_: config,
			d_: $author$project$StudentProfile$studentProfileDecoder,
			cf: callback,
			K: A2($author$project$Api$Endpoint$studentProfile, config, id)
		};
	});
var $author$project$Element$TrimesterFeedbackForm$tagTrimesterClosing = 'trimester-closing';
var $author$project$Element$TrimesterFeedbackForm$init = F3(
	function (config, session, params) {
		var t_ = session.h6;
		var model = {
			b_: config,
			fU: $elm$core$Maybe$Nothing,
			c4: $elm$core$Maybe$Nothing,
			bE: A2($author$project$Element$TrimesterFeedbackForm$buildForm, t_, params.dv.nT),
			e4: 0,
			dr: $elm$core$Maybe$Nothing,
			fm: $elm$core$Maybe$Nothing,
			eu: $elm$core$Maybe$Nothing,
			dB: $elm$core$Maybe$Nothing,
			gB: session,
			gC: false,
			h5: $elm$core$Maybe$Nothing,
			kb: params.kb,
			eG: params.dv,
			eI: $author$project$Element$TrimesterFeedbackForm$emptyForm
		};
		var defaultParams = $author$project$Rubric$defaultListParams;
		var listParams = _Utils_update(
			defaultParams,
			{
				fv: $elm$core$Maybe$Just(
					_List_fromArray(
						[params.dv.nT.i8])),
				ke: $elm$core$Maybe$Just(
					_List_fromArray(
						[$author$project$Element$TrimesterFeedbackForm$tagTrimesterClosing]))
			});
		return _Utils_Tuple3(
			model,
			$author$project$Element$TrimesterFeedbackForm$BatchEffect(
				_List_fromArray(
					[
						$author$project$Element$TrimesterFeedbackForm$Cmd(
						$author$project$Element$TrimesterFeedbackForm$FetchRubrics(
							A3($author$project$Rubric$fetchRubricsV2, config.gX, listParams, $author$project$Element$TrimesterFeedbackForm$RubricsListDownloaded))),
						$author$project$Element$TrimesterFeedbackForm$Cmd(
						$author$project$Element$TrimesterFeedbackForm$FetchCurrentTrimester(
							A2($author$project$Trimester$fetchCurrentTrimester, config.gX, $author$project$Element$TrimesterFeedbackForm$CurrentTrimesterDownloaded))),
						$author$project$Element$TrimesterFeedbackForm$Cmd(
						$author$project$Element$TrimesterFeedbackForm$FetchStudentProfile(
							A3($author$project$StudentProfile$fetchStudentProfileV4, config.gX, params.dv.nT.i8, $author$project$Element$TrimesterFeedbackForm$StudentProfileDownloaded)))
					])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$TrimesterFeedbackForm$RubricAssessmentEffect = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$RubricAssessmentMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$embeddedRubricAssessment = {
	ha: $author$project$Element$RubricAssessment$element,
	kk: $author$project$Element$TrimesterFeedbackForm$RubricAssessmentEffect,
	cf: $author$project$Element$TrimesterFeedbackForm$RubricAssessmentMsg,
	kt: F2(
		function (containerModel, model) {
			return _Utils_update(
				containerModel,
				{
					eu: $elm$core$Maybe$Just(model)
				});
		})
};
var $author$project$Element$TrimesterFeedbackForm$PopupMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$RubricsFormEffect = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$RubricsFormModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$RubricsFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$RubricsListEffect = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$RubricsListModel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$RubricsListMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$popups = {
	dx: {
		ha: $author$project$Element$RubricsForm$element,
		kk: $author$project$Element$TrimesterFeedbackForm$RubricsFormEffect,
		cf: A2($elm$core$Basics$composeL, $author$project$Element$TrimesterFeedbackForm$PopupMsg, $author$project$Element$TrimesterFeedbackForm$RubricsFormMsg),
		kt: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						dr: $elm$core$Maybe$Just(
							$author$project$Element$TrimesterFeedbackForm$RubricsFormModel(model))
					});
			})
	},
	dz: {
		ha: $author$project$Element$RubricsList$element,
		kk: $author$project$Element$TrimesterFeedbackForm$RubricsListEffect,
		cf: A2($elm$core$Basics$composeL, $author$project$Element$TrimesterFeedbackForm$PopupMsg, $author$project$Element$TrimesterFeedbackForm$RubricsListMsg),
		kt: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						dr: $elm$core$Maybe$Just(
							$author$project$Element$TrimesterFeedbackForm$RubricsListModel(model))
					});
			})
	}
};
var $author$project$Element$TrimesterFeedbackForm$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$TrimesterFeedbackForm$perform(key),
						effects));
			case 2:
				var cmd = effect.a;
				switch (cmd.$) {
					case 0:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					case 1:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 2:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 3:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 4:
						return $author$project$Ports$scrollToFormError;
					case 5:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					default:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
				}
			case 3:
				var elementEffect = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, elementEffect, $author$project$Element$TrimesterFeedbackForm$embeddedRubricAssessment);
			case 4:
				var elementEffect = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, elementEffect, $author$project$Element$TrimesterFeedbackForm$popups.dx);
			default:
				var elementEffect = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, elementEffect, $author$project$Element$TrimesterFeedbackForm$popups.dz);
		}
	});
var $author$project$Element$TrimesterFeedbackForm$Exit = {$: 0};
var $author$project$Element$TrimesterFeedbackForm$LogError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$LogOk = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$NoEffect = {$: 0};
var $author$project$Element$TrimesterFeedbackForm$NoOp = {$: 0};
var $author$project$Element$TrimesterFeedbackForm$Saved = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$TrimesterDownloadError = {$: 640};
var $author$project$Locale$Messages$TrimesterFeedbackFormSaveError = {$: 646};
var $author$project$Locale$Messages$TrimesterFeedbackFormSaveSuccess = {$: 645};
var $author$project$Log$msgTrimesterDownload = 'trimester_download';
var $author$project$Log$msgTrimesterFeedbackSave = 'trimester_feedback_save';
var $author$project$Element$TrimesterFeedbackForm$openRubricsListPopup = F2(
	function (model, effect) {
		var session = model.gB;
		var selected = function () {
			var _v1 = _Utils_Tuple2(model.dB, model.fm);
			_v1$2:
			while (true) {
				if (!_v1.a.$) {
					if (!_v1.b.$) {
						var rubric_ = _v1.a.a;
						return _List_fromArray(
							[rubric_]);
					} else {
						break _v1$2;
					}
				} else {
					if (!_v1.b.$) {
						var _v2 = _v1.a;
						var rubrics_ = _v1.b.a;
						return rubrics_;
					} else {
						break _v1$2;
					}
				}
			}
			return _List_Nil;
		}();
		var params = $author$project$Element$RubricsList$Selector(selected);
		var _v0 = A3(
			$author$project$Application$V3$Boundaries$mapElement,
			model,
			$author$project$Element$TrimesterFeedbackForm$popups.dz,
			A4($author$project$Application$V3$Boundaries$initElement, model.b_, session, $author$project$Element$TrimesterFeedbackForm$popups.dz, params));
		var model2 = _v0.a;
		var effect2 = _v0.b;
		return _Utils_Tuple3(
			model2,
			$author$project$Element$TrimesterFeedbackForm$BatchEffect(
				_List_fromArray(
					[effect2, effect])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Log$paramScopeTrimesterFeedbackForm = 'scope_trimester_feedback_form';
var $author$project$Element$TrimesterFeedbackForm$CreateTrimesterFeedback = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$ScrollToFormError = {$: 4};
var $author$project$Element$TrimesterFeedbackForm$TrimesterFeedbackSaved = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Api$Endpoint$trimesterFeedbackCreate = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'trimester-feedback']),
		_List_Nil);
};
var $author$project$TrimesterFeedback$trimesterFeedbackEncoder = function (tf) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(tf.g8)),
				_Utils_Tuple2(
				'report',
				$elm$json$Json$Encode$int(tf.dv)),
				_Utils_Tuple2(
				'feedback',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $author$project$Rubric$rubricAssessmentEncoder, tf.hd)))
			]));
};
var $author$project$TrimesterFeedback$createTrimesterFeedbackV2 = F3(
	function (config, tf, callback) {
		return {
			T: $author$project$TrimesterFeedback$trimesterFeedbackEncoder(tf),
			b_: config,
			d_: $author$project$TrimesterFeedback$trimesterFeedbackDecoder,
			cf: callback,
			K: $author$project$Api$Endpoint$trimesterFeedbackCreate(config.gX)
		};
	});
var $author$project$Element$TrimesterFeedbackForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.a9, values);
	});
var $author$project$Log$msgTrimesterFeedbackFormSubmitted = 'trimester_feedback_form_submitted';
var $author$project$Log$msgTrimesterFeedbackFormValidationError = 'trimester_feedback_form_validation_error';
var $author$project$Element$TrimesterFeedbackForm$parseRubricAssessment = function (_v0) {
	var selectedRubric = _v0.dB;
	var filledRubric = _v0.c4;
	var _v1 = _Utils_Tuple2(selectedRubric, filledRubric);
	if ((!_v1.a.$) && (!_v1.b.$)) {
		var selectedRubric_ = _v1.a.a;
		var filledRubric_ = _v1.b.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(selectedRubric_, filledRubric_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Element$TrimesterFeedbackForm$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			a9: $author$project$Form$markEdited(form.a9)
		});
};
var $author$project$Element$TrimesterFeedbackForm$submitForm = function (model) {
	var config = model.b_;
	var form = model.bE;
	var values = model.eI;
	var trimesterFeedbackReport = model.eG;
	var validationError = $author$project$Api$CustomError(
		'trimester_feedback_form_validation_failed ' + $elm$core$String$fromInt(trimesterFeedbackReport.nT.i8));
	var model2 = _Utils_update(
		model,
		{e4: 2});
	var logValidationError = A3(
		$author$project$Log$errorV2,
		config,
		_Utils_Tuple3(
			$author$project$Log$msgTrimesterFeedbackFormValidationError,
			$elm$core$Maybe$Just($author$project$Log$paramScopeTrimesterFeedbackForm),
			validationError),
		$elm$core$Basics$always($author$project$Element$TrimesterFeedbackForm$NoOp));
	var createTrimesterFeedback = function (maybeRubricAssessment) {
		var rubricAssessment = A2($elm$core$Maybe$map, $elm$core$Tuple$second, maybeRubricAssessment);
		var tfUnsaved = {
			g8: form.a9.fC(values),
			hd: rubricAssessment,
			dv: model2.eG.i8
		};
		var rubric = A2($elm$core$Maybe$map, $elm$core$Tuple$first, maybeRubricAssessment);
		var logRequest = A3(
			$author$project$Log$okV2,
			config,
			_Utils_Tuple2(
				$author$project$Log$msgTrimesterFeedbackFormSubmitted,
				_List_fromArray(
					[
						$author$project$Log$paramScopeTrimesterFeedbackForm,
						A2(
						$elm$core$Maybe$withDefault,
						'none',
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$String$fromInt,
								function ($) {
									return $.nu;
								}),
							tfUnsaved.hd)),
						$elm$core$String$fromInt(tfUnsaved.dv),
						$author$project$Log$paramOk
					])),
			$elm$core$Basics$always($author$project$Element$TrimesterFeedbackForm$NoOp));
		return _Utils_Tuple3(
			model2,
			$author$project$Element$TrimesterFeedbackForm$BatchEffect(
				_List_fromArray(
					[
						$author$project$Element$TrimesterFeedbackForm$Cmd(
						$author$project$Element$TrimesterFeedbackForm$CreateTrimesterFeedback(
							A3(
								$author$project$TrimesterFeedback$createTrimesterFeedbackV2,
								config,
								tfUnsaved,
								$author$project$Element$TrimesterFeedbackForm$TrimesterFeedbackSaved(rubric)))),
						$author$project$Element$TrimesterFeedbackForm$Cmd(
						$author$project$Element$TrimesterFeedbackForm$LogOk(logRequest))
					])),
			$elm$core$Maybe$Nothing);
	};
	return A2($author$project$Element$TrimesterFeedbackForm$isFormValid, form, values) ? createTrimesterFeedback(
		$author$project$Element$TrimesterFeedbackForm$parseRubricAssessment(model2)) : _Utils_Tuple3(
		_Utils_update(
			model,
			{
				bE: $author$project$Element$TrimesterFeedbackForm$validateForm(form),
				gC: true
			}),
		$author$project$Element$TrimesterFeedbackForm$BatchEffect(
			_List_fromArray(
				[
					$author$project$Element$TrimesterFeedbackForm$Cmd($author$project$Element$TrimesterFeedbackForm$ScrollToFormError),
					$author$project$Element$TrimesterFeedbackForm$Cmd(
					$author$project$Element$TrimesterFeedbackForm$LogError(logValidationError))
				])),
		$elm$core$Maybe$Nothing);
};
var $author$project$Element$TrimesterFeedbackForm$openRubricAssessment = F3(
	function (model, effect, rubric) {
		var config = model.b_;
		var session = model.gB;
		var model2 = _Utils_update(
			model,
			{c4: $elm$core$Maybe$Nothing, e4: 1});
		var params = {
			jE: true,
			fq: _List_fromArray(
				[rubric]),
			fv: _List_fromArray(
				[model2.eG.nT]),
			kb: model2.kb
		};
		var _v0 = A3(
			$author$project$Application$V3$Boundaries$mapElement,
			model2,
			$author$project$Element$TrimesterFeedbackForm$embeddedRubricAssessment,
			A4($author$project$Application$V3$Boundaries$initElement, config, session, $author$project$Element$TrimesterFeedbackForm$embeddedRubricAssessment, params));
		var model3 = _v0.a;
		var effect2 = _v0.b;
		return _Utils_Tuple3(
			model3,
			$author$project$Element$TrimesterFeedbackForm$BatchEffect(
				_List_fromArray(
					[effect, effect2])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$TrimesterFeedbackForm$toggleRubricAssessment = F3(
	function (model, effect, maybeRubric) {
		var model2 = _Utils_update(
			model,
			{dB: maybeRubric});
		var _v0 = _Utils_Tuple2(model.dB, maybeRubric);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var prevRubric = _v0.a.a;
					var newRubric = _v0.b.a;
					return (!_Utils_eq(prevRubric.i8, newRubric.i8)) ? A3($author$project$Element$TrimesterFeedbackForm$openRubricAssessment, model2, effect, newRubric) : _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var newRubric = _v0.b.a;
					return A3($author$project$Element$TrimesterFeedbackForm$openRubricAssessment, model2, effect, newRubric);
				} else {
					break _v0$2;
				}
			}
		}
		return _Utils_Tuple3(
			_Utils_update(
				model2,
				{c4: $elm$core$Maybe$Nothing, eu: $elm$core$Maybe$Nothing}),
			effect,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$TrimesterFeedbackForm$update = F2(
	function (msg, model) {
		var config = model.b_;
		var form = model.bE;
		var values = model.eI;
		var session = model.gB;
		var t_ = session.h6;
		var noop = _Utils_Tuple3(model, $author$project$Element$TrimesterFeedbackForm$NoEffect, $elm$core$Maybe$Nothing);
		switch (msg.$) {
			case 0:
				return noop;
			case 1:
				return A2($author$project$Element$TrimesterFeedbackForm$openRubricsListPopup, model, $author$project$Element$TrimesterFeedbackForm$NoEffect);
			case 2:
				return _Utils_Tuple3(
					model,
					$author$project$Element$TrimesterFeedbackForm$NoEffect,
					$elm$core$Maybe$Just($author$project$Element$TrimesterFeedbackForm$Exit));
			case 3:
				return $author$project$Element$TrimesterFeedbackForm$submitForm(model);
			case 6:
				var rubricAssessmentMsg = msg.a;
				var _v1 = model.eu;
				if (!_v1.$) {
					var rubricAssessmentModel = _v1.a;
					var _v2 = A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						$author$project$Element$TrimesterFeedbackForm$embeddedRubricAssessment,
						A4($author$project$Application$V3$Boundaries$updateElement, session, rubricAssessmentMsg, rubricAssessmentModel, $author$project$Element$TrimesterFeedbackForm$embeddedRubricAssessment));
					var model2 = _v2.a;
					var effect = _v2.b;
					var reply = _v2.c;
					if (!reply.$) {
						var reply_ = reply.a;
						switch (reply_.$) {
							case 0:
								return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
							case 1:
								return _Utils_Tuple3(
									model2,
									effect,
									$elm$core$Maybe$Just($author$project$Element$TrimesterFeedbackForm$Exit));
							default:
								var assessment = reply_.a;
								return _Utils_Tuple3(
									_Utils_update(
										model2,
										{
											c4: $elm$core$Maybe$Just(assessment)
										}),
									effect,
									$elm$core$Maybe$Nothing);
						}
					} else {
						return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
					}
				} else {
					return noop;
				}
			case 5:
				var fieldMsg = msg.a;
				var value = fieldMsg;
				var model2 = _Utils_update(
					model,
					{
						bE: _Utils_update(
							form,
							{
								a9: $author$project$Form$markEdited(model.bE.a9)
							}),
						e4: 1,
						eI: A2(form.a9.ks, value, values)
					});
				return _Utils_Tuple3(model2, $author$project$Element$TrimesterFeedbackForm$NoEffect, $elm$core$Maybe$Nothing);
			case 4:
				var popupMsg = msg.a;
				var _v6 = _Utils_Tuple2(popupMsg, model.dr);
				_v6$2:
				while (true) {
					if (_v6.a.$ === 1) {
						if ((!_v6.b.$) && (_v6.b.a.$ === 1)) {
							var rubricsFormMsg = _v6.a.a;
							var rubricsFormModel = _v6.b.a.a;
							var _v7 = A3(
								$author$project$Application$V3$Boundaries$mapElement,
								model,
								$author$project$Element$TrimesterFeedbackForm$popups.dx,
								A4($author$project$Application$V3$Boundaries$updateElement, session, rubricsFormMsg, rubricsFormModel, $author$project$Element$TrimesterFeedbackForm$popups.dx));
							var model2 = _v7.a;
							var effect = _v7.b;
							var reply = _v7.c;
							if (!reply.$) {
								var _v9 = reply.a;
								return A2($author$project$Element$TrimesterFeedbackForm$openRubricsListPopup, model2, effect);
							} else {
								return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
							}
						} else {
							break _v6$2;
						}
					} else {
						if ((!_v6.b.$) && (!_v6.b.a.$)) {
							var rubricsListMsg = _v6.a.a;
							var rubricsListModel = _v6.b.a.a;
							var _v10 = A3(
								$author$project$Application$V3$Boundaries$mapElement,
								model,
								$author$project$Element$TrimesterFeedbackForm$popups.dz,
								A4($author$project$Application$V3$Boundaries$updateElement, session, rubricsListMsg, rubricsListModel, $author$project$Element$TrimesterFeedbackForm$popups.dz));
							var model2 = _v10.a;
							var effect = _v10.b;
							var reply = _v10.c;
							if (!reply.$) {
								var reply_ = reply.a;
								switch (reply_.$) {
									case 1:
										var rubrics = reply_.a;
										var maybeSelected = $elm$core$List$head(rubrics);
										var _v13 = A3($author$project$Element$TrimesterFeedbackForm$toggleRubricAssessment, model2, effect, maybeSelected);
										var model3 = _v13.a;
										var effect2 = _v13.b;
										return _Utils_Tuple3(
											_Utils_update(
												model3,
												{dr: $elm$core$Maybe$Nothing}),
											effect2,
											$elm$core$Maybe$Nothing);
									case 2:
										var _v14 = A3(
											$author$project$Application$V3$Boundaries$mapElement,
											model2,
											$author$project$Element$TrimesterFeedbackForm$popups.dx,
											A4(
												$author$project$Application$V3$Boundaries$initElement,
												config,
												model2.gB,
												$author$project$Element$TrimesterFeedbackForm$popups.dx,
												{mc: true, nt: $elm$core$Maybe$Nothing}));
										var model3 = _v14.a;
										var effect2 = _v14.b;
										return _Utils_Tuple3(
											model3,
											$author$project$Element$TrimesterFeedbackForm$BatchEffect(
												_List_fromArray(
													[effect, effect2])),
											$elm$core$Maybe$Nothing);
									default:
										return _Utils_Tuple3(
											_Utils_update(
												model2,
												{dr: $elm$core$Maybe$Nothing}),
											effect,
											$elm$core$Maybe$Nothing);
								}
							} else {
								return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
							}
						} else {
							break _v6$2;
						}
					}
				}
				return noop;
			case 7:
				if (!msg.b.$) {
					var maybeRubric = msg.a;
					var trimesterFeedback = msg.b.a;
					var logParams = _List_fromArray(
						[
							$elm$core$String$fromInt(trimesterFeedback.i8),
							A2(
							$elm$core$Maybe$withDefault,
							'none',
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.i8;
									},
									$elm$core$String$fromInt),
								maybeRubric))
						]);
					var logRequest = A3(
						$author$project$Log$okV2,
						model.b_,
						_Utils_Tuple2($author$project$Log$msgTrimesterFeedbackSave, logParams),
						$elm$core$Basics$always($author$project$Element$TrimesterFeedbackForm$NoOp));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								e4: 0,
								gB: A2(
									$author$project$Session$ok,
									session,
									t_($author$project$Locale$Messages$TrimesterFeedbackFormSaveSuccess))
							}),
						$author$project$Element$TrimesterFeedbackForm$Cmd(
							$author$project$Element$TrimesterFeedbackForm$LogOk(logRequest)),
						$elm$core$Maybe$Just(
							$author$project$Element$TrimesterFeedbackForm$Saved(trimesterFeedback)));
				} else {
					var error = msg.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$TrimesterFeedbackFormSaveError))
							}),
						$author$project$Element$TrimesterFeedbackForm$Cmd(
							$author$project$Element$TrimesterFeedbackForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgTrimesterFeedbackSave, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$TrimesterFeedbackForm$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 8:
				if (!msg.a.$) {
					var rubrics = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fm: $elm$core$Maybe$Just(rubrics)
							}),
						$author$project$Element$TrimesterFeedbackForm$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$RubricsDownloadError))
							}),
						$author$project$Element$TrimesterFeedbackForm$Cmd(
							$author$project$Element$TrimesterFeedbackForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgRubricsDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeTrimesterFeedbackForm),
										error),
									$elm$core$Basics$always($author$project$Element$TrimesterFeedbackForm$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 9:
				if (!msg.a.$) {
					var trimester = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fU: $elm$core$Maybe$Just(trimester)
							}),
						$author$project$Element$TrimesterFeedbackForm$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$TrimesterDownloadError))
							}),
						$author$project$Element$TrimesterFeedbackForm$Cmd(
							$author$project$Element$TrimesterFeedbackForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgTrimesterDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeTrimesterFeedbackForm),
										error),
									$elm$core$Basics$always($author$project$Element$TrimesterFeedbackForm$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			default:
				if (!msg.a.$) {
					var profile = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								h5: $elm$core$Maybe$Just(profile)
							}),
						$author$project$Element$TrimesterFeedbackForm$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gB: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$ProfilesDownloadError))
							}),
						$author$project$Element$TrimesterFeedbackForm$Cmd(
							$author$project$Element$TrimesterFeedbackForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgStudentProfileDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeTrimesterFeedbackForm),
										error),
									$elm$core$Basics$always($author$project$Element$TrimesterFeedbackForm$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
		}
	});
var $author$project$Element$TrimesterFeedbackForm$ClosePopup = {$: 2};
var $author$project$Element$TrimesterFeedbackForm$OpenRubricSelector = {$: 1};
var $author$project$Locale$Messages$RubricSelectorNotAvailable = {$: 412};
var $author$project$Element$TrimesterFeedbackForm$SubmitForm = {$: 3};
var $author$project$Locale$Messages$TrimesterFeedbackFormFilledRubricRequired = {$: 647};
var $author$project$Locale$Messages$TrimesterFeedbackFormRubricSelector = {$: 644};
var $author$project$Locale$Messages$TrimesterFeedbackFormTitle = {$: 642};
var $author$project$ACL$canSelectRubrics = F2(
	function (currentTrimester, studentProfile) {
		return !(((currentTrimester.kq === 1) && ((studentProfile.fT === '4') || (studentProfile.fT === '8'))) || ((currentTrimester.kq === 2) && ((studentProfile.fT === '3') || (studentProfile.fT === '7'))));
	});
var $author$project$Element$TrimesterFeedbackForm$isRubricAssessmentValid = function (_v0) {
	var selectedRubric = _v0.dB;
	var filledRubric = _v0.c4;
	var _v1 = _Utils_Tuple2(selectedRubric, filledRubric);
	if (_v1.a.$ === 1) {
		var _v2 = _v1.a;
		return true;
	} else {
		if (!_v1.b.$) {
			return true;
		} else {
			var _v3 = _v1.b;
			return false;
		}
	}
};
var $author$project$Locale$Messages$TrimesterFeedbackFormSubtitle = function (a) {
	return {$: 643, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$viewMeta = F2(
	function (t_, report) {
		var params = {
			d3: report.eB + 1,
			fb: A2($author$project$Person$fullName, t_, report.nT),
			eB: report.eB,
			kp: report.kp
		};
		return $author$project$UI$subtitle(
			_List_fromArray(
				[
					A2(
					$author$project$UI$caption,
					t_,
					$author$project$Locale$Messages$TrimesterFeedbackFormSubtitle(params))
				]));
	});
var $author$project$Element$TrimesterFeedbackForm$viewPopup = F2(
	function (session, model) {
		var _v0 = model.dr;
		if (!_v0.$) {
			if (!_v0.a.$) {
				var popupModel = _v0.a.a;
				return A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, $author$project$Element$TrimesterFeedbackForm$PopupMsg, $author$project$Element$TrimesterFeedbackForm$RubricsListMsg),
					$author$project$Element$RubricsList$viewPopup(
						_Utils_update(
							popupModel,
							{gB: session})));
			} else {
				var popupModel = _v0.a.a;
				return A3($author$project$Application$V3$Boundaries$viewElement, session, popupModel, $author$project$Element$TrimesterFeedbackForm$popups.dx);
			}
		} else {
			return $author$project$UI$none;
		}
	});
var $author$project$Element$TrimesterFeedbackForm$view = function (model) {
	var form = model.bE;
	var values = model.eI;
	var formState = model.e4;
	var session = model.gB;
	var currentTrimester = model.fU;
	var studentProfile = model.h5;
	var viewRubricAssessment = A2(
		$elm$core$Maybe$withDefault,
		$author$project$UI$none,
		A2(
			$elm$core$Maybe$map,
			function (rubricsModel) {
				return A3($author$project$Application$V3$Boundaries$viewElement, session, rubricsModel, $author$project$Element$TrimesterFeedbackForm$embeddedRubricAssessment);
			},
			model.eu));
	var t_ = session.h6;
	var viewRubricsButton = function () {
		var canShowButton = function () {
			var _v1 = _Utils_Tuple2(currentTrimester, studentProfile);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var trimester = _v1.a.a;
				var profile = _v1.b.a;
				return A2($author$project$ACL$canSelectRubrics, trimester, profile);
			} else {
				return false;
			}
		}();
		if (canShowButton) {
			var _v0 = model.fm;
			if (!_v0.$) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-link is-light'),
							$elm$html$Html$Events$onClick($author$project$Element$TrimesterFeedbackForm$OpenRubricSelector)
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TrimesterFeedbackFormRubricSelector)
						]));
			} else {
				return $author$project$UI$Icon$loadingOptions(_List_Nil);
			}
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container is-fullwidth')
					]),
				_List_fromArray(
					[
						$author$project$UI$notification(
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricSelectorNotAvailable)
							]))
					]));
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('container')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$UI$modalPanel,
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TrimesterFeedbackFormTitle)
					]),
				_List_fromArray(
					[
						$author$project$UI$closeButton($author$project$Element$TrimesterFeedbackForm$ClosePopup)
					]),
				_List_fromArray(
					[
						A2($author$project$Element$TrimesterFeedbackForm$viewMeta, t_, model.eG),
						$author$project$UI$columns(
						_List_fromArray(
							[
								A3($author$project$UI$richTextEditorField, t_, form.a9, values)
							])),
						$author$project$UI$columns(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										viewRubricAssessment,
										((!$author$project$Element$TrimesterFeedbackForm$isRubricAssessmentValid(model)) && model.gC) ? A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('has-errors help is-danger')
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TrimesterFeedbackFormFilledRubricRequired)
											])) : $author$project$UI$none
									]))
							])),
						$author$project$UI$columns(
						_List_fromArray(
							[viewRubricsButton]))
					]),
				_List_fromArray(
					[
						A4(
						$author$project$UI$submitButton,
						t_($author$project$Locale$Messages$BtnSave),
						formState !== 1,
						$author$project$Form$isProcessing(formState),
						$author$project$Element$TrimesterFeedbackForm$SubmitForm),
						A4(
						$author$project$UI$resetButton,
						t_($author$project$Locale$Messages$BtnCancel),
						$author$project$Form$resetDisabled(formState),
						$author$project$Form$isProcessing(formState),
						$author$project$Element$TrimesterFeedbackForm$ClosePopup)
					])),
				A2($author$project$Element$TrimesterFeedbackForm$viewPopup, session, model)
			]));
};
var $author$project$Element$TrimesterFeedbackForm$element = {jb: $author$project$Element$TrimesterFeedbackForm$init, hP: $author$project$Element$TrimesterFeedbackForm$perform, ks: $author$project$Element$TrimesterFeedbackForm$update, og: $author$project$Element$TrimesterFeedbackForm$view};
var $author$project$Element$TrimesterFeedbackReport$trimesterFeedbackForm = {
	ha: $author$project$Element$TrimesterFeedbackForm$element,
	cf: $author$project$Element$TrimesterFeedbackReport$TrimesterFeedbackFormMsg,
	kt: F2(
		function (containerModel, model) {
			return _Utils_update(
				containerModel,
				{
					dK: $elm$core$Maybe$Just(model)
				});
		})
};
var $author$project$Element$TrimesterFeedbackReport$openTrimesterFeedbackForm = F5(
	function (config, session, report, subjects, model) {
		var trimesterFeedbackFormOpened = A3(
			$author$project$Application$V2$Boundaries$mapElement,
			A2($author$project$Application$Boundaries$save, model, session),
			$author$project$Element$TrimesterFeedbackReport$trimesterFeedbackForm,
			A5(
				$author$project$Application$V2$Boundaries$initElement,
				config.jk,
				$author$project$Application$V2$SharedConfig$fromV1(config),
				session,
				$author$project$Element$TrimesterFeedbackReport$trimesterFeedbackForm,
				{dv: report, kb: subjects}));
		return {dX: trimesterFeedbackFormOpened.dX, eh: trimesterFeedbackFormOpened.eh, gs: $elm$core$Maybe$Nothing, gB: trimesterFeedbackFormOpened.gB};
	});
var $author$project$Log$paramScopeTrimesterFeedbackReport = 'scope_trimester_feedback_report';
var $author$project$Element$TrimesterFeedbackReport$updatePortfolioSinglesModel = F5(
	function (session, model, storyId, elementMsg, portfolioSinglesModel) {
		var single = $author$project$Element$TrimesterFeedbackReport$portfolioSingle(storyId);
		var updateSingleModel = function (singleModel) {
			var _return = A3(
				$author$project$Application$V2$Boundaries$mapElement,
				A2($author$project$Application$Boundaries$save, model, session),
				single,
				A5($author$project$Application$V2$Boundaries$updateElement, model.b_.jk, session, elementMsg, singleModel, single));
			var returnNoReply = {dX: _return.dX, eh: _return.eh, gs: $elm$core$Maybe$Nothing, gB: _return.gB};
			var _v0 = _return.gs;
			if (!_v0.$) {
				var _v1 = _v0.a;
				return A2(
					$author$project$Application$Boundaries$mapModel,
					function (model_) {
						return _Utils_update(
							model_,
							{
								b8: $author$project$RemoteData$Success(
									A2($elm$core$Dict$remove, storyId, portfolioSinglesModel))
							});
					},
					returnNoReply);
			} else {
				return returnNoReply;
			}
		};
		var maybeSingleModel = A2($elm$core$Dict$get, storyId, portfolioSinglesModel);
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Application$Boundaries$save, model, session),
			A2($elm$core$Maybe$map, updateSingleModel, maybeSingleModel));
	});
var $author$project$Element$TrimesterFeedbackReport$updateTrimesterFeedbackFormModel = F4(
	function (session, model, elementMsg, trimesterFeedbackFormModel) {
		var returnNoReply = function (return_) {
			return {dX: return_.dX, eh: return_.eh, gs: $elm$core$Maybe$Nothing, gB: return_.gB};
		};
		var _return = A5($author$project$Application$V2$Boundaries$updateElement, model.b_.jk, session, elementMsg, trimesterFeedbackFormModel, $author$project$Element$TrimesterFeedbackReport$trimesterFeedbackForm);
		var _v0 = _return.gs;
		if (_v0.$ === 1) {
			return returnNoReply(
				A3(
					$author$project$Application$V2$Boundaries$mapElement,
					A2($author$project$Application$Boundaries$save, model, session),
					$author$project$Element$TrimesterFeedbackReport$trimesterFeedbackForm,
					_return));
		} else {
			var reply_ = _v0.a;
			if (!reply_.$) {
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{dK: $elm$core$Maybe$Nothing}),
					session);
			} else {
				var trimesterFeedback = reply_.a;
				return returnNoReply(
					A2(
						$author$project$Application$Boundaries$mapModel,
						function (model_) {
							return _Utils_update(
								model_,
								{
									bk: A2(
										$author$project$Element$TrimesterFeedbackReport$mapTrimesterPage,
										function (report_) {
											return _Utils_update(
												report_,
												{
													ih: $elm$core$Maybe$Just(trimesterFeedback)
												});
										},
										model.bk),
									dK: $elm$core$Maybe$Nothing
								});
						},
						A3(
							$author$project$Application$V2$Boundaries$mapElement,
							A2($author$project$Application$Boundaries$save, model, session),
							$author$project$Element$TrimesterFeedbackReport$trimesterFeedbackForm,
							_return)));
			}
		}
	});
var $author$project$Element$TrimesterFeedbackReport$update = F3(
	function (session, msg, model) {
		var t_ = session.h6;
		var config = model.b_;
		switch (msg.$) {
			case 0:
				var storyId = msg.a;
				var elementMsg = msg.b;
				return A2(
					$author$project$RemoteData$withDefault,
					A2($author$project$Application$Boundaries$save, model, session),
					A2(
						$author$project$RemoteData$map,
						A4($author$project$Element$TrimesterFeedbackReport$updatePortfolioSinglesModel, session, model, storyId, elementMsg),
						model.b8));
			case 1:
				var elementMsg = msg.a;
				var _v1 = _Utils_Tuple2(
					model.dK,
					$author$project$Element$TrimesterFeedbackReport$pageToReport(model.bk));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var trimesterFeedbackFormModel = _v1.a.a;
					return A4($author$project$Element$TrimesterFeedbackReport$updateTrimesterFeedbackFormModel, session, model, elementMsg, trimesterFeedbackFormModel);
				} else {
					return A2($author$project$Application$Boundaries$save, model, session);
				}
			case 2:
				var tab = msg.a;
				return A2(
					$author$project$RemoteData$withDefault,
					A2($author$project$Application$Boundaries$save, model, session),
					A2(
						$author$project$RemoteData$map,
						function (reports) {
							return $author$project$Element$TrimesterFeedbackReport$andThenFetchModuleClosures(
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bk: A2($author$project$Element$TrimesterFeedbackReport$switchTab, reports, tab)
										}),
									session));
						},
						model.et));
			case 3:
				var report = msg.a;
				var subjects = msg.b;
				return A5($author$project$Element$TrimesterFeedbackReport$openTrimesterFeedbackForm, config, session, report, subjects, model);
			case 7:
				var feedback = msg.a;
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A3($author$project$TrimesterFeedback$deleteTrimesterFeedback, model.b_.gX, feedback, $author$project$Element$TrimesterFeedbackReport$TrimesterFeedbackDeleted),
					A2($author$project$Application$Boundaries$save, model, session));
			case 5:
				var data = msg.a;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{kb: data}),
					session);
			case 4:
				if (!msg.a.$) {
					var stories = msg.a.a;
					return A2(
						$author$project$Element$TrimesterFeedbackReport$andThenInitPortfolioSingleElements,
						stories,
						A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									b8: $author$project$RemoteData$Success($elm$core$Dict$empty)
								}),
							session));
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgPortfoliosDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeTrimesterFeedbackReport),
								error),
							$elm$core$Basics$always($author$project$Element$TrimesterFeedbackReport$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$PortfoliosDownloadError))));
				}
			case 6:
				var reports = msg.a;
				switch (reports.$) {
					case 2:
						var reports_ = reports.a;
						return $author$project$Element$TrimesterFeedbackReport$andThenFetchModuleClosures(
							A2(
								$author$project$Element$TrimesterFeedbackReport$andThenInitPage,
								reports_,
								A2($author$project$Application$Boundaries$save, model, session)));
					case 3:
						var error = reports.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3($author$project$Log$msgTrimesterFeedbackDownload, $elm$core$Maybe$Nothing, error),
								$elm$core$Basics$always($author$project$Element$TrimesterFeedbackReport$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$TrimesterFeedbackReportDownloadError))));
					case 0:
						return A2($author$project$Application$Boundaries$save, model, session);
					default:
						return A2($author$project$Application$Boundaries$save, model, session);
				}
			case 8:
				if (!msg.a.$) {
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								bk: A2(
									$author$project$Element$TrimesterFeedbackReport$mapTrimesterPage,
									function (report) {
										return _Utils_update(
											report,
											{ih: $elm$core$Maybe$Nothing});
									},
									model.bk)
							}),
						A2(
							$author$project$Session$ok,
							session,
							t_($author$project$Locale$Messages$TrimesterFeedbackDeleteSuccess)));
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							config,
							_Utils_Tuple3($author$project$Log$msgTrimesterFeedbackDelete, $elm$core$Maybe$Nothing, error),
							$elm$core$Basics$always($author$project$Element$TrimesterFeedbackReport$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$TrimesterFeedbackDeleteError))));
				}
			default:
				return A2($author$project$Application$Boundaries$save, model, session);
		}
	});
var $author$project$Locale$Messages$TrimesterFeedbackReportLoadingProgress = {$: 651};
var $author$project$Locale$Messages$TrimesterFeedbackReportNotFound = {$: 652};
var $author$project$Element$TrimesterFeedbackReport$viewNotFoundPage = function (t_) {
	return $author$project$UI$notification(
		_List_fromArray(
			[
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TrimesterFeedbackReportNotFound)
			]));
};
var $author$project$Locale$Messages$TrimesterFeedbackReportTitle = {$: 649};
var $author$project$Element$TrimesterFeedbackReport$NoSelectedTab = 4;
var $author$project$Element$TrimesterFeedbackReport$pageToTab = function (page) {
	switch (page.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		default:
			return 4;
	}
};
var $author$project$Element$TrimesterFeedbackReport$TabSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$TrimesterFeedbackReportTabFirstTrimester = {$: 658};
var $author$project$Locale$Messages$TrimesterFeedbackReportTabPreviousYears = {$: 657};
var $author$project$Locale$Messages$TrimesterFeedbackReportTabSecondTrimester = {$: 659};
var $author$project$Locale$Messages$TrimesterFeedbackReportTabThirdTrimester = {$: 660};
var $author$project$Element$TrimesterFeedbackReport$viewTabs = F3(
	function (t_, reports, selectedTab) {
		var isEnabledTrimesterReportTab = function (tabPos) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						function ($) {
							return $.l3;
						}),
					A2($author$project$Element$TrimesterFeedbackReport$findReportByTrimester, reports, tabPos)));
		};
		return A3(
			$author$project$UI$List$filterBar,
			t_,
			_Utils_Tuple2($author$project$Element$TrimesterFeedbackReport$TabSelected, selectedTab),
			_List_fromArray(
				[
					{cm: 'previous', ad: 0, hv: true, hw: true, ea: $author$project$Locale$Messages$TrimesterFeedbackReportTabPreviousYears},
					{
					cm: 'first',
					ad: 1,
					hv: isEnabledTrimesterReportTab(1),
					hw: true,
					ea: $author$project$Locale$Messages$TrimesterFeedbackReportTabFirstTrimester
				},
					{
					cm: 'second',
					ad: 2,
					hv: isEnabledTrimesterReportTab(2),
					hw: true,
					ea: $author$project$Locale$Messages$TrimesterFeedbackReportTabSecondTrimester
				},
					{
					cm: 'third',
					ad: 3,
					hv: isEnabledTrimesterReportTab(3),
					hw: true,
					ea: $author$project$Locale$Messages$TrimesterFeedbackReportTabThirdTrimester
				}
				]));
	});
var $author$project$Locale$Messages$TrimesterFeedbackReportDownloadTrimesterFeedback = F2(
	function (a, b) {
		return {$: 662, a: a, b: b};
	});
var $author$project$Element$TrimesterFeedbackReport$viewDownloadLink = F3(
	function (t_, message, url) {
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(url),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							$author$project$UI$Icon$filePdf(
							_List_fromArray(
								[
									$author$project$UI$Icon$style('has-text-primary')
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, message)
								]))
						]))
				]));
	});
var $author$project$Element$TrimesterFeedbackReport$viewTrimesterFeedbackLink = F2(
	function (t_, report) {
		return A2(
			$author$project$UI$maybe,
			report.K,
			A2(
				$author$project$Element$TrimesterFeedbackReport$viewDownloadLink,
				t_,
				A2($author$project$Locale$Messages$TrimesterFeedbackReportDownloadTrimesterFeedback, report.eB, report.kp)));
	});
var $author$project$Element$TrimesterFeedbackReport$viewPreviousYearsPage = F3(
	function (t_, reports, page) {
		return $author$project$UI$panel(
			{
				g$: function () {
					if (reports.$ === 2) {
						var reports_ = reports.a;
						var pastReports = A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$not,
								function ($) {
									return $.jh;
								}),
							reports_);
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								A2(
									$elm$core$List$map,
									$author$project$Element$TrimesterFeedbackReport$viewTrimesterFeedbackLink(t_),
									pastReports))
							]);
					} else {
						return _List_fromArray(
							[$author$project$UI$List$resultsLoadingProgressBar]);
					}
				}(),
				cm: 'feedback-list-archive',
				hl: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TrimesterFeedbackReportTitle)
							]),
						_List_Nil)
					]),
				h7: A3(
					$author$project$Element$TrimesterFeedbackReport$viewTabs,
					t_,
					A2($author$project$RemoteData$withDefault, _List_Nil, reports),
					$author$project$Element$TrimesterFeedbackReport$pageToTab(page)),
				ie: 'is-link'
			});
	});
var $author$project$Element$TrimesterFeedbackReport$OpenTrimesterFeedbackForm = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Locale$Messages$TrimesterFeedbackReportNew = {$: 648};
var $author$project$ACL$canCreateTrimesterClosingFeedback = F2(
	function (person, student) {
		return A2(
			$elm$core$List$any,
			$author$project$Person$isSamePerson(student),
			person.mx);
	});
var $author$project$Locale$Messages$TrimesterFeedbackReportAddFeedback = {$: 656};
var $author$project$Locale$Messages$TrimesterFeedbackReportMissingFeedback = function (a) {
	return {$: 654, a: a};
};
var $author$project$Element$TrimesterFeedbackReport$viewMissingTrimesterFeedback = F3(
	function (_v0, report, subjects) {
		var t_ = _v0.h6;
		var viewer = _v0.ok;
		var student = report.nT;
		var studentName = A2($author$project$Person$fullName, t_, student);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container is-fullwidth')
				]),
			_List_fromArray(
				[
					$author$project$UI$notification(
					_List_fromArray(
						[
							A2(
							$author$project$UI$caption,
							t_,
							$author$project$Locale$Messages$TrimesterFeedbackReportMissingFeedback(studentName)),
							A3(
							$elm$core$Basics$apL,
							$author$project$UI$when,
							A2($author$project$ACL$canCreateTrimesterClosingFeedback, viewer, student),
							A3(
								$author$project$UI$actionLink,
								A2($author$project$Element$TrimesterFeedbackReport$OpenTrimesterFeedbackForm, report, subjects),
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TrimesterFeedbackReportAddFeedback)
									])))
						]))
				]));
	});
var $author$project$Locale$Messages$TrimesterFeedbackReportMissingModuleClosures = function (a) {
	return {$: 655, a: a};
};
var $author$project$Element$TrimesterFeedbackReport$viewMissingModuleClosures = F2(
	function (t_, student) {
		var studentName = A2($author$project$Person$fullName, t_, student);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container is-fullwidth')
				]),
			_List_fromArray(
				[
					$author$project$UI$notification(
					_List_fromArray(
						[
							A2(
							$author$project$UI$caption,
							t_,
							$author$project$Locale$Messages$TrimesterFeedbackReportMissingModuleClosures(studentName))
						]))
				]));
	});
var $author$project$Element$TrimesterFeedbackReport$viewSingleElement = F3(
	function (session, story, portfolioSinglesModel) {
		return A3(
			$author$project$Application$V2$Boundaries$viewElement,
			session,
			portfolioSinglesModel,
			$author$project$Element$TrimesterFeedbackReport$portfolioSingle(story.i8));
	});
var $author$project$Element$TrimesterFeedbackReport$viewStoryList = F3(
	function (session, student, portfolioSinglesModel) {
		var t_ = session.h6;
		if (portfolioSinglesModel.$ === 2) {
			var portfolioSinglesModel_ = portfolioSinglesModel.a;
			var viewKeyedItem = function (story) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(story.i8),
					A2(
						$author$project$UI$maybe,
						A2($elm$core$Dict$get, story.i8, portfolioSinglesModel_),
						A2($author$project$Element$TrimesterFeedbackReport$viewSingleElement, session, story)));
			};
			var stories = A2(
				$elm$core$List$filterMap,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bA;
					},
					$author$project$RemoteData$toMaybe),
				$elm$core$Dict$values(portfolioSinglesModel_));
			return $elm$core$List$isEmpty(stories) ? _List_fromArray(
				[
					_Utils_Tuple2(
					'',
					A2($author$project$Element$TrimesterFeedbackReport$viewMissingModuleClosures, t_, student))
				]) : A2($elm$core$List$map, viewKeyedItem, stories);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2('', $author$project$UI$List$resultsLoadingProgressBar)
				]);
		}
	});
var $author$project$Element$TrimesterFeedbackReport$TrimesterFeedbackDeleteRequested = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$TrimesterFeedbackReport$viewTrimesterFeedbackContent = function (trimesterFeedback) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('block mt-2')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('block')
					]),
				_List_fromArray(
					[
						$author$project$Util$Html$markdownToHtml(trimesterFeedback.g8)
					]))
			]));
};
var $author$project$Element$TrimesterFeedbackReport$viewTrimesterFeedbackMeta = F3(
	function (t_, student, trimesterFeedback) {
		var viewTitle = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('has-text-grey')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$UI$caption,
					t_,
					A2(
						$author$project$Locale$Messages$TrimesterClosureFeedbackGiven,
						A2($author$project$Person$fullName, t_, trimesterFeedback.lf),
						A2($author$project$Person$fullName, t_, student)))
				]));
		var viewDateLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$TrimesterFeedbackReport(student.i8))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$UI$caption,
					t_,
					A2(
						$author$project$Locale$Messages$TimeDateTimeFormat,
						$elm$time$Time$utc,
						$elm$time$Time$millisToPosix(trimesterFeedback.g4)))
				]));
		return A4(
			$author$project$UI$mediaObjectSmall,
			_List_fromArray(
				[
					$author$project$UI$gravatar(trimesterFeedback.lf.O)
				]),
			_List_fromArray(
				[
					viewTitle,
					$author$project$UI$mediaObjectHighlights(
					_List_fromArray(
						[viewDateLink]))
				]),
			_List_Nil,
			_List_Nil);
	});
var $author$project$Element$TrimesterFeedbackReport$viewTrimesterFeedback = F4(
	function (t_, subjects, student, trimesterFeedback) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container is-fullwidth')
				]),
			_List_fromArray(
				[
					A3($author$project$Element$TrimesterFeedbackReport$viewTrimesterFeedbackMeta, t_, student, trimesterFeedback),
					$author$project$Element$TrimesterFeedbackReport$viewTrimesterFeedbackContent(trimesterFeedback),
					A2(
					$author$project$UI$maybe,
					trimesterFeedback.hd,
					$author$project$UI$RubricAssessment$view(subjects)),
					A2(
					$author$project$UI$levelHorizontal,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$UI$actionLink,
							$author$project$Element$TrimesterFeedbackReport$TrimesterFeedbackDeleteRequested(trimesterFeedback),
							_List_Nil,
							_List_fromArray(
								[
									$author$project$UI$Icon$delete(_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Element$TrimesterFeedbackReport$viewTrimesterPage = F6(
	function (session, reports, portfolioSinglesModel, page, report, subjects) {
		var t_ = session.h6;
		var viewer = session.ok;
		var trimesterFeedback = report.ih;
		var student = report.nT;
		var url = report.K;
		var viewDownloadBar = function (url_) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-fullwidth')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UI$level,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(url_)
										]),
									_List_fromArray(
										[
											$author$project$UI$Icon$filePdf(
											_List_fromArray(
												[
													$author$project$UI$Icon$style('has-text-primary')
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsDownloadFeedbackPDF)
												]))
										]))
								]))
						]))
				]);
		};
		var viewAddIcon = function () {
			if (!trimesterFeedback.$) {
				return $author$project$UI$none;
			} else {
				return A3(
					$elm$core$Basics$apL,
					$author$project$UI$when,
					A2($author$project$ACL$canCreateTrimesterClosingFeedback, viewer, student),
					A3(
						$author$project$UI$actionLink,
						A2($author$project$Element$TrimesterFeedbackReport$OpenTrimesterFeedbackForm, report, subjects),
						_List_Nil,
						_List_fromArray(
							[
								$author$project$UI$Icon$add(
								_List_fromArray(
									[
										$author$project$UI$Icon$style('has-text-white'),
										$author$project$UI$Icon$alt(
										t_($author$project$Locale$Messages$TrimesterFeedbackReportNew))
									]))
							])));
			}
		}();
		return $author$project$UI$keyedPanel(
			{
				g$: _Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, viewDownloadBar, url)),
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							A3($author$project$Element$TrimesterFeedbackReport$viewMissingTrimesterFeedback, session, report, subjects),
							A2(
								$elm$core$Maybe$map,
								A3($author$project$Element$TrimesterFeedbackReport$viewTrimesterFeedback, t_, subjects, student),
								trimesterFeedback))
						])),
				cm: 'feedback-list-current',
				hl: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TrimesterFeedbackReportTitle)
							]),
						_List_fromArray(
							[viewAddIcon]))
					]),
				mm: A3($author$project$Element$TrimesterFeedbackReport$viewStoryList, session, student, portfolioSinglesModel),
				h7: A3(
					$author$project$Element$TrimesterFeedbackReport$viewTabs,
					t_,
					A2($author$project$RemoteData$withDefault, _List_Nil, reports),
					$author$project$Element$TrimesterFeedbackReport$pageToTab(page)),
				ie: 'is-link'
			});
	});
var $author$project$Element$TrimesterFeedbackReport$viewPage = F2(
	function (session, _v0) {
		var t_ = session.h6;
		var portfolioSinglesModel = _v0.b8;
		var page = _v0.bk;
		var reports = _v0.et;
		var subjects = _v0.kb;
		var viewTrimesterPage_ = function (report) {
			return A6(
				$author$project$Element$TrimesterFeedbackReport$viewTrimesterPage,
				session,
				reports,
				portfolioSinglesModel,
				page,
				report,
				A2($author$project$RemoteData$withDefault, _List_Nil, subjects));
		};
		switch (page.$) {
			case 1:
				var report = page.a;
				return viewTrimesterPage_(report);
			case 2:
				var report = page.a;
				return viewTrimesterPage_(report);
			case 3:
				var report = page.a;
				return viewTrimesterPage_(report);
			case 0:
				return A3($author$project$Element$TrimesterFeedbackReport$viewPreviousYearsPage, t_, reports, page);
			default:
				return $author$project$Element$TrimesterFeedbackReport$viewNotFoundPage(t_);
		}
	});
var $author$project$Element$TrimesterFeedbackReport$view = F2(
	function (session, model) {
		var t_ = session.h6;
		var viewReportsLoading = A2(
			$author$project$UI$progressBar,
			'is-link',
			t_($author$project$Locale$Messages$TrimesterFeedbackReportLoadingProgress));
		var viewReports = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Element$TrimesterFeedbackReport$viewPage, session, model),
					A2(
					$elm$core$Maybe$withDefault,
					$author$project$UI$none,
					A2(
						$elm$core$Maybe$map,
						function (model_) {
							return A3($author$project$Application$V2$Boundaries$viewElement, session, model_, $author$project$Element$TrimesterFeedbackReport$trimesterFeedbackForm);
						},
						model.dK))
				]));
		return A2(
			$author$project$RemoteData$withDefault,
			viewReportsLoading,
			A2(
				$author$project$RemoteData$map,
				$elm$core$Basics$always(viewReports),
				model.et));
	});
var $author$project$Element$TrimesterFeedbackReport$element = {jb: $author$project$Element$TrimesterFeedbackReport$init, ks: $author$project$Element$TrimesterFeedbackReport$update, og: $author$project$Element$TrimesterFeedbackReport$view};
var $author$project$Pages$pages = {
	c0: {
		ha: $author$project$Element$CompanyContractForm$element,
		cf: $author$project$Pages$CompanyContractFormMsg,
		kt: $elm$core$Basics$always($author$project$Pages$CompanyContractFormModel)
	},
	dZ: {
		ha: $author$project$Element$Counter$element,
		cf: $author$project$Pages$CounterMsg,
		kt: $elm$core$Basics$always($author$project$Pages$CounterModel)
	},
	c2: {
		ha: $author$project$Element$CurriculumBrowser$element,
		cf: $author$project$Pages$CurriculumBrowserMsg,
		kt: $elm$core$Basics$always($author$project$Pages$CurriculumBrowserModel)
	},
	cr: {
		iz: $elm$core$Basics$always($author$project$Pages$GenericProfileFormModel),
		ha: $author$project$Element$GenericProfileForm$element,
		jv: $author$project$Pages$GenericProfileFormMsg
	},
	c8: {
		ha: $author$project$Element$GradeRequestList$element,
		cf: $author$project$Pages$GradeRequestListMsg,
		kt: $elm$core$Basics$always($author$project$Pages$GradeRequestListModel)
	},
	c9: {
		ha: $author$project$Element$GradingPage$element,
		cf: $author$project$Pages$GradingPageMsg,
		kt: $elm$core$Basics$always($author$project$Pages$GradingPageModel)
	},
	ct: {
		iz: $elm$core$Basics$always($author$project$Pages$HomePageModel),
		ha: $author$project$Element$HomePage$element,
		jv: $author$project$Pages$HomePageMsg
	},
	cu: {
		iz: $elm$core$Basics$always($author$project$Pages$LearningAssessmentCardModel),
		ha: $author$project$Element$LearningAssessmentCard$element,
		jv: $author$project$Pages$LearningAssessmentCardMsg
	},
	bw: {
		iz: $elm$core$Basics$always($author$project$Pages$LearningContractsModel),
		ha: $author$project$Element$LearningContracts$element,
		jv: $author$project$Pages$LearningContractsMsg
	},
	b1: {
		ha: $author$project$Element$LearningGroupForm$element,
		cf: $author$project$Pages$LearningGroupFormMsg,
		kt: $elm$core$Basics$always($author$project$Pages$LearningGroupFormModel)
	},
	de: {
		ha: $author$project$Element$LearningGroupList$element,
		cf: $author$project$Pages$LearningGroupListMsg,
		kt: $elm$core$Basics$always($author$project$Pages$LearningGroupListModel)
	},
	e8: {
		ha: $author$project$Element$LearningGroupSelector$element,
		cf: $author$project$Pages$LearningGroupSelectorMsg,
		kt: $elm$core$Basics$always($author$project$Pages$LearningGroupSelectorModel)
	},
	cA: {
		iz: $elm$core$Basics$always($author$project$Pages$ModuleClosureOverviewModel),
		ha: $author$project$Element$ModuleClosureOverview$element,
		jv: $author$project$Pages$ModuleClosureOverviewMsg
	},
	b3: {
		ha: $author$project$Element$ModuleSingle$element,
		cf: $author$project$Pages$ModuleSingleMsg,
		kt: $elm$core$Basics$always($author$project$Pages$ModuleSingleModel)
	},
	cC: {
		iz: $elm$core$Basics$always($author$project$Pages$ModuleTeacherProfilesModel),
		ha: $author$project$Element$ModuleTeacherProfiles$element,
		jv: $author$project$Pages$ModuleTeacherProfilesMsg
	},
	ax: {
		iz: $elm$core$Basics$always($author$project$Pages$ModulesMainModel),
		ha: $author$project$Element$ModulesMain$element,
		jv: $author$project$Pages$ModulesMainMsg
	},
	cD: {
		iz: $elm$core$Basics$always($author$project$Pages$NotificationListModel),
		ha: $author$project$Element$NotificationList$element,
		jv: $author$project$Pages$NotificationListMsg
	},
	dq: {
		ha: $author$project$Element$PhoneBook$element,
		cf: $author$project$Pages$PhoneBookMsg,
		kt: $elm$core$Basics$always($author$project$Pages$PhoneBookModel)
	},
	b6: {
		ha: $author$project$Element$PortfolioForm$element,
		cf: $author$project$Pages$PortfolioFormMsg,
		kt: $elm$core$Basics$always($author$project$Pages$PortfolioFormModel)
	},
	b7: {
		ha: $author$project$Element$PortfolioList$element,
		cf: $author$project$Pages$PortfolioListMsg,
		kt: $elm$core$Basics$always($author$project$Pages$PortfolioListModel)
	},
	ds: {
		ha: $author$project$Element$PortfolioSingle$element,
		cf: $author$project$Pages$PortfolioSingleMsg,
		kt: $elm$core$Basics$always($author$project$Pages$PortfolioSingleModel)
	},
	du: {
		ha: $author$project$Element$ReconciliationPage$element,
		cf: $author$project$Pages$ReconciliationPageMsg,
		kt: $elm$core$Basics$always($author$project$Pages$ReconciliationPageModel)
	},
	cN: {
		iz: F2(
			function (_v0, model) {
				return $author$project$Pages$RubricSubjectOverviewModel(model);
			}),
		ha: $author$project$Element$RubricSubjectOverview$element,
		jv: $author$project$Pages$RubricSubjectOverviewMsg
	},
	b9: {
		ha: $author$project$Element$RubricsForm$element,
		cf: $author$project$Pages$RubricsFormMsg,
		kt: $elm$core$Basics$always($author$project$Pages$RubricsFormModel)
	},
	dy: {
		ha: $author$project$Element$RubricsList$element,
		cf: $author$project$Pages$RubricsListMsg,
		kt: $elm$core$Basics$always($author$project$Pages$RubricsListModel)
	},
	dA: {
		ha: $author$project$Element$RubricsSingle$element,
		cf: $author$project$Pages$RubricsSingleMsg,
		kt: $elm$core$Basics$always($author$project$Pages$RubricsSingleModel)
	},
	dD: {
		ha: $author$project$Element$StudentAbsenceList$element,
		cf: $author$project$Pages$StudentAbsenceListMsg,
		kt: $elm$core$Basics$always($author$project$Pages$StudentAbsenceListModel)
	},
	cU: {
		iz: $elm$core$Basics$always($author$project$Pages$StudentListModel),
		ha: $author$project$Element$StudentList$element,
		jv: $author$project$Pages$StudentListMsg
	},
	bW: {
		iz: $elm$core$Basics$always($author$project$Pages$StudentProfileFormModel),
		ha: $author$project$Element$StudentProfileForm$element,
		jv: $author$project$Pages$StudentProfileFormMsg
	},
	dF: {
		ha: $author$project$Element$SubjectFeedbackList$element,
		cf: $author$project$Pages$SubjectFeedbackListMsg,
		kt: $elm$core$Basics$always($author$project$Pages$SubjectFeedbackListModel)
	},
	cV: {
		iz: $elm$core$Basics$always($author$project$Pages$TeacherProfileFormModel),
		ha: $author$project$Element$TeacherProfileForm$element,
		jv: $author$project$Pages$TeacherProfileFormMsg
	},
	aL: {
		iz: $elm$core$Basics$always($author$project$Pages$TimetableModel),
		ha: $author$project$Element$Timetable$element,
		jv: $author$project$Pages$TimetableMsg
	},
	cW: {
		iz: $elm$core$Basics$always($author$project$Pages$TrimesterFeedbackReportModel),
		ha: $author$project$Element$TrimesterFeedbackReport$element,
		jv: $author$project$Pages$TrimesterFeedbackReportMsg
	}
};
var $author$project$Application$Boundaries$updateElement = F4(
	function (session, msg, model, element) {
		return A3(element.ha.ks, session, msg, model);
	});
var $author$project$Pages$init = F5(
	function (key, config, route, session, model) {
		var obsoletePageClosed = _Utils_Tuple3($author$project$Pages$NotLoaded, $elm$core$Platform$Cmd$none, session);
		var noop = _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, session);
		var _v0 = _Utils_Tuple2(route, model);
		switch (_v0.a.$) {
			case 4:
				if (_v0.b.$ === 2) {
					return noop;
				} else {
					var params = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.dZ,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							key,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.dZ,
							params));
				}
			case 49:
				if (_v0.b.$ === 1) {
					var _v1 = _v0.a;
					return noop;
				} else {
					var _v2 = _v0.a;
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.c2,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							key,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.c2,
							0));
				}
			case 5:
				if (_v0.b.$ === 4) {
					return noop;
				} else {
					var studentId = _v0.a.a;
					return $author$project$ACL$canOpenStudentAbsences(session.ok) ? A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.dD,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							key,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.dD,
							{dE: studentId})) : obsoletePageClosed;
				}
			case 6:
				if (_v0.b.$ === 5) {
					return noop;
				} else {
					var personId = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.cu,
						A4(
							$author$project$Application$Boundaries$initElement,
							config,
							session,
							$author$project$Pages$pages.cu,
							{hA: personId}));
				}
			case 7:
				var _v3 = _v0.a;
				var personId = _v3.a;
				var maybeLearningAssessmentId = _v3.b;
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.c8,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						key,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.c8,
						_Utils_Tuple2(personId, maybeLearningAssessmentId)));
			case 8:
				if (_v0.b.$ === 7) {
					var _v4 = _v0.a;
					return noop;
				} else {
					var _v5 = _v0.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.ct,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.ct, 0));
				}
			case 9:
				var _v6 = _v0.a;
				return A3(
					$author$project$Pages$mapProgram,
					model,
					$author$project$Pages$pages.bw,
					A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.bw, $author$project$Element$LearningContracts$Create));
			case 10:
				var _v7 = _v0.a;
				return A3(
					$author$project$Pages$mapProgram,
					model,
					$author$project$Pages$pages.bw,
					A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.bw, $author$project$Element$LearningContracts$List));
			case 11:
				var id = _v0.a.a;
				return A3(
					$author$project$Pages$mapProgram,
					model,
					$author$project$Pages$pages.bw,
					A4(
						$author$project$Application$Boundaries$initElement,
						config,
						session,
						$author$project$Pages$pages.bw,
						$author$project$Element$LearningContracts$Update(id)));
			case 12:
				if (_v0.b.$ === 10) {
					var _v8 = _v0.a;
					return noop;
				} else {
					var _v9 = _v0.a;
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.b1,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							key,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.b1,
							$author$project$Element$LearningGroupForm$Create));
				}
			case 13:
				if (_v0.b.$ === 1) {
					var _v10 = _v0.a;
					return noop;
				} else {
					var _v11 = _v0.a;
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.de,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							key,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.de,
							0));
				}
			case 15:
				if (_v0.b.$ === 10) {
					return noop;
				} else {
					var learningGroupId = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.b1,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							key,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.b1,
							$author$project$Element$LearningGroupForm$UpdateGroup(learningGroupId)));
				}
			case 16:
				if (_v0.b.$ === 14) {
					return noop;
				} else {
					var query = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.cA,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.cA, query));
				}
			case 18:
				if (_v0.b.$ === 8) {
					return noop;
				} else {
					var id = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.cC,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.cC, id));
				}
			case 19:
				var _v12 = _v0.a;
				return A3(
					$author$project$Pages$mapProgram,
					model,
					$author$project$Pages$pages.ax,
					A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.ax, $author$project$Element$ModulesMain$CreateModule));
			case 23:
				var _v13 = _v0.a;
				return A3(
					$author$project$Pages$mapProgram,
					model,
					$author$project$Pages$pages.ax,
					A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.ax, $author$project$Element$ModulesMain$ListModules));
			case 21:
				var moduleId = _v0.a.a;
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.b3,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						key,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.b3,
						$author$project$Element$ModuleSingle$ViewModule(moduleId)));
			case 17:
				var moduleId = _v0.a.a;
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.b3,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						config.jk,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.b3,
						$author$project$Element$ModuleSingle$CloseModule(moduleId)));
			case 20:
				var moduleId = _v0.a.a;
				return A3(
					$author$project$Pages$mapProgram,
					model,
					$author$project$Pages$pages.ax,
					A4(
						$author$project$Application$Boundaries$initElement,
						config,
						session,
						$author$project$Pages$pages.ax,
						$author$project$Element$ModulesMain$CreateModuleFromTemplate(moduleId)));
			case 22:
				var moduleId = _v0.a.a;
				return A3(
					$author$project$Pages$mapProgram,
					model,
					$author$project$Pages$pages.ax,
					A4(
						$author$project$Application$Boundaries$initElement,
						config,
						session,
						$author$project$Pages$pages.ax,
						$author$project$Element$ModulesMain$DuplicateModule(moduleId)));
			case 24:
				var moduleId = _v0.a.a;
				return A3(
					$author$project$Pages$mapProgram,
					model,
					$author$project$Pages$pages.ax,
					A4(
						$author$project$Application$Boundaries$initElement,
						config,
						session,
						$author$project$Pages$pages.ax,
						$author$project$Element$ModulesMain$UpdateModule(moduleId)));
			case 25:
				if (_v0.b.$ === 15) {
					var _v14 = _v0.a;
					return noop;
				} else {
					var _v15 = _v0.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.cD,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.cD, 0));
				}
			case 26:
				if (_v0.b.$ === 16) {
					var _v16 = _v0.a;
					return noop;
				} else {
					var _v17 = _v0.a;
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.dq,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							key,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.dq,
							0));
				}
			case 32:
				if (_v0.b.$ === 17) {
					return noop;
				} else {
					var id = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.cr,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.cr, id));
				}
			case 27:
				if (_v0.b.$ === 18) {
					return noop;
				} else {
					var moduleId = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.b6,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							key,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.b6,
							$author$project$Element$PortfolioForm$Create(moduleId)));
				}
			case 28:
				if (_v0.b.$ === 19) {
					return noop;
				} else {
					var storyId = _v0.a.a;
					var params = {
						kb: $author$project$RemoteData$NotAsked,
						oi: $author$project$Element$PortfolioSingle$Page(storyId)
					};
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.ds,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							config.jk,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.ds,
							params));
				}
			case 29:
				if (_v0.b.$ === 20) {
					return noop;
				} else {
					var query = _v0.a.a;
					var defaults = $author$project$Element$PortfolioList$defaultParams;
					var params = _Utils_update(
						defaults,
						{
							hb: A2($elm$core$Maybe$map, $author$project$Form$dateToMillis, query.ly),
							mY: A2($elm$core$Maybe$withDefault, false, query.ol),
							h2: A2($elm$core$Maybe$map, $author$project$Form$dateToMillis, query.nN),
							fv: $author$project$Element$PortfolioList$SpecificStudents(query.fv)
						});
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.b7,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							config.jk,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.b7,
							params));
				}
			case 30:
				if (_v0.b.$ === 20) {
					var _v18 = _v0.a;
					return noop;
				} else {
					var _v19 = _v0.a;
					var defaults = $author$project$Element$PortfolioList$defaultParams;
					var params = _Utils_update(
						defaults,
						{fv: $author$project$Element$PortfolioList$MyChildren});
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.b7,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							config.jk,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.b7,
							params));
				}
			case 31:
				if (_v0.b.$ === 18) {
					return noop;
				} else {
					var storyId = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.b6,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							key,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.b6,
							$author$project$Element$PortfolioForm$Update(storyId)));
				}
			case 33:
				var _v20 = _v0.a;
				var params = {mc: false, nt: $elm$core$Maybe$Nothing};
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.b9,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						key,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.b9,
						params));
			case 35:
				var rubricId = _v0.a.a;
				var params = {
					mc: false,
					nt: $elm$core$Maybe$Just(rubricId)
				};
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.b9,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						key,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.b9,
						params));
			case 34:
				var _v21 = _v0.a;
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.dy,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						key,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.dy,
						$author$project$Element$RubricsList$Page));
			case 37:
				if (_v0.b.$ === 24) {
					return noop;
				} else {
					var query = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.cN,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.cN, query));
				}
			case 36:
				var rubricId = _v0.a.a;
				var params = $author$project$Element$RubricsSingle$Page(rubricId);
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.dA,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						key,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.dA,
						params));
			case 39:
				if (_v0.b.$ === 25) {
					return noop;
				} else {
					var id = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.bW,
						A4(
							$author$project$Application$Boundaries$initElement,
							config,
							session,
							$author$project$Pages$pages.bW,
							$author$project$Element$StudentProfileForm$FullProfile(id)));
				}
			case 38:
				if (_v0.b.$ === 25) {
					return noop;
				} else {
					var id = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.bW,
						A4(
							$author$project$Application$Boundaries$initElement,
							config,
							session,
							$author$project$Pages$pages.bW,
							$author$project$Element$StudentProfileForm$NekProfile(id)));
				}
			case 40:
				if (_v0.b.$ === 26) {
					var _v22 = _v0.a;
					return noop;
				} else {
					var _v23 = _v0.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.cU,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.cU, 0));
				}
			case 41:
				var _v24 = _v0.a;
				var studentId = _v24.a;
				var subject = _v24.b.gE;
				var grade = _v24.b.W;
				var midYear = _v24.b.mB;
				var params = {
					W: grade,
					mB: A2($elm$core$Maybe$withDefault, false, midYear),
					dE: studentId,
					nW: subject
				};
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.dF,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						key,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.dF,
						params));
			case 42:
				if (_v0.b.$ === 28) {
					return noop;
				} else {
					var id = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.cV,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.cV, id));
				}
			case 45:
				if (_v0.b.$ === 29) {
					var query = _v0.a.a;
					var timetableModel = _v0.b.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.aL,
						A4(
							$author$project$Application$Boundaries$updateElement,
							session,
							$author$project$Element$Timetable$UpdateEventSelected(query),
							timetableModel,
							$author$project$Pages$pages.aL));
				} else {
					var query = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.aL,
						A4(
							$author$project$Application$Boundaries$initElement,
							config,
							session,
							$author$project$Pages$pages.aL,
							$author$project$Element$Timetable$UpdateEvent(query)));
				}
			case 44:
				if (_v0.b.$ === 29) {
					var query = _v0.a.a;
					var timetableModel = _v0.b.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.aL,
						A4(
							$author$project$Application$Boundaries$updateElement,
							session,
							$author$project$Element$Timetable$CreateEventSelected(query),
							timetableModel,
							$author$project$Pages$pages.aL));
				} else {
					var query = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.aL,
						A4(
							$author$project$Application$Boundaries$initElement,
							config,
							session,
							$author$project$Pages$pages.aL,
							$author$project$Element$Timetable$CreateEvent(query)));
				}
			case 43:
				if (_v0.b.$ === 29) {
					return noop;
				} else {
					var people = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.aL,
						A4(
							$author$project$Application$Boundaries$initElement,
							config,
							session,
							$author$project$Pages$pages.aL,
							$author$project$Element$Timetable$Calendar(people)));
				}
			case 46:
				if (_v0.b.$ === 30) {
					return noop;
				} else {
					var studentId = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.cW,
						A4(
							$author$project$Application$Boundaries$initElement,
							config,
							session,
							$author$project$Pages$pages.cW,
							{dE: studentId}));
				}
			case 14:
				if (_v0.b.$ === 31) {
					return noop;
				} else {
					var id = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.c0,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							key,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.c0,
							id));
				}
			case 47:
				var _v25 = _v0.a;
				var schoolId = _v25.a;
				var grade = _v25.b;
				var realTime = _v25.c;
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.c9,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						key,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.c9,
						{W: grade, jI: realTime, fr: schoolId}));
			case 50:
				var _v26 = _v0.a;
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.du,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						key,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.du,
						0));
			case 48:
				var _v27 = _v0.a;
				return obsoletePageClosed;
			case 0:
				return obsoletePageClosed;
			case 1:
				var _v28 = _v0.a;
				return obsoletePageClosed;
			case 2:
				var _v29 = _v0.a;
				return obsoletePageClosed;
			default:
				return obsoletePageClosed;
		}
	});
var $author$project$Main$session = function (model) {
	var _v0 = model.a0;
	if ((_v0.$ === 2) && (_v0.a.$ === 2)) {
		var s = _v0.a.a;
		return $elm$core$Maybe$Just(s);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$openPageByRoute = function (model) {
	var _v0 = $author$project$Main$session(model);
	if (_v0.$ === 1) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bx: $author$project$Pages$notLoaded}),
			$elm$core$Platform$Cmd$none);
	} else {
		var session_ = _v0.a;
		return $author$project$Main$andThenLoadManifest(
			A2(
				$author$project$Main$mapPagesToProgram,
				model,
				A5($author$project$Pages$init, model.jk, model.bG, model.cM, session_, model.bx)));
	}
};
var $author$project$Api$Endpoint$CsrfToken = $elm$core$Basics$identity;
var $author$project$Api$Endpoint$parseCsrfToken = function (value) {
	return $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value);
};
var $author$project$Ports$posthogIdentify = _Platform_outgoingPort(
	'posthogIdentify',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'distinctId',
					$elm$json$Json$Encode$string($.lq)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string($.O)),
					_Utils_Tuple2(
					'firstName',
					$elm$json$Json$Encode$string($.lI)),
					_Utils_Tuple2(
					'lastName',
					$elm$json$Json$Encode$string($.av))
				]));
	});
var $author$project$Ports$posthogReset = _Platform_outgoingPort(
	'posthogReset',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $elm$browser$Browser$Navigation$reload = _Browser_reload(false);
var $author$project$Ports$saveLastRequestedUrl = _Platform_outgoingPort('saveLastRequestedUrl', $elm$json$Json$Encode$string);
var $author$project$Main$trackPageView = function (model) {
	var t_ = A2(
		$elm$core$Maybe$withDefault,
		model.mn.h6,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.h6;
			},
			$author$project$Main$session(model)));
	return $author$project$Ports$sendPageView(
		{
			m1: $author$project$Route$toString(model.cM),
			m2: A2($author$project$Route$pageTitle, t_, model.cM)
		});
};
var $author$project$Pages$update = F4(
	function (key, session, msg, model) {
		var noop = _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, session);
		var _v0 = _Utils_Tuple2(msg, model);
		switch (_v0.a.$) {
			case 0:
				if (_v0.b.$ === 2) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.dZ);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.dZ, _return);
				} else {
					return noop;
				}
			case 1:
				if (_v0.b.$ === 3) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.c2);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.c2, _return);
				} else {
					return noop;
				}
			case 2:
				if (_v0.b.$ === 4) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.dD);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.dD, _return);
				} else {
					return noop;
				}
			case 3:
				if (_v0.b.$ === 5) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.cu);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.cu, _return);
				} else {
					return noop;
				}
			case 4:
				if (_v0.b.$ === 6) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.c8);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.c8, _return);
				} else {
					return noop;
				}
			case 5:
				if (_v0.b.$ === 7) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.ct);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.ct, _return);
				} else {
					return noop;
				}
			case 7:
				if (_v0.b.$ === 9) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.bw);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.bw, _return);
				} else {
					return noop;
				}
			case 8:
				if (_v0.b.$ === 10) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.b1);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.b1, _return);
				} else {
					return noop;
				}
			case 9:
				if (_v0.b.$ === 1) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.de);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.de, _return);
				} else {
					return noop;
				}
			case 10:
				if (_v0.b.$ === 11) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.e8);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.e8, _return);
				} else {
					return noop;
				}
			case 11:
				if (_v0.b.$ === 14) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.cA);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.cA, _return);
				} else {
					return noop;
				}
			case 12:
				if (_v0.b.$ === 12) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.ax);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.ax, _return);
				} else {
					return noop;
				}
			case 13:
				if (_v0.b.$ === 13) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.b3);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.b3, _return);
				} else {
					return noop;
				}
			case 6:
				if (_v0.b.$ === 8) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.cC);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.cC, _return);
				} else {
					return noop;
				}
			case 14:
				if (_v0.b.$ === 15) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.cD);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.cD, _return);
				} else {
					return noop;
				}
			case 15:
				if (_v0.b.$ === 16) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.dq);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.dq, _return);
				} else {
					return noop;
				}
			case 16:
				if (_v0.b.$ === 17) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.cr);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.cr, _return);
				} else {
					return noop;
				}
			case 17:
				if (_v0.b.$ === 18) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.b6);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.b6, _return);
				} else {
					return noop;
				}
			case 18:
				if (_v0.b.$ === 20) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.b7);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.b7, _return);
				} else {
					return noop;
				}
			case 19:
				if (_v0.b.$ === 19) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.ds);
					var _v1 = A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.ds, _return);
					var model2 = _v1.a;
					var cmd = _v1.b;
					var session2 = _v1.c;
					var _v2 = _return.gs;
					if (!_v2.$) {
						var _v3 = _v2.a;
						var redirectCmd = A2(
							$elm$browser$Browser$Navigation$pushUrl,
							key,
							$author$project$Route$toString(
								$author$project$Route$PortfoliosList($author$project$Route$blankPortfoliosListQuery)));
						return _Utils_Tuple3(
							model2,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[cmd, redirectCmd])),
							session2);
					} else {
						return _Utils_Tuple3(model2, cmd, session2);
					}
				} else {
					return noop;
				}
			case 20:
				if (_v0.b.$ === 21) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.dy);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.dy, _return);
				} else {
					return noop;
				}
			case 22:
				if (_v0.b.$ === 23) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.dA);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.dA, _return);
				} else {
					return noop;
				}
			case 23:
				if (_v0.b.$ === 24) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.cN);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.cN, _return);
				} else {
					return noop;
				}
			case 21:
				if (_v0.b.$ === 22) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.b9);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.b9, _return);
				} else {
					return noop;
				}
			case 24:
				if (_v0.b.$ === 25) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.bW);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.bW, _return);
				} else {
					return noop;
				}
			case 25:
				if (_v0.b.$ === 26) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.cU);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.cU, _return);
				} else {
					return noop;
				}
			case 26:
				if (_v0.b.$ === 27) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.dF);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.dF, _return);
				} else {
					return noop;
				}
			case 27:
				if (_v0.b.$ === 28) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.cV);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.cV, _return);
				} else {
					return noop;
				}
			case 28:
				if (_v0.b.$ === 29) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.aL);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.aL, _return);
				} else {
					return noop;
				}
			case 29:
				if (_v0.b.$ === 30) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.cW);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.cW, _return);
				} else {
					return noop;
				}
			case 30:
				if (_v0.b.$ === 31) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.c0);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.c0, _return);
				} else {
					return noop;
				}
			case 31:
				if (_v0.b.$ === 32) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.c9);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.c9, _return);
				} else {
					return noop;
				}
			default:
				if (_v0.b.$ === 33) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.du);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.du, _return);
				} else {
					return noop;
				}
		}
	});
var $author$project$Main$ClearNotification = function (a) {
	return {$: 7, a: a};
};
var $elm$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2($elm$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});
var $author$project$Notification$diff = F2(
	function (n1, n2) {
		return $elm$core$Dict$toList(
			A2($elm$core$Dict$diff, n1, n2));
	});
var $author$project$Notification$isOk = function (notification) {
	return notification.di === 1;
};
var $author$project$Main$newNotifications = F2(
	function (oldSession, newSession) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var id = _v0.a;
				var notif = _v0.b;
				return $author$project$Notification$isOk(notif) ? $elm$core$Maybe$Just(id) : $elm$core$Maybe$Nothing;
			},
			A2($author$project$Notification$diff, newSession.em, oldSession.em));
	});
var $author$project$Main$withToastNotifications = F2(
	function (oldSession, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var timeout = 3;
		var toastCmd = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				function (newSession) {
					return $elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Main$ClearNotification,
								$author$project$Util$Delay$after(timeout)),
							A2($author$project$Main$newNotifications, oldSession, newSession)));
				},
				$author$project$Main$session(model)));
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, toastCmd])));
	});
var $author$project$Main$broadcastScrollEvent = function (model) {
	var subscriptions_ = _List_fromArray(
		[
			$author$project$Main$PageMsg(
			$author$project$Pages$HomePageMsg(
				$author$project$Element$HomePage$ListElementMsg($author$project$Element$PortfolioList$LoadMoreStories))),
			$author$project$Main$PageMsg(
			$author$project$Pages$ModulesMainMsg($author$project$Element$ModulesMain$LoadMoreModules)),
			$author$project$Main$PageMsg(
			$author$project$Pages$ModuleSingleMsg(
				$author$project$Element$ModuleSingle$PortfolioListMsg($author$project$Element$PortfolioList$LoadMoreStories))),
			$author$project$Main$PageMsg(
			$author$project$Pages$StudentListMsg($author$project$Element$StudentList$LoadMoreStudents))
		]);
	var batchUpdate = F2(
		function (scrollMsg, _v20) {
			var prevModel = _v20.a;
			var prevCmd = _v20.b;
			var _v19 = A2($author$project$Main$update, scrollMsg, prevModel);
			var newModel = _v19.a;
			var newCmd = _v19.b;
			return _Utils_Tuple2(
				newModel,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[prevCmd, newCmd])));
		});
	return A3(
		$elm$core$List$foldl,
		batchUpdate,
		_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
		subscriptions_);
};
var $author$project$Main$openStartPage = F2(
	function (session_, model) {
		var _v17 = A2($author$project$Main$openNavbar, session_, model);
		var model2 = _v17.a;
		var navbarCmd = _v17.b;
		var _v18 = A2($author$project$Main$updateRoute, model2.cM, model2);
		var model3 = _v18.a;
		var routeCmd = _v18.b;
		return _Utils_Tuple2(
			model3,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						navbarCmd,
						routeCmd,
						A3(
						$author$project$Log$ok,
						model.bG,
						_Utils_Tuple2(
							$author$project$Log$msgOpenStartPage,
							_List_fromArray(
								[
									$elm$core$String$fromInt(session_.ok.i8)
								])),
						$elm$core$Basics$always($author$project$Main$NoOp))
					])));
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		var sharedConfig = model.bG;
		var t__ = model.mn.h6;
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					return $author$project$Main$fetchViewer(model);
				} else {
					var error = msg.a.a;
					if (error.$ === 3) {
						var status = error.a;
						return _Utils_Tuple2(
							model,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$elm$browser$Browser$Navigation$load(
										A2($author$project$Auth0$auth0AuthorizeURL, model.kY, false)),
										$author$project$Ports$saveLastRequestedUrl(
										$author$project$Route$toString(model.cM)),
										function () {
										if (status === 401) {
											return A3(
												$author$project$Log$ok,
												sharedConfig,
												_Utils_Tuple2(
													$author$project$Log$msgAutoLogin,
													_List_fromArray(
														[
															$author$project$Api$httpErrorToRobots(error)
														])),
												$author$project$Main$LogResponse);
										} else {
											return A3(
												$author$project$Log$error,
												sharedConfig,
												_Utils_Tuple3($author$project$Log$msgAutoLogin, $elm$core$Maybe$Nothing, error),
												$author$project$Main$LogResponse);
										}
									}()
									])));
					} else {
						return _Utils_Tuple2(
							A3(
								$author$project$Main$addError,
								_Utils_update(
									model,
									{a0: $author$project$Main$LoggedOut}),
								t__($author$project$Locale$Messages$MainErrorLogin),
								error),
							A3(
								$author$project$Log$error,
								sharedConfig,
								_Utils_Tuple3($author$project$Log$msgLogin, $elm$core$Maybe$Nothing, error),
								$author$project$Main$LogResponse));
					}
				}
			case 2:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{a0: $author$project$Main$LoggedOut}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Route$replaceUrl, sharedConfig.jk, $author$project$Route$Login),
									$author$project$Ports$posthogReset(0)
								])));
				} else {
					var error = msg.a.a;
					var _v8 = model.a0;
					if (!_v8.$) {
						return _Utils_Tuple2(
							model,
							A2($author$project$Route$replaceUrl, sharedConfig.jk, $author$project$Route$Login));
					} else {
						return _Utils_Tuple2(
							A3(
								$author$project$Main$addError,
								model,
								t__($author$project$Locale$Messages$MainErrorLogout),
								error),
							A3(
								$author$project$Log$error,
								sharedConfig,
								_Utils_Tuple3($author$project$Log$msgLogout, $elm$core$Maybe$Nothing, error),
								$author$project$Main$LogResponse));
					}
				}
			case 3:
				if (msg.a.$ === 1) {
					var error = msg.a.a;
					return _Utils_Tuple2(
						A3(
							$author$project$Main$addError,
							model,
							t__($author$project$Locale$Messages$MainErrorProfileDownload),
							error),
						A3(
							$author$project$Log$error,
							sharedConfig,
							_Utils_Tuple3(
								$author$project$Log$msgProfileDownload,
								$elm$core$Maybe$Just('me'),
								error),
							$author$project$Main$LogResponse));
				} else {
					var person = msg.a.a;
					var session_ = $author$project$Session$create(person);
					var model2 = _Utils_update(
						model,
						{
							a0: $author$project$Main$Authenticated(
								$author$project$Main$Viewer(session_))
						});
					var _v9 = A2($author$project$Main$openStartPage, session_, model2);
					var m3 = _v9.a;
					var cmd3 = _v9.b;
					return _Utils_Tuple2(
						m3,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd3,
									$author$project$Ports$posthogIdentify(
									{
										lq: $elm$core$String$fromInt(person.i8),
										O: person.O,
										lI: person.lI,
										av: person.av
									})
								])));
				}
			case 4:
				return _Utils_Tuple2(
					model,
					A2($author$project$Api$logout, sharedConfig.gX, $author$project$Main$LogoutResponse));
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bK: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a0: function () {
								var _v10 = model.a0;
								if ((_v10.$ === 2) && (_v10.a.$ === 2)) {
									var session_ = _v10.a.a;
									return $author$project$Main$Authenticated(
										$author$project$Main$Viewer(
											A2($author$project$Session$clearNotification, id, session_)));
								} else {
									var x = _v10;
									return x;
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var urlRequest = msg.a;
				if (!urlRequest.$) {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$browser$Browser$Navigation$pushUrl,
									sharedConfig.jk,
									$elm$url$Url$toString(url)),
									$author$project$Main$trackPageView(model)
								])));
				} else {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Ports$saveLastRequestedUrl(
									$author$project$Route$toString(model.cM)),
									$elm$browser$Browser$Navigation$load(url)
								])));
				}
			case 5:
				var url = msg.a;
				return A2(
					$author$project$Main$updateRoute,
					$author$project$Route$fromUrl(url),
					model);
			case 1:
				if (!msg.a.$) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$Ports$consoleError(
							'log' + (' ' + $author$project$Api$httpErrorToRobots(error))));
				}
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f7: true}),
					$elm$core$Platform$Cmd$none);
			case 11:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3(
								$author$project$Log$ok,
								sharedConfig,
								_Utils_Tuple2($author$project$Log$msgAppUpdateRequest, _List_Nil),
								$author$project$Main$LogResponse),
								$elm$browser$Browser$Navigation$reload
							])));
			case 10:
				var value = msg.a;
				var csrfToken = $author$project$Api$Endpoint$parseCsrfToken(value);
				var backend = sharedConfig.gX;
				var newBackend = _Utils_update(
					backend,
					{lg: csrfToken});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bG: _Utils_update(
								sharedConfig,
								{gX: newBackend})
						}),
					A2($author$project$Main$authenticateStep2, model.a0, newBackend));
			case 12:
				return $author$project$Main$broadcastScrollEvent(model);
			case 13:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 14:
				var pageMsg = msg.a;
				if (((pageMsg.$ === 15) && (pageMsg.a.$ === 5)) && (pageMsg.a.a.$ === 4)) {
					var response = pageMsg.a.a.a;
					if (response.nZ) {
						return _Utils_Tuple2(model, $elm$browser$Browser$Navigation$reload);
					} else {
						var _v13 = $author$project$Main$session(model);
						if (_v13.$ === 1) {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						} else {
							var session_ = _v13.a;
							return A2(
								$author$project$Main$withToastNotifications,
								session_,
								A2(
									$author$project$Main$mapPagesToProgram,
									model,
									A4($author$project$Pages$update, model.jk, session_, pageMsg, model.bx)));
						}
					}
				} else {
					var _v14 = $author$project$Main$session(model);
					if (_v14.$ === 1) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var session_ = _v14.a;
						return A2(
							$author$project$Main$withToastNotifications,
							session_,
							A2(
								$author$project$Main$mapPagesToProgram,
								model,
								A4($author$project$Pages$update, model.jk, session_, pageMsg, model.bx)));
					}
				}
			default:
				var navbarMsg = msg.a;
				var _v15 = _Utils_Tuple2(
					model.el,
					$author$project$Main$session(model));
				if ((!_v15.a.$) && (!_v15.b.$)) {
					var navbarModel = _v15.a.a;
					var session_ = _v15.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session_, navbarMsg, navbarModel, $author$project$Main$navbar);
					var _v16 = _return.gs;
					if (!_v16.$) {
						var lang = _v16.a;
						return A2(
							$author$project$Main$withToastNotifications,
							session_,
							A2(
								$author$project$Main$openStartPage,
								_return.gB,
								_Utils_update(
									model,
									{mn: lang})));
					} else {
						return A3($author$project$Main$mapProgram, model, $author$project$Main$navbar, _return);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Main$updateRoute = F2(
	function (route, model) {
		var model0 = _Utils_update(
			model,
			{cM: route});
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(
				model.el,
				$author$project$Main$session(model));
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var navbarModel = _v1.a.a;
				var session_ = _v1.b.a;
				return A3(
					$author$project$Main$mapProgram,
					model0,
					$author$project$Main$navbar,
					A3(
						$author$project$Main$navbar.ha.ks,
						session_,
						$author$project$Element$Navbar$RouteChanged(route),
						navbarModel));
			} else {
				return _Utils_Tuple2(model0, $elm$core$Platform$Cmd$none);
			}
		}();
		var model1 = _v0.a;
		var _v2 = $author$project$Main$openPageByRoute(model1);
		var model2 = _v2.a;
		var pageCmd = _v2.b;
		if ($author$project$Pages$isPageLoaded(model2.bx)) {
			return _Utils_Tuple2(model2, pageCmd);
		} else {
			var _v3 = model2.cM;
			switch (_v3.$) {
				case 3:
					var url = _v3.a;
					return _Utils_Tuple2(
						model2,
						A3(
							$author$project$Log$err,
							model.bG,
							_Utils_Tuple2(
								$author$project$Log$msgPageNotFound,
								$elm$url$Url$toString(url)),
							$author$project$Main$LogResponse));
				case 1:
					var _v4 = $author$project$Main$session(model2);
					if (!_v4.$) {
						return _Utils_Tuple2(
							_Utils_update(
								model2,
								{cM: $author$project$Route$Home}),
							A2($author$project$Route$replaceUrl, model.bG.jk, $author$project$Route$Home));
					} else {
						return _Utils_Tuple2(model2, $elm$core$Platform$Cmd$none);
					}
				case 2:
					return A2($author$project$Main$update, $author$project$Main$LogOutRequest, model2);
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Locale$Messages$LoadingPageProgress = {$: 168};
var $author$project$Main$ClearErrors = {$: 6};
var $author$project$Locale$Messages$MainErrorSelfHelp = {$: 180};
var $author$project$Main$viewError = function (error) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(error)
					]))
			]));
};
var $author$project$Main$viewErrors = F2(
	function (language, appErrors) {
		if (!appErrors.b) {
			return $author$project$UI$none;
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('columns')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('column is-two-thirds')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$article,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message is-danger')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('message-header')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														A2($author$project$UI$caption, language.h6, $author$project$Locale$Messages$MainErrorGeneral)
													])),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('delete'),
														$elm$html$Html$Events$onClick($author$project$Main$ClearErrors)
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('message-body content')
											]),
										A2(
											$elm$core$List$append,
											A2(
												$elm$core$List$map,
												$author$project$Main$viewError,
												$elm$core$List$reverse(appErrors)),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															$author$project$UI$textToHtml(
																language.h6($author$project$Locale$Messages$MainErrorSelfHelp)))
														]))
												])))
									]))
							]))
					]));
		}
	});
var $author$project$Element$Navbar$viewLogo = function (logoPath) {
	return A2(
		$elm$html$Html$nav,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('navbar')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('navbar-brand')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-item')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src(logoPath)
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Main$loginInProgressPage = F3(
	function (model, caption, style) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Element$Navbar$viewLogo(model.ef),
					$author$project$UI$section(
					_List_fromArray(
						[
							$elm$core$List$isEmpty(model.bK) ? A2($author$project$UI$progressBar, style, caption) : A2($author$project$Main$viewErrors, model.mn, model.bK)
						]))
				]));
	});
var $author$project$Locale$Messages$LoginPageInfo = {$: 170};
var $author$project$Locale$Messages$BtnLogin = {$: 31};
var $author$project$Element$Navbar$viewAnonymous = function (model) {
	return A2(
		$elm$html$Html$nav,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('navbar')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('navbar-brand')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-item')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src(model.ef)
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('navbar-menu is-active')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-start')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('navbar-item has-text-centered ')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$author$project$UI$attrCyData('login'),
												$elm$html$Html$Attributes$href(
												A2($author$project$Auth0$auth0AuthorizeURL, model.kY, false)),
												$elm$html$Html$Attributes$class(' button is-success')
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, model.mn.h6, $author$project$Locale$Messages$BtnLogin)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Main$loginPage = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Element$Navbar$viewAnonymous(model),
				$author$project$UI$section(
				_List_fromArray(
					[
						A2($author$project$UI$caption, model.mn.h6, $author$project$Locale$Messages$LoginPageInfo),
						A2($author$project$Main$viewErrors, model.mn, model.bK)
					]))
			]));
};
var $author$project$Notification$isEmpty = function (notifications) {
	return !$elm$core$Dict$size(notifications);
};
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $author$project$Main$ScrolledToBottom = {$: 12};
var $author$project$Util$Html$ScrollEvent = F3(
	function (offsetHeight, scrollHeight, scrollTop) {
		return {jD: offsetHeight, j3: scrollHeight, j4: scrollTop};
	});
var $author$project$Util$Html$scrollEventDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Util$Html$ScrollEvent,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'offsetHeight']),
		$elm$json$Json$Decode$float),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'scrollHeight']),
		$elm$json$Json$Decode$float),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'scrollTop']),
		$elm$json$Json$Decode$float));
var $author$project$Util$Html$onScrollToBottom = function (tagger) {
	var isBottom = function (evt) {
		return (_Utils_cmp(evt.j4 + evt.jD, evt.j3 - 5) > -1) ? $elm$json$Json$Decode$succeed(tagger) : $elm$json$Json$Decode$fail('not bottom');
	};
	return A2(
		$elm$html$Html$Events$on,
		'scroll',
		A2($elm$json$Json$Decode$andThen, isBottom, $author$project$Util$Html$scrollEventDecoder));
};
var $author$project$Main$scrollablePanel = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Util$Html$onScrollToBottom($author$project$Main$ScrolledToBottom),
				$elm$html$Html$Attributes$class('is-scrollable')
			]),
		content);
};
var $author$project$UI$toastNotifications = F2(
	function (toMsg, notifications_) {
		var getNotificationClass = function (noticeLevel) {
			if (!noticeLevel) {
				return 'is-danger';
			} else {
				return 'is-success';
			}
		};
		var toastNotificationItem = F2(
			function (id, item) {
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('notification'),
							$elm$html$Html$Attributes$class(
							getNotificationClass(item.di)),
							$author$project$UI$attrCyData('notification')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('delete'),
									$elm$html$Html$Events$onClick(
									toMsg(id))
								]),
							_List_fromArray(
								[$author$project$UI$none])),
							$elm$html$Html$text(item.cz)
						]));
			});
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('toast')
				]),
			$elm$core$Dict$values(
				A2($elm$core$Dict$map, toastNotificationItem, notifications_)));
	});
var $author$project$Main$AppUpdateRequested = {$: 11};
var $author$project$Locale$Messages$MainUpdateAvailableAction = {$: 183};
var $author$project$Locale$Messages$MainUpdateAvailableInfo = {$: 181};
var $author$project$Main$viewAppUpdateNotification = function (t_) {
	return $author$project$UI$section(
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('notification is-dark')
					]),
				_List_fromArray(
					[
						$author$project$UI$Icon$icon(
						_List_fromArray(
							[
								$author$project$UI$Icon$face('fa-bell'),
								$author$project$UI$Icon$style('has-text-primary')
							])),
						$elm$html$Html$text(' '),
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$MainUpdateAvailableInfo),
						$elm$html$Html$text(' '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$UI$actionLink,
								$author$project$Main$AppUpdateRequested,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$UI$caption, t_, $author$project$Locale$Messages$MainUpdateAvailableAction)
									]))
							]))
					]))
			]));
};
var $author$project$Main$viewNavbar = F2(
	function (session_, model) {
		return A2(
			$elm$html$Html$map,
			$author$project$Main$navbar.jv,
			A2($author$project$Main$navbar.ha.og, session_, model));
	});
var $author$project$Pages$view = F2(
	function (session, model) {
		switch (model.$) {
			case 0:
				return $elm$html$Html$text('');
			case 2:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.dZ);
			case 3:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.c2);
			case 4:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.dD);
			case 5:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.cu.jv,
					A2($author$project$Pages$pages.cu.ha.og, session, pageModel));
			case 6:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.c8);
			case 7:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.ct.jv,
					A2($author$project$Pages$pages.ct.ha.og, session, pageModel));
			case 9:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.bw.jv,
					A2($author$project$Pages$pages.bw.ha.og, session, pageModel));
			case 10:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.b1);
			case 1:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.de);
			case 11:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.e8);
			case 14:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.cA.jv,
					A2($author$project$Pages$pages.cA.ha.og, session, pageModel));
			case 12:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.ax.jv,
					A2($author$project$Pages$pages.ax.ha.og, session, pageModel));
			case 13:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.b3);
			case 8:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.cC.jv,
					A2($author$project$Pages$pages.cC.ha.og, session, pageModel));
			case 15:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.cD.jv,
					A2($author$project$Pages$pages.cD.ha.og, session, pageModel));
			case 16:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.dq);
			case 17:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.cr.jv,
					A2($author$project$Pages$pages.cr.ha.og, session, pageModel));
			case 18:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.b6);
			case 20:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.b7);
			case 19:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.ds);
			case 21:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.dy);
			case 23:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.dA);
			case 22:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.b9);
			case 24:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.cN.jv,
					A2($author$project$Pages$pages.cN.ha.og, session, pageModel));
			case 25:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.bW.jv,
					A2($author$project$Pages$pages.bW.ha.og, session, pageModel));
			case 26:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.cU.jv,
					A2($author$project$Pages$pages.cU.ha.og, session, pageModel));
			case 27:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.dF);
			case 28:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.cV.jv,
					A2($author$project$Pages$pages.cV.ha.og, session, pageModel));
			case 29:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.aL.jv,
					A2($author$project$Pages$pages.aL.ha.og, session, pageModel));
			case 30:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.cW.jv,
					A2($author$project$Pages$pages.cW.ha.og, session, pageModel));
			case 31:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.c0);
			case 32:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.c9);
			default:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.du);
		}
	});
var $author$project$Locale$Messages$LogoutPageProgress = {$: 171};
var $author$project$Locale$Messages$MainErrorPageNotFound = function (a) {
	return {$: 177, a: a};
};
var $author$project$Locale$Messages$MainErrorPageNotFoundTitle = {$: 178};
var $author$project$Main$viewPageNotFound = F2(
	function (t_, route) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$UI$attrCyData('page-not-found')
				]),
			_List_fromArray(
				[
					$author$project$UI$notification(
					_List_fromArray(
						[
							$author$project$UI$title(
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$MainErrorPageNotFoundTitle)
								])),
							A2(
							$author$project$UI$caption,
							t_,
							$author$project$Locale$Messages$MainErrorPageNotFound(
								$author$project$Route$toString(route)))
						]))
				]));
	});
var $author$project$Main$viewSpecialPageByRoute = F2(
	function (_v0, model) {
		var t_ = _v0.h6;
		var viewNotFoundPage = A2($author$project$Main$viewPageNotFound, model.mn.h6, model.cM);
		var _v1 = model.cM;
		switch (_v1.$) {
			case 2:
				return A2(
					$author$project$UI$progressBar,
					'is-link',
					t_($author$project$Locale$Messages$LogoutPageProgress));
			case 1:
				return $author$project$Main$loginPage(model);
			case 3:
				return viewNotFoundPage;
			case 0:
				return viewNotFoundPage;
			case 48:
				return viewNotFoundPage;
			default:
				return viewNotFoundPage;
		}
	});
var $author$project$Main$viewPage = F2(
	function (session_, model) {
		var _v0 = model.bK;
		if (!_v0.b) {
			return $author$project$Pages$isPageLoaded(model.bx) ? A2(
				$elm$html$Html$map,
				$author$project$Main$PageMsg,
				A2($author$project$Pages$view, session_, model.bx)) : A2($author$project$Main$viewSpecialPageByRoute, session_, model);
		} else {
			return A2($author$project$Main$viewErrors, model.mn, model.bK);
		}
	});
var $author$project$Main$viewSessionPage = F2(
	function (model, session_) {
		return $author$project$Main$scrollablePanel(
			_List_fromArray(
				[
					A2(
					$author$project$UI$maybe,
					model.el,
					$author$project$Main$viewNavbar(session_)),
					A2(
					$elm$html$Html$main_,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$when,
							model.f7,
							$author$project$Main$viewAppUpdateNotification(session_.h6)),
							A2(
							$author$project$UI$when,
							!$author$project$Notification$isEmpty(session_.em),
							A2(
								$elm$html$Html$section,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$UI$toastNotifications, $author$project$Main$ClearNotification, session_.em)
									]))),
							$author$project$UI$section(
							_List_fromArray(
								[
									A2($author$project$Main$viewPage, session_, model)
								]))
						]))
				]));
	});
var $author$project$Main$view = function (model) {
	var t__ = model.mn.h6;
	var _v0 = model.a0;
	switch (_v0.$) {
		case 0:
			return {
				T: _List_fromArray(
					[
						$author$project$Main$loginPage(model)
					]),
				kj: A2($author$project$Route$pageTitle, t__, model.cM)
			};
		case 1:
			return {
				T: _List_fromArray(
					[
						A3(
						$author$project$Main$loginInProgressPage,
						model,
						t__($author$project$Locale$Messages$LoadingPageProgress),
						'is-primary')
					]),
				kj: A2($author$project$Route$pageTitle, t__, model.cM)
			};
		default:
			switch (_v0.a.$) {
				case 0:
					return {
						T: _List_fromArray(
							[
								A3(
								$author$project$Main$loginInProgressPage,
								model,
								t__($author$project$Locale$Messages$LoadingPageProgress),
								'is-warning')
							]),
						kj: A2($author$project$Route$pageTitle, t__, model.cM)
					};
				case 1:
					var _v1 = _v0.a;
					return {
						T: _List_fromArray(
							[
								A3(
								$author$project$Main$loginInProgressPage,
								model,
								t__($author$project$Locale$Messages$LoadingPageProgress),
								'is-info')
							]),
						kj: A2($author$project$Route$pageTitle, t__, model.cM)
					};
				default:
					var sess = _v0.a.a;
					return {
						T: _List_fromArray(
							[
								A2($author$project$Main$viewSessionPage, model, sess)
							]),
						kj: A2($author$project$Route$pageTitle, sess.h6, model.cM)
					};
			}
	}
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{jb: $author$project$Main$init, mW: $author$project$Main$UrlChange, mX: $author$project$Main$LinkClicked, nY: $author$project$Main$subscriptions, ks: $author$project$Main$update, og: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (logoPath) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (logMaxLength) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (logAppName) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (lastRequestedUrl) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (buildRev) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (auth0Domain) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (auth0ClientId) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (auth0Callback) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (apiBase) {
																			return $elm$json$Json$Decode$succeed(
																				{fK: apiBase, kW: auth0Callback, kX: auth0ClientId, kZ: auth0Domain, g0: buildRev, mo: lastRequestedUrl, hD: logAppName, hE: logMaxLength, ef: logoPath});
																		},
																		A2($elm$json$Json$Decode$field, 'apiBase', $elm$json$Json$Decode$string));
																},
																A2($elm$json$Json$Decode$field, 'auth0Callback', $elm$json$Json$Decode$string));
														},
														A2($elm$json$Json$Decode$field, 'auth0ClientId', $elm$json$Json$Decode$string));
												},
												A2($elm$json$Json$Decode$field, 'auth0Domain', $elm$json$Json$Decode$string));
										},
										A2($elm$json$Json$Decode$field, 'buildRev', $elm$json$Json$Decode$string));
								},
								A2(
									$elm$json$Json$Decode$field,
									'lastRequestedUrl',
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
											]))));
						},
						A2($elm$json$Json$Decode$field, 'logAppName', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'logMaxLength', $elm$json$Json$Decode$int));
		},
		A2($elm$json$Json$Decode$field, 'logoPath', $elm$json$Json$Decode$string)))(0)}});}(this));